/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 * 
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 * 
 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.OktaSignIn = t() : e.OktaSignIn = t();
}("undefined" != typeof self ? self : this, function () {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 381);
  }([function (e, t) {
    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        o = r(n(10));
    /*! THIS FILE IS GENERATED FROM PACKAGE @okta/courage@4.5.0-5082-ga8d26d7 */

    e.exports = function (e) {
      function t(r) {
        if (n[r]) return n[r].exports;
        var o = n[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
      }

      var n = {};
      return t.m = e, t.c = n, t.d = function (e, n, r) {
        t.o(e, n) || Object.defineProperty(e, n, {
          configurable: !1,
          enumerable: !0,
          get: r
        });
      }, t.n = function (e) {
        var n = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return t.d(n, "a", n), n;
      }, t.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, t.p = "", t(t.s = 35);
    }([function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(5)),
          i = r(n(37)),
          a = i.default;
      a.mixin({
        resultCtx: function resultCtx(e, t, n, r) {
          var o = a.isObject(e) ? e[t] : void 0;
          return a.isFunction(o) && (o = o.call(n || e)), o || (a.isUndefined(r) ? o : r);
        },
        isInteger: function isInteger(e) {
          return a.isNumber(e) && e % 1 == 0;
        },
        template: function template(e, t) {
          var n = o.default.compile(e);
          return t ? n(t) : function (e) {
            return n(e);
          };
        }
      });
      var s = a;
      t.default = s, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        "@babel/helpers - typeof";

        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var i = r(n(6)),
          a = r(n(0)),
          s = r(n(14)),
          l = r(n(43)),
          u = a.default.clone(i.default.Events),
          c = {
        constructor: function constructor() {
          s.default.apply(this, arguments), this.module && this.$el.attr("data-view", this.module.id);
        },
        empty: function empty() {
          return this.removeChildren();
        },
        compileTemplate: l.default.tpl,
        broadcast: function broadcast() {
          return u.trigger.apply(u, arguments), this;
        },
        listen: function listen(e, t) {
          return u.off(e, t), this.listenTo(u, e, t), this;
        },
        notify: function notify(e, t, n) {
          return this.broadcast("notification", a.default.defaults({
            message: t,
            level: e
          }, n)), this;
        },
        confirm: function confirm(e, t, n, r) {
          var i;
          return i = "object" === o(e) ? e : 2 === arguments.length && a.default.isFunction(t) ? {
            title: "Okta",
            subtitle: e,
            ok: t
          } : {
            title: e,
            subtitle: t,
            ok: n,
            cancelFn: r
          }, a.default.isFunction(i.ok) && (i.ok = a.default.bind(i.ok, this)), a.default.isFunction(i.cancelFn) && (i.cancelFn = a.default.bind(i.cancelFn, this)), this.broadcast("confirmation", i), this;
        },
        alert: function alert(e) {
          return a.default.isString(e) && (e = {
            subtitle: e
          }), this.confirm(a.default.extend({}, e, {
            noCancelButton: !0
          })), this;
        }
      },
          d = s.default.extend(c, {
        decorate: function decorate(e) {
          var t = e.extend({});
          return a.default.defaults(t.prototype, c), t;
        }
      });
      t.default = d, e.exports = t.default;
    }, function (e, t) {
      e.exports = n(2);
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;

      var r = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n(12));

      r.default.ajaxSetup({
        beforeSend: function beforeSend(e) {
          e.setRequestHeader("X-Okta-XsrfToken", (0, r.default)("#_xsrfToken").text());
        },
        converters: {
          "text secureJSON": function textSecureJSON(e) {
            return "while(1){};" === e.substring(0, 11) && (e = e.substring(11)), JSON.parse(e);
          }
        }
      }), window.jQueryCourage = r.default;
      var o = r.default;
      t.default = o, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        if (!e) return u.default[l.default.keys(u.default)[0]];
        var t = f(window && window.okta && window.okta.locale) || "en";
        return u.default["".concat(e, "_").concat(t)] || u.default[e];
      }

      function i(e, t) {
        t = t || {
          bubbles: !1,
          cancelable: !1,
          detail: null
        };
        var n = document.createEvent("CustomEvent");
        return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n;
      }

      function a(e, t, n) {
        if (window.CustomEvent || (window.CustomEvent = i), "function" == typeof window.CustomEvent) {
          var r = new CustomEvent("okta-i18n-error", {
            detail: {
              type: "l10n-error",
              key: e,
              bundleName: t,
              reason: n
            }
          });
          document.dispatchEvent(r);
        }
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;

      var s = r(n(3)),
          l = r(n(0)),
          u = r(n(41)),
          c = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'",
        "&#039;": "'",
        "&#x2F;": "/"
      },
          d = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(?!-)((\[?[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\]?)|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          f = function f(e) {
        if (/-/.test(e)) {
          var t = e.split("-");
          return t[1] = t[1].toUpperCase(), t.join("_");
        }

        return e;
      },
          p = {
        sprintf: function sprintf() {
          function e() {
            throw new Error("Mismatch number of variables: " + arguments[0] + ", " + JSON.stringify(t));
          }

          for (var t = Array.prototype.slice.apply(arguments), n = t.shift(), r = n, o = 0, i = t.length; o < i; o++) {
            var a = t[o];
            n = n.replace("{" + o + "}", a), void 0 !== a && null !== a && n !== r || e(), r = n;
          }

          return /\{[\d+]\}/.test(n) && e(), n;
        },
        parseQuery: function parseQuery(e) {
          for (var t = {}, n = decodeURIComponent(e.replace(/\+/g, " ")).split("&"), r = 0; r < n.length; r++) {
            var o = n[r],
                i = o.split("=");
            t[i.shift()] = i.join("=");
          }

          return t;
        },
        encodeJSObject: function encodeJSObject(e) {
          return encodeURIComponent(JSON.stringify(e));
        },
        decodeJSObject: function decodeJSObject(e) {
          try {
            return JSON.parse(decodeURIComponent(e));
          } catch (e) {
            return null;
          }
        },
        unescapeHtml: function unescapeHtml(e) {
          return String(e).replace(/&[\w#\d]{2,};/g, function (e) {
            return c[e] || e;
          });
        },
        getTemplate: function getTemplate(e, t) {
          var n = o(t);
          return n ? n[e] ? n[e] : (a(e, t, "key"), "L10N_ERROR[" + e + "]") : (a(e, t, "bundle"), "L10N_ERROR[" + t + "]");
        },
        localize: function localize(e, t, n) {
          var r = o(t);
          if (!r) return a(e, t, "bundle"), "L10N_ERROR[" + t + "]";
          var i = r[e];

          try {
            return n = n && n.slice ? n.slice(0) : [], n.unshift(i), (i = p.sprintf.apply(null, n)) || (a(e, t, "key"), "L10N_ERROR[" + e + "]");
          } catch (n) {
            return a(e, t, "parameters"), "L10N_ERROR[" + e + "]";
          }
        },
        parseFloat: function (e) {
          function t(t) {
            return e.apply(this, arguments);
          }

          return t.toString = function () {
            return e.toString();
          }, t;
        }(function (e) {
          var t = +e;
          return "string" == typeof e && t === parseFloat(e) ? t : e;
        }),
        parseInt: function (e) {
          function t(t) {
            return e.apply(this, arguments);
          }

          return t.toString = function () {
            return e.toString();
          }, t;
        }(function (e) {
          var t = +e;
          return l.default.isString(e) && t === parseInt(e, 10) ? t : e;
        }),
        parseObject: function parseObject(e) {
          if (!l.default.isString(e)) return e;

          try {
            var t = JSON.parse(e);
            return s.default.isPlainObject(t) ? t : e;
          } catch (t) {
            return e;
          }
        },
        randomString: function randomString(e) {
          var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
          if (void 0 === e) e = l.default.random(t.length);else if (0 === e) return "";

          for (var n = []; e--;) {
            n.push(t[l.default.random(t.length - 1)]);
          }

          return n.join("");
        },
        endsWith: function endsWith(e, t) {
          return e += "", t += "", e.length >= t.length && e.substring(e.length - t.length) === t;
        },
        isEmail: function isEmail(e) {
          var t = s.default.trim(e);
          return !l.default.isEmpty(t) && d.test(t);
        }
      },
          h = p;

      t.default = h, e.exports = t.default;
    }, function (e, t) {
      e.exports = n(2);
    }, function (e, t) {
      e.exports = n(469);
    }, function (e, t, n) {
      function r(e, t) {
        window.console && window.okta && window.okta.debug && window.console[e].apply(window.console, t);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = {
        trace: function trace() {
          return r("trace", arguments);
        },
        dir: function dir() {
          return r("dir", arguments);
        },
        time: function time() {
          return r("time", arguments);
        },
        timeEnd: function timeEnd() {
          return r("timeEnd", arguments);
        },
        group: function group() {
          return r("group", arguments);
        },
        groupEnd: function groupEnd() {
          return r("groupEnd", arguments);
        },
        assert: function assert() {
          return r("assert", arguments);
        },
        log: function log() {
          return r("log", arguments);
        },
        info: function info() {
          return r("info", arguments);
        },
        warn: function warn() {
          return r("warn", arguments);
        },
        error: function error() {
          return r("error", arguments);
        }
      };
      t.default = o, e.exports = t.default;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var r = {
        UP: 38,
        DOWN: 40,
        DEL: 46,
        TAB: 9,
        RETURN: 13,
        ENTER: 13,
        ESC: 27,
        COMMA: 188,
        PAGEUP: 33,
        PAGEDOWN: 34,
        SPACE: 32,
        BACKSPACE: 8,
        __isKey: function __isKey(e, t) {
          return (e.which || e.keyCode) === this[t];
        },
        isEnter: function isEnter(e) {
          return this.__isKey(e, "ENTER");
        },
        isEsc: function isEsc(e) {
          return this.__isKey(e, "ESC");
        },
        isSpaceBar: function isSpaceBar(e) {
          return this.__isKey(e, "SPACE");
        }
      };
      t.default = r, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(2)),
          i = r(n(3)),
          a = r(n(0)),
          s = r(n(18)),
          l = r(n(4)),
          u = r(n(1)),
          c = r(n(31)),
          d = u.default.extend({
        tagName: "span",
        attributes: function attributes() {
          return {
            "data-se": "o-form-input-" + this.getNameString()
          };
        },
        defaultPlaceholder: "",
        constructor: function constructor(e) {
          e = a.default.defaults(e || {}, {
            inputId: e.id || a.default.uniqueId("input"),
            placeholder: this.defaultPlaceholder,
            inlineValidation: !0,
            validateOnlyIfDirty: !1
          }), delete e.id;
          var t = this;
          a.default.each({
            enable: "removeClass",
            disable: "addClass"
          }, function (e, n) {
            t[n] = a.default.wrap(t[n], function (n) {
              n.apply(t, arguments), t.$el[e]("o-form-disabled");
            });
          }), u.default.call(this, e), !0 !== a.default.result(e, "readOnly") && !0 === a.default.result(e, "read") && this.listenTo(this.model, "change:__edit__", this.render), a.default.isFunction(this.focus) && (this.focus = a.default.debounce(a.default.bind(this.focus, this), 50)), a.default.result(e, "validateOnlyIfDirty") || this.addInlineValidation(), this.addModelListeners(), this.$el.addClass("o-form-input-name-" + this.getNameString());
        },
        addAriaLabel: function addAriaLabel() {
          var e = this.options.ariaLabel;
          e && this.$(":input").attr("aria-label", e);
        },
        addInlineValidation: function addInlineValidation() {
          a.default.result(this.options, "inlineValidation") && this.$el.on("focusout", ":input", a.default.bind(this.validate, this));
        },
        toModelValue: function toModelValue() {
          var e = this.val();
          return a.default.isFunction(this.to) && (e = this.to.call(this, e)), a.default.isFunction(this.options.to) && (e = this.options.to.call(this, e)), e;
        },
        __getDependencyCalloutBtn: function __getDependencyCalloutBtn(e) {
          var t = this,
              n = a.default.clone(e),
              r = n.click || function () {};

          return n.click = function () {
            (0, i.default)(window).one("focus.dependency", function () {
              t.__showInputDependencies();
            }), r.call(t);
          }, new (u.default.extend({
            children: [s.default.create(n)]
          }))();
        },
        getCalloutParent: function getCalloutParent() {
          return this.$('input[value="' + this.getModelValue() + '"]').parent();
        },
        __getCalloutMsgContainer: function __getCalloutMsgContainer(e) {
          return u.default.extend({
            template: o.default.template({
              compiler: [8, ">= 4.3.0"],
              main: function main(e, t, n, r, o) {
                var i,
                    a = e.lookupProperty || function (e, t) {
                  if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                };

                return '<span class="o-form-explain">' + e.escapeExpression((i = null != (i = a(n, "msg") || (null != t ? a(t, "msg") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
                  name: "msg",
                  hash: {},
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 29
                    },
                    end: {
                      line: 1,
                      column: 36
                    }
                  }
                }) : i)) + "</span>";
              },
              useData: !0
            }),
            getTemplateData: function getTemplateData() {
              return {
                msg: e
              };
            }
          });
        },
        showCallout: function showCallout(e, t) {
          var n = a.default.clone(e);
          n.className = "dependency-callout", n.btn && (n.content = this.__getDependencyCalloutBtn(n.btn), delete n.btn);
          var r = c.default.create(n);
          t || r.add(this.__getCalloutMsgContainer(l.default.localize("dependency.callout.msg", "courage"))), this.getCalloutParent().append(r.render().el), "success" === n.type && a.default.delay(function () {
            r.$el.fadeOut(800);
          }, 1e3);
        },
        removeCallout: function removeCallout() {
          this.$el.find(".dependency-callout").remove();
        },
        __evaluateCalloutObject: function __evaluateCalloutObject(e, t) {
          return e ? {
            title: l.default.localize("dependency.action.completed", "courage"),
            size: "large",
            type: "success"
          } : {
            title: l.default.localize("dependency.action.required", "courage", [t]),
            size: "large",
            type: "warning"
          };
        },
        __handleDependency: function __handleDependency(e, t) {
          var n = this,
              r = a.default.isFunction(t) ? t(e) : a.default.extend({}, t, n.__evaluateCalloutObject(e.resolved, t.title));
          n.removeCallout(), n.showCallout(r, e.resolved);
        },
        __showInputDependencies: function __showInputDependencies() {
          var e = this,
              t = e.options.deps[e.getModelValue()];
          t && a.default.isFunction(t.func) ? t.func().done(function (n) {
            e.__handleDependency({
              resolved: !0,
              data: n
            }, t.callout);
          }).fail(function (n) {
            e.__handleDependency({
              resolved: !1,
              data: n
            }, t.callout);
          }) : e.removeCallout();
        },
        _isEdited: !1,
        update: function update() {
          !this._isEdited && a.default.result(this.options, "validateOnlyIfDirty") && (this._isEdited = !0, this.addInlineValidation()), this.model.set(this.options.name, this.toModelValue()), this.options.deps && this.__showInputDependencies();
        },
        isEditMode: function isEditMode() {
          return !a.default.result(this.options, "readOnly") && (!0 !== a.default.result(this.options, "read") || !0 === this.model.get("__edit__"));
        },
        render: function render() {
          this.preRender();
          var e = this.options.params;
          return this.options.params = a.default.resultCtx(this.options, "params", this), this.isEditMode() ? (this.editMode(), a.default.resultCtx(this.options, "disabled", this) ? this.disable() : this.enable()) : this.readMode(), this.options.params = e, this.addAriaLabel(), this.postRender(), this;
        },
        validate: function validate() {
          if (!this.model.get("__pending__") && this.isEditMode() && a.default.isFunction(this.model.validateField)) {
            var e = this.model.validateField(this.options.name);
            e && a.default.delay(function () {
              this.model.trigger("form:clear-error:" + this.options.name), this.model.trigger("invalid", this.model, e, !1);
            }.bind(this), 100);
          }
        },
        addModelListeners: function addModelListeners() {
          this.listenTo(this.model, "form:field-error", function (e) {
            this.options.name === e && this.__markError();
          }), this.listenTo(this.model, "form:clear-errors change:" + this.options.name, this.__clearError), this.listenTo(this.model, "form:clear-error:" + this.options.name, this.__clearError);
        },
        val: function val() {
          throw new Error("val() is an abstract method");
        },
        focus: function focus() {
          throw new Error("focus() is an abstract method");
        },
        defaultValue: function defaultValue() {
          return "";
        },
        editMode: function editMode() {
          var e = a.default.extend({}, this.options, {
            value: this.getModelValue()
          });
          return this.$el.html(this.template(e)), this.options.multi && this.$el.removeClass("margin-r"), this;
        },
        readMode: function readMode() {
          return this.$el.text(this.getReadModeString()), this.$el.removeClass("error-field"), this.options.multi && this.$el.addClass("margin-r"), this;
        },
        getReadModeString: function getReadModeString() {
          var e = a.default.resultCtx(this.options, "readModeString", this);
          return e || this.toStringValue();
        },
        getModelValue: function getModelValue() {
          var e = this.model.get(this.options.name);
          return a.default.isFunction(this.from) && (e = this.from.call(this, e)), a.default.isFunction(this.options.from) && (e = this.options.from.call(this, e)), e;
        },
        toStringValue: function toStringValue() {
          var e = this.getModelValue();
          return this.options.options && (e = this.options.options[e]), (Number.isInteger(e) || "boolean" == typeof e) && (e = String(e)), e || this.defaultValue();
        },
        resize: function resize() {
          this.model.trigger("form:resize");
        },
        disable: function disable() {
          this.$(":input").prop("disabled", !0);
        },
        enable: function enable() {
          this.$(":input").prop("disabled", !1);
        },
        changeType: function changeType(e) {
          this.$(":input").prop("type", e), this.options.type = e;
        },
        getNameString: function getNameString() {
          return a.default.isArray(this.options.name) ? this.options.name.join("-") : this.options.name;
        },
        getParams: function getParams(e) {
          var t = e || this.options || {};
          return a.default.clone(a.default.resultCtx(t, "params", this) || {});
        },
        getParam: function getParam(e, t) {
          var n = a.default.resultCtx(this.getParams(), e, this);
          return a.default.isUndefined(n) ? t : n;
        },
        getParamOrAttribute: function getParamOrAttribute(e) {
          return this.getParam(e) || a.default.result(this, e);
        },
        __markError: function __markError() {
          this.$el.addClass("o-form-has-errors");
        },
        __clearError: function __clearError() {
          this.$el.removeClass("o-form-has-errors");
        }
      });
      t.default = d, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        if (e && !e.__edit__) return l.default.extend({
          __edit__: l.default.constant(!0)
        }, e);
      }

      function i(e) {
        e = l.default.pick(e || {}, "action", "id", "className", "text", "type");
        var t, n, r;
        return p.default.extend({
          tagName: "input",
          className: "button",
          events: {
            click: function click() {
              e.action && !this.disabled() && e.action.call(this);
            },
            keyup: function keyup(t) {
              u.default.isEnter(t) && e.action && !this.disabled() && e.action.call(this);
            }
          },
          disabled: function disabled() {
            return !0 === this.$el.prop("disabled");
          },
          disable: function disable() {
            this.$el.prop("disabled", !0), this.$el.addClass("btn-disabled");
          },
          enable: function enable() {
            this.$el.prop("disabled", !1), this.$el.removeClass("btn-disabled");
          },
          initialize: function initialize() {
            var r = this;
            this.$el.attr("type", "save" === e.type ? "submit" : "button"), this.$el.val(e.text), e.id && this.$el.attr("id", e.id), e.className && this.$el.addClass(e.className), e.type && this.$el.attr("data-type", e.type), this.$el.mousedown(function () {
              r.model.set("__pending__", !0);
            }), this.$el.mouseup(function () {
              r.model.set("__pending__", !1);
            }), this.listenTo(this.model, "form:set-saving-state", function () {
              this.disable(), "save" === e.type && (t = setTimeout(l.default.bind(this.__changeSaveText, this), 1e3));
            }), this.listenTo(this.model, "form:clear-saving-state", function () {
              this.enable(), "save" === e.type && (clearTimeout(t), clearInterval(n), this.$el.val(e.text));
            });
          },
          __changeSaveText: function __changeSaveText() {
            r = 0, n = setInterval(l.default.bind(this.__showLoadingText, this), 200);
          },
          __showLoadingText: function __showLoadingText() {
            this.$el.val(_[r++ % _.length]);
          }
        });
      }

      function a(e, t) {
        if (e || (e = {}), "label" === e.type) return void (e.label || c.default.warn('A label input must have a "label" parameter', e));
        if ("button" === e.type) return e.title || e.icon || c.default.warn('A button input must have a "title" and/or an "icon" parameter', e), void (e.click || e.href || c.default.warn('A button input must have a "click" and/or an "href" parameter', e));
        if (e.name || e.input || c.default.warn('Missing "name" or "input" parameters', e), l.default.isArray(e.name) && l.default.isArray(e.input)) throw new Error('Not allowed to have both "name" and "input" defined as array.');

        if ("list" !== e.type && e.name && t && t.allows) {
          var n = [];
          l.default.isArray(e.name) ? n = e.name : n.push(e.name), l.default.each(n, function (n) {
            if (!t.allows(n)) throw new Error("field not allowed: " + e.name);
          });
        }

        l.default.isArray(e.input) && "list" !== e.type && l.default.each(e.input, function (e) {
          a(e, t);
        });
        var r = l.default.keys(e),
            o = l.default.intersection(r, b);

        if (l.default.size(o) !== l.default.size(e)) {
          var i = l.default.clone(b);
          i.unshift(r), c.default.warn("Invalid input parameters", l.default.without.apply(null, i), e);
        }
      }

      function s(e, t, n) {
        e = l.default.clone(e), l.default.contains(["list", "group"], e.type) && (e.params = l.default.defaults({
          create: n,
          inputs: l.default.map(l.default.isArray(e.input) ? e.input : [e.input], function (e) {
            return l.default.first(s(e, t, n));
          })
        }, e.params || {}), delete e.input);
        var r = l.default.isArray(e.input) ? l.default.clone(e.input) : [e];
        return l.default.map(r, function (n) {
          var r = l.default.defaults({
            model: t.model
          }, n, l.default.omit(e, "input", "inputs"), t.options, {
            id: l.default.uniqueId("input"),
            readOnly: t.isReadOnly(),
            read: t.hasReadMode()
          });
          return t.isReadOnly() && (r.read = r.readOnly = !0), r;
        });
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var l = r(n(0)),
          u = r(n(8)),
          c = r(n(7)),
          d = r(n(4)),
          f = r(n(25)),
          p = r(n(1)),
          h = ["model", "id", "inputId", "type", "label", "sublabel", "tooltip", "name"],
          m = ["wide", "multi", "input", "label-top", "explain", "explain-top", "customExplain", "model", "name", "type", "autoRender"],
          g = ["model", "name", "label-top", "readOnly", "events", "initialize", "showWhen", "bindings", "render", "className", "data-se", "toggleWhen"],
          v = ["model", "name", "inputId", "type", "input", "placeholder", "label", "readOnly", "read", "disabled", "readModeString", "options", "deps", "from", "to", "autoRender", "inlineValidation", "validateOnlyIfDirty", "ariaLabel", "params", "autoComplete"],
          y = ["errorField"],
          b = l.default.uniq(l.default.union(h, m, g, v, y)),
          _ = ["•         ", "•  •      ", "•  •  •   ", "•  •  •  •", "   •  •  •", "      •  •", "         •", "          ", "          ", "          "],
          w = {
        LABEL_OPTIONS: h,
        CONTAINER_OPTIONS: m,
        WRAPPER_OPTIONS: g,
        INPUT_OPTIONS: v,
        generateInputOptions: s,
        changeEventString: function changeEventString(e) {
          return "change:" + e.join(" change:");
        },
        createReadFormButton: function createReadFormButton(e) {
          var t, n, r;
          return "cancel" === e.type ? (n = r = d.default.localize("oform.cancel", "courage"), t = function t() {
            this.model.trigger("form:cancel");
          }) : (n = d.default.localize("oform.edit", "courage"), r = n + " " + e.formTitle, t = function t() {
            this.model.set("__edit__", !0);
          }), p.default.extend({
            tagName: "a",
            className: e.className,
            attributes: {
              href: "#",
              "aria-label": r
            },
            template: function template() {
              return l.default.escape(n);
            },
            events: {
              click: function click(e) {
                e.preventDefault(), t.call(this);
              }
            }
          });
        },
        createButton: function createButton(e) {
          switch (e = l.default.clone(e), e.type) {
            case "save":
              l.default.defaults(e, {
                className: "button-primary"
              });
              break;

            case "cancel":
              l.default.defaults(e, {
                className: "button-clear",
                text: d.default.localize("oform.cancel", "courage"),
                action: function action() {
                  this.model.trigger("form:cancel");
                }
              });
              break;

            case "previous":
              l.default.defaults(e, {
                text: d.default.localize("oform.previous", "courage"),
                action: function action() {
                  this.model.trigger("form:previous");
                }
              });
          }

          return i(e);
        },
        validateInput: a,
        applyShowWhen: function applyShowWhen(e, t) {
          var n = function n(t) {
            return function () {
              e.$el.toggle(t), e.model.trigger("form:resize");
            };
          };

          f.default.applyDoWhen(e, o(t), function (t, r) {
            r.animate ? e.$el["slide" + (t ? "Down" : "Up")](200, n(t)) : e.$el.toggle(t);
          });
        },
        applyToggleWhen: function applyToggleWhen(e, t) {
          f.default.applyDoWhen(e, o(t), function (t, n) {
            e.$el.toggle(t), e.model.trigger("form:resize"), n.animate && e.render();
          });
        }
      };
      t.default = w, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(0)),
          i = r(n(39)),
          a = i.default.extend({
        secureJSON: !1,
        _builtInLocalProps: {
          __edit__: "boolean",
          __pending__: "boolean"
        },
        constructor: function constructor() {
          this.local = o.default.defaults({}, o.default.result(this, "local"), this._builtInLocalProps), o.default.result(this, "secureJSON") && (this.sync = o.default.wrap(this.sync, function (e, t, n, r) {
            return e.call(this, t, n, o.default.extend({
              dataType: "secureJSON"
            }, r));
          })), i.default.apply(this, arguments);
        }
      });
      t.default = a, e.exports = t.default;
    }, function (e, t) {
      e.exports = n(154);
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(0)),
          i = r(n(4)),
          a = i.default.localize,
          s = {
        STRING: "string",
        NUMBER: "number",
        INTEGER: "integer",
        BOOLEAN: "boolean",
        OBJECT: "object",
        FORMATDISPLAYTYPE: {
          "date-time": "date",
          uri: "uri",
          email: "email",
          "country-code": "country-code",
          "language-code": "language-code",
          country_code: "country_code",
          language_code: "language_code",
          locale: "locale",
          timezone: "timezone",
          "ref-id": "reference"
        },
        ARRAYDISPLAYTYPE: {
          arrayofobject: "arrayofobject",
          arrayofstring: "arrayofstring",
          arrayofnumber: "arrayofnumber",
          arrayofinteger: "arrayofinteger",
          "arrayofref-id": "arrayofref-id"
        },
        DISPLAYTYPES: {
          date: {
            type: "string",
            format: "date-time"
          },
          uri: {
            type: "string",
            format: "uri"
          },
          email: {
            type: "string",
            format: "email"
          },
          "country-code": {
            type: "string",
            format: "country-code"
          },
          "language-code": {
            type: "string",
            format: "language-code"
          },
          country_code: {
            type: "string"
          },
          language_code: {
            type: "string"
          },
          locale: {
            type: "string",
            format: "locale"
          },
          timezone: {
            type: "string",
            format: "timezone"
          },
          string: {
            type: "string"
          },
          number: {
            type: "number"
          },
          boolean: {
            type: "boolean"
          },
          integer: {
            type: "integer"
          },
          reference: {
            type: "string",
            format: "ref-id"
          },
          arrayofobject: {
            type: "array",
            items: {
              type: "object"
            }
          },
          arrayofstring: {
            type: "array",
            items: {
              type: "string"
            }
          },
          arrayofnumber: {
            type: "array",
            items: {
              type: "number"
            }
          },
          arrayofinteger: {
            type: "array",
            items: {
              type: "integer"
            }
          },
          "arrayofref-id": {
            type: "array",
            items: {
              type: "string",
              format: "ref-id"
            }
          },
          image: {
            type: "image"
          },
          password: {
            type: "string"
          }
        },
        SUPPORTSMINMAX: ["string", "number", "integer", "password"],
        SUPPORTENUM: ["string", "number", "integer", "object", "arrayofstring", "arrayofnumber", "arrayofinteger", "arrayofobject"],
        DATATYPE: {
          string: "string",
          number: "number",
          boolean: "boolean",
          integer: "integer",
          date: "datetime",
          object: "object",
          arrayofobject: "object array",
          arrayofstring: "string array",
          arrayofnumber: "number array",
          arrayofinteger: "integer array",
          "arrayofref-id": "reference array",
          "country-code": "country code",
          "language-code": "language code",
          country_code: "country code",
          language_code: "language code",
          reference: "reference",
          timezone: "timezone",
          image: "image"
        },
        MUTABILITY: {
          READONLY: "READ_ONLY",
          WRITEONLY: "WRITE_ONLY",
          READWRITE: "READ_WRITE",
          IMMUTABLE: "IMMUTABLE"
        },
        SCOPE: {
          NONE: "NONE",
          SELF: "SELF",
          SYSTEM: "SYSTEM"
        },
        DISPLAYSCOPE: {
          SELF: "User personal",
          SYSTEM: "System",
          NA: "None"
        },
        UNION: {
          DISABLE: "DISABLE",
          ENABLE: "ENABLE"
        },
        UNION_OPTIONS: {
          DISABLE: a("universal-directory.profiles.attribute.form.union.enable.display", "courage"),
          ENABLE: a("universal-directory.profiles.attribute.form.union.disable.display", "courage")
        },
        PERMISSION: {
          HIDE: "HIDE",
          READ_ONLY: "READ_ONLY",
          WRITE_ONLY: "WRITE_ONLY",
          READ_WRITE: "READ_WRITE"
        },
        ENDUSER_ATTRIBUTE_PERMISSION_OPTIONS: {
          HIDE: a("universal-directory.profiles.attribute.enduser.permission.hide", "courage"),
          READ_ONLY: a("universal-directory.profiles.attribute.enduser.permission.readonly", "courage"),
          READ_WRITE: a("universal-directory.profiles.attribute.enduser.permission.readwrite", "courage")
        },
        ATTRIBUTE_LEVEL_MASTERING_OPTIONS: {
          INHERIT: a("universal-directory.profiles.attribute.source.inherit", "courage"),
          OKTA_MASTERED: a("universal-directory.profiles.attribute.source.oktamastered", "courage"),
          OVERRIDE: a("universal-directory.profiles.attribute.source.override", "courage")
        },
        USERNAMETYPE: {
          NONE: "non-username",
          OKTA_TO_APP: "okta-to-app-username",
          OKTA_TO_AD: "okta-to-ad-username",
          APP_TO_OKTA: "app-to-okta-username",
          IDP_TO_OKTA: "idp-to-okta-username"
        },
        LOGINPATTERNFORMAT: {
          EMAIL: "EMAIL",
          CUSTOM: "CUSTOM",
          NONE: "NONE"
        },
        UNIQUENESS: {
          NOT_UNIQUE: "NOT_UNIQUE",
          PENDING_UNIQUENESS: "PENDING_UNIQUENESS",
          UNIQUE_VALIDATED: "UNIQUE_VALIDATED"
        },
        getDisplayType: function getDisplayType(e, t, n, r) {
          var o;
          return e && (o = t ? this.FORMATDISPLAYTYPE[t] : n ? this.ARRAYDISPLAYTYPE[e + "of" + n] : e), o || (o = void 0 === r ? "" : r), o;
        },
        getSourceUsernameType: function getSourceUsernameType(e, t, n) {
          var r = this.USERNAMETYPE.NONE;
          return "oktaToApp" === e ? "userName" === t ? r = this.USERNAMETYPE.OKTA_TO_APP : "cn" === t && (r = this.USERNAMETYPE.OKTA_TO_AD) : "appToOkta" === e && "login" === t && (r = "saml_idp" === n ? this.USERNAMETYPE.IDP_TO_OKTA : this.USERNAMETYPE.APP_TO_OKTA), r;
        },
        isArrayDataType: function isArrayDataType(e) {
          return o.default.contains(o.default.values(this.ARRAYDISPLAYTYPE), e);
        },
        isObjectDataType: function isObjectDataType(e) {
          return this.DATATYPE.object === e;
        }
      },
          l = s;
      t.default = l, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e, t) {
        for (var n = 0; n < e[c].length; n++) {
          if (t.cid === e[c][n].cid) return n;
        }
      }

      function i() {}

      function a(e) {
        e[d] = !0;
        var t = e.renderTemplate(e.template);
        t ? e.$el.html(t) : e.length && e.$el.empty(), e.each(function (e) {
          e[p]();
        });
      }

      function s(e) {
        var t = /^(?!(?:delegate|undelegate|_))([a-zA-Z0-9]+)(?:Events)$/;
        l.default.each(l.default.allKeys(e), function (n) {
          var r = n.match(t);

          if (r) {
            var o = l.default.result(e, n),
                i = e.options[r[1]] || e[r[1]];
            i && l.default.isObject(o) && l.default.isFunction(i.trigger) && l.default.each(o, function (t, n) {
              var r = l.default.isFunction(t) ? [t] : l.default.reduce(t.split(/\s+/), function (t, n) {
                return l.default.isFunction(e[n]) && t.push(e[n]), t;
              }, []);
              l.default.each(r, function (t) {
                e.listenTo(i, n, t);
              });
            });
          }
        });
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var l = r(n(0)),
          u = r(n(6)),
          c = "__children__",
          d = "__rendered__",
          f = "__parent__",
          p = "__add_to_container__",
          h = u.default.View.extend({
        constructor: function constructor(e) {
          this.options = e || {}, l.default.extend(this, l.default.pick(this.options, "state", "settings")), this[c] = [], this[d] = !1, this[f] = null, this.__children_definitions__ = this.children;
          var t = this.initialize;

          if (this.initialize = i, u.default.View.apply(this, arguments), l.default.each(l.default.result(this, "__children_definitions__"), function (e) {
            this.add.apply(this, l.default.isArray(e) ? e : [e]);
          }, this), delete this.__children_definitions__, this.autoRender && this.model) {
            var n = l.default.isArray(this.autoRender) ? l.default.map(this.autoRender, function (e) {
              return "change:" + e;
            }).join(" ") : "change";
            this.listenTo(this.model, n, function () {
              this.render();
            });
          }

          this.initialize = t, this.initialize.apply(this, arguments), s(this);
        },
        unregister: function unregister(e) {
          this.stopListening(e);
          var t = o(this, e);
          l.default.isNumber(t) && this[c].splice(t, 1);
        },
        autoRender: !1,
        template: null,
        children: [],
        add: function add(e, t, n, r, i) {
          var a = {},
              s = l.default.toArray(arguments);
          if (l.default.isFunction(e) && (!e.prototype || !e.prototype.render)) throw new Error("Type passed to add() is not a View");

          if (l.default.isObject(t) ? (a = t, t = a.selector, n = a.bubble, r = a.prepend, i = a.options) : l.default.isObject(n) && (a = n, n = a.bubble, r = a.prepend, i = a.options), l.default.isString(e) && (e = function (e) {
            return h.extend({
              constructor: function constructor() {
                try {
                  var t = u.default.$(e);
                  if (1 != t.length) throw "invalid Element";
                  var n = /&(\w+|#x\d+);/g;
                  if (t.prop("outerHTML").replace(n, " ").length !== e.replace(n, " ").length) throw "invalid Element";
                  this.template = t.html(), this.el = t.empty()[0];
                } catch (t) {
                  this.template = e;
                }

                h.apply(this, arguments);
              }
            });
          }(e)), e.prototype && e.prototype instanceof h) {
            var d = l.default.omit(l.default.extend({}, this.options, i), "el");
            return s[0] = new e(d), this.add.apply(this, s);
          }

          if (l.default.isNumber(o(this, e))) throw new Error("Duplicate child");
          return e[f] = this, e[p] = function (t) {
            return function () {
              if (t && 1 != e[f].$(t).length) throw new Error("Invalid selector: " + t);
              var n = t ? this[f].$(t) : this[f].$el;
              this.render(), this.delegateEvents(), r ? n.prepend(this.el) : n.append(this.el);
            };
          }.call(e, t), n && this.listenTo(e, "all", function () {
            this.trigger.apply(this, arguments);
          }), this.rendered() && e[p](), this[c].push(e), this;
        },
        removeChildren: function removeChildren() {
          return this.each(function (e) {
            e.remove();
          }), this;
        },
        remove: function remove() {
          return this.removeChildren(), this[f] && this[f].unregister(this), u.default.View.prototype.remove.apply(this, arguments);
        },
        compileTemplate: function compileTemplate(e) {
          return l.default.template(e);
        },
        renderTemplate: function renderTemplate(e) {
          if (l.default.isString(e) && (e = this.compileTemplate(e)), l.default.isFunction(e)) return e(this.getTemplateData());
        },
        getTemplateData: function getTemplateData() {
          var e = this.model && this.model.toJSON({
            verbose: !0
          }) || {},
              t = l.default.omit(this.options, ["state", "settings", "model", "collection"]);
          return l.default.defaults({}, e, t);
        },
        render: function render() {
          return this.preRender(), a(this), this.postRender(), this;
        },
        preRender: i,
        postRender: i,
        rendered: function rendered() {
          return this[d];
        },
        getChildren: function getChildren() {
          return this.toArray();
        },
        at: function at(e) {
          return this.getChildren()[e];
        },
        invoke: function invoke(e) {
          var t = l.default.toArray(arguments);
          return this.each(function (n) {
            n.size() && n.invoke.apply(n, t), l.default.isFunction(n[e]) && n[e].apply(n, t.slice(1));
          }), this;
        }
      }),
          m = ["each", "map", "reduce", "reduceRight", "find", "filter", "reject", "every", "some", "contains", "toArray", "size", "first", "initial", "rest", "last", "without", "indexOf", "shuffle", "lastIndexOf", "isEmpty", "chain", "where", "findWhere"];
      l.default.each(m, function (e) {
        h.prototype[e] = function () {
          var t = l.default.toArray(arguments);
          return t.unshift(l.default.toArray(this[c])), l.default[e].apply(l.default, t);
        };
      }, void 0);
      var g = h;
      t.default = g, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(0)),
          i = r(n(38)),
          a = i.default.extend({
        secureJSON: !1,
        constructor: function constructor() {
          o.default.result(this, "secureJSON") && (this.sync = o.default.wrap(this.sync, function (e, t, n, r) {
            return e.call(this, t, n, o.default.extend({
              dataType: "secureJSON"
            }, r));
          })), i.default.apply(this, arguments);
        }
      });
      t.default = a, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        "@babel/helpers - typeof";

        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;

      var i = r(n(0)),
          a = r(n(11)),
          s = function s(e) {
        var t = i.default.omit(e.local, i.default.keys(e._builtInLocalProps));
        return i.default.size(e.props) + i.default.size(t) > 0;
      },
          l = a.default.extend({
        flat: !1,
        constructor: function constructor() {
          a.default.apply(this, arguments), this.on("sync", this._setSynced);
        },
        allows: function allows() {
          return !s(this) || a.default.prototype.allows.apply(this, arguments);
        },
        set: function set(e, t) {
          var n;
          return "object" === o(e) ? n = e : (n = {})[e] = t, (0, i.default)(n).each(function (e, t) {
            e && i.default.isArray(e.__attributes) && this.on("change:" + e.__attributes.join(" change:"), function () {
              var e = this.get(t);
              e !== this.__schema__.computedProperties[t] && (this.__schema__.computedProperties[t] = e, this.trigger("change:" + t, e));
            }, this);
          }, this), a.default.prototype.set.apply(this, arguments);
        },
        get: function get() {
          var e = a.default.prototype.get.apply(this, arguments);
          return i.default.isFunction(e) ? e.apply(this, i.default.map(e.__attributes || [], this.get, this)) : e;
        },
        toJSON: function toJSON(e) {
          e || (e = {});
          var t = a.default.prototype.toJSON.apply(this, arguments);
          return (0, i.default)(t).each(function (n, r) {
            "function" == typeof n && (e.verbose ? t[r] = this.get(r) : delete t[r]);
          }, this), e.verbose || (0, i.default)(t).each(function (e, n) {
            /^__\w+__$/.test(n) && delete t[n];
          }), t;
        },
        sanitizeAttributes: function sanitizeAttributes(e) {
          var t = {};
          return i.default.each(e, function (e, n) {
            i.default.isFunction(e) || (t[n] = e);
          }), t;
        },
        reset: function reset(e) {
          this.clear(e), this.set(this.sanitizeAttributes(this.defaults), e);
        },
        clear: function clear(e) {
          var t = {};
          return i.default.each(this.sanitizeAttributes(this.attributes), function (e, n) {
            t[n] = void 0;
          }), this.set(t, i.default.extend({}, e, {
            unset: !0
          }));
        },
        _setSynced: function _setSynced(e) {
          this._syncedData = e && i.default.isFunction(e.toJSON) ? e.toJSON() : {};
        },
        _getSynced: function _getSynced() {
          return this._syncedData;
        },
        isSynced: function isSynced() {
          return i.default.isEqual(this._getSynced(), this.toJSON());
        }
      }, {
        ComputedProperty: function ComputedProperty() {
          var e = i.default.toArray(arguments),
              t = e.pop();
          return t.__attributes = e.pop(), t;
        }
      }),
          u = l;

      t.default = u, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(0)),
          i = r(n(11)),
          a = i.default.extend({
        local: function local() {
          var e = window.okta && window.okta.settings || {},
              t = window.okta && window.okta.theme || "";
          return {
            orgId: ["string", !1, e.orgId],
            orgName: ["string", !1, e.orgName],
            serverStatus: ["string", !1, e.serverStatus],
            persona: ["string", !1, e.persona],
            isDeveloperConsole: ["boolean", !1, e.isDeveloperConsole],
            isPreview: ["boolean", !1, e.isPreview],
            permissions: ["array", !0, e.permissions || []],
            theme: ["string", !1, t]
          };
        },
        extraProperties: !0,
        constructor: function constructor() {
          this.features = window._features || [], i.default.apply(this, arguments);
        },
        hasFeature: function hasFeature(e) {
          return o.default.contains(this.features, e);
        },
        hasAnyFeature: function hasAnyFeature(e) {
          return o.default.some(e, this.hasFeature, this);
        },
        hasPermission: function hasPermission(e) {
          return o.default.contains(this.get("permissions"), e);
        },
        isDsTheme: function isDsTheme() {
          return "dstheme" === this.get("theme");
        }
      });
      t.default = a, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        var t = i.default.extend(e.click ? {
          click: e.click
        } : {}, e.events || {}),
            n = {};
        return i.default.each(t, function (t, r) {
          n[r] = function (n) {
            e.href || (n.preventDefault(), n.stopPropagation()), this.disabled && "click" === r || t.apply(this, arguments);
          };
        }), n;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var i = r(n(0)),
          a = r(n(45)),
          s = {
        create: function create(e) {
          return e = i.default.clone(e), e.attrs = e.attributes, delete e.attributes, a.default.extend(i.default.extend(e, {
            events: o(e)
          }));
        }
      };
      t.default = s, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(0)),
          i = r(n(1)),
          a = {
        redirect: function redirect(e) {
          window.location = e;
        },
        reloadPage: function reloadPage() {
          window.location.reload();
        },
        constantError: function constantError(e) {
          return function () {
            throw new Error(e);
          };
        },
        getUrlQueryString: function getUrlQueryString(e) {
          o.default.isObject(e) || (e = {});
          var t = o.default.without(o.default.map(e, function (e, t) {
            if (void 0 !== e && null !== e) return t + "=" + encodeURIComponent(e);
          }), void 0).join("&");
          return o.default.isEmpty(t) ? "" : "?" + t;
        },
        isABaseView: function isABaseView(e) {
          return e instanceof i.default || e.prototype instanceof i.default || e === i.default;
        }
      };
      t.default = a, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;

      var o = r(n(3)),
          i = r(n(0)),
          a = r(n(15)),
          s = r(n(16)),
          l = r(n(7)),
          u = r(n(13)),
          c = r(n(4)),
          d = r(n(21)),
          f = c.default.localize,
          p = u.default.STRING,
          h = u.default.NUMBER,
          m = u.default.INTEGER,
          g = u.default.OBJECT,
          v = function v(e, t) {
        return e + "of" + t;
      },
          y = s.default.extend({
        defaults: {
          description: void 0,
          minLength: void 0,
          maxLength: void 0,
          format: void 0
        },
        parse: function parse(e) {
          if (i.default.isString(e.format)) {
            var t = /^\/(.+)\/$/.exec(e.format);
            t && (e.format = t[1]);
          }

          return e;
        }
      }),
          b = a.default.extend({
        model: y
      }),
          _ = b.extend({
        _type: "allOf"
      }),
          w = b.extend({
        _type: "oneOf"
      }),
          E = b.extend({
        _type: "noneOf"
      }),
          O = {
        string: f("schema.validation.field.value.must.string", "courage"),
        number: f("schema.validation.field.value.must.number", "courage"),
        integer: f("schema.validation.field.value.must.integer", "courage"),
        object: f("schema.validation.field.value.must.object", "courage")
      },
          S = /[^a-zA-Z0-9-]/,
          x = s.default.extend({
        constraintHandlers: {
          between: "_checkBetweenConstraints",
          greaterThan: "_checkGreaterThanConstraint",
          lessThan: "_checkLessThanConstraint",
          equals: "_checkEqualsConstraint"
        },
        idAttribute: "name",
        local: {
          __oneOf__: {
            type: "array",
            minItems: 1
          }
        },
        defaults: {
          name: "",
          title: void 0,
          type: void 0,
          description: void 0,
          required: !1,
          format: void 0,
          union: void 0,
          subSchemas: void 0,
          settings: {
            permissions: {
              SELF: u.default.PERMISSION.READ_ONLY
            }
          },
          unique: void 0,
          __metadata__: void 0,
          __isSensitive__: s.default.ComputedProperty(["settings"], function (e) {
            return !(!e || !e.sensitive);
          }),
          __unique__: !1,
          __isUniqueValidated__: s.default.ComputedProperty(["unique"], function (e) {
            return e === u.default.UNIQUENESS.UNIQUE_VALIDATED;
          }),
          __isPendingUniqueness__: s.default.ComputedProperty(["unique"], function (e) {
            return e === u.default.UNIQUENESS.PENDING_UNIQUENESS;
          }),
          __isUniqueness__: s.default.ComputedProperty(["__isUniqueValidated__", "__isPendingUniqueness__"], function (e, t) {
            return e || t;
          }),
          __canBeSensitive__: s.default.ComputedProperty(["__metadata__"], function (e) {
            return !(!e || !e.sensitivizable);
          }),
          __userPermission__: u.default.PERMISSION.READ_ONLY,
          __displayType__: void 0,
          __displayTypeLabel__: s.default.ComputedProperty(["__displayType__"], function (e) {
            return u.default.DATATYPE[e] || e;
          }),
          __supportsMinMax__: !1,
          __isReadOnly__: s.default.ComputedProperty(["mutability"], function (e) {
            return e === u.default.MUTABILITY.READONLY;
          }),
          __isWriteOnly__: s.default.ComputedProperty(["mutability"], function (e) {
            return e === u.default.MUTABILITY.WRITEONLY;
          }),
          __displayScope__: void 0,
          __isScopeSelf__: s.default.ComputedProperty(["scope"], function (e) {
            return e === u.default.SCOPE.SELF;
          }),
          __isNoneScopeArrayType__: s.default.ComputedProperty(["__isScopeSelf__", "__displayType__"], function (e, t) {
            return !e && u.default.isArrayDataType(t);
          }),
          __isImported__: s.default.ComputedProperty(["externalName"], function (e) {
            return !!e;
          }),
          __isFromBaseSchema__: s.default.ComputedProperty(["__schemaMeta__"], function (e) {
            return e && "base" === e.name;
          }),
          __enumDefined__: !1,
          __supportEnum__: s.default.ComputedProperty(["__displayType__"], function (e) {
            return i.default.contains(u.default.SUPPORTENUM, e);
          }),
          __isNumberTypeEnum__: s.default.ComputedProperty(["__displayType__"], function (e) {
            return i.default.contains([u.default.NUMBER, u.default.ARRAYDISPLAYTYPE.arrayofnumber], e);
          }),
          __isIntegerTypeEnum__: s.default.ComputedProperty(["__displayType__"], function (e) {
            return i.default.contains([u.default.INTEGER, u.default.ARRAYDISPLAYTYPE.arrayofinteger], e);
          }),
          __isObjectTypeEnum__: s.default.ComputedProperty(["__displayType__"], function (e) {
            return i.default.contains([u.default.OBJECT, u.default.ARRAYDISPLAYTYPE.arrayofobject], e);
          }),
          __isStringTypeEnum__: s.default.ComputedProperty(["__displayType__"], function (e) {
            return i.default.contains([u.default.STRING, u.default.ARRAYDISPLAYTYPE.arrayofstring], e);
          }),
          __enumConstraintType__: s.default.ComputedProperty(["__isStringTypeEnum__", "__isNumberTypeEnum__", "__isIntegerTypeEnum__", "__isObjectTypeEnum__"], function (e, t, n, r) {
            return e ? p : t ? h : n ? m : r ? g : void 0;
          }),
          __isEnumDefinedAndSupported__: s.default.ComputedProperty(["__enumDefined__", "__supportEnum__"], function (e, t) {
            return e && t;
          }),
          __isLoginOfBaseSchema__: s.default.ComputedProperty(["__isFromBaseSchema__", "name"], function (e, t) {
            return e && "login" === t;
          }),
          __isLoginFormatRestrictionToEmail__: s.default.ComputedProperty(["__loginFormatRestriction__"], function (e) {
            return e === u.default.LOGINPATTERNFORMAT.EMAIL;
          })
        },
        initialize: function initialize() {
          s.default.prototype.initialize.apply(this, arguments), this.listenTo(this, "change:__displayType__", this._updateTypeFormatConstraints), this.listenTo(this, "change:type change:format change:items", this._updateDisplayType), this.listenTo(this, "change:__minVal__ change:__maxVal__", this._updateMinMax), this.listenTo(this, "change:__equals__", this._convertEqualsToMinMax), this.listenTo(this, "change:__constraint__", this._setConstraintText), this._setConstraintText(), this._setLoginPattern();
        },
        parse: function parse(e) {
          return e = i.default.clone(e), "object" === e.type && "image" === e.extendedType && (e.type = "image"), e.__displayType__ = u.default.getDisplayType(e.type, e.format, e.items ? e.items.format ? e.items.format : e.items.type : void 0), this._setRangeConstraints(e), e.__supportsMinMax__ = -1 !== u.default.SUPPORTSMINMAX.indexOf(e.__displayType__), e.__displayScope__ = u.default.DISPLAYSCOPE[e.scope] || u.default.DISPLAYSCOPE.NA, e.settings && e.settings.permissions && e.settings.permissions.SELF && (e.__userPermission__ = e.settings.permissions.SELF), this._setMasterOverride(e), this._setSubSchemas(e), this._setUniqueness(e), e;
        },
        validate: function validate() {
          var e = this._validateEnumOneOf();

          if (e) return e;

          if (this.get("__supportsMinMax__") && this.get("__constraint__")) {
            var t = this.get("__constraint__"),
                n = this[this.constraintHandlers[t]];
            return i.default.isFunction(n) ? n.call(this) : void l.default.warn("No constraint handler found for: " + t);
          }
        },
        _checkBetweenConstraints: function _checkBetweenConstraints() {
          var e = this.get("__minVal__"),
              t = this.get("__maxVal__");

          if (e || t) {
            if (!e) return {
              __minVal__: "Min value is required"
            };
            if (!t) return {
              __maxVal__: "Max value is required"
            };

            var n = this._checkIntegerConstraints("__minVal__", "Min value");

            return n || (n = this._checkIntegerConstraints("__maxVal__", "Max value")) || (+e >= +t ? {
              __maxVal__: "Max val must be greater than min val"
            } : void 0);
          }
        },
        _checkGreaterThanConstraint: function _checkGreaterThanConstraint() {
          if (this.get("__minVal__")) {
            var e = this._checkIntegerConstraints("__minVal__", "Min value");

            return e || void 0;
          }
        },
        _checkLessThanConstraint: function _checkLessThanConstraint() {
          if (this.get("__maxVal__")) {
            var e = this._checkIntegerConstraints("__maxVal__", "Max value");

            return e || void 0;
          }
        },
        _checkEqualsConstraint: function _checkEqualsConstraint() {
          if (this.get("__equals__")) {
            var e = this._checkIntegerConstraints("__equals__", "Constraint");

            return e || void 0;
          }
        },
        _checkIntegerConstraints: function _checkIntegerConstraints(e, t) {
          var n = this.get(e),
              r = {};
          return isNaN(n) ? (r[e] = t + " must be a number", r) : +n < 0 ? (r[e] = t + " must be greater than 0", r) : void 0;
        },
        _setMasterOverride: function _setMasterOverride(e) {
          if (e.settings && e.settings.masterOverride && e.settings.masterOverride) {
            var t = e.settings.masterOverride.value;
            i.default.isArray(t) && !i.default.isEmpty(t) ? (e.__masterOverrideType__ = "OVERRIDE", e.__masterOverrideValue__ = t || []) : e.__masterOverrideType__ = e.settings.masterOverride.type;
          } else e.__masterOverrideType__ = "INHERIT";
        },
        _setRangeConstraints: function _setRangeConstraints(e) {
          e.__displayType__ === p ? (e.__minVal__ = e.minLength, e.__maxVal__ = e.maxLength) : e.__displayType__ !== m && e.__displayType__ !== h || (e.__minVal__ = e.minimum, e.__maxVal__ = e.maximum), e.__minVal__ && e.__maxVal__ ? e.__minVal__ === e.__maxVal__ ? (e.__constraint__ = "equals", e.__equals__ = e.__minVal__) : e.__constraint__ = "between" : !e.__minVal__ && e.__maxVal__ ? e.__constraint__ = "lessThan" : !e.__maxVal__ && e.__minVal__ && (e.__constraint__ = "greaterThan");
        },
        _setSubSchemas: function _setSubSchemas(e) {
          e.allOf ? e.subSchemas = new _(e.allOf, {
            parse: !0
          }) : e.oneOf ? e.subSchemas = new w(e.oneOf, {
            parse: !0
          }) : e.noneOf && (e.subSchemas = new E(e.noneOf, {
            parse: !0
          }));
        },
        _setUniqueness: function _setUniqueness(e) {
          var t = e && e.unique;
          e.__unique__ = !(!t || t !== u.default.UNIQUENESS.UNIQUE_VALIDATED && t !== u.default.UNIQUENESS.PENDING_UNIQUENESS);
        },
        _setLoginPattern: function _setLoginPattern() {
          if (this.get("__isLoginOfBaseSchema__")) {
            var e = this.get("pattern");
            ".+" === e ? this.set("__loginFormatRestriction__", u.default.LOGINPATTERNFORMAT.NONE) : e ? (this.set("__loginFormatRestriction__", u.default.LOGINPATTERNFORMAT.CUSTOM), this.set("__loginFormatRestrictionCustom__", this._extractLoginPattern(e))) : this.set("__loginFormatRestriction__", u.default.LOGINPATTERNFORMAT.EMAIL);
          }
        },
        _updateDisplayType: function _updateDisplayType() {
          var e = this.get("type");
          if (e === p && this.get("format")) this.set("__displayType__", u.default.FORMATDISPLAYTYPE[this.get("format")]);else {
            var t = this.get("items"),
                n = t && (t.format ? t.format : t.type);
            e && n ? this.set("__displayType__", u.default.ARRAYDISPLAYTYPE[v(e, n)]) : this.set("__displayType__", e);
          }
        },
        _validateEnumOneOf: function _validateEnumOneOf() {
          if (this.get("__isEnumDefinedAndSupported__")) {
            var e = this.get("__oneOf__") || [];
            if (i.default.isEmpty(e)) return {
              __oneOf__: f("model.validation.field.blank", "courage")
            };

            if (!this._isValidateOneOfConstraint(e)) {
              var t = this.get("__enumConstraintType__");
              return {
                __oneOf__: O[t]
              };
            }
          }
        },
        _isValidateOneOfConstraint: function _isValidateOneOfConstraint(e) {
          var t = this.get("__enumConstraintType__");
          return i.default.all(e, function (e) {
            return d.default.isConstraintValueMatchType(e.const, t);
          });
        },
        toJSON: function toJSON() {
          var e = s.default.prototype.toJSON.apply(this, arguments);
          return e.settings = {
            permissions: {}
          }, e.settings.permissions.SELF = this.get("__userPermission__"), this.get("__isSensitive__") && (e.settings.sensitive = this.get("__isSensitive__")), "image" === this.get("type") && (e.type = "object", e.extendedType = "image"), e = this._enumAssignment(e), e = this._attributeOverrideToJson(e), e = this._normalizeUnionValue(e), e = this._patternAssignment(e), e = this._uniquenessAssignment(e);
        },
        _attributeOverrideToJson: function _attributeOverrideToJson(e) {
          var t = this.get("__masterOverrideType__"),
              n = this.get("__masterOverrideValue__");
          return "OKTA_MASTERED" === t ? e.settings.masterOverride = {
            type: "OKTA_MASTERED"
          } : "OVERRIDE" === t && (e.settings.masterOverride = {
            type: "ORDERED_LIST",
            value: []
          }, n instanceof a.default ? i.default.each(n.toJSON(), function (t) {
            e.settings.masterOverride.value.push(t.id);
          }) : n instanceof Array && (e.settings.masterOverride.value = n), i.default.isEmpty(e.settings.masterOverride.value) && delete e.settings.masterOverride), "INHERIT" === t && delete e.settings.masterOverride, e;
        },
        _normalizeUnionValue: function _normalizeUnionValue(e) {
          return this.get("__isNoneScopeArrayType__") || (e.union = void 0), e;
        },
        _enumAssignment: function _enumAssignment(e) {
          if (!this.get("__isEnumDefinedAndSupported__")) return e;

          var t = this._getEnumOneOfWithTitleCheck();

          return "array" === this.get("type") ? (delete e.items.enum, e.items.oneOf = t) : (delete e.enum, e.oneOf = t), e;
        },
        _patternAssignment: function _patternAssignment(e) {
          if (!this.get("__isLoginOfBaseSchema__") || !this.get("__loginFormatRestriction__")) return e;

          switch (this.get("__loginFormatRestriction__")) {
            case u.default.LOGINPATTERNFORMAT.EMAIL:
              delete e.pattern;
              break;

            case u.default.LOGINPATTERNFORMAT.CUSTOM:
              e.pattern = this._buildLoginPattern(this.get("__loginFormatRestrictionCustom__"));
              break;

            case u.default.LOGINPATTERNFORMAT.NONE:
              e.pattern = ".+";
          }

          return e;
        },
        _uniquenessAssignment: function _uniquenessAssignment(e) {
          return this.get("__unique__") ? this.get("__isUniqueness__") || (e.unique = u.default.UNIQUENESS.UNIQUE_VALIDATED) : delete e.unique, e;
        },
        _escapedRegexChar: function _escapedRegexChar(e, t) {
          var n = e.charAt(t);
          return S.test(n) ? "\\" + n : n;
        },
        _buildLoginPattern: function _buildLoginPattern(e) {
          for (var t = "", n = 0; n < e.length; n++) {
            t += this._escapedRegexChar(e, n);
          }

          return "[" + t + "]+";
        },
        _extractLoginPattern: function _extractLoginPattern(e) {
          var t = /^\[(.*)\]\+/,
              n = e.match(t);
          return n ? n[1].replace(/\\(.)/g, "$1") : e;
        },
        _getEnumOneOfWithTitleCheck: function _getEnumOneOfWithTitleCheck() {
          var e = this.get("__oneOf__");
          return i.default.map(e, function (e) {
            return "" !== o.default.trim(e.title) ? e : (e.title = i.default.isString(e.const) ? e.const : JSON.stringify(e.const), e);
          });
        },
        _updateTypeFormatConstraints: function _updateTypeFormatConstraints() {
          var e = this.get("__displayType__");
          this.unset("format", {
            silent: !0
          }), this.unset("items", {
            silent: !0
          }), this.set(u.default.DISPLAYTYPES[e]), e !== h && e !== m && (this.unset("minimum"), this.unset("maximum")), e !== p && (this.unset("minLength"), this.unset("maxLength")), this.unset("__minVal__"), this.unset("__maxVal__"), this.unset("__equals__"), this.set("__supportsMinMax__", -1 !== u.default.SUPPORTSMINMAX.indexOf(this.get("__displayType__")));
        },
        _updateMinMax: function _updateMinMax() {
          var e,
              t,
              n = this.get("__displayType__");
          n === p ? (e = "minLength", t = "maxLength") : n !== m && n !== h || (e = "minimum", t = "maximum"), this.get("__minVal__") ? this.set(e, parseInt(this.get("__minVal__"), 10)) : this.unset(e), this.get("__maxVal__") ? this.set(t, parseInt(this.get("__maxVal__"), 10)) : this.unset(t);
        },
        _convertEqualsToMinMax: function _convertEqualsToMinMax() {
          var e = this.get("__equals__");
          e && (this.set("__minVal__", e), this.set("__maxVal__", e));
        },
        _setConstraintText: function _setConstraintText() {
          var e = this.get("__constraint__"),
              t = this.get("__minVal__"),
              n = this.get("__maxVal__"),
              r = this.get("__equals__");

          switch (e) {
            case "between":
              this.set("__constraintText__", "Between " + t + " and " + n);
              break;

            case "greaterThan":
              this.set("__constraintText__", "Greater than " + t);
              break;

            case "lessThan":
              this.set("__constraintText__", "Less than " + n);
              break;

            case "equals":
              this.set("__constraintText__", "Equals " + r);
              break;

            default:
              this.set("__constraintText__", "");
          }
        },
        cleanup: function cleanup() {
          "lessThan" === this.get("__constraint__") ? this.unset("__minVal__") : "greaterThan" === this.get("__constraint__") && this.unset("__maxVal__"), this.get("scope") !== u.default.SCOPE.SYSTEM && (!0 === this.get("__isScopeSelf__") ? this.set({
            scope: u.default.SCOPE.SELF
          }, {
            silent: !0
          }) : this.unset("scope")), this.get("__unique__") || this.unset("unique");
        },
        isEnumType: function isEnumType() {
          return !!this.getEnumValues();
        },
        getEnumValues: function getEnumValues() {
          return this.get("oneOf") || this.get("enum") || this.get("items") && this.get("items").oneOf || this.get("items") && this.get("items").enum;
        },
        detectHasEnumDefined: function detectHasEnumDefined() {
          var e = this.getEnumValues();
          e && (this.set("__oneOf__", d.default.convertToOneOf(e)), this.set("__enumDefined__", !0));
        }
      }),
          T = a.default.extend({
        model: x,
        clone: function clone() {
          return new this.constructor(this.toJSON({
            verbose: !0
          }), {
            parse: !0
          });
        },
        areAllReadOnly: function areAllReadOnly() {
          return i.default.all(this.pluck("__isReadOnly__"));
        },
        createModelProperties: function createModelProperties() {
          return this.reduce(function (e, t) {
            var n = t.get("type");
            return e[t.id] = i.default.clone(u.default.DISPLAYTYPES[n]), -1 !== u.default.SUPPORTSMINMAX.indexOf(n) && (e[t.id].minLength = t.get("minLength"), e[t.id].maxLength = t.get("maxLength")), "string" === n && (e[t.id].format = t.get("format")), e;
          }, {});
        }
      }),
          k = {
        Model: x,
        Collection: T
      };

      t.default = k, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        var t = s(e.enumValues),
            n = {
          name: e.name,
          label: e.title,
          readOnly: e.readOnly,
          customExplain: e.explain,
          params: {
            enumOneOf: t
          },
          options: a(t)
        };
        return S.default.isArrayDataType(e.displayType) ? (n.type = "checkboxset", n.to = m, n.from = g) : (n.type = "select", n.to = h, n.from = p), n.input = null, n;
      }

      function i(e) {
        return O.default.isArray(e) ? a(s(e)) : {};
      }

      function a(e) {
        return l(e) ? O.default.reduce(e, function (e, t, n) {
          return e[f(n)] = t.title, e;
        }, {}) : {};
      }

      function s(e) {
        return O.default.all(e, E.default.isPlainObject) ? l(e) ? e : d(e) : u(e);
      }

      function l(e) {
        return O.default.isArray(e) && O.default.all(e, function (e) {
          return O.default.has(e, "const") && O.default.has(e, "title");
        });
      }

      function u(e) {
        return O.default.map(e, function (e) {
          return {
            const: e,
            title: c(e)
          };
        });
      }

      function c(e) {
        return O.default.isObject(e) ? JSON.stringify(e) : O.default.isNumber(e) ? e + "" : e;
      }

      function d(e) {
        var t = O.default.partial(O.default.has, O.default, T);
        return O.default.all(e, t) ? O.default.chain(e).filter(function (e) {
          return E.default.isPlainObject(e) && O.default.has(e, T);
        }).map(function (e) {
          return {
            const: e,
            title: e[T]
          };
        }).value() : u(e);
      }

      function f(e) {
        return "".concat(k).concat(e);
      }

      function p(e) {
        var t = O.default.findIndex(this.options.params.enumOneOf, function (t) {
          return O.default.isObject(e) ? O.default.isEqual(t.const, e) : t.const === e;
        });
        return t > -1 ? f(t) : e;
      }

      function h(e) {
        if (!O.default.isString(e) || 0 !== e.indexOf(k)) return e;
        var t = e.replace(k, ""),
            n = this.options.params && O.default.isArray(this.options.params.enumOneOf) ? this.options.params.enumOneOf[t] : null;
        return O.default.has(n, "const") ? n.const : n;
      }

      function m(e) {
        return O.default.map(e, h.bind(this));
      }

      function g(e) {
        return O.default.map(e, p.bind(this));
      }

      function v(e) {
        return O.default.isString(e) && "" !== E.default.trim(e);
      }

      function y(e) {
        return O.default.isNumber(e) || O.default.isNumber(x.default.parseFloat(E.default.trim(e)));
      }

      function b(e) {
        var t = O.default.isNumber(e) ? e : x.default.parseInt(E.default.trim(e));
        return "number" == typeof t && isFinite(t) && Math.floor(t) === t;
      }

      function _(e) {
        if (O.default.isObject(e) && !O.default.isArray(e)) return !0;
        var t = x.default.parseObject(E.default.trim(e));
        return O.default.isObject(t) && !O.default.isArray(t);
      }

      function w(e, t) {
        switch (t) {
          case S.default.STRING:
            return v(e);

          case S.default.NUMBER:
            return y(e);

          case S.default.INTEGER:
            return b(e);

          case S.default.OBJECT:
            return _(e);
        }
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var E = r(n(3)),
          O = r(n(0)),
          S = r(n(13)),
          x = r(n(4)),
          T = "name",
          k = "_enum_",
          C = {
        getEnumInputOptions: o,
        getDropdownOptions: i,
        convertToOneOf: s,
        isConstraintValueMatchType: w
      };
      t.default = C, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e, t) {
        var n = s.default.result(e, "root") || "";
        return n && s.default.isString(t) ? [n, t].join("/").replace(/\/{2,}/g, "/") : t;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var i = r(n(6)),
          a = r(n(3)),
          s = r(n(0)),
          l = r(n(7)),
          u = r(n(17)),
          c = r(n(23)),
          d = r(n(24)),
          f = i.default.Router.extend({
        root: "",
        listen: d.default.prototype.listen,
        constructor: function constructor(e) {
          e || (e = {}), this.el = e.el, this.settings = new u.default(s.default.omit(e, "el")), e.root && (this.root = e.root), i.default.Router.apply(this, arguments), this.listen("notification", this._notify), this.listen("confirmation", this._confirm);
        },
        _confirm: function _confirm(e) {
          e || (e = {});
          var t = c.default.extend(s.default.pick(e, "title", "subtitle", "save", "ok", "cancel", "cancelFn", "noCancelButton", "noSubmitButton", "content", "danger", "type", "closeOnOverlayClick", "buttonOrder")),
              n = new t({
            model: this.settings
          });
          return n.render(), n;
        },
        _notify: function _notify(e) {
          var t = new d.default(e);
          return (0, a.default)("#content").prepend(t.render().el), t;
        },
        render: function render(e, t) {
          this.unload(), t = s.default.extend(s.default.pick(this, "settings", "el"), t || {}), this.controller = new e(t), this.controller.render();
        },
        start: function start() {
          var e = arguments;
          (0, a.default)(function () {
            if (i.default.History.started) return void l.default.error("History has already been started");
            i.default.history.start.apply(i.default.history, e);
          });
        },
        unload: function unload() {
          this.controller && (this.stopListening(this.controller), this.stopListening(this.controller.state), this.controller.remove());
        },
        route: function route(e, t, n) {
          return i.default.Router.prototype.route.call(this, o(this, e), t, n);
        },
        navigate: function navigate(e, t) {
          return i.default.Router.prototype.navigate.call(this, o(this, e), t);
        }
      });
      t.default = f, e.exports = t.default;
    }, function (e, t, n) {
      var r;
      void 0 !== (r = function () {}.call(t, n, t, e)) && (e.exports = r);
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        "@babel/helpers - typeof";

        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var i = r(n(2)),
          a = r(n(0)),
          s = r(n(1)),
          l = {
        level: "success",
        message: "Great Success!",
        hide: !0,
        fade: 400,
        delay: 3e3,
        width: 0,
        dismissable: !1
      },
          u = s.default.extend({
        className: "infobox infobox-confirm infobox-confirm-fixed",
        events: {
          "click .infobox-dismiss-link": function clickInfoboxDismissLink(e) {
            e.preventDefault(), this.fadeOut();
          }
        },
        template: i.default.template({
          1: function _(e, t, n, r, o) {
            var i = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<a class="infobox-dismiss-link" title="' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
              name: "i18n",
              hash: {
                bundle: "courage",
                code: "component.dismiss"
              },
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 58
                },
                end: {
                  line: 1,
                  column: 108
                }
              }
            })) + '" href="#"><span class="dismiss-icon"></span></a>';
          },
          3: function _(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return "<h3>" + e.escapeExpression((i = null != (i = a(n, "title") || (null != t ? a(t, "title") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
              name: "title",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 220
                },
                end: {
                  line: 1,
                  column: 229
                }
              }
            }) : i)) + "</h3>";
          },
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, i) {
            var a,
                s,
                l = null != t ? t : e.nullContext || {},
                u = e.hooks.helperMissing,
                c = e.escapeExpression,
                d = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return (null != (a = d(n, "if").call(l, null != t ? d(t, "dismissable") : t, {
              name: "if",
              hash: {},
              fn: e.program(1, i, 0),
              inverse: e.noop,
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 0
                },
                end: {
                  line: 1,
                  column: 164
                }
              }
            })) ? a : "") + '<span class="icon ' + c((s = null != (s = d(n, "level") || (null != t ? d(t, "level") : t)) ? s : u, "function" === o(s) ? s.call(l, {
              name: "level",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 182
                },
                end: {
                  line: 1,
                  column: 191
                }
              }
            }) : s)) + '-16"></span>' + (null != (a = d(n, "if").call(l, null != t ? d(t, "title") : t, {
              name: "if",
              hash: {},
              fn: e.program(3, i, 0),
              inverse: e.noop,
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 203
                },
                end: {
                  line: 1,
                  column: 241
                }
              }
            })) ? a : "") + "<p>" + c((s = null != (s = d(n, "message") || (null != t ? d(t, "message") : t)) ? s : u, "function" === o(s) ? s.call(l, {
              name: "message",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 244
                },
                end: {
                  line: 1,
                  column: 255
                }
              }
            }) : s)) + "</p>";
          },
          useData: !0
        }),
        initialize: function initialize() {
          this.options = a.default.defaults({}, this.options, l), this.$el.addClass("infobox-" + this.options.level), this.options.width && this.$el.width(this.options.width);
        },
        getTemplateData: function getTemplateData() {
          return a.default.extend(a.default.pick(this.options, "level", "message", "title"), {
            dismissable: !1 === this.options.hide || !0 === this.options.dismissable
          });
        },
        postRender: function postRender() {
          this.options.hide && a.default.delay(a.default.bind(this.fadeOut, this), this.options.delay);
        },
        fadeOut: function fadeOut() {
          this.$el.fadeOut(this.options.fade, a.default.bind(this.remove, this));
        }
      });
      t.default = u, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return "change:" + a.default.keys(e).join(" change:");
      }

      function o(e, t) {
        var n = this.model.get(t);
        return a.default.isFunction(e) ? e.call(this, n) : e === n;
      }

      function i(e, t, n) {
        var o = a.default.bind(n, e, e, t);
        e.render = a.default.wrap(e.render, function (t) {
          var n = t.call(e);
          return o({
            animate: !1
          }), n;
        }), e.listenTo(e.model, r(t), function () {
          o({
            animate: !0
          });
        });
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;

      var a = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n(0)),
          s = {
        applyDoWhen: function applyDoWhen(e, t, n) {
          e.model && a.default.isObject(t) && a.default.size(t) && a.default.isFunction(n) && i(e, t, function (e, t, r) {
            var i = a.default.every(a.default.map(t, o, e));
            n.call(e, i, r);
          });
        }
      };

      t.default = s, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        this.options = a.default.clone(e || {}), this.cid = a.default.uniqueId("class"), this.initialize.apply(this, arguments);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var i = r(n(6)),
          a = r(n(0));
      a.default.extend(o.prototype, i.default.Events, {
        initialize: function initialize() {}
      }), o.extend = i.default.Model.extend;
      var s = o;
      t.default = s, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(0)),
          i = r(n(1)),
          a = r(n(10)),
          s = i.default.extend({
        className: "o-form-button-bar",
        buttonOrder: ["previous", "save", "cancel"],
        initialize: function initialize(e) {
          var t = this,
              n = {
            previous: {
              type: "previous"
            },
            save: {
              type: "save",
              text: o.default.resultCtx(e, "save", this),
              id: o.default.resultCtx(e, "saveId", this),
              className: o.default.resultCtx(e, "saveClassName", this)
            },
            cancel: {
              type: "cancel",
              text: o.default.resultCtx(e, "cancel", this)
            }
          };

          this.__getButtonOrder(e).forEach(function (e) {
            t.addButton(n[e]);
          });
        },
        addButton: function addButton(e, t) {
          return this.add(a.default.createButton(e), t);
        },
        __getButtonOrder: function __getButtonOrder(e) {
          var t = o.default.resultCtx(e, "buttonOrder", this, this.buttonOrder),
              n = [];
          return e.noSubmitButton && n.push("save"), e.noCancelButton && n.push("cancel"), e.hasPrevStep || n.push("previous"), o.default.without.apply(o.default, [t].concat(n));
        }
      });
      t.default = s, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return o.default.isFunction(e) ? o.default.isFunction(e.prototype.editMode) && o.default.isFunction(e.prototype.readMode) : o.default.isObject(e) && o.default.isFunction(e.editMode) && o.default.isFunction(e.readMode);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;

      var o = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n(0)),
          i = {},
          a = {
        isBaseInput: r,
        register: function register(e, t) {
          i[e] = t;
        },
        get: function get(e) {
          var t = i[e.type];
          return t && (r(t) ? t : t(e));
        },
        unregister: function unregister(e) {
          delete i[e];
        }
      };

      t.default = a, e.exports = t.default;
    }, function (e, t) {
      e.exports = n(114);
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        "@babel/helpers - typeof";

        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      function i(e) {
        return this.params.autoWidth ? e.call(this) : d.default.defer(d.default.bind(e, this));
      }

      function a(e) {
        e.$select.hide();
        var t = (0, c.default)(e.$select[0]).hide();
        (0, c.default)("body").append(t);
        var n = e.params.width = 1.2 * t.width() + "px";
        return e.$el.append(t.show()), n;
      }

      function s(e, t, n) {
        var r = n.offset();
        e.css({
          left: r.left,
          top: r.top
        });
        var o = (0, c.default)(window),
            i = t.outerHeight(),
            a = i + t.offset().top - o.scrollTop(),
            s = o.height() - g,
            l = Math.min(i + s - a, v);
        t.css("max-height", l);
      }

      function l(e) {
        var t = e.next(".chzn-container"),
            n = t.clone(),
            r = t.find(".chzn-results");
        n.css("visibility", "hidden"), n.removeAttr("id"), n.find("li").removeAttr("id");
        var o = {
          left: t.css("left"),
          top: t.css("top"),
          position: t.css("position"),
          float: t.css("float"),
          "z-index": t.css("z-index")
        };
        r.hide();
        var i = d.default.debounce(function () {
          s(t, r, n);
        }, 10);
        e.off(".fixChosen"), e.on("liszt:showing_dropdown.fixChosen", function () {
          t.width(t.width()), e.after(n), t.css({
            position: "absolute",
            float: "none",
            "z-index": y,
            top: -999999
          }), (0, c.default)("body").append(t), r.show(), s(t, r, n), e.parents().scroll(i), (0, c.default)(window).on("resize scroll", i);
        }), e.on("liszt:hiding_dropdown.fixChosen remove.fixChosen", function () {
          e.parents().off("scroll", i), (0, c.default)(window).off("resize scroll", i), t.css(o), r.hide(), r.css("max-height", v), n.remove(), e.after(t);
        });
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var u = r(n(2)),
          c = r(n(3)),
          d = r(n(0)),
          f = r(n(8));
      n(78);
      var p = r(n(9)),
          h = u.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<select id="' + u((a = null != (a = c(n, "inputId") || (null != t ? c(t, "inputId") : t)) ? a : l, "function" === o(a) ? a.call(s, {
            name: "inputId",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 12
              },
              end: {
                line: 1,
                column: 23
              }
            }
          }) : a)) + '" name="' + u((a = null != (a = c(n, "name") || (null != t ? c(t, "name") : t)) ? a : l, "function" === o(a) ? a.call(s, {
            name: "name",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 31
              },
              end: {
                line: 1,
                column: 39
              }
            }
          }) : a)) + '"></select>';
        },
        useData: !0
      }),
          m = u.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<option value="' + u((a = null != (a = c(n, "key") || (null != t ? c(t, "key") : t)) ? a : l, "function" === o(a) ? a.call(s, {
            name: "key",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 15
              },
              end: {
                line: 1,
                column: 22
              }
            }
          }) : a)) + '">' + u((a = null != (a = c(n, "value") || (null != t ? c(t, "value") : t)) ? a : l, "function" === o(a) ? a.call(s, {
            name: "value",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 24
              },
              end: {
                line: 1,
                column: 33
              }
            }
          }) : a)) + "</option>";
        },
        useData: !0
      }),
          g = 20,
          v = 240,
          y = 5e4,
          b = p.default.extend({
        className: "o-form-select",
        events: {
          "change select": "update",
          "keyup .chzn-search > :text": function keyupChznSearchText(e) {
            f.default.isEsc(e) && (this.$(".chzn-search > :text").val(""), e.stopPropagation());
          }
        },
        constructor: function constructor() {
          this.template = h, this.option = m, p.default.apply(this, arguments), this.params = this.options.params || {};
        },
        editMode: function editMode() {
          this.$el.html(h(this.options)), this.$select = this.$("select");
          var e = this.getOptions();
          d.default.each(e, function (e, t) {
            this.$select.append(m({
              key: t,
              value: e
            }));
          }, this);
          var t = this.getModelValue();
          return t ? this.$select.val(t) : this.$("option:first-child").prop("selected", !0), this.$el.addClass("o-form-control"), !1 !== this.params.chosen && this.__applyChosen(), this;
        },
        __applyChosen: function __applyChosen(e) {
          var t = this.options.wide ? "100%" : this.params.width || "62%";
          this.params.autoWidth && (t = a(this)), i.call(this, function () {
            var n = this.getParam("searchThreshold", 10);
            d.default.result(this.options, "autoRender") || !1 === e || this.update(), this.$select.chosen({
              width: t,
              disable_search_threshold: n,
              placeholder_text: this.options.placeholder,
              search_contains: !0
            }), l(this.$select), this.params.autoWidth && this.$el.width(0), this.model.trigger("form:resize");
          });
        },
        val: function val() {
          return this.$select && this.$select.val();
        },
        focus: function focus() {
          if (this.$select) return this.$select.focus();
        },
        toStringValue: function toStringValue() {
          var e = this.getModelValue(),
              t = e,
              n = this.getOptions();
          return d.default.isEmpty(n) || (t = n[e]), d.default.isUndefined(t) && (t = this.defaultValue()), t || "";
        },
        getOptions: function getOptions() {
          var e = this.options.options;
          return d.default.isFunction(e) && (e = e.call(this)), d.default.isObject(e) ? e : {};
        },
        remove: function remove() {
          return this.$select && this.$select.trigger("remove"), p.default.prototype.remove.apply(this, arguments);
        }
      });
      t.default = b, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e, t) {
        return s.default.resultCtx(e.options, t, e) || s.default.result(e, t);
      }

      function i(e) {
        var t = "infobox clearfix infobox-" + o(e, "type");

        switch (o(e, "size")) {
          case "standard":
            t += "";
            break;

          case "slim":
            t += " infobox-slim";
            break;

          case "compact":
            t += " infobox-compact";
            break;

          case "large":
            t += " infobox-md";
        }

        return o(e, "dismissible") && (t += " infobox-dismiss"), t;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var a = r(n(2)),
          s = r(n(0)),
          l = r(n(32)),
          u = r(n(1)),
          c = {
        "click .infobox-dismiss-link": function clickInfoboxDismissLink(e) {
          var t = this;
          e.preventDefault(), this.$el.fadeOut(l.default.UNLOADING_FADE, function () {
            t.trigger("dismissed"), t.remove();
          });
        }
      },
          d = a.default.template({
        1: function _(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a data-se="dismiss-link" class="infobox-dismiss-link" title="' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "courage",
              code: "component.dismiss"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 81
              },
              end: {
                line: 1,
                column: 131
              }
            }
          })) + '" href="#"><span data-se="icon" class="dismiss-icon"></span></a>';
        },
        3: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<h3 data-se="header">' + e.escapeExpression((i = null != (i = a(n, "title") || (null != t ? a(t, "title") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "title",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 286
              },
              end: {
                line: 1,
                column: 295
              }
            }
          }) : i)) + "</h3>";
        },
        5: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<p data-se="sub-header">' + e.escapeExpression((i = null != (i = a(n, "subtitle") || (null != t ? a(t, "subtitle") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "subtitle",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 347
              },
              end: {
                line: 1,
                column: 359
              }
            }
          }) : i)) + "</p>";
        },
        7: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<ul data-se="list" class="bullets">' + (null != (i = a(n, "each").call(null != t ? t : e.nullContext || {}, null != t ? a(t, "bullets") : t, {
            name: "each",
            hash: {},
            fn: e.program(8, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 420
              },
              end: {
                line: 1,
                column: 483
              }
            }
          })) ? i : "") + "</ul>";
        },
        8: function _(e, t, n, r, o) {
          return '<li data-se="list-item">' + e.escapeExpression(e.lambda(t, t)) + "</li>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a,
              s = null != t ? t : e.nullContext || {},
              l = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return (null != (i = l(n, "if").call(s, null != t ? l(t, "dismissible") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 202
              }
            }
          })) ? i : "") + '<span data-se="icon" class="icon ' + e.escapeExpression((a = null != (a = l(n, "icon") || (null != t ? l(t, "icon") : t)) ? a : e.hooks.helperMissing, "function" == typeof a ? a.call(s, {
            name: "icon",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 235
              },
              end: {
                line: 1,
                column: 243
              }
            }
          }) : a)) + '"></span>' + (null != (i = l(n, "if").call(s, null != t ? l(t, "title") : t, {
            name: "if",
            hash: {},
            fn: e.program(3, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 252
              },
              end: {
                line: 1,
                column: 307
              }
            }
          })) ? i : "") + (null != (i = l(n, "if").call(s, null != t ? l(t, "subtitle") : t, {
            name: "if",
            hash: {},
            fn: e.program(5, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 307
              },
              end: {
                line: 1,
                column: 370
              }
            }
          })) ? i : "") + (null != (i = l(n, "if").call(s, null != t ? l(t, "bullets") : t, {
            name: "if",
            hash: {},
            fn: e.program(7, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 370
              },
              end: {
                line: 1,
                column: 495
              }
            }
          })) ? i : "");
        },
        useData: !0
      }),
          f = u.default.extend({
        attributes: {
          "data-se": "callout"
        },
        content: null,
        size: "standard",
        type: "info",
        dismissible: !1,
        title: null,
        subtitle: null,
        bullets: null,
        constructor: function constructor() {
          this.events = s.default.defaults(this.events || {}, c), u.default.apply(this, arguments), this.$el.addClass(i(this)), this.template = d;
          var e = o(this, "content");
          e && this.add(e);
        },
        getTemplateData: function getTemplateData() {
          var e = o(this, "type"),
              t = o(this, "size");

          switch ("tip" === e && (e = "light-bulb"), t) {
            case "slim":
              e = "";
              break;

            case "large":
              e = [e, "-", "24"].join("");
              break;

            default:
              e = [e, "-", "16"].join("");
          }

          return {
            icon: e,
            title: o(this, "title"),
            subtitle: o(this, "subtitle"),
            bullets: o(this, "bullets"),
            dismissible: o(this, "dismissible")
          };
        }
      }),
          p = {
        create: function create(e) {
          return new f(e);
        }
      };
      t.default = p, e.exports = t.default;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var r = {
        DEBOUNCE_DELAY: 200,
        LOADING_FADE: 400,
        UNLOADING_FADE: 400,
        ROW_EXPANDER_TRANSITION: 150,
        HIDE_ADD_MAPPING_FORM: 300
      };
      t.default = r, e.exports = t.default;
    }, function (e, t, n) {
      var r, o;
      r = [n(12)], void 0 !== (o = function (e) {
        var t = e;

        e.fn.customInput = function () {
          return t(this).each(function () {
            if (t(this).is("[type=checkbox],[type=radio]")) {
              var e = t(this),
                  n = e.siblings('label[for="' + e.attr("id") + '"]:first');
              n.length || (n = e.closest('label[for="' + e.attr("id") + '"]:first')), e.add(n).wrapAll('<div class="custom-' + e.attr("type") + '"></div>'), n.hover(function () {
                t(this).addClass("hover");
              }, function () {
                t(this).removeClass("hover");
              }), e.bind("updateState", function () {
                e.is(":checked") ? n.addClass("checked") : n.removeClass("checked checkedHover checkedFocus");
              }).trigger("updateState").click(function () {
                t('input[name="' + t(this).attr("name") + '"]').trigger("updateState");
              }).focus(function () {
                n.addClass("focus"), e.is(":checked") && t(this).addClass("checkedFocus");
              }).blur(function () {
                n.removeClass("focus checkedFocus");
              });
            }
          });
        };
      }.apply(t, r)) && (e.exports = o);
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        "@babel/helpers - typeof";

        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      function i(e) {
        var t = e.title,
            n = e.text;
        return t && n && t !== n;
      }

      function a(e) {
        return i(e) ? e : {
          text: e.text || e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var s = r(n(2)),
          l = r(n(3));
      n(29);
      var u = r(n(8));
      n(83);
      var c = r(n(9)),
          d = "okta-form-input-field input-fix",
          f = c.default.extend({
        template: s.default.template({
          1: function _(e, t, n, r, o) {
            return '<span class="input-tooltip icon form-help-16"></span>';
          },
          3: function _(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<span class="icon input-icon ' + e.escapeExpression(e.lambda(null != (i = null != t ? a(t, "params") : t) ? a(i, "icon") : i, t)) + '"></span>';
          },
          5: function _(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return e.escapeExpression((i = null != (i = a(n, "autoComplete") || (null != t ? a(t, "autoComplete") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
              name: "autoComplete",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 333
                },
                end: {
                  line: 1,
                  column: 349
                }
              }
            }) : i));
          },
          7: function _(e, t, n, r, o) {
            return "off";
          },
          9: function _(e, t, n, r, o) {
            return '<span class="input-icon-divider"></span>';
          },
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, i) {
            var a,
                s,
                l = null != t ? t : e.nullContext || {},
                u = e.hooks.helperMissing,
                c = "function",
                d = e.escapeExpression,
                f = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return (null != (a = f(n, "if").call(l, null != (a = null != t ? f(t, "params") : t) ? f(a, "innerTooltip") : a, {
              name: "if",
              hash: {},
              fn: e.program(1, i, 0),
              inverse: e.noop,
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 0
                },
                end: {
                  line: 1,
                  column: 87
                }
              }
            })) ? a : "") + (null != (a = f(n, "if").call(l, null != (a = null != t ? f(t, "params") : t) ? f(a, "icon") : a, {
              name: "if",
              hash: {},
              fn: e.program(3, i, 0),
              inverse: e.noop,
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 87
                },
                end: {
                  line: 1,
                  column: 166
                }
              }
            })) ? a : "") + '<input type="' + d((s = null != (s = f(n, "type") || (null != t ? f(t, "type") : t)) ? s : u, o(s) === c ? s.call(l, {
              name: "type",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 179
                },
                end: {
                  line: 1,
                  column: 187
                }
              }
            }) : s)) + '" placeholder="' + d((s = null != (s = f(n, "placeholder") || (null != t ? f(t, "placeholder") : t)) ? s : u, o(s) === c ? s.call(l, {
              name: "placeholder",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 202
                },
                end: {
                  line: 1,
                  column: 217
                }
              }
            }) : s)) + '" name="' + d((s = null != (s = f(n, "name") || (null != t ? f(t, "name") : t)) ? s : u, o(s) === c ? s.call(l, {
              name: "name",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 225
                },
                end: {
                  line: 1,
                  column: 233
                }
              }
            }) : s)) + '" id="' + d((s = null != (s = f(n, "inputId") || (null != t ? f(t, "inputId") : t)) ? s : u, o(s) === c ? s.call(l, {
              name: "inputId",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 239
                },
                end: {
                  line: 1,
                  column: 250
                }
              }
            }) : s)) + '" value="' + d((s = null != (s = f(n, "value") || (null != t ? f(t, "value") : t)) ? s : u, o(s) === c ? s.call(l, {
              name: "value",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 259
                },
                end: {
                  line: 1,
                  column: 268
                }
              }
            }) : s)) + '" aria-label="' + d((s = null != (s = f(n, "placeholder") || (null != t ? f(t, "placeholder") : t)) ? s : u, o(s) === c ? s.call(l, {
              name: "placeholder",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 282
                },
                end: {
                  line: 1,
                  column: 297
                }
              }
            }) : s)) + '" autocomplete="' + (null != (a = f(n, "if").call(l, null != t ? f(t, "autoComplete") : t, {
              name: "if",
              hash: {},
              fn: e.program(5, i, 0),
              inverse: e.program(7, i, 0),
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 313
                },
                end: {
                  line: 1,
                  column: 367
                }
              }
            })) ? a : "") + '" />' + (null != (a = f(n, "if").call(l, null != (a = null != t ? f(t, "params") : t) ? f(a, "iconDivider") : a, {
              name: "if",
              hash: {},
              fn: e.program(9, i, 0),
              inverse: e.noop,
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 371
                },
                end: {
                  line: 1,
                  column: 444
                }
              }
            })) ? a : "");
          },
          useData: !0
        }),
        events: {
          "input input": "update",
          "change input": "update",
          "keydown input": "update",
          "keyup input": function keyupInput(e) {
            u.default.isEnter(e) ? this.model.trigger("form:save") : u.default.isEsc(e) && this.model.trigger("form:cancel");
          }
        },
        constructor: function constructor() {
          c.default.apply(this, arguments), this.$el.addClass("o-form-control");
        },
        editMode: function editMode() {
          this.$el.addClass(d), c.default.prototype.editMode.apply(this, arguments), this.$("input").placeholder();
        },
        readMode: function readMode() {
          c.default.prototype.readMode.apply(this, arguments), "password" === this.options.type && this.$el.text("********"), this.$el.removeClass(d);
        },
        val: function val() {
          var e = this.$('input[type="' + this.options.type + '"]').val();
          return "password" !== this.options.type && (e = l.default.trim(e)), e;
        },
        focus: function focus() {
          return this.$("input").focus();
        },
        postRender: function postRender() {
          var e = this.options.params;

          if (e && e.innerTooltip) {
            var t = a(e.innerTooltip);
            this.$(".input-tooltip").qtip({
              content: t,
              style: {
                classes: "okta-tooltip qtip-custom qtip-shadow"
              },
              position: {
                my: "bottom left",
                target: "mouse",
                adjust: {
                  method: "flip",
                  mouse: !0,
                  y: -5,
                  x: 5
                },
                viewport: (0, l.default)("body")
              }
            });
          }
        }
      });
      t.default = f, e.exports = t.default;
    }, function (e, t, n) {
      e.exports = n(36);
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;

      var o = r(n(15)),
          i = r(n(16)),
          a = r(n(40)),
          s = r(n(11)),
          l = r(n(20)),
          u = r(n(42)),
          c = r(n(22)),
          d = r(n(18)),
          f = r(n(26)),
          p = r(n(46)),
          h = r(n(48)),
          m = r(n(8)),
          g = r(n(7)),
          v = r(n(4)),
          y = r(n(19)),
          b = r(n(57)),
          _ = r(n(3)),
          w = r(n(0)),
          E = r(n(65)),
          O = r(n(1)),
          S = r(n(67)),
          x = r(n(24)),
          T = r(n(68)),
          k = r(n(27)),
          C = r(n(10)),
          A = r(n(28)),
          N = r(n(76)),
          P = r(n(81)),
          R = r(n(82)),
          I = r(n(84)),
          M = r(n(30)),
          j = r(n(85)),
          L = r(n(34)),
          D = r(n(31)),
          F = r(n(6)),
          U = r(n(14));

      n(86), U.default.prototype.compileTemplate = function (e) {
        return function () {
          return e;
        };
      };
      var B = {
        "input input": "update",
        "change input": "update",
        "keydown input": "update",
        "keyup input": function keyupInput(e) {
          m.default.isEsc(e) && this.model.trigger("form:cancel");
        }
      },
          V = L.default.extend({
        events: B
      }),
          H = R.default.extend({
        events: B
      }),
          q = {
        Backbone: F.default,
        $: _.default,
        _: w.default,
        Handlebars: b.default,
        loc: v.default.localize,
        createButton: d.default.create,
        createCallout: D.default.create,
        registerInput: A.default.register,
        Model: s.default,
        BaseModel: i.default,
        Collection: o.default,
        FrameworkView: U.default,
        View: O.default,
        ListView: E.default,
        Router: c.default,
        Controller: u.default,
        Form: T.default,
        internal: {
          util: {
            Util: y.default,
            Cookie: p.default,
            Clipboard: h.default,
            Logger: g.default,
            Class: f.default,
            Keys: m.default
          },
          views: {
            components: {
              BaseDropDown: S.default,
              Notification: x.default
            },
            forms: {
              helpers: {
                FormUtil: C.default,
                SchemaFormFactory: N.default
              },
              components: {
                Toolbar: k.default
              },
              inputs: {
                TextBox: V,
                PasswordBox: H,
                CheckBox: P.default,
                Radio: I.default,
                Select: M.default,
                InputGroup: j.default
              }
            }
          },
          models: {
            BaseSchema: a.default,
            SchemaProperty: l.default
          }
        }
      };
      q.registerInput("text", V), q.registerInput("password", H), q.registerInput("checkbox", P.default), q.registerInput("radio", I.default), q.registerInput("select", M.default), q.registerInput("group", j.default);
      var W = q;
      t.default = W, e.exports = t.default;
    }, function (e, t) {
      e.exports = n(110);
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e, t) {
        try {
          var n = s(t.getResponseHeader("link"));
          e[c].set(d, !0), e.setPagination(n.next.href);
        } catch (t) {
          e[c].get(d) && e.setPagination(null);
        }
      }

      function i(e) {
        for (var t = {}, n = e && e.split("?")[1], r = n && decodeURIComponent(n.split("#")[0]).replace(/\+/g, " "), o = r ? r.split("&") : [], i = 0; i < o.length; i++) {
          var a = o[i].split("=");
          t[a.shift()] = a.join("=");
        }

        return t;
      }

      function a(e) {
        return '"' == e.charAt(0) && '"' == e.charAt(e.length - 1) ? e.substring(1, e.length - 1) : e;
      }

      function s(e) {
        for (var t = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*")))*(,|$)/g, n = /[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*"))/g, r = e.match(t), o = {}, i = 0; i < r.length; i++) {
          var s = r[i].split(">"),
              l = s[0].substring(1),
              u = {};
          u.href = l;

          for (var c = s[1].match(n), d = 0; d < c.length; d++) {
            var f = c[d].split("=");
            u[f[0]] = a(f[1]);
          }

          void 0 !== u.rel && (o[u.rel] = u);
        }

        return o;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var l = r(n(0)),
          u = r(n(6)),
          c = "__STATE__",
          d = "LINK_BY_HEADER",
          f = u.default.Collection.extend({
        params: {},
        constructor: function constructor(e, t) {
          (this[c] = new u.default.Model()).set("DEFAULT_PARAMS", l.default.defaults(t && t.params || {}, this.params || {})), u.default.Collection.apply(this, arguments);
        },
        sync: function sync(e, t, n) {
          var r = this,
              i = n.success;
          return n.success = function (e, t, n) {
            o(r, n), i.apply(null, arguments);
          }, u.default.Collection.prototype.sync.call(this, e, t, n);
        },
        fetch: function fetch(e) {
          e || (e = {});
          var t = this[c],
              n = t.get("XHR");
          return e.data = l.default.extend({}, t.get("DEFAULT_PARAMS"), e.data || {}), e.fromFetch = !0, t.set("FETCH_DATA", e.data), n && n.abort && !1 !== e.abort && n.abort(), n = u.default.Collection.prototype.fetch.call(this, e), t.set("XHR", n), n;
        },
        setPagination: function setPagination(e, t) {
          l.default.isString(e) && e && (e = i(e)), l.default.isObject(e) && !l.default.isArray(e) && l.default.size(e) ? t && t.fromFetch && (e = l.default.extend({}, this.getFetchData(), e)) : e = null, this[c].set("PAGINATION_DATA", e);
        },
        getFetchData: function getFetchData() {
          return this[c].get("FETCH_DATA") || {};
        },
        getPaginationData: function getPaginationData() {
          return this[c].get("PAGINATION_DATA") || {};
        },
        hasMore: function hasMore() {
          return l.default.size(this.getPaginationData()) > 0;
        },
        fetchMore: function fetchMore() {
          if (!this.hasMore()) throw new Error("Invalid Request");
          return this.fetch({
            data: this.getPaginationData(),
            add: !0,
            remove: !1,
            update: !0
          });
        },
        reset: function reset(e, t) {
          return t || (t = {}), t.fromFetch || this.setPagination(null), u.default.Collection.prototype.reset.apply(this, arguments);
        },
        where: function where(e, t) {
          return l.default.isEmpty(e) ? t ? void 0 : [] : this[t ? "find" : "filter"](function (t) {
            for (var n in e) {
              if (e[n] !== t.get(n)) return !1;
            }

            return !0;
          });
        },
        create: function create(e, t) {
          return t || (t = {}), l.default.result(e, "urlRoot") || (t.url = l.default.result(this, "url")), u.default.Collection.prototype.create.call(this, e, t);
        }
      });
      t.default = f, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        "@babel/helpers - typeof";

        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      function i(e, t, n, r) {
        var o = g.default.contains(t, n);
        return r || (r = {}), o || !g.default.isObject(e) || g.default.isArray(e) || g.default.isFunction(e) ? void 0 !== n && (r[n] = e) : g.default.each(e, function (e, o) {
          i(e, t, n ? n + "." + o : o, r);
        }), r;
      }

      function a(e) {
        return g.default.each(e, function (e, t, n) {
          if (-1 != t.indexOf(".")) {
            for (var r, o = n, i = t.split("."); void 0 !== (r = i.shift());) {
              o[r] || (o[r] = i.length ? {} : e), o = o[r];
            }

            delete n[t];
          }
        }), e;
      }

      function s(e, t) {
        var n = {};
        return n[e.name] = t, n;
      }

      function l(e, t) {
        var n;
        return n = g.default.isString(e) ? {
          type: e
        } : g.default.isArray(e) ? {
          type: e[0],
          required: e[1],
          value: e[2]
        } : g.default.clone(e), g.default.defaults(n, {
          required: !1,
          name: t
        }), n;
      }

      function u(e) {
        return e.toLowerCase().replace(/\b[a-z]/g, function (e) {
          return e.toUpperCase();
        });
      }

      function c(e, t, n) {
        if (!t.test(e)) return n;
      }

      function d(e, t) {
        var n = b[e.format];
        if (e.format && !n) throw new TypeError(e.format + " is not a supported string format");
        return n && n(t);
      }

      function f(e, t) {
        var n = g.default.partial(s, e),
            r = d(e, t);
        return r ? n(r) : t && e.minLength && t.length < e.minLength ? n(m.ERROR_STRING_STRING_MIN_LENGTH, t.length) : t && e.maxLength && t.length > e.maxLength ? n(m.ERROR_STRING_STRING_MAX_LENGTH, t.length) : void 0;
      }

      function p(e, t) {
        var n,
            r,
            o = g.default.partial(s, e),
            i = !g.default.isUndefined(t) && !g.default.isNull(t);
        {
          if (!Array.isArray(e.validate)) {
            if (e.required && (!i || g.default.isNull(t) || "" === t)) return o(m.ERROR_BLANK);
            if (n = g.default["is" + u(e.type)], i && "any" != e.type && (!g.default.isFunction(n) || !n(t))) return o(m.ERROR_WRONG_TYPE);

            if (t && "string" == e.type) {
              var a = f(e, t);
              if (a) return a;
            }

            if (i && e.values && !g.default.contains(e.values, t)) return o(m.ERROR_NOT_ALLOWED);

            if (g.default.isFunction(e.validate)) {
              var l = e.validate(t);
              if (g.default.isString(l) && l) return o(l);
              if (!1 === l) return o(m.ERROR_INVALID);
            }

            return i && "array" == e.type && (r = h(e, t)) ? o(r) : void 0;
          }

          var c,
              d = [],
              p = !1;
          if (e.validate.forEach(function (e) {
            if (t) switch (e.type.toLowerCase()) {
              case "regex":
                c = new RegExp(e.value.pattern, e.value.flags || "").test(t);
                break;

              default:
                c = !1;
            } else c = !1;
            p = p || !c, d.push({
              message: e.hasOwnProperty("message") ? e.message : "",
              passed: c
            });
          }), p) return o(d);
        }
      }

      function h(e, t) {
        if (e.minItems && t.length < e.minItems) return "model.validation.field.array.minItems";
        if (e.maxItems && t.length > e.maxItems) return "model.validation.field.array.maxItems";
        if (e.uniqueItems && t.length > g.default.uniq(t).length) return m.ERROR_IARRAY_UNIQUE;
        if (e.items) for (var n = l(e.items, "placeholder"), r = 0; r < t.length; r++) {
          var o = t[r],
              i = p(n, o);
          if (i) return i.placeholder;
        }
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var m,
          g = r(n(0)),
          v = r(n(6)),
          y = r(n(7)),
          b = {
        email: function email(e) {
          return c(e, /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, m.ERROR_INVALID_FORMAT_EMAIL);
        },
        uri: function uri(e) {
          return c(e, /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i, m.ERROR_INVALID_FORMAT_URI);
        },
        ipv4: function ipv4(e) {
          return c(e, /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, m.ERROR_INVALID_FORMAT_IPV4);
        },
        hostname: function hostname(e) {
          return c(e, /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/, m.ERROR_INVALID_FORMAT_HOSTNAME);
        }
      };
      m = v.default.Model.extend({
        props: {},
        derived: {},
        local: {},
        flat: !0,
        defaults: {},
        constructor: function constructor(e) {
          this.options = e || {};
          var t = this.__schema__ = {},
              n = [];
          t.computedProperties = {}, t.props = g.default.clone(g.default.result(this, "props") || {}), t.derived = g.default.clone(g.default.result(this, "derived") || {}), t.local = g.default.clone(g.default.result(this, "local") || {});
          var r = {};

          if (g.default.each(g.default.extend({}, t.props, t.local), function (e, t) {
            var o = l(e, t);
            g.default.isUndefined(o.value) || (r[t] = o.value), "object" === o.type && n.push(t);
          }, this), g.default.size(r)) {
            var o = g.default.result(this, "defaults");

            this.defaults = function () {
              return g.default.defaults({}, r, o);
            };
          }

          this.validate = g.default.wrap(this.validate, function (e) {
            var t = g.default.rest(arguments),
                n = g.default.extend(this._validateSchema.apply(this, t), e.apply(this, t));
            return g.default.size(n) && n || void 0;
          }), this.parse = g.default.wrap(this.parse, function (e) {
            var t = e.apply(this, g.default.rest(arguments));
            return this.flat && (t = i(t, n)), t;
          }), v.default.Model.apply(this, arguments), g.default.each(t.derived, function (e, n) {
            t.computedProperties[n] = this.__getDerivedValue(n);
            var r = e.deps || [];
            r.length && this.on("cache:clear change:" + r.join(" change:"), function () {
              var e = this.__getDerivedValue(n);

              e !== t.computedProperties[n] && (t.computedProperties[n] = e, this.trigger("change:" + n, this, e));
            }, this);
          }, this), this.on("sync", function () {
            this.__syncedData = this.toJSON();
          }, this);
        },
        validate: function validate() {},
        allows: function allows(e) {
          var t = this.__schema__,
              n = g.default.extend({}, t.props, t.local);
          return g.default.has(n, e) || y.default.warn("Field not defined in schema", e), !0;
        },
        getPropertySchema: function getPropertySchema(e) {
          var t = this.__schema__;
          return g.default.reduce([t.props, t.local], function (t, n) {
            return t || l(n[e], e);
          }, null);
        },
        set: function set(e, t) {
          var n;
          "object" === o(e) ? n = e : (n = {})[e] = t, g.default.each(n, function (e, t) {
            if (g.default.has(this.__schema__.derived, t)) throw "overriding derived properties is not supported: " + t;
          }, this);
          var r = [];
          if (g.default.each(n, function (e, t) {
            this.allows(t) || r.push(t);
          }, this), r.length) throw "field not allowed: " + r.join(", ");
          return v.default.Model.prototype.set.apply(this, arguments);
        },
        get: function get(e) {
          var t = this.__schema__;
          return g.default.has(t.derived, e) ? !1 !== t.derived[e].cache ? t.computedProperties[e] : this.__getDerivedValue(e) : v.default.Model.prototype.get.apply(this, arguments);
        },
        toJSON: function toJSON(e) {
          e || (e = {});
          var t = g.default.clone(v.default.Model.prototype.toJSON.apply(this, arguments)),
              n = this.__schema__;
          return e.verbose ? g.default.each(n.derived, function (e, n) {
            t[n] = this.get(n);
          }, this) : t = g.default.omit(t, g.default.keys(n.local)), this.flat && (t = a(t)), t;
        },
        reset: function reset(e) {
          this.clear(e), this.set(g.default.result(this, "defaults"), e);
        },
        isSynced: function isSynced() {
          return g.default.isEqual(this.__syncedData, this.toJSON());
        },
        validateField: function validateField(e) {
          var t = e && this.getPropertySchema(e);
          return t && p(t, this.get(e));
        },
        _validateSchema: function _validateSchema() {
          var e = this.__schema__;
          return g.default.reduce(g.default.extend({}, e.props, e.local), function (e, t, n) {
            return g.default.extend(e, this.validateField(n) || {});
          }, {}, this);
        },
        __getDerivedValue: function __getDerivedValue(e) {
          var t = this.__schema__.derived[e];

          if (g.default.isString(t)) {
            var n = t;
            t = {
              deps: [n],
              fn: function fn() {
                return this.get(n);
              }
            };
          }

          var r = t.deps || [];
          return t.fn.apply(this, g.default.map(r, this.get, this));
        }
      }, {
        ERROR_BLANK: "model.validation.field.blank",
        ERROR_WRONG_TYPE: "model.validation.field.wrong.type",
        ERROR_NOT_ALLOWED: "model.validation.field.value.not.allowed",
        ERROR_INVALID: "model.validation.field.invalid",
        ERROR_IARRAY_UNIQUE: "model.validation.field.array.unique",
        ERROR_INVALID_FORMAT_EMAIL: "model.validation.field.invalid.format.email",
        ERROR_INVALID_FORMAT_URI: "model.validation.field.invalid.format.uri",
        ERROR_INVALID_FORMAT_IPV4: "model.validation.field.invalid.format.ipv4",
        ERROR_INVALID_FORMAT_HOSTNAME: "model.validation.field.invalid.format.hostname",
        ERROR_STRING_STRING_MIN_LENGTH: "model.validation.field.string.minLength",
        ERROR_STRING_STRING_MAX_LENGTH: "model.validation.field.string.maxLength"
      });
      var _ = m;
      t.default = _, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;

      var o = r(n(0)),
          i = r(n(15)),
          a = r(n(16)),
          s = r(n(20)),
          l = function l(e) {
        var t = o.default.pick(e, "id", "name", "displayName"),
            n = o.default.map(e.schema.properties, function (e, t) {
          return o.default.extend({
            name: t
          }, e);
        });
        return o.default.each(n, function (e) {
          e.__schemaMeta__ = t, e.__metadata && (e.__metadata__ = e.__metadata, delete e.__metadata);
        }), n;
      },
          u = a.default.extend({
        defaults: {
          id: void 0,
          displayName: void 0,
          name: void 0
        },
        constructor: function constructor() {
          this.properties = new s.default.Collection(), a.default.apply(this, arguments);
        },
        getProperties: function getProperties() {
          return this.properties;
        },
        clone: function clone() {
          var e = a.default.prototype.clone.apply(this, arguments);
          return e.getProperties().set(this.getProperties().toJSON({
            verbose: !0
          })), e;
        },
        parse: function parse(e) {
          var t = l(e);
          return this.properties.set(t, {
            parse: !0
          }), o.default.omit(e, "schema");
        },
        trimProperty: function trimProperty(e) {
          return o.default.omit(e, "name");
        },
        toJSON: function toJSON() {
          var e = a.default.prototype.toJSON.apply(this, arguments);
          return e.schema = {
            properties: {}
          }, this.getProperties().each(function (t) {
            var n = t.toJSON();
            e.schema.properties[n.name] = this.trimProperty(n);
          }, this), e;
        },
        save: function save() {
          return this.getProperties().each(function (e) {
            e.cleanup();
          }), a.default.prototype.save.apply(this, arguments);
        }
      }),
          c = i.default.extend({
        model: u
      }),
          d = {
        parseProperties: l,
        Model: u,
        Collection: c
      };

      t.default = d, e.exports = t.default;
    }, function (e, t) {
      e.exports = n(72);
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        var t = {};
        return a.default.each(e, function (e, n) {
          a.default.isNull(e) || (t[n] = e);
        }), t;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var i = r(n(3)),
          a = r(n(0)),
          s = r(n(22)),
          l = r(n(17)),
          u = r(n(44)),
          c = r(n(1)),
          d = c.default.extend({
        constructor: function constructor(e) {
          if (e || (e = {}), e.state instanceof u.default || this.state instanceof u.default) this.state = e.state || this.state;else {
            var t = a.default.defaults(o(e.state), this.state || {});
            this.state = new u.default(t), delete e.state;
          }
          e.settings ? this.settings = e.settings : (this.settings = e.settings = new l.default(a.default.omit(e || {}, "el")), this.listen("notification", s.default.prototype._notify), this.listen("confirmation", s.default.prototype._confirm)), c.default.call(this, e), this.listenTo(this.state, "__invoke__", function () {
            var e = a.default.toArray(arguments),
                t = e.shift();
            a.default.isFunction(this[t]) && this[t].apply(this, e);
          }), this.View && this.add(new this.View(this.toJSON()));
        },
        state: {},
        View: null,
        render: function render() {
          var e = arguments,
              t = this;
          return (0, i.default)(function () {
            c.default.prototype.render.apply(t, e);
          }), this;
        },
        toJSON: function toJSON(e) {
          return a.default.extend(a.default.pick(this, "state", "settings", "collection", "model"), e || {});
        },
        remove: function remove() {
          return this.removeChildren(), this.stopListening(), this.$el.empty(), this;
        }
      });
      t.default = d, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(5)),
          i = r(n(0)),
          a = {
        tpl: i.default.memoize(function (e) {
          return function (t) {
            return o.default.compile(e)(t);
          };
        })
      };
      t.default = a, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(0)),
          i = r(n(11)),
          a = i.default.extend({
        extraProperties: !0,
        invoke: function invoke() {
          var e = o.default.toArray(arguments);
          e.unshift("__invoke__"), this.trigger.apply(this, e);
        }
      });
      t.default = a, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(2)),
          i = r(n(0)),
          a = r(n(25)),
          s = r(n(1)),
          l = {
        click: function click(e) {
          e.preventDefault(), e.stopPropagation();
        }
      },
          u = s.default.extend({
        attributes: function attributes() {
          var e = {
            "data-se": "button"
          },
              t = this.__getAttribute("attrs");

          return i.default.extend(e, t);
        },
        tagName: "a",
        template: o.default.template({
          1: function _(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<span class="icon ' + e.escapeExpression((i = null != (i = a(n, "icon") || (null != t ? a(t, "icon") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
              name: "icon",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 30
                },
                end: {
                  line: 1,
                  column: 38
                }
              }
            }) : i)) + '"></span>';
          },
          3: function _(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return e.escapeExpression((i = null != (i = a(n, "title") || (null != t ? a(t, "title") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
              name: "title",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 67
                },
                end: {
                  line: 1,
                  column: 76
                }
              }
            }) : i));
          },
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, o) {
            var i,
                a = null != t ? t : e.nullContext || {},
                s = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return (null != (i = s(n, "if").call(a, null != t ? s(t, "icon") : t, {
              name: "if",
              hash: {},
              fn: e.program(1, o, 0),
              inverse: e.noop,
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 0
                },
                end: {
                  line: 1,
                  column: 54
                }
              }
            })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "title") : t, {
              name: "if",
              hash: {},
              fn: e.program(3, o, 0),
              inverse: e.noop,
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 54
                },
                end: {
                  line: 1,
                  column: 83
                }
              }
            })) ? i : "");
          },
          useData: !0
        }),
        visible: !0,
        enabled: !0,
        enableWhen: {},
        showWhen: {},
        constructor: function constructor(e) {
          this.options = e || {};
          var t = this.getTemplateData();
          this.disabled = !1, s.default.apply(this, arguments), this.$el.addClass("link-button"), t.icon && (this.$el.addClass("link-button-icon"), t.title || this.$el.addClass("icon-only"));
        },
        getTemplateData: function getTemplateData() {
          return {
            href: this.__getAttribute("href"),
            title: this.__getAttribute("title"),
            icon: this.__getAttribute("icon")
          };
        },
        initialize: function initialize() {
          a.default.applyDoWhen(this, i.default.resultCtx(this, "enableWhen", this), this.toggle), a.default.applyDoWhen(this, i.default.resultCtx(this, "showWhen", this), this.toggleVisible);
        },
        render: function render() {
          s.default.prototype.render.apply(this, arguments), i.default.result(this, "enabled") || this.toggle(!1), i.default.result(this, "visible") || this.toggleVisible(!1);
          var e = this.getTemplateData();
          return this.$el.attr("href", e.href || "#"), this;
        },
        __getAttribute: function __getAttribute(e, t) {
          var n = i.default.resultCtx(this.options, e, this);
          return i.default.isUndefined(n) && (n = i.default.result(this, e)), i.default.isUndefined(n) ? t : n;
        },
        enable: function enable() {
          this.toggle(!0);
        },
        disable: function disable() {
          this.toggle(!1);
        },
        show: function show() {
          this.toggleVisible(!0);
        },
        hide: function hide() {
          this.toggleVisible(!1);
        },
        toggle: function toggle(e) {
          var t = !!e && i.default.result(this, "enabled");
          this.disabled = !t, this.$el.toggleClass("link-button-disabled btn-disabled disabled", this.disabled), this.delegateEvents(this.disabled ? l : null);
        },
        toggleVisible: function toggleVisible(e) {
          var t = !e || !i.default.result(this, "visible");
          this.$el.toggleClass("hide", t);
        }
      });
      t.default = u, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(0)),
          i = r(n(47)),
          a = /^https/.test(window.location.href),
          s = {
        setCookie: function setCookie(e, t, n) {
          i.default.set(e, t, o.default.defaults(n || {}, {
            secure: a,
            path: "/"
          }));
        },
        getCookie: function getCookie() {
          return i.default.get.apply(i.default, arguments);
        },
        removeCookie: function removeCookie() {
          return i.default.remove.apply(i.default, arguments);
        }
      };
      t.default = s, e.exports = t.default;
    }, function (e, t, n) {
      var r, o;
      /*!
      * JavaScript Cookie v2.1.0
      * https://github.com/js-cookie/js-cookie
      *
      * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
      * Released under the MIT license
      */

      !function (i) {
        r = i, void 0 !== (o = "function" == typeof r ? r.call(t, n, t, e) : r) && (e.exports = o);
      }(function () {
        function e() {
          for (var e = 0, t = {}; e < arguments.length; e++) {
            var n = arguments[e];

            for (var r in n) {
              t[r] = n[r];
            }
          }

          return t;
        }

        function t(n) {
          function r(t, o, i) {
            var a;

            if (arguments.length > 1) {
              if (i = e({
                path: "/"
              }, r.defaults, i), "number" == typeof i.expires) {
                var s = new Date();
                s.setMilliseconds(s.getMilliseconds() + 864e5 * i.expires), i.expires = s;
              }

              try {
                a = JSON.stringify(o), /^[\{\[]/.test(a) && (o = a);
              } catch (e) {}

              return o = n.write ? n.write(o, t) : encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = encodeURIComponent(String(t)), t = t.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent), t = t.replace(/[\(\)]/g, escape), document.cookie = [t, "=", o, i.expires && "; expires=" + i.expires.toUTCString(), i.path && "; path=" + i.path, i.domain && "; domain=" + i.domain, i.secure ? "; secure" : ""].join("");
            }

            t || (a = {});

            for (var l = document.cookie ? document.cookie.split("; ") : [], u = /(%[0-9A-Z]{2})+/g, c = 0; c < l.length; c++) {
              var d = l[c].split("="),
                  f = d[0].replace(u, decodeURIComponent),
                  p = d.slice(1).join("=");
              '"' === p.charAt(0) && (p = p.slice(1, -1));

              try {
                if (p = n.read ? n.read(p, f) : n(p, f) || p.replace(u, decodeURIComponent), this.json) try {
                  p = JSON.parse(p);
                } catch (e) {}

                if (t === f) {
                  a = p;
                  break;
                }

                t || (a[f] = p);
              } catch (e) {}
            }

            return a;
          }

          return r.get = r.set = r, r.getJSON = function () {
            return r.apply({
              json: !0
            }, [].slice.call(arguments));
          }, r.defaults = {}, r.remove = function (t, n) {
            r(t, "", e(n, {
              expires: -1
            }));
          }, r.withConverter = t, r;
        }

        return t(function () {});
      });
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(49)),
          i = r(n(3)),
          a = r(n(0)),
          s = r(n(14)),
          l = r(n(26)),
          u = o.default,
          c = ["success", "error", "target", "text"],
          d = l.default.extend({
        initialize: function initialize(e, t) {
          t = a.default.pick(t || {}, c);
          var n, r, o;
          a.default.isString(e) && (n = e), a.default.isElement(e) && (n = e), e instanceof i.default && (n = e.selector), e instanceof s.default && (n = e.el), a.default.isFunction(t.target) && (r = t.target), a.default.isElement(t.target) && (r = a.default.constant(t.target)), a.default.isString(t.text) ? o = a.default.constant(t.text) : a.default.isFunction(t.text) && (o = t.text), this.__instance = new u(n, {
            target: r,
            text: o
          }), this.done = a.default.partial(this.__setCallback, "success"), this.error = a.default.partial(this.__setCallback, "error"), this.done(t.success), this.error(t.error);
        },
        __setCallback: function __setCallback(e, t) {
          if (a.default.isFunction(t)) return this.__instance.on(e, t), this.__instance;
        }
      }),
          f = {
        attach: function attach(e, t) {
          return new d(e, t);
        }
      };
      t.default = f, e.exports = t.default;
    }, function (e, t, n) {
      var r, i, a;
      !function (o, s) {
        i = [e, n(50), n(52), n(53)], r = s, void 0 !== (a = "function" == typeof r ? r.apply(t, i) : r) && (e.exports = a);
      }(0, function (e, t, n, r) {
        function i(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }

        function a(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function s(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" !== (0, o.default)(t) && "function" != typeof t ? e : t;
        }

        function l(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (0, o.default)(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }

        function u(e, t) {
          var n = "data-clipboard-" + e;
          if (t.hasAttribute(n)) return t.getAttribute(n);
        }

        var c = i(t),
            d = i(n),
            f = i(r),
            p = "function" == typeof Symbol && "symbol" === (0, o.default)(Symbol.iterator) ? function (e) {
          return (0, o.default)(e);
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : (0, o.default)(e);
        },
            h = function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }

          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        }(),
            m = function (e) {
          function t(e, n) {
            a(this, t);
            var r = s(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
            return r.resolveOptions(n), r.listenClick(e), r;
          }

          return l(t, e), h(t, [{
            key: "resolveOptions",
            value: function value() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              this.action = "function" == typeof e.action ? e.action : this.defaultAction, this.target = "function" == typeof e.target ? e.target : this.defaultTarget, this.text = "function" == typeof e.text ? e.text : this.defaultText, this.container = "object" === p(e.container) ? e.container : document.body;
            }
          }, {
            key: "listenClick",
            value: function value(e) {
              var t = this;
              this.listener = (0, f.default)(e, "click", function (e) {
                return t.onClick(e);
              });
            }
          }, {
            key: "onClick",
            value: function value(e) {
              var t = e.delegateTarget || e.currentTarget;
              this.clipboardAction && (this.clipboardAction = null), this.clipboardAction = new c.default({
                action: this.action(t),
                target: this.target(t),
                text: this.text(t),
                container: this.container,
                trigger: t,
                emitter: this
              });
            }
          }, {
            key: "defaultAction",
            value: function value(e) {
              return u("action", e);
            }
          }, {
            key: "defaultTarget",
            value: function value(e) {
              var t = u("target", e);
              if (t) return document.querySelector(t);
            }
          }, {
            key: "defaultText",
            value: function value(e) {
              return u("text", e);
            }
          }, {
            key: "destroy",
            value: function value() {
              this.listener.destroy(), this.clipboardAction && (this.clipboardAction.destroy(), this.clipboardAction = null);
            }
          }], [{
            key: "isSupported",
            value: function value() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["copy", "cut"],
                  t = "string" == typeof e ? [e] : e,
                  n = !!document.queryCommandSupported;
              return t.forEach(function (e) {
                n = n && !!document.queryCommandSupported(e);
              }), n;
            }
          }]), t;
        }(d.default);

        e.exports = m;
      });
    }, function (e, t, n) {
      var r, i, a;
      !function (o, s) {
        i = [e, n(51)], r = s, void 0 !== (a = "function" == typeof r ? r.apply(t, i) : r) && (e.exports = a);
      }(0, function (e, t) {
        function n(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        var r = function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }(t),
            i = "function" == typeof Symbol && "symbol" === (0, o.default)(Symbol.iterator) ? function (e) {
          return (0, o.default)(e);
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : (0, o.default)(e);
        },
            a = function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }

          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        }(),
            s = function () {
          function e(t) {
            n(this, e), this.resolveOptions(t), this.initSelection();
          }

          return a(e, [{
            key: "resolveOptions",
            value: function value() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              this.action = e.action, this.container = e.container, this.emitter = e.emitter, this.target = e.target, this.text = e.text, this.trigger = e.trigger, this.selectedText = "";
            }
          }, {
            key: "initSelection",
            value: function value() {
              this.text ? this.selectFake() : this.target && this.selectTarget();
            }
          }, {
            key: "selectFake",
            value: function value() {
              var e = this,
                  t = "rtl" == document.documentElement.getAttribute("dir");
              this.removeFake(), this.fakeHandlerCallback = function () {
                return e.removeFake();
              }, this.fakeHandler = this.container.addEventListener("click", this.fakeHandlerCallback) || !0, this.fakeElem = document.createElement("textarea"), this.fakeElem.style.fontSize = "12pt", this.fakeElem.style.border = "0", this.fakeElem.style.padding = "0", this.fakeElem.style.margin = "0", this.fakeElem.style.position = "absolute", this.fakeElem.style[t ? "right" : "left"] = "-9999px";
              var n = window.pageYOffset || document.documentElement.scrollTop;
              this.fakeElem.style.top = n + "px", this.fakeElem.setAttribute("readonly", ""), this.fakeElem.value = this.text, this.container.appendChild(this.fakeElem), this.selectedText = (0, r.default)(this.fakeElem), this.copyText();
            }
          }, {
            key: "removeFake",
            value: function value() {
              this.fakeHandler && (this.container.removeEventListener("click", this.fakeHandlerCallback), this.fakeHandler = null, this.fakeHandlerCallback = null), this.fakeElem && (this.container.removeChild(this.fakeElem), this.fakeElem = null);
            }
          }, {
            key: "selectTarget",
            value: function value() {
              this.selectedText = (0, r.default)(this.target), this.copyText();
            }
          }, {
            key: "copyText",
            value: function value() {
              var e = void 0;

              try {
                e = document.execCommand(this.action);
              } catch (t) {
                e = !1;
              }

              this.handleResult(e);
            }
          }, {
            key: "handleResult",
            value: function value(e) {
              this.emitter.emit(e ? "success" : "error", {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
              });
            }
          }, {
            key: "clearSelection",
            value: function value() {
              this.trigger && this.trigger.focus(), window.getSelection().removeAllRanges();
            }
          }, {
            key: "destroy",
            value: function value() {
              this.removeFake();
            }
          }, {
            key: "action",
            set: function set() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "copy";
              if (this._action = e, "copy" !== this._action && "cut" !== this._action) throw new Error('Invalid "action" value, use either "copy" or "cut"');
            },
            get: function get() {
              return this._action;
            }
          }, {
            key: "target",
            set: function set(e) {
              if (void 0 !== e) {
                if (!e || "object" !== (void 0 === e ? "undefined" : i(e)) || 1 !== e.nodeType) throw new Error('Invalid "target" value, use a valid Element');
                if ("copy" === this.action && e.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                if ("cut" === this.action && (e.hasAttribute("readonly") || e.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                this._target = e;
              }
            },
            get: function get() {
              return this._target;
            }
          }]), e;
        }();

        e.exports = s;
      });
    }, function (e, t) {
      function n(e) {
        var t;
        if ("SELECT" === e.nodeName) e.focus(), t = e.value;else if ("INPUT" === e.nodeName || "TEXTAREA" === e.nodeName) {
          var n = e.hasAttribute("readonly");
          n || e.setAttribute("readonly", ""), e.select(), e.setSelectionRange(0, e.value.length), n || e.removeAttribute("readonly"), t = e.value;
        } else {
          e.hasAttribute("contenteditable") && e.focus();
          var r = window.getSelection(),
              o = document.createRange();
          o.selectNodeContents(e), r.removeAllRanges(), r.addRange(o), t = r.toString();
        }
        return t;
      }

      e.exports = n;
    }, function (e, t) {
      function n() {}

      n.prototype = {
        on: function on(e, t, n) {
          var r = this.e || (this.e = {});
          return (r[e] || (r[e] = [])).push({
            fn: t,
            ctx: n
          }), this;
        },
        once: function once(e, t, n) {
          function r() {
            o.off(e, r), t.apply(n, arguments);
          }

          var o = this;
          return r._ = t, this.on(e, r, n);
        },
        emit: function emit(e) {
          var t = [].slice.call(arguments, 1),
              n = ((this.e || (this.e = {}))[e] || []).slice(),
              r = 0,
              o = n.length;

          for (r; r < o; r++) {
            n[r].fn.apply(n[r].ctx, t);
          }

          return this;
        },
        off: function off(e, t) {
          var n = this.e || (this.e = {}),
              r = n[e],
              o = [];
          if (r && t) for (var i = 0, a = r.length; i < a; i++) {
            r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
          }
          return o.length ? n[e] = o : delete n[e], this;
        }
      }, e.exports = n, e.exports.TinyEmitter = n;
    }, function (e, t, n) {
      function r(e, t, n) {
        if (!e && !t && !n) throw new Error("Missing required arguments");
        if (!s.string(t)) throw new TypeError("Second argument must be a String");
        if (!s.fn(n)) throw new TypeError("Third argument must be a Function");
        if (s.node(e)) return o(e, t, n);
        if (s.nodeList(e)) return i(e, t, n);
        if (s.string(e)) return a(e, t, n);
        throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
      }

      function o(e, t, n) {
        return e.addEventListener(t, n), {
          destroy: function destroy() {
            e.removeEventListener(t, n);
          }
        };
      }

      function i(e, t, n) {
        return Array.prototype.forEach.call(e, function (e) {
          e.addEventListener(t, n);
        }), {
          destroy: function destroy() {
            Array.prototype.forEach.call(e, function (e) {
              e.removeEventListener(t, n);
            });
          }
        };
      }

      function a(e, t, n) {
        return l(document.body, e, t, n);
      }

      var s = n(54),
          l = n(55);
      e.exports = r;
    }, function (e, t) {
      t.node = function (e) {
        return void 0 !== e && e instanceof HTMLElement && 1 === e.nodeType;
      }, t.nodeList = function (e) {
        var n = Object.prototype.toString.call(e);
        return void 0 !== e && ("[object NodeList]" === n || "[object HTMLCollection]" === n) && "length" in e && (0 === e.length || t.node(e[0]));
      }, t.string = function (e) {
        return "string" == typeof e || e instanceof String;
      }, t.fn = function (e) {
        return "[object Function]" === Object.prototype.toString.call(e);
      };
    }, function (e, t, n) {
      function r(e, t, n, r, o) {
        var a = i.apply(this, arguments);
        return e.addEventListener(n, a, o), {
          destroy: function destroy() {
            e.removeEventListener(n, a, o);
          }
        };
      }

      function o(e, t, n, o, i) {
        return "function" == typeof e.addEventListener ? r.apply(null, arguments) : "function" == typeof n ? r.bind(null, document).apply(null, arguments) : ("string" == typeof e && (e = document.querySelectorAll(e)), Array.prototype.map.call(e, function (e) {
          return r(e, t, n, o, i);
        }));
      }

      function i(e, t, n, r) {
        return function (n) {
          n.delegateTarget = a(n.target, t), n.delegateTarget && r.call(e, n);
        };
      }

      var a = n(56);
      e.exports = o;
    }, function (e, t) {
      function n(e, t) {
        for (; e && e.nodeType !== r;) {
          if ("function" == typeof e.matches && e.matches(t)) return e;
          e = e.parentNode;
        }
      }

      var r = 9;

      if ("undefined" != typeof Element && !Element.prototype.matches) {
        var o = Element.prototype;
        o.matches = o.matchesSelector || o.mozMatchesSelector || o.msMatchesSelector || o.oMatchesSelector || o.webkitMatchesSelector;
      }

      e.exports = n;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;

      var r = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n(5));

      n(58), n(59), n(60), n(61), n(62), n(64);
      var o = r.default;
      t.default = o, e.exports = t.default;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;

      var r = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n(5)),
          o = r.default.Utils.escapeExpression;

      r.default.Utils.escapeExpression = function (e) {
        return o(e).replace(/&#x3D;/g, "=");
      };

      var i = r.default;
      t.default = i, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e, t) {
        return a.default.utc(t).utcOffset("-07:00").format(e);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var i = r(n(5)),
          a = r(n(23)),
          s = r(n(0));
      i.default.registerHelper("shortDate", s.default.partial(o, "MMM Do")), i.default.registerHelper("mediumDate", s.default.partial(o, "MMMM DD, YYYY")), i.default.registerHelper("longDate", s.default.partial(o, "MMMM DD, YYYY, h:mma")), i.default.registerHelper("formatDate", o);
      var l = i.default;
      t.default = l, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e, t) {
        return u(e) || l(e, t) || a(e, t) || i();
      }

      function i() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      function a(e, t) {
        if (e) {
          if ("string" == typeof e) return s(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? s(e, t) : void 0;
        }
      }

      function s(e, t) {
        (null == t || t > e.length) && (t = e.length);

        for (var n = 0, r = new Array(t); n < t; n++) {
          r[n] = e[n];
        }

        return r;
      }

      function l(e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              r = !0,
              o = !1,
              i = void 0;

          try {
            for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            o = !0, i = e;
          } finally {
            try {
              r || null == s.return || s.return();
            } finally {
              if (o) throw i;
            }
          }

          return n;
        }
      }

      function u(e) {
        if (Array.isArray(e)) return e;
      }

      function c(e) {
        return e && e.replace(/^\s+|\s+$/g, "");
      }

      function d(e, t, n) {
        var r = g("<".concat(t, ">")),
            i = g("</".concat(t, ">")),
            a = n.split(t),
            s = o(a, 2),
            l = s[0],
            u = s[1];
        if (!e.includes(r) && !e.includes(i)) throw Error('Parsed tag "'.concat(t, '" is not present in "').concat(e, '"'));
        if (!n.includes(t)) throw Error('Parsed tag "'.concat(t, '" is not present in "').concat(n, '"'));
        if (!l || !u) throw Error('Template value "'.concat(n, '" must contain beginning and closing tags'));
        return e.replace(r, l).replace(i, u);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var f = r(n(5)),
          p = r(n(0)),
          h = r(n(7)),
          m = r(n(4)),
          g = f.default.Utils.escapeExpression;
      f.default.registerHelper("i18n", function (e) {
        var t,
            n = c(e.hash.code),
            r = c(e.hash.bundle),
            o = c(e.hash.arguments),
            i = Object.keys(e.hash).filter(function (e) {
          return e.match(/^\$\d+/);
        }).map(function (t) {
          return {
            tag: t,
            value: e.hash[t]
          };
        });
        o && (t = p.default.map(c(o).split(";"), function (e) {
          e = c(e);
          var t,
              n = this;
          return p.default.each(e.split("."), function (e) {
            t = t ? t[e] : n[e];
          }), t;
        }, this));
        var a = m.default.localize(n, r, t);
        if (i.length < 1) return a;
        var s = g(a);

        try {
          return i.forEach(function (e) {
            s = d(s, e.tag, e.value);
          }), new f.default.SafeString(s);
        } catch (e) {
          return h.default.error(e.toString()), a;
        }
      });
      var v = f.default;
      t.default = v, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        return 0 === e.indexOf(s) ? e : s + e;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var i = r(n(5)),
          a = r(n(0)),
          s = "/assets";
      i.default.registerHelper("img", function (e) {
        var t = "undefined" != typeof okta && okta.cdnUrlHostname || "",
            n = a.default.pick(e.hash, ["src", "alt", "width", "height", "class", "title"]);
        n.src = "" + t + o(n.src);
        var r = a.default.map(n, function (e, t) {
          return t + '="' + ("src" === t ? encodeURI(e) : i.default.Utils.escapeExpression(e)) + '"';
        });
        return new i.default.SafeString("<img " + r.join(" ") + "/>");
      });
      var l = i.default;
      t.default = l, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(5)),
          i = r(n(63));
      o.default.registerHelper("markdown", function (e) {
        return (0, i.default)(o.default, e);
      });
      var a = o.default;
      t.default = a, e.exports = t.default;
    }, function (e, t, n) {
      function r(e, t) {
        var n,
            r = e.compile('<a href="{{href}}">{{text}}</a>');
        return n = o.default.isString(t) ? e.Utils.escapeExpression(t).replace(l, "").replace(i, function (e) {
          return r({
            href: e.match(a)[1],
            text: e.match(s)[1]
          });
        }) : "", new e.SafeString(n);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = r;

      var o = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n(0)),
          i = /\[[^\]]*\]\([^)]*\)/gi,
          a = /\]\(([^)]*)\)/i,
          s = /\[([^\]]*)\]/i,
          l = /javascript:/gi;

      e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(5)),
          i = r(n(3));
      o.default.registerHelper("xsrfTokenInput", function () {
        return new o.default.SafeString('<input type="hidden" class="hide" name="_xsrfToken" value="' + (0, i.default)("#_xsrfToken").text() + '">');
      });
      var a = o.default;
      t.default = a, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(66)),
          i = r(n(1)),
          a = i.default.decorate(o.default);
      t.default = a, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(14)),
          i = r(n(0)),
          a = o.default.extend({
        constructor: function constructor() {
          if (o.default.apply(this, arguments), !this.collection) throw new Error("Missing collection");
          this.listenTo(this.collection, "reset sort", this.reset), this.listenTo(this.collection, "add", this.addItem), this.fetchCollection ? this.collection.fetch() : this.collection.each(this.addItem, this);
        },
        item: null,
        itemSelector: null,
        reset: function reset() {
          var e = this;
          return this.removeChildren(), this.collection.each(function (t, n) {
            e.addItem(t, n);
          }), this;
        },
        addItem: function addItem(e) {
          var t = this.add(this.item, this.itemSelector, {
            options: {
              model: e
            }
          }).last();
          return this.state && this.state.get("trackItemAdded") && this.state.trigger("itemAdded", t), t.listenTo(e, "destroy remove", t.remove), this;
        },
        addShowMore: i.default.noop
      });
      t.default = a, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        "@babel/helpers - typeof";

        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var i = r(n(2)),
          a = r(n(3)),
          s = r(n(0)),
          l = r(n(1)),
          u = i.default.template({
        1: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<span class="icon ' + e.escapeExpression((i = null != (i = a(n, "icon") || (null != t ? a(t, "icon") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "icon",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 96
              },
              end: {
                line: 1,
                column: 104
              }
            }
          }) : i)) + '"></span>';
        },
        3: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return e.escapeExpression((i = null != (i = a(n, "title") || (null != t ? a(t, "title") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "title",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 133
              },
              end: {
                line: 1,
                column: 142
              }
            }
          }) : i));
        },
        5: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<p class="option-subtitle">' + e.escapeExpression((i = null != (i = a(n, "subtitle") || (null != t ? a(t, "subtitle") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "subtitle",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 192
              },
              end: {
                line: 1,
                column: 204
              }
            }
          }) : i)) + "</p>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s,
              l = null != t ? t : e.nullContext || {},
              u = e.hooks.helperMissing,
              c = e.escapeExpression,
              d = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="" class="icon-16 ' + c((s = null != (s = d(n, "className") || (null != t ? d(t, "className") : t)) ? s : u, "function" === o(s) ? s.call(l, {
            name: "className",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 26
              },
              end: {
                line: 1,
                column: 39
              }
            }
          }) : s)) + '" data-se="' + c((s = null != (s = d(n, "seleniumId") || (null != t ? d(t, "seleniumId") : t)) ? s : u, "function" === o(s) ? s.call(l, {
            name: "seleniumId",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 50
              },
              end: {
                line: 1,
                column: 64
              }
            }
          }) : s)) + '">' + (null != (a = d(n, "if").call(l, null != t ? d(t, "icon") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 66
              },
              end: {
                line: 1,
                column: 120
              }
            }
          })) ? a : "") + (null != (a = d(n, "if").call(l, null != t ? d(t, "title") : t, {
            name: "if",
            hash: {},
            fn: e.program(3, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 120
              },
              end: {
                line: 1,
                column: 149
              }
            }
          })) ? a : "") + (null != (a = d(n, "if").call(l, null != t ? d(t, "subtitle") : t, {
            name: "if",
            hash: {},
            fn: e.program(5, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 149
              },
              end: {
                line: 1,
                column: 215
              }
            }
          })) ? a : "") + "</a>";
        },
        useData: !0
      }),
          c = l.default.extend({
        tagName: "li",
        events: {
          click: function click(e) {
            e.preventDefault(), this.action && this.action.call(this);
          }
        },
        constructor: function constructor() {
          l.default.apply(this, arguments), this.$el.addClass("okta-dropdown-option option");
        },
        render: function render() {
          return this.$el.html(u({
            icon: s.default.result(this, "icon"),
            className: s.default.result(this, "className") || "",
            title: s.default.result(this, "title"),
            subtitle: s.default.result(this, "subtitle"),
            seleniumId: s.default.result(this, "seleniumId")
          })), s.default.result(this, "disabled") && this.disable(), this;
        },
        disable: function disable() {
          this.$el.addClass("option-disabled"), this.$el.find("a").attr("tabindex", "-1");
        }
      }),
          d = l.default.extend({
        events: {
          "click a.option-selected": function clickAOptionSelected(e) {
            e.preventDefault(), s.default.result(this, "disabled") && e.stopPropagation();
          },
          "click .dropdown-disabled": function clickDropdownDisabled(e) {
            e.preventDefault(), e.stopPropagation();
          }
        },
        items: [],
        constructor: function constructor() {
          var e = this.className;
          this.className = null, l.default.apply(this, arguments), this.className = e, this.$el.addClass("dropdown more-actions float-l"), s.default.each(s.default.result(this, "items"), function (e) {
            this.addOption(e, this.options);
          }, this);
        },
        template: i.default.template({
          1: function _(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<span class="icon ' + e.escapeExpression((i = null != (i = a(n, "icon") || (null != t ? a(t, "icon") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
              name: "icon",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 176
                },
                end: {
                  line: 1,
                  column: 184
                }
              }
            }) : i)) + '"></span>';
          },
          3: function _(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<span class="off-screen">' + e.escapeExpression((i = null != (i = a(n, "screenReaderText") || (null != t ? a(t, "screenReaderText") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
              name: "screenReaderText",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 249
                },
                end: {
                  line: 1,
                  column: 269
                }
              }
            }) : i)) + "</span>";
          },
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, i) {
            var a,
                s,
                l = null != t ? t : e.nullContext || {},
                u = e.hooks.helperMissing,
                c = e.escapeExpression,
                d = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<a href="#" class="link-button ' + c((s = null != (s = d(n, "className") || (null != t ? d(t, "className") : t)) ? s : u, "function" === o(s) ? s.call(l, {
              name: "className",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 31
                },
                end: {
                  line: 1,
                  column: 44
                }
              }
            }) : s)) + ' link-button-icon option-selected center" aria-expanded="false" aria-controls="okta-dropdown-options">' + (null != (a = d(n, "if").call(l, null != t ? d(t, "icon") : t, {
              name: "if",
              hash: {},
              fn: e.program(1, i, 0),
              inverse: e.noop,
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 146
                },
                end: {
                  line: 1,
                  column: 200
                }
              }
            })) ? a : "") + (null != (a = d(n, "if").call(l, null != t ? d(t, "screenReaderText") : t, {
              name: "if",
              hash: {},
              fn: e.program(3, i, 0),
              inverse: e.noop,
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 200
                },
                end: {
                  line: 1,
                  column: 283
                }
              }
            })) ? a : "") + '<span class="option-selected-text">' + c((s = null != (s = d(n, "title") || (null != t ? d(t, "title") : t)) ? s : u, "function" === o(s) ? s.call(l, {
              name: "title",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 318
                },
                end: {
                  line: 1,
                  column: 327
                }
              }
            }) : s)) + '</span><span class="icon-dm"></span></a><div id="okta-dropdown-options" class="options clearfix" style="display: none;"><ul class="okta-dropdown-list options-wrap clearfix"></ul></div>';
          },
          useData: !0
        }),
        getTemplateData: function getTemplateData() {
          var e = [s.default.result(this, "className") || "", s.default.result(this, "disabled") ? "dropdown-disabled" : ""];
          return {
            icon: s.default.result(this, "icon"),
            className: a.default.trim(e.join(" ")),
            title: s.default.result(this, "title"),
            screenReaderText: s.default.result(this, "screenReaderText")
          };
        },
        addOption: function addOption(e, t) {
          this.add(c.extend(e), "ul.options-wrap", {
            options: t || {}
          });
        }
      });
      t.default = d, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        if (!E && this.$el.hasClass("o-form-saving")) {
          var t = (0, a.default)(e.currentTarget);
          t.css("display", "none");
          var n = document.elementFromPoint(e.clientX, e.clientY);
          return t.css("display", "block"), e.target = n, (0, a.default)(n).trigger(e), !1;
        }
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;

      var i = r(n(2)),
          a = r(n(3)),
          s = r(n(0)),
          l = r(n(4)),
          u = r(n(1)),
          c = r(n(69)),
          d = r(n(27)),
          f = r(n(70)),
          p = r(n(71)),
          h = r(n(10)),
          m = r(n(72)),
          g = r(n(73)),
          v = r(n(74)),
          y = r(n(75)),
          b = r(n(17)),
          _ = i.default.template({
        1: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<h2 class="o-form-title-bar" data-se="o-form-title-bar">' + e.escapeExpression((i = null != (i = a(n, "title") || (null != t ? a(t, "title") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "title",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 75
              },
              end: {
                line: 1,
                column: 84
              }
            }
          }) : i)) + "</h2>";
        },
        3: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return null != (i = a(n, "if").call(null != t ? t : e.nullContext || {}, null != t ? a(t, "title") : t, {
            name: "if",
            hash: {},
            fn: e.program(4, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 192
              },
              end: {
                line: 1,
                column: 288
              }
            }
          })) ? i : "";
        },
        4: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<h2 data-se="o-form-head" class="okta-form-title o-form-head">' + e.escapeExpression((i = null != (i = a(n, "title") || (null != t ? a(t, "title") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "title",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 267
              },
              end: {
                line: 1,
                column: 276
              }
            }
          }) : i)) + "</h2>";
        },
        6: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<p class="okta-form-subtitle o-form-explain" data-se="o-form-explain">' + e.escapeExpression((i = null != (i = a(n, "subtitle") || (null != t ? a(t, "subtitle") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "subtitle",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 385
              },
              end: {
                line: 1,
                column: 397
              }
            }
          }) : i)) + "</p>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a,
              s = null != t ? t : e.nullContext || {},
              l = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return (null != (i = l(n, "if").call(s, null != t ? l(t, "hasReadMode") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 96
              }
            }
          })) ? i : "") + '<div data-se="o-form-content" class="o-form-content ' + e.escapeExpression((a = null != (a = l(n, "layout") || (null != t ? l(t, "layout") : t)) ? a : e.hooks.helperMissing, "function" == typeof a ? a.call(s, {
            name: "layout",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 148
              },
              end: {
                line: 1,
                column: 158
              }
            }
          }) : a)) + ' clearfix">' + (null != (i = l(n, "unless").call(s, null != t ? l(t, "hasReadMode") : t, {
            name: "unless",
            hash: {},
            fn: e.program(3, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 169
              },
              end: {
                line: 1,
                column: 299
              }
            }
          })) ? i : "") + (null != (i = l(n, "if").call(s, null != t ? l(t, "subtitle") : t, {
            name: "if",
            hash: {},
            fn: e.program(6, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 299
              },
              end: {
                line: 1,
                column: 408
              }
            }
          })) ? i : "") + '<div class="o-form-error-container" data-se="o-form-error-container"></div><div class="o-form-fieldset-container" data-se="o-form-fieldset-container"></div></div>';
        },
        useData: !0
      }),
          w = i.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<h2 class="o-form-head">' + e.escapeExpression((i = null != (i = a(n, "title") || (null != t ? a(t, "title") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "title",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 24
              },
              end: {
                line: 1,
                column: 33
              }
            }
          }) : i)) + "</h2>";
        },
        useData: !0
      }),
          E = "auto" === (0, a.default)("<div>").css({
        "pointer-events": "auto"
      })[0].style.pointerEvents,
          O = {
        submit: function submit(e) {
          e.preventDefault(), this.__save();
        }
      };

      s.default.each(["click", "dblclick", "mousedown", "mouseup"], function (e) {
        O[e + " .o-form-input"] = o;
      });

      var S = function S(e) {
        e || (e = {});
        var t = e && e.collection || {};
        return {
          method: "POST",
          action: s.default.result(e, "urlRoot") || s.default.result(t, "url") || window.location.pathname,
          "data-se": "o-form",
          slot: "content"
        };
      },
          x = function x(e, t) {
        e || (e = "");
        var n = [];
        return s.default.isString(e) && (n = e.split(" ")), n = s.default.union(n, t), n.join(" ");
      },
          T = function T() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return Array.isArray(e.errorCauses) && e.errorCauses.length > 0 ? e.errorCauses[0].errorSummary : e.errorSummary;
      },
          k = u.default.extend({
        constructor: function constructor(e) {
          e || (e = {}), this.options = e, e.settings ? this.settings = e.settings : this.settings = e.settings = new b.default(), this.id = s.default.uniqueId("form"), this.tagName = "form", s.default.defaults(this.events, O), s.default.defaults(this.attributes, S(e.model)), this.__buttons = [], this.__errorFields = {}, this.__saveModelState(e.model), this.step && (this.save || (this.save = this.totalSteps && this.step !== this.totalSteps ? "Next" : "Finish"), this.className += " wizard"), this.className += " o-form", this.__toolbar = this.__createToolbar(e), u.default.call(this, e), s.default.each(s.default.result(this, "inputs") || [], function (e) {
            this.__addLayoutItem(e);
          }, this), this.add(this.__toolbar, ""), this.listenTo(this.model, "change:__edit__", this.__applyMode), this.listenTo(this.model, "invalid error", s.default.throttle(function (e, t, n) {
            this.__showErrors(e, t, !1 !== n);
          }, 100, {
            trailing: !1
          })), this.listenTo(this.model, "form:resize", function () {
            this.trigger("resize");
          }), this.listenTo(this.model, "form:cancel", s.default.throttle(this.__cancel, 100, {
            trailing: !1
          })), this.listenTo(this.model, "form:previous", s.default.throttle(this.__previous, 100, {
            trailing: !1
          })), this.__save = s.default.throttle(this.__save, 200, {
            trailing: !1
          }), this.listenTo(this.model, "form:save", function () {
            this.$el.submit();
          }), this.listenTo(this.model, "sync", function () {
            this.model.get("__edit__") && this.model.set("__edit__", !1, {
              silent: !0
            }), this.__saveModelState(this.model), this.render();
          });
          var t = this.getAttribute("hasSavingState");

          if (this.getAttribute("autoSave") && (this.listenTo(this, "save", function (e) {
            var t = this,
                n = e.save();
            n && n.done && n.done(function () {
              t.trigger("saved", e);
            });
          }), s.default.isUndefined(t) && (t = !0)), t) {
            var n = this.getAttribute("customSavingState", {});
            this.listenTo(this.model, x(n.start || "", ["request"]), this.__setSavingState), this.listenTo(this.model, x(n.stop || "", ["error", "sync"]), this.__clearSavingState);
          }
        },
        __createToolbar: function __createToolbar(e) {
          var t = this.getAttribute("danger"),
              n = !0 === t ? "button-error" : "button-primary",
              r = new d.default(s.default.extend({
            save: this.save || l.default.localize("oform.save", "courage"),
            saveId: this.saveId,
            saveClassName: n,
            cancel: this.cancel || l.default.localize("oform.cancel", "courage"),
            noCancelButton: this.noCancelButton || !1,
            noSubmitButton: this.noSubmitButton || !1,
            buttonOrder: this.buttonOrder,
            hasPrevStep: this.step && this.step > 1
          }, e || this.options));
          return s.default.each(this.__buttons, function (e) {
            r.addButton.apply(r, e);
          }), r;
        },
        className: "",
        attributes: {},
        events: {},
        inputs: [],
        template: null,
        read: !1,
        readOnly: !1,
        noButtonBar: !1,
        noCancelButton: !1,
        noSubmitButton: !1,
        buttonOrder: ["previous", "save", "cancel"],
        save: null,
        cancel: null,
        danger: !1,
        layout: "",
        step: void 0,
        totalSteps: void 0,
        title: null,
        subtitle: null,
        autoSave: !1,
        scrollOnError: !0,
        showErrors: !0,
        resizeSelector: ".o-form-content",
        getAttribute: function getAttribute(e, t) {
          var n = s.default.resultCtx(this.options, e, this);
          return s.default.isUndefined(n) && (n = s.default.result(this, e)), s.default.isUndefined(n) ? t : n;
        },
        hasReadMode: function hasReadMode() {
          return !!this.getAttribute("read");
        },
        isReadOnly: function isReadOnly() {
          return !!this.getAttribute("readOnly");
        },
        hasButtonBar: function hasButtonBar() {
          return !(this.getAttribute("noButtonBar") || this.isReadOnly());
        },
        render: function render() {
          if (this.__readModeBar && this.__readModeBar.remove(), this.hasReadMode() && !this.isReadOnly()) {
            var e = c.default.extend({
              formTitle: this.getAttribute("title", "")
            });
            this.__readModeBar = this.add(e, ".o-form-title-bar").last();
          }

          var t = _({
            layout: this.getAttribute("layout", ""),
            title: this.getAttribute("title", "", !0),
            subtitle: this.getAttribute("subtitle", "", !0),
            hasReadMode: this.hasReadMode()
          });

          return this.$el.html(t), delete this.template, u.default.prototype.render.apply(this, arguments), this.__applyMode(), this;
        },
        __setSavingState: function __setSavingState() {
          this.model.trigger("form:set-saving-state"), this.$el.addClass("o-form-saving");
        },
        __clearSavingState: function __clearSavingState() {
          this.model.trigger("form:clear-saving-state"), this.$el.removeClass("o-form-saving");
        },
        __toggleToolbar: function __toggleToolbar() {
          this.__toolbar && this.__toolbar.remove(), this.hasButtonBar() && this._editMode() && (this.__toolbar = this.__createToolbar(), this.add(this.__toolbar, "")), this.trigger("resize");
        },
        __cancel: function __cancel() {
          var e = this.model.get("__edit__");
          this.model.clear({
            silent: !0
          });
          var t;
          t = this.model.sanitizeAttributes ? this.model.sanitizeAttributes(this.__originalModel) : s.default.clone(this.__originalModel), this.model.set(t, {
            silent: !0
          }), this.trigger("cancel", this.model), this.model.trigger("cache:clear"), e && (this.model.set("__edit__", !1, {
            silent: !0
          }), this.model.trigger("change:__edit__", this.model, !1)), this.clearErrors();
        },
        isValid: function isValid() {
          function e(e) {
            return s.default.reduce(e, function (e, t) {
              return s.default.extend(e, n.model.validateField(t));
            }, {});
          }

          var t,
              n = this;
          return s.default.isUndefined(this.validate) ? this.model.isValid() : (s.default.isFunction(this.validate) ? t = this.validate() : s.default.isArray(this.validate) ? t = e(this.validate) : "local" === this.validate && (t = e(this.getInputs().map(function (e) {
            return e.options.name;
          }))), !!s.default.isEmpty(t) || (this.model.trigger("invalid", this.model, t), !1));
        },
        __save: function __save() {
          this.clearErrors(), this.isValid() && this.trigger("save", this.model);
        },
        __previous: function __previous() {
          this.trigger("previous", this.model);
        },
        __applyMode: function __applyMode() {
          this.clearErrors(), this.__toggleToolbar(), this._editMode() ? (this.$el.addClass("o-form-edit-mode"), this.$el.removeClass("o-form-read-mode"), this.$(".o-form-content").removeClass("rounded-btm-4"), this.focus()) : (this.$el.removeClass("o-form-edit-mode"), this.$el.addClass("o-form-read-mode"), this.$(".o-form-content").addClass("rounded-btm-4"));
        },
        _editMode: function _editMode() {
          return this.model.get("__edit__") || !this.hasReadMode();
        },
        parseErrorMessage: s.default.identity,
        _handleErrorScroll: function _handleErrorScroll() {
          if (this.getAttribute("scrollOnError")) {
            var e = (0, a.default)("#" + this.id + " .o-form-error-container");

            if (e.length) {
              var t,
                  n = e.scrollParent();
              n[0] === document ? (n = (0, a.default)("html, body"), t = e.offset().top) : t = n.scrollTop() + e.offset().top - n.offset().top, n.animate({
                scrollTop: t
              }, 400);
            }
          }
        },
        __showErrors: function __showErrors(e, t, n) {
          if (this.trigger("error", e), this.getAttribute("showErrors")) {
            var r,
                o = p.default.getResponseJSON(t),
                i = p.default.parseFieldErrors(t);
            s.default.size(i) ? s.default.each(i, function (e, t) {
              this.model.trigger("form:field-error", this.__errorFields[t] || t, s.default.map(e, function (e) {
                return /^model\.validation/.test(e) ? l.default.localize(e, "courage") : e;
              }));
            }, this) : (o = this.parseErrorMessage(o), r = T(o)), n && (this.$(".o-form-error-container").addClass("o-form-has-errors"), this.add(f.default, ".o-form-error-container", {
              options: {
                errorSummary: r
              }
            })), this._handleErrorScroll(), this.model.trigger("form:resize");
          }
        },
        clearErrors: function clearErrors() {
          this.$(".o-form-error-container").removeClass("o-form-has-errors"), this.model.trigger("form:clear-errors"), this.model.trigger("form:resize");
        },
        toggle: function toggle() {
          return this.model.set("__edit__", !this.hasReadMode() || !this.model.get("__edit__")), this;
        },
        __addLayoutItem: function __addLayoutItem(e) {
          g.default.supports(e) ? this.addInput(e) : this.__addNonInputLayoutItem(e);
        },
        __addNonInputLayoutItem: function __addNonInputLayoutItem(e) {
          var t = s.default.omit(e, "type");

          switch (e.type) {
            case "sectionTitle":
              this.addSectionTitle(e.title, s.default.omit(t, "title"));
              break;

            case "divider":
              this.addDivider(t);
              break;

            default:
              throw new Error("unknown input: " + e.type);
          }
        },
        addButton: function addButton(e, t) {
          this.__toolbar && this.__toolbar.addButton(e, t), this.__buttons.push([e, t]);
        },
        addDivider: function addDivider(e) {
          return this.add('<div class="okta-form-divider form-divider"></div>'), h.default.applyShowWhen(this.last(), e && e.showWhen), h.default.applyToggleWhen(this.last(), e && e.toggleWhen), this;
        },
        addSectionTitle: function addSectionTitle(e, t) {
          return this.add(w({
            title: e
          })), h.default.applyShowWhen(this.last(), t && t.showWhen), h.default.applyToggleWhen(this.last(), t && t.toggleWhen), this;
        },
        addInput: function addInput(e) {
          e = s.default.clone(e), h.default.validateInput(e, this.model);
          var t = h.default.generateInputOptions(e, this, this.__createInput).reverse();
          s.default.isEmpty(this.getInputs().toArray()) && s.default.extend(t[0], {
            validateOnlyIfDirty: !0
          });
          var n = s.default.map(t, this.__createInput, this);
          s.default.each(t, function (e) {
            e.errorField && (this.__errorFields[e.errorField] = e.name);
          }, this);
          var r = {
            inputId: s.default.last(n).options.inputId,
            input: n,
            multi: t.length > 1 ? t.length : void 0
          };
          s.default.extend(r, s.default.omit(this.options, "input"), s.default.omit(e, "input"));

          var o = this.__createWrapper(r);

          !1 !== r.label && o.add(this.__createLabel(r)), o.add(this._createContainer(r)), o.type = r.type || r.input.type || "custom";
          var i = [o].concat(s.default.rest(arguments));
          return this.add.apply(this, i);
        },
        __createInput: function __createInput(e) {
          return e = s.default.pick(e, h.default.INPUT_OPTIONS), g.default.create(e);
        },
        __createWrapper: function __createWrapper(e) {
          return e = s.default.pick(e, h.default.WRAPPER_OPTIONS), new y.default(e);
        },
        __createLabel: function __createLabel(e) {
          return e = s.default.pick(e, h.default.LABEL_OPTIONS), new v.default(e);
        },
        _createContainer: function _createContainer(e) {
          return e = s.default.pick(e, h.default.CONTAINER_OPTIONS), new m.default(e);
        },
        __saveModelState: function __saveModelState(e) {
          this.__originalModel = a.default.extend(!0, {}, e.attributes);
        },
        add: function add() {
          var e = s.default.toArray(arguments);
          return void 0 === e[1] && (e[1] = "> div.o-form-content > .o-form-fieldset-container"), u.default.prototype.add.apply(this, e);
        },
        focus: function focus() {
          var e = this.getInputs().first();
          return e && e.focus && e.focus(), this;
        },
        disable: function disable() {
          return this.invoke("disable"), this;
        },
        enable: function enable() {
          this.invoke("enable");
        },
        contentHeight: function contentHeight(e) {
          var t = this.$(".o-form-content");
          if (!s.default.isNumber(e)) return t.height();
          t.css("max-height", e);
        },
        getInputs: function getInputs() {
          return (0, s.default)(this.filter(function (e) {
            return e instanceof y.default;
          }));
        }
      });

      t.default = k, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(1)),
          i = r(n(10)),
          a = o.default.extend({
        el: '<span class="o-form-toggle" data-type="header-btn"></span>',
        formTitle: "",
        modelEvents: {
          "change:__edit__": "toggle"
        },
        initialize: function initialize() {
          this.addButton();
        },
        addButton: function addButton() {
          this.model.get("__edit__") ? this.add(i.default.createReadFormButton({
            type: "cancel"
          })) : this.add(i.default.createReadFormButton({
            type: "edit",
            formTitle: this.formTitle,
            className: "ajax-form-edit-link"
          }));
        },
        toggle: function toggle() {
          this.removeChildren(), this.addButton();
        }
      });
      t.default = a, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(2)),
          i = r(n(1)),
          a = i.default.extend({
        template: o.default.template({
          1: function _(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return "<p>" + e.escapeExpression((i = null != (i = a(n, "errorSummary") || (null != t ? a(t, "errorSummary") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
              name: "errorSummary",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 130
                },
                end: {
                  line: 1,
                  column: 146
                }
              }
            }) : i)) + "</p>";
          },
          3: function _(e, t, n, r, o) {
            var i = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return "<p>" + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
              name: "i18n",
              hash: {
                bundle: "courage",
                code: "oform.errorbanner.title"
              },
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 161
                },
                end: {
                  line: 1,
                  column: 217
                }
              }
            })) + "</p>";
          },
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<div class="okta-form-infobox-error infobox infobox-error" role="alert"><span class="icon error-16"></span>' + (null != (i = a(n, "if").call(null != t ? t : e.nullContext || {}, null != t ? a(t, "errorSummary") : t, {
              name: "if",
              hash: {},
              fn: e.program(1, o, 0),
              inverse: e.program(3, o, 0),
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 107
                },
                end: {
                  line: 1,
                  column: 228
                }
              }
            })) ? i : "") + "</div>";
          },
          useData: !0
        }),
        modelEvents: {
          "form:clear-errors": "remove"
        }
      });
      t.default = a, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(0)),
          i = r(n(4)),
          a = /^([\S]+): (.+)$/,
          s = {
        getResponseJSON: function getResponseJSON(e) {
          try {
            return e.responseJSON || JSON.parse(e.responseText);
          } catch (e) {
            return;
          }
        },
        parseErrorSummary: function parseErrorSummary(e) {
          var t = e.match(a);
          if (t) return [t[1], t[2]];
        },
        parseErrorCauseObject: function parseErrorCauseObject(e) {
          if (e.property && e.errorSummary) {
            var t = i.default.localize(e.reason),
                n = e.errorSummary;
            return [e.property, -1 === t.indexOf("L10N_ERROR[") ? t : n];
          }
        },
        parseErrors: function parseErrors(e) {
          var t = this.getResponseJSON(e);
          return o.default.map(t && t.errorCauses || [], function (e) {
            return ("" + e.errorSummary).replace(a, "$2");
          });
        },
        parseFieldErrors: function parseFieldErrors(e) {
          var t = this.getResponseJSON(e),
              n = {};
          return t ? o.default.each(t.errorCauses || [], function (e) {
            var t = [];

            if (t = e.property && e.errorSummary ? this.parseErrorCauseObject(e) : e.location && e.errorSummary ? [e.location, e.errorSummary] : this.parseErrorSummary(e && e.errorSummary || "")) {
              var r = t[0],
                  o = t[1];
              n[r] || (n[r] = []), n[r].push(o);
            }
          }, this) : o.default.isObject(e) && o.default.size(e) && o.default.each(e, function (e, t) {
            n[t] = [e];
          }), o.default.size(n) ? n : void 0;
        }
      };
      t.default = s, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        "@babel/helpers - typeof";

        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var i = r(n(2)),
          a = r(n(0)),
          s = r(n(7)),
          l = r(n(19)),
          u = r(n(4)),
          c = r(n(1)),
          d = l.default.isABaseView,
          f = c.default.extend({
        attributes: function attributes() {
          return {
            "data-se": "o-form-input-container"
          };
        },
        className: function className() {
          var e = "o-form-input";

          if (this.options.wide && (e += " o-form-wide"), a.default.contains([1, 2, 3, 4], this.options.multi) && (e += " o-form-multi-input-" + this.options.multi, a.default.isArray(this.options.input))) {
            a.default.find(this.options.input, function (e) {
              return a.default.contains(["text+select", "select+text"], e.options.type);
            }) && (e += " o-form-multi-input-group-" + this.options.multi);
          }

          return e;
        },
        _getNames: function _getNames() {
          var e = a.default.isArray(this.options.name) ? this.options.name : [this.options.name];
          return "group" === this.options.type ? e.push.apply(e, a.default.pluck(this.options.input[0].options.params.inputs, "name")) : a.default.isArray(this.options.name) ? this.options.input && this.options.input.options && this.options.input.options.name && e.push(this.options.input.options.name) : this.options.input && (a.default.isArray(this.options.input) ? a.default.each(this.options.input, function (t) {
            e.push(t.options.name);
          }) : e.push(this.options.input.options.name)), a.default.uniq(a.default.compact(e));
        },
        _getInputElement: function _getInputElement() {
          var e = Array.isArray(this.options.input) ? a.default.last(this.options.input) : this.options.input,
              t = e && e.options && e.options.inputId,
              n = t ? this.$("#" + t) : null;
          return n && n.length ? n : null;
        },
        constructor: function constructor() {
          c.default.apply(this, arguments);
          var e = this.options["explain-top"] && this.options["label-top"];
          this.options.input && (a.default.isArray(this.options.input) ? a.default.each(this.options.input, function (t) {
            this.add(t, {
              prepend: !e
            });
          }, this) : this.add(this.options.input, {
            prepend: !e
          })), this.__setExplain(this.options);

          var t = this._getNames();

          this.listenTo(this.model, "form:field-error", function (n, r) {
            a.default.contains(t, n) && this.__setError(r, e);
          }), this.listenTo(this.model, "form:clear-errors change:" + t.join(" change:"), this.__clearError), this.listenTo(this.model, "form:clear-error:" + t.join(" form:clear-error:"), this.__clearError), a.default.resultCtx(this.options, "autoRender", this) && this.listenTo(this.model, "change:" + this.options.name, this.render), this.__errorState = !1;
        },
        __setExplain: function __setExplain(e) {
          var t;
          if (e.customExplain) return s.default.warn("Deprecated - use explain instead of customExplain"), void this.add(this.options.customExplain);
          t = e.explain, a.default.isFunction(t) && !d(t) && (t = a.default.resultCtx(this.options, "explain", this)), t && (d(t) ? (this.template = i.default.template({
            compiler: [8, ">= 4.3.0"],
            main: function main(e, t, n, r, o) {
              return '<p class="o-form-explain"></p>';
            },
            useData: !0
          }), this.add(t, " > .o-form-explain")) : this.template = i.default.template({
            compiler: [8, ">= 4.3.0"],
            main: function main(e, t, n, r, o) {
              var i,
                  a = e.lookupProperty || function (e, t) {
                if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
              };

              return '<p class="o-form-explain">' + e.escapeExpression((i = null != (i = a(n, "explain") || (null != t ? a(t, "explain") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
                name: "explain",
                hash: {},
                data: o,
                loc: {
                  start: {
                    line: 1,
                    column: 26
                  },
                  end: {
                    line: 1,
                    column: 37
                  }
                }
              }) : i)) + "</p>";
            },
            useData: !0
          }));
        },
        __setError: function __setError(e, t) {
          this.__errorState = !0, this.$el.addClass("o-form-has-errors");
          var n = a.default.uniqueId("input-container-error"),
              r = i.default.template({
            compiler: [8, ">= 4.3.0"],
            main: function main(e, t, n, r, i) {
              var a,
                  s = null != t ? t : e.nullContext || {},
                  l = e.hooks.helperMissing,
                  u = e.escapeExpression,
                  c = e.lookupProperty || function (e, t) {
                if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
              };

              return '<p id="' + u((a = null != (a = c(n, "errorId") || (null != t ? c(t, "errorId") : t)) ? a : l, "function" === o(a) ? a.call(s, {
                name: "errorId",
                hash: {},
                data: i,
                loc: {
                  start: {
                    line: 1,
                    column: 7
                  },
                  end: {
                    line: 1,
                    column: 18
                  }
                }
              }) : a)) + '" class="okta-form-input-error o-form-input-error o-form-explain" role="alert"><span class="icon icon-16 error-16-small" role="img" aria-label="' + u((a = null != (a = c(n, "iconLabel") || (null != t ? c(t, "iconLabel") : t)) ? a : l, "function" === o(a) ? a.call(s, {
                name: "iconLabel",
                hash: {},
                data: i,
                loc: {
                  start: {
                    line: 1,
                    column: 162
                  },
                  end: {
                    line: 1,
                    column: 175
                  }
                }
              }) : a)) + '"></span>' + u((a = null != (a = c(n, "text") || (null != t ? c(t, "text") : t)) ? a : l, "function" === o(a) ? a.call(s, {
                name: "text",
                hash: {},
                data: i,
                loc: {
                  start: {
                    line: 1,
                    column: 184
                  },
                  end: {
                    line: 1,
                    column: 192
                  }
                }
              }) : a)) + "</p>";
            },
            useData: !0
          }),
              s = u.default.localize("oform.error.icon.ariaLabel", "courage"),
              l = r({
            errorId: n,
            iconLabel: s,
            text: e.join(", ")
          }),
              c = this.$(".o-form-explain").not(".o-form-input-error").first();
          c.length && !t ? c.before(l) : this.$el.append(l);
          var d = this._getInputElement() || this.$el;
          d.attr("aria-describedby", n), d.attr("aria-invalid", !0);
        },
        __clearError: function __clearError() {
          var e = this;

          if (this.__errorState) {
            this.$(".o-form-input-error").remove();
            var t = this._getInputElement() || this.$el;
            t.attr("aria-describedby", null), t.attr("aria-invalid", null), this.$el.removeClass("o-form-has-errors"), this.__errorState = !1, a.default.defer(function () {
              e.model.trigger("form:resize");
            });
          }
        },
        focus: function focus() {
          return this.each(function (e) {
            if (e.focus) return e.focus();
          }), this;
        }
      });
      t.default = f, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e, t) {
        return l.default.isBaseInput(e) && e.prototype ? new e(s.default.omit(t, "input")) : e;
      }

      function i(e) {
        if (e = s.default.clone(e), e.input) return o(e.input, e);
        var t = l.default.get(e);
        if (!t) throw new Error("unknown input: " + e.type);
        return o(t, e);
      }

      function a(e) {
        return !!e.input || !!l.default.get(e);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var s = r(n(0)),
          l = r(n(28)),
          u = {
        create: i,
        supports: a
      };
      t.default = u, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        "@babel/helpers - typeof";

        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var i = r(n(2)),
          a = r(n(0));
      n(29);
      var s = r(n(1)),
          l = s.default.extend({
        className: "okta-form-label o-form-label",
        attributes: {
          "data-se": "o-form-label"
        },
        constructor: function constructor(e) {
          a.default.defaults(e, {
            inputId: e.id
          }), delete e.id, s.default.apply(this, arguments);
        },
        template: i.default.template({
          1: function _(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<label for="' + e.escapeExpression((i = null != (i = a(n, "inputId") || (null != t ? a(t, "inputId") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
              name: "inputId",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 33
                },
                end: {
                  line: 1,
                  column: 44
                }
              }
            }) : i)) + '"></label>';
          },
          3: function _(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return e.escapeExpression((i = null != (i = a(n, "label") || (null != t ? a(t, "label") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
              name: "label",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 88
                },
                end: {
                  line: 1,
                  column: 97
                }
              }
            }) : i));
          },
          5: function _(e, t, n, r, i) {
            var a,
                s = null != t ? t : e.nullContext || {},
                l = e.hooks.helperMissing,
                u = e.escapeExpression,
                c = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<label for="' + u((a = null != (a = c(n, "inputId") || (null != t ? c(t, "inputId") : t)) ? a : l, "function" === o(a) ? a.call(s, {
              name: "inputId",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 139
                },
                end: {
                  line: 1,
                  column: 150
                }
              }
            }) : a)) + '">' + u((a = null != (a = c(n, "label") || (null != t ? c(t, "label") : t)) ? a : l, "function" === o(a) ? a.call(s, {
              name: "label",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 152
                },
                end: {
                  line: 1,
                  column: 161
                }
              }
            }) : a)) + "&nbsp;</label>";
          },
          7: function _(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<span class="o-form-explain">' + e.escapeExpression((i = null != (i = a(n, "sublabel") || (null != t ? a(t, "sublabel") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
              name: "sublabel",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 228
                },
                end: {
                  line: 1,
                  column: 240
                }
              }
            }) : i)) + "</span>";
          },
          9: function _(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<span class="o-form-tooltip icon-16 icon-only form-help-16" title="' + e.escapeExpression(e.lambda(null != (i = null != t ? a(t, "tooltip") : t) ? a(i, "text") : i, t)) + '"></span>';
          },
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, o) {
            var i,
                a = null != t ? t : e.nullContext || {},
                s = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return (null != (i = s(n, "if").call(a, null != t ? s(t, "_isLabelView") : t, {
              name: "if",
              hash: {},
              fn: e.program(1, o, 0),
              inverse: e.noop,
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 0
                },
                end: {
                  line: 1,
                  column: 61
                }
              }
            })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "_isRadioOrCheckbox") : t, {
              name: "if",
              hash: {},
              fn: e.program(3, o, 0),
              inverse: e.noop,
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 61
                },
                end: {
                  line: 1,
                  column: 104
                }
              }
            })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "_standardLabel") : t, {
              name: "if",
              hash: {},
              fn: e.program(5, o, 0),
              inverse: e.noop,
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 104
                },
                end: {
                  line: 1,
                  column: 182
                }
              }
            })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "sublabel") : t, {
              name: "if",
              hash: {},
              fn: e.program(7, o, 0),
              inverse: e.noop,
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 182
                },
                end: {
                  line: 1,
                  column: 254
                }
              }
            })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "tooltip") : t, {
              name: "if",
              hash: {},
              fn: e.program(9, o, 0),
              inverse: e.noop,
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 254
                },
                end: {
                  line: 1,
                  column: 369
                }
              }
            })) ? i : "");
          },
          useData: !0
        }),
        getTemplateData: function getTemplateData() {
          var e = {
            label: ""
          };
          return a.default.each(["inputId", "label", "sublabel", "tooltip"], function (t) {
            e[t] = a.default.resultCtx(this.options, t, this);
          }, this), this._isLabelView(e.label) ? e._isLabelView = !0 : a.default.contains(["radio", "checkbox"], this.options.type) || !e.label ? e._isRadioOrCheckbox = !0 : e._standardLabel = !0, e.tooltip && a.default.isString(e.tooltip) && (e.tooltip = {
            text: e.tooltip
          }), e;
        },
        _isLabelView: function _isLabelView(e) {
          return !a.default.isUndefined(e) && e instanceof s.default;
        },
        postRender: function postRender() {
          var e = this.getTemplateData();
          this._isLabelView(e.label) && (this.removeChildren(), this.add(e.label, "label")), e.tooltip && this.$(".o-form-tooltip").qtip(a.default.extend({
            style: {
              classes: "qtip-custom qtip-shadow"
            },
            position: {
              my: window.okta && "dstheme" === window.okta.theme ? "bottom center" : "bottom left",
              at: "top center"
            },
            hide: {
              fixed: !0
            },
            show: {
              delay: 0
            }
          }, e.tooltip.options));
        }
      });
      t.default = l, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e, t) {
        e.apply(this, a.default.map(t.split(/\s+/), function (e) {
          return this.model.get(e);
        }, this));
      }

      function i(e, t) {
        a.default.isFunction(e) && e.call(t);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var a = r(n(0)),
          s = r(n(1)),
          l = r(n(10)),
          u = s.default.extend({
        className: function className() {
          var e = "o-form-fieldset";
          return this.options["label-top"] && (e += " o-form-label-top"), this.options.readOnly && (e += " o-form-read-mode"), e;
        },
        attributes: function attributes() {
          return {
            "data-se": this.options["data-se"] || "o-form-fieldset"
          };
        },
        constructor: function constructor(e) {
          e.className && (this.inputWrapperClassName = this.className, this.optionsClassName = e.className, e.className = function () {
            return a.default.result(this, "inputWrapperClassName", "") + " " + a.default.result(this, "optionsClassName");
          }), s.default.apply(this, arguments), a.default.each(e.events || {}, function (e, t) {
            this.listenTo(this.model, t, e);
          }, this), a.default.each(e.bindings || {}, function (e, t) {
            this.listenTo(this.model, l.default.changeEventString(t.split(/\s+/)), a.default.bind(o, this, e, t));
          }, this), l.default.applyShowWhen(this, e.showWhen), l.default.applyToggleWhen(this, e.toggleWhen), i(e.initialize, this);
        },
        postRender: function postRender() {
          a.default.each(this.options.bindings || {}, o, this), i(this.options.render, this);
        },
        getLabel: function getLabel() {
          return this.size() > 1 ? this.at(0) : null;
        },
        getInput: function getInput() {
          return this.getInputContainer();
        },
        getInputContainer: function getInputContainer() {
          return this.at(this.size() > 1 ? 1 : 0);
        },
        getInputs: function getInputs() {
          return this.getInputContainer().toArray();
        },
        focus: function focus() {
          return this.getInput().focus();
        }
      });
      t.default = u, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        var t = e.get("__displayType__"),
            n = e.get("__possibleValues__"),
            r = e.get("name"),
            o = e.get("title"),
            i = {
          type: "text",
          name: r,
          label: o || r
        };

        switch (t) {
          case "arrayofstring":
            i.input = v.default, i.params = {
              itemType: "string"
            };
            break;

          case "arrayofnumber":
            i.input = v.default, i.params = {
              itemType: "number"
            };
            break;

          case "arrayofinteger":
            i.input = v.default, i.params = {
              itemType: "integer"
            };
            break;

          case "arrayofobject":
            i.input = v.default, i.params = {
              itemType: e.get("items").type
            };
            break;

          case "arrayofref-id":
            i.input = v.default, i.params = {
              itemType: e.get("items").format
            };
            break;

          case "boolean":
            i.input = g.default;
            break;

          case "integer":
          case "number":
            i.to = a;
            break;

          case "reference":
            i.type = "select", i.options = l(n);
            break;

          case "image":
            i.readOnly = !0, i.from = function (e) {
              return h.default.isEmpty(e) ? "" : m.default.localize("user.profile.image.image_set", "courage");
            };
            break;

          case "password":
            i.type = "password";
            break;

          case "date":
            i.type = "date";
            break;

          case "uri":
          case "country-code":
          case "country_code":
          case "language-code":
          case "language_code":
          case "email":
          case "locale":
          case "timezone":
          case "string":
          case "object":
            break;

          default:
            throw new Error("unknown type: " + t);
        }

        return i;
      }

      function i(e) {
        var t = {},
            n = e.get("name"),
            r = e.get("__displayType__"),
            o = e.get("__possibleValues__"),
            i = e.get("__fieldNamePrefix__");

        if (i && (t.name = i + n, t.errorField = n), e.isEnumType()) {
          var a = {
            displayType: r,
            title: e.get("title"),
            enumValues: e.getEnumValues()
          };
          t = h.default.extend({}, y.default.getEnumInputOptions(a), t);
        } else s(r) && o && (t.type = "checkboxset", t.input = null, t.options = l(o));

        return t;
      }

      function a(e) {
        var t = m.default.parseFloat(e);
        return "" === e ? null : t;
      }

      function s(e) {
        return e && e.indexOf("array") >= 0;
      }

      function l(e) {
        return h.default.object(e, e);
      }

      function u(e) {
        var t = e.get("items");
        return t ? t.objectName : e.get("objectName");
      }

      function c(e, t, n) {
        var r,
            o,
            i = e.get("name"),
            a = n.__nestedProperty__,
            s = t[i],
            l = n.get(i);
        a && e.set("__fieldNamePrefix__", a), r = t[u(e)], s && l && (s = h.default.union(s, l)), r && r.length ? o = r : s && s.length && (o = s), e.set("__possibleValues__", o);
      }

      function d(e, t, n) {
        return e.each(function (e) {
          c(e, t, n);
        }), e;
      }

      function f(e, t) {
        return e.filter(function (e) {
          return p(e, t);
        });
      }

      function p(e, t) {
        var n = u(e),
            r = t[n];
        return !n || !(0, h.default)(r).isEmpty();
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var h = r(n(0)),
          m = r(n(4)),
          g = r(n(77)),
          v = r(n(79)),
          y = r(n(21)),
          b = {
        createInputOptions: function createInputOptions(e) {
          var t = i(e),
              n = o(e);
          return t.params && n.params && (t.params = h.default.defaults(t.params, n.params)), h.default.defaults(t, n);
        },
        hasValidSchemaProps: function hasValidSchemaProps(e, t) {
          return !h.default.isEmpty(e) && !!f(e, t).length;
        },
        prepareSchema: function prepareSchema(e, t, n) {
          return e.reset(f(e, t)), d(e, t, n);
        },
        augmentSchemaProps: d,
        augmentSchemaProp: c
      };
      t.default = b, e.exports = t.default;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;

      var r = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n(30)),
          o = {
        undefined: "undefined",
        true: "true",
        false: "false"
      },
          i = function i(e) {
        return e ? "true" : !1 === e ? "false" : "undefined";
      },
          a = function a(e) {
        switch (e) {
          case "undefined":
            return null;

          case "true":
            return !0;

          case "false":
            return !1;

          default:
            return null;
        }
      },
          s = r.default.extend({
        initialize: function initialize() {
          this.options.options = o, this.options.from = i, this.options.to = a;
        }
      });

      t.default = s, e.exports = t.default;
    }, function (e, t, n) {
      var r, o;
      r = [n(12)], void 0 !== (o = function (e) {
        (function () {
          var e;
          e = function () {
            function e() {
              this.options_index = 0, this.parsed = [];
            }

            return e.prototype.add_node = function (e) {
              return "OPTGROUP" === e.nodeName.toUpperCase() ? this.add_group(e) : this.add_option(e);
            }, e.prototype.add_group = function (e) {
              var t, n, r, o, i, a;

              for (t = this.parsed.length, this.parsed.push({
                array_index: t,
                group: !0,
                label: e.label,
                children: 0,
                disabled: e.disabled
              }), i = e.childNodes, a = [], r = 0, o = i.length; r < o; r++) {
                n = i[r], a.push(this.add_option(n, t, e.disabled));
              }

              return a;
            }, e.prototype.add_option = function (e, t, n) {
              if ("OPTION" === e.nodeName.toUpperCase()) return "" !== e.text ? (null != t && (this.parsed[t].children += 1), this.parsed.push({
                array_index: this.parsed.length,
                options_index: this.options_index,
                value: e.value,
                text: e.text,
                html: e.innerHTML,
                selected: e.selected,
                disabled: !0 === n ? n : e.disabled,
                group_array_index: t,
                classes: e.className,
                style: e.style.cssText
              })) : this.parsed.push({
                array_index: this.parsed.length,
                options_index: this.options_index,
                empty: !0
              }), this.options_index += 1;
            }, e;
          }(), e.select_to_array = function (t) {
            var n, r, o, i, a;

            for (r = new e(), a = t.childNodes, o = 0, i = a.length; o < i; o++) {
              n = a[o], r.add_node(n);
            }

            return r.parsed;
          }, this.SelectParser = e;
        }).call(this), function () {
          var e, t;
          t = this, e = function () {
            function e(t, n) {
              this.form_field = t, this.options = null != n ? n : {}, e.browser_is_supported() && (this.is_multiple = this.form_field.multiple, this.set_default_text(), this.set_default_values(), this.setup(), this.set_up_html(), this.register_observers(), this.finish_setup());
            }

            return e.prototype.set_default_values = function () {
              var e = this;
              return this.click_test_action = function (t) {
                return e.test_active_click(t);
              }, this.activate_action = function (t) {
                return e.activate_field(t);
              }, this.active_field = !1, this.mouse_on_container = !1, this.results_showing = !1, this.result_highlighted = null, this.result_single_selected = null, this.allow_single_deselect = null != this.options.allow_single_deselect && null != this.form_field.options[0] && "" === this.form_field.options[0].text && this.options.allow_single_deselect, this.disable_search_threshold = this.options.disable_search_threshold || 0, this.disable_search = this.options.disable_search || !1, this.enable_split_word_search = null == this.options.enable_split_word_search || this.options.enable_split_word_search, this.search_contains = this.options.search_contains || !1, this.single_backstroke_delete = this.options.single_backstroke_delete || !1, this.max_selected_options = this.options.max_selected_options || 1 / 0, this.inherit_select_classes = this.options.inherit_select_classes || !1;
            }, e.prototype.set_default_text = function () {
              return this.form_field.getAttribute("data-placeholder") ? this.default_text = this.form_field.getAttribute("data-placeholder") : this.is_multiple ? this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || e.default_multiple_text : this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || e.default_single_text, this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || e.default_no_result_text;
            }, e.prototype.mouse_enter = function () {
              return this.mouse_on_container = !0;
            }, e.prototype.mouse_leave = function () {
              return this.mouse_on_container = !1;
            }, e.prototype.input_focus = function (e) {
              var t = this;

              if (this.is_multiple) {
                if (!this.active_field) return setTimeout(function () {
                  return t.container_mousedown();
                }, 50);
              } else if (!this.active_field) return this.activate_field();
            }, e.prototype.input_blur = function (e) {
              var t = this;
              if (!this.mouse_on_container) return this.active_field = !1, setTimeout(function () {
                return t.blur_test();
              }, 100);
            }, e.prototype.result_add_option = function (e) {
              var t, n;
              return e.dom_id = this.container_id + "_o_" + e.array_index, t = [], e.disabled || e.selected && this.is_multiple || t.push("active-result"), !e.disabled || e.selected && this.is_multiple || t.push("disabled-result"), e.selected && t.push("result-selected"), null != e.group_array_index && t.push("group-option"), "" !== e.classes && t.push(e.classes), n = "" !== e.style.cssText ? ' style="' + e.style + '"' : "", '<li id="' + e.dom_id + '" class="' + t.join(" ") + '"' + n + ">" + e.html + "</li>";
            }, e.prototype.results_update_field = function () {
              return this.set_default_text(), this.is_multiple || this.results_reset_cleanup(), this.result_clear_highlight(), this.result_single_selected = null, this.results_build();
            }, e.prototype.results_toggle = function () {
              return this.results_showing ? this.results_hide() : this.results_show();
            }, e.prototype.results_search = function (e) {
              return this.results_showing ? this.winnow_results() : this.results_show();
            }, e.prototype.choices_count = function () {
              var e, t, n, r;
              if (null != this.selected_option_count) return this.selected_option_count;

              for (this.selected_option_count = 0, r = this.form_field.options, t = 0, n = r.length; t < n; t++) {
                e = r[t], e.selected && (this.selected_option_count += 1);
              }

              return this.selected_option_count;
            }, e.prototype.choices_click = function (e) {
              if (e.preventDefault(), !this.results_showing && !this.is_disabled) return this.results_show();
            }, e.prototype.keyup_checker = function (e) {
              var t, n;

              switch (t = null != (n = e.which) ? n : e.keyCode, this.search_field_scale(), t) {
                case 8:
                  if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) return this.keydown_backstroke();
                  if (!this.pending_backstroke) return this.result_clear_highlight(), this.results_search();
                  break;

                case 13:
                  if (e.preventDefault(), this.results_showing) return this.result_select(e);
                  break;

                case 27:
                  return this.results_showing && this.results_hide(), !0;

                case 9:
                case 38:
                case 40:
                case 16:
                case 91:
                case 17:
                  break;

                default:
                  return this.results_search();
              }
            }, e.prototype.generate_field_id = function () {
              var e;
              return e = this.generate_random_id(), this.form_field.id = e, e;
            }, e.prototype.generate_random_char = function () {
              var e, t;
              return e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", t = Math.floor(Math.random() * e.length), e.substring(t, t + 1);
            }, e.prototype.container_width = function () {
              return null != this.options.width ? this.options.width : this.form_field.offsetWidth + "px";
            }, e.browser_is_supported = function () {
              var e;
              return "Microsoft Internet Explorer" !== window.navigator.appName || null !== (e = document.documentMode) && e >= 8;
            }, e.default_multiple_text = "Select Some Options", e.default_single_text = "Select an Option", e.default_no_result_text = "No results match", e;
          }(), t.AbstractChosen = e;
        }.call(this), function () {
          var t,
              n,
              r,
              o,
              i = {}.hasOwnProperty,
              a = function a(e, t) {
            function n() {
              this.constructor = e;
            }

            for (var r in t) {
              i.call(t, r) && (e[r] = t[r]);
            }

            return n.prototype = t.prototype, e.prototype = new n(), e.__super__ = t.prototype, e;
          };

          r = this;
          var s = r.AbstractChosen;
          t = e, t.fn.extend({
            chosen: function chosen(e) {
              return s.browser_is_supported() ? this.each(function (r) {
                var o;
                if (o = t(this), !o.hasClass("chzn-done")) return o.data("chosen", new n(this, e));
              }) : this;
            }
          }), n = function (e) {
            function n() {
              return o = n.__super__.constructor.apply(this, arguments);
            }

            return a(n, e), n.prototype.setup = function () {
              return this.form_field_jq = t(this.form_field), this.current_selectedIndex = this.form_field.selectedIndex, this.is_rtl = this.form_field_jq.hasClass("chzn-rtl");
            }, n.prototype.finish_setup = function () {
              return this.form_field_jq.addClass("chzn-done");
            }, n.prototype.set_up_html = function () {
              var e, n;
              return this.container_id = this.form_field.id.length ? this.form_field.id.replace(/[^\w]/g, "_") : this.generate_field_id(), this.container_id += "_chzn", e = ["chzn-container"], e.push("chzn-container-" + (this.is_multiple ? "multi" : "single")), this.inherit_select_classes && this.form_field.className && e.push(this.form_field.className), this.is_rtl && e.push("chzn-rtl"), n = {
                id: this.container_id,
                class: e.join(" "),
                style: "width: " + this.container_width() + ";",
                title: this.form_field.title
              }, this.container = t("<div></div>", n), this.is_multiple ? this.container.html('<ul class="chzn-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chzn-drop"><ul class="chzn-results"></ul></div>') : this.container.html('<a href="javascript:void(0)" class="chzn-single chzn-default" tabindex="-1"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chzn-drop"><div class="chzn-search"><input type="text" autocomplete="off" /></div><ul class="chzn-results"></ul></div>'), this.form_field_jq.hide().after(this.container), this.dropdown = this.container.find("div.chzn-drop").first(), this.search_field = this.container.find("input").first(), this.search_results = this.container.find("ul.chzn-results").first(), this.search_field_scale(), this.search_no_results = this.container.find("li.no-results").first(), this.is_multiple ? (this.search_choices = this.container.find("ul.chzn-choices").first(), this.search_container = this.container.find("li.search-field").first()) : (this.search_container = this.container.find("div.chzn-search").first(), this.selected_item = this.container.find(".chzn-single").first()), this.results_build(), this.set_tab_index(), this.set_label_behavior(), this.form_field_jq.trigger("liszt:ready", {
                chosen: this
              });
            }, n.prototype.register_observers = function () {
              var e = this;
              return this.container.mousedown(function (t) {
                e.container_mousedown(t);
              }), this.container.mouseup(function (t) {
                e.container_mouseup(t);
              }), this.container.mouseenter(function (t) {
                e.mouse_enter(t);
              }), this.container.mouseleave(function (t) {
                e.mouse_leave(t);
              }), this.search_results.mouseup(function (t) {
                e.search_results_mouseup(t);
              }), this.search_results.mouseover(function (t) {
                e.search_results_mouseover(t);
              }), this.search_results.mouseout(function (t) {
                e.search_results_mouseout(t);
              }), this.search_results.bind("mousewheel DOMMouseScroll", function (t) {
                e.search_results_mousewheel(t);
              }), this.form_field_jq.bind("liszt:updated", function (t) {
                e.results_update_field(t);
              }), this.form_field_jq.bind("liszt:activate", function (t) {
                e.activate_field(t);
              }), this.form_field_jq.bind("liszt:open", function (t) {
                e.container_mousedown(t);
              }), this.search_field.blur(function (t) {
                e.input_blur(t);
              }), this.search_field.keyup(function (t) {
                e.keyup_checker(t);
              }), this.search_field.keydown(function (t) {
                e.keydown_checker(t);
              }), this.search_field.focus(function (t) {
                e.input_focus(t);
              }), this.is_multiple ? this.search_choices.click(function (t) {
                e.choices_click(t);
              }) : this.container.click(function (e) {
                e.preventDefault();
              });
            }, n.prototype.search_field_disabled = function () {
              return this.is_disabled = this.form_field_jq[0].disabled, this.is_disabled ? (this.container.addClass("chzn-disabled"), this.search_field[0].disabled = !0, this.is_multiple || this.selected_item.unbind("focus", this.activate_action), this.close_field()) : (this.container.removeClass("chzn-disabled"), this.search_field[0].disabled = !1, this.is_multiple ? void 0 : this.selected_item.bind("focus", this.activate_action));
            }, n.prototype.container_mousedown = function (e) {
              if (!this.is_disabled && (e && "mousedown" === e.type && !this.results_showing && e.preventDefault(), null == e || !t(e.target).hasClass("search-choice-close"))) return this.active_field ? this.is_multiple || !e || t(e.target)[0] !== this.selected_item[0] && !t(e.target).parents("a.chzn-single").length || (e.preventDefault(), this.results_toggle()) : (this.is_multiple && this.search_field.val(""), t(document).click(this.click_test_action), this.results_show()), this.activate_field();
            }, n.prototype.container_mouseup = function (e) {
              if ("ABBR" === e.target.nodeName && !this.is_disabled) return this.results_reset(e);
            }, n.prototype.search_results_mousewheel = function (e) {
              var t, n, r;
              if (null != (t = -(null != (n = e.originalEvent) ? n.wheelDelta : void 0) || (null != (r = e.originialEvent) ? r.detail : void 0))) return e.preventDefault(), "DOMMouseScroll" === e.type && (t *= 40), this.search_results.scrollTop(t + this.search_results.scrollTop());
            }, n.prototype.blur_test = function (e) {
              if (!this.active_field && this.container.hasClass("chzn-container-active")) return this.close_field();
            }, n.prototype.close_field = function () {
              return t(document).unbind("click", this.click_test_action), this.active_field = !1, this.results_hide(), this.container.removeClass("chzn-container-active"), this.clear_backstroke(), this.show_search_field_default(), this.search_field_scale();
            }, n.prototype.activate_field = function () {
              return this.container.addClass("chzn-container-active"), this.active_field = !0, this.search_field.val(this.search_field.val()), this.search_field.focus();
            }, n.prototype.test_active_click = function (e) {
              return t(e.target).parents("#" + this.container_id).length ? this.active_field = !0 : this.close_field();
            }, n.prototype.results_build = function () {
              var e, t, n, o, i;

              for (this.parsing = !0, this.selected_option_count = null, this.results_data = r.SelectParser.select_to_array(this.form_field), this.is_multiple ? this.search_choices.find("li.search-choice").remove() : this.is_multiple || (this.selected_item.addClass("chzn-default").find("span").text(this.default_text), this.disable_search || this.form_field.options.length <= this.disable_search_threshold ? (this.search_field[0].readOnly = !0, this.container.addClass("chzn-container-single-nosearch")) : (this.search_field[0].readOnly = !1, this.container.removeClass("chzn-container-single-nosearch"))), e = "", i = this.results_data, n = 0, o = i.length; n < o; n++) {
                t = i[n], t.group ? e += this.result_add_group(t) : t.empty || (e += this.result_add_option(t), t.selected && this.is_multiple ? this.choice_build(t) : t.selected && !this.is_multiple && (this.selected_item.removeClass("chzn-default").find("span").text(t.text), this.allow_single_deselect && this.single_deselect_control_build()));
              }

              return this.search_field_disabled(), this.show_search_field_default(), this.search_field_scale(), this.search_results.html(e), this.parsing = !1;
            }, n.prototype.result_add_group = function (e) {
              return e.dom_id = this.container_id + "_g_" + e.array_index, '<li id="' + e.dom_id + '" class="group-result">' + t("<div></div>").text(e.label).html() + "</li>";
            }, n.prototype.result_do_highlight = function (e) {
              var t, n, r, o, i;

              if (e.length) {
                if (this.result_clear_highlight(), this.result_highlight = e, this.result_highlight.addClass("highlighted"), r = parseInt(this.search_results.css("maxHeight"), 10), i = this.search_results.scrollTop(), o = r + i, n = this.result_highlight.position().top + this.search_results.scrollTop(), (t = n + this.result_highlight.outerHeight()) >= o) return this.search_results.scrollTop(t - r > 0 ? t - r : 0);
                if (n < i) return this.search_results.scrollTop(n);
              }
            }, n.prototype.result_clear_highlight = function () {
              return this.result_highlight && this.result_highlight.removeClass("highlighted"), this.result_highlight = null;
            }, n.prototype.results_show = function () {
              return this.is_multiple && this.max_selected_options <= this.choices_count() ? (this.form_field_jq.trigger("liszt:maxselected", {
                chosen: this
              }), !1) : (this.container.addClass("chzn-with-drop"), this.form_field_jq.trigger("liszt:showing_dropdown", {
                chosen: this
              }), this.results_showing = !0, this.search_field.focus(), this.search_field.val(this.search_field.val()), this.winnow_results());
            }, n.prototype.results_hide = function () {
              return this.results_showing && (this.result_clear_highlight(), this.container.removeClass("chzn-with-drop"), this.form_field_jq.trigger("liszt:hiding_dropdown", {
                chosen: this
              })), this.results_showing = !1;
            }, n.prototype.set_tab_index = function (e) {
              var t;
              if (this.form_field_jq.attr("tabindex")) return t = this.form_field_jq.attr("tabindex"), this.form_field_jq.attr("tabindex", -1), this.search_field.attr("tabindex", t);
            }, n.prototype.set_label_behavior = function () {
              var e = this;
              if (this.form_field_label = this.form_field_jq.parents("label"), !this.form_field_label.length && this.form_field.id.length && (this.form_field_label = t("label[for='" + this.form_field.id + "']")), this.form_field_label.length > 0) return this.form_field_label.click(function (t) {
                return e.is_multiple ? e.container_mousedown(t) : e.activate_field();
              });
            }, n.prototype.show_search_field_default = function () {
              return this.is_multiple && this.choices_count() < 1 && !this.active_field ? (this.search_field.val(this.default_text), this.search_field.addClass("default")) : (this.search_field.val(""), this.search_field.removeClass("default"));
            }, n.prototype.search_results_mouseup = function (e) {
              var n;
              if (n = t(e.target).hasClass("active-result") ? t(e.target) : t(e.target).parents(".active-result").first(), n.length) return this.result_highlight = n, this.result_select(e), this.search_field.focus();
            }, n.prototype.search_results_mouseover = function (e) {
              var n;
              if (n = t(e.target).hasClass("active-result") ? t(e.target) : t(e.target).parents(".active-result").first()) return this.result_do_highlight(n);
            }, n.prototype.search_results_mouseout = function (e) {
              if (t(e.target).hasClass("active-result")) return this.result_clear_highlight();
            }, n.prototype.choice_build = function (e) {
              var n,
                  r,
                  o = this;
              return n = t("<li></li>", {
                class: "search-choice"
              }).html("<span>" + e.html + "</span>"), e.disabled ? n.addClass("search-choice-disabled") : (r = t("<a></a>", {
                href: "#",
                class: "search-choice-close",
                rel: e.array_index
              }), r.click(function (e) {
                return o.choice_destroy_link_click(e);
              }), n.append(r)), this.search_container.before(n);
            }, n.prototype.choice_destroy_link_click = function (e) {
              if (e.preventDefault(), e.stopPropagation(), !this.is_disabled) return this.choice_destroy(t(e.target));
            }, n.prototype.choice_destroy = function (e) {
              if (this.result_deselect(e.attr("rel"))) return this.show_search_field_default(), this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1 && this.results_hide(), e.parents("li").first().remove(), this.search_field_scale();
            }, n.prototype.results_reset = function () {
              if (this.form_field.options[0].selected = !0, this.selected_option_count = null, this.selected_item.find("span").text(this.default_text), this.is_multiple || this.selected_item.addClass("chzn-default"), this.show_search_field_default(), this.results_reset_cleanup(), this.form_field_jq.trigger("change"), this.active_field) return this.results_hide();
            }, n.prototype.results_reset_cleanup = function () {
              return this.current_selectedIndex = this.form_field.selectedIndex, this.selected_item.find("abbr").remove();
            }, n.prototype.result_select = function (e) {
              var t, n, r, o;
              if (this.result_highlight) return t = this.result_highlight, n = t.attr("id"), this.result_clear_highlight(), this.is_multiple && this.max_selected_options <= this.choices_count() ? (this.form_field_jq.trigger("liszt:maxselected", {
                chosen: this
              }), !1) : (this.is_multiple ? t.removeClass("active-result") : (this.search_results.find(".result-selected").removeClass("result-selected"), this.result_single_selected = t, this.selected_item.removeClass("chzn-default")), t.addClass("result-selected"), o = n.substr(n.lastIndexOf("_") + 1), r = this.results_data[o], r.selected = !0, this.form_field.options[r.options_index].selected = !0, this.selected_option_count = null, this.is_multiple ? this.choice_build(r) : (this.selected_item.find("span").first().text(r.text), this.allow_single_deselect && this.single_deselect_control_build()), (e.metaKey || e.ctrlKey) && this.is_multiple || this.results_hide(), this.search_field.val(""), (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) && this.form_field_jq.trigger("change", {
                selected: this.form_field.options[r.options_index].value
              }), this.current_selectedIndex = this.form_field.selectedIndex, this.search_field_scale());
            }, n.prototype.result_activate = function (e, t) {
              return t.disabled ? e.addClass("disabled-result") : this.is_multiple && t.selected ? e.addClass("result-selected") : e.addClass("active-result");
            }, n.prototype.result_deactivate = function (e) {
              return e.removeClass("active-result result-selected disabled-result");
            }, n.prototype.result_deselect = function (e) {
              var n, r;
              return r = this.results_data[e], !this.form_field.options[r.options_index].disabled && (r.selected = !1, this.form_field.options[r.options_index].selected = !1, this.selected_option_count = null, n = t("#" + this.container_id + "_o_" + e), n.removeClass("result-selected").addClass("active-result").show(), this.result_clear_highlight(), this.winnow_results(), this.form_field_jq.trigger("change", {
                deselected: this.form_field.options[r.options_index].value
              }), this.search_field_scale(), !0);
            }, n.prototype.single_deselect_control_build = function () {
              if (this.allow_single_deselect) return this.selected_item.find("abbr").length || this.selected_item.find("span").first().after('<abbr class="search-choice-close"></abbr>'), this.selected_item.addClass("chzn-single-with-deselect");
            }, n.prototype.winnow_results = function () {
              var e, n, r, o, i, a, s, l, u, c, d, f, p, h, m, g, v, y;

              for (this.no_results_clear(), u = 0, c = this.search_field.val() === this.default_text ? "" : t("<div></div>").text(t.trim(this.search_field.val())).html(), a = this.search_contains ? "" : "^", i = new RegExp(a + c.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), "i"), p = new RegExp(c.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), "i"), y = this.results_data, h = 0, g = y.length; h < g; h++) {
                if (n = y[h], !n.empty) if (n.group) t("#" + n.dom_id).css("display", "none");else {
                  if (e = !1, l = n.dom_id, s = t("#" + l), i.test(n.html)) e = !0, u += 1;else if (this.enable_split_word_search && (n.html.indexOf(" ") >= 0 || 0 === n.html.indexOf("[")) && (o = n.html.replace(/\[|\]/g, "").split(" "), o.length)) for (m = 0, v = o.length; m < v; m++) {
                    r = o[m], i.test(r) && (e = !0, u += 1);
                  }
                  e ? (c.length ? (d = n.html.search(p), f = n.html.substr(0, d + c.length) + "</em>" + n.html.substr(d + c.length), f = f.substr(0, d) + "<em>" + f.substr(d)) : f = n.html, s.html(f), this.result_activate(s, n), null != n.group_array_index && t("#" + this.results_data[n.group_array_index].dom_id).css("display", "list-item")) : (this.result_highlight && l === this.result_highlight.attr("id") && this.result_clear_highlight(), this.result_deactivate(s));
                }
              }

              return u < 1 && c.length ? this.no_results(c) : this.winnow_results_set_highlight();
            }, n.prototype.winnow_results_set_highlight = function () {
              var e, t;
              if (!this.result_highlight && (t = this.is_multiple ? [] : this.search_results.find(".result-selected.active-result"), null != (e = t.length ? t.first() : this.search_results.find(".active-result").first()))) return this.result_do_highlight(e);
            }, n.prototype.no_results = function (e) {
              var n;
              return n = t('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>'), n.find("span").first().html(e), this.search_results.append(n);
            }, n.prototype.no_results_clear = function () {
              return this.search_results.find(".no-results").remove();
            }, n.prototype.keydown_arrow = function () {
              var e;
              return this.results_showing && this.result_highlight ? (e = this.result_highlight.nextAll("li.active-result").first()) ? this.result_do_highlight(e) : void 0 : this.results_show();
            }, n.prototype.keyup_arrow = function () {
              var e;
              return this.results_showing || this.is_multiple ? this.result_highlight ? (e = this.result_highlight.prevAll("li.active-result"), e.length ? this.result_do_highlight(e.first()) : (this.choices_count() > 0 && this.results_hide(), this.result_clear_highlight())) : void 0 : this.results_show();
            }, n.prototype.keydown_backstroke = function () {
              var e;
              return this.pending_backstroke ? (this.choice_destroy(this.pending_backstroke.find("a").first()), this.clear_backstroke()) : (e = this.search_container.siblings("li.search-choice").last(), e.length && !e.hasClass("search-choice-disabled") ? (this.pending_backstroke = e, this.single_backstroke_delete ? this.keydown_backstroke() : this.pending_backstroke.addClass("search-choice-focus")) : void 0);
            }, n.prototype.clear_backstroke = function () {
              return this.pending_backstroke && this.pending_backstroke.removeClass("search-choice-focus"), this.pending_backstroke = null;
            }, n.prototype.keydown_checker = function (e) {
              var t, n;

              switch (t = null != (n = e.which) ? n : e.keyCode, this.search_field_scale(), 8 !== t && this.pending_backstroke && this.clear_backstroke(), t) {
                case 8:
                  this.backstroke_length = this.search_field.val().length;
                  break;

                case 9:
                  this.results_showing && !this.is_multiple && this.result_select(e), this.mouse_on_container = !1;
                  break;

                case 13:
                  e.preventDefault();
                  break;

                case 38:
                  e.preventDefault(), this.keyup_arrow();
                  break;

                case 40:
                  e.preventDefault(), this.keydown_arrow();
              }
            }, n.prototype.search_field_scale = function () {
              var e, n, r, o, i, a, s;

              if (this.is_multiple) {
                for (0, i = 0, r = "position:absolute; left: -1000px; top: -1000px; display:none;", o = ["font-size", "font-style", "font-weight", "font-family", "line-height", "text-transform", "letter-spacing"], a = 0, s = o.length; a < s; a++) {
                  n = o[a], r += n + ":" + this.search_field.css(n) + ";";
                }

                return e = t("<div></div>", {
                  style: r
                }), e.text(this.search_field.val()), t("body").append(e), i = e.width() + 25, e.remove(), this.f_width || (this.f_width = this.container.outerWidth()), i > this.f_width - 10 && (i = this.f_width - 10), this.search_field.css({
                  width: i + "px"
                });
              }
            }, n.prototype.generate_random_id = function () {
              var e;

              for (e = "sel" + this.generate_random_char() + this.generate_random_char() + this.generate_random_char(); t("#" + e).length > 0;) {
                e += this.generate_random_char();
              }

              return e;
            }, n;
          }(s), r.Chosen = n;
        }.call(this);
      }.apply(t, r)) && (e.exports = o);
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(2)),
          i = r(n(0)),
          a = r(n(13)),
          s = r(n(9)),
          l = r(n(80)),
          u = s.default.extend({
        className: "array-input",
        template: o.default.template({
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, o) {
            var i = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<a href="#" class="array-inputs-button link-button">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
              name: "i18n",
              hash: {
                bundle: "courage",
                code: "oform.add.another"
              },
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 52
                },
                end: {
                  line: 1,
                  column: 102
                }
              }
            })) + "</a>";
          },
          useData: !0
        }),
        params: {
          itemType: "string"
        },
        events: {
          "click .array-inputs-button": function clickArrayInputsButton(e) {
            e.preventDefault(), this.isEditMode() && this.addNewElement();
          }
        },
        initialize: function initialize(e) {
          e || (e = {}), this.params = i.default.defaults(e.params || {}, this.params), this.uniqueIdPrefix = "array";
        },
        from: function from(e) {
          return i.default.isArray(e) ? e : [];
        },
        editMode: function editMode() {
          return this._setArrayObject(), this.$el.html(this.template), i.default.each(this.arrayObject, i.default.bind(this._addDeletableBox, this)), this;
        },
        readMode: function readMode() {
          this.editMode(), this.$(".array-inputs-button").addClass("link-button-disabled");
        },
        val: function val() {
          var e = i.default.values(this.arrayObject);
          return i.default.contains([a.default.DATATYPE.number, a.default.DATATYPE.integer], this.params.itemType) && (e = i.default.filter(e, i.default.isNumber)), e;
        },
        focus: function focus() {},
        addNewElement: function addNewElement() {
          var e = i.default.uniqueId(this.uniqueIdPrefix);
          this.arrayObject[e] = "", this._addDeletableBox("", e), this.update();
        },
        _addDeletableBox: function _addDeletableBox(e, t) {
          var n = new l.default(i.default.extend(i.default.pick(this.options, "read", "readOnly", "model"), {
            key: t,
            value: e,
            itemType: this.params.itemType
          }));
          return this.listenTo(n, "updateArray", function (e) {
            i.default.isNull(e) ? (delete this.arrayObject[t], this.stopListening(n)) : this.arrayObject[t] = e, this.update();
          }), n.render().$el.hide(), this.$(".array-inputs-button").before(n.el), n.$el.slideDown(), n;
        },
        _setArrayObject: function _setArrayObject() {
          var e = this.model.get(this.options.name);

          if (this.arrayObject = {}, i.default.isArray(e) && !i.default.isEmpty(e)) {
            var t = [],
                n = this;
            (0, i.default)(e.length).times(function () {
              t.push(i.default.uniqueId(n.uniqueIdPrefix));
            }), this.arrayObject = i.default.object(t, e);
          }
        }
      });
      t.default = u, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        "@babel/helpers - typeof";

        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;

      var i = r(n(2)),
          a = r(n(0)),
          s = r(n(13)),
          l = r(n(4)),
          u = r(n(32)),
          c = r(n(1)),
          d = function d(e) {
        return /^[aeiou]/.test(e);
      },
          f = function f(e) {
        return d(e) ? "an" : "a";
      },
          p = i.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = "function",
              c = e.escapeExpression,
              d = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="o-form-input-group-controls"><span class="input-fix o-form-control"><input type="text" class="o-form-text" name="' + c((a = null != (a = d(n, "key") || (null != t ? d(t, "key") : t)) ? a : l, o(a) === u ? a.call(s, {
            name: "key",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 125
              },
              end: {
                line: 1,
                column: 132
              }
            }
          }) : a)) + '" id="' + c((a = null != (a = d(n, "key") || (null != t ? d(t, "key") : t)) ? a : l, o(a) === u ? a.call(s, {
            name: "key",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 138
              },
              end: {
                line: 1,
                column: 145
              }
            }
          }) : a)) + '" value="' + c((a = null != (a = d(n, "value") || (null != t ? d(t, "value") : t)) ? a : l, o(a) === u ? a.call(s, {
            name: "value",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 154
              },
              end: {
                line: 1,
                column: 163
              }
            }
          }) : a)) + '" placeholder="' + c((a = null != (a = d(n, "placeholder") || (null != t ? d(t, "placeholder") : t)) ? a : l, o(a) === u ? a.call(s, {
            name: "placeholder",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 178
              },
              end: {
                line: 1,
                column: 193
              }
            }
          }) : a)) + '"/></span><a href="#" class="link-button link-button-icon icon-only"><span class="icon clear-input-16 "></span></a></div><p class="o-form-input-error o-form-explain"><span class="icon icon-16 error-16-small"></span>' + c((a = null != (a = d(n, "errorExplain") || (null != t ? d(t, "errorExplain") : t)) ? a : l, o(a) === u ? a.call(s, {
            name: "errorExplain",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 408
              },
              end: {
                line: 1,
                column: 424
              }
            }
          }) : a)) + "</p>";
        },
        useData: !0
      }),
          h = c.default.extend({
        tagName: "div",
        className: "o-form-input-group",
        events: {
          "click a": function clickA(e) {
            e.preventDefault(), this.remove();
          },
          "keyup input": function keyupInput() {
            this.update();
          }
        },
        isEditMode: function isEditMode() {
          return !this.options.readOnly && (!0 !== this.options.read || !0 === this.model.get("__edit__"));
        },
        initialize: function initialize() {
          this.template = p(a.default.extend(this.options, {
            placeholder: this.getPlaceholderText(),
            errorExplain: this.getErrorExplainText()
          })), this.update = a.default.debounce(this.update, this.options.debounceDelay || u.default.DEBOUNCE_DELAY);
        },
        render: function render() {
          return this.isEditMode() ? this.$el.html(this.template) : (this.$el.text(this.options.value), this.$("a").hide()), this;
        },
        remove: function remove() {
          var e = arguments,
              t = this;
          this.trigger("updateArray", null), this.$el.slideUp(function () {
            c.default.prototype.remove.call(t, e);
          });
        },
        update: function update() {
          var e = this.$("input").val(),
              t = a.default.object([s.default.DATATYPE.number, s.default.DATATYPE.integer], [l.default.parseFloat, this.parseInt]);
          a.default.has(t, this.options.itemType) && (e = t[this.options.itemType](e), a.default.isNumber(e) ? this.clearInvalid() : this.markInvalid()), this.trigger("updateArray", e);
        },
        markInvalid: function markInvalid() {
          this.$el.addClass("o-form-has-errors");
        },
        clearInvalid: function clearInvalid() {
          this.$el.removeClass("o-form-has-errors");
        },
        getPlaceholderText: function getPlaceholderText() {
          var e = ["Enter"];
          return e.push(f(this.options.itemType)), e.push(this.options.itemType.toLowerCase()), e.join(" ");
        },
        getErrorExplainText: function getErrorExplainText() {
          var e = ["Value must be"];
          return e.push(f(this.options.itemType)), e.push(this.options.itemType.toLowerCase()), e.join(" ");
        },
        parseInt: function (e) {
          function t(t) {
            return e.apply(this, arguments);
          }

          return t.toString = function () {
            return e.toString();
          }, t;
        }(function (e) {
          if (/^-?\d+$/.test(e)) {
            var t = parseInt(e, 10);
            return a.default.isNaN(t) ? e : t;
          }

          return e;
        })
      });

      t.default = h, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        "@babel/helpers - typeof";

        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var i = r(n(2)),
          a = r(n(0)),
          s = r(n(8));
      n(33);
      var l = r(n(9)),
          u = l.default.extend({
        template: i.default.template({
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, i) {
            var a,
                s = null != t ? t : e.nullContext || {},
                l = e.hooks.helperMissing,
                u = "function",
                c = e.escapeExpression,
                d = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<input type="checkbox" name="' + c((a = null != (a = d(n, "name") || (null != t ? d(t, "name") : t)) ? a : l, o(a) === u ? a.call(s, {
              name: "name",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 29
                },
                end: {
                  line: 1,
                  column: 37
                }
              }
            }) : a)) + '" id="' + c((a = null != (a = d(n, "inputId") || (null != t ? d(t, "inputId") : t)) ? a : l, o(a) === u ? a.call(s, {
              name: "inputId",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 43
                },
                end: {
                  line: 1,
                  column: 54
                }
              }
            }) : a)) + '"/><label for="' + c((a = null != (a = d(n, "inputId") || (null != t ? d(t, "inputId") : t)) ? a : l, o(a) === u ? a.call(s, {
              name: "inputId",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 69
                },
                end: {
                  line: 1,
                  column: 80
                }
              }
            }) : a)) + '" data-se-for-name="' + c((a = null != (a = d(n, "name") || (null != t ? d(t, "name") : t)) ? a : l, o(a) === u ? a.call(s, {
              name: "name",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 100
                },
                end: {
                  line: 1,
                  column: 108
                }
              }
            }) : a)) + '">' + c((a = null != (a = d(n, "placeholder") || (null != t ? d(t, "placeholder") : t)) ? a : l, o(a) === u ? a.call(s, {
              name: "placeholder",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 110
                },
                end: {
                  line: 1,
                  column: 125
                }
              }
            }) : a)) + "</label>";
          },
          useData: !0
        }),
        events: {
          "change :checkbox": "update",
          keyup: function keyup(e) {
            e.preventDefault(), s.default.isSpaceBar(e) ? this.$(":checkbox").click() : s.default.isEnter(e) && this.model.trigger("form:save");
          }
        },
        editMode: function editMode() {
          var e = a.default.resultCtx(this.options, "placeholder", this);
          return "" === e ? e = a.default.resultCtx(this.options, "label", this) : !1 === e && (e = ""), this.$el.html(this.template(a.default.extend(a.default.omit(this.options, "placeholder"), {
            placeholder: e
          }))), this.$(":checkbox").prop("checked", this.getModelValue() || !1), this.$("input").customInput(), this.model.trigger("form:resize"), this;
        },
        readMode: function readMode() {
          return this.editMode(), this.$(":checkbox").prop("disabled", !0), this;
        },
        val: function val() {
          return this.$(":checkbox").prop("checked");
        },
        focus: function focus() {
          return this.$(":checkbox").focus();
        }
      });
      t.default = u, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var o = r(n(2)),
          i = r(n(0)),
          a = r(n(34)),
          s = o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          return '<span class="password-toggle"><span class="eyeicon visibility-16 button-show"></span><span class="eyeicon visibility-off-16 button-hide"></span></span>';
        },
        useData: !0
      }),
          l = a.default.extend({
        initialize: function initialize() {
          this.__showPasswordToggle() && (this.events["click .password-toggle .button-show"] = "__showPassword", this.events["click .password-toggle .button-hide"] = "__hidePassword"), this.delegateEvents();
        },
        postRender: function postRender() {
          this.isEditMode() && this.__showPasswordToggle() && (this.$el.append(s), this.$el.find('input[type="password"]').addClass("password-with-toggle")), a.default.prototype.postRender.apply(this, arguments);
        },
        __showPasswordToggle: function __showPasswordToggle() {
          return this.options.params && this.options.params.showPasswordToggle;
        },
        __showPassword: function __showPassword() {
          var e = this;
          a.default.prototype.changeType.apply(this, ["text"]), this.$(".password-toggle .button-show").hide(), this.$(".password-toggle .button-hide").show(), this.passwordToggleTimer = i.default.delay(function () {
            e.__hidePassword();
          }, 3e4);
        },
        __hidePassword: function __hidePassword() {
          a.default.prototype.changeType.apply(this, ["password"]), this.$(".password-toggle .button-show").show(), this.$(".password-toggle .button-hide").hide(), this.passwordToggleTimer && clearTimeout(this.passwordToggleTimer);
        }
      });
      t.default = l, e.exports = t.default;
    }, function (e, t, n) {
      var r, o;
      r = [n(12)], void 0 !== (o = function (e) {
        function t(t) {
          var n = {},
              r = /^jQuery\d+$/;
          return e.each(t.attributes, function (e, t) {
            t.specified && !r.test(t.name) && (n[t.name] = t.value);
          }), n;
        }

        function n(t, n) {
          var r = this,
              o = e(r);
          if (r.value == o.attr("placeholder") && o.hasClass("placeholder")) if (o.data("placeholder-password")) {
            if (o = o.hide().next().show().attr("id", o.removeAttr("id").data("placeholder-id")), !0 === t) return o[0].value = n;
            o.focus();
          } else r.value = "", o.removeClass("placeholder"), r == document.activeElement && r.select();
        }

        function r() {
          var r,
              o = this,
              i = e(o),
              a = this.id;

          if ("" == o.value) {
            if ("password" == o.type) {
              if (!i.data("placeholder-textinput")) {
                try {
                  r = i.clone().attr({
                    type: "text"
                  });
                } catch (n) {
                  r = e("<input>").attr(e.extend(t(this), {
                    type: "text"
                  }));
                }

                r.removeAttr("name").data({
                  "placeholder-password": !0,
                  "placeholder-id": a
                }).bind("focus.placeholder", n), i.data({
                  "placeholder-textinput": r,
                  "placeholder-id": a
                }).before(r);
              }

              i = i.removeAttr("id").hide().prev().attr("id", a).show();
            }

            i.addClass("placeholder"), i[0].value = i.attr("placeholder");
          } else i.removeClass("placeholder");
        }

        var o,
            i,
            a = "placeholder" in document.createElement("input"),
            s = "placeholder" in document.createElement("textarea"),
            l = e.fn,
            u = e.valHooks;
        a && s ? (i = l.placeholder = function () {
          return this;
        }, i.input = i.textarea = !0) : (i = l.placeholder = function () {
          var e = this;
          return e.filter((a ? "textarea" : ":input") + "[placeholder]").not(".placeholder").bind({
            "focus.placeholder": n,
            "blur.placeholder": r
          }).data("placeholder-enabled", !0).trigger("blur.placeholder"), e;
        }, i.input = a, i.textarea = s, o = {
          get: function get(t) {
            var n = e(t);
            return n.data("placeholder-enabled") && n.hasClass("placeholder") ? "" : t.value;
          },
          set: function set(t, o) {
            var i = e(t);
            return i.data("placeholder-enabled") ? ("" == o ? (t.value = o, t != document.activeElement && r.call(t)) : i.hasClass("placeholder") ? n.call(t, !0, o) || (t.value = o) : t.value = o, i) : t.value = o;
          }
        }, a || (u.input = o), s || (u.textarea = o), e(function () {
          e(document).delegate("form", "submit.placeholder", function () {
            var t = e(".placeholder", this).each(n);
            setTimeout(function () {
              t.each(r);
            }, 10);
          });
        }), e(window).bind("beforeunload.placeholder", function () {
          e(".placeholder").each(function () {
            this.value = "";
          });
        }));
      }.apply(t, r)) && (e.exports = o);
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        "@babel/helpers - typeof";

        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var i = r(n(2)),
          a = r(n(3)),
          s = r(n(0)),
          l = r(n(8)),
          u = r(n(19)),
          c = r(n(1));
      n(33);
      var d = r(n(9)),
          f = u.default.isABaseView,
          p = c.default.extend({
        template: i.default.template({
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, i) {
            var a,
                s = null != t ? t : e.nullContext || {},
                l = e.hooks.helperMissing,
                u = "function",
                c = e.escapeExpression,
                d = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<input type="radio" name="' + c((a = null != (a = d(n, "name") || (null != t ? d(t, "name") : t)) ? a : l, o(a) === u ? a.call(s, {
              name: "name",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 26
                },
                end: {
                  line: 1,
                  column: 34
                }
              }
            }) : a)) + '" data-se-name="' + c((a = null != (a = d(n, "realName") || (null != t ? d(t, "realName") : t)) ? a : l, o(a) === u ? a.call(s, {
              name: "realName",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 50
                },
                end: {
                  line: 1,
                  column: 62
                }
              }
            }) : a)) + '" value="' + c((a = null != (a = d(n, "value") || (null != t ? d(t, "value") : t)) ? a : l, o(a) === u ? a.call(s, {
              name: "value",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 71
                },
                end: {
                  line: 1,
                  column: 80
                }
              }
            }) : a)) + '" id="' + c((a = null != (a = d(n, "optionId") || (null != t ? d(t, "optionId") : t)) ? a : l, o(a) === u ? a.call(s, {
              name: "optionId",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 86
                },
                end: {
                  line: 1,
                  column: 98
                }
              }
            }) : a)) + '"><label for="' + c((a = null != (a = d(n, "optionId") || (null != t ? d(t, "optionId") : t)) ? a : l, o(a) === u ? a.call(s, {
              name: "optionId",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 112
                },
                end: {
                  line: 1,
                  column: 124
                }
              }
            }) : a)) + '" data-se-for-name="' + c((a = null != (a = d(n, "realName") || (null != t ? d(t, "realName") : t)) ? a : l, o(a) === u ? a.call(s, {
              name: "realName",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 144
                },
                end: {
                  line: 1,
                  column: 156
                }
              }
            }) : a)) + '" class="radio-label">' + c((a = null != (a = d(n, "label") || (null != t ? d(t, "label") : t)) ? a : l, o(a) === u ? a.call(s, {
              name: "label",
              hash: {},
              data: i,
              loc: {
                start: {
                  line: 1,
                  column: 178
                },
                end: {
                  line: 1,
                  column: 187
                }
              }
            }) : a)) + "</label>";
          },
          useData: !0
        }),
        initialize: function initialize(e) {
          var t;
          t = e.explain, s.default.isFunction(t) && !f(t) && (t = s.default.resultCtx(this.options, "explain", this)), t && (f(t) ? (this.add('<p class="o-form-explain"></p>', ".radio-label"), this.add(t, ".o-form-explain")) : this.add(c.default.extend({
            className: "o-form-explain",
            tagName: "p",
            template: i.default.template({
              compiler: [8, ">= 4.3.0"],
              main: function main(e, t, n, r, o) {
                var i,
                    a = e.lookupProperty || function (e, t) {
                  if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                };

                return e.escapeExpression((i = null != (i = a(n, "explain") || (null != t ? a(t, "explain") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
                  name: "explain",
                  hash: {},
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 0
                    },
                    end: {
                      line: 1,
                      column: 11
                    }
                  }
                }) : i));
              },
              useData: !0
            })
          }), ".radio-label"));
        }
      }),
          h = d.default.extend({
        events: {
          "change :radio": "update",
          keyup: function keyup(e) {
            l.default.isSpaceBar(e) ? (0, a.default)(e.target).click() : l.default.isEnter(e) && this.model.trigger("form:save");
          }
        },
        editMode: function editMode() {
          var e = [];
          this.$el.empty(), s.default.each(this.options.options, function (t, n) {
            var r = {
              optionId: s.default.uniqueId("option"),
              name: this.options.inputId,
              realName: this.options.name,
              value: n
            };
            s.default.isObject(t) || (t = {
              label: t
            }), s.default.extend(r, t), e.push(new p(r).render().el);
          }, this), this.$el.append(e);
          var t = this.getModelValue();
          return t && this.$(":radio[value=" + t + "]").prop("checked", !0), this.$("input").customInput(), this.model.trigger("form:resize"), !0 === this.getParam("inline") && this.$("div.custom-radio").addClass("inline"), this;
        },
        readMode: function readMode() {
          return this.editMode(), this.$(":radio").prop("disabled", !0), this;
        },
        val: function val() {
          return this.$(":radio:checked").val();
        },
        focus: function focus() {
          return this.$("label:eq(0)").focus();
        }
      });
      t.default = h, e.exports = t.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        return a.default.filter(e || [], function (e) {
          return !a.default.contains(["label", "button", "select"], e.type);
        }).length;
      }

      function i(e) {
        return s.default.create(a.default.defaults({
          getReadModeString: a.default.constant(" "),
          focus: a.default.noop
        }, a.default.pick(e, "click", "title", "href", "icon")));
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var a = r(n(0)),
          s = r(n(18)),
          l = r(n(1)),
          u = r(n(9)),
          c = u.default.extend({
        tagName: "span",
        initialize: function initialize() {
          this.$el.text(this.getModelValue());
        },
        editMode: function editMode() {
          this.toggle(!0);
        },
        readMode: function readMode() {
          this.toggle(!1);
        },
        getModelValue: function getModelValue() {
          return this.options.label;
        },
        toggle: function toggle(e) {
          this.$el.toggleClass("o-form-label-inline", e), this.$el.toggleClass("o-form-control", !e);
        },
        focus: a.default.noop
      }),
          d = l.default.extend({
        getParams: u.default.prototype.getParams,
        getParam: u.default.prototype.getParam,
        className: function className() {
          var e;
          return e = "text" === this.getParam("display") ? "o-form-input-group-subtle" : "o-form-input-group", o(this.getParam("inputs")) > 1 && (e += " o-form-input-group-2"), e;
        },
        initialize: function initialize() {
          a.default.each(this.getParam("inputs"), function (e) {
            switch (e.type) {
              case "label":
                this.add(c, {
                  options: e
                });
                break;

              case "button":
                this.add(i(e));
                break;

              default:
                e = a.default.defaults({
                  model: this.model,
                  params: a.default.extend({
                    autoWidth: !0
                  }, e.params || {})
                }, e), this.add(this.getParams().create(e));
            }
          }, this);
        },
        focus: function focus() {
          this.first().focus();
        }
      }),
          f = u.default.extend({
        constructor: function constructor(e) {
          this.inputGroupView = new d(e), u.default.apply(this, arguments);
        },
        editMode: function editMode() {
          this.inputGroupView.remove(), this.inputGroupView = new d(this.options), this.$el.html(this.inputGroupView.render().el);
        },
        toStringValue: function toStringValue() {
          var e = this.inputGroupView.map(function (e) {
            return e.getReadModeString();
          });
          return e.length && a.default.every(e) ? e.join(" ") : " ";
        },
        focus: function focus() {
          this.inputGroupView.focus();
        }
      }, {
        LabelInput: c,
        InputGroupView: d
      });
      t.default = f, e.exports = t.default;
    }, function (e, t, n) {
      var r = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n(3));

      r.default.fn.scrollParent = function (e) {
        var t = this.css("position"),
            n = "absolute" === t,
            o = e ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
            i = this.parents().filter(function () {
          var e = (0, r.default)(this);
          return (!n || "static" !== e.css("position")) && o.test(e.css("overflow") + e.css("overflow-y") + e.css("overflow-x"));
        }).eq(0);
        return "fixed" !== t && i.length ? i : (0, r.default)(this[0].ownerDocument || document);
      };
    }]);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function o(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    }

    function i() {
      var e = new s.HandlebarsEnvironment();
      return p.extend(e, s), e.SafeString = u.default, e.Exception = d.default, e.Utils = p, e.escapeExpression = p.escapeExpression, e.VM = m, e.template = function (t) {
        return m.template(t, e);
      }, e;
    }

    t.__esModule = !0;
    var a = n(245),
        s = o(a),
        l = n(465),
        u = r(l),
        c = n(56),
        d = r(c),
        f = n(41),
        p = o(f),
        h = n(466),
        m = o(h),
        g = n(468),
        v = r(g),
        y = i();
    y.create = i, v.default(y), y.default = y, t.default = y, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "BaseHeader", {
      enumerable: !0,
      get: function get() {
        return o.default;
      }
    }), Object.defineProperty(t, "BaseFooter", {
      enumerable: !0,
      get: function get() {
        return i.default;
      }
    }), Object.defineProperty(t, "BaseForm", {
      enumerable: !0,
      get: function get() {
        return a.default;
      }
    }), Object.defineProperty(t, "BaseFormWithPolling", {
      enumerable: !0,
      get: function get() {
        return s.default;
      }
    }), Object.defineProperty(t, "BaseModel", {
      enumerable: !0,
      get: function get() {
        return l.default;
      }
    }), Object.defineProperty(t, "BaseView", {
      enumerable: !0,
      get: function get() {
        return u.default;
      }
    }), Object.defineProperty(t, "addCustomButton", {
      enumerable: !0,
      get: function get() {
        return c.addCustomButton;
      }
    }), Object.defineProperty(t, "createCustomButtons", {
      enumerable: !0,
      get: function get() {
        return c.createCustomButtons;
      }
    }), Object.defineProperty(t, "createIdpButtons", {
      enumerable: !0,
      get: function get() {
        return c.createIdpButtons;
      }
    });
    var o = r(n(358)),
        i = r(n(359)),
        a = r(n(137)),
        s = r(n(362)),
        l = r(n(363)),
        u = r(n(777)),
        c = n(360);
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(93)),
        a = r(n(73)),
        s = r(n(6)),
        l = o.internal.views.forms.components.Toolbar,
        u = o.internal.views.forms.helpers.FormUtil,
        c = o.Form.extend({
      layout: "o-form-theme",
      noCancelButton: !0,
      constructor: function constructor(e) {
        o.Form.call(this, e), o._.each(o._.result(this, "formChildren") || [], function (e) {
          switch (e.type) {
            case s.default.INPUT:
              this.addInput(o._.extend({
                label: !1,
                "label-top": !0
              }, e.viewOptions));
              break;

            case s.default.BUTTON:
              this.add((0, o.createButton)(o._.extend({
                model: this.model
              }, e.viewOptions)), e.addOptions), u.applyShowWhen(this.last(), e.viewOptions && e.viewOptions.showWhen);
              break;

            case s.default.DIVIDER:
              this.addDivider(e.viewOptions);
              break;

            case s.default.TOOLBAR:
              this.add(l, {
                options: e.viewOptions
              }), u.applyShowWhen(this.last(), e.viewOptions && e.viewOptions.showWhen);
              break;

            case s.default.VIEW:
              this.add(e.viewOptions.View, e.addOptions), u.applyShowWhen(this.last(), e.viewOptions.showWhen);
              break;

            default:
              throw new Error("Unrecognized child type: " + e.type);
          }
        }, this);
      }
    }),
        d = a.default.extend({
      constructor: function constructor() {
        var e = this.initialize;

        if (this.initialize = function () {}, a.default.apply(this, arguments), this.Model && this.Form) {
          var t = i.default.extend(o._.extend({
            parse: function parse(e) {
              return this.settings = e.settings, this.appState = e.appState, o._.omit(e, ["settings", "appState"]);
            }
          }, o._.result(this, "Model")));
          this.model = new t({
            settings: this.settings,
            appState: this.options.appState
          }, {
            parse: !0
          });
          var n = c.extend(o._.result(this, "Form", this));
          this.form = new n(this.toJSON()), this.add(this.form);
        }

        this.Footer && this.addFooter(this.Footer), this.addListeners(), e.apply(this, arguments);
      },
      addFooter: function addFooter(e, t) {
        this.footer = new e(o._.extend(this.toJSON(), t || {})), this.add(this.footer);
      },
      toJSON: function toJSON() {
        var e = a.default.prototype.toJSON.apply(this, arguments);
        return o._.extend(o._.pick(this.options, "appState"), e);
      },
      back: function back() {
        this.footer && this.footer.back && this.footer.back();
      }
    });
    t.default = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = {
      API_RATE_LIMIT: 3e4,
      WIDGET_LOGIN_CONTAINER_ID: "okta-login-container",
      WIDGET_CONTAINER_ID: "okta-sign-in",
      WIDGET_CONFIG_COLORS_ID: "okta-sign-in-config-colors",
      DIRECTION_BACK: "DIRECTION_BACK",
      RECOVERY_TYPE_PASSWORD: "PASSWORD",
      RECOVERY_TYPE_UNLOCK: "UNLOCK",
      RECOVERY_FACTOR_TYPE_SMS: "SMS",
      RECOVERY_FACTOR_TYPE_EMAIL: "EMAIL",
      RECOVERY_FACTOR_TYPE_CALL: "CALL",
      IOS: "ios",
      ANDROID: "android",
      ODA: "oda",
      MDM: "mdm",
      SUCCESS: "SUCCESS",
      FORGOT_PASSWORD_EMAIL_SENT: "FORGOT_PASSWORD_EMAIL_SENT",
      UNLOCK_ACCOUNT_EMAIL_SENT: "UNLOCK_ACCOUNT_EMAIL_SENT",
      CONFIG_ERROR: "CONFIG_ERROR",
      UNSUPPORTED_BROWSER_ERROR: "UNSUPPORTED_BROWSER_ERROR",
      OAUTH_ERROR: "OAUTH_ERROR",
      AUTH_STOP_POLL_INITIATION_ERROR: "AUTH_STOP_POLL_INITIATION_ERROR",
      U2F_ERROR: "U2F_ERROR",
      WEB_AUTHN_ERROR: "WEB_AUTHN_ERROR",
      WEBAUTHN_ABORT_ERROR: "WEBAUTHN_ABORT_ERROR",
      ALL_OPTIONAL_NONE_ENROLLED: "ALL_OPTIONAL_NONE_ENROLLED",
      ALL_OPTIONAL_SOME_ENROLLED: "ALL_OPTIONAL_SOME_ENROLLED",
      HAS_REQUIRED_NONE_ENROLLED: "HAS_REQUIRED_NONE_ENROLLED",
      HAS_REQUIRED_SOME_REQUIRED_ENROLLED: "HAS_REQUIRED_SOME_REQUIRED_ENROLLED",
      HAS_REQUIRED_ALL_REQUIRED_ENROLLED: "HAS_REQUIRED_ALL_REQUIRED_ENROLLED",
      PRIMARY_AUTH: "PRIMARY_AUTH",
      FORGOT_PASSWORD: "FORGOT_PASSWORD",
      UNLOCK_ACCOUNT: "UNLOCK_ACCOUNT",
      SESSION_SSO: "SESSION_SSO",
      SESSION_STEP_UP: "SESSION_STEP_UP",
      ACTIVATION_EMAIL_SENT: "ACTIVATION_EMAIL_SENT",
      REGISTRATION_COMPLETE: "REGISTRATION_COMPLETE",
      REGISTRATION_FAILED: "REGISTRATION_FAILED",
      IDP_DISCOVERY: "IDP_DISCOVERY",
      OKTA_VERIFY_APPLE_APP_STORE_URL: "https://apps.apple.com/us/app/okta-verify/id490179405",
      OKTA_VERIFY_GOOGLE_PLAY_STORE_URL: "https://play.google.com/store/apps/details?id=com.okta.android.auth",
      LOOPBACK_CHALLENGE: "LOOPBACK",
      CUSTOM_URI_CHALLENGE: "CUSTOM_URI",
      UNIVERSAL_LINK_CHALLENGE: "UNIVERSAL_LINK"
    };
    t.default = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function (t, n) {
        return {
          type: e,
          viewOptions: t,
          addOptions: n
        };
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = {
      Input: r("INPUT"),
      Button: r("BUTTON"),
      Divider: r("DIVIDER"),
      Toolbar: r("TOOLBAR"),
      View: r("VIEW"),
      INPUT: "INPUT",
      BUTTON: "BUTTON",
      DIVIDER: "DIVIDER",
      TOOLBAR: "TOOLBAR",
      VIEW: "VIEW"
    };
    t.default = o;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.BaseAuthenticatorBeacon = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(369)),
        s = r(n(783)),
        l = n(108),
        u = s.default.extend({
      authenticatorKey: function authenticatorKey() {
        return this.options.appState.get("authenticatorKey");
      },
      getBeaconClassName: function getBeaconClassName() {
        var e = o._.result(this, "authenticatorKey");

        return (0, l.getIconClassNameForBeacon)(e);
      }
    });
    t.BaseAuthenticatorBeacon = u;
    var c = i.BaseView.extend({
      Header: i.BaseHeader.extend({
        HeaderBeacon: u
      }),
      Footer: a.default
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TERMINAL_FORMS = t.HINTS = t.FORM_NAME_TO_OPERATION_MAP = t.AUTHENTICATOR_METHODS = t.AUTHENTICATOR_KEY = t.FORMS_FOR_VERIFICATION = t.FORMS_WITH_STATIC_BACK_LINK = t.FORMS_WITHOUT_SIGNOUT = t.FORMS = t.ACTIONS = void 0;
    var o,
        i = r(n(42)),
        a = r(n(5)),
        s = {
      IDENTIFY: "identify",
      SELECT_IDENTIFY: "select-identify",
      IDENTIFY_RECOVERY: "identify-recovery",
      SELECT_ENROLL_PROFILE: "select-enroll-profile",
      ENROLL_PROFILE: "enroll-profile",
      UNLOCK_ACCOUNT: "unlock-account",
      CONSENT_ADMIN: "admin-consent",
      CONSENT_ENDUSER: "consent",
      CONSENT_EMAIL_CHALLENGE: "email-challenge-consent",
      SELECT_AUTHENTICATOR_AUTHENTICATE: "select-authenticator-authenticate",
      SELECT_AUTHENTICATOR_UNLOCK: "select-authenticator-unlock-account",
      AUTHENTICATOR_VERIFICATION_DATA: "authenticator-verification-data",
      CHALLENGE_AUTHENTICATOR: "challenge-authenticator",
      CHALLENGE_POLL: "challenge-poll",
      RESEND: "resend",
      SELECT_AUTHENTICATOR_ENROLL: "select-authenticator-enroll",
      SELECT_AUTHENTICATOR_ENROLL_DATA: "select-authenticator-enroll-data",
      AUTHENTICATOR_ENROLLMENT_DATA: "authenticator-enrollment-data",
      ENROLL_AUTHENTICATOR: "enroll-authenticator",
      SELECT_ENROLLMENT_CHANNEL: "select-enrollment-channel",
      ENROLLMENT_CHANNEL_DATA: "enrollment-channel-data",
      ENROLL_POLL: "enroll-poll",
      REENROLL_AUTHENTICATOR: "reenroll-authenticator",
      REENROLL_AUTHENTICATOR_WARNING: "reenroll-authenticator-warning",
      RESET_AUTHENTICATOR: "reset-authenticator",
      SKIP: "skip",
      POLL: "poll",
      FAILURE_REDIRECT: "failure-redirect",
      SUCCESS_REDIRECT: "success-redirect",
      REDIRECT_IDP: "redirect-idp",
      DEVICE_CHALLENGE_POLL: "device-challenge-poll",
      DEVICE_APPLE_SSO_EXTENSION: "device-apple-sso-extension",
      CANCEL_TRANSACTION: "cancel-transaction",
      LAUNCH_AUTHENTICATOR: "launch-authenticator",
      DEVICE_ENROLLMENT_TERMINAL: "device-enrollment-terminal",
      USER_CODE: "user-code",
      TERMINAL: "terminal"
    };
    t.FORMS = s;
    var l = [s.IDENTIFY, s.SUCCESS_REDIRECT, s.ENROLL_PROFILE, s.REDIRECT_IDP, s.DEVICE_ENROLLMENT_TERMINAL, s.CONSENT_ADMIN, s.CONSENT_ENDUSER, s.CONSENT_EMAIL_CHALLENGE, s.USER_CODE];
    t.FORMS_WITHOUT_SIGNOUT = l;
    var u = [s.SELECT_AUTHENTICATOR_ENROLL, s.SELECT_AUTHENTICATOR_AUTHENTICATE];
    t.FORMS_WITH_STATIC_BACK_LINK = u;
    var c = [s.SELECT_AUTHENTICATOR_AUTHENTICATE, s.CHALLENGE_AUTHENTICATOR, s.CHALLENGE_POLL, s.RESEND];
    t.FORMS_FOR_VERIFICATION = c;
    var d = {
      EMAIL: "okta_email",
      PASSWORD: "okta_password",
      PHONE: "phone_number",
      WEBAUTHN: "webauthn",
      SECURITY_QUESTION: "security_question",
      OV: "okta_verify",
      GOOGLE_OTP: "google_otp",
      ON_PREM: "onprem_mfa",
      RSA: "rsa_token",
      DUO: "duo",
      IDP: "external_idp",
      CUSTOM_OTP: "custom_otp",
      SYMANTEC_VIP: "symantec_vip"
    };
    t.AUTHENTICATOR_KEY = d;
    var f = {
      PUSH: "push"
    };
    t.AUTHENTICATOR_METHODS = f;
    var p = (o = {}, (0, i.default)(o, s.SELECT_AUTHENTICATOR_UNLOCK, a.default.UNLOCK_ACCOUNT), (0, i.default)(o, s.IDENTIFY, a.default.PRIMARY_AUTH), (0, i.default)(o, s.IDENTIFY_RECOVERY, a.default.FORGOT_PASSWORD), o);
    t.FORM_NAME_TO_OPERATION_MAP = p;
    var h = {
      ENROLLED_PASSWORD_RECOVERY_LINK: "currentAuthenticatorEnrollment-recover",
      ORG_PASSWORD_RECOVERY_LINK: "currentAuthenticator-recover"
    };
    t.ACTIONS = h;
    var m = {
      CAPTCHA: "captcha"
    };
    t.HINTS = m;
    var g = [s.TERMINAL, s.DEVICE_ENROLLMENT_TERMINAL];
    t.TERMINAL_FORMS = g;
  }, function (e, t, n) {
    "use strict";

    var r = n(19),
        o = n(95).f,
        i = n(286),
        a = n(21),
        s = n(78),
        l = n(44),
        u = n(31),
        c = function c(e) {
      var t = function t(_t2, n, r) {
        if (this instanceof e) {
          switch (arguments.length) {
            case 0:
              return new e();

            case 1:
              return new e(_t2);

            case 2:
              return new e(_t2, n);
          }

          return new e(_t2, n, r);
        }

        return e.apply(this, arguments);
      };

      return t.prototype = e.prototype, t;
    };

    e.exports = function (e, t) {
      var n,
          d,
          f,
          p,
          h,
          m,
          g,
          v,
          y,
          b = e.target,
          _ = e.global,
          w = e.stat,
          E = e.proto,
          O = _ ? r : w ? r[b] : (r[b] || {}).prototype,
          S = _ ? a : a[b] || (a[b] = {}),
          x = S.prototype;

      for (p in t) {
        n = i(_ ? p : b + (w ? "." : "#") + p, e.forced), d = !n && O && u(O, p), m = S[p], d && (e.noTargetGet ? (y = o(O, p), g = y && y.value) : g = O[p]), h = d && g ? g : t[p], d && typeof m == typeof h || (v = e.bind && d ? s(h, r) : e.wrap && d ? c(h) : E && "function" == typeof h ? s(Function.call, h) : h, (e.sham || h && h.sham || m && m.sham) && l(v, "sham", !0), S[p] = v, E && (f = b + "Prototype", u(a, f) || l(a, f, {}), a[f][p] = h, e.real && x && !x[p] && l(x, p, h)));
      }
    };
  }, function (e, t) {
    function n(t) {
      "@babel/helpers - typeof";

      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? e.exports = n = function n(e) {
        return typeof e;
      } : e.exports = n = function n(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, n(t);
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      n.d(t, "e", function () {
        return r;
      }), n.d(t, "p", function () {
        return o;
      }), n.d(t, "a", function () {
        return i;
      }), n.d(t, "c", function () {
        return a;
      }), n.d(t, "d", function () {
        return s;
      }), n.d(t, "o", function () {
        return l;
      }), n.d(t, "q", function () {
        return u;
      }), n.d(t, "t", function () {
        return c;
      }), n.d(t, "i", function () {
        return d;
      }), n.d(t, "r", function () {
        return f;
      }), n.d(t, "s", function () {
        return p;
      }), n.d(t, "k", function () {
        return h;
      }), n.d(t, "m", function () {
        return m;
      }), n.d(t, "j", function () {
        return g;
      }), n.d(t, "l", function () {
        return v;
      }), n.d(t, "g", function () {
        return y;
      }), n.d(t, "f", function () {
        return b;
      }), n.d(t, "h", function () {
        return _;
      }), n.d(t, "n", function () {
        return w;
      }), n.d(t, "b", function () {
        return E;
      });

      var r = "1.13.1",
          o = "object" == typeof self && self.self === self && self || "object" == typeof e && e.global === e && e || Function("return this")() || {},
          i = Array.prototype,
          a = Object.prototype,
          s = "undefined" != typeof Symbol ? Symbol.prototype : null,
          l = i.push,
          u = i.slice,
          c = a.toString,
          d = a.hasOwnProperty,
          f = "undefined" != typeof ArrayBuffer,
          p = "undefined" != typeof DataView,
          h = Array.isArray,
          m = Object.keys,
          g = Object.create,
          v = f && ArrayBuffer.isView,
          y = isNaN,
          b = isFinite,
          _ = !{
        toString: null
      }.propertyIsEnumerable("toString"),
          w = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
          E = Math.pow(2, 53) - 1;
    }).call(t, n(49));
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var t = [e], n = e.split("-"); n.pop() && n.length > 0;) {
        t.push(n.join("-"));
      }

      return t;
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var i = n(1),
        a = o(n(5)),
        s = o(n(38)),
        l = o(n(25)),
        u = {},
        c = function c(e, t) {
      var n = document.createElement("input");
      return n.name = e, n.value = decodeURIComponent(t), n.type = "hidden", n;
    },
        d = function d() {
      var e = document.createElement("input");
      return e.type = "submit", e;
    },
        f = function f() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t = arguments.length > 1 ? arguments[1] : void 0,
          n = e.split("#"),
          r = n[1],
          o = (n[0] || "").split("?"),
          i = o[1],
          a = o[0];
      r && (a += "#" + r);
      var s = document.createElement("form");

      if (s.method = t, s.setAttribute("style", "display: none;"), s.action = a, i && i.length) {
        i.split("&").forEach(function (e) {
          var t = e.split("="),
              n = c(t[0], t[1]);
          s.appendChild(n);
        });
      }

      return s.appendChild(d()), s;
    };

    u.transformErrorXHR = function (e) {
      if (0 === e.status && i._.isEmpty(e.responseJSON)) return e.responseJSON = {
        errorSummary: (0, i.loc)("error.network.connection", "login")
      }, e;

      if (!e.responseJSON) {
        if (!e.responseText) return e.responseJSON = {
          errorSummary: (0, i.loc)("oform.error.unexpected", "login")
        }, e;
        e.responseJSON = e.responseText;
      }

      if (e.responseJSON && e.responseJSON.errorCauses && e.responseJSON.errorCauses.length && (e.responseJSON.errorSummary = e.responseJSON.errorCauses[0].errorSummary), !i._.isEmpty(e.responseJSON)) {
        var t = (0, i.loc)("errors." + e.responseJSON.errorCode, "login");
        -1 === t.indexOf("L10N_ERROR[") && (e.responseJSON.errorSummary = t, e.responseJSON && e.responseJSON.errorCauses && e.responseJSON.errorCauses.length && delete e.responseJSON.errorCauses);
      }

      return e;
    }, u.toLower = function (e) {
      return i._.map(e, function (e) {
        return e.toLowerCase();
      });
    }, u.expandLanguages = function (e) {
      return i._.chain(e).map(r).flatten().uniq().value();
    }, u.callAfterTimeout = function (e, t) {
      return setTimeout(e, t);
    }, u.debugMessage = function (e) {
      s.default.warn("\n".concat(e.replace(/^(\s)+/gm, "")));
    }, u.triggerAfterError = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      !t.statusCode && t.xhr && t.xhr.status && (t.statusCode = t.xhr.status);

      var n = i._.isFunction(e.className) ? e.className() : e.className,
          r = i._.pick(t, "name", "message", "statusCode", "xhr");

      e.trigger("afterError", {
        controller: n
      }, r), s.default.warn("controller: " + n + ", error: " + r);
    }, u.redirect = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window;
      if (!e) return void s.default.error("Cannot redirect to empty URL: (".concat(e, ")"));
      l.default.isAndroid() ? u.redirectWithFormGet(e) : t.location.href = e;
    }, u.redirectWithFormGet = function (e) {
      u.redirectWithForm(e, "get");
    }, u.redirectWithForm = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "post";
      if (!e) return void s.default.error("Cannot redirect to empty URL: (".concat(e, ")"));
      var n = document.getElementById(a.default.WIDGET_CONTAINER_ID);
      if (!n) return void s.default.error("Cannot find okta-sign-in container append to which a form");
      var r = f(e, t);
      n.appendChild(r), r.querySelector('input[type="submit"]').click();
    }, u.createInputExplain = function (e, t, n, r, o) {
      var a = r ? (0, i.loc)(e, n, r) : (0, i.loc)(e, n);
      return a !== (o ? (0, i.loc)(t, n, o) : (0, i.loc)(t, n)) && a;
    }, u.isV1StateToken = function (e) {
      return !!(e && i._.isString(e) && e.startsWith("00"));
    }, u.removeNils = function (e) {
      var t = {};

      for (var n in e) {
        if (Object.prototype.hasOwnProperty.call(e, n)) {
          var r = e[n];
          null !== r && void 0 !== r && (t[n] = r);
        }
      }

      return t;
    };
    var p = u;
    t.default = p;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1);
    n(114);
    var i = r(n(25)),
        a = o.internal.views.forms.inputs.TextBox,
        s = a.extend({
      postRender: function postRender() {
        if ("number" === this.options.type) {
          this.$("input").attr({
            pattern: "[0-9]*",
            inputmode: "numeric"
          });
        }

        a.prototype.postRender.apply(this, arguments);
      },
      focus: function focus() {
        if (!i.default.isIE()) return a.prototype.focus.apply(this, arguments);
      }
    });
    t.default = s;
  }, function (e, t, n) {
    var r = n(19),
        o = n(167),
        i = n(31),
        a = n(168),
        s = n(170),
        l = n(299),
        u = o("wks"),
        c = r.Symbol,
        d = l ? c : c && c.withoutSetter || a;

    e.exports = function (e) {
      return i(u, e) || (s && i(c, e) ? u[e] = c[e] : u[e] = d("Symbol." + e)), u[e];
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = n(1),
        i = r(n(480)),
        a = {},
        s = {
      OKTA_VERIFY: {
        label: "factor.totpSoft.oktaVerify",
        description: "factor.totpSoft.description",
        iconClassName: "mfa-okta-verify",
        sortOrder: 1
      },
      OKTA_VERIFY_PUSH: {
        label: "factor.oktaVerifyPush",
        description: "factor.push.description",
        iconClassName: "mfa-okta-verify",
        sortOrder: 1
      },
      U2F: {
        label: "factor.u2f",
        description: function description(e) {
          return e ? "factor.u2f.description.specific" : "factor.u2f.description.generic";
        },
        iconClassName: "mfa-u2f",
        sortOrder: 2
      },
      WEBAUTHN: {
        label: "factor.webauthn.biometric",
        description: "factor.webauthn.biometric.description",
        iconClassName: "mfa-webauthn",
        sortOrder: 2
      },
      WINDOWS_HELLO: {
        label: "factor.windowsHello",
        description: function description(e) {
          return e ? "factor.windowsHello.signin.description.specific" : "factor.windowsHello.signin.description.generic";
        },
        iconClassName: "mfa-windows-hello",
        sortOrder: 3
      },
      YUBIKEY: {
        label: "factor.totpHard.yubikey",
        description: "factor.totpHard.yubikey.description",
        iconClassName: "mfa-yubikey",
        sortOrder: 4
      },
      GOOGLE_AUTH: {
        label: "factor.totpSoft.googleAuthenticator",
        description: "factor.totpSoft.description",
        iconClassName: "mfa-google-auth",
        sortOrder: 5
      },
      CUSTOM_HOTP: {
        label: "",
        description: "factor.hotp.description",
        iconClassName: "mfa-hotp",
        sortOrder: 6
      },
      SMS: {
        label: "factor.sms",
        description: "factor.sms.description",
        iconClassName: "mfa-okta-sms",
        sortOrder: 7
      },
      CALL: {
        label: "factor.call",
        description: "factor.call.description",
        iconClassName: "mfa-okta-call",
        sortOrder: 8
      },
      EMAIL: {
        label: "factor.email",
        description: "factor.email.description",
        iconClassName: "mfa-okta-email",
        sortOrder: 9
      },
      QUESTION: {
        label: "factor.securityQuestion",
        description: "factor.securityQuestion.description",
        iconClassName: "mfa-okta-security-question",
        sortOrder: 10
      },
      DUO: {
        label: "factor.duo",
        description: "factor.duo.description",
        iconClassName: "mfa-duo",
        sortOrder: 11
      },
      SYMANTEC_VIP: {
        label: "factor.totpHard.symantecVip",
        description: "factor.totpHard.description",
        iconClassName: "mfa-symantec",
        sortOrder: 12
      },
      RSA_SECURID: {
        label: "factor.totpHard.rsaSecurId",
        description: "factor.totpHard.description",
        iconClassName: "mfa-rsa",
        sortOrder: 13
      },
      ON_PREM: {
        label: "",
        description: "factor.totpHard.description",
        iconClassName: "mfa-onprem",
        sortOrder: 14
      },
      PASSWORD: {
        label: "factor.password",
        description: "",
        iconClassName: "mfa-okta-password",
        sortOrder: 15
      },
      CUSTOM_CLAIMS: {
        label: "",
        description: "factor.customFactor.description",
        iconClassName: "mfa-custom-factor",
        sortOrder: 16
      },
      GENERIC_SAML: {
        label: "",
        description: function description(e) {
          return e ? "factor.customFactor.description.specific" : "factor.customFactor.description.generic";
        },
        iconClassName: "mfa-custom-factor",
        sortOrder: 17
      },
      GENERIC_OIDC: {
        label: "",
        description: function description(e) {
          return e ? "factor.customFactor.description.specific" : "factor.customFactor.description.generic";
        },
        iconClassName: "mfa-custom-factor",
        sortOrder: 18
      }
    },
        l = function l(e, t) {
      if (e.complexity) {
        var n = t.complexity,
            r = function (e) {
          var t = e.excludeAttributes;
          return e.excludeFirstName = o._.contains(t, "firstName"), e.excludeLastName = o._.contains(t, "lastName"), o._.omit(e, "excludeAttributes");
        }(e.complexity),
            i = o._.map(r, function (e, t) {
          if (!(e <= 0)) {
            var r = n[t];
            return r.args ? (0, o.loc)(r.i18n, "login", [e]) : (0, o.loc)(r.i18n, "login");
          }
        });

        return o._.compact(i);
      }

      return [];
    },
        u = function u(e, t) {
      return e.age && e.age.historyCount > 0 ? (0, o.loc)(t.history.i18n, "login", [e.age.historyCount]) : null;
    },
        c = function c(e, t) {
      if (e.age && e.age.minAgeMinutes > 0) {
        var n = i.default.getTimeInHighestRelevantUnit(e.age.minAgeMinutes, "MINUTE");
        return function (e) {
          var n;

          switch (e.unit) {
            case "DAY":
              n = t.age.days.i18n;
              break;

            case "HOUR":
              n = t.age.hours.i18n;
              break;

            case "MINUTE":
              n = t.age.minutes.i18n;
          }

          return (0, o.loc)(n, "login", [e.time]);
        }(n);
      }

      return null;
    },
        d = function d(e, t) {
      var n = {
        complexity: [],
        history: [],
        age: []
      };
      n.complexity = l(e, t);
      var r = u(e, t);
      r && n.history.push(r);
      var o = c(e, t);
      return o && n.age.push(o), n;
    };

    a.getFactorName = function (e, t) {
      return "OKTA" === e && "token:software:totp" === t ? "OKTA_VERIFY" : "OKTA" === e && "push" === t ? "OKTA_VERIFY_PUSH" : "GOOGLE" === e ? "GOOGLE_AUTH" : "SYMANTEC" === e && "token" === t ? "SYMANTEC_VIP" : "RSA" === e && "token" === t ? "RSA_SECURID" : "DEL_OATH" === e && "token" === t ? "ON_PREM" : "DUO" === e && "web" === t ? "DUO" : "YUBICO" === e && "token:hardware" === t ? "YUBIKEY" : "OKTA" === e && "sms" === t ? "SMS" : "OKTA" === e && "call" === t ? "CALL" : "OKTA" === e && "question" === t ? "QUESTION" : "OKTA" === e && "email" === t ? "EMAIL" : "OKTA" === e && "password" === t ? "PASSWORD" : "GENERIC_SAML" === e && "assertion:saml2" === t ? "GENERIC_SAML" : "GENERIC_OIDC" === e && "assertion:oidc" === t ? "GENERIC_OIDC" : a.getFactorNameForFactorType.call(this, t);
    }, a.getFactorNameForFactorType = function (e) {
      return "u2f" === e ? "U2F" : "token:software:totp" === e ? "OKTA_VERIFY" : "webauthn" === e ? this.settings.get("features.webauthn") ? "WEBAUTHN" : "WINDOWS_HELLO" : "token:hotp" === e ? "CUSTOM_HOTP" : "claims_provider" === e ? "CUSTOM_CLAIMS" : void 0;
    }, a.isOktaVerify = function (e, t) {
      return "OKTA" === e && ("token:software:totp" === t || "push" === t);
    }, a.getFactorLabel = function (e, t) {
      var n = s[a.getFactorName.apply(this, [e, t])].label;
      return (0, o.loc)(n, "login");
    }, a.getFactorDescription = function (e, t) {
      var n = s[a.getFactorName.apply(this, [e, t])].description;

      if (o._.isFunction(n)) {
        var r = this.settings.get("brandName"),
            i = n(r);
        return r ? (0, o.loc)(i, "login", [r]) : (0, o.loc)(i, "login");
      }

      return (0, o.loc)(n, "login");
    }, a.getFactorIconClassName = function (e, t) {
      return s[a.getFactorName.apply(this, [e, t])].iconClassName;
    }, a.getFactorSortOrder = function (e, t) {
      return s[a.getFactorName.apply(this, [e, t])].sortOrder;
    }, a.getRememberDeviceValue = function (e) {
      return e && e.get("rememberDeviceByDefault");
    }, a.getSecurityQuestionLabel = function (e) {
      var t = (0, o.loc)("security." + e.question);
      return t.indexOf("L10N_ERROR") < 0 ? t : e.questionText;
    }, a.removeRequirementsFromError = function (e, t) {
      var n = this.getPasswordComplexityDescription(t);
      return e.errorCauses && e.errorCauses.length > 0 && o._.isString(e.errorCauses[0].errorSummary) && (e.errorCauses[0].errorSummary = e.errorCauses[0].errorSummary.replace(n, "").trim()), e;
    }, a.getPasswordComplexityDescriptionForHtmlList = function (e) {
      var t = {
        complexity: {
          minLength: {
            i18n: "password.complexity.length.description",
            args: !0
          },
          minLowerCase: {
            i18n: "password.complexity.lowercase.description"
          },
          minUpperCase: {
            i18n: "password.complexity.uppercase.description"
          },
          minNumber: {
            i18n: "password.complexity.number.description"
          },
          minSymbol: {
            i18n: "password.complexity.symbol.description"
          },
          excludeUsername: {
            i18n: "password.complexity.no_username.description"
          },
          excludeFirstName: {
            i18n: "password.complexity.no_first_name.description"
          },
          excludeLastName: {
            i18n: "password.complexity.no_last_name.description"
          }
        },
        history: {
          i18n: "password.complexity.history.description"
        },
        age: {
          minutes: {
            i18n: "password.complexity.minAgeMinutes.description"
          },
          hours: {
            i18n: "password.complexity.minAgeHours.description"
          },
          days: {
            i18n: "password.complexity.minAgeDays.description"
          }
        }
      },
          n = d(e, t);
      return o._.union(n.complexity, n.history, n.age);
    }, a.getPasswordComplexityDescription = function (e) {
      var t = {
        complexity: {
          minLength: {
            i18n: "password.complexity.length",
            args: !0
          },
          minLowerCase: {
            i18n: "password.complexity.lowercase"
          },
          minUpperCase: {
            i18n: "password.complexity.uppercase"
          },
          minNumber: {
            i18n: "password.complexity.number"
          },
          minSymbol: {
            i18n: "password.complexity.symbol"
          },
          excludeUsername: {
            i18n: "password.complexity.no_username"
          },
          excludeFirstName: {
            i18n: "password.complexity.no_first_name"
          },
          excludeLastName: {
            i18n: "password.complexity.no_last_name"
          }
        },
        history: {
          i18n: "password.complexity.history"
        },
        age: {
          minutes: {
            i18n: "password.complexity.minAgeMinutes"
          },
          hours: {
            i18n: "password.complexity.minAgeHours"
          },
          days: {
            i18n: "password.complexity.minAgeDays"
          }
        }
      },
          n = [],
          r = d(e, t),
          i = r.complexity;
      return i.length > 0 && (i = o._.reduce(i, function (e, t) {
        return e ? e + (0, o.loc)("password.complexity.list.element", "login", [t]) : t;
      }), n.push((0, o.loc)("password.complexity.requirements", "login", [i]))), n.push(r.history[0]), n.push(r.age[0]), o._.compact(n).join(" ");
    }, a.getCardinalityText = function (e, t, n) {
      if (n) {
        if (e) return 1 === n.enrolled ? "" : (0, o.loc)("enroll.choices.cardinality.setup", "login", [n.enrolled]);
        if (t && n.maximum > 1) return (0, o.loc)("enroll.choices.cardinality.setup.remaining", "login", [n.enrolled, n.minimum]);
      }

      return "";
    }, a.findFactorInFactorsArray = function (e, t, n) {
      var r = e.findWhere({
        provider: t,
        factorType: n
      });
      return void 0 === r && (r = e.findWhere({
        factorType: n
      })), r;
    };
    var f = a;
    t.default = f;
  }, function (e, t, n) {
    /*!
    *
    * Copyright 2009-2012 Kris Kowal under the terms of the MIT
    * license found at http://github.com/kriskowal/q/raw/master/LICENSE
    *
    * With parts by Tyler Close
    * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
    * at http://www.opensource.org/licenses/mit-license.html
    * Forked at ref_send.js version: 2009-05-11
    *
    * With parts by Mark Miller
    * Copyright (C) 2011 Google Inc.
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    * http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    *
    */
    !function (t) {
      "use strict";

      if ("function" == typeof bootstrap) bootstrap("promise", t);else {
        e.exports = t();
      }
    }(function () {
      "use strict";

      function e(e) {
        return function () {
          return $.apply(e, arguments);
        };
      }

      function t(e) {
        return e === Object(e);
      }

      function n(e) {
        return "[object StopIteration]" === ee(e) || e instanceof H;
      }

      function r(e, t) {
        if (B && t.stack && "object" == typeof e && null !== e && e.stack && -1 === e.stack.indexOf(te)) {
          for (var n = [], r = t; r; r = r.source) {
            r.stack && n.unshift(r.stack);
          }

          n.unshift(e.stack);
          var i = n.join("\n" + te + "\n");
          e.stack = o(i);
        }
      }

      function o(e) {
        for (var t = e.split("\n"), n = [], r = 0; r < t.length; ++r) {
          var o = t[r];
          s(o) || i(o) || !o || n.push(o);
        }

        return n.join("\n");
      }

      function i(e) {
        return -1 !== e.indexOf("(module.js:") || -1 !== e.indexOf("(node.js:");
      }

      function a(e) {
        var t = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(e);
        if (t) return [t[1], Number(t[2])];
        var n = /at ([^ ]+):(\d+):(?:\d+)$/.exec(e);
        if (n) return [n[1], Number(n[2])];
        var r = /.*@(.+):(\d+)$/.exec(e);
        return r ? [r[1], Number(r[2])] : void 0;
      }

      function s(e) {
        var t = a(e);
        if (!t) return !1;
        var n = t[0],
            r = t[1];
        return n === V && r >= q && r <= ae;
      }

      function l() {
        if (B) try {
          throw new Error();
        } catch (r) {
          var e = r.stack.split("\n"),
              t = e[0].indexOf("@") > 0 ? e[1] : e[2],
              n = a(t);
          if (!n) return;
          return V = n[0], n[1];
        }
      }

      function u(e) {
        return e instanceof p ? e : v(e) ? T(e) : x(e);
      }

      function c() {
        function e(e) {
          t = e, i.source = e, G(n, function (t, n) {
            u.nextTick(function () {
              e.promiseDispatch.apply(e, n);
            });
          }, void 0), n = void 0, r = void 0;
        }

        var t,
            n = [],
            r = [],
            o = Q(c.prototype),
            i = Q(p.prototype);
        if (i.promiseDispatch = function (e, o, i) {
          var a = K(arguments);
          n ? (n.push(a), "when" === o && i[1] && r.push(i[1])) : u.nextTick(function () {
            t.promiseDispatch.apply(t, a);
          });
        }, i.valueOf = function () {
          if (n) return i;
          var e = m(t);
          return g(e) && (t = e), e;
        }, i.inspect = function () {
          return t ? t.inspect() : {
            state: "pending"
          };
        }, u.longStackSupport && B) try {
          throw new Error();
        } catch (e) {
          i.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
        }
        return o.promise = i, o.resolve = function (n) {
          t || e(u(n));
        }, o.fulfill = function (n) {
          t || e(x(n));
        }, o.reject = function (n) {
          t || e(S(n));
        }, o.notify = function (e) {
          t || G(r, function (t, n) {
            u.nextTick(function () {
              n(e);
            });
          }, void 0);
        }, o;
      }

      function d(e) {
        if ("function" != typeof e) throw new TypeError("resolver must be a function.");
        var t = c();

        try {
          e(t.resolve, t.reject, t.notify);
        } catch (e) {
          t.reject(e);
        }

        return t.promise;
      }

      function f(e) {
        return d(function (t, n) {
          for (var r = 0, o = e.length; r < o; r++) {
            u(e[r]).then(t, n);
          }
        });
      }

      function p(e, t, n) {
        void 0 === t && (t = function t(e) {
          return S(new Error("Promise does not support operation: " + e));
        }), void 0 === n && (n = function n() {
          return {
            state: "unknown"
          };
        });
        var r = Q(p.prototype);

        if (r.promiseDispatch = function (n, o, i) {
          var a;

          try {
            a = e[o] ? e[o].apply(r, i) : t.call(r, o, i);
          } catch (e) {
            a = S(e);
          }

          n && n(a);
        }, r.inspect = n, n) {
          var o = n();
          "rejected" === o.state && (r.exception = o.reason), r.valueOf = function () {
            var e = n();
            return "pending" === e.state || "rejected" === e.state ? r : e.value;
          };
        }

        return r;
      }

      function h(e, t, n, r) {
        return u(e).then(t, n, r);
      }

      function m(e) {
        if (g(e)) {
          var t = e.inspect();
          if ("fulfilled" === t.state) return t.value;
        }

        return e;
      }

      function g(e) {
        return e instanceof p;
      }

      function v(e) {
        return t(e) && "function" == typeof e.then;
      }

      function y(e) {
        return g(e) && "pending" === e.inspect().state;
      }

      function b(e) {
        return !g(e) || "fulfilled" === e.inspect().state;
      }

      function _(e) {
        return g(e) && "rejected" === e.inspect().state;
      }

      function w() {
        ne.length = 0, re.length = 0, ie || (ie = !0);
      }

      function E(e, t) {
        ie && ("object" == typeof process && "function" == typeof process.emit && u.nextTick.runAfter(function () {
          -1 !== Y(re, e) && (process.emit("unhandledRejection", t, e), oe.push(e));
        }), re.push(e), t && void 0 !== t.stack ? ne.push(t.stack) : ne.push("(no stack) " + t));
      }

      function O(e) {
        if (ie) {
          var t = Y(re, e);
          -1 !== t && ("object" == typeof process && "function" == typeof process.emit && u.nextTick.runAfter(function () {
            var n = Y(oe, e);
            -1 !== n && (process.emit("rejectionHandled", ne[t], e), oe.splice(n, 1));
          }), re.splice(t, 1), ne.splice(t, 1));
        }
      }

      function S(e) {
        var t = p({
          when: function when(t) {
            return t && O(this), t ? t(e) : this;
          }
        }, function () {
          return this;
        }, function () {
          return {
            state: "rejected",
            reason: e
          };
        });
        return E(t, e), t;
      }

      function x(e) {
        return p({
          when: function when() {
            return e;
          },
          get: function get(t) {
            return e[t];
          },
          set: function set(t, n) {
            e[t] = n;
          },
          delete: function _delete(t) {
            delete e[t];
          },
          post: function post(t, n) {
            return null === t || void 0 === t ? e.apply(void 0, n) : e[t].apply(e, n);
          },
          apply: function apply(t, n) {
            return e.apply(t, n);
          },
          keys: function keys() {
            return Z(e);
          }
        }, void 0, function () {
          return {
            state: "fulfilled",
            value: e
          };
        });
      }

      function T(e) {
        var t = c();
        return u.nextTick(function () {
          try {
            e.then(t.resolve, t.reject, t.notify);
          } catch (e) {
            t.reject(e);
          }
        }), t.promise;
      }

      function k(e) {
        return p({
          isDef: function isDef() {}
        }, function (t, n) {
          return I(e, t, n);
        }, function () {
          return u(e).inspect();
        });
      }

      function C(e, t, n) {
        return u(e).spread(t, n);
      }

      function A(e) {
        return function () {
          function t(e, t) {
            var a;

            if ("undefined" == typeof StopIteration) {
              try {
                a = r[e](t);
              } catch (e) {
                return S(e);
              }

              return a.done ? u(a.value) : h(a.value, o, i);
            }

            try {
              a = r[e](t);
            } catch (e) {
              return n(e) ? u(e.value) : S(e);
            }

            return h(a, o, i);
          }

          var r = e.apply(this, arguments),
              o = t.bind(t, "next"),
              i = t.bind(t, "throw");
          return o();
        };
      }

      function N(e) {
        u.done(u.async(e)());
      }

      function P(e) {
        throw new H(e);
      }

      function R(e) {
        return function () {
          return C([this, M(arguments)], function (t, n) {
            return e.apply(t, n);
          });
        };
      }

      function I(e, t, n) {
        return u(e).dispatch(t, n);
      }

      function M(e) {
        return h(e, function (e) {
          var t = 0,
              n = c();
          return G(e, function (r, o, i) {
            var a;
            g(o) && "fulfilled" === (a = o.inspect()).state ? e[i] = a.value : (++t, h(o, function (r) {
              e[i] = r, 0 == --t && n.resolve(e);
            }, n.reject, function (e) {
              n.notify({
                index: i,
                value: e
              });
            }));
          }, void 0), 0 === t && n.resolve(e), n.promise;
        });
      }

      function j(e) {
        if (0 === e.length) return u.resolve();
        var t = u.defer(),
            n = 0;
        return G(e, function (r, o, i) {
          function a(e) {
            t.resolve(e);
          }

          function s() {
            0 === --n && t.reject(new Error("Can't get fulfillment value from any promise, all promises were rejected."));
          }

          function l(e) {
            t.notify({
              index: i,
              value: e
            });
          }

          var u = e[i];
          n++, h(u, a, s, l);
        }, void 0), t.promise;
      }

      function L(e) {
        return h(e, function (e) {
          return e = J(e, u), h(M(J(e, function (e) {
            return h(e, W, W);
          })), function () {
            return e;
          });
        });
      }

      function D(e) {
        return u(e).allSettled();
      }

      function F(e, t) {
        return u(e).then(void 0, void 0, t);
      }

      function U(e, t) {
        return u(e).nodeify(t);
      }

      var B = !1;

      try {
        throw new Error();
      } catch (e) {
        B = !!e.stack;
      }

      var V,
          H,
          q = l(),
          W = function W() {},
          z = function () {
        function e() {
          for (var e, r; n.next;) {
            n = n.next, e = n.task, n.task = void 0, r = n.domain, r && (n.domain = void 0, r.enter()), t(e, r);
          }

          for (; s.length;) {
            e = s.pop(), t(e);
          }

          o = !1;
        }

        function t(t, n) {
          try {
            t();
          } catch (t) {
            if (a) throw n && n.exit(), setTimeout(e, 0), n && n.enter(), t;
            setTimeout(function () {
              throw t;
            }, 0);
          }

          n && n.exit();
        }

        var n = {
          task: void 0,
          next: null
        },
            r = n,
            o = !1,
            i = void 0,
            a = !1,
            s = [];
        if (z = function z(e) {
          r = r.next = {
            task: e,
            domain: a && process.domain,
            next: null
          }, o || (o = !0, i());
        }, "object" == typeof process && "[object process]" === process.toString() && process.nextTick) a = !0, i = function i() {
          process.nextTick(e);
        };else if ("function" == typeof setImmediate) i = "undefined" != typeof window ? setImmediate.bind(window, e) : function () {
          setImmediate(e);
        };else if ("undefined" != typeof MessageChannel) {
          var l = new MessageChannel();

          l.port1.onmessage = function () {
            i = u, l.port1.onmessage = e, e();
          };

          var u = function u() {
            l.port2.postMessage(0);
          };

          i = function i() {
            setTimeout(e, 0), u();
          };
        } else i = function i() {
          setTimeout(e, 0);
        };
        return z.runAfter = function (e) {
          s.push(e), o || (o = !0, i());
        }, z;
      }(),
          $ = Function.call,
          K = e(Array.prototype.slice),
          G = e(Array.prototype.reduce || function (e, t) {
        var n = 0,
            r = this.length;
        if (1 === arguments.length) for (;;) {
          if (n in this) {
            t = this[n++];
            break;
          }

          if (++n >= r) throw new TypeError();
        }

        for (; n < r; n++) {
          n in this && (t = e(t, this[n], n));
        }

        return t;
      }),
          Y = e(Array.prototype.indexOf || function (e) {
        for (var t = 0; t < this.length; t++) {
          if (this[t] === e) return t;
        }

        return -1;
      }),
          J = e(Array.prototype.map || function (e, t) {
        var n = this,
            r = [];
        return G(n, function (o, i, a) {
          r.push(e.call(t, i, a, n));
        }, void 0), r;
      }),
          Q = Object.create || function (e) {
        function t() {}

        return t.prototype = e, new t();
      },
          X = e(Object.prototype.hasOwnProperty),
          Z = Object.keys || function (e) {
        var t = [];

        for (var n in e) {
          X(e, n) && t.push(n);
        }

        return t;
      },
          ee = e(Object.prototype.toString);

      H = "undefined" != typeof ReturnValue ? ReturnValue : function (e) {
        this.value = e;
      };
      var te = "From previous event:";
      u.resolve = u, u.nextTick = z, u.longStackSupport = !1, "object" == typeof process && process && process.env && process.env.Q_DEBUG && (u.longStackSupport = !0), u.defer = c, c.prototype.makeNodeResolver = function () {
        var e = this;
        return function (t, n) {
          t ? e.reject(t) : arguments.length > 2 ? e.resolve(K(arguments, 1)) : e.resolve(n);
        };
      }, u.Promise = d, u.promise = d, d.race = f, d.all = M, d.reject = S, d.resolve = u, u.passByCopy = function (e) {
        return e;
      }, p.prototype.passByCopy = function () {
        return this;
      }, u.join = function (e, t) {
        return u(e).join(t);
      }, p.prototype.join = function (e) {
        return u([this, e]).spread(function (e, t) {
          if (e === t) return e;
          throw new Error("Can't join: not the same: " + e + " " + t);
        });
      }, u.race = f, p.prototype.race = function () {
        return this.then(u.race);
      }, u.makePromise = p, p.prototype.toString = function () {
        return "[object Promise]";
      }, p.prototype.then = function (e, t, n) {
        function o(t) {
          try {
            return "function" == typeof e ? e(t) : t;
          } catch (e) {
            return S(e);
          }
        }

        function i(e) {
          if ("function" == typeof t) {
            r(e, s);

            try {
              return t(e);
            } catch (e) {
              return S(e);
            }
          }

          return S(e);
        }

        function a(e) {
          return "function" == typeof n ? n(e) : e;
        }

        var s = this,
            l = c(),
            d = !1;
        return u.nextTick(function () {
          s.promiseDispatch(function (e) {
            d || (d = !0, l.resolve(o(e)));
          }, "when", [function (e) {
            d || (d = !0, l.resolve(i(e)));
          }]);
        }), s.promiseDispatch(void 0, "when", [void 0, function (e) {
          var t,
              n = !1;

          try {
            t = a(e);
          } catch (e) {
            if (n = !0, !u.onerror) throw e;
            u.onerror(e);
          }

          n || l.notify(t);
        }]), l.promise;
      }, u.tap = function (e, t) {
        return u(e).tap(t);
      }, p.prototype.tap = function (e) {
        return e = u(e), this.then(function (t) {
          return e.fcall(t).thenResolve(t);
        });
      }, u.when = h, p.prototype.thenResolve = function (e) {
        return this.then(function () {
          return e;
        });
      }, u.thenResolve = function (e, t) {
        return u(e).thenResolve(t);
      }, p.prototype.thenReject = function (e) {
        return this.then(function () {
          throw e;
        });
      }, u.thenReject = function (e, t) {
        return u(e).thenReject(t);
      }, u.nearer = m, u.isPromise = g, u.isPromiseAlike = v, u.isPending = y, p.prototype.isPending = function () {
        return "pending" === this.inspect().state;
      }, u.isFulfilled = b, p.prototype.isFulfilled = function () {
        return "fulfilled" === this.inspect().state;
      }, u.isRejected = _, p.prototype.isRejected = function () {
        return "rejected" === this.inspect().state;
      };
      var ne = [],
          re = [],
          oe = [],
          ie = !0;
      u.resetUnhandledRejections = w, u.getUnhandledReasons = function () {
        return ne.slice();
      }, u.stopUnhandledRejectionTracking = function () {
        w(), ie = !1;
      }, w(), u.reject = S, u.fulfill = x, u.master = k, u.spread = C, p.prototype.spread = function (e, t) {
        return this.all().then(function (t) {
          return e.apply(void 0, t);
        }, t);
      }, u.async = A, u.spawn = N, u.return = P, u.promised = R, u.dispatch = I, p.prototype.dispatch = function (e, t) {
        var n = this,
            r = c();
        return u.nextTick(function () {
          n.promiseDispatch(r.resolve, e, t);
        }), r.promise;
      }, u.get = function (e, t) {
        return u(e).dispatch("get", [t]);
      }, p.prototype.get = function (e) {
        return this.dispatch("get", [e]);
      }, u.set = function (e, t, n) {
        return u(e).dispatch("set", [t, n]);
      }, p.prototype.set = function (e, t) {
        return this.dispatch("set", [e, t]);
      }, u.del = u.delete = function (e, t) {
        return u(e).dispatch("delete", [t]);
      }, p.prototype.del = p.prototype.delete = function (e) {
        return this.dispatch("delete", [e]);
      }, u.mapply = u.post = function (e, t, n) {
        return u(e).dispatch("post", [t, n]);
      }, p.prototype.mapply = p.prototype.post = function (e, t) {
        return this.dispatch("post", [e, t]);
      }, u.send = u.mcall = u.invoke = function (e, t) {
        return u(e).dispatch("post", [t, K(arguments, 2)]);
      }, p.prototype.send = p.prototype.mcall = p.prototype.invoke = function (e) {
        return this.dispatch("post", [e, K(arguments, 1)]);
      }, u.fapply = function (e, t) {
        return u(e).dispatch("apply", [void 0, t]);
      }, p.prototype.fapply = function (e) {
        return this.dispatch("apply", [void 0, e]);
      }, u.try = u.fcall = function (e) {
        return u(e).dispatch("apply", [void 0, K(arguments, 1)]);
      }, p.prototype.fcall = function () {
        return this.dispatch("apply", [void 0, K(arguments)]);
      }, u.fbind = function (e) {
        var t = u(e),
            n = K(arguments, 1);
        return function () {
          return t.dispatch("apply", [this, n.concat(K(arguments))]);
        };
      }, p.prototype.fbind = function () {
        var e = this,
            t = K(arguments);
        return function () {
          return e.dispatch("apply", [this, t.concat(K(arguments))]);
        };
      }, u.keys = function (e) {
        return u(e).dispatch("keys", []);
      }, p.prototype.keys = function () {
        return this.dispatch("keys", []);
      }, u.all = M, p.prototype.all = function () {
        return M(this);
      }, u.any = j, p.prototype.any = function () {
        return j(this);
      }, u.allResolved = function (e, t, n) {
        return function () {
          return "undefined" != typeof console && console.warn, e.apply(e, arguments);
        };
      }(L, "allResolved", "allSettled"), p.prototype.allResolved = function () {
        return L(this);
      }, u.allSettled = D, p.prototype.allSettled = function () {
        return this.then(function (e) {
          return M(J(e, function (e) {
            function t() {
              return e.inspect();
            }

            return e = u(e), e.then(t, t);
          }));
        });
      }, u.fail = u.catch = function (e, t) {
        return u(e).then(void 0, t);
      }, p.prototype.fail = p.prototype.catch = function (e) {
        return this.then(void 0, e);
      }, u.progress = F, p.prototype.progress = function (e) {
        return this.then(void 0, void 0, e);
      }, u.fin = u.finally = function (e, t) {
        return u(e).finally(t);
      }, p.prototype.fin = p.prototype.finally = function (e) {
        return e = u(e), this.then(function (t) {
          return e.fcall().then(function () {
            return t;
          });
        }, function (t) {
          return e.fcall().then(function () {
            throw t;
          });
        });
      }, u.done = function (e, t, n, r) {
        return u(e).done(t, n, r);
      }, p.prototype.done = function (e, t, n) {
        var o = function o(e) {
          u.nextTick(function () {
            if (r(e, i), !u.onerror) throw e;
            u.onerror(e);
          });
        },
            i = e || t || n ? this.then(e, t, n) : this;

        "object" == typeof process && process && process.domain && (o = process.domain.bind(o)), i.then(void 0, o);
      }, u.timeout = function (e, t, n) {
        return u(e).timeout(t, n);
      }, p.prototype.timeout = function (e, t) {
        var n = c(),
            r = setTimeout(function () {
          t && "string" != typeof t || (t = new Error(t || "Timed out after " + e + " ms"), t.code = "ETIMEDOUT"), n.reject(t);
        }, e);
        return this.then(function (e) {
          clearTimeout(r), n.resolve(e);
        }, function (e) {
          clearTimeout(r), n.reject(e);
        }, n.notify), n.promise;
      }, u.delay = function (e, t) {
        return void 0 === t && (t = e, e = void 0), u(e).delay(t);
      }, p.prototype.delay = function (e) {
        return this.then(function (t) {
          var n = c();
          return setTimeout(function () {
            n.resolve(t);
          }, e), n.promise;
        });
      }, u.nfapply = function (e, t) {
        return u(e).nfapply(t);
      }, p.prototype.nfapply = function (e) {
        var t = c(),
            n = K(e);
        return n.push(t.makeNodeResolver()), this.fapply(n).fail(t.reject), t.promise;
      }, u.nfcall = function (e) {
        var t = K(arguments, 1);
        return u(e).nfapply(t);
      }, p.prototype.nfcall = function () {
        var e = K(arguments),
            t = c();
        return e.push(t.makeNodeResolver()), this.fapply(e).fail(t.reject), t.promise;
      }, u.nfbind = u.denodeify = function (e) {
        var t = K(arguments, 1);
        return function () {
          var n = t.concat(K(arguments)),
              r = c();
          return n.push(r.makeNodeResolver()), u(e).fapply(n).fail(r.reject), r.promise;
        };
      }, p.prototype.nfbind = p.prototype.denodeify = function () {
        var e = K(arguments);
        return e.unshift(this), u.denodeify.apply(void 0, e);
      }, u.nbind = function (e, t) {
        var n = K(arguments, 2);
        return function () {
          function r() {
            return e.apply(t, arguments);
          }

          var o = n.concat(K(arguments)),
              i = c();
          return o.push(i.makeNodeResolver()), u(r).fapply(o).fail(i.reject), i.promise;
        };
      }, p.prototype.nbind = function () {
        var e = K(arguments, 0);
        return e.unshift(this), u.nbind.apply(void 0, e);
      }, u.nmapply = u.npost = function (e, t, n) {
        return u(e).npost(t, n);
      }, p.prototype.nmapply = p.prototype.npost = function (e, t) {
        var n = K(t || []),
            r = c();
        return n.push(r.makeNodeResolver()), this.dispatch("post", [e, n]).fail(r.reject), r.promise;
      }, u.nsend = u.nmcall = u.ninvoke = function (e, t) {
        var n = K(arguments, 2),
            r = c();
        return n.push(r.makeNodeResolver()), u(e).dispatch("post", [t, n]).fail(r.reject), r.promise;
      }, p.prototype.nsend = p.prototype.nmcall = p.prototype.ninvoke = function (e) {
        var t = K(arguments, 1),
            n = c();
        return t.push(n.makeNodeResolver()), this.dispatch("post", [e, t]).fail(n.reject), n.promise;
      }, u.nodeify = U, p.prototype.nodeify = function (e) {
        if (!e) return this;
        this.then(function (t) {
          u.nextTick(function () {
            e(null, t);
          });
        }, function (t) {
          u.nextTick(function () {
            e(t);
          });
        });
      }, u.noConflict = function () {
        throw new Error("Q.noConflict only works when Q is used as a global");
      };
      var ae = l();
      return u;
    });
  }, function (e, t, n) {
    var r = n(21),
        o = n(31),
        i = n(186),
        a = n(48).f;

    e.exports = function (e) {
      var t = r.Symbol || (r.Symbol = {});
      o(t, e) || a(t, e, {
        value: i.f(e)
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(5)),
        s = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link help js-back" data-se="back-link">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "mfa.backToFactors"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 58
              },
              end: {
                line: 1,
                column: 106
              }
            }
          })) + "</a>";
        },
        useData: !0
      }),
      className: "auth-footer",
      events: {
        "click .js-back": function clickJsBack(e) {
          e.preventDefault(), this.options.appState.trigger("backToFactors"), this.back();
        }
      },
      back: function back() {
        this.state.set("navigateDir", a.default.DIRECTION_BACK), this.options.appState.get("prevLink") ? this.model.doTransaction(function (e) {
          return e.prev();
        }) : this.options.appState.trigger("navigate", "signin/enroll");
      }
    });
    t.default = s;
  }, function (e, t, n) {
    (function (t) {
      var n = function n(e) {
        return e && e.Math == Math && e;
      };

      e.exports = n("object" == typeof globalThis && globalThis) || n("object" == typeof window && window) || n("object" == typeof self && self) || n("object" == typeof t && t) || Function("return this")();
    }).call(t, n(49));
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      if (!Object(o.a)(e)) return [];
      if (i.m) return Object(i.m)(e);
      var t = [];

      for (var n in e) {
        Object(a.a)(e, n) && t.push(n);
      }

      return i.h && Object(s.a)(e, t), t;
    }

    t.a = r;
    var o = n(53),
        i = n(11),
        a = n(50),
        s = n(207);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = "[object " + e + "]";
      return function (e) {
        return o.t.call(e) === t;
      };
    }

    t.a = r;
    var o = n(11);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      this.name = p.default.CONFIG_ERROR, this.message = e || (0, f.loc)("error.config");
    }

    function o(e) {
      this.name = p.default.UNSUPPORTED_BROWSER_ERROR, this.message = e || (0, f.loc)("error.unsupported.browser");
    }

    function i(e) {
      this.name = p.default.OAUTH_ERROR, this.message = e;
    }

    function a(e) {
      this.name = p.default.REGISTRATION_FAILED, this.message = e;
    }

    function s() {
      this.name = p.default.AUTH_STOP_POLL_INITIATION_ERROR;
    }

    function l(e) {
      this.name = p.default.U2F_ERROR, this.message = e.xhr.responseJSON.errorSummary, this.xhr = e.xhr;
    }

    function u(e) {
      this.name = p.default.WEB_AUTHN_ERROR, this.message = e.xhr.responseJSON.errorSummary, this.xhr = e.xhr;
    }

    function c() {
      this.name = p.default.WEBAUTHN_ABORT_ERROR;
    }

    var d = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var f = n(1),
        p = d(n(5));
    r.prototype = new Error(), o.prototype = new Error(), i.prototype = new Error(), a.prototype = new Error(), s.prototype = new Error(), l.prototype = new Error(), u.prototype = new Error(), c.prototype = new Error();
    var h = {
      ConfigError: r,
      UnsupportedBrowserError: o,
      OAuthError: i,
      RegistrationError: a,
      AuthStopPollInitiationError: s,
      U2FError: l,
      WebAuthnError: u,
      WebauthnAbortError: c
    };
    t.default = h;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = {},
        o = "withCredentials" in new window.XMLHttpRequest(),
        i = "undefined" != typeof XDomainRequest;
    r.corsIsNotSupported = function () {
      return !(o || i);
    }, r.corsIsNotEnabled = function (e) {
      return 0 === e.status;
    }, r.localStorageIsNotSupported = function () {
      try {
        return localStorage.setItem("test", "test"), localStorage.removeItem("test"), !1;
      } catch (e) {
        return !0;
      }
    }, r.supportsPushState = function (e) {
      return e = e || window, !(!e.history || !e.history.pushState);
    }, r.isIE = function () {
      return /(msie|trident)/i.test(navigator.userAgent);
    }, r.isFirefox = function () {
      return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    }, r.isEdge = function () {
      return navigator.userAgent.toLowerCase().indexOf("edge") > -1;
    }, r.isSafari = function () {
      return navigator.userAgent.toLowerCase().indexOf("safari") > -1 && -1 === navigator.userAgent.toLowerCase().indexOf("chrome");
    }, r.isMac = function () {
      return navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    }, r.isAndroid = function () {
      return /android/i.test(navigator.userAgent) && !/windows phone/i.test(navigator.userAgent);
    }, r.isIOS = function () {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }, r.getUserLanguages = function () {
      var e, t;
      return navigator.languages ? navigator.languages : (e = [], t = ["language", "userLanguage", "browserLanguage", "systemLanguage"], t.forEach(function (t) {
        navigator[t] && e.push(navigator[t]);
      }), e);
    };
    var a = r;
    t.default = a;
  }, function (e, t, n) {
    var r = n(20);
    e.exports = !r(function () {
      return 7 != Object.defineProperty({}, 1, {
        get: function get() {
          return 7;
        }
      })[1];
    });
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      return o.a.iteratee !== a.a ? o.a.iteratee(e, t) : Object(i.a)(e, t, n);
    }

    t.a = r;
    var o = n(29),
        i = n(217),
        a = n(218);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return t = null == t ? e.length - 1 : +t, function () {
        for (var n = Math.max(arguments.length - t, 0), r = Array(n), o = 0; o < n; o++) {
          r[o] = arguments[o + t];
        }

        switch (t) {
          case 0:
            return e.call(this, r);

          case 1:
            return e.call(this, arguments[0], r);

          case 2:
            return e.call(this, arguments[0], arguments[1], r);
        }

        var i = Array(t + 1);

        for (o = 0; o < t; o++) {
          i[o] = arguments[o];
        }

        return i[t] = r, e.apply(this, i);
      };
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e instanceof r ? e : this instanceof r ? void (this._wrapped = e) : new r(e);
    }

    t.a = r;
    var o = n(11);
    r.VERSION = o.e, r.prototype.value = function () {
      return this._wrapped;
    }, r.prototype.valueOf = r.prototype.toJSON = r.prototype.value, r.prototype.toString = function () {
      return String(this._wrapped);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(205),
        o = n(33);
    t.a = Object(r.a)(o.a);
  }, function (e, t) {
    var n = {}.hasOwnProperty;

    e.exports = function (e, t) {
      return n.call(e, t);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(23),
        o = n(11),
        i = Object(r.a)("Function"),
        a = o.p.document && o.p.document.childNodes;
    "function" != typeof /./ && "object" != typeof Int8Array && "function" != typeof a && (i = function i(e) {
      return "function" == typeof e || !1;
    }), t.a = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(206);
    t.a = Object(r.a)("length");
  }, function (e, t, n) {
    e.exports = n(585);
  }, function (e, t) {
    e.exports = function (e) {
      return "object" == typeof e ? null !== e : "function" == typeof e;
    };
  }, function (e, t, n) {
    var r = n(35);

    e.exports = function (e) {
      if (!r(e)) throw TypeError(String(e) + " is not an object");
      return e;
    };
  }, function (e, t, n) {
    (function (t) {
      var n = function n(e) {
        return e && e.Math == Math && e;
      };

      e.exports = n("object" == typeof globalThis && globalThis) || n("object" == typeof window && window) || n("object" == typeof self && self) || n("object" == typeof t && t) || function () {
        return this;
      }() || Function("return this")();
    }).call(t, n(49));
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      "error" === e && window.console[e].apply(window.console, t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = {
      trace: function trace() {
        return r("trace", arguments);
      },
      dir: function dir() {
        return r("dir", arguments);
      },
      time: function time() {
        return r("time", arguments);
      },
      timeEnd: function timeEnd() {
        return r("timeEnd", arguments);
      },
      group: function group() {
        return r("group", arguments);
      },
      groupEnd: function groupEnd() {
        return r("groupEnd", arguments);
      },
      assert: function assert() {
        return r("assert", arguments);
      },
      log: function log() {
        return r("log", arguments);
      },
      info: function info() {
        return r("info", arguments);
      },
      warn: function warn() {
        return r("warn", arguments);
      },
      error: function error() {
        return r("error", arguments);
      },
      deprecate: function deprecate(e) {
        return r("warn", ["[okta-signin-widget] DEPRECATED:", e]);
      }
    };
    t.default = o;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = r(n(25)),
        l = r(n(5)),
        u = r(n(489)),
        c = r(n(24)),
        d = r(n(156)),
        f = r(n(12)),
        p = {},
        h = i.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, i) {
        var a,
            s = null != t ? t : e.nullContext || {},
            l = e.hooks.helperMissing,
            u = e.escapeExpression,
            c = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return "signin/verify/" + u((a = null != (a = c(n, "provider") || (null != t ? c(t, "provider") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
          name: "provider",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 14
            },
            end: {
              line: 1,
              column: 26
            }
          }
        }) : a)) + "/" + u((a = null != (a = c(n, "factorType") || (null != t ? c(t, "factorType") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
          name: "factorType",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 27
            },
            end: {
              line: 1,
              column: 41
            }
          }
        }) : a));
      },
      useData: !0
    }),
        m = i.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, i) {
        var a,
            s = null != t ? t : e.nullContext || {},
            l = e.hooks.helperMissing,
            u = e.escapeExpression,
            c = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return "signin/verify/" + u((a = null != (a = c(n, "provider") || (null != t ? c(t, "provider") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
          name: "provider",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 14
            },
            end: {
              line: 1,
              column: 26
            }
          }
        }) : a)) + "/" + u((a = null != (a = c(n, "factorType") || (null != t ? c(t, "factorType") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
          name: "factorType",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 27
            },
            end: {
              line: 1,
              column: 41
            }
          }
        }) : a)) + "/" + u((a = null != (a = c(n, "factorIndex") || (null != t ? c(t, "factorIndex") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
          name: "factorIndex",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 42
            },
            end: {
              line: 1,
              column: 57
            }
          }
        }) : a));
      },
      useData: !0
    }),
        g = i.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return "signin/verify/" + e.escapeExpression((i = null != (i = a(n, "factorType") || (null != t ? a(t, "factorType") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
          name: "factorType",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 14
            },
            end: {
              line: 1,
              column: 28
            }
          }
        }) : i));
      },
      useData: !0
    }),
        v = i.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, i) {
        var a,
            s = null != t ? t : e.nullContext || {},
            l = e.hooks.helperMissing,
            u = e.escapeExpression,
            c = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return "signin/enroll/" + u((a = null != (a = c(n, "provider") || (null != t ? c(t, "provider") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
          name: "provider",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 14
            },
            end: {
              line: 1,
              column: 26
            }
          }
        }) : a)) + "/" + u((a = null != (a = c(n, "factorType") || (null != t ? c(t, "factorType") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
          name: "factorType",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 27
            },
            end: {
              line: 1,
              column: 41
            }
          }
        }) : a));
      },
      useData: !0
    }),
        y = i.default.template({
      1: function _(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return "/" + e.escapeExpression((i = null != (i = a(n, "step") || (null != t ? a(t, "step") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
          name: "step",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 63
            },
            end: {
              line: 1,
              column: 71
            }
          }
        }) : i));
      },
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, i) {
        var a,
            s,
            l = null != t ? t : e.nullContext || {},
            u = e.hooks.helperMissing,
            c = e.escapeExpression,
            d = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return "signin/enroll-activate/" + c((s = null != (s = d(n, "provider") || (null != t ? d(t, "provider") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
          name: "provider",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 23
            },
            end: {
              line: 1,
              column: 35
            }
          }
        }) : s)) + "/" + c((s = null != (s = d(n, "factorType") || (null != t ? d(t, "factorType") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
          name: "factorType",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 36
            },
            end: {
              line: 1,
              column: 50
            }
          }
        }) : s)) + (null != (a = d(n, "if").call(l, null != t ? d(t, "step") : t, {
          name: "if",
          hash: {},
          fn: e.program(1, i, 0),
          inverse: e.noop,
          data: i,
          loc: {
            start: {
              line: 1,
              column: 50
            },
            end: {
              line: 1,
              column: 78
            }
          }
        })) ? a : "");
      },
      useData: !0
    }),
        b = i.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return "signin/recovery/" + e.escapeExpression((i = null != (i = a(n, "recoveryToken") || (null != t ? a(t, "recoveryToken") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
          name: "recoveryToken",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 16
            },
            end: {
              line: 1,
              column: 33
            }
          }
        }) : i));
      },
      useData: !0
    }),
        _ = i.default.template({
      1: function _(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return "/" + e.escapeExpression((i = null != (i = a(n, "token") || (null != t ? a(t, "token") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
          name: "token",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 39
            },
            end: {
              line: 1,
              column: 48
            }
          }
        }) : i));
      },
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return "signin/refresh-auth-state" + (null != (i = a(n, "if").call(null != t ? t : e.nullContext || {}, null != t ? a(t, "token") : t, {
          name: "if",
          hash: {},
          fn: e.program(1, o, 0),
          inverse: e.noop,
          data: o,
          loc: {
            start: {
              line: 1,
              column: 25
            },
            end: {
              line: 1,
              column: 55
            }
          }
        })) ? i : "");
      },
      useData: !0
    }),
        w = i.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, i) {
        var a,
            s,
            l = null != t ? t : e.nullContext || {},
            u = e.hooks.helperMissing,
            c = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return e.escapeExpression((s = null != (s = c(n, "baseUrl") || (null != t ? c(t, "baseUrl") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
          name: "baseUrl",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 0
            },
            end: {
              line: 1,
              column: 11
            }
          }
        }) : s)) + "/login/sessionCookieRedirect?checkAccountSetupComplete=true&token=" + (null != (s = null != (s = c(n, "token") || (null != t ? c(t, "token") : t)) ? s : u, a = "function" === (0, o.default)(s) ? s.call(l, {
          name: "token",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 77
            },
            end: {
              line: 1,
              column: 88
            }
          }
        }) : s) ? a : "") + "&redirectUrl=" + (null != (s = null != (s = c(n, "redirectUrl") || (null != t ? c(t, "redirectUrl") : t)) ? s : u, a = "function" === (0, o.default)(s) ? s.call(l, {
          name: "redirectUrl",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 101
            },
            end: {
              line: 1,
              column: 118
            }
          }
        }) : s) ? a : "");
      },
      useData: !0
    }),
        E = ["DEVICE_ACTIVATED", "DEVICE_NOT_ACTIVATED_CONSENT_DENIED", "DEVICE_NOT_ACTIVATED"];

    p.isHostBackgroundChromeTab = function () {
      return !!(navigator.userAgent.match(/Android/) && navigator.userAgent.match(/Chrome/) && document.hidden);
    }, p.isDocumentVisible = function () {
      return "visible" === document.visibilityState;
    }, p.createVerifyUrl = function (e, t, n) {
      return e && n ? m({
        provider: encodeURIComponent(e.toLowerCase()),
        factorType: encodeURIComponent(t),
        factorIndex: encodeURIComponent(n)
      }) : e ? h({
        provider: encodeURIComponent(e.toLowerCase()),
        factorType: encodeURIComponent(t)
      }) : g({
        factorType: encodeURIComponent(t)
      });
    }, p.createEnrollFactorUrl = function (e, t) {
      return v({
        provider: encodeURIComponent(e.toLowerCase()),
        factorType: encodeURIComponent(t)
      });
    }, p.createActivateFactorUrl = function (e, t, n) {
      return y({
        provider: encodeURIComponent(e.toLowerCase()),
        factorType: encodeURIComponent(t),
        step: !!n && encodeURIComponent(n)
      });
    }, p.createRecoveryUrl = function (e) {
      return b({
        recoveryToken: encodeURIComponent(e)
      });
    }, p.createRefreshUrl = function (e) {
      var t = e ? encodeURIComponent(e) : null;
      return _({
        token: t
      });
    }, p.routeAfterAuthStatusChangeError = function (e, t) {
      if (t) return t.xhr && s.default.corsIsNotEnabled(t.xhr) ? void e.settings.callGlobalError(new c.default.UnsupportedBrowserError((0, a.loc)("error.enabled.cors"))) : t.errorCode === u.default.INVALID_TOKEN_EXCEPTION ? (e.appState.set("flashError", t), e.controller.state.set("navigateDir", l.default.DIRECTION_BACK), void (e.settings.get("features.mfaOnlyFlow") ? e.navigate("signin/error", {
        trigger: !0
      }) : e.navigate("", {
        trigger: !0
      }))) : void f.default.triggerAfterError(e.controller, t);
    }, p.routeAfterAuthStatusChange = function (e, t) {
      if (!t || !t.status) return void e.appState.clearLastAuthResponse();
      e.appState.setAuthResponse(t), e.controller && e.controller.trapAuthResponse(t) || p.handleResponseStatus(e, t);
    }, p.handleResponseStatus = function (e, t) {
      switch (t.status) {
        case "SUCCESS":
          var n;
          if (t.recoveryType === l.default.RECOVERY_TYPE_UNLOCK) return void e.navigate("signin/account-unlocked", {
            trigger: !0
          });
          if (a._.contains(E, null === (n = t._embedded) || void 0 === n ? void 0 : n.deviceActivationStatus)) return void e.navigate("signin/device-activate-complete", {
            trigger: !0
          });
          if (e.settings.get("oauth2Enabled")) return void d.default.getTokens(e.settings, {
            sessionToken: t.sessionToken
          }, e.controller);
          var r = {
            user: t._embedded.user,
            type: t.type || l.default.SESSION_SSO
          };
          t.relayState && (r.relayState = t.relayState);
          var o = e.settings.get("redirectUtilFn"),
              i = t._links && (t._links.original && t._links.original.href || t._links.next && t._links.next.href);

          if (t.type === l.default.SESSION_STEP_UP) {
            var s = t._links && t._links.next && t._links.next.href;
            r.stepUp = {
              url: s,
              finish: function finish() {
                o(s);
              }
            };
          } else i ? r.next = function () {
            o(i);
          } : (r.type = l.default.SESSION_SSO, r.session = {
            token: t.sessionToken,
            setCookieAndRedirect: function setCookieAndRedirect(n) {
              if (n && f.default.debugMessage('\n              Passing a "redirectUri" to "setCookieAndRedirect" is strongly discouraged.\n              It is recommended to set a "redirectUri" option in the config object passed to the widget constructor.\n            '), !(n = n || e.settings.get("redirectUri"))) throw new c.default.ConfigError('"redirectUri" is required');
              o(w({
                baseUrl: e.settings.get("baseUrl"),
                token: encodeURIComponent(t.sessionToken),
                redirectUrl: encodeURIComponent(n)
              }));
            }
          });

          return void (p.isHostBackgroundChromeTab() ? document.addEventListener("visibilitychange", function t() {
            p.isDocumentVisible() && (document.removeEventListener("visibilitychange", t), e.settings.callGlobalSuccess(l.default.SUCCESS, r));
          }) : e.settings.callGlobalSuccess(l.default.SUCCESS, r));

        case "ADMIN_CONSENT_REQUIRED":
          return void e.navigate("signin/admin-consent", {
            trigger: !0
          });

        case "CONSENT_REQUIRED":
          return void e.navigate("signin/consent", {
            trigger: !0
          });

        case "DEVICE_ACTIVATE":
          return void e.navigate("signin/device-activate", {
            trigger: !0
          });

        case "FACTOR_REQUIRED":
        case "FACTOR_CHALLENGE":
        case "MFA_REQUIRED":
          var u = e.appState.get("lastFailedChallengeFactorData");
          u && u.factor && (e.appState.get("factors").lastUsedFactor = u.factor);
          var h = e.appState.get("factors").getDefaultFactor(),
              m = p.createVerifyUrl(h.get("provider"), h.get("factorType"));
          return e.navigate(m, {
            trigger: !0
          }), void e.appState.clearLastFailedChallengeFactorData();

        case "POLL":
          ;
          return void e.navigate("signin/poll", {
            trigger: !0
          });

        case "MFA_CHALLENGE":
          return e.appState.get("isFactorResultFailed") && e.appState.setLastFailedChallengeFactorData(), void e.appState.get("transaction").prev().then(function (t) {
            e.appState.set("transaction", t);
          });

        case "MFA_ENROLL":
        case "FACTOR_ENROLL":
          return void e.navigate("signin/enroll", {
            trigger: !0
          });

        case "MFA_ENROLL_ACTIVATE":
        case "FACTOR_ENROLL_ACTIVATE":
          var g = p.createActivateFactorUrl(e.appState.get("activatedFactorProvider"), e.appState.get("activatedFactorType"));
          return void e.navigate(g, {
            trigger: !0
          });

        case "PASSWORD_WARN":
        case "PASSWORD_EXPIRED":
          return void (e.settings.get("features.customExpiredPassword") && !e.appState.get("isPwdManagedByOkta") ? e.navigate("signin/custom-password-expired", {
            trigger: !0
          }) : e.navigate("signin/password-expired", {
            trigger: !0
          }));

        case "RECOVERY_CHALLENGE":
          var v = t.factorType.toLowerCase() === l.default.RECOVERY_FACTOR_TYPE_EMAIL.toLowerCase(),
              y = t.recoveryType === l.default.RECOVERY_TYPE_PASSWORD,
              b = t.recoveryType === l.default.RECOVERY_TYPE_UNLOCK;
          return void (y && v ? e.navigate("signin/recovery-emailed", {
            trigger: !0
          }) : b && v ? e.navigate("signin/unlock-emailed", {
            trigger: !0
          }) : e.navigate("signin/recovery-challenge", {
            trigger: !0
          }));

        case "RECOVERY":
          return void e.navigate("signin/recovery-question", {
            trigger: !0
          });

        case "PASSWORD_RESET":
          return void e.navigate("signin/password-reset", {
            trigger: !0
          });

        case "LOCKED_OUT":
          return void (e.settings.get("features.selfServiceUnlock") ? e.navigate("signin/unlock", {
            trigger: !0
          }) : e.controller.model.trigger("error", e.controller.model, {
            responseJSON: {
              errorCauses: [],
              errorSummary: (0, a.loc)("error.auth.lockedOut", "login")
            }
          }));

        case "PROFILE_REQUIRED":
          return void e.navigate("signin/enroll-user", {
            trigger: !0
          });

        case "UNAUTHENTICATED":
          if (e.appState.get("promptForFactorInUnauthenticated")) {
            var _ = e.appState.get("factors").getDefaultFactor(),
                O = p.createVerifyUrl(_.get("provider"), _.get("factorType"));

            return void e.navigate(O, {
              trigger: !0
            });
          }

          return void e.navigate("", {
            trigger: !0
          });

        default:
          throw new Error("Unknown status: " + t.status);
      }
    };
    var O = p;
    t.default = O;
  }, function (e, t) {
    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return d[e];
    }

    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        for (var n in arguments[t]) {
          Object.prototype.hasOwnProperty.call(arguments[t], n) && (e[n] = arguments[t][n]);
        }
      }

      return e;
    }

    function i(e, t) {
      for (var n = 0, r = e.length; n < r; n++) {
        if (e[n] === t) return n;
      }

      return -1;
    }

    function a(e) {
      if ("string" != typeof e) {
        if (e && e.toHTML) return e.toHTML();
        if (null == e) return "";
        if (!e) return e + "";
        e = "" + e;
      }

      return p.test(e) ? e.replace(f, r) : e;
    }

    function s(e) {
      return !e && 0 !== e || !(!g(e) || 0 !== e.length);
    }

    function l(e) {
      var t = o({}, e);
      return t._parent = e, t;
    }

    function u(e, t) {
      return e.path = t, e;
    }

    function c(e, t) {
      return (e ? e + "." : "") + t;
    }

    t.__esModule = !0, t.extend = o, t.indexOf = i, t.escapeExpression = a, t.isEmpty = s, t.createFrame = l, t.blockParams = u, t.appendContextPath = c;
    var d = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#x27;",
      "`": "&#x60;",
      "=": "&#x3D;"
    },
        f = /[&<>"'`=]/g,
        p = /[&<>"'`=]/,
        h = Object.prototype.toString;
    t.toString = h;

    var m = function m(e) {
      return "function" == typeof e;
    };

    m(/x/) && (t.isFunction = m = function m(e) {
      return "function" == typeof e && "[object Function]" === h.call(e);
    }), t.isFunction = m;

    var g = Array.isArray || function (e) {
      return !(!e || "object" != typeof e) && "[object Array]" === h.call(e);
    };

    t.isArray = g;
  }, function (e, t) {
    function n(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    e.exports = n;
  }, function (e, t, n) {
    var r = n(163),
        o = n(164);

    e.exports = function (e) {
      return r(o(e));
    };
  }, function (e, t, n) {
    var r = n(26),
        o = n(48),
        i = n(59);
    e.exports = r ? function (e, t, n) {
      return o.f(e, t, i(1, n));
    } : function (e, t, n) {
      return e[t] = n, e;
    };
  }, function (e, t, n) {
    var r = n(21),
        o = n(19),
        i = function i(e) {
      return "function" == typeof e ? e : void 0;
    };

    e.exports = function (e, t) {
      return arguments.length < 2 ? i(r[e]) || i(o[e]) : r[e] && r[e][t] || o[e] && o[e][t];
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.WIDGET_FOOTER_CLASS = t.CANCEL_POLLING_ACTION = t.UNIVERSAL_LINK_POST_DELAY = t.MS_PER_SEC = t.WARNING_TIMEOUT = t.SHOW_RESEND_TIMEOUT = void 0;
    t.SHOW_RESEND_TIMEOUT = 3e4;
    t.WARNING_TIMEOUT = 3e4;
    t.MS_PER_SEC = 1e3;
    t.UNIVERSAL_LINK_POST_DELAY = 500;
    t.CANCEL_POLLING_ACTION = "authenticatorChallenge-cancel";
    t.WIDGET_FOOTER_CLASS = "siw-main-footer";
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = o.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, o) {
        var i,
            a,
            s = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return '<span class="icon error-24"></span><h4><strong>' + (null != (a = null != (a = s(n, "message") || (null != t ? s(t, "message") : t)) ? a : e.hooks.helperMissing, i = "function" == typeof a ? a.call(null != t ? t : e.nullContext || {}, {
          name: "message",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 47
            },
            end: {
              line: 1,
              column: 60
            }
          }
        }) : a) ? i : "") + "</strong></h4>";
      },
      useData: !0
    }),
        s = i.View.extend({
      template: a,
      className: "okta-infobox-error infobox infobox-error infobox-md margin-btm-25",
      attributes: {
        "data-se": "o-form-error-html"
      },
      message: "",
      initialize: function initialize(e) {
        e && e.message && (this.message = e.message);
      },
      getTemplateData: function getTemplateData() {
        return {
          message: this.message
        };
      }
    });
    t.default = s;
  }, function (e, t, n) {
    var r = n(26),
        o = n(285),
        i = n(36),
        a = n(121),
        s = Object.defineProperty;
    t.f = r ? s : function (e, t, n) {
      if (i(e), t = a(t, !0), i(n), o) try {
        return s(e, t, n);
      } catch (e) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
      return "value" in n && (e[t] = n.value), e;
    };
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return null != e && o.i.call(e, t);
    }

    t.a = r;
    var o = n(11);
  }, function (e, t, n) {
    var r = n(173),
        o = n(48).f,
        i = n(44),
        a = n(31),
        s = n(596),
        l = n(14),
        u = l("toStringTag");

    e.exports = function (e, t, n, l) {
      if (e) {
        var c = n ? e : e.prototype;
        a(c, u) || o(c, u, {
          configurable: !0,
          value: t
        }), l && !r && i(c, "toString", s);
      }
    };
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = typeof e;
      return "function" === t || "object" === t && !!e;
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    var r = n(11),
        o = n(23);
    t.a = r.k || Object(o.a)("Array");
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      t = Object(o.a)(t, n);
      var r, s;
      if (Object(i.a)(e)) for (r = 0, s = e.length; r < s; r++) {
        t(e[r], r, e);
      } else {
        var l = Object(a.a)(e);

        for (r = 0, s = l.length; r < s; r++) {
          t(e[l[r]], l[r], e);
        }
      }
      return e;
    }

    t.a = r;
    var o = n(90),
        i = n(30),
        a = n(22);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = t && t.loc,
          i = void 0,
          a = void 0,
          s = void 0,
          l = void 0;
      n && (i = n.start.line, a = n.end.line, s = n.start.column, l = n.end.column, e += " - " + i + ":" + s);

      for (var u = Error.prototype.constructor.call(this, e), c = 0; c < o.length; c++) {
        this[o[c]] = u[o[c]];
      }

      Error.captureStackTrace && Error.captureStackTrace(this, r);

      try {
        n && (this.lineNumber = i, this.endLineNumber = a, Object.defineProperty ? (Object.defineProperty(this, "column", {
          value: s,
          enumerable: !0
        }), Object.defineProperty(this, "endColumn", {
          value: l,
          enumerable: !0
        })) : (this.column = s, this.endColumn = l));
      } catch (e) {}
    }

    t.__esModule = !0;
    var o = ["description", "fileName", "lineNumber", "endLineNumber", "message", "name", "number", "stack"];
    r.prototype = new Error(), t.default = r, e.exports = t.default;
  }, function (e, t, n) {
    e.exports = n(564);
  }, function (e, t) {
    function n(e, t, n, r, o, i, a) {
      try {
        var s = e[i](a),
            l = s.value;
      } catch (e) {
        return void n(e);
      }

      s.done ? t(l) : Promise.resolve(l).then(r, o);
    }

    function r(e) {
      return function () {
        var t = this,
            r = arguments;
        return new Promise(function (o, i) {
          function a(e) {
            n(l, o, i, a, s, "next", e);
          }

          function s(e) {
            n(l, o, i, a, s, "throw", e);
          }

          var l = e.apply(t, r);
          a(void 0);
        });
      };
    }

    e.exports = r;
  }, function (e, t) {
    e.exports = function (e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t
      };
    };
  }, function (e, t, n) {
    var r = n(21);

    e.exports = function (e) {
      return r[e + "Prototype"];
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(293).charAt,
        o = n(62),
        i = n(296),
        a = o.set,
        s = o.getterFor("String Iterator");
    i(String, "String", function (e) {
      a(this, {
        type: "String Iterator",
        string: String(e),
        index: 0
      });
    }, function () {
      var e,
          t = s(this),
          n = t.string,
          o = t.index;
      return o >= n.length ? {
        value: void 0,
        done: !0
      } : (e = r(n, o), t.index += e.length, {
        value: e,
        done: !1
      });
    });
  }, function (e, t, n) {
    var r,
        o,
        i,
        a = n(593),
        s = n(19),
        l = n(35),
        u = n(44),
        c = n(31),
        d = n(122),
        f = n(123),
        p = s.WeakMap,
        h = function h(e) {
      return i(e) ? o(e) : r(e, {});
    },
        m = function m(e) {
      return function (t) {
        var n;
        if (!l(t) || (n = o(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
        return n;
      };
    };

    if (a) {
      var g = new p(),
          v = g.get,
          y = g.has,
          b = g.set;
      r = function r(e, t) {
        return b.call(g, e, t), t;
      }, o = function o(e) {
        return v.call(g, e) || {};
      }, i = function i(e) {
        return y.call(g, e);
      };
    } else {
      var _ = d("state");

      f[_] = !0, r = function r(e, t) {
        return u(e, _, t), t;
      }, o = function o(e) {
        return c(e, _) ? e[_] : {};
      }, i = function i(e) {
        return c(e, _);
      };
    }

    e.exports = {
      set: r,
      get: o,
      has: i,
      enforce: h,
      getterFor: m
    };
  }, function (e, t) {
    e.exports = !0;
  }, function (e, t, n) {
    var r = n(164);

    e.exports = function (e) {
      return Object(r(e));
    };
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, n) {
    var r = n(44);

    e.exports = function (e, t, n, o) {
      o && o.enumerable ? e[t] = n : r(e, t, n);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getMessageFromBrowserError = t.isCustomizedI18nKey = t.doesI18NKeyExist = t.getI18NParams = t.getMessageKey = t.getMessage = t.default = void 0;

    var o,
        i = r(n(42)),
        a = n(1),
        s = r(n(72)),
        l = r(n(38)),
        u = n(108),
        c = n(8),
        d = ["enroll-authenticator.security_question.credentials.questionKey.", "challenge-authenticator.security_question.credentials.questionKey."],
        f = {
      "identify.identifier": "primaryauth.username.placeholder",
      "select-authenticator-unlock-account.identifier": "primaryauth.username.placeholder",
      "identify.credentials.passcode": "primaryauth.password.placeholder",
      "identify.rememberMe": "oie.remember",
      "identify-recovery.identifier": "password.forgot.email.or.username.placeholder",
      "select-authenticator-enroll.authenticator.duo": "factor.duo",
      "select-authenticator-enroll.authenticator.google_otp": "oie.google_authenticator.label",
      "select-authenticator-enroll.authenticator.okta_email": "oie.email.label",
      "select-authenticator-enroll.authenticator.okta_password": "oie.password.label",
      "select-authenticator-enroll.authenticator.okta_verify": "oie.okta_verify.label",
      "select-authenticator-enroll.authenticator.phone_number": "oie.phone.label",
      "select-authenticator-enroll.authenticator.rsa_token": "factor.totpHard.rsaSecurId",
      "select-authenticator-enroll.authenticator.security_question": "oie.security.question.label",
      "select-authenticator-enroll.authenticator.symantec_vip": "factor.totpHard.symantecVip",
      "select-authenticator-enroll.authenticator.webauthn": "oie.webauthn.label",
      "select-authenticator-authenticate.authenticator.duo": "factor.duo",
      "select-authenticator-authenticate.authenticator.google_otp": "oie.google_authenticator.label",
      "select-authenticator-authenticate.authenticator.okta_email": "oie.email.label",
      "select-authenticator-authenticate.authenticator.okta_password": "oie.password.label",
      "select-authenticator-authenticate.authenticator.okta_verify.push": "oie.okta_verify.push.title",
      "select-authenticator-authenticate.authenticator.okta_verify.signed_nonce": "oie.okta_verify.signed_nonce.label",
      "select-authenticator-authenticate.authenticator.okta_verify.totp": "oie.okta_verify.totp.title",
      "select-authenticator-authenticate.authenticator.phone_number": "oie.phone.label",
      "select-authenticator-authenticate.authenticator.rsa_token": "factor.totpHard.rsaSecurId",
      "select-authenticator-authenticate.authenticator.security_question": "oie.security.question.label",
      "select-authenticator-authenticate.authenticator.symantec_vip": "factor.totpHard.symantecVip",
      "select-authenticator-authenticate.authenticator.webauthn": "oie.webauthn.label",
      "select-authenticator-unlock-account.authenticator.okta_email": "oie.email.label",
      "select-authenticator-unlock-account.authenticator.phone_number": "oie.phone.label",
      "authenticator-verification-data.okta_verify.authenticator.methodType.signed_nonce": "oie.okta_verify.signed_nonce.label",
      "authenticator-verification-data.okta_verify.authenticator.methodType.push": "oie.okta_verify.push.title",
      "authenticator-verification-data.okta_verify.authenticator.methodType.totp": "oie.okta_verify.totp.title",
      "authenticator-enrollment-data.phone_number.authenticator.phoneNumber": "mfa.phoneNumber.placeholder",
      "authenticator-enrollment-data.phone_number.authenticator.methodType.sms": "oie.phone.enroll.sms.label",
      "authenticator-enrollment-data.phone_number.authenticator.methodType.voice": "oie.phone.enroll.voice.label",
      "enroll-authenticator.okta_password.credentials.passcode": "oie.password.passwordLabel",
      "enroll-authenticator.okta_email.credentials.passcode": "mfa.challenge.enterCode.placeholder",
      "enroll-authenticator.phone_number.credentials.passcode": "mfa.challenge.enterCode.placeholder",
      "enroll-authenticator.security_question.sub_schema_local_credentials.0": "oie.security.question.questionKey.label",
      "enroll-authenticator.security_question.sub_schema_local_credentials.1": "oie.security.question.createQuestion.label",
      "enroll-authenticator.security_question.credentials.answer": "mfa.challenge.answer.placeholder",
      "enroll-authenticator.security_question.credentials.question": "oie.security.question.createQuestion.label",
      "enroll-authenticator.security_question.credentials.questionKey": "oie.security.question.questionKey.label",
      "enroll-authenticator.google_otp.credentials.passcode": "oie.google_authenticator.otp.enterCodeText",
      "enroll-authenticator.onprem_mfa.credentials.clientData": "enroll.onprem.username.placeholder",
      "enroll-authenticator.onprem_mfa.credentials.passcode": "enroll.onprem.passcode.placeholder",
      "enroll-authenticator.rsa_token.credentials.clientData": "enroll.onprem.username.placeholder",
      "enroll-authenticator.rsa_token.credentials.passcode": "enroll.onprem.passcode.placeholder",
      "enroll-authenticator.symantec_vip.credentials.credentialId": "enroll.symantecVip.credentialId.placeholder",
      "enroll-authenticator.symantec_vip.credentials.passcode": "enroll.symantecVip.passcode1.placeholder",
      "enroll-authenticator.symantec_vip.credentials.nextPasscode": "enroll.symantecVip.passcode2.placeholder",
      "enrollment-channel-data.email": "oie.enroll.okta_verify.channel.email.label",
      "select-enrollment-channel.authenticator.channel.qrcode": "oie.enroll.okta_verify.select.channel.qrcode.label",
      "select-enrollment-channel.authenticator.channel.email": "oie.enroll.okta_verify.select.channel.email.label",
      "select-enrollment-channel.authenticator.channel.sms": "oie.enroll.okta_verify.select.channel.sms.label",
      "challenge-authenticator.okta_email.credentials.passcode": "mfa.challenge.enterCode.placeholder",
      "challenge-authenticator.okta_password.credentials.passcode": "mfa.challenge.password.placeholder",
      "challenge-authenticator.phone_number.credentials.passcode": "mfa.challenge.enterCode.placeholder",
      "challenge-authenticator.security_question.credentials.answer": "mfa.challenge.answer.placeholder",
      "challenge-authenticator.okta_verify.credentials.totp": "oie.okta_verify.totp.enterCodeText",
      "challenge-authenticator.google_otp.credentials.passcode": "oie.google_authenticator.otp.enterCodeText",
      "challenge-authenticator.onprem_mfa.credentials.passcode": "mfa.challenge.enterCode.placeholder",
      "challenge-authenticator.rsa_token.credentials.passcode": "mfa.challenge.enterCode.placeholder",
      "challenge-authenticator.custom_otp.credentials.passcode": "oie.custom_otp.verify.passcode.label",
      "challenge-authenticator.symantec_vip.credentials.passcode": "oie.symantecVip.verify.passcode.label",
      "challenge-authenticator.credentials.passcode": "oie.password.label",
      "reset-authenticator.okta_password.credentials.passcode": "oie.password.newPasswordLabel",
      "reenroll-authenticator.okta_password.credentials.passcode": "oie.password.newPasswordLabel",
      "reenroll-authenticator-warning.okta_password.credentials.passcode": "oie.password.newPasswordLabel",
      incorrectPassword: "oie.password.incorrect.message",
      "enroll-profile.userProfile.lastName": "oie.user.profile.lastname",
      "enroll-profile.userProfile.firstName": "oie.user.profile.firstname",
      "enroll-profile.userProfile.email": "oie.user.profile.primary.email",
      "user-code.userCode": "device.code.activate.label",
      "api.authn.poll.error.push_rejected": "oktaverify.rejected",
      "oie.authenticator.duo.method.duo.verification_timeout": "oie.authenticator.duo.error",
      "oie.authenticator.duo.method.duo.verification_failed": "oie.authenticator.duo.error",
      "idx.email.verification.required": "registration.complete.confirm.text",
      tooManyRequests: "oie.tooManyRequests",
      "api.users.auth.error.POST_PASSWORD_UPDATE_AUTH_FAILURE": "oie.post.password.update.auth.failure.error",
      "security.access_denied": "errors.E0000006",
      "api.factors.error.sms.invalid_phone": "oie.phone.invalid",
      "app.ldap.password.reset.failed": "errors.E0000017"
    },
        p = (0, i.default)({}, c.FORMS.ENROLL_AUTHENTICATOR, (o = {}, (0, i.default)(o, c.AUTHENTICATOR_KEY.ON_PREM, {
      getParam: u.getAuthenticatorDisplayName
    }), (0, i.default)(o, c.AUTHENTICATOR_KEY.RSA, {
      getParam: u.getAuthenticatorDisplayName
    }), o)),
        h = {
      "registration.error.invalidLoginEmail": {
        Email: "Email"
      },
      "registration.error.doesNotMatchPattern": {
        Email: "Email"
      },
      "registration.error.notUniqueWithinOrg": {
        Email: "Email"
      }
    },
        m = function m(e, t) {
      var n = e;
      return h[n][t] ? n += ".".concat(t) : n += ".custom", n;
    },
        g = function g(e, t) {
      var n = [],
          r = e.name;

      if (p[r] && p[r][t]) {
        var o = p[r][t],
            i = o.getParam(e);
        n.push(i);
      }

      return n;
    };

    t.getI18NParams = g;

    var v = function v(e) {
      var t;
      return d.forEach(function (n) {
        if (0 === e.indexOf(n)) {
          var r = e.replace(n, "");
          t = "security.".concat(r);
        }
      }), f[e] && (t = f[e]), t && !s.default.login[t] && (l.default.warn("expect i18n key ".concat(t, " for ").concat(e, " but not found in 'login' bundle.")), t = null), t;
    },
        y = function y(e) {
      return !!s.default.login[e];
    };

    t.doesI18NKeyExist = y;

    var b = function b(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
          r = v(e);
      return r ? (0, a.loc)(r, "login", n) : (l.default.warn("Avoid rendering unlocalized text sent from the API: ".concat(t)), t);
    },
        _ = function e(t, n) {
      var r, o;

      if (!(!1 === n.mutable && n.name.indexOf("questionKey") < 0)) {
        l.default.info("i18n label transformer"), l.default.info("\t remediationName: ", t.name), l.default.info("\t uiSchema: ", JSON.stringify(n));
        var i = null === (r = t.relatesTo) || void 0 === r ? void 0 : null === (o = r.value) || void 0 === o ? void 0 : o.key,
            s = i ? ".".concat(t.relatesTo.value.key) : "",
            u = "".concat(t.name).concat(s, "."),
            d = "".concat(u).concat(n.name);

        if ("text" === n.type && n.name.indexOf("questionKey") >= 0 && "custom" !== n.value && (d = "".concat(d, ".").concat(n.value)), "checkbox" === n.type && n.placeholder && (l.default.info("\t 1: ", d), n.placeholder = b(d, n.placeholder)), n.label) {
          l.default.info("\t 2: ", d);
          var f = g(t, i);
          n.label = b(d, n.label, f);
        }

        a.$.isPlainObject(n.options) && (n.options = a._.mapObject(n.options, function (e, t) {
          var n = "".concat(d, ".").concat(t);
          return l.default.info("\t 3: ", n), b(n, e);
        })), Array.isArray(n.options) && n.options.forEach(function (e) {
          if (e.label) {
            var t;

            if (e.authenticatorKey) {
              var n;
              t = "".concat(d, ".").concat(e.authenticatorKey);
              var r = null === (n = e.value) || void 0 === n ? void 0 : n.methodType;
              e.authenticatorKey === c.AUTHENTICATOR_KEY.OV && r && (t = "".concat(t, ".").concat(r));
            } else void 0 !== e.value && (t = "".concat(d, ".").concat(e.value));

            l.default.info("\t 4: ", t), e.label = b(t, e.label);
          }
        }), Array.isArray(n.optionsUiSchemas) && n.optionsUiSchemas.forEach(function (n) {
          n.forEach(function (n) {
            return e(t, n);
          });
        });
      }
    },
        w = function w(e) {
      return e.startsWith("authfactor.webauthn.error");
    },
        E = function E(e) {
      var t;

      if (null === (t = e.i18n) || void 0 === t ? void 0 : t.key) {
        var n,
            r = e.i18n.key,
            o = e.i18n.params || [];

        if (1 === o.length && "" === o[0] && (o = []), f[null === (n = e.i18n) || void 0 === n ? void 0 : n.key]) {
          var i;
          r = f[null === (i = e.i18n) || void 0 === i ? void 0 : i.key];
        } else if (h[r]) {
          var u,
              c = null === (u = e.i18n.params) || void 0 === u ? void 0 : u[0];
          r = m(r, c), o = r.endsWith("custom") ? [c] : [];
        }

        if (s.default.login[r]) return l.default.info("Override messages using i18n key ".concat(r)), (0, a.loc)(r, "login", o);
        if (w(r)) return (0, a.loc)("authfactor.webauthn.error", "login");
      }

      return l.default.warn("Avoid rendering unlocalized text sent from the API: ".concat(e.message)), e.message;
    };

    t.getMessage = E;

    var O = function O(e) {
      if (e.name) {
        var t = "oie.browser.error.".concat(e.name);
        if (s.default.login[t]) return l.default.info("Override messages using i18n key ".concat(t)), (0, a.loc)(t, "login");
      }

      return e.message;
    };

    t.getMessageFromBrowserError = O;

    var S = function S(e) {
      var t;
      return (null === e || void 0 === e ? void 0 : null === (t = e.i18n) || void 0 === t ? void 0 : t.key) || "";
    };

    t.getMessageKey = S;

    var x = function x(e) {
      var t;
      return Array.isArray(e.remediations) && e.remediations.filter(function (e) {
        return Array.isArray(e.uiSchema) && e.uiSchema.length;
      }).forEach(function (e) {
        e.uiSchema.forEach(function (t) {
          return _(e, t);
        });
      }), Array.isArray(null === (t = e.messages) || void 0 === t ? void 0 : t.value) && e.messages.value.forEach(function (e) {
        e.message = E(e);
      }), e;
    };

    t.default = x;

    var T = function T(e, t) {
      var n = t.get("languageCode"),
          r = t.get("i18n");
      return !!(r && r[n] && r[n][e]);
    };

    t.isCustomizedI18nKey = T;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getReloadPageButtonLink = t.getSkipSetupLink = t.getBackToSignInLink = t.getSignOutLink = t.getSignUpLink = t.goBackLink = t.getForgotPasswordLink = t.getSwitchAuthenticatorLink = void 0;

    var r = n(1),
        o = n(8),
        i = o.ACTIONS.ENROLLED_PASSWORD_RECOVERY_LINK,
        a = o.ACTIONS.ORG_PASSWORD_RECOVERY_LINK,
        s = function s(e) {
      return e.getRemediationAuthenticationOptions(o.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE).length > 1 ? [{
        type: "link",
        label: (0, r.loc)("oie.verification.switch.authenticator", "login"),
        name: "switchAuthenticator",
        formName: o.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE
      }] : e.getRemediationAuthenticationOptions(o.FORMS.SELECT_AUTHENTICATOR_ENROLL).length > 1 ? [{
        type: "link",
        label: (0, r.loc)("oie.enroll.switch.authenticator", "login"),
        name: "switchAuthenticator",
        formName: o.FORMS.SELECT_AUTHENTICATOR_ENROLL
      }] : [];
    };

    t.getSwitchAuthenticatorLink = s;

    var l = function l(e, t) {
      var n = {
        type: "link",
        label: (0, r.loc)("forgotpassword", "login"),
        name: "forgot-password"
      },
          o = t.get("helpLinks.forgotPassword");
      return o ? [Object.assign({}, {
        href: o,
        label: (0, r.loc)("forgotpassword", "login"),
        name: "forgot-password"
      })] : e.getActionByPath(a) ? [Object.assign({}, n, {
        actionPath: a
      })] : e.getActionByPath(i) ? [Object.assign({}, n, {
        actionPath: i
      })] : [];
    };

    t.getForgotPasswordLink = l;

    var u = function u(e) {
      return e.hasRemediationObject(o.FORMS.SELECT_AUTHENTICATOR_ENROLL) ? [{
        type: "link",
        label: (0, r.loc)("oie.go.back", "login"),
        name: "go-back",
        formName: o.FORMS.SELECT_AUTHENTICATOR_ENROLL
      }] : [];
    };

    t.goBackLink = u;

    var c = function c(e) {
      return e.hasRemediationObject(o.FORMS.SKIP) ? [{
        type: "link",
        label: (0, r.loc)("oie.enroll.skip.setup", "login"),
        name: "skip-setup",
        actionPath: o.FORMS.SKIP
      }] : [];
    };

    t.getSkipSetupLink = c;

    var d = function d(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return (null === e || void 0 === e ? void 0 : e.get("signOutLink")) ? [{
        label: (0, r.loc)("signout", "login"),
        name: "cancel",
        href: e.get("signOutLink")
      }] : [{
        actionPath: "cancel",
        label: t.label ? t.label : (0, r.loc)("backToSignin", "login"),
        name: "cancel",
        type: "link"
      }];
    };

    t.getSignOutLink = d;

    var f = function f(e) {
      return [{
        type: "link",
        label: (0, r.loc)("backToSignin", "login"),
        name: "go-back",
        href: null === e || void 0 === e ? void 0 : e.get("baseUrl")
      }];
    };

    t.getBackToSignInLink = f;

    var p = function p() {
      return [{
        type: "link",
        label: (0, r.loc)("oie.try.again", "login"),
        name: "try-again",
        href: window.location,
        className: "button button-primary text-align-c"
      }];
    };

    t.getReloadPageButtonLink = p;

    var h = function h(e, t) {
      var n = [];

      if (e.hasRemediationObject(o.FORMS.SELECT_ENROLL_PROFILE)) {
        var i = {
          type: "link",
          label: (0, r.loc)("oie.registration.form.title", "login"),
          name: "enroll"
        };
        r._.isFunction(t.get("registration.click")) ? i.clickHandler = t.get("registration.click") : i.actionPath = o.FORMS.SELECT_ENROLL_PROFILE, n.push(i);
      }

      return n;
    };

    t.getSignUpLink = h;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var t = Object(o.a)(e), n = t.length, r = Array(n), i = 0; i < n; i++) {
        r[i] = e[t[i]];
      }

      return r;
    }

    t.a = r;
    var o = n(22);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n, l) {
      if (l = l || [], t || 0 === t) {
        if (t <= 0) return l.concat(e);
      } else t = 1 / 0;

      for (var u = l.length, c = 0, d = Object(o.a)(e); c < d; c++) {
        var f = e[c];
        if (Object(i.a)(f) && (Object(a.a)(f) || Object(s.a)(f))) {
          if (t > 1) r(f, t - 1, n, l), u = l.length;else for (var p = 0, h = f.length; p < h;) {
            l[u++] = f[p++];
          }
        } else n || (l[u++] = f);
      }

      return l;
    }

    t.a = r;
    var o = n(33),
        i = n(30),
        a = n(54),
        s = n(142);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      t = Object(o.a)(t, n);

      for (var r = !Object(i.a)(e) && Object(a.a)(e), s = (r || e).length, l = Array(s), u = 0; u < s; u++) {
        var c = r ? r[u] : u;
        l[u] = t(e[c], c, e);
      }

      return l;
    }

    t.a = r;
    var o = n(27),
        i = n(30),
        a = n(22);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      if (!e) return {};
      var t = {};
      return h.default.each(h.default.keys(e), function (n) {
        t[n.toLowerCase()] = e[n];
      }), h.default.mapObject(t, function (e) {
        var t = {
          login: {},
          country: {}
        };
        if (!h.default.isObject(e)) throw new Error('Invalid format for "i18n"');
        return h.default.each(e, function (e, n) {
          var r = n.split(/^country\./);
          r.length > 1 ? t.country[r[1]] = e : t.login[r[0]] = e;
        }), t;
      });
    }

    function o() {
      var e = JSON.parse(localStorage.getItem(v));
      return e && e.version === u.default.version || (e = {
        version: u.default.version
      }), e;
    }

    function i(e, t, n) {
      var r = o();
      r[e] = {
        login: t,
        country: n
      }, localStorage.setItem(v, JSON.stringify(r));
    }

    function a(e, t, n) {
      var r, o;
      r = t.replace("-", "_"), o = n.rewrite(encodeURI("/labels/json/".concat(e, "_").concat(r, ".json")));
      var i = {
        Accept: "application/json",
        "Content-Type": "text/plain"
      };
      return (0, c.default)(n.baseUrl + o, {
        method: "GET",
        headers: i,
        mode: "no-cors"
      }).then(function (e) {
        return e.text();
      }).then(function (e) {
        return JSON.parse(e);
      });
    }

    function s(e, t) {
      if ("en" === e || !h.default.contains(u.default.supportedLanguages, e)) return (0, p.default)({});
      var n = !m.default.localStorageIsNotSupported();

      if (n) {
        var r = o();
        if (r[e]) return (0, p.default)(r[e]);
      }

      return p.default.all([a("login", e, t), a("country", e, t)]).spread(function (t, r) {
        return n && i(e, t, r), {
          login: t,
          country: r
        };
      }).catch(function () {
        return g.default.warn("Unable to load language: " + e), {};
      });
    }

    var l = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var u = l(n(155)),
        c = l(n(249)),
        d = l(n(472)),
        f = l(n(473)),
        p = l(n(16)),
        h = l(n(110)),
        m = l(n(25)),
        g = l(n(38)),
        v = "osw.languages",
        y = {
      login: f.default,
      country: d.default,
      courage: f.default,
      currentLanguage: null,
      isLoaded: function isLoaded(e) {
        return this.currentLanguage === e;
      },
      remove: function remove() {
        this.currentLanguage = null;
      },
      loadLanguage: function loadLanguage(e, t, n) {
        var o = this,
            i = r(t),
            a = e.toLowerCase();
        return s(e, n).then(function (t) {
          o.login = h.default.extend({}, f.default, t.login), o.country = h.default.extend({}, d.default, t.country), o.courage = h.default.extend({}, f.default, t.login), i[a] && (h.default.extend(o.login, i[a].login), h.default.extend(o.country, i[a].country), h.default.extend(o.courage, i[a].login)), o.currentLanguage = e;
        });
      }
    };
    t.default = y;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return i._.find(e.getChildren(), function (e) {
        return e instanceof i.Form;
      });
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = n(1),
        a = o(n(16)),
        s = i.Controller.extend({
      addListeners: function addListeners() {
        this.listenTo(this.model, "save", function () {
          var e = r(this);
          e.disableSubmitButton && !e.disableSubmitButton() || this.toggleButtonState(!0);
        }), this.listenTo(this.model, "error", function () {
          this.toggleButtonState(!1);
        }), this.addModelListeners(this.model);
      },
      addModelListeners: function addModelListeners(e) {
        var t = this,
            n = function n(e) {
          t.options.appState.set("transaction", e);
        },
            r = function r(e) {
          t.options.appState.set("transactionError", e);
        };

        this.listenTo(e, "setTransaction", n), this.listenTo(e, "setTransactionError", r);
        var o = e.get("backupFactor");
        o && (this.listenTo(o, "setTransaction", n), this.listenTo(o, "setTransactionError", r));
      },
      fetchInitialData: function fetchInitialData() {
        return (0, a.default)();
      },
      trapAuthResponse: function trapAuthResponse() {
        return !1;
      },
      toJSON: function toJSON() {
        var e = i.Controller.prototype.toJSON.apply(this, arguments);
        return i._.extend(i._.pick(this.options, "appState"), e);
      },
      toggleButtonState: function toggleButtonState(e) {
        this.$el.find(".button").toggleClass("link-button-disabled", e).prop("disabled", e);
      },
      postRenderAnimation: function postRenderAnimation() {
        this.trigger("pageRendered", {
          page: this.className
        }), this.trigger("afterRender", {
          controller: this.className
        });
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(72)),
        a = r(n(500)),
        s = {};
    s.getCountries = function () {
      var e = o._.omit(i.default.country, "HM", "BV", "TF"),
          t = o._.map(e, function (e, t) {
        return {
          name: e,
          code: t
        };
      });

      t = o._.sortBy(t, "name");
      var n = {};
      return o._.each(t, function (e) {
        n[e.code] = e.name;
      }), n;
    }, s.getCallingCodeForCountry = function (e) {
      return a.default[e];
    };
    var l = s;
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return new s.default(e);
    }

    function o(e, t, n) {
      return t = t.map(function (e) {
        return {
          type: "FIDO_2_0",
          algorithm: e.algorithm
        };
      }), r(window.msCredentials.makeCredential(e, t, n).then(function (e) {
        return Object.freeze({
          credential: {
            id: e.id
          },
          publicKey: JSON.parse(e.publicKey),
          attestation: e.attestation
        });
      }));
    }

    function i(e, t) {
      var n = t.map(function (e) {
        return {
          type: "FIDO_2_0",
          id: e.id
        };
      }),
          o = {
        accept: n
      };
      return r(window.msCredentials.getAssertion(e, o).then(function (e) {
        var t = e.signature;
        return Object.freeze({
          credential: {
            id: e.id
          },
          clientData: t.clientData,
          authenticatorData: t.authnrData,
          signature: t.signature
        });
      }));
    }

    var a = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var s = a(n(16)),
        l = a(n(158)),
        u = {
      makeCredential: o,
      getAssertion: i,
      isAvailable: function isAvailable() {
        return Object.prototype.hasOwnProperty.call(window, "msCredentials");
      },
      isNewApiAvailable: function isNewApiAvailable() {
        return navigator && navigator.credentials && navigator.credentials.create;
      },
      isWebauthnOrU2fAvailable: function isWebauthnOrU2fAvailable() {
        return this.isNewApiAvailable() || l.default.isU2fAvailable();
      }
    };
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = r(n(117)),
        s = a.default.extend({
      template: i.default.template({
        1: function _(e, t, n, r, i) {
          var a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="' + u((a = null != (a = c(n, "factorPageCustomLinkHref") || (null != t ? c(t, "factorPageCustomLinkHref") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "factorPageCustomLinkHref",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 40
              },
              end: {
                line: 1,
                column: 68
              }
            }
          }) : a)) + '" data-se="factor-page-custom-link" class="link js-factor-page-custom-link" rel="noopener noreferrer" target="_blank">' + u((a = null != (a = c(n, "factorPageCustomLinkText") || (null != t ? c(t, "factorPageCustomLinkText") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "factorPageCustomLinkText",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 186
              },
              end: {
                line: 1,
                column: 214
              }
            }
          }) : a)) + "</a>";
        },
        3: function _(e, t, n, r, i) {
          var a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link ' + u((a = null != (a = c(n, "linkClassName") || (null != t ? c(t, "linkClassName") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "linkClassName",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 265
              },
              end: {
                line: 1,
                column: 282
              }
            }
          }) : a)) + '" data-se="signout-link">' + u((a = null != (a = c(n, "linkText") || (null != t ? c(t, "linkText") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "linkText",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 307
              },
              end: {
                line: 1,
                column: 319
              }
            }
          }) : a)) + "</a>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return (null != (i = s(n, "if").call(a, null != t ? s(t, "hasFactorPageCustomLink") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 225
              }
            }
          })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "showLink") : t, {
            name: "if",
            hash: {},
            fn: e.program(3, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 225
              },
              end: {
                line: 1,
                column: 330
              }
            }
          })) ? i : "");
        },
        useData: !0
      }),
      className: "auth-footer clearfix",
      getTemplateData: function getTemplateData() {
        var e = a.default.prototype.getTemplateData.apply(this, arguments),
            t = this.settings.get("helpLinks.factorPage.href"),
            n = this.settings.get("helpLinks.factorPage.text"),
            r = !this.settings.get("features.hideSignOutLinkInMFA") && !this.settings.get("features.mfaOnlyFlow");
        return Object.assign({}, e, {
          hasFactorPageCustomLink: n && t,
          factorPageCustomLinkHref: t,
          factorPageCustomLinkText: n,
          showLink: r
        });
      }
    });
    t.default = s;
  }, function (e, t) {
    var n = {}.toString;

    e.exports = function (e) {
      return n.call(e).slice(8, -1);
    };
  }, function (e, t, n) {
    var r = n(79);

    e.exports = function (e, t, n) {
      if (r(e), void 0 === t) return e;

      switch (n) {
        case 0:
          return function () {
            return e.call(t);
          };

        case 1:
          return function (n) {
            return e.call(t, n);
          };

        case 2:
          return function (n, r) {
            return e.call(t, n, r);
          };

        case 3:
          return function (n, r, o) {
            return e.call(t, n, r, o);
          };
      }

      return function () {
        return e.apply(t, arguments);
      };
    };
  }, function (e, t) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(String(e) + " is not a function");
      return e;
    };
  }, function (e, t, n) {
    e.exports = n(587);
  }, function (e, t, n) {
    var r = n(166),
        o = Math.min;

    e.exports = function (e) {
      return e > 0 ? o(r(e), 9007199254740991) : 0;
    };
  }, function (e, t, n) {
    var r = n(26),
        o = n(20),
        i = n(31),
        a = Object.defineProperty,
        s = {},
        l = function l(e) {
      throw e;
    };

    e.exports = function (e, t) {
      if (i(s, e)) return s[e];
      t || (t = {});
      var n = [][e],
          u = !!i(t, "ACCESSORS") && t.ACCESSORS,
          c = i(t, 0) ? t[0] : l,
          d = i(t, 1) ? t[1] : void 0;
      return s[e] = !!n && !o(function () {
        if (u && !r) return !0;
        var e = {
          length: -1
        };
        u ? a(e, 1, {
          enumerable: !0,
          get: l
        }) : e[1] = 1, n.call(e, c, d);
      });
    };
  }, function (e, t, n) {
    var r = n(173),
        o = n(77),
        i = n(14),
        a = i("toStringTag"),
        s = "Arguments" == o(function () {
      return arguments;
    }()),
        l = function l(e, t) {
      try {
        return e[t];
      } catch (e) {}
    };

    e.exports = r ? o : function (e) {
      var t, n, r;
      return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = l(t = Object(e), a)) ? n : s ? o(t) : "Object" == (r = o(t)) && "function" == typeof t.callee ? "Arguments" : r;
    };
  }, function (e, t, n) {
    n(174);
    var r = n(598),
        o = n(19),
        i = n(83),
        a = n(44),
        s = n(65),
        l = n(14),
        u = l("toStringTag");

    for (var c in r) {
      var d = o[c],
          f = d && d.prototype;
      f && i(f) !== u && a(f, u, c), s[c] = s.Array;
    }
  }, function (e, t) {
    var n = {}.hasOwnProperty;

    e.exports = function (e, t) {
      return n.call(e, t);
    };
  }, function (e, t, n) {
    function r(e, t, n, r, o, a, s) {
      try {
        var l = e[a](s),
            u = l.value;
      } catch (e) {
        return void n(e);
      }

      l.done ? t(u) : i.resolve(u).then(r, o);
    }

    function o(e) {
      return function () {
        var t = this,
            n = arguments;
        return new i(function (o, i) {
          function a(e) {
            r(l, o, i, a, s, "next", e);
          }

          function s(e) {
            r(l, o, i, a, s, "throw", e);
          }

          var l = e.apply(t, n);
          a(void 0);
        });
      };
    }

    var i = n(640);
    e.exports = o;
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return i;
    }), n.d(t, "b", function () {
      return a;
    });
    var r = n(11),
        o = n(389),
        i = r.s && Object(o.a)(new DataView(new ArrayBuffer(8))),
        a = "undefined" != typeof Map && Object(o.a)(new Map());
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      if (!Object(o.a)(e)) return [];
      var t = [];

      for (var n in e) {
        t.push(n);
      }

      return i.h && Object(a.a)(e, t), t;
    }

    t.a = r;
    var o = n(53),
        i = n(11),
        a = n(207);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return o.a.toPath(e);
    }

    t.a = r;
    var o = n(29);
    n(216);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      if (void 0 === t) return e;

      switch (null == n ? 3 : n) {
        case 1:
          return function (n) {
            return e.call(t, n);
          };

        case 3:
          return function (n, r, o) {
            return e.call(t, n, r, o);
          };

        case 4:
          return function (n, r, o, i) {
            return e.call(t, n, r, o, i);
          };
      }

      return function () {
        return e.apply(t, arguments);
      };
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      var r = [];
      return t = Object(o.a)(t, n), Object(i.a)(e, function (e, n, o) {
        t(e, n, o) && r.push(e);
      }), r;
    }

    t.a = r;
    var o = n(27),
        i = n(55);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n, r) {
      return Object(o.a)(e) || (e = Object(i.a)(e)), ("number" != typeof n || r) && (n = 0), Object(a.a)(e, t, n) >= 0;
    }

    t.a = r;
    var o = n(30),
        i = n(69),
        a = n(232);
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(16)),
        a = r(n(5)),
        s = ["OAuthError", "AuthSdkError", "AuthPollStopError", "AuthApiError"],
        l = o.Model.extend({
      doTransaction: function doTransaction(e, t) {
        var n = this;
        return e.call(this, this.appState.get("transaction")).then(function (e) {
          return n.trigger("setTransaction", e), e;
        }).catch(function (e) {
          if ("AuthPollStopError" !== e.name && e.name !== a.default.AUTH_STOP_POLL_INITIATION_ERROR && e.name !== a.default.WEBAUTHN_ABORT_ERROR && (n.trigger("error", n, e.xhr), n.trigger("setTransactionError", e), t || -1 === o._.indexOf(s, e.name))) throw e;
        });
      },
      manageTransaction: function manageTransaction(e) {
        var t = this,
            n = e.call(this, this.appState.get("transaction"), o._.bind(this.setTransaction, this));
        return i.default.isPromiseAlike(n) ? n.catch(function (e) {
          "AuthPollStopError" !== e.name && e.name !== a.default.AUTH_STOP_POLL_INITIATION_ERROR && e.name !== a.default.WEBAUTHN_ABORT_ERROR && (t.trigger("error", t, e.xhr), t.trigger("setTransactionError", e));
        }) : i.default.resolve(n);
      },
      startTransaction: function startTransaction(e) {
        var t = this,
            n = e.call(this, this.settings.getAuthClient());
        return i.default.isPromiseAlike(n) ? n.then(function (e) {
          return t.trigger("setTransaction", e), e;
        }).catch(function (e) {
          throw t.trigger("error", t, e.xhr), t.trigger("setTransactionError", e), e;
        }) : i.default.resolve(n);
      },
      setTransaction: function setTransaction(e) {
        this.appState.set("transaction", e);
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = {};
    o.validateUsername = function (e) {
      var t = e.get("username");
      if (t && t.length > 256) return {
        username: (0, r.loc)("model.validation.field.username", "login")
      };
    }, o.validateFieldsMatch = function (e, t, n, r) {
      if (e.get(t) !== e.get(n)) {
        var o = {};
        return o[n] = r, o;
      }
    }, o.validatePasswordMatch = function (e) {
      return o.validateFieldsMatch(e, "newPassword", "confirmPassword", (0, r.loc)("password.error.match", "login"));
    };
    var i = o;
    t.default = i;
  }, function (e, t, n) {
    var r = n(26),
        o = n(120),
        i = n(59),
        a = n(43),
        s = n(121),
        l = n(31),
        u = n(285),
        c = Object.getOwnPropertyDescriptor;
    t.f = r ? c : function (e, t) {
      if (e = a(e), t = s(t, !0), u) try {
        return c(e, t);
      } catch (e) {}
      if (l(e, t)) return i(!o.f.call(e, t), e[t]);
    };
  }, function (e, t, n) {
    e.exports = n(592);
  }, function (e, t, n) {
    var r = n(300),
        o = n(172);

    e.exports = Object.keys || function (e) {
      return r(e, o);
    };
  }, function (e, t, n) {
    var r = n(36),
        o = n(306),
        i = n(81),
        a = n(78),
        s = n(99),
        l = n(307),
        u = function u(e, t) {
      this.stopped = e, this.result = t;
    };

    (e.exports = function (e, t, n, c, d) {
      var f,
          p,
          h,
          m,
          g,
          v,
          y,
          b = a(t, n, c ? 2 : 1);
      if (d) f = e;else {
        if ("function" != typeof (p = s(e))) throw TypeError("Target is not iterable");

        if (o(p)) {
          for (h = 0, m = i(e.length); m > h; h++) {
            if ((g = c ? b(r(y = e[h])[0], y[1]) : b(e[h])) && g instanceof u) return g;
          }

          return new u(!1);
        }

        f = p.call(e);
      }

      for (v = f.next; !(y = v.call(f)).done;) {
        if ("object" == typeof (g = l(f, b, y.value, c)) && g && g instanceof u) return g;
      }

      return new u(!1);
    }).stop = function (e) {
      return new u(!0, e);
    };
  }, function (e, t, n) {
    var r = n(83),
        o = n(65),
        i = n(14),
        a = i("iterator");

    e.exports = function (e) {
      if (void 0 != e) return e[a] || e["@@iterator"] || o[r(e)];
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(79),
        o = function o(e) {
      var t, n;
      this.promise = new e(function (e, r) {
        if (void 0 !== t || void 0 !== n) throw TypeError("Bad Promise constructor");
        t = e, n = r;
      }), this.resolve = r(t), this.reject = r(n);
    }; // 25.4.1.5 NewPromiseCapability(C)


    e.exports.f = function (e) {
      return new o(e);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(121),
        o = n(48),
        i = n(59);

    e.exports = function (e, t, n) {
      var a = r(t);
      a in e ? o.f(e, a, i(0, n)) : e[a] = n;
    };
  }, function (e, t, n) {
    var r = n(52);
    e.exports = !r(function () {
      return 7 != Object.defineProperty({}, 1, {
        get: function get() {
          return 7;
        }
      })[1];
    });
  }, function (e, t, n) {
    var r = n(102),
        o = n(178),
        i = n(322);
    e.exports = r ? function (e, t, n) {
      return o.f(e, t, i(1, n));
    } : function (e, t, n) {
      return e[t] = n, e;
    };
  }, function (e, t, n) {
    var r = n(77);

    e.exports = Array.isArray || function (e) {
      return "Array" == r(e);
    };
  }, function (e, t, n) {
    var r = n(78),
        o = n(163),
        i = n(64),
        a = n(81),
        s = n(337),
        l = [].push,
        u = function u(e) {
      var t = 1 == e,
          n = 2 == e,
          u = 3 == e,
          c = 4 == e,
          d = 6 == e,
          f = 5 == e || d;
      return function (p, h, m, g) {
        for (var v, y, b = i(p), _ = o(b), w = r(h, m, 3), E = a(_.length), O = 0, S = g || s, x = t ? S(p, E) : n ? S(p, 0) : void 0; E > O; O++) {
          if ((f || O in _) && (v = _[O], y = w(v, O, b), e)) if (t) x[O] = y;else if (y) switch (e) {
            case 3:
              return !0;

            case 5:
              return v;

            case 6:
              return O;

            case 2:
              l.call(x, v);
          } else if (c) return !1;
        }

        return d ? -1 : u || c ? c : x;
      };
    };

    e.exports = {
      forEach: u(0),
      map: u(1),
      filter: u(2),
      some: u(3),
      every: u(4),
      find: u(5),
      findIndex: u(6)
    };
  }, function (e, t, n) {
    e.exports = n(661);
  }, function (e, t, n) {
    var r = n(102),
        o = n(178).f,
        i = Function.prototype,
        a = i.toString,
        s = /^\s*function ([^ (]*)/;
    !r || "name" in i || o(i, "name", {
      configurable: !0,
      get: function get() {
        try {
          return a.call(this).match(s)[1];
        } catch (e) {
          return "";
        }
      }
    });
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return h(e);
    }

    function o(e) {
      return h(e, !0);
    }

    function i(e) {
      return h({
        authenticatorKey: e
      }).iconClassName;
    }

    function a(e) {
      var t;

      if ((null === (t = e.errorCauses) || void 0 === t ? void 0 : t.length) > 0 && Array.isArray(e.errorCauses[0].errorSummary) && e.errorCauses[0].errorSummary.length > 0) {
        var n;
        e.errorCauses[0].errorSummary = e.errorCauses[0].errorSummary[0];
        "password.passwordRequirementsNotMet" === ((null === (n = e.errorCauses[0].errorKey) || void 0 === n ? void 0 : n.length) > 0 && e.errorCauses[0].errorKey[0]) && (e.errorCauses[0].errorSummary = (0, u.loc)("registration.error.password.passwordRequirementsNotMet", "login"));
      }

      return e;
    }

    function s(e) {
      var t, n;
      return null === (t = e.relatesTo) || void 0 === t ? void 0 : null === (n = t.value) || void 0 === n ? void 0 : n.displayName;
    }

    var l = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getAuthenticatorDataForEnroll = r, t.getAuthenticatorDataForVerification = o, t.getIconClassNameForBeacon = i, t.removeRequirementsFromError = a, t.getAuthenticatorDisplayName = s, t.getPasswordComplexityDescriptionForHtmlList = void 0;
    var u = n(1),
        c = l(n(15)),
        d = n(8),
        f = c.default.getPasswordComplexityDescriptionForHtmlList;
    t.getPasswordComplexityDescriptionForHtmlList = f;

    var p = function p(e) {
      if (e.authenticatorKey) {
        var t,
            n,
            r = (null === (t = e.value) || void 0 === t ? void 0 : t.methodType) ? "-" + (null === (n = e.value) || void 0 === n ? void 0 : n.methodType) : "";
        return e.authenticatorKey + r;
      }

      return "";
    },
        h = function h(e, t) {
      var n,
          r,
          o = e.authenticatorKey,
          i = u._.isString(o) ? o.toLowerCase() : "",
          a = {};

      switch (i) {
        case d.AUTHENTICATOR_KEY.EMAIL:
          Object.assign(a, {
            description: t ? "" : (0, u.loc)("oie.email.authenticator.description", "login"),
            iconClassName: "mfa-okta-email",
            buttonDataSeAttr: p(e)
          });
          break;

        case d.AUTHENTICATOR_KEY.PASSWORD:
          Object.assign(a, {
            description: t ? "" : (0, u.loc)("oie.password.authenticator.description", "login"),
            iconClassName: "mfa-okta-password",
            buttonDataSeAttr: p(e)
          });
          break;

        case d.AUTHENTICATOR_KEY.PHONE:
          Object.assign(a, {
            description: t ? null === (n = e.relatesTo) || void 0 === n ? void 0 : null === (r = n.profile) || void 0 === r ? void 0 : r.phoneNumber : (0, u.loc)("oie.phone.authenticator.description", "login"),
            iconClassName: "mfa-okta-phone",
            noTranslateClassName: t ? "no-translate" : "",
            buttonDataSeAttr: p(e)
          });
          break;

        case d.AUTHENTICATOR_KEY.SECURITY_QUESTION:
          Object.assign(a, {
            description: t ? "" : (0, u.loc)("oie.security.question.authenticator.description", "login"),
            iconClassName: "mfa-okta-security-question",
            buttonDataSeAttr: p(e)
          });
          break;

        case d.AUTHENTICATOR_KEY.WEBAUTHN:
          Object.assign(a, {
            description: t ? "" : (0, u.loc)("oie.webauthn.description", "login"),
            iconClassName: "mfa-webauthn",
            buttonDataSeAttr: p(e)
          });
          break;

        case d.AUTHENTICATOR_KEY.OV:
          Object.assign(a, {
            description: t ? "" : (0, u.loc)("oie.okta_verify.authenticator.description", "login"),
            iconClassName: "mfa-okta-verify",
            buttonDataSeAttr: p(e)
          });
          break;

        case d.AUTHENTICATOR_KEY.GOOGLE_OTP:
          Object.assign(a, {
            description: t ? "" : (0, u.loc)("oie.google_authenticator.authenticator.description", "login"),
            iconClassName: "mfa-google-auth",
            buttonDataSeAttr: p(e)
          });
          break;

        case d.AUTHENTICATOR_KEY.ON_PREM:
          var s,
              l = (null === (s = e.relatesTo) || void 0 === s ? void 0 : s.displayName) || (0, u.loc)("oie.on_prem.authenticator.default.vendorName", "login");
          Object.assign(a, {
            description: t ? "" : (0, u.loc)("oie.on_prem.authenticator.description", "login", [l]),
            iconClassName: "mfa-onprem",
            buttonDataSeAttr: p(e)
          });
          break;

        case d.AUTHENTICATOR_KEY.RSA:
          Object.assign(a, {
            description: t ? "" : (0, u.loc)("oie.rsa.authenticator.description", "login"),
            iconClassName: "mfa-rsa",
            buttonDataSeAttr: p(e)
          });
          break;

        case d.AUTHENTICATOR_KEY.DUO:
          Object.assign(a, {
            description: t ? "" : (0, u.loc)("oie.duo.authenticator.description", "login"),
            iconClassName: "mfa-duo",
            buttonDataSeAttr: p(e)
          });
          break;

        case d.AUTHENTICATOR_KEY.IDP:
          var c,
              f = null === (c = e.relatesTo) || void 0 === c ? void 0 : c.displayName;
          Object.assign(a, {
            description: t ? "" : (0, u.loc)("oie.idp.authenticator.description", "login", [f]),
            iconClassName: "mfa-custom-factor",
            buttonDataSeAttr: p(e)
          });
          break;

        case d.AUTHENTICATOR_KEY.CUSTOM_OTP:
          Object.assign(a, {
            description: t ? "" : (0, u.loc)("oie.custom_otp.description", "login"),
            iconClassName: "mfa-hotp",
            buttonDataSeAttr: p(e)
          });
          break;

        case d.AUTHENTICATOR_KEY.SYMANTEC_VIP:
          var h,
              m = null === (h = e.relatesTo) || void 0 === h ? void 0 : h.displayName;
          Object.assign(a, {
            description: t ? "" : (0, u.loc)("oie.symantecVip.authenticator.description", "login", [m]),
            iconClassName: "mfa-symantec",
            buttonDataSeAttr: p(e)
          });
      }

      return a;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = n(46),
        i = {
      startPolling: function startPolling(e) {
        this.fixedPollingInterval = this.options.currentViewState.refresh, this.dynamicPollingInterval = e, this.countDownCounterValue = Math.ceil(this.pollingInterval / o.MS_PER_SEC), this.fixedPollingInterval ? this._startRemediationPolling() : this._startAuthenticatorPolling();
      },
      _startAuthenticatorPolling: function _startAuthenticatorPolling() {
        var e = this;
        ["currentAuthenticator", "currentAuthenticatorEnrollment"].some(function (t) {
          if (e.options.appState.has(t)) {
            var n,
                o = e.options.appState.get(t),
                i = "".concat(t, "-poll"),
                a = e.dynamicPollingInterval || (null === o || void 0 === o ? void 0 : null === (n = o.poll) || void 0 === n ? void 0 : n.refresh);
            return r._.isNumber(a) && (e.polling = setInterval(function () {
              e.options.appState.trigger("invokeAction", i);
            }, a)), !0;
          }

          return !1;
        });
      },
      _startRemediationPolling: function _startRemediationPolling() {
        var e = this,
            t = this.dynamicPollingInterval || this.fixedPollingInterval;
        r._.isNumber(t) && (this.polling = setInterval(function () {
          e.options.appState.trigger("saveForm", e.model);
        }, t));
      },
      stopPolling: function stopPolling() {
        this.polling && clearInterval(this.polling);
      }
    };
    t.default = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(383);
    n.d(t, "default", function () {
      return r.a;
    });
    var o = n(139);
    n.d(t, "VERSION", function () {
      return o.VERSION;
    }), n.d(t, "restArguments", function () {
      return o.restArguments;
    }), n.d(t, "isObject", function () {
      return o.isObject;
    }), n.d(t, "isNull", function () {
      return o.isNull;
    }), n.d(t, "isUndefined", function () {
      return o.isUndefined;
    }), n.d(t, "isBoolean", function () {
      return o.isBoolean;
    }), n.d(t, "isElement", function () {
      return o.isElement;
    }), n.d(t, "isString", function () {
      return o.isString;
    }), n.d(t, "isNumber", function () {
      return o.isNumber;
    }), n.d(t, "isDate", function () {
      return o.isDate;
    }), n.d(t, "isRegExp", function () {
      return o.isRegExp;
    }), n.d(t, "isError", function () {
      return o.isError;
    }), n.d(t, "isSymbol", function () {
      return o.isSymbol;
    }), n.d(t, "isArrayBuffer", function () {
      return o.isArrayBuffer;
    }), n.d(t, "isDataView", function () {
      return o.isDataView;
    }), n.d(t, "isArray", function () {
      return o.isArray;
    }), n.d(t, "isFunction", function () {
      return o.isFunction;
    }), n.d(t, "isArguments", function () {
      return o.isArguments;
    }), n.d(t, "isFinite", function () {
      return o.isFinite;
    }), n.d(t, "isNaN", function () {
      return o.isNaN;
    }), n.d(t, "isTypedArray", function () {
      return o.isTypedArray;
    }), n.d(t, "isEmpty", function () {
      return o.isEmpty;
    }), n.d(t, "isMatch", function () {
      return o.isMatch;
    }), n.d(t, "isEqual", function () {
      return o.isEqual;
    }), n.d(t, "isMap", function () {
      return o.isMap;
    }), n.d(t, "isWeakMap", function () {
      return o.isWeakMap;
    }), n.d(t, "isSet", function () {
      return o.isSet;
    }), n.d(t, "isWeakSet", function () {
      return o.isWeakSet;
    }), n.d(t, "keys", function () {
      return o.keys;
    }), n.d(t, "allKeys", function () {
      return o.allKeys;
    }), n.d(t, "values", function () {
      return o.values;
    }), n.d(t, "pairs", function () {
      return o.pairs;
    }), n.d(t, "invert", function () {
      return o.invert;
    }), n.d(t, "functions", function () {
      return o.functions;
    }), n.d(t, "methods", function () {
      return o.methods;
    }), n.d(t, "extend", function () {
      return o.extend;
    }), n.d(t, "extendOwn", function () {
      return o.extendOwn;
    }), n.d(t, "assign", function () {
      return o.assign;
    }), n.d(t, "defaults", function () {
      return o.defaults;
    }), n.d(t, "create", function () {
      return o.create;
    }), n.d(t, "clone", function () {
      return o.clone;
    }), n.d(t, "tap", function () {
      return o.tap;
    }), n.d(t, "get", function () {
      return o.get;
    }), n.d(t, "has", function () {
      return o.has;
    }), n.d(t, "mapObject", function () {
      return o.mapObject;
    }), n.d(t, "identity", function () {
      return o.identity;
    }), n.d(t, "constant", function () {
      return o.constant;
    }), n.d(t, "noop", function () {
      return o.noop;
    }), n.d(t, "toPath", function () {
      return o.toPath;
    }), n.d(t, "property", function () {
      return o.property;
    }), n.d(t, "propertyOf", function () {
      return o.propertyOf;
    }), n.d(t, "matcher", function () {
      return o.matcher;
    }), n.d(t, "matches", function () {
      return o.matches;
    }), n.d(t, "times", function () {
      return o.times;
    }), n.d(t, "random", function () {
      return o.random;
    }), n.d(t, "now", function () {
      return o.now;
    }), n.d(t, "escape", function () {
      return o.escape;
    }), n.d(t, "unescape", function () {
      return o.unescape;
    }), n.d(t, "templateSettings", function () {
      return o.templateSettings;
    }), n.d(t, "template", function () {
      return o.template;
    }), n.d(t, "result", function () {
      return o.result;
    }), n.d(t, "uniqueId", function () {
      return o.uniqueId;
    }), n.d(t, "chain", function () {
      return o.chain;
    }), n.d(t, "iteratee", function () {
      return o.iteratee;
    }), n.d(t, "partial", function () {
      return o.partial;
    }), n.d(t, "bind", function () {
      return o.bind;
    }), n.d(t, "bindAll", function () {
      return o.bindAll;
    }), n.d(t, "memoize", function () {
      return o.memoize;
    }), n.d(t, "delay", function () {
      return o.delay;
    }), n.d(t, "defer", function () {
      return o.defer;
    }), n.d(t, "throttle", function () {
      return o.throttle;
    }), n.d(t, "debounce", function () {
      return o.debounce;
    }), n.d(t, "wrap", function () {
      return o.wrap;
    }), n.d(t, "negate", function () {
      return o.negate;
    }), n.d(t, "compose", function () {
      return o.compose;
    }), n.d(t, "after", function () {
      return o.after;
    }), n.d(t, "before", function () {
      return o.before;
    }), n.d(t, "once", function () {
      return o.once;
    }), n.d(t, "findKey", function () {
      return o.findKey;
    }), n.d(t, "findIndex", function () {
      return o.findIndex;
    }), n.d(t, "findLastIndex", function () {
      return o.findLastIndex;
    }), n.d(t, "sortedIndex", function () {
      return o.sortedIndex;
    }), n.d(t, "indexOf", function () {
      return o.indexOf;
    }), n.d(t, "lastIndexOf", function () {
      return o.lastIndexOf;
    }), n.d(t, "find", function () {
      return o.find;
    }), n.d(t, "detect", function () {
      return o.detect;
    }), n.d(t, "findWhere", function () {
      return o.findWhere;
    }), n.d(t, "each", function () {
      return o.each;
    }), n.d(t, "forEach", function () {
      return o.forEach;
    }), n.d(t, "map", function () {
      return o.map;
    }), n.d(t, "collect", function () {
      return o.collect;
    }), n.d(t, "reduce", function () {
      return o.reduce;
    }), n.d(t, "foldl", function () {
      return o.foldl;
    }), n.d(t, "inject", function () {
      return o.inject;
    }), n.d(t, "reduceRight", function () {
      return o.reduceRight;
    }), n.d(t, "foldr", function () {
      return o.foldr;
    }), n.d(t, "filter", function () {
      return o.filter;
    }), n.d(t, "select", function () {
      return o.select;
    }), n.d(t, "reject", function () {
      return o.reject;
    }), n.d(t, "every", function () {
      return o.every;
    }), n.d(t, "all", function () {
      return o.all;
    }), n.d(t, "some", function () {
      return o.some;
    }), n.d(t, "any", function () {
      return o.any;
    }), n.d(t, "contains", function () {
      return o.contains;
    }), n.d(t, "includes", function () {
      return o.includes;
    }), n.d(t, "include", function () {
      return o.include;
    }), n.d(t, "invoke", function () {
      return o.invoke;
    }), n.d(t, "pluck", function () {
      return o.pluck;
    }), n.d(t, "where", function () {
      return o.where;
    }), n.d(t, "max", function () {
      return o.max;
    }), n.d(t, "min", function () {
      return o.min;
    }), n.d(t, "shuffle", function () {
      return o.shuffle;
    }), n.d(t, "sample", function () {
      return o.sample;
    }), n.d(t, "sortBy", function () {
      return o.sortBy;
    }), n.d(t, "groupBy", function () {
      return o.groupBy;
    }), n.d(t, "indexBy", function () {
      return o.indexBy;
    }), n.d(t, "countBy", function () {
      return o.countBy;
    }), n.d(t, "partition", function () {
      return o.partition;
    }), n.d(t, "toArray", function () {
      return o.toArray;
    }), n.d(t, "size", function () {
      return o.size;
    }), n.d(t, "pick", function () {
      return o.pick;
    }), n.d(t, "omit", function () {
      return o.omit;
    }), n.d(t, "first", function () {
      return o.first;
    }), n.d(t, "head", function () {
      return o.head;
    }), n.d(t, "take", function () {
      return o.take;
    }), n.d(t, "initial", function () {
      return o.initial;
    }), n.d(t, "last", function () {
      return o.last;
    }), n.d(t, "rest", function () {
      return o.rest;
    }), n.d(t, "tail", function () {
      return o.tail;
    }), n.d(t, "drop", function () {
      return o.drop;
    }), n.d(t, "compact", function () {
      return o.compact;
    }), n.d(t, "flatten", function () {
      return o.flatten;
    }), n.d(t, "without", function () {
      return o.without;
    }), n.d(t, "uniq", function () {
      return o.uniq;
    }), n.d(t, "unique", function () {
      return o.unique;
    }), n.d(t, "union", function () {
      return o.union;
    }), n.d(t, "intersection", function () {
      return o.intersection;
    }), n.d(t, "difference", function () {
      return o.difference;
    }), n.d(t, "unzip", function () {
      return o.unzip;
    }), n.d(t, "transpose", function () {
      return o.transpose;
    }), n.d(t, "zip", function () {
      return o.zip;
    }), n.d(t, "object", function () {
      return o.object;
    }), n.d(t, "range", function () {
      return o.range;
    }), n.d(t, "chunk", function () {
      return o.chunk;
    }), n.d(t, "mixin", function () {
      return o.mixin;
    });
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e = Object(o.a)({}, e), function (t) {
        return Object(i.a)(t, e);
      };
    }

    t.a = r;
    var o = n(146),
        i = n(208);
  }, function (e, t, n) {
    "use strict";

    var r = n(28),
        o = n(224),
        i = n(29),
        a = Object(r.a)(function (e, t) {
      var n = a.placeholder,
          r = function r() {
        for (var i = 0, a = t.length, s = Array(a), l = 0; l < a; l++) {
          s[l] = t[l] === n ? arguments[i++] : t[l];
        }

        for (; i < arguments.length;) {
          s.push(arguments[i++]);
        }

        return Object(o.a)(e, r, this, this, s);
      };

      return r;
    });
    a.placeholder = i.a, t.a = a;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return function (n, r, a) {
        var s = t ? [[], []] : {};
        return r = Object(o.a)(r, a), Object(i.a)(n, function (t, o) {
          var i = r(t, o, n);
          e(s, t, i);
        }), s;
      };
    }

    t.a = r;
    var o = n(27),
        i = n(55);
  }, function (e, t, n) {
    var r, o, i;
    /* @okta/qtip2 v3.0.3-5-g | Plugins: tips modal viewport svg imagemap ie6 | Styles: core basic css3 | qtip2.com | Licensed MIT | Wed May 24 2017 01:22:57 */

    !function (a, s, l) {
      !function (a) {
        "use strict";

        o = [n(154)], r = a, void 0 !== (i = "function" == typeof r ? r.apply(t, o) : r) && (e.exports = i);
      }(function (e) {
        "use strict";

        function t(t, n, r, o) {
          this.id = r, this.target = t, this.tooltip = P, this.elements = {
            target: t
          }, this._id = W + "-" + r, this.timers = {
            img: {}
          }, this.options = n, this.plugins = {}, this.cache = {
            event: {},
            target: e(),
            disabled: N,
            attr: o,
            onTooltip: N,
            lastClass: ""
          }, this.rendered = this.destroyed = this.disabled = this.waiting = this.hiddenDuringWait = this.positioning = this.triggering = N;
        }

        function n(t) {
          return t === P || "object" !== e.type(t);
        }

        function r(t) {
          return !(e.isFunction(t) || t && t.attr || t.length || "object" === e.type(t) && (t.jquery || t.then));
        }

        function o(t) {
          var o, i, a, s;
          return n(t) ? N : (n(t.metadata) && (t.metadata = {
            type: t.metadata
          }), "content" in t && (o = t.content, n(o) || o.jquery || o.done ? (i = r(o) ? N : o, o = t.content = {
            text: i
          }) : i = o.text, "ajax" in o && (a = o.ajax, s = a && a.once !== N, delete o.ajax, o.text = function (t, n) {
            var r = i || e(this).attr(n.options.content.attr) || "Loading...",
                o = e.ajax(e.extend({}, a, {
              context: n
            })).then(a.success, P, a.error).then(function (e) {
              return e && s && n.set("content.text", e), e;
            }, function (e, t, r) {
              n.destroyed || 0 === e.status || n.set("content.text", t + ": " + r);
            });
            return s ? r : (n.set("content.text", r), o);
          }), "title" in o && (e.isPlainObject(o.title) && (o.button = o.title.button, o.title = o.title.text), r(o.title || N) && (o.title = N))), "position" in t && n(t.position) && (t.position = {
            my: t.position,
            at: t.position
          }), "show" in t && n(t.show) && (t.show = t.show.jquery ? {
            target: t.show
          } : t.show === A ? {
            ready: A
          } : {
            event: t.show
          }), "hide" in t && n(t.hide) && (t.hide = t.hide.jquery ? {
            target: t.hide
          } : {
            event: t.hide
          }), "style" in t && n(t.style) && (t.style = {
            classes: t.style
          }), e.each(q, function () {
            this.sanitize && this.sanitize(t);
          }), t);
        }

        function i(e, t) {
          for (var n, r = 0, o = e, i = t.split("."); o = o[i[r++]];) {
            r < i.length && (n = o);
          }

          return [n || e, i.pop()];
        }

        function u(e, t) {
          var n, r, o;

          for (n in this.checks) {
            if (this.checks.hasOwnProperty(n)) for (r in this.checks[n]) {
              this.checks[n].hasOwnProperty(r) && (o = new RegExp(r, "i").exec(e)) && (t.push(o), ("builtin" === n || this.plugins[n]) && this.checks[n][r].apply(this.plugins[n] || this, t));
            }
          }
        }

        function c(e) {
          return K.concat("").join(e ? "-" + e + " " : " ");
        }

        function d(t, n) {
          return n > 0 ? setTimeout(e.proxy(t, this), n) : void t.call(this);
        }

        function f(e) {
          this.tooltip.hasClass(ee) || (clearTimeout(this.timers.show), clearTimeout(this.timers.hide), this.timers.show = d.call(this, function () {
            this.toggle(A, e);
          }, this.options.show.delay));
        }

        function p(t) {
          if (!this.tooltip.hasClass(ee) && !this.destroyed) {
            var n = e(t.relatedTarget),
                r = n.closest(G)[0] === this.tooltip[0],
                o = n[0] === this.options.show.target[0];
            if (clearTimeout(this.timers.show), clearTimeout(this.timers.hide), this !== n[0] && "mouse" === this.options.position.target && r || this.options.hide.fixed && /mouse(out|leave|move)/.test(t.type) && (r || o)) try {
              t.preventDefault(), t.stopImmediatePropagation();
            } catch (e) {} else this.timers.hide = d.call(this, function () {
              this.toggle(N, t);
            }, this.options.hide.delay, this);
          }
        }

        function h(e) {
          !this.tooltip.hasClass(ee) && this.options.hide.inactive && (clearTimeout(this.timers.inactive), this.timers.inactive = d.call(this, function () {
            this.hide(e);
          }, this.options.hide.inactive));
        }

        function m(e) {
          this.rendered && this.tooltip[0].offsetWidth > 0 && this.reposition(e);
        }

        function g(t, n, r) {
          e(s.body).delegate(t, (n.split ? n : n.join("." + W + " ")) + "." + W, function () {
            var t = S.api[e.attr(this, $)];
            t && !t.disabled && r.apply(t, arguments);
          });
        }

        function v(n, r, i) {
          var a,
              l,
              u,
              c,
              d,
              f = e(s.body),
              p = n[0] === s ? f : n,
              h = n.metadata ? n.metadata(i.metadata) : P,
              m = "html5" === i.metadata.type && h ? h[i.metadata.name] : P,
              g = n.data(i.metadata.name || "qtipopts");

          try {
            g = "string" == typeof g ? e.parseJSON(g) : g;
          } catch (e) {}

          if (c = e.extend(A, {}, S.defaults, i, "object" == typeof g ? o(g) : P, o(m || h)), l = c.position, c.id = r, "boolean" == typeof c.content.text) {
            if (u = n.attr(c.content.attr), c.content.attr === N || !u) return N;
            c.content.text = u;
          }

          if (l.container.length || (l.container = f), l.target === N && (l.target = p), c.show.target === N && (c.show.target = p), c.show.solo === A && (c.show.solo = l.container.closest("body")), c.hide.target === N && (c.hide.target = p), c.position.viewport === A && (c.position.viewport = l.container), l.container = l.container.eq(0), l.at = new T(l.at, A), l.my = new T(l.my), n.data(W)) if (c.overwrite) n.qtip("destroy", !0);else if (c.overwrite === N) return N;
          return n.attr(z, r), c.suppress && (d = n.attr("title")) && n.removeAttr("title").attr(ne, d).attr("title", ""), a = new t(n, c, r, !!u), n.data(W, a), a;
        }

        function y(e) {
          return e.charAt(0).toUpperCase() + e.slice(1);
        }

        function b(e, t) {
          var n,
              r,
              o = t.charAt(0).toUpperCase() + t.slice(1),
              i = (t + " " + we.join(o + " ") + o).split(" "),
              a = 0;
          if (_e[t]) return e.css(_e[t]);

          for (; n = i[a++];) {
            if ((r = e.css(n)) !== l) return _e[t] = n, r;
          }
        }

        function _(e, t) {
          return Math.ceil(parseFloat(b(e, t)));
        }

        function w(e, t) {
          this._ns = "tip", this.options = t, this.offset = t.offset, this.size = [t.width, t.height], this.qtip = e, this.init(e);
        }

        function E(e, t) {
          this.options = t, this._ns = "-modal", this.qtip = e, this.init(e);
        }

        function O(e) {
          this._ns = "ie6", this.qtip = e, this.init(e);
        }

        var S,
            x,
            T,
            k,
            C,
            A = !0,
            N = !1,
            P = null,
            R = "x",
            I = "y",
            M = "width",
            j = "height",
            L = "top",
            D = "left",
            F = "bottom",
            U = "right",
            B = "center",
            V = "flipinvert",
            H = "shift",
            q = {},
            W = "qtip",
            z = "data-hasqtip",
            $ = "data-qtip-id",
            K = ["ui-widget", "ui-tooltip"],
            G = "." + W,
            Y = "click dblclick mousedown mouseup mousemove mouseleave mouseenter".split(" "),
            J = W + "-fixed",
            Q = W + "-default",
            X = W + "-focus",
            Z = W + "-hover",
            ee = W + "-disabled",
            te = "_replacedByqTip",
            ne = "oldtitle",
            re = {
          ie: function () {
            var e, t;

            for (e = 4, t = s.createElement("div"); (t.innerHTML = "\x3c!--[if gt IE " + e + "]><i></i><![endif]--\x3e") && t.getElementsByTagName("i")[0]; e += 1) {
              ;
            }

            return e > 4 ? e : NaN;
          }(),
          iOS: parseFloat(("" + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ""])[1]).replace("undefined", "3_2").replace("_", ".").replace("_", "")) || N
        };
        x = t.prototype, x._when = function (t) {
          return e.when.apply(e, t);
        }, x.render = function (t) {
          if (this.rendered || this.destroyed) return this;
          var n = this,
              r = this.options,
              o = this.cache,
              i = this.elements,
              a = r.content.text,
              s = r.content.title,
              l = r.content.button,
              u = r.position,
              c = [];
          return e.attr(this.target[0], "aria-describedby", this._id), o.posClass = this._createPosClass((this.position = {
            my: u.my,
            at: u.at
          }).my), this.tooltip = i.tooltip = e("<div/>", {
            id: this._id,
            class: [W, Q, r.style.classes, o.posClass].join(" "),
            width: r.style.width || "",
            height: r.style.height || "",
            tracking: "mouse" === u.target && u.adjust.mouse,
            role: "alert",
            "aria-live": "polite",
            "aria-atomic": N,
            "aria-describedby": this._id + "-content",
            "aria-hidden": A
          }).toggleClass(ee, this.disabled).attr($, this.id).data(W, this).appendTo(u.container).append(i.content = e("<div />", {
            class: W + "-content",
            id: this._id + "-content",
            "aria-atomic": A
          })), this.rendered = -1, this.positioning = A, s && (this._createTitle(), e.isFunction(s) || c.push(this._updateTitle(s, N))), l && this._createButton(), e.isFunction(a) || c.push(this._updateContent(a, N)), this.rendered = A, this._setWidget(), e.each(q, function (e) {
            var t;
            "render" === this.initialize && (t = this(n)) && (n.plugins[e] = t);
          }), this._unassignEvents(), this._assignEvents(), this._when(c).then(function () {
            n._trigger("render"), n.positioning = N, n.hiddenDuringWait || !r.show.ready && !t || n.toggle(A, o.event, N), n.hiddenDuringWait = N;
          }), S.api[this.id] = this, this;
        }, x.destroy = function (t) {
          function n() {
            if (!this.destroyed) {
              this.destroyed = A;
              var t,
                  n = this.target,
                  r = n.attr(ne);
              this.rendered && this.tooltip.stop(1, 0).find("*").remove().end().remove(), e.each(this.plugins, function () {
                this.destroy && this.destroy();
              });

              for (t in this.timers) {
                this.timers.hasOwnProperty(t) && clearTimeout(this.timers[t]);
              }

              n.removeData(W).removeAttr($).removeAttr(z).removeAttr("aria-describedby"), this.options.suppress && r && n.attr("title", r).removeAttr(ne), this._unassignEvents(), this.options = this.elements = this.cache = this.timers = this.plugins = this.mouse = P, delete S.api[this.id];
            }
          }

          return this.destroyed ? this.target : (t === A && "hide" !== this.triggering || !this.rendered ? n.call(this) : (this.tooltip.one("tooltiphidden", e.proxy(n, this)), !this.triggering && this.hide()), this.target);
        }, k = x.checks = {
          builtin: {
            "^id$": function id$(t, n, r, o) {
              var i = r === A ? S.nextid : r,
                  a = W + "-" + i;
              i !== N && i.length > 0 && !e("#" + a).length ? (this._id = a, this.rendered && (this.tooltip[0].id = this._id, this.elements.content[0].id = this._id + "-content", this.elements.title[0].id = this._id + "-title")) : t[n] = o;
            },
            "^prerender": function prerender(e, t, n) {
              n && !this.rendered && this.render(this.options.show.ready);
            },
            "^content.text$": function contentText$(e, t, n) {
              this._updateContent(n);
            },
            "^content.attr$": function contentAttr$(e, t, n, r) {
              this.options.content.text === this.target.attr(r) && this._updateContent(this.target.attr(n));
            },
            "^content.title$": function contentTitle$(e, t, n) {
              return n ? (n && !this.elements.title && this._createTitle(), void this._updateTitle(n)) : this._removeTitle();
            },
            "^content.button$": function contentButton$(e, t, n) {
              this._updateButton(n);
            },
            "^content.title.(text|button)$": function contentTitleTextButton$(e, t, n) {
              this.set("content." + t, n);
            },
            "^position.(my|at)$": function positionMyAt$(e, t, n) {
              "string" == typeof n && (this.position[t] = e[t] = new T(n, "at" === t));
            },
            "^position.container$": function positionContainer$(e, t, n) {
              this.rendered && this.tooltip.appendTo(n);
            },
            "^show.ready$": function showReady$(e, t, n) {
              n && (!this.rendered && this.render(A) || this.toggle(A));
            },
            "^style.classes$": function styleClasses$(e, t, n, r) {
              this.rendered && this.tooltip.removeClass(r).addClass(n);
            },
            "^style.(width|height)": function styleWidthHeight(e, t, n) {
              this.rendered && this.tooltip.css(t, n);
            },
            "^style.widget|content.title": function styleWidgetContentTitle() {
              this.rendered && this._setWidget();
            },
            "^style.def": function styleDef(e, t, n) {
              this.rendered && this.tooltip.toggleClass(Q, !!n);
            },
            "^events.(render|show|move|hide|focus|blur)$": function eventsRenderShowMoveHideFocusBlur$(t, n, r) {
              this.rendered && this.tooltip[(e.isFunction(r) ? "" : "un") + "bind"]("tooltip" + n, r);
            },
            "^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)": function showHidePositionEventTargetFixedInactiveLeaveDistanceViewportAdjust() {
              if (this.rendered) {
                var e = this.options.position;
                this.tooltip.attr("tracking", "mouse" === e.target && e.adjust.mouse), this._unassignEvents(), this._assignEvents();
              }
            }
          }
        }, x.get = function (e) {
          if (this.destroyed) return this;
          var t = i(this.options, e.toLowerCase()),
              n = t[0][t[1]];
          return n.precedance ? n.string() : n;
        };
        var oe = /^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i,
            ie = /^prerender|show\.ready/i;
        x.set = function (t, n) {
          if (this.destroyed) return this;
          var r,
              a = this.rendered,
              s = N,
              l = this.options;
          return "string" == typeof t ? (r = t, t = {}, t[r] = n) : t = e.extend({}, t), e.each(t, function (n, r) {
            if (a && ie.test(n)) return void delete t[n];
            var o,
                u = i(l, n.toLowerCase());
            o = u[0][u[1]], u[0][u[1]] = r && r.nodeType ? e(r) : r, s = oe.test(n) || s, t[n] = [u[0], u[1], r, o];
          }), o(l), this.positioning = A, e.each(t, e.proxy(u, this)), this.positioning = N, this.rendered && this.tooltip[0].offsetWidth > 0 && s && this.reposition("mouse" === l.position.target ? P : this.cache.event), this;
        }, x._update = function (t, n) {
          var r = this,
              o = this.cache;
          return this.rendered && t ? (e.isFunction(t) && (t = t.call(this.elements.target, o.event, this) || ""), e.isFunction(t.then) ? (o.waiting = A, t.then(function (e) {
            return o.waiting = N, r._update(e, n);
          }, P, function (e) {
            return r._update(e, n);
          })) : t === N || !t && "" !== t ? N : (t.jquery && t.length > 0 ? n.empty().append(t.css({
            display: "block",
            visibility: "visible"
          })) : n.html(t), this._waitForContent(n).then(function (e) {
            r.rendered && r.tooltip[0].offsetWidth > 0 && r.reposition(o.event, !e.length);
          }))) : N;
        }, x._waitForContent = function (t) {
          var n = this.cache;
          return n.waiting = A, (e.fn.imagesLoaded ? t.imagesLoaded() : new e.Deferred().resolve([])).done(function () {
            n.waiting = N;
          }).promise();
        }, x._updateContent = function (e, t) {
          this._update(e, this.elements.content, t);
        }, x._updateTitle = function (e, t) {
          this._update(e, this.elements.title, t) === N && this._removeTitle(N);
        }, x._createTitle = function () {
          var t = this.elements,
              n = this._id + "-title";
          t.titlebar && this._removeTitle(), t.titlebar = e("<div />", {
            class: W + "-titlebar " + (this.options.style.widget ? c("header") : "")
          }).append(t.title = e("<div />", {
            id: n,
            class: W + "-title",
            "aria-atomic": A
          })).insertBefore(t.content).delegate(".qtip-close", "mousedown keydown mouseup keyup mouseout", function (t) {
            e(this).toggleClass("ui-state-active ui-state-focus", "down" === t.type.substr(-4));
          }).delegate(".qtip-close", "mouseover mouseout", function (t) {
            e(this).toggleClass("ui-state-hover", "mouseover" === t.type);
          }), this.options.content.button && this._createButton();
        }, x._removeTitle = function (e) {
          var t = this.elements;
          t.title && (t.titlebar.remove(), t.titlebar = t.title = t.button = P, e !== N && this.reposition());
        }, x._createPosClass = function (e) {
          return W + "-pos-" + (e || this.options.position.my).abbrev();
        }, x.reposition = function (t, n) {
          if (!this.rendered || this.positioning || this.destroyed) return this;
          this.positioning = A;

          var r,
              o,
              i,
              l,
              u = this.cache,
              c = this.tooltip,
              d = this.options.position,
              f = d.target,
              p = d.my,
              h = d.at,
              m = d.viewport,
              g = d.container,
              v = d.adjust,
              y = v.method.split(" "),
              b = c.outerWidth(N),
              _ = c.outerHeight(N),
              w = 0,
              E = 0,
              O = c.css("position"),
              S = {
            left: 0,
            top: 0
          },
              x = c[0].offsetWidth > 0,
              T = t && "scroll" === t.type,
              k = e(a),
              C = g[0].ownerDocument,
              P = this.mouse;

          if (e.isArray(f) && 2 === f.length) h = {
            x: D,
            y: L
          }, S = {
            left: f[0],
            top: f[1]
          };else if ("mouse" === f) h = {
            x: D,
            y: L
          }, (!v.mouse || this.options.hide.distance) && u.origin && u.origin.pageX ? t = u.origin : !t || t && ("resize" === t.type || "scroll" === t.type) ? t = u.event : P && P.pageX && (t = P), "static" !== O && (S = g.offset()), C.body.offsetWidth !== (a.innerWidth || C.documentElement.clientWidth) && (o = e(s.body).offset()), S = {
            left: t.pageX - S.left + (o && o.left || 0),
            top: t.pageY - S.top + (o && o.top || 0)
          }, v.mouse && T && P && (S.left -= (P.scrollX || 0) - k.scrollLeft(), S.top -= (P.scrollY || 0) - k.scrollTop());else {
            if ("event" === f ? t && t.target && "scroll" !== t.type && "resize" !== t.type ? u.target = e(t.target) : t.target || (u.target = this.elements.target) : "event" !== f && (u.target = e(f.jquery ? f : this.elements.target)), f = u.target, f = e(f).eq(0), 0 === f.length) return this;
            f[0] === s || f[0] === a ? (w = re.iOS ? a.innerWidth : f.width(), E = re.iOS ? a.innerHeight : f.height(), f[0] === a && (S = {
              top: (m || f).scrollTop(),
              left: (m || f).scrollLeft()
            })) : q.imagemap && f.is("area") ? r = q.imagemap(this, f, h, q.viewport ? y : N) : q.svg && f && f[0].ownerSVGElement ? r = q.svg(this, f, h, q.viewport ? y : N) : (w = f.outerWidth(N), E = f.outerHeight(N), S = f.offset()), r && (w = r.width, E = r.height, o = r.offset, S = r.position), S = this.reposition.offset(f, S, g), (re.iOS > 3.1 && re.iOS < 4.1 || re.iOS >= 4.3 && re.iOS < 4.33 || !re.iOS && "fixed" === O) && (S.left -= k.scrollLeft(), S.top -= k.scrollTop()), (!r || r && r.adjustable !== N) && (S.left += h.x === U ? w : h.x === B ? w / 2 : 0, S.top += h.y === F ? E : h.y === B ? E / 2 : 0);
          }
          return S.left += v.x + (p.x === U ? -b : p.x === B ? -b / 2 : 0), S.top += v.y + (p.y === F ? -_ : p.y === B ? -_ / 2 : 0), q.viewport ? (i = S.adjusted = q.viewport(this, S, d, w, E, b, _), o && i.left && (S.left += o.left), o && i.top && (S.top += o.top), i.my && (this.position.my = i.my)) : S.adjusted = {
            left: 0,
            top: 0
          }, u.posClass !== (l = this._createPosClass(this.position.my)) && (u.posClass = l, c.removeClass(u.posClass).addClass(l)), this._trigger("move", [S, m.elem || m], t) ? (delete S.adjusted, n === N || !x || isNaN(S.left) || isNaN(S.top) || "mouse" === f || !e.isFunction(d.effect) ? c.css(S) : e.isFunction(d.effect) && (d.effect.call(c, this, e.extend({}, S)), c.queue(function (t) {
            e(this).css({
              opacity: "",
              height: ""
            }), re.ie && this.style.removeAttribute("filter"), t();
          })), this.positioning = N, this) : this;
        }, x.reposition.offset = function (t, n, r) {
          function o(e, t) {
            n.left += t * e.scrollLeft(), n.top += t * e.scrollTop();
          }

          if (!r[0]) return n;
          var i,
              a,
              l,
              u,
              c = e(t[0].ownerDocument),
              d = !!re.ie && "CSS1Compat" !== s.compatMode,
              f = r[0];

          do {
            "static" !== (a = e.css(f, "position")) && ("fixed" === a ? (l = f.getBoundingClientRect(), o(c, -1)) : (l = e(f).position(), l.left += parseFloat(e.css(f, "borderLeftWidth")) || 0, l.top += parseFloat(e.css(f, "borderTopWidth")) || 0), n.left -= l.left + (parseFloat(e.css(f, "marginLeft")) || 0), n.top -= l.top + (parseFloat(e.css(f, "marginTop")) || 0), i || "hidden" === (u = e.css(f, "overflow")) || "visible" === u || "BODY" === e.prop(f, "tagName") || (i = e(f)));
          } while (f = f.offsetParent);

          return i && (i[0] !== c[0] || d) && o(i, 1), n;
        };

        var ae = (T = x.reposition.Corner = function (e, t) {
          e = ("" + e).replace(/([A-Z])/, " $1").replace(/middle/gi, B).toLowerCase(), this.x = (e.match(/left|right/i) || e.match(/center/) || ["inherit"])[0].toLowerCase(), this.y = (e.match(/top|bottom|center/i) || ["inherit"])[0].toLowerCase(), this.forceY = !!t;
          var n = e.charAt(0);
          this.precedance = "t" === n || "b" === n ? I : R;
        }).prototype;

        ae.invert = function (e, t) {
          this[e] = this[e] === D ? U : this[e] === U ? D : t || this[e];
        }, ae.string = function (e) {
          var t = this.x,
              n = this.y,
              r = t !== n ? "center" === t || "center" !== n && (this.precedance === I || this.forceY) ? [n, t] : [t, n] : [t];
          return !1 !== e ? r.join(" ") : r;
        }, ae.abbrev = function () {
          var e = this.string(!1);
          return e[0].charAt(0) + (e[1] && e[1].charAt(0) || "");
        }, ae.clone = function () {
          return new T(this.string(), this.forceY);
        }, x.toggle = function (t, n) {
          var r = this.cache,
              o = this.options,
              i = this.tooltip;

          if (n) {
            if (/over|enter/.test(n.type) && r.event && /out|leave/.test(r.event.type) && o.show.target.add(n.target).length === o.show.target.length && i.has(n.relatedTarget).length) return this;
            r.event = e.event.fix(n);
          }

          if (this.waiting && !t && (this.hiddenDuringWait = A), !this.rendered) return t ? this.render(1) : this;
          if (this.destroyed || this.disabled) return this;
          var a,
              l,
              u,
              c = t ? "show" : "hide",
              d = this.options[c],
              f = this.options.position,
              p = this.options.content,
              h = this.tooltip.css("width"),
              m = this.tooltip.is(":visible"),
              g = t || 1 === d.target.length,
              v = !n || d.target.length < 2 || r.target[0] === n.target;
          return (typeof t).search("boolean|number") && (t = !m), a = !i.is(":animated") && m === t && v, l = a ? P : !!this._trigger(c, [90]), this.destroyed ? this : (l !== N && t && this.focus(n), !l || a ? this : (e.attr(i[0], "aria-hidden", !t), t ? (this.mouse && (r.origin = e.event.fix(this.mouse)), e.isFunction(p.text) && this._updateContent(p.text, N), e.isFunction(p.title) && this._updateTitle(p.title, N), !C && "mouse" === f.target && f.adjust.mouse && (e(s).bind("mousemove." + W, this._storeMouse), C = A), h || i.css("width", i.outerWidth(N)), this.reposition(n, arguments[2]), h || i.css("width", ""), d.solo && ("string" == typeof d.solo ? e(d.solo) : e(G, d.solo)).not(i).not(d.target).qtip("hide", new e.Event("tooltipsolo"))) : (clearTimeout(this.timers.show), delete r.origin, C && !e(G + '[tracking="true"]:visible', d.solo).not(i).length && (e(s).unbind("mousemove." + W), C = N), this.blur(n)), u = e.proxy(function () {
            t ? (re.ie && i[0].style.removeAttribute("filter"), i.css("overflow", ""), "string" == typeof d.autofocus && e(this.options.show.autofocus, i).focus(), this.options.show.target.trigger("qtip-" + this.id + "-inactive")) : i.css({
              display: "",
              visibility: "",
              opacity: "",
              left: "",
              top: ""
            }), this._trigger(t ? "visible" : "hidden");
          }, this), d.effect === N || g === N ? (i[c](), u()) : e.isFunction(d.effect) ? (i.stop(1, 1), d.effect.call(i, this), i.queue("fx", function (e) {
            u(), e();
          })) : i.fadeTo(90, t ? 1 : 0, u), t && d.target.trigger("qtip-" + this.id + "-inactive"), this));
        }, x.show = function (e) {
          return this.toggle(A, e);
        }, x.hide = function (e) {
          return this.toggle(N, e);
        }, x.focus = function (t) {
          if (!this.rendered || this.destroyed) return this;
          var n = e(G),
              r = this.tooltip,
              o = parseInt(r[0].style.zIndex, 10),
              i = S.zindex + n.length;
          return r.hasClass(X) || this._trigger("focus", [i], t) && (o !== i && (n.each(function () {
            this.style.zIndex > o && (this.style.zIndex = this.style.zIndex - 1);
          }), n.filter("." + X).qtip("blur", t)), r.addClass(X)[0].style.zIndex = i), this;
        }, x.blur = function (e) {
          return !this.rendered || this.destroyed ? this : (this.tooltip.removeClass(X), this._trigger("blur", [this.tooltip.css("zIndex")], e), this);
        }, x.disable = function (e) {
          return this.destroyed ? this : ("toggle" === e ? e = !(this.rendered ? this.tooltip.hasClass(ee) : this.disabled) : "boolean" != typeof e && (e = A), this.rendered && this.tooltip.toggleClass(ee, e).attr("aria-disabled", e), this.disabled = !!e, this);
        }, x.enable = function () {
          return this.disable(N);
        }, x._createButton = function () {
          var t = this,
              n = this.elements,
              r = n.tooltip,
              o = this.options.content.button,
              i = "string" == typeof o,
              a = i ? o : "Close tooltip";
          n.button && n.button.remove(), o.jquery ? n.button = o : n.button = e("<a />", {
            class: "qtip-close " + (this.options.style.widget ? "" : W + "-icon"),
            title: a,
            "aria-label": a
          }).prepend(e("<span />", {
            class: "ui-icon ui-icon-close",
            html: "&times;"
          })), n.button.appendTo(n.titlebar || r).attr("role", "button").click(function (e) {
            return r.hasClass(ee) || t.hide(e), N;
          });
        }, x._updateButton = function (e) {
          if (!this.rendered) return N;
          var t = this.elements.button;
          e ? this._createButton() : t.remove();
        }, x._setWidget = function () {
          var e = this.options.style.widget,
              t = this.elements,
              n = t.tooltip,
              r = n.hasClass(ee);
          n.removeClass(ee), ee = e ? "ui-state-disabled" : "qtip-disabled", n.toggleClass(ee, r), n.toggleClass("ui-helper-reset " + c(), e).toggleClass(Q, this.options.style.def && !e), t.content && t.content.toggleClass(c("content"), e), t.titlebar && t.titlebar.toggleClass(c("header"), e), t.button && t.button.toggleClass(W + "-icon", !e);
        }, x._storeMouse = function (t) {
          return (this.mouse = e.event.fix(t)).type = "mousemove", this;
        }, x._bind = function (t, n, r, o, i) {
          if (t && r && n.length) {
            var a = "." + this._id + (o ? "-" + o : "");
            return e(t).bind((n.split ? n : n.join(a + " ")) + a, e.proxy(r, i || this)), this;
          }
        }, x._unbind = function (t, n) {
          return t && e(t).unbind("." + this._id + (n ? "-" + n : "")), this;
        }, x._trigger = function (t, n, r) {
          var o = new e.Event("tooltip" + t);
          return o.originalEvent = r && e.extend({}, r) || this.cache.event || P, this.triggering = t, this.tooltip.trigger(o, [this].concat(n || [])), this.triggering = N, !o.isDefaultPrevented();
        }, x._bindEvents = function (t, n, r, o, i, a) {
          var s = r.filter(o).add(o.filter(r)),
              l = [];
          s.length && (e.each(n, function (n, r) {
            var o = e.inArray(r, t);
            o > -1 && l.push(t.splice(o, 1)[0]);
          }), l.length && (this._bind(s, l, function (e) {
            (!!this.rendered && this.tooltip[0].offsetWidth > 0 ? a : i).call(this, e);
          }), r = r.not(s), o = o.not(s))), this._bind(r, t, i), this._bind(o, n, a);
        }, x._assignInitialEvents = function (t) {
          function n(t) {
            return this.disabled || this.destroyed ? N : (this.cache.event = t && e.event.fix(t), this.cache.target = t && e(t.target), clearTimeout(this.timers.show), void (this.timers.show = d.call(this, function () {
              this.render("object" == typeof t || r.show.ready);
            }, r.prerender ? 0 : r.show.delay)));
          }

          var r = this.options,
              o = r.show.target,
              i = r.hide.target,
              a = r.show.event ? e.trim("" + r.show.event).split(" ") : [],
              s = r.hide.event ? e.trim("" + r.hide.event).split(" ") : [];
          this._bind(this.elements.target, ["remove", "removeqtip"], function () {
            this.destroy(!0);
          }, "destroy"), /mouse(over|enter)/i.test(r.show.event) && !/mouse(out|leave)/i.test(r.hide.event) && s.push("mouseleave"), this._bind(o, "mousemove", function (e) {
            this._storeMouse(e), this.cache.onTarget = A;
          }), this._bindEvents(a, s, o, i, n, function () {
            return this.timers ? void clearTimeout(this.timers.show) : N;
          }), (r.show.ready || r.prerender) && n.call(this, t);
        }, x._assignEvents = function () {
          var t = this,
              n = this.options,
              r = n.position,
              o = this.tooltip,
              i = n.show.target,
              l = n.hide.target,
              u = r.container,
              c = r.viewport,
              d = e(s),
              g = e(a),
              v = n.show.event ? e.trim("" + n.show.event).split(" ") : [],
              y = n.hide.event ? e.trim("" + n.hide.event).split(" ") : [];
          e.each(n.events, function (e, n) {
            t._bind(o, "toggle" === e ? ["tooltipshow", "tooltiphide"] : ["tooltip" + e], n, null, o);
          }), /mouse(out|leave)/i.test(n.hide.event) && "window" === n.hide.leave && this._bind(d, ["mouseout", "blur"], function (e) {
            /select|option/.test(e.target.nodeName) || e.relatedTarget || this.hide(e);
          }), n.hide.fixed ? l = l.add(o.addClass(J)) : /mouse(over|enter)/i.test(n.show.event) && this._bind(l, "mouseleave", function () {
            clearTimeout(this.timers.show);
          }), ("" + n.hide.event).indexOf("unfocus") > -1 && this._bind(u.closest("html"), ["mousedown", "touchstart"], function (t) {
            var n = e(t.target),
                r = this.rendered && !this.tooltip.hasClass(ee) && this.tooltip[0].offsetWidth > 0,
                o = n.parents(G).filter(this.tooltip[0]).length > 0;
            n[0] === this.target[0] || n[0] === this.tooltip[0] || o || this.target.has(n[0]).length || !r || this.hide(t);
          }), "number" == typeof n.hide.inactive && (this._bind(i, "qtip-" + this.id + "-inactive", h, "inactive"), this._bind(l.add(o), S.inactiveEvents, h)), this._bindEvents(v, y, i, l, f, p), this._bind(i.add(o), "mousemove", function (e) {
            if ("number" == typeof n.hide.distance) {
              var t = this.cache.origin || {},
                  r = this.options.hide.distance,
                  o = Math.abs;
              (o(e.pageX - t.pageX) >= r || o(e.pageY - t.pageY) >= r) && this.hide(e);
            }

            this._storeMouse(e);
          }), "mouse" === r.target && r.adjust.mouse && (n.hide.event && this._bind(i, ["mouseenter", "mouseleave"], function (e) {
            return this.cache ? void (this.cache.onTarget = "mouseenter" === e.type) : N;
          }), this._bind(d, "mousemove", function (e) {
            this.rendered && this.cache.onTarget && !this.tooltip.hasClass(ee) && this.tooltip[0].offsetWidth > 0 && this.reposition(e);
          })), (r.adjust.resize || c.length) && this._bind(e.event.special.resize ? c : g, "resize", m), r.adjust.scroll && this._bind(g.add(r.container), "scroll", m);
        }, x._unassignEvents = function () {
          var t = this.options,
              n = t.show.target,
              r = t.hide.target,
              o = e.grep([this.elements.target[0], this.rendered && this.tooltip[0], t.position.container[0], t.position.viewport[0], t.position.container.closest("html")[0], a, s], function (e) {
            return "object" == typeof e;
          });
          n && n.toArray && (o = o.concat(n.toArray())), r && r.toArray && (o = o.concat(r.toArray())), this._unbind(o)._unbind(o, "destroy")._unbind(o, "inactive");
        }, e(function () {
          g(G, ["mouseenter", "mouseleave"], function (t) {
            var n = "mouseenter" === t.type,
                r = e(t.currentTarget),
                o = e(t.relatedTarget || t.target),
                i = this.options;
            n ? (this.focus(t), r.hasClass(J) && !r.hasClass(ee) && clearTimeout(this.timers.hide)) : "mouse" === i.position.target && i.position.adjust.mouse && i.hide.event && i.show.target && !o.closest(i.show.target[0]).length && this.hide(t), r.toggleClass(Z, n);
          }), g("[" + $ + "]", Y, h);
        }), S = e.fn.qtip = function (t, n, r) {
          var i = ("" + t).toLowerCase(),
              a = P,
              s = e.makeArray(arguments).slice(1),
              u = s[s.length - 1],
              c = this[0] ? e.data(this[0], W) : P;
          return !arguments.length && c || "api" === i ? c : "string" == typeof t ? (this.each(function () {
            var t = e.data(this, W);
            if (!t) return A;
            if (u && u.timeStamp && (t.cache.event = u), !n || "option" !== i && "options" !== i) t[i] && t[i].apply(t, s);else {
              if (r === l && !e.isPlainObject(n)) return a = t.get(n), N;
              t.set(n, r);
            }
          }), a !== P ? a : this) : "object" != typeof t && arguments.length ? void 0 : (c = o(e.extend(A, {}, t)), this.each(function (t) {
            var n, r;
            return r = e.isArray(c.id) ? c.id[t] : c.id, r = !r || r === N || r.length < 1 || S.api[r] ? S.nextid++ : r, n = v(e(this), r, c), n === N ? A : (S.api[r] = n, e.each(q, function () {
              "initialize" === this.initialize && this(n);
            }), void n._assignInitialEvents(u));
          }));
        }, e.qtip = t, S.api = {}, e.each({
          attr: function attr(t, n) {
            if (this.length) {
              var r = this[0],
                  o = "title",
                  i = e.data(r, "qtip");
              if (t === o && i && i.options && "object" == typeof i && "object" == typeof i.options && i.options.suppress) return arguments.length < 2 ? e.attr(r, ne) : (i && i.options.content.attr === o && i.cache.attr && i.set("content.text", n), this.attr(ne, n));
            }

            return e.fn["attr" + te].apply(this, arguments);
          },
          clone: function clone(t) {
            var n = e.fn["clone" + te].apply(this, arguments);
            return t || n.filter("[" + ne + "]").attr("title", function () {
              return e.attr(this, ne);
            }).removeAttr(ne), n;
          }
        }, function (t, n) {
          if (!n || e.fn[t + te]) return A;
          var r = e.fn[t + te] = e.fn[t];

          e.fn[t] = function () {
            return n.apply(this, arguments) || r.apply(this, arguments);
          };
        }), e.ui || (e["cleanData" + te] = e.cleanData, e.cleanData = function (t) {
          for (var n, r = 0; (n = e(t[r])).length; r++) {
            if (n.attr(z)) try {
              n.triggerHandler("removeqtip");
            } catch (e) {}
          }

          e["cleanData" + te].apply(this, arguments);
        }), S.version = "3.0.3-5-g", S.nextid = 0, S.inactiveEvents = Y, S.zindex = 15e3, S.defaults = {
          prerender: N,
          id: N,
          overwrite: A,
          suppress: A,
          content: {
            text: A,
            attr: "title",
            title: N,
            button: N
          },
          position: {
            my: "top left",
            at: "bottom right",
            target: N,
            container: N,
            viewport: N,
            adjust: {
              x: 0,
              y: 0,
              mouse: A,
              scroll: A,
              resize: A,
              method: "flipinvert flipinvert"
            },
            effect: function effect(t, n) {
              e(this).animate(n, {
                duration: 200,
                queue: N
              });
            }
          },
          show: {
            target: N,
            event: "mouseenter",
            effect: A,
            delay: 90,
            solo: N,
            ready: N,
            autofocus: N
          },
          hide: {
            target: N,
            event: "mouseleave",
            effect: A,
            delay: 0,
            fixed: N,
            inactive: N,
            leave: "window",
            distance: N
          },
          style: {
            classes: "",
            widget: N,
            width: N,
            height: N,
            def: A
          },
          events: {
            render: P,
            move: P,
            show: P,
            hide: P,
            toggle: P,
            visible: P,
            hidden: P,
            focus: P,
            blur: P
          }
        };
        var se,
            le,
            ue,
            ce,
            de,
            fe = "margin",
            pe = "border",
            he = "color",
            me = "background-color",
            ge = "transparent",
            ve = " !important",
            ye = !!s.createElement("canvas").getContext,
            be = /rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i,
            _e = {},
            we = ["Webkit", "O", "Moz", "ms"];
        ye ? (ce = a.devicePixelRatio || 1, de = function () {
          var e = s.createElement("canvas").getContext("2d");
          return e.backingStorePixelRatio || e.webkitBackingStorePixelRatio || e.mozBackingStorePixelRatio || e.msBackingStorePixelRatio || e.oBackingStorePixelRatio || 1;
        }(), ue = ce / de) : le = function le(e, t, n) {
          return "<qtipvml:" + e + ' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" ' + (t || "") + ' style="behavior: url(#default#VML); ' + (n || "") + '" />';
        }, e.extend(w.prototype, {
          init: function init(t) {
            var n, r;
            r = this.element = t.elements.tip = e("<div />", {
              class: W + "-tip"
            }).prependTo(t.tooltip), ye ? (n = e("<canvas />").appendTo(this.element)[0].getContext("2d"), n.lineJoin = "miter", n.miterLimit = 1e5, n.save()) : (n = le("shape", 'coordorigin="0,0"', "position:absolute;"), this.element.html(n + n), t._bind(e("*", r).add(r), ["click", "mousedown"], function (e) {
              e.stopPropagation();
            }, this._ns)), t._bind(t.tooltip, "tooltipmove", this.reposition, this._ns, this), this.create();
          },
          _swapDimensions: function _swapDimensions() {
            this.size[0] = this.options.height, this.size[1] = this.options.width;
          },
          _resetDimensions: function _resetDimensions() {
            this.size[0] = this.options.width, this.size[1] = this.options.height;
          },
          _useTitle: function _useTitle(e) {
            var t = this.qtip.elements.titlebar;
            return t && (e.y === L || e.y === B && this.element.position().top + this.size[1] / 2 + this.options.offset < t.outerHeight(A));
          },
          _parseCorner: function _parseCorner(e) {
            var t = this.qtip.options.position.my;
            return e === N || t === N ? e = N : e === A ? e = new T(t.string()) : e.string || (e = new T(e), e.fixed = A), e;
          },
          _parseWidth: function _parseWidth(e, t, n) {
            var r = this.qtip.elements,
                o = pe + y(t) + "Width";
            return (n ? _(n, o) : _(r.content, o) || _(this._useTitle(e) && r.titlebar || r.content, o) || _(r.tooltip, o)) || 0;
          },
          _parseRadius: function _parseRadius(e) {
            var t = this.qtip.elements,
                n = pe + y(e.y) + y(e.x) + "Radius";
            return re.ie < 9 ? 0 : _(this._useTitle(e) && t.titlebar || t.content, n) || _(t.tooltip, n) || 0;
          },
          _invalidColour: function _invalidColour(e, t, n) {
            var r = e.css(t);
            return !r || n && r === e.css(n) || be.test(r) ? N : r;
          },
          _parseColours: function _parseColours(t) {
            var n = this.qtip.elements,
                r = this.element.css("cssText", ""),
                o = pe + y(t[t.precedance]) + y(he),
                i = this._useTitle(t) && n.titlebar || n.content,
                a = this._invalidColour,
                s = [];
            return s[0] = a(r, me) || a(i, me) || a(n.content, me) || a(n.tooltip, me) || r.css(me), s[1] = a(r, o, he) || a(i, o, he) || a(n.content, o, he) || a(n.tooltip, o, he) || n.tooltip.css(o), e("*", r).add(r).css("cssText", me + ":" + ge + ve + ";" + pe + ":0" + ve + ";"), s;
          },
          _calculateSize: function _calculateSize(e) {
            var t,
                n,
                r,
                o = e.precedance === I,
                i = this.options.width,
                a = this.options.height,
                s = "c" === e.abbrev(),
                l = (o ? i : a) * (s ? .5 : 1),
                u = Math.pow,
                c = Math.round,
                d = Math.sqrt(u(l, 2) + u(a, 2)),
                f = [this.border / l * d, this.border / a * d];
            return f[2] = Math.sqrt(u(f[0], 2) - u(this.border, 2)), f[3] = Math.sqrt(u(f[1], 2) - u(this.border, 2)), t = d + f[2] + f[3] + (s ? 0 : f[0]), n = t / d, r = [c(n * i), c(n * a)], o ? r : r.reverse();
          },
          _calculateTip: function _calculateTip(e, t, n) {
            n = n || 1, t = t || this.size;
            var r = t[0] * n,
                o = t[1] * n,
                i = Math.ceil(r / 2),
                a = Math.ceil(o / 2),
                s = {
              br: [0, 0, r, o, r, 0],
              bl: [0, 0, r, 0, 0, o],
              tr: [0, o, r, 0, r, o],
              tl: [0, 0, 0, o, r, o],
              tc: [0, o, i, 0, r, o],
              bc: [0, 0, r, 0, i, o],
              rc: [0, 0, r, a, 0, o],
              lc: [r, 0, r, o, 0, a]
            };
            return s.lt = s.br, s.rt = s.bl, s.lb = s.tr, s.rb = s.tl, s[e.abbrev()];
          },
          _drawCoords: function _drawCoords(e, t) {
            e.beginPath(), e.moveTo(t[0], t[1]), e.lineTo(t[2], t[3]), e.lineTo(t[4], t[5]), e.closePath();
          },
          create: function create() {
            var e = this.corner = (ye || re.ie) && this._parseCorner(this.options.corner);

            return this.enabled = !!this.corner && "c" !== this.corner.abbrev(), this.enabled && (this.qtip.cache.corner = e.clone(), this.update()), this.element.toggle(this.enabled), this.corner;
          },
          update: function update(t, n) {
            if (!this.enabled) return this;
            var r,
                o,
                i,
                s,
                l,
                u,
                c,
                d,
                f = this.qtip.elements,
                p = this.element,
                h = p.children(),
                m = this.options,
                g = this.size,
                v = m.mimic,
                y = Math.round;
            t || (t = this.qtip.cache.corner || this.corner), v === N ? v = t : (v = new T(v), v.precedance = t.precedance, "inherit" === v.x ? v.x = t.x : "inherit" === v.y ? v.y = t.y : v.x === v.y && (v[t.precedance] = t[t.precedance])), o = v.precedance, t.precedance === R ? this._swapDimensions() : this._resetDimensions(), r = this.color = this._parseColours(t), r[1] !== ge ? (d = this.border = this._parseWidth(t, t[t.precedance]), m.border && d < 1 && !be.test(r[1]) && (r[0] = r[1]), this.border = d = m.border !== A ? m.border : d) : this.border = d = 0, c = this.size = this._calculateSize(t), p.css({
              width: c[0],
              height: c[1],
              lineHeight: c[1] + "px"
            }), u = t.precedance === I ? [y(v.x === D ? d : v.x === U ? c[0] - g[0] - d : (c[0] - g[0]) / 2), y(v.y === L ? c[1] - g[1] : 0)] : [y(v.x === D ? c[0] - g[0] : 0), y(v.y === L ? d : v.y === F ? c[1] - g[1] - d : (c[1] - g[1]) / 2)], ye ? (i = h[0].getContext("2d"), i.restore(), i.save(), i.clearRect(0, 0, 6e3, 6e3), s = this._calculateTip(v, g, ue), l = this._calculateTip(v, this.size, ue), h.attr(M, c[0] * ue).attr(j, c[1] * ue), h.css(M, c[0]).css(j, c[1]), this._drawCoords(i, l), i.fillStyle = r[1], i.fill(), i.translate(u[0] * ue, u[1] * ue), this._drawCoords(i, s), i.fillStyle = r[0], i.fill()) : (s = this._calculateTip(v), s = "m" + s[0] + "," + s[1] + " l" + s[2] + "," + s[3] + " " + s[4] + "," + s[5] + " xe", u[2] = d && /^(r|b)/i.test(t.string()) ? 8 === re.ie ? 2 : 1 : 0, h.css({
              coordsize: c[0] + d + " " + c[1] + d,
              antialias: "" + (v.string().indexOf(B) > -1),
              left: u[0] - u[2] * Number(o === R),
              top: u[1] - u[2] * Number(o === I),
              width: c[0] + d,
              height: c[1] + d
            }).each(function (t) {
              var n = e(this);
              n[n.prop ? "prop" : "attr"]({
                coordsize: c[0] + d + " " + c[1] + d,
                path: s,
                fillcolor: r[0],
                filled: !!t,
                stroked: !t
              }).toggle(!(!d && !t)), !t && n.html(le("stroke", 'weight="' + 2 * d + 'px" color="' + r[1] + '" miterlimit="1000" joinstyle="miter"'));
            })), a.opera && setTimeout(function () {
              f.tip.css({
                display: "inline-block",
                visibility: "visible"
              });
            }, 1), n !== N && this.calculate(t, c);
          },
          calculate: function calculate(t, n) {
            if (!this.enabled) return N;
            var r,
                o,
                i = this,
                a = this.qtip.elements,
                s = this.element,
                l = this.options.offset,
                u = {};
            return t = t || this.corner, r = t.precedance, n = n || this._calculateSize(t), o = [t.x, t.y], r === R && o.reverse(), e.each(o, function (e, o) {
              var s, c, d;
              o === B ? (s = r === I ? D : L, u[s] = "50%", u[fe + "-" + s] = -Math.round(n[r === I ? 0 : 1] / 2) + l) : (s = i._parseWidth(t, o, a.tooltip), c = i._parseWidth(t, o, a.content), d = i._parseRadius(t), u[o] = Math.max(-i.border, e ? c : l + (d > s ? d : -s)));
            }), u[t[r]] -= n[r === R ? 0 : 1], s.css({
              margin: "",
              top: "",
              bottom: "",
              left: "",
              right: ""
            }).css(u), u;
          },
          reposition: function reposition(e, t, n) {
            function r(e, t, n, r, o) {
              e === H && u.precedance === t && c[r] && u[n] !== B ? u.precedance = u.precedance === R ? I : R : e !== H && c[r] && (u[t] = u[t] === B ? c[r] > 0 ? r : o : u[t] === r ? o : r);
            }

            function o(e, t, r) {
              u[e] === B ? m[fe + "-" + t] = h[e] = i[fe + "-" + t] - c[t] : (a = i[r] !== l ? [c[t], -i[t]] : [-c[t], i[t]], (h[e] = Math.max(a[0], a[1])) > a[0] && (n[t] -= c[t], h[t] = N), m[i[r] !== l ? r : t] = h[e]);
            }

            if (this.enabled) {
              var i,
                  a,
                  s = t.cache,
                  u = this.corner.clone(),
                  c = n.adjusted,
                  d = t.options.position.adjust.method.split(" "),
                  f = d[0],
                  p = d[1] || d[0],
                  h = {
                left: N,
                top: N,
                x: 0,
                y: 0
              },
                  m = {};
              this.corner.fixed !== A && (r(f, R, I, D, U), r(p, I, R, L, F), u.string() === s.corner.string() && s.cornerTop === c.top && s.cornerLeft === c.left || this.update(u, N)), i = this.calculate(u), i.right !== l && (i.left = -i.right), i.bottom !== l && (i.top = -i.bottom), i.user = this.offset, h.left = f === H && !!c.left, h.left && o(R, D, U), h.top = p === H && !!c.top, h.top && o(I, L, F), this.element.css(m).toggle(!(h.x && h.y || u.x === B && h.y || u.y === B && h.x)), n.left -= i.left.charAt ? i.user : f !== H || h.top || !h.left && !h.top ? i.left + this.border : 0, n.top -= i.top.charAt ? i.user : p !== H || h.left || !h.left && !h.top ? i.top + this.border : 0, s.cornerLeft = c.left, s.cornerTop = c.top, s.corner = u.clone();
            }
          },
          destroy: function destroy() {
            this.qtip._unbind(this.qtip.tooltip, this._ns), this.qtip.elements.tip && this.qtip.elements.tip.find("*").remove().end().remove();
          }
        }), se = q.tip = function (e) {
          return new w(e, e.options.style.tip);
        }, se.initialize = "render", se.sanitize = function (e) {
          if (e.style && "tip" in e.style) {
            var t = e.style.tip;
            "object" != typeof t && (t = e.style.tip = {
              corner: t
            }), /string|boolean/i.test(typeof t.corner) || (t.corner = A);
          }
        }, k.tip = {
          "^position.my|style.tip.(corner|mimic|border)$": function positionMyStyleTipCornerMimicBorder$() {
            this.create(), this.qtip.reposition();
          },
          "^style.tip.(height|width)$": function styleTipHeightWidth$(e) {
            this.size = [e.width, e.height], this.update(), this.qtip.reposition();
          },
          "^content.title|style.(classes|widget)$": function contentTitleStyleClassesWidget$() {
            this.update();
          }
        }, e.extend(A, S.defaults, {
          style: {
            tip: {
              corner: A,
              mimic: N,
              width: 6,
              height: 6,
              border: A,
              offset: 0
            }
          }
        });
        var Ee,
            Oe,
            Se = "qtip-modal",
            xe = "." + Se;
        Oe = function Oe() {
          function t(t) {
            if (e.expr[":"].focusable) return e.expr[":"].focusable;
            var n,
                r,
                o,
                i = !isNaN(e.attr(t, "tabindex")),
                a = t.nodeName && t.nodeName.toLowerCase();
            return "area" === a ? (n = t.parentNode, r = n.name, !(!t.href || !r || "map" !== n.nodeName.toLowerCase()) && !!(o = e("img[usemap=#" + r + "]")[0]) && o.is(":visible")) : /input|select|textarea|button|object/.test(a) ? !t.disabled : "a" === a ? t.href || i : i;
          }

          function n(e) {
            u.length < 1 && e.length ? e.not("body").blur() : u.first().focus();
          }

          function r(t) {
            if (a.is(":visible")) {
              var r = e(t.target),
                  i = o.tooltip,
                  s = r.closest(G);
              (s.length < 1 ? N : parseInt(s[0].style.zIndex, 10) > parseInt(i[0].style.zIndex, 10)) || r.closest(G)[0] === i[0] || n(r);
            }
          }

          var o,
              i,
              a,
              l = this,
              u = {};
          e.extend(l, {
            init: function init() {
              return a = l.elem = e("<div />", {
                id: "qtip-overlay",
                html: "<div></div>",
                mousedown: function mousedown() {
                  return N;
                }
              }).hide(), e(s.body).bind("focusin" + xe, r), e(s).bind("keydown" + xe, function (e) {
                o && o.options.show.modal.escape && 27 === e.keyCode && o.hide(e);
              }), a.bind("click" + xe, function (e) {
                o && o.options.show.modal.blur && o.hide(e);
              }), l;
            },
            update: function update(e) {
              o = e, u = e.options.show.modal.stealfocus !== N ? e.tooltip.find("*").filter(function () {
                return t(this);
              }) : [];
            },
            toggle: function toggle(t, r, u) {
              var c = t.tooltip,
                  d = t.options.show.modal,
                  f = d.effect,
                  p = r ? "show" : "hide",
                  h = a.is(":visible"),
                  m = e(xe).filter(":visible:not(:animated)").not(c);
              return l.update(t), r && d.stealfocus !== N && n(e(":focus")), a.toggleClass("blurs", d.blur), r && a.appendTo(s.body), a.is(":animated") && h === r && i !== N || !r && m.length ? l : (a.stop(A, N), e.isFunction(f) ? f.call(a, r) : f === N ? a[p]() : a.fadeTo(parseInt(u, 10) || 90, r ? 1 : 0, function () {
                r || a.hide();
              }), r || a.queue(function (t) {
                a.css({
                  left: "",
                  top: ""
                }), e(xe).length || a.detach(), t();
              }), i = r, o.destroyed && (o = P), l);
            }
          }), l.init();
        }, Oe = new Oe(), e.extend(E.prototype, {
          init: function init(t) {
            var n = t.tooltip;
            return this.options.on ? (t.elements.overlay = Oe.elem, n.addClass(Se).css("z-index", S.modal_zindex + e(xe).length), t._bind(n, ["tooltipshow", "tooltiphide"], function (t, r, o) {
              var i = t.originalEvent;
              if (t.target === n[0]) if (i && "tooltiphide" === t.type && /mouse(leave|enter)/.test(i.type) && e(i.relatedTarget).closest(Oe.elem[0]).length) try {
                t.preventDefault();
              } catch (e) {} else (!i || i && "tooltipsolo" !== i.type) && this.toggle(t, "tooltipshow" === t.type, o);
            }, this._ns, this), t._bind(n, "tooltipfocus", function (t, r) {
              if (!t.isDefaultPrevented() && t.target === n[0]) {
                var o = e(xe),
                    i = S.modal_zindex + o.length,
                    a = parseInt(n[0].style.zIndex, 10);
                Oe.elem[0].style.zIndex = i - 1, o.each(function () {
                  this.style.zIndex > a && (this.style.zIndex -= 1);
                }), o.filter("." + X).qtip("blur", t.originalEvent), n.addClass(X)[0].style.zIndex = i, Oe.update(r);

                try {
                  t.preventDefault();
                } catch (e) {}
              }
            }, this._ns, this), void t._bind(n, "tooltiphide", function (t) {
              t.target === n[0] && e(xe).filter(":visible").not(n).last().qtip("focus", t);
            }, this._ns, this)) : this;
          },
          toggle: function toggle(e, t, n) {
            return e && e.isDefaultPrevented() ? this : void Oe.toggle(this.qtip, !!t, n);
          },
          destroy: function destroy() {
            this.qtip.tooltip.removeClass(Se), this.qtip._unbind(this.qtip.tooltip, this._ns), Oe.toggle(this.qtip, N), delete this.qtip.elements.overlay;
          }
        }), Ee = q.modal = function (e) {
          return new E(e, e.options.show.modal);
        }, Ee.sanitize = function (e) {
          e.show && ("object" != typeof e.show.modal ? e.show.modal = {
            on: !!e.show.modal
          } : void 0 === e.show.modal.on && (e.show.modal.on = A));
        }, S.modal_zindex = S.zindex - 200, Ee.initialize = "render", k.modal = {
          "^show.modal.(on|blur)$": function showModalOnBlur$() {
            this.destroy(), this.init(), this.qtip.elems.overlay.toggle(this.qtip.tooltip[0].offsetWidth > 0);
          }
        }, e.extend(A, S.defaults, {
          show: {
            modal: {
              on: N,
              effect: A,
              blur: A,
              stealfocus: A,
              escape: A
            }
          }
        }), q.viewport = function (e, t, n, r, o, i, l) {
          function u(e, n, r, o, i, a, s, l, u) {
            var c = t[i],
                y = _[e],
                b = w[e],
                E = r === H,
                O = y === i ? u : y === a ? -u : -u / 2,
                S = b === i ? l : b === a ? -l : -l / 2,
                x = g[i] + v[i] - (p ? 0 : f[i]),
                T = x - c,
                k = c + u - (s === M ? h : m) - x,
                C = O - (_.precedance === e || y === _[n] ? S : 0) - (b === B ? l / 2 : 0);
            return E ? (C = (y === i ? 1 : -1) * O, t[i] += T > 0 ? T : k > 0 ? -k : 0, t[i] = Math.max(-f[i] + v[i], c - C, Math.min(Math.max(-f[i] + v[i] + (s === M ? h : m), c + C), t[i], "center" === y ? c - O : 1e9))) : (o *= r === V ? 2 : 0, T > 0 && (y !== i || k > 0) ? (t[i] -= C + o, d.invert(e, i)) : k > 0 && (y !== a || T > 0) && (t[i] -= (y === B ? -C : C) + o, d.invert(e, a)), t[i] < g[i] && -t[i] > k && (t[i] = c, d = _.clone())), t[i] - c;
          }

          var c,
              d,
              f,
              p,
              h,
              m,
              g,
              v,
              y = n.target,
              b = e.elements.tooltip,
              _ = n.my,
              w = n.at,
              E = n.adjust,
              O = E.method.split(" "),
              S = O[0],
              x = O[1] || O[0],
              T = n.viewport,
              k = n.container,
              C = {
            left: 0,
            top: 0
          };
          return T.jquery && y[0] !== a && y[0] !== s.body && "none" !== E.method ? (f = k.offset() || C, p = "static" === k.css("position"), c = "fixed" === b.css("position"), h = T[0] === a ? T.width() : T.outerWidth(N), m = T[0] === a ? T.height() : T.outerHeight(N), g = {
            left: c ? 0 : T.scrollLeft(),
            top: c ? 0 : T.scrollTop()
          }, v = T.offset() || C, "shift" === S && "shift" === x || (d = _.clone()), C = {
            left: "none" !== S ? u(R, I, S, E.x, D, U, M, r, i) : 0,
            top: "none" !== x ? u(I, R, x, E.y, L, F, j, o, l) : 0,
            my: d
          }) : C;
        }, q.polys = {
          polygon: function polygon(e, t) {
            var n,
                r,
                o,
                i = {
              width: 0,
              height: 0,
              position: {
                top: 1e10,
                right: 0,
                bottom: 0,
                left: 1e10
              },
              adjustable: N
            },
                a = 0,
                s = [],
                l = 1,
                u = 1,
                c = 0,
                d = 0;

            for (a = e.length; a--;) {
              n = [parseInt(e[--a], 10), parseInt(e[a + 1], 10)], n[0] > i.position.right && (i.position.right = n[0]), n[0] < i.position.left && (i.position.left = n[0]), n[1] > i.position.bottom && (i.position.bottom = n[1]), n[1] < i.position.top && (i.position.top = n[1]), s.push(n);
            }

            if (r = i.width = Math.abs(i.position.right - i.position.left), o = i.height = Math.abs(i.position.bottom - i.position.top), "c" === t.abbrev()) i.position = {
              left: i.position.left + i.width / 2,
              top: i.position.top + i.height / 2
            };else {
              for (; r > 0 && o > 0 && l > 0 && u > 0;) {
                for (r = Math.floor(r / 2), o = Math.floor(o / 2), t.x === D ? l = r : t.x === U ? l = i.width - r : l += Math.floor(r / 2), t.y === L ? u = o : t.y === F ? u = i.height - o : u += Math.floor(o / 2), a = s.length; a-- && !(s.length < 2);) {
                  c = s[a][0] - i.position.left, d = s[a][1] - i.position.top, (t.x === D && c >= l || t.x === U && c <= l || t.x === B && (c < l || c > i.width - l) || t.y === L && d >= u || t.y === F && d <= u || t.y === B && (d < u || d > i.height - u)) && s.splice(a, 1);
                }
              }

              i.position = {
                left: s[0][0],
                top: s[0][1]
              };
            }
            return i;
          },
          rect: function rect(e, t, n, r) {
            return {
              width: Math.abs(n - e),
              height: Math.abs(r - t),
              position: {
                left: Math.min(e, n),
                top: Math.min(t, r)
              }
            };
          },
          _angles: {
            tc: 1.5,
            tr: 7 / 4,
            tl: 5 / 4,
            bc: .5,
            br: .25,
            bl: .75,
            rc: 2,
            lc: 1,
            c: 0
          },
          ellipse: function ellipse(e, t, n, r, o) {
            var i = q.polys._angles[o.abbrev()],
                a = 0 === i ? 0 : n * Math.cos(i * Math.PI),
                s = r * Math.sin(i * Math.PI);

            return {
              width: 2 * n - Math.abs(a),
              height: 2 * r - Math.abs(s),
              position: {
                left: e + a,
                top: t + s
              },
              adjustable: N
            };
          },
          circle: function circle(e, t, n, r) {
            return q.polys.ellipse(e, t, n, n, r);
          }
        }, q.svg = function (t, n, r) {
          for (var o, i, a, l, u, c, d, f, p, h = n[0], m = e(h.ownerSVGElement), g = h.ownerDocument, v = (parseInt(n.css("stroke-width"), 10) || 0) / 2; !h.getBBox;) {
            h = h.parentNode;
          }

          if (!h.getBBox || !h.parentNode) return N;

          switch (h.nodeName) {
            case "ellipse":
            case "circle":
              f = q.polys.ellipse(h.cx.baseVal.value, h.cy.baseVal.value, (h.rx || h.r).baseVal.value + v, (h.ry || h.r).baseVal.value + v, r);
              break;

            case "line":
            case "polygon":
            case "polyline":
              for (d = h.points || [{
                x: h.x1.baseVal.value,
                y: h.y1.baseVal.value
              }, {
                x: h.x2.baseVal.value,
                y: h.y2.baseVal.value
              }], f = [], c = -1, l = d.numberOfItems || d.length; ++c < l;) {
                u = d.getItem ? d.getItem(c) : d[c], f.push.apply(f, [u.x, u.y]);
              }

              f = q.polys.polygon(f, r);
              break;

            default:
              f = h.getBBox(), f = {
                width: f.width,
                height: f.height,
                position: {
                  left: f.x,
                  top: f.y
                }
              };
          }

          return p = f.position, m = m[0], m.createSVGPoint && (i = h.getScreenCTM(), d = m.createSVGPoint(), d.x = p.left, d.y = p.top, a = d.matrixTransform(i), p.left = a.x, p.top = a.y), g !== s && "mouse" !== t.position.target && (o = e((g.defaultView || g.parentWindow).frameElement).offset()) && (p.left += o.left, p.top += o.top), g = e(g), p.left += g.scrollLeft(), p.top += g.scrollTop(), f;
        }, q.imagemap = function (t, n, r) {
          n.jquery || (n = e(n));
          var o,
              i,
              a,
              s,
              l,
              u = (n.attr("shape") || "rect").toLowerCase().replace("poly", "polygon"),
              c = e('img[usemap="#' + n.parent("map").attr("name") + '"]'),
              d = e.trim(n.attr("coords")),
              f = d.replace(/,$/, "").split(",");
          if (!c.length) return N;
          if ("polygon" === u) s = q.polys.polygon(f, r);else {
            if (!q.polys[u]) return N;

            for (a = -1, l = f.length, i = []; ++a < l;) {
              i.push(parseInt(f[a], 10));
            }

            s = q.polys[u].apply(this, i.concat(r));
          }
          return o = c.offset(), o.left += Math.ceil((c.outerWidth(N) - c.width()) / 2), o.top += Math.ceil((c.outerHeight(N) - c.height()) / 2), s.position.left += o.left, s.position.top += o.top, s;
        };
        var Te;
        e.extend(O.prototype, {
          _scroll: function _scroll() {
            var t = this.qtip.elements.overlay;
            t && (t[0].style.top = e(a).scrollTop() + "px");
          },
          init: function init(t) {
            var n = t.tooltip;
            e("select, object").length < 1 && (this.bgiframe = t.elements.bgiframe = e('<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';"  style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>').appendTo(n), t._bind(n, "tooltipmove", this.adjustBGIFrame, this._ns, this)), this.redrawContainer = e("<div/>", {
              id: W + "-rcontainer"
            }).appendTo(s.body), t.elements.overlay && t.elements.overlay.addClass("qtipmodal-ie6fix") && (t._bind(a, ["scroll", "resize"], this._scroll, this._ns, this), t._bind(n, ["tooltipshow"], this._scroll, this._ns, this)), this.redraw();
          },
          adjustBGIFrame: function adjustBGIFrame() {
            var e,
                t,
                n = this.qtip.tooltip,
                r = {
              height: n.outerHeight(N),
              width: n.outerWidth(N)
            },
                o = this.qtip.plugins.tip,
                i = this.qtip.elements.tip;
            t = parseInt(n.css("borderLeftWidth"), 10) || 0, t = {
              left: -t,
              top: -t
            }, o && i && (e = "x" === o.corner.precedance ? [M, D] : [j, L], t[e[1]] -= i[e[0]]()), this.bgiframe.css(t).css(r);
          },
          redraw: function redraw() {
            if (this.qtip.rendered < 1 || this.drawing) return this;
            var e,
                t,
                n,
                r,
                o = this.qtip.tooltip,
                i = this.qtip.options.style,
                a = this.qtip.options.position.container;
            return this.qtip.drawing = 1, i.height && o.css(j, i.height), i.width ? o.css(M, i.width) : (o.css(M, "").appendTo(this.redrawContainer), t = o.width(), t % 2 < 1 && (t += 1), n = o.css("maxWidth") || "", r = o.css("minWidth") || "", e = (n + r).indexOf("%") > -1 ? a.width() / 100 : 0, n = (n.indexOf("%") > -1 ? e : 1 * parseInt(n, 10)) || t, r = (r.indexOf("%") > -1 ? e : 1 * parseInt(r, 10)) || 0, t = n + r ? Math.min(Math.max(t, r), n) : t, o.css(M, Math.round(t)).appendTo(a)), this.drawing = 0, this;
          },
          destroy: function destroy() {
            this.bgiframe && this.bgiframe.remove(), this.qtip._unbind([a, this.qtip.tooltip], this._ns);
          }
        }), Te = q.ie6 = function (e) {
          return 6 === re.ie ? new O(e) : N;
        }, Te.initialize = "render", k.ie6 = {
          "^content|style$": function contentStyle$() {
            this.redraw();
          }
        };
      });
    }(window, document);
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(16)),
        a = r(n(24)),
        s = r(n(15)),
        l = r(n(12)),
        u = r(n(93)),
        c = u.default.extend({
      extraProperties: !0,
      flat: !1,
      props: {
        id: "string",
        factorType: {
          type: "string",
          values: ["sms", "call", "email", "token", "token:software:totp", "token:hotp", "token:hardware", "question", "push", "u2f", "password", "assertion:saml2", "assertion:oidc", "claims_provider", "webauthn"]
        },
        provider: {
          type: "string",
          values: ["OKTA", "RSA", "DEL_OATH", "SYMANTEC", "GOOGLE", "YUBICO", "FIDO", "CUSTOM", "GENERIC_SAML", "GENERIC_OIDC"]
        },
        enrollment: {
          type: "string",
          values: ["OPTIONAL", "REQUIRED"]
        },
        status: {
          type: "string",
          values: ["NOT_SETUP", "ACTIVE"]
        },
        profile: ["object"],
        vendorName: "string",
        policy: ["object"],
        profiles: ["object"]
      },
      local: {
        answer: "string",
        password: "string",
        backupFactor: "object",
        showAnswer: "boolean",
        rememberDevice: "boolean",
        autoPush: ["boolean", !0, !1]
      },
      derived: {
        isOktaFactor: {
          deps: ["provider"],
          fn: function fn(e) {
            return "OKTA" === e;
          }
        },
        factorName: {
          deps: ["provider", "factorType"],
          fn: s.default.getFactorName
        },
        factorLabel: {
          deps: ["provider", "factorType", "vendorName"],
          fn: function fn(e, t, n) {
            return o._.contains(["DEL_OATH", "GENERIC_SAML", "GENERIC_OIDC", "CUSTOM"], e) ? n : s.default.getFactorLabel.apply(this, [e, t]);
          }
        },
        factorDescription: {
          deps: ["provider", "factorType"],
          fn: s.default.getFactorDescription
        },
        sortOrder: {
          deps: ["provider", "factorType"],
          fn: s.default.getFactorSortOrder
        },
        iconClassName: {
          deps: ["provider", "factorType"],
          fn: s.default.getFactorIconClassName
        },
        securityQuestion: {
          deps: ["profile", "factorType"],
          fn: function fn(e, t) {
            return "question" !== t ? null : e && s.default.getSecurityQuestionLabel(e);
          }
        },
        phoneNumber: {
          deps: ["profile", "factorType"],
          fn: function fn(e, t) {
            return o._.contains(["sms", "call"], t) ? e && e.phoneNumber : null;
          }
        },
        email: {
          deps: ["profile", "factorType"],
          fn: function fn(e, t) {
            return "email" === t ? e && e.email : null;
          }
        },
        deviceName: {
          deps: ["profile", "factorType"],
          fn: function fn(e, t) {
            return "push" !== t ? null : e && e.name;
          }
        },
        enrolled: {
          deps: ["status"],
          fn: function fn(e) {
            return "ACTIVE" === e;
          }
        },
        cardinality: {
          deps: ["policy", "profiles"],
          fn: function fn(e, t) {
            if (t && t.length > 0) {
              var n = t[0],
                  r = n._embedded.enrolledFactors.length,
                  i = o._.findWhere(n._embedded.features, {
                type: "adoption"
              });

              return !(!i || !i.cardinality) && {
                enrolled: r,
                minimum: i.cardinality.min,
                maximum: i.cardinality.max
              };
            }

            return !(!e || !e.enrollment) && e.enrollment;
          }
        },
        additionalEnrollment: {
          deps: ["cardinality"],
          fn: function fn(e) {
            return !!e && 0 !== e.enrolled && e.enrolled < e.maximum;
          }
        },
        required: {
          deps: ["enrollment"],
          fn: function fn(e) {
            return "REQUIRED" === e;
          }
        },
        canUseResend: {
          deps: ["provider", "factorType"],
          fn: function fn(e, t) {
            return "OKTA" === e && o._.contains(["push", "sms", "call", "email"], t);
          }
        },
        isAnswerRequired: {
          deps: ["factorType"],
          fn: function fn(e) {
            return o._.contains(["sms", "call", "email", "token", "token:software:totp", "question"], e);
          }
        },
        isFactorTypeVerification: {
          deps: ["provider", "id"],
          fn: function fn(e, t) {
            return void 0 === e && void 0 === t;
          }
        }
      },
      parse: function parse(e) {
        return this.settings = e.settings, this.appState = e.appState, e.rememberDevice = s.default.getRememberDeviceValue(this.appState), this.setCustomHotpVendorName(e), o._.omit(e, ["settings", "appState"]);
      },
      validate: function validate() {
        return this.get("isAnswerRequired") && !this.get("answer") ? {
          answer: (0, o.loc)("model.validation.field.blank")
        } : "password" !== this.get("factorType") || this.get("password") ? void 0 : {
          password: (0, o.loc)("error.password.required")
        };
      },
      needsPasscode: function needsPasscode() {
        return !(this.options.appState.get("isIdxStateToken") && "email" === this.get("factorType"));
      },
      resend: function resend() {
        return this.trigger("form:clear-errors"), this.manageTransaction(function (e) {
          var t = e.data._links.resend[0];
          return e.resend(t.name);
        });
      },
      save: function save() {
        var e = !!this.get("rememberDevice"),
            t = this;
        return this.manageTransaction(function (n, r) {
          var o = {
            rememberDevice: e
          };
          "question" === this.get("factorType") ? o.answer = this.get("answer") : "password" === this.get("factorType") ? o.password = this.get("password") : this.needsPasscode() && (o.passCode = this.get("answer")), this.pushFactorHasAutoPush() && (o.autoPush = this.get("autoPush"));
          var s;

          if ("MFA_REQUIRED" === n.status || "FACTOR_REQUIRED" === n.status || this.appState.get("promptForFactorInUnauthenticated")) {
            s = this._findFactor(n).verify(o);
          } else if (this.get("canUseResend") && !this.get("answer") && n.resend) {
            var u = n.data._links.resend[0];
            s = n.resend(u.name);
          } else s = n.verify(o);

          return this.trigger("save"), s.then(function (e) {
            var n = {
              delay: 4e3,
              transactionCallBack: function transactionCallBack(e) {
                t.options.appState.set("lastAuthResponse", e);
              }
            };

            if (r(e), "MFA_CHALLENGE" === e.status && e.poll || "FACTOR_CHALLENGE" === e.status && e.poll) {
              var o = i.default.defer(),
                  s = l.default.callAfterTimeout(o.resolve, 4e3);
              return t.listenToOnce(t.options.appState, "factorSwitched", function () {
                clearTimeout(s), o.reject(new a.default.AuthStopPollInitiationError());
              }), o.promise.then(function () {
                return t.stopListening(t.options.appState, "factorSwitched"), t.pushFactorHasAutoPush() && (n.autoPush = function () {
                  return t.get("autoPush");
                }, n.rememberDevice = function () {
                  return t.get("rememberDevice");
                }), e.poll(n).then(function (e) {
                  t.options.appState.set("lastAuthResponse", e.data), r(e);
                });
              });
            }
          });
        });
      },
      _findFactor: function _findFactor(e) {
        var t;
        return e.factorTypes && (t = o._.findWhere(e.factorTypes, {
          factorType: this.get("factorType")
        })), t || (t = o._.findWhere(e.factors, {
          id: this.get("id")
        })), t;
      },
      pushFactorHasAutoPush: function pushFactorHasAutoPush() {
        return this.settings.get("features.autoPush") && "push" === this.get("factorType");
      },
      setCustomHotpVendorName: function setCustomHotpVendorName(e) {
        if ("token:hotp" === e.factorType && e.profiles) if ("NOT_SETUP" === e.status) e.vendorName = e.profiles[0].name;else if ("ACTIVE" === e.status) {
          var t = e.profiles.filter(function (e) {
            return e._embedded.enrolledFactors.length > 0;
          });
          e.vendorName = t[0].name;
        }
        return e;
      }
    }),
        d = o.Collection.extend({
      model: c,
      comparator: "sortOrder",
      parse: function parse(e) {
        this.lastUsedFactor = e[0];

        var t,
            n = o._.findWhere(e, {
          provider: "OKTA",
          factorType: "push"
        });

        if (t = o._.where(e, {
          factorType: "push"
        }).length > 1 ? o._.findWhere(e, {
          factorType: "token:software:totp"
        }) : o._.findWhere(e, {
          provider: "OKTA",
          factorType: "token:software:totp"
        }), !n || !t) return e;

        var r = t === e[0],
            i = o._.reduce(e, function (e, r) {
          var o = "OKTA" === r.provider,
              i = o && "token:software:totp" === r.factorType,
              a = o && "push" === r.factorType,
              s = "ACTIVE" !== r.status,
              l = i && (s || "ACTIVE" === n.status),
              u = a && s && "ACTIVE" === t.status;
          return l || u ? e : (a && (r.backupFactor = new c(t, {
            parse: !0
          })), e.push(r), e);
        }, []);

        return r && (this.lastUsedFactor = n), i;
      },
      getDefaultFactor: function getDefaultFactor() {
        var e = o._.pick(this.lastUsedFactor, "factorType", "provider");

        return this.findWhere(e);
      },
      getFirstUnenrolledRequiredFactor: function getFirstUnenrolledRequiredFactor() {
        return this.findWhere({
          required: !0,
          enrolled: !1
        });
      },
      _getFactorsOfType: function _getFactorsOfType(e) {
        return this.where({
          factorType: e
        });
      },
      getFactorIndex: function getFactorIndex(e, t) {
        return this._getFactorsOfType(e).findIndex(function (e) {
          return e.get("id") === t;
        });
      },
      hasMultipleFactorsOfSameType: function hasMultipleFactorsOfSameType(e) {
        return this._getFactorsOfType(e).length > 1;
      },
      getFactorByTypeAndIndex: function getFactorByTypeAndIndex(e, t) {
        return this._getFactorsOfType(e)[t];
      }
    }),
        f = {
      Model: c,
      Collection: d
    };
    t.default = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = {};
    r.getStringHash = function (e) {
      for (var t = 5381, n = e.length; n;) {
        t = 33 * t ^ e.charCodeAt(--n);
      }

      return t >>> 0;
    }, r.base64UrlSafeToBase64 = function (e) {
      return e.replace(new RegExp("_", "g"), "/").replace(new RegExp("-", "g"), "+");
    }, r.binToStr = function (e) {
      return btoa(new Uint8Array(e).reduce(function (e, t) {
        return e + String.fromCharCode(t);
      }, ""));
    }, r.strToBin = function (e) {
      return Uint8Array.from(atob(this.base64UrlSafeToBase64(e)), function (e) {
        return e.charCodeAt(0);
      });
    };
    var o = r;
    t.default = o;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = r(n(5)),
        l = a.internal.util.Util,
        u = a.View.extend({
      template: i.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link ' + u((a = null != (a = c(n, "linkClassName") || (null != t ? c(t, "linkClassName") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "linkClassName",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 24
              },
              end: {
                line: 1,
                column: 41
              }
            }
          }) : a)) + '" data-se="signout-link">' + u((a = null != (a = c(n, "linkText") || (null != t ? c(t, "linkText") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "linkText",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 66
              },
              end: {
                line: 1,
                column: 78
              }
            }
          }) : a)) + "</a>";
        },
        useData: !0
      }),
      className: "auth-footer clearfix",
      events: {
        'click a[data-se="signout-link"]': "handleSignout"
      },
      handleSignout: function handleSignout(e) {
        var t = this;
        e.preventDefault();
        var n = this.options.appState;
        n.trigger("signOut");
        var r = n.get("isSMSPasswordRecovery");
        this.model.doTransaction(function (e) {
          return e.cancel();
        }).then(function () {
          t.settings.get("signOutLink") && !r ? l.redirect(t.settings.get("signOutLink")) : (t.state.set("navigateDir", s.default.DIRECTION_BACK), n.trigger("navigate", ""));
        });
      },
      getTemplateData: function getTemplateData() {
        return {
          linkClassName: a._.isUndefined(this.options.linkClassName) ? "goto" : this.options.linkClassName,
          linkText: this.options.linkText || (0, a.loc)("signout", "login")
        };
      }
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      var r = a.default.defer();
      return e.animate({
        "text-indent": 1
      }, {
        duration: 200,
        easing: "swing",
        step: function step(r, o) {
          o.start = t, o.end = n, e.css("transform", "scale(" + r + ", " + r + ")");
        },
        always: function always() {
          r.resolve(e);
        }
      }), r.promise;
    }

    function o(e, t, n) {
      var r = a.default.defer();
      return e.animate({
        "text-indent": 1
      }, {
        duration: 150,
        easing: "swing",
        step: function step(r, o) {
          o.start = t, o.end = n, e.css("transform", "rotate(" + r + "deg)");
        },
        always: function always() {
          r.resolve(e);
        }
      }), r.promise;
    }

    var i = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = i(n(16)),
        s = i(n(5)),
        l = {};
    l.swapPages = function (e) {
      var t = a.default.defer(),
          n = e.$parent,
          r = e.$oldRoot,
          o = e.$newRoot,
          i = e.success,
          l = e.ctx,
          u = "transition-from-right";
      return e.dir && e.dir === s.default.DIRECTION_BACK && (u = "transition-from-left"), o.addClass(u), n.append(o), n.addClass("animation-container-overflow"), o.animate({
        left: "0px",
        top: "0px",
        opacity: 1
      }, 200, function () {
        n.removeClass("animation-container-overflow"), o.removeClass(u), o.removeAttr("style"), i.call(l), t.resolve();
      }), r.animate({
        height: o.height(),
        opacity: 0
      }, 160), t.promise;
    }, l.swapBeacons = function (e) {
      var t = e.$el,
          n = e.swap,
          r = e.ctx;
      return this.implode(t).then(function () {
        return n.call(r), t;
      }).then(this.explode);
    }, l.explode = function (e) {
      return r(e, 0, 1);
    }, l.implode = function (e) {
      return r(e, 1, 0);
    }, l.radialProgressBar = function (e) {
      var t = e.$el,
          n = e.swap,
          r = t.children();
      return o(r, 0, 180).then(function () {
        t.css({
          clip: "auto"
        });
      }).then(function () {
        var e = r.eq(0);
        return n(), o(e, 180, 360);
      }).then(function () {
        t.css({
          clip: "rect(0px, 96px, 96px, 48px)"
        }), r.css({
          transform: "rotate(0deg)",
          "text-indent": "1px"
        });
      });
    };
    var u = l;
    t.default = u;
  }, function (e, t, n) {
    function r(e) {
      return o(e) || i(e) || a(e) || s();
    }

    var o = n(580),
        i = n(581),
        a = n(253),
        s = n(582);
    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    var r = {}.propertyIsEnumerable,
        o = Object.getOwnPropertyDescriptor,
        i = o && !r.call({
      1: 2
    }, 1);
    t.f = i ? function (e) {
      var t = o(this, e);
      return !!t && t.enumerable;
    } : r;
  }, function (e, t, n) {
    var r = n(35);

    e.exports = function (e, t) {
      if (!r(e)) return e;
      var n, o;
      if (t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
      if ("function" == typeof (n = e.valueOf) && !r(o = n.call(e))) return o;
      if (!t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, t, n) {
    var r = n(167),
        o = n(168),
        i = r("keys");

    e.exports = function (e) {
      return i[e] || (i[e] = o(e));
    };
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, n) {
    var r,
        o = n(36),
        i = n(171),
        a = n(172),
        s = n(123),
        l = n(301),
        u = n(165),
        c = n(122),
        d = c("IE_PROTO"),
        f = function f() {},
        p = function p(e) {
      return "<script>" + e + "<\/script>";
    },
        h = function h(e) {
      e.write(p("")), e.close();
      var t = e.parentWindow.Object;
      return e = null, t;
    },
        m = function m() {
      var e,
          t = u("iframe");
      return t.style.display = "none", l.appendChild(t), t.src = String("javascript:"), e = t.contentWindow.document, e.open(), e.write(p("document.F=Object")), e.close(), e.F;
    },
        _g = function g() {
      try {
        r = document.domain && new ActiveXObject("htmlfile");
      } catch (e) {}

      _g = r ? h(r) : m();

      for (var e = a.length; e--;) {
        delete _g.prototype[a[e]];
      }

      return _g();
    };

    s[d] = !0, e.exports = Object.create || function (e, t) {
      var n;
      return null !== e ? (f.prototype = o(e), n = new f(), f.prototype = null, n[d] = e) : n = _g(), void 0 === t ? n : i(n, t);
    };
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return {
          error: !1,
          value: e()
        };
      } catch (e) {
        return {
          error: !0,
          value: e
        };
      }
    };
  }, function (e, t, n) {
    var r = n(323),
        o = n(128);

    e.exports = function (e) {
      return r(o(e));
    };
  }, function (e, t) {
    var n = {}.toString;

    e.exports = function (e) {
      return n.call(e).slice(8, -1);
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 == e) throw TypeError("Can't call method on " + e);
      return e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return "object" == typeof e ? null !== e : "function" == typeof e;
    };
  }, function (e, t, n) {
    var r = n(129);

    e.exports = function (e) {
      if (!r(e)) throw TypeError(String(e) + " is not an object");
      return e;
    };
  }, function (e, t) {
    var n = Math.ceil,
        r = Math.floor;

    e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? r : n)(e);
    };
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = a(e);

      if (s) {
        var r = s(e);
        t && (r = l(r).call(r, function (t) {
          return u(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};

        if (t % 2) {
          var o;
          c(o = r(Object(n), !0)).call(o, function (t) {
            (0, v.default)(e, t, n[t]);
          });
        } else if (d) f(e, d(n));else {
          var i;
          c(i = r(Object(n))).call(i, function (t) {
            p(e, t, u(n, t));
          });
        }
      }

      return e;
    }

    function i() {
      this.handlers = [], this.use = function (e) {
        this.handlers.push({
          before: e
        });
      }, this.clear = function () {
        this.handlers = [];
      };
    }

    var a = n(133),
        s = n(184),
        l = n(134),
        u = n(187),
        c = n(106),
        d = n(188),
        f = n(189),
        p = n(34),
        h = n(40);
    p(t, "__esModule", {
      value: !0
    }), t.request = t.HttpClient = void 0;

    var m = h(n(80)),
        g = h(n(106)),
        v = h(n(190)),
        y = h(n(86)),
        b = h(n(249)),
        _ = n(675),
        w = {
      interceptors: {
        request: new i()
      }
    };

    t.HttpClient = w;

    var E = function () {
      function e(e, n) {
        return t.apply(this, arguments);
      }

      var t = (0, y.default)(m.default.mark(function e(t, n) {
        var r, i, a, s, l, u, c, d;
        return m.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = n.method, i = void 0 === r ? "POST" : r, a = n.headers, s = void 0 === a ? {} : a, l = n.body, u = {
                  url: t,
                  method: i,
                  headers: o(o({}, (0, _.userAgentHeaders)()), s),
                  body: l
                }, w.interceptors && (0, g.default)(c = w.interceptors.request.handlers).call(c, function (e) {
                  e.before(u);
                }), d = u.url, delete u.url, e.abrupt("return", (0, b.default)(d, u));

              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return e;
    }();

    t.request = E;
  }, function (e, t, n) {
    e.exports = n(650);
  }, function (e, t, n) {
    e.exports = n(654);
  }, function (e, t, n) {
    var r = n(20),
        o = n(14),
        i = n(176),
        a = o("species");

    e.exports = function (e) {
      return i >= 51 || !r(function () {
        var t = [],
            n = t.constructor = {};
        return n[a] = function () {
          return {
            foo: 1
          };
        }, 1 !== t[e](Boolean).foo;
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return e.escapeExpression((i = null != (i = a(n, "label") || (null != t ? a(t, "label") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "label",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 9
              }
            }
          }) : i));
        },
        useData: !0
      }),
      tagName: "a",
      attributes: function attributes() {
        var e = this.options.href || "#";
        return {
          "data-se": this.options.name,
          href: e
        };
      },
      className: function className() {
        var e = ["link"];

        if (this.options.name) {
          var t = this.options.name.replace(/[ ]/g, "-");
          e.push("js-".concat(t));
        }

        return e.join(" ");
      },
      postRender: function postRender() {
        var e = this;
        this.options.href || this.$el.click(function (t) {
          t.preventDefault();
          var n = e.options,
              r = n.appState,
              o = n.formName,
              i = n.actionPath,
              a = n.clickHandler;
          a ? a() : o ? r.trigger("switchForm", o) : i && r.trigger("invokeAction", i);
        });
      }
    });
    e.exports = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(360)),
        a = o.internal.views.forms.helpers.FormUtil,
        s = o.Form.extend({
      layout: "o-form-theme",
      className: "ion-form",
      hasSavingState: !0,
      autoSave: !1,
      noCancelButton: !0,
      title: function title() {
        return (0, o.loc)("oform.title.authenticate", "login");
      },
      save: function save() {
        return (0, o.loc)("oform.next", "login");
      },
      modelEvents: {
        clearFormError: "handleClearFormError",
        error: "triggerAfterError"
      },
      initialize: function initialize() {
        var e = this,
            t = this.getUISchema(),
            n = t.map(i.default.create);
        this.showMessages(), this.listenTo(this.options.appState, "onCaptchaLoaded", function (t) {
          e.captchaObject = t;
        }), n.forEach(function (t) {
          e.addInputOrView(t);
        }), this.listenTo(this, "save", this.saveForm), this.listenTo(this, "cancel", this.cancelForm);
      },
      handleClearFormError: function handleClearFormError() {
        this.$(".o-form-error-container").hasClass("o-form-has-errors") && this.clearErrors();
      },
      triggerAfterError: function triggerAfterError(e, t) {
        this.options.appState.trigger("afterError", t);
      },
      saveForm: function saveForm(e) {
        this.$el.find(".o-form-error-container").empty(), this.captchaObject ? this.captchaObject.execute() : this.options.appState.trigger("saveForm", e);
      },
      cancelForm: function cancelForm() {
        this.options.appState.trigger("invokeAction", "cancel");
      },
      getUISchema: function getUISchema() {
        return Array.isArray(this.options.currentViewState.uiSchema) ? this.options.currentViewState.uiSchema : [];
      },
      addInputOrView: function addInputOrView(e) {
        if (!1 !== e.visible && !1 !== e.mutable && (e.View ? (this.add(e.View, o._.omit(e, "View", "showWhen")), e.showWhen && a.applyShowWhen(this.last(), e.showWhen)) : this.addInput(e), Array.isArray(e.optionsUiSchemas) && this.options.optionUiSchemaConfig[e.name])) {
          var t = Number(this.options.optionUiSchemaConfig[e.name]);
          (e.optionsUiSchemas[t] || []).forEach(this.addInputOrView.bind(this));
        }
      },
      showMessages: function showMessages() {
        var e = this.options.appState.get("messages");

        if (null === e || void 0 === e ? void 0 : e.value.length) {
          var t = e.value.map(function (e) {
            return e.message;
          });
          this.add('<div class="ion-messages-container">'.concat(t.join(" "), "</div>"), ".o-form-error-container");
        }
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = n(3),
        s = r(n(7)),
        l = n(108),
        u = a.BaseForm.extend({
      title: function title() {
        return (0, i.loc)("oie.password.enroll.title", "login");
      },
      save: function save() {
        return (0, i.loc)("oform.next", "login");
      },
      initialize: function initialize() {
        a.BaseForm.prototype.initialize.apply(this, arguments);
        var e = this.getPasswordPolicySettings();
        this.displayPasswordPolicy(e);
      },
      displayPasswordPolicy: function displayPasswordPolicy(e) {
        if (e) {
          var t = (0, l.getPasswordComplexityDescriptionForHtmlList)(e);
          this.add(i.View.extend({
            tagName: "section",
            template: o.default.template({
              1: function _(e, t, n, r, o) {
                return "<li>" + e.escapeExpression(e.lambda(t, t)) + "</li>";
              },
              compiler: [8, ">= 4.3.0"],
              main: function main(e, t, n, r, o) {
                var i,
                    a = null != t ? t : e.nullContext || {},
                    s = e.lookupProperty || function (e, t) {
                  if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                };

                return '<div class="password-authenticator--heading">' + e.escapeExpression((s(n, "i18n") || t && s(t, "i18n") || e.hooks.helperMissing).call(a, {
                  name: "i18n",
                  hash: {
                    bundle: "login",
                    code: "password.complexity.requirements.header"
                  },
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 45
                    },
                    end: {
                      line: 1,
                      column: 115
                    }
                  }
                })) + '</div><ul class="password-authenticator--list">' + (null != (i = s(n, "each").call(a, null != t ? s(t, "rulesList") : t, {
                  name: "each",
                  hash: {},
                  fn: e.program(1, o, 0),
                  inverse: e.noop,
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 162
                    },
                    end: {
                      line: 1,
                      column: 207
                    }
                  }
                })) ? i : "") + "</ul>";
              },
              useData: !0
            }),
            getTemplateData: function getTemplateData() {
              return {
                rulesList: t
              };
            },
            attributes: {
              "data-se": "password-authenticator--rules"
            }
          }), {
            prepend: !0,
            selector: ".o-form-fieldset-container"
          });
        }
      },
      triggerAfterError: function triggerAfterError(e, t) {
        t.responseJSON = (0, l.removeRequirementsFromError)(t.responseJSON), this.options.appState.trigger("afterError", t);
      },
      getPasswordPolicySettings: function getPasswordPolicySettings() {
        var e,
            t = this.options.currentViewState.relatesTo;
        return null === t || void 0 === t ? void 0 : null === (e = t.value) || void 0 === e ? void 0 : e.settings;
      },
      getUISchema: function getUISchema() {
        return a.BaseForm.prototype.getUISchema.apply(this, arguments).concat([{
          name: "confirmPassword",
          label: (0, i.loc)("oie.password.confirmPasswordLabel", "login"),
          type: "password",
          "label-top": !0,
          params: {
            showPasswordToggle: this.settings.get("showPasswordToggle")
          }
        }]);
      }
    }),
        c = s.default.extend({
      Body: u,
      createModelClass: function createModelClass() {
        var e = a.BaseView.prototype.createModelClass.apply(this, arguments),
            t = Object.assign({
          confirmPassword: {
            type: "string",
            required: !0
          }
        }, e.prototype.local);
        return e.extend({
          local: t,
          validate: function validate() {
            if (this.get("credentials.passcode") !== this.get("confirmPassword") && this.get("credential.value") !== this.get("confirmPassword")) {
              return {
                confirmPassword: (0, i.loc)("password.error.match", "login")
              };
            }

            return null;
          }
        });
      }
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(11);
    n.d(t, "VERSION", function () {
      return r.e;
    });
    var o = n(28);
    n.d(t, "restArguments", function () {
      return o.a;
    });
    var i = n(53);
    n.d(t, "isObject", function () {
      return i.a;
    });
    var a = n(384);
    n.d(t, "isNull", function () {
      return a.a;
    });
    var s = n(197);
    n.d(t, "isUndefined", function () {
      return s.a;
    });
    var l = n(198);
    n.d(t, "isBoolean", function () {
      return l.a;
    });
    var u = n(385);
    n.d(t, "isElement", function () {
      return u.a;
    });
    var c = n(140);
    n.d(t, "isString", function () {
      return c.a;
    });
    var d = n(199);
    n.d(t, "isNumber", function () {
      return d.a;
    });
    var f = n(386);
    n.d(t, "isDate", function () {
      return f.a;
    });
    var p = n(387);
    n.d(t, "isRegExp", function () {
      return p.a;
    });
    var h = n(388);
    n.d(t, "isError", function () {
      return h.a;
    });
    var m = n(200);
    n.d(t, "isSymbol", function () {
      return m.a;
    });
    var g = n(201);
    n.d(t, "isArrayBuffer", function () {
      return g.a;
    });
    var v = n(141);
    n.d(t, "isDataView", function () {
      return v.a;
    });
    var y = n(54);
    n.d(t, "isArray", function () {
      return y.a;
    });
    var b = n(32);
    n.d(t, "isFunction", function () {
      return b.a;
    });

    var _ = n(142);

    n.d(t, "isArguments", function () {
      return _.a;
    });
    var w = n(390);
    n.d(t, "isFinite", function () {
      return w.a;
    });
    var E = n(202);
    n.d(t, "isNaN", function () {
      return E.a;
    });
    var O = n(203);
    n.d(t, "isTypedArray", function () {
      return O.a;
    });
    var S = n(392);
    n.d(t, "isEmpty", function () {
      return S.a;
    });
    var x = n(208);
    n.d(t, "isMatch", function () {
      return x.a;
    });
    var T = n(393);
    n.d(t, "isEqual", function () {
      return T.a;
    });
    var k = n(395);
    n.d(t, "isMap", function () {
      return k.a;
    });
    var C = n(396);
    n.d(t, "isWeakMap", function () {
      return C.a;
    });
    var A = n(397);
    n.d(t, "isSet", function () {
      return A.a;
    });
    var N = n(398);
    n.d(t, "isWeakSet", function () {
      return N.a;
    });
    var P = n(22);
    n.d(t, "keys", function () {
      return P.a;
    });
    var R = n(88);
    n.d(t, "allKeys", function () {
      return R.a;
    });
    var I = n(69);
    n.d(t, "values", function () {
      return I.a;
    });
    var M = n(399);
    n.d(t, "pairs", function () {
      return M.a;
    });
    var j = n(209);
    n.d(t, "invert", function () {
      return j.a;
    });
    var L = n(210);
    n.d(t, "functions", function () {
      return L.a;
    }), n.d(t, "methods", function () {
      return L.a;
    });
    var D = n(211);
    n.d(t, "extend", function () {
      return D.a;
    });
    var F = n(146);
    n.d(t, "extendOwn", function () {
      return F.a;
    }), n.d(t, "assign", function () {
      return F.a;
    });
    var U = n(212);
    n.d(t, "defaults", function () {
      return U.a;
    });
    var B = n(400);
    n.d(t, "create", function () {
      return B.a;
    });
    var V = n(214);
    n.d(t, "clone", function () {
      return V.a;
    });
    var H = n(401);
    n.d(t, "tap", function () {
      return H.a;
    });
    var q = n(215);
    n.d(t, "get", function () {
      return q.a;
    });
    var W = n(402);
    n.d(t, "has", function () {
      return W.a;
    });
    var z = n(403);
    n.d(t, "mapObject", function () {
      return z.a;
    });
    var $ = n(148);
    n.d(t, "identity", function () {
      return $.a;
    });
    var K = n(204);
    n.d(t, "constant", function () {
      return K.a;
    });
    var G = n(219);
    n.d(t, "noop", function () {
      return G.a;
    });
    var Y = n(216);
    n.d(t, "toPath", function () {
      return Y.a;
    });
    var J = n(149);
    n.d(t, "property", function () {
      return J.a;
    });
    var Q = n(404);
    n.d(t, "propertyOf", function () {
      return Q.a;
    });
    var X = n(111);
    n.d(t, "matcher", function () {
      return X.a;
    }), n.d(t, "matches", function () {
      return X.a;
    });
    var Z = n(405);
    n.d(t, "times", function () {
      return Z.a;
    });
    var ee = n(220);
    n.d(t, "random", function () {
      return ee.a;
    });
    var te = n(150);
    n.d(t, "now", function () {
      return te.a;
    });
    var ne = n(406);
    n.d(t, "escape", function () {
      return ne.a;
    });
    var re = n(407);
    n.d(t, "unescape", function () {
      return re.a;
    });
    var oe = n(223);
    n.d(t, "templateSettings", function () {
      return oe.a;
    });
    var ie = n(409);
    n.d(t, "template", function () {
      return ie.a;
    });
    var ae = n(410);
    n.d(t, "result", function () {
      return ae.a;
    });
    var se = n(411);
    n.d(t, "uniqueId", function () {
      return se.a;
    });
    var le = n(412);
    n.d(t, "chain", function () {
      return le.a;
    });
    var ue = n(218);
    n.d(t, "iteratee", function () {
      return ue.a;
    });
    var ce = n(112);
    n.d(t, "partial", function () {
      return ce.a;
    });
    var de = n(225);
    n.d(t, "bind", function () {
      return de.a;
    });
    var fe = n(413);
    n.d(t, "bindAll", function () {
      return fe.a;
    });
    var pe = n(414);
    n.d(t, "memoize", function () {
      return pe.a;
    });
    var he = n(226);
    n.d(t, "delay", function () {
      return he.a;
    });
    var me = n(415);
    n.d(t, "defer", function () {
      return me.a;
    });
    var ge = n(416);
    n.d(t, "throttle", function () {
      return ge.a;
    });
    var ve = n(417);
    n.d(t, "debounce", function () {
      return ve.a;
    });
    var ye = n(418);
    n.d(t, "wrap", function () {
      return ye.a;
    });
    var be = n(151);
    n.d(t, "negate", function () {
      return be.a;
    });

    var _e = n(419);

    n.d(t, "compose", function () {
      return _e.a;
    });
    var we = n(420);
    n.d(t, "after", function () {
      return we.a;
    });
    var Ee = n(227);
    n.d(t, "before", function () {
      return Ee.a;
    });
    var Oe = n(421);
    n.d(t, "once", function () {
      return Oe.a;
    });
    var Se = n(228);
    n.d(t, "findKey", function () {
      return Se.a;
    });
    var xe = n(152);
    n.d(t, "findIndex", function () {
      return xe.a;
    });
    var Te = n(230);
    n.d(t, "findLastIndex", function () {
      return Te.a;
    });
    var ke = n(231);
    n.d(t, "sortedIndex", function () {
      return ke.a;
    });
    var Ce = n(232);
    n.d(t, "indexOf", function () {
      return Ce.a;
    });
    var Ae = n(422);
    n.d(t, "lastIndexOf", function () {
      return Ae.a;
    });
    var Ne = n(234);
    n.d(t, "find", function () {
      return Ne.a;
    }), n.d(t, "detect", function () {
      return Ne.a;
    });
    var Pe = n(423);
    n.d(t, "findWhere", function () {
      return Pe.a;
    });
    var Re = n(55);
    n.d(t, "each", function () {
      return Re.a;
    }), n.d(t, "forEach", function () {
      return Re.a;
    });
    var Ie = n(71);
    n.d(t, "map", function () {
      return Ie.a;
    }), n.d(t, "collect", function () {
      return Ie.a;
    });
    var Me = n(424);
    n.d(t, "reduce", function () {
      return Me.a;
    }), n.d(t, "foldl", function () {
      return Me.a;
    }), n.d(t, "inject", function () {
      return Me.a;
    });
    var je = n(425);
    n.d(t, "reduceRight", function () {
      return je.a;
    }), n.d(t, "foldr", function () {
      return je.a;
    });
    var Le = n(91);
    n.d(t, "filter", function () {
      return Le.a;
    }), n.d(t, "select", function () {
      return Le.a;
    });
    var De = n(426);
    n.d(t, "reject", function () {
      return De.a;
    });
    var Fe = n(427);
    n.d(t, "every", function () {
      return Fe.a;
    }), n.d(t, "all", function () {
      return Fe.a;
    });
    var Ue = n(428);
    n.d(t, "some", function () {
      return Ue.a;
    }), n.d(t, "any", function () {
      return Ue.a;
    });
    var Be = n(92);
    n.d(t, "contains", function () {
      return Be.a;
    }), n.d(t, "includes", function () {
      return Be.a;
    }), n.d(t, "include", function () {
      return Be.a;
    });
    var Ve = n(429);
    n.d(t, "invoke", function () {
      return Ve.a;
    });
    var He = n(153);
    n.d(t, "pluck", function () {
      return He.a;
    });
    var qe = n(430);
    n.d(t, "where", function () {
      return qe.a;
    });
    var We = n(236);
    n.d(t, "max", function () {
      return We.a;
    });
    var ze = n(431);
    n.d(t, "min", function () {
      return ze.a;
    });
    var $e = n(432);
    n.d(t, "shuffle", function () {
      return $e.a;
    });
    var Ke = n(237);
    n.d(t, "sample", function () {
      return Ke.a;
    });
    var Ge = n(433);
    n.d(t, "sortBy", function () {
      return Ge.a;
    });
    var Ye = n(434);
    n.d(t, "groupBy", function () {
      return Ye.a;
    });
    var Je = n(435);
    n.d(t, "indexBy", function () {
      return Je.a;
    });
    var Qe = n(436);
    n.d(t, "countBy", function () {
      return Qe.a;
    });
    var Xe = n(437);
    n.d(t, "partition", function () {
      return Xe.a;
    });
    var Ze = n(438);
    n.d(t, "toArray", function () {
      return Ze.a;
    });
    var et = n(439);
    n.d(t, "size", function () {
      return et.a;
    });
    var tt = n(238);
    n.d(t, "pick", function () {
      return tt.a;
    });
    var nt = n(441);
    n.d(t, "omit", function () {
      return nt.a;
    });
    var rt = n(442);
    n.d(t, "first", function () {
      return rt.a;
    }), n.d(t, "head", function () {
      return rt.a;
    }), n.d(t, "take", function () {
      return rt.a;
    });
    var ot = n(239);
    n.d(t, "initial", function () {
      return ot.a;
    });
    var it = n(443);
    n.d(t, "last", function () {
      return it.a;
    });
    var at = n(240);
    n.d(t, "rest", function () {
      return at.a;
    }), n.d(t, "tail", function () {
      return at.a;
    }), n.d(t, "drop", function () {
      return at.a;
    });
    var st = n(444);
    n.d(t, "compact", function () {
      return st.a;
    });
    var lt = n(445);
    n.d(t, "flatten", function () {
      return lt.a;
    });
    var ut = n(446);
    n.d(t, "without", function () {
      return ut.a;
    });
    var ct = n(242);
    n.d(t, "uniq", function () {
      return ct.a;
    }), n.d(t, "unique", function () {
      return ct.a;
    });
    var dt = n(447);
    n.d(t, "union", function () {
      return dt.a;
    });
    var ft = n(448);
    n.d(t, "intersection", function () {
      return ft.a;
    });
    var pt = n(241);
    n.d(t, "difference", function () {
      return pt.a;
    });
    var ht = n(243);
    n.d(t, "unzip", function () {
      return ht.a;
    }), n.d(t, "transpose", function () {
      return ht.a;
    });
    var mt = n(449);
    n.d(t, "zip", function () {
      return mt.a;
    });
    var gt = n(450);
    n.d(t, "object", function () {
      return gt.a;
    });
    var vt = n(451);
    n.d(t, "range", function () {
      return vt.a;
    });
    var yt = n(452);
    n.d(t, "chunk", function () {
      return yt.a;
    });
    var bt = n(453);
    n.d(t, "mixin", function () {
      return bt.a;
    });

    var _t = n(454);

    n.d(t, "default", function () {
      return _t.a;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(23);
    t.a = Object(r.a)("String");
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return null != e && Object(i.a)(e.getInt8) && Object(a.a)(e.buffer);
    }

    var o = n(23),
        i = n(32),
        a = n(201),
        s = n(87),
        l = Object(o.a)("DataView");
    t.a = s.a ? r : l;
  }, function (e, t, n) {
    "use strict";

    var r = n(23),
        o = n(50),
        i = Object(r.a)("Arguments");
    !function () {
      i(arguments) || (i = function i(e) {
        return Object(o.a)(e, "callee");
      });
    }(), t.a = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(206);
    t.a = Object(r.a)("byteLength");
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = Object(o.a)(e);
      return function (n) {
        if (null == n) return !1;
        var r = Object(a.a)(n);
        if (Object(o.a)(r)) return !1;

        for (var l = 0; l < t; l++) {
          if (!Object(i.a)(n[e[l]])) return !1;
        }

        return e !== d || !Object(i.a)(n[s]);
      };
    }

    t.a = r, n.d(t, "b", function () {
      return c;
    }), n.d(t, "d", function () {
      return d;
    }), n.d(t, "c", function () {
      return f;
    });
    var o = n(33),
        i = n(32),
        a = n(88),
        s = "forEach",
        l = ["clear", "delete"],
        u = ["get", "has", "set"],
        c = l.concat(s, u),
        d = l.concat(u),
        f = ["add"].concat(l, s, "has");
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return function (n) {
        var r = arguments.length;
        if (t && (n = Object(n)), r < 2 || null == n) return n;

        for (var o = 1; o < r; o++) {
          for (var i = arguments[o], a = e(i), s = a.length, l = 0; l < s; l++) {
            var u = a[l];
            t && void 0 !== n[u] || (n[u] = i[u]);
          }
        }

        return n;
      };
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    var r = n(145),
        o = n(22);
    t.a = Object(r.a)(o.a);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      for (var n = t.length, r = 0; r < n; r++) {
        if (null == e) return;
        e = e[t[r]];
      }

      return n ? e : void 0;
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e;
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e = Object(i.a)(e), function (t) {
        return Object(o.a)(t, e);
      };
    }

    t.a = r;
    var o = n(147),
        i = n(89);
  }, function (e, t, n) {
    "use strict";

    t.a = Date.now || function () {
      return new Date().getTime();
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function () {
        return !e.apply(this, arguments);
      };
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    var r = n(229);
    t.a = Object(r.a)(1);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return Object(o.a)(e, Object(i.a)(t));
    }

    t.a = r;
    var o = n(71),
        i = n(149);
  }, function (e, t, n) {
    var r, o;
    /*!
    * jQuery JavaScript Library v1.12.4
    * http://jquery.com/
    *
    * Includes Sizzle.js
    * http://sizzlejs.com/
    *
    * Copyright jQuery Foundation and other contributors
    * Released under the MIT license
    * http://jquery.org/license
    *
    * Date: 2017-10-25T15:48Z
    */

    !function (t, n) {
      "object" == typeof e && "object" == typeof e.exports ? e.exports = t.document ? n(t, !0) : function (e) {
        if (!e.document) throw new Error("jQuery requires a window with a document");
        return n(e);
      } : n(t);
    }("undefined" != typeof window ? window : this, function (n, i) {
      function a(e) {
        var t = !!e && "length" in e && e.length,
            n = ge.type(e);
        return "function" !== n && !ge.isWindow(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e);
      }

      function s(e, t, n) {
        if (ge.isFunction(t)) return ge.grep(e, function (e, r) {
          return !!t.call(e, r, e) !== n;
        });
        if (t.nodeType) return ge.grep(e, function (e) {
          return e === t !== n;
        });

        if ("string" == typeof t) {
          if (Te.test(t)) return ge.filter(t, e, n);
          t = ge.filter(t, e);
        }

        return ge.grep(e, function (e) {
          return ge.inArray(e, t) > -1 !== n;
        });
      }

      function l(e, t) {
        do {
          e = e[t];
        } while (e && 1 !== e.nodeType);

        return e;
      }

      function u(e) {
        var t = {};
        return ge.each(e.match(Pe) || [], function (e, n) {
          t[n] = !0;
        }), t;
      }

      function c() {
        se.addEventListener ? (se.removeEventListener("DOMContentLoaded", d), n.removeEventListener("load", d)) : (se.detachEvent("onreadystatechange", d), n.detachEvent("onload", d));
      }

      function d() {
        (se.addEventListener || "load" === n.event.type || "complete" === se.readyState) && (c(), ge.ready());
      }

      function f(e, t, n) {
        if (void 0 === n && 1 === e.nodeType) {
          var r = "data-" + t.replace(Le, "-$1").toLowerCase();

          if ("string" == typeof (n = e.getAttribute(r))) {
            try {
              n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : je.test(n) ? ge.parseJSON(n) : n);
            } catch (e) {}

            ge.data(e, t, n);
          } else n = void 0;
        }

        return n;
      }

      function p(e) {
        var t;

        for (t in e) {
          if (("data" !== t || !ge.isEmptyObject(e[t])) && "toJSON" !== t) return !1;
        }

        return !0;
      }

      function h(e, t, n, r) {
        if (Me(e)) {
          var o,
              i,
              a = ge.expando,
              s = e.nodeType,
              l = s ? ge.cache : e,
              u = s ? e[a] : e[a] && a;
          if (u && l[u] && (r || l[u].data) || void 0 !== n || "string" != typeof t) return u || (u = s ? e[a] = ae.pop() || ge.guid++ : a), l[u] || (l[u] = s ? {} : {
            toJSON: ge.noop
          }), "object" != typeof t && "function" != typeof t || (r ? l[u] = ge.extend(l[u], t) : l[u].data = ge.extend(l[u].data, t)), i = l[u], r || (i.data || (i.data = {}), i = i.data), void 0 !== n && (i[ge.camelCase(t)] = n), "string" == typeof t ? null == (o = i[t]) && (o = i[ge.camelCase(t)]) : o = i, o;
        }
      }

      function m(e, t, n) {
        if (Me(e)) {
          var r,
              o,
              i = e.nodeType,
              a = i ? ge.cache : e,
              s = i ? e[ge.expando] : ge.expando;

          if (a[s]) {
            if (t && (r = n ? a[s] : a[s].data)) {
              ge.isArray(t) ? t = t.concat(ge.map(t, ge.camelCase)) : t in r ? t = [t] : (t = ge.camelCase(t), t = t in r ? [t] : t.split(" ")), o = t.length;

              for (; o--;) {
                delete r[t[o]];
              }

              if (n ? !p(r) : !ge.isEmptyObject(r)) return;
            }

            (n || (delete a[s].data, p(a[s]))) && (i ? ge.cleanData([e], !0) : me.deleteExpando || a != a.window ? delete a[s] : a[s] = void 0);
          }
        }
      }

      function g(e, t, n, r) {
        var o,
            i = 1,
            a = 20,
            s = r ? function () {
          return r.cur();
        } : function () {
          return ge.css(e, t, "");
        },
            l = s(),
            u = n && n[3] || (ge.cssNumber[t] ? "" : "px"),
            c = (ge.cssNumber[t] || "px" !== u && +l) && Fe.exec(ge.css(e, t));

        if (c && c[3] !== u) {
          u = u || c[3], n = n || [], c = +l || 1;

          do {
            i = i || ".5", c /= i, ge.style(e, t, c + u);
          } while (i !== (i = s() / l) && 1 !== i && --a);
        }

        return n && (c = +c || +l || 0, o = n[1] ? c + (n[1] + 1) * n[2] : +n[2], r && (r.unit = u, r.start = c, r.end = o)), o;
      }

      function v(e) {
        var t = $e.split("|"),
            n = e.createDocumentFragment();
        if (n.createElement) for (; t.length;) {
          n.createElement(t.pop());
        }
        return n;
      }

      function y(e, t) {
        var n,
            r,
            o = 0,
            i = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : void 0;
        if (!i) for (i = [], n = e.childNodes || e; null != (r = n[o]); o++) {
          !t || ge.nodeName(r, t) ? i.push(r) : ge.merge(i, y(r, t));
        }
        return void 0 === t || t && ge.nodeName(e, t) ? ge.merge([e], i) : i;
      }

      function b(e, t) {
        for (var n, r = 0; null != (n = e[r]); r++) {
          ge._data(n, "globalEval", !t || ge._data(t[r], "globalEval"));
        }
      }

      function _(e) {
        He.test(e.type) && (e.defaultChecked = e.checked);
      }

      function w(e, t, n, r, o) {
        for (var i, a, s, l, u, c, d, f = e.length, p = v(t), h = [], m = 0; m < f; m++) {
          if ((a = e[m]) || 0 === a) if ("object" === ge.type(a)) ge.merge(h, a.nodeType ? [a] : a);else if (Ge.test(a)) {
            for (l = l || p.appendChild(t.createElement("div")), u = (qe.exec(a) || ["", ""])[1].toLowerCase(), d = Ke[u] || Ke._default, l.innerHTML = d[1] + ge.htmlPrefilter(a) + d[2], i = d[0]; i--;) {
              l = l.lastChild;
            }

            if (!me.leadingWhitespace && ze.test(a) && h.push(t.createTextNode(ze.exec(a)[0])), !me.tbody) for (a = "table" !== u || Ye.test(a) ? "<table>" !== d[1] || Ye.test(a) ? 0 : l : l.firstChild, i = a && a.childNodes.length; i--;) {
              ge.nodeName(c = a.childNodes[i], "tbody") && !c.childNodes.length && a.removeChild(c);
            }

            for (ge.merge(h, l.childNodes), l.textContent = ""; l.firstChild;) {
              l.removeChild(l.firstChild);
            }

            l = p.lastChild;
          } else h.push(t.createTextNode(a));
        }

        for (l && p.removeChild(l), me.appendChecked || ge.grep(y(h, "input"), _), m = 0; a = h[m++];) {
          if (r && ge.inArray(a, r) > -1) o && o.push(a);else if (s = ge.contains(a.ownerDocument, a), l = y(p.appendChild(a), "script"), s && b(l), n) for (i = 0; a = l[i++];) {
            We.test(a.type || "") && n.push(a);
          }
        }

        return l = null, p;
      }

      function E() {
        return !0;
      }

      function O() {
        return !1;
      }

      function S() {
        try {
          return se.activeElement;
        } catch (e) {}
      }

      function x(e, t, n, r, o, i) {
        var a, s;

        if ("object" == typeof t) {
          "string" != typeof n && (r = r || n, n = void 0);

          for (s in t) {
            x(e, s, n, r, t[s], i);
          }

          return e;
        }

        if (null == r && null == o ? (o = n, r = n = void 0) : null == o && ("string" == typeof n ? (o = r, r = void 0) : (o = r, r = n, n = void 0)), !1 === o) o = O;else if (!o) return e;
        return 1 === i && (a = o, o = function o(e) {
          return ge().off(e), a.apply(this, arguments);
        }, o.guid = a.guid || (a.guid = ge.guid++)), e.each(function () {
          ge.event.add(this, t, o, r, n);
        });
      }

      function T(e, t) {
        return ge.nodeName(e, "table") && ge.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e;
      }

      function k(e) {
        return e.type = (null !== ge.find.attr(e, "type")) + "/" + e.type, e;
      }

      function C(e) {
        var t = it.exec(e.type);
        return t ? e.type = t[1] : e.removeAttribute("type"), e;
      }

      function A(e, t) {
        if (1 === t.nodeType && ge.hasData(e)) {
          var n,
              r,
              o,
              i = ge._data(e),
              a = ge._data(t, i),
              s = i.events;

          if (s) {
            delete a.handle, a.events = {};

            for (n in s) {
              for (r = 0, o = s[n].length; r < o; r++) {
                ge.event.add(t, n, s[n][r]);
              }
            }
          }

          a.data && (a.data = ge.extend({}, a.data));
        }
      }

      function N(e, t) {
        var n, r, o;

        if (1 === t.nodeType) {
          if (n = t.nodeName.toLowerCase(), !me.noCloneEvent && t[ge.expando]) {
            o = ge._data(t);

            for (r in o.events) {
              ge.removeEvent(t, r, o.handle);
            }

            t.removeAttribute(ge.expando);
          }

          "script" === n && t.text !== e.text ? (k(t).text = e.text, C(t)) : "object" === n ? (t.parentNode && (t.outerHTML = e.outerHTML), me.html5Clone && e.innerHTML && !ge.trim(t.innerHTML) && (t.innerHTML = e.innerHTML)) : "input" === n && He.test(e.type) ? (t.defaultChecked = t.checked = e.checked, t.value !== e.value && (t.value = e.value)) : "option" === n ? t.defaultSelected = t.selected = e.defaultSelected : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue);
        }
      }

      function P(e, t, n, r) {
        t = ue.apply([], t);
        var o,
            i,
            a,
            s,
            l,
            u,
            c = 0,
            d = e.length,
            f = d - 1,
            p = t[0],
            h = ge.isFunction(p);
        if (h || d > 1 && "string" == typeof p && !me.checkClone && ot.test(p)) return e.each(function (o) {
          var i = e.eq(o);
          h && (t[0] = p.call(this, o, i.html())), P(i, t, n, r);
        });

        if (d && (u = w(t, e[0].ownerDocument, !1, e, r), o = u.firstChild, 1 === u.childNodes.length && (u = o), o || r)) {
          for (s = ge.map(y(u, "script"), k), a = s.length; c < d; c++) {
            i = u, c !== f && (i = ge.clone(i, !0, !0), a && ge.merge(s, y(i, "script"))), n.call(e[c], i, c);
          }

          if (a) for (l = s[s.length - 1].ownerDocument, ge.map(s, C), c = 0; c < a; c++) {
            i = s[c], We.test(i.type || "") && !ge._data(i, "globalEval") && ge.contains(l, i) && (i.src ? ge._evalUrl && ge._evalUrl(i.src) : ge.globalEval((i.text || i.textContent || i.innerHTML || "").replace(at, "")));
          }
          u = o = null;
        }

        return e;
      }

      function R(e, t, n) {
        for (var r, o = t ? ge.filter(t, e) : e, i = 0; null != (r = o[i]); i++) {
          n || 1 !== r.nodeType || ge.cleanData(y(r)), r.parentNode && (n && ge.contains(r.ownerDocument, r) && b(y(r, "script")), r.parentNode.removeChild(r));
        }

        return e;
      }

      function I(e, t) {
        var n = ge(t.createElement(e)).appendTo(t.body),
            r = ge.css(n[0], "display");
        return n.detach(), r;
      }

      function M(e) {
        var t = se,
            n = ct[e];
        return n || (n = I(e, t), "none" !== n && n || (ut = (ut || ge("<iframe frameborder='0' width='0' height='0'></iframe>")).appendTo(t.documentElement), t = (ut[0].contentWindow || ut[0].contentDocument).document, t.write(), t.close(), n = I(e, t), ut.detach()), ct[e] = n), n;
      }

      function j(e, t) {
        return {
          get: function get() {
            return e() ? void delete this.get : (this.get = t).apply(this, arguments);
          }
        };
      }

      function L(e) {
        if (e in xt) return e;

        for (var t = e.charAt(0).toUpperCase() + e.slice(1), n = St.length; n--;) {
          if ((e = St[n] + t) in xt) return e;
        }
      }

      function D(e, t) {
        for (var n, r, o, i = [], a = 0, s = e.length; a < s; a++) {
          r = e[a], r.style && (i[a] = ge._data(r, "olddisplay"), n = r.style.display, t ? (i[a] || "none" !== n || (r.style.display = ""), "" === r.style.display && Be(r) && (i[a] = ge._data(r, "olddisplay", M(r.nodeName)))) : (o = Be(r), (n && "none" !== n || !o) && ge._data(r, "olddisplay", o ? n : ge.css(r, "display"))));
        }

        for (a = 0; a < s; a++) {
          r = e[a], r.style && (t && "none" !== r.style.display && "" !== r.style.display || (r.style.display = t ? i[a] || "" : "none"));
        }

        return e;
      }

      function F(e, t, n) {
        var r = wt.exec(t);
        return r ? Math.max(0, r[1] - (n || 0)) + (r[2] || "px") : t;
      }

      function U(e, t, n, r, o) {
        for (var i = n === (r ? "border" : "content") ? 4 : "width" === t ? 1 : 0, a = 0; i < 4; i += 2) {
          "margin" === n && (a += ge.css(e, n + Ue[i], !0, o)), r ? ("content" === n && (a -= ge.css(e, "padding" + Ue[i], !0, o)), "margin" !== n && (a -= ge.css(e, "border" + Ue[i] + "Width", !0, o))) : (a += ge.css(e, "padding" + Ue[i], !0, o), "padding" !== n && (a += ge.css(e, "border" + Ue[i] + "Width", !0, o)));
        }

        return a;
      }

      function B(e, t, n) {
        var r = !0,
            o = "width" === t ? e.offsetWidth : e.offsetHeight,
            i = mt(e),
            a = me.boxSizing && "border-box" === ge.css(e, "boxSizing", !1, i);

        if (o <= 0 || null == o) {
          if (o = gt(e, t, i), (o < 0 || null == o) && (o = e.style[t]), ft.test(o)) return o;
          r = a && (me.boxSizingReliable() || o === e.style[t]), o = parseFloat(o) || 0;
        }

        return o + U(e, t, n || (a ? "border" : "content"), r, i) + "px";
      }

      function V(e, t, n, r, o) {
        return new V.prototype.init(e, t, n, r, o);
      }

      function H() {
        return n.setTimeout(function () {
          Tt = void 0;
        }), Tt = ge.now();
      }

      function q(e, t) {
        var n,
            r = {
          height: e
        },
            o = 0;

        for (t = t ? 1 : 0; o < 4; o += 2 - t) {
          n = Ue[o], r["margin" + n] = r["padding" + n] = e;
        }

        return t && (r.opacity = r.width = e), r;
      }

      function W(e, t, n) {
        for (var r, o = (K.tweeners[t] || []).concat(K.tweeners["*"]), i = 0, a = o.length; i < a; i++) {
          if (r = o[i].call(n, t, e)) return r;
        }
      }

      function z(e, t, n) {
        var r,
            o,
            i,
            a,
            s,
            l,
            u,
            c = this,
            d = {},
            f = e.style,
            p = e.nodeType && Be(e),
            h = ge._data(e, "fxshow");

        n.queue || (s = ge._queueHooks(e, "fx"), null == s.unqueued && (s.unqueued = 0, l = s.empty.fire, s.empty.fire = function () {
          s.unqueued || l();
        }), s.unqueued++, c.always(function () {
          c.always(function () {
            s.unqueued--, ge.queue(e, "fx").length || s.empty.fire();
          });
        })), 1 === e.nodeType && ("height" in t || "width" in t) && (n.overflow = [f.overflow, f.overflowX, f.overflowY], u = ge.css(e, "display"), "inline" === ("none" === u ? ge._data(e, "olddisplay") || M(e.nodeName) : u) && "none" === ge.css(e, "float") && (me.inlineBlockNeedsLayout && "inline" !== M(e.nodeName) ? f.zoom = 1 : f.display = "inline-block")), n.overflow && (f.overflow = "hidden", me.shrinkWrapBlocks() || c.always(function () {
          f.overflow = n.overflow[0], f.overflowX = n.overflow[1], f.overflowY = n.overflow[2];
        }));

        for (r in t) {
          if (o = t[r], Ct.exec(o)) {
            if (delete t[r], i = i || "toggle" === o, o === (p ? "hide" : "show")) {
              if ("show" !== o || !h || void 0 === h[r]) continue;
              p = !0;
            }

            d[r] = h && h[r] || ge.style(e, r);
          } else u = void 0;
        }

        if (ge.isEmptyObject(d)) "inline" === ("none" === u ? M(e.nodeName) : u) && (f.display = u);else {
          h ? "hidden" in h && (p = h.hidden) : h = ge._data(e, "fxshow", {}), i && (h.hidden = !p), p ? ge(e).show() : c.done(function () {
            ge(e).hide();
          }), c.done(function () {
            var t;

            ge._removeData(e, "fxshow");

            for (t in d) {
              ge.style(e, t, d[t]);
            }
          });

          for (r in d) {
            a = W(p ? h[r] : 0, r, c), r in h || (h[r] = a.start, p && (a.end = a.start, a.start = "width" === r || "height" === r ? 1 : 0));
          }
        }
      }

      function $(e, t) {
        var n, r, o, i, a;

        for (n in e) {
          if (r = ge.camelCase(n), o = t[r], i = e[n], ge.isArray(i) && (o = i[1], i = e[n] = i[0]), n !== r && (e[r] = i, delete e[n]), (a = ge.cssHooks[r]) && "expand" in a) {
            i = a.expand(i), delete e[r];

            for (n in i) {
              n in e || (e[n] = i[n], t[n] = o);
            }
          } else t[r] = o;
        }
      }

      function K(e, t, n) {
        var r,
            o,
            i = 0,
            a = K.prefilters.length,
            s = ge.Deferred().always(function () {
          delete l.elem;
        }),
            l = function l() {
          if (o) return !1;

          for (var t = Tt || H(), n = Math.max(0, u.startTime + u.duration - t), r = n / u.duration || 0, i = 1 - r, a = 0, l = u.tweens.length; a < l; a++) {
            u.tweens[a].run(i);
          }

          return s.notifyWith(e, [u, i, n]), i < 1 && l ? n : (s.resolveWith(e, [u]), !1);
        },
            u = s.promise({
          elem: e,
          props: ge.extend({}, t),
          opts: ge.extend(!0, {
            specialEasing: {},
            easing: ge.easing._default
          }, n),
          originalProperties: t,
          originalOptions: n,
          startTime: Tt || H(),
          duration: n.duration,
          tweens: [],
          createTween: function createTween(t, n) {
            var r = ge.Tween(e, u.opts, t, n, u.opts.specialEasing[t] || u.opts.easing);
            return u.tweens.push(r), r;
          },
          stop: function stop(t) {
            var n = 0,
                r = t ? u.tweens.length : 0;
            if (o) return this;

            for (o = !0; n < r; n++) {
              u.tweens[n].run(1);
            }

            return t ? (s.notifyWith(e, [u, 1, 0]), s.resolveWith(e, [u, t])) : s.rejectWith(e, [u, t]), this;
          }
        }),
            c = u.props;

        for ($(c, u.opts.specialEasing); i < a; i++) {
          if (r = K.prefilters[i].call(u, e, c, u.opts)) return ge.isFunction(r.stop) && (ge._queueHooks(u.elem, u.opts.queue).stop = ge.proxy(r.stop, r)), r;
        }

        return ge.map(c, W, u), ge.isFunction(u.opts.start) && u.opts.start.call(e, u), ge.fx.timer(ge.extend(l, {
          elem: e,
          anim: u,
          queue: u.opts.queue
        })), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always);
      }

      function G(e) {
        return ge.attr(e, "class") || "";
      }

      function Y(e) {
        return function (t, n) {
          "string" != typeof t && (n = t, t = "*");
          var r,
              o = 0,
              i = t.toLowerCase().match(Pe) || [];
          if (ge.isFunction(n)) for (; r = i[o++];) {
            "+" === r.charAt(0) ? (r = r.slice(1) || "*", (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n);
          }
        };
      }

      function J(e, t, n, r) {
        function o(s) {
          var l;
          return i[s] = !0, ge.each(e[s] || [], function (e, s) {
            var u = s(t, n, r);
            return "string" != typeof u || a || i[u] ? a ? !(l = u) : void 0 : (t.dataTypes.unshift(u), o(u), !1);
          }), l;
        }

        var i = {},
            a = e === Zt;
        return o(t.dataTypes[0]) || !i["*"] && o("*");
      }

      function Q(e, t) {
        var n,
            r,
            o = ge.ajaxSettings.flatOptions || {};

        for (r in t) {
          void 0 !== t[r] && ((o[r] ? e : n || (n = {}))[r] = t[r]);
        }

        return n && ge.extend(!0, e, n), e;
      }

      function X(e, t, n) {
        for (var r, o, i, a, s = e.contents, l = e.dataTypes; "*" === l[0];) {
          l.shift(), void 0 === o && (o = e.mimeType || t.getResponseHeader("Content-Type"));
        }

        if (o) for (a in s) {
          if (s[a] && s[a].test(o)) {
            l.unshift(a);
            break;
          }
        }
        if (l[0] in n) i = l[0];else {
          for (a in n) {
            if (!l[0] || e.converters[a + " " + l[0]]) {
              i = a;
              break;
            }

            r || (r = a);
          }

          i = i || r;
        }
        if (i) return i !== l[0] && l.unshift(i), n[i];
      }

      function Z(e, t, n, r) {
        var o,
            i,
            a,
            s,
            l,
            u = {},
            c = e.dataTypes.slice();
        if (c[1]) for (a in e.converters) {
          u[a.toLowerCase()] = e.converters[a];
        }

        for (i = c.shift(); i;) {
          if (e.responseFields[i] && (n[e.responseFields[i]] = t), !l && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = i, i = c.shift()) if ("*" === i) i = l;else if ("*" !== l && l !== i) {
            if (!(a = u[l + " " + i] || u["* " + i])) for (o in u) {
              if (s = o.split(" "), s[1] === i && (a = u[l + " " + s[0]] || u["* " + s[0]])) {
                !0 === a ? a = u[o] : !0 !== u[o] && (i = s[0], c.unshift(s[1]));
                break;
              }
            }
            if (!0 !== a) if (a && e.throws) t = a(t);else try {
              t = a(t);
            } catch (e) {
              return {
                state: "parsererror",
                error: a ? e : "No conversion from " + l + " to " + i
              };
            }
          }
        }

        return {
          state: "success",
          data: t
        };
      }

      function ee(e) {
        return e.style && e.style.display || ge.css(e, "display");
      }

      function te(e) {
        if (!ge.contains(e.ownerDocument || se, e)) return !0;

        for (; e && 1 === e.nodeType;) {
          if ("none" === ee(e) || "hidden" === e.type) return !0;
          e = e.parentNode;
        }

        return !1;
      }

      function ne(e, t, n, r) {
        var o;
        if (ge.isArray(t)) ge.each(t, function (t, o) {
          n || on.test(e) ? r(e, o) : ne(e + "[" + ("object" == typeof o && null != o ? t : "") + "]", o, n, r);
        });else if (n || "object" !== ge.type(t)) r(e, t);else for (o in t) {
          ne(e + "[" + o + "]", t[o], n, r);
        }
      }

      function re() {
        try {
          return new n.XMLHttpRequest();
        } catch (e) {}
      }

      function oe() {
        try {
          return new n.ActiveXObject("Microsoft.XMLHTTP");
        } catch (e) {}
      }

      function ie(e) {
        return ge.isWindow(e) ? e : 9 === e.nodeType && (e.defaultView || e.parentWindow);
      }

      var ae = [],
          se = n.document,
          le = ae.slice,
          ue = ae.concat,
          ce = ae.push,
          de = ae.indexOf,
          fe = {},
          pe = fe.toString,
          he = fe.hasOwnProperty,
          me = {},
          ge = function ge(e, t) {
        return new ge.fn.init(e, t);
      },
          ve = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
          ye = /^-ms-/,
          be = /-([\da-z])/gi,
          _e = function _e(e, t) {
        return t.toUpperCase();
      };

      ge.fn = ge.prototype = {
        jquery: "1.12.4",
        constructor: ge,
        selector: "",
        length: 0,
        toArray: function toArray() {
          return le.call(this);
        },
        get: function get(e) {
          return null != e ? e < 0 ? this[e + this.length] : this[e] : le.call(this);
        },
        pushStack: function pushStack(e) {
          var t = ge.merge(this.constructor(), e);
          return t.prevObject = this, t.context = this.context, t;
        },
        each: function each(e) {
          return ge.each(this, e);
        },
        map: function map(e) {
          return this.pushStack(ge.map(this, function (t, n) {
            return e.call(t, n, t);
          }));
        },
        slice: function slice() {
          return this.pushStack(le.apply(this, arguments));
        },
        first: function first() {
          return this.eq(0);
        },
        last: function last() {
          return this.eq(-1);
        },
        eq: function eq(e) {
          var t = this.length,
              n = +e + (e < 0 ? t : 0);
          return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
        },
        end: function end() {
          return this.prevObject || this.constructor();
        },
        push: ce,
        sort: ae.sort,
        splice: ae.splice
      }, ge.extend = ge.fn.extend = function () {
        var e,
            t,
            n,
            r,
            o,
            i,
            a = arguments[0] || {},
            s = 1,
            l = arguments.length,
            u = !1;

        for ("boolean" == typeof a && (u = a, a = arguments[s] || {}, s++), "object" == typeof a || ge.isFunction(a) || (a = {}), s === l && (a = this, s--); s < l; s++) {
          if (null != (o = arguments[s])) for (r in o) {
            e = a[r], n = o[r], "__proto__" !== r && a !== n && (u && n && (ge.isPlainObject(n) || (t = ge.isArray(n))) ? (t ? (t = !1, i = e && ge.isArray(e) ? e : []) : i = e && ge.isPlainObject(e) ? e : {}, a[r] = ge.extend(u, i, n)) : void 0 !== n && (a[r] = n));
          }
        }

        return a;
      }, ge.extend({
        expando: "jQuery" + ("1.12.4" + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function error(e) {
          throw new Error(e);
        },
        noop: function noop() {},
        isFunction: function isFunction(e) {
          return "function" === ge.type(e);
        },
        isArray: Array.isArray || function (e) {
          return "array" === ge.type(e);
        },
        isWindow: function isWindow(e) {
          return null != e && e == e.window;
        },
        isNumeric: function isNumeric(e) {
          var t = e && e.toString();
          return !ge.isArray(e) && t - parseFloat(t) + 1 >= 0;
        },
        isEmptyObject: function isEmptyObject(e) {
          var t;

          for (t in e) {
            return !1;
          }

          return !0;
        },
        isPlainObject: function isPlainObject(e) {
          var t;
          if (!e || "object" !== ge.type(e) || e.nodeType || ge.isWindow(e)) return !1;

          try {
            if (e.constructor && !he.call(e, "constructor") && !he.call(e.constructor.prototype, "isPrototypeOf")) return !1;
          } catch (e) {
            return !1;
          }

          if (!me.ownFirst) for (t in e) {
            return he.call(e, t);
          }

          for (t in e) {
            ;
          }

          return void 0 === t || he.call(e, t);
        },
        type: function type(e) {
          return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? fe[pe.call(e)] || "object" : typeof e;
        },
        globalEval: function globalEval(e) {
          e && ge.trim(e) && (n.execScript || function (e) {
            n.eval.call(n, e);
          })(e);
        },
        camelCase: function camelCase(e) {
          return e.replace(ye, "ms-").replace(be, _e);
        },
        nodeName: function nodeName(e, t) {
          return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
        },
        each: function each(e, t) {
          var n,
              r = 0;
          if (a(e)) for (n = e.length; r < n && !1 !== t.call(e[r], r, e[r]); r++) {
            ;
          } else for (r in e) {
            if (!1 === t.call(e[r], r, e[r])) break;
          }
          return e;
        },
        trim: function trim(e) {
          return null == e ? "" : (e + "").replace(ve, "");
        },
        makeArray: function makeArray(e, t) {
          var n = t || [];
          return null != e && (a(Object(e)) ? ge.merge(n, "string" == typeof e ? [e] : e) : ce.call(n, e)), n;
        },
        inArray: function inArray(e, t, n) {
          var r;

          if (t) {
            if (de) return de.call(t, e, n);

            for (r = t.length, n = n ? n < 0 ? Math.max(0, r + n) : n : 0; n < r; n++) {
              if (n in t && t[n] === e) return n;
            }
          }

          return -1;
        },
        merge: function merge(e, t) {
          for (var n = +t.length, r = 0, o = e.length; r < n;) {
            e[o++] = t[r++];
          }

          if (n !== n) for (; void 0 !== t[r];) {
            e[o++] = t[r++];
          }
          return e.length = o, e;
        },
        grep: function grep(e, t, n) {
          for (var r = [], o = 0, i = e.length, a = !n; o < i; o++) {
            !t(e[o], o) !== a && r.push(e[o]);
          }

          return r;
        },
        map: function map(e, t, n) {
          var r,
              o,
              i = 0,
              s = [];
          if (a(e)) for (r = e.length; i < r; i++) {
            null != (o = t(e[i], i, n)) && s.push(o);
          } else for (i in e) {
            null != (o = t(e[i], i, n)) && s.push(o);
          }
          return ue.apply([], s);
        },
        guid: 1,
        proxy: function proxy(e, t) {
          var n, r, o;
          if ("string" == typeof t && (o = e[t], t = e, e = o), ge.isFunction(e)) return n = le.call(arguments, 2), r = function r() {
            return e.apply(t || this, n.concat(le.call(arguments)));
          }, r.guid = e.guid = e.guid || ge.guid++, r;
        },
        now: function now() {
          return +new Date();
        },
        support: me
      }), "function" == typeof Symbol && (ge.fn[Symbol.iterator] = ae[Symbol.iterator]), ge.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
        fe["[object " + t + "]"] = t.toLowerCase();
      });

      var we =
      /*!
      * Sizzle CSS Selector Engine v2.2.1
      * http://sizzlejs.com/
      *
      * Copyright jQuery Foundation and other contributors
      * Released under the MIT license
      * http://jquery.org/license
      *
      * Date: 2015-10-17
      */
      function (e) {
        function t(e, t, n, r) {
          var o,
              i,
              a,
              s,
              u,
              d,
              f,
              p,
              h = t && t.ownerDocument,
              m = t ? t.nodeType : 9;
          if (n = n || [], "string" != typeof e || !e || 1 !== m && 9 !== m && 11 !== m) return n;

          if (!r && ((t ? t.ownerDocument || t : F) !== N && A(t), t = t || N, R)) {
            if (11 !== m && (d = me.exec(e))) if (o = d[1]) {
              if (9 === m) {
                if (!(a = t.getElementById(o))) return n;
                if (a.id === o) return n.push(a), n;
              } else if (h && (a = h.getElementById(o)) && L(t, a) && a.id === o) return n.push(a), n;
            } else {
              if (d[2]) return J.apply(n, t.getElementsByTagName(e)), n;
              if ((o = d[3]) && b.getElementsByClassName && t.getElementsByClassName) return J.apply(n, t.getElementsByClassName(o)), n;
            }

            if (b.qsa && !q[e + " "] && (!I || !I.test(e))) {
              if (1 !== m) h = t, p = e;else if ("object" !== t.nodeName.toLowerCase()) {
                for ((s = t.getAttribute("id")) ? s = s.replace(ve, "\\$&") : t.setAttribute("id", s = D), f = O(e), i = f.length, u = ce.test(s) ? "#" + s : "[id='" + s + "']"; i--;) {
                  f[i] = u + " " + c(f[i]);
                }

                p = f.join(","), h = ge.test(e) && l(t.parentNode) || t;
              }
              if (p) try {
                return J.apply(n, h.querySelectorAll(p)), n;
              } catch (e) {} finally {
                s === D && t.removeAttribute("id");
              }
            }
          }

          return x(e.replace(ie, "$1"), t, n, r);
        }

        function n() {
          function e(n, r) {
            return t.push(n + " ") > _.cacheLength && delete e[t.shift()], e[n + " "] = r;
          }

          var t = [];
          return e;
        }

        function r(e) {
          return e[D] = !0, e;
        }

        function o(e) {
          var t = N.createElement("div");

          try {
            return !!e(t);
          } catch (e) {
            return !1;
          } finally {
            t.parentNode && t.parentNode.removeChild(t), t = null;
          }
        }

        function i(e, t) {
          for (var n = e.split("|"), r = n.length; r--;) {
            _.attrHandle[n[r]] = t;
          }
        }

        function a(e, t) {
          var n = t && e,
              r = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || z) - (~e.sourceIndex || z);
          if (r) return r;
          if (n) for (; n = n.nextSibling;) {
            if (n === t) return -1;
          }
          return e ? 1 : -1;
        }

        function s(e) {
          return r(function (t) {
            return t = +t, r(function (n, r) {
              for (var o, i = e([], n.length, t), a = i.length; a--;) {
                n[o = i[a]] && (n[o] = !(r[o] = n[o]));
              }
            });
          });
        }

        function l(e) {
          return e && void 0 !== e.getElementsByTagName && e;
        }

        function u() {}

        function c(e) {
          for (var t = 0, n = e.length, r = ""; t < n; t++) {
            r += e[t].value;
          }

          return r;
        }

        function d(e, t, n) {
          var r = t.dir,
              o = n && "parentNode" === r,
              i = B++;
          return t.first ? function (t, n, i) {
            for (; t = t[r];) {
              if (1 === t.nodeType || o) return e(t, n, i);
            }
          } : function (t, n, a) {
            var s,
                l,
                u,
                c = [U, i];

            if (a) {
              for (; t = t[r];) {
                if ((1 === t.nodeType || o) && e(t, n, a)) return !0;
              }
            } else for (; t = t[r];) {
              if (1 === t.nodeType || o) {
                if (u = t[D] || (t[D] = {}), l = u[t.uniqueID] || (u[t.uniqueID] = {}), (s = l[r]) && s[0] === U && s[1] === i) return c[2] = s[2];
                if (l[r] = c, c[2] = e(t, n, a)) return !0;
              }
            }
          };
        }

        function f(e) {
          return e.length > 1 ? function (t, n, r) {
            for (var o = e.length; o--;) {
              if (!e[o](t, n, r)) return !1;
            }

            return !0;
          } : e[0];
        }

        function p(e, n, r) {
          for (var o = 0, i = n.length; o < i; o++) {
            t(e, n[o], r);
          }

          return r;
        }

        function h(e, t, n, r, o) {
          for (var i, a = [], s = 0, l = e.length, u = null != t; s < l; s++) {
            (i = e[s]) && (n && !n(i, r, o) || (a.push(i), u && t.push(s)));
          }

          return a;
        }

        function m(e, t, n, o, i, a) {
          return o && !o[D] && (o = m(o)), i && !i[D] && (i = m(i, a)), r(function (r, a, s, l) {
            var u,
                c,
                d,
                f = [],
                m = [],
                g = a.length,
                v = r || p(t || "*", s.nodeType ? [s] : s, []),
                y = !e || !r && t ? v : h(v, f, e, s, l),
                b = n ? i || (r ? e : g || o) ? [] : a : y;
            if (n && n(y, b, s, l), o) for (u = h(b, m), o(u, [], s, l), c = u.length; c--;) {
              (d = u[c]) && (b[m[c]] = !(y[m[c]] = d));
            }

            if (r) {
              if (i || e) {
                if (i) {
                  for (u = [], c = b.length; c--;) {
                    (d = b[c]) && u.push(y[c] = d);
                  }

                  i(null, b = [], u, l);
                }

                for (c = b.length; c--;) {
                  (d = b[c]) && (u = i ? X(r, d) : f[c]) > -1 && (r[u] = !(a[u] = d));
                }
              }
            } else b = h(b === a ? b.splice(g, b.length) : b), i ? i(null, a, b, l) : J.apply(a, b);
          });
        }

        function g(e) {
          for (var t, n, r, o = e.length, i = _.relative[e[0].type], a = i || _.relative[" "], s = i ? 1 : 0, l = d(function (e) {
            return e === t;
          }, a, !0), u = d(function (e) {
            return X(t, e) > -1;
          }, a, !0), p = [function (e, n, r) {
            var o = !i && (r || n !== T) || ((t = n).nodeType ? l(e, n, r) : u(e, n, r));
            return t = null, o;
          }]; s < o; s++) {
            if (n = _.relative[e[s].type]) p = [d(f(p), n)];else {
              if (n = _.filter[e[s].type].apply(null, e[s].matches), n[D]) {
                for (r = ++s; r < o && !_.relative[e[r].type]; r++) {
                  ;
                }

                return m(s > 1 && f(p), s > 1 && c(e.slice(0, s - 1).concat({
                  value: " " === e[s - 2].type ? "*" : ""
                })).replace(ie, "$1"), n, s < r && g(e.slice(s, r)), r < o && g(e = e.slice(r)), r < o && c(e));
              }

              p.push(n);
            }
          }

          return f(p);
        }

        function v(e, n) {
          var o = n.length > 0,
              i = e.length > 0,
              a = function a(r, _a, s, l, u) {
            var c,
                d,
                f,
                p = 0,
                m = "0",
                g = r && [],
                v = [],
                y = T,
                b = r || i && _.find.TAG("*", u),
                w = U += null == y ? 1 : Math.random() || .1,
                E = b.length;

            for (u && (T = _a === N || _a || u); m !== E && null != (c = b[m]); m++) {
              if (i && c) {
                for (d = 0, _a || c.ownerDocument === N || (A(c), s = !R); f = e[d++];) {
                  if (f(c, _a || N, s)) {
                    l.push(c);
                    break;
                  }
                }

                u && (U = w);
              }

              o && ((c = !f && c) && p--, r && g.push(c));
            }

            if (p += m, o && m !== p) {
              for (d = 0; f = n[d++];) {
                f(g, v, _a, s);
              }

              if (r) {
                if (p > 0) for (; m--;) {
                  g[m] || v[m] || (v[m] = G.call(l));
                }
                v = h(v);
              }

              J.apply(l, v), u && !r && v.length > 0 && p + n.length > 1 && t.uniqueSort(l);
            }

            return u && (U = w, T = y), g;
          };

          return o ? r(a) : a;
        }

        var y,
            b,
            _,
            w,
            E,
            O,
            S,
            x,
            T,
            k,
            C,
            A,
            N,
            P,
            R,
            I,
            M,
            j,
            L,
            D = "sizzle" + 1 * new Date(),
            F = e.document,
            U = 0,
            B = 0,
            V = n(),
            H = n(),
            q = n(),
            W = function W(e, t) {
          return e === t && (C = !0), 0;
        },
            z = 1 << 31,
            $ = {}.hasOwnProperty,
            K = [],
            G = K.pop,
            Y = K.push,
            J = K.push,
            Q = K.slice,
            X = function X(e, t) {
          for (var n = 0, r = e.length; n < r; n++) {
            if (e[n] === t) return n;
          }

          return -1;
        },
            Z = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            ee = "[\\x20\\t\\r\\n\\f]",
            te = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
            ne = "\\[" + ee + "*(" + te + ")(?:" + ee + "*([*^$|!~]?=)" + ee + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + te + "))|)" + ee + "*\\]",
            re = ":(" + te + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + ne + ")*)|.*)\\)|)",
            oe = new RegExp(ee + "+", "g"),
            ie = new RegExp("^" + ee + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ee + "+$", "g"),
            ae = new RegExp("^" + ee + "*," + ee + "*"),
            se = new RegExp("^" + ee + "*([>+~]|" + ee + ")" + ee + "*"),
            le = new RegExp("=" + ee + "*([^\\]'\"]*?)" + ee + "*\\]", "g"),
            ue = new RegExp(re),
            ce = new RegExp("^" + te + "$"),
            de = {
          ID: new RegExp("^#(" + te + ")"),
          CLASS: new RegExp("^\\.(" + te + ")"),
          TAG: new RegExp("^(" + te + "|[*])"),
          ATTR: new RegExp("^" + ne),
          PSEUDO: new RegExp("^" + re),
          CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ee + "*(even|odd|(([+-]|)(\\d*)n|)" + ee + "*(?:([+-]|)" + ee + "*(\\d+)|))" + ee + "*\\)|)", "i"),
          bool: new RegExp("^(?:" + Z + ")$", "i"),
          needsContext: new RegExp("^" + ee + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ee + "*((?:-\\d)?\\d*)" + ee + "*\\)|)(?=[^-]|$)", "i")
        },
            fe = /^(?:input|select|textarea|button)$/i,
            pe = /^h\d$/i,
            he = /^[^{]+\{\s*\[native \w/,
            me = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ge = /[+~]/,
            ve = /'|\\/g,
            ye = new RegExp("\\\\([\\da-f]{1,6}" + ee + "?|(" + ee + ")|.)", "ig"),
            be = function be(e, t, n) {
          var r = "0x" + t - 65536;
          return r !== r || n ? t : r < 0 ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320);
        },
            _e = function _e() {
          A();
        };

        try {
          J.apply(K = Q.call(F.childNodes), F.childNodes), K[F.childNodes.length].nodeType;
        } catch (e) {
          J = {
            apply: K.length ? function (e, t) {
              Y.apply(e, Q.call(t));
            } : function (e, t) {
              for (var n = e.length, r = 0; e[n++] = t[r++];) {
                ;
              }

              e.length = n - 1;
            }
          };
        }

        b = t.support = {}, E = t.isXML = function (e) {
          var t = e && (e.ownerDocument || e).documentElement;
          return !!t && "HTML" !== t.nodeName;
        }, A = t.setDocument = function (e) {
          var t,
              n,
              r = e ? e.ownerDocument || e : F;
          return r !== N && 9 === r.nodeType && r.documentElement ? (N = r, P = N.documentElement, R = !E(N), (n = N.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", _e, !1) : n.attachEvent && n.attachEvent("onunload", _e)), b.attributes = o(function (e) {
            return e.className = "i", !e.getAttribute("className");
          }), b.getElementsByTagName = o(function (e) {
            return e.appendChild(N.createComment("")), !e.getElementsByTagName("*").length;
          }), b.getElementsByClassName = he.test(N.getElementsByClassName), b.getById = o(function (e) {
            return P.appendChild(e).id = D, !N.getElementsByName || !N.getElementsByName(D).length;
          }), b.getById ? (_.find.ID = function (e, t) {
            if (void 0 !== t.getElementById && R) {
              var n = t.getElementById(e);
              return n ? [n] : [];
            }
          }, _.filter.ID = function (e) {
            var t = e.replace(ye, be);
            return function (e) {
              return e.getAttribute("id") === t;
            };
          }) : (delete _.find.ID, _.filter.ID = function (e) {
            var t = e.replace(ye, be);
            return function (e) {
              var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
              return n && n.value === t;
            };
          }), _.find.TAG = b.getElementsByTagName ? function (e, t) {
            return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : b.qsa ? t.querySelectorAll(e) : void 0;
          } : function (e, t) {
            var n,
                r = [],
                o = 0,
                i = t.getElementsByTagName(e);

            if ("*" === e) {
              for (; n = i[o++];) {
                1 === n.nodeType && r.push(n);
              }

              return r;
            }

            return i;
          }, _.find.CLASS = b.getElementsByClassName && function (e, t) {
            if (void 0 !== t.getElementsByClassName && R) return t.getElementsByClassName(e);
          }, M = [], I = [], (b.qsa = he.test(N.querySelectorAll)) && (o(function (e) {
            P.appendChild(e).innerHTML = "<a id='" + D + "'></a><select id='" + D + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && I.push("[*^$]=" + ee + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || I.push("\\[" + ee + "*(?:value|" + Z + ")"), e.querySelectorAll("[id~=" + D + "-]").length || I.push("~="), e.querySelectorAll(":checked").length || I.push(":checked"), e.querySelectorAll("a#" + D + "+*").length || I.push(".#.+[+~]");
          }), o(function (e) {
            var t = N.createElement("input");
            t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && I.push("name" + ee + "*[*^$|!~]?="), e.querySelectorAll(":enabled").length || I.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), I.push(",.*:");
          })), (b.matchesSelector = he.test(j = P.matches || P.webkitMatchesSelector || P.mozMatchesSelector || P.oMatchesSelector || P.msMatchesSelector)) && o(function (e) {
            b.disconnectedMatch = j.call(e, "div"), j.call(e, "[s!='']:x"), M.push("!=", re);
          }), I = I.length && new RegExp(I.join("|")), M = M.length && new RegExp(M.join("|")), t = he.test(P.compareDocumentPosition), L = t || he.test(P.contains) ? function (e, t) {
            var n = 9 === e.nodeType ? e.documentElement : e,
                r = t && t.parentNode;
            return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)));
          } : function (e, t) {
            if (t) for (; t = t.parentNode;) {
              if (t === e) return !0;
            }
            return !1;
          }, W = t ? function (e, t) {
            if (e === t) return C = !0, 0;
            var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
            return n || (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1, 1 & n || !b.sortDetached && t.compareDocumentPosition(e) === n ? e === N || e.ownerDocument === F && L(F, e) ? -1 : t === N || t.ownerDocument === F && L(F, t) ? 1 : k ? X(k, e) - X(k, t) : 0 : 4 & n ? -1 : 1);
          } : function (e, t) {
            if (e === t) return C = !0, 0;
            var n,
                r = 0,
                o = e.parentNode,
                i = t.parentNode,
                s = [e],
                l = [t];
            if (!o || !i) return e === N ? -1 : t === N ? 1 : o ? -1 : i ? 1 : k ? X(k, e) - X(k, t) : 0;
            if (o === i) return a(e, t);

            for (n = e; n = n.parentNode;) {
              s.unshift(n);
            }

            for (n = t; n = n.parentNode;) {
              l.unshift(n);
            }

            for (; s[r] === l[r];) {
              r++;
            }

            return r ? a(s[r], l[r]) : s[r] === F ? -1 : l[r] === F ? 1 : 0;
          }, N) : N;
        }, t.matches = function (e, n) {
          return t(e, null, null, n);
        }, t.matchesSelector = function (e, n) {
          if ((e.ownerDocument || e) !== N && A(e), n = n.replace(le, "='$1']"), b.matchesSelector && R && !q[n + " "] && (!M || !M.test(n)) && (!I || !I.test(n))) try {
            var r = j.call(e, n);
            if (r || b.disconnectedMatch || e.document && 11 !== e.document.nodeType) return r;
          } catch (e) {}
          return t(n, N, null, [e]).length > 0;
        }, t.contains = function (e, t) {
          return (e.ownerDocument || e) !== N && A(e), L(e, t);
        }, t.attr = function (e, t) {
          (e.ownerDocument || e) !== N && A(e);

          var n = _.attrHandle[t.toLowerCase()],
              r = n && $.call(_.attrHandle, t.toLowerCase()) ? n(e, t, !R) : void 0;

          return void 0 !== r ? r : b.attributes || !R ? e.getAttribute(t) : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
        }, t.error = function (e) {
          throw new Error("Syntax error, unrecognized expression: " + e);
        }, t.uniqueSort = function (e) {
          var t,
              n = [],
              r = 0,
              o = 0;

          if (C = !b.detectDuplicates, k = !b.sortStable && e.slice(0), e.sort(W), C) {
            for (; t = e[o++];) {
              t === e[o] && (r = n.push(o));
            }

            for (; r--;) {
              e.splice(n[r], 1);
            }
          }

          return k = null, e;
        }, w = t.getText = function (e) {
          var t,
              n = "",
              r = 0,
              o = e.nodeType;

          if (o) {
            if (1 === o || 9 === o || 11 === o) {
              if ("string" == typeof e.textContent) return e.textContent;

              for (e = e.firstChild; e; e = e.nextSibling) {
                n += w(e);
              }
            } else if (3 === o || 4 === o) return e.nodeValue;
          } else for (; t = e[r++];) {
            n += w(t);
          }

          return n;
        }, _ = t.selectors = {
          cacheLength: 50,
          createPseudo: r,
          match: de,
          attrHandle: {},
          find: {},
          relative: {
            ">": {
              dir: "parentNode",
              first: !0
            },
            " ": {
              dir: "parentNode"
            },
            "+": {
              dir: "previousSibling",
              first: !0
            },
            "~": {
              dir: "previousSibling"
            }
          },
          preFilter: {
            ATTR: function ATTR(e) {
              return e[1] = e[1].replace(ye, be), e[3] = (e[3] || e[4] || e[5] || "").replace(ye, be), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
            },
            CHILD: function CHILD(e) {
              return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && t.error(e[0]), e;
            },
            PSEUDO: function PSEUDO(e) {
              var t,
                  n = !e[6] && e[2];
              return de.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && ue.test(n) && (t = O(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3));
            }
          },
          filter: {
            TAG: function TAG(e) {
              var t = e.replace(ye, be).toLowerCase();
              return "*" === e ? function () {
                return !0;
              } : function (e) {
                return e.nodeName && e.nodeName.toLowerCase() === t;
              };
            },
            CLASS: function CLASS(e) {
              var t = V[e + " "];
              return t || (t = new RegExp("(^|" + ee + ")" + e + "(" + ee + "|$)")) && V(e, function (e) {
                return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "");
              });
            },
            ATTR: function ATTR(e, n, r) {
              return function (o) {
                var i = t.attr(o, e);
                return null == i ? "!=" === n : !n || (i += "", "=" === n ? i === r : "!=" === n ? i !== r : "^=" === n ? r && 0 === i.indexOf(r) : "*=" === n ? r && i.indexOf(r) > -1 : "$=" === n ? r && i.slice(-r.length) === r : "~=" === n ? (" " + i.replace(oe, " ") + " ").indexOf(r) > -1 : "|=" === n && (i === r || i.slice(0, r.length + 1) === r + "-"));
              };
            },
            CHILD: function CHILD(e, t, n, r, o) {
              var i = "nth" !== e.slice(0, 3),
                  a = "last" !== e.slice(-4),
                  s = "of-type" === t;
              return 1 === r && 0 === o ? function (e) {
                return !!e.parentNode;
              } : function (t, n, l) {
                var u,
                    c,
                    d,
                    f,
                    p,
                    h,
                    m = i !== a ? "nextSibling" : "previousSibling",
                    g = t.parentNode,
                    v = s && t.nodeName.toLowerCase(),
                    y = !l && !s,
                    b = !1;

                if (g) {
                  if (i) {
                    for (; m;) {
                      for (f = t; f = f[m];) {
                        if (s ? f.nodeName.toLowerCase() === v : 1 === f.nodeType) return !1;
                      }

                      h = m = "only" === e && !h && "nextSibling";
                    }

                    return !0;
                  }

                  if (h = [a ? g.firstChild : g.lastChild], a && y) {
                    for (f = g, d = f[D] || (f[D] = {}), c = d[f.uniqueID] || (d[f.uniqueID] = {}), u = c[e] || [], p = u[0] === U && u[1], b = p && u[2], f = p && g.childNodes[p]; f = ++p && f && f[m] || (b = p = 0) || h.pop();) {
                      if (1 === f.nodeType && ++b && f === t) {
                        c[e] = [U, p, b];
                        break;
                      }
                    }
                  } else if (y && (f = t, d = f[D] || (f[D] = {}), c = d[f.uniqueID] || (d[f.uniqueID] = {}), u = c[e] || [], p = u[0] === U && u[1], b = p), !1 === b) for (; (f = ++p && f && f[m] || (b = p = 0) || h.pop()) && ((s ? f.nodeName.toLowerCase() !== v : 1 !== f.nodeType) || !++b || (y && (d = f[D] || (f[D] = {}), c = d[f.uniqueID] || (d[f.uniqueID] = {}), c[e] = [U, b]), f !== t));) {
                    ;
                  }

                  return (b -= o) === r || b % r == 0 && b / r >= 0;
                }
              };
            },
            PSEUDO: function PSEUDO(e, n) {
              var o,
                  i = _.pseudos[e] || _.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);
              return i[D] ? i(n) : i.length > 1 ? (o = [e, e, "", n], _.setFilters.hasOwnProperty(e.toLowerCase()) ? r(function (e, t) {
                for (var r, o = i(e, n), a = o.length; a--;) {
                  r = X(e, o[a]), e[r] = !(t[r] = o[a]);
                }
              }) : function (e) {
                return i(e, 0, o);
              }) : i;
            }
          },
          pseudos: {
            not: r(function (e) {
              var t = [],
                  n = [],
                  o = S(e.replace(ie, "$1"));
              return o[D] ? r(function (e, t, n, r) {
                for (var i, a = o(e, null, r, []), s = e.length; s--;) {
                  (i = a[s]) && (e[s] = !(t[s] = i));
                }
              }) : function (e, r, i) {
                return t[0] = e, o(t, null, i, n), t[0] = null, !n.pop();
              };
            }),
            has: r(function (e) {
              return function (n) {
                return t(e, n).length > 0;
              };
            }),
            contains: r(function (e) {
              return e = e.replace(ye, be), function (t) {
                return (t.textContent || t.innerText || w(t)).indexOf(e) > -1;
              };
            }),
            lang: r(function (e) {
              return ce.test(e || "") || t.error("unsupported lang: " + e), e = e.replace(ye, be).toLowerCase(), function (t) {
                var n;

                do {
                  if (n = R ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                } while ((t = t.parentNode) && 1 === t.nodeType);

                return !1;
              };
            }),
            target: function target(t) {
              var n = e.location && e.location.hash;
              return n && n.slice(1) === t.id;
            },
            root: function root(e) {
              return e === P;
            },
            focus: function focus(e) {
              return e === N.activeElement && (!N.hasFocus || N.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
            },
            enabled: function enabled(e) {
              return !1 === e.disabled;
            },
            disabled: function disabled(e) {
              return !0 === e.disabled;
            },
            checked: function checked(e) {
              var t = e.nodeName.toLowerCase();
              return "input" === t && !!e.checked || "option" === t && !!e.selected;
            },
            selected: function selected(e) {
              return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
            },
            empty: function empty(e) {
              for (e = e.firstChild; e; e = e.nextSibling) {
                if (e.nodeType < 6) return !1;
              }

              return !0;
            },
            parent: function parent(e) {
              return !_.pseudos.empty(e);
            },
            header: function header(e) {
              return pe.test(e.nodeName);
            },
            input: function input(e) {
              return fe.test(e.nodeName);
            },
            button: function button(e) {
              var t = e.nodeName.toLowerCase();
              return "input" === t && "button" === e.type || "button" === t;
            },
            text: function text(e) {
              var t;
              return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
            },
            first: s(function () {
              return [0];
            }),
            last: s(function (e, t) {
              return [t - 1];
            }),
            eq: s(function (e, t, n) {
              return [n < 0 ? n + t : n];
            }),
            even: s(function (e, t) {
              for (var n = 0; n < t; n += 2) {
                e.push(n);
              }

              return e;
            }),
            odd: s(function (e, t) {
              for (var n = 1; n < t; n += 2) {
                e.push(n);
              }

              return e;
            }),
            lt: s(function (e, t, n) {
              for (var r = n < 0 ? n + t : n; --r >= 0;) {
                e.push(r);
              }

              return e;
            }),
            gt: s(function (e, t, n) {
              for (var r = n < 0 ? n + t : n; ++r < t;) {
                e.push(r);
              }

              return e;
            })
          }
        }, _.pseudos.nth = _.pseudos.eq;

        for (y in {
          radio: !0,
          checkbox: !0,
          file: !0,
          password: !0,
          image: !0
        }) {
          _.pseudos[y] = function (e) {
            return function (t) {
              return "input" === t.nodeName.toLowerCase() && t.type === e;
            };
          }(y);
        }

        for (y in {
          submit: !0,
          reset: !0
        }) {
          _.pseudos[y] = function (e) {
            return function (t) {
              var n = t.nodeName.toLowerCase();
              return ("input" === n || "button" === n) && t.type === e;
            };
          }(y);
        }

        return u.prototype = _.filters = _.pseudos, _.setFilters = new u(), O = t.tokenize = function (e, n) {
          var r,
              o,
              i,
              a,
              s,
              l,
              u,
              c = H[e + " "];
          if (c) return n ? 0 : c.slice(0);

          for (s = e, l = [], u = _.preFilter; s;) {
            r && !(o = ae.exec(s)) || (o && (s = s.slice(o[0].length) || s), l.push(i = [])), r = !1, (o = se.exec(s)) && (r = o.shift(), i.push({
              value: r,
              type: o[0].replace(ie, " ")
            }), s = s.slice(r.length));

            for (a in _.filter) {
              !(o = de[a].exec(s)) || u[a] && !(o = u[a](o)) || (r = o.shift(), i.push({
                value: r,
                type: a,
                matches: o
              }), s = s.slice(r.length));
            }

            if (!r) break;
          }

          return n ? s.length : s ? t.error(e) : H(e, l).slice(0);
        }, S = t.compile = function (e, t) {
          var n,
              r = [],
              o = [],
              i = q[e + " "];

          if (!i) {
            for (t || (t = O(e)), n = t.length; n--;) {
              i = g(t[n]), i[D] ? r.push(i) : o.push(i);
            }

            i = q(e, v(o, r)), i.selector = e;
          }

          return i;
        }, x = t.select = function (e, t, n, r) {
          var o,
              i,
              a,
              s,
              u,
              d = "function" == typeof e && e,
              f = !r && O(e = d.selector || e);

          if (n = n || [], 1 === f.length) {
            if (i = f[0] = f[0].slice(0), i.length > 2 && "ID" === (a = i[0]).type && b.getById && 9 === t.nodeType && R && _.relative[i[1].type]) {
              if (!(t = (_.find.ID(a.matches[0].replace(ye, be), t) || [])[0])) return n;
              d && (t = t.parentNode), e = e.slice(i.shift().value.length);
            }

            for (o = de.needsContext.test(e) ? 0 : i.length; o-- && (a = i[o], !_.relative[s = a.type]);) {
              if ((u = _.find[s]) && (r = u(a.matches[0].replace(ye, be), ge.test(i[0].type) && l(t.parentNode) || t))) {
                if (i.splice(o, 1), !(e = r.length && c(i))) return J.apply(n, r), n;
                break;
              }
            }
          }

          return (d || S(e, f))(r, t, !R, n, !t || ge.test(e) && l(t.parentNode) || t), n;
        }, b.sortStable = D.split("").sort(W).join("") === D, b.detectDuplicates = !!C, A(), b.sortDetached = o(function (e) {
          return 1 & e.compareDocumentPosition(N.createElement("div"));
        }), o(function (e) {
          return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href");
        }) || i("type|href|height|width", function (e, t, n) {
          if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
        }), b.attributes && o(function (e) {
          return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
        }) || i("value", function (e, t, n) {
          if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
        }), o(function (e) {
          return null == e.getAttribute("disabled");
        }) || i(Z, function (e, t, n) {
          var r;
          if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
        }), t;
      }(n);

      ge.find = we, ge.expr = we.selectors, ge.expr[":"] = ge.expr.pseudos, ge.uniqueSort = ge.unique = we.uniqueSort, ge.text = we.getText, ge.isXMLDoc = we.isXML, ge.contains = we.contains;

      var Ee = function Ee(e, t, n) {
        for (var r = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType;) {
          if (1 === e.nodeType) {
            if (o && ge(e).is(n)) break;
            r.push(e);
          }
        }

        return r;
      },
          Oe = function Oe(e, t) {
        for (var n = []; e; e = e.nextSibling) {
          1 === e.nodeType && e !== t && n.push(e);
        }

        return n;
      },
          Se = ge.expr.match.needsContext,
          xe = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
          Te = /^.[^:#\[\.,]*$/;

      ge.filter = function (e, t, n) {
        var r = t[0];
        return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? ge.find.matchesSelector(r, e) ? [r] : [] : ge.find.matches(e, ge.grep(t, function (e) {
          return 1 === e.nodeType;
        }));
      }, ge.fn.extend({
        find: function find(e) {
          var t,
              n = [],
              r = this,
              o = r.length;
          if ("string" != typeof e) return this.pushStack(ge(e).filter(function () {
            for (t = 0; t < o; t++) {
              if (ge.contains(r[t], this)) return !0;
            }
          }));

          for (t = 0; t < o; t++) {
            ge.find(e, r[t], n);
          }

          return n = this.pushStack(o > 1 ? ge.unique(n) : n), n.selector = this.selector ? this.selector + " " + e : e, n;
        },
        filter: function filter(e) {
          return this.pushStack(s(this, e || [], !1));
        },
        not: function not(e) {
          return this.pushStack(s(this, e || [], !0));
        },
        is: function is(e) {
          return !!s(this, "string" == typeof e && Se.test(e) ? ge(e) : e || [], !1).length;
        }
      });
      var ke,
          Ce = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
      (ge.fn.init = function (e, t, n) {
        var r, o;
        if (!e) return this;

        if (n = n || ke, "string" == typeof e) {
          if (!(r = "<" === e.charAt(0) && ">" === e.charAt(e.length - 1) && e.length >= 3 ? [null, e, null] : Ce.exec(e)) || !r[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);

          if (r[1]) {
            if (t = t instanceof ge ? t[0] : t, ge.merge(this, ge.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : se, !0)), xe.test(r[1]) && ge.isPlainObject(t)) for (r in t) {
              ge.isFunction(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
            }
            return this;
          }

          if ((o = se.getElementById(r[2])) && o.parentNode) {
            if (o.id !== r[2]) return ke.find(e);
            this.length = 1, this[0] = o;
          }

          return this.context = se, this.selector = e, this;
        }

        return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : ge.isFunction(e) ? void 0 !== n.ready ? n.ready(e) : e(ge) : (void 0 !== e.selector && (this.selector = e.selector, this.context = e.context), ge.makeArray(e, this));
      }).prototype = ge.fn, ke = ge(se);
      var Ae = /^(?:parents|prev(?:Until|All))/,
          Ne = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
      };
      ge.fn.extend({
        has: function has(e) {
          var t,
              n = ge(e, this),
              r = n.length;
          return this.filter(function () {
            for (t = 0; t < r; t++) {
              if (ge.contains(this, n[t])) return !0;
            }
          });
        },
        closest: function closest(e, t) {
          for (var n, r = 0, o = this.length, i = [], a = Se.test(e) || "string" != typeof e ? ge(e, t || this.context) : 0; r < o; r++) {
            for (n = this[r]; n && n !== t; n = n.parentNode) {
              if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && ge.find.matchesSelector(n, e))) {
                i.push(n);
                break;
              }
            }
          }

          return this.pushStack(i.length > 1 ? ge.uniqueSort(i) : i);
        },
        index: function index(e) {
          return e ? "string" == typeof e ? ge.inArray(this[0], ge(e)) : ge.inArray(e.jquery ? e[0] : e, this) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        },
        add: function add(e, t) {
          return this.pushStack(ge.uniqueSort(ge.merge(this.get(), ge(e, t))));
        },
        addBack: function addBack(e) {
          return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
        }
      }), ge.each({
        parent: function parent(e) {
          var t = e.parentNode;
          return t && 11 !== t.nodeType ? t : null;
        },
        parents: function parents(e) {
          return Ee(e, "parentNode");
        },
        parentsUntil: function parentsUntil(e, t, n) {
          return Ee(e, "parentNode", n);
        },
        next: function next(e) {
          return l(e, "nextSibling");
        },
        prev: function prev(e) {
          return l(e, "previousSibling");
        },
        nextAll: function nextAll(e) {
          return Ee(e, "nextSibling");
        },
        prevAll: function prevAll(e) {
          return Ee(e, "previousSibling");
        },
        nextUntil: function nextUntil(e, t, n) {
          return Ee(e, "nextSibling", n);
        },
        prevUntil: function prevUntil(e, t, n) {
          return Ee(e, "previousSibling", n);
        },
        siblings: function siblings(e) {
          return Oe((e.parentNode || {}).firstChild, e);
        },
        children: function children(e) {
          return Oe(e.firstChild);
        },
        contents: function contents(e) {
          return ge.nodeName(e, "iframe") ? e.contentDocument || e.contentWindow.document : ge.merge([], e.childNodes);
        }
      }, function (e, t) {
        ge.fn[e] = function (n, r) {
          var o = ge.map(this, t, n);
          return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (o = ge.filter(r, o)), this.length > 1 && (Ne[e] || (o = ge.uniqueSort(o)), Ae.test(e) && (o = o.reverse())), this.pushStack(o);
        };
      });
      var Pe = /\S+/g;
      ge.Callbacks = function (e) {
        e = "string" == typeof e ? u(e) : ge.extend({}, e);

        var t,
            n,
            r,
            o,
            i = [],
            a = [],
            s = -1,
            l = function l() {
          for (o = e.once, r = t = !0; a.length; s = -1) {
            for (n = a.shift(); ++s < i.length;) {
              !1 === i[s].apply(n[0], n[1]) && e.stopOnFalse && (s = i.length, n = !1);
            }
          }

          e.memory || (n = !1), t = !1, o && (i = n ? [] : "");
        },
            c = {
          add: function add() {
            return i && (n && !t && (s = i.length - 1, a.push(n)), function t(n) {
              ge.each(n, function (n, r) {
                ge.isFunction(r) ? e.unique && c.has(r) || i.push(r) : r && r.length && "string" !== ge.type(r) && t(r);
              });
            }(arguments), n && !t && l()), this;
          },
          remove: function remove() {
            return ge.each(arguments, function (e, t) {
              for (var n; (n = ge.inArray(t, i, n)) > -1;) {
                i.splice(n, 1), n <= s && s--;
              }
            }), this;
          },
          has: function has(e) {
            return e ? ge.inArray(e, i) > -1 : i.length > 0;
          },
          empty: function empty() {
            return i && (i = []), this;
          },
          disable: function disable() {
            return o = a = [], i = n = "", this;
          },
          disabled: function disabled() {
            return !i;
          },
          lock: function lock() {
            return o = !0, n || c.disable(), this;
          },
          locked: function locked() {
            return !!o;
          },
          fireWith: function fireWith(e, n) {
            return o || (n = n || [], n = [e, n.slice ? n.slice() : n], a.push(n), t || l()), this;
          },
          fire: function fire() {
            return c.fireWith(this, arguments), this;
          },
          fired: function fired() {
            return !!r;
          }
        };

        return c;
      }, ge.extend({
        Deferred: function Deferred(e) {
          var t = [["resolve", "done", ge.Callbacks("once memory"), "resolved"], ["reject", "fail", ge.Callbacks("once memory"), "rejected"], ["notify", "progress", ge.Callbacks("memory")]],
              n = "pending",
              r = {
            state: function state() {
              return n;
            },
            always: function always() {
              return o.done(arguments).fail(arguments), this;
            },
            then: function then() {
              var e = arguments;
              return ge.Deferred(function (n) {
                ge.each(t, function (t, i) {
                  var a = ge.isFunction(e[t]) && e[t];
                  o[i[1]](function () {
                    var e = a && a.apply(this, arguments);
                    e && ge.isFunction(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[i[0] + "With"](this === r ? n.promise() : this, a ? [e] : arguments);
                  });
                }), e = null;
              }).promise();
            },
            promise: function promise(e) {
              return null != e ? ge.extend(e, r) : r;
            }
          },
              o = {};
          return r.pipe = r.then, ge.each(t, function (e, i) {
            var a = i[2],
                s = i[3];
            r[i[1]] = a.add, s && a.add(function () {
              n = s;
            }, t[1 ^ e][2].disable, t[2][2].lock), o[i[0]] = function () {
              return o[i[0] + "With"](this === o ? r : this, arguments), this;
            }, o[i[0] + "With"] = a.fireWith;
          }), r.promise(o), e && e.call(o, o), o;
        },
        when: function when(e) {
          var t,
              n,
              r,
              o = 0,
              i = le.call(arguments),
              a = i.length,
              s = 1 !== a || e && ge.isFunction(e.promise) ? a : 0,
              l = 1 === s ? e : ge.Deferred(),
              u = function u(e, n, r) {
            return function (o) {
              n[e] = this, r[e] = arguments.length > 1 ? le.call(arguments) : o, r === t ? l.notifyWith(n, r) : --s || l.resolveWith(n, r);
            };
          };

          if (a > 1) for (t = new Array(a), n = new Array(a), r = new Array(a); o < a; o++) {
            i[o] && ge.isFunction(i[o].promise) ? i[o].promise().progress(u(o, n, t)).done(u(o, r, i)).fail(l.reject) : --s;
          }
          return s || l.resolveWith(r, i), l.promise();
        }
      });
      var Re;
      ge.fn.ready = function (e) {
        return ge.ready.promise().done(e), this;
      }, ge.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function holdReady(e) {
          e ? ge.readyWait++ : ge.ready(!0);
        },
        ready: function ready(e) {
          (!0 === e ? --ge.readyWait : ge.isReady) || (ge.isReady = !0, !0 !== e && --ge.readyWait > 0 || (Re.resolveWith(se, [ge]), ge.fn.triggerHandler && (ge(se).triggerHandler("ready"), ge(se).off("ready"))));
        }
      }), ge.ready.promise = function (e) {
        if (!Re) if (Re = ge.Deferred(), "complete" === se.readyState || "loading" !== se.readyState && !se.documentElement.doScroll) n.setTimeout(ge.ready);else if (se.addEventListener) se.addEventListener("DOMContentLoaded", d), n.addEventListener("load", d);else {
          se.attachEvent("onreadystatechange", d), n.attachEvent("onload", d);
          var t = !1;

          try {
            t = null == n.frameElement && se.documentElement;
          } catch (e) {}

          t && t.doScroll && function e() {
            if (!ge.isReady) {
              try {
                t.doScroll("left");
              } catch (t) {
                return n.setTimeout(e, 50);
              }

              c(), ge.ready();
            }
          }();
        }
        return Re.promise(e);
      }, ge.ready.promise();
      var Ie;

      for (Ie in ge(me)) {
        break;
      }

      me.ownFirst = "0" === Ie, me.inlineBlockNeedsLayout = !1, ge(function () {
        var e, t, n, r;
        (n = se.getElementsByTagName("body")[0]) && n.style && (t = se.createElement("div"), r = se.createElement("div"), r.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", n.appendChild(r).appendChild(t), void 0 !== t.style.zoom && (t.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1", me.inlineBlockNeedsLayout = e = 3 === t.offsetWidth, e && (n.style.zoom = 1)), n.removeChild(r));
      }), function () {
        var e = se.createElement("div");
        me.deleteExpando = !0;

        try {
          delete e.test;
        } catch (e) {
          me.deleteExpando = !1;
        }

        e = null;
      }();

      var Me = function Me(e) {
        var t = ge.noData[(e.nodeName + " ").toLowerCase()],
            n = +e.nodeType || 1;
        return (1 === n || 9 === n) && (!t || !0 !== t && e.getAttribute("classid") === t);
      },
          je = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
          Le = /([A-Z])/g;

      ge.extend({
        cache: {},
        noData: {
          "applet ": !0,
          "embed ": !0,
          "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
        },
        hasData: function hasData(e) {
          return !!(e = e.nodeType ? ge.cache[e[ge.expando]] : e[ge.expando]) && !p(e);
        },
        data: function data(e, t, n) {
          return h(e, t, n);
        },
        removeData: function removeData(e, t) {
          return m(e, t);
        },
        _data: function _data(e, t, n) {
          return h(e, t, n, !0);
        },
        _removeData: function _removeData(e, t) {
          return m(e, t, !0);
        }
      }), ge.fn.extend({
        data: function data(e, t) {
          var n,
              r,
              o,
              i = this[0],
              a = i && i.attributes;

          if (void 0 === e) {
            if (this.length && (o = ge.data(i), 1 === i.nodeType && !ge._data(i, "parsedAttrs"))) {
              for (n = a.length; n--;) {
                a[n] && (r = a[n].name, 0 === r.indexOf("data-") && (r = ge.camelCase(r.slice(5)), f(i, r, o[r])));
              }

              ge._data(i, "parsedAttrs", !0);
            }

            return o;
          }

          return "object" == typeof e ? this.each(function () {
            ge.data(this, e);
          }) : arguments.length > 1 ? this.each(function () {
            ge.data(this, e, t);
          }) : i ? f(i, e, ge.data(i, e)) : void 0;
        },
        removeData: function removeData(e) {
          return this.each(function () {
            ge.removeData(this, e);
          });
        }
      }), ge.extend({
        queue: function queue(e, t, n) {
          var r;
          if (e) return t = (t || "fx") + "queue", r = ge._data(e, t), n && (!r || ge.isArray(n) ? r = ge._data(e, t, ge.makeArray(n)) : r.push(n)), r || [];
        },
        dequeue: function dequeue(e, t) {
          t = t || "fx";

          var n = ge.queue(e, t),
              r = n.length,
              o = n.shift(),
              i = ge._queueHooks(e, t),
              a = function a() {
            ge.dequeue(e, t);
          };

          "inprogress" === o && (o = n.shift(), r--), o && ("fx" === t && n.unshift("inprogress"), delete i.stop, o.call(e, a, i)), !r && i && i.empty.fire();
        },
        _queueHooks: function _queueHooks(e, t) {
          var n = t + "queueHooks";
          return ge._data(e, n) || ge._data(e, n, {
            empty: ge.Callbacks("once memory").add(function () {
              ge._removeData(e, t + "queue"), ge._removeData(e, n);
            })
          });
        }
      }), ge.fn.extend({
        queue: function queue(e, t) {
          var n = 2;
          return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? ge.queue(this[0], e) : void 0 === t ? this : this.each(function () {
            var n = ge.queue(this, e, t);
            ge._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && ge.dequeue(this, e);
          });
        },
        dequeue: function dequeue(e) {
          return this.each(function () {
            ge.dequeue(this, e);
          });
        },
        clearQueue: function clearQueue(e) {
          return this.queue(e || "fx", []);
        },
        promise: function promise(e, t) {
          var n,
              r = 1,
              o = ge.Deferred(),
              i = this,
              a = this.length,
              s = function s() {
            --r || o.resolveWith(i, [i]);
          };

          for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; a--;) {
            (n = ge._data(i[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s));
          }

          return s(), o.promise(t);
        }
      }), function () {
        var e;

        me.shrinkWrapBlocks = function () {
          if (null != e) return e;
          e = !1;
          var t, n, r;
          return (n = se.getElementsByTagName("body")[0]) && n.style ? (t = se.createElement("div"), r = se.createElement("div"), r.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", n.appendChild(r).appendChild(t), void 0 !== t.style.zoom && (t.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1", t.appendChild(se.createElement("div")).style.width = "5px", e = 3 !== t.offsetWidth), n.removeChild(r), e) : void 0;
        };
      }();

      var De = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
          Fe = new RegExp("^(?:([+-])=|)(" + De + ")([a-z%]*)$", "i"),
          Ue = ["Top", "Right", "Bottom", "Left"],
          Be = function Be(e, t) {
        return e = t || e, "none" === ge.css(e, "display") || !ge.contains(e.ownerDocument, e);
      },
          Ve = function Ve(e, t, n, r, o, i, a) {
        var s = 0,
            l = e.length,
            u = null == n;

        if ("object" === ge.type(n)) {
          o = !0;

          for (s in n) {
            Ve(e, t, s, n[s], !0, i, a);
          }
        } else if (void 0 !== r && (o = !0, ge.isFunction(r) || (a = !0), u && (a ? (t.call(e, r), t = null) : (u = t, t = function t(e, _t3, n) {
          return u.call(ge(e), n);
        })), t)) for (; s < l; s++) {
          t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
        }

        return o ? e : u ? t.call(e) : l ? t(e[0], n) : i;
      },
          He = /^(?:checkbox|radio)$/i,
          qe = /<([\w:-]+)/,
          We = /^$|\/(?:java|ecma)script/i,
          ze = /^\s+/,
          $e = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|dialog|figcaption|figure|footer|header|hgroup|main|mark|meter|nav|output|picture|progress|section|summary|template|time|video";

      !function () {
        var e = se.createElement("div"),
            t = se.createDocumentFragment(),
            n = se.createElement("input");
        e.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", me.leadingWhitespace = 3 === e.firstChild.nodeType, me.tbody = !e.getElementsByTagName("tbody").length, me.htmlSerialize = !!e.getElementsByTagName("link").length, me.html5Clone = "<:nav></:nav>" !== se.createElement("nav").cloneNode(!0).outerHTML, n.type = "checkbox", n.checked = !0, t.appendChild(n), me.appendChecked = n.checked, e.innerHTML = "<textarea>x</textarea>", me.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue, t.appendChild(e), n = se.createElement("input"), n.setAttribute("type", "radio"), n.setAttribute("checked", "checked"), n.setAttribute("name", "t"), e.appendChild(n), me.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked, me.noCloneEvent = !!e.addEventListener, e[ge.expando] = 1, me.attributes = !e.getAttribute(ge.expando);
      }();
      var Ke = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        legend: [1, "<fieldset>", "</fieldset>"],
        area: [1, "<map>", "</map>"],
        param: [1, "<object>", "</object>"],
        thead: [1, "<table>", "</table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: me.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"]
      };
      Ke.optgroup = Ke.option, Ke.tbody = Ke.tfoot = Ke.colgroup = Ke.caption = Ke.thead, Ke.th = Ke.td;
      var Ge = /<|&#?\w+;/,
          Ye = /<tbody/i;
      !function () {
        var e,
            t,
            r = se.createElement("div");

        for (e in {
          submit: !0,
          change: !0,
          focusin: !0
        }) {
          t = "on" + e, (me[e] = t in n) || (r.setAttribute(t, "t"), me[e] = !1 === r.attributes[t].expando);
        }

        r = null;
      }();
      var Je = /^(?:input|select|textarea)$/i,
          Qe = /^key/,
          Xe = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
          Ze = /^(?:focusinfocus|focusoutblur)$/,
          et = /^([^.]*)(?:\.(.+)|)/;
      ge.event = {
        global: {},
        add: function add(e, t, n, r, o) {
          var i,
              a,
              s,
              l,
              u,
              c,
              d,
              f,
              p,
              h,
              m,
              g = ge._data(e);

          if (g) {
            for (n.handler && (l = n, n = l.handler, o = l.selector), n.guid || (n.guid = ge.guid++), (a = g.events) || (a = g.events = {}), (c = g.handle) || (c = g.handle = function (e) {
              return void 0 === ge || e && ge.event.triggered === e.type ? void 0 : ge.event.dispatch.apply(c.elem, arguments);
            }, c.elem = e), t = (t || "").match(Pe) || [""], s = t.length; s--;) {
              i = et.exec(t[s]) || [], p = m = i[1], h = (i[2] || "").split(".").sort(), p && (u = ge.event.special[p] || {}, p = (o ? u.delegateType : u.bindType) || p, u = ge.event.special[p] || {}, d = ge.extend({
                type: p,
                origType: m,
                data: r,
                handler: n,
                guid: n.guid,
                selector: o,
                needsContext: o && ge.expr.match.needsContext.test(o),
                namespace: h.join(".")
              }, l), (f = a[p]) || (f = a[p] = [], f.delegateCount = 0, u.setup && !1 !== u.setup.call(e, r, h, c) || (e.addEventListener ? e.addEventListener(p, c, !1) : e.attachEvent && e.attachEvent("on" + p, c))), u.add && (u.add.call(e, d), d.handler.guid || (d.handler.guid = n.guid)), o ? f.splice(f.delegateCount++, 0, d) : f.push(d), ge.event.global[p] = !0);
            }

            e = null;
          }
        },
        remove: function remove(e, t, n, r, o) {
          var i,
              a,
              s,
              l,
              u,
              c,
              d,
              f,
              p,
              h,
              m,
              g = ge.hasData(e) && ge._data(e);

          if (g && (c = g.events)) {
            for (t = (t || "").match(Pe) || [""], u = t.length; u--;) {
              if (s = et.exec(t[u]) || [], p = m = s[1], h = (s[2] || "").split(".").sort(), p) {
                for (d = ge.event.special[p] || {}, p = (r ? d.delegateType : d.bindType) || p, f = c[p] || [], s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), l = i = f.length; i--;) {
                  a = f[i], !o && m !== a.origType || n && n.guid !== a.guid || s && !s.test(a.namespace) || r && r !== a.selector && ("**" !== r || !a.selector) || (f.splice(i, 1), a.selector && f.delegateCount--, d.remove && d.remove.call(e, a));
                }

                l && !f.length && (d.teardown && !1 !== d.teardown.call(e, h, g.handle) || ge.removeEvent(e, p, g.handle), delete c[p]);
              } else for (p in c) {
                ge.event.remove(e, p + t[u], n, r, !0);
              }
            }

            ge.isEmptyObject(c) && (delete g.handle, ge._removeData(e, "events"));
          }
        },
        trigger: function trigger(e, t, r, o) {
          var i,
              a,
              s,
              l,
              u,
              c,
              d,
              f = [r || se],
              p = he.call(e, "type") ? e.type : e,
              h = he.call(e, "namespace") ? e.namespace.split(".") : [];

          if (s = c = r = r || se, 3 !== r.nodeType && 8 !== r.nodeType && !Ze.test(p + ge.event.triggered) && (p.indexOf(".") > -1 && (h = p.split("."), p = h.shift(), h.sort()), a = p.indexOf(":") < 0 && "on" + p, e = e[ge.expando] ? e : new ge.Event(p, "object" == typeof e && e), e.isTrigger = o ? 2 : 3, e.namespace = h.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = r), t = null == t ? [e] : ge.makeArray(t, [e]), u = ge.event.special[p] || {}, o || !u.trigger || !1 !== u.trigger.apply(r, t))) {
            if (!o && !u.noBubble && !ge.isWindow(r)) {
              for (l = u.delegateType || p, Ze.test(l + p) || (s = s.parentNode); s; s = s.parentNode) {
                f.push(s), c = s;
              }

              c === (r.ownerDocument || se) && f.push(c.defaultView || c.parentWindow || n);
            }

            for (d = 0; (s = f[d++]) && !e.isPropagationStopped();) {
              e.type = d > 1 ? l : u.bindType || p, i = (ge._data(s, "events") || {})[e.type] && ge._data(s, "handle"), i && i.apply(s, t), (i = a && s[a]) && i.apply && Me(s) && (e.result = i.apply(s, t), !1 === e.result && e.preventDefault());
            }

            if (e.type = p, !o && !e.isDefaultPrevented() && (!u._default || !1 === u._default.apply(f.pop(), t)) && Me(r) && a && r[p] && !ge.isWindow(r)) {
              c = r[a], c && (r[a] = null), ge.event.triggered = p;

              try {
                r[p]();
              } catch (e) {}

              ge.event.triggered = void 0, c && (r[a] = c);
            }

            return e.result;
          }
        },
        dispatch: function dispatch(e) {
          e = ge.event.fix(e);
          var t,
              n,
              r,
              o,
              i,
              a = [],
              s = le.call(arguments),
              l = (ge._data(this, "events") || {})[e.type] || [],
              u = ge.event.special[e.type] || {};

          if (s[0] = e, e.delegateTarget = this, !u.preDispatch || !1 !== u.preDispatch.call(this, e)) {
            for (a = ge.event.handlers.call(this, e, l), t = 0; (o = a[t++]) && !e.isPropagationStopped();) {
              for (e.currentTarget = o.elem, n = 0; (i = o.handlers[n++]) && !e.isImmediatePropagationStopped();) {
                e.rnamespace && !e.rnamespace.test(i.namespace) || (e.handleObj = i, e.data = i.data, void 0 !== (r = ((ge.event.special[i.origType] || {}).handle || i.handler).apply(o.elem, s)) && !1 === (e.result = r) && (e.preventDefault(), e.stopPropagation()));
              }
            }

            return u.postDispatch && u.postDispatch.call(this, e), e.result;
          }
        },
        handlers: function handlers(e, t) {
          var n,
              r,
              o,
              i,
              a = [],
              s = t.delegateCount,
              l = e.target;
          if (s && l.nodeType && ("click" !== e.type || isNaN(e.button) || e.button < 1)) for (; l != this; l = l.parentNode || this) {
            if (1 === l.nodeType && (!0 !== l.disabled || "click" !== e.type)) {
              for (r = [], n = 0; n < s; n++) {
                i = t[n], o = i.selector + " ", void 0 === r[o] && (r[o] = i.needsContext ? ge(o, this).index(l) > -1 : ge.find(o, this, null, [l]).length), r[o] && r.push(i);
              }

              r.length && a.push({
                elem: l,
                handlers: r
              });
            }
          }
          return s < t.length && a.push({
            elem: this,
            handlers: t.slice(s)
          }), a;
        },
        fix: function fix(e) {
          if (e[ge.expando]) return e;
          var t,
              n,
              r,
              o = e.type,
              i = e,
              a = this.fixHooks[o];

          for (a || (this.fixHooks[o] = a = Xe.test(o) ? this.mouseHooks : Qe.test(o) ? this.keyHooks : {}), r = a.props ? this.props.concat(a.props) : this.props, e = new ge.Event(i), t = r.length; t--;) {
            n = r[t], e[n] = i[n];
          }

          return e.target || (e.target = i.srcElement || se), 3 === e.target.nodeType && (e.target = e.target.parentNode), e.metaKey = !!e.metaKey, a.filter ? a.filter(e, i) : e;
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
          props: "char charCode key keyCode".split(" "),
          filter: function filter(e, t) {
            return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e;
          }
        },
        mouseHooks: {
          props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
          filter: function filter(e, t) {
            var n,
                r,
                o,
                i = t.button,
                a = t.fromElement;
            return null == e.pageX && null != t.clientX && (r = e.target.ownerDocument || se, o = r.documentElement, n = r.body, e.pageX = t.clientX + (o && o.scrollLeft || n && n.scrollLeft || 0) - (o && o.clientLeft || n && n.clientLeft || 0), e.pageY = t.clientY + (o && o.scrollTop || n && n.scrollTop || 0) - (o && o.clientTop || n && n.clientTop || 0)), !e.relatedTarget && a && (e.relatedTarget = a === e.target ? t.toElement : a), e.which || void 0 === i || (e.which = 1 & i ? 1 : 2 & i ? 3 : 4 & i ? 2 : 0), e;
          }
        },
        special: {
          load: {
            noBubble: !0
          },
          focus: {
            trigger: function trigger() {
              if (this !== S() && this.focus) try {
                return this.focus(), !1;
              } catch (e) {}
            },
            delegateType: "focusin"
          },
          blur: {
            trigger: function trigger() {
              if (this === S() && this.blur) return this.blur(), !1;
            },
            delegateType: "focusout"
          },
          click: {
            trigger: function trigger() {
              if (ge.nodeName(this, "input") && "checkbox" === this.type && this.click) return this.click(), !1;
            },
            _default: function _default(e) {
              return ge.nodeName(e.target, "a");
            }
          },
          beforeunload: {
            postDispatch: function postDispatch(e) {
              void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
            }
          }
        },
        simulate: function simulate(e, t, n) {
          var r = ge.extend(new ge.Event(), n, {
            type: e,
            isSimulated: !0
          });
          ge.event.trigger(r, null, t), r.isDefaultPrevented() && n.preventDefault();
        }
      }, ge.removeEvent = se.removeEventListener ? function (e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n);
      } : function (e, t, n) {
        var r = "on" + t;
        e.detachEvent && (void 0 === e[r] && (e[r] = null), e.detachEvent(r, n));
      }, ge.Event = function (e, t) {
        if (!(this instanceof ge.Event)) return new ge.Event(e, t);
        e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? E : O) : this.type = e, t && ge.extend(this, t), this.timeStamp = e && e.timeStamp || ge.now(), this[ge.expando] = !0;
      }, ge.Event.prototype = {
        constructor: ge.Event,
        isDefaultPrevented: O,
        isPropagationStopped: O,
        isImmediatePropagationStopped: O,
        preventDefault: function preventDefault() {
          var e = this.originalEvent;
          this.isDefaultPrevented = E, e && (e.preventDefault ? e.preventDefault() : e.returnValue = !1);
        },
        stopPropagation: function stopPropagation() {
          var e = this.originalEvent;
          this.isPropagationStopped = E, e && !this.isSimulated && (e.stopPropagation && e.stopPropagation(), e.cancelBubble = !0);
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
          var e = this.originalEvent;
          this.isImmediatePropagationStopped = E, e && e.stopImmediatePropagation && e.stopImmediatePropagation(), this.stopPropagation();
        }
      }, ge.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
      }, function (e, t) {
        ge.event.special[e] = {
          delegateType: t,
          bindType: t,
          handle: function handle(e) {
            var n,
                r = this,
                o = e.relatedTarget,
                i = e.handleObj;
            return o && (o === r || ge.contains(r, o)) || (e.type = i.origType, n = i.handler.apply(this, arguments), e.type = t), n;
          }
        };
      }), me.submit || (ge.event.special.submit = {
        setup: function setup() {
          if (ge.nodeName(this, "form")) return !1;
          ge.event.add(this, "click._submit keypress._submit", function (e) {
            var t = e.target,
                n = ge.nodeName(t, "input") || ge.nodeName(t, "button") ? ge.prop(t, "form") : void 0;
            n && !ge._data(n, "submit") && (ge.event.add(n, "submit._submit", function (e) {
              e._submitBubble = !0;
            }), ge._data(n, "submit", !0));
          });
        },
        postDispatch: function postDispatch(e) {
          e._submitBubble && (delete e._submitBubble, this.parentNode && !e.isTrigger && ge.event.simulate("submit", this.parentNode, e));
        },
        teardown: function teardown() {
          if (ge.nodeName(this, "form")) return !1;
          ge.event.remove(this, "._submit");
        }
      }), me.change || (ge.event.special.change = {
        setup: function setup() {
          if (Je.test(this.nodeName)) return "checkbox" !== this.type && "radio" !== this.type || (ge.event.add(this, "propertychange._change", function (e) {
            "checked" === e.originalEvent.propertyName && (this._justChanged = !0);
          }), ge.event.add(this, "click._change", function (e) {
            this._justChanged && !e.isTrigger && (this._justChanged = !1), ge.event.simulate("change", this, e);
          })), !1;
          ge.event.add(this, "beforeactivate._change", function (e) {
            var t = e.target;
            Je.test(t.nodeName) && !ge._data(t, "change") && (ge.event.add(t, "change._change", function (e) {
              !this.parentNode || e.isSimulated || e.isTrigger || ge.event.simulate("change", this.parentNode, e);
            }), ge._data(t, "change", !0));
          });
        },
        handle: function handle(e) {
          var t = e.target;
          if (this !== t || e.isSimulated || e.isTrigger || "radio" !== t.type && "checkbox" !== t.type) return e.handleObj.handler.apply(this, arguments);
        },
        teardown: function teardown() {
          return ge.event.remove(this, "._change"), !Je.test(this.nodeName);
        }
      }), me.focusin || ge.each({
        focus: "focusin",
        blur: "focusout"
      }, function (e, t) {
        var n = function n(e) {
          ge.event.simulate(t, e.target, ge.event.fix(e));
        };

        ge.event.special[t] = {
          setup: function setup() {
            var r = this.ownerDocument || this,
                o = ge._data(r, t);

            o || r.addEventListener(e, n, !0), ge._data(r, t, (o || 0) + 1);
          },
          teardown: function teardown() {
            var r = this.ownerDocument || this,
                o = ge._data(r, t) - 1;
            o ? ge._data(r, t, o) : (r.removeEventListener(e, n, !0), ge._removeData(r, t));
          }
        };
      }), ge.fn.extend({
        on: function on(e, t, n, r) {
          return x(this, e, t, n, r);
        },
        one: function one(e, t, n, r) {
          return x(this, e, t, n, r, 1);
        },
        off: function off(e, t, n) {
          var r, o;
          if (e && e.preventDefault && e.handleObj) return r = e.handleObj, ge(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;

          if ("object" == typeof e) {
            for (o in e) {
              this.off(o, t, e[o]);
            }

            return this;
          }

          return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = O), this.each(function () {
            ge.event.remove(this, e, n, t);
          });
        },
        trigger: function trigger(e, t) {
          return this.each(function () {
            ge.event.trigger(e, t, this);
          });
        },
        triggerHandler: function triggerHandler(e, t) {
          var n = this[0];
          if (n) return ge.event.trigger(e, t, n, !0);
        }
      });
      var tt = / jQuery\d+="(?:null|\d+)"/g,
          nt = new RegExp("<(?:" + $e + ")[\\s/>]", "i"),
          rt = /<script|<style|<link/i,
          ot = /checked\s*(?:[^=]|=\s*.checked.)/i,
          it = /^true\/(.*)/,
          at = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
          st = v(se),
          lt = st.appendChild(se.createElement("div"));
      ge.extend({
        htmlPrefilter: function htmlPrefilter(e) {
          return e;
        },
        clone: function clone(e, t, n) {
          var r,
              o,
              i,
              a,
              s,
              l = ge.contains(e.ownerDocument, e);
          if (me.html5Clone || ge.isXMLDoc(e) || !nt.test("<" + e.nodeName + ">") ? i = e.cloneNode(!0) : (lt.innerHTML = e.outerHTML, lt.removeChild(i = lt.firstChild)), !(me.noCloneEvent && me.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || ge.isXMLDoc(e))) for (r = y(i), s = y(e), a = 0; null != (o = s[a]); ++a) {
            r[a] && N(o, r[a]);
          }
          if (t) if (n) for (s = s || y(e), r = r || y(i), a = 0; null != (o = s[a]); a++) {
            A(o, r[a]);
          } else A(e, i);
          return r = y(i, "script"), r.length > 0 && b(r, !l && y(e, "script")), r = s = o = null, i;
        },
        cleanData: function cleanData(e, t) {
          for (var n, r, o, i, a = 0, s = ge.expando, l = ge.cache, u = me.attributes, c = ge.event.special; null != (n = e[a]); a++) {
            if ((t || Me(n)) && (o = n[s], i = o && l[o])) {
              if (i.events) for (r in i.events) {
                c[r] ? ge.event.remove(n, r) : ge.removeEvent(n, r, i.handle);
              }
              l[o] && (delete l[o], u || void 0 === n.removeAttribute ? n[s] = void 0 : n.removeAttribute(s), ae.push(o));
            }
          }
        }
      }), ge.fn.extend({
        domManip: P,
        detach: function detach(e) {
          return R(this, e, !0);
        },
        remove: function remove(e) {
          return R(this, e);
        },
        text: function text(e) {
          return Ve(this, function (e) {
            return void 0 === e ? ge.text(this) : this.empty().append((this[0] && this[0].ownerDocument || se).createTextNode(e));
          }, null, e, arguments.length);
        },
        append: function append() {
          return P(this, arguments, function (e) {
            if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
              T(this, e).appendChild(e);
            }
          });
        },
        prepend: function prepend() {
          return P(this, arguments, function (e) {
            if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
              var t = T(this, e);
              t.insertBefore(e, t.firstChild);
            }
          });
        },
        before: function before() {
          return P(this, arguments, function (e) {
            this.parentNode && this.parentNode.insertBefore(e, this);
          });
        },
        after: function after() {
          return P(this, arguments, function (e) {
            this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
          });
        },
        empty: function empty() {
          for (var e, t = 0; null != (e = this[t]); t++) {
            for (1 === e.nodeType && ge.cleanData(y(e, !1)); e.firstChild;) {
              e.removeChild(e.firstChild);
            }

            e.options && ge.nodeName(e, "select") && (e.options.length = 0);
          }

          return this;
        },
        clone: function clone(e, t) {
          return e = null != e && e, t = null == t ? e : t, this.map(function () {
            return ge.clone(this, e, t);
          });
        },
        html: function html(e) {
          return Ve(this, function (e) {
            var t = this[0] || {},
                n = 0,
                r = this.length;
            if (void 0 === e) return 1 === t.nodeType ? t.innerHTML.replace(tt, "") : void 0;

            if ("string" == typeof e && !rt.test(e) && (me.htmlSerialize || !nt.test(e)) && (me.leadingWhitespace || !ze.test(e)) && !Ke[(qe.exec(e) || ["", ""])[1].toLowerCase()]) {
              e = ge.htmlPrefilter(e);

              try {
                for (; n < r; n++) {
                  t = this[n] || {}, 1 === t.nodeType && (ge.cleanData(y(t, !1)), t.innerHTML = e);
                }

                t = 0;
              } catch (e) {}
            }

            t && this.empty().append(e);
          }, null, e, arguments.length);
        },
        replaceWith: function replaceWith() {
          var e = [];
          return P(this, arguments, function (t) {
            var n = this.parentNode;
            ge.inArray(this, e) < 0 && (ge.cleanData(y(this)), n && n.replaceChild(t, this));
          }, e);
        }
      }), ge.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
      }, function (e, t) {
        ge.fn[e] = function (e) {
          for (var n, r = 0, o = [], i = ge(e), a = i.length - 1; r <= a; r++) {
            n = r === a ? this : this.clone(!0), ge(i[r])[t](n), ce.apply(o, n.get());
          }

          return this.pushStack(o);
        };
      });

      var ut,
          ct = {
        HTML: "block",
        BODY: "block"
      },
          dt = /^margin/,
          ft = new RegExp("^(" + De + ")(?!px)[a-z%]+$", "i"),
          pt = function pt(e, t, n, r) {
        var o,
            i,
            a = {};

        for (i in t) {
          a[i] = e.style[i], e.style[i] = t[i];
        }

        o = n.apply(e, r || []);

        for (i in t) {
          e.style[i] = a[i];
        }

        return o;
      },
          ht = se.documentElement;

      !function () {
        function e() {
          var e,
              c,
              d = se.documentElement;
          d.appendChild(l), u.style.cssText = "-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", t = o = s = !1, r = a = !0, n.getComputedStyle && (c = n.getComputedStyle(u), t = "1%" !== (c || {}).top, s = "2px" === (c || {}).marginLeft, o = "4px" === (c || {
            width: "4px"
          }).width, u.style.marginRight = "50%", r = "4px" === (c || {
            marginRight: "4px"
          }).marginRight, e = u.appendChild(se.createElement("div")), e.style.cssText = u.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", e.style.marginRight = e.style.width = "0", u.style.width = "1px", a = !parseFloat((n.getComputedStyle(e) || {}).marginRight), u.removeChild(e)), u.style.display = "none", i = 0 === u.getClientRects().length, i && (u.style.display = "", u.innerHTML = "<table><tr><td></td><td>t</td></tr></table>", u.childNodes[0].style.borderCollapse = "separate", e = u.getElementsByTagName("td"), e[0].style.cssText = "margin:0;border:0;padding:0;display:none", (i = 0 === e[0].offsetHeight) && (e[0].style.display = "", e[1].style.display = "none", i = 0 === e[0].offsetHeight)), d.removeChild(l);
        }

        var t,
            r,
            o,
            i,
            a,
            s,
            l = se.createElement("div"),
            u = se.createElement("div");
        u.style && (u.style.cssText = "float:left;opacity:.5", me.opacity = "0.5" === u.style.opacity, me.cssFloat = !!u.style.cssFloat, u.style.backgroundClip = "content-box", u.cloneNode(!0).style.backgroundClip = "", me.clearCloneStyle = "content-box" === u.style.backgroundClip, l = se.createElement("div"), l.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", u.innerHTML = "", l.appendChild(u), me.boxSizing = "" === u.style.boxSizing || "" === u.style.MozBoxSizing || "" === u.style.WebkitBoxSizing, ge.extend(me, {
          reliableHiddenOffsets: function reliableHiddenOffsets() {
            return null == t && e(), i;
          },
          boxSizingReliable: function boxSizingReliable() {
            return null == t && e(), o;
          },
          pixelMarginRight: function pixelMarginRight() {
            return null == t && e(), r;
          },
          pixelPosition: function pixelPosition() {
            return null == t && e(), t;
          },
          reliableMarginRight: function reliableMarginRight() {
            return null == t && e(), a;
          },
          reliableMarginLeft: function reliableMarginLeft() {
            return null == t && e(), s;
          }
        }));
      }();
      var mt,
          gt,
          vt = /^(top|right|bottom|left)$/;
      n.getComputedStyle ? (mt = function mt(e) {
        var t = e.ownerDocument.defaultView;
        return t && t.opener || (t = n), t.getComputedStyle(e);
      }, gt = function gt(e, t, n) {
        var r,
            o,
            i,
            a,
            s = e.style;
        return n = n || mt(e), a = n ? n.getPropertyValue(t) || n[t] : void 0, "" !== a && void 0 !== a || ge.contains(e.ownerDocument, e) || (a = ge.style(e, t)), n && !me.pixelMarginRight() && ft.test(a) && dt.test(t) && (r = s.width, o = s.minWidth, i = s.maxWidth, s.minWidth = s.maxWidth = s.width = a, a = n.width, s.width = r, s.minWidth = o, s.maxWidth = i), void 0 === a ? a : a + "";
      }) : ht.currentStyle && (mt = function mt(e) {
        return e.currentStyle;
      }, gt = function gt(e, t, n) {
        var r,
            o,
            i,
            a,
            s = e.style;
        return n = n || mt(e), a = n ? n[t] : void 0, null == a && s && s[t] && (a = s[t]), ft.test(a) && !vt.test(t) && (r = s.left, o = e.runtimeStyle, i = o && o.left, i && (o.left = e.currentStyle.left), s.left = "fontSize" === t ? "1em" : a, a = s.pixelLeft + "px", s.left = r, i && (o.left = i)), void 0 === a ? a : a + "" || "auto";
      });
      var yt = /alpha\([^)]*\)/i,
          bt = /opacity\s*=\s*([^)]*)/i,
          _t = /^(none|table(?!-c[ea]).+)/,
          wt = new RegExp("^(" + De + ")(.*)$", "i"),
          Et = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
      },
          Ot = {
        letterSpacing: "0",
        fontWeight: "400"
      },
          St = ["Webkit", "O", "Moz", "ms"],
          xt = se.createElement("div").style;
      ge.extend({
        cssHooks: {
          opacity: {
            get: function get(e, t) {
              if (t) {
                var n = gt(e, "opacity");
                return "" === n ? "1" : n;
              }
            }
          }
        },
        cssNumber: {
          animationIterationCount: !0,
          columnCount: !0,
          fillOpacity: !0,
          flexGrow: !0,
          flexShrink: !0,
          fontWeight: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0
        },
        cssProps: {
          float: me.cssFloat ? "cssFloat" : "styleFloat"
        },
        style: function style(e, t, n, r) {
          if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
            var o,
                i,
                a,
                s = ge.camelCase(t),
                l = e.style;
            if (t = ge.cssProps[s] || (ge.cssProps[s] = L(s) || s), a = ge.cssHooks[t] || ge.cssHooks[s], void 0 === n) return a && "get" in a && void 0 !== (o = a.get(e, !1, r)) ? o : l[t];
            if (i = typeof n, "string" === i && (o = Fe.exec(n)) && o[1] && (n = g(e, t, o), i = "number"), null != n && n === n && ("number" === i && (n += o && o[3] || (ge.cssNumber[s] ? "" : "px")), me.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), !(a && "set" in a && void 0 === (n = a.set(e, n, r))))) try {
              l[t] = n;
            } catch (e) {}
          }
        },
        css: function css(e, t, n, r) {
          var o,
              i,
              a,
              s = ge.camelCase(t);
          return t = ge.cssProps[s] || (ge.cssProps[s] = L(s) || s), a = ge.cssHooks[t] || ge.cssHooks[s], a && "get" in a && (i = a.get(e, !0, n)), void 0 === i && (i = gt(e, t, r)), "normal" === i && t in Ot && (i = Ot[t]), "" === n || n ? (o = parseFloat(i), !0 === n || isFinite(o) ? o || 0 : i) : i;
        }
      }), ge.each(["height", "width"], function (e, t) {
        ge.cssHooks[t] = {
          get: function get(e, n, r) {
            if (n) return _t.test(ge.css(e, "display")) && 0 === e.offsetWidth ? pt(e, Et, function () {
              return B(e, t, r);
            }) : B(e, t, r);
          },
          set: function set(e, n, r) {
            var o = r && mt(e);
            return F(e, n, r ? U(e, t, r, me.boxSizing && "border-box" === ge.css(e, "boxSizing", !1, o), o) : 0);
          }
        };
      }), me.opacity || (ge.cssHooks.opacity = {
        get: function get(e, t) {
          return bt.test((t && e.currentStyle ? e.currentStyle.filter : e.style.filter) || "") ? .01 * parseFloat(RegExp.$1) + "" : t ? "1" : "";
        },
        set: function set(e, t) {
          var n = e.style,
              r = e.currentStyle,
              o = ge.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : "",
              i = r && r.filter || n.filter || "";
          n.zoom = 1, (t >= 1 || "" === t) && "" === ge.trim(i.replace(yt, "")) && n.removeAttribute && (n.removeAttribute("filter"), "" === t || r && !r.filter) || (n.filter = yt.test(i) ? i.replace(yt, o) : i + " " + o);
        }
      }), ge.cssHooks.marginRight = j(me.reliableMarginRight, function (e, t) {
        if (t) return pt(e, {
          display: "inline-block"
        }, gt, [e, "marginRight"]);
      }), ge.cssHooks.marginLeft = j(me.reliableMarginLeft, function (e, t) {
        if (t) return (parseFloat(gt(e, "marginLeft")) || (ge.contains(e.ownerDocument, e) ? e.getBoundingClientRect().left - pt(e, {
          marginLeft: 0
        }, function () {
          return e.getBoundingClientRect().left;
        }) : 0)) + "px";
      }), ge.each({
        margin: "",
        padding: "",
        border: "Width"
      }, function (e, t) {
        ge.cssHooks[e + t] = {
          expand: function expand(n) {
            for (var r = 0, o = {}, i = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++) {
              o[e + Ue[r] + t] = i[r] || i[r - 2] || i[0];
            }

            return o;
          }
        }, dt.test(e) || (ge.cssHooks[e + t].set = F);
      }), ge.fn.extend({
        css: function css(e, t) {
          return Ve(this, function (e, t, n) {
            var r,
                o,
                i = {},
                a = 0;

            if (ge.isArray(t)) {
              for (r = mt(e), o = t.length; a < o; a++) {
                i[t[a]] = ge.css(e, t[a], !1, r);
              }

              return i;
            }

            return void 0 !== n ? ge.style(e, t, n) : ge.css(e, t);
          }, e, t, arguments.length > 1);
        },
        show: function show() {
          return D(this, !0);
        },
        hide: function hide() {
          return D(this);
        },
        toggle: function toggle(e) {
          return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
            Be(this) ? ge(this).show() : ge(this).hide();
          });
        }
      }), ge.Tween = V, V.prototype = {
        constructor: V,
        init: function init(e, t, n, r, o, i) {
          this.elem = e, this.prop = n, this.easing = o || ge.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = i || (ge.cssNumber[n] ? "" : "px");
        },
        cur: function cur() {
          var e = V.propHooks[this.prop];
          return e && e.get ? e.get(this) : V.propHooks._default.get(this);
        },
        run: function run(e) {
          var t,
              n = V.propHooks[this.prop];
          return this.options.duration ? this.pos = t = ge.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : V.propHooks._default.set(this), this;
        }
      }, V.prototype.init.prototype = V.prototype, V.propHooks = {
        _default: {
          get: function get(e) {
            var t;
            return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = ge.css(e.elem, e.prop, ""), t && "auto" !== t ? t : 0);
          },
          set: function set(e) {
            ge.fx.step[e.prop] ? ge.fx.step[e.prop](e) : 1 !== e.elem.nodeType || null == e.elem.style[ge.cssProps[e.prop]] && !ge.cssHooks[e.prop] ? e.elem[e.prop] = e.now : ge.style(e.elem, e.prop, e.now + e.unit);
          }
        }
      }, V.propHooks.scrollTop = V.propHooks.scrollLeft = {
        set: function set(e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        }
      }, ge.easing = {
        linear: function linear(e) {
          return e;
        },
        swing: function swing(e) {
          return .5 - Math.cos(e * Math.PI) / 2;
        },
        _default: "swing"
      }, ge.fx = V.prototype.init, ge.fx.step = {};
      var Tt,
          kt,
          Ct = /^(?:toggle|show|hide)$/,
          At = /queueHooks$/;
      ge.Animation = ge.extend(K, {
        tweeners: {
          "*": [function (e, t) {
            var n = this.createTween(e, t);
            return g(n.elem, e, Fe.exec(t), n), n;
          }]
        },
        tweener: function tweener(e, t) {
          ge.isFunction(e) ? (t = e, e = ["*"]) : e = e.match(Pe);

          for (var n, r = 0, o = e.length; r < o; r++) {
            n = e[r], K.tweeners[n] = K.tweeners[n] || [], K.tweeners[n].unshift(t);
          }
        },
        prefilters: [z],
        prefilter: function prefilter(e, t) {
          t ? K.prefilters.unshift(e) : K.prefilters.push(e);
        }
      }), ge.speed = function (e, t, n) {
        var r = e && "object" == typeof e ? ge.extend({}, e) : {
          complete: n || !n && t || ge.isFunction(e) && e,
          duration: e,
          easing: n && t || t && !ge.isFunction(t) && t
        };
        return r.duration = ge.fx.off ? 0 : "number" == typeof r.duration ? r.duration : r.duration in ge.fx.speeds ? ge.fx.speeds[r.duration] : ge.fx.speeds._default, null != r.queue && !0 !== r.queue || (r.queue = "fx"), r.old = r.complete, r.complete = function () {
          ge.isFunction(r.old) && r.old.call(this), r.queue && ge.dequeue(this, r.queue);
        }, r;
      }, ge.fn.extend({
        fadeTo: function fadeTo(e, t, n, r) {
          return this.filter(Be).css("opacity", 0).show().end().animate({
            opacity: t
          }, e, n, r);
        },
        animate: function animate(e, t, n, r) {
          var o = ge.isEmptyObject(e),
              i = ge.speed(t, n, r),
              a = function a() {
            var t = K(this, ge.extend({}, e), i);
            (o || ge._data(this, "finish")) && t.stop(!0);
          };

          return a.finish = a, o || !1 === i.queue ? this.each(a) : this.queue(i.queue, a);
        },
        stop: function stop(e, t, n) {
          var r = function r(e) {
            var t = e.stop;
            delete e.stop, t(n);
          };

          return "string" != typeof e && (n = t, t = e, e = void 0), t && !1 !== e && this.queue(e || "fx", []), this.each(function () {
            var t = !0,
                o = null != e && e + "queueHooks",
                i = ge.timers,
                a = ge._data(this);

            if (o) a[o] && a[o].stop && r(a[o]);else for (o in a) {
              a[o] && a[o].stop && At.test(o) && r(a[o]);
            }

            for (o = i.length; o--;) {
              i[o].elem !== this || null != e && i[o].queue !== e || (i[o].anim.stop(n), t = !1, i.splice(o, 1));
            }

            !t && n || ge.dequeue(this, e);
          });
        },
        finish: function finish(e) {
          return !1 !== e && (e = e || "fx"), this.each(function () {
            var t,
                n = ge._data(this),
                r = n[e + "queue"],
                o = n[e + "queueHooks"],
                i = ge.timers,
                a = r ? r.length : 0;

            for (n.finish = !0, ge.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = i.length; t--;) {
              i[t].elem === this && i[t].queue === e && (i[t].anim.stop(!0), i.splice(t, 1));
            }

            for (t = 0; t < a; t++) {
              r[t] && r[t].finish && r[t].finish.call(this);
            }

            delete n.finish;
          });
        }
      }), ge.each(["toggle", "show", "hide"], function (e, t) {
        var n = ge.fn[t];

        ge.fn[t] = function (e, r, o) {
          return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(q(t, !0), e, r, o);
        };
      }), ge.each({
        slideDown: q("show"),
        slideUp: q("hide"),
        slideToggle: q("toggle"),
        fadeIn: {
          opacity: "show"
        },
        fadeOut: {
          opacity: "hide"
        },
        fadeToggle: {
          opacity: "toggle"
        }
      }, function (e, t) {
        ge.fn[e] = function (e, n, r) {
          return this.animate(t, e, n, r);
        };
      }), ge.timers = [], ge.fx.tick = function () {
        var e,
            t = ge.timers,
            n = 0;

        for (Tt = ge.now(); n < t.length; n++) {
          (e = t[n])() || t[n] !== e || t.splice(n--, 1);
        }

        t.length || ge.fx.stop(), Tt = void 0;
      }, ge.fx.timer = function (e) {
        ge.timers.push(e), e() ? ge.fx.start() : ge.timers.pop();
      }, ge.fx.interval = 13, ge.fx.start = function () {
        kt || (kt = n.setInterval(ge.fx.tick, ge.fx.interval));
      }, ge.fx.stop = function () {
        n.clearInterval(kt), kt = null;
      }, ge.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
      }, ge.fn.delay = function (e, t) {
        return e = ge.fx ? ge.fx.speeds[e] || e : e, t = t || "fx", this.queue(t, function (t, r) {
          var o = n.setTimeout(t, e);

          r.stop = function () {
            n.clearTimeout(o);
          };
        });
      }, function () {
        var e,
            t = se.createElement("input"),
            n = se.createElement("div"),
            r = se.createElement("select"),
            o = r.appendChild(se.createElement("option"));
        n = se.createElement("div"), n.setAttribute("className", "t"), n.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", e = n.getElementsByTagName("a")[0], t.setAttribute("type", "checkbox"), n.appendChild(t), e = n.getElementsByTagName("a")[0], e.style.cssText = "top:1px", me.getSetAttribute = "t" !== n.className, me.style = /top/.test(e.getAttribute("style")), me.hrefNormalized = "/a" === e.getAttribute("href"), me.checkOn = !!t.value, me.optSelected = o.selected, me.enctype = !!se.createElement("form").enctype, r.disabled = !0, me.optDisabled = !o.disabled, t = se.createElement("input"), t.setAttribute("value", ""), me.input = "" === t.getAttribute("value"), t.value = "t", t.setAttribute("type", "radio"), me.radioValue = "t" === t.value;
      }();
      var Nt = /\r/g,
          Pt = /[\x20\t\r\n\f]+/g;
      ge.fn.extend({
        val: function val(e) {
          var t,
              n,
              r,
              o = this[0];
          {
            if (arguments.length) return r = ge.isFunction(e), this.each(function (n) {
              var o;
              1 === this.nodeType && (o = r ? e.call(this, n, ge(this).val()) : e, null == o ? o = "" : "number" == typeof o ? o += "" : ge.isArray(o) && (o = ge.map(o, function (e) {
                return null == e ? "" : e + "";
              })), (t = ge.valHooks[this.type] || ge.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, o, "value") || (this.value = o));
            });
            if (o) return (t = ge.valHooks[o.type] || ge.valHooks[o.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(o, "value")) ? n : (n = o.value, "string" == typeof n ? n.replace(Nt, "") : null == n ? "" : n);
          }
        }
      }), ge.extend({
        valHooks: {
          option: {
            get: function get(e) {
              var t = ge.find.attr(e, "value");
              return null != t ? t : ge.trim(ge.text(e)).replace(Pt, " ");
            }
          },
          select: {
            get: function get(e) {
              for (var t, n, r = e.options, o = e.selectedIndex, i = "select-one" === e.type || o < 0, a = i ? null : [], s = i ? o + 1 : r.length, l = o < 0 ? s : i ? o : 0; l < s; l++) {
                if (n = r[l], (n.selected || l === o) && (me.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) && (!n.parentNode.disabled || !ge.nodeName(n.parentNode, "optgroup"))) {
                  if (t = ge(n).val(), i) return t;
                  a.push(t);
                }
              }

              return a;
            },
            set: function set(e, t) {
              for (var n, r, o = e.options, i = ge.makeArray(t), a = o.length; a--;) {
                if (r = o[a], ge.inArray(ge.valHooks.option.get(r), i) > -1) try {
                  r.selected = n = !0;
                } catch (e) {
                  r.scrollHeight;
                } else r.selected = !1;
              }

              return n || (e.selectedIndex = -1), o;
            }
          }
        }
      }), ge.each(["radio", "checkbox"], function () {
        ge.valHooks[this] = {
          set: function set(e, t) {
            if (ge.isArray(t)) return e.checked = ge.inArray(ge(e).val(), t) > -1;
          }
        }, me.checkOn || (ge.valHooks[this].get = function (e) {
          return null === e.getAttribute("value") ? "on" : e.value;
        });
      });
      var Rt,
          It,
          Mt = ge.expr.attrHandle,
          jt = /^(?:checked|selected)$/i,
          Lt = me.getSetAttribute,
          Dt = me.input;
      ge.fn.extend({
        attr: function attr(e, t) {
          return Ve(this, ge.attr, e, t, arguments.length > 1);
        },
        removeAttr: function removeAttr(e) {
          return this.each(function () {
            ge.removeAttr(this, e);
          });
        }
      }), ge.extend({
        attr: function attr(e, t, n) {
          var r,
              o,
              i = e.nodeType;
          if (3 !== i && 8 !== i && 2 !== i) return void 0 === e.getAttribute ? ge.prop(e, t, n) : (1 === i && ge.isXMLDoc(e) || (t = t.toLowerCase(), o = ge.attrHooks[t] || (ge.expr.match.bool.test(t) ? It : Rt)), void 0 !== n ? null === n ? void ge.removeAttr(e, t) : o && "set" in o && void 0 !== (r = o.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : o && "get" in o && null !== (r = o.get(e, t)) ? r : (r = ge.find.attr(e, t), null == r ? void 0 : r));
        },
        attrHooks: {
          type: {
            set: function set(e, t) {
              if (!me.radioValue && "radio" === t && ge.nodeName(e, "input")) {
                var n = e.value;
                return e.setAttribute("type", t), n && (e.value = n), t;
              }
            }
          }
        },
        removeAttr: function removeAttr(e, t) {
          var n,
              r,
              o = 0,
              i = t && t.match(Pe);
          if (i && 1 === e.nodeType) for (; n = i[o++];) {
            r = ge.propFix[n] || n, ge.expr.match.bool.test(n) ? Dt && Lt || !jt.test(n) ? e[r] = !1 : e[ge.camelCase("default-" + n)] = e[r] = !1 : ge.attr(e, n, ""), e.removeAttribute(Lt ? n : r);
          }
        }
      }), It = {
        set: function set(e, t, n) {
          return !1 === t ? ge.removeAttr(e, n) : Dt && Lt || !jt.test(n) ? e.setAttribute(!Lt && ge.propFix[n] || n, n) : e[ge.camelCase("default-" + n)] = e[n] = !0, n;
        }
      }, ge.each(ge.expr.match.bool.source.match(/\w+/g), function (e, t) {
        var n = Mt[t] || ge.find.attr;
        Dt && Lt || !jt.test(t) ? Mt[t] = function (e, t, r) {
          var o, i;
          return r || (i = Mt[t], Mt[t] = o, o = null != n(e, t, r) ? t.toLowerCase() : null, Mt[t] = i), o;
        } : Mt[t] = function (e, t, n) {
          if (!n) return e[ge.camelCase("default-" + t)] ? t.toLowerCase() : null;
        };
      }), Dt && Lt || (ge.attrHooks.value = {
        set: function set(e, t, n) {
          if (!ge.nodeName(e, "input")) return Rt && Rt.set(e, t, n);
          e.defaultValue = t;
        }
      }), Lt || (Rt = {
        set: function set(e, t, n) {
          var r = e.getAttributeNode(n);
          if (r || e.setAttributeNode(r = e.ownerDocument.createAttribute(n)), r.value = t += "", "value" === n || t === e.getAttribute(n)) return t;
        }
      }, Mt.id = Mt.name = Mt.coords = function (e, t, n) {
        var r;
        if (!n) return (r = e.getAttributeNode(t)) && "" !== r.value ? r.value : null;
      }, ge.valHooks.button = {
        get: function get(e, t) {
          var n = e.getAttributeNode(t);
          if (n && n.specified) return n.value;
        },
        set: Rt.set
      }, ge.attrHooks.contenteditable = {
        set: function set(e, t, n) {
          Rt.set(e, "" !== t && t, n);
        }
      }, ge.each(["width", "height"], function (e, t) {
        ge.attrHooks[t] = {
          set: function set(e, n) {
            if ("" === n) return e.setAttribute(t, "auto"), n;
          }
        };
      })), me.style || (ge.attrHooks.style = {
        get: function get(e) {
          return e.style.cssText || void 0;
        },
        set: function set(e, t) {
          return e.style.cssText = t + "";
        }
      });
      var Ft = /^(?:input|select|textarea|button|object)$/i,
          Ut = /^(?:a|area)$/i;
      ge.fn.extend({
        prop: function prop(e, t) {
          return Ve(this, ge.prop, e, t, arguments.length > 1);
        },
        removeProp: function removeProp(e) {
          return e = ge.propFix[e] || e, this.each(function () {
            try {
              this[e] = void 0, delete this[e];
            } catch (e) {}
          });
        }
      }), ge.extend({
        prop: function prop(e, t, n) {
          var r,
              o,
              i = e.nodeType;
          if (3 !== i && 8 !== i && 2 !== i) return 1 === i && ge.isXMLDoc(e) || (t = ge.propFix[t] || t, o = ge.propHooks[t]), void 0 !== n ? o && "set" in o && void 0 !== (r = o.set(e, n, t)) ? r : e[t] = n : o && "get" in o && null !== (r = o.get(e, t)) ? r : e[t];
        },
        propHooks: {
          tabIndex: {
            get: function get(e) {
              var t = ge.find.attr(e, "tabindex");
              return t ? parseInt(t, 10) : Ft.test(e.nodeName) || Ut.test(e.nodeName) && e.href ? 0 : -1;
            }
          }
        },
        propFix: {
          for: "htmlFor",
          class: "className"
        }
      }), me.hrefNormalized || ge.each(["href", "src"], function (e, t) {
        ge.propHooks[t] = {
          get: function get(e) {
            return e.getAttribute(t, 4);
          }
        };
      }), me.optSelected || (ge.propHooks.selected = {
        get: function get(e) {
          var t = e.parentNode;
          return t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex), null;
        },
        set: function set(e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        }
      }), ge.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
        ge.propFix[this.toLowerCase()] = this;
      }), me.enctype || (ge.propFix.enctype = "encoding");
      var Bt = /[\t\r\n\f]/g;
      ge.fn.extend({
        addClass: function addClass(e) {
          var t,
              n,
              r,
              o,
              i,
              a,
              s,
              l = 0;
          if (ge.isFunction(e)) return this.each(function (t) {
            ge(this).addClass(e.call(this, t, G(this)));
          });
          if ("string" == typeof e && e) for (t = e.match(Pe) || []; n = this[l++];) {
            if (o = G(n), r = 1 === n.nodeType && (" " + o + " ").replace(Bt, " ")) {
              for (a = 0; i = t[a++];) {
                r.indexOf(" " + i + " ") < 0 && (r += i + " ");
              }

              s = ge.trim(r), o !== s && ge.attr(n, "class", s);
            }
          }
          return this;
        },
        removeClass: function removeClass(e) {
          var t,
              n,
              r,
              o,
              i,
              a,
              s,
              l = 0;
          if (ge.isFunction(e)) return this.each(function (t) {
            ge(this).removeClass(e.call(this, t, G(this)));
          });
          if (!arguments.length) return this.attr("class", "");
          if ("string" == typeof e && e) for (t = e.match(Pe) || []; n = this[l++];) {
            if (o = G(n), r = 1 === n.nodeType && (" " + o + " ").replace(Bt, " ")) {
              for (a = 0; i = t[a++];) {
                for (; r.indexOf(" " + i + " ") > -1;) {
                  r = r.replace(" " + i + " ", " ");
                }
              }

              s = ge.trim(r), o !== s && ge.attr(n, "class", s);
            }
          }
          return this;
        },
        toggleClass: function toggleClass(e, t) {
          var n = typeof e;
          return "boolean" == typeof t && "string" === n ? t ? this.addClass(e) : this.removeClass(e) : ge.isFunction(e) ? this.each(function (n) {
            ge(this).toggleClass(e.call(this, n, G(this), t), t);
          }) : this.each(function () {
            var t, r, o, i;
            if ("string" === n) for (r = 0, o = ge(this), i = e.match(Pe) || []; t = i[r++];) {
              o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
            } else void 0 !== e && "boolean" !== n || (t = G(this), t && ge._data(this, "__className__", t), ge.attr(this, "class", t || !1 === e ? "" : ge._data(this, "__className__") || ""));
          });
        },
        hasClass: function hasClass(e) {
          var t,
              n,
              r = 0;

          for (t = " " + e + " "; n = this[r++];) {
            if (1 === n.nodeType && (" " + G(n) + " ").replace(Bt, " ").indexOf(t) > -1) return !0;
          }

          return !1;
        }
      }), ge.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (e, t) {
        ge.fn[t] = function (e, n) {
          return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
        };
      }), ge.fn.extend({
        hover: function hover(e, t) {
          return this.mouseenter(e).mouseleave(t || e);
        }
      });
      var Vt = n.location,
          Ht = ge.now(),
          qt = /\?/,
          Wt = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
      ge.parseJSON = function (e) {
        if (n.JSON && n.JSON.parse) return n.JSON.parse(e + "");
        var t,
            r = null,
            o = ge.trim(e + "");
        return o && !ge.trim(o.replace(Wt, function (e, n, o, i) {
          return t && n && (r = 0), 0 === r ? e : (t = o || n, r += !i - !o, "");
        })) ? Function("return " + o)() : ge.error("Invalid JSON: " + e);
      }, ge.parseXML = function (e) {
        var t, r;
        if (!e || "string" != typeof e) return null;

        try {
          n.DOMParser ? (r = new n.DOMParser(), t = r.parseFromString(e, "text/xml")) : (t = new n.ActiveXObject("Microsoft.XMLDOM"), t.async = "false", t.loadXML(e));
        } catch (e) {
          t = void 0;
        }

        return t && t.documentElement && !t.getElementsByTagName("parsererror").length || ge.error("Invalid XML: " + e), t;
      };
      var zt = /#.*$/,
          $t = /([?&])_=[^&]*/,
          Kt = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
          Gt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
          Yt = /^(?:GET|HEAD)$/,
          Jt = /^\/\//,
          Qt = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
          Xt = {},
          Zt = {},
          en = "*/".concat("*"),
          tn = Vt.href,
          nn = Qt.exec(tn.toLowerCase()) || [];
      ge.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
          url: tn,
          type: "GET",
          isLocal: Gt.test(nn[1]),
          global: !0,
          processData: !0,
          async: !0,
          contentType: "application/x-www-form-urlencoded; charset=UTF-8",
          accepts: {
            "*": en,
            text: "text/plain",
            html: "text/html",
            xml: "application/xml, text/xml",
            json: "application/json, text/javascript"
          },
          contents: {
            xml: /\bxml\b/,
            html: /\bhtml/,
            json: /\bjson\b/
          },
          responseFields: {
            xml: "responseXML",
            text: "responseText",
            json: "responseJSON"
          },
          converters: {
            "* text": String,
            "text html": !0,
            "text json": ge.parseJSON,
            "text xml": ge.parseXML
          },
          flatOptions: {
            url: !0,
            context: !0
          }
        },
        ajaxSetup: function ajaxSetup(e, t) {
          return t ? Q(Q(e, ge.ajaxSettings), t) : Q(ge.ajaxSettings, e);
        },
        ajaxPrefilter: Y(Xt),
        ajaxTransport: Y(Zt),
        ajax: function ajax(e, t) {
          function r(e, t, r, o) {
            var i,
                d,
                y,
                b,
                w,
                O = t;
            2 !== _ && (_ = 2, l && n.clearTimeout(l), c = void 0, s = o || "", E.readyState = e > 0 ? 4 : 0, i = e >= 200 && e < 300 || 304 === e, r && (b = X(f, E, r)), b = Z(f, b, E, i), i ? (f.ifModified && (w = E.getResponseHeader("Last-Modified"), w && (ge.lastModified[a] = w), (w = E.getResponseHeader("etag")) && (ge.etag[a] = w)), 204 === e || "HEAD" === f.type ? O = "nocontent" : 304 === e ? O = "notmodified" : (O = b.state, d = b.data, y = b.error, i = !y)) : (y = O, !e && O || (O = "error", e < 0 && (e = 0))), E.status = e, E.statusText = (t || O) + "", i ? m.resolveWith(p, [d, O, E]) : m.rejectWith(p, [E, O, y]), E.statusCode(v), v = void 0, u && h.trigger(i ? "ajaxSuccess" : "ajaxError", [E, f, i ? d : y]), g.fireWith(p, [E, O]), u && (h.trigger("ajaxComplete", [E, f]), --ge.active || ge.event.trigger("ajaxStop")));
          }

          "object" == typeof e && (t = e, e = void 0), t = t || {};
          var o,
              i,
              a,
              s,
              l,
              u,
              c,
              d,
              f = ge.ajaxSetup({}, t),
              p = f.context || f,
              h = f.context && (p.nodeType || p.jquery) ? ge(p) : ge.event,
              m = ge.Deferred(),
              g = ge.Callbacks("once memory"),
              v = f.statusCode || {},
              y = {},
              b = {},
              _ = 0,
              w = "canceled",
              E = {
            readyState: 0,
            getResponseHeader: function getResponseHeader(e) {
              var t;

              if (2 === _) {
                if (!d) for (d = {}; t = Kt.exec(s);) {
                  d[t[1].toLowerCase()] = t[2];
                }
                t = d[e.toLowerCase()];
              }

              return null == t ? null : t;
            },
            getAllResponseHeaders: function getAllResponseHeaders() {
              return 2 === _ ? s : null;
            },
            setRequestHeader: function setRequestHeader(e, t) {
              var n = e.toLowerCase();
              return _ || (e = b[n] = b[n] || e, y[e] = t), this;
            },
            overrideMimeType: function overrideMimeType(e) {
              return _ || (f.mimeType = e), this;
            },
            statusCode: function statusCode(e) {
              var t;
              if (e) if (_ < 2) for (t in e) {
                v[t] = [v[t], e[t]];
              } else E.always(e[E.status]);
              return this;
            },
            abort: function abort(e) {
              var t = e || w;
              return c && c.abort(t), r(0, t), this;
            }
          };
          if (m.promise(E).complete = g.add, E.success = E.done, E.error = E.fail, f.url = ((e || f.url || tn) + "").replace(zt, "").replace(Jt, nn[1] + "//"), f.type = t.method || t.type || f.method || f.type, f.dataTypes = ge.trim(f.dataType || "*").toLowerCase().match(Pe) || [""], null == f.crossDomain && (o = Qt.exec(f.url.toLowerCase()), f.crossDomain = !(!o || o[1] === nn[1] && o[2] === nn[2] && (o[3] || ("http:" === o[1] ? "80" : "443")) === (nn[3] || ("http:" === nn[1] ? "80" : "443")))), f.data && f.processData && "string" != typeof f.data && (f.data = ge.param(f.data, f.traditional)), J(Xt, f, t, E), 2 === _) return E;
          u = ge.event && f.global, u && 0 == ge.active++ && ge.event.trigger("ajaxStart"), f.type = f.type.toUpperCase(), f.hasContent = !Yt.test(f.type), a = f.url, f.hasContent || (f.data && (a = f.url += (qt.test(a) ? "&" : "?") + f.data, delete f.data), !1 === f.cache && (f.url = $t.test(a) ? a.replace($t, "$1_=" + Ht++) : a + (qt.test(a) ? "&" : "?") + "_=" + Ht++)), f.ifModified && (ge.lastModified[a] && E.setRequestHeader("If-Modified-Since", ge.lastModified[a]), ge.etag[a] && E.setRequestHeader("If-None-Match", ge.etag[a])), (f.data && f.hasContent && !1 !== f.contentType || t.contentType) && E.setRequestHeader("Content-Type", f.contentType), E.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + en + "; q=0.01" : "") : f.accepts["*"]);

          for (i in f.headers) {
            E.setRequestHeader(i, f.headers[i]);
          }

          if (f.beforeSend && (!1 === f.beforeSend.call(p, E, f) || 2 === _)) return E.abort();
          w = "abort";

          for (i in {
            success: 1,
            error: 1,
            complete: 1
          }) {
            E[i](f[i]);
          }

          if (c = J(Zt, f, t, E)) {
            if (E.readyState = 1, u && h.trigger("ajaxSend", [E, f]), 2 === _) return E;
            f.async && f.timeout > 0 && (l = n.setTimeout(function () {
              E.abort("timeout");
            }, f.timeout));

            try {
              _ = 1, c.send(y, r);
            } catch (e) {
              if (!(_ < 2)) throw e;
              r(-1, e);
            }
          } else r(-1, "No Transport");

          return E;
        },
        getJSON: function getJSON(e, t, n) {
          return ge.get(e, t, n, "json");
        },
        getScript: function getScript(e, t) {
          return ge.get(e, void 0, t, "script");
        }
      }), ge.each(["get", "post"], function (e, t) {
        ge[t] = function (e, n, r, o) {
          return ge.isFunction(n) && (o = o || r, r = n, n = void 0), ge.ajax(ge.extend({
            url: e,
            type: t,
            dataType: o,
            data: n,
            success: r
          }, ge.isPlainObject(e) && e));
        };
      }), ge._evalUrl = function (e) {
        return ge.ajax({
          url: e,
          type: "GET",
          dataType: "script",
          cache: !0,
          async: !1,
          global: !1,
          throws: !0
        });
      }, ge.fn.extend({
        wrapAll: function wrapAll(e) {
          if (ge.isFunction(e)) return this.each(function (t) {
            ge(this).wrapAll(e.call(this, t));
          });

          if (this[0]) {
            var t = ge(e, this[0].ownerDocument).eq(0).clone(!0);
            this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
              for (var e = this; e.firstChild && 1 === e.firstChild.nodeType;) {
                e = e.firstChild;
              }

              return e;
            }).append(this);
          }

          return this;
        },
        wrapInner: function wrapInner(e) {
          return ge.isFunction(e) ? this.each(function (t) {
            ge(this).wrapInner(e.call(this, t));
          }) : this.each(function () {
            var t = ge(this),
                n = t.contents();
            n.length ? n.wrapAll(e) : t.append(e);
          });
        },
        wrap: function wrap(e) {
          var t = ge.isFunction(e);
          return this.each(function (n) {
            ge(this).wrapAll(t ? e.call(this, n) : e);
          });
        },
        unwrap: function unwrap() {
          return this.parent().each(function () {
            ge.nodeName(this, "body") || ge(this).replaceWith(this.childNodes);
          }).end();
        }
      }), ge.expr.filters.hidden = function (e) {
        return me.reliableHiddenOffsets() ? e.offsetWidth <= 0 && e.offsetHeight <= 0 && !e.getClientRects().length : te(e);
      }, ge.expr.filters.visible = function (e) {
        return !ge.expr.filters.hidden(e);
      };
      var rn = /%20/g,
          on = /\[\]$/,
          an = /\r?\n/g,
          sn = /^(?:submit|button|image|reset|file)$/i,
          ln = /^(?:input|select|textarea|keygen)/i;
      ge.param = function (e, t) {
        var n,
            r = [],
            o = function o(e, t) {
          t = ge.isFunction(t) ? t() : null == t ? "" : t, r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t);
        };

        if (void 0 === t && (t = ge.ajaxSettings && ge.ajaxSettings.traditional), ge.isArray(e) || e.jquery && !ge.isPlainObject(e)) ge.each(e, function () {
          o(this.name, this.value);
        });else for (n in e) {
          ne(n, e[n], t, o);
        }
        return r.join("&").replace(rn, "+");
      }, ge.fn.extend({
        serialize: function serialize() {
          return ge.param(this.serializeArray());
        },
        serializeArray: function serializeArray() {
          return this.map(function () {
            var e = ge.prop(this, "elements");
            return e ? ge.makeArray(e) : this;
          }).filter(function () {
            var e = this.type;
            return this.name && !ge(this).is(":disabled") && ln.test(this.nodeName) && !sn.test(e) && (this.checked || !He.test(e));
          }).map(function (e, t) {
            var n = ge(this).val();
            return null == n ? null : ge.isArray(n) ? ge.map(n, function (e) {
              return {
                name: t.name,
                value: e.replace(an, "\r\n")
              };
            }) : {
              name: t.name,
              value: n.replace(an, "\r\n")
            };
          }).get();
        }
      }), ge.ajaxSettings.xhr = void 0 !== n.ActiveXObject ? function () {
        return this.isLocal ? oe() : se.documentMode > 8 ? re() : /^(get|post|head|put|delete|options)$/i.test(this.type) && re() || oe();
      } : re;
      var un = 0,
          cn = {},
          dn = ge.ajaxSettings.xhr();
      n.attachEvent && n.attachEvent("onunload", function () {
        for (var e in cn) {
          cn[e](void 0, !0);
        }
      }), me.cors = !!dn && "withCredentials" in dn, dn = me.ajax = !!dn, dn && ge.ajaxTransport(function (e) {
        if (!e.crossDomain || me.cors) {
          var _t4;

          return {
            send: function send(r, o) {
              var i,
                  a = e.xhr(),
                  s = ++un;
              if (a.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields) for (i in e.xhrFields) {
                a[i] = e.xhrFields[i];
              }
              e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType), e.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest");

              for (i in r) {
                void 0 !== r[i] && a.setRequestHeader(i, r[i] + "");
              }

              a.send(e.hasContent && e.data || null), _t4 = function t(n, r) {
                var i, l, u;
                if (_t4 && (r || 4 === a.readyState)) if (delete cn[s], _t4 = void 0, a.onreadystatechange = ge.noop, r) 4 !== a.readyState && a.abort();else {
                  u = {}, i = a.status, "string" == typeof a.responseText && (u.text = a.responseText);

                  try {
                    l = a.statusText;
                  } catch (e) {
                    l = "";
                  }

                  i || !e.isLocal || e.crossDomain ? 1223 === i && (i = 204) : i = u.text ? 200 : 404;
                }
                u && o(i, l, u, a.getAllResponseHeaders());
              }, e.async ? 4 === a.readyState ? n.setTimeout(_t4) : a.onreadystatechange = cn[s] = _t4 : _t4();
            },
            abort: function abort() {
              _t4 && _t4(void 0, !0);
            }
          };
        }
      }), ge.ajaxPrefilter(function (e) {
        e.crossDomain && (e.contents.script = !1);
      }), ge.ajaxSetup({
        accepts: {
          script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
          script: /\b(?:java|ecma)script\b/
        },
        converters: {
          "text script": function textScript(e) {
            return ge.globalEval(e), e;
          }
        }
      }), ge.ajaxPrefilter("script", function (e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET", e.global = !1);
      }), ge.ajaxTransport("script", function (e) {
        if (e.crossDomain) {
          var t,
              n = se.head || ge("head")[0] || se.documentElement;
          return {
            send: function send(r, o) {
              t = se.createElement("script"), t.async = !0, e.scriptCharset && (t.charset = e.scriptCharset), t.src = e.url, t.onload = t.onreadystatechange = function (e, n) {
                (n || !t.readyState || /loaded|complete/.test(t.readyState)) && (t.onload = t.onreadystatechange = null, t.parentNode && t.parentNode.removeChild(t), t = null, n || o(200, "success"));
              }, n.insertBefore(t, n.firstChild);
            },
            abort: function abort() {
              t && t.onload(void 0, !0);
            }
          };
        }
      });
      var fn = [],
          pn = /(=)\?(?=&|$)|\?\?/;
      ge.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
          var e = fn.pop() || ge.expando + "_" + Ht++;
          return this[e] = !0, e;
        }
      }), ge.ajaxPrefilter("json jsonp", function (e, t, r) {
        var o,
            i,
            a,
            s = !1 !== e.jsonp && (pn.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && pn.test(e.data) && "data");
        if (s || "jsonp" === e.dataTypes[0]) return o = e.jsonpCallback = ge.isFunction(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, s ? e[s] = e[s].replace(pn, "$1" + o) : !1 !== e.jsonp && (e.url += (qt.test(e.url) ? "&" : "?") + e.jsonp + "=" + o), e.converters["script json"] = function () {
          return a || ge.error(o + " was not called"), a[0];
        }, e.dataTypes[0] = "json", i = n[o], n[o] = function () {
          a = arguments;
        }, r.always(function () {
          void 0 === i ? ge(n).removeProp(o) : n[o] = i, e[o] && (e.jsonpCallback = t.jsonpCallback, fn.push(o)), a && ge.isFunction(i) && i(a[0]), a = i = void 0;
        }), "script";
      }), ge.parseHTML = function (e, t, n) {
        if (!e || "string" != typeof e) return null;
        "boolean" == typeof t && (n = t, t = !1), t = t || se;
        var r = xe.exec(e),
            o = !n && [];
        return r ? [t.createElement(r[1])] : (r = w([e], t, o), o && o.length && ge(o).remove(), ge.merge([], r.childNodes));
      };
      var hn = ge.fn.load;
      ge.fn.load = function (e, t, n) {
        if ("string" != typeof e && hn) return hn.apply(this, arguments);
        var r,
            o,
            i,
            a = this,
            s = e.indexOf(" ");
        return s > -1 && (r = ge.trim(e.slice(s, e.length)), e = e.slice(0, s)), ge.isFunction(t) ? (n = t, t = void 0) : t && "object" == typeof t && (o = "POST"), a.length > 0 && ge.ajax({
          url: e,
          type: o || "GET",
          dataType: "html",
          data: t
        }).done(function (e) {
          i = arguments, a.html(r ? ge("<div>").append(ge.parseHTML(e)).find(r) : e);
        }).always(n && function (e, t) {
          a.each(function () {
            n.apply(this, i || [e.responseText, t, e]);
          });
        }), this;
      }, ge.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
        ge.fn[t] = function (e) {
          return this.on(t, e);
        };
      }), ge.expr.filters.animated = function (e) {
        return ge.grep(ge.timers, function (t) {
          return e === t.elem;
        }).length;
      }, ge.offset = {
        setOffset: function setOffset(e, t, n) {
          var r,
              o,
              i,
              a,
              s,
              l,
              u,
              c = ge.css(e, "position"),
              d = ge(e),
              f = {};
          "static" === c && (e.style.position = "relative"), s = d.offset(), i = ge.css(e, "top"), l = ge.css(e, "left"), u = ("absolute" === c || "fixed" === c) && ge.inArray("auto", [i, l]) > -1, u ? (r = d.position(), a = r.top, o = r.left) : (a = parseFloat(i) || 0, o = parseFloat(l) || 0), ge.isFunction(t) && (t = t.call(e, n, ge.extend({}, s))), null != t.top && (f.top = t.top - s.top + a), null != t.left && (f.left = t.left - s.left + o), "using" in t ? t.using.call(e, f) : d.css(f);
        }
      }, ge.fn.extend({
        offset: function offset(e) {
          if (arguments.length) return void 0 === e ? this : this.each(function (t) {
            ge.offset.setOffset(this, e, t);
          });
          var t,
              n,
              r = {
            top: 0,
            left: 0
          },
              o = this[0],
              i = o && o.ownerDocument;
          if (i) return t = i.documentElement, ge.contains(t, o) ? (void 0 !== o.getBoundingClientRect && (r = o.getBoundingClientRect()), n = ie(i), {
            top: r.top + (n.pageYOffset || t.scrollTop) - (t.clientTop || 0),
            left: r.left + (n.pageXOffset || t.scrollLeft) - (t.clientLeft || 0)
          }) : r;
        },
        position: function position() {
          if (this[0]) {
            var e,
                t,
                n = {
              top: 0,
              left: 0
            },
                r = this[0];
            return "fixed" === ge.css(r, "position") ? t = r.getBoundingClientRect() : (e = this.offsetParent(), t = this.offset(), ge.nodeName(e[0], "html") || (n = e.offset()), n.top += ge.css(e[0], "borderTopWidth", !0), n.left += ge.css(e[0], "borderLeftWidth", !0)), {
              top: t.top - n.top - ge.css(r, "marginTop", !0),
              left: t.left - n.left - ge.css(r, "marginLeft", !0)
            };
          }
        },
        offsetParent: function offsetParent() {
          return this.map(function () {
            for (var e = this.offsetParent; e && !ge.nodeName(e, "html") && "static" === ge.css(e, "position");) {
              e = e.offsetParent;
            }

            return e || ht;
          });
        }
      }), ge.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
      }, function (e, t) {
        var n = /Y/.test(t);

        ge.fn[e] = function (r) {
          return Ve(this, function (e, r, o) {
            var i = ie(e);
            if (void 0 === o) return i ? t in i ? i[t] : i.document.documentElement[r] : e[r];
            i ? i.scrollTo(n ? ge(i).scrollLeft() : o, n ? o : ge(i).scrollTop()) : e[r] = o;
          }, e, r, arguments.length, null);
        };
      }), ge.each(["top", "left"], function (e, t) {
        ge.cssHooks[t] = j(me.pixelPosition, function (e, n) {
          if (n) return n = gt(e, t), ft.test(n) ? ge(e).position()[t] + "px" : n;
        });
      }), ge.each({
        Height: "height",
        Width: "width"
      }, function (e, t) {
        ge.each({
          padding: "inner" + e,
          content: t,
          "": "outer" + e
        }, function (n, r) {
          ge.fn[r] = function (r, o) {
            var i = arguments.length && (n || "boolean" != typeof r),
                a = n || (!0 === r || !0 === o ? "margin" : "border");
            return Ve(this, function (t, n, r) {
              var o;
              return ge.isWindow(t) ? t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === r ? ge.css(t, n, a) : ge.style(t, n, r, a);
            }, t, i ? r : void 0, i, null);
          };
        });
      }), ge.fn.extend({
        bind: function bind(e, t, n) {
          return this.on(e, null, t, n);
        },
        unbind: function unbind(e, t) {
          return this.off(e, null, t);
        },
        delegate: function delegate(e, t, n, r) {
          return this.on(t, e, n, r);
        },
        undelegate: function undelegate(e, t, n) {
          return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
        }
      }), ge.fn.size = function () {
        return this.length;
      }, ge.fn.andSelf = ge.fn.addBack, r = [], void 0 !== (o = function () {
        return ge;
      }.apply(t, r)) && (e.exports = o);
      var mn = n.jQuery,
          gn = n.$;
      return ge.noConflict = function (e) {
        return n.$ === ge && (n.$ = gn), e && n.jQuery === ge && (n.jQuery = mn), ge;
      }, i && !n.__OKTA_EXPORT_JQUERY__ || (n.jQuery = n.$ = ge), ge;
    });
  }, function (e, t) {
    e.exports = {
      version: "5.7.3",
      supportedLanguages: ["en", "cs", "da", "de", "el", "es", "fi", "fr", "hu", "id", "in", "it", "ja", "ko", "ms", "nb", "nl-NL", "ok-PL", "pl", "pt-BR", "ro", "ru", "sv", "th", "tr", "uk", "vi", "zh-CN", "zh-TW"]
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(5)),
        a = r(n(24)),
        s = r(n(12)),
        l = {},
        u = ["responseType", "scopes", "state", "nonce", "idp", "idpScope", "display", "prompt", "maxAge", "loginHint"];
    l.AUTH_PARAMS = u, l.getTokens = function (e, t, n) {
      function r(t) {
        e.callGlobalSuccess(i.default.SUCCESS, t);
      }

      function l(t) {
        var r = !1,
            i = t;
        "access_denied" === t.errorCode && (r = !0);
        "login_required" === t.errorCode && "The client specified not to prompt, but the client app requires re-authentication or MFA." === t.errorSummary && (r = !0, i = {
          errorSummary: (0, o.loc)("error.mfa.required", "login")
        }), r && (n.model.trigger("error", n.model, {
          responseJSON: i
        }), n.model.appState.trigger("removeLoading")), s.default.triggerAfterError(n, new a.default.OAuthError(t.message), e);
      }

      var c = e.getAuthClient(),
          d = c.isAuthorizationCodeFlow() && !c.isPKCE(),
          f = e.toJSON({
        verbose: !0
      }),
          p = {};
      o._.extend(p, o._.pick(f, "clientId", "redirectUri"), o._.pick(f.authParams, u), t), p.popupTitle = (0, o.loc)("socialauth.popup.title", "login"), p.timeout = f.oAuthTimeout, "always" === f.redirect || d ? c.token.getWithRedirect(p).catch(l) : p.sessionToken ? c.token.getWithoutPrompt(p).then(r).catch(l) : c.token.getWithPopup(p).then(r).catch(l);
    };
    var c = l;
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r,
        o,
        i,
        a = n(0);
    a(n(10));
    /**
    * Duo Web SDK v2
    * Copyright 2019, Duo Security
    */

    !function (n, a) {
      o = [], r = a, void 0 !== (i = "function" == typeof r ? r.apply(t, o) : r) && (e.exports = i);
    }(0, function () {
      function e() {
        S = "", x = "sig_response", T = void 0, k = void 0, C = void 0, A = void 0, N = void 0, P = void 0;
      }

      function t(e, t) {
        var n = t || "https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe";
        throw new Error("Duo Web SDK error: " + e + (n ? "\nSee " + n + " for more information" : ""));
      }

      function n(e) {
        return e.replace(/([a-z])([A-Z])/, "$1-$2").toLowerCase();
      }

      function r(e, t) {
        return "dataset" in e ? e.dataset[t] : e.getAttribute("data-" + n(t));
      }

      function o(e, t, n, r) {
        "addEventListener" in window ? e.addEventListener(t, r, !1) : e.attachEvent(n, r);
      }

      function i(e, t, n, r) {
        "removeEventListener" in window ? e.removeEventListener(t, r, !1) : e.detachEvent(n, r);
      }

      function a(e) {
        o(document, "DOMContentLoaded", "onreadystatechange", e);
      }

      function s(e) {
        i(document, "DOMContentLoaded", "onreadystatechange", e);
      }

      function l(e) {
        o(window, "message", "onmessage", e);
      }

      function u(e) {
        i(window, "message", "onmessage", e);
      }

      function c(e) {
        if (e) {
          0 === e.indexOf("ERR|") && t(e.split("|")[1]), -1 !== e.indexOf(":") && 2 === e.split(":").length || t("Duo was given a bad token.  This might indicate a configuration problem with one of Duo's client libraries.");
          var n = e.split(":");
          return k = e, C = n[0], A = n[1], {
            sigRequest: e,
            duoSig: n[0],
            appSig: n[1]
          };
        }
      }

      function d(e) {
        return Boolean(e.origin === "https://" + T && "string" == typeof e.data && (e.data.match(R) || e.data.match(I) || e.data.match(M)));
      }

      function f(t) {
        e(), t && (t.host && (T = t.host), t.sig_request && c(t.sig_request), t.post_action && (S = t.post_action), t.post_argument && (x = t.post_argument), "function" == typeof t.submit_callback && (P = t.submit_callback));
        var n = p(t);
        n ? E(n, t.iframeAttributes || {}) : w(t), s(f);
      }

      function p(e) {
        var n;
        return e.iframe && e.iframeContainer ? t("Passing both `iframe` and `iframeContainer` arguments at the same time is not allowed.") : e.iframe ? (n = h(e.iframe), g(n)) : e.iframeContainer ? (n = h(e.iframeContainer), v(n)) : n = document.getElementById("duo_iframe"), n;
      }

      function h(e) {
        return e.tagName ? e : "string" == typeof e ? document.getElementById(e) : null;
      }

      function m(e) {
        return e && e.tagName && "iframe" === e.tagName.toLowerCase();
      }

      function g(e) {
        e && !m(e) && t("`iframe` only accepts an iframe element or the id of an iframe. To use a non-iframe element, use the `iframeContainer` argument.");
      }

      function v(e) {
        e && m(e) && t("`iframeContainer` only accepts a non-iframe element or the id of a non-iframe. To use a non-iframe element, use the `iframeContainer` argument on Duo.init().");
      }

      function y() {
        return ["https://", T, "/frame/web/v1/auth?tx=", C, "&parent=", encodeURIComponent(document.location.href), "&v=2.8"].join("");
      }

      function b(e) {
        if (d(e)) if (e.data.match(M)) {
          var t = e.data.substring("DUO_OPEN_WINDOW|".length);
          _(t) && window.open(t, "_self");
        } else O(e.data), u(b);
      }

      function _(e) {
        if (!e) return !1;
        var t = document.createElement("a");
        if (t.href = e, "duotrustedendpoints:" === t.protocol) return !0;
        if ("https:" !== t.protocol) return !1;

        for (var n = 0; n < j.length; n++) {
          if (t.hostname.endsWith("." + j[n]) || t.hostname === j[n]) return !0;
        }

        return !1;
      }

      function w(e) {
        a(function n() {
          var r = p(e);
          r || t('This page does not contain an iframe for Duo to use. Add an element like <iframe id="duo_iframe"></iframe> to this page.'), E(r, e.iframeAttributes || {}), s(n);
        });
      }

      function E(e, n) {
        if (T || (T = r(e, "host")) || t("No API hostname is given for Duo to use.  Be sure to pass a `host` parameter to Duo.init, or through the `data-host` attribute on the iframe element."), C && A || (c(r(e, "sigRequest")), C && A || t("No valid signed request is given.  Be sure to give the `sig_request` parameter to Duo.init, or use the `data-sig-request` attribute on the iframe element.")), "" === S && (S = r(e, "postAction") || S), "sig_response" === x && (x = r(e, "postArgument") || x), m(e)) N = e, N.src = y();else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          N = document.createElement("iframe"), n.src = y();

          for (var o in n) {
            N.setAttribute(o, n[o]);
          }

          e.appendChild(N);
        }
        l(b);
      }

      function O(e) {
        S(e + ":" + A);
      }

      var S,
          x,
          T,
          k,
          C,
          A,
          N,
          P,
          R = /^(?:AUTH|ENROLL)+\|[A-Za-z0-9\+\/=]+\|[A-Za-z0-9\+\/=]+$/,
          I = /^ERR\|[\w\s\.\(\)]+$/,
          M = /^DUO_OPEN_WINDOW\|/,
          j = ["duo.com", "duosecurity.com", "duomobile.s3-us-west-1.amazonaws.com"];
      return e(), {
        init: f,
        _onReady: a,
        _parseSigRequest: c,
        _isDuoMessage: d,
        _doPostBack: O
      };
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = {};
    o.getU2fEnrollErrorMessageKeyByCode = function (e) {
      switch (e) {
        default:
        case 1:
          return "u2f.error.other";

        case 2:
        case 3:
          return "u2f.error.badRequest";

        case 4:
          return "u2f.error.unsupported";

        case 5:
          return "u2f.error.timeout";
      }
    }, o.getU2fVerifyErrorMessageKeyByCode = function (e, t) {
      switch (e) {
        case 1:
          return t ? "u2f.error.other.oneFactor" : "u2f.error.other";

        case 2:
        case 3:
          return t ? "u2f.error.badRequest.oneFactor" : "u2f.error.badRequest";

        case 4:
          return t ? "u2f.error.unsupported.oneFactor" : "u2f.error.unsupported";

        case 5:
          return "u2f.error.timeout";
      }
    }, o.getU2fEnrollErrorMessageByCode = function (e) {
      return (0, r.loc)(o.getU2fEnrollErrorMessageKeyByCode(e), "login");
    }, o.getU2fVerifyErrorMessageByCode = function (e, t) {
      return (0, r.loc)(o.getU2fVerifyErrorMessageKeyByCode(e, t), "login");
    }, o.getU2fVersion = function () {
      return "U2F_V2";
    }, o.isU2fAvailable = function () {
      return Object.prototype.hasOwnProperty.call(window, "u2f");
    };
    var i = o;
    t.default = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(270)),
        a = r(n(5)),
        s = r(n(93)),
        l = r(n(12)),
        u = s.default.extend({
      props: function props() {
        var e = i.default.getCookieUsername(),
            t = this.getUsernameAndRemember(e),
            n = {
          username: {
            type: "string",
            validate: function validate(e) {
              if (o._.isEmpty(e)) return (0, o.loc)("error.username.required", "login");
            },
            value: t.username
          },
          lastUsername: ["string", !1, e],
          context: ["object", !1],
          remember: ["boolean", !0, t.remember],
          multiOptionalFactorEnroll: ["boolean", !0]
        };
        return this.settings && this.settings.get("features.passwordlessAuth") || (n.password = {
          type: "string",
          validate: function validate(e) {
            if (o._.isEmpty(e)) return (0, o.loc)("error.password.required", "login");
          }
        }), n;
      },
      getUsernameAndRemember: function getUsernameAndRemember(e) {
        var t,
            n = this.settings && this.settings.get("username"),
            r = this.settings && this.settings.get("features.rememberMe"),
            o = !1;
        return n ? (t = n, o = r && t === e) : r && e && (t = e, o = !0), {
          username: t,
          remember: o
        };
      },
      constructor: function constructor(e) {
        this.settings = e && e.settings, this.appState = e && e.appState, o.Model.apply(this, arguments), this.listenTo(this, "change:username", function (e, t) {
          this.set({
            remember: t === this.get("lastUsername")
          });
        });
      },
      parse: function parse(e) {
        return o._.omit(e, ["settings", "appState"]);
      },
      save: function save() {
        var e = this,
            t = this.settings.transformUsername(this.get("username"), a.default.PRIMARY_AUTH),
            n = this.get("remember"),
            r = this.get("lastUsername");
        this.setUsernameCookie(t, n, r), this.trigger("save"), this.appState.trigger("loading", !0);
        var s,
            l = this.getSignInArgs(t);

        if (this.appState.get("isUnauthenticated")) {
          var u = this.appState.settings.authClient;
          s = this.appState.get("isIdxStateToken") ? this.doTransaction(function (e) {
            return this.doPrimaryAuth(u, l, e.login);
          }) : this.doTransaction(function (e) {
            return this.doPrimaryAuth(u, l, e.authenticate);
          });
        } else s = this.startTransaction(function (e) {
          return this.doPrimaryAuth(e, l, o._.bind(e.signInWithCredentials, e));
        });

        return s.catch(function () {
          e.appState.trigger("removeLoading"), i.default.removeUsernameCookie();
        }).finally(function () {
          e.appState.trigger("loading", !1);
        });
      },
      getSignInArgs: function getSignInArgs(e) {
        var t = this.get("multiOptionalFactorEnroll"),
            n = {};
        return this.settings.get("features.passwordlessAuth") || (n.password = this.get("password")), this.appState.get("isIdxStateToken") ? n.identifier = e : (n.username = e, n.options = {
          warnBeforePasswordExpired: !0,
          multiOptionalFactorEnroll: t
        }), n;
      },
      setUsernameCookie: function setUsernameCookie(e, t, n) {
        this.settings.get("features.rememberMe") && (t || n !== e ? t && i.default.setUsernameCookie(e) : i.default.removeUsernameCookie());
      },
      doPrimaryAuth: function doPrimaryAuth(e, t, n) {
        var r = this.settings.get("features.deviceFingerprinting"),
            o = this.settings.get("features.trackTypingPattern");
        r && this.appState.get("deviceFingerprint") && (e.options.headers["X-Device-Fingerprint"] = this.appState.get("deviceFingerprint")), o && this.appState.get("typingPattern") && (e.options.headers["X-Typing-Pattern"] = this.appState.get("typingPattern")), e.options.headers = l.default.removeNils(e.options.headers);
        var i = this;
        return n(t).finally(function () {
          r && (delete e.options.headers["X-Device-Fingerprint"], i.appState.unset("deviceFingerprint")), o && (delete e.options.headers["X-Typing-Pattern"], i.appState.unset("typingPattern"));
        });
      }
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var r = function r() {
      sessionStorage.removeItem("osw-oie-state-handle"), sessionStorage.removeItem("osw-oie-last-initiated-login-url");
    },
        o = function o(e) {
      sessionStorage.setItem("osw-oie-state-handle", e), sessionStorage.setItem("osw-oie-last-initiated-login-url", window.location.href);
    },
        i = function i() {
      return sessionStorage.getItem("osw-oie-state-handle");
    },
        a = function a() {
      return sessionStorage.getItem("osw-oie-last-initiated-login-url");
    },
        s = {
      removeStateHandle: r,
      setStateHandle: o,
      getStateHandle: i,
      getLastInitiatedLoginUrl: a
    };

    t.default = s;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return o.apply(this, arguments);
    }

    function o() {
      return o = (0, f.default)(d.default.mark(function e(t) {
        var n;
        return d.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = t.getAuthClient(), e.abrupt("return", n.token.prepareTokenParams());

              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), o.apply(this, arguments);
    }

    function i(e) {
      return a.apply(this, arguments);
    }

    function a() {
      return a = (0, f.default)(d.default.mark(function e(t) {
        var n, o, i, a, s, l;
        return d.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (n = t.getAuthClient(), !n.transactionManager.exists()) {
                  e.next = 6;
                  break;
                }

                if (o = n.transactionManager.load(), !u(t, o)) {
                  e.next = 5;
                  break;
                }

                return e.abrupt("return", o);

              case 5:
                p.default.warn("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.");

              case 6:
                return i = t.get("interactionHandle"), a = t.get("codeChallenge"), s = t.get("codeChallengeMethod"), e.next = 11, r(t);

              case 11:
                return l = e.sent, i && (l.interactionHandle = i), a && (l.codeChallenge = a), s && (l.codeChallengeMethod = s), e.abrupt("return", l);

              case 16:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), a.apply(this, arguments);
    }

    function s(e, t) {
      e.getAuthClient().transactionManager.save(t);
    }

    function l(e) {
      e.getAuthClient().transactionManager.clear();
    }

    function u(e, t) {
      var n = ["clientId", "redirectUri"],
          r = e.getAuthClient();
      if (n.find(function (e) {
        return r.options[e] !== t[e];
      })) return !1;
      var o = e.get("interactionHandle");
      if (o && t.interactionHandle !== o) return !1;
      var i = e.get("codeChallenge");
      if (i && t.codeChallenge !== i) return !1;
      var a = e.get("codeChallengeMethod");
      return !a || t.codeChallengeMethod === a;
    }

    var c = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createTransactionMeta = r, t.getTransactionMeta = i, t.saveTransactionMeta = s, t.clearTransactionMeta = l, t.isTransactionMetaValid = u;
    var d = c(n(57)),
        f = c(n(58)),
        p = c(n(38));
  }, function (e, t, n) {
    "use strict";

    var r = n(34),
        o = n(40);
    r(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = o(n(80)),
        a = o(n(588)),
        s = o(n(96)),
        l = o(n(604));
    n(611), n(319);

    var u = o(n(86)),
        c = o(n(646)),
        d = o(n(676)),
        f = o(n(725)),
        p = n(132),
        h = function () {
      function e(e) {
        return t.apply(this, arguments);
      }

      var t = (0, u.default)(i.default.mark(function e(t) {
        var n, r, o, u, p, h, m, g, v, y, b, _, w, E, O, S, x, T, k, C, A, N;

        return i.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (o = t.clientId, u = t.domain, p = t.issuer, h = t.stateHandle, m = t.interactionHandle, g = t.version, v = t.redirectUri, y = t.state, b = t.scopes, _ = t.codeChallenge, w = t.codeChallengeMethod, p = null === (n = p) || void 0 === n ? void 0 : n.replace(/\/+$/, ""), E = (null === (r = p) || void 0 === r ? void 0 : (0, a.default)(r).call(r, "/oauth2")) > 0 ? p : p + "/oauth2", O = {
                  baseUrl: E,
                  clientId: o,
                  state: y
                }, u || p) {
                  e.next = 6;
                  break;
                }

                return e.abrupt("return", s.default.reject({
                  error: "issuer is required"
                }));

              case 6:
                if (h || o) {
                  e.next = 8;
                  break;
                }

                return e.abrupt("return", s.default.reject({
                  error: "clientId is required"
                }));

              case 8:
                if (h || v) {
                  e.next = 10;
                  break;
                }

                return e.abrupt("return", s.default.reject({
                  error: "redirectUri is required"
                }));

              case 10:
                if (h || _ && w) {
                  e.next = 12;
                  break;
                }

                return e.abrupt("return", s.default.reject({
                  error: "PKCE params (codeChallenge, codeChallengeMethod) are required"
                }));

              case 12:
                if (u || (u = new l.default(p).origin), g) {
                  e.next = 15;
                  break;
                }

                return e.abrupt("return", s.default.reject({
                  error: "version is required"
                }));

              case 15:
                if ((S = (null !== g && void 0 !== g ? g : "").replace(/[^0-9a-zA-Z._-]/, "")) === g && g) {
                  e.next = 18;
                  break;
                }

                return e.abrupt("return", s.default.reject({
                  error: "invalid version supplied - version is required and uses semver syntax"
                }));

              case 18:
                if (h || m) {
                  e.next = 31;
                  break;
                }

                return e.prev = 19, x = {
                  clientId: o,
                  baseUrl: E,
                  scopes: b,
                  redirectUri: v,
                  codeChallenge: _,
                  codeChallengeMethod: w,
                  state: y
                }, e.next = 23, (0, d.default)(x);

              case 23:
                T = e.sent, m = T, O.interactionHandle = m, e.next = 31;
                break;

              case 28:
                return e.prev = 28, e.t0 = e.catch(19), e.abrupt("return", s.default.reject({
                  error: e.t0
                }));

              case 31:
                return e.prev = 31, k = (0, f.default)(g), C = k.makeIdxState, e.next = 35, (0, c.default)({
                  domain: u,
                  interactionHandle: m,
                  stateHandle: h,
                  version: g
                }).catch(function (e) {
                  return s.default.reject({
                    error: "introspect call failed",
                    details: C(e, O)
                  });
                });

              case 35:
                return A = e.sent, N = C(A, O), e.abrupt("return", N);

              case 40:
                return e.prev = 40, e.t1 = e.catch(31), e.abrupt("return", s.default.reject({
                  error: e.t1
                }));

              case 43:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[19, 28], [31, 40]]);
      }));
      return e;
    }(),
        m = {
      start: h,
      client: p.HttpClient,
      LATEST_SUPPORTED_IDX_API_VERSION: "1.0.0"
    };

    t.default = m;
  }, function (e, t, n) {
    var r = n(20),
        o = n(77),
        i = "".split;
    e.exports = r(function () {
      return !Object("z").propertyIsEnumerable(0);
    }) ? function (e) {
      return "String" == o(e) ? i.call(e, "") : Object(e);
    } : Object;
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 == e) throw TypeError("Can't call method on " + e);
      return e;
    };
  }, function (e, t, n) {
    var r = n(19),
        o = n(35),
        i = r.document,
        a = o(i) && o(i.createElement);

    e.exports = function (e) {
      return a ? i.createElement(e) : {};
    };
  }, function (e, t) {
    var n = Math.ceil,
        r = Math.floor;

    e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? r : n)(e);
    };
  }, function (e, t, n) {
    var r = n(63),
        o = n(295);
    (e.exports = function (e, t) {
      return o[e] || (o[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: "3.6.4",
      mode: r ? "pure" : "global",
      copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
    });
  }, function (e, t) {
    var n = 0,
        r = Math.random();

    e.exports = function (e) {
      return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++n + r).toString(36);
    };
  }, function (e, t, n) {
    var r = n(31),
        o = n(64),
        i = n(122),
        a = n(595),
        s = i("IE_PROTO"),
        l = Object.prototype;
    e.exports = a ? Object.getPrototypeOf : function (e) {
      return e = o(e), r(e, s) ? e[s] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? l : null;
    };
  }, function (e, t, n) {
    var r = n(20);
    e.exports = !!Object.getOwnPropertySymbols && !r(function () {
      return !String(Symbol());
    });
  }, function (e, t, n) {
    var r = n(26),
        o = n(48),
        i = n(36),
        a = n(97);
    e.exports = r ? Object.defineProperties : function (e, t) {
      i(e);

      for (var n, r = a(t), s = r.length, l = 0; s > l;) {
        o.f(e, n = r[l++], t[n]);
      }

      return e;
    };
  }, function (e, t) {
    e.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
  }, function (e, t, n) {
    var r = n(14),
        o = r("toStringTag"),
        i = {};
    i[o] = "z", e.exports = "[object z]" === String(i);
  }, function (e, t, n) {
    "use strict";

    var r = n(43),
        o = n(303),
        i = n(65),
        a = n(62),
        s = n(296),
        l = a.set,
        u = a.getterFor("Array Iterator");
    e.exports = s(Array, "Array", function (e, t) {
      l(this, {
        type: "Array Iterator",
        target: r(e),
        index: 0,
        kind: t
      });
    }, function () {
      var e = u(this),
          t = e.target,
          n = e.kind,
          r = e.index++;
      return !t || r >= t.length ? (e.target = void 0, {
        value: void 0,
        done: !0
      }) : "keys" == n ? {
        value: r,
        done: !1
      } : "values" == n ? {
        value: t[r],
        done: !1
      } : {
        value: [r, t[r]],
        done: !1
      };
    }, "values"), i.Arguments = i.Array, o("keys"), o("values"), o("entries");
  }, function (e, t) {
    e.exports = function (e, t, n) {
      if (!(e instanceof t)) throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
      return e;
    };
  }, function (e, t, n) {
    var r,
        o,
        i = n(19),
        a = n(312),
        s = i.process,
        l = s && s.versions,
        u = l && l.v8;
    u ? (r = u.split("."), o = r[0] + r[1]) : a && (!(r = a.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = a.match(/Chrome\/(\d+)/)) && (o = r[1]), e.exports = o && +o;
  }, function (e, t) {
    t.f = Object.getOwnPropertySymbols;
  }, function (e, t, n) {
    var r = n(102),
        o = n(325),
        i = n(130),
        a = n(324),
        s = Object.defineProperty;
    t.f = r ? s : function (e, t, n) {
      if (i(e), t = a(t, !0), i(n), o) try {
        return s(e, t, n);
      } catch (e) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
      return "value" in n && (e[t] = n.value), e;
    };
  }, function (e, t, n) {
    var r = n(37),
        o = n(103),
        i = n(85),
        a = n(180),
        s = n(326),
        l = n(615),
        u = l.get,
        c = l.enforce,
        d = String(String).split("String");
    (e.exports = function (e, t, n, s) {
      var l,
          u = !!s && !!s.unsafe,
          f = !!s && !!s.enumerable,
          p = !!s && !!s.noTargetGet;
      if ("function" == typeof n && ("string" != typeof t || i(n, "name") || o(n, "name", t), l = c(n), l.source || (l.source = d.join("string" == typeof t ? t : ""))), e === r) return void (f ? e[t] = n : a(t, n));
      u ? !p && e[t] && (f = !0) : delete e[t], f ? e[t] = n : o(e, t, n);
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && u(this).source || s(this);
    });
  }, function (e, t, n) {
    var r = n(37),
        o = n(103);

    e.exports = function (e, t) {
      try {
        o(r, e, t);
      } catch (n) {
        r[e] = t;
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(37),
        o = n(180),
        i = r["__core-js_shared__"] || o("__core-js_shared__", {});
    e.exports = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(629),
        o = n(630),
        i = RegExp.prototype.exec,
        a = String.prototype.replace,
        s = i,
        l = function () {
      var e = /a/,
          t = /b*/g;
      return i.call(e, "a"), i.call(t, "a"), 0 !== e.lastIndex || 0 !== t.lastIndex;
    }(),
        u = o.UNSUPPORTED_Y || o.BROKEN_CARET,
        c = void 0 !== /()??/.exec("")[1];

    (l || c || u) && (s = function s(e) {
      var t,
          n,
          o,
          s,
          d = this,
          f = u && d.sticky,
          p = r.call(d),
          h = d.source,
          m = 0,
          g = e;
      return f && (p = p.replace("y", ""), -1 === p.indexOf("g") && (p += "g"), g = String(e).slice(d.lastIndex), d.lastIndex > 0 && (!d.multiline || d.multiline && "\n" !== e[d.lastIndex - 1]) && (h = "(?: " + h + ")", g = " " + g, m++), n = new RegExp("^(?:" + h + ")", p)), c && (n = new RegExp("^" + h + "$(?!\\s)", p)), l && (t = d.lastIndex), o = i.call(f ? n : d, g), f ? o ? (o.input = o.input.slice(m), o[0] = o[0].slice(m), o.index = d.lastIndex, d.lastIndex += o[0].length) : d.lastIndex = 0 : l && o && (d.lastIndex = d.global ? o.index + o[0].length : t), c && o && o.length > 1 && a.call(o[0], n, function () {
        for (s = 1; s < arguments.length - 2; s++) {
          void 0 === arguments[s] && (o[s] = void 0);
        }
      }), o;
    }), e.exports = s;
  }, function (e, t, n) {
    var r = n(37),
        o = n(327),
        i = n(85),
        a = n(328),
        s = n(332),
        l = n(634),
        u = o("wks"),
        c = r.Symbol,
        d = l ? c : c && c.withoutSetter || a;

    e.exports = function (e) {
      return i(u, e) && (s || "string" == typeof u[e]) || (s && i(c, e) ? u[e] = c[e] : u[e] = d("Symbol." + e)), u[e];
    };
  }, function (e, t, n) {
    e.exports = n(652);
  }, function (e, t, n) {
    var r = n(300),
        o = n(172),
        i = o.concat("length", "prototype");

    t.f = Object.getOwnPropertyNames || function (e) {
      return r(e, i);
    };
  }, function (e, t, n) {
    var r = n(14);
    t.f = r;
  }, function (e, t, n) {
    e.exports = n(658);
  }, function (e, t, n) {
    e.exports = n(666);
  }, function (e, t, n) {
    e.exports = n(670);
  }, function (e, t, n) {
    function r(e, t, n) {
      return t in e ? o(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var o = n(673);
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(686);
  }, function (e, t, n) {
    e.exports = n(714);
  }, function (e, t, n) {
    e.exports = n(751);
  }, function (e, t, n) {
    var r = n(183),
        o = r("toStringTag"),
        i = {};
    i[o] = "z", e.exports = "[object z]" === String(i);
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(773)),
        a = r(n(845)),
        s = n(364),
        l = n(8),
        u = r(n(12)),
        c = r(n(160)),
        d = n(282),
        f = o.Controller.extend({
      className: "form-controller",
      appStateEvents: {
        "change:currentFormName": "handleFormNameChange",
        afterError: "handleAfterError",
        invokeAction: "handleInvokeAction",
        saveForm: "handleSaveForm",
        switchForm: "handleSwitchForm"
      },
      preRender: function preRender() {
        this.removeChildren();
      },
      postRender: function postRender() {
        var e = this.options.appState.getCurrentViewState();

        if (e) {
          this.clearMetadata();
          var t = i.default.create(e.name, this.options.appState.get("authenticatorKey"));

          try {
            this.formView = this.add(t, {
              options: {
                currentViewState: e
              }
            }).last();
          } catch (e) {
            return void this.options.settings.callGlobalError(e);
          }

          this.triggerAfterRenderEvent();
        }
      },
      clearMetadata: function clearMetadata() {
        var e = this.options.appState.get("currentFormName");
        l.TERMINAL_FORMS.includes(e) && c.default.removeStateHandle();
      },
      triggerAfterRenderEvent: function triggerAfterRenderEvent() {
        var e = this.createAfterEventContext();
        this.trigger("afterRender", e);
      },
      handleFormNameChange: function handleFormNameChange() {
        this.render();
      },
      handleAfterError: function handleAfterError() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = this.createAfterEventContext(),
            n = {
          xhr: e,
          errorSummary: e.responseJSON && e.responseJSON.errorSummary
        };
        this.trigger("afterError", t, n);
      },
      createAfterEventContext: function createAfterEventContext() {
        var e = this.options.appState.get("currentFormName"),
            t = this.options.appState.get("authenticatorKey"),
            n = this.options.appState.get("authenticatorMethodType"),
            r = this.options.appState.get("isPasswordRecoveryFlow"),
            o = (0, s.getV1ClassName)(e, t, n, r),
            i = {
          controller: o,
          formName: e
        };
        return t && (i.authenticatorKey = t), n && (i.methodType = n), i;
      },
      handleSwitchForm: function handleSwitchForm(e) {
        this.options.appState.get("messages") && this.options.appState.unset("messages"), this.options.appState.set("currentFormName", e);
      },
      handleInvokeAction: function handleInvokeAction() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
            n = this.options.appState.get("idx");
        if ("cancel" === t && ((0, d.clearTransactionMeta)(this.options.settings), c.default.removeStateHandle(), this.options.appState.clearAppStateCache()), n.neededToProceed.find(function (e) {
          return e.name === t;
        })) return void n.proceed(t, {}).then(this.handleIdxSuccess.bind(this)).catch(function (t) {
          e.showFormErrors(e.formView.model, t);
        });
        var r = n.actions[t];
        o._.isFunction(r) ? r().then(this.handleIdxSuccess.bind(this)).catch(function (t) {
          e.showFormErrors(e.formView.model, t);
        }) : (this.options.settings.callGlobalError("Invalid action selected: ".concat(t)), this.showFormErrors(this.formView.model, "Invalid action selected."));
      },
      handleSaveForm: function handleSaveForm(e) {
        var t = this,
            n = e.get("formName");

        if (this.toggleFormButtonState(!0), e.trigger("request"), e.get("useRedirect")) {
          c.default.removeStateHandle();
          var r = this.options.appState.getCurrentViewState();
          return void u.default.redirectWithFormGet(r.href);
        }

        var o = this.transformIdentifier(n, e),
            i = this.options.appState.get("idx");
        if (!this.options.appState.hasRemediationObject(n)) return this.options.settings.callGlobalError('Cannot find http action for "'.concat(n, '".')), void this.showFormErrors(this.formView.model, "Cannot find action to proceed.");
        i.proceed(n, o).then(function (r) {
          var i = t.handleIdxSuccess.bind(t, r);

          if (n === l.FORMS.ENROLL_PROFILE) {
            var a;
            t.settings.postRegistrationSubmit(null === o || void 0 === o ? void 0 : null === (a = o.userProfile) || void 0 === a ? void 0 : a.email, i, function (t) {
              e.trigger("error", e, {
                responseJSON: t
              });
            });
          } else i();
        }).catch(function (n) {
          n.proceed && n.rawIdxState ? t.handleIdxSuccess(n) : t.showFormErrors(e, n);
        }).finally(function () {
          t.toggleFormButtonState(!1);
        });
      },
      transformIdentifier: function transformIdentifier(e, t) {
        var n = t.toJSON();

        if (Object.prototype.hasOwnProperty.call(n, "identifier")) {
          var r = l.FORM_NAME_TO_OPERATION_MAP[e];
          n.identifier = this.settings.transformUsername(n.identifier, r);
        }

        return n;
      },
      showFormErrors: function showFormErrors(e, t) {
        e.trigger("clearFormError"), t || (t = "FormController - unknown error found", this.options.settings.callGlobalError(t));
        var n;
        a.default.isIonErrorResponse(t) ? n = a.default.convertFormErrors(t) : t.errorSummary && (n = {
          responseJSON: t
        }), e.trigger("error", e, n || {
          responseJSON: {
            errorSummary: String(t)
          }
        }, !0);
      },
      handleIdxSuccess: function handleIdxSuccess(e) {
        this.options.appState.trigger("remediationSuccess", e);
      },
      toggleFormButtonState: function toggleFormButtonState(e) {
        this.$el.find(".o-form-button-bar .button").toggleClass("link-button-disabled", e);
      }
    });
    t.default = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.FORGOT_PASSWORD_NOT_ENABLED = t.REGISTRATION_NOT_ENABLED = void 0;
    var o = n(1),
        i = n(3),
        a = n(68),
        s = r(n(368));
    t.REGISTRATION_NOT_ENABLED = "oie.registration.is.not.enabled";
    t.FORGOT_PASSWORD_NOT_ENABLED = "oie.forgot.password.is.not.enabled";
    var l = ["idx.transferred.to.new.tab", "idx.return.stale", "idx.return.error", "idx.email.verification.required", "idx.return.to.original.tab", "idx.return.link.expired", "idx.operation.cancelled.on.other.device", "idx.operation.cancelled.by.user"],
        u = ["idx.return.link.expired", "oie.registration.is.not.enabled"],
        c = ["idx.device.not.activated.consent.denied", "idx.device.not.activated.internal.error"],
        d = ["idx.device.activated"].concat(c),
        f = i.BaseForm.extend({
      noButtonBar: !0,
      postRender: function postRender() {
        if (i.BaseForm.prototype.postRender.apply(this, arguments), this.$el.addClass("terminal-state"), this.options.appState.containsMessageWithI18nKey(d)) {
          var e = this.options.appState.containsMessageWithI18nKey("idx.device.activated") ? "success-24-green" : "error-24-red";
          this.$(".o-form-head").before('<div class="device-code-terminal--icon-container"><span class="device-code-terminal--icon ' + e + '"></span></div>');
        }
      },
      title: function title() {
        return this.options.appState.containsMessageWithI18nKey("idx.return.link.expired") ? (0, o.loc)("oie.email.return.link.expired.title", "login") : this.options.appState.containsMessageStartingWithI18nKey("idx.error.server.safe.mode") ? (0, o.loc)("oie.safe.mode.title", "login") : this.options.appState.containsMessageWithI18nKey("oie.selfservice.unlock_user.success.message") ? (0, o.loc)("account.unlock.unlocked.title", "login") : this.options.appState.containsMessageWithI18nKey("idx.device.activated") ? (0, o.loc)("device.code.activated.success.title", "login") : this.options.appState.containsMessageWithI18nKey(c) ? (0, o.loc)("device.code.activated.error.title", "login") : this.options.appState.containsMessageWithI18nKey("oie.registration.is.not.enabled") ? (0, o.loc)("oie.registration.form.title", "login") : this.options.appState.containsMessageWithI18nKey("oie.forgot.password.is.not.enabled") ? (0, o.loc)("password.reset.title.generic", "login") : void 0;
      },
      showMessages: function showMessages() {
        var e,
            t = this,
            n = this.options.appState.get("messages");
        this.options.appState.containsMessageWithI18nKey("idx.operation.cancelled.on.other.device") ? (e = (0, o.loc)("idx.operation.cancelled.on.other.device", "login"), n.value.push({
          message: (0, o.loc)("oie.consent.enduser.deny.description", "login")
        })) : this.options.appState.containsMessageWithI18nKey("idx.return.to.original.tab") ? (e = (0, o.loc)("oie.return.to.original.tab", "login"), n.value.push({
          message: (0, o.loc)("oie.consent.enduser.email.allow.description", "login")
        })) : this.options.appState.containsMessageWithI18nKey("tooManyRequests") && (e = (0, o.loc)("oie.tooManyRequests", "login")), e && Array.isArray(null === n || void 0 === n ? void 0 : n.value) && (n.value[0].message = e), n && Array.isArray(n.value) && (this.add('<div class="ion-messages-container"></div>', ".o-form-error-container"), n.value.forEach(function (e) {
          var n,
              r = e.message;
          "ERROR" === e.class || "idx.return.link.expired" === (null === (n = e.i18n) || void 0 === n ? void 0 : n.key) ? t.add((0, o.createCallout)({
            content: r,
            type: "error"
          }), {
            selector: ".o-form-error-container",
            prepend: !0
          }) : t.add("<p>".concat(r, "</p>"), ".ion-messages-container");
        }));
      }
    }),
        p = i.BaseFooter.extend({
      links: function links() {
        return this.options.appState.containsMessageWithI18nKey(u) ? (0, a.getBackToSignInLink)(this.options.settings) : this.options.appState.containsMessageStartingWithI18nKey("idx.error.server.safe.mode") ? (0, a.getSkipSetupLink)(this.options.appState) : this.options.appState.containsMessageWithI18nKey(c) ? (0, a.getReloadPageButtonLink)() : void 0;
      }
    }),
        h = i.BaseView.extend({
      initialize: function initialize() {
        i.BaseView.prototype.initialize.apply(this, arguments), this.options.appState.containsMessageWithI18nKey(l) && (this.Header = s.default);
      },
      Body: f,
      Footer: p
    });
    t.default = h;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return void 0 === e;
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return !0 === e || !1 === e || "[object Boolean]" === o.t.call(e);
    }

    t.a = r;
    var o = n(11);
  }, function (e, t, n) {
    "use strict";

    var r = n(23);
    t.a = Object(r.a)("Number");
  }, function (e, t, n) {
    "use strict";

    var r = n(23);
    t.a = Object(r.a)("Symbol");
  }, function (e, t, n) {
    "use strict";

    var r = n(23);
    t.a = Object(r.a)("ArrayBuffer");
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return Object(i.a)(e) && Object(o.g)(e);
    }

    t.a = r;
    var o = n(11),
        i = n(199);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return o.l ? Object(o.l)(e) && !Object(i.a)(e) : Object(s.a)(e) && l.test(o.t.call(e));
    }

    var o = n(11),
        i = n(141),
        a = n(204),
        s = n(391),
        l = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
    t.a = o.r ? r : Object(a.a)(!1);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function () {
        return e;
      };
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function (t) {
        var n = e(t);
        return "number" == typeof n && n >= 0 && n <= o.b;
      };
    }

    t.a = r;
    var o = n(11);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function (t) {
        return null == t ? void 0 : t[e];
      };
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var t = {}, n = e.length, r = 0; r < n; ++r) {
        t[e[r]] = !0;
      }

      return {
        contains: function contains(e) {
          return t[e];
        },
        push: function push(n) {
          return t[n] = !0, e.push(n);
        }
      };
    }

    function o(e, t) {
      t = r(t);
      var n = i.n.length,
          o = e.constructor,
          l = Object(a.a)(o) && o.prototype || i.c,
          u = "constructor";

      for (Object(s.a)(e, u) && !t.contains(u) && t.push(u); n--;) {
        (u = i.n[n]) in e && e[u] !== l[u] && !t.contains(u) && t.push(u);
      }
    }

    t.a = o;
    var i = n(11),
        a = n(32),
        s = n(50);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = Object(o.a)(t),
          r = n.length;
      if (null == e) return !r;

      for (var i = Object(e), a = 0; a < r; a++) {
        var s = n[a];
        if (t[s] !== i[s] || !(s in i)) return !1;
      }

      return !0;
    }

    t.a = r;
    var o = n(22);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var t = {}, n = Object(o.a)(e), r = 0, i = n.length; r < i; r++) {
        t[e[n[r]]] = n[r];
      }

      return t;
    }

    t.a = r;
    var o = n(22);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = [];

      for (var n in e) {
        Object(o.a)(e[n]) && t.push(n);
      }

      return t.sort();
    }

    t.a = r;
    var o = n(32);
  }, function (e, t, n) {
    "use strict";

    var r = n(145),
        o = n(88);
    t.a = Object(r.a)(o.a);
  }, function (e, t, n) {
    "use strict";

    var r = n(145),
        o = n(88);
    t.a = Object(r.a)(o.a, !0);
  }, function (e, t, n) {
    "use strict";

    function r() {
      return function () {};
    }

    function o(e) {
      if (!Object(i.a)(e)) return {};
      if (a.j) return Object(a.j)(e);
      var t = r();
      t.prototype = e;
      var n = new t();
      return t.prototype = null, n;
    }

    t.a = o;
    var i = n(53),
        a = n(11);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return Object(o.a)(e) ? Object(i.a)(e) ? e.slice() : Object(a.a)({}, e) : e;
    }

    t.a = r;
    var o = n(53),
        i = n(54),
        a = n(211);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      var r = Object(i.a)(e, Object(o.a)(t));
      return Object(a.a)(r) ? n : r;
    }

    t.a = r;
    var o = n(89),
        i = n(147),
        a = n(197);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return Object(i.a)(e) ? e : [e];
    }

    t.a = r;
    var o = n(29),
        i = n(54);
    o.a.toPath = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      return null == e ? o.a : Object(i.a)(e) ? Object(c.a)(e, t, n) : Object(a.a)(e) && !Object(s.a)(e) ? Object(l.a)(e) : Object(u.a)(e);
    }

    t.a = r;
    var o = n(148),
        i = n(32),
        a = n(53),
        s = n(54),
        l = n(111),
        u = n(149),
        c = n(90);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return Object(i.a)(e, t, 1 / 0);
    }

    t.a = r;
    var o = n(29),
        i = n(217);
    o.a.iteratee = r;
  }, function (e, t, n) {
    "use strict";

    function r() {}

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return null == t && (t = e, e = 0), e + Math.floor(Math.random() * (t - e + 1));
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = function t(_t5) {
        return e[_t5];
      },
          n = "(?:" + Object(o.a)(e).join("|") + ")",
          r = RegExp(n),
          i = RegExp(n, "g");

      return function (e) {
        return e = null == e ? "" : "" + e, r.test(e) ? e.replace(i, t) : e;
      };
    }

    t.a = r;
    var o = n(22);
  }, function (e, t, n) {
    "use strict";

    t.a = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#x27;",
      "`": "&#x60;"
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(29);
    t.a = r.a.templateSettings = {
      evaluate: /<%([\s\S]+?)%>/g,
      interpolate: /<%=([\s\S]+?)%>/g,
      escape: /<%-([\s\S]+?)%>/g
    };
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n, r, a) {
      if (!(r instanceof t)) return e.apply(n, a);
      var s = Object(o.a)(e.prototype),
          l = e.apply(s, a);
      return Object(i.a)(l) ? l : s;
    }

    t.a = r;
    var o = n(213),
        i = n(53);
  }, function (e, t, n) {
    "use strict";

    var r = n(28),
        o = n(32),
        i = n(224);
    t.a = Object(r.a)(function (e, t, n) {
      if (!Object(o.a)(e)) throw new TypeError("Bind must be called on a function");
      var a = Object(r.a)(function (r) {
        return Object(i.a)(e, a, t, this, n.concat(r));
      });
      return a;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(28);
    t.a = Object(r.a)(function (e, t, n) {
      return setTimeout(function () {
        return e.apply(null, n);
      }, t);
    });
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n;
      return function () {
        return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = null), n;
      };
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      t = Object(o.a)(t, n);

      for (var r, a = Object(i.a)(e), s = 0, l = a.length; s < l; s++) {
        if (r = a[s], t(e[r], r, e)) return r;
      }
    }

    t.a = r;
    var o = n(27),
        i = n(22);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function (t, n, r) {
        n = Object(o.a)(n, r);

        for (var a = Object(i.a)(t), s = e > 0 ? 0 : a - 1; s >= 0 && s < a; s += e) {
          if (n(t[s], s, t)) return s;
        }

        return -1;
      };
    }

    t.a = r;
    var o = n(27),
        i = n(33);
  }, function (e, t, n) {
    "use strict";

    var r = n(229);
    t.a = Object(r.a)(-1);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n, r) {
      n = Object(o.a)(n, r, 1);

      for (var a = n(t), s = 0, l = Object(i.a)(e); s < l;) {
        var u = Math.floor((s + l) / 2);
        n(e[u]) < a ? s = u + 1 : l = u;
      }

      return s;
    }

    t.a = r;
    var o = n(27),
        i = n(33);
  }, function (e, t, n) {
    "use strict";

    var r = n(231),
        o = n(152),
        i = n(233);
    t.a = Object(i.a)(1, o.a, r.a);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      return function (r, s, l) {
        var u = 0,
            c = Object(o.a)(r);
        if ("number" == typeof l) e > 0 ? u = l >= 0 ? l : Math.max(l + c, u) : c = l >= 0 ? Math.min(l + 1, c) : l + c + 1;else if (n && l && c) return l = n(r, s), r[l] === s ? l : -1;
        if (s !== s) return l = t(i.q.call(r, u, c), a.a), l >= 0 ? l + u : -1;

        for (l = e > 0 ? u : c - 1; l >= 0 && l < c; l += e) {
          if (r[l] === s) return l;
        }

        return -1;
      };
    }

    t.a = r;
    var o = n(33),
        i = n(11),
        a = n(202);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      var r = Object(o.a)(e) ? i.a : a.a,
          s = r(e, t, n);
      if (void 0 !== s && -1 !== s) return e[s];
    }

    t.a = r;
    var o = n(30),
        i = n(152),
        a = n(228);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = function t(_t6, n, r, a) {
        var s = !Object(o.a)(_t6) && Object(i.a)(_t6),
            l = (s || _t6).length,
            u = e > 0 ? 0 : l - 1;

        for (a || (r = _t6[s ? s[u] : u], u += e); u >= 0 && u < l; u += e) {
          var c = s ? s[u] : u;
          r = n(r, _t6[c], c, _t6);
        }

        return r;
      };

      return function (e, n, r, o) {
        var i = arguments.length >= 3;
        return t(e, Object(a.a)(n, o, 4), r, i);
      };
    }

    t.a = r;
    var o = n(30),
        i = n(22),
        a = n(90);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      var r,
          l,
          u = -1 / 0,
          c = -1 / 0;

      if (null == t || "number" == typeof t && "object" != typeof e[0] && null != e) {
        e = Object(o.a)(e) ? e : Object(i.a)(e);

        for (var d = 0, f = e.length; d < f; d++) {
          null != (r = e[d]) && r > u && (u = r);
        }
      } else t = Object(a.a)(t, n), Object(s.a)(e, function (e, n, r) {
        ((l = t(e, n, r)) > c || l === -1 / 0 && u === -1 / 0) && (u = e, c = l);
      });

      return u;
    }

    t.a = r;
    var o = n(30),
        i = n(69),
        a = n(27),
        s = n(55);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      if (null == t || n) return Object(o.a)(e) || (e = Object(a.a)(e)), e[Object(l.a)(e.length - 1)];
      var r = Object(o.a)(e) ? Object(i.a)(e) : Object(a.a)(e),
          u = Object(s.a)(r);
      t = Math.max(Math.min(t, u), 0);

      for (var c = u - 1, d = 0; d < t; d++) {
        var f = Object(l.a)(d, c),
            p = r[d];
        r[d] = r[f], r[f] = p;
      }

      return r.slice(0, t);
    }

    t.a = r;
    var o = n(30),
        i = n(214),
        a = n(69),
        s = n(33),
        l = n(220);
  }, function (e, t, n) {
    "use strict";

    var r = n(28),
        o = n(32),
        i = n(90),
        a = n(88),
        s = n(440),
        l = n(70);
    t.a = Object(r.a)(function (e, t) {
      var n = {},
          r = t[0];
      if (null == e) return n;
      Object(o.a)(r) ? (t.length > 1 && (r = Object(i.a)(r, t[1])), t = Object(a.a)(e)) : (r = s.a, t = Object(l.a)(t, !1, !1), e = Object(e));

      for (var u = 0, c = t.length; u < c; u++) {
        var d = t[u],
            f = e[d];
        r(f, d, e) && (n[d] = f);
      }

      return n;
    });
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      return o.q.call(e, 0, Math.max(0, e.length - (null == t || n ? 1 : t)));
    }

    t.a = r;
    var o = n(11);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      return o.q.call(e, null == t || n ? 1 : t);
    }

    t.a = r;
    var o = n(11);
  }, function (e, t, n) {
    "use strict";

    var r = n(28),
        o = n(70),
        i = n(91),
        a = n(92);
    t.a = Object(r.a)(function (e, t) {
      return t = Object(o.a)(t, !0, !0), Object(i.a)(e, function (e) {
        return !Object(a.a)(t, e);
      });
    });
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n, r) {
      Object(o.a)(t) || (r = n, n = t, t = !1), null != n && (n = Object(i.a)(n, r));

      for (var l = [], u = [], c = 0, d = Object(a.a)(e); c < d; c++) {
        var f = e[c],
            p = n ? n(f, c, e) : f;
        t && !n ? (c && u === p || l.push(f), u = p) : n ? Object(s.a)(u, p) || (u.push(p), l.push(f)) : Object(s.a)(l, f) || l.push(f);
      }

      return l;
    }

    t.a = r;
    var o = n(198),
        i = n(27),
        a = n(33),
        s = n(92);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var t = e && Object(o.a)(e, i.a).length || 0, n = Array(t), r = 0; r < t; r++) {
        n[r] = Object(a.a)(e, r);
      }

      return n;
    }

    t.a = r;
    var o = n(236),
        i = n(33),
        a = n(153);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return e._chain ? Object(o.a)(t).chain() : t;
    }

    t.a = r;
    var o = n(29);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function o(e, t, n) {
      this.helpers = e || {}, this.partials = t || {}, this.decorators = n || {}, l.registerDefaultHelpers(this), u.registerDefaultDecorators(this);
    }

    t.__esModule = !0, t.HandlebarsEnvironment = o;
    var i = n(41),
        a = n(56),
        s = r(a),
        l = n(246),
        u = n(462),
        c = n(247),
        d = r(c),
        f = n(248);
    t.VERSION = "4.7.6";
    t.COMPILER_REVISION = 8;
    t.LAST_COMPATIBLE_COMPILER_REVISION = 7;
    var p = {
      1: "<= 1.0.rc.2",
      2: "== 1.0.0-rc.3",
      3: "== 1.0.0-rc.4",
      4: "== 1.x.x",
      5: "== 2.0.0-alpha.x",
      6: ">= 2.0.0-beta.1",
      7: ">= 4.0.0 <4.3.0",
      8: ">= 4.3.0"
    };
    t.REVISION_CHANGES = p;
    o.prototype = {
      constructor: o,
      logger: d.default,
      log: d.default.log,
      registerHelper: function registerHelper(e, t) {
        if ("[object Object]" === i.toString.call(e)) {
          if (t) throw new s.default("Arg not supported with multiple helpers");
          i.extend(this.helpers, e);
        } else this.helpers[e] = t;
      },
      unregisterHelper: function unregisterHelper(e) {
        delete this.helpers[e];
      },
      registerPartial: function registerPartial(e, t) {
        if ("[object Object]" === i.toString.call(e)) i.extend(this.partials, e);else {
          if (void 0 === t) throw new s.default('Attempting to register a partial called "' + e + '" as undefined');
          this.partials[e] = t;
        }
      },
      unregisterPartial: function unregisterPartial(e) {
        delete this.partials[e];
      },
      registerDecorator: function registerDecorator(e, t) {
        if ("[object Object]" === i.toString.call(e)) {
          if (t) throw new s.default("Arg not supported with multiple decorators");
          i.extend(this.decorators, e);
        } else this.decorators[e] = t;
      },
      unregisterDecorator: function unregisterDecorator(e) {
        delete this.decorators[e];
      },
      resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
        f.resetLoggedProperties();
      }
    };
    var h = d.default.log;
    t.log = h, t.createFrame = i.createFrame, t.logger = d.default;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function o(e) {
      s.default(e), u.default(e), d.default(e), p.default(e), m.default(e), v.default(e), b.default(e);
    }

    function i(e, t, n) {
      e.helpers[t] && (e.hooks[t] = e.helpers[t], n || delete e.helpers[t]);
    }

    t.__esModule = !0, t.registerDefaultHelpers = o, t.moveHelperToHooks = i;
    var a = n(455),
        s = r(a),
        l = n(456),
        u = r(l),
        c = n(457),
        d = r(c),
        f = n(458),
        p = r(f),
        h = n(459),
        m = r(h),
        g = n(460),
        v = r(g),
        y = n(461),
        b = r(y);
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(41),
        o = {
      methodMap: ["debug", "info", "warn", "error"],
      level: "info",
      lookupLevel: function lookupLevel(e) {
        if ("string" == typeof e) {
          var t = r.indexOf(o.methodMap, e.toLowerCase());
          e = t >= 0 ? t : parseInt(e, 10);
        }

        return e;
      },
      log: function log(e) {
        if (e = o.lookupLevel(e), "undefined" != typeof console && o.lookupLevel(o.level) <= e) {
          var t = o.methodMap[e];
          console[t] || (t = "log");

          for (var n = arguments.length, r = Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
            r[i - 1] = arguments[i];
          }
        }
      }
    };
    t.default = o, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = Object.create(null);
      t.constructor = !1, t.__defineGetter__ = !1, t.__defineSetter__ = !1, t.__lookupGetter__ = !1;
      var n = Object.create(null);
      return n.__proto__ = !1, {
        properties: {
          whitelist: l.createNewLookupObject(n, e.allowedProtoProperties),
          defaultValue: e.allowProtoPropertiesByDefault
        },
        methods: {
          whitelist: l.createNewLookupObject(t, e.allowedProtoMethods),
          defaultValue: e.allowProtoMethodsByDefault
        }
      };
    }

    function o(e, t, n) {
      return "function" == typeof e ? i(t.methods, n) : i(t.properties, n);
    }

    function i(e, t) {
      return void 0 !== e.whitelist[t] ? !0 === e.whitelist[t] : void 0 !== e.defaultValue ? e.defaultValue : (a(t), !1);
    }

    function a(e) {
      !0 !== d[e] && (d[e] = !0, c.log("error", 'Handlebars: Access has been denied to resolve the property "' + e + '" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'));
    }

    function s() {
      Object.keys(d).forEach(function (e) {
        delete d[e];
      });
    }

    t.__esModule = !0, t.createProtoAccessControl = r, t.resultIsAllowed = o, t.resetLoggedProperties = s;

    var l = n(464),
        u = n(247),
        c = function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    }(u),
        d = Object.create(null);
  }, function (e, t) {
    var n = function (e) {
      function t() {
        this.fetch = !1, this.DOMException = e.DOMException;
      }

      return t.prototype = e, new t();
    }("undefined" != typeof self ? self : this);

    !function (e) {
      !function (t) {
        function n(e) {
          return e && DataView.prototype.isPrototypeOf(e);
        }

        function r(e) {
          if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
          return e.toLowerCase();
        }

        function o(e) {
          return "string" != typeof e && (e = String(e)), e;
        }

        function i(e) {
          var t = {
            next: function next() {
              var t = e.shift();
              return {
                done: void 0 === t,
                value: t
              };
            }
          };
          return _.iterable && (t[Symbol.iterator] = function () {
            return t;
          }), t;
        }

        function a(e) {
          this.map = {}, e instanceof a ? e.forEach(function (e, t) {
            this.append(t, e);
          }, this) : Array.isArray(e) ? e.forEach(function (e) {
            this.append(e[0], e[1]);
          }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
            this.append(t, e[t]);
          }, this);
        }

        function s(e) {
          if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
          e.bodyUsed = !0;
        }

        function l(e) {
          return new Promise(function (t, n) {
            e.onload = function () {
              t(e.result);
            }, e.onerror = function () {
              n(e.error);
            };
          });
        }

        function u(e) {
          var t = new FileReader(),
              n = l(t);
          return t.readAsArrayBuffer(e), n;
        }

        function c(e) {
          var t = new FileReader(),
              n = l(t);
          return t.readAsText(e), n;
        }

        function d(e) {
          for (var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++) {
            n[r] = String.fromCharCode(t[r]);
          }

          return n.join("");
        }

        function f(e) {
          if (e.slice) return e.slice(0);
          var t = new Uint8Array(e.byteLength);
          return t.set(new Uint8Array(e)), t.buffer;
        }

        function p() {
          return this.bodyUsed = !1, this._initBody = function (e) {
            this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : _.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : _.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : _.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : _.arrayBuffer && _.blob && n(e) ? (this._bodyArrayBuffer = f(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : _.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || E(e)) ? this._bodyArrayBuffer = f(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : _.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, _.blob && (this.blob = function () {
            var e = s(this);
            if (e) return e;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function () {
            return this._bodyArrayBuffer ? s(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(u);
          }), this.text = function () {
            var e = s(this);
            if (e) return e;
            if (this._bodyBlob) return c(this._bodyBlob);
            if (this._bodyArrayBuffer) return Promise.resolve(d(this._bodyArrayBuffer));
            if (this._bodyFormData) throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, _.formData && (this.formData = function () {
            return this.text().then(g);
          }), this.json = function () {
            return this.text().then(JSON.parse);
          }, this;
        }

        function h(e) {
          var t = e.toUpperCase();
          return O.indexOf(t) > -1 ? t : e;
        }

        function m(e, t) {
          t = t || {};
          var n = t.body;

          if (e instanceof m) {
            if (e.bodyUsed) throw new TypeError("Already read");
            this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new a(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, n || null == e._bodyInit || (n = e._bodyInit, e.bodyUsed = !0);
          } else this.url = String(e);

          if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new a(t.headers)), this.method = h(t.method || this.method || "GET"), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && n) throw new TypeError("Body not allowed for GET or HEAD requests");

          this._initBody(n);
        }

        function g(e) {
          var t = new FormData();
          return e.trim().split("&").forEach(function (e) {
            if (e) {
              var n = e.split("="),
                  r = n.shift().replace(/\+/g, " "),
                  o = n.join("=").replace(/\+/g, " ");
              t.append(decodeURIComponent(r), decodeURIComponent(o));
            }
          }), t;
        }

        function v(e) {
          var t = new a();
          return e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
            var n = e.split(":"),
                r = n.shift().trim();

            if (r) {
              var o = n.join(":").trim();
              t.append(r, o);
            }
          }), t;
        }

        function y(e, t) {
          t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new a(t.headers), this.url = t.url || "", this._initBody(e);
        }

        function b(e, n) {
          return new Promise(function (r, o) {
            function i() {
              s.abort();
            }

            var a = new m(e, n);
            if (a.signal && a.signal.aborted) return o(new t.DOMException("Aborted", "AbortError"));
            var s = new XMLHttpRequest();
            s.onload = function () {
              var e = {
                status: s.status,
                statusText: s.statusText,
                headers: v(s.getAllResponseHeaders() || "")
              };
              e.url = "responseURL" in s ? s.responseURL : e.headers.get("X-Request-URL");
              var t = "response" in s ? s.response : s.responseText;
              r(new y(t, e));
            }, s.onerror = function () {
              o(new TypeError("Network request failed"));
            }, s.ontimeout = function () {
              o(new TypeError("Network request failed"));
            }, s.onabort = function () {
              o(new t.DOMException("Aborted", "AbortError"));
            }, s.open(a.method, a.url, !0), "include" === a.credentials ? s.withCredentials = !0 : "omit" === a.credentials && (s.withCredentials = !1), "responseType" in s && _.blob && (s.responseType = "blob"), a.headers.forEach(function (e, t) {
              s.setRequestHeader(t, e);
            }), a.signal && (a.signal.addEventListener("abort", i), s.onreadystatechange = function () {
              4 === s.readyState && a.signal.removeEventListener("abort", i);
            }), s.send(void 0 === a._bodyInit ? null : a._bodyInit);
          });
        }

        var _ = {
          searchParams: "URLSearchParams" in e,
          iterable: "Symbol" in e && "iterator" in Symbol,
          blob: "FileReader" in e && "Blob" in e && function () {
            try {
              return new Blob(), !0;
            } catch (e) {
              return !1;
            }
          }(),
          formData: "FormData" in e,
          arrayBuffer: "ArrayBuffer" in e
        };
        if (_.arrayBuffer) var w = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
            E = ArrayBuffer.isView || function (e) {
          return e && w.indexOf(Object.prototype.toString.call(e)) > -1;
        };
        a.prototype.append = function (e, t) {
          e = r(e), t = o(t);
          var n = this.map[e];
          this.map[e] = n ? n + ", " + t : t;
        }, a.prototype.delete = function (e) {
          delete this.map[r(e)];
        }, a.prototype.get = function (e) {
          return e = r(e), this.has(e) ? this.map[e] : null;
        }, a.prototype.has = function (e) {
          return this.map.hasOwnProperty(r(e));
        }, a.prototype.set = function (e, t) {
          this.map[r(e)] = o(t);
        }, a.prototype.forEach = function (e, t) {
          for (var n in this.map) {
            this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
          }
        }, a.prototype.keys = function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push(n);
          }), i(e);
        }, a.prototype.values = function () {
          var e = [];
          return this.forEach(function (t) {
            e.push(t);
          }), i(e);
        }, a.prototype.entries = function () {
          var e = [];
          return this.forEach(function (t, n) {
            e.push([n, t]);
          }), i(e);
        }, _.iterable && (a.prototype[Symbol.iterator] = a.prototype.entries);
        var O = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        m.prototype.clone = function () {
          return new m(this, {
            body: this._bodyInit
          });
        }, p.call(m.prototype), p.call(y.prototype), y.prototype.clone = function () {
          return new y(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new a(this.headers),
            url: this.url
          });
        }, y.error = function () {
          var e = new y(null, {
            status: 0,
            statusText: ""
          });
          return e.type = "error", e;
        };
        var S = [301, 302, 303, 307, 308];
        y.redirect = function (e, t) {
          if (-1 === S.indexOf(t)) throw new RangeError("Invalid status code");
          return new y(null, {
            status: t,
            headers: {
              location: e
            }
          });
        }, t.DOMException = e.DOMException;

        try {
          new t.DOMException();
        } catch (e) {
          t.DOMException = function (e, t) {
            this.message = e, this.name = t;
            var n = Error(e);
            this.stack = n.stack;
          }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
        }

        b.polyfill = !0, e.fetch || (e.fetch = b, e.Headers = a, e.Request = m, e.Response = y), t.Headers = a, t.Request = m, t.Response = y, t.fetch = b;
      }({});
    }(n), delete n.fetch.polyfill, t = n.fetch, t.default = n.fetch, t.fetch = n.fetch, t.Headers = n.Headers, t.Request = n.Request, t.Response = n.Response, e.exports = t;
  }, function (e, t, n) {
    !function (t, n) {
      e.exports = n();
    }(window, function () {
      return function (e) {
        function t(r) {
          if (n[r]) return n[r].exports;
          var o = n[r] = {
            i: r,
            l: !1,
            exports: {}
          };
          return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
        }

        var n = {};
        return t.m = e, t.c = n, t.d = function (e, n, r) {
          t.o(e, n) || Object.defineProperty(e, n, {
            enumerable: !0,
            get: r
          });
        }, t.r = function (e) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }, t.t = function (e, n) {
          if (1 & n && (e = t(e)), 8 & n) return e;
          if (4 & n && "object" == typeof e && e && e.__esModule) return e;
          var r = Object.create(null);
          if (t.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
          }), 2 & n && "string" != typeof e) for (var o in e) {
            t.d(r, o, function (t) {
              return e[t];
            }.bind(null, o));
          }
          return r;
        }, t.n = function (e) {
          var n = e && e.__esModule ? function () {
            return e.default;
          } : function () {
            return e;
          };
          return t.d(n, "a", n), n;
        }, t.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 41);
      }([function (e, t, n) {
        "use strict";

        function r(e) {
          return o(btoa(e));
        }

        function o(e) {
          return e.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        }

        function i(e) {
          return e.replace(/-/g, "+").replace(/_/g, "/");
        }

        function a(e) {
          var t = i(e);

          switch (t.length % 4) {
            case 0:
              break;

            case 2:
              t += "==";
              break;

            case 3:
              t += "=";
              break;

            default:
              throw "Not a valid Base64Url";
          }

          var n = atob(t);

          try {
            return decodeURIComponent(escape(n));
          } catch (e) {
            return n;
          }
        }

        function s(e) {
          for (var t = new Uint8Array(e.length), n = 0; n < e.length; n++) {
            t[n] = e.charCodeAt(n);
          }

          return t;
        }

        function l(e) {
          return atob(i(e));
        }

        function u(e, t) {
          var n = Array.prototype.slice.call(arguments, 2);
          return function () {
            var r = Array.prototype.slice.call(arguments);
            return r = n.concat(r), e.apply(t, r);
          };
        }

        function c(e) {
          return /^(?:[a-z]+:)?\/\//i.test(e);
        }

        function d() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
              t = arguments.length > 1 ? arguments[1] : void 0;
          return c(e) ? e : (t = N(t), "/" === e[0] ? "".concat(t).concat(e) : "".concat(t, "/").concat(e));
        }

        function f() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
              t = arguments.length > 1 ? arguments[1] : void 0;
          return c(e) && (e = e.substring(t.length)), "/" === e[0] ? e : "/".concat(e);
        }

        function p(e) {
          return "[object String]" === Object.prototype.toString.call(e);
        }

        function h(e) {
          return "[object Object]" === Object.prototype.toString.call(e);
        }

        function m(e) {
          return "[object Number]" === Object.prototype.toString.call(e);
        }

        function g(e) {
          var t = e.match(/\d+/g),
              n = Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
          return new Date(n).toUTCString();
        }

        function v(e) {
          var t = [];
          if (null !== e) for (var n in e) {
            Object.prototype.hasOwnProperty.call(e, n) && void 0 !== e[n] && null !== e[n] && t.push(n + "=" + encodeURIComponent(e[n]));
          }
          return t.length ? "?" + t.join("&") : "";
        }

        function y(e) {
          for (var t = "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789", n = "", r = 0, o = t.length; r < e; ++r) {
            n += t[Math.floor(Math.random() * o)];
          }

          return n;
        }

        function b() {
          var e = arguments[0];
          return [].slice.call(arguments, 1).forEach(function (t) {
            for (var n in t) {
              Object.prototype.hasOwnProperty.call(t, n) && void 0 !== t[n] && (e[n] = t[n]);
            }
          }), e;
        }

        function _(e) {
          var t = {};

          for (var n in e) {
            if (Object.prototype.hasOwnProperty.call(e, n)) {
              var r = e[n];
              null != r && (t[n] = r);
            }
          }

          return t;
        }

        function w(e) {
          if (e) {
            var t = JSON.stringify(e);
            if (t) return JSON.parse(t);
          }

          return e;
        }

        function E(e) {
          for (var t = {}, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) {
            r[o - 1] = arguments[o];
          }

          for (var i in e) {
            Object.prototype.hasOwnProperty.call(e, i) && -1 == r.indexOf(i) && (t[i] = e[i]);
          }

          return w(t);
        }

        function O(e, t) {
          for (var n = e.length; n--;) {
            var r = e[n],
                o = !0;

            for (var i in t) {
              if (Object.prototype.hasOwnProperty.call(t, i) && r[i] !== t[i]) {
                o = !1;
                break;
              }
            }

            if (o) return r;
          }
        }

        function S(e, t, n) {
          if (e && e._links) {
            var r = w(e._links[t]);
            return r && r.name && n ? r.name === n ? r : void 0 : r;
          }
        }

        function x() {
          return "undefined" != typeof window ? window.console : "undefined" != typeof console ? console : void 0;
        }

        function T() {
          var e = x();
          return e && e.log ? e : {
            log: function log() {},
            warn: function warn() {},
            group: function group() {},
            groupEnd: function groupEnd() {}
          };
        }

        function k(e) {
          T().warn("[okta-auth-sdk] WARN: " + e);
        }

        function C(e) {
          T().warn("[okta-auth-sdk] DEPRECATION: " + e);
        }

        function A(e, t) {
          return function () {
            return C(e), t.apply(null, arguments);
          };
        }

        function N(e) {
          if (e) {
            var t = e.replace(/^\s+|\s+$/gm, "");
            return t = t.replace(/\/+$/, "");
          }
        }

        function P() {
          return !!document.documentMode && document.documentMode <= 11;
        }

        function R(e) {
          return !!e && "[object Function]" === {}.toString.call(e);
        }

        function I(e) {
          return new Promise(function (t) {
            setTimeout(t, e);
          });
        }

        function M(e) {
          return e && e.finally && "function" == typeof e.finally;
        }

        n.d(t, "A", function () {
          return r;
        }), n.d(t, "a", function () {
          return o;
        }), n.d(t, "c", function () {
          return i;
        }), n.d(t, "d", function () {
          return a;
        }), n.d(t, "B", function () {
          return s;
        }), n.d(t, "b", function () {
          return l;
        }), n.d(t, "e", function () {
          return u;
        }), n.d(t, "p", function () {
          return c;
        }), n.d(t, "C", function () {
          return d;
        }), n.d(t, "E", function () {
          return f;
        }), n.d(t, "v", function () {
          return p;
        }), n.d(t, "t", function () {
          return h;
        }), n.d(t, "s", function () {
          return m;
        }), n.d(t, "w", function () {
          return g;
        }), n.d(t, "D", function () {
          return v;
        }), n.d(t, "l", function () {
          return y;
        }), n.d(t, "j", function () {
          return b;
        }), n.d(t, "y", function () {
          return _;
        }), n.d(t, "f", function () {
          return w;
        }), n.d(t, "x", function () {
          return E;
        }), n.d(t, "k", function () {
          return O;
        }), n.d(t, "n", function () {
          return S;
        }), n.d(t, "o", function () {
          return x;
        }), n.d(t, "m", function () {
          return T;
        }), n.d(t, "F", function () {
          return k;
        }), n.d(t, "h", function () {
          return C;
        }), n.d(t, "i", function () {
          return A;
        }), n.d(t, "z", function () {
          return N;
        }), n.d(t, "r", function () {
          return P;
        }), n.d(t, "q", function () {
          return R;
        }), n.d(t, "g", function () {
          return I;
        }), n.d(t, "u", function () {
          return M;
        });
      }, function (e, t, n) {
        "use strict";

        function r(e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();

          return function () {
            var n,
                r = h()(e);

            if (t) {
              var o = h()(this).constructor;
              n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);

            return f()(this, n);
          };
        }

        n.d(t, "a", function () {
          return o.a;
        }), n.d(t, "b", function () {
          return i.a;
        }), n.d(t, "c", function () {
          return a.a;
        }), n.d(t, "d", function () {
          return m;
        });

        var o = n(21),
            i = n(19),
            a = n(2),
            s = n(4),
            l = n.n(s),
            u = n(12),
            c = n.n(u),
            d = n(13),
            f = n.n(d),
            p = n(10),
            h = n.n(p),
            m = function (e) {
          function t(e, r) {
            var o;
            return l()(this, t), (o = n.call(this, r)).name = "OAuthError", o.errorCode = e, o.errorSummary = r, o;
          }

          c()(t, e);
          var n = r(t);
          return t;
        }(n(17).a);
      }, function (e, t, n) {
        "use strict";

        function r(e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();

          return function () {
            var n,
                r = d()(e);

            if (t) {
              var o = d()(this).constructor;
              n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);

            return u()(this, n);
          };
        }

        n.d(t, "a", function () {
          return f;
        });

        var o = n(4),
            i = n.n(o),
            a = n(12),
            s = n.n(a),
            l = n(13),
            u = n.n(l),
            c = n(10),
            d = n.n(c),
            f = function (e) {
          function t(e, r) {
            var o;
            return i()(this, t), (o = n.call(this, e)).name = "AuthSdkError", o.errorCode = "INTERNAL", o.errorSummary = e, o.errorLink = "INTERNAL", o.errorId = "INTERNAL", o.errorCauses = [], r && (o.xhr = r), o;
          }

          s()(t, e);
          var n = r(t);
          return t;
        }(n(17).a);
      }, function (e, t, n) {
        "use strict";

        n.r(t), n.d(t, "STATE_TOKEN_KEY_NAME", function () {
          return r;
        }), n.d(t, "DEFAULT_POLLING_DELAY", function () {
          return o;
        }), n.d(t, "DEFAULT_MAX_CLOCK_SKEW", function () {
          return i;
        }), n.d(t, "DEFAULT_CACHE_DURATION", function () {
          return a;
        }), n.d(t, "REDIRECT_OAUTH_PARAMS_NAME", function () {
          return s;
        }), n.d(t, "REDIRECT_STATE_COOKIE_NAME", function () {
          return l;
        }), n.d(t, "REDIRECT_NONCE_COOKIE_NAME", function () {
          return u;
        }), n.d(t, "TOKEN_STORAGE_NAME", function () {
          return c;
        }), n.d(t, "CACHE_STORAGE_NAME", function () {
          return d;
        }), n.d(t, "PKCE_STORAGE_NAME", function () {
          return f;
        }), n.d(t, "TRANSACTION_STORAGE_NAME", function () {
          return p;
        }), n.d(t, "ACCESS_TOKEN_STORAGE_KEY", function () {
          return h;
        }), n.d(t, "ID_TOKEN_STORAGE_KEY", function () {
          return m;
        }), n.d(t, "REFRESH_TOKEN_STORAGE_KEY", function () {
          return g;
        }), n.d(t, "REFERRER_PATH_STORAGE_KEY", function () {
          return v;
        }), n.d(t, "MIN_VERIFIER_LENGTH", function () {
          return y;
        }), n.d(t, "MAX_VERIFIER_LENGTH", function () {
          return b;
        }), n.d(t, "DEFAULT_CODE_CHALLENGE_METHOD", function () {
          return _;
        });
        var r = "oktaStateToken",
            o = 500,
            i = 300,
            a = 86400,
            s = "okta-oauth-redirect-params",
            l = "okta-oauth-state",
            u = "okta-oauth-nonce",
            c = "okta-token-storage",
            d = "okta-cache-storage",
            f = "okta-pkce-storage",
            p = "okta-transaction-storage",
            h = "accessToken",
            m = "idToken",
            g = "refreshToken",
            v = "referrerPath",
            y = 43,
            b = 128,
            _ = "S256";
      }, function (e, t) {
        e.exports = function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        };
      }, function (e, t, n) {
        e.exports = n(42);
      }, function (e, t, n) {
        "use strict";

        function r(e, t) {
          var n = (t = t || {}).url,
              r = t.method,
              s = t.args,
              l = t.saveAuthnState,
              u = t.accessToken,
              c = !1 !== t.withCredentials,
              d = e.options.storageUtil.storage,
              f = e.storageManager.getHttpCache(e.options.cookies);

          if (t.cacheResponse) {
            var p = f.getStorage()[n];
            if (p && Date.now() / 1e3 < p.expiresAt) return Promise.resolve(p.response);
          }

          var h = {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Okta-User-Agent-Extended": e.userAgent
          };
          Object.assign(h, e.options.headers, t.headers), h = Object(o.y)(h), u && Object(o.v)(u) && (h.Authorization = "Bearer " + u);
          var m,
              g,
              v = {
            headers: h,
            data: s || void 0,
            withCredentials: c
          };
          return e.options.httpRequestClient(r, n, v).then(function (r) {
            return (g = r.responseText) && Object(o.v)(g) && (g = JSON.parse(g)), l && (g.stateToken || d.delete(a.STATE_TOKEN_KEY_NAME)), g && g.stateToken && g.expiresAt && d.set(a.STATE_TOKEN_KEY_NAME, g.stateToken, g.expiresAt, e.options.cookies), g && t.cacheResponse && f.updateStorage(n, {
              expiresAt: Math.floor(Date.now() / 1e3) + a.DEFAULT_CACHE_DURATION,
              response: g
            }), g;
          }).catch(function (t) {
            var n = t.responseText || {};
            if (Object(o.v)(n)) try {
              n = JSON.parse(n);
            } catch (e) {
              n = {
                errorSummary: "Unknown error"
              };
            }
            throw t.status >= 500 && (n.errorSummary = "Unknown error"), e.options.transformErrorXHR && (t = e.options.transformErrorXHR(Object(o.f)(t))), "E0000011" === (m = new i.a(n, t)).errorCode && d.delete(a.STATE_TOKEN_KEY_NAME), m;
          });
        }

        var o = n(0),
            i = n(21),
            a = n(3);
        t.a = {
          get: function get(e, t, n) {
            var i = {
              url: t = Object(o.p)(t) ? t : e.getIssuerOrigin() + t,
              method: "GET"
            };
            return Object.assign(i, n), r(e, i);
          },
          post: function post(e, t, n, i) {
            var a = {
              url: t = Object(o.p)(t) ? t : e.getIssuerOrigin() + t,
              method: "POST",
              args: n,
              saveAuthnState: !0
            };
            return Object.assign(a, i), r(e, a);
          },
          httpRequest: r
        };
      }, function (e, t, n) {
        "use strict";

        n.r(t);
        var r = n(27);

        for (var o in r) {
          "default" !== o && function (e) {
            n.d(t, e, function () {
              return r[e];
            });
          }(o);
        }

        var i = n(20);

        for (var o in i) {
          "default" !== o && function (e) {
            n.d(t, e, function () {
              return i[e];
            });
          }(o);
        }

        var a = n(28);
        n.d(t, "isOAuthTransactionMeta", function () {
          return a.c;
        }), n.d(t, "isPKCETransactionMeta", function () {
          return a.d;
        }), n.d(t, "isIdxTransactionMeta", function () {
          return a.b;
        }), n.d(t, "isCustomAuthTransactionMeta", function () {
          return a.a;
        }), n.d(t, "isTransactionMeta", function () {
          return a.e;
        });
        var s = n(29);

        for (var o in s) {
          ["isOAuthTransactionMeta", "isPKCETransactionMeta", "isIdxTransactionMeta", "isCustomAuthTransactionMeta", "isTransactionMeta", "default"].indexOf(o) < 0 && function (e) {
            n.d(t, e, function () {
              return s[e];
            });
          }(o);
        }

        var l = n(30);

        for (var o in l) {
          ["isOAuthTransactionMeta", "isPKCETransactionMeta", "isIdxTransactionMeta", "isCustomAuthTransactionMeta", "isTransactionMeta", "default"].indexOf(o) < 0 && function (e) {
            n.d(t, e, function () {
              return l[e];
            });
          }(o);
        }

        var u = n(31);

        for (var o in u) {
          ["isOAuthTransactionMeta", "isPKCETransactionMeta", "isIdxTransactionMeta", "isCustomAuthTransactionMeta", "isTransactionMeta", "default"].indexOf(o) < 0 && function (e) {
            n.d(t, e, function () {
              return u[e];
            });
          }(o);
        }

        var c = n(32);

        for (var o in c) {
          ["isOAuthTransactionMeta", "isPKCETransactionMeta", "isIdxTransactionMeta", "isCustomAuthTransactionMeta", "isTransactionMeta", "default"].indexOf(o) < 0 && function (e) {
            n.d(t, e, function () {
              return c[e];
            });
          }(o);
        }

        var d = n(33);

        for (var o in d) {
          ["isOAuthTransactionMeta", "isPKCETransactionMeta", "isIdxTransactionMeta", "isCustomAuthTransactionMeta", "isTransactionMeta", "default"].indexOf(o) < 0 && function (e) {
            n.d(t, e, function () {
              return d[e];
            });
          }(o);
        }

        var f = n(34);

        for (var o in f) {
          ["isOAuthTransactionMeta", "isPKCETransactionMeta", "isIdxTransactionMeta", "isCustomAuthTransactionMeta", "isTransactionMeta", "default"].indexOf(o) < 0 && function (e) {
            n.d(t, e, function () {
              return f[e];
            });
          }(o);
        }

        var p = n(35);
        n.d(t, "isToken", function () {
          return p.d;
        }), n.d(t, "isAccessToken", function () {
          return p.a;
        }), n.d(t, "isIDToken", function () {
          return p.b;
        }), n.d(t, "isRefreshToken", function () {
          return p.c;
        });
        var h = n(36);

        for (var o in h) {
          ["isOAuthTransactionMeta", "isPKCETransactionMeta", "isIdxTransactionMeta", "isCustomAuthTransactionMeta", "isTransactionMeta", "isToken", "isAccessToken", "isIDToken", "isRefreshToken", "default"].indexOf(o) < 0 && function (e) {
            n.d(t, e, function () {
              return h[e];
            });
          }(o);
        }

        for (var o in i) {
          ["isOAuthTransactionMeta", "isPKCETransactionMeta", "isIdxTransactionMeta", "isCustomAuthTransactionMeta", "isTransactionMeta", "isToken", "isAccessToken", "isIDToken", "isRefreshToken", "default"].indexOf(o) < 0 && function (e) {
            n.d(t, e, function () {
              return i[e];
            });
          }(o);
        }
      }, function (e, t, n) {
        "use strict";

        function r(e) {
          if (!e.clientId) throw new $.c("A clientId must be specified in the OktaAuth constructor to get a token");
          if (Object(z.v)(e.responseType) && -1 !== e.responseType.indexOf(" ")) throw new $.c("Multiple OAuth responseTypes must be defined as an array");
          var t = {
            client_id: e.clientId,
            code_challenge: e.codeChallenge,
            code_challenge_method: e.codeChallengeMethod,
            display: e.display,
            idp: e.idp,
            idp_scope: e.idpScope,
            login_hint: e.loginHint,
            max_age: e.maxAge,
            nonce: e.nonce,
            prompt: e.prompt,
            redirect_uri: e.redirectUri,
            response_mode: e.responseMode,
            response_type: e.responseType,
            sessionToken: e.sessionToken,
            state: e.state
          };
          if (t = Object(z.y)(t), ["idp_scope", "response_type"].forEach(function (e) {
            Array.isArray(t[e]) && (t[e] = t[e].join(" "));
          }), -1 !== e.responseType.indexOf("id_token") && -1 === e.scopes.indexOf("openid")) throw new $.c("openid scope must be specified in the scopes argument when requesting an id_token");
          return t.scope = e.scopes.join(" "), t;
        }

        function o(e) {
          var t = r(e);
          return Object(z.D)(t);
        }

        function i(e, t, n) {
          !function (e) {
            if (!e.clientId) throw new $.c("A clientId must be specified in the OktaAuth constructor to get a token");
            if (!e.redirectUri) throw new $.c("The redirectUri passed to /authorize must also be passed to /token");
            if (!e.authorizationCode && !e.interactionCode) throw new $.c("An authorization code (returned from /authorize) must be passed to /token");
            if (!e.codeVerifier) throw new $.c('The "codeVerifier" (generated and saved by your app) must be passed to /token');
          }(t);

          var r = function (e) {
            var t = Object(z.y)({
              client_id: e.clientId,
              redirect_uri: e.redirectUri,
              grant_type: e.interactionCode ? "interaction_code" : "authorization_code",
              code_verifier: e.codeVerifier
            });
            return e.interactionCode ? t.interaction_code = e.interactionCode : e.authorizationCode && (t.code = e.authorizationCode), Object(z.D)(t).slice(1);
          }(t);

          return Y.a.httpRequest(e, {
            url: n.tokenUrl,
            method: "POST",
            args: r,
            withCredentials: !1,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          });
        }

        function a(e, t, n) {
          return Y.a.httpRequest(e, {
            url: n.tokenUrl,
            method: "POST",
            withCredentials: !1,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            args: Object.entries({
              client_id: t.clientId,
              grant_type: "refresh_token",
              scope: n.scopes.join(" "),
              refresh_token: n.refreshToken
            }).map(function (e) {
              var t = G()(e, 2),
                  n = t[0],
                  r = t[1];
              return n + "=" + encodeURIComponent(r);
            }).join("&")
          });
        }

        function s(e, t) {
          var n = t || e.options.issuer;
          return Y.a.get(e, n + "/.well-known/openid-configuration", {
            cacheResponse: !0
          });
        }

        function l(e, t, n) {
          var r = e.storageManager.getHttpCache(e.options.cookies);
          return s(e, t).then(function (t) {
            var o = t.jwks_uri,
                i = r.getStorage()[o];

            if (i && Date.now() / 1e3 < i.expiresAt) {
              var a = Object(z.k)(i.response.keys, {
                kid: n
              });
              if (a) return a;
            }

            return r.clearStorage(o), Y.a.get(e, o, {
              cacheResponse: !0
            }).then(function (e) {
              var t = Object(z.k)(e.keys, {
                kid: n
              });
              if (t) return t;
              throw new J.a("The key id, " + n + ", was not found in the server's keys");
            });
          });
        }

        function u(e, t, n) {
          e.addEventListener ? e.addEventListener(t, n) : e.attachEvent("on" + t, n);
        }

        function c(e, t, n) {
          e.removeEventListener ? e.removeEventListener(t, n) : e.detachEvent("on" + t, n);
        }

        function d(e) {
          var t = document.createElement("iframe");
          return t.style.display = "none", t.src = e, document.body.appendChild(t);
        }

        function f(e, t) {
          var n = t.popupTitle || "External Identity Provider User Authentication",
              r = "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600";

          if (Object(z.r)()) {
            var o = window.open("/", n, r);
            return o.location.href = e, o;
          }

          return window.open(e, n, r);
        }

        function p(e, t, n) {
          var r, o;
          return new Promise(function (i, a) {
            r = function r(t) {
              if (t.data && t.data.state === n) return t.origin !== e.getIssuerOrigin() ? a(new $.c("The request does not match client configuration")) : void i(t.data);
            }, u(window, "message", r), o = setTimeout(function () {
              a(new $.c("OAuth flow timed out"));
            }, t || 12e4);
          }).finally(function () {
            clearTimeout(o), c(window, "message", r);
          });
        }

        function h() {
          return Object(z.l)(64);
        }

        function m() {
          return Object(z.l)(64);
        }

        function g(e, t) {
          if (arguments.length > 2) throw new J.a('As of version 3.0, "getOAuthUrls" takes only a single set of options');
          t = t || {};
          var n = Object(z.z)(t.authorizeUrl) || e.options.authorizeUrl,
              r = Object(z.z)(t.issuer) || e.options.issuer,
              o = Object(z.z)(t.userinfoUrl) || e.options.userinfoUrl,
              i = Object(z.z)(t.tokenUrl) || e.options.tokenUrl,
              a = Object(z.z)(t.logoutUrl) || e.options.logoutUrl,
              s = Object(z.z)(t.revokeUrl) || e.options.revokeUrl,
              l = r.indexOf("/oauth2") > 0 ? r : r + "/oauth2";
          return {
            issuer: r,
            authorizeUrl: n = n || l + "/v1/authorize",
            userinfoUrl: o = o || l + "/v1/userinfo",
            tokenUrl: i = i || l + "/v1/token",
            revokeUrl: s = s || l + "/v1/revoke",
            logoutUrl: a = a || l + "/v1/logout"
          };
        }

        function v(e) {
          var t = e.options,
              n = t.pkce,
              r = t.clientId,
              o = t.redirectUri,
              i = t.responseType,
              a = t.responseMode,
              s = t.scopes,
              l = t.state,
              u = t.ignoreSignature;
          return {
            pkce: n,
            clientId: r,
            redirectUri: o || window.location.href,
            responseType: i || ["token", "id_token"],
            responseMode: a,
            state: l || h(),
            nonce: m(),
            scopes: s || ["openid", "email"],
            ignoreSignature: u
          };
        }

        function y(e) {
          return "OAuthError" === e.name && "interaction_required" === e.errorCode;
        }

        function b(e) {
          return /((id|access)_token=)/i.test(e);
        }

        function _(e) {
          return /(code=)/i.test(e);
        }

        function w(e) {
          return /(interaction_code=)/i.test(e);
        }

        function E(e) {
          return /(error=)/i.test(e) || /(error_description)/i.test(e);
        }

        function O(e, t) {
          var n = t.options;
          return e && 0 === e.indexOf(n.redirectUri);
        }

        function S(e) {
          return e.pkce || "code" === e.responseType || "query" === e.responseMode;
        }

        function x(e) {
          return S(e) && "fragment" !== e.responseMode ? window.location.search : window.location.hash;
        }

        function T(e) {
          if (!O(window.location.href, e)) return !1;
          var t = S(e.options),
              n = x(e.options);
          return !!E(n) || (t ? _(n) || w(n) : b(window.location.hash));
        }

        function k(e) {
          return !!T(e) && /(error=interaction_required)/i.test(x(e.options));
        }

        function C(e, t) {
          var n = v(e);
          if (!1 === (t = Object.assign({}, n, Object(z.f)(t))).pkce) return Promise.resolve(t);

          if (!e.features.isPKCESupported()) {
            var r = "PKCE requires a modern browser with encryption support running in a secure context.";
            return e.features.isHTTPS() || (r += "\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."), e.features.hasTextEncoder() || (r += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'), Promise.reject(new $.c(r));
          }

          return t.codeChallengeMethod || (t.codeChallengeMethod = X.DEFAULT_CODE_CHALLENGE_METHOD), t.responseType = "code", s(e, null).then(function (e) {
            if (-1 === (e.code_challenge_methods_supported || []).indexOf(t.codeChallengeMethod)) throw new $.c("Invalid code_challenge_method");
          }).then(function () {
            return t.codeVerifier || (t.codeVerifier = Q.a.generateVerifier()), Q.a.computeChallenge(t.codeVerifier);
          }).then(function (e) {
            var n = Object(z.f)(t) || {};
            return Object.assign(n, t, {
              codeChallenge: e
            }), n;
          });
        }

        function A(e) {
          var t = /\+/g,
              n = /([^&=]+)=?([^&]*)/g,
              r = e;
          "#" === r.charAt(0) && "/" === r.charAt(1) && (r = r.substring(2)), "#" !== r.charAt(0) && "?" !== r.charAt(0) || (r = r.substring(1));

          for (var o, i = {}; o = n.exec(r);) {
            var a = o[1],
                s = o[2];
            i[a] = "id_token" === a || "access_token" === a || "code" === a ? s : decodeURIComponent(s.replace(t, " "));
          }

          return i;
        }

        function N(e, t, n) {
          var r = n.clientId,
              o = n.issuer,
              i = n.nonce;
          if (!t || !o || !r) throw new J.a("The jwt, iss, and aud arguments are all required");
          if (i && t.nonce !== i) throw new J.a("OAuth flow response nonce doesn't match request nonce");
          var a = Math.floor(Date.now() / 1e3);
          if (t.iss !== o) throw new J.a("The issuer [" + t.iss + "] does not match [" + o + "]");
          if (t.aud !== r) throw new J.a("The audience [" + t.aud + "] does not match [" + r + "]");
          if (t.iat > t.exp) throw new J.a("The JWT expired before it was issued");
          if (a - e.options.maxClockSkew > t.exp) throw new J.a("The JWT expired and is no longer valid");
          if (t.iat > a + e.options.maxClockSkew) throw new J.a("The JWT was issued in the future");
        }

        function P(e) {
          var t,
              n = e.split(".");

          try {
            t = {
              header: JSON.parse(Object(z.d)(n[0])),
              payload: JSON.parse(Object(z.d)(n[1])),
              signature: n[2]
            };
          } catch (e) {
            throw new $.c("Malformed token");
          }

          return t;
        }

        function R(e, t) {
          return Promise.resolve().then(function () {
            var n, r;
            if (t && (n = t.accessToken, r = t.refreshToken), !n && !r) throw new J.a("A valid access or refresh token object is required");
            var o = e.options.clientId;
            if (!o) throw new J.a("A clientId must be specified in the OktaAuth constructor to revoke a token");
            var i = g(e).revokeUrl,
                a = Object(z.D)({
              token_type_hint: r ? "refresh_token" : "access_token",
              token: r || n
            }).slice(1),
                s = btoa(o);
            return Y.a.post(e, i, a, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Basic " + s
              }
            });
          });
        }

        function I(e, t, n) {
          n = n || g(e, t);
          var r = t = Object.assign({}, v(e), Object(z.f)(t)),
              o = r.authorizationCode,
              a = r.interactionCode,
              s = r.codeVerifier,
              l = r.clientId,
              u = r.redirectUri,
              c = r.scopes,
              d = r.ignoreSignature;
          return i(e, {
            clientId: l,
            redirectUri: u,
            authorizationCode: o,
            interactionCode: a,
            codeVerifier: s
          }, n).then(function (t) {
            var r = ["token"];
            return -1 !== c.indexOf("openid") && r.push("id_token"), L(e, {
              clientId: l,
              redirectUri: u,
              scopes: c,
              responseType: r,
              ignoreSignature: d
            }, t, n).then(function (e) {
              return e.code = o, e;
            });
          });
        }

        function M(e, t) {
          t = Object(z.f)(t);
          var n = {
            name: "RSASSA-PKCS1-v1_5",
            hash: {
              name: "SHA-256"
            }
          };
          return delete t.use, crypto.subtle.importKey("jwk", t, n, !0, ["verify"]).then(function (t) {
            var r = e.split("."),
                o = Object(z.B)(r[0] + "." + r[1]),
                i = Object(z.b)(r[2]),
                a = Object(z.B)(i);
            return crypto.subtle.verify(n, t, a, o);
          });
        }

        function j(e, t, n) {
          return ne(this, void 0, void 0, te.a.mark(function r() {
            var o, i, a, u;
            return te.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    if (t && t.idToken) {
                      r.next = 2;
                      break;
                    }

                    throw new $.c("Only idTokens may be verified");

                  case 2:
                    return o = P(t.idToken), r.next = 5, s(e);

                  case 5:
                    if (i = r.sent, a = {
                      issuer: i.issuer,
                      clientId: e.options.clientId,
                      ignoreSignature: e.options.ignoreSignature
                    }, Object.assign(a, n), N(e, o.payload, a), 1 != a.ignoreSignature && e.features.isTokenVerifySupported()) {
                      r.next = 11;
                      break;
                    }

                    return r.abrupt("return", t);

                  case 11:
                    return r.next = 13, l(e, t.issuer, o.header.kid);

                  case 13:
                    return u = r.sent, r.next = 16, M(t.idToken, u);

                  case 16:
                    if (r.sent) {
                      r.next = 19;
                      break;
                    }

                    throw new $.c("The token signature is not valid");

                  case 19:
                    if (!(n && n.accessToken && t.claims.at_hash)) {
                      r.next = 25;
                      break;
                    }

                    return r.next = 22, c = n.accessToken, d = void 0, d = new TextEncoder().encode(c), crypto.subtle.digest("SHA-256", d).then(function (e) {
                      var t = new Uint8Array(e).slice(0, 16),
                          n = String.fromCharCode.apply(null, t);
                      return Object(z.A)(n);
                    });

                  case 22:
                    if (r.sent === t.claims.at_hash) {
                      r.next = 25;
                      break;
                    }

                    throw new $.c("Token hash verification failed");

                  case 25:
                    return r.abrupt("return", t);

                  case 26:
                  case "end":
                    return r.stop();
                }
              }

              var c, d;
            }, r);
          }));
        }

        function L(e, t, n, r) {
          if (!1 !== e.options.pkce && (n.code || n.interaction_code)) return I(e, Object.assign({}, t, {
            authorizationCode: n.code,
            interactionCode: n.interaction_code
          }), r);
          t = t || v(e), r = r || g(e, t);
          var o,
              i = t.responseType;
          Array.isArray(i) || (i = [i]), o = n.scope ? n.scope.split(" ") : Object(z.f)(t.scopes);
          var a = t.clientId || e.options.clientId;
          return Promise.resolve().then(function () {
            !function (e, t) {
              if (e.error || e.error_description) throw new $.d(e.error, e.error_description);
              if (e.state !== t.state) throw new $.c("OAuth flow response state doesn't match request state");
            }(n, t);
          }).then(function () {
            var i = {},
                s = n.expires_in,
                l = n.token_type,
                u = n.access_token,
                c = n.id_token,
                d = n.refresh_token;

            if (u) {
              var f = e.token.decode(u);
              i.accessToken = {
                value: u,
                accessToken: u,
                claims: f.payload,
                expiresAt: Number(s) + Math.floor(Date.now() / 1e3),
                tokenType: l,
                scopes: o,
                authorizeUrl: r.authorizeUrl,
                userinfoUrl: r.userinfoUrl
              };
            }

            if (d && (i.refreshToken = {
              value: d,
              refreshToken: d,
              expiresAt: Number(s) + Math.floor(Date.now() / 1e3),
              scopes: o,
              tokenUrl: r.tokenUrl,
              authorizeUrl: r.authorizeUrl,
              issuer: r.issuer
            }), c) {
              var p = e.token.decode(c),
                  h = {
                value: c,
                idToken: c,
                claims: p.payload,
                expiresAt: p.payload.exp,
                scopes: o,
                authorizeUrl: r.authorizeUrl,
                issuer: r.issuer,
                clientId: a
              },
                  m = {
                clientId: a,
                issuer: r.issuer,
                nonce: t.nonce,
                accessToken: u
              };
              return void 0 !== t.ignoreSignature && (m.ignoreSignature = t.ignoreSignature), j(e, h, m).then(function () {
                return i.idToken = h, i;
              });
            }

            return i;
          }).then(function (e) {
            if (-1 !== i.indexOf("token") && !e.accessToken) throw new $.c('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
            if (-1 !== i.indexOf("id_token") && !e.idToken) throw new $.c('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
            return {
              tokens: e,
              state: n.state,
              code: n.code
            };
          });
        }

        function D(e, t) {
          return arguments.length > 2 ? Promise.reject(new J.a('As of version 3.0, "getToken" takes only a single set of options')) : C(e, t = t || {}).then(function (n) {
            var r, i;

            switch (t.sessionToken ? Object.assign(n, {
              prompt: "none",
              responseMode: "okta_post_message",
              display: null
            }) : t.idp && Object.assign(n, {
              display: "popup"
            }), i = g(e, n), r = (t.codeVerifier ? i.tokenUrl : i.authorizeUrl) + o(n), n.sessionToken || null === n.display ? "IFRAME" : "popup" === n.display ? "POPUP" : "IMPLICIT") {
              case "IFRAME":
                var a = p(e, t.timeout, n.state),
                    s = d(r);
                return a.then(function (t) {
                  return L(e, n, t, i);
                }).finally(function () {
                  document.body.contains(s) && s.parentElement.removeChild(s);
                });

              case "POPUP":
                var l;

                if ("okta_post_message" === n.responseMode) {
                  if (!e.features.isPopupPostMessageSupported()) throw new J.a("This browser doesn't have full postMessage support");
                  l = p(e, t.timeout, n.state);
                }

                var u = f(r, {
                  popupTitle: t.popupTitle
                });
                return new Promise(function (e, t) {
                  var n = setInterval(function () {
                    u && !u.closed || (clearInterval(n), t(new J.a("Unable to parse OAuth flow response")));
                  }, 100);
                  l.then(function (t) {
                    clearInterval(n), e(t);
                  }).catch(function (e) {
                    clearInterval(n), t(e);
                  });
                }).then(function (t) {
                  return L(e, n, t, i);
                }).finally(function () {
                  u && !u.closed && u.close();
                });

              default:
                throw new J.a("The full page redirect flow is not supported");
            }
          });
        }

        function F(e, t) {
          return arguments.length > 2 ? Promise.reject(new $.c('As of version 3.0, "getWithoutPrompt" takes only a single set of options')) : (t = Object(z.f)(t) || {}, Object.assign(t, {
            prompt: "none",
            responseMode: "okta_post_message",
            display: null
          }), D(e, t));
        }

        function U(e, t) {
          return Object(Z.isToken)(t) ? F(e, {
            responseType: e.options.pkce ? "code" : Object(Z.isAccessToken)(t) ? "token" : "id_token",
            scopes: t.scopes,
            authorizeUrl: t.authorizeUrl,
            userinfoUrl: t.userinfoUrl,
            issuer: t.issuer
          }).then(function (e) {
            var n = e.tokens;
            return Object(Z.isIDToken)(t) ? n.idToken : n.accessToken;
          }) : Promise.reject(new $.c("Renew must be passed a token with an array of scopes and an accessToken or idToken"));
        }

        function B(e, t) {
          return e.tokenManager.getTokens().then(function (e) {
            return e.refreshToken;
          }).then(function (n) {
            if (n) return function (e, t, n) {
              return re(this, void 0, void 0, te.a.mark(function r() {
                var o, i, s, l, u, c;
                return te.a.wrap(function (r) {
                  for (;;) {
                    switch (r.prev = r.next) {
                      case 0:
                        if (o = e.options.clientId) {
                          r.next = 3;
                          break;
                        }

                        throw new $.c("A clientId must be specified in the OktaAuth constructor to renew tokens");

                      case 3:
                        return i = Object.assign({}, t, {
                          clientId: o
                        }), r.next = 6, a(e, i, n);

                      case 6:
                        return s = r.sent, l = g(e, t), r.next = 10, L(e, i, s, l);

                      case 10:
                        return u = r.sent, c = u.tokens, r.abrupt("return", c);

                      case 13:
                      case "end":
                        return r.stop();
                    }
                  }
                }, r);
              }));
            }(e, t, n);
            if (t = Object.assign({
              scopes: e.options.scopes,
              authorizeUrl: e.options.authorizeUrl,
              userinfoUrl: e.options.userinfoUrl,
              issuer: e.options.issuer
            }, t), e.options.pkce) t.responseType = "code";else {
              var r = v(e).responseType;
              t.responseType = r;
            }
            return F(e, t).then(function (e) {
              return e.tokens;
            });
          });
        }

        function V(e, t, n) {
          return oe(this, void 0, void 0, te.a.mark(function r() {
            return te.a.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    if (t) {
                      r.next = 4;
                      break;
                    }

                    return r.next = 3, e.tokenManager.getTokens();

                  case 3:
                    t = r.sent.accessToken;

                  case 4:
                    if (n) {
                      r.next = 8;
                      break;
                    }

                    return r.next = 7, e.tokenManager.getTokens();

                  case 7:
                    n = r.sent.idToken;

                  case 8:
                    if (t && Object(Z.isAccessToken)(t)) {
                      r.next = 10;
                      break;
                    }

                    return r.abrupt("return", Promise.reject(new $.c("getUserInfo requires an access token object")));

                  case 10:
                    if (n && Object(Z.isIDToken)(n)) {
                      r.next = 12;
                      break;
                    }

                    return r.abrupt("return", Promise.reject(new $.c("getUserInfo requires an ID token object")));

                  case 12:
                    return r.abrupt("return", Y.a.httpRequest(e, {
                      url: t.userinfoUrl,
                      method: "GET",
                      accessToken: t.accessToken
                    }).then(function (e) {
                      return e.sub === n.claims.sub ? e : Promise.reject(new $.c("getUserInfo request was rejected due to token mismatch"));
                    }).catch(function (e) {
                      var t;

                      if (e.xhr && (401 === e.xhr.status || 403 === e.xhr.status) && (e.xhr.headers && Object(z.q)(e.xhr.headers.get) && e.xhr.headers.get("WWW-Authenticate") ? t = e.xhr.headers.get("WWW-Authenticate") : Object(z.q)(e.xhr.getResponseHeader) && (t = e.xhr.getResponseHeader("WWW-Authenticate")), t)) {
                        var n = t.match(/error="(.*?)"/) || [],
                            r = t.match(/error_description="(.*?)"/) || [],
                            o = n[1],
                            i = r[1];
                        o && i && (e = new $.d(o, i));
                      }

                      throw e;
                    }));

                  case 13:
                  case "end":
                    return r.stop();
                }
              }
            }, r);
          }));
        }

        function H(e, t) {
          return arguments.length > 2 ? Promise.reject(new $.c('As of version 3.0, "getWithPopup" takes only a single set of options')) : (t = Object(z.f)(t) || {}, Object.assign(t, {
            display: "popup",
            responseMode: "okta_post_message"
          }), D(e, t));
        }

        function q(e, t) {
          return arguments.length > 2 ? Promise.reject(new $.c('As of version 3.0, "getWithRedirect" takes only a single set of options')) : (t = Object(z.f)(t) || {}, C(e, t).then(function (n) {
            var r = g(e, t),
                i = r.authorizeUrl + o(n),
                a = {
              responseType: n.responseType,
              state: n.state,
              nonce: n.nonce,
              scopes: n.scopes,
              clientId: n.clientId,
              urls: r,
              ignoreSignature: n.ignoreSignature,
              redirectUri: n.redirectUri,
              codeVerifier: n.codeVerifier,
              codeChallenge: n.codeChallenge,
              codeChallengeMethod: n.codeChallengeMethod
            };
            e.transactionManager.save(a, {
              oauth: !0
            }), e.token.getWithRedirect._setLocation(i);
          }));
        }

        function W(e, t) {
          t = t || {}, t = Object(z.v)(t) ? {
            url: t
          } : t;

          var n,
              r = e.options.pkce ? "query" : "fragment",
              o = t.url,
              i = t.responseMode || e.options.responseMode || r,
              a = e.token.parseFromUrl._getLocation();

          if (!(n = "query" === i ? o ? o.substring(o.indexOf("?")) : a.search : o ? o.substring(o.indexOf("#")) : a.hash)) return Promise.reject(new $.c("Unable to parse a token from the url"));
          var s = e.transactionManager.load({
            oauth: !0,
            pkce: e.options.pkce
          }),
              l = s.urls;
          return delete s.urls, Promise.resolve(A(n)).then(function (t) {
            return o || ("query" === i ? function (e) {
              var t = e.token.parseFromUrl._getHistory(),
                  n = e.token.parseFromUrl._getDocument(),
                  r = e.token.parseFromUrl._getLocation();

              t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.hash) : r.search = "";
            }(e) : function (e) {
              var t = e.token.parseFromUrl._getHistory(),
                  n = e.token.parseFromUrl._getDocument(),
                  r = e.token.parseFromUrl._getLocation();

              t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.search) : r.hash = "";
            }(e)), L(e, s, t, l).finally(function () {
              e.transactionManager.clear();
            });
          });
        }

        n.d(t, "d", function () {
          return r;
        }), n.d(t, "c", function () {
          return o;
        }), n.d(t, "H", function () {
          return i;
        }), n.d(t, "G", function () {
          return a;
        }), n.d(t, "o", function () {
          return s;
        }), n.d(t, "k", function () {
          return l;
        }), n.d(t, "a", function () {
          return u;
        }), n.d(t, "J", function () {
          return c;
        }), n.d(t, "C", function () {
          return d;
        }), n.d(t, "D", function () {
          return f;
        }), n.d(t, "b", function () {
          return p;
        }), n.d(t, "i", function () {
          return v;
        }), n.d(t, "z", function () {
          return y;
        }), n.d(t, "w", function () {
          return b;
        }), n.d(t, "t", function () {
          return _;
        }), n.d(t, "v", function () {
          return w;
        }), n.d(t, "u", function () {
          return E;
        }), n.d(t, "B", function () {
          return O;
        }), n.d(t, "x", function () {
          return S;
        }), n.d(t, "j", function () {
          return x;
        }), n.d(t, "A", function () {
          return T;
        }), n.d(t, "y", function () {
          return k;
        }), n.d(t, "h", function () {
          return h;
        }), n.d(t, "g", function () {
          return m;
        }), n.d(t, "l", function () {
          return g;
        }), n.d(t, "F", function () {
          return Q.a;
        }), n.d(t, "I", function () {
          return C;
        }), n.d(t, "N", function () {
          return A;
        }), n.d(t, "O", function () {
          return N;
        }), n.d(t, "e", function () {
          return P;
        }), n.d(t, "M", function () {
          return R;
        }), n.d(t, "K", function () {
          return U;
        }), n.d(t, "L", function () {
          return B;
        }), n.d(t, "P", function () {
          return j;
        }), n.d(t, "n", function () {
          return V;
        }), n.d(t, "s", function () {
          return L;
        }), n.d(t, "f", function () {
          return I;
        }), n.d(t, "m", function () {
          return D;
        }), n.d(t, "r", function () {
          return F;
        }), n.d(t, "p", function () {
          return H;
        }), n.d(t, "q", function () {
          return q;
        }), n.d(t, "E", function () {
          return W;
        });

        var z = n(0),
            $ = n(1),
            K = n(40),
            G = n.n(K),
            Y = n(6),
            J = n(2),
            Q = n(15),
            X = n(3),
            Z = n(7),
            ee = n(5),
            te = n.n(ee),
            ne = function ne(e, t, n, r) {
          return new (n || (n = Promise))(function (o, i) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                i(e);
              }
            }

            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                i(e);
              }
            }

            function l(e) {
              var t;
              e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                e(t);
              })).then(a, s);
            }

            l((r = r.apply(e, t || [])).next());
          });
        },
            re = function re(e, t, n, r) {
          return new (n || (n = Promise))(function (o, i) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                i(e);
              }
            }

            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                i(e);
              }
            }

            function l(e) {
              var t;
              e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                e(t);
              })).then(a, s);
            }

            l((r = r.apply(e, t || [])).next());
          });
        },
            oe = function oe(e, t, n, r) {
          return new (n || (n = Promise))(function (o, i) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                i(e);
              }
            }

            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                i(e);
              }
            }

            function l(e) {
              var t;
              e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                e(t);
              })).then(a, s);
            }

            l((r = r.apply(e, t || [])).next());
          });
        };
      }, function (e, t) {
        e.exports = function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        };
      }, function (e, t) {
        function n(t) {
          return e.exports = n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, n(t);
        }

        e.exports = n;
      }, function (e, t) {
        function n(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        e.exports = function (e, t, r) {
          return t && n(e.prototype, t), r && n(e, r), e;
        };
      }, function (e, t, n) {
        var r = n(25);

        e.exports = function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && r(e, t);
        };
      }, function (e, t, n) {
        var r = n(18),
            o = n(9);

        e.exports = function (e, t) {
          return !t || "object" !== r(t) && "function" != typeof t ? o(e) : t;
        };
      }, function (e, t, n) {
        "use strict";

        function r(e, t) {
          var n = {};
          return Object.assign(n, t), !n.stateToken && e.stateToken && (n.stateToken = e.stateToken), n;
        }

        function o(e) {
          return r(e);
        }

        function i(e, t, n) {
          return function (r) {
            var i, a, s, l;
            Object(y.s)(r) ? i = r : Object(y.t)(r) && (i = (r = r).delay, a = r.rememberDevice, s = r.autoPush, l = r.transactionCallBack), i || 0 === i || (i = m.DEFAULT_POLLING_DELAY);
            var u = Object(y.n)(t, "next", "poll");
            n.isPolling = !0;
            var c = 0;
            return function r() {
              return n.isPolling ? function () {
                var n = {};
                if ("function" == typeof s) try {
                  n.autoPush = !!s();
                } catch (e) {
                  return Promise.reject(new h.a("AutoPush resulted in an error."));
                } else null != s && (n.autoPush = !!s);
                if ("function" == typeof a) try {
                  n.rememberDevice = !!a();
                } catch (e) {
                  return Promise.reject(new h.a("RememberDevice resulted in an error."));
                } else null != a && (n.rememberDevice = !!a);
                var r = u.href + Object(y.D)(n);
                return p.a.post(e, r, o(t), {
                  saveAuthnState: !1
                });
              }().then(function (t) {
                if (c = 0, t.factorResult && "WAITING" === t.factorResult) {
                  if (!n.isPolling) throw new b.a();
                  return "function" == typeof l && l(t), Object(y.g)(i).then(r);
                }

                return n.isPolling = !1, new _(e, t);
              }).catch(function (e) {
                if (e.xhr && (0 === e.xhr.status || 429 === e.xhr.status) && c <= 4) {
                  var t = 1e3 * Math.pow(2, c);
                  return c++, Object(y.g)(t).then(r);
                }

                throw e;
              }) : Promise.reject(new b.a());
            }().catch(function (e) {
              throw n.isPolling = !1, e;
            });
          };
        }

        function a(e, t, n, o, i) {
          if (Array.isArray(o)) return function (r, s) {
            if (!r) throw new h.a("Must provide a link name");
            var l = Object(y.k)(o, {
              name: r
            });
            if (!l) throw new h.a("No link found for that name");
            return a(e, t, n, l, i)(s);
          };
          if (o.hints && o.hints.allow && 1 === o.hints.allow.length) switch (o.hints.allow[0]) {
            case "GET":
              return function () {
                return p.a.get(e, o.href);
              };

            case "POST":
              return function (a) {
                i && i.isPolling && (i.isPolling = !1);
                var s = r(t, a);
                "MFA_ENROLL" !== t.status && "FACTOR_ENROLL" !== t.status || Object.assign(s, {
                  factorType: n.factorType,
                  provider: n.provider
                });
                var l = {},
                    u = s.autoPush;

                if (void 0 !== u) {
                  if ("function" == typeof u) try {
                    l.autoPush = !!u();
                  } catch (e) {
                    return Promise.reject(new h.a("AutoPush resulted in an error."));
                  } else null !== u && (l.autoPush = !!u);
                  s = Object(y.x)(s, "autoPush");
                }

                var c = s.rememberDevice;

                if (void 0 !== c) {
                  if ("function" == typeof c) try {
                    l.rememberDevice = !!c();
                  } catch (e) {
                    return Promise.reject(new h.a("RememberDevice resulted in an error."));
                  } else null !== c && (l.rememberDevice = !!c);
                  s = Object(y.x)(s, "rememberDevice");
                } else s.profile && void 0 !== s.profile.updatePhone && (s.profile.updatePhone && (l.updatePhone = !0), s.profile = Object(y.x)(s.profile, "updatePhone"));

                var d = o.href + Object(y.D)(l);
                return f(e, d, s);
              };
          }
        }

        function s(e, t, n, r) {
          if (n = n || t, n = Object(y.f)(n), Array.isArray(n)) {
            for (var o = [], l = 0, u = n.length; l < u; l++) {
              o.push(s(e, t, n[l], r));
            }

            return o;
          }

          var c = n._embedded || {};

          for (var d in c) {
            Object.prototype.hasOwnProperty.call(c, d) && (Object(y.t)(c[d]) || Array.isArray(c[d])) && (c[d] = s(e, t, c[d], r));
          }

          var f = function (e, t, n, r) {
            var o = {};

            for (var s in n._links) {
              if (Object.prototype.hasOwnProperty.call(n._links, s)) {
                var l = n._links[s];
                if ("next" === s && (s = l.name), l.type) o[s] = l;else switch (s) {
                  case "poll":
                    o.poll = i(e, t, r);
                    break;

                  default:
                    var u = a(e, t, n, l, r);
                    u && (o[s] = u);
                }
              }
            }

            return o;
          }(e, t, n, r);

          return Object.assign(c, f), n = Object(y.x)(n, "_embedded", "_links"), Object.assign(n, c), n;
        }

        function l(e, t) {
          return t = r(e, t), p.a.post(e, e.getIssuerOrigin() + "/api/v1/authn", t);
        }

        function u(e, t) {
          if (!t || !t.stateToken) {
            var n = e.tx.exists._get(m.STATE_TOKEN_KEY_NAME);

            if (!n) return Promise.reject(new h.a("No transaction to resume"));
            t = {
              stateToken: n
            };
          }

          return e.tx.status(t).then(function (t) {
            return new _(e, t);
          });
        }

        function c(e, t) {
          if (!t || !t.stateToken) {
            var n = e.tx.exists._get(m.STATE_TOKEN_KEY_NAME);

            if (!n) return Promise.reject(new h.a("No transaction to evaluate"));
            t = {
              stateToken: n
            };
          }

          return function (e, t) {
            return t = r(e, t), p.a.post(e, e.getIssuerOrigin() + "/api/v1/authn/introspect", t);
          }(e, t).then(function (t) {
            return new _(e, t);
          });
        }

        function d(e) {
          return !!e.tx.exists._get(m.STATE_TOKEN_KEY_NAME);
        }

        function f(e, t, n, r) {
          return p.a.post(e, t, n, r).then(function (t) {
            return new _(e, t);
          });
        }

        n.d(t, "j", function () {
          return l;
        }), n.d(t, "h", function () {
          return u;
        }), n.d(t, "i", function () {
          return d;
        }), n.d(t, "g", function () {
          return f;
        }), n.d(t, "f", function () {
          return c;
        }), n.d(t, "a", function () {
          return _;
        }), n.d(t, "d", function () {
          return i;
        }), n.d(t, "b", function () {
          return w;
        }), n.d(t, "c", function () {
          return r;
        }), n.d(t, "e", function () {
          return o;
        });

        var p = n(6),
            h = n(2),
            m = n(3),
            g = n(4),
            v = n.n(g),
            y = n(0),
            b = n(19),
            _ = function e(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          v()(this, e), n && (this.data = n, Object.assign(this, s(t, n, n, {})), delete this.stateToken, "RECOVERY_CHALLENGE" !== n.status || n._links || (this.cancel = function () {
            return Promise.resolve(new e(t));
          }));
        },
            w = function e() {
          v()(this, e);
        };
      }, function (e, t, n) {
        "use strict";

        function r(e) {
          return ("0" + e.toString(16)).substr(-2);
        }

        var o = n(0),
            i = n(3);
        t.a = {
          DEFAULT_CODE_CHALLENGE_METHOD: i.DEFAULT_CODE_CHALLENGE_METHOD,
          generateVerifier: function generateVerifier(e) {
            var t,
                n,
                o = e || "";
            return o.length < i.MIN_VERIFIER_LENGTH && (o += (t = i.MIN_VERIFIER_LENGTH - o.length, n = new Uint8Array(Math.ceil(t / 2)), crypto.getRandomValues(n), Array.from(n, r).join("").slice(0, t))), encodeURIComponent(o).slice(0, i.MAX_VERIFIER_LENGTH);
          },
          computeChallenge: function computeChallenge(e) {
            var t = new TextEncoder().encode(e);
            return crypto.subtle.digest("SHA-256", t).then(function (e) {
              var t = String.fromCharCode.apply(null, new Uint8Array(e));
              return Object(o.A)(t);
            });
          }
        };
      }, function (e, t, n) {
        "use strict";

        function r(e, t) {
          return t.expiresAt - e.options.expireEarlySeconds;
        }

        function o(e, t) {
          return r(e, t) <= e.clock.now();
        }

        function i(e, t, n, r) {
          e.emitter.emit(H, t, n, r);
        }

        function a(e, t, n) {
          e.emitter.emit(q, t, n);
        }

        function s(e, t, n) {
          e.emitter.emit(W, t, n);
        }

        function l(e, t) {
          e.emitter.emit(z, t);
        }

        function u(e, t, n) {
          var r = T(n),
              o = T(t);
          Object.keys(o).forEach(function (t) {
            var n = r[t],
                i = o[t];
            JSON.stringify(n) !== JSON.stringify(i) && a(e, t, i);
          }), Object.keys(r).forEach(function (t) {
            var n = r[t];
            o[t] || s(e, t, n);
          });
        }

        function c(e, t) {
          clearTimeout(e.expireTimeouts[t]), delete e.expireTimeouts[t], delete e.renewPromise[t];
        }

        function d(e) {
          var t = e.expireTimeouts;

          for (var n in t) {
            Object.prototype.hasOwnProperty.call(t, n) && c(e, n);
          }
        }

        function f(e, t, n, o) {
          var i = r(t, o),
              a = 1e3 * Math.max(i - t.clock.now(), 0);
          c(t, n);
          var s = setTimeout(function () {
            !function (e, t, n) {
              e.emitter.emit(V, t, n);
            }(t, n, o);
          }, a);
          t.expireTimeouts[n] = s;
        }

        function p(e, t, n) {
          try {
            var r = n.getStorage();
          } catch (e) {
            return void l(t, e);
          }

          for (var o in r) {
            Object.prototype.hasOwnProperty.call(r, o) && f(0, t, o, r[o]);
          }
        }

        function h(e, t, n) {
          d(t), p(0, t, n);
        }

        function m(e) {
          if (!Object(I.t)(e) || !e.scopes || !e.expiresAt && 0 !== e.expiresAt || !Object(U.isIDToken)(e) && !Object(U.isAccessToken)(e) && !Object(U.isRefreshToken)(e)) throw new M.a("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");
        }

        function g(e, t, n, r, o) {
          e.features.isLocalhost() && Object(I.F)("Use setTokens() instead if you want to add a set of tokens at same time.\nIt prevents current tab from emitting unnecessary StorageEvent,\nwhich may cause false-positive authState change cross tabs.");
          var i = n.getStorage();
          m(o), i[r] = o, n.setStorage(i), a(t, r, o), f(0, t, r, o);
        }

        function v(e, t) {
          return e.getStorage()[t];
        }

        function y(e, t) {
          var n = e.getStorage();
          return Object.keys(n).filter(function (e) {
            var r = n[e];
            return Object(U.isAccessToken)(r) && "accessToken" === t || Object(U.isIDToken)(r) && "idToken" === t || Object(U.isRefreshToken)(r) && "refreshToken" === t;
          })[0];
        }

        function b(e, t) {
          return new Promise(function (n) {
            return n(v(e, t));
          });
        }

        function _(e) {
          var t = {},
              n = e.getStorage();
          return Object.keys(n).forEach(function (e) {
            var r = n[e];
            Object(U.isAccessToken)(r) ? t.accessToken = r : Object(U.isIDToken)(r) ? t.idToken = r : Object(U.isRefreshToken)(r) && (t.refreshToken = r);
          }), t;
        }

        function w(e) {
          return new Promise(function (t) {
            return t(_(e));
          });
        }

        function E(e, t, n, r, o, i, l) {
          var u = r.accessToken,
              d = r.idToken,
              p = r.refreshToken,
              h = function h(e, n, r) {
            a(t, e, n), f(0, t, e, n), r && r(e, n);
          },
              g = function g(e, n, r) {
            c(t, e), s(t, e, n), r && r(e, n);
          };

          d && m(d), u && m(u);
          var v = y(n, "idToken") || j.ID_TOKEN_STORAGE_KEY,
              b = y(n, "accessToken") || j.ACCESS_TOKEN_STORAGE_KEY,
              w = y(n, "refreshToken") || j.REFRESH_TOKEN_STORAGE_KEY,
              E = Object.assign(Object.assign(Object.assign({}, d && R()({}, v, d)), u && R()({}, b, u)), p && R()({}, w, p));
          n.setStorage(E);

          var O = _(n);

          d ? h(v, d, i) : O.idToken && g(v, O.idToken, i), u ? h(b, u, o) : O.accessToken && g(b, O.accessToken, o), p ? h(w, p, l) : O.refreshToken && g(w, O.refreshToken, l);
        }

        function O(e, t, n) {
          c(e, n);
          var r = t.getStorage(),
              o = r[n];
          delete r[n], t.setStorage(r), s(e, n, o);
        }

        function S(e, t, n, r) {
          var a = t.renewPromise[r];
          if (a) return a;

          try {
            var u = v(n, r);
            if (!u) throw new M.a("The tokenManager has no token for the key: " + r);
          } catch (e) {
            return Promise.reject(e);
          }

          return d(t), t.renewPromise[r] = e.token.renewTokens({
            scopes: u.scopes
          }).then(function (e) {
            var o = n.getStorage();
            return E(0, t, n, e, function (e, n) {
              return i(t, e, n, o[e]);
            }, function (e, n) {
              return i(t, e, n, o[e]);
            }), v(n, r);
          }).catch(function (e) {
            if ("OAuthError" === e.name || "AuthSdkError" === e.name) {
              var i = [],
                  a = n.getStorage();
              Object.keys(a).forEach(function (e) {
                var n = a[e];
                n && o(t, n) && (delete a[e], i.push({
                  key: e,
                  token: n
                }), c(t, e));
              }), n.setStorage(a), i.length ? i.forEach(function (e, n) {
                return s(t, e, n);
              }) : (s(t, j.ID_TOKEN_STORAGE_KEY), s(t, j.ACCESS_TOKEN_STORAGE_KEY)), e.tokenKey = r, l(t, e);
            }

            throw e;
          }).finally(function () {
            delete t.renewPromise[r];
          }), t.renewPromise[r];
        }

        function x(e, t) {
          d(e), t.clearStorage();
        }

        function T(e) {
          var t;

          try {
            t = JSON.parse(e) || {};
          } catch (e) {
            t = {};
          }

          return t;
        }

        n.d(t, "c", function () {
          return V;
        }), n.d(t, "e", function () {
          return H;
        }), n.d(t, "a", function () {
          return q;
        }), n.d(t, "d", function () {
          return W;
        }), n.d(t, "b", function () {
          return z;
        }), n.d(t, "f", function () {
          return $;
        });

        var k = n(18),
            C = n.n(k),
            A = n(4),
            N = n.n(A),
            P = n(24),
            R = n.n(P),
            I = n(0),
            M = n(2),
            j = n(3),
            L = n(11),
            D = n.n(L),
            F = function () {
          function e(t) {
            N()(this, e), this.localOffset = parseInt(t || 0);
          }

          return D()(e, [{
            key: "now",
            value: function value() {
              return (Date.now() + this.localOffset) / 1e3;
            }
          }], [{
            key: "create",
            value: function value() {
              return new e(0);
            }
          }]), e;
        }(),
            U = n(7),
            B = {
          autoRenew: !0,
          autoRemove: !0,
          storage: "localStorage",
          expireEarlySeconds: 30,
          storageKey: j.TOKEN_STORAGE_NAME,
          _storageEventDelay: 0
        },
            V = "expired",
            H = "renewed",
            q = "added",
            W = "removed",
            z = "error",
            $ = function e(t, n) {
          var r = this;
          N()(this, e), n = Object.assign({}, B, Object(I.y)(n));
          var i = t.emitter;
          if (!i) throw new M.a("Emitter should be initialized before TokenManager");
          Object(I.r)() && (n._storageEventDelay = n._storageEventDelay || 1e3);
          var a = Object(I.y)({
            storageKey: n.storageKey,
            secure: n.secure
          });
          "object" === C()(n.storage) ? a.storageProvider = n.storage : n.storage && (a.storageType = n.storage);
          var s = t.storageManager.getTokenStorage(a),
              c = {
            clock: F.create(),
            options: n,
            emitter: i,
            expireTimeouts: {},
            renewPromise: {}
          };
          this.add = g.bind(this, t, c, s), this.get = b.bind(this, s), this.remove = O.bind(this, c, s), this.clear = x.bind(this, c, s), this.renew = S.bind(this, t, c, s), this.on = c.emitter.on.bind(c.emitter), this.off = c.emitter.off.bind(c.emitter), this.hasExpired = o.bind(this, c), this.getTokens = w.bind(this, s), this.setTokens = E.bind(this, t, c, s), this._getStorageKeyByType = y.bind(this, s), this._clearExpireEventTimeoutAll = d.bind(this, c), this._getOptions = function () {
            return Object(I.f)(n);
          }, this._resetExpireEventTimeoutAll = h.bind(this, t, c, s), this._emitEventsForCrossTabsStorageUpdate = u.bind(this, c);
          var f = [];
          this.on(V, function (e) {
            if (n.autoRenew) {
              if (function (e) {
                var t = !1;

                if (e.push(Date.now()), e.length >= 10) {
                  var n = e.shift();
                  t = e[e.length - 1] - n < 3e4;
                }

                return t;
              }(f)) {
                var t = new M.a("Too many token renew requests");
                l(c, t);
              } else r.renew(e).catch(function () {});
            } else n.autoRemove && r.remove(e);
          }), p(0, c, s), window.addEventListener("storage", function (e) {
            var t = e.key,
                o = e.newValue,
                i = e.oldValue;
            (!t || t === n.storageKey && o !== i) && setTimeout(function () {
              return r._resetExpireEventTimeoutAll(), void r._emitEventsForCrossTabsStorageUpdate(o, i);
            }, n._storageEventDelay);
          });
        };
      }, function (e, t, n) {
        "use strict";

        function r(e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();

          return function () {
            var n,
                r = p()(e);

            if (t) {
              var o = p()(this).constructor;
              n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);

            return d()(this, n);
          };
        }

        n.d(t, "a", function () {
          return m;
        });

        var o = n(4),
            i = n.n(o),
            a = n(9),
            s = n.n(a),
            l = n(12),
            u = n.n(l),
            c = n(13),
            d = n.n(c),
            f = n(10),
            p = n.n(f),
            h = n(26),
            m = function (e) {
          function t(e) {
            var r;
            return i()(this, t), r = n.call(this, e), Object.setPrototypeOf(s()(r), (this instanceof t ? this.constructor : void 0).prototype), r;
          }

          u()(t, e);
          var n = r(t);
          return t;
        }(n.n(h)()(Error));
      }, function (e, t) {
        function n(t) {
          return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? e.exports = n = function n(e) {
            return typeof e;
          } : e.exports = n = function n(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, n(t);
        }

        e.exports = n;
      }, function (e, t, n) {
        "use strict";

        function r(e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();

          return function () {
            var n,
                r = d()(e);

            if (t) {
              var o = d()(this).constructor;
              n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);

            return u()(this, n);
          };
        }

        n.d(t, "a", function () {
          return f;
        });

        var o = n(4),
            i = n.n(o),
            a = n(12),
            s = n.n(a),
            l = n(13),
            u = n.n(l),
            c = n(10),
            d = n.n(c),
            f = function (e) {
          function t() {
            return i()(this, t), n.call(this, "The poll was stopped by the sdk");
          }

          s()(t, e);
          var n = r(t);
          return t;
        }(n(17).a);
      }, function (e, t) {}, function (e, t, n) {
        "use strict";

        function r(e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();

          return function () {
            var n,
                r = d()(e);

            if (t) {
              var o = d()(this).constructor;
              n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);

            return u()(this, n);
          };
        }

        n.d(t, "a", function () {
          return f;
        });

        var o = n(4),
            i = n.n(o),
            a = n(12),
            s = n.n(a),
            l = n(13),
            u = n.n(l),
            c = n(10),
            d = n.n(c),
            f = function (e) {
          function t(e, r) {
            var o;
            i()(this, t);
            var a = e.errorSummary;
            return (o = n.call(this, a)).name = "AuthApiError", o.errorSummary = e.errorSummary, o.errorCode = e.errorCode, o.errorLink = e.errorLink, o.errorId = e.errorId, o.errorCauses = e.errorCauses, r && (o.xhr = r), o;
          }

          s()(t, e);
          var n = r(t);
          return t;
        }(n(17).a);
      }, function (e, t, n) {
        "use strict";

        n.d(t, "a", function () {
          return d;
        });

        var r = n(4),
            o = n.n(r),
            i = n(11),
            a = n.n(i),
            s = n(1),
            l = n(3),
            u = n(7),
            c = n(0),
            d = function () {
          function e(t) {
            o()(this, e), this.storageManager = t.storageManager, this.legacyWidgetSupport = !1 !== t.legacyWidgetSupport, this.saveNonceCookie = !1 !== t.saveNonceCookie, this.saveStateCookie = !1 !== t.saveStateCookie, this.saveParamsCookie = !1 !== t.saveParamsCookie, this.options = t;
          }

          return a()(e, [{
            key: "clear",
            value: function value() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              this.storageManager.getTransactionStorage().clearStorage(), this.legacyWidgetSupport && (e.oauth && this.clearLegacyOAuthParams(), e.pkce && this.clearLegacyPKCE());
            }
          }, {
            key: "save",
            value: function value(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                  n = this.storageManager.getTransactionStorage(),
                  r = n.getStorage();

              if (Object(u.isTransactionMeta)(r) && Object(c.F)("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."), n.setStorage(e), t.oauth && (this.saveNonceCookie || this.saveStateCookie || this.saveParamsCookie)) {
                var o = this.storageManager.getStorage({
                  storageType: "cookie"
                });

                if (this.saveParamsCookie) {
                  var i = e.responseType,
                      a = e.state,
                      s = e.nonce,
                      d = e.scopes,
                      f = e.clientId,
                      p = e.urls,
                      h = e.ignoreSignature,
                      m = {
                    responseType: i,
                    state: a,
                    nonce: s,
                    scopes: d,
                    clientId: f,
                    urls: p,
                    ignoreSignature: h
                  };
                  o.setItem(l.REDIRECT_OAUTH_PARAMS_NAME, JSON.stringify(m), null);
                }

                this.saveNonceCookie && e.nonce && o.setItem(l.REDIRECT_NONCE_COOKIE_NAME, e.nonce, null), this.saveStateCookie && e.state && o.setItem(l.REDIRECT_STATE_COOKIE_NAME, e.state, null);
              }
            }
          }, {
            key: "exists",
            value: function value() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};

              try {
                return !!this.load(e);
              } catch (e) {
                return !1;
              }
            }
          }, {
            key: "load",
            value: function value() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  t = this.storageManager.getTransactionStorage(),
                  n = t.getStorage();
              if (Object(u.isTransactionMeta)(n)) return n;
              if (!this.legacyWidgetSupport) return null;
              if (e.oauth) try {
                var r = this.loadLegacyOAuthParams();
                Object.assign(n, r);
              } finally {
                this.clearLegacyOAuthParams();
              }
              if (e.pkce) try {
                var o = this.loadLegacyPKCE();
                Object.assign(n, o);
              } finally {
                this.clearLegacyPKCE();
              }
              return Object(u.isTransactionMeta)(n) ? n : null;
            }
          }, {
            key: "clearLegacyPKCE",
            value: function value() {
              this.storageManager.storageUtil.testStorageType("localStorage") && this.storageManager.getLegacyPKCEStorage({
                storageType: "localStorage"
              }).clearStorage(), this.storageManager.storageUtil.testStorageType("sessionStorage") && this.storageManager.getLegacyPKCEStorage({
                storageType: "sessionStorage"
              }).clearStorage();
            }
          }, {
            key: "loadLegacyPKCE",
            value: function value() {
              var e;
              if (this.storageManager.storageUtil.testStorageType("localStorage") && (e = this.storageManager.getLegacyPKCEStorage({
                storageType: "localStorage"
              }).getStorage()) && e.codeVerifier) return e;
              if (this.storageManager.storageUtil.testStorageType("sessionStorage") && (e = this.storageManager.getLegacyPKCEStorage({
                storageType: "sessionStorage"
              }).getStorage()) && e.codeVerifier) return e;
              throw new s.c("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.", null);
            }
          }, {
            key: "clearLegacyOAuthParams",
            value: function value() {
              this.storageManager.storageUtil.testStorageType("sessionStorage") && this.storageManager.getLegacyOAuthParamsStorage({
                storageType: "sessionStorage"
              }).clearStorage(), this.storageManager.storageUtil.testStorageType("cookie") && this.storageManager.getLegacyOAuthParamsStorage({
                storageType: "cookie"
              }).clearStorage();
            }
          }, {
            key: "loadLegacyOAuthParams",
            value: function value() {
              var e;
              if (this.storageManager.storageUtil.testStorageType("sessionStorage") && (e = this.storageManager.getLegacyOAuthParamsStorage({
                storageType: "sessionStorage"
              }).getStorage()), Object(u.isOAuthTransactionMeta)(e)) return e;
              if (this.storageManager.storageUtil.testStorageType("cookie") && (e = this.storageManager.getLegacyOAuthParamsStorage({
                storageType: "cookie"
              }).getStorage()), Object(u.isOAuthTransactionMeta)(e)) return e;
              throw new s.c("Unable to retrieve OAuth redirect params from storage");
            }
          }]), e;
        }();
      }, function (e, t, n) {
        "use strict";

        n.d(t, "a", function () {
          return c;
        });

        var r = n(4),
            o = n.n(r),
            i = n(11),
            a = n.n(i),
            s = n(3),
            l = n(2),
            u = function () {
          function e(t, n) {
            if (o()(this, e), !t) throw new l.a('"storage" is required');
            if ("string" != typeof n || !n.length) throw new l.a('"storageName" is required');
            this.storageName = n, this.storageProvider = t;
          }

          return a()(e, [{
            key: "getItem",
            value: function value(e) {
              return this.getStorage()[e];
            }
          }, {
            key: "setItem",
            value: function value(e, t) {
              return this.updateStorage(e, t);
            }
          }, {
            key: "removeItem",
            value: function value(e) {
              return this.clearStorage(e);
            }
          }, {
            key: "getStorage",
            value: function value() {
              var e = this.storageProvider.getItem(this.storageName);
              e = e || "{}";

              try {
                return JSON.parse(e);
              } catch (e) {
                throw new l.a("Unable to parse storage string: " + this.storageName);
              }
            }
          }, {
            key: "setStorage",
            value: function value(e) {
              try {
                var t = e ? JSON.stringify(e) : "{}";
                this.storageProvider.setItem(this.storageName, t);
              } catch (e) {
                throw new l.a("Unable to set storage: " + this.storageName);
              }
            }
          }, {
            key: "clearStorage",
            value: function value(e) {
              if (e) {
                var t = this.getStorage();
                delete t[e], this.setStorage(t);
              } else this.storageProvider.removeItem ? this.storageProvider.removeItem(this.storageName) : this.setStorage();
            }
          }, {
            key: "updateStorage",
            value: function value(e, t) {
              var n = this.getStorage();
              n[e] = t, this.setStorage(n);
            }
          }]), e;
        }(),
            c = function () {
          function e(t, n, r) {
            o()(this, e), this.storageManagerOptions = t, this.cookieOptions = n, this.storageUtil = r;
          }

          return a()(e, [{
            key: "getOptionsForSection",
            value: function value(e, t) {
              return Object.assign({}, this.storageManagerOptions[e], t);
            }
          }, {
            key: "getStorage",
            value: function value(e) {
              if ((e = Object.assign({}, this.cookieOptions, e)).storageProvider) return e.storageProvider;
              var t = e,
                  n = t.storageType,
                  r = t.storageTypes;

              if (n && r) {
                var o = r.indexOf(n);
                o >= 0 && (r = r.slice(o), n = null);
              }

              return n || (n = this.storageUtil.findStorageType(r)), this.storageUtil.getStorageByType(n, e);
            }
          }, {
            key: "getTransactionStorage",
            value: function value(e) {
              e = this.getOptionsForSection("transaction", e);
              var t = this.getStorage(e),
                  n = e.storageKey || s.TRANSACTION_STORAGE_NAME;
              return new u(t, n);
            }
          }, {
            key: "getTokenStorage",
            value: function value(e) {
              e = this.getOptionsForSection("token", e);
              var t = this.getStorage(e),
                  n = e.storageKey || s.TOKEN_STORAGE_NAME;
              return new u(t, n);
            }
          }, {
            key: "getHttpCache",
            value: function value(e) {
              e = this.getOptionsForSection("cache", e);
              var t = this.getStorage(e),
                  n = e.storageKey || s.CACHE_STORAGE_NAME;
              return new u(t, n);
            }
          }, {
            key: "getLegacyPKCEStorage",
            value: function value(e) {
              e = this.getOptionsForSection("legacy-pkce", e);
              var t = this.getStorage(e),
                  n = e.storageKey || s.PKCE_STORAGE_NAME;
              return new u(t, n);
            }
          }, {
            key: "getLegacyOAuthParamsStorage",
            value: function value(e) {
              e = this.getOptionsForSection("legacy-oauth-params", e);
              var t = this.getStorage(e),
                  n = e.storageKey || s.REDIRECT_OAUTH_PARAMS_NAME;
              return new u(t, n);
            }
          }]), e;
        }();
      }, function (e, t) {
        e.exports = function (e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        };
      }, function (e, t) {
        function n(t, r) {
          return e.exports = n = Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          }, n(t, r);
        }

        e.exports = n;
      }, function (e, t, n) {
        function r(t) {
          var n = "function" == typeof Map ? new Map() : void 0;
          return e.exports = r = function r(e) {
            function t() {
              return s(e, arguments, o(this).constructor);
            }

            if (null === e || !a(e)) return e;
            if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

            if (void 0 !== n) {
              if (n.has(e)) return n.get(e);
              n.set(e, t);
            }

            return t.prototype = Object.create(e.prototype, {
              constructor: {
                value: t,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), i(t, e);
          }, r(t);
        }

        var o = n(10),
            i = n(25),
            a = n(43),
            s = n(44);
        e.exports = r;
      }, function (e, t) {}, function (e, t, n) {
        "use strict";

        function r(e) {
          return !(!e || "object" !== c()(e) || 0 === Object.values(e).length);
        }

        function o(e) {
          return !(!r(e) || !e.redirectUri && !e.responseType);
        }

        function i(e) {
          return !!o(e) && !!e.codeVerifier;
        }

        function a(e) {
          return !!i(e) && !!e.interactionHandle;
        }

        function s(e) {
          return !!r(e) && void 0 === Object.values(e).find(function (e) {
            return "string" != typeof e;
          });
        }

        function l(e) {
          return !(!o(e) && !s(e));
        }

        n.d(t, "c", function () {
          return o;
        }), n.d(t, "d", function () {
          return i;
        }), n.d(t, "b", function () {
          return a;
        }), n.d(t, "a", function () {
          return s;
        }), n.d(t, "e", function () {
          return l;
        });
        var u = n(18),
            c = n.n(u);
      }, function (e, t) {}, function (e, t) {}, function (e, t) {}, function (e, t) {}, function (e, t) {}, function (e, t) {}, function (e, t, n) {
        "use strict";

        function r(e) {
          return !!(e && (e.accessToken || e.idToken || e.refreshToken) && Array.isArray(e.scopes));
        }

        function o(e) {
          return e && e.accessToken;
        }

        function i(e) {
          return e && e.idToken;
        }

        function a(e) {
          return e && e.refreshToken;
        }

        n.d(t, "d", function () {
          return r;
        }), n.d(t, "a", function () {
          return o;
        }), n.d(t, "b", function () {
          return i;
        }), n.d(t, "c", function () {
          return a;
        });
      }, function (e, t) {}, function (e, t, n) {
        "use strict";

        function r(e, t) {
          var n = e.userAgent || {};
          return n.value ? n.value : n.template ? n.template.replace("$OKTA_AUTH_JS", t) : t;
        }

        function o() {
          return navigator.userAgent;
        }

        function i() {
          var e = o();
          return e && !H.test(e);
        }

        function a() {
          var e = document.documentMode && document.documentMode < 10;
          return !(!window.postMessage || e);
        }

        function s() {
          return "undefined" != typeof crypto && crypto.subtle && "undefined" != typeof Uint8Array;
        }

        function l() {
          return "undefined" != typeof TextEncoder;
        }

        function u() {
          return s() && l();
        }

        function c() {
          return "https:" === window.location.protocol;
        }

        function d() {
          return "localhost" === window.location.hostname;
        }

        function f(e) {
          return e.session.get().then(function (e) {
            return "ACTIVE" === e.status;
          }).catch(function () {
            return !1;
          });
        }

        function p(e) {
          return G.a.get(e, "/api/v1/sessions/me").then(function (t) {
            var n = Object(L.x)(t, "_links");
            return n.refresh = function () {
              return G.a.post(e, Object(L.n)(t, "refresh").href);
            }, n.user = function () {
              return G.a.get(e, Object(L.n)(t, "user").href);
            }, n;
          }).catch(function () {
            return {
              status: "INACTIVE"
            };
          });
        }

        function h(e) {
          return G.a.httpRequest(e, {
            url: e.getIssuerOrigin() + "/api/v1/sessions/me",
            method: "DELETE"
          });
        }

        function m(e) {
          return G.a.post(e, "/api/v1/sessions/me/lifecycle/refresh");
        }

        function g(e, t, n) {
          n = n || window.location.href, window.location.assign(e.getIssuerOrigin() + "/login/sessionCookieRedirect" + Object(L.D)({
            checkAccountSetupComplete: !0,
            token: t,
            redirectUrl: n
          }));
        }

        function v(e, t) {
          return t = t || {}, i() ? new Promise(function (i, a) {
            (r = document.createElement("iframe")).style.display = "none", o = function o(t) {
              if (t && t.data && t.origin === e.getIssuerOrigin()) {
                try {
                  var n = JSON.parse(t.data);
                } catch (e) {
                  return;
                }

                if (n) return "FingerprintAvailable" === n.type ? i(n.fingerprint) : void ("FingerprintServiceReady" === n.type && t.source.postMessage(JSON.stringify({
                  type: "GetFingerprint"
                }), t.origin));
              }
            }, Object(Y.a)(window, "message", o), r.src = e.getIssuerOrigin() + "/auth/services/devicefingerprint", document.body.appendChild(r), n = setTimeout(function () {
              a(new X.c("Fingerprinting timed out"));
            }, t.timeout || 15e3);
          }).finally(function () {
            clearTimeout(n), Object(Y.J)(window, "message", o), document.body.contains(r) && r.parentElement.removeChild(r);
          }) : Promise.reject(new X.c("Fingerprinting is not supported on this device"));
          var n, r, o;
        }

        function y(e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();

          return function () {
            var n,
                r = M()(e);

            if (t) {
              var o = M()(this).constructor;
              n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);

            return R()(this, n);
          };
        }

        function b() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0,
              n = e.cookies || {};
          return void 0 === n.secure && (n.secure = t), void 0 === n.sameSite && (n.sameSite = n.secure ? "none" : "lax"), n.secure && !t && (Object(L.F)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'), n.secure = !1), "none" !== n.sameSite || n.secure || (n.sameSite = "lax"), n;
        }

        var _ = {};
        n.r(_), n.d(_, "getUserAgent", function () {
          return o;
        }), n.d(_, "isFingerprintSupported", function () {
          return i;
        }), n.d(_, "isPopupPostMessageSupported", function () {
          return a;
        }), n.d(_, "isTokenVerifySupported", function () {
          return s;
        }), n.d(_, "hasTextEncoder", function () {
          return l;
        }), n.d(_, "isPKCESupported", function () {
          return u;
        }), n.d(_, "isHTTPS", function () {
          return c;
        }), n.d(_, "isLocalhost", function () {
          return d;
        });

        var w = n(5),
            E = n.n(w),
            O = n(4),
            S = n.n(O),
            x = n(11),
            T = n.n(x),
            k = n(9),
            C = n.n(k),
            A = n(12),
            N = n.n(A),
            P = n(13),
            R = n.n(P),
            I = n(10),
            M = n.n(I),
            j = n(2),
            L = n(0),
            D = n(14),
            F = n(15),
            U = n(23),
            B = n(22),
            V = function () {
          function e(t) {
            S()(this, e), function (e) {
              var t = (e = e || {}).issuer;
              if (!t) throw new j.a('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
              if (!new RegExp("^http?s?://.+").test(e.issuer)) throw new j.a('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
              if (-1 !== t.indexOf("-admin.")) throw new j.a('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
              var n = e.userAgent;
              if (n && n.template && -1 === n.template.indexOf("$OKTA_AUTH_JS")) throw new j.a('UserAgentTemplate must include "$OKTA_AUTH_JS" placeholder. Required usage: new OktaAuth({userAgentTemplate: "xxx $OKTA_AUTH_JS xxx"})');
            }(t), this.options = {
              issuer: Object(L.z)(t.issuer),
              tokenUrl: Object(L.z)(t.tokenUrl),
              authorizeUrl: Object(L.z)(t.authorizeUrl),
              userinfoUrl: Object(L.z)(t.userinfoUrl),
              revokeUrl: Object(L.z)(t.revokeUrl),
              logoutUrl: Object(L.z)(t.logoutUrl),
              clientId: t.clientId,
              redirectUri: t.redirectUri,
              state: t.state,
              scopes: t.scopes,
              postLogoutRedirectUri: t.postLogoutRedirectUri,
              responseMode: t.responseMode,
              responseType: t.responseType,
              pkce: t.pkce,
              httpRequestClient: t.httpRequestClient,
              transformErrorXHR: t.transformErrorXHR,
              transformAuthState: t.transformAuthState,
              restoreOriginalUri: t.restoreOriginalUri,
              storageUtil: t.storageUtil,
              headers: t.headers,
              devMode: t.devMode || !1,
              storageManager: Object.assign({
                token: {},
                transaction: {}
              }, t.storageManager),
              cookies: t.cookies,
              ignoreSignature: !!t.ignoreSignature
            };
            var n = this.options,
                r = n.storageManager,
                o = n.cookies,
                i = n.storageUtil;
            this.storageManager = new U.a(r, o, i), this.transactionManager = new B.a(Object.assign({
              storageManager: this.storageManager
            }, t.transactionManager)), this.tx = {
              status: D.j.bind(null, this),
              resume: D.h.bind(null, this),
              exists: Object.assign(D.i.bind(null, this), {
                _get: function _get(e) {
                  return i.storage.get(e);
                }
              }),
              introspect: D.f.bind(null, this)
            }, this.pkce = {
              DEFAULT_CODE_CHALLENGE_METHOD: F.a.DEFAULT_CODE_CHALLENGE_METHOD,
              generateVerifier: F.a.generateVerifier,
              computeChallenge: F.a.computeChallenge
            };
          }

          return T()(e, [{
            key: "signIn",
            value: function value(e) {
              return Object(D.g)(this, "/api/v1/authn", e);
            }
          }, {
            key: "getIssuerOrigin",
            value: function value() {
              return this.options.issuer.split("/oauth2/")[0];
            }
          }, {
            key: "forgotPassword",
            value: function value(e) {
              return Object(D.g)(this, "/api/v1/authn/recovery/password", e);
            }
          }, {
            key: "unlockAccount",
            value: function value(e) {
              return Object(D.g)(this, "/api/v1/authn/recovery/unlock", e);
            }
          }, {
            key: "verifyRecoveryToken",
            value: function value(e) {
              return Object(D.g)(this, "/api/v1/authn/recovery/token", e);
            }
          }]), e;
        }(),
            H = /windows phone|iemobile|wpdesktop/i,
            q = n(38),
            W = n(47),
            z = {
          getHttpCache: function getHttpCache() {
            return null;
          },
          getPKCEStorage: function getPKCEStorage() {
            return null;
          },
          browserHasLocalStorage: function browserHasLocalStorage() {
            try {
              var e = z.getLocalStorage();
              return z.testStorage(e);
            } catch (e) {
              return !1;
            }
          },
          browserHasSessionStorage: function browserHasSessionStorage() {
            try {
              var e = z.getSessionStorage();
              return z.testStorage(e);
            } catch (e) {
              return !1;
            }
          },
          testStorageType: function testStorageType(e) {
            var t = !1;

            switch (e) {
              case "sessionStorage":
                t = z.browserHasSessionStorage();
                break;

              case "localStorage":
                t = z.browserHasLocalStorage();
                break;

              case "cookie":
              case "memory":
                t = !0;
                break;

              default:
                t = !1;
            }

            return t;
          },
          getStorageByType: function getStorageByType(e, t) {
            var n = null;

            switch (e) {
              case "sessionStorage":
                n = z.getSessionStorage();
                break;

              case "localStorage":
                n = z.getLocalStorage();
                break;

              case "cookie":
                n = z.getCookieStorage(t);
                break;

              case "memory":
                n = z.getInMemoryStorage();
                break;

              default:
                throw new j.a("Unrecognized storage option: ".concat(e));
            }

            return n;
          },
          findStorageType: function findStorageType(e) {
            var t, n;
            return t = (e = e.slice()).shift(), (n = e.length ? e[0] : null) ? z.testStorageType(t) ? t : (Object(L.F)("This browser doesn't support ".concat(t, ". Switching to ").concat(n, ".")), z.findStorageType(e)) : t;
          },
          getLocalStorage: function getLocalStorage() {
            return localStorage;
          },
          getSessionStorage: function getSessionStorage() {
            return sessionStorage;
          },
          getCookieStorage: function getCookieStorage(e) {
            var t = e.secure,
                n = e.sameSite;
            if (void 0 === t || void 0 === n) throw new j.a('getCookieStorage: "secure" and "sameSite" options must be provided');
            var r = {
              getItem: z.storage.get,
              setItem: function setItem(e, r, o) {
                o = void 0 === o ? "2200-01-01T00:00:00.000Z" : o, z.storage.set(e, r, o, {
                  secure: t,
                  sameSite: n
                });
              },
              removeItem: function removeItem(e) {
                z.storage.delete(e);
              }
            };
            return e.useMultipleCookies ? {
              getItem: function getItem(e) {
                var t = r.getItem(),
                    n = {};
                return Object.keys(t).forEach(function (r) {
                  0 === r.indexOf(e) && (n[r.replace("".concat(e, "_"), "")] = JSON.parse(t[r]));
                }), JSON.stringify(n);
              },
              setItem: function setItem(e, t) {
                var n = JSON.parse(this.getItem(e));
                t = JSON.parse(t), Object.keys(t).forEach(function (o) {
                  var i = e + "_" + o,
                      a = JSON.stringify(t[o]);
                  r.setItem(i, a), delete n[o];
                }), Object.keys(n).forEach(function (t) {
                  r.removeItem(e + "_" + t);
                });
              },
              removeItem: function removeItem(e) {
                var t = JSON.parse(this.getItem(e));
                Object.keys(t).forEach(function (t) {
                  r.removeItem(e + "_" + t);
                });
              }
            } : r;
          },
          getInMemoryStorage: function getInMemoryStorage() {
            var e = {};
            return {
              getItem: function getItem(t) {
                return e[t];
              },
              setItem: function setItem(t, n) {
                e[t] = n;
              }
            };
          },
          testStorage: function testStorage(e) {
            var t = "okta-test-storage";

            try {
              return e.setItem(t, t), e.removeItem(t), !0;
            } catch (e) {
              return !1;
            }
          },
          storage: {
            set: function set(e, t, n, r) {
              var o = r.secure,
                  i = r.sameSite;
              if (void 0 === o || void 0 === i) throw new j.a('storage.set: "secure" and "sameSite" options must be provided');
              var a = {
                path: r.path || "/",
                secure: o,
                sameSite: i
              };
              return Date.parse(n) && (a.expires = new Date(n)), W.set(e, t, a), z.storage.get(e);
            },
            get: function get(e) {
              return W.get(e);
            },
            delete: function _delete(e) {
              return W.remove(e, {
                path: "/"
              });
            }
          }
        },
            $ = z,
            K = n(3),
            G = n(6),
            Y = n(8),
            J = n(16),
            Q = function () {
          function e() {
            S()(this, e), this.queue = [], this.running = !1;
          }

          return T()(e, [{
            key: "push",
            value: function value(e, t) {
              for (var n = this, r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) {
                o[i - 2] = arguments[i];
              }

              return new Promise(function (r, i) {
                n.queue.push({
                  method: e,
                  thisObject: t,
                  args: o,
                  resolve: r,
                  reject: i
                }), n.run();
              });
            }
          }, {
            key: "run",
            value: function value() {
              var e = this;

              if (!this.running && 0 !== this.queue.length) {
                this.running = !0;
                var t = this.queue.shift(),
                    n = t.method.apply(t.thisObject, t.args);
                Object(L.u)(n) ? n.then(t.resolve, t.reject).finally(function () {
                  e.running = !1, e.run();
                }) : (t.resolve(n), this.running = !1, this.run());
              }
            }
          }]), e;
        }(),
            X = n(1),
            Z = n(53),
            ee = {
          isPending: !0,
          isAuthenticated: !1,
          idToken: null,
          accessToken: null,
          refreshToken: null
        },
            te = {
          updateAuthStatePromise: null,
          canceledTimes: 0
        },
            ne = function () {
          function e(t) {
            var n = this;
            if (S()(this, e), !t.emitter) throw new X.c("Emitter should be initialized before AuthStateManager");
            this._sdk = t, this._pending = Object.assign({}, te), this._authState = Object.assign({}, ee), this._logOptions = {}, t.tokenManager.on(J.a, function (e, t) {
              n._setLogOptions({
                event: J.a,
                key: e,
                token: t
              }), n.updateAuthState();
            }), t.tokenManager.on(J.d, function (e, t) {
              n._setLogOptions({
                event: J.d,
                key: e,
                token: t
              }), n.updateAuthState();
            });
          }

          return T()(e, [{
            key: "_setLogOptions",
            value: function value(e) {
              this._logOptions = e;
            }
          }, {
            key: "getAuthState",
            value: function value() {
              return this._authState;
            }
          }, {
            key: "updateAuthState",
            value: function value() {
              var e = this;
              this._sdk.emitter.e && this._sdk.emitter.e.authStateChange && this._sdk.emitter.e.authStateChange.length || Object(L.F)("updateAuthState is an asynchronous method with no return, please subscribe to the latest authState update with authStateManager.subscribe(handler) method before calling updateAuthState.");

              var t = this._sdk.options,
                  n = t.transformAuthState,
                  r = t.devMode,
                  o = this._sdk.tokenManager._getOptions(),
                  i = o.autoRenew,
                  a = o.autoRemove,
                  s = function s(t) {
                var n = e._logOptions,
                    r = n.event,
                    o = n.key,
                    i = n.token;
                Object(L.m)().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(r, " Status:").concat(t)), Object(L.m)().log(o, i), Object(L.m)().log("Current authState", e._authState), Object(L.m)().groupEnd(), e._logOptions = {};
              },
                  l = function l(t) {
                var n, o;
                n = e._authState, o = t, n.isPending !== o.isPending || n.isAuthenticated !== o.isAuthenticated || JSON.stringify(n.idToken) !== JSON.stringify(o.idToken) || JSON.stringify(n.accessToken) !== JSON.stringify(o.accessToken) || n.error !== o.error ? (e._authState = t, e._sdk.emitter.emit("authStateChange", Object.assign({}, t)), r && s("emitted")) : r && s("unchanged");
              },
                  u = function u() {
                return i || a;
              };

              if (this._pending.updateAuthStatePromise) {
                if (this._pending.canceledTimes >= 10) return void (r && s("terminated"));

                this._pending.updateAuthStatePromise.cancel();
              }

              var c = new Z(function (t, o, i) {
                i.shouldReject = !1, i(function () {
                  e._pending.updateAuthStatePromise = null, e._pending.canceledTimes = e._pending.canceledTimes + 1, r && s("canceled");
                });

                var a = function a(n) {
                  c.isCanceled || (l(n), e._pending = Object.assign({}, te)), t();
                };

                e._sdk.tokenManager.getTokens().then(function (r) {
                  var o = r.accessToken,
                      i = r.idToken,
                      s = r.refreshToken;
                  if (c.isCanceled) t();else {
                    var l = !1;
                    o && e._sdk.tokenManager.hasExpired(o) && (o = null, l = u()), i && e._sdk.tokenManager.hasExpired(i) && (i = null, l = u());
                    var d = {
                      accessToken: o,
                      idToken: i,
                      refreshToken: s,
                      isPending: l,
                      isAuthenticated: !(!o || !i)
                    };
                    (n ? n(e._sdk, d) : Promise.resolve(d)).then(function (e) {
                      return a(e);
                    }).catch(function (e) {
                      return a({
                        accessToken: o,
                        idToken: i,
                        refreshToken: s,
                        isAuthenticated: !1,
                        isPending: !1,
                        error: e
                      });
                    });
                  }
                });
              });
              this._pending.updateAuthStatePromise = c;
            }
          }, {
            key: "subscribe",
            value: function value(e) {
              this._sdk.emitter.on("authStateChange", e);
            }
          }, {
            key: "unsubscribe",
            value: function value(e) {
              this._sdk.emitter.off("authStateChange", e);
            }
          }]), e;
        }(),
            re = function re(e, t, n, r) {
          return new (n || (n = Promise))(function (o, i) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                i(e);
              }
            }

            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                i(e);
              }
            }

            function l(e) {
              var t;
              e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                e(t);
              })).then(a, s);
            }

            l((r = r.apply(e, t || [])).next());
          });
        },
            oe = function oe(e, t) {
          var n = {};

          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }

          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;

            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
              t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
            }
          }

          return n;
        },
            ie = n(54),
            ae = function (e) {
          function t() {
            var e,
                o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            S()(this, t), e = n.call(this, Object.assign({
              httpRequestClient: q.a,
              storageUtil: o.storageUtil || $,
              cookies: b(o, t.features.isHTTPS()),
              storageManager: Object.assign({
                token: {
                  storageTypes: ["localStorage", "sessionStorage", "cookie"],
                  useMultipleCookies: !0
                },
                cache: {
                  storageTypes: ["localStorage", "sessionStorage", "cookie"]
                },
                transaction: {
                  storageTypes: ["sessionStorage", "localStorage", "cookie"]
                }
              }, o.storageManager)
            }, o)), Object.assign(e.options.storageUtil, {
              getPKCEStorage: e.storageManager.getLegacyPKCEStorage.bind(e.storageManager),
              getHttpCache: e.storageManager.getHttpCache.bind(e.storageManager)
            }), e._pending = {
              handleLogin: !1
            }, e.options = Object.assign(e.options, {
              pkce: !1 !== o.pkce,
              redirectUri: Object(L.C)(o.redirectUri, window.location.origin)
            }), e.userAgent = r(o, "okta-auth-js/".concat("4.8.0")), o.maxClockSkew || 0 === o.maxClockSkew ? e.options.maxClockSkew = o.maxClockSkew : e.options.maxClockSkew = K.DEFAULT_MAX_CLOCK_SKEW, e.session = {
              close: h.bind(null, C()(e)),
              exists: f.bind(null, C()(e)),
              get: p.bind(null, C()(e)),
              refresh: m.bind(null, C()(e)),
              setCookieAndRedirect: g.bind(null, C()(e))
            }, e._tokenQueue = new Q(), e.token = {
              prepareTokenParams: Y.I.bind(null, C()(e)),
              exchangeCodeForTokens: Y.f.bind(null, C()(e)),
              getWithoutPrompt: Y.r.bind(null, C()(e)),
              getWithPopup: Y.p.bind(null, C()(e)),
              getWithRedirect: Y.q.bind(null, C()(e)),
              parseFromUrl: Y.E.bind(null, C()(e)),
              decode: Y.e,
              revoke: Y.M.bind(null, C()(e)),
              renew: Y.K.bind(null, C()(e)),
              renewTokens: Y.L.bind(null, C()(e)),
              getUserInfo: Y.n.bind(null, C()(e)),
              verify: Y.P.bind(null, C()(e)),
              isLoginRedirect: Y.A.bind(null, C()(e))
            };
            var i = ["decode", "isLoginRedirect"];
            return Object.keys(e.token).forEach(function (t) {
              if (!(i.indexOf(t) >= 0)) {
                var n = e.token[t];
                e.token[t] = Q.prototype.push.bind(e._tokenQueue, n, null);
              }
            }), Object.assign(e.token.getWithRedirect, {
              _setLocation: function _setLocation(e) {
                window.location = e;
              }
            }), Object.assign(e.token.parseFromUrl, {
              _getHistory: function _getHistory() {
                return window.history;
              },
              _getLocation: function _getLocation() {
                return window.location;
              },
              _getDocument: function _getDocument() {
                return window.document;
              }
            }), e.fingerprint = v.bind(null, C()(e)), e.emitter = new ie(), e.tokenManager = new J.f(C()(e), o.tokenManager), e.authStateManager = new ne(C()(e)), e;
          }

          N()(t, e);
          var n = y(t);
          return T()(t, [{
            key: "isInteractionRequired",
            value: function value() {
              return Object(Y.y)(this);
            }
          }, {
            key: "isInteractionRequiredError",
            value: function value(e) {
              return Object(Y.z)(e);
            }
          }, {
            key: "signIn",
            value: function value(e) {
              return this.features.isLocalhost() && Object(L.h)("This method has been deprecated, please use signInWithCredentials() instead."), this.signInWithCredentials(e);
            }
          }, {
            key: "signInWithCredentials",
            value: function value(e) {
              var t = this;
              e = Object(L.f)(e || {});

              var n = function n(_n) {
                return delete e.sendFingerprint, Object(D.g)(t, "/api/v1/authn", e, _n);
              };

              return e.sendFingerprint ? this.fingerprint().then(function (e) {
                return n({
                  headers: {
                    "X-Device-Fingerprint": e
                  }
                });
              }) : n();
            }
          }, {
            key: "signInWithRedirect",
            value: function value() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  t = e.originalUri,
                  n = oe(e, ["originalUri"]);
              return re(this, void 0, void 0, E.a.mark(function e() {
                var r;
                return E.a.wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        if (!this._pending.handleLogin) {
                          e.next = 2;
                          break;
                        }

                        return e.abrupt("return");

                      case 2:
                        return this._pending.handleLogin = !0, e.prev = 3, t && this.setOriginalUri(t), r = Object.assign({
                          scopes: this.options.scopes || ["openid", "email", "profile"]
                        }, n), e.next = 8, this.token.getWithRedirect(r);

                      case 8:
                        return e.prev = 8, this._pending.handleLogin = !1, e.finish(8);

                      case 11:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, this, [[3,, 8, 11]]);
              }));
            }
          }, {
            key: "closeSession",
            value: function value() {
              return this.tokenManager.clear(), this.session.close().catch(function (e) {
                if ("AuthApiError" !== e.name || "E0000007" !== e.errorCode) throw e;
              });
            }
          }, {
            key: "revokeAccessToken",
            value: function value(e) {
              return re(this, void 0, void 0, E.a.mark(function t() {
                var n;
                return E.a.wrap(function (t) {
                  for (;;) {
                    switch (t.prev = t.next) {
                      case 0:
                        if (e) {
                          t.next = 6;
                          break;
                        }

                        return t.next = 3, this.tokenManager.getTokens();

                      case 3:
                        e = t.sent.accessToken, n = this.tokenManager._getStorageKeyByType("accessToken"), this.tokenManager.remove(n);

                      case 6:
                        if (e) {
                          t.next = 8;
                          break;
                        }

                        return t.abrupt("return", Promise.resolve());

                      case 8:
                        return t.abrupt("return", this.token.revoke(e));

                      case 9:
                      case "end":
                        return t.stop();
                    }
                  }
                }, t, this);
              }));
            }
          }, {
            key: "revokeRefreshToken",
            value: function value(e) {
              return re(this, void 0, void 0, E.a.mark(function t() {
                var n;
                return E.a.wrap(function (t) {
                  for (;;) {
                    switch (t.prev = t.next) {
                      case 0:
                        if (e) {
                          t.next = 6;
                          break;
                        }

                        return t.next = 3, this.tokenManager.getTokens();

                      case 3:
                        e = t.sent.refreshToken, n = this.tokenManager._getStorageKeyByType("refreshToken"), this.tokenManager.remove(n);

                      case 6:
                        if (e) {
                          t.next = 8;
                          break;
                        }

                        return t.abrupt("return", Promise.resolve());

                      case 8:
                        return t.abrupt("return", this.token.revoke(e));

                      case 9:
                      case "end":
                        return t.stop();
                    }
                  }
                }, t, this);
              }));
            }
          }, {
            key: "signOut",
            value: function value(e) {
              return re(this, void 0, void 0, E.a.mark(function t() {
                var n, r, o, i, a, s, l, u, c, d, f, p;
                return E.a.wrap(function (t) {
                  for (;;) {
                    switch (t.prev = t.next) {
                      case 0:
                        if (e = Object.assign({}, e), n = window.location.origin, r = window.location.href, o = e.postLogoutRedirectUri || this.options.postLogoutRedirectUri || n, i = e.accessToken, a = e.refreshToken, s = !1 !== e.revokeAccessToken, l = !1 !== e.revokeRefreshToken, u = e.idToken, c = Object(Y.l)(this).logoutUrl, void 0 !== u) {
                          t.next = 14;
                          break;
                        }

                        return t.next = 13, this.tokenManager.getTokens();

                      case 13:
                        u = t.sent.idToken;

                      case 14:
                        if (!l || void 0 !== a) {
                          t.next = 18;
                          break;
                        }

                        return t.next = 17, this.tokenManager.getTokens();

                      case 17:
                        a = t.sent.refreshToken;

                      case 18:
                        if (!s || void 0 !== i) {
                          t.next = 22;
                          break;
                        }

                        return t.next = 21, this.tokenManager.getTokens();

                      case 21:
                        i = t.sent.accessToken;

                      case 22:
                        if (this.tokenManager.clear(), !l || !a) {
                          t.next = 26;
                          break;
                        }

                        return t.next = 26, this.revokeRefreshToken(a);

                      case 26:
                        if (!s || !i) {
                          t.next = 29;
                          break;
                        }

                        return t.next = 29, this.revokeAccessToken(i);

                      case 29:
                        if (u) {
                          t.next = 31;
                          break;
                        }

                        return t.abrupt("return", this.closeSession().then(function () {
                          o === r ? window.location.reload() : window.location.assign(o);
                        }));

                      case 31:
                        d = e.state, f = u.idToken, p = c + "?id_token_hint=" + encodeURIComponent(f) + "&post_logout_redirect_uri=" + encodeURIComponent(o), d && (p += "&state=" + encodeURIComponent(d)), window.location.assign(p);

                      case 36:
                      case "end":
                        return t.stop();
                    }
                  }
                }, t, this);
              }));
            }
          }, {
            key: "webfinger",
            value: function value(e) {
              var t = "/.well-known/webfinger" + Object(L.D)(e);
              return G.a.get(this, t, {
                headers: {
                  Accept: "application/jrd+json"
                }
              });
            }
          }, {
            key: "isAuthenticated",
            value: function value(e) {
              return re(this, void 0, void 0, E.a.mark(function t() {
                var n,
                    r,
                    o,
                    i,
                    a = this;
                return E.a.wrap(function (t) {
                  for (;;) {
                    switch (t.prev = t.next) {
                      case 0:
                        if ((n = this.authStateManager.getAuthState()).isPending) {
                          t.next = 3;
                          break;
                        }

                        return t.abrupt("return", Promise.resolve(n.isAuthenticated));

                      case 3:
                        return t.abrupt("return", new Promise(function (t) {
                          r = function r() {
                            a.authStateManager.unsubscribe(o), clearTimeout(i);
                          }, o = function o(e) {
                            var n = e.isAuthenticated;
                            e.isPending || (t(n), r());
                          }, i = setTimeout(function () {
                            t(!1), r();
                          }, e || 6e4), a.authStateManager.subscribe(o), a.authStateManager.updateAuthState();
                        }));

                      case 4:
                      case "end":
                        return t.stop();
                    }
                  }
                }, t, this);
              }));
            }
          }, {
            key: "getUser",
            value: function value() {
              return re(this, void 0, void 0, E.a.mark(function e() {
                var t, n, r;
                return E.a.wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        return t = this.authStateManager.getAuthState(), n = t.idToken, r = t.accessToken, e.abrupt("return", this.token.getUserInfo(r, n));

                      case 2:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, this);
              }));
            }
          }, {
            key: "getIdToken",
            value: function value() {
              var e = this.authStateManager.getAuthState().idToken;
              return e ? e.idToken : void 0;
            }
          }, {
            key: "getAccessToken",
            value: function value() {
              var e = this.authStateManager.getAuthState().accessToken;
              return e ? e.accessToken : void 0;
            }
          }, {
            key: "getRefreshToken",
            value: function value() {
              var e = this.authStateManager.getAuthState().refreshToken;
              return e ? e.refreshToken : void 0;
            }
          }, {
            key: "storeTokensFromRedirect",
            value: function value() {
              return re(this, void 0, void 0, E.a.mark(function e() {
                var t, n;
                return E.a.wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        return e.next = 2, this.token.parseFromUrl();

                      case 2:
                        t = e.sent, n = t.tokens, this.tokenManager.setTokens(n);

                      case 5:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, this);
              }));
            }
          }, {
            key: "setOriginalUri",
            value: function value(e) {
              e = e || window.location.href, $.getSessionStorage().setItem(K.REFERRER_PATH_STORAGE_KEY, e);
            }
          }, {
            key: "getOriginalUri",
            value: function value() {
              return $.getSessionStorage().getItem(K.REFERRER_PATH_STORAGE_KEY) || window.location.origin;
            }
          }, {
            key: "removeOriginalUri",
            value: function value() {
              $.getSessionStorage().removeItem(K.REFERRER_PATH_STORAGE_KEY);
            }
          }, {
            key: "isLoginRedirect",
            value: function value() {
              return Object(Y.A)(this);
            }
          }, {
            key: "handleLoginRedirect",
            value: function value(e) {
              return re(this, void 0, void 0, E.a.mark(function t() {
                var n,
                    r = this;
                return E.a.wrap(function (t) {
                  for (;;) {
                    switch (t.prev = t.next) {
                      case 0:
                        if (n = function e(t) {
                          var n = t.isPending;
                          return re(r, void 0, void 0, E.a.mark(function t() {
                            var r, o;
                            return E.a.wrap(function (t) {
                              for (;;) {
                                switch (t.prev = t.next) {
                                  case 0:
                                    if (!n) {
                                      t.next = 2;
                                      break;
                                    }

                                    return t.abrupt("return");

                                  case 2:
                                    if (this.authStateManager.unsubscribe(e), r = this.getOriginalUri(), this.removeOriginalUri(), !(o = this.options.restoreOriginalUri)) {
                                      t.next = 11;
                                      break;
                                    }

                                    return t.next = 9, o(this, r);

                                  case 9:
                                    t.next = 12;
                                    break;

                                  case 11:
                                    window.location.replace(r);

                                  case 12:
                                  case "end":
                                    return t.stop();
                                }
                              }
                            }, t, this);
                          }));
                        }, this.authStateManager.subscribe(n), !e) {
                          t.next = 6;
                          break;
                        }

                        this.tokenManager.setTokens(e), t.next = 12;
                        break;

                      case 6:
                        if (!this.isLoginRedirect()) {
                          t.next = 11;
                          break;
                        }

                        return t.next = 9, this.storeTokensFromRedirect();

                      case 9:
                        t.next = 12;
                        break;

                      case 11:
                        this.authStateManager.unsubscribe(n);

                      case 12:
                      case "end":
                        return t.stop();
                    }
                  }
                }, t, this);
              }));
            }
          }, {
            key: "isPKCE",
            value: function value() {
              return !!this.options.pkce;
            }
          }, {
            key: "hasResponseType",
            value: function value(e) {
              return Array.isArray(this.options.responseType) && this.options.responseType.length ? this.options.responseType.indexOf(e) >= 0 : this.options.responseType === e;
            }
          }, {
            key: "isAuthorizationCodeFlow",
            value: function value() {
              return this.hasResponseType("code");
            }
          }]), t;
        }(V);

        ae.features = ae.prototype.features = _, Object.assign(ae, {
          constants: K,
          isInteractionRequiredError: Y.z
        }), t.a = ae;
      }, function (e, t, n) {
        "use strict";

        (function (e) {
          var r = n(18),
              o = n.n(r),
              i = n(39),
              a = n.n(i);

          t.a = function (t, n, r) {
            var i = r.data,
                s = r.headers || {};
            "application/json" === (s["Content-Type"] || s["content-type"] || "") && i && "string" != typeof i && (i = JSON.stringify(i));
            var l = (e.fetch || a.a)(n, {
              method: t,
              headers: r.headers,
              body: i,
              credentials: r.withCredentials ? "include" : "omit"
            });
            return l.finally || (l = Promise.resolve(l)), l.then(function (e) {
              var t = !e.ok,
                  n = e.status;
              return function (e) {
                return e.headers.get("Content-Type") && e.headers.get("Content-Type").toLowerCase().indexOf("application/json") >= 0 ? e.json().catch(function (e) {
                  return {
                    error: e,
                    errorSummary: "Could not parse server response"
                  };
                }) : e.text();
              }(e).then(function (e) {
                return function (e, t) {
                  var n = "object" === o()(t),
                      r = {
                    responseText: n ? JSON.stringify(t) : t,
                    status: e
                  };
                  return n && (r.responseType = "json", r.responseJSON = t), r;
                }(n, e);
              }).then(function (e) {
                if (t) throw e;
                return e;
              });
            });
          };
        }).call(this, n(46));
      }, function (e, t) {
        var n = function (e) {
          function t() {
            this.fetch = !1, this.DOMException = e.DOMException;
          }

          return t.prototype = e, new t();
        }("undefined" != typeof self ? self : this);

        !function (e) {
          !function (t) {
            function n(e) {
              if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
              return e.toLowerCase();
            }

            function r(e) {
              return "string" != typeof e && (e = String(e)), e;
            }

            function o(e) {
              var t = {
                next: function next() {
                  var t = e.shift();
                  return {
                    done: void 0 === t,
                    value: t
                  };
                }
              };
              return g && (t[Symbol.iterator] = function () {
                return t;
              }), t;
            }

            function i(e) {
              this.map = {}, e instanceof i ? e.forEach(function (e, t) {
                this.append(t, e);
              }, this) : Array.isArray(e) ? e.forEach(function (e) {
                this.append(e[0], e[1]);
              }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
                this.append(t, e[t]);
              }, this);
            }

            function a(e) {
              if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
              e.bodyUsed = !0;
            }

            function s(e) {
              return new Promise(function (t, n) {
                e.onload = function () {
                  t(e.result);
                }, e.onerror = function () {
                  n(e.error);
                };
              });
            }

            function l(e) {
              var t = new FileReader(),
                  n = s(t);
              return t.readAsArrayBuffer(e), n;
            }

            function u(e) {
              if (e.slice) return e.slice(0);
              var t = new Uint8Array(e.byteLength);
              return t.set(new Uint8Array(e)), t.buffer;
            }

            function c() {
              return this.bodyUsed = !1, this._initBody = function (e) {
                var t;
                this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : v && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : y && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : m && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : b && v && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = u(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : b && (ArrayBuffer.prototype.isPrototypeOf(e) || w(e)) ? this._bodyArrayBuffer = u(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : m && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
              }, v && (this.blob = function () {
                var e = a(this);
                if (e) return e;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                return Promise.resolve(new Blob([this._bodyText]));
              }, this.arrayBuffer = function () {
                return this._bodyArrayBuffer ? a(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(l);
              }), this.text = function () {
                var e,
                    t,
                    n,
                    r = a(this);
                if (r) return r;
                if (this._bodyBlob) return e = this._bodyBlob, t = new FileReader(), n = s(t), t.readAsText(e), n;
                if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
                  for (var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++) {
                    n[r] = String.fromCharCode(t[r]);
                  }

                  return n.join("");
                }(this._bodyArrayBuffer));
                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                return Promise.resolve(this._bodyText);
              }, y && (this.formData = function () {
                return this.text().then(f);
              }), this.json = function () {
                return this.text().then(JSON.parse);
              }, this;
            }

            function d(e, t) {
              var n,
                  r,
                  o = (t = t || {}).body;

              if (e instanceof d) {
                if (e.bodyUsed) throw new TypeError("Already read");
                this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new i(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, o || null == e._bodyInit || (o = e._bodyInit, e.bodyUsed = !0);
              } else this.url = String(e);

              if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new i(t.headers)), this.method = (n = t.method || this.method || "GET", r = n.toUpperCase(), E.indexOf(r) > -1 ? r : n), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");

              this._initBody(o);
            }

            function f(e) {
              var t = new FormData();
              return e.trim().split("&").forEach(function (e) {
                if (e) {
                  var n = e.split("="),
                      r = n.shift().replace(/\+/g, " "),
                      o = n.join("=").replace(/\+/g, " ");
                  t.append(decodeURIComponent(r), decodeURIComponent(o));
                }
              }), t;
            }

            function p(e, t) {
              t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new i(t.headers), this.url = t.url || "", this._initBody(e);
            }

            function h(e, n) {
              return new Promise(function (r, o) {
                function a() {
                  l.abort();
                }

                var s = new d(e, n);
                if (s.signal && s.signal.aborted) return o(new t.DOMException("Aborted", "AbortError"));
                var l = new XMLHttpRequest();
                l.onload = function () {
                  var e,
                      t,
                      n = {
                    status: l.status,
                    statusText: l.statusText,
                    headers: (e = l.getAllResponseHeaders() || "", t = new i(), e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
                      var n = e.split(":"),
                          r = n.shift().trim();

                      if (r) {
                        var o = n.join(":").trim();
                        t.append(r, o);
                      }
                    }), t)
                  };
                  n.url = "responseURL" in l ? l.responseURL : n.headers.get("X-Request-URL");
                  var o = "response" in l ? l.response : l.responseText;
                  r(new p(o, n));
                }, l.onerror = function () {
                  o(new TypeError("Network request failed"));
                }, l.ontimeout = function () {
                  o(new TypeError("Network request failed"));
                }, l.onabort = function () {
                  o(new t.DOMException("Aborted", "AbortError"));
                }, l.open(s.method, s.url, !0), "include" === s.credentials ? l.withCredentials = !0 : "omit" === s.credentials && (l.withCredentials = !1), "responseType" in l && v && (l.responseType = "blob"), s.headers.forEach(function (e, t) {
                  l.setRequestHeader(t, e);
                }), s.signal && (s.signal.addEventListener("abort", a), l.onreadystatechange = function () {
                  4 === l.readyState && s.signal.removeEventListener("abort", a);
                }), l.send(void 0 === s._bodyInit ? null : s._bodyInit);
              });
            }

            var m = "URLSearchParams" in e,
                g = "Symbol" in e && "iterator" in Symbol,
                v = "FileReader" in e && "Blob" in e && function () {
              try {
                return new Blob(), !0;
              } catch (e) {
                return !1;
              }
            }(),
                y = "FormData" in e,
                b = "ArrayBuffer" in e;

            if (b) var _ = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
                w = ArrayBuffer.isView || function (e) {
              return e && _.indexOf(Object.prototype.toString.call(e)) > -1;
            };
            i.prototype.append = function (e, t) {
              e = n(e), t = r(t);
              var o = this.map[e];
              this.map[e] = o ? o + ", " + t : t;
            }, i.prototype.delete = function (e) {
              delete this.map[n(e)];
            }, i.prototype.get = function (e) {
              return e = n(e), this.has(e) ? this.map[e] : null;
            }, i.prototype.has = function (e) {
              return this.map.hasOwnProperty(n(e));
            }, i.prototype.set = function (e, t) {
              this.map[n(e)] = r(t);
            }, i.prototype.forEach = function (e, t) {
              for (var n in this.map) {
                this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
              }
            }, i.prototype.keys = function () {
              var e = [];
              return this.forEach(function (t, n) {
                e.push(n);
              }), o(e);
            }, i.prototype.values = function () {
              var e = [];
              return this.forEach(function (t) {
                e.push(t);
              }), o(e);
            }, i.prototype.entries = function () {
              var e = [];
              return this.forEach(function (t, n) {
                e.push([n, t]);
              }), o(e);
            }, g && (i.prototype[Symbol.iterator] = i.prototype.entries);
            var E = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
            d.prototype.clone = function () {
              return new d(this, {
                body: this._bodyInit
              });
            }, c.call(d.prototype), c.call(p.prototype), p.prototype.clone = function () {
              return new p(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new i(this.headers),
                url: this.url
              });
            }, p.error = function () {
              var e = new p(null, {
                status: 0,
                statusText: ""
              });
              return e.type = "error", e;
            };
            var O = [301, 302, 303, 307, 308];
            p.redirect = function (e, t) {
              if (-1 === O.indexOf(t)) throw new RangeError("Invalid status code");
              return new p(null, {
                status: t,
                headers: {
                  location: e
                }
              });
            }, t.DOMException = e.DOMException;

            try {
              new t.DOMException();
            } catch (e) {
              t.DOMException = function (e, t) {
                this.message = e, this.name = t;
                var n = Error(e);
                this.stack = n.stack;
              }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
            }

            h.polyfill = !0, e.fetch || (e.fetch = h, e.Headers = i, e.Request = d, e.Response = p), t.Headers = i, t.Request = d, t.Response = p, t.fetch = h;
          }({});
        }(n), delete n.fetch.polyfill, (t = n.fetch).default = n.fetch, t.fetch = n.fetch, t.Headers = n.Headers, t.Request = n.Request, t.Response = n.Response, e.exports = t;
      }, function (e, t, n) {
        var r = n(48),
            o = n(49),
            i = n(50),
            a = n(52);

        e.exports = function (e, t) {
          return r(e) || o(e, t) || i(e, t) || a();
        };
      }, function (e, t, n) {
        "use strict";

        n.r(t);
        var r = n(37);
        n.d(t, "OktaAuth", function () {
          return r.a;
        });
        var o = n(3);
        n.d(t, "STATE_TOKEN_KEY_NAME", function () {
          return o.STATE_TOKEN_KEY_NAME;
        }), n.d(t, "DEFAULT_POLLING_DELAY", function () {
          return o.DEFAULT_POLLING_DELAY;
        }), n.d(t, "DEFAULT_MAX_CLOCK_SKEW", function () {
          return o.DEFAULT_MAX_CLOCK_SKEW;
        }), n.d(t, "DEFAULT_CACHE_DURATION", function () {
          return o.DEFAULT_CACHE_DURATION;
        }), n.d(t, "REDIRECT_OAUTH_PARAMS_NAME", function () {
          return o.REDIRECT_OAUTH_PARAMS_NAME;
        }), n.d(t, "REDIRECT_STATE_COOKIE_NAME", function () {
          return o.REDIRECT_STATE_COOKIE_NAME;
        }), n.d(t, "REDIRECT_NONCE_COOKIE_NAME", function () {
          return o.REDIRECT_NONCE_COOKIE_NAME;
        }), n.d(t, "TOKEN_STORAGE_NAME", function () {
          return o.TOKEN_STORAGE_NAME;
        }), n.d(t, "CACHE_STORAGE_NAME", function () {
          return o.CACHE_STORAGE_NAME;
        }), n.d(t, "PKCE_STORAGE_NAME", function () {
          return o.PKCE_STORAGE_NAME;
        }), n.d(t, "TRANSACTION_STORAGE_NAME", function () {
          return o.TRANSACTION_STORAGE_NAME;
        }), n.d(t, "ACCESS_TOKEN_STORAGE_KEY", function () {
          return o.ACCESS_TOKEN_STORAGE_KEY;
        }), n.d(t, "ID_TOKEN_STORAGE_KEY", function () {
          return o.ID_TOKEN_STORAGE_KEY;
        }), n.d(t, "REFRESH_TOKEN_STORAGE_KEY", function () {
          return o.REFRESH_TOKEN_STORAGE_KEY;
        }), n.d(t, "REFERRER_PATH_STORAGE_KEY", function () {
          return o.REFERRER_PATH_STORAGE_KEY;
        }), n.d(t, "MIN_VERIFIER_LENGTH", function () {
          return o.MIN_VERIFIER_LENGTH;
        }), n.d(t, "MAX_VERIFIER_LENGTH", function () {
          return o.MAX_VERIFIER_LENGTH;
        }), n.d(t, "DEFAULT_CODE_CHALLENGE_METHOD", function () {
          return o.DEFAULT_CODE_CHALLENGE_METHOD;
        });
        var i = n(7);

        for (var a in i) {
          ["OktaAuth", "STATE_TOKEN_KEY_NAME", "DEFAULT_POLLING_DELAY", "DEFAULT_MAX_CLOCK_SKEW", "DEFAULT_CACHE_DURATION", "REDIRECT_OAUTH_PARAMS_NAME", "REDIRECT_STATE_COOKIE_NAME", "REDIRECT_NONCE_COOKIE_NAME", "TOKEN_STORAGE_NAME", "CACHE_STORAGE_NAME", "PKCE_STORAGE_NAME", "TRANSACTION_STORAGE_NAME", "ACCESS_TOKEN_STORAGE_KEY", "ID_TOKEN_STORAGE_KEY", "REFRESH_TOKEN_STORAGE_KEY", "REFERRER_PATH_STORAGE_KEY", "MIN_VERIFIER_LENGTH", "MAX_VERIFIER_LENGTH", "DEFAULT_CODE_CHALLENGE_METHOD", "default"].indexOf(a) < 0 && function (e) {
            n.d(t, e, function () {
              return i[e];
            });
          }(a);
        }

        var s = n(14);
        n.d(t, "transactionStatus", function () {
          return s.j;
        }), n.d(t, "resumeTransaction", function () {
          return s.h;
        }), n.d(t, "transactionExists", function () {
          return s.i;
        }), n.d(t, "postToTransaction", function () {
          return s.g;
        }), n.d(t, "introspect", function () {
          return s.f;
        }), n.d(t, "AuthTransaction", function () {
          return s.a;
        }), n.d(t, "getPollFn", function () {
          return s.d;
        }), n.d(t, "TransactionState", function () {
          return s.b;
        }), n.d(t, "addStateToken", function () {
          return s.c;
        }), n.d(t, "getStateToken", function () {
          return s.e;
        });
        var l = n(1);
        n.d(t, "AuthApiError", function () {
          return l.a;
        }), n.d(t, "AuthPollStopError", function () {
          return l.b;
        }), n.d(t, "AuthSdkError", function () {
          return l.c;
        }), n.d(t, "OAuthError", function () {
          return l.d;
        });
        var u = n(8);
        n.d(t, "convertTokenParamsToOAuthParams", function () {
          return u.d;
        }), n.d(t, "buildAuthorizeParams", function () {
          return u.c;
        }), n.d(t, "postToTokenEndpoint", function () {
          return u.H;
        }), n.d(t, "postRefreshToken", function () {
          return u.G;
        }), n.d(t, "getWellKnown", function () {
          return u.o;
        }), n.d(t, "getKey", function () {
          return u.k;
        }), n.d(t, "addListener", function () {
          return u.a;
        }), n.d(t, "removeListener", function () {
          return u.J;
        }), n.d(t, "loadFrame", function () {
          return u.C;
        }), n.d(t, "loadPopup", function () {
          return u.D;
        }), n.d(t, "addPostMessageListener", function () {
          return u.b;
        }), n.d(t, "getDefaultTokenParams", function () {
          return u.i;
        }), n.d(t, "isInteractionRequiredError", function () {
          return u.z;
        }), n.d(t, "hasTokensInHash", function () {
          return u.w;
        }), n.d(t, "hasAuthorizationCode", function () {
          return u.t;
        }), n.d(t, "hasInteractionCode", function () {
          return u.v;
        }), n.d(t, "hasErrorInUrl", function () {
          return u.u;
        }), n.d(t, "isRedirectUri", function () {
          return u.B;
        }), n.d(t, "isCodeFlow", function () {
          return u.x;
        }), n.d(t, "getHashOrSearch", function () {
          return u.j;
        }), n.d(t, "isLoginRedirect", function () {
          return u.A;
        }), n.d(t, "isInteractionRequired", function () {
          return u.y;
        }), n.d(t, "generateState", function () {
          return u.h;
        }), n.d(t, "generateNonce", function () {
          return u.g;
        }), n.d(t, "getOAuthUrls", function () {
          return u.l;
        }), n.d(t, "pkce", function () {
          return u.F;
        }), n.d(t, "prepareTokenParams", function () {
          return u.I;
        }), n.d(t, "urlParamsToObject", function () {
          return u.N;
        }), n.d(t, "validateClaims", function () {
          return u.O;
        }), n.d(t, "decodeToken", function () {
          return u.e;
        }), n.d(t, "revokeToken", function () {
          return u.M;
        }), n.d(t, "renewToken", function () {
          return u.K;
        }), n.d(t, "renewTokens", function () {
          return u.L;
        }), n.d(t, "verifyToken", function () {
          return u.P;
        }), n.d(t, "getUserInfo", function () {
          return u.n;
        }), n.d(t, "handleOAuthResponse", function () {
          return u.s;
        }), n.d(t, "exchangeCodeForTokens", function () {
          return u.f;
        }), n.d(t, "getToken", function () {
          return u.m;
        }), n.d(t, "getWithoutPrompt", function () {
          return u.r;
        }), n.d(t, "getWithPopup", function () {
          return u.p;
        }), n.d(t, "getWithRedirect", function () {
          return u.q;
        }), n.d(t, "parseFromUrl", function () {
          return u.E;
        }), n(23), n(22);
        var c = n(16);
        n.d(t, "EVENT_EXPIRED", function () {
          return c.c;
        }), n.d(t, "EVENT_RENEWED", function () {
          return c.e;
        }), n.d(t, "EVENT_ADDED", function () {
          return c.a;
        }), n.d(t, "EVENT_REMOVED", function () {
          return c.d;
        }), n.d(t, "EVENT_ERROR", function () {
          return c.b;
        }), n.d(t, "TokenManager", function () {
          return c.f;
        });
        var d = n(0);
        n.d(t, "stringToBase64Url", function () {
          return d.A;
        }), n.d(t, "base64ToBase64Url", function () {
          return d.a;
        }), n.d(t, "base64UrlToBase64", function () {
          return d.c;
        }), n.d(t, "base64UrlToString", function () {
          return d.d;
        }), n.d(t, "stringToBuffer", function () {
          return d.B;
        }), n.d(t, "base64UrlDecode", function () {
          return d.b;
        }), n.d(t, "bind", function () {
          return d.e;
        }), n.d(t, "isAbsoluteUrl", function () {
          return d.p;
        }), n.d(t, "toAbsoluteUrl", function () {
          return d.C;
        }), n.d(t, "toRelativeUrl", function () {
          return d.E;
        }), n.d(t, "isString", function () {
          return d.v;
        }), n.d(t, "isObject", function () {
          return d.t;
        }), n.d(t, "isNumber", function () {
          return d.s;
        }), n.d(t, "isoToUTCString", function () {
          return d.w;
        }), n.d(t, "toQueryString", function () {
          return d.D;
        }), n.d(t, "genRandomString", function () {
          return d.l;
        }), n.d(t, "extend", function () {
          return d.j;
        }), n.d(t, "removeNils", function () {
          return d.y;
        }), n.d(t, "clone", function () {
          return d.f;
        }), n.d(t, "omit", function () {
          return d.x;
        }), n.d(t, "find", function () {
          return d.k;
        }), n.d(t, "getLink", function () {
          return d.n;
        }), n.d(t, "getNativeConsole", function () {
          return d.o;
        }), n.d(t, "getConsole", function () {
          return d.m;
        }), n.d(t, "warn", function () {
          return d.F;
        }), n.d(t, "deprecate", function () {
          return d.h;
        }), n.d(t, "deprecateWrap", function () {
          return d.i;
        }), n.d(t, "removeTrailingSlash", function () {
          return d.z;
        }), n.d(t, "isIE11OrLess", function () {
          return d.r;
        }), n.d(t, "isFunction", function () {
          return d.q;
        }), n.d(t, "delay", function () {
          return d.g;
        }), n.d(t, "isPromise", function () {
          return d.u;
        });
      }, function (e, t, n) {
        var r = function (e) {
          "use strict";

          function t(e, t, o, i) {
            var a = t && t.prototype instanceof r ? t : r,
                s = Object.create(a.prototype),
                u = new d(i || []);
            return s._invoke = function (e, t, r) {
              var o = "suspendedStart";
              return function (i, a) {
                if ("executing" === o) throw new Error("Generator is already running");

                if ("completed" === o) {
                  if ("throw" === i) throw a;
                  return p();
                }

                for (r.method = i, r.arg = a;;) {
                  var s = r.delegate;

                  if (s) {
                    var u = l(s, r);

                    if (u) {
                      if (u === _) continue;
                      return u;
                    }
                  }

                  if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                    if ("suspendedStart" === o) throw o = "completed", r.arg;
                    r.dispatchException(r.arg);
                  } else "return" === r.method && r.abrupt("return", r.arg);
                  o = "executing";
                  var c = n(e, t, r);

                  if ("normal" === c.type) {
                    if (o = r.done ? "completed" : "suspendedYield", c.arg === _) continue;
                    return {
                      value: c.arg,
                      done: r.done
                    };
                  }

                  "throw" === c.type && (o = "completed", r.method = "throw", r.arg = c.arg);
                }
              };
            }(e, o, u), s;
          }

          function n(e, t, n) {
            try {
              return {
                type: "normal",
                arg: e.call(t, n)
              };
            } catch (e) {
              return {
                type: "throw",
                arg: e
              };
            }
          }

          function r() {}

          function o() {}

          function i() {}

          function a(e) {
            ["next", "throw", "return"].forEach(function (t) {
              e[t] = function (e) {
                return this._invoke(t, e);
              };
            });
          }

          function s(e, t) {
            var r;

            this._invoke = function (o, i) {
              function a() {
                return new t(function (r, a) {
                  !function r(o, i, a, s) {
                    var l = n(e[o], e, i);

                    if ("throw" !== l.type) {
                      var u = l.arg,
                          c = u.value;
                      return c && "object" == typeof c && m.call(c, "__await") ? t.resolve(c.__await).then(function (e) {
                        r("next", e, a, s);
                      }, function (e) {
                        r("throw", e, a, s);
                      }) : t.resolve(c).then(function (e) {
                        u.value = e, a(u);
                      }, function (e) {
                        return r("throw", e, a, s);
                      });
                    }

                    s(l.arg);
                  }(o, i, r, a);
                });
              }

              return r = r ? r.then(a, a) : a();
            };
          }

          function l(e, t) {
            var r = e.iterator[t.method];

            if (void 0 === r) {
              if (t.delegate = null, "throw" === t.method) {
                if (e.iterator.return && (t.method = "return", t.arg = void 0, l(e, t), "throw" === t.method)) return _;
                t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
              }

              return _;
            }

            var o = n(r, e.iterator, t.arg);
            if ("throw" === o.type) return t.method = "throw", t.arg = o.arg, t.delegate = null, _;
            var i = o.arg;
            return i ? i.done ? (t[e.resultName] = i.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, _) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, _);
          }

          function u(e) {
            var t = {
              tryLoc: e[0]
            };
            1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
          }

          function c(e) {
            var t = e.completion || {};
            t.type = "normal", delete t.arg, e.completion = t;
          }

          function d(e) {
            this.tryEntries = [{
              tryLoc: "root"
            }], e.forEach(u, this), this.reset(!0);
          }

          function f(e) {
            if (e) {
              var t = e[v];
              if (t) return t.call(e);
              if ("function" == typeof e.next) return e;

              if (!isNaN(e.length)) {
                var n = -1,
                    r = function t() {
                  for (; ++n < e.length;) {
                    if (m.call(e, n)) return t.value = e[n], t.done = !1, t;
                  }

                  return t.value = void 0, t.done = !0, t;
                };

                return r.next = r;
              }
            }

            return {
              next: p
            };
          }

          function p() {
            return {
              value: void 0,
              done: !0
            };
          }

          var h = Object.prototype,
              m = h.hasOwnProperty,
              g = "function" == typeof Symbol ? Symbol : {},
              v = g.iterator || "@@iterator",
              y = g.asyncIterator || "@@asyncIterator",
              b = g.toStringTag || "@@toStringTag";
          e.wrap = t;
          var _ = {},
              w = {};

          w[v] = function () {
            return this;
          };

          var E = Object.getPrototypeOf,
              O = E && E(E(f([])));
          O && O !== h && m.call(O, v) && (w = O);
          var S = i.prototype = r.prototype = Object.create(w);
          return o.prototype = S.constructor = i, i.constructor = o, i[b] = o.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return !!t && (t === o || "GeneratorFunction" === (t.displayName || t.name));
          }, e.mark = function (e) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(e, i) : (e.__proto__ = i, b in e || (e[b] = "GeneratorFunction")), e.prototype = Object.create(S), e;
          }, e.awrap = function (e) {
            return {
              __await: e
            };
          }, a(s.prototype), s.prototype[y] = function () {
            return this;
          }, e.AsyncIterator = s, e.async = function (n, r, o, i, a) {
            void 0 === a && (a = Promise);
            var l = new s(t(n, r, o, i), a);
            return e.isGeneratorFunction(r) ? l : l.next().then(function (e) {
              return e.done ? e.value : l.next();
            });
          }, a(S), S[b] = "Generator", S[v] = function () {
            return this;
          }, S.toString = function () {
            return "[object Generator]";
          }, e.keys = function (e) {
            var t = [];

            for (var n in e) {
              t.push(n);
            }

            return t.reverse(), function n() {
              for (; t.length;) {
                var r = t.pop();
                if (r in e) return n.value = r, n.done = !1, n;
              }

              return n.done = !0, n;
            };
          }, e.values = f, d.prototype = {
            constructor: d,
            reset: function reset(e) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(c), !e) for (var t in this) {
                "t" === t.charAt(0) && m.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
              }
            },
            stop: function stop() {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function dispatchException(e) {
              function t(t, r) {
                return i.type = "throw", i.arg = e, n.next = t, r && (n.method = "next", n.arg = void 0), !!r;
              }

              if (this.done) throw e;

              for (var n = this, r = this.tryEntries.length - 1; r >= 0; --r) {
                var o = this.tryEntries[r],
                    i = o.completion;
                if ("root" === o.tryLoc) return t("end");

                if (o.tryLoc <= this.prev) {
                  var a = m.call(o, "catchLoc"),
                      s = m.call(o, "finallyLoc");

                  if (a && s) {
                    if (this.prev < o.catchLoc) return t(o.catchLoc, !0);
                    if (this.prev < o.finallyLoc) return t(o.finallyLoc);
                  } else if (a) {
                    if (this.prev < o.catchLoc) return t(o.catchLoc, !0);
                  } else {
                    if (!s) throw new Error("try statement without catch or finally");
                    if (this.prev < o.finallyLoc) return t(o.finallyLoc);
                  }
                }
              }
            },
            abrupt: function abrupt(e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var r = this.tryEntries[n];

                if (r.tryLoc <= this.prev && m.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                  var o = r;
                  break;
                }
              }

              o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
              var i = o ? o.completion : {};
              return i.type = e, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, _) : this.complete(i);
            },
            complete: function complete(e, t) {
              if ("throw" === e.type) throw e.arg;
              return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), _;
            },
            finish: function finish(e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), c(n), _;
              }
            },
            catch: function _catch(e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];

                if (n.tryLoc === e) {
                  var r = n.completion;

                  if ("throw" === r.type) {
                    var o = r.arg;
                    c(n);
                  }

                  return o;
                }
              }

              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(e, t, n) {
              return this.delegate = {
                iterator: f(e),
                resultName: t,
                nextLoc: n
              }, "next" === this.method && (this.arg = void 0), _;
            }
          }, e;
        }(e.exports);

        try {
          regeneratorRuntime = r;
        } catch (e) {
          Function("r", "regeneratorRuntime = r")(r);
        }
      }, function (e, t) {
        e.exports = function (e) {
          return -1 !== Function.toString.call(e).indexOf("[native code]");
        };
      }, function (e, t, n) {
        function r(t, n, a) {
          return i() ? e.exports = r = Reflect.construct : e.exports = r = function r(e, t, n) {
            var r = [null];
            r.push.apply(r, t);
            var i = new (Function.bind.apply(e, r))();
            return n && o(i, n.prototype), i;
          }, r.apply(null, arguments);
        }

        var o = n(25),
            i = n(45);
        e.exports = r;
      }, function (e, t) {
        e.exports = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        };
      }, function (e, t) {
        var n;

        n = function () {
          return this;
        }();

        try {
          n = n || new Function("return this")();
        } catch (e) {
          "object" == typeof window && (n = window);
        }

        e.exports = n;
      }, function (e, t, n) {
        var r, o;
        /*!
        * JavaScript Cookie v2.2.1
        * https://github.com/js-cookie/js-cookie
        *
        * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
        * Released under the MIT license
        */

        !function (i) {
          if (void 0 === (o = "function" == typeof (r = i) ? r.call(t, n, t, e) : r) || (e.exports = o), e.exports = i(), !1) {
            var a = window.Cookies,
                s = window.Cookies = i();

            s.noConflict = function () {
              return window.Cookies = a, s;
            };
          }
        }(function () {
          function e() {
            for (var e = 0, t = {}; e < arguments.length; e++) {
              var n = arguments[e];

              for (var r in n) {
                t[r] = n[r];
              }
            }

            return t;
          }

          function t(e) {
            return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
          }

          return function n(r) {
            function o() {}

            function i(t, n, i) {
              if ("undefined" != typeof document) {
                "number" == typeof (i = e({
                  path: "/"
                }, o.defaults, i)).expires && (i.expires = new Date(1 * new Date() + 864e5 * i.expires)), i.expires = i.expires ? i.expires.toUTCString() : "";

                try {
                  var a = JSON.stringify(n);
                  /^[\{\[]/.test(a) && (n = a);
                } catch (e) {}

                n = r.write ? r.write(n, t) : encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = encodeURIComponent(String(t)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                var s = "";

                for (var l in i) {
                  i[l] && (s += "; " + l, !0 !== i[l] && (s += "=" + i[l].split(";")[0]));
                }

                return document.cookie = t + "=" + n + s;
              }
            }

            function a(e, n) {
              if ("undefined" != typeof document) {
                for (var o = {}, i = document.cookie ? document.cookie.split("; ") : [], a = 0; a < i.length; a++) {
                  var s = i[a].split("="),
                      l = s.slice(1).join("=");
                  n || '"' !== l.charAt(0) || (l = l.slice(1, -1));

                  try {
                    var u = t(s[0]);
                    if (l = (r.read || r)(l, u) || t(l), n) try {
                      l = JSON.parse(l);
                    } catch (e) {}
                    if (o[u] = l, e === u) break;
                  } catch (e) {}
                }

                return e ? o[e] : o;
              }
            }

            return o.set = i, o.get = function (e) {
              return a(e, !1);
            }, o.getJSON = function (e) {
              return a(e, !0);
            }, o.remove = function (t, n) {
              i(t, "", e(n, {
                expires: -1
              }));
            }, o.defaults = {}, o.withConverter = n, o;
          }(function () {});
        });
      }, function (e, t) {
        e.exports = function (e) {
          if (Array.isArray(e)) return e;
        };
      }, function (e, t) {
        e.exports = function (e, t) {
          if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
            var n = [],
                r = !0,
                o = !1,
                i = void 0;

            try {
              for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
                ;
              }
            } catch (e) {
              o = !0, i = e;
            } finally {
              try {
                r || null == s.return || s.return();
              } finally {
                if (o) throw i;
              }
            }

            return n;
          }
        };
      }, function (e, t, n) {
        var r = n(51);

        e.exports = function (e, t) {
          if (e) {
            if ("string" == typeof e) return r(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(e, t) : void 0;
          }
        };
      }, function (e, t) {
        e.exports = function (e, t) {
          (null == t || t > e.length) && (t = e.length);

          for (var n = 0, r = new Array(t); n < t; n++) {
            r[n] = e[n];
          }

          return r;
        };
      }, function (e, t) {
        e.exports = function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        };
      }, function (e, t, n) {
        "use strict";

        function r(e, t) {
          var _n2;

          if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
            if (Array.isArray(e) || (_n2 = function (e, t) {
              if (e) {
                if ("string" == typeof e) return o(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? o(e, t) : void 0;
              }
            }(e)) || t && e && "number" == typeof e.length) {
              _n2 && (e = _n2);

              var r = 0,
                  i = function i() {};

              return {
                s: i,
                n: function n() {
                  return r >= e.length ? {
                    done: !0
                  } : {
                    done: !1,
                    value: e[r++]
                  };
                },
                e: function e(_e2) {
                  throw _e2;
                },
                f: i
              };
            }

            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }

          var a,
              s = !0,
              l = !1;
          return {
            s: function s() {
              _n2 = e[Symbol.iterator]();
            },
            n: function n() {
              var e = _n2.next();

              return s = e.done, e;
            },
            e: function e(_e3) {
              l = !0, a = _e3;
            },
            f: function f() {
              try {
                s || null == _n2.return || _n2.return();
              } finally {
                if (l) throw a;
              }
            }
          };
        }

        function o(e, t) {
          (null == t || t > e.length) && (t = e.length);

          for (var n = 0, r = new Array(t); n < t; n++) {
            r[n] = e[n];
          }

          return r;
        }

        function i(e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();

          return function () {
            var n,
                r = c(e);

            if (t) {
              var o = c(this).constructor;
              n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);

            return u(this, n);
          };
        }

        var a = n(4),
            s = n(11),
            l = n(12),
            u = n(13),
            c = n(10),
            d = function (e) {
          function t(e) {
            var r;
            return a(this, t), (r = n.call(this, e || "Promise was canceled")).name = "CancelError", r;
          }

          l(t, e);
          var n = i(t);
          return s(t, [{
            key: "isCanceled",
            get: function get() {
              return !0;
            }
          }]), t;
        }(n(26)(Error)),
            f = function () {
          function e(t) {
            var n = this;
            a(this, e), this._cancelHandlers = [], this._isPending = !0, this._isCanceled = !1, this._rejectOnCancel = !0, this._promise = new Promise(function (e, r) {
              n._reject = r;

              var o = function o(e) {
                if (!n._isPending) throw new Error("The `onCancel` handler was attached after the promise settled.");

                n._cancelHandlers.push(e);
              };

              return Object.defineProperties(o, {
                shouldReject: {
                  get: function get() {
                    return n._rejectOnCancel;
                  },
                  set: function set(e) {
                    n._rejectOnCancel = e;
                  }
                }
              }), t(function (t) {
                n._isPending = !1, e(t);
              }, function (e) {
                n._isPending = !1, r(e);
              }, o);
            });
          }

          return s(e, null, [{
            key: "fn",
            value: function value(t) {
              return function () {
                for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
                  r[o] = arguments[o];
                }

                return new e(function (e, n, o) {
                  r.push(o), t.apply(void 0, r).then(e, n);
                });
              };
            }
          }]), s(e, [{
            key: "then",
            value: function value(e, t) {
              return this._promise.then(e, t);
            }
          }, {
            key: "catch",
            value: function value(e) {
              return this._promise.catch(e);
            }
          }, {
            key: "finally",
            value: function value(e) {
              return this._promise.finally(e);
            }
          }, {
            key: "cancel",
            value: function value(e) {
              if (this._isPending && !this._isCanceled) {
                if (this._cancelHandlers.length > 0) try {
                  var t,
                      n = r(this._cancelHandlers);

                  try {
                    for (n.s(); !(t = n.n()).done;) {
                      (0, t.value)();
                    }
                  } catch (e) {
                    n.e(e);
                  } finally {
                    n.f();
                  }
                } catch (e) {
                  this._reject(e);
                }
                this._isCanceled = !0, this._rejectOnCancel && this._reject(new d(e));
              }
            }
          }, {
            key: "isCanceled",
            get: function get() {
              return this._isCanceled;
            }
          }]), e;
        }();

        Object.setPrototypeOf(f.prototype, Promise.prototype), e.exports = f, e.exports.CancelError = d;
      }, function (e, t) {
        function n() {}

        n.prototype = {
          on: function on(e, t, n) {
            var r = this.e || (this.e = {});
            return (r[e] || (r[e] = [])).push({
              fn: t,
              ctx: n
            }), this;
          },
          once: function once(e, t, n) {
            function r() {
              o.off(e, r), t.apply(n, arguments);
            }

            var o = this;
            return r._ = t, this.on(e, r, n);
          },
          emit: function emit(e) {
            for (var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e] || []).slice(), r = 0, o = n.length; r < o; r++) {
              n[r].fn.apply(n[r].ctx, t);
            }

            return this;
          },
          off: function off(e, t) {
            var n = this.e || (this.e = {}),
                r = n[e],
                o = [];
            if (r && t) for (var i = 0, a = r.length; i < a; i++) {
              r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
            }
            return o.length ? n[e] = o : delete n[e], this;
          }
        }, e.exports = n;
      }]);
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(15)),
        a = r(n(6)),
        s = r(n(12)),
        l = r(n(13)),
        u = {
      title: function title() {
        var e = i.default.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
        return (0, o.loc)("enroll.totp.title", "login", [e]);
      },
      subtitle: o._.partial(o.loc, "enroll.totp.enterCode", "login"),
      autoSave: !0,
      noButtonBar: !0,
      attributes: {
        "data-se": "step-sendcode"
      },
      formChildren: function formChildren() {
        return [a.default.Input({
          label: (0, o.loc)("mfa.challenge.enterCode.placeholder", "login"),
          "label-top": !0,
          explain: s.default.createInputExplain("mfa.challenge.enterCode.tooltip", "mfa.challenge.enterCode.placeholder", "login"),
          "explain-top": !0,
          name: "passCode",
          input: l.default,
          type: "tel"
        }), a.default.Toolbar({
          noCancelButton: !0,
          save: (0, o.loc)("oform.verify", "login")
        })];
      }
    },
        c = u;
    t.default = c;
  }, function (e, t, n) {
    function r(e, t) {
      return o(e) || i(e, t) || a(e, t) || s();
    }

    var o = n(482),
        i = n(483),
        a = n(253),
        s = n(484);
    e.exports = r;
  }, function (e, t, n) {
    function r(e, t) {
      if (e) {
        if ("string" == typeof e) return o(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? o(e, t) : void 0;
      }
    }

    var o = n(254);
    e.exports = r;
  }, function (e, t) {
    function n(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = r(n(2)),
        i = n(1),
        a = r(n(487)),
        s = {
      groups: "user",
      myAccount: "user",
      users: "user",
      apps: "resource",
      authenticators: "resource",
      authorizationServers: "resource",
      clients: "resource",
      domains: "resource",
      factors: "resource",
      idps: "resource",
      linkedObjects: "resource",
      policies: "resource",
      templates: "resource",
      eventHooks: "hook",
      inlineHooks: "hook",
      events: "system",
      logs: "system",
      orgs: "system",
      roles: "system",
      schemas: "system",
      sessions: "system",
      trustedOrigins: "system"
    },
        l = function l(e) {
      var t = e.name,
          n = void 0 === t ? "" : t,
          r = n.split("."),
          o = r[1];
      return s[o] || "system";
    },
        u = i.View.extend({
      className: "scope-group",
      events: {
        click: "expandScopes"
      },
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="scope-group--header"><h3>' + e.escapeExpression((i = null != (i = a(n, "groupName") || (null != t ? a(t, "groupName") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "groupName",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 37
              },
              end: {
                line: 1,
                column: 50
              }
            }
          }) : i)) + '</h3><span class="scope-group--toggle"><svg class="caret" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="path" fill-rule="evenodd" clip-rule="evenodd" d="M5.99967 4.66663L10.2663 8.66663L11.333 7.66663L5.99967 2.66663L0.666342 7.73636L1.73301 8.66663L5.99967 4.66663Z" fill="#A0A7AC"></path></svg></span></div>';
        },
        useData: !0
      }),
      expandScopes: function expandScopes() {
        this.$el.toggleClass("scope-group--is-expanded"), this.$(".caret").toggleClass("caret--is-rotated");
      },
      preRender: function preRender() {
        var e = this;

        i._.chain(this.options.scopes).sortBy(function (e) {
          return e.name;
        }).each(function (t) {
          var n = t.name,
              r = t.displayName,
              o = t.description;
          e.add(a.default, {
            options: {
              name: r || n,
              description: o
            }
          });
        });
      }
    }),
        c = i.View.extend({
      className: "scope-list detail-row",
      postRender: function postRender() {
        var e = this,
            t = this.model.get("scopes"),
            n = i._.groupBy(t, l),
            r = {
          user: (0, i.loc)("admin.consent.group.user.group", "login"),
          resource: (0, i.loc)("admin.consent.group.resource.policy", "login"),
          hook: (0, i.loc)("admin.consent.group.hook", "login"),
          system: (0, i.loc)("admin.consent.group.system", "login")
        };

        i._.each(r, function (t, r) {
          var o = n[r];
          Array.isArray(o) && e.add(u, {
            options: {
              groupName: t,
              scopes: o
            }
          });
        });
      }
    });

    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = o.default.template({
      1: function _(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return '<a href="' + e.escapeExpression((i = null != (i = a(n, "clientURI") || (null != t ? a(t, "clientURI") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
          name: "clientURI",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 26
            },
            end: {
              line: 1,
              column: 39
            }
          }
        }) : i)) + '" class="client-logo-link" target="_blank">';
      },
      3: function _(e, t, n, r, o) {
        var i,
            a = null != t ? t : e.nullContext || {},
            s = e.hooks.helperMissing,
            l = e.escapeExpression,
            u = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return '<img class="client-logo custom-logo" src="' + l((i = null != (i = u(n, "customLogo") || (null != t ? u(t, "customLogo") : t)) ? i : s, "function" == typeof i ? i.call(a, {
          name: "customLogo",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 149
            },
            end: {
              line: 1,
              column: 163
            }
          }
        }) : i)) + '" alt="' + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
          name: "i18n",
          hash: {
            bundle: "login",
            code: "common.logo.alt"
          },
          data: o,
          loc: {
            start: {
              line: 1,
              column: 170
            },
            end: {
              line: 1,
              column: 216
            }
          }
        })) + '" aria-hidden="true" />';
      },
      5: function _(e, t, n, r, o) {
        var i,
            a = null != t ? t : e.nullContext || {},
            s = e.hooks.helperMissing,
            l = e.escapeExpression,
            u = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return '<img class="client-logo default-logo" src="' + l((i = null != (i = u(n, "defaultLogo") || (null != t ? u(t, "defaultLogo") : t)) ? i : s, "function" == typeof i ? i.call(a, {
          name: "defaultLogo",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 290
            },
            end: {
              line: 1,
              column: 305
            }
          }
        }) : i)) + '" alt="' + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
          name: "i18n",
          hash: {
            bundle: "login",
            code: "common.logo.alt"
          },
          data: o,
          loc: {
            start: {
              line: 1,
              column: 312
            },
            end: {
              line: 1,
              column: 358
            }
          }
        })) + '" aria-hidden="true" />';
      },
      7: function _(e, t, n, r, o) {
        return "</a>";
      },
      9: function _(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return '<div class="issuer"><span>' + e.escapeExpression((i = null != (i = a(n, "issuer") || (null != t ? a(t, "issuer") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
          name: "issuer",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 566
            },
            end: {
              line: 1,
              column: 576
            }
          }
        }) : i)) + "</span></div>";
      },
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, o) {
        var i,
            a = null != t ? t : e.nullContext || {},
            s = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return (null != (i = s(n, "if").call(a, null != t ? s(t, "clientURI") : t, {
          name: "if",
          hash: {},
          fn: e.program(1, o, 0),
          inverse: e.noop,
          data: o,
          loc: {
            start: {
              line: 1,
              column: 0
            },
            end: {
              line: 1,
              column: 89
            }
          }
        })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "customLogo") : t, {
          name: "if",
          hash: {},
          fn: e.program(3, o, 0),
          inverse: e.program(5, o, 0),
          data: o,
          loc: {
            start: {
              line: 1,
              column: 89
            },
            end: {
              line: 1,
              column: 388
            }
          }
        })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "clientURI") : t, {
          name: "if",
          hash: {},
          fn: e.program(7, o, 0),
          inverse: e.noop,
          data: o,
          loc: {
            start: {
              line: 1,
              column: 388
            },
            end: {
              line: 1,
              column: 416
            }
          }
        })) ? i : "") + '<h1><span class="title-text">' + (null != (i = (s(n, "i18n") || t && s(t, "i18n") || e.hooks.helperMissing).call(a, {
          name: "i18n",
          hash: {
            arguments: "appName",
            bundle: "login",
            code: "consent.required.text"
          },
          data: o,
          loc: {
            start: {
              line: 1,
              column: 445
            },
            end: {
              line: 1,
              column: 519
            }
          }
        })) ? i : "") + "</span>" + (null != (i = s(n, "if").call(a, null != t ? s(t, "issuer") : t, {
          name: "if",
          hash: {},
          fn: e.program(9, o, 0),
          inverse: e.noop,
          data: o,
          loc: {
            start: {
              line: 1,
              column: 526
            },
            end: {
              line: 1,
              column: 596
            }
          }
        })) ? i : "") + "</h1>";
      },
      useData: !0
    }),
        a = i;
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = r(n(15)),
        l = r(n(39)),
        u = a.View.extend({
      className: "scan-instructions clearfix",
      template: i.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="scan-instructions-details-wrapper"><div class="scan-instructions-details"><p>' + u((a = null != (a = c(n, "instructions") || (null != t ? c(t, "instructions") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "instructions",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 89
              },
              end: {
                line: 1,
                column: 105
              }
            }
          }) : a)) + '</p></div></div><div class="scan-instructions-qrcode-wrapper"><div class="qrcode-wrap"><img data-se="qrcode" alt="' + u((a = null != (a = c(n, "altQRCode") || (null != t ? c(t, "altQRCode") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "altQRCode",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 219
              },
              end: {
                line: 1,
                column: 232
              }
            }
          }) : a)) + '" class="qrcode-image" src="' + u((a = null != (a = c(n, "qrcode") || (null != t ? c(t, "qrcode") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "qrcode",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 260
              },
              end: {
                line: 1,
                column: 270
              }
            }
          }) : a)) + '"><div data-se="qrcode-success" class="qrcode-success"></div><div data-se="qrcode-error" class="qrcode-error"></div></div><a href="#" data-type="manual-setup" data-se="manual-setup" class="link manual-setup">' + u((c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "enroll.totp.cannotScan"
            },
            data: i,
            loc: {
              start: {
                line: 1,
                column: 478
              },
              end: {
                line: 1,
                column: 531
              }
            }
          })) + '</a><a href="#" data-type="refresh-qrcode" data-se="refresh-qrcode" class="link refresh-qrcode">' + u((c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "enroll.totp.refreshBarcode"
            },
            data: i,
            loc: {
              start: {
                line: 1,
                column: 627
              },
              end: {
                line: 1,
                column: 684
              }
            }
          })) + "</a></div>";
        },
        useData: !0
      }),
      events: {
        'click [data-type="manual-setup"]': function clickDataTypeManualSetup(e) {
          var t = this;
          e.preventDefault();
          var n = l.default.createActivateFactorUrl(this.model.get("__provider__"), this.model.get("__factorType__"), "manual");
          "push" === this.model.get("__factorType__") ? this.model.doTransaction(function (e) {
            return e.prev().then(function (e) {
              return a._.findWhere(e.factors, {
                factorType: "push",
                provider: "OKTA"
              }).enroll();
            });
          }).then(function () {
            t.options.appState.trigger("navigate", n);
          }) : this.options.appState.trigger("navigate", n);
        },
        'click [data-type="refresh-qrcode"]': function clickDataTypeRefreshQrcode(e) {
          e.preventDefault(), this.model.trigger("errors:clear");
          var t = this;
          this.model.doTransaction(function (e) {
            return this.appState.get("isWaitingForActivation") ? e.poll() : e.activate();
          }).then(function (e) {
            var n = e.data;
            "MFA_ENROLL_ACTIVATE" !== n.status && "FACTOR_ENROLL_ACTIVATE" !== n.status || "WAITING" !== n.factorResult || a._.defer(a._.bind(t.render, t));
          });
        }
      },
      initialize: function initialize() {
        this.listenTo(this.options.appState, "change:lastAuthResponse", function () {
          this.options.appState.get("isMfaEnrollActivate") ? this.$el.toggleClass("qrcode-expired", !this.options.appState.get("isWaitingForActivation")) : this.options.appState.get("isSuccessResponse") && this.$el.addClass("qrcode-success");
        }), this.listenTo(this.model, "error", function () {
          this.options.appState.get("isMfaEnrollActivate") && this.$el.toggleClass("qrcode-expired", !0);
        });
      },
      getTemplateData: function getTemplateData() {
        var e,
            t = s.default.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
        return e = "GOOGLE" === this.model.get("__provider__") ? (0, a.loc)("enroll.totp.setupGoogleAuthApp", "login", [t]) : (0, a.loc)("enroll.totp.setupApp", "login", [t]), {
          instructions: e,
          qrcode: this.options.appState.get("qrcode"),
          altQRCode: (0, a.loc)("mfa.altQrCode", "login")
        };
      }
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(492)),
        a = o.View.extend({
      className: "scope-list detail-row",
      postRender: function postRender() {
        var e = this;
        this.model.get("scopes").forEach(function (t) {
          e.add(i.default, {
            options: {
              name: t.displayName || t.name,
              description: t.description,
              isCustomized: t.isCustomized
            }
          });
        });
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(5)),
        s = i.internal.util.Util,
        l = i.View.extend({
      template: o.default.template({
        1: function _(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link help js-skip" data-se="skip-link">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "password.expiring.later"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 78
              },
              end: {
                line: 1,
                column: 132
              }
            }
          })) + "</a>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return (null != (i = s(n, "if").call(a, null != t ? s(t, "passwordWarn") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 143
              }
            }
          })) ? i : "") + '<a href="#" class="link help goto js-signout" data-se="signout-link">' + e.escapeExpression((s(n, "i18n") || t && s(t, "i18n") || e.hooks.helperMissing).call(a, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "signout"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 212
              },
              end: {
                line: 1,
                column: 250
              }
            }
          })) + "</a>";
        },
        useData: !0
      }),
      className: "auth-footer clearfix",
      events: {
        "click .js-signout": function clickJsSignout(e) {
          e.preventDefault();
          var t = this;
          this.model.doTransaction(function (e) {
            return e.cancel();
          }).then(function () {
            t.settings.get("signOutLink") ? s.redirect(t.settings.get("signOutLink")) : (t.state.set("navigateDir", a.default.DIRECTION_BACK), t.options.appState.trigger("navigate", ""));
          });
        },
        "click .js-skip": function clickJsSkip(e) {
          e.preventDefault(), this.model.doTransaction(function (e) {
            return e.skip();
          });
        }
      },
      getTemplateData: function getTemplateData() {
        return {
          passwordWarn: this.options.appState.get("isPwdExpiringSoon")
        };
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(4)),
        a = r(n(18)),
        s = o.internal.util.Util,
        l = i.default.extend({
      className: "enroll-custom-factor",
      Model: {
        local: {
          provider: "string",
          factorType: "string"
        },
        save: function save() {
          var e = this;
          return this.manageTransaction(function (t, n) {
            return o._.findWhere(t.factors, {
              provider: e.get("provider"),
              factorType: e.get("factorType")
            }).enroll().then(function (t) {
              n(t);
              var r = e.appState.get("enrollCustomFactorRedirectUrl");
              null !== r && s.redirect(r);
            }).catch(function (e) {
              throw e;
            });
          });
        }
      },
      Form: function Form() {
        var e = this.options.appState.get("factors"),
            t = e.findWhere({
          provider: this.options.provider,
          factorType: this.options.factorType
        }),
            n = t.get("vendorName");
        return {
          autoSave: !0,
          title: n,
          subtitle: (0, o.loc)("enroll.customFactor.subtitle", "login", [n]),
          save: (0, o.loc)("enroll.customFactor.save", "login")
        };
      },
      trapAuthResponse: function trapAuthResponse() {
        if (this.options.appState.get("isMfaEnrollActivate")) return !0;
      },
      initialize: function initialize() {
        this.model.set("provider", this.options.provider), this.model.set("factorType", this.options.factorType);
      },
      Footer: a.default
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(5)),
        s = i.View.extend({
      className: "hide resend-email-infobox",
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = null != t ? t : e.nullContext || {},
              a = e.hooks.helperMissing,
              s = e.escapeExpression,
              l = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="infobox infobox-warning" aria-live="polite"><span class="icon warning-16"></span><p><span>' + s((l(n, "i18n") || t && l(t, "i18n") || a).call(i, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "email.code.not.received"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 102
              },
              end: {
                line: 1,
                column: 156
              }
            }
          })) + '</span><a href="#" class="resend-email-btn">' + s((l(n, "i18n") || t && l(t, "i18n") || a).call(i, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "email.button.resend"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 200
              },
              end: {
                line: 1,
                column: 250
              }
            }
          })) + "</a></p></div>";
        },
        useData: !0
      }),
      events: {
        "click .resend-email-btn": "resendEmail"
      },
      postRender: function postRender() {
        this.showResendCallout();
      },
      showResendCallout: function showResendCallout() {
        var e = this;

        i._.delay(function () {
          e.$el.removeClass("hide");
        }, a.default.API_RATE_LIMIT);
      },
      hideResendCallout: function hideResendCallout() {
        this.$el.addClass("hide");
      },
      resendEmail: function resendEmail(e) {
        e.preventDefault(), this.hideResendCallout(), this.model.resend().finally(this.showResendCallout.bind(this));
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = a.internal.views.forms.inputs.TextBox,
        l = s.extend({
      template: i.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = "function",
              c = e.escapeExpression,
              d = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<span class="okta-form-label-inline o-form-label-inline">' + c((a = null != (a = d(n, "countryCallingCode") || (null != t ? d(t, "countryCallingCode") : t)) ? a : l, (0, o.default)(a) === u ? a.call(s, {
            name: "countryCallingCode",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 57
              },
              end: {
                line: 1,
                column: 79
              }
            }
          }) : a)) + '</span><span class="okta-form-input-field input-fix o-form-control"><input type="' + c((a = null != (a = d(n, "type") || (null != t ? d(t, "type") : t)) ? a : l, (0, o.default)(a) === u ? a.call(s, {
            name: "type",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 160
              },
              end: {
                line: 1,
                column: 168
              }
            }
          }) : a)) + '" placeholder="' + c((a = null != (a = d(n, "placeholder") || (null != t ? d(t, "placeholder") : t)) ? a : l, (0, o.default)(a) === u ? a.call(s, {
            name: "placeholder",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 183
              },
              end: {
                line: 1,
                column: 198
              }
            }
          }) : a)) + '" name="' + c((a = null != (a = d(n, "name") || (null != t ? d(t, "name") : t)) ? a : l, (0, o.default)(a) === u ? a.call(s, {
            name: "name",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 206
              },
              end: {
                line: 1,
                column: 214
              }
            }
          }) : a)) + '" id="' + c((a = null != (a = d(n, "inputId") || (null != t ? d(t, "inputId") : t)) ? a : l, (0, o.default)(a) === u ? a.call(s, {
            name: "inputId",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 220
              },
              end: {
                line: 1,
                column: 231
              }
            }
          }) : a)) + '" value="' + c((a = null != (a = d(n, "value") || (null != t ? d(t, "value") : t)) ? a : l, (0, o.default)(a) === u ? a.call(s, {
            name: "value",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 240
              },
              end: {
                line: 1,
                column: 249
              }
            }
          }) : a)) + '" autocomplete="tel"></span>';
        },
        useData: !0
      }),
      initialize: function initialize() {
        this.listenTo(this.model, "change:countryCallingCode", function () {
          this.$(".o-form-label-inline").text(this.model.get("countryCallingCode"));
        });
      },
      preRender: function preRender() {
        this.options.countryCallingCode = this.model.get("countryCallingCode");
      },
      postRender: function postRender() {
        var e = this;
        this.$el.removeClass("input-fix o-form-control"), a._.defer(function () {
          e.$el.parent().addClass("o-form-input-group");
        });
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = r(n(15)),
        l = r(n(39)),
        u = i.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return '<span class="factor-cardinality">' + e.escapeExpression((i = null != (i = a(n, "cardinalityText") || (null != t ? a(t, "cardinalityText") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
          name: "cardinalityText",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 33
            },
            end: {
              line: 1,
              column: 52
            }
          }
        }) : i)) + "</span>";
      },
      useData: !0
    }),
        c = a.View.extend({
      tagName: "li",
      className: "enroll-factor-row clearfix",
      template: i.default.template({
        1: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return "<p>" + e.escapeExpression((i = null != (i = a(n, "factorDescription") || (null != t ? a(t, "factorDescription") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "factorDescription",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 235
              },
              end: {
                line: 1,
                column: 256
              }
            }
          }) : i)) + "</p>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s,
              l = null != t ? t : e.nullContext || {},
              u = e.hooks.helperMissing,
              c = e.escapeExpression,
              d = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="enroll-factor-icon-container"><div class="factor-icon enroll-factor-icon ' + c((s = null != (s = d(n, "iconClassName") || (null != t ? d(t, "iconClassName") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "iconClassName",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 85
              },
              end: {
                line: 1,
                column: 102
              }
            }
          }) : s)) + '"></div></div><div class="enroll-factor-description"><h3 class="enroll-factor-label">' + c((s = null != (s = d(n, "factorLabel") || (null != t ? d(t, "factorLabel") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "factorLabel",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 187
              },
              end: {
                line: 1,
                column: 202
              }
            }
          }) : s)) + "</h3>" + (null != (a = d(n, "if").call(l, null != t ? d(t, "factorDescription") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 207
              },
              end: {
                line: 1,
                column: 267
              }
            }
          })) ? a : "") + '<div class="enroll-factor-button"></div></div>';
        },
        useData: !0
      }),
      attributes: function attributes() {
        return {
          "data-se": this.model.get("factorName")
        };
      },
      children: function children() {
        var e = [],
            t = this.model.get("enrolled"),
            n = this.model.get("required"),
            r = this.model.get("cardinality");
        if (this.options.showInlineSetupButton) return [[(0, a.createButton)({
          className: "button",
          title: this.getSetupButtonText(),
          click: function click() {
            this.options.appState.trigger("navigate", l.default.createEnrollFactorUrl(this.model.get("provider"), this.model.get("factorType")));
          }
        }), ".enroll-factor-button"]];
        t ? e.push(['<span class="icon success-16-green"></span>', ".enroll-factor-label"]) : n && e.push(['<span class="icon success-16-gray"></span>', ".enroll-factor-label"]);
        var o = s.default.getCardinalityText(t, n, r);
        return o && e.push([u({
          cardinalityText: o
        }), ".enroll-factor-description"]), e;
      },
      minimize: function minimize() {
        this.$el.addClass("enroll-factor-row-min");
      },
      maximize: function maximize() {
        this.$el.removeClass("enroll-factor-row-min");
      },
      getSetupButtonText: function getSetupButtonText() {
        return this.model.get("additionalEnrollment") ? (0, a.loc)("enroll.choices.setup.another", "login") : (0, a.loc)("enroll.choices.setup", "login");
      }
    }),
        d = a.ListView.extend({
      className: "enroll-factor-list",
      item: c,
      itemSelector: ".list-content",
      template: i.default.template({
        1: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<h3 class="list-title">' + e.escapeExpression((i = null != (i = a(n, "listTitle") || (null != t ? a(t, "listTitle") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "listTitle",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 40
              },
              end: {
                line: 1,
                column: 53
              }
            }
          }) : i)) + "</h3>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return (null != (i = a(n, "if").call(null != t ? t : e.nullContext || {}, null != t ? a(t, "listTitle") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 65
              }
            }
          })) ? i : "") + '<ul class="list-content"></ul>';
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        var e = a.ListView.prototype.getTemplateData.call(this);
        return a._.extend(e, this), e;
      },
      postRender: function postRender() {
        this.options.minimize && this.invoke("minimize");
      }
    });
    t.default = d;
  }, function (e, t, n) {
    "use strict"; //Copyright 2014-2015 Google Inc. All rights reserved.
    //license that can be found in the LICENSE file or at
    //https://developers.google.com/open-source/licenses/bsd

    !function () {
      var e = "chrome" in window && window.navigator.userAgent.indexOf("Edge") < 0;

      if (!("u2f" in window) && e) {
        var t,
            n = window.u2f = {};
        n.EXTENSION_ID = "kmendfapggjehodndflmmgagdbamhnfd", n.MessageTypes = {
          U2F_REGISTER_REQUEST: "u2f_register_request",
          U2F_REGISTER_RESPONSE: "u2f_register_response",
          U2F_SIGN_REQUEST: "u2f_sign_request",
          U2F_SIGN_RESPONSE: "u2f_sign_response",
          U2F_GET_API_VERSION_REQUEST: "u2f_get_api_version_request",
          U2F_GET_API_VERSION_RESPONSE: "u2f_get_api_version_response"
        }, n.ErrorCodes = {
          OK: 0,
          OTHER_ERROR: 1,
          BAD_REQUEST: 2,
          CONFIGURATION_UNSUPPORTED: 3,
          DEVICE_INELIGIBLE: 4,
          TIMEOUT: 5
        }, n.U2fRequest, n.U2fResponse, n.Error, n.Transport, n.Transports, n.SignRequest, n.SignResponse, n.RegisterRequest, n.RegisterResponse, n.RegisteredKey, n.GetJsApiVersionResponse, n.getMessagePort = function (e) {
          if ("undefined" != typeof chrome && chrome.runtime) {
            var t = {
              type: n.MessageTypes.U2F_SIGN_REQUEST,
              signRequests: []
            };
            chrome.runtime.sendMessage(n.EXTENSION_ID, t, function () {
              chrome.runtime.lastError ? n.getIframePort_(e) : n.getChromeRuntimePort_(e);
            });
          } else n.isAndroidChrome_() ? n.getAuthenticatorPort_(e) : n.isIosChrome_() ? n.getIosPort_(e) : n.getIframePort_(e);
        }, n.isAndroidChrome_ = function () {
          var e = navigator.userAgent;
          return -1 != e.indexOf("Chrome") && -1 != e.indexOf("Android");
        }, n.isIosChrome_ = function () {
          return ["iPhone", "iPad", "iPod"].indexOf(navigator.platform) > -1;
        }, n.getChromeRuntimePort_ = function (e) {
          var t = chrome.runtime.connect(n.EXTENSION_ID, {
            includeTlsChannelId: !0
          });
          setTimeout(function () {
            e(new n.WrappedChromeRuntimePort_(t));
          }, 0);
        }, n.getAuthenticatorPort_ = function (e) {
          setTimeout(function () {
            e(new n.WrappedAuthenticatorPort_());
          }, 0);
        }, n.getIosPort_ = function (e) {
          setTimeout(function () {
            e(new n.WrappedIosPort_());
          }, 0);
        }, n.WrappedChromeRuntimePort_ = function (e) {
          this.port_ = e;
        }, n.formatSignRequest_ = function (e, r, o, i, a) {
          if (void 0 === t || t < 1.1) {
            for (var s = [], l = 0; l < o.length; l++) {
              s[l] = {
                version: o[l].version,
                challenge: r,
                keyHandle: o[l].keyHandle,
                appId: e
              };
            }

            return {
              type: n.MessageTypes.U2F_SIGN_REQUEST,
              signRequests: s,
              timeoutSeconds: i,
              requestId: a
            };
          }

          return {
            type: n.MessageTypes.U2F_SIGN_REQUEST,
            appId: e,
            challenge: r,
            registeredKeys: o,
            timeoutSeconds: i,
            requestId: a
          };
        }, n.formatRegisterRequest_ = function (e, r, o, i, a) {
          if (void 0 === t || t < 1.1) {
            for (var s = 0; s < o.length; s++) {
              o[s].appId = e;
            }

            for (var l = [], s = 0; s < r.length; s++) {
              l[s] = {
                version: r[s].version,
                challenge: o[0],
                keyHandle: r[s].keyHandle,
                appId: e
              };
            }

            return {
              type: n.MessageTypes.U2F_REGISTER_REQUEST,
              signRequests: l,
              registerRequests: o,
              timeoutSeconds: i,
              requestId: a
            };
          }

          return {
            type: n.MessageTypes.U2F_REGISTER_REQUEST,
            appId: e,
            registerRequests: o,
            registeredKeys: r,
            timeoutSeconds: i,
            requestId: a
          };
        }, n.WrappedChromeRuntimePort_.prototype.postMessage = function (e) {
          this.port_.postMessage(e);
        }, n.WrappedChromeRuntimePort_.prototype.addEventListener = function (e, t) {
          var n = e.toLowerCase();
          "message" != n && "onmessage" != n || this.port_.onMessage.addListener(function (e) {
            t({
              data: e
            });
          });
        }, n.WrappedAuthenticatorPort_ = function () {
          this.requestId_ = -1, this.requestObject_ = null;
        }, n.WrappedAuthenticatorPort_.prototype.postMessage = function (e) {
          var t = n.WrappedAuthenticatorPort_.INTENT_URL_BASE_ + ";S.request=" + encodeURIComponent(JSON.stringify(e)) + ";end";
          document.location = t;
        }, n.WrappedAuthenticatorPort_.prototype.getPortType = function () {
          return "WrappedAuthenticatorPort_";
        }, n.WrappedAuthenticatorPort_.prototype.addEventListener = function (e, t) {
          if ("message" == e.toLowerCase()) {
            var n = this;
            window.addEventListener("message", n.onRequestUpdate_.bind(n, t), !1);
          }
        }, n.WrappedAuthenticatorPort_.prototype.onRequestUpdate_ = function (e, t) {
          var n = JSON.parse(t.data),
              r = (n.intentURL, n.errorCode, null);
          n.hasOwnProperty("data") && (r = JSON.parse(n.data)), e({
            data: r
          });
        }, n.WrappedAuthenticatorPort_.INTENT_URL_BASE_ = "intent:#Intent;action=com.google.android.apps.authenticator.AUTHENTICATE", n.WrappedIosPort_ = function () {}, n.WrappedIosPort_.prototype.postMessage = function (e) {
          var t = JSON.stringify(e),
              n = "u2f://auth?" + encodeURI(t);
          location.replace(n);
        }, n.WrappedIosPort_.prototype.getPortType = function () {
          return "WrappedIosPort_";
        }, n.WrappedIosPort_.prototype.addEventListener = function (e, t) {
          e.toLowerCase();
        }, n.getIframePort_ = function (e) {
          var t = "chrome-extension://" + n.EXTENSION_ID,
              r = document.createElement("iframe");
          r.src = t + "/u2f-comms.html", r.setAttribute("style", "display:none"), document.body.appendChild(r);

          var o = new MessageChannel(),
              i = function i(t) {
            "ready" == t.data && (o.port1.removeEventListener("message", i), e(o.port1));
          };

          o.port1.addEventListener("message", i), o.port1.start(), r.addEventListener("load", function () {
            r.contentWindow.postMessage("init", t, [o.port2]);
          });
        }, n.EXTENSION_TIMEOUT_SEC = 30, n.port_ = null, n.waitingForPort_ = [], n.reqCounter_ = 0, n.callbackMap_ = {}, n.getPortSingleton_ = function (e) {
          n.port_ ? e(n.port_) : (0 == n.waitingForPort_.length && n.getMessagePort(function (e) {
            for (n.port_ = e, n.port_.addEventListener("message", n.responseHandler_); n.waitingForPort_.length;) {
              n.waitingForPort_.shift()(n.port_);
            }
          }), n.waitingForPort_.push(e));
        }, n.responseHandler_ = function (e) {
          var t = e.data,
              r = t.requestId;

          if (r && n.callbackMap_[r]) {
            var o = n.callbackMap_[r];
            delete n.callbackMap_[r], o(t.responseData);
          }
        }, n.sign = function (e, r, o, i, a) {
          void 0 === t ? n.getApiVersion(function (s) {
            t = void 0 === s.js_api_version ? 0 : s.js_api_version, n.sendSignRequest(e, r, o, i, a);
          }) : n.sendSignRequest(e, r, o, i, a);
        }, n.sendSignRequest = function (e, t, r, o, i) {
          n.getPortSingleton_(function (a) {
            var s = ++n.reqCounter_;
            n.callbackMap_[s] = o;
            var l = void 0 !== i ? i : n.EXTENSION_TIMEOUT_SEC,
                u = n.formatSignRequest_(e, t, r, l, s);
            a.postMessage(u);
          });
        }, n.register = function (e, r, o, i, a) {
          void 0 === t ? n.getApiVersion(function (s) {
            t = void 0 === s.js_api_version ? 0 : s.js_api_version, n.sendRegisterRequest(e, r, o, i, a);
          }) : n.sendRegisterRequest(e, r, o, i, a);
        }, n.sendRegisterRequest = function (e, t, r, o, i) {
          n.getPortSingleton_(function (a) {
            var s = ++n.reqCounter_;
            n.callbackMap_[s] = o;
            var l = void 0 !== i ? i : n.EXTENSION_TIMEOUT_SEC,
                u = n.formatRegisterRequest_(e, r, t, l, s);
            a.postMessage(u);
          });
        }, n.getApiVersion = function (e, t) {
          n.getPortSingleton_(function (r) {
            if (r.getPortType) {
              var o;

              switch (r.getPortType()) {
                case "WrappedIosPort_":
                case "WrappedAuthenticatorPort_":
                  o = 1.1;
                  break;

                default:
                  o = 0;
              }

              return void e({
                js_api_version: o
              });
            }

            var i = ++n.reqCounter_;
            n.callbackMap_[i] = e;
            var a = {
              type: n.MessageTypes.U2F_GET_API_VERSION_REQUEST,
              timeoutSeconds: void 0 !== t ? t : n.EXTENSION_TIMEOUT_SEC,
              requestId: i
            };
            r.postMessage(a);
          });
        };
      }
    }();
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = n(1),
        i = r(n(13)),
        a = o.internal.views.forms.helpers.SchemaFormFactory,
        s = function s(e) {
      var t = e.split(""),
          n = [],
          r = [",", ".", "-", "_", "#", "@"],
          i = "";
      return o._.each(t, function (e) {
        -1 === r.indexOf(e) ? i += e : (i.length >= 3 && n.push(o._.clone(i)), i = "");
      }), i.length >= 3 && n.push(o._.clone(i)), n.filter(Boolean);
    },
        l = function l(e, t) {
      if (!e) return !1;
      e = e.toLowerCase(), t = t.toLowerCase();

      for (var n = s(e), r = 0; r < n.length; r++) {
        var o = n[r];
        if (-1 !== t.indexOf(o)) return !0;
      }

      return !1;
    },
        u = function u(e, t, n) {
      var r = e.get("minLength"),
          i = e.get("maxLength"),
          a = e.get("format");
      if (o._.isNumber(r) && t.length < r) return !1;
      if (o._.isNumber(i) && t.length > i) return !1;
      var s = t;

      if (o._.isString(a)) {
        if ("^[#/userName]" === a || "^[#/firstName]" === a || "^[#/lastName]" === a) {
          var u = a.split("^[#/")[1].split("]")[0],
              c = n.get(u);
          return "userName" === u && (c = n.has("userName") ? n.get("userName") : n.get("email")), !l(c, s);
        }

        if (!new RegExp(a).test(t)) return !1;
      }

      return !0;
    },
        c = function c(e, t, n, r) {
      var i = t.get(e);
      o._.isString(i) && n.each(function (n, a) {
        var s = (0, o.$)("#subschemas-" + e + " .subschema-" + a);
        i ? s.children("p").removeClass("default-schema") : s.children("p").addClass("default-schema"), s.removeClass("subschema-satisfied subschema-unsatisfied subschema-error"), u(n, i, t) ? (s.addClass("subschema-satisfied"), s.find("p span").removeClass("error error-16-small"), s.find("p span").addClass("confirm-16")) : r && (s.find("p span").removeClass("confirm-16"), s.find("p span").addClass("error error-16-small"), s.addClass("subschema-error subschema-unsatisfied"));
      });
    },
        d = function d(e) {
      var t = a.createInputOptions(e);
      if ("select" === t.type) t = o._.extend(t, {
        label: e.get("title")
      });else {
        var n = e.get("title");
        e.get("required") && (n += " *"), t = o._.extend(t, {
          label: !1,
          "label-top": !0,
          placeholder: n
        });
      }
      var r = e.get("name");

      switch (r) {
        case "userName":
          t.input = i.default, t.params = {
            icon: "person-16-gray"
          };
          break;

        case "password":
          t.type = "password", t.input = i.default, t.params = {
            icon: "remote-lock-16"
          };
      }

      var s = e.get("subSchemas");
      return s && (t.events = {
        input: function input() {
          c(r, this.model, s, !0);
        },
        focusout: function focusout() {
          c(r, this.model, s, !0);
        },
        "change:userName": function changeUserName() {
          c(r, this.model, s, !0);
        },
        "change:firstName": function changeFirstName() {
          c(r, this.model, s, !0);
        },
        "change:lastName": function changeLastName() {
          c(r, this.model, s, !0);
        },
        "change:email": function changeEmail() {
          c(r, this.model, s, !0);
        }
      }), t;
    },
        f = {
      createInputOptions: d,
      getUsernameParts: s,
      passwordContainsFormField: l
    };

    t.default = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(5)),
        s = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link help" data-se="back-link">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "goback"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 50
              },
              end: {
                line: 1,
                column: 87
              }
            }
          })) + "</a>";
        },
        useData: !0
      }),
      className: "auth-footer",
      events: {
        "click .help": function clickHelp(e) {
          e.preventDefault(), this.back();
        }
      },
      back: function back() {
        this.state.set("navigateDir", a.default.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = r.View.extend({
      className: "okta-waiting-spinner",
      attributes: {
        "data-se": "o-form-okta-waiting-spinner"
      },
      modelEvents: {
        "spinner:show": "show",
        "spinner:hide": "hide"
      },
      initialize: function initialize(e) {
        e && !1 === e.visible && this.hide();
      },
      show: function show() {
        this.$el.removeClass("hide");
      },
      hide: function hide() {
        this.$el.addClass("hide");
      }
    });
    t.default = o;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="infobox"><span class="icon info-16"></span><p>' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              arguments: "helpSupportNumber",
              bundle: "login",
              code: "contact.support"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 58
              },
              end: {
                line: 1,
                column: 134
              }
            }
          })) + "</p></div>";
        },
        useData: !0
      }),
      className: "contact-support",
      getTemplateData: function getTemplateData() {
        return this.settings.pick("helpSupportNumber");
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(159)),
        a = r(n(73)),
        s = r(n(271)),
        l = r(n(272)),
        u = r(n(273)),
        c = r(n(527)),
        d = r(n(528)),
        f = a.default.extend({
      className: "primary-auth",
      state: {
        enabled: !0
      },
      View: u.default,
      constructor: function constructor(e) {
        e.appState.unset("username"), this.model = new i.default({
          multiOptionalFactorEnroll: e.settings.get("features.multiOptionalFactorEnroll"),
          settings: e.settings,
          appState: e.appState
        }, {
          parse: !0
        }), a.default.apply(this, arguments), this.addListeners(), e.settings.get("hasConfiguredButtons") && this.add(l.default, {
          prepend: e.settings.get("socialAuthPositionTop"),
          options: {
            currentController: this
          }
        }), this.addFooter(e), this.setUsername();
      },
      addFooter: function addFooter(e) {
        this.add(new c.default(this.toJSON({
          appState: e.appState
        }))), (e.settings.get("features.registration") || e.appState.get("isIdxStateToken")) && this.add(new d.default({
          settings: this.settings,
          appState: e.appState
        }));
      },
      setUsername: function setUsername() {
        var e = this.model.get("username");
        e && this.options.appState.set("username", e);
      },
      events: {
        "focusout input[name=username]": function focusoutInputNameUsername() {
          if (this.shouldComputeDeviceFingerprint() && this.model.get("username")) {
            var e = this;
            this.options.appState.trigger("loading", !0), s.default.generateDeviceFingerprint(this.settings.get("baseUrl"), this.$el).then(function (t) {
              e.options.appState.set("deviceFingerprint", t), e.options.appState.set("username", e.model.get("username"));
            }).catch(function () {
              e.options.appState.set("username", e.model.get("username"));
            }).finally(function () {
              e.options.appState.trigger("loading", !1);
            });
          } else this.options.appState.set("username", this.model.get("username"));
        },
        "focusin input": function focusinInput(e) {
          (0, o.$)(e.target.parentElement).addClass("focused-input");
        },
        "focusout input": function focusoutInput(e) {
          (0, o.$)(e.target.parentElement).removeClass("focused-input");
        }
      },
      initialize: function initialize() {
        this.options.appState.unset("deviceFingerprint"), this.listenTo(this.model, "change:username", function (e, t) {
          t || this.options.appState.set("username", "");
        }), this.listenTo(this.model, "save", function () {
          this.state.set("enabled", !1);
        }), this.listenTo(this.model, "error", function () {
          this.state.set("enabled", !0);
        }), this.listenTo(this.state, "togglePrimaryAuthButton", function (e) {
          this.toggleButtonState(e);
        });
      },
      shouldComputeDeviceFingerprint: function shouldComputeDeviceFingerprint() {
        return this.settings.get("features.securityImage") && this.settings.get("features.deviceFingerprinting") && this.settings.get("features.useDeviceFingerprintForSecurityImage");
      }
    });
    t.default = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = r.internal.util.Cookie,
        i = {};
    i.getCookieUsername = function () {
      return o.getCookie("ln");
    }, i.setUsernameCookie = function (e) {
      o.setCookie("ln", e, {
        expires: 365,
        path: "/"
      });
    }, i.removeUsernameCookie = function () {
      o.removeCookie("ln", {
        path: "/"
      });
    };
    var a = i;
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(16)),
        a = {
      getUserAgent: function getUserAgent() {
        return navigator.userAgent;
      },
      isMessageFromCorrectSource: function isMessageFromCorrectSource(e, t) {
        return t.source === e[0].contentWindow;
      },
      generateDeviceFingerprint: function generateDeviceFingerprint(e, t) {
        function n() {
          u.off(), u.remove(), window.removeEventListener("message", a, !1);
        }

        function r(e) {
          n(), d.reject(e);
        }

        function a(t) {
          if (f.isMessageFromCorrectSource(u, t)) {
            if (clearTimeout(c), !t || !t.data || t.origin !== e) return void r("no data");

            try {
              var o = JSON.parse(t.data);
              o && "FingerprintServiceReady" === o.type ? s({
                type: "GetFingerprint"
              }) : o && "FingerprintAvailable" === o.type ? (n(), d.resolve(o.fingerprint)) : r("no data");
            } catch (e) {}
          }
        }

        function s(t) {
          var n = u[0].contentWindow;
          n && n.postMessage(JSON.stringify(t), e);
        }

        var l = this.getUserAgent();
        if (!l) return i.default.reject("user agent is not defined");
        if (function (e) {
          return e.match(/windows phone|iemobile|wpdesktop/i);
        }(l)) return i.default.reject("device fingerprint is not supported on Windows phones");
        var u,
            c,
            d = i.default.defer(),
            f = this;
        return window.addEventListener("message", a, !1), u = (0, o.$)("<iframe>", {
          style: "display: none;",
          src: e + "/auth/services/devicefingerprint"
        }), t.append(u), c = setTimeout(function () {
          r("service not available");
        }, 2e3), d.promise;
      }
    };
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(156)),
        s = i.internal.util.Util,
        l = o.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return '<div class="auth-divider"><span class="auth-divider-text">' + e.escapeExpression((i = null != (i = a(n, "text") || (null != t ? a(t, "text") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
          name: "text",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 58
            },
            end: {
              line: 1,
              column: 66
            }
          }
        }) : i)) + "</span></div>";
      },
      useData: !0
    }),
        u = o.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return '<h2 data-se="o-form-head" class="okta-form-title o-form-head">' + e.escapeExpression((i = null != (i = a(n, "title") || (null != t ? a(t, "title") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
          name: "title",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 62
            },
            end: {
              line: 1,
              column: 71
            }
          }
        }) : i)) + "</h2>";
      },
      useData: !0
    }),
        c = i.View.extend({
      className: "primary-auth-container",
      children: function children() {
        var e = [],
            t = this.settings.get("configuredSocialIdps"),
            n = this.settings.get("piv"),
            r = this.settings.get("customButtons"),
            o = l({
          text: (0, i.loc)("socialauth.divider.text", "login")
        });
        return this.settings.get("hasPivCard") && e.push(this._createPivButton(n)), i._.each(t, function (t) {
          e.push(this._createSocialIdpButton(t));
        }, this), i._.each(r, function (t) {
          e.push(this._createCustomButton(t));
        }, this), this.settings.get("socialAuthPositionTop") ? (e.unshift(u({
          title: (0, i.loc)("primaryauth.title", "login")
        })), e.push(o)) : e.unshift(o), e;
      },
      _createSocialIdpButton: function _createSocialIdpButton(e) {
        return (0, i.createButton)({
          attributes: {
            "data-se": e.dataAttr
          },
          className: e.className,
          title: function title() {
            return e.text || (0, i.loc)(e.i18nKey);
          },
          click: function click(t) {
            if (t.preventDefault(), this.settings.get("oauth2Enabled")) a.default.getTokens(this.settings, {
              idp: e.id
            }, this.options.currentController);else {
              var n = this.settings.get("baseUrl"),
                  r = i.$.param({
                fromURI: this.settings.get("relayState")
              }),
                  o = "".concat(n, "/sso/idps/").concat(e.id, "?").concat(r);
              s.redirect(o);
            }
          }
        });
      },
      _createPivButton: function _createPivButton(e) {
        var t = e.className || "";
        return (0, i.createButton)({
          attributes: {
            "data-se": "piv-card-button"
          },
          className: t + " piv-button",
          title: e.text || (0, i.loc)("piv.cac.card", "login"),
          click: function click(e) {
            e.preventDefault(), this.options.appState.trigger("navigate", "signin/verify/piv");
          }
        });
      },
      _createCustomButton: function _createCustomButton(e) {
        return (0, i.createButton)({
          attributes: {
            "data-se": e.dataAttr
          },
          className: e.className + " default-custom-button",
          title: function title() {
            return e.title || (0, i.loc)(e.i18nKey);
          },
          click: e.click
        });
      }
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(271)),
        a = r(n(525)),
        s = r(n(12)),
        l = r(n(13)),
        u = o.Form.extend({
      className: "primary-auth-form",
      noCancelButton: !0,
      attributes: {
        novalidate: "novalidate"
      },
      save: function save() {
        return this.settings.get("features.passwordlessAuth") ? (0, o.loc)("oform.next", "login") : (0, o.loc)("primaryauth.submit", "login");
      },
      saveId: "okta-signin-submit",
      layout: "o-form-theme",
      title: function title() {
        var e = (0, o.loc)("primaryauth.title", "login");
        return this.settings.get("socialAuthPositionTop") && (e = ""), e;
      },
      initialize: function initialize() {
        var e = this.settings.get("features.trackTypingPattern");
        this.listenTo(this, "save", function () {
          if (e) {
            var t = a.default.getTypingPattern();
            this.options.appState.set("typingPattern", t);
          }

          var n = this,
              r = {
            username: this.model.get("username")
          };
          this.settings.get("features.passwordlessAuth") || (r.password = this.model.get("password")), this.settings.processCreds(r).then(function () {
            if (n.settings.get("features.deviceFingerprinting")) return n.options.appState.trigger("loading", !0), n.state.trigger("togglePrimaryAuthButton", !0), i.default.generateDeviceFingerprint(n.settings.get("baseUrl"), n.$el).then(function (e) {
              n.options.appState.set("deviceFingerprint", e);
            }).catch(function () {}).finally(function () {
              n.options.appState.trigger("loading", !1), n.state.trigger("togglePrimaryAuthButton", !1);
            });
          }).then(o._.bind(this.model.save, this.model));
        }), this.stateEnableChange();
      },
      stateEnableChange: function stateEnableChange() {
        this.listenTo(this.state, "change:enabled", function (e, t) {
          t ? this.enable() : this.disable();
        });
      },
      inputs: function inputs() {
        var e = [];
        return e.push(this.getUsernameField()), this.settings.get("features.passwordlessAuth") || e.push(this.getPasswordField()), this.settings.get("features.rememberMe") && e.push(this.getRemeberMeCheckbox()), e;
      },
      getUsernameField: function getUsernameField() {
        var e = this;
        return {
          className: "margin-btm-5",
          label: (0, o.loc)("primaryauth.username.placeholder", "login"),
          "label-top": !0,
          explain: function explain() {
            return !!e.isCustomized("primaryauth.username.tooltip") && s.default.createInputExplain("primaryauth.username.tooltip", "primaryauth.username.placeholder", "login");
          },
          "explain-top": !0,
          name: "username",
          input: l.default,
          inputId: "okta-signin-username",
          type: "text",
          disabled: this.options.appState.get("disableUsername"),
          autoComplete: "username",
          render: function render() {
            this.$("input[name=".concat(this.options.name, "]")).prop("required", !0);
          }
        };
      },
      getPasswordField: function getPasswordField() {
        var e = this,
            t = {
          className: "margin-btm-30",
          label: (0, o.loc)("primaryauth.password.placeholder", "login"),
          "label-top": !0,
          explain: function explain() {
            return !!e.isCustomized("primaryauth.password.tooltip") && s.default.createInputExplain("primaryauth.password.tooltip", "primaryauth.password.placeholder", "login");
          },
          "explain-top": !0,
          name: "password",
          inputId: "okta-signin-password",
          validateOnlyIfDirty: !0,
          type: "password",
          autoComplete: "current-password",
          render: function render() {
            this.$("input[name=".concat(this.options.name, "]")).prop("required", !0);
          }
        };
        return this.settings.get("features.showPasswordToggleOnSignInPage") && (t.params = {}, t.params.showPasswordToggle = !0), t;
      },
      isCustomized: function isCustomized(e) {
        var t = this.settings.get("language"),
            n = this.settings.get("i18n");
        return !!(n && n[t] && n[t][e]);
      },
      getRemeberMeCheckbox: function getRemeberMeCheckbox() {
        return {
          label: !1,
          placeholder: (0, o.loc)("remember", "login"),
          name: "remember",
          type: "checkbox",
          "label-top": !0,
          className: "margin-btm-0",
          initialize: function initialize() {
            this.listenTo(this.model, "change:remember", function (e, t) {
              this.$(":checkbox").prop("checked", t).trigger("updateState");
            });
          }
        };
      },
      focus: function focus() {
        this.model.get("username") ? this.settings.get("features.passwordlessAuth") || this.getInputs().toArray()[1].focus() : this.getInputs().first().focus(), this.settings.get("features.trackTypingPattern") && a.default.track("okta-signin-username");
      }
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(15)),
        s = i.View.extend({
      template: o.default.template({
        1: function _(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="password-requirements--header">' + e.escapeExpression((s(n, "i18n") || t && s(t, "i18n") || e.hooks.helperMissing).call(a, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "password.complexity.requirements.header"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 63
              },
              end: {
                line: 1,
                column: 133
              }
            }
          })) + '</div><ul class="password-requirements--list">' + (null != (i = s(n, "each").call(a, null != t ? s(t, "requirements") : t, {
            name: "each",
            hash: {},
            fn: e.program(2, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 179
              },
              end: {
                line: 1,
                column: 268
              }
            }
          })) ? i : "") + "</ul>";
        },
        2: function _(e, t, n, r, o) {
          return '<li class="password-requirements--list-item">' + e.escapeExpression(e.lambda(t, t)) + "</li>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return null != (i = a(n, "if").call(null != t ? t : e.nullContext || {}, null != t ? a(t, "requirements") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 280
              }
            }
          })) ? i : "";
        },
        useData: !0
      }),
      attributes: {
        "data-se": "password-requirements-html"
      },
      allRequirements: [],
      initialize: function initialize(e) {
        var t = e.policy;
        t && (this.allRequirements = a.default.getPasswordComplexityDescriptionForHtmlList(t));
      },
      getTemplateData: function getTemplateData() {
        return {
          requirements: this.allRequirements
        };
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(155)),
        s = r(n(16)),
        l = r(n(25)),
        u = r(n(24)),
        c = r(n(276)),
        d = r(n(38)),
        f = r(n(12)),
        p = r(n(74)),
        h = i.internal.util.Util,
        m = u.default.ConfigError,
        g = u.default.UnsupportedBrowserError,
        v = o.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return "https://global.oktacdn.com/okta-signin-widget/" + e.escapeExpression((i = null != (i = a(n, "version") || (null != t ? a(t, "version") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
          name: "version",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 46
            },
            end: {
              line: 1,
              column: 57
            }
          }
        }) : i));
      },
      useData: !0
    }),
        y = i.Model.extend({
      authClient: void 0,
      local: {
        baseUrl: ["string", !0],
        recoveryToken: ["string", !1, void 0],
        stateToken: ["string", !1, void 0],
        interactionHandle: ["string", !1, void 0],
        username: ["string", !1],
        signOutLink: ["string", !1],
        relayState: ["string", !1],
        redirect: {
          type: "string",
          values: ["never", "always", "auto"],
          value: "auto"
        },
        transformUsername: ["function", !1],
        globalSuccessFn: "function",
        globalErrorFn: "function",
        processCreds: "function",
        logo: "string",
        logoText: ["string", !1],
        helpSupportNumber: "string",
        apiVersion: ["string", !0, "1.0.0"],
        proxyIdxResponse: ["object", !1],
        overrideExistingStateToken: ["boolean", !1, !1],
        "features.router": ["boolean", !0, !1],
        "features.securityImage": ["boolean", !0, !1],
        "features.rememberMe": ["boolean", !0, !0],
        "features.autoPush": ["boolean", !0, !1],
        "features.smsRecovery": ["boolean", !0, !1],
        "features.callRecovery": ["boolean", !0, !1],
        "features.emailRecovery": ["boolean", !1, !0],
        "features.webauthn": ["boolean", !0, !1],
        "features.selfServiceUnlock": ["boolean", !0, !1],
        "features.multiOptionalFactorEnroll": ["boolean", !0, !1],
        "features.deviceFingerprinting": ["boolean", !1, !1],
        "features.hideSignOutLinkInMFA": ["boolean", !1, !1],
        "features.hideBackToSignInForReset": ["boolean", !1, !1],
        "features.customExpiredPassword": ["boolean", !0, !1],
        "features.registration": ["boolean", !1, !1],
        "features.idpDiscovery": ["boolean", !1, !1],
        "features.passwordlessAuth": ["boolean", !1, !1],
        "features.showPasswordToggleOnSignInPage": ["boolean", !1, !1],
        "features.trackTypingPattern": ["boolean", !1, !1],
        "features.redirectByFormSubmit": ["boolean", !1, !1],
        "features.useDeviceFingerprintForSecurityImage": ["boolean", !1, !0],
        "features.showPasswordRequirementsAsHtmlList": ["boolean", !1, !1],
        "features.mfaOnlyFlow": ["boolean", !1, !1],
        defaultCountryCode: ["string", !1, "US"],
        language: ["any", !1],
        i18n: ["object", !1],
        "assets.baseUrl": ["string", !1],
        "assets.rewrite": {
          type: "function",
          value: i._.identity
        },
        clientId: "string",
        redirectUri: "string",
        state: "string",
        scopes: "array",
        codeChallenge: "string",
        codeChallengeMethod: ["string", !1],
        oAuthTimeout: ["number", !1],
        authScheme: ["string", !1, "OAUTH2"],
        idps: ["array", !1, []],
        idpDisplay: {
          type: "string",
          values: ["PRIMARY", "SECONDARY"],
          value: "SECONDARY"
        },
        "helpLinks.help": "string",
        "helpLinks.forgotPassword": "string",
        "helpLinks.unlock": "string",
        "helpLinks.custom": "array",
        "helpLinks.factorPage.href": "string",
        "helpLinks.factorPage.text": "string",
        customButtons: ["array", !1, []],
        policyId: "string",
        "registration.click": "function",
        "registration.parseSchema": "function",
        "registration.preSubmit": "function",
        "registration.postSubmit": "function",
        "consent.cancel": "function",
        "idpDiscovery.requestContext": "string",
        "colors.brand": "string",
        brandName: "string",
        piv: ["object", !1, {}]
      },
      derived: {
        showPasswordToggle: {
          deps: ["features.showPasswordToggleOnSignInPage"],
          fn: function fn() {
            var e,
                t,
                n,
                r,
                o = null !== (e = null === (t = this.options) || void 0 === t ? void 0 : null === (n = t.features) || void 0 === n ? void 0 : n.showPasswordToggleOnSignInPage) && void 0 !== e ? e : null === (r = this.options) || void 0 === r ? void 0 : r["features.showPasswordToggleOnSignInPage"];
            return null === o || void 0 === o || o;
          },
          cache: !0
        },
        redirectUtilFn: {
          deps: ["features.redirectByFormSubmit"],
          fn: function fn(e) {
            return e ? f.default.redirectWithFormGet.bind(f.default) : h.redirect.bind(h);
          },
          cache: !0
        },
        supportedLanguages: {
          deps: ["i18n"],
          fn: function fn(e) {
            return i._.union(a.default.supportedLanguages, i._.keys(e));
          },
          cache: !0
        },
        languageCode: {
          deps: ["language", "supportedLanguages"],
          fn: function fn(e, t) {
            var n,
                r = l.default.getUserLanguages(),
                o = i._.clone(r),
                a = f.default.toLower(t);

            i._.isString(e) ? o.unshift(e) : i._.isFunction(e) && o.unshift(e(t, r)), o.push("en"), n = f.default.toLower(f.default.expandLanguages(o));
            var s, u;

            for (s = 0; s < n.length; s++) {
              if ((u = a.indexOf(n[s])) > -1) return t[u];
            }
          }
        },
        countryCode: {
          deps: ["defaultCountryCode"],
          fn: function fn(e) {
            var t = p.default.getCountries();
            return Object.keys(t).includes(e) ? e : "US";
          }
        },
        mode: {
          deps: ["useInteractionCodeFlow", "interactionHandle", "codeChallenge"],
          fn: function fn(e, t, n) {
            return t || e && n ? "remediation" : "relying-party";
          }
        },
        oauth2Enabled: {
          deps: ["clientId", "authScheme"],
          fn: function fn(e, t) {
            return !!e && "oauth2" === t.toLowerCase();
          },
          cache: !0
        },
        oieEnabled: {
          deps: ["stateToken", "proxyIdxResponse", "useInteractionCodeFlow"],
          fn: function fn(e, t, n) {
            return e || t || n;
          },
          cache: !0
        },
        oauthRedirectUri: {
          deps: ["redirectUri"],
          fn: function fn(e) {
            if (e) return e;
            var t = window.location.origin;

            if (!t) {
              var n = window.location.href,
                  r = window.location.pathname;
              "" !== r && (t = n.substring(0, n.lastIndexOf(r)));
            }

            return encodeURI(t);
          }
        },
        configuredSocialIdps: {
          deps: ["idps"],
          fn: function fn(e) {
            return i._.map(e, function (e) {
              var t = i._.clone(e),
                  n = t.type && t.type.toLowerCase();

              return n && i._.contains(c.default.SUPPORTED_SOCIAL_IDPS, n) || (n = "general-idp", t.text = t.text || "{ Please provide a text value }"), t.className = ["social-auth-button", "social-auth-" + n + "-button ", t.className ? t.className : ""].join(" "), t.dataAttr = "social-auth-" + n + "-button", t.i18nKey = "socialauth." + n + ".label", t;
            });
          },
          cache: !0
        },
        hasPivCard: {
          deps: ["piv"],
          fn: function fn(e) {
            return e && e.certAuthUrl;
          },
          cache: !0
        },
        socialAuthPositionTop: {
          deps: ["configuredSocialIdps", "hasPivCard", "idpDisplay"],
          fn: function fn(e, t, n) {
            return (!i._.isEmpty(e) || t) && "PRIMARY" === n.toUpperCase();
          },
          cache: !0
        },
        hasConfiguredButtons: {
          deps: ["configuredSocialIdps", "customButtons", "hasPivCard"],
          fn: function fn(e, t, n) {
            return !i._.isEmpty(e) || !i._.isEmpty(t) || n;
          },
          cache: !0
        }
      },
      initialize: function initialize(e) {
        e.baseUrl ? e.colors && i._.isString(e.colors.brand) && !e.colors.brand.match(/^#[0-9A-Fa-f]{6}$/) ? this.callGlobalError(new m((0, i.loc)("error.invalid.colors.brand"))) : l.default.corsIsNotSupported() && this.callGlobalError(new g((0, i.loc)("error.unsupported.cors"))) : this.callGlobalError(new m((0, i.loc)("error.required.baseUrl")));
      },
      setAcceptLanguageHeader: function setAcceptLanguageHeader(e) {
        e && e.options && e.options.headers && (e.options.headers["Accept-Language"] = this.get("languageCode"));
      },
      setAuthClient: function setAuthClient(e) {
        this.setAcceptLanguageHeader(e), this.authClient = e;
      },
      getAuthClient: function getAuthClient() {
        return this.authClient;
      },
      set: function set() {
        try {
          return i.Model.prototype.set.apply(this, arguments);
        } catch (t) {
          var e = t.message ? t.message : t;
          this.callGlobalError(new m(e));
        }
      },
      callGlobalSuccess: function callGlobalSuccess(e, t) {
        var n = i._.extend(t, {
          status: e
        });

        i._.defer(i._.partial(this.get("globalSuccessFn"), n));
      },
      callGlobalError: function callGlobalError(e) {
        var t = this.get("globalErrorFn") || this.options.globalErrorFn;
        if (!t) throw e;
        t(e);
      },
      transformUsername: function transformUsername(e, t) {
        var n = this.get("transformUsername");
        return n && i._.isFunction(n) ? n(e, t) : e;
      },
      processCreds: function processCreds(e) {
        var t = this.get("processCreds");
        return s.default.Promise(function (n) {
          i._.isFunction(t) ? 2 === t.length ? t(e, n) : (t(e), n()) : n();
        });
      },
      parseRegistrationSchema: function parseRegistrationSchema(e, t, n) {
        var r = this.get("registration.parseSchema");
        i._.isFunction(r) ? r(e, function (e) {
          t(e);
        }, function (e) {
          e = e || {
            errorSummary: (0, i.loc)("registration.default.callbackhook.error")
          }, e.callback = "parseSchema", n(e);
        }) : t(e);
      },
      preRegistrationSubmit: function preRegistrationSubmit(e, t, n) {
        var r = this.get("registration.preSubmit");
        i._.isFunction(r) ? r(e, function (e) {
          t(e);
        }, function (e) {
          e = e || {
            errorSummary: (0, i.loc)("registration.default.callbackhook.error")
          }, e.callback = "preSubmit", n(e);
        }) : t(e);
      },
      postRegistrationSubmit: function postRegistrationSubmit(e, t, n) {
        var r = this.get("registration.postSubmit");
        i._.isFunction(r) ? r(e, function (e) {
          t(e);
        }, function (e) {
          e = e || {
            errorSummary: (0, i.loc)("registration.default.callbackhook.error")
          }, e.callback = "postSubmit", n(e);
        }) : t(e);
      },
      parse: function parse(e) {
        if (e.labels || e.country) {
          d.default.deprecate('Use "i18n" instead of "labels" and "country"');
          var t = e.labels || {};
          i._.each(e.country, function (e, n) {
            t["country." + n] = e;
          }), e.i18n = {}, i._.each(a.default.supportedLanguages, function (n) {
            e.i18n[n] = t;
          }), delete e.labels, delete e.country;
        }

        e.assets || (e.assets = {});
        var n = e.assets.baseUrl;
        return n ? "/" === n[n.length - 1] && (e.assets.baseUrl = n.substring(0, n.length - 1)) : e.assets.baseUrl = v({
          version: a.default.version
        }), e;
      },
      isDsTheme: function isDsTheme() {
        return !1;
      }
    });
    t.default = y;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = ["facebook", "google", "linkedin", "microsoft", "apple"],
        o = {
      SUPPORTED_SOCIAL_IDPS: r
    };
    t.default = o;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(5)),
        a = o.View.extend({
      tagName: "main",
      className: "auth-container main-container",
      id: i.default.WIDGET_CONTAINER_ID,
      attributes: {
        "data-se": "auth-container",
        tabindex: "-1"
      },
      initialize: function initialize(e) {
        this.listenTo(e.appState, "change:beaconType", function (e, t) {
          this.$el.toggleClass("can-remove-beacon", "security" === t);
        });
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.equals(f.default);
    }

    function o(e) {
      e.currentBeacon && (e.currentBeacon.remove(), e.currentBeacon = null);
    }

    function i(e, t, n, r) {
      e.add(t, {
        selector: n,
        options: r
      }), e.currentBeacon = e.first();
    }

    function a(e, t, n) {
      return e || t ? !e && n.loading ? "load" : e && r(e) ? t ? "swap" : "unload" : e && e.equals(t, n) ? "same" : !e && t ? "add" : e && !t ? "remove" : e instanceof t ? "fade" : "swap" : "none";
    }

    var s = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var l = s(n(10)),
        u = s(n(2)),
        c = n(1),
        d = s(n(118)),
        f = s(n(571)),
        p = c.View.extend({
      currentBeacon: null,
      template: u.default.template({
        1: function _(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<img src="' + u((i = null != (i = c(n, "logo") || (null != t ? c(t, "logo") : t)) ? i : s, "function" === (0, l.default)(i) ? i.call(a, {
            name: "logo",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 67
              },
              end: {
                line: 1,
                column: 75
              }
            }
          }) : i)) + '" class="auth-org-logo" alt="' + u((i = null != (i = c(n, "logoText") || (null != t ? c(t, "logoText") : t)) ? i : s, "function" === (0, l.default)(i) ? i.call(a, {
            name: "logoText",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 104
              },
              end: {
                line: 1,
                column: 116
              }
            }
          }) : i)) + ' logo" aria-label="' + u((i = null != (i = c(n, "logoText") || (null != t ? c(t, "logoText") : t)) ? i : s, "function" === (0, l.default)(i) ? i.call(a, {
            name: "logoText",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 135
              },
              end: {
                line: 1,
                column: 147
              }
            }
          }) : i)) + ' logo">';
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="okta-sign-in-header auth-header">' + (null != (i = a(n, "if").call(null != t ? t : e.nullContext || {}, null != t ? a(t, "logo") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 45
              },
              end: {
                line: 1,
                column: 161
              }
            }
          })) ? i : "") + '<div data-type="beacon-container" class="beacon-container"></div></div><div class="auth-content"><div class="auth-content-inner"></div></div>';
        },
        useData: !0
      }),
      initialize: function initialize(e) {
        e.settings.get("features.securityImage") || (this.$el.addClass("no-beacon"), this.listenTo(e.appState, "loading", this.setLoadingBeacon), this.listenTo(e.appState, "removeLoading", this.removeLoadingBeacon));
      },
      setBeacon: function setBeacon(e, t) {
        var n = '[data-type="beacon-container"]',
            s = this.$(n),
            l = a(this.currentBeacon, e, t),
            u = this;

        switch (l) {
          case "none":
            return void this.$el.addClass("no-beacon");

          case "same":
            return;

          case "add":
            return this.$el.removeClass("no-beacon"), i(this, e, n, t), d.default.explode(s);

          case "remove":
            return this.$el.addClass("no-beacon"), d.default.implode(s).then(function () {
              o(u);
            }).done();

          case "fade":
            if (!this.currentBeacon.fadeOut) throw new Error('The current beacon is missing the "fadeOut" method');
            return t.animate = !0, this.currentBeacon.fadeOut().then(function () {
              o(u), i(u, e, n, t);
            }).done();

          case "swap":
            return d.default.swapBeacons({
              $el: s,
              swap: function swap() {
                var a = r(u.currentBeacon);
                o(u), a && (s.removeClass("beacon-small beacon-loading"), u.$el.removeClass("no-beacon")), i(u, e, n, t);
              }
            }).done();

          case "load":
            return s.addClass("beacon-small beacon-loading"), i(u, e, n, t), d.default.explode(s);

          case "unload":
            return this.removeLoadingBeacon();

          default:
            throw new Error('the "' + l + '" is not recognized');
        }
      },
      setLoadingBeacon: function setLoadingBeacon(e) {
        e && !r(this.currentBeacon) && this.setBeacon(f.default, {
          loading: !0
        });
      },
      removeLoadingBeacon: function removeLoadingBeacon() {
        var e = this,
            t = this.$('[data-type="beacon-container"]');
        return d.default.implode(t).then(function () {
          o(e), t.removeClass("beacon-small beacon-loading");
        }).done();
      },
      getTemplateData: function getTemplateData() {
        return this.settings.toJSON({
          verbose: !0
        });
      },
      getContentEl: function getContentEl() {
        return this.$(".auth-content-inner");
      }
    });
    t.default = p;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = t.get("securityImage"),
          r = t.get("securityImageDescription"),
          o = t.get("isUndefinedUser"),
          i = t.get("isNewUser"),
          a = !o && !i;
      return e.css("background-image", ""), e.removeClass("new-user undefined-user"), i ? void e.addClass("new-user") : o ? void e.addClass("undefined-user") : a ? (e.removeAttr("aria-describedby"), e.find(".accessibility-text").text(r), void e.css("background-image", "url(" + f._.escape(n) + ")")) : void 0;
    }

    function o(e, t) {
      (0, f.$)(window).on("resize.securityBeaconQtip", f._.debounce(function () {
        e.is(":visible") && e.qtip("show");
      }, 300)), e.qtip({
        prerender: !0,
        content: {
          text: (0, f.loc)("primaryauth.newUser.tooltip", "login", [f._.escape(t)]),
          button: (0, f.loc)("primaryauth.newUser.tooltip.close", "login")
        },
        style: {
          classes: "okta-security-image-tooltip security-image-qtip qtip-custom qtip-shadow qtip-rounded",
          tip: {
            height: 12,
            width: 16
          }
        },
        position: {
          my: "top center",
          at: "center",
          target: (0, f.$)(".auth-beacon-security"),
          adjust: {
            method: "flip",
            scroll: !1,
            resize: !0
          },
          effect: !1
        },
        hide: {
          event: !1,
          fixed: !0
        },
        show: {
          event: !1,
          delay: 200
        },
        events: {
          move: function move(e, t) {
            t.elements.target.is(":visible") || (t.set("hide.effect", !1), t.hide(), t.set("hide.effect", !0));
          }
        }
      }), e.qtip("toggle", e.is(":visible"));
    }

    function i(e) {
      e.qtip("destroy"), (0, f.$)(window).off("resize.securityBeaconQtip");
    }

    function a(e, t, n) {
      return s.apply(this, arguments);
    }

    function s() {
      return s = (0, c.default)(u.default.mark(function e(t, n, a) {
        var s, l, c, d, f, h, m;
        return u.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (s = t.find(".auth-beacon-security"), l = t.find(".js-auth-beacon-border"), c = !n.get("isUndefinedUser"), d = n.get("isNewUser"), f = t.find(".radial-progress-bar"), h = n.get("baseUrl").match(/https?:\/\/(.[^/]+)/)[1], m = 200, a) {
                  e.next = 11;
                  break;
                }

                return r(s, n), l.toggleClass("auth-beacon-border", c), e.abrupt("return");

              case 11:
                if (i(s), c) {
                  e.next = 16;
                  break;
                }

                s.fadeOut(m, function () {
                  r(s, n), l.removeClass("auth-beacon-border"), s.fadeIn(m);
                }), e.next = 21;
                break;

              case 16:
                return l.removeClass("auth-beacon-border"), e.next = 19, p.default.radialProgressBar({
                  $el: f,
                  swap: function swap() {
                    s.fadeOut(m, function () {
                      r(s, n), s.fadeIn(m);
                    });
                  }
                });

              case 19:
                l.addClass("auth-beacon-border"), d && o(s, h);

              case 21:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), s.apply(this, arguments);
    }

    var l = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var u = l(n(57)),
        c = l(n(58)),
        d = l(n(2)),
        f = n(1),
        p = l(n(118)),
        h = f.View.extend({
      template: d.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          return '<div class="beacon-blank"><div class="radial-progress-bar"><div class="circle left"></div><div class="circle right"></div></div></div><div aria-live="polite" role="img" class="bg-helper auth-beacon auth-beacon-security" data-se="security-beacon"><span class="accessibility-text"></span><div class="okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border"></div></div>';
        },
        useData: !0
      }),
      className: "js-security-beacon",
      initialize: function initialize(e) {
        this.update = f._.partial(a, this.$el, e.appState), this.listenTo(e.appState, "change:securityImage", this.update), this.listenTo(e.appState, "loading", function (e) {
          this.$el.toggleClass("beacon-loading", e), this.removeAntiPhishingMessage();
        }), this.options.appState.set("beaconType", "security"), this.listenTo(e.appState, "navigate", this.removeAntiPhishingMessage);
      },
      postRender: function postRender() {
        this.update(!1);
      },
      equals: function equals(e) {
        return e && this instanceof e;
      },
      removeAntiPhishingMessage: function removeAntiPhishingMessage() {
        this.$el.find(".auth-beacon-security").qtip("destroy");
      }
    });
    t.default = h;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = r(n(5)),
        i = {},
        a = function a(e) {
      return "\n#okta-sign-in.auth-container .button-primary,\n#okta-sign-in.auth-container .button-primary:active,\n#okta-sign-in.auth-container .button-primary:focus { background: ".concat(e.brand, "; }\n#okta-sign-in.auth-container .button-primary:hover { background: ").concat(i.lighten(e.brand, .05), "; }\n#okta-sign-in.auth-container .button.button-primary.link-button-disabled {\n  background: ").concat(e.brand, ";\n  opacity: 0.5;\n}\n    ");
    };

    i.lighten = function (e, t) {
      t = t || 0, e = e.substr(1);

      for (var n = "#", r = 0; r < 3; r++) {
        var o = parseInt(e.substr(2 * r, 2), 16);
        o = Math.round(Math.min(Math.max(0, o + o * t), 255)).toString(16), n += ("00" + o).substr(o.length);
      }

      return n;
    }, i.addStyle = function (e) {
      var t = a(e),
          n = document.getElementById(o.default.WIDGET_CONTAINER_ID),
          r = document.createElement("style");
      r.id = o.default.WIDGET_CONFIG_COLORS_ID, r.type = "text/css", r.appendChild(document.createTextNode(t)), n.appendChild(r);
    }, i.isLoaded = function () {
      return !!document.getElementById(o.default.WIDGET_CONFIG_COLORS_ID);
    };
    var s = i;
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    function r() {
      var e,
          t,
          n,
          r,
          o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          i = o.find(function (e) {
        return e.relatesTo.key === f.AUTHENTICATOR_KEY.OV;
      }),
          a = null === i || void 0 === i ? void 0 : null === (e = i.value) || void 0 === e ? void 0 : null === (t = e.form) || void 0 === t ? void 0 : null === (n = t.value) || void 0 === n ? void 0 : n.find(function (e) {
        return "methodType" === e.name;
      }),
          s = null === a || void 0 === a ? void 0 : a.options;

      if (s) {
        var l = [];
        s.forEach(function (e) {
          var t = (0, c.default)(i.value.form.value),
              n = i.value.form.value.findIndex(function (e) {
            return "methodType" === e.name;
          }),
              o = Object.assign(d._.omit(a, "options"), e);
          o.required = !0, o.mutable = !1, t.splice(n, 1, o);
          var s = Object.assign({}, i, {
            label: e.label,
            value: {
              form: {
                value: t
              }
            }
          });
          "signed_nonce" === e.value ? r = s : l.push(s);
        });
        var u = o.findIndex(function (e) {
          return e.relatesTo.key === f.AUTHENTICATOR_KEY.OV;
        });
        o.splice.apply(o, [u, 1].concat(l)), r && (i.relatesTo.deviceKnown ? o.unshift(r) : o.push(r));
      }
    }

    function o() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
      return r(e), e.map(function (e) {
        var t,
            n,
            r,
            o = (null === (t = e.value) || void 0 === t ? void 0 : null === (n = t.form) || void 0 === n ? void 0 : n.value) || [],
            i = o.filter(function (e) {
          return !0 === e.required && !1 === e.mutable;
        }).reduce(function (e, t) {
          return Object.assign(e, (0, u.default)({}, t.name, t.value));
        }, {});
        return {
          label: e.label,
          value: i,
          relatesTo: e.relatesTo,
          authenticatorKey: null === (r = e.relatesTo) || void 0 === r ? void 0 : r.key
        };
      });
    }

    function i(e) {
      return {
        type: "authenticatorEnrollSelect",
        options: o(e.options)
      };
    }

    function a(e) {
      return {
        type: "authenticatorVerifySelect",
        options: o(e.options)
      };
    }

    function s(e, t, n, r, o) {
      var s = {};
      return "authenticator" !== e.name || "select-authenticator-authenticate" !== t.name && "select-authenticator-unlock-account" !== t.name ? "authenticator" === e.name && "select-authenticator-enroll" === t.name ? Object.assign(s, i(e)) : Array.isArray(e.options) && (s.optionsUiSchemas = e.options.map(function (t) {
        return r(n, {
          value: [{
            name: e.name,
            value: t.value
          }]
        }, o);
      }), s.options = e.options.map(function (e, t) {
        return {
          label: e.label,
          value: t
        };
      }), s.type = "radio", s.value = "0", s.name = "sub_schema_local_".concat(e.name)) : Object.assign(s, a(e)), s;
    }

    var l = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createOVOptions = r, t.default = s;
    var u = l(n(42)),
        c = l(n(119)),
        d = n(1),
        f = n(8);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(584);
    Object.keys(r).forEach(function (e) {
      "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
        enumerable: !0,
        get: function get() {
          return r[e];
        }
      });
    });
    var o = n(161);
    Object.keys(o).forEach(function (e) {
      "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
        enumerable: !0,
        get: function get() {
          return o[e];
        }
      });
    });
    var i = n(283);
    Object.keys(i).forEach(function (e) {
      "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
        enumerable: !0,
        get: function get() {
          return i[e];
        }
      });
    });
    var a = n(357);
    Object.keys(a).forEach(function (e) {
      "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
        enumerable: !0,
        get: function get() {
          return a[e];
        }
      });
    });
    var s = n(766);
    Object.keys(s).forEach(function (e) {
      "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
        enumerable: !0,
        get: function get() {
          return s[e];
        }
      });
    });
    var l = n(767);
    Object.keys(l).forEach(function (e) {
      "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
        enumerable: !0,
        get: function get() {
          return l[e];
        }
      });
    });
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return o.apply(this, arguments);
    }

    function o() {
      return o = (0, s.default)(a.default.mark(function e(t) {
        var n, r, o, i, s, c, d, f, p, h, m, g, v;
        return a.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = t.getAuthClient(), e.next = 3, (0, u.getTransactionMeta)(t);

              case 3:
                return r = e.sent, o = r, i = o.interactionHandle, s = o.codeChallenge, c = o.codeChallengeMethod, d = o.scopes, f = o.state, p = n.options, h = p.issuer, m = p.clientId, g = p.redirectUri, v = t.get("apiVersion"), e.abrupt("return", l.default.start({
                  interactionHandle: i,
                  version: v,
                  clientId: m,
                  issuer: h,
                  scopes: d,
                  state: f,
                  redirectUri: g,
                  codeChallenge: s,
                  codeChallengeMethod: c
                }).then(function (e) {
                  return !i && e.toPersist.interactionHandle && (r = Object.assign({}, r, {
                    interactionHandle: e.toPersist.interactionHandle
                  })), (0, u.saveTransactionMeta)(t, r), e;
                }));

              case 8:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), o.apply(this, arguments);
    }

    var i = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.interact = r;
    var a = i(n(57)),
        s = i(n(58)),
        l = i(n(162)),
        u = n(161);
  }, function (e, t, n) {
    n(586);

    var r = n(21),
        o = r.Object,
        i = e.exports = function (e, t, n) {
      return o.defineProperty(e, t, n);
    };

    o.defineProperty.sham && (i.sham = !0);
  }, function (e, t, n) {
    var r = n(26),
        o = n(20),
        i = n(165);
    e.exports = !r && !o(function () {
      return 7 != Object.defineProperty(i("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, n) {
    var r = n(20),
        o = /#|\.prototype\./,
        i = function i(e, t) {
      var n = s[a(e)];
      return n == u || n != l && ("function" == typeof t ? r(t) : !!t);
    },
        a = i.normalize = function (e) {
      return String(e).replace(o, ".").toLowerCase();
    },
        s = i.data = {},
        l = i.NATIVE = "N",
        u = i.POLYFILL = "P";

    e.exports = i;
  }, function (e, t, n) {
    var r = n(590),
        o = Array.prototype;

    e.exports = function (e) {
      var t = e.indexOf;
      return e === o || e instanceof Array && t === o.indexOf ? r : t;
    };
  }, function (e, t, n) {
    var r = n(43),
        o = n(81),
        i = n(289),
        a = function a(e) {
      return function (t, n, a) {
        var s,
            l = r(t),
            u = o(l.length),
            c = i(a, u);

        if (e && n != n) {
          for (; u > c;) {
            if ((s = l[c++]) != s) return !0;
          }
        } else for (; u > c; c++) {
          if ((e || c in l) && l[c] === n) return e || c || 0;
        }

        return !e && -1;
      };
    };

    e.exports = {
      includes: a(!0),
      indexOf: a(!1)
    };
  }, function (e, t, n) {
    var r = n(166),
        o = Math.max,
        i = Math.min;

    e.exports = function (e, t) {
      var n = r(e);
      return n < 0 ? o(n + t, 0) : i(n, t);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(20);

    e.exports = function (e, t) {
      var n = [][e];
      return !!n && r(function () {
        n.call(null, t || function () {
          throw 1;
        }, 1);
      });
    };
  }, function (e, t, n) {
    n(292), n(61), n(84), n(599), n(314), n(603);
    var r = n(21);
    e.exports = r.Promise;
  }, function (e, t) {}, function (e, t, n) {
    var r = n(166),
        o = n(164),
        i = function i(e) {
      return function (t, n) {
        var i,
            a,
            s = String(o(t)),
            l = r(n),
            u = s.length;
        return l < 0 || l >= u ? e ? "" : void 0 : (i = s.charCodeAt(l), i < 55296 || i > 56319 || l + 1 === u || (a = s.charCodeAt(l + 1)) < 56320 || a > 57343 ? e ? s.charAt(l) : i : e ? s.slice(l, l + 2) : a - 56320 + (i - 55296 << 10) + 65536);
      };
    };

    e.exports = {
      codeAt: i(!1),
      charAt: i(!0)
    };
  }, function (e, t, n) {
    var r = n(295),
        o = Function.toString;
    "function" != typeof r.inspectSource && (r.inspectSource = function (e) {
      return o.call(e);
    }), e.exports = r.inspectSource;
  }, function (e, t, n) {
    var r = n(19),
        o = n(594),
        i = r["__core-js_shared__"] || o("__core-js_shared__", {});
    e.exports = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(297),
        i = n(169),
        a = n(302),
        s = n(51),
        l = n(44),
        u = n(66),
        c = n(14),
        d = n(63),
        f = n(65),
        p = n(298),
        h = p.IteratorPrototype,
        m = p.BUGGY_SAFARI_ITERATORS,
        g = c("iterator"),
        v = function v() {
      return this;
    };

    e.exports = function (e, t, n, c, p, y, b) {
      o(n, t, c);

      var _,
          w,
          E,
          O = function O(e) {
        if (e === p && C) return C;
        if (!m && e in T) return T[e];

        switch (e) {
          case "keys":
          case "values":
          case "entries":
            return function () {
              return new n(this, e);
            };
        }

        return function () {
          return new n(this);
        };
      },
          S = t + " Iterator",
          x = !1,
          T = e.prototype,
          k = T[g] || T["@@iterator"] || p && T[p],
          C = !m && k || O(p),
          A = "Array" == t ? T.entries || k : k;

      if (A && (_ = i(A.call(new e())), h !== Object.prototype && _.next && (d || i(_) === h || (a ? a(_, h) : "function" != typeof _[g] && l(_, g, v)), s(_, S, !0, !0), d && (f[S] = v))), "values" == p && k && "values" !== k.name && (x = !0, C = function C() {
        return k.call(this);
      }), d && !b || T[g] === C || l(T, g, C), f[t] = C, p) if (w = {
        values: O("values"),
        keys: y ? C : O("keys"),
        entries: O("entries")
      }, b) for (E in w) {
        !m && !x && E in T || u(T, E, w[E]);
      } else r({
        target: t,
        proto: !0,
        forced: m || x
      }, w);
      return w;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(298).IteratorPrototype,
        o = n(124),
        i = n(59),
        a = n(51),
        s = n(65),
        l = function l() {
      return this;
    };

    e.exports = function (e, t, n) {
      var u = t + " Iterator";
      return e.prototype = o(r, {
        next: i(1, n)
      }), a(e, u, !1, !0), s[u] = l, e;
    };
  }, function (e, t, n) {
    "use strict";

    var r,
        o,
        i,
        a = n(169),
        s = n(44),
        l = n(31),
        u = n(14),
        c = n(63),
        d = u("iterator"),
        f = !1,
        p = function p() {
      return this;
    };

    [].keys && (i = [].keys(), "next" in i ? (o = a(a(i))) !== Object.prototype && (r = o) : f = !0), void 0 == r && (r = {}), c || l(r, d) || s(r, d, p), e.exports = {
      IteratorPrototype: r,
      BUGGY_SAFARI_ITERATORS: f
    };
  }, function (e, t, n) {
    var r = n(170);
    e.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator;
  }, function (e, t, n) {
    var r = n(31),
        o = n(43),
        i = n(288).indexOf,
        a = n(123);

    e.exports = function (e, t) {
      var n,
          s = o(e),
          l = 0,
          u = [];

      for (n in s) {
        !r(a, n) && r(s, n) && u.push(n);
      }

      for (; t.length > l;) {
        r(s, n = t[l++]) && (~i(u, n) || u.push(n));
      }

      return u;
    };
  }, function (e, t, n) {
    var r = n(45);
    e.exports = r("document", "documentElement");
  }, function (e, t, n) {
    var r = n(36),
        o = n(597);
    e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
      var e,
          t = !1,
          n = {};

      try {
        e = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set, e.call(n, []), t = n instanceof Array;
      } catch (e) {}

      return function (n, i) {
        return r(n), o(i), t ? e.call(n, i) : n.__proto__ = i, n;
      };
    }() : void 0);
  }, function (e, t) {
    e.exports = function () {};
  }, function (e, t, n) {
    var r = n(19);
    e.exports = r.Promise;
  }, function (e, t, n) {
    var r = n(66);

    e.exports = function (e, t, n) {
      for (var o in t) {
        n && n.unsafe && e[o] ? e[o] = t[o] : r(e, o, t[o], n);
      }

      return e;
    };
  }, function (e, t, n) {
    var r = n(14),
        o = n(65),
        i = r("iterator"),
        a = Array.prototype;

    e.exports = function (e) {
      return void 0 !== e && (o.Array === e || a[i] === e);
    };
  }, function (e, t, n) {
    var r = n(36);

    e.exports = function (e, t, n, o) {
      try {
        return o ? t(r(n)[0], n[1]) : t(n);
      } catch (t) {
        var i = e.return;
        throw void 0 !== i && r(i.call(e)), t;
      }
    };
  }, function (e, t, n) {
    var r = n(14),
        o = r("iterator"),
        i = !1;

    try {
      var a = 0,
          s = {
        next: function next() {
          return {
            done: !!a++
          };
        },
        return: function _return() {
          i = !0;
        }
      };
      s[o] = function () {
        return this;
      }, Array.from(s, function () {
        throw 2;
      });
    } catch (e) {}

    e.exports = function (e, t) {
      if (!t && !i) return !1;
      var n = !1;

      try {
        var r = {};
        r[o] = function () {
          return {
            next: function next() {
              return {
                done: n = !0
              };
            }
          };
        }, e(r);
      } catch (e) {}

      return n;
    };
  }, function (e, t, n) {
    var r = n(36),
        o = n(79),
        i = n(14),
        a = i("species");

    e.exports = function (e, t) {
      var n,
          i = r(e).constructor;
      return void 0 === i || void 0 == (n = r(i)[a]) ? t : o(n);
    };
  }, function (e, t, n) {
    var r,
        o,
        i,
        a = n(19),
        s = n(20),
        l = n(77),
        u = n(78),
        c = n(301),
        d = n(165),
        f = n(311),
        p = a.location,
        h = a.setImmediate,
        m = a.clearImmediate,
        g = a.process,
        v = a.MessageChannel,
        y = a.Dispatch,
        b = 0,
        _ = {},
        w = function w(e) {
      if (_.hasOwnProperty(e)) {
        var t = _[e];
        delete _[e], t();
      }
    },
        E = function E(e) {
      return function () {
        w(e);
      };
    },
        O = function O(e) {
      w(e.data);
    },
        S = function S(e) {
      a.postMessage(e + "", p.protocol + "//" + p.host);
    };

    h && m || (h = function h(e) {
      for (var t = [], n = 1; arguments.length > n;) {
        t.push(arguments[n++]);
      }

      return _[++b] = function () {
        ("function" == typeof e ? e : Function(e)).apply(void 0, t);
      }, r(b), b;
    }, m = function m(e) {
      delete _[e];
    }, "process" == l(g) ? r = function r(e) {
      g.nextTick(E(e));
    } : y && y.now ? r = function r(e) {
      y.now(E(e));
    } : v && !f ? (o = new v(), i = o.port2, o.port1.onmessage = O, r = u(i.postMessage, i, 1)) : !a.addEventListener || "function" != typeof postMessage || a.importScripts || s(S) || "file:" === p.protocol ? r = "onreadystatechange" in d("script") ? function (e) {
      c.appendChild(d("script")).onreadystatechange = function () {
        c.removeChild(this), w(e);
      };
    } : function (e) {
      setTimeout(E(e), 0);
    } : (r = S, a.addEventListener("message", O, !1))), e.exports = {
      set: h,
      clear: m
    };
  }, function (e, t, n) {
    var r = n(312);
    e.exports = /(iphone|ipod|ipad).*applewebkit/i.test(r);
  }, function (e, t, n) {
    var r = n(45);
    e.exports = r("navigator", "userAgent") || "";
  }, function (e, t, n) {
    var r = n(36),
        o = n(35),
        i = n(100);

    e.exports = function (e, t) {
      if (r(e), o(t) && t.constructor === e) return t;
      var n = i.f(e);
      return (0, n.resolve)(t), n.promise;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(79),
        i = n(100),
        a = n(125),
        s = n(98);
    r({
      target: "Promise",
      stat: !0
    }, {
      allSettled: function allSettled(e) {
        var t = this,
            n = i.f(t),
            r = n.resolve,
            l = n.reject,
            u = a(function () {
          var n = o(t.resolve),
              i = [],
              a = 0,
              l = 1;
          s(e, function (e) {
            var o = a++,
                s = !1;
            i.push(void 0), l++, n.call(t, e).then(function (e) {
              s || (s = !0, i[o] = {
                status: "fulfilled",
                value: e
              }, --l || r(i));
            }, function (e) {
              s || (s = !0, i[o] = {
                status: "rejected",
                reason: e
              }, --l || r(i));
            });
          }), --l || r(i);
        });
        return u.error && l(u.value), n.promise;
      }
    });
  }, function (e, t, n) {
    var r = n(20),
        o = n(14),
        i = n(63),
        a = o("iterator");
    e.exports = !r(function () {
      var e = new URL("b?a=1&b=2&c=3", "http://a"),
          t = e.searchParams,
          n = "";
      return e.pathname = "c%20d", t.forEach(function (e, r) {
        t.delete("b"), n += r + e;
      }), i && !e.toJSON || !t.sort || "http://a/c%20d?a=1&c=3" !== e.href || "3" !== t.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !t[a] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://тест").host || "#%D0%B1" !== new URL("http://a#б").hash || "a1c3" !== n || "x" !== new URL("http://x", void 0).host;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(78),
        o = n(64),
        i = n(307),
        a = n(306),
        s = n(81),
        l = n(101),
        u = n(99);

    e.exports = function (e) {
      var t,
          n,
          c,
          d,
          f,
          p,
          h = o(e),
          m = "function" == typeof this ? this : Array,
          g = arguments.length,
          v = g > 1 ? arguments[1] : void 0,
          y = void 0 !== v,
          b = u(h),
          _ = 0;
      if (y && (v = r(v, g > 2 ? arguments[2] : void 0, 2)), void 0 == b || m == Array && a(b)) for (t = s(h.length), n = new m(t); t > _; _++) {
        p = y ? v(h[_], _) : h[_], l(n, _, p);
      } else for (d = b.call(h), f = d.next, n = new m(); !(c = f.call(d)).done; _++) {
        p = y ? i(d, v, [c.value, _], !0) : c.value, l(n, _, p);
      }
      return n.length = _, n;
    };
  }, function (e, t, n) {
    "use strict";

    n(174);

    var r = n(9),
        o = n(45),
        i = n(315),
        a = n(66),
        s = n(305),
        l = n(51),
        u = n(297),
        c = n(62),
        d = n(175),
        f = n(31),
        p = n(78),
        h = n(83),
        m = n(36),
        g = n(35),
        v = n(124),
        y = n(59),
        b = n(318),
        _ = n(99),
        w = n(14),
        E = o("fetch"),
        O = o("Headers"),
        S = w("iterator"),
        x = c.set,
        T = c.getterFor("URLSearchParams"),
        k = c.getterFor("URLSearchParamsIterator"),
        C = /\+/g,
        A = Array(4),
        N = function N(e) {
      return A[e - 1] || (A[e - 1] = RegExp("((?:%[\\da-f]{2}){" + e + "})", "gi"));
    },
        P = function P(e) {
      try {
        return decodeURIComponent(e);
      } catch (t) {
        return e;
      }
    },
        R = function R(e) {
      var t = e.replace(C, " "),
          n = 4;

      try {
        return decodeURIComponent(t);
      } catch (e) {
        for (; n;) {
          t = t.replace(N(n--), P);
        }

        return t;
      }
    },
        I = /[!'()~]|%20/g,
        M = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+"
    },
        j = function j(e) {
      return M[e];
    },
        L = function L(e) {
      return encodeURIComponent(e).replace(I, j);
    },
        D = function D(e, t) {
      if (t) for (var n, r, o = t.split("&"), i = 0; i < o.length;) {
        n = o[i++], n.length && (r = n.split("="), e.push({
          key: R(r.shift()),
          value: R(r.join("="))
        }));
      }
    },
        F = function F(e) {
      this.entries.length = 0, D(this.entries, e);
    },
        U = function U(e, t) {
      if (e < t) throw TypeError("Not enough arguments");
    },
        B = u(function (e, t) {
      x(this, {
        type: "URLSearchParamsIterator",
        iterator: b(T(e).entries),
        kind: t
      });
    }, "Iterator", function () {
      var e = k(this),
          t = e.kind,
          n = e.iterator.next(),
          r = n.value;
      return n.done || (n.value = "keys" === t ? r.key : "values" === t ? r.value : [r.key, r.value]), n;
    }),
        V = function V() {
      d(this, V, "URLSearchParams");
      var e,
          t,
          n,
          r,
          o,
          i,
          a,
          s,
          l,
          u = arguments.length > 0 ? arguments[0] : void 0,
          c = this,
          p = [];
      if (x(c, {
        type: "URLSearchParams",
        entries: p,
        updateURL: function updateURL() {},
        updateSearchParams: F
      }), void 0 !== u) if (g(u)) {
        if ("function" == typeof (e = _(u))) for (t = e.call(u), n = t.next; !(r = n.call(t)).done;) {
          if (o = b(m(r.value)), i = o.next, (a = i.call(o)).done || (s = i.call(o)).done || !i.call(o).done) throw TypeError("Expected sequence with length 2");
          p.push({
            key: a.value + "",
            value: s.value + ""
          });
        } else for (l in u) {
          f(u, l) && p.push({
            key: l,
            value: u[l] + ""
          });
        }
      } else D(p, "string" == typeof u ? "?" === u.charAt(0) ? u.slice(1) : u : u + "");
    },
        H = V.prototype;

    s(H, {
      append: function append(e, t) {
        U(arguments.length, 2);
        var n = T(this);
        n.entries.push({
          key: e + "",
          value: t + ""
        }), n.updateURL();
      },
      delete: function _delete(e) {
        U(arguments.length, 1);

        for (var t = T(this), n = t.entries, r = e + "", o = 0; o < n.length;) {
          n[o].key === r ? n.splice(o, 1) : o++;
        }

        t.updateURL();
      },
      get: function get(e) {
        U(arguments.length, 1);

        for (var t = T(this).entries, n = e + "", r = 0; r < t.length; r++) {
          if (t[r].key === n) return t[r].value;
        }

        return null;
      },
      getAll: function getAll(e) {
        U(arguments.length, 1);

        for (var t = T(this).entries, n = e + "", r = [], o = 0; o < t.length; o++) {
          t[o].key === n && r.push(t[o].value);
        }

        return r;
      },
      has: function has(e) {
        U(arguments.length, 1);

        for (var t = T(this).entries, n = e + "", r = 0; r < t.length;) {
          if (t[r++].key === n) return !0;
        }

        return !1;
      },
      set: function set(e, t) {
        U(arguments.length, 1);

        for (var n, r = T(this), o = r.entries, i = !1, a = e + "", s = t + "", l = 0; l < o.length; l++) {
          n = o[l], n.key === a && (i ? o.splice(l--, 1) : (i = !0, n.value = s));
        }

        i || o.push({
          key: a,
          value: s
        }), r.updateURL();
      },
      sort: function sort() {
        var e,
            t,
            n,
            r = T(this),
            o = r.entries,
            i = o.slice();

        for (o.length = 0, n = 0; n < i.length; n++) {
          for (e = i[n], t = 0; t < n; t++) {
            if (o[t].key > e.key) {
              o.splice(t, 0, e);
              break;
            }
          }

          t === n && o.push(e);
        }

        r.updateURL();
      },
      forEach: function forEach(e) {
        for (var t, n = T(this).entries, r = p(e, arguments.length > 1 ? arguments[1] : void 0, 3), o = 0; o < n.length;) {
          t = n[o++], r(t.value, t.key, this);
        }
      },
      keys: function keys() {
        return new B(this, "keys");
      },
      values: function values() {
        return new B(this, "values");
      },
      entries: function entries() {
        return new B(this, "entries");
      }
    }, {
      enumerable: !0
    }), a(H, S, H.entries), a(H, "toString", function () {
      for (var e, t = T(this).entries, n = [], r = 0; r < t.length;) {
        e = t[r++], n.push(L(e.key) + "=" + L(e.value));
      }

      return n.join("&");
    }, {
      enumerable: !0
    }), l(V, "URLSearchParams"), r({
      global: !0,
      forced: !i
    }, {
      URLSearchParams: V
    }), i || "function" != typeof E || "function" != typeof O || r({
      global: !0,
      enumerable: !0,
      forced: !0
    }, {
      fetch: function fetch(e) {
        var t,
            n,
            r,
            o = [e];
        return arguments.length > 1 && (t = arguments[1], g(t) && (n = t.body, "URLSearchParams" === h(n) && (r = t.headers ? new O(t.headers) : new O(), r.has("content-type") || r.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), t = v(t, {
          body: y(0, String(n)),
          headers: y(0, r)
        }))), o.push(t)), E.apply(this, o);
      }
    }), e.exports = {
      URLSearchParams: V,
      getState: T
    };
  }, function (e, t, n) {
    var r = n(36),
        o = n(99);

    e.exports = function (e) {
      var t = o(e);
      if ("function" != typeof t) throw TypeError(String(e) + " is not iterable");
      return r(t.call(e));
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(320),
        o = n(182);
    r({
      target: "RegExp",
      proto: !0,
      forced: /./.exec !== o
    }, {
      exec: o
    });
  }, function (e, t, n) {
    var r = n(37),
        o = n(321).f,
        i = n(103),
        a = n(179),
        s = n(180),
        l = n(619),
        u = n(628);

    e.exports = function (e, t) {
      var n,
          c,
          d,
          f,
          p,
          h = e.target,
          m = e.global,
          g = e.stat;
      if (n = m ? r : g ? r[h] || s(h, {}) : (r[h] || {}).prototype) for (c in t) {
        if (f = t[c], e.noTargetGet ? (p = o(n, c), d = p && p.value) : d = n[c], !u(m ? c : h + (g ? "." : "#") + c, e.forced) && void 0 !== d) {
          if (typeof f == typeof d) continue;
          l(f, d);
        }

        (e.sham || d && d.sham) && i(f, "sham", !0), a(n, c, f, e);
      }
    };
  }, function (e, t, n) {
    var r = n(102),
        o = n(613),
        i = n(322),
        a = n(126),
        s = n(324),
        l = n(85),
        u = n(325),
        c = Object.getOwnPropertyDescriptor;
    t.f = r ? c : function (e, t) {
      if (e = a(e), t = s(t, !0), u) try {
        return c(e, t);
      } catch (e) {}
      if (l(e, t)) return i(!o.f.call(e, t), e[t]);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t
      };
    };
  }, function (e, t, n) {
    var r = n(52),
        o = n(127),
        i = "".split;
    e.exports = r(function () {
      return !Object("z").propertyIsEnumerable(0);
    }) ? function (e) {
      return "String" == o(e) ? i.call(e, "") : Object(e);
    } : Object;
  }, function (e, t, n) {
    var r = n(129);

    e.exports = function (e, t) {
      if (!r(e)) return e;
      var n, o;
      if (t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
      if ("function" == typeof (n = e.valueOf) && !r(o = n.call(e))) return o;
      if (!t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, t, n) {
    var r = n(102),
        o = n(52),
        i = n(614);
    e.exports = !r && !o(function () {
      return 7 != Object.defineProperty(i("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, n) {
    var r = n(181),
        o = Function.toString;
    "function" != typeof r.inspectSource && (r.inspectSource = function (e) {
      return o.call(e);
    }), e.exports = r.inspectSource;
  }, function (e, t, n) {
    var r = n(618),
        o = n(181);
    (e.exports = function (e, t) {
      return o[e] || (o[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: "3.9.1",
      mode: r ? "pure" : "global",
      copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
    });
  }, function (e, t) {
    var n = 0,
        r = Math.random();

    e.exports = function (e) {
      return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++n + r).toString(36);
    };
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, n) {
    var r = n(621),
        o = n(37),
        i = function i(e) {
      return "function" == typeof e ? e : void 0;
    };

    e.exports = function (e, t) {
      return arguments.length < 2 ? i(r[e]) || i(o[e]) : r[e] && r[e][t] || o[e] && o[e][t];
    };
  }, function (e, t, n) {
    var r = n(131),
        o = Math.min;

    e.exports = function (e) {
      return e > 0 ? o(r(e), 9007199254740991) : 0;
    };
  }, function (e, t, n) {
    var r = n(631),
        o = n(632),
        i = n(52);
    e.exports = !!Object.getOwnPropertySymbols && !i(function () {
      return !Symbol.sham && (r ? 38 === o : o > 37 && o < 41);
    });
  }, function (e, t, n) {
    e.exports = n(647);
  }, function (e, t, n) {
    n(651);
    var r = n(21);
    e.exports = r.Object.keys;
  }, function (e, t, n) {
    n(336);
    var r = n(21);
    e.exports = r.Object.getOwnPropertySymbols;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(19),
        i = n(45),
        a = n(63),
        s = n(26),
        l = n(170),
        u = n(299),
        c = n(20),
        d = n(31),
        f = n(104),
        p = n(35),
        h = n(36),
        m = n(64),
        g = n(43),
        v = n(121),
        y = n(59),
        b = n(124),
        _ = n(97),
        w = n(185),
        E = n(653),
        O = n(177),
        S = n(95),
        x = n(48),
        T = n(120),
        k = n(44),
        C = n(66),
        A = n(167),
        N = n(122),
        P = n(123),
        R = n(168),
        I = n(14),
        M = n(186),
        j = n(17),
        L = n(51),
        D = n(62),
        F = n(105).forEach,
        U = N("hidden"),
        B = I("toPrimitive"),
        V = D.set,
        H = D.getterFor("Symbol"),
        q = Object.prototype,
        _W = o.Symbol,
        z = i("JSON", "stringify"),
        $ = S.f,
        K = x.f,
        G = E.f,
        Y = T.f,
        J = A("symbols"),
        Q = A("op-symbols"),
        X = A("string-to-symbol-registry"),
        Z = A("symbol-to-string-registry"),
        ee = A("wks"),
        te = o.QObject,
        ne = !te || !te.prototype || !te.prototype.findChild,
        re = s && c(function () {
      return 7 != b(K({}, "a", {
        get: function get() {
          return K(this, "a", {
            value: 7
          }).a;
        }
      })).a;
    }) ? function (e, t, n) {
      var r = $(q, t);
      r && delete q[t], K(e, t, n), r && e !== q && K(q, t, r);
    } : K,
        oe = function oe(e, t) {
      var n = J[e] = b(_W.prototype);
      return V(n, {
        type: "Symbol",
        tag: e,
        description: t
      }), s || (n.description = t), n;
    },
        ie = u ? function (e) {
      return "symbol" == typeof e;
    } : function (e) {
      return Object(e) instanceof _W;
    },
        ae = function ae(e, t, n) {
      e === q && ae(Q, t, n), h(e);
      var r = v(t, !0);
      return h(n), d(J, r) ? (n.enumerable ? (d(e, U) && e[U][r] && (e[U][r] = !1), n = b(n, {
        enumerable: y(0, !1)
      })) : (d(e, U) || K(e, U, y(1, {})), e[U][r] = !0), re(e, r, n)) : K(e, r, n);
    },
        se = function se(e, t) {
      h(e);

      var n = g(t),
          r = _(n).concat(fe(n));

      return F(r, function (t) {
        s && !ue.call(n, t) || ae(e, t, n[t]);
      }), e;
    },
        le = function le(e, t) {
      return void 0 === t ? b(e) : se(b(e), t);
    },
        ue = function ue(e) {
      var t = v(e, !0),
          n = Y.call(this, t);
      return !(this === q && d(J, t) && !d(Q, t)) && (!(n || !d(this, t) || !d(J, t) || d(this, U) && this[U][t]) || n);
    },
        ce = function ce(e, t) {
      var n = g(e),
          r = v(t, !0);

      if (n !== q || !d(J, r) || d(Q, r)) {
        var o = $(n, r);
        return !o || !d(J, r) || d(n, U) && n[U][r] || (o.enumerable = !0), o;
      }
    },
        de = function de(e) {
      var t = G(g(e)),
          n = [];
      return F(t, function (e) {
        d(J, e) || d(P, e) || n.push(e);
      }), n;
    },
        fe = function fe(e) {
      var t = e === q,
          n = G(t ? Q : g(e)),
          r = [];
      return F(n, function (e) {
        !d(J, e) || t && !d(q, e) || r.push(J[e]);
      }), r;
    };

    if (l || (_W = function W() {
      if (this instanceof _W) throw TypeError("Symbol is not a constructor");

      var e = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0,
          t = R(e),
          n = function n(e) {
        this === q && n.call(Q, e), d(this, U) && d(this[U], t) && (this[U][t] = !1), re(this, t, y(1, e));
      };

      return s && ne && re(q, t, {
        configurable: !0,
        set: n
      }), oe(t, e);
    }, C(_W.prototype, "toString", function () {
      return H(this).tag;
    }), C(_W, "withoutSetter", function (e) {
      return oe(R(e), e);
    }), T.f = ue, x.f = ae, S.f = ce, w.f = E.f = de, O.f = fe, M.f = function (e) {
      return oe(I(e), e);
    }, s && (K(_W.prototype, "description", {
      configurable: !0,
      get: function get() {
        return H(this).description;
      }
    }), a || C(q, "propertyIsEnumerable", ue, {
      unsafe: !0
    }))), r({
      global: !0,
      wrap: !0,
      forced: !l,
      sham: !l
    }, {
      Symbol: _W
    }), F(_(ee), function (e) {
      j(e);
    }), r({
      target: "Symbol",
      stat: !0,
      forced: !l
    }, {
      for: function _for(e) {
        var t = String(e);
        if (d(X, t)) return X[t];

        var n = _W(t);

        return X[t] = n, Z[n] = t, n;
      },
      keyFor: function keyFor(e) {
        if (!ie(e)) throw TypeError(e + " is not a symbol");
        if (d(Z, e)) return Z[e];
      },
      useSetter: function useSetter() {
        ne = !0;
      },
      useSimple: function useSimple() {
        ne = !1;
      }
    }), r({
      target: "Object",
      stat: !0,
      forced: !l,
      sham: !s
    }, {
      create: le,
      defineProperty: ae,
      defineProperties: se,
      getOwnPropertyDescriptor: ce
    }), r({
      target: "Object",
      stat: !0,
      forced: !l
    }, {
      getOwnPropertyNames: de,
      getOwnPropertySymbols: fe
    }), r({
      target: "Object",
      stat: !0,
      forced: c(function () {
        O.f(1);
      })
    }, {
      getOwnPropertySymbols: function getOwnPropertySymbols(e) {
        return O.f(m(e));
      }
    }), z) {
      r({
        target: "JSON",
        stat: !0,
        forced: !l || c(function () {
          var e = _W();

          return "[null]" != z([e]) || "{}" != z({
            a: e
          }) || "{}" != z(Object(e));
        })
      }, {
        stringify: function stringify(e, t, n) {
          for (var r, o = [e], i = 1; arguments.length > i;) {
            o.push(arguments[i++]);
          }

          if (r = t, (p(t) || void 0 !== e) && !ie(e)) return f(t) || (t = function t(e, _t7) {
            if ("function" == typeof r && (_t7 = r.call(this, e, _t7)), !ie(_t7)) return _t7;
          }), o[1] = t, z.apply(null, o);
        }
      });
    }

    _W.prototype[B] || k(_W.prototype, B, _W.prototype.valueOf), L(_W, "Symbol"), P[U] = !0;
  }, function (e, t, n) {
    var r = n(35),
        o = n(104),
        i = n(14),
        a = i("species");

    e.exports = function (e, t) {
      var n;
      return o(e) && (n = e.constructor, "function" != typeof n || n !== Array && !o(n.prototype) ? r(n) && null === (n = n[a]) && (n = void 0) : n = void 0), new (void 0 === n ? Array : n)(0 === t ? 0 : t);
    };
  }, function (e, t, n) {
    function r(e, t) {
      return o(e) || i(e, t) || a(e, t) || s();
    }

    var o = n(679),
        i = n(682),
        a = n(346),
        s = n(713);
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(680);
  }, function (e, t, n) {
    n(681);
    var r = n(21);
    e.exports = r.Array.isArray;
  }, function (e, t, n) {
    e.exports = n(683);
  }, function (e, t, n) {
    e.exports = n(684);
  }, function (e, t, n) {
    n(344), n(292), n(336), n(687), n(688), n(689), n(690), n(345), n(691), n(692), n(693), n(694), n(695), n(696), n(697), n(698), n(699), n(700), n(701);
    var r = n(21);
    e.exports = r.Symbol;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(20),
        i = n(104),
        a = n(35),
        s = n(64),
        l = n(81),
        u = n(101),
        c = n(337),
        d = n(135),
        f = n(14),
        p = n(176),
        h = f("isConcatSpreadable"),
        m = p >= 51 || !o(function () {
      var e = [];
      return e[h] = !1, e.concat()[0] !== e;
    }),
        g = d("concat"),
        v = function v(e) {
      if (!a(e)) return !1;
      var t = e[h];
      return void 0 !== t ? !!t : i(e);
    };

    r({
      target: "Array",
      proto: !0,
      forced: !m || !g
    }, {
      concat: function concat(e) {
        var t,
            n,
            r,
            o,
            i,
            a = s(this),
            d = c(a, 0),
            f = 0;

        for (t = -1, r = arguments.length; t < r; t++) {
          if (i = -1 === t ? a : arguments[t], v(i)) {
            if (o = l(i.length), f + o > 9007199254740991) throw TypeError("Maximum allowed index exceeded");

            for (n = 0; n < o; n++, f++) {
              n in i && u(d, f, i[n]);
            }
          } else {
            if (f >= 9007199254740991) throw TypeError("Maximum allowed index exceeded");
            u(d, f++, i);
          }
        }

        return d.length = f, d;
      }
    });
  }, function (e, t, n) {
    n(17)("iterator");
  }, function (e, t, n) {
    function r(e, t) {
      var n;

      if (e) {
        if ("string" == typeof e) return a(e, t);
        var r = i(n = Object.prototype.toString.call(e)).call(n, 8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? o(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? a(e, t) : void 0;
      }
    }

    var o = n(347),
        i = n(709),
        a = n(350);
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(707);
  }, function (e, t, n) {
    n(61), n(708);
    var r = n(21);
    e.exports = r.Array.from;
  }, function (e, t, n) {
    var r = n(711),
        o = Array.prototype;

    e.exports = function (e) {
      var t = e.slice;
      return e === o || e instanceof Array && t === o.slice ? r : t;
    };
  }, function (e, t) {
    function n(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    e.exports = n;
  }, function (e, t, n) {
    e.exports = n(718);
  }, function (e, t, n) {
    e.exports = n(722);
  }, function (e, t, n) {
    "use strict";

    var r = n(34),
        o = n(40);
    r(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = o(n(80));
    n(107);

    var a = o(n(727)),
        s = o(n(96)),
        l = o(n(86)),
        u = o(n(732)),
        c = n(736),
        d = function d(e, t) {
      var n,
          r,
          o = e,
          d = (0, c.parseIdxResponse)(e, t),
          f = d.remediations,
          p = d.context,
          h = d.actions,
          m = (0, u.default)(f),
          g = function () {
        var e = (0, l.default)(i.default.mark(function e(t) {
          var n,
              r,
              o = arguments;
          return i.default.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, a.default)(f).call(f, function (e) {
                    return e.name === t;
                  })) {
                    e.next = 4;
                    break;
                  }

                  return e.abrupt("return", s.default.reject("Unknown remediation choice: [".concat(t, "]")));

                case 4:
                  return e.abrupt("return", r.action(n));

                case 5:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }(),
          v = function v() {
        return !!o.successWithInteractionCode;
      },
          y = function y(e) {
        return "interaction_code" === e.name;
      },
          b = null === (n = o.successWithInteractionCode) || void 0 === n ? void 0 : (0, a.default)(r = n.value).call(r, y).value;

      return {
        proceed: g,
        neededToProceed: m,
        actions: h,
        context: p,
        rawIdxState: o,
        hasInteractionCode: v,
        interactionCode: b,
        toPersist: t
      };
    },
        f = d;

    t.default = f;
  }, function (e, t, n) {
    e.exports = n(738);
  }, function (e, t, n) {
    e.exports = n(748);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = i(e);

      if (a) {
        var r = a(e);
        t && (r = s(r).call(r, function (t) {
          return l(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};

        if (t % 2) {
          var o;
          u(o = r(Object(n), !0)).call(o, function (t) {
            (0, v.default)(e, t, n[t]);
          });
        } else if (c) d(e, c(n));else {
          var i;
          u(i = r(Object(n))).call(i, function (t) {
            f(e, t, l(n, t));
          });
        }
      }

      return e;
    }

    var i = n(133),
        a = n(184),
        s = n(134),
        l = n(187),
        u = n(106),
        c = n(188),
        d = n(189),
        f = n(34),
        p = n(40);
    f(t, "__esModule", {
      value: !0
    }), t.default = void 0, n(107);

    var h = p(n(80)),
        m = p(n(333)),
        g = p(n(96)),
        v = p(n(190)),
        y = p(n(86)),
        b = n(132),
        _ = n(753),
        w = p(n(353)),
        E = function E(e) {
      var t = e.actionDefinition,
          n = e.defaultParamsForAction,
          r = void 0 === n ? {} : n,
          i = e.immutableParamsForAction,
          a = void 0 === i ? {} : i,
          s = e.toPersist,
          l = t.href;
      return function () {
        var e = (0, y.default)(h.default.mark(function e(n) {
          var i, u;
          return h.default.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return i = {
                    "content-type": "application/json",
                    accept: t.accepts || "application/ion+json"
                  }, u = (0, m.default)(o(o(o({}, r), n), a)), e.abrupt("return", (0, b.request)(l, {
                    method: t.method,
                    headers: i,
                    body: u
                  }).then(function (e) {
                    var t = e.json();
                    return e.ok ? t : 401 === e.status && 'Oktadevicejwt realm="Okta Device"' === e.headers.get("WWW-Authenticate") ? t.then(function (e) {
                      return g.default.reject((0, w.default)(e, s));
                    }) : t.then(function (e) {
                      return g.default.reject(e);
                    });
                  }).then(function (e) {
                    return (0, w.default)(e, s);
                  }));

                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));
        return function (t) {
          return e.apply(this, arguments);
        };
      }();
    },
        O = function O(e, t) {
      var n = E,
          r = (0, _.divideActionParamsByMutability)(e),
          o = r.defaultParams,
          i = r.neededParams,
          a = r.immutableParams,
          s = n({
        actionDefinition: e,
        defaultParamsForAction: o[e.name],
        immutableParamsForAction: a[e.name],
        toPersist: t
      });
      return s.neededParams = i, s;
    },
        S = O;

    t.default = S;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return o.apply(this, arguments);
    }

    function o() {
      return o = (0, s.default)(a.default.mark(function e(t, n) {
        var r, o;
        return a.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = t.get("baseUrl"), o = t.get("apiVersion"), e.abrupt("return", l.default.start({
                  domain: r,
                  stateHandle: n,
                  version: o
                }));

              case 3:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), o.apply(this, arguments);
    }

    var i = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.introspect = r;
    var a = i(n(57)),
        s = i(n(58)),
        l = i(n(162));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(118)),
        a = r(n(5)),
        s = o.View.extend({
      HeaderBeacon: null,
      initialize: function initialize() {
        this.HeaderBeacon && this.add(this.HeaderBeacon);
      },
      postRender: function postRender() {
        var e = (0, o.$)("#".concat(a.default.WIDGET_CONTAINER_ID));

        if (this.HeaderBeacon) {
          e.removeClass("no-beacon");
          var t = this.$el.find('[data-type="beacon-container"]');
          i.default.explode(t);
        } else e.addClass("no-beacon");
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(136)),
        a = n(68),
        s = o.View.extend({
      className: "auth-footer",
      links: [],
      footerInfo: null,
      hasBackToSignInLink: !0,
      initialize: function initialize() {
        var e = this,
            t = o._.resultCtx(this, "links", this),
            n = o._.resultCtx(this, "footerInfo", this),
            r = o._.resultCtx(this, "hasBackToSignInLink", this);

        t = Array.isArray(t) ? t.filter(function (e) {
          return o.$.isPlainObject(e);
        }) : [], this.options.appState.shouldShowSignOutLinkInCurrentForm(this.options.settings.get("features.hideSignOutLinkInMFA") || this.settings.get("features.mfaOnlyFlow")) && r && (t = t.concat((0, a.getSignOutLink)(this.options.settings))), t.forEach(function (t) {
          e.add(i.default, {
            options: t
          });
        }), n && (this.add(o.View.extend({
          className: "footer-info"
        })), this.add(n, ".footer-info"));
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? r(Object(n), !0).forEach(function (t) {
          (0, s.default)(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var i,
        a = n(0),
        s = a(n(42)),
        l = n(1),
        u = a(n(774)),
        c = a(n(361)),
        d = n(108),
        f = n(8),
        p = a(n(276)),
        h = a(n(255)),
        m = a(n(258)),
        g = a(n(776)),
        v = function v(e) {
      var t = (e.options || []).map(function (e) {
        return Object.assign({}, e, (0, d.getAuthenticatorDataForEnroll)(e));
      });
      return {
        View: u.default,
        options: {
          name: e.name,
          collection: new l.Collection(t)
        }
      };
    },
        y = function y(e) {
      var t = e.options || [],
          n = !1;
      return t = t.filter(function (e) {
        return e.authenticatorKey !== f.AUTHENTICATOR_KEY.WEBAUTHN || !n && (n = !0, !0);
      }), t = t.map(function (e) {
        return Object.assign({}, e, (0, d.getAuthenticatorDataForVerification)(e));
      }), {
        View: c.default,
        options: {
          name: e.name,
          collection: new l.Collection(t)
        }
      };
    },
        b = function b() {
      return {
        View: h.default
      };
    },
        _ = function _() {
      return {
        View: m.default
      };
    },
        w = function w(e) {
      return {
        View: g.default,
        options: {
          name: e.name
        }
      };
    },
        E = (i = {
      authenticatorEnrollSelect: v,
      authenticatorVerifySelect: y
    }, (0, s.default)(i, "admin-consent", b), (0, s.default)(i, "consent", _), (0, s.default)(i, "captcha", w), i),
        O = function O(e) {
      return (E[e.type] || l._.identity)(e);
    },
        S = function S(e) {
      var t = e.filter(function (e) {
        return e.name === f.FORMS.REDIRECT_IDP;
      });
      return Array.isArray(t) ? t.map(function (e) {
        var t,
            n,
            r = null === (t = e.type) || void 0 === t ? void 0 : t.toLowerCase();
        if (l._.contains(p.default.SUPPORTED_SOCIAL_IDPS, r)) n = (0, l.loc)("socialauth.".concat(r, ".label"), "login");else {
          var o;
          r = "general-idp", n = (0, l.loc)("customauth.sign.in.with.label", "login", [null === (o = e.idp) || void 0 === o ? void 0 : o.name]);
        }
        var i = ["social-auth-button", "social-auth-".concat(r, "-button")];
        return "general-idp" === r && i.push("no-translate"), e.idp.className && i.push(e.idp.className), {
          attributes: {
            "data-se": "social-auth-".concat(r, "-button")
          },
          className: i.join(" "),
          title: n,
          href: e.href
        };
      }) : [];
    },
        x = function x(e) {
      return e.get("customButtons").map(function (e) {
        return {
          attributes: {
            "data-se": e.dataAttr
          },
          className: e.className + " default-custom-button",
          title: e.title,
          click: e.click
        };
      });
    },
        T = function T(e) {
      return (0, l.createButton)(o(o({}, e), {}, {
        className: "".concat(e.className, " default-custom-button button-primary")
      }));
    };

    e.exports = {
      create: O,
      createIdpButtons: S,
      createCustomButtons: x,
      addCustomButton: T
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = a.View.extend({
      className: "authenticator-row clearfix",
      template: i.default.template({
        1: function _(e, t, n, r, o) {
          return "authenticator-label--small";
        },
        3: function _(e, t, n, r, i) {
          var a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<p class="authenticator-description--text ' + u((a = null != (a = c(n, "noTranslateClassName") || (null != t ? c(t, "noTranslateClassName") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "noTranslateClassName",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 333
              },
              end: {
                line: 1,
                column: 357
              }
            }
          }) : a)) + '">' + u((a = null != (a = c(n, "description") || (null != t ? c(t, "description") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "description",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 359
              },
              end: {
                line: 1,
                column: 374
              }
            }
          }) : a)) + "</p>";
        },
        5: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return 'data-se="' + e.escapeExpression((i = null != (i = a(n, "buttonDataSeAttr") || (null != t ? a(t, "buttonDataSeAttr") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "buttonDataSeAttr",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 458
              },
              end: {
                line: 1,
                column: 478
              }
            }
          }) : i)) + '"';
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s,
              l = null != t ? t : e.nullContext || {},
              u = e.hooks.helperMissing,
              c = e.escapeExpression,
              d = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="authenticator-icon-container"><div class="factor-icon authenticator-icon ' + c((s = null != (s = d(n, "iconClassName") || (null != t ? d(t, "iconClassName") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "iconClassName",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 85
              },
              end: {
                line: 1,
                column: 102
              }
            }
          }) : s)) + '"></div></div><div class="authenticator-description"><div><h3 class="authenticator-label no-translate ' + (null != (a = d(n, "if").call(l, null != t ? d(t, "description") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 204
              },
              end: {
                line: 1,
                column: 256
              }
            }
          })) ? a : "") + '">' + c((s = null != (s = d(n, "label") || (null != t ? d(t, "label") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "label",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 258
              },
              end: {
                line: 1,
                column: 267
              }
            }
          }) : s)) + "</h3>" + (null != (a = d(n, "if").call(l, null != t ? d(t, "description") : t, {
            name: "if",
            hash: {},
            fn: e.program(3, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 272
              },
              end: {
                line: 1,
                column: 385
              }
            }
          })) ? a : "") + '</div><div class="authenticator-button" ' + (null != (a = d(n, "if").call(l, null != t ? d(t, "buttonDataSeAttr") : t, {
            name: "if",
            hash: {},
            fn: e.program(5, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 425
              },
              end: {
                line: 1,
                column: 486
              }
            }
          })) ? a : "") + "></div></div>";
        },
        useData: !0
      }),
      children: function children() {
        return [[(0, a.createButton)({
          className: "button select-factor",
          title: function title() {
            return (0, a.loc)("oie.verify.authenticator.button.text", "login");
          },
          click: function click() {
            this.model.trigger("selectAutheticator", this.model.get("value"));
          }
        }), ".authenticator-button"]];
      },
      minimize: function minimize() {
        this.$el.addClass("authenticator-row-min");
      }
    }),
        l = a.ListView.extend({
      className: "authenticator-verify-list authenticator-list",
      item: s,
      itemSelector: ".list-content",
      initialize: function initialize() {
        this.listenTo(this.collection, "selectAutheticator", this.handleSelect);
      },
      handleSelect: function handleSelect(e) {
        var t,
            n = this.model.validateField("identifier");
        this.model.trigger("clearFormError"), (null === (t = this.model.getPropertySchema("identifier")) || void 0 === t ? void 0 : t.required) && n ? this.model.trigger("invalid", this.model, n) : (this.model.set(this.options.name, e), this.options.appState.trigger("saveForm", this.model));
      },
      template: i.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          return '<div class="list-content"></div>';
        },
        useData: !0
      })
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(109)),
        i = r(n(137)),
        a = i.default.extend(Object.assign({
      initialize: function initialize() {
        i.default.prototype.initialize.apply(this, arguments), this.listenTo(this.options.appState, "change:dynamicRefreshInterval", this.updateRefreshInterval);
      },
      updateRefreshInterval: function updateRefreshInterval() {
        this.polling && (this.stopPolling(), this.startPolling(this.options.appState.get("dynamicRefreshInterval")));
      }
    }, o.default));
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        o = r(n(42)),
        i = n(1),
        a = function a(e) {
      var t = Object.assign({}, i._.chain(e).pick("minLength", "maxLength", "required", "value").defaults({
        type: "string",
        required: !0
      }).value());
      return e.modelType && (t.type = e.modelType), (0, o.default)({}, e.name, t);
    },
        s = function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      (t.uiSchema || []).forEach(function (t) {
        if (Array.isArray(t.optionsUiSchemas)) {
          var i,
              s = {};
          Number(t.value) >= 0 && (i = t.value), n[t.name] && (s = {
            value: n[t.name]
          }, i = Number(s.value)), Object.assign(o, a(Object.assign({}, t, s))), i && e({
            uiSchema: t.optionsUiSchemas[i]
          }, n, r, o);
        } else Object.assign(r, a(t));
      });
    },
        l = function l() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = {},
          r = {
        formName: "string",
        useRedirect: "boolean"
      };
      return s(e, t, n, r), i.Model.extend({
        props: n,
        local: r
      });
    };

    e.exports = {
      create: l
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getV1ClassName = t.getClassNameMapping = void 0;

    var o,
        i,
        a,
        s,
        l = r(n(42)),
        u = n(8),
        c = (s = {}, (0, l.default)(s, u.FORMS.IDENTIFY, (o = {}, (0, l.default)(o, u.FORMS.IDENTIFY, "primary-auth"), (0, l.default)(o, u.AUTHENTICATOR_KEY.PASSWORD, "primary-auth"), o)), (0, l.default)(s, u.FORMS.IDENTIFY_RECOVERY, (0, l.default)({}, u.FORMS.IDENTIFY_RECOVERY, "forgot-password")), (0, l.default)(s, u.FORMS.ENROLL_PROFILE, (0, l.default)({}, u.FORMS.ENROLL_PROFILE, "registration")), (0, l.default)(s, u.FORMS.CHALLENGE_AUTHENTICATOR, (i = {}, (0, l.default)(i, u.AUTHENTICATOR_KEY.EMAIL, "mfa-verify-passcode"), (0, l.default)(i, u.AUTHENTICATOR_KEY.PASSWORD, "mfa-verify-password"), (0, l.default)(i, "sms", "mfa-verify-passcode"), (0, l.default)(i, "voice", "mfa-verify-passcode"), (0, l.default)(i, u.AUTHENTICATOR_KEY.SECURITY_QUESTION, "mfa-verify-question"), (0, l.default)(i, u.AUTHENTICATOR_KEY.WEBAUTHN, "mfa-verify-webauthn"), (0, l.default)(i, u.AUTHENTICATOR_KEY.ON_PREM, "mfa-verify-totp"), (0, l.default)(i, u.AUTHENTICATOR_KEY.RSA, "mfa-verify-totp"), (0, l.default)(i, u.AUTHENTICATOR_KEY.OV, "mfa-verify"), (0, l.default)(i, u.AUTHENTICATOR_KEY.GOOGLE_OTP, "mfa-verify"), (0, l.default)(i, u.AUTHENTICATOR_KEY.DUO, "mfa-verify-duo"), (0, l.default)(i, u.AUTHENTICATOR_KEY.SYMANTEC_VIP, "mfa-verify"), i)), (0, l.default)(s, u.FORMS.CHALLENGE_POLL, (0, l.default)({}, u.AUTHENTICATOR_KEY.OV, "mfa-verify")), (0, l.default)(s, u.FORMS.RESEND_PUSH, (0, l.default)({}, u.AUTHENTICATOR_KEY.OV, "mfa-verify")), (0, l.default)(s, u.FORMS.ENROLL_AUTHENTICATOR, (a = {}, (0, l.default)(a, u.AUTHENTICATOR_KEY.EMAIL, "enroll-email"), (0, l.default)(a, u.AUTHENTICATOR_KEY.PASSWORD, "enroll-password"), (0, l.default)(a, "sms", "enroll-sms"), (0, l.default)(a, "voice", "enroll-call"), (0, l.default)(a, u.AUTHENTICATOR_KEY.SECURITY_QUESTION, "enroll-question"), (0, l.default)(a, u.AUTHENTICATOR_KEY.WEBAUTHN, "enroll-webauthn"), (0, l.default)(a, u.AUTHENTICATOR_KEY.ON_PREM, "enroll-onprem"), (0, l.default)(a, u.AUTHENTICATOR_KEY.RSA, "enroll-rsa"), (0, l.default)(a, u.AUTHENTICATOR_KEY.DUO, "enroll-duo"), (0, l.default)(a, u.AUTHENTICATOR_KEY.SYMANTEC_VIP, "enroll-symantec"), a)), (0, l.default)(s, u.FORMS.SELECT_AUTHENTICATOR_ENROLL, {
      "select-authenticator-enroll": "enroll-choices"
    }), (0, l.default)(s, u.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE, (0, l.default)({}, u.AUTHENTICATOR_KEY.PASSWORD, "forgot-password")), (0, l.default)(s, u.FORMS.REENROLL_AUTHENTICATOR, (0, l.default)({}, u.AUTHENTICATOR_KEY.PASSWORD, "password-expired")), (0, l.default)(s, u.FORMS.RESET_AUTHENTICATOR, (0, l.default)({}, u.AUTHENTICATOR_KEY.PASSWORD, "forgot-password")), (0, l.default)(s, u.FORMS.CONSENT_ADMIN, (0, l.default)({}, u.FORMS.CONSENT_ADMIN, "admin-consent-required")), (0, l.default)(s, u.FORMS.CONSENT_ENDUSER, (0, l.default)({}, u.FORMS.CONSENT_ENDUSER, "consent-required")), s),
        d = function d(e, t, n, r) {
      if (r && e === u.FORMS.IDENTIFY) return "forgot-password";
      var o = e;
      return t === u.AUTHENTICATOR_KEY.PHONE ? o = "".concat(n) : t && (o = "".concat(t)), c[e] && c[e][o] ? c[e][o] : null;
    };

    t.getV1ClassName = d;

    var f = function f(e, t, n, r) {
      var o = e;
      t && (o = o + "--" + t);
      var i = d(e, t, n, r),
          a = [o];
      return i && a.push(i), a;
    };

    t.getClassNameMapping = f;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? r(Object(n), !0).forEach(function (t) {
          (0, a.default)(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var i = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = i(n(42)),
        s = n(1),
        l = n(8),
        u = n(3),
        c = i(n(778)),
        d = i(n(366)),
        f = i(n(136)),
        p = i(n(779)),
        h = i(n(780)),
        m = i(n(367)),
        g = n(67),
        v = n(68),
        y = u.BaseForm.extend({
      title: function title() {
        return (0, s.loc)("primaryauth.title", "login");
      },
      save: function save() {
        return (0, s.loc)("oform.next", "login");
      },
      initialize: function initialize() {
        u.BaseForm.prototype.initialize.apply(this, arguments), this.getUISchema().find(function (e) {
          return "credentials.passcode" === e.name;
        }) && (this.save = (0, s.loc)("oie.primaryauth.submit", "login"));
      },
      saveForm: function saveForm() {
        var e = this,
            t = arguments;
        if (!this.settings.get("features.deviceFingerprinting")) return void u.BaseForm.prototype.saveForm.apply(this, arguments);
        var n = {
          oktaDomainUrl: this.settings.get("baseUrl"),
          element: this.$el
        };
        c.default.generateDeviceFingerprint(n).then(function (t) {
          e.options.appState.set("deviceFingerprint", t);
        }).catch(function () {}).finally(function () {
          u.BaseForm.prototype.saveForm.apply(e, t);
        });
      },
      render: function render() {
        u.BaseForm.prototype.render.apply(this, arguments), this.options.appState.hasRemediationObject(l.FORMS.LAUNCH_AUTHENTICATOR) && this.add(m.default, ".o-form-fieldset-container", !1, !0, {
          isRequired: !1
        });
        var e = (0, u.createIdpButtons)(this.options.appState.get("remediations"));
        Array.isArray(e) && e.length && (this._addForgotPasswordView(), this._addIdpView(e));
        var t = (0, u.createCustomButtons)(this.options.settings);
        Array.isArray(t) && t.length && this.add(h.default, {
          selector: ".o-form-button-bar",
          options: {
            customButtons: t,
            addSeparateLine: !0
          }
        });
      },
      showMessages: function showMessages() {
        var e = this.options.appState.get("messages");

        if ((null === e || void 0 === e ? void 0 : e.value.length) && "identify" === this.options.appState.get("currentFormName")) {
          var t = e.value[0].message,
              n = (0, s.createCallout)({
            content: t,
            type: "warning"
          });
          this.add(n, ".o-form-error-container");
        }
      },
      getUISchema: function getUISchema() {
        var e = u.BaseForm.prototype.getUISchema.apply(this, arguments),
            t = this.options.settings;
        return e.map(function (e) {
          var n = o({}, e);
          return "identifier" === e.name && (0, g.isCustomizedI18nKey)("primaryauth.username.tooltip", t) ? n = o(o({}, n), {}, {
            explain: (0, s.loc)("primaryauth.username.tooltip", "login"),
            "explain-top": !0
          }) : "credentials.passcode" === e.name && (0, g.isCustomizedI18nKey)("primaryauth.password.tooltip", t) && (n = o(o({}, n), {}, {
            explain: (0, s.loc)("primaryauth.password.tooltip", "login"),
            "explain-top": !0
          })), n;
        });
      },
      _addForgotPasswordView: function _addForgotPasswordView() {
        var e = (0, v.getForgotPasswordLink)(this.options.appState, this.options.settings);
        e.length && (this.add('<div class="links-primary"></div>', {
          selector: ".o-form-button-bar"
        }), this.add(f.default, {
          selector: ".links-primary",
          options: e[0]
        }));
      },
      _addIdpView: function _addIdpView(e) {
        var t = this.options.settings.get("idpDisplay"),
            n = t && "PRIMARY" === t.toUpperCase();
        this.add(p.default, {
          prepend: n,
          selector: n ? ".o-form-fieldset-container" : ".o-form-button-bar",
          options: {
            idpButtons: e,
            isPrimaryIdpDisplay: n
          }
        });
      }
    }),
        b = u.BaseView.extend({
      Body: y,
      initialize: function initialize() {
        var e = this;
        this.Footer = d.default.extend({
          showForgotPasswordLink: function showForgotPasswordLink() {
            var t = (0, u.createIdpButtons)(e.options.appState.get("remediations"));
            return !(e.options.appState.isIdentifierOnlyView() || Array.isArray(t) && 0 !== t.length);
          }
        });
      },
      postRender: function postRender() {
        u.BaseView.prototype.postRender.apply(this, arguments);
        var e = this.options.appState;
        this.$el.find(".js-sign-up").click(function () {
          return e.trigger("invokeAction", l.FORMS.SELECT_ENROLL_PROFILE), !1;
        });
      }
    });
    t.default = b;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = n(3),
        s = n(8),
        l = n(68),
        u = r(n(136)),
        c = a.BaseFooter.extend({
      showForgotPasswordLink: function showForgotPasswordLink() {
        return !this.options.appState.isIdentifierOnlyView();
      },
      footerInfo: function footerInfo() {
        var e,
            t = (0, l.getSignUpLink)(this.options.appState, this.options.settings);
        return t.length && (e = i.View.extend({
          className: "signup-info",
          template: o.default.template({
            compiler: [8, ">= 4.3.0"],
            main: function main(e, t, n, r, o) {
              var i = e.lookupProperty || function (e, t) {
                if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
              };

              return "<span>" + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                name: "i18n",
                hash: {
                  bundle: "login",
                  code: "registration.signup.label"
                },
                data: o,
                loc: {
                  start: {
                    line: 1,
                    column: 6
                  },
                  end: {
                    line: 1,
                    column: 62
                  }
                }
              })) + '</span><span class="signup-link"></span>';
            },
            useData: !0
          }),
          initialize: function initialize() {
            this.add(u.default, ".signup-link", {
              options: t[0]
            });
          }
        })), e;
      },
      links: function links() {
        var e,
            t = this.options,
            n = t.appState,
            r = t.settings;
        if (r.get("helpLinks.help")) e = r.get("helpLinks.help");else {
          e = r.get("baseUrl") + "/help/login";
        }
        var o = [{
          name: "help",
          label: (0, i.loc)("help", "login"),
          href: e
        }],
            a = [];
        this.showForgotPasswordLink() && (a = (0, l.getForgotPasswordLink)(n, r));
        var u = [];
        r.get("helpLinks.custom") && r.get("helpLinks.custom").forEach(function (e) {
          e.name = "custom", e.label = e.text, u.push(e);
        });
        var c = [];
        return r.get("helpLinks.unlock") ? c.push({
          type: "link",
          label: (0, i.loc)("unlockaccount", "login"),
          name: "unlock",
          href: r.get("helpLinks.unlock")
        }) : n.hasRemediationObject(s.FORMS.UNLOCK_ACCOUNT) && c.push({
          type: "link",
          label: (0, i.loc)("unlockaccount", "login"),
          name: "unlock",
          actionPath: s.FORMS.UNLOCK_ACCOUNT
        }), a.concat(c).concat(o).concat(u);
      }
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(12)),
        s = r(n(5)),
        l = n(46),
        u = n(8),
        c = i.View.extend({
      className: "sign-in-with-device-option",
      template: o.default.template({
        1: function _(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="signin-with-ov-description">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oktaVerify.description"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 109
              },
              end: {
                line: 1,
                column: 162
              }
            }
          })) + "</div>";
        },
        3: function _(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="separation-line"><span>' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "authbutton.divider.text"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 254
              },
              end: {
                line: 1,
                column: 308
              }
            }
          })) + "</span></div>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="okta-verify-container">' + (null != (i = s(n, "if").call(a, null != t ? s(t, "signInWithDeviceIsRequired") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 35
              },
              end: {
                line: 1,
                column: 175
              }
            }
          })) ? i : "") + "</div>" + (null != (i = s(n, "unless").call(a, null != t ? s(t, "signInWithDeviceIsRequired") : t, {
            name: "unless",
            hash: {},
            fn: e.program(3, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 181
              },
              end: {
                line: 1,
                column: 332
              }
            }
          })) ? i : "");
        },
        useData: !0
      }),
      initialize: function initialize() {
        var e,
            t = this.options.appState,
            n = this.options.appState.hasRemediationObject(u.FORMS.LAUNCH_AUTHENTICATOR),
            r = null === n || void 0 === n ? void 0 : null === (e = n.relatesTo) || void 0 === e ? void 0 : e.value;
        this.add((0, i.createButton)({
          className: "button",
          icon: "okta-verify-authenticator",
          title: (0, i.loc)("oktaVerify.button", "login"),
          click: function click() {
            var e = this,
                n = (null === r || void 0 === r ? void 0 : r.challengeMethod) === s.default.UNIVERSAL_LINK_CHALLENGE;
            n && a.default.redirect(r.href), a.default.callAfterTimeout(function () {
              e.options.isRequired ? t.trigger("saveForm", e.model) : t.trigger("invokeAction", u.FORMS.LAUNCH_AUTHENTICATOR);
            }, n ? l.UNIVERSAL_LINK_POST_DELAY : 0);
          }
        }), ".okta-verify-container");
      },
      getTemplateData: function getTemplateData() {
        return {
          signInWithDeviceIsRequired: !!this.options.isRequired
        };
      }
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(3),
        o = n(8),
        i = n(7),
        a = r.BaseHeader.extend({
      HeaderBeacon: i.BaseAuthenticatorBeacon.extend({
        authenticatorKey: o.AUTHENTICATOR_KEY.EMAIL
      })
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(3),
        o = n(68),
        i = r.BaseFooter.extend({
      links: function links() {
        return (0, o.getSwitchAuthenticatorLink)(this.options.appState);
      }
    });
    t.default = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(3),
        i = n(1),
        a = r(n(371)),
        s = r(n(372)),
        l = n(67),
        u = o.BaseView.extend({
      Header: a.default,
      Body: s.default,
      createModelClass: function createModelClass(e) {
        var t = o.BaseView.prototype.createModelClass.apply(this, arguments),
            n = e.uiSchema,
            r = n[0].scopes,
            a = r.map(function (e) {
          var t = e.name,
              n = e.displayName,
              r = e.description,
              o = "".concat("consent.scopes", ".").concat(t),
              a = "".concat(o, ".label"),
              s = "".concat(o, ".desc"),
              u = (0, l.doesI18NKeyExist)(a),
              c = (0, l.doesI18NKeyExist)(s);
          return {
            name: t,
            displayName: u ? (0, i.loc)(a, "login") : n,
            description: c ? (0, i.loc)(s, "login") : r,
            isCustomized: !u
          };
        });
        return t.extend({
          props: {
            scopes: {
              type: "array",
              value: a
            }
          },
          local: {
            consent: {
              type: "boolean",
              value: !1
            }
          },
          toJSON: function toJSON() {
            return {
              consent: this.get("consent")
            };
          }
        });
      }
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = a.View.extend({
      className: "consent-title detail-row",
      titleText: function titleText() {
        return (0, a.loc)("oie.consent.admin.title", "login");
      },
      hasIssuer: !0,
      template: i.default.template({
        1: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="' + e.escapeExpression((i = null != (i = a(n, "clientURI") || (null != t ? a(t, "clientURI") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "clientURI",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 26
              },
              end: {
                line: 1,
                column: 39
              }
            }
          }) : i)) + '" class="client-logo-link" target="_blank">';
        },
        3: function _(e, t, n, r, i) {
          var a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<img class="client-logo custom-logo" src="' + u((a = null != (a = c(n, "customLogo") || (null != t ? c(t, "customLogo") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "customLogo",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 149
              },
              end: {
                line: 1,
                column: 163
              }
            }
          }) : a)) + '" alt="' + u((a = null != (a = c(n, "altText") || (null != t ? c(t, "altText") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "altText",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 170
              },
              end: {
                line: 1,
                column: 181
              }
            }
          }) : a)) + '" aria-hidden="true" />';
        },
        5: function _(e, t, n, r, i) {
          var a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<img class="client-logo default-logo" src="' + u((a = null != (a = c(n, "defaultLogo") || (null != t ? c(t, "defaultLogo") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "defaultLogo",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 255
              },
              end: {
                line: 1,
                column: 270
              }
            }
          }) : a)) + '" alt="' + u((a = null != (a = c(n, "altText") || (null != t ? c(t, "altText") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "altText",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 277
              },
              end: {
                line: 1,
                column: 288
              }
            }
          }) : a)) + '" aria-hidden="true" />';
        },
        7: function _(e, t, n, r, o) {
          return "</a>";
        },
        9: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="issuer no-translate"><span>' + e.escapeExpression((i = null != (i = a(n, "issuer") || (null != t ? a(t, "issuer") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "issuer",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 493
              },
              end: {
                line: 1,
                column: 503
              }
            }
          }) : i)) + "</span></div>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s,
              l = null != t ? t : e.nullContext || {},
              u = e.hooks.helperMissing,
              c = e.escapeExpression,
              d = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return (null != (a = d(n, "if").call(l, null != t ? d(t, "clientURI") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 89
              }
            }
          })) ? a : "") + (null != (a = d(n, "if").call(l, null != t ? d(t, "customLogo") : t, {
            name: "if",
            hash: {},
            fn: e.program(3, i, 0),
            inverse: e.program(5, i, 0),
            data: i,
            loc: {
              start: {
                line: 1,
                column: 89
              },
              end: {
                line: 1,
                column: 318
              }
            }
          })) ? a : "") + (null != (a = d(n, "if").call(l, null != t ? d(t, "clientURI") : t, {
            name: "if",
            hash: {},
            fn: e.program(7, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 318
              },
              end: {
                line: 1,
                column: 346
              }
            }
          })) ? a : "") + '<h1><span class="title-text"><b class="no-translate">' + c((s = null != (s = d(n, "appName") || (null != t ? d(t, "appName") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "appName",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 399
              },
              end: {
                line: 1,
                column: 410
              }
            }
          }) : s)) + "</b>&nbsp;" + c((s = null != (s = d(n, "titleText") || (null != t ? d(t, "titleText") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "titleText",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 420
              },
              end: {
                line: 1,
                column: 433
              }
            }
          }) : s)) + "</span>" + (null != (a = d(n, "if").call(l, null != t ? d(t, "issuer") : t, {
            name: "if",
            hash: {},
            fn: e.program(9, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 440
              },
              end: {
                line: 1,
                column: 523
              }
            }
          })) ? a : "") + "</h1>";
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        var e = this.options.appState,
            t = e.get("app"),
            n = t.label,
            r = t.clientUri,
            o = t.logo,
            i = e.get("authentication"),
            s = i.issuer,
            l = null === o || void 0 === o ? void 0 : o.href,
            u = (0, a.loc)("logo.for.the.app.alt.text", "login"),
            c = a._.escape(n);

        return {
          customLogo: l,
          defaultLogo: "/img/logos/default.png",
          clientURI: null === r || void 0 === r ? void 0 : r.href,
          issuer: this.hasIssuer ? null === s || void 0 === s ? void 0 : s.uri : null,
          altText: u,
          appName: c,
          titleText: this.titleText()
        };
      }
    }),
        l = s;
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = n(3),
        i = o.BaseForm.extend({
      noButtonBar: !1,
      noCancelButton: !1,
      buttonOrder: ["cancel", "save"],
      save: function save() {
        return (0, r.loc)("consent.required.consentButton", "login");
      },
      cancel: function cancel() {
        return (0, r.loc)("consent.required.cancelButton", "login");
      },
      title: !1,
      events: {
        'click input[data-type="save"]': function clickInputDataTypeSave() {
          this.setConsent(!0);
        }
      },
      setConsent: function setConsent(e) {
        this.model.set("consent", e);
      },
      cancelForm: function cancelForm() {
        this.setConsent(!1), this.options.appState.trigger("saveForm", this.model);
      }
    });
    t.default = i;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = e.getDeviceChallengePayload();

      switch (t.challengeMethod) {
        case s.default.LOOPBACK_CHALLENGE:
          e.title = (0, a.loc)("deviceTrust.sso.redirectText", "login"), e.add(a.View.extend({
            className: "loopback-content",
            template: i.default.template({
              compiler: [8, ">= 4.3.0"],
              main: function main(e, t, n, r, o) {
                return '<div class="spinner"></div>';
              },
              useData: !0
            })
          })), e.doLoopback(t);
          break;

        case s.default.CUSTOM_URI_CHALLENGE:
          e.title = (0, a.loc)("customUri.title", "login"), e.add(a.View.extend({
            className: "skinny-content",
            template: i.default.template({
              compiler: [8, ">= 4.3.0"],
              main: function main(e, t, n, r, o) {
                var i = e.lookupProperty || function (e, t) {
                  if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                };

                return "<p>" + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                  name: "i18n",
                  hash: {
                    bundle: "login",
                    code: "customUri.required.content.prompt"
                  },
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 3
                    },
                    end: {
                      line: 1,
                      column: 67
                    }
                  }
                })) + "</p>";
              },
              useData: !0
            })
          })), e.add((0, a.createButton)({
            className: "ul-button button button-wide button-primary",
            title: (0, a.loc)("customUri.required.content.button", "login"),
            id: "launch-ov",
            click: function click() {
              e.doCustomURI();
            }
          })), e.add(a.View.extend({
            className: "skinny-content",
            template: i.default.template({
              compiler: [8, ">= 4.3.0"],
              main: function main(e, t, n, r, o) {
                var i,
                    a = null != t ? t : e.nullContext || {},
                    s = e.hooks.helperMissing,
                    l = e.escapeExpression,
                    u = e.lookupProperty || function (e, t) {
                  if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                };

                return "<p>" + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
                  name: "i18n",
                  hash: {
                    bundle: "login",
                    code: "customUri.required.content.download.title"
                  },
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 3
                    },
                    end: {
                      line: 1,
                      column: 75
                    }
                  }
                })) + '</p><p><a href="' + l((i = null != (i = u(n, "downloadOVLink") || (null != t ? u(t, "downloadOVLink") : t)) ? i : s, "function" == typeof i ? i.call(a, {
                  name: "downloadOVLink",
                  hash: {},
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 91
                    },
                    end: {
                      line: 1,
                      column: 109
                    }
                  }
                }) : i)) + '" target="_blank" id="download-ov" class="link">' + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
                  name: "i18n",
                  hash: {
                    bundle: "login",
                    code: "customUri.required.content.download.linkText"
                  },
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 157
                    },
                    end: {
                      line: 1,
                      column: 232
                    }
                  }
                })) + "</a></p>";
              },
              useData: !0
            }),
            getTemplateData: function getTemplateData() {
              return {
                downloadOVLink: t.downloadHref
              };
            }
          })), e.customURI = t.href, e.doCustomURI();
          break;

        case s.default.UNIVERSAL_LINK_CHALLENGE:
          e.title = (0, a.loc)("universalLink.title", "login"), e.add(a.View.extend({
            className: "universal-link-content",
            template: i.default.template({
              compiler: [8, ">= 4.3.0"],
              main: function main(e, t, n, r, o) {
                var i,
                    a = e.lookupProperty || function (e, t) {
                  if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                };

                return '<div class="spinner"></div>' + (null != (i = (a(n, "i18n") || t && a(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                  name: "i18n",
                  hash: {
                    bundle: "login",
                    code: "universalLink.content"
                  },
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 27
                    },
                    end: {
                      line: 1,
                      column: 81
                    }
                  }
                })) ? i : "");
              },
              useData: !0
            })
          })), e.add((0, a.createButton)({
            className: "ul-button button button-wide button-primary",
            title: (0, a.loc)("oktaVerify.reopen.button", "login"),
            click: function click() {
              l.default.redirect(t.href);
            }
          }));
      }
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.doChallenge = r;
    var i = o(n(2)),
        a = n(1),
        s = o(n(5)),
        l = o(n(12));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(3),
        o = n(8),
        i = n(7),
        a = r.BaseHeader.extend({
      HeaderBeacon: i.BaseAuthenticatorBeacon.extend({
        authenticatorKey: o.AUTHENTICATOR_KEY.OV
      })
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.Body = void 0;
    var r = n(3),
        o = n(1),
        i = r.BaseForm.extend({
      title: function title() {
        return this.isPasswordRecoveryFlow() ? (0, o.loc)("password.reset.title.generic", "login") : (0, o.loc)("oie.select.authenticators.verify.title", "login");
      },
      subtitle: function subtitle() {
        return this.isPasswordRecoveryFlow() ? (0, o.loc)("oie.password.reset.verification", "login") : (0, o.loc)("oie.select.authenticators.verify.subtitle", "login");
      },
      isPasswordRecoveryFlow: function isPasswordRecoveryFlow() {
        return this.options.appState.get("isPasswordRecovery");
      },
      noButtonBar: !0
    });
    t.Body = i;
    var a = r.BaseView.extend({
      Body: i
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ResendView = t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = n(46),
        l = o.View.extend({
      className: "phone-authenticator-challenge__resend-warning hide",
      events: {
        "click a.resend-link": "handleResendLink"
      },
      resendActionKey: "currentAuthenticatorEnrollment-resend",
      initialize: function initialize() {
        var e = "sms" === this.model.get("mode") ? (0, o.loc)("oie.phone.verify.sms.resendText", "login") : (0, o.loc)("oie.phone.verify.call.resendText", "login"),
            t = "sms" === this.model.get("mode") ? (0, o.loc)("oie.phone.verify.sms.resendLinkText", "login") : (0, o.loc)("oie.phone.verify.call.resendLinkText", "login");
        this.add((0, o.createCallout)({
          content: "".concat(e, "&nbsp;<a class='resend-link'>").concat(t, "</a>"),
          type: "warning"
        }));
      },
      handleResendLink: function handleResendLink() {
        this.options.appState.trigger("invokeAction", this.resendActionKey), this.el.classList.contains("hide") || this.el.classList.add("hide"), this.showCalloutAfterTimeout();
      },
      postRender: function postRender() {
        this.showCalloutAfterTimeout();
      },
      showCalloutAfterTimeout: function showCalloutAfterTimeout() {
        var e = this;
        this.showCalloutTimer = setTimeout(function () {
          e.el.classList.remove("hide");
        }, s.SHOW_RESEND_TIMEOUT);
      },
      remove: function remove() {
        o.View.prototype.remove.apply(this, arguments), clearTimeout(this.showCalloutTimer);
      }
    });
    t.ResendView = l;
    var u = i.BaseForm.extend(Object.assign({
      className: "phone-authenticator-challenge",
      title: function title() {
        return (0, o.loc)("oie.phone.verify.title", "login");
      },
      save: function save() {
        return (0, o.loc)("mfa.challenge.verify", "login");
      },
      initialize: function initialize() {
        i.BaseForm.prototype.initialize.apply(this, arguments);
        var e = "sms" === this.model.get("mode") ? (0, o.loc)("oie.phone.verify.sms.codeSentText", "login") : (0, o.loc)("mfa.calling", "login"),
            t = (0, o.loc)("oie.phone.verify.enterCodeText", "login"),
            n = (0, o.loc)("oie.phone.carrier.charges", "login"),
            r = this.model.get("phoneNumber") !== (0, o.loc)("oie.phone.alternate.title", "login") ? "strong no-translate" : "";
        this.add('<div class="okta-form-subtitle" data-se="o-form-explain">\n        '.concat(e, "&nbsp;<span class='").concat(r, "'>").concat(this.model.escape("phoneNumber"), ".</span>\n        &nbsp;").concat(t, "\n        <p>").concat(n, "</p>\n        </div>"), {
          prepend: !0,
          selector: ".o-form-fieldset-container"
        });
      },
      postRender: function postRender() {
        i.BaseForm.prototype.postRender.apply(this, arguments), this.add(l, {
          selector: ".o-form-error-container",
          prepend: !0
        });
      }
    })),
        c = a.default.extend({
      Body: u,
      createModelClass: function createModelClass() {
        var e = this.options.currentViewState.relatesTo,
            t = (null === e || void 0 === e ? void 0 : e.value) || {},
            n = t.methods,
            r = t.profile,
            a = i.BaseView.prototype.createModelClass.apply(this, arguments),
            s = Object.assign({
          mode: {
            value: n[0].type,
            type: "string"
          },
          phoneNumber: {
            value: (null === r || void 0 === r ? void 0 : r.phoneNumber) ? r.phoneNumber : (0, o.loc)("oie.phone.alternate.title", "login"),
            type: "string"
          }
        }, a.prototype.local);
        return a.extend({
          local: s
        });
      }
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(815)),
        s = r(n(7)),
        l = n(46),
        u = r(n(362)),
        c = o.View.extend({
      className: "hide resend-email-view",
      events: {
        "click a.resend-link": "handelResendLink"
      },
      initialize: function initialize() {
        this.add((0, o.createCallout)({
          content: "".concat((0, o.loc)("email.code.not.received", "login"), "\n        <a class='resend-link'>").concat((0, o.loc)("email.button.resend", "login"), "</a>"),
          type: "warning"
        }));
      },
      handelResendLink: function handelResendLink() {
        this.options.appState.trigger("invokeAction", this.options.resendEmailAction), this.$el.hasClass("hide") || this.$el.addClass("hide"), this.showCalloutWithDelay();
      },
      postRender: function postRender() {
        this.showCalloutWithDelay();
      },
      showCalloutWithDelay: function showCalloutWithDelay() {
        var e = this;
        this.showMeTimeout = o._.delay(function () {
          e.$el.removeClass("hide");
        }, l.SHOW_RESEND_TIMEOUT);
      },
      remove: function remove() {
        o.View.prototype.remove.apply(this, arguments), clearTimeout(this.showMeTimeout);
      }
    }),
        d = u.default.extend(Object.assign({
      save: function save() {
        return (0, o.loc)("mfa.challenge.verify", "login");
      },
      initialize: function initialize() {
        u.default.prototype.initialize.apply(this, arguments), this.add(c, {
          selector: ".o-form-error-container",
          options: {
            resendEmailAction: this.resendEmailAction
          }
        }), this.startPolling();
      },
      saveForm: function saveForm() {
        i.BaseForm.prototype.saveForm.apply(this, arguments), this.stopPolling();
      },
      remove: function remove() {
        i.BaseForm.prototype.remove.apply(this, arguments), this.stopPolling();
      },
      triggerAfterError: function triggerAfterError(e, t) {
        var n,
            r,
            o = this;
        i.BaseForm.prototype.triggerAfterError.apply(this, arguments), this.stopPolling(), (null === (n = t.responseJSON) || void 0 === n ? void 0 : null === (r = n.errorSummaryKeys) || void 0 === r ? void 0 : r.includes("idx.session.expired")) || (this.isPollingRateLimitError(t) ? (setTimeout(function () {
          e.trigger("clearFormError");
        }, 0), setTimeout(function () {
          o.startPolling(o.options.appState.get("dynamicRefreshInterval"));
        }, 6e4)) : this.startPolling(this.options.appState.get("dynamicRefreshInterval")));
      },
      isPollingRateLimitError: function isPollingRateLimitError(e) {
        var t, n, r, o;
        return ((null === (t = e.responseJSON) || void 0 === t ? void 0 : null === (n = t.errorSummaryKeys) || void 0 === n ? void 0 : n.includes("tooManyRequests")) || "E0000047" === (null === (r = e.responseJSON) || void 0 === r ? void 0 : r.errorCode)) && !(null === (o = e.responseJSON) || void 0 === o ? void 0 : o.errorIntent);
      }
    }, a.default)),
        f = s.default.extend({
      Body: d
    });
    t.default = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = n(8),
        s = i.View.extend({
      className: "switch-channel-text",
      template: o.default.template({
        1: function _(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="switch-channel-link">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "enroll.totp.cannotScan"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 63
              },
              end: {
                line: 1,
                column: 116
              }
            }
          })) + "</a>";
        },
        3: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return null != (i = (a(n, "i18n") || t && a(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oie.enroll.okta_verify.switch.channel.link.text"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 128
              },
              end: {
                line: 1,
                column: 208
              }
            }
          })) ? i : "";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return null != (i = a(n, "if").call(null != t ? t : e.nullContext || {}, null != t ? a(t, "isQRcodeChannel") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.program(3, o, 0),
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 215
              }
            }
          })) ? i : "";
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        return {
          isQRcodeChannel: "qrcode" === this.options.appState.get("currentAuthenticator").contextualData.selectedChannel
        };
      },
      postRender: function postRender() {
        var e = this;
        this.$el.find(".switch-channel-link").on("click", function (t) {
          var n = e.options.appState;
          t.preventDefault(), n.trigger("switchForm", a.FORMS.SELECT_ENROLLMENT_CHANNEL);
        });
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(157)),
        a = n(3),
        s = a.BaseForm.extend({
      noButtonBar: !0,
      postRender: function postRender() {
        var e = this,
            t = this.getContextualData(),
            n = this.add('<iframe frameborder="0" title="\''.concat(this.title(), "'\"></iframe>")).last();

        try {
          i.default.init({
            host: t.host,
            sig_request: t.signedToken,
            iframe: n.el,
            post_action: function post_action(t) {
              e.model.set("credentials.signatureData", t), e.saveForm(e.model);
            }
          });
        } catch (e) {
          n.remove(), this.add((0, o.createCallout)({
            type: "error",
            subtitle: (0, o.loc)("oie.duo.iFrameError", "login")
          }), ".o-form-error-container");
        }
      },
      getContextualData: function getContextualData() {}
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = n(3),
        i = o.BaseForm.extend({
      initialize: function initialize() {
        o.BaseForm.prototype.initialize.apply(this, arguments), this.model.set("useRedirect", !0);
      },
      showMessages: function showMessages() {
        var e = this,
            t = this.options.appState.get("messages") || {};
        Array.isArray(t.value) && (this.add('<div class="ion-messages-container”></div>', ".o-form-error-container"), t.value.forEach(function (t) {
          var n = t.message;
          "ERROR" === t.class ? e.add((0, r.createCallout)({
            content: n,
            type: "error"
          }), ".o-form-error-container") : e.add("<p>".concat(n, "</p>"), ".ion-messages-container");
        }));
      }
    });
    t.default = i;
  }, function (e, t, n) {
    e.exports = n(382);
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        o = r(n(110)),
        i = r(n(24)),
        a = r(n(12)),
        s = r(n(474)),
        l = r(n(475)),
        u = r(n(476)),
        c = r(n(477)),
        d = r(n(576)),
        f = function () {
      function e(e, t) {
        function r(r, o, i) {
          if (n) throw new Error("An instance of the widget has already been rendered. Call remove() first.");
          var a = (0, u.default)(t, p, r, e, o, i);
          return n = a.router, a.promise;
        }

        function o() {
          n && n.hide();
        }

        function a() {
          n && n.show();
        }

        function s() {
          n && (n.remove(), n = void 0);
        }

        function c() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = Object.assign((0, l.default)(p, e), {
            redirect: "never"
          }),
              r = this.renderEl(t).then(function (e) {
            return e.tokens;
          }),
              o = n.settings.getAuthClient();
          if (o.isAuthorizationCodeFlow() && !o.isPKCE()) throw new i.default.ConfigError('"showSignInToGetTokens()" should not be used for authorization_code flow. Use "showSignInAndRedirect()" instead');
          return r;
        }

        function d() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = Object.assign((0, l.default)(p, e), {
            redirect: "always"
          });
          return this.renderEl(t);
        }

        function f() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = Object.assign((0, l.default)(p, e));
          return this.renderEl(t);
        }

        var p = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return {
          renderEl: r,
          authClient: e,
          showSignIn: f,
          showSignInToGetTokens: c,
          showSignInAndRedirect: d,
          hide: o,
          show: a,
          remove: s
        };
      }

      function t(t) {
        a.default.debugMessage("\n        The Okta Sign-In Widget is running in development mode.\n        When you are ready to publish your app, embed the minified version to turn on production mode.\n        See: https://developer.okta.com/code/javascript/okta_sign-in_widget#cdn\n      ");
        var n = o.default.extend({
          clientId: t.clientId,
          redirectUri: t.redirectUri,
          state: t.state,
          scopes: t.scopes
        }, t.authParams);
        n.issuer || (n.issuer = t.baseUrl + "/oauth2/default");
        var r = t.authClient ? t.authClient : (0, s.default)(n),
            l = t.useInteractionCodeFlow || t.interactionHandle;
        if (l && !1 === r.isPKCE()) throw new i.default.ConfigError('The "useInteractionCodeFlow" option requires PKCE to be enabled on the authClient.');
        var u;
        u = t.stateToken && !a.default.isV1StateToken(t.stateToken) || l || t.proxyIdxResponse ? d.default : c.default, o.default.extend(this, u.prototype.Events), o.default.extend(this, e(r, u, t)), this.listenTo(u.prototype, "all", this.trigger), this.once("afterRender", function (e) {
          this.trigger("ready", e);
        });
      }

      var n;
      return t;
    }();

    e.exports = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(139),
        o = Object(r.mixin)(r);
    o._ = o, t.a = o;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return null === e;
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return !(!e || 1 !== e.nodeType);
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    var r = n(23);
    t.a = Object(r.a)("Date");
  }, function (e, t, n) {
    "use strict";

    var r = n(23);
    t.a = Object(r.a)("RegExp");
  }, function (e, t, n) {
    "use strict";

    var r = n(23);
    t.a = Object(r.a)("Error");
  }, function (e, t, n) {
    "use strict";

    var r = n(23);
    t.a = Object(r.a)("Object");
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return !Object(i.a)(e) && Object(o.f)(e) && !isNaN(parseFloat(e));
    }

    t.a = r;
    var o = n(11),
        i = n(200);
  }, function (e, t, n) {
    "use strict";

    var r = n(205),
        o = n(143);
    t.a = Object(r.a)(o.a);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      if (null == e) return !0;
      var t = Object(o.a)(e);
      return "number" == typeof t && (Object(i.a)(e) || Object(a.a)(e) || Object(s.a)(e)) ? 0 === t : 0 === Object(o.a)(Object(l.a)(e));
    }

    t.a = r;
    var o = n(33),
        i = n(54),
        a = n(140),
        s = n(142),
        l = n(22);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n, r) {
      if (e === t) return 0 !== e || 1 / e == 1 / t;
      if (null == e || null == t) return !1;
      if (e !== e) return t !== t;
      var i = typeof e;
      return ("function" === i || "object" === i || "object" == typeof t) && o(e, t, n, r);
    }

    function o(e, t, n, i) {
      e instanceof a.a && (e = e._wrapped), t instanceof a.a && (t = t._wrapped);
      var v = s.t.call(e);
      if (v !== s.t.call(t)) return !1;

      if (d.a && "[object Object]" == v && Object(f.a)(e)) {
        if (!Object(f.a)(t)) return !1;
        v = g;
      }

      switch (v) {
        case "[object RegExp]":
        case "[object String]":
          return "" + e == "" + t;

        case "[object Number]":
          return +e != +e ? +t != +t : 0 == +e ? 1 / +e == 1 / t : +e == +t;

        case "[object Date]":
        case "[object Boolean]":
          return +e == +t;

        case "[object Symbol]":
          return s.d.valueOf.call(e) === s.d.valueOf.call(t);

        case "[object ArrayBuffer]":
        case g:
          return o(Object(m.a)(e), Object(m.a)(t), n, i);
      }

      var y = "[object Array]" === v;

      if (!y && Object(u.a)(e)) {
        if (Object(l.a)(e) !== Object(l.a)(t)) return !1;
        if (e.buffer === t.buffer && e.byteOffset === t.byteOffset) return !0;
        y = !0;
      }

      if (!y) {
        if ("object" != typeof e || "object" != typeof t) return !1;
        var b = e.constructor,
            _ = t.constructor;
        if (b !== _ && !(Object(c.a)(b) && b instanceof b && Object(c.a)(_) && _ instanceof _) && "constructor" in e && "constructor" in t) return !1;
      }

      n = n || [], i = i || [];

      for (var w = n.length; w--;) {
        if (n[w] === e) return i[w] === t;
      }

      if (n.push(e), i.push(t), y) {
        if ((w = e.length) !== t.length) return !1;

        for (; w--;) {
          if (!r(e[w], t[w], n, i)) return !1;
        }
      } else {
        var E,
            O = Object(p.a)(e);
        if (w = O.length, Object(p.a)(t).length !== w) return !1;

        for (; w--;) {
          if (E = O[w], !Object(h.a)(t, E) || !r(e[E], t[E], n, i)) return !1;
        }
      }

      return n.pop(), i.pop(), !0;
    }

    function i(e, t) {
      return r(e, t);
    }

    t.a = i;
    var a = n(29),
        s = n(11),
        l = n(143),
        u = n(203),
        c = n(32),
        d = n(87),
        f = n(141),
        p = n(22),
        h = n(50),
        m = n(394),
        g = "[object DataView]";
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return new Uint8Array(e.buffer || e, e.byteOffset || 0, Object(o.a)(e));
    }

    t.a = r;
    var o = n(143);
  }, function (e, t, n) {
    "use strict";

    var r = n(23),
        o = n(87),
        i = n(144);
    t.a = o.b ? Object(i.a)(i.b) : Object(r.a)("Map");
  }, function (e, t, n) {
    "use strict";

    var r = n(23),
        o = n(87),
        i = n(144);
    t.a = o.b ? Object(i.a)(i.d) : Object(r.a)("WeakMap");
  }, function (e, t, n) {
    "use strict";

    var r = n(23),
        o = n(87),
        i = n(144);
    t.a = o.b ? Object(i.a)(i.c) : Object(r.a)("Set");
  }, function (e, t, n) {
    "use strict";

    var r = n(23);
    t.a = Object(r.a)("WeakSet");
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var t = Object(o.a)(e), n = t.length, r = Array(n), i = 0; i < n; i++) {
        r[i] = [t[i], e[t[i]]];
      }

      return r;
    }

    t.a = r;
    var o = n(22);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = Object(o.a)(e);
      return t && Object(i.a)(n, t), n;
    }

    t.a = r;
    var o = n(213),
        i = n(146);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return t(e), e;
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      t = Object(i.a)(t);

      for (var n = t.length, r = 0; r < n; r++) {
        var a = t[r];
        if (!Object(o.a)(e, a)) return !1;
        e = e[a];
      }

      return !!n;
    }

    t.a = r;
    var o = n(50),
        i = n(89);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      t = Object(o.a)(t, n);

      for (var r = Object(i.a)(e), a = r.length, s = {}, l = 0; l < a; l++) {
        var u = r[l];
        s[u] = t(e[u], u, e);
      }

      return s;
    }

    t.a = r;
    var o = n(27),
        i = n(22);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return null == e ? o.a : function (t) {
        return Object(i.a)(e, t);
      };
    }

    t.a = r;
    var o = n(219),
        i = n(215);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      var r = Array(Math.max(0, e));
      t = Object(o.a)(t, n, 1);

      for (var i = 0; i < e; i++) {
        r[i] = t(i);
      }

      return r;
    }

    t.a = r;
    var o = n(90);
  }, function (e, t, n) {
    "use strict";

    var r = n(221),
        o = n(222);
    t.a = Object(r.a)(o.a);
  }, function (e, t, n) {
    "use strict";

    var r = n(221),
        o = n(408);
    t.a = Object(r.a)(o.a);
  }, function (e, t, n) {
    "use strict";

    var r = n(209),
        o = n(222);
    t.a = Object(r.a)(o.a);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return "\\" + l[e];
    }

    function o(e, t, n) {
      !t && n && (t = n), t = Object(i.a)({}, t, a.a.templateSettings);
      var o = RegExp([(t.escape || s).source, (t.interpolate || s).source, (t.evaluate || s).source].join("|") + "|$", "g"),
          l = 0,
          d = "__p+='";
      e.replace(o, function (t, n, o, i, a) {
        return d += e.slice(l, a).replace(u, r), l = a + t.length, n ? d += "'+\n((__t=(" + n + "))==null?'':_.escape(__t))+\n'" : o ? d += "'+\n((__t=(" + o + "))==null?'':__t)+\n'" : i && (d += "';\n" + i + "\n__p+='"), t;
      }), d += "';\n";
      var f = t.variable;

      if (f) {
        if (!c.test(f)) throw new Error("variable is not a bare identifier: " + f);
      } else d = "with(obj||{}){\n" + d + "}\n", f = "obj";

      d = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + d + "return __p;\n";
      var p;

      try {
        p = new Function(f, "_", d);
      } catch (e) {
        throw e.source = d, e;
      }

      var h = function h(e) {
        return p.call(this, e, a.a);
      };

      return h.source = "function(" + f + "){\n" + d + "}", h;
    }

    t.a = o;
    var i = n(212),
        a = n(29),
        s = (n(223), /(.)^/),
        l = {
      "'": "'",
      "\\": "\\",
      "\r": "r",
      "\n": "n",
      "\u2028": "u2028",
      "\u2029": "u2029"
    },
        u = /\\|'|\r|\n|\u2028|\u2029/g,
        c = /^\s*(\w|\$)+\s*$/;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      t = Object(i.a)(t);
      var r = t.length;
      if (!r) return Object(o.a)(n) ? n.call(e) : n;

      for (var a = 0; a < r; a++) {
        var s = null == e ? void 0 : e[t[a]];
        void 0 === s && (s = n, a = r), e = Object(o.a)(s) ? s.call(e) : s;
      }

      return e;
    }

    t.a = r;
    var o = n(32),
        i = n(89);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = ++o + "";
      return e ? e + t : t;
    }

    t.a = r;
    var o = 0;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = Object(o.a)(e);
      return t._chain = !0, t;
    }

    t.a = r;
    var o = n(29);
  }, function (e, t, n) {
    "use strict";

    var r = n(28),
        o = n(70),
        i = n(225);
    t.a = Object(r.a)(function (e, t) {
      t = Object(o.a)(t, !1, !1);
      var n = t.length;
      if (n < 1) throw new Error("bindAll must be passed function names");

      for (; n--;) {
        var r = t[n];
        e[r] = Object(i.a)(e[r], e);
      }

      return e;
    });
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = function n(r) {
        var i = n.cache,
            a = "" + (t ? t.apply(this, arguments) : r);
        return Object(o.a)(i, a) || (i[a] = e.apply(this, arguments)), i[a];
      };

      return n.cache = {}, n;
    }

    t.a = r;
    var o = n(50);
  }, function (e, t, n) {
    "use strict";

    var r = n(112),
        o = n(226),
        i = n(29);
    t.a = Object(r.a)(o.a, i.a, 1);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      var r,
          i,
          a,
          s,
          l = 0;
      n || (n = {});

      var u = function u() {
        l = !1 === n.leading ? 0 : Object(o.a)(), r = null, s = e.apply(i, a), r || (i = a = null);
      },
          c = function c() {
        var c = Object(o.a)();
        l || !1 !== n.leading || (l = c);
        var d = t - (c - l);
        return i = this, a = arguments, d <= 0 || d > t ? (r && (clearTimeout(r), r = null), l = c, s = e.apply(i, a), r || (i = a = null)) : r || !1 === n.trailing || (r = setTimeout(u, d)), s;
      };

      return c.cancel = function () {
        clearTimeout(r), l = 0, r = i = a = null;
      }, c;
    }

    t.a = r;
    var o = n(150);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      var r,
          a,
          s,
          l,
          u,
          c = function c() {
        var o = Object(i.a)() - a;
        t > o ? r = setTimeout(c, t - o) : (r = null, n || (l = e.apply(u, s)), r || (s = u = null));
      },
          d = Object(o.a)(function (o) {
        return u = this, s = o, a = Object(i.a)(), r || (r = setTimeout(c, t), n && (l = e.apply(u, s))), l;
      });

      return d.cancel = function () {
        clearTimeout(r), r = s = u = null;
      }, d;
    }

    t.a = r;
    var o = n(28),
        i = n(150);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return Object(o.a)(t, e);
    }

    t.a = r;
    var o = n(112);
  }, function (e, t, n) {
    "use strict";

    function r() {
      var e = arguments,
          t = e.length - 1;
      return function () {
        for (var n = t, r = e[t].apply(this, arguments); n--;) {
          r = e[n].call(this, r);
        }

        return r;
      };
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return function () {
        if (--e < 1) return t.apply(this, arguments);
      };
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    var r = n(112),
        o = n(227);
    t.a = Object(r.a)(o.a, 2);
  }, function (e, t, n) {
    "use strict";

    var r = n(230),
        o = n(233);
    t.a = Object(o.a)(-1, r.a);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return Object(o.a)(e, Object(i.a)(t));
    }

    t.a = r;
    var o = n(234),
        i = n(111);
  }, function (e, t, n) {
    "use strict";

    var r = n(235);
    t.a = Object(r.a)(1);
  }, function (e, t, n) {
    "use strict";

    var r = n(235);
    t.a = Object(r.a)(-1);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      return Object(o.a)(e, Object(i.a)(Object(a.a)(t)), n);
    }

    t.a = r;
    var o = n(91),
        i = n(151),
        a = n(27);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      t = Object(o.a)(t, n);

      for (var r = !Object(i.a)(e) && Object(a.a)(e), s = (r || e).length, l = 0; l < s; l++) {
        var u = r ? r[l] : l;
        if (!t(e[u], u, e)) return !1;
      }

      return !0;
    }

    t.a = r;
    var o = n(27),
        i = n(30),
        a = n(22);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      t = Object(o.a)(t, n);

      for (var r = !Object(i.a)(e) && Object(a.a)(e), s = (r || e).length, l = 0; l < s; l++) {
        var u = r ? r[l] : l;
        if (t(e[u], u, e)) return !0;
      }

      return !1;
    }

    t.a = r;
    var o = n(27),
        i = n(30),
        a = n(22);
  }, function (e, t, n) {
    "use strict";

    var r = n(28),
        o = n(32),
        i = n(71),
        a = n(147),
        s = n(89);
    t.a = Object(r.a)(function (e, t, n) {
      var r, l;
      return Object(o.a)(t) ? l = t : (t = Object(s.a)(t), r = t.slice(0, -1), t = t[t.length - 1]), Object(i.a)(e, function (e) {
        var o = l;

        if (!o) {
          if (r && r.length && (e = Object(a.a)(e, r)), null == e) return;
          o = e[t];
        }

        return null == o ? o : o.apply(e, n);
      });
    });
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return Object(o.a)(e, Object(i.a)(t));
    }

    t.a = r;
    var o = n(91),
        i = n(111);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      var r,
          l,
          u = 1 / 0,
          c = 1 / 0;

      if (null == t || "number" == typeof t && "object" != typeof e[0] && null != e) {
        e = Object(o.a)(e) ? e : Object(i.a)(e);

        for (var d = 0, f = e.length; d < f; d++) {
          null != (r = e[d]) && r < u && (u = r);
        }
      } else t = Object(a.a)(t, n), Object(s.a)(e, function (e, n, r) {
        ((l = t(e, n, r)) < c || l === 1 / 0 && u === 1 / 0) && (u = e, c = l);
      });

      return u;
    }

    t.a = r;
    var o = n(30),
        i = n(69),
        a = n(27),
        s = n(55);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return Object(o.a)(e, 1 / 0);
    }

    t.a = r;
    var o = n(237);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      var r = 0;
      return t = Object(o.a)(t, n), Object(i.a)(Object(a.a)(e, function (e, n, o) {
        return {
          value: e,
          index: r++,
          criteria: t(e, n, o)
        };
      }).sort(function (e, t) {
        var n = e.criteria,
            r = t.criteria;

        if (n !== r) {
          if (n > r || void 0 === n) return 1;
          if (n < r || void 0 === r) return -1;
        }

        return e.index - t.index;
      }), "value");
    }

    t.a = r;
    var o = n(27),
        i = n(153),
        a = n(71);
  }, function (e, t, n) {
    "use strict";

    var r = n(113),
        o = n(50);
    t.a = Object(r.a)(function (e, t, n) {
      Object(o.a)(e, n) ? e[n].push(t) : e[n] = [t];
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(113);
    t.a = Object(r.a)(function (e, t, n) {
      e[n] = t;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(113),
        o = n(50);
    t.a = Object(r.a)(function (e, t, n) {
      Object(o.a)(e, n) ? e[n]++ : e[n] = 1;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(113);
    t.a = Object(r.a)(function (e, t, n) {
      e[n ? 0 : 1].push(t);
    }, !0);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e ? Object(o.a)(e) ? i.q.call(e) : Object(a.a)(e) ? e.match(d) : Object(s.a)(e) ? Object(l.a)(e, u.a) : Object(c.a)(e) : [];
    }

    t.a = r;
    var o = n(54),
        i = n(11),
        a = n(140),
        s = n(30),
        l = n(71),
        u = n(148),
        c = n(69),
        d = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return null == e ? 0 : Object(o.a)(e) ? e.length : Object(i.a)(e).length;
    }

    t.a = r;
    var o = n(30),
        i = n(22);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      return t in n;
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    var r = n(28),
        o = n(32),
        i = n(151),
        a = n(71),
        s = n(70),
        l = n(92),
        u = n(238);
    t.a = Object(r.a)(function (e, t) {
      var n,
          r = t[0];
      return Object(o.a)(r) ? (r = Object(i.a)(r), t.length > 1 && (n = t[1])) : (t = Object(a.a)(Object(s.a)(t, !1, !1), String), r = function r(e, n) {
        return !Object(l.a)(t, n);
      }), Object(u.a)(e, r, n);
    });
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      return null == e || e.length < 1 ? null == t || n ? void 0 : [] : null == t || n ? e[0] : Object(o.a)(e, e.length - t);
    }

    t.a = r;
    var o = n(239);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      return null == e || e.length < 1 ? null == t || n ? void 0 : [] : null == t || n ? e[e.length - 1] : Object(o.a)(e, Math.max(0, e.length - t));
    }

    t.a = r;
    var o = n(240);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return Object(o.a)(e, Boolean);
    }

    t.a = r;
    var o = n(91);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return Object(o.a)(e, t, !1);
    }

    t.a = r;
    var o = n(70);
  }, function (e, t, n) {
    "use strict";

    var r = n(28),
        o = n(241);
    t.a = Object(r.a)(function (e, t) {
      return Object(o.a)(e, t);
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(28),
        o = n(242),
        i = n(70);
    t.a = Object(r.a)(function (e) {
      return Object(o.a)(Object(i.a)(e, !0, !0));
    });
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      for (var t = [], n = arguments.length, r = 0, a = Object(o.a)(e); r < a; r++) {
        var s = e[r];

        if (!Object(i.a)(t, s)) {
          var l;

          for (l = 1; l < n && Object(i.a)(arguments[l], s); l++) {
            ;
          }

          l === n && t.push(s);
        }
      }

      return t;
    }

    t.a = r;
    var o = n(33),
        i = n(92);
  }, function (e, t, n) {
    "use strict";

    var r = n(28),
        o = n(243);
    t.a = Object(r.a)(o.a);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      for (var n = {}, r = 0, i = Object(o.a)(e); r < i; r++) {
        t ? n[e[r]] = t[r] : n[e[r][0]] = e[r][1];
      }

      return n;
    }

    t.a = r;
    var o = n(33);
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      null == t && (t = e || 0, e = 0), n || (n = t < e ? -1 : 1);

      for (var r = Math.max(Math.ceil((t - e) / n), 0), o = Array(r), i = 0; i < r; i++, e += n) {
        o[i] = e;
      }

      return o;
    }

    t.a = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (null == t || t < 1) return [];

      for (var n = [], r = 0, i = e.length; r < i;) {
        n.push(o.q.call(e, r, r += t));
      }

      return n;
    }

    t.a = r;
    var o = n(11);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return Object(i.a)(Object(a.a)(e), function (t) {
        var n = o.a[t] = e[t];

        o.a.prototype[t] = function () {
          var e = [this._wrapped];
          return s.o.apply(e, arguments), Object(l.a)(this, n.apply(o.a, e));
        };
      }), o.a;
    }

    t.a = r;
    var o = n(29),
        i = n(55),
        a = n(210),
        s = n(11),
        l = n(244);
  }, function (e, t, n) {
    "use strict";

    var r = n(29),
        o = n(55),
        i = n(11),
        a = n(244);
    Object(o.a)(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (e) {
      var t = i.a[e];

      r.a.prototype[e] = function () {
        var n = this._wrapped;
        return null != n && (t.apply(n, arguments), "shift" !== e && "splice" !== e || 0 !== n.length || delete n[0]), Object(a.a)(this, n);
      };
    }), Object(o.a)(["concat", "join", "slice"], function (e) {
      var t = i.a[e];

      r.a.prototype[e] = function () {
        var e = this._wrapped;
        return null != e && (e = t.apply(e, arguments)), Object(a.a)(this, e);
      };
    }), t.a = r.a;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(41);
    t.default = function (e) {
      e.registerHelper("blockHelperMissing", function (t, n) {
        var o = n.inverse,
            i = n.fn;
        if (!0 === t) return i(this);
        if (!1 === t || null == t) return o(this);
        if (r.isArray(t)) return t.length > 0 ? (n.ids && (n.ids = [n.name]), e.helpers.each(t, n)) : o(this);

        if (n.data && n.ids) {
          var a = r.createFrame(n.data);
          a.contextPath = r.appendContextPath(n.data.contextPath, n.name), n = {
            data: a
          };
        }

        return i(t, n);
      });
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    (function (r) {
      t.__esModule = !0;

      var o = n(41),
          i = n(56),
          a = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(i);

      t.default = function (e) {
        e.registerHelper("each", function (e, t) {
          function n(t, n, r) {
            c && (c.key = t, c.index = n, c.first = 0 === n, c.last = !!r, d && (c.contextPath = d + t)), u += i(e[t], {
              data: c,
              blockParams: o.blockParams([e[t], t], [d + t, null])
            });
          }

          if (!t) throw new a.default("Must pass iterator to #each");
          var i = t.fn,
              s = t.inverse,
              l = 0,
              u = "",
              c = void 0,
              d = void 0;
          if (t.data && t.ids && (d = o.appendContextPath(t.data.contextPath, t.ids[0]) + "."), o.isFunction(e) && (e = e.call(this)), t.data && (c = o.createFrame(t.data)), e && "object" == typeof e) if (o.isArray(e)) for (var f = e.length; l < f; l++) {
            l in e && n(l, l, l === e.length - 1);
          } else if (r.Symbol && e[r.Symbol.iterator]) {
            for (var p = [], h = e[r.Symbol.iterator](), m = h.next(); !m.done; m = h.next()) {
              p.push(m.value);
            }

            e = p;

            for (var f = e.length; l < f; l++) {
              n(l, l, l === e.length - 1);
            }
          } else !function () {
            var t = void 0;
            Object.keys(e).forEach(function (e) {
              void 0 !== t && n(t, l - 1), t = e, l++;
            }), void 0 !== t && n(t, l - 1, !0);
          }();
          return 0 === l && (u = s(this)), u;
        });
      }, e.exports = t.default;
    }).call(t, n(49));
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = n(56),
        o = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(r);

    t.default = function (e) {
      e.registerHelper("helperMissing", function () {
        if (1 !== arguments.length) throw new o.default('Missing helper: "' + arguments[arguments.length - 1].name + '"');
      });
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = n(41),
        o = n(56),
        i = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(o);

    t.default = function (e) {
      e.registerHelper("if", function (e, t) {
        if (2 != arguments.length) throw new i.default("#if requires exactly one argument");
        return r.isFunction(e) && (e = e.call(this)), !t.hash.includeZero && !e || r.isEmpty(e) ? t.inverse(this) : t.fn(this);
      }), e.registerHelper("unless", function (t, n) {
        if (2 != arguments.length) throw new i.default("#unless requires exactly one argument");
        return e.helpers.if.call(this, t, {
          fn: n.inverse,
          inverse: n.fn,
          hash: n.hash
        });
      });
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.default = function (e) {
      e.registerHelper("log", function () {
        for (var t = [void 0], n = arguments[arguments.length - 1], r = 0; r < arguments.length - 1; r++) {
          t.push(arguments[r]);
        }

        var o = 1;
        null != n.hash.level ? o = n.hash.level : n.data && null != n.data.level && (o = n.data.level), t[0] = o, e.log.apply(e, t);
      });
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.default = function (e) {
      e.registerHelper("lookup", function (e, t, n) {
        return e ? n.lookupProperty(e, t) : e;
      });
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = n(41),
        o = n(56),
        i = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(o);

    t.default = function (e) {
      e.registerHelper("with", function (e, t) {
        if (2 != arguments.length) throw new i.default("#with requires exactly one argument");
        r.isFunction(e) && (e = e.call(this));
        var n = t.fn;
        if (r.isEmpty(e)) return t.inverse(this);
        var o = t.data;
        return t.data && t.ids && (o = r.createFrame(t.data), o.contextPath = r.appendContextPath(t.data.contextPath, t.ids[0])), n(e, {
          data: o,
          blockParams: r.blockParams([e], [o && o.contextPath])
        });
      });
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      i.default(e);
    }

    t.__esModule = !0, t.registerDefaultDecorators = r;

    var o = n(463),
        i = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(o);
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(41);
    t.default = function (e) {
      e.registerDecorator("inline", function (e, t, n, o) {
        var i = e;
        return t.partials || (t.partials = {}, i = function i(o, _i) {
          var a = n.partials;
          n.partials = r.extend({}, a, t.partials);
          var s = e(o, _i);
          return n.partials = a, s;
        }), t.partials[o.args[0]] = o.fn, i;
      });
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function r() {
      for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }

      return o.extend.apply(void 0, [Object.create(null)].concat(t));
    }

    t.__esModule = !0, t.createNewLookupObject = r;
    var o = n(41);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      this.string = e;
    }

    t.__esModule = !0, r.prototype.toString = r.prototype.toHTML = function () {
      return "" + this.string;
    }, t.default = r, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = e && e[0] || 1,
          n = v.COMPILER_REVISION;

      if (!(t >= v.LAST_COMPATIBLE_COMPILER_REVISION && t <= v.COMPILER_REVISION)) {
        if (t < v.LAST_COMPATIBLE_COMPILER_REVISION) {
          var r = v.REVISION_CHANGES[n],
              o = v.REVISION_CHANGES[t];
          throw new g.default("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + r + ") or downgrade your runtime to an older version (" + o + ").");
        }

        throw new g.default("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + e[1] + ").");
      }
    }

    function o(e, t) {
      function n(n, r, o) {
        o.hash && (r = h.extend({}, r, o.hash), o.ids && (o.ids[0] = !0)), n = t.VM.resolvePartial.call(this, n, r, o);
        var i = h.extend({}, o, {
          hooks: this.hooks,
          protoAccessControl: this.protoAccessControl
        }),
            a = t.VM.invokePartial.call(this, n, r, i);

        if (null == a && t.compile && (o.partials[o.name] = t.compile(n, e.compilerOptions, t), a = o.partials[o.name](r, i)), null != a) {
          if (o.indent) {
            for (var s = a.split("\n"), l = 0, u = s.length; l < u && (s[l] || l + 1 !== u); l++) {
              s[l] = o.indent + s[l];
            }

            a = s.join("\n");
          }

          return a;
        }

        throw new g.default("The partial " + o.name + " could not be compiled when running in runtime-only mode");
      }

      function r(t) {
        function n(t) {
          return "" + e.main(a, t, a.helpers, a.partials, i, l, s);
        }

        var o = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
            i = o.data;
        r._setup(o), !o.partial && e.useData && (i = u(t, i));
        var s = void 0,
            l = e.useBlockParams ? [] : void 0;
        return e.useDepths && (s = o.depths ? t != o.depths[0] ? [t].concat(o.depths) : o.depths : [t]), (n = c(e.main, n, a, o.depths || [], i, l))(t, o);
      }

      if (!t) throw new g.default("No environment passed to template");
      if (!e || !e.main) throw new g.default("Unknown template object: " + typeof e);
      e.main.decorator = e.main_d, t.VM.checkRevision(e.compiler);
      var o = e.compiler && 7 === e.compiler[0],
          a = {
        strict: function strict(e, t, n) {
          if (!(e && t in e)) throw new g.default('"' + t + '" not defined in ' + e, {
            loc: n
          });
          return e[t];
        },
        lookupProperty: function lookupProperty(e, t) {
          var n = e[t];
          return null == n ? n : Object.prototype.hasOwnProperty.call(e, t) ? n : _.resultIsAllowed(n, a.protoAccessControl, t) ? n : void 0;
        },
        lookup: function lookup(e, t) {
          for (var n = e.length, r = 0; r < n; r++) {
            if (null != (e[r] && a.lookupProperty(e[r], t))) return e[r][t];
          }
        },
        lambda: function lambda(e, t) {
          return "function" == typeof e ? e.call(t) : e;
        },
        escapeExpression: h.escapeExpression,
        invokePartial: n,
        fn: function fn(t) {
          var n = e[t];
          return n.decorator = e[t + "_d"], n;
        },
        programs: [],
        program: function program(e, t, n, r, o) {
          var a = this.programs[e],
              s = this.fn(e);
          return t || o || r || n ? a = i(this, e, s, t, n, r, o) : a || (a = this.programs[e] = i(this, e, s)), a;
        },
        data: function data(e, t) {
          for (; e && t--;) {
            e = e._parent;
          }

          return e;
        },
        mergeIfNeeded: function mergeIfNeeded(e, t) {
          var n = e || t;
          return e && t && e !== t && (n = h.extend({}, t, e)), n;
        },
        nullContext: Object.seal({}),
        noop: t.VM.noop,
        compilerInfo: e.compiler
      };
      return r.isTop = !0, r._setup = function (n) {
        if (n.partial) a.protoAccessControl = n.protoAccessControl, a.helpers = n.helpers, a.partials = n.partials, a.decorators = n.decorators, a.hooks = n.hooks;else {
          var r = h.extend({}, t.helpers, n.helpers);
          d(r, a), a.helpers = r, e.usePartial && (a.partials = a.mergeIfNeeded(n.partials, t.partials)), (e.usePartial || e.useDecorators) && (a.decorators = h.extend({}, t.decorators, n.decorators)), a.hooks = {}, a.protoAccessControl = _.createProtoAccessControl(n);
          var i = n.allowCallsToHelperMissing || o;
          y.moveHelperToHooks(a, "helperMissing", i), y.moveHelperToHooks(a, "blockHelperMissing", i);
        }
      }, r._child = function (t, n, r, o) {
        if (e.useBlockParams && !r) throw new g.default("must pass block params");
        if (e.useDepths && !o) throw new g.default("must pass parent depths");
        return i(a, t, e[t], n, 0, r, o);
      }, r;
    }

    function i(e, t, n, r, o, i, a) {
      function s(t) {
        var o = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
            s = a;
        return !a || t == a[0] || t === e.nullContext && null === a[0] || (s = [t].concat(a)), n(e, t, e.helpers, e.partials, o.data || r, i && [o.blockParams].concat(i), s);
      }

      return s = c(n, s, e, a, r, i), s.program = t, s.depth = a ? a.length : 0, s.blockParams = o || 0, s;
    }

    function a(e, t, n) {
      return e ? e.call || n.name || (n.name = e, e = n.partials[e]) : e = "@partial-block" === n.name ? n.data["partial-block"] : n.partials[n.name], e;
    }

    function s(e, t, n) {
      var r = n.data && n.data["partial-block"];
      n.partial = !0, n.ids && (n.data.contextPath = n.ids[0] || n.data.contextPath);
      var o = void 0;
      if (n.fn && n.fn !== l && function () {
        n.data = v.createFrame(n.data);
        var e = n.fn;
        o = n.data["partial-block"] = function (t) {
          var n = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1];
          return n.data = v.createFrame(n.data), n.data["partial-block"] = r, e(t, n);
        }, e.partials && (n.partials = h.extend({}, n.partials, e.partials));
      }(), void 0 === e && o && (e = o), void 0 === e) throw new g.default("The partial " + n.name + " could not be found");
      if (e instanceof Function) return e(t, n);
    }

    function l() {
      return "";
    }

    function u(e, t) {
      return t && "root" in t || (t = t ? v.createFrame(t) : {}, t.root = e), t;
    }

    function c(e, t, n, r, o, i) {
      if (e.decorator) {
        var a = {};
        t = e.decorator(t, a, n, r && r[0], o, i, r), h.extend(t, a);
      }

      return t;
    }

    function d(e, t) {
      Object.keys(e).forEach(function (n) {
        var r = e[n];
        e[n] = f(r, t);
      });
    }

    function f(e, t) {
      var n = t.lookupProperty;
      return b.wrapHelper(e, function (e) {
        return h.extend({
          lookupProperty: n
        }, e);
      });
    }

    t.__esModule = !0, t.checkRevision = r, t.template = o, t.wrapProgram = i, t.resolvePartial = a, t.invokePartial = s, t.noop = l;

    var p = n(41),
        h = function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    }(p),
        m = n(56),
        g = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(m),
        v = n(245),
        y = n(246),
        b = n(467),
        _ = n(248);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return "function" != typeof e ? e : function () {
        var n = arguments[arguments.length - 1];
        return arguments[arguments.length - 1] = t(n), e.apply(this, arguments);
      };
    }

    t.__esModule = !0, t.wrapHelper = r;
  }, function (e, t, n) {
    "use strict";

    (function (n) {
      t.__esModule = !0, t.default = function (e) {
        var t = void 0 !== n ? n : window,
            r = t.Handlebars;

        e.noConflict = function () {
          return t.Handlebars === e && (t.Handlebars = r), e;
        };
      }, e.exports = t.default;
    }).call(t, n(49));
  }, function (e, t, n) {
    (function (r) {
      var o, i; //     (c) 2010-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
      //     Backbone may be freely distributed under the MIT license.

      !function (a) {
        var s = "object" == typeof self && self.self == self && self || "object" == typeof r && r.global == r && r;
        o = [n(470), n(154), t], void 0 !== (i = function (e, t, n) {
          s.Backbone = a(s, n, e, t);
        }.apply(t, o)) && (e.exports = i);
      }(function (e, t, n, r) {
        var o = e.Backbone,
            i = [].slice;
        t.VERSION = "1.2.1", t.$ = r, t.noConflict = function () {
          return e.Backbone = o, this;
        }, t.emulateHTTP = !1, t.emulateJSON = !1;

        var a = function a(e, t, r) {
          switch (e) {
            case 1:
              return function () {
                return n[t](this[r]);
              };

            case 2:
              return function (e) {
                return n[t](this[r], e);
              };

            case 3:
              return function (e, o) {
                return n[t](this[r], e, o);
              };

            case 4:
              return function (e, o, i) {
                return n[t](this[r], e, o, i);
              };

            default:
              return function () {
                var e = i.call(arguments);
                return e.unshift(this[r]), n[t].apply(n, e);
              };
          }
        },
            s = function s(e, t, r) {
          n.each(t, function (t, o) {
            n[o] && (e.prototype[o] = a(t, o, r));
          });
        },
            l = t.Events = {},
            u = /\s+/,
            c = function c(e, t, r, o, i) {
          var a,
              s = 0;

          if (r && "object" == typeof r) {
            void 0 !== o && "context" in i && void 0 === i.context && (i.context = o);

            for (a = n.keys(r); s < a.length; s++) {
              t = e(t, a[s], r[a[s]], i);
            }
          } else if (r && u.test(r)) for (a = r.split(u); s < a.length; s++) {
            t = e(t, a[s], o, i);
          } else t = e(t, r, o, i);

          return t;
        };

        l.on = function (e, t, n) {
          return d(this, e, t, n);
        };

        var d = function d(e, t, n, r, o) {
          if (e._events = c(f, e._events || {}, t, n, {
            context: r,
            ctx: e,
            listening: o
          }), o) {
            (e._listeners || (e._listeners = {}))[o.id] = o;
          }

          return e;
        };

        l.listenTo = function (e, t, r) {
          if (!e) return this;
          var o = e._listenId || (e._listenId = n.uniqueId("l")),
              i = this._listeningTo || (this._listeningTo = {}),
              a = i[o];

          if (!a) {
            var s = this._listenId || (this._listenId = n.uniqueId("l"));
            a = i[o] = {
              obj: e,
              objId: o,
              id: s,
              listeningTo: i,
              count: 0
            };
          }

          return d(e, t, r, this, a), this;
        };

        var f = function f(e, t, n, r) {
          if (n) {
            var o = e[t] || (e[t] = []),
                i = r.context,
                a = r.ctx,
                s = r.listening;
            s && s.count++, o.push({
              callback: n,
              context: i,
              ctx: i || a,
              listening: s
            });
          }

          return e;
        };

        l.off = function (e, t, n) {
          return this._events ? (this._events = c(p, this._events, e, t, {
            context: n,
            listeners: this._listeners
          }), this) : this;
        }, l.stopListening = function (e, t, r) {
          var o = this._listeningTo;
          if (!o) return this;

          for (var i = e ? [e._listenId] : n.keys(o), a = 0; a < i.length; a++) {
            var s = o[i[a]];
            if (!s) break;
            s.obj.off(t, r, this);
          }

          return n.isEmpty(o) && (this._listeningTo = void 0), this;
        };

        var p = function p(e, t, r, o) {
          if (e) {
            var i,
                a = 0,
                s = o.context,
                l = o.listeners;

            if (t || r || s) {
              for (var u = t ? [t] : n.keys(e); a < u.length; a++) {
                t = u[a];
                var c = e[t];
                if (!c) break;

                for (var d = [], f = 0; f < c.length; f++) {
                  var p = c[f];
                  r && r !== p.callback && r !== p.callback._callback || s && s !== p.context ? d.push(p) : (i = p.listening) && 0 == --i.count && (delete l[i.id], delete i.listeningTo[i.objId]);
                }

                d.length ? e[t] = d : delete e[t];
              }

              return n.size(e) ? e : void 0;
            }

            for (var h = n.keys(l); a < h.length; a++) {
              i = l[h[a]], delete l[i.id], delete i.listeningTo[i.objId];
            }
          }
        };

        l.once = function (e, t, r) {
          var o = c(h, {}, e, t, n.bind(this.off, this));
          return this.on(o, void 0, r);
        }, l.listenToOnce = function (e, t, r) {
          var o = c(h, {}, t, r, n.bind(this.stopListening, this, e));
          return this.listenTo(e, o);
        };

        var h = function h(e, t, r, o) {
          if (r) {
            var i = e[t] = n.once(function () {
              o(t, i), r.apply(this, arguments);
            });
            i._callback = r;
          }

          return e;
        };

        l.trigger = function (e) {
          if (!this._events) return this;

          for (var t = Math.max(0, arguments.length - 1), n = Array(t), r = 0; r < t; r++) {
            n[r] = arguments[r + 1];
          }

          return c(m, this._events, e, void 0, n), this;
        };

        var m = function m(e, t, n, r) {
          if (e) {
            var o = e[t],
                i = e.all;
            o && i && (i = i.slice()), o && g(o, r), i && g(i, [t].concat(r));
          }

          return e;
        },
            g = function g(e, t) {
          var n,
              r = -1,
              o = e.length,
              i = t[0],
              a = t[1],
              s = t[2];

          switch (t.length) {
            case 0:
              for (; ++r < o;) {
                (n = e[r]).callback.call(n.ctx);
              }

              return;

            case 1:
              for (; ++r < o;) {
                (n = e[r]).callback.call(n.ctx, i);
              }

              return;

            case 2:
              for (; ++r < o;) {
                (n = e[r]).callback.call(n.ctx, i, a);
              }

              return;

            case 3:
              for (; ++r < o;) {
                (n = e[r]).callback.call(n.ctx, i, a, s);
              }

              return;

            default:
              for (; ++r < o;) {
                (n = e[r]).callback.apply(n.ctx, t);
              }

              return;
          }
        };

        l.bind = l.on, l.unbind = l.off, n.extend(t, l);

        var v = t.Model = function (e, t) {
          var r = e || {};
          t || (t = {}), this.cid = n.uniqueId(this.cidPrefix), this.attributes = {}, t.collection && (this.collection = t.collection), t.parse && (r = this.parse(r, t) || {}), r = n.defaults({}, r, n.result(this, "defaults")), this.set(r, t), this.changed = {}, this.initialize.apply(this, arguments);
        };

        n.extend(v.prototype, l, {
          changed: null,
          validationError: null,
          idAttribute: "id",
          cidPrefix: "c",
          initialize: function initialize() {},
          toJSON: function toJSON(e) {
            return n.clone(this.attributes);
          },
          sync: function sync() {
            return t.sync.apply(this, arguments);
          },
          get: function get(e) {
            return this.attributes[e];
          },
          escape: function escape(e) {
            return n.escape(this.get(e));
          },
          has: function has(e) {
            return null != this.get(e);
          },
          matches: function matches(e) {
            return !!n.iteratee(e, this)(this.attributes);
          },
          set: function set(e, t, r) {
            if (null == e) return this;
            var o;
            if ("object" == typeof e ? (o = e, r = t) : (o = {})[e] = t, r || (r = {}), !this._validate(o, r)) return !1;
            var i = r.unset,
                a = r.silent,
                s = [],
                l = this._changing;
            this._changing = !0, l || (this._previousAttributes = n.clone(this.attributes), this.changed = {});
            var u = this.attributes,
                c = this.changed,
                d = this._previousAttributes;
            this.idAttribute in o && (this.id = o[this.idAttribute]);

            for (var f in o) {
              t = o[f], n.isEqual(u[f], t) || s.push(f), n.isEqual(d[f], t) ? delete c[f] : c[f] = t, i ? delete u[f] : u[f] = t;
            }

            if (!a) {
              s.length && (this._pending = r);

              for (var p = 0; p < s.length; p++) {
                this.trigger("change:" + s[p], this, u[s[p]], r);
              }
            }

            if (l) return this;
            if (!a) for (; this._pending;) {
              r = this._pending, this._pending = !1, this.trigger("change", this, r);
            }
            return this._pending = !1, this._changing = !1, this;
          },
          unset: function unset(e, t) {
            return this.set(e, void 0, n.extend({}, t, {
              unset: !0
            }));
          },
          clear: function clear(e) {
            var t = {};

            for (var r in this.attributes) {
              t[r] = void 0;
            }

            return this.set(t, n.extend({}, e, {
              unset: !0
            }));
          },
          hasChanged: function hasChanged(e) {
            return null == e ? !n.isEmpty(this.changed) : n.has(this.changed, e);
          },
          changedAttributes: function changedAttributes(e) {
            if (!e) return !!this.hasChanged() && n.clone(this.changed);
            var t = this._changing ? this._previousAttributes : this.attributes,
                r = {};

            for (var o in e) {
              var i = e[o];
              n.isEqual(t[o], i) || (r[o] = i);
            }

            return !!n.size(r) && r;
          },
          previous: function previous(e) {
            return null != e && this._previousAttributes ? this._previousAttributes[e] : null;
          },
          previousAttributes: function previousAttributes() {
            return n.clone(this._previousAttributes);
          },
          fetch: function fetch(e) {
            e = n.extend({
              parse: !0
            }, e);
            var t = this,
                r = e.success;
            return e.success = function (n) {
              var o = e.parse ? t.parse(n, e) : n;
              if (!t.set(o, e)) return !1;
              r && r.call(e.context, t, n, e), t.trigger("sync", t, n, e);
            }, D(this, e), this.sync("read", this, e);
          },
          save: function save(e, t, r) {
            var o;
            null == e || "object" == typeof e ? (o = e, r = t) : (o = {})[e] = t, r = n.extend({
              validate: !0,
              parse: !0
            }, r);
            var i = r.wait;

            if (o && !i) {
              if (!this.set(o, r)) return !1;
            } else if (!this._validate(o, r)) return !1;

            var a = this,
                s = r.success,
                l = this.attributes;
            r.success = function (e) {
              a.attributes = l;
              var t = r.parse ? a.parse(e, r) : e;
              if (i && (t = n.extend({}, o, t)), t && !a.set(t, r)) return !1;
              s && s.call(r.context, a, e, r), a.trigger("sync", a, e, r);
            }, D(this, r), o && i && (this.attributes = n.extend({}, l, o));
            var u = this.isNew() ? "create" : r.patch ? "patch" : "update";
            "patch" !== u || r.attrs || (r.attrs = o);
            var c = this.sync(u, this, r);
            return this.attributes = l, c;
          },
          destroy: function destroy(e) {
            e = e ? n.clone(e) : {};

            var t = this,
                r = e.success,
                o = e.wait,
                i = function i() {
              t.stopListening(), t.trigger("destroy", t, t.collection, e);
            };

            e.success = function (n) {
              o && i(), r && r.call(e.context, t, n, e), t.isNew() || t.trigger("sync", t, n, e);
            };

            var a = !1;
            return this.isNew() ? n.defer(e.success) : (D(this, e), a = this.sync("delete", this, e)), o || i(), a;
          },
          url: function url() {
            var e = n.result(this, "urlRoot") || n.result(this.collection, "url") || L();
            if (this.isNew()) return e;
            var t = this.get(this.idAttribute);
            return e.replace(/[^\/]$/, "$&/") + encodeURIComponent(t);
          },
          parse: function parse(e, t) {
            return e;
          },
          clone: function clone() {
            return new this.constructor(this.attributes);
          },
          isNew: function isNew() {
            return !this.has(this.idAttribute);
          },
          isValid: function isValid(e) {
            return this._validate({}, n.defaults({
              validate: !0
            }, e));
          },
          _validate: function _validate(e, t) {
            if (!t.validate || !this.validate) return !0;
            e = n.extend({}, this.attributes, e);
            var r = this.validationError = this.validate(e, t) || null;
            return !r || (this.trigger("invalid", this, r, n.extend(t, {
              validationError: r
            })), !1);
          }
        }), s(v, {
          keys: 1,
          values: 1,
          pairs: 1,
          invert: 1,
          pick: 0,
          omit: 0,
          chain: 1,
          isEmpty: 1
        }, "attributes");

        var y = t.Collection = function (e, t) {
          t || (t = {}), t.model && (this.model = t.model), void 0 !== t.comparator && (this.comparator = t.comparator), this._reset(), this.initialize.apply(this, arguments), e && this.reset(e, n.extend({
            silent: !0
          }, t));
        },
            b = {
          add: !0,
          remove: !0,
          merge: !0
        },
            _ = {
          add: !0,
          remove: !1
        };

        n.extend(y.prototype, l, {
          model: v,
          initialize: function initialize() {},
          toJSON: function toJSON(e) {
            return this.map(function (t) {
              return t.toJSON(e);
            });
          },
          sync: function sync() {
            return t.sync.apply(this, arguments);
          },
          add: function add(e, t) {
            return this.set(e, n.extend({
              merge: !1
            }, t, _));
          },
          remove: function remove(e, t) {
            t = n.extend({}, t);
            var r = !n.isArray(e);
            e = r ? [e] : n.clone(e);

            var o = this._removeModels(e, t);

            return !t.silent && o && this.trigger("update", this, t), r ? o[0] : o;
          },
          set: function set(e, t) {
            t = n.defaults({}, t, b), t.parse && !this._isModel(e) && (e = this.parse(e, t));
            var r = !n.isArray(e);
            e = r ? e ? [e] : [] : e.slice();
            var o,
                i,
                a,
                s,
                l,
                u = t.at;
            null != u && (u = +u), u < 0 && (u += this.length + 1);

            for (var c = this.comparator && null == u && !1 !== t.sort, d = n.isString(this.comparator) ? this.comparator : null, f = [], p = [], h = {}, m = t.add, g = t.merge, v = t.remove, y = !(c || !m || !v) && [], _ = !1, w = 0; w < e.length; w++) {
              if (a = e[w], s = this.get(a)) v && (h[s.cid] = !0), g && a !== s && (a = this._isModel(a) ? a.attributes : a, t.parse && (a = s.parse(a, t)), s.set(a, t), c && !l && s.hasChanged(d) && (l = !0)), e[w] = s;else if (m) {
                if (!(i = e[w] = this._prepareModel(a, t))) continue;
                f.push(i), this._addReference(i, t);
              }
              i = s || i, i && (o = this.modelId(i.attributes), !y || !i.isNew() && h[o] || (y.push(i), _ = _ || !this.models[w] || i.cid !== this.models[w].cid), h[o] = !0);
            }

            if (v) {
              for (var w = 0; w < this.length; w++) {
                h[(i = this.models[w]).cid] || p.push(i);
              }

              p.length && this._removeModels(p, t);
            }

            if (f.length || _) if (c && (l = !0), this.length += f.length, null != u) for (var w = 0; w < f.length; w++) {
              this.models.splice(u + w, 0, f[w]);
            } else {
              y && (this.models.length = 0);

              for (var E = y || f, w = 0; w < E.length; w++) {
                this.models.push(E[w]);
              }
            }

            if (l && this.sort({
              silent: !0
            }), !t.silent) {
              for (var O = null != u ? n.clone(t) : t, w = 0; w < f.length; w++) {
                null != u && (O.index = u + w), (i = f[w]).trigger("add", i, this, O);
              }

              (l || _) && this.trigger("sort", this, t), (f.length || p.length) && this.trigger("update", this, t);
            }

            return r ? e[0] : e;
          },
          reset: function reset(e, t) {
            t = t ? n.clone(t) : {};

            for (var r = 0; r < this.models.length; r++) {
              this._removeReference(this.models[r], t);
            }

            return t.previousModels = this.models, this._reset(), e = this.add(e, n.extend({
              silent: !0
            }, t)), t.silent || this.trigger("reset", this, t), e;
          },
          push: function push(e, t) {
            return this.add(e, n.extend({
              at: this.length
            }, t));
          },
          pop: function pop(e) {
            var t = this.at(this.length - 1);
            return this.remove(t, e);
          },
          unshift: function unshift(e, t) {
            return this.add(e, n.extend({
              at: 0
            }, t));
          },
          shift: function shift(e) {
            var t = this.at(0);
            return this.remove(t, e);
          },
          slice: function slice() {
            return i.apply(this.models, arguments);
          },
          get: function get(e) {
            if (null != e) {
              var t = this.modelId(this._isModel(e) ? e.attributes : e);
              return this._byId[e] || this._byId[t] || this._byId[e.cid];
            }
          },
          at: function at(e) {
            return e < 0 && (e += this.length), this.models[e];
          },
          where: function where(e, t) {
            var r = n.matches(e);
            return this[t ? "find" : "filter"](function (e) {
              return r(e.attributes);
            });
          },
          findWhere: function findWhere(e) {
            return this.where(e, !0);
          },
          sort: function sort(e) {
            if (!this.comparator) throw new Error("Cannot sort a set without a comparator");
            return e || (e = {}), n.isString(this.comparator) || 1 === this.comparator.length ? this.models = this.sortBy(this.comparator, this) : this.models.sort(n.bind(this.comparator, this)), e.silent || this.trigger("sort", this, e), this;
          },
          pluck: function pluck(e) {
            return n.invoke(this.models, "get", e);
          },
          fetch: function fetch(e) {
            e = n.extend({
              parse: !0
            }, e);
            var t = e.success,
                r = this;
            return e.success = function (n) {
              var o = e.reset ? "reset" : "set";
              r[o](n, e), t && t.call(e.context, r, n, e), r.trigger("sync", r, n, e);
            }, D(this, e), this.sync("read", this, e);
          },
          create: function create(e, t) {
            t = t ? n.clone(t) : {};
            var r = t.wait;
            if (!(e = this._prepareModel(e, t))) return !1;
            r || this.add(e, t);
            var o = this,
                i = t.success;
            return t.success = function (e, t, n) {
              r && o.add(e, n), i && i.call(n.context, e, t, n);
            }, e.save(null, t), e;
          },
          parse: function parse(e, t) {
            return e;
          },
          clone: function clone() {
            return new this.constructor(this.models, {
              model: this.model,
              comparator: this.comparator
            });
          },
          modelId: function modelId(e) {
            return e[this.model.prototype.idAttribute || "id"];
          },
          _reset: function _reset() {
            this.length = 0, this.models = [], this._byId = {};
          },
          _prepareModel: function _prepareModel(e, t) {
            if (this._isModel(e)) return e.collection || (e.collection = this), e;
            t = t ? n.clone(t) : {}, t.collection = this;
            var r = new this.model(e, t);
            return r.validationError ? (this.trigger("invalid", this, r.validationError, t), !1) : r;
          },
          _removeModels: function _removeModels(e, t) {
            for (var n = [], r = 0; r < e.length; r++) {
              var o = this.get(e[r]);

              if (o) {
                var i = this.indexOf(o);
                this.models.splice(i, 1), this.length--, t.silent || (t.index = i, o.trigger("remove", o, this, t)), n.push(o), this._removeReference(o, t);
              }
            }

            return !!n.length && n;
          },
          _isModel: function _isModel(e) {
            return e instanceof v;
          },
          _addReference: function _addReference(e, t) {
            this._byId[e.cid] = e;
            var n = this.modelId(e.attributes);
            null != n && (this._byId[n] = e), e.on("all", this._onModelEvent, this);
          },
          _removeReference: function _removeReference(e, t) {
            delete this._byId[e.cid];
            var n = this.modelId(e.attributes);
            null != n && delete this._byId[n], this === e.collection && delete e.collection, e.off("all", this._onModelEvent, this);
          },
          _onModelEvent: function _onModelEvent(e, t, n, r) {
            if ("add" !== e && "remove" !== e || n === this) {
              if ("destroy" === e && this.remove(t, r), "change" === e) {
                var o = this.modelId(t.previousAttributes()),
                    i = this.modelId(t.attributes);
                o !== i && (null != o && delete this._byId[o], null != i && (this._byId[i] = t));
              }

              this.trigger.apply(this, arguments);
            }
          }
        }), s(y, {
          forEach: 3,
          each: 3,
          map: 3,
          collect: 3,
          reduce: 4,
          foldl: 4,
          inject: 4,
          reduceRight: 4,
          foldr: 4,
          find: 3,
          detect: 3,
          filter: 3,
          select: 3,
          reject: 3,
          every: 3,
          all: 3,
          some: 3,
          any: 3,
          include: 2,
          contains: 2,
          invoke: 0,
          max: 3,
          min: 3,
          toArray: 1,
          size: 1,
          first: 3,
          head: 3,
          take: 3,
          initial: 3,
          rest: 3,
          tail: 3,
          drop: 3,
          last: 3,
          without: 0,
          difference: 0,
          indexOf: 3,
          shuffle: 1,
          lastIndexOf: 3,
          isEmpty: 1,
          chain: 1,
          sample: 3,
          partition: 3
        }, "models");
        var w = ["groupBy", "countBy", "sortBy", "indexBy"];
        n.each(w, function (e) {
          n[e] && (y.prototype[e] = function (t, r) {
            var o = n.isFunction(t) ? t : function (e) {
              return e.get(t);
            };
            return n[e](this.models, o, r);
          });
        });

        var E = t.View = function (e) {
          this.cid = n.uniqueId("view"), n.extend(this, n.pick(e, S)), this._ensureElement(), this.initialize.apply(this, arguments);
        },
            O = /^(\S+)\s*(.*)$/,
            S = ["model", "collection", "el", "id", "attributes", "className", "tagName", "events"];

        n.extend(E.prototype, l, {
          tagName: "div",
          $: function $(e) {
            return this.$el.find(e);
          },
          initialize: function initialize() {},
          render: function render() {
            return this;
          },
          remove: function remove() {
            return this._removeElement(), this.stopListening(), this;
          },
          _removeElement: function _removeElement() {
            this.$el.remove();
          },
          setElement: function setElement(e) {
            return this.undelegateEvents(), this._setElement(e), this.delegateEvents(), this;
          },
          _setElement: function _setElement(e) {
            this.$el = e instanceof t.$ ? e : t.$(e), this.el = this.$el[0];
          },
          delegateEvents: function delegateEvents(e) {
            if (e || (e = n.result(this, "events")), !e) return this;
            this.undelegateEvents();

            for (var t in e) {
              var r = e[t];

              if (n.isFunction(r) || (r = this[r]), r) {
                var o = t.match(O);
                this.delegate(o[1], o[2], n.bind(r, this));
              }
            }

            return this;
          },
          delegate: function delegate(e, t, n) {
            return this.$el.on(e + ".delegateEvents" + this.cid, t, n), this;
          },
          undelegateEvents: function undelegateEvents() {
            return this.$el && this.$el.off(".delegateEvents" + this.cid), this;
          },
          undelegate: function undelegate(e, t, n) {
            return this.$el.off(e + ".delegateEvents" + this.cid, t, n), this;
          },
          _createElement: function _createElement(e) {
            return document.createElement(e);
          },
          _ensureElement: function _ensureElement() {
            if (this.el) this.setElement(n.result(this, "el"));else {
              var e = n.extend({}, n.result(this, "attributes"));
              this.id && (e.id = n.result(this, "id")), this.className && (e.class = n.result(this, "className")), this.setElement(this._createElement(n.result(this, "tagName"))), this._setAttributes(e);
            }
          },
          _setAttributes: function _setAttributes(e) {
            this.$el.attr(e);
          }
        }), t.sync = function (e, r, o) {
          var i = x[e];
          n.defaults(o || (o = {}), {
            emulateHTTP: t.emulateHTTP,
            emulateJSON: t.emulateJSON
          });
          var a = {
            type: i,
            dataType: "json"
          };

          if (o.url || (a.url = n.result(r, "url") || L()), null != o.data || !r || "create" !== e && "update" !== e && "patch" !== e || (a.contentType = "application/json", a.data = JSON.stringify(o.attrs || r.toJSON(o))), o.emulateJSON && (a.contentType = "application/x-www-form-urlencoded", a.data = a.data ? {
            model: a.data
          } : {}), o.emulateHTTP && ("PUT" === i || "DELETE" === i || "PATCH" === i)) {
            a.type = "POST", o.emulateJSON && (a.data._method = i);
            var s = o.beforeSend;

            o.beforeSend = function (e) {
              if (e.setRequestHeader("X-HTTP-Method-Override", i), s) return s.apply(this, arguments);
            };
          }

          "GET" === a.type || o.emulateJSON || (a.processData = !1);
          var l = o.error;

          o.error = function (e, t, n) {
            o.textStatus = t, o.errorThrown = n, l && l.call(o.context, e, t, n);
          };

          var u = o.xhr = t.ajax(n.extend(a, o));
          return r.trigger("request", r, u, o), u;
        };
        var x = {
          create: "POST",
          update: "PUT",
          patch: "PATCH",
          delete: "DELETE",
          read: "GET"
        };

        t.ajax = function () {
          return t.$.ajax.apply(t.$, arguments);
        };

        var T = t.Router = function (e) {
          e || (e = {}), e.routes && (this.routes = e.routes), this._bindRoutes(), this.initialize.apply(this, arguments);
        },
            k = /\((.*?)\)/g,
            C = /(\(\?)?:\w+/g,
            A = /\*\w+/g,
            N = /[\-{}\[\]+?.,\\\^$|#\s]/g;

        n.extend(T.prototype, l, {
          initialize: function initialize() {},
          route: function route(e, r, o) {
            n.isRegExp(e) || (e = this._routeToRegExp(e)), n.isFunction(r) && (o = r, r = ""), o || (o = this[r]);
            var i = this;
            return t.history.route(e, function (n) {
              var a = i._extractParameters(e, n);

              !1 !== i.execute(o, a, r) && (i.trigger.apply(i, ["route:" + r].concat(a)), i.trigger("route", r, a), t.history.trigger("route", i, r, a));
            }), this;
          },
          execute: function execute(e, t, n) {
            e && e.apply(this, t);
          },
          navigate: function navigate(e, n) {
            return t.history.navigate(e, n), this;
          },
          _bindRoutes: function _bindRoutes() {
            if (this.routes) {
              this.routes = n.result(this, "routes");

              for (var e, t = n.keys(this.routes); null != (e = t.pop());) {
                this.route(e, this.routes[e]);
              }
            }
          },
          _routeToRegExp: function _routeToRegExp(e) {
            return e = e.replace(N, "\\$&").replace(k, "(?:$1)?").replace(C, function (e, t) {
              return t ? e : "([^/?]+)";
            }).replace(A, "([^?]*?)"), new RegExp("^" + e + "(?:\\?([\\s\\S]*))?$");
          },
          _extractParameters: function _extractParameters(e, t) {
            var r = e.exec(t).slice(1);
            return n.map(r, function (e, t) {
              return t === r.length - 1 ? e || null : e ? decodeURIComponent(e) : null;
            });
          }
        });

        var P = t.History = function () {
          this.handlers = [], n.bindAll(this, "checkUrl"), "undefined" != typeof window && (this.location = window.location, this.history = window.history);
        },
            R = /^[#\/]|\s+$/g,
            I = /^\/+|\/+$/g,
            M = /#.*$/;

        P.started = !1, n.extend(P.prototype, l, {
          interval: 50,
          atRoot: function atRoot() {
            return this.location.pathname.replace(/[^\/]$/, "$&/") === this.root && !this.getSearch();
          },
          matchRoot: function matchRoot() {
            return this.decodeFragment(this.location.pathname).slice(0, this.root.length - 1) + "/" === this.root;
          },
          decodeFragment: function decodeFragment(e) {
            return decodeURI(e.replace(/%25/g, "%2525"));
          },
          getSearch: function getSearch() {
            var e = this.location.href.replace(/#.*/, "").match(/\?.+/);
            return e ? e[0] : "";
          },
          getHash: function getHash(e) {
            var t = (e || this).location.href.match(/#(.*)$/);
            return t ? t[1] : "";
          },
          getPath: function getPath() {
            var e = this.decodeFragment(this.location.pathname + this.getSearch()).slice(this.root.length - 1);
            return "/" === e.charAt(0) ? e.slice(1) : e;
          },
          getFragment: function getFragment(e) {
            return null == e && (e = this._usePushState || !this._wantsHashChange ? this.getPath() : this.getHash()), e.replace(R, "");
          },
          start: function start(e) {
            if (P.started) throw new Error("Backbone.history has already been started");

            if (P.started = !0, this.options = n.extend({
              root: "/"
            }, this.options, e), this.root = this.options.root, this._wantsHashChange = !1 !== this.options.hashChange, this._hasHashChange = "onhashchange" in window, this._useHashChange = this._wantsHashChange && this._hasHashChange, this._wantsPushState = !!this.options.pushState, this._hasPushState = !(!this.history || !this.history.pushState), this._usePushState = this._wantsPushState && this._hasPushState, this.fragment = this.getFragment(), this.root = ("/" + this.root + "/").replace(I, "/"), this._wantsHashChange && this._wantsPushState) {
              if (!this._hasPushState && !this.atRoot()) {
                var t = this.root.slice(0, -1) || "/";
                return this.location.replace(t + "#" + this.getPath()), !0;
              }

              this._hasPushState && this.atRoot() && this.navigate(this.getHash(), {
                replace: !0
              });
            }

            if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
              this.iframe = document.createElement("iframe"), this.iframe.src = "javascript:0", this.iframe.style.display = "none", this.iframe.tabIndex = -1;
              var r = document.body,
                  o = r.insertBefore(this.iframe, r.firstChild).contentWindow;
              o.document.open(), o.document.close(), o.location.hash = "#" + this.fragment;
            }

            var i = window.addEventListener || function (e, t) {
              return attachEvent("on" + e, t);
            };

            if (this._usePushState ? i("popstate", this.checkUrl, !1) : this._useHashChange && !this.iframe ? i("hashchange", this.checkUrl, !1) : this._wantsHashChange && (this._checkUrlInterval = setInterval(this.checkUrl, this.interval)), !this.options.silent) return this.loadUrl();
          },
          stop: function stop() {
            var e = window.removeEventListener || function (e, t) {
              return detachEvent("on" + e, t);
            };

            this._usePushState ? e("popstate", this.checkUrl, !1) : this._useHashChange && !this.iframe && e("hashchange", this.checkUrl, !1), this.iframe && (document.body.removeChild(this.iframe), this.iframe = null), this._checkUrlInterval && clearInterval(this._checkUrlInterval), P.started = !1;
          },
          route: function route(e, t) {
            this.handlers.unshift({
              route: e,
              callback: t
            });
          },
          checkUrl: function checkUrl(e) {
            var t = this.getFragment();
            if (t === this.fragment && this.iframe && (t = this.getHash(this.iframe.contentWindow)), t === this.fragment) return !1;
            this.iframe && this.navigate(t), this.loadUrl();
          },
          loadUrl: function loadUrl(e) {
            return !!this.matchRoot() && (e = this.fragment = this.getFragment(e), n.any(this.handlers, function (t) {
              if (t.route.test(e)) return t.callback(e), !0;
            }));
          },
          navigate: function navigate(e, t) {
            if (!P.started) return !1;
            t && !0 !== t || (t = {
              trigger: !!t
            }), e = this.getFragment(e || "");
            var n = this.root;
            "" !== e && "?" !== e.charAt(0) || (n = n.slice(0, -1) || "/");
            var r = n + e;

            if (e = this.decodeFragment(e.replace(M, "")), this.fragment !== e) {
              if (this.fragment = e, this._usePushState) this.history[t.replace ? "replaceState" : "pushState"]({}, document.title, r);else {
                if (!this._wantsHashChange) return this.location.assign(r);

                if (this._updateHash(this.location, e, t.replace), this.iframe && e !== this.getHash(this.iframe.contentWindow)) {
                  var o = this.iframe.contentWindow;
                  t.replace || (o.document.open(), o.document.close()), this._updateHash(o.location, e, t.replace);
                }
              }
              return t.trigger ? this.loadUrl(e) : void 0;
            }
          },
          _updateHash: function _updateHash(e, t, n) {
            if (n) {
              var r = e.href.replace(/(javascript:|#).*$/, "");
              e.replace(r + "#" + t);
            } else e.hash = "#" + t;
          }
        }), t.history = new P();

        var j = function j(e, t) {
          var r,
              o = this;
          r = e && n.has(e, "constructor") ? e.constructor : function () {
            return o.apply(this, arguments);
          }, n.extend(r, o, t);

          var i = function i() {
            this.constructor = r;
          };

          return i.prototype = o.prototype, r.prototype = new i(), e && n.extend(r.prototype, e), r.__super__ = o.prototype, r;
        };

        v.extend = y.extend = T.extend = E.extend = P.extend = j;

        var L = function L() {
          throw new Error('A "url" property or function must be specified');
        },
            D = function D(e, t) {
          var n = t.error;

          t.error = function (r) {
            n && n.call(t.context, e, r, t), e.trigger("error", e, r, t);
          };
        };

        return t;
      });
    }).call(t, n(49));
  }, function (e, t, n) {
    (function (e, n) {
      var r, o; //     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
      //     Underscore may be freely distributed under the MIT license.

      !function () {
        var i = "object" == typeof self && self.self === self && self || "object" == typeof e && e.global === e && e || this || {},
            a = i._,
            s = Array.prototype,
            l = Object.prototype,
            u = "undefined" != typeof Symbol ? Symbol.prototype : null,
            c = s.push,
            d = s.slice,
            f = l.toString,
            p = l.hasOwnProperty,
            h = Array.isArray,
            m = Object.keys,
            g = Object.create,
            v = function v() {},
            y = function y(e) {
          return e instanceof y ? e : this instanceof y ? void (this._wrapped = e) : new y(e);
        };

        void 0 === t || t.nodeType ? i._ = y : (void 0 !== n && !n.nodeType && n.exports && (t = n.exports = y), t._ = y), y.VERSION = "1.9.1";

        var b,
            _ = function _(e, t, n) {
          if (void 0 === t) return e;

          switch (null == n ? 3 : n) {
            case 1:
              return function (n) {
                return e.call(t, n);
              };

            case 3:
              return function (n, r, o) {
                return e.call(t, n, r, o);
              };

            case 4:
              return function (n, r, o, i) {
                return e.call(t, n, r, o, i);
              };
          }

          return function () {
            return e.apply(t, arguments);
          };
        },
            w = function w(e, t, n) {
          return y.iteratee !== b ? y.iteratee(e, t) : null == e ? y.identity : y.isFunction(e) ? _(e, t, n) : y.isObject(e) && !y.isArray(e) ? y.matcher(e) : y.property(e);
        };

        y.iteratee = b = function b(e, t) {
          return w(e, t, 1 / 0);
        };

        var E = function E(e, t) {
          return t = null == t ? e.length - 1 : +t, function () {
            for (var n = Math.max(arguments.length - t, 0), r = Array(n), o = 0; o < n; o++) {
              r[o] = arguments[o + t];
            }

            switch (t) {
              case 0:
                return e.call(this, r);

              case 1:
                return e.call(this, arguments[0], r);

              case 2:
                return e.call(this, arguments[0], arguments[1], r);
            }

            var i = Array(t + 1);

            for (o = 0; o < t; o++) {
              i[o] = arguments[o];
            }

            return i[t] = r, e.apply(this, i);
          };
        },
            O = function O(e) {
          if (!y.isObject(e)) return {};
          if (g) return g(e);
          v.prototype = e;
          var t = new v();
          return v.prototype = null, t;
        },
            S = function S(e) {
          return function (t) {
            return null == t ? void 0 : t[e];
          };
        },
            x = function x(e, t) {
          return null != e && p.call(e, t);
        },
            T = function T(e, t) {
          for (var n = t.length, r = 0; r < n; r++) {
            if (null == e) return;
            e = e[t[r]];
          }

          return n ? e : void 0;
        },
            k = Math.pow(2, 53) - 1,
            C = S("length"),
            A = function A(e) {
          var t = C(e);
          return "number" == typeof t && t >= 0 && t <= k;
        };

        y.each = y.forEach = function (e, t, n) {
          t = _(t, n);
          var r, o;
          if (A(e)) for (r = 0, o = e.length; r < o; r++) {
            t(e[r], r, e);
          } else {
            var i = y.keys(e);

            for (r = 0, o = i.length; r < o; r++) {
              t(e[i[r]], i[r], e);
            }
          }
          return e;
        }, y.map = y.collect = function (e, t, n) {
          t = w(t, n);

          for (var r = !A(e) && y.keys(e), o = (r || e).length, i = Array(o), a = 0; a < o; a++) {
            var s = r ? r[a] : a;
            i[a] = t(e[s], s, e);
          }

          return i;
        };

        var N = function N(e) {
          var t = function t(_t8, n, r, o) {
            var i = !A(_t8) && y.keys(_t8),
                a = (i || _t8).length,
                s = e > 0 ? 0 : a - 1;

            for (o || (r = _t8[i ? i[s] : s], s += e); s >= 0 && s < a; s += e) {
              var l = i ? i[s] : s;
              r = n(r, _t8[l], l, _t8);
            }

            return r;
          };

          return function (e, n, r, o) {
            var i = arguments.length >= 3;
            return t(e, _(n, o, 4), r, i);
          };
        };

        y.reduce = y.foldl = y.inject = N(1), y.reduceRight = y.foldr = N(-1), y.find = y.detect = function (e, t, n) {
          var r = A(e) ? y.findIndex : y.findKey,
              o = r(e, t, n);
          if (void 0 !== o && -1 !== o) return e[o];
        }, y.filter = y.select = function (e, t, n) {
          var r = [];
          return t = w(t, n), y.each(e, function (e, n, o) {
            t(e, n, o) && r.push(e);
          }), r;
        }, y.reject = function (e, t, n) {
          return y.filter(e, y.negate(w(t)), n);
        }, y.every = y.all = function (e, t, n) {
          t = w(t, n);

          for (var r = !A(e) && y.keys(e), o = (r || e).length, i = 0; i < o; i++) {
            var a = r ? r[i] : i;
            if (!t(e[a], a, e)) return !1;
          }

          return !0;
        }, y.some = y.any = function (e, t, n) {
          t = w(t, n);

          for (var r = !A(e) && y.keys(e), o = (r || e).length, i = 0; i < o; i++) {
            var a = r ? r[i] : i;
            if (t(e[a], a, e)) return !0;
          }

          return !1;
        }, y.contains = y.includes = y.include = function (e, t, n, r) {
          return A(e) || (e = y.values(e)), ("number" != typeof n || r) && (n = 0), y.indexOf(e, t, n) >= 0;
        }, y.invoke = E(function (e, t, n) {
          var r, o;
          return y.isFunction(t) ? o = t : y.isArray(t) && (r = t.slice(0, -1), t = t[t.length - 1]), y.map(e, function (e) {
            var i = o;

            if (!i) {
              if (r && r.length && (e = T(e, r)), null == e) return;
              i = e[t];
            }

            return null == i ? i : i.apply(e, n);
          });
        }), y.pluck = function (e, t) {
          return y.map(e, y.property(t));
        }, y.where = function (e, t) {
          return y.filter(e, y.matcher(t));
        }, y.findWhere = function (e, t) {
          return y.find(e, y.matcher(t));
        }, y.max = function (e, t, n) {
          var r,
              o,
              i = -1 / 0,
              a = -1 / 0;

          if (null == t || "number" == typeof t && "object" != typeof e[0] && null != e) {
            e = A(e) ? e : y.values(e);

            for (var s = 0, l = e.length; s < l; s++) {
              null != (r = e[s]) && r > i && (i = r);
            }
          } else t = w(t, n), y.each(e, function (e, n, r) {
            ((o = t(e, n, r)) > a || o === -1 / 0 && i === -1 / 0) && (i = e, a = o);
          });

          return i;
        }, y.min = function (e, t, n) {
          var r,
              o,
              i = 1 / 0,
              a = 1 / 0;

          if (null == t || "number" == typeof t && "object" != typeof e[0] && null != e) {
            e = A(e) ? e : y.values(e);

            for (var s = 0, l = e.length; s < l; s++) {
              null != (r = e[s]) && r < i && (i = r);
            }
          } else t = w(t, n), y.each(e, function (e, n, r) {
            ((o = t(e, n, r)) < a || o === 1 / 0 && i === 1 / 0) && (i = e, a = o);
          });

          return i;
        }, y.shuffle = function (e) {
          return y.sample(e, 1 / 0);
        }, y.sample = function (e, t, n) {
          if (null == t || n) return A(e) || (e = y.values(e)), e[y.random(e.length - 1)];
          var r = A(e) ? y.clone(e) : y.values(e),
              o = C(r);
          t = Math.max(Math.min(t, o), 0);

          for (var i = o - 1, a = 0; a < t; a++) {
            var s = y.random(a, i),
                l = r[a];
            r[a] = r[s], r[s] = l;
          }

          return r.slice(0, t);
        }, y.sortBy = function (e, t, n) {
          var r = 0;
          return t = w(t, n), y.pluck(y.map(e, function (e, n, o) {
            return {
              value: e,
              index: r++,
              criteria: t(e, n, o)
            };
          }).sort(function (e, t) {
            var n = e.criteria,
                r = t.criteria;

            if (n !== r) {
              if (n > r || void 0 === n) return 1;
              if (n < r || void 0 === r) return -1;
            }

            return e.index - t.index;
          }), "value");
        };

        var P = function P(e, t) {
          return function (n, r, o) {
            var i = t ? [[], []] : {};
            return r = w(r, o), y.each(n, function (t, o) {
              var a = r(t, o, n);
              e(i, t, a);
            }), i;
          };
        };

        y.groupBy = P(function (e, t, n) {
          x(e, n) ? e[n].push(t) : e[n] = [t];
        }), y.indexBy = P(function (e, t, n) {
          e[n] = t;
        }), y.countBy = P(function (e, t, n) {
          x(e, n) ? e[n]++ : e[n] = 1;
        });
        var R = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
        y.toArray = function (e) {
          return e ? y.isArray(e) ? d.call(e) : y.isString(e) ? e.match(R) : A(e) ? y.map(e, y.identity) : y.values(e) : [];
        }, y.size = function (e) {
          return null == e ? 0 : A(e) ? e.length : y.keys(e).length;
        }, y.partition = P(function (e, t, n) {
          e[n ? 0 : 1].push(t);
        }, !0), y.first = y.head = y.take = function (e, t, n) {
          return null == e || e.length < 1 ? null == t ? void 0 : [] : null == t || n ? e[0] : y.initial(e, e.length - t);
        }, y.initial = function (e, t, n) {
          return d.call(e, 0, Math.max(0, e.length - (null == t || n ? 1 : t)));
        }, y.last = function (e, t, n) {
          return null == e || e.length < 1 ? null == t ? void 0 : [] : null == t || n ? e[e.length - 1] : y.rest(e, Math.max(0, e.length - t));
        }, y.rest = y.tail = y.drop = function (e, t, n) {
          return d.call(e, null == t || n ? 1 : t);
        }, y.compact = function (e) {
          return y.filter(e, Boolean);
        };

        var I = function I(e, t, n, r) {
          r = r || [];

          for (var o = r.length, i = 0, a = C(e); i < a; i++) {
            var s = e[i];
            if (A(s) && (y.isArray(s) || y.isArguments(s))) {
              if (t) for (var l = 0, u = s.length; l < u;) {
                r[o++] = s[l++];
              } else I(s, t, n, r), o = r.length;
            } else n || (r[o++] = s);
          }

          return r;
        };

        y.flatten = function (e, t) {
          return I(e, t, !1);
        }, y.without = E(function (e, t) {
          return y.difference(e, t);
        }), y.uniq = y.unique = function (e, t, n, r) {
          y.isBoolean(t) || (r = n, n = t, t = !1), null != n && (n = w(n, r));

          for (var o = [], i = [], a = 0, s = C(e); a < s; a++) {
            var l = e[a],
                u = n ? n(l, a, e) : l;
            t && !n ? (a && i === u || o.push(l), i = u) : n ? y.contains(i, u) || (i.push(u), o.push(l)) : y.contains(o, l) || o.push(l);
          }

          return o;
        }, y.union = E(function (e) {
          return y.uniq(I(e, !0, !0));
        }), y.intersection = function (e) {
          for (var t = [], n = arguments.length, r = 0, o = C(e); r < o; r++) {
            var i = e[r];

            if (!y.contains(t, i)) {
              var a;

              for (a = 1; a < n && y.contains(arguments[a], i); a++) {
                ;
              }

              a === n && t.push(i);
            }
          }

          return t;
        }, y.difference = E(function (e, t) {
          return t = I(t, !0, !0), y.filter(e, function (e) {
            return !y.contains(t, e);
          });
        }), y.unzip = function (e) {
          for (var t = e && y.max(e, C).length || 0, n = Array(t), r = 0; r < t; r++) {
            n[r] = y.pluck(e, r);
          }

          return n;
        }, y.zip = E(y.unzip), y.object = function (e, t) {
          for (var n = {}, r = 0, o = C(e); r < o; r++) {
            t ? n[e[r]] = t[r] : n[e[r][0]] = e[r][1];
          }

          return n;
        };

        var M = function M(e) {
          return function (t, n, r) {
            n = w(n, r);

            for (var o = C(t), i = e > 0 ? 0 : o - 1; i >= 0 && i < o; i += e) {
              if (n(t[i], i, t)) return i;
            }

            return -1;
          };
        };

        y.findIndex = M(1), y.findLastIndex = M(-1), y.sortedIndex = function (e, t, n, r) {
          n = w(n, r, 1);

          for (var o = n(t), i = 0, a = C(e); i < a;) {
            var s = Math.floor((i + a) / 2);
            n(e[s]) < o ? i = s + 1 : a = s;
          }

          return i;
        };

        var j = function j(e, t, n) {
          return function (r, o, i) {
            var a = 0,
                s = C(r);
            if ("number" == typeof i) e > 0 ? a = i >= 0 ? i : Math.max(i + s, a) : s = i >= 0 ? Math.min(i + 1, s) : i + s + 1;else if (n && i && s) return i = n(r, o), r[i] === o ? i : -1;
            if (o !== o) return i = t(d.call(r, a, s), y.isNaN), i >= 0 ? i + a : -1;

            for (i = e > 0 ? a : s - 1; i >= 0 && i < s; i += e) {
              if (r[i] === o) return i;
            }

            return -1;
          };
        };

        y.indexOf = j(1, y.findIndex, y.sortedIndex), y.lastIndexOf = j(-1, y.findLastIndex), y.range = function (e, t, n) {
          null == t && (t = e || 0, e = 0), n || (n = t < e ? -1 : 1);

          for (var r = Math.max(Math.ceil((t - e) / n), 0), o = Array(r), i = 0; i < r; i++, e += n) {
            o[i] = e;
          }

          return o;
        }, y.chunk = function (e, t) {
          if (null == t || t < 1) return [];

          for (var n = [], r = 0, o = e.length; r < o;) {
            n.push(d.call(e, r, r += t));
          }

          return n;
        };

        var L = function L(e, t, n, r, o) {
          if (!(r instanceof t)) return e.apply(n, o);
          var i = O(e.prototype),
              a = e.apply(i, o);
          return y.isObject(a) ? a : i;
        };

        y.bind = E(function (e, t, n) {
          if (!y.isFunction(e)) throw new TypeError("Bind must be called on a function");
          var r = E(function (o) {
            return L(e, r, t, this, n.concat(o));
          });
          return r;
        }), y.partial = E(function (e, t) {
          var n = y.partial.placeholder,
              r = function r() {
            for (var o = 0, i = t.length, a = Array(i), s = 0; s < i; s++) {
              a[s] = t[s] === n ? arguments[o++] : t[s];
            }

            for (; o < arguments.length;) {
              a.push(arguments[o++]);
            }

            return L(e, r, this, this, a);
          };

          return r;
        }), y.partial.placeholder = y, y.bindAll = E(function (e, t) {
          t = I(t, !1, !1);
          var n = t.length;
          if (n < 1) throw new Error("bindAll must be passed function names");

          for (; n--;) {
            var r = t[n];
            e[r] = y.bind(e[r], e);
          }
        }), y.memoize = function (e, t) {
          var n = function n(r) {
            var o = n.cache,
                i = "" + (t ? t.apply(this, arguments) : r);
            return x(o, i) || (o[i] = e.apply(this, arguments)), o[i];
          };

          return n.cache = {}, n;
        }, y.delay = E(function (e, t, n) {
          return setTimeout(function () {
            return e.apply(null, n);
          }, t);
        }), y.defer = y.partial(y.delay, y, 1), y.throttle = function (e, t, n) {
          var r,
              o,
              i,
              a,
              s = 0;
          n || (n = {});

          var l = function l() {
            s = !1 === n.leading ? 0 : y.now(), r = null, a = e.apply(o, i), r || (o = i = null);
          },
              u = function u() {
            var u = y.now();
            s || !1 !== n.leading || (s = u);
            var c = t - (u - s);
            return o = this, i = arguments, c <= 0 || c > t ? (r && (clearTimeout(r), r = null), s = u, a = e.apply(o, i), r || (o = i = null)) : r || !1 === n.trailing || (r = setTimeout(l, c)), a;
          };

          return u.cancel = function () {
            clearTimeout(r), s = 0, r = o = i = null;
          }, u;
        }, y.debounce = function (e, t, n) {
          var r,
              o,
              i = function i(t, n) {
            r = null, n && (o = e.apply(t, n));
          },
              a = E(function (a) {
            if (r && clearTimeout(r), n) {
              var s = !r;
              r = setTimeout(i, t), s && (o = e.apply(this, a));
            } else r = y.delay(i, t, this, a);

            return o;
          });

          return a.cancel = function () {
            clearTimeout(r), r = null;
          }, a;
        }, y.wrap = function (e, t) {
          return y.partial(t, e);
        }, y.negate = function (e) {
          return function () {
            return !e.apply(this, arguments);
          };
        }, y.compose = function () {
          var e = arguments,
              t = e.length - 1;
          return function () {
            for (var n = t, r = e[t].apply(this, arguments); n--;) {
              r = e[n].call(this, r);
            }

            return r;
          };
        }, y.after = function (e, t) {
          return function () {
            if (--e < 1) return t.apply(this, arguments);
          };
        }, y.before = function (e, t) {
          var n;
          return function () {
            return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = null), n;
          };
        }, y.once = y.partial(y.before, 2), y.restArguments = E;

        var D = !{
          toString: null
        }.propertyIsEnumerable("toString"),
            F = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
            U = function U(e, t) {
          var n = F.length,
              r = e.constructor,
              o = y.isFunction(r) && r.prototype || l,
              i = "constructor";

          for (x(e, i) && !y.contains(t, i) && t.push(i); n--;) {
            (i = F[n]) in e && e[i] !== o[i] && !y.contains(t, i) && t.push(i);
          }
        };

        y.keys = function (e) {
          if (!y.isObject(e)) return [];
          if (m) return m(e);
          var t = [];

          for (var n in e) {
            x(e, n) && t.push(n);
          }

          return D && U(e, t), t;
        }, y.allKeys = function (e) {
          if (!y.isObject(e)) return [];
          var t = [];

          for (var n in e) {
            t.push(n);
          }

          return D && U(e, t), t;
        }, y.values = function (e) {
          for (var t = y.keys(e), n = t.length, r = Array(n), o = 0; o < n; o++) {
            r[o] = e[t[o]];
          }

          return r;
        }, y.mapObject = function (e, t, n) {
          t = w(t, n);

          for (var r = y.keys(e), o = r.length, i = {}, a = 0; a < o; a++) {
            var s = r[a];
            i[s] = t(e[s], s, e);
          }

          return i;
        }, y.pairs = function (e) {
          for (var t = y.keys(e), n = t.length, r = Array(n), o = 0; o < n; o++) {
            r[o] = [t[o], e[t[o]]];
          }

          return r;
        }, y.invert = function (e) {
          for (var t = {}, n = y.keys(e), r = 0, o = n.length; r < o; r++) {
            t[e[n[r]]] = n[r];
          }

          return t;
        }, y.functions = y.methods = function (e) {
          var t = [];

          for (var n in e) {
            y.isFunction(e[n]) && t.push(n);
          }

          return t.sort();
        };

        var B = function B(e, t) {
          return function (n) {
            var r = arguments.length;
            if (t && (n = Object(n)), r < 2 || null == n) return n;

            for (var o = 1; o < r; o++) {
              for (var i = arguments[o], a = e(i), s = a.length, l = 0; l < s; l++) {
                var u = a[l];
                t && void 0 !== n[u] || (n[u] = i[u]);
              }
            }

            return n;
          };
        };

        y.extend = B(y.allKeys), y.extendOwn = y.assign = B(y.keys), y.findKey = function (e, t, n) {
          t = w(t, n);

          for (var r, o = y.keys(e), i = 0, a = o.length; i < a; i++) {
            if (r = o[i], t(e[r], r, e)) return r;
          }
        };

        var V = function V(e, t, n) {
          return t in n;
        };

        y.pick = E(function (e, t) {
          var n = {},
              r = t[0];
          if (null == e) return n;
          y.isFunction(r) ? (t.length > 1 && (r = _(r, t[1])), t = y.allKeys(e)) : (r = V, t = I(t, !1, !1), e = Object(e));

          for (var o = 0, i = t.length; o < i; o++) {
            var a = t[o],
                s = e[a];
            r(s, a, e) && (n[a] = s);
          }

          return n;
        }), y.omit = E(function (e, t) {
          var n,
              r = t[0];
          return y.isFunction(r) ? (r = y.negate(r), t.length > 1 && (n = t[1])) : (t = y.map(I(t, !1, !1), String), r = function r(e, n) {
            return !y.contains(t, n);
          }), y.pick(e, r, n);
        }), y.defaults = B(y.allKeys, !0), y.create = function (e, t) {
          var n = O(e);
          return t && y.extendOwn(n, t), n;
        }, y.clone = function (e) {
          return y.isObject(e) ? y.isArray(e) ? e.slice() : y.extend({}, e) : e;
        }, y.tap = function (e, t) {
          return t(e), e;
        }, y.isMatch = function (e, t) {
          var n = y.keys(t),
              r = n.length;
          if (null == e) return !r;

          for (var o = Object(e), i = 0; i < r; i++) {
            var a = n[i];
            if (t[a] !== o[a] || !(a in o)) return !1;
          }

          return !0;
        };
        var H, q;
        H = function H(e, t, n, r) {
          if (e === t) return 0 !== e || 1 / e == 1 / t;
          if (null == e || null == t) return !1;
          if (e !== e) return t !== t;
          var o = typeof e;
          return ("function" === o || "object" === o || "object" == typeof t) && q(e, t, n, r);
        }, q = function q(e, t, n, r) {
          e instanceof y && (e = e._wrapped), t instanceof y && (t = t._wrapped);
          var o = f.call(e);
          if (o !== f.call(t)) return !1;

          switch (o) {
            case "[object RegExp]":
            case "[object String]":
              return "" + e == "" + t;

            case "[object Number]":
              return +e != +e ? +t != +t : 0 == +e ? 1 / +e == 1 / t : +e == +t;

            case "[object Date]":
            case "[object Boolean]":
              return +e == +t;

            case "[object Symbol]":
              return u.valueOf.call(e) === u.valueOf.call(t);
          }

          var i = "[object Array]" === o;

          if (!i) {
            if ("object" != typeof e || "object" != typeof t) return !1;
            var a = e.constructor,
                s = t.constructor;
            if (a !== s && !(y.isFunction(a) && a instanceof a && y.isFunction(s) && s instanceof s) && "constructor" in e && "constructor" in t) return !1;
          }

          n = n || [], r = r || [];

          for (var l = n.length; l--;) {
            if (n[l] === e) return r[l] === t;
          }

          if (n.push(e), r.push(t), i) {
            if ((l = e.length) !== t.length) return !1;

            for (; l--;) {
              if (!H(e[l], t[l], n, r)) return !1;
            }
          } else {
            var c,
                d = y.keys(e);
            if (l = d.length, y.keys(t).length !== l) return !1;

            for (; l--;) {
              if (c = d[l], !x(t, c) || !H(e[c], t[c], n, r)) return !1;
            }
          }

          return n.pop(), r.pop(), !0;
        }, y.isEqual = function (e, t) {
          return H(e, t);
        }, y.isEmpty = function (e) {
          return null == e || (A(e) && (y.isArray(e) || y.isString(e) || y.isArguments(e)) ? 0 === e.length : 0 === y.keys(e).length);
        }, y.isElement = function (e) {
          return !(!e || 1 !== e.nodeType);
        }, y.isArray = h || function (e) {
          return "[object Array]" === f.call(e);
        }, y.isObject = function (e) {
          var t = typeof e;
          return "function" === t || "object" === t && !!e;
        }, y.each(["Arguments", "Function", "String", "Number", "Date", "RegExp", "Error", "Symbol", "Map", "WeakMap", "Set", "WeakSet"], function (e) {
          y["is" + e] = function (t) {
            return f.call(t) === "[object " + e + "]";
          };
        }), y.isArguments(arguments) || (y.isArguments = function (e) {
          return x(e, "callee");
        });
        var W = i.document && i.document.childNodes;
        "function" != typeof /./ && "object" != typeof Int8Array && "function" != typeof W && (y.isFunction = function (e) {
          return "function" == typeof e || !1;
        }), y.isFinite = function (e) {
          return !y.isSymbol(e) && isFinite(e) && !isNaN(parseFloat(e));
        }, y.isNaN = function (e) {
          return y.isNumber(e) && isNaN(e);
        }, y.isBoolean = function (e) {
          return !0 === e || !1 === e || "[object Boolean]" === f.call(e);
        }, y.isNull = function (e) {
          return null === e;
        }, y.isUndefined = function (e) {
          return void 0 === e;
        }, y.has = function (e, t) {
          if (!y.isArray(t)) return x(e, t);

          for (var n = t.length, r = 0; r < n; r++) {
            var o = t[r];
            if (null == e || !p.call(e, o)) return !1;
            e = e[o];
          }

          return !!n;
        }, y.noConflict = function () {
          return i._ = a, this;
        }, y.identity = function (e) {
          return e;
        }, y.constant = function (e) {
          return function () {
            return e;
          };
        }, y.noop = function () {}, y.property = function (e) {
          return y.isArray(e) ? function (t) {
            return T(t, e);
          } : S(e);
        }, y.propertyOf = function (e) {
          return null == e ? function () {} : function (t) {
            return y.isArray(t) ? T(e, t) : e[t];
          };
        }, y.matcher = y.matches = function (e) {
          return e = y.extendOwn({}, e), function (t) {
            return y.isMatch(t, e);
          };
        }, y.times = function (e, t, n) {
          var r = Array(Math.max(0, e));
          t = _(t, n, 1);

          for (var o = 0; o < e; o++) {
            r[o] = t(o);
          }

          return r;
        }, y.random = function (e, t) {
          return null == t && (t = e, e = 0), e + Math.floor(Math.random() * (t - e + 1));
        }, y.now = Date.now || function () {
          return new Date().getTime();
        };

        var z = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#x27;",
          "`": "&#x60;"
        },
            $ = y.invert(z),
            K = function K(e) {
          var t = function t(_t9) {
            return e[_t9];
          },
              n = "(?:" + y.keys(e).join("|") + ")",
              r = RegExp(n),
              o = RegExp(n, "g");

          return function (e) {
            return e = null == e ? "" : "" + e, r.test(e) ? e.replace(o, t) : e;
          };
        };

        y.escape = K(z), y.unescape = K($), y.result = function (e, t, n) {
          y.isArray(t) || (t = [t]);
          var r = t.length;
          if (!r) return y.isFunction(n) ? n.call(e) : n;

          for (var o = 0; o < r; o++) {
            var i = null == e ? void 0 : e[t[o]];
            void 0 === i && (i = n, o = r), e = y.isFunction(i) ? i.call(e) : i;
          }

          return e;
        };
        var G = 0;
        y.uniqueId = function (e) {
          var t = ++G + "";
          return e ? e + t : t;
        }, y.templateSettings = {
          evaluate: /<%([\s\S]+?)%>/g,
          interpolate: /<%=([\s\S]+?)%>/g,
          escape: /<%-([\s\S]+?)%>/g
        };

        var Y = /(.)^/,
            J = {
          "'": "'",
          "\\": "\\",
          "\r": "r",
          "\n": "n",
          "\u2028": "u2028",
          "\u2029": "u2029"
        },
            Q = /\\|'|\r|\n|\u2028|\u2029/g,
            X = function X(e) {
          return "\\" + J[e];
        };

        y.template = function (e, t, n) {
          !t && n && (t = n), t = y.defaults({}, t, y.templateSettings);
          var r = RegExp([(t.escape || Y).source, (t.interpolate || Y).source, (t.evaluate || Y).source].join("|") + "|$", "g"),
              o = 0,
              i = "__p+='";
          e.replace(r, function (t, n, r, a, s) {
            return i += e.slice(o, s).replace(Q, X), o = s + t.length, n ? i += "'+\n((__t=(" + n + "))==null?'':_.escape(__t))+\n'" : r ? i += "'+\n((__t=(" + r + "))==null?'':__t)+\n'" : a && (i += "';\n" + a + "\n__p+='"), t;
          }), i += "';\n", t.variable || (i = "with(obj||{}){\n" + i + "}\n"), i = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + i + "return __p;\n";
          var a;

          try {
            a = new Function(t.variable || "obj", "_", i);
          } catch (e) {
            throw e.source = i, e;
          }

          var s = function s(e) {
            return a.call(this, e, y);
          };

          return s.source = "function(" + (t.variable || "obj") + "){\n" + i + "}", s;
        }, y.chain = function (e) {
          var t = y(e);
          return t._chain = !0, t;
        };

        var Z = function Z(e, t) {
          return e._chain ? y(t).chain() : t;
        };

        y.mixin = function (e) {
          return y.each(y.functions(e), function (t) {
            var n = y[t] = e[t];

            y.prototype[t] = function () {
              var e = [this._wrapped];
              return c.apply(e, arguments), Z(this, n.apply(y, e));
            };
          }), y;
        }, y.mixin(y), y.each(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (e) {
          var t = s[e];

          y.prototype[e] = function () {
            var n = this._wrapped;
            return t.apply(n, arguments), "shift" !== e && "splice" !== e || 0 !== n.length || delete n[0], Z(this, n);
          };
        }), y.each(["concat", "join", "slice"], function (e) {
          var t = s[e];

          y.prototype[e] = function () {
            return Z(this, t.apply(this._wrapped, arguments));
          };
        }), y.prototype.value = function () {
          return this._wrapped;
        }, y.prototype.valueOf = y.prototype.toJSON = y.prototype.value, y.prototype.toString = function () {
          return String(this._wrapped);
        }, r = [], void 0 !== (o = function () {
          return y;
        }.apply(t, r)) && (n.exports = o);
      }();
    }).call(t, n(49), n(471)(e));
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t) {
    e.exports = {
      AF: "Afghanistan",
      AX: "Åland Islands",
      AL: "Albania",
      DZ: "Algeria",
      AS: "American Samoa",
      AD: "Andorra",
      AO: "Angola",
      AI: "Anguilla",
      AQ: "Antarctica",
      AG: "Antigua and Barbuda",
      AR: "Argentina",
      AM: "Armenia",
      AW: "Aruba",
      AU: "Australia",
      AT: "Austria",
      AZ: "Azerbaijan",
      BS: "Bahamas",
      BH: "Bahrain",
      BD: "Bangladesh",
      BB: "Barbados",
      BY: "Belarus",
      BE: "Belgium",
      BZ: "Belize",
      BJ: "Benin",
      BM: "Bermuda",
      BT: "Bhutan",
      BO: "Bolivia, Plurinational State of",
      BA: "Bosnia and Herzegovina",
      BW: "Botswana",
      BV: "Bouvet Island",
      BR: "Brazil",
      IO: "British Indian Ocean Territory",
      VG: "Virgin Islands, British",
      BN: "Brunei Darussalam",
      BG: "Bulgaria",
      BF: "Burkina Faso",
      BI: "Burundi",
      KH: "Cambodia",
      CM: "Cameroon",
      CA: "Canada",
      CV: "Cape Verde",
      KY: "Cayman Islands",
      CF: "Central African Republic",
      TD: "Chad",
      CL: "Chile",
      CN: "China",
      CX: "Christmas Island",
      CO: "Colombia",
      KM: "Comoros",
      CG: "Congo",
      CK: "Cook Islands",
      CR: "Costa Rica",
      CI: "Côte d'Ivoire",
      HR: "Croatia",
      CU: "Cuba",
      CY: "Cyprus",
      CZ: "Czech Republic",
      CD: "Congo, the Democratic Republic of the",
      DK: "Denmark",
      DJ: "Djibouti",
      DM: "Dominica",
      DO: "Dominican Republic",
      TL: "Timor-Leste",
      EC: "Ecuador",
      EG: "Egypt",
      SV: "El Salvador",
      GQ: "Equatorial Guinea",
      ER: "Eritrea",
      EE: "Estonia",
      ET: "Ethiopia",
      FK: "Falkland Islands (Malvinas)",
      FO: "Faroe Islands",
      FJ: "Fiji",
      FI: "Finland",
      FR: "France",
      GF: "French Guiana",
      PF: "French Polynesia",
      TF: "French Southern Territories",
      GA: "Gabon",
      GM: "Gambia",
      GE: "Georgia",
      DE: "Germany",
      GH: "Ghana",
      GI: "Gibraltar",
      GR: "Greece",
      GL: "Greenland",
      GD: "Grenada",
      GP: "Guadeloupe",
      GU: "Guam",
      GT: "Guatemala",
      GG: "Guernsey",
      GN: "Guinea",
      GW: "Guinea-Bissau",
      GY: "Guyana",
      HT: "Haiti",
      HM: "Heard Island and McDonald Islands",
      HN: "Honduras",
      HK: "Hong Kong",
      HU: "Hungary",
      IS: "Iceland",
      IN: "India",
      ID: "Indonesia",
      IR: "Iran, Islamic Republic of",
      IQ: "Iraq",
      IE: "Ireland",
      IL: "Israel",
      IT: "Italy",
      JM: "Jamaica",
      JP: "Japan",
      JE: "Jersey",
      JO: "Jordan",
      KZ: "Kazakhstan",
      KE: "Kenya",
      KI: "Kiribati",
      KR: "Korea, Republic of",
      XK: "Kosovo, Republic of",
      KW: "Kuwait",
      KG: "Kyrgyzstan",
      LA: "Lao People's Democratic Republic",
      LV: "Latvia",
      LB: "Lebanon",
      LS: "Lesotho",
      LR: "Liberia",
      LY: "Libya",
      LI: "Liechtenstein",
      LT: "Lithuania",
      LU: "Luxembourg",
      MO: "Macao",
      MK: "Macedonia, the former Yugoslav Republic of",
      MG: "Madagascar",
      MW: "Malawi",
      MY: "Malaysia",
      MV: "Maldives",
      ML: "Mali",
      MT: "Malta",
      MH: "Marshall Islands",
      MQ: "Martinique",
      MR: "Mauritania",
      MU: "Mauritius",
      YT: "Mayotte",
      MX: "Mexico",
      FM: "Micronesia, Federated States of",
      MD: "Moldova, Republic of",
      MC: "Monaco",
      MN: "Mongolia",
      ME: "Montenegro",
      MS: "Montserrat",
      MA: "Morocco",
      MZ: "Mozambique",
      MM: "Myanmar",
      NA: "Namibia",
      NR: "Nauru",
      NP: "Nepal",
      NL: "Netherlands",
      AN: "Netherlands Antilles",
      NC: "New Caledonia",
      NZ: "New Zealand",
      NI: "Nicaragua",
      NE: "Niger",
      NG: "Nigeria",
      NU: "Niue",
      NF: "Norfolk Island",
      KP: "Korea, Democratic People's Republic of",
      MP: "Northern Mariana Islands",
      NO: "Norway",
      OM: "Oman",
      PK: "Pakistan",
      PW: "Palau",
      PS: "Palestine, State of",
      PA: "Panama",
      PG: "Papua New Guinea",
      PY: "Paraguay",
      PE: "Peru",
      PH: "Philippines",
      PN: "Pitcairn",
      PL: "Poland",
      PT: "Portugal",
      PR: "Puerto Rico",
      QA: "Qatar",
      RE: "Réunion",
      RO: "Romania",
      RU: "Russian Federation",
      RW: "Rwanda",
      SH: "Saint Helena, Ascension and Tristan da Cunha",
      KN: "Saint Kitts and Nevis",
      LC: "Saint Lucia",
      PM: "Saint Pierre and Miquelon",
      VC: "Saint Vincent and the Grenadines",
      WS: "Samoa",
      SM: "San Marino",
      ST: "São Tomé and Príncipe",
      SA: "Saudi Arabia",
      SN: "Senegal",
      RS: "Serbia",
      SC: "Seychelles",
      SL: "Sierra Leone",
      SG: "Singapore",
      SK: "Slovakia",
      SI: "Slovenia",
      SB: "Solomon Islands",
      SO: "Somalia",
      ZA: "South Africa",
      GS: "South Georgia and the South Sandwich Islands",
      SS: "South Sudan",
      ES: "Spain",
      LK: "Sri Lanka",
      SD: "Sudan",
      SR: "Suriname",
      SJ: "Svalbard and Jan Mayen",
      SZ: "Swaziland",
      SE: "Sweden",
      CH: "Switzerland",
      SY: "Syrian Arab Republic",
      TW: "Taiwan",
      TJ: "Tajikistan",
      TZ: "Tanzania, United Republic of",
      TH: "Thailand",
      TG: "Togo",
      TK: "Tokelau",
      TO: "Tonga",
      TT: "Trinidad and Tobago",
      TN: "Tunisia",
      TR: "Turkey",
      TM: "Turkmenistan",
      TC: "Turks and Caicos Islands",
      TV: "Tuvalu",
      VI: "Virgin Islands, U.S.",
      UG: "Uganda",
      UA: "Ukraine",
      AE: "United Arab Emirates",
      GB: "United Kingdom",
      US: "United States",
      UM: "United States Minor Outlying Islands",
      UY: "Uruguay",
      UZ: "Uzbekistan",
      VU: "Vanuatu",
      VA: "Holy See (Vatican City State)",
      VE: "Venezuela, Bolivarian Republic of",
      VN: "Viet Nam",
      WF: "Wallis and Futuna",
      EH: "Western Sahara",
      YE: "Yemen",
      ZM: "Zambia",
      ZW: "Zimbabwe"
    };
  }, function (e, t) {
    e.exports = {
      signout: "Sign Out",
      signin: "Sign In",
      signup: "Sign Up",
      remember: "Remember me",
      rememberDevice: "Trust this device",
      "rememberDevice.timebased": "Do not challenge me on this device for the next {0}",
      "rememberDevice.devicebased": "Do not challenge me on this device again",
      autoPush: "Send push automatically",
      unlockaccount: "Unlock account?",
      haveaccount: "Already have an account?",
      needhelp: "Need help signing in?",
      forgotpassword: "Forgot password?",
      help: "Help",
      retry: "Retry",
      iphone: "iPhone",
      android: "Android",
      goback: "Back to Sign In",
      backToSignin: "Back to sign in",
      closeWindow: "You can close this window",
      "country.label": "Country",
      "phone.extention.label": "Extension",
      "skip.to.main.content": "Skip to main content",
      "minutes.oneMinute": "minute",
      minutes: "{0} minutes",
      hours: "{0} hours",
      days: "{0} days",
      "error.config": "There was a configuration error",
      "error.required.authParams": 'Missing parameters for the configured authentication scheme - "OAUTH2"',
      "error.required.baseUrl": '"baseUrl" is a required widget parameter',
      "error.required.success": "A success handler is required",
      "error.required.el": '"el" is a required widget parameter',
      "error.invalid.colors.brand": '"colors.brand" must be in six-digit hex format',
      "error.unsupported.browser": "Unsupported browser",
      "error.unsupported.cors": "Unsupported browser - missing CORS support",
      "error.unsupported.localStorage": "Unsupported browser - missing localStorage support",
      "error.enabled.cors": "There was an error sending the request - have you enabled CORS?",
      "error.expired.session": "Your session has expired. Please try to sign in again.",
      "error.mfa.only.expired.session": "Unable to authenticate at this time.",
      "error.auth.lockedOut": "Your account is locked. Please contact your administrator.",
      "error.oauth.idToken": "There was a problem generating the id_token for the user. Please try again.",
      "error.network.connection": "Unable to connect to the server. Please check your network connection.",
      "error.username.required": "Please enter a username",
      "error.password.required": "Please enter a password",
      "error.mfa.required": "The current sign on policy requires this client to redirect for re-authentication or MFA. Please contact your administrator.",
      "errors.E0000004": "Unable to sign in",
      "errors.E0000069": "Your account is locked because of too many authentication attempts.",
      "errors.E0000047": "You exceeded the maximum number of requests. Try again in a while.",
      "errors.E0000079": "The operation is not allowed. Please refresh the page to proceed.",
      "errors.E0000001": "Api validation failed: {0}",
      "errors.E0000002": "The request was not valid: {0}",
      "errors.E0000003": "The request body was not well-formed.",
      "errors.E0000005": "Invalid session",
      "errors.E0000006": "You do not have permission to perform the requested action",
      "errors.E0000007": "Not found: {0}",
      "errors.E0000008": "The requested path was not found",
      "errors.E0000009": "Internal Server Error",
      "errors.E0000010": "Service is in read only mode",
      "errors.E0000011": "Invalid token provided",
      "errors.E0000012": "Unsupported media type",
      "errors.E0000013": "Invalid client app id",
      "errors.E0000015": "You do not have permission to access the feature you are requesting",
      "errors.E0000016": "Activation failed because the user is already active",
      "errors.E0000017": "Password reset failed",
      "errors.E0000018": "Bad request.  Accept and/or Content-Type headers are likely not set.",
      "errors.E0000019": "Bad request.  Accept and/or Content-Type headers likely do not match supported values.",
      "errors.E0000020": "Bad request.",
      "errors.E0000021": "Bad request.  Accept and/or Content-Type headers likely do not match supported values.",
      "errors.E0000022": "The endpoint does not support the provided HTTP method",
      "errors.E0000023": "Operation failed because user profile is mastered under another system",
      "errors.E0000024": "Bad request.  This operation on app metadata is not yet supported.",
      "errors.E0000025": "App version assignment failed.",
      "errors.E0000026": "This endpoint has been deprecated.",
      "errors.E0000027": "Group push bad request : {0}",
      "errors.E0000028": "The request is missing a required parameter.",
      "errors.E0000029": "Invalid paging request.",
      "errors.E0000030": "Bad request. Invalid date. Dates must be of the form yyyy-MM-dd''T''HH:mm:ss.SSSZZ, e.g. 2013-01-01T12:00:00.000-07:00.",
      "errors.E0000031": "Invalid search criteria.",
      "errors.E0000032": "Unlock is not allowed for this user.",
      "errors.E0000033": "Bad request. Can't specify a search query and filter in the same request.",
      "errors.E0000034": "Forgot password not allowed on specified user.",
      "errors.E0000035": "Change password not allowed on specified user.",
      "errors.E0000036": "Change recovery question not allowed on specified user.",
      "errors.E0000037": "Type mismatch exception.",
      "errors.E0000038": "This operation is not allowed in the user''s current status.",
      "errors.E0000039": "Operation on application settings failed.",
      "errors.E0000040": "Application label must not be the same as an existing application label.",
      "errors.E0000041": "Credentials should not be set on this resource based on the scheme.",
      "errors.E0000042": "Setting the error page redirect URL failed.",
      "errors.E0000043": "Self service application assignment is not enabled.",
      "errors.E0000044": "Self service application assignment is not supported.",
      "errors.E0000045": "Field mapping bad request.",
      "errors.E0000046": "Deactivate application for user forbidden.",
      "errors.E0000048": "Entity not found exception.",
      "errors.E0000049": "Invalid SCIM data from SCIM implementation.",
      "errors.E0000050": "Invalid SCIM data from client.",
      "errors.E0000051": "No response from SCIM implementation.",
      "errors.E0000052": "Endpoint not implemented.",
      "errors.E0000053": "Invalid SCIM filter.",
      "errors.E0000054": "Invalid pagination properties.",
      "errors.E0000055": "Duplicate group.",
      "errors.E0000056": "Delete application forbidden.",
      "errors.E0000057": "Access to this application is denied due to a policy.",
      "errors.E0000058": "Access to this application requires MFA: {0}",
      "errors.E0000059": "The connector configuration could not be tested. Make sure that the URL, Authentication Parameters are correct and that there is an implementation available at the URL provided.",
      "errors.E0000060": "Unsupported operation.",
      "errors.E0000061": "Tab error: {0}",
      "errors.E0000062": "The specified user is already assigned to the application.",
      "errors.E0000063": "Invalid combination of parameters specified.",
      "errors.E0000064": "Password is expired and must be changed.",
      "errors.E0000065": "Internal error processing app metadata.",
      "errors.E0000066": "APNS is not configured, contact your admin",
      "errors.E0000067": "Factors Service Error.",
      "errors.E0000070": "Waiting for ACK",
      "errors.E0000071": "Unsupported OS Version: {0}",
      "errors.E0000072": "MIM policy settings have disallowed enrollment for this user",
      "errors.E0000073": "User rejected authentication",
      "errors.E0000074": "Factor Service Error",
      "errors.E0000075": "Cannot modify the {0} attribute because it has a field mapping and profile push is enabled.",
      "errors.E0000076": "Cannot modify the app user because it is mastered by an external app.",
      "errors.E0000077": "Cannot modify the {0} attribute because it is read-only.",
      "errors.E0000078": "Cannot modify the {0} attribute because it is immutable.",
      "errors.E0000081": "Cannot modify the {0} attribute because it is a reserved attribute for this application.",
      "errors.E0000082": "Each code can only be used once. Please wait for a new code and try again.",
      "errors.E0000083": "PassCode is valid but exceeded time window.",
      "errors.E0000084": "App evaluation error.",
      "errors.E0000085": "You do not have permission to access your account at this time.",
      "errors.E0000086": "This policy cannot be activated at this time.",
      "errors.E0000087": "The recovery question answer did not match our records.",
      "errors.E0000090": "The role specified is already assigned to the user.",
      "errors.E0000091": "The provided role type was not the same as required role type.",
      "errors.E0000092": "Access to this application requires re-authentication: {0}",
      "errors.E0000093": "Target count limit exceeded",
      "errors.E0000094": "The provided filter is unsupported.",
      "errors.E0000095": "Recovery not allowed for unknown user.",
      "errors.E0000096": "This certificate has already been uploaded with kid={0}.",
      "errors.E0000097": "There is no verified phone number on file.",
      "errors.E0000098": "This phone number is invalid.",
      "errors.E0000099": "Only numbers located in US and Canada are allowed.  Contact your administrator if this is a problem.",
      "errors.E0000100": "Unable to perform search query.",
      "errors.E0000101": "Upload failed because of a problem with your ipa file, {0}",
      "errors.E0000102": "YubiKey cannot be deleted while assigned to an user. Please deactivate YubiKey using reset MFA and try again",
      "errors.E0000103": "Action on device already in queue or in progress",
      "errors.E0000104": "Device is already locked and cannot be locked again",
      "errors.E0000105": "You have accessed an account recovery link that has expired or been previously used.",
      "errors.E0000106": "Wait for token to change, then enter the new tokencode.",
      "errors.E0000107": "The entity is not in the expected state for the requested transition.",
      "errors.E0000109": "An SMS message was recently sent. Please wait 30 seconds before trying again.",
      "errors.E0000110": "You have accessed a link that has expired or has been previously used.",
      "errors.E0000111": "Cannot modify the {0} object because it is read-only.",
      "errors.E0000112": "Cannot update this user because they are still being activated. Please try again in a few minutes.",
      "errors.E0000113": "{0}.",
      "errors.E0000114": "A user with this login already exists in the current organization.",
      "errors.E0000115": "Upload failed, {0}",
      "errors.E0000116": "{0}",
      "errors.E0000119": "Your account is locked. Please contact your administrator.",
      "errors.E0000124": "Could not create user. To create a user and expire their password immediately, a password must be specified",
      "errors.E0000125": 'Could not create user. To create a user and expire their password immediately, "activate" must be true',
      "errors.E0000133": "A phone call was recently made. Please wait 30 seconds before trying again.",
      "oform.next": "Next",
      "oform.verify": "Verify",
      "oform.send": "Send",
      "oform.back": "Back",
      "oform.title.authenticate": "Authenticate",
      "oform.save": "Save",
      "oform.cancel": "Cancel",
      "oform.edit": "Edit",
      "oform.previous": "Previous",
      "oform.error.icon.ariaLabel": "Error",
      "oform.errorbanner.title": "We found some errors. Please review the form and make corrections.",
      "oform.errormsg.title": "Please review the form to correct the following errors:",
      "oform.error.unexpected": "There was an unexpected internal error. Please try again.",
      "model.validation.field.blank": "This field cannot be left blank",
      "model.validation.field.wrong.type": "This field is of the wrong type",
      "model.validation.field.invalid": "This field has an invalid value",
      "model.validation.field.value.not.allowed": "This field value is not allowed",
      "model.validation.field.array.minItems": "This array does not have enough items",
      "model.validation.field.array.maxItems": "This array contains too many items",
      "model.validation.field.array.unique": "This array can only have unique values",
      "model.validation.field.string.minLength": "This field cannot be less than the minimum required characters",
      "model.validation.field.string.maxLength": "This field cannot exceed the maximum allowed characters",
      "model.validation.field.invalid.format.email": "This value is not a valid email address",
      "model.validation.field.invalid.format.uri": "This value is not a valid URI",
      "model.validation.field.invalid.format.ipv4": "This value is not a valid IPv4 address",
      "model.validation.field.invalid.format.hostname": "This value is not a valid hostname",
      "model.validation.field.username": "Please check your username",
      "factor.totpSoft.oktaVerify": "Okta Verify",
      "factor.totpSoft.googleAuthenticator": "Google Authenticator",
      "factor.totpSoft.description": "Enter single-use code from the mobile app.",
      "factor.totpHard.rsaSecurId": "RSA SecurID",
      "factor.totpHard.symantecVip": "Symantec VIP",
      "factor.totpHard.description": "Enter a single-use code from a hardware token.",
      "factor.totpHard.yubikey": "YubiKey",
      "factor.totpHard.yubikey.description": "Insert your YubiKey and tap it to get a verification code.",
      "factor.totpHard.yubikey.placeholder": "Click here, then tap your YubiKey",
      "factor.oktaVerifyPush": "Okta Verify",
      "factor.push.description": "Use a push notification sent to the mobile app.",
      "factor.duo": "Duo Security",
      "factor.duo.description": "Use Push Notification, SMS, or Voice call to authenticate.",
      "factor.sms": "SMS Authentication",
      "factor.sms.description": "Enter a single-use code sent to your mobile phone.",
      "factor.sms.time.warning": 'Haven\'t received an SMS? To try again, click <span style="font-weight:bold">Re-send code</span>.',
      "factor.call": "Voice Call Authentication",
      "factor.call.description": "Use a phone to authenticate by following voice instructions.",
      "factor.call.time.warning": 'Haven\'t received a voice call? To try again, click <span style="font-weight:bold">Redial</span>.',
      "factor.securityQuestion": "Security Question",
      "factor.securityQuestion.description": "Use the answer to a security question to authenticate.",
      "factor.windowsHello": "Windows Hello",
      "factor.windowsHello.signin.description": "Sign in to Okta using Windows Hello.",
      "factor.windowsHello.signin.description.generic": "Sign in using Windows Hello.",
      "factor.windowsHello.signin.description.specific": "Sign in to {0} using Windows Hello.",
      "factor.u2f": "Security Key (U2F)",
      "factor.u2f.description": "Use a Universal 2nd Factor (U2F) security key to sign on to Okta.",
      "factor.u2f.description.generic": "Use a Universal 2nd Factor (U2F) security key to sign in.",
      "factor.u2f.description.specific": "Use a Universal 2nd Factor (U2F) security key to sign in to {0}.",
      "factor.email": "Email Authentication",
      "factor.email.description": "Enter a verification code sent to your email.",
      "factor.password": "Password",
      "factor.customFactor.description": "Redirect to a third party MFA provider to sign in to Okta.",
      "factor.customFactor.description.generic": "Redirect to a third party MFA provider to sign in.",
      "factor.customFactor.description.specific": "Redirect to a third party MFA provider to sign in to {0}.",
      "factor.webauthn.biometric": "Security Key or Biometric Authenticator",
      "factor.webauthn.biometric.description": "Use a security key (USB or bluetooth) or a biometric authenticator (Windows Hello, Touch ID, etc.)",
      "factor.hotp.description": "Enter a single-use code from an authenticator.",
      "mfa.challenge.verify": "Verify",
      "mfa.challenge.answer.placeholder": "Answer",
      "mfa.challenge.answer.tooltip": "Answer",
      "mfa.challenge.answer.showAnswer": "Show",
      "mfa.challenge.answer.hideAnswer": "Hide",
      "mfa.challenge.enterCode.placeholder": "Enter Code",
      "mfa.challenge.enterCode.tooltip": "Enter Code",
      "mfa.challenge.password.placeholder": "Password",
      "mfa.backToFactors": "Back to factor list",
      "mfa.enroll": "Enroll",
      "mfa.phoneNumber.placeholder": "Phone number",
      "mfa.phoneNumber.ext.placeholder": "Extension",
      "mfa.sendCode": "Send code",
      "mfa.sent": "Sent",
      "mfa.resendCode": "Re-send code",
      "mfa.call": "Call",
      "mfa.calling": "Calling",
      "mfa.redial": "Redial",
      "mfa.sendEmail": "Send email",
      "mfa.resendEmail": "Re-send email",
      "mfa.scanBarcode": "Scan barcode",
      "mfa.altQrCode": "qr code",
      "mfa.noAccessToEmail": "Can't access email",
      "password.reset": "Reset Password",
      "password.oldPassword.placeholder": "Old password",
      "password.oldPassword.tooltip": "Old password",
      "password.newPassword.placeholder": "New password",
      "password.newPassword.tooltip": "New password",
      "password.confirmPassword.placeholder": "Repeat password",
      "password.confirmPassword.tooltip": "Repeat password",
      "password.error.match": "New passwords must match",
      "password.enroll.error.match": "Passwords must match",
      "recovery.sms.hint": "SMS can only be used if a mobile phone number has been configured.",
      "recovery.mobile.hint": "{0} can only be used if a mobile phone number has been configured.",
      "recovery.sms": "SMS",
      "recovery.call": "Voice Call",
      "recovery.smsOrCall": "SMS or Voice Call",
      "verify.choices.description": "Verify with one of the following factors.",
      "email.button.send": "Send me the code",
      "email.button.resend": "Send again",
      "email.code.label": "Verification code",
      "email.code.not.received": "Haven't received an email?",
      "email.enroll.title": "Set up Email Authentication",
      "email.enroll.description": "Send a verification code to your registered email.",
      "email.enroll.enterCode": "Enter code",
      "email.link.terminal.msg": "To finish signing in, return to the screen where you requested the email link.",
      "email.mfa.title": "Verify with Email Authentication",
      "email.mfa.description": "Send a verification code to {0}.",
      "email.mfa.email.sent.description": "A verification code was sent to {0}. Check your email and enter the code below.",
      "email.mfa.email.sent.description.sentText": "A verification code was sent to",
      "email.mfa.email.sent.description.emailCodeText": "Check your email and enter the code below.",
      "enroll.choices.title": "Set up multifactor authentication",
      "enroll.choices.description": "Your company requires multifactor authentication to add an additional layer of security when signing in to your Okta account",
      "enroll.choices.description.generic": "Your company requires multifactor authentication to add an additional layer of security when signing in to your account",
      "enroll.choices.description.specific": "Your company requires multifactor authentication to add an additional layer of security when signing in to your {0} account",
      "enroll.choices.description.gracePeriod.bold": "Your company recommends setting up additional factors for authentication. Set up will be required in: <b>{0} day(s)</b>.",
      "enroll.choices.description.gracePeriod.oneDay.bold": "Your company recommends setting up additional factors for authentication. Set up will be required in: <b>less than 1 day</b>.",
      "enroll.choices.optional": "You can configure any additional optional factor or click finish",
      "enroll.choices.list.setup": "Setup required",
      "enroll.choices.list.enrolled": "Enrolled factors",
      "enroll.choices.list.optional": "Additional optional factors",
      "enroll.choices.setup": "Setup",
      "enroll.choices.setup.another": "Set up another",
      "enroll.choices.submit.finish": "Finish",
      "enroll.choices.submit.configure": "Configure factor",
      "enroll.choices.submit.next": "Configure next factor",
      "enroll.choices.cardinality.setup": "({0} set up)",
      "enroll.choices.cardinality.setup.remaining": "({0} of {1} set up)",
      "enroll.choices.setup.skip": "Skip set up",
      "enroll.securityQuestion.setup": "Setup secret question authentication",
      "security.disliked_food": "What is the food you least liked as a child?",
      "security.name_of_first_plush_toy": "What is the name of your first stuffed animal?",
      "security.first_award": "What did you earn your first medal or award for?",
      "security.favorite_security_question": "What is your favorite security question?",
      "security.favorite_toy": "What is the toy/stuffed animal you liked the most as a kid?",
      "security.first_computer_game": "What was the first computer game you played?",
      "security.favorite_movie_quote": "What is your favorite movie quote?",
      "security.first_sports_team_mascot": "What was the mascot of the first sports team you played on?",
      "security.first_music_purchase": "What music album or song did you first purchase?",
      "security.favorite_art_piece": "What is your favorite piece of art?",
      "security.grandmother_favorite_desert": "What was your grandmother's favorite dessert?",
      "security.first_thing_cooked": "What was the first thing you learned to cook?",
      "security.childhood_dream_job": "What was your dream job as a child?",
      "security.first_kiss_location": "Where did you have your first kiss?",
      "security.place_where_significant_other_was_met": "Where did you meet your spouse/significant other?",
      "security.favorite_vacation_location": "Where did you go for your favorite vacation?",
      "security.new_years_two_thousand": "Where were you on New Year's Eve in the year 2000?",
      "security.favorite_speaker_actor": "Who is your favorite speaker/orator?",
      "security.favorite_book_movie_character": "Who is your favorite book/movie character?",
      "security.favorite_sports_player": "Who is your favorite sports player?",
      "enroll.password.setup": "Select a password",
      "save.password": "Save password",
      "enroll.sms.setup": "Receive a code via SMS to authenticate",
      "enroll.sms.try_again": "The number you entered seems invalid. If the number is correct, please try again.",
      "enroll.call.setup": "Follow phone call instructions to authenticate",
      "enroll.onprem.username.placeholder": "Enter {0} username",
      "enroll.onprem.username.tooltip": "Enter {0} username",
      "enroll.onprem.passcode.placeholder": "Enter {0} passcode",
      "enroll.onprem.passcode.tooltip": "Enter {0} passcode",
      "enroll.symantecVip.subtitle": "Enter Credential ID and two consecutive generated codes",
      "enroll.symantecVip.credentialId.placeholder": "Enter credential ID",
      "enroll.symantecVip.credentialId.tooltip": "Enter credential ID",
      "enroll.symantecVip.passcode1.placeholder": "Security code 1",
      "enroll.symantecVip.passcode1.tooltip": "Security code 1",
      "enroll.symantecVip.passcode2.placeholder": "Security code 2",
      "enroll.symantecVip.passcode2.tooltip": "Security code 2",
      "enroll.yubikey.title": "Setup YubiKey",
      "enroll.yubikey.subtitle": "Insert your YubiKey into a USB port and tap it to generate a verification code",
      "enroll.totp.title": "Setup {0}",
      "enroll.totp.selectDevice": "Select your device type",
      "enroll.totp.downloadApp": 'Download <a href="{0}" class="inline-link">{1} from the {2}</a> onto your mobile device.',
      "enroll.hotp.restricted": "Contact your administrator to continue enrollment.",
      "enroll.duo.title": "Setup Duo Security",
      "enroll.windowsHello.title": "Enroll Windows Hello",
      "enroll.windowsHello.subtitle": "Click below to enroll Windows Hello as a second form of authentication",
      "enroll.windowsHello.subtitle.loading": "Please wait while Windows Hello is loading...",
      "enroll.windowsHello.save": "Enroll Windows Hello",
      "enroll.windowsHello.error.notWindows": "Windows Hello can only be used on Windows Edge with Windows 10. Contact your admin for assistance.",
      "enroll.windowsHello.error.notConfiguredHtml": "Windows Hello is not configured. Select the <b>Start</b> button, then select <b>Settings</b> - <b>Accounts</b> - <b>Sign-in</b> to configure Windows Hello.",
      "verify.windowsHello.subtitle": "Verify your identity with Windows Hello",
      "verify.windowsHello.subtitle.loading": "Please wait while Windows Hello is loading...",
      "verify.windowsHello.subtitle.signingIn": "Signing in to Okta...",
      "verify.windowsHello.subtitle.signingIn.generic": "Signing in...",
      "verify.windowsHello.subtitle.signingIn.specific": "Signing in to {0}...",
      "verify.windowsHello.save": "Verify with Windows Hello",
      "verify.windowsHello.error.notFound": "Your Windows Hello enrollment does not match our records. Contact your administrator for assistance.",
      "verify.windowsHello.error.notFound.selectAnother": "Your Windows Hello enrollment does not match our records. Select another factor or contact your administrator for assistance.",
      "enroll.u2f.title": "Setup Security Key (U2F)",
      "enroll.u2f.save": "Register Security Key",
      "enroll.u2f.general2": "Make sure you have a Security Key. If already inserted, remove it now.<br>If you have a Bluetooth Security Key, turn on your computer's Bluetooth.",
      "enroll.u2f.general3": "Click the button below to register",
      "enroll.u2f.instructions": "Insert your Security Key into a USB port on this computer. If it has a button or gold disk, tap it.",
      "enroll.u2f.instructionsBluetooth": "If you are using a Bluetooth Security Key, press the button.",
      "u2f.error.factorNotSupported": "Security Key (U2F) is not supported on this browser. Select another factor or contact your admin for assistance.",
      "u2f.error.factorNotSupported.oneFactor": "Security Key (U2F) is not supported on this browser. Contact your admin for assistance.",
      "u2f.error.other": "An unknown error has occured. Try again or select another factor.",
      "u2f.error.other.oneFactor": "An unknown error has occured. Try again or contact your admin for assistance.",
      "u2f.error.badRequest": "There was an error with the U2F request. Try again or select another factor.",
      "u2f.error.badRequest.oneFactor": "There was an error with the U2F request. Try again or contact your admin for assistance.",
      "u2f.error.unsupported": "The security key is unsupported. Select another factor.",
      "u2f.error.unsupported.oneFactor": "The security key is unsupported. Contact your admin for assistance.",
      "u2f.error.timeout": "You have timed out of the authentication period. Please try again.",
      "verify.u2f.instructions": "Insert your Security Key. If it has a button or gold disk, tap it.",
      "verify.u2f.instructionsBluetooth": "If you are using a Bluetooth Security Key, turn on your computer's Bluetooth and press the button.",
      "verify.u2f.retry": "Retry",
      "enroll.customFactor.subtitle": "Clicking below will redirect to MFA enrollment with {0}",
      "enroll.customFactor.save": "Enroll",
      "verify.customFactor.subtitle": "Clicking below will redirect to verification with {0}",
      "enroll.webauthn.biometric.title": "Set up security key or biometric authenticator",
      "enroll.webauthn.save": "Enroll",
      "enroll.webauthn.biometric.instructions": "Your browser will prompt to register a security key or biometric authenticator (Windows Hello, Touch ID, etc.). Follow the instructions to complete enrollment.",
      "enroll.webauthn.biometric.instructions.edge": "Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select '<b>Cancel</b>' in the prompt before continuing.",
      "verify.webauthn.biometric.instructions": "Your browser or device will prompt you to verify with a security key or biometric authenticator. Follow the instructions to complete authentication.",
      "webauthn.biometric.error.factorNotSupported": "Security key or biometric authenticator is not supported on this browser. Select another factor or contact your admin for assistance.",
      "webauthn.biometric.error.factorNotSupported.oneFactor": "Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.",
      "enroll.webauthn.instructions.noSupportForBiometric": "Note: Some browsers may not support biometric authenticators.",
      "authfactor.webauthn.error": "You are currently unable to use a Security key or biometric authenticator. Try again.",
      "enroll.totp.enterCode": "Enter code displayed from the application",
      "enroll.totp.setupApp": "Launch {0} application on your mobile device and select Add an account.",
      "enroll.totp.setupGoogleAuthApp": 'Launch {0}, tap the "+" icon, then select "Scan barcode".',
      "enroll.totp.cannotScan": "Can't scan?",
      "enroll.totp.refreshBarcode": "Refresh code",
      "enroll.totp.cannotScanBarcode": "Can't scan barcode?",
      "enroll.totp.manualSetupInstructions": "To set up manually enter your Okta Account username and then input the following in the Secret Key Field",
      "enroll.totp.manualSetupInstructions.generic": "To set up manually enter your Account username and then input the following in the Secret Key Field",
      "enroll.totp.manualSetupInstructions.specific": "To set up manually enter your {0} Account username and then input the following in the Secret Key Field",
      "enroll.totp.sharedSecretInstructions": "Enter your Okta Account username and enter the following in the Secret Key Field",
      "enroll.totp.sharedSecretInstructions.generic": "Enter your Account username and enter the following in the Secret Key Field",
      "enroll.totp.sharedSecretInstructions.specific": "Enter your {0} Account username and enter the following in the Secret Key Field",
      "enroll.totp.sendSms": "Send activation link via SMS",
      "enroll.totp.sendEmail": "Send activation link via email",
      "enroll.totp.setupManually": "Setup manually without push notification",
      "enroll.totp.enrollViaEmail.title": "Activation email sent!",
      "enroll.totp.enrollViaEmail.msg": "Open the email from your mobile device.",
      "enroll.totp.enrollViaSms.title": "SMS sent!",
      "enroll.totp.enrollViaSms.msg": "View the SMS on your mobile device.",
      "recoveryChallenge.sms.title": "Enter verification code sent via SMS",
      "recoveryChallenge.call.title": "Enter verification code received via Voice Call",
      "mfa.factors.dropdown.title": "Select an authentication factor",
      "mfa.factors.dropdown.sr.text": "Select Authentication Factor - {0} Factor Selected",
      "mfa.duoSecurity.push": "Push — {0}",
      "mfa.duoSecurity.sms": "SMS — {0}",
      "mfa.duoSecurity.call": "Call — {0}",
      "mfa.switch": "Switch Factor",
      "mfa.challenge.title": "Enter your {0} passcode",
      "mfa.challenge.orEnterCode": "Or enter code",
      "mfa.challenge.totp.subtitle.multiple": "Enter code from any registered {0} device.",
      "mfa.emailVerification.checkEmail": "To finish signing in, click the link in your email.",
      "mfa.emailVerification.title": "Sign in using a link sent to your email.",
      "mfa.emailVerification.subtitle": "Emails will be sent to {0}",
      "mfa.emailVerification.otc.finish": "To finish signing in, enter the code which was emailed to you.",
      "oktaverify.send": "Send Push",
      "oktaverify.resend": "Re-send Push",
      "oktaverify.sent": "Push sent!",
      "oktaverify.rejected": "You have chosen to reject this login.",
      "oktaverify.rejected.upgradeRequired.ios": "Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on the App Store, then try again.",
      "oktaverify.rejected.upgradeRequired.android": "Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on Google Play, then try again.",
      "oktaverify.timeout": "Your push notification has expired.",
      "oktaverify.warning": "Haven't received a push notification yet? Try opening the Okta Verify App on your phone.",
      "oktaverify.numberchallenge.instruction": 'On your phone, tap <span class="challenge-number">{0}</span> on Okta Verify prompt to continue.',
      "oktaverify.numberchallenge.explain": "This extra step helps us make sure it's really you signing in.",
      "primaryauth.title": "Sign In",
      "primaryauth.username.placeholder": "Username",
      "primaryauth.username.tooltip": "Username",
      "primaryauth.password.placeholder": "Password",
      "primaryauth.password.tooltip": "Password",
      "primaryauth.submit": "Sign In",
      "primaryauth.newUser.tooltip": "This is the first time you are connecting to {0} from this browser",
      "primaryauth.newUser.tooltip.close": "Close",
      "oktaVerify.description": "To access this resource, your organization requires you to sign in using your device.",
      "oktaVerify.button": "Sign in using Okta Verify on this device",
      "idpDiscovery.email.placeholder": "Email",
      "password.forgot.email.or.username.placeholder": "Email or Username",
      "password.forgot.email.or.username.tooltip": "Email or Username",
      "password.forgot.sendText": "Reset via SMS",
      "password.forgot.sendEmail": "Reset via Email",
      "password.forgot.call": "Reset via Voice Call",
      "password.forgot.emailSent.title": "Email sent!",
      "password.forgot.emailSent.desc": "Email has been sent to {0} with instructions on resetting your password.",
      "password.forgot.question.title": "Answer Forgotten Password Challenge",
      "password.forgot.question.submit": "Reset Password",
      "password.forgot.code.notReceived": "Didn't receive a code? Reset via email",
      "password.forgot.noFactorsEnabled": "No password reset options available. Please contact your administrator.",
      "password.reset.title": "Reset your Okta password",
      "password.reset.title.generic": "Reset your password",
      "password.reset.title.specific": "Reset your {0} password",
      "password.complexity.requirements": "Password requirements: {0}.",
      "password.complexity.history": "Your password cannot be any of your last {0} passwords.",
      "password.complexity.minAgeMinutes": "At least {0} minute(s) must have elapsed since you last changed your password.",
      "password.complexity.minAgeHours": "At least {0} hour(s) must have elapsed since you last changed your password.",
      "password.complexity.minAgeDays": "At least {0} day(s) must have elapsed since you last changed your password.",
      "password.reset.verification": "Verify with one of the following factors to reset your password.",
      "password.complexity.length": "at least {0} characters",
      "password.complexity.list.element": ", {0}",
      "password.complexity.lowercase": "a lowercase letter",
      "password.complexity.uppercase": "an uppercase letter",
      "password.complexity.number": "a number",
      "password.complexity.symbol": "a symbol",
      "password.complexity.no_username": "no parts of your username",
      "password.complexity.no_first_name": "does not include your first name",
      "password.complexity.no_last_name": "does not include your last name",
      "password.complexity.requirements.header": "Password requirements:",
      "password.complexity.length.description": "At least {0} characters",
      "password.complexity.lowercase.description": "A lowercase letter",
      "password.complexity.uppercase.description": "An uppercase letter",
      "password.complexity.number.description": "A number",
      "password.complexity.symbol.description": "A symbol",
      "password.complexity.no_username.description": "No parts of your username",
      "password.complexity.no_first_name.description": "Does not include your first name",
      "password.complexity.no_last_name.description": "Does not include your last name",
      "password.complexity.history.description": "Your password cannot be any of your last {0} passwords",
      "password.complexity.minAgeMinutes.description": "At least {0} minute(s) must have elapsed since you last changed your password",
      "password.complexity.minAgeHours.description": "At least {0} hour(s) must have elapsed since you last changed your password",
      "password.complexity.minAgeDays.description": "At least {0} day(s) must have elapsed since you last changed your password",
      "password.expired.submit": "Change Password",
      "password.expired.title": "Your Okta password has expired",
      "password.expired.title.generic": "Your password has expired",
      "password.expired.title.specific": "Your {0} password has expired",
      "password.expiring.later": "Remind me later",
      "password.expiring.title": "Your password will expire in {0} days",
      "password.expiring.today": "Your password will expire later today",
      "password.expiring.soon": "Your password is expiring soon",
      "password.expiring.subtitle": "When password expires you may be locked out of Okta Mobile, mobile email, and other services.",
      "password.expiring.subtitle.generic": "When password expires you will be locked out of your account.",
      "password.expiring.subtitle.specific": "When password expires you will be locked out of your {0} account.",
      "password.expired.custom.submit": "Go to {0}",
      "password.expired.custom.subtitle": "This password is set on another website. Click the button below to go there and set a new password.",
      "hcaptcha.footer.label": "This site is protected by hCaptcha and its <$1>Privacy Policy</$1> and <$2>Terms of Service</$2> apply.",
      "account.unlock.title": "Unlock account",
      "account.unlock.email.or.username.placeholder": "Email or username",
      "account.unlock.email.or.username.tooltip": "Email or username",
      "account.unlock.sendText": "Send SMS",
      "account.unlock.voiceCall": "Voice Call",
      "account.unlock.sendEmail": "Send Email",
      "account.unlock.emailSent.title": "Email sent!",
      "account.unlock.emailSent.desc": "Email has been sent to {0} with instructions on unlocking your account.",
      "account.unlock.question.title": "Answer Unlock Account Challenge",
      "account.unlock.question.submit": "Unlock Account",
      "account.unlock.unlocked.title": "Account successfully unlocked!",
      "account.unlock.unlocked.desc": "You can log in using your existing username and password.",
      "account.unlock.code.notReceived": "Didn't receive a code? Unlock via email",
      "account.unlock.noFactorsEnabled": "No unlock options available. Please contact your administrator.",
      "contact.support": "If you didn't provide a secondary email address or don't have access to email, please contact your administrator at {0}",
      "customauth.sign.in.with.label": "Sign in with {0}",
      "socialauth.divider.text": "OR",
      "socialauth.facebook.label": "Sign in with Facebook",
      "socialauth.google.label": "Sign in with Google",
      "socialauth.linkedin.label": "Sign in with LinkedIn",
      "socialauth.microsoft.label": "Sign in with Microsoft",
      "socialauth.apple.label": "Sign in with Apple",
      "socialauth.popup.title": "External Identity Provider User Authentication",
      "authbutton.divider.text": "or",
      "registration.signup.label": "Don't have an account?",
      "registration.signup.text": "Sign up",
      "registration.complete.title": "Verification email sent",
      "registration.complete.confirm.text": "To finish signing in, check your email.",
      "registration.form.title": "Create Account",
      "registration.form.submit": "Register",
      "registration.passwordComplexity.minLength": "At least {0} character(s)",
      "registration.passwordComplexity.minLower": "At least {0} lowercase letter(s)",
      "registration.passwordComplexity.minUpper": "At least {0} uppercase letter(s)",
      "registration.passwordComplexity.minNumber": "At least {0} number(s)",
      "registration.passwordComplexity.minSymbol": "At least {0} symbol(s)",
      "registration.passwordComplexity.excludeUsername": "Does not contain part of username",
      "registration.passwordComplexity.excludeAttribute": "Does not contain '{0}'",
      "registration.required.fields.label": "* indicates required field",
      "registration.default.callbackhook.error": "We could not process your registration at this time. Please try again later.",
      "registration.error.userName.invalidEmail": "Invalid email address",
      "registration.error.password.passwordRequirementsNotMet": "Password requirements were not met",
      "registration.error.userName.notUniqueWithinOrg": "An account with that email already exists",
      "registration.error.notUniqueWithinOrg.Email": "A user with this Email already exists",
      "registration.error.notUniqueWithinOrg.custom": "A user with this {0} already exists",
      "registration.error.invalidLoginEmail.Email": "'Email' must be in the form of an email address",
      "registration.error.invalidLoginEmail.custom": "'{0}' must be in the form of an email address",
      "registration.error.doesNotMatchPattern.Email": "Provided value for property 'Email' does not match required pattern",
      "registration.error.doesNotMatchPattern.custom": "Provided value for property '{0}' does not match required pattern",
      "registration.error.generic": "There was an error creating your account. Please try registering again.",
      "registration.error.request.not.completed": "Your request could not be completed. Try again later.",
      "registration.model.validation.field.string.too.short": "Please enter something at least {0} characters long",
      "registration.model.validation.field.string.too.long": "Please enter something shorter than {0} characters",
      "piv.card": "PIV Card",
      "piv.card.insert": "Please insert your PIV card and select the user certificate.",
      "piv.card.error": "Certificate authentication failed. Contact your admin.",
      "piv.card.error.empty": "No certificate selected. Choose a certificate and try again.",
      "piv.card.error.invalid": "Certificate validation failed. Choose another certificate and try again.",
      "piv.cac.card": "Sign in with PIV / CAC card",
      "piv.cac.title": "PIV / CAC card",
      "piv.cac.card.insert": "Please insert your PIV / CAC card and select the user certificate.",
      "piv.cac.error": "There was an error signing in. Click the button below to try again.",
      "unsupported.oneDrive.title": "Your OneDrive version is not supported",
      "unsupported.oneDrive.desc": "Upgrade now by installing the OneDrive for Business Next Generation Sync Client to login to Okta",
      "unsupported.oneDrive.action": "Learn how to upgrade",
      "unsupported.cookies.title": "Cookies are required",
      "unsupported.cookies.desc": "Cookies are disabled on your browser. Please enable Cookies and refresh this page.",
      "unsupported.cookies.action": "Refresh",
      "deviceTrust.sso.text": "Sign in to access company resources",
      "deviceTrust.sso.subtitle.2": "Your company uses Okta Mobile to get you approved to access this app.",
      "deviceTrust.sso.button": "Sign in with Okta Mobile",
      "deviceTrust.sso.expire.title": "Oops let's get you back on track",
      "deviceTrust.sso.redirectText": "Verifying your identity",
      "deviceTrust.sso.expire.subtitle": "Unfortunately the steps required to sign in took longer than expected and your attempt timed out.",
      "deviceTrust.sso.expire.button": "Sign in using Okta Mobile",
      "deviceTrust.universalLink.fallback.getOktaMobile.title": "Get Okta Mobile",
      "deviceTrust.universalLink.fallback.getOktaMobile.subtitle": "Go to the {0}AppStore{1}, {0}search{1} for {0}Okta Mobile{1} and tap on {0}GET{1} Okta Mobile. Once installed, sign in to Okta Mobile and follow the instructions to secure your device.",
      "loopback.polling.cancel.link": "Cancel and take me to sign in",
      "loopback.polling.cancel.link.with.form.error": "Take me to sign in",
      "customUri.subtitle": "Launching Okta Verify...",
      "customUri.content": '<div class="skinny-content"> If nothing prompts from the browser, <a href="#" id="launch-ov" class="link">click here</a> to launch Okta Verify, or make sure Okta Verify is installed.</div>',
      "customUri.title": 'Click "Open Okta Verify" on the browser prompt',
      "customUri.required.content.prompt": "Didn’t get a prompt?",
      "customUri.required.content.download.title": "Don’t have Okta Verify?",
      "customUri.required.content.download.linkText": "Download here",
      "customUri.required.content.button": "Launch Okta Verify",
      "universalLink.title": "Sign in using Okta Verify on this device",
      "universalLink.content": "Open Okta Verify to continue signing in. If Okta Verify did not open automatically, tap the button below to reopen Okta Verify.",
      "oktaVerify.reopen.button": "Reopen Okta Verify",
      "consent.required.text": "<b>{0}</b> would like to access:",
      "consent.required.description": "By clicking Allow Access, you allow the actions listed above.",
      "consent.required.termsOfService": "Terms of Service",
      "consent.required.privacyPolicy": "Privacy Policy",
      "consent.required.consentButton": "Allow Access",
      "consent.required.cancelButton": "Don't Allow",
      "admin.consent.group.user.group": "User and groups",
      "admin.consent.group.resource.policy": "Resource and policies",
      "admin.consent.group.hook": "Hooks",
      "admin.consent.group.system": "System",
      "polling.title": "There are too many users trying to sign in right now. We will automatically retry in {0} seconds.",
      "poll.form.title": "Unable to complete your request",
      "poll.form.message": "We will automatically retry in <$1>{0}</$1> seconds.",
      "cert.authentication.title": "Certificate authentication",
      "common.logo.alt": "aria logo",
      "oie.authenticator.enroll.error.fail": "Unable to enroll authenticator. Try again.",
      "oie.authenticator.verify.error.fail": "Unable to verify authenticator. Try again.",
      "oie.password.label": "Password",
      "oie.password.newPasswordLabel": "New password",
      "oie.password.authenticator.description": "Choose a password for your account",
      "oie.password.challenge.title": "Verify with your password",
      "oie.password.enroll.title": "Set up password",
      "oie.password.passwordLabel": "Enter password",
      "oie.password.confirmPasswordLabel": "Re-enter password",
      "oie.password.reset.verification": "Verify with one of the following authenticators to reset your password.",
      "idx.password.expiring.message": "When your password expires you will be locked out of your Okta account.",
      "oie.password.incorrect.message": "Password is incorrect",
      "oie.selfservice.reset.password.not.allowed": "Reset password is not allowed at this time. Please contact support for assistance.",
      "password.common": "This password was found in a list of commonly used passwords. Please try another password.",
      "oie.phone.label": "Phone",
      "oie.phone.authenticator.description": "Verify with a code sent to your phone",
      "oie.phone.enroll.sms.label": "SMS",
      "oie.phone.enroll.voice.label": "Voice call",
      "oie.phone.enroll.title": "Set up phone authentication",
      "oie.phone.enroll.call.subtitle": "Enter your phone number to receive a verification code via voice call.",
      "oie.phone.enroll.sms.subtitle": "Enter your phone number to receive a verification code via SMS.",
      "oie.phone.sms.primaryButton": "Receive a code via SMS",
      "oie.phone.sms.secondaryButton": "Receive an SMS instead",
      "oie.phone.call.primaryButton": "Receive a code via voice call",
      "oie.phone.call.secondaryButton": "Receive a voice call instead",
      "oie.phone.verify.sms.resendText": "Haven't received an SMS?",
      "oie.phone.verify.sms.codeSentText": "A code was sent to",
      "oie.phone.verify.sms.sendText": "Send a code via SMS to",
      "oie.phone.verify.call.sendText": "Send a code via voice call to",
      "oie.phone.verify.call.resendText": "Haven't received a call?",
      "oie.phone.verify.call.resendLinkText": "Call again",
      "oie.phone.verify.sms.resendLinkText": "Send again",
      "oie.phone.verify.enterCodeText": "Enter the code below to verify.",
      "oie.phone.verify.title": "Verify with your phone",
      "oie.phone.alternate.title": "your phone",
      "oie.phone.carrier.charges": "Carrier messaging charges may apply",
      "oie.phone.invalid": "Invalid Phone Number.",
      "oie.email.label": "Email",
      "oie.email.authenticator.description": "Verify with a link or code sent to your email",
      "oie.email.mfa.title": "Verify with your email",
      "oie.email.verify.alternate.sentText": "Check your email for a verification message. Click the verification button in your email or enter the code below to continue.",
      "oie.email.enroll.subtitle": "Please check your email and enter the code below.",
      "oie.email.return.link.expired.title": "Verify with your email",
      "oie.webauthn.label": "Security Key or Biometric Authenticator",
      "oie.webauthn.description": "Use a security key or a biometric authenticator to sign in",
      "oie.enroll.webauthn.title": "Set up security key or biometric authenticator",
      "oie.enroll.webauthn.instructions": "You will be prompted to register a security key or biometric authenticator (Windows Hello, Touch ID, Face ID, etc.). Follow the instructions to complete set up.",
      "oie.enroll.webauthn.uv.required.instructions": "Biometric verification or a PIN is required to setup this authenticator.",
      "oie.enroll.webauthn.instructions.edge": "Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select 'Cancel' in the prompt before continuing.",
      "oie.enroll.webauthn.save": "Set up",
      "oie.webauthn.error.not.supported": "Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.",
      "oie.verify.webauth.title": "Verify with Security Key or Biometric Authenticator",
      "oie.verify.webauthn.instructions": "You will be prompted to use a security key or biometric verification (Windows Hello, Touch ID, etc.). Follow the instructions to complete verification.",
      "oie.verify.webauthn.uv.required.instructions": "Biometric verification or a PIN is required to sign in with this authenticator.",
      "oie.security.question.label": "Security Question",
      "oie.security.question.enroll.title": "Set up security question",
      "oie.security.question.challenge.title": "Verify with your Security Question",
      "oie.security.question.questionKey.label": "Choose a security question",
      "oie.security.question.createQuestion.label": "Create my own security question",
      "oie.security.question.authenticator.description": "Choose a security question and answer that will be used for signing in",
      "securityQuestion.answer.tooShort.arg": "The security question answer must be at least {0} characters in length",
      "oie.okta_verify.label": "Okta Verify",
      "oie.okta_verify.authenticator.description": "Okta Verify is an authenticator app, installed on your phone, used to prove your identity",
      "oie.enroll.okta_verify.setup.title": "Set up Okta Verify",
      "oie.enroll.okta_verify.setup.email.title": "Check your email",
      "oie.enroll.okta_verify.setup.sms.title": "Check your text messages",
      "oie.enroll.okta_verify.select.channel.description": "Which option do you want to try?",
      "oie.enroll.okta_verify.select.channel.qrcode.label": "Scan a QR code",
      "oie.enroll.okta_verify.select.channel.email.label": "Email me a setup link",
      "oie.enroll.okta_verify.select.channel.sms.label": "Text me a setup link",
      "oie.enroll.okta_verify.select.channel.title": "More options",
      "oie.enroll.okta_verify.channel.email.label": "Email",
      "oie.enroll.okta_verify.enroll.channel.email.title": "Set up Okta Verify via email link",
      "oie.enroll.okta_verify.enroll.channel.sms.title": "Set up Okta Verify via SMS",
      "oie.enroll.okta_verify.channel.email.description": "Make sure you can access the email on your mobile device.",
      "oie.enroll.okta_verify.channel.sms.description": "Make sure you can access the text on your mobile device.",
      "oie.enroll.okta_verify.qrcode.step1": "On your mobile device, download the Okta Verify app from the App Store (iPhone and iPad) or Google Play (Android devices).",
      "oie.enroll.okta_verify.qrcode.step2": "Open the app and follow the instructions to add your account",
      "oie.enroll.okta_verify.qrcode.step3": "When prompted, tap Scan a QR code, then scan the QR code below:",
      "oie.enroll.okta_verify.qrcode.cannotScan": "Can't scan?",
      "oie.enroll.okta_verify.switch.channel.link.text": 'Or <a href="#" class="switch-channel-link">try a different way</a> to set up Okta Verify.',
      "oie.enroll.okta_verify.email.info": 'We sent an email to <span class="strong">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.',
      "oie.enroll.okta_verify.email.notReceived": 'Haven’t received an email? Check your spam folder or <a href="#" class="resend-link">send again</a>',
      "oie.enroll.okta_verify.sms.info": 'We sent an SMS to <span class="strong">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.',
      "oie.enroll.okta_verify.sms.notReceived": 'Haven’t received an SMS? <a href="#" class="resend-link">Send again</a>',
      "oie.enroll.okta_verify.setupLink": "Send me the setup link",
      "oie.okta_verify.totp.title": "Enter a code",
      "oie.okta_verify.totp.enterCodeText": "Enter code from Okta Verify app",
      "oie.okta_verify.push.title": "Get a push notification",
      "oie.okta_verify.push.sent": "Push notification sent",
      "oie.okta_verify.push.resend": "Resend push notification",
      "oie.okta_verify.signed_nonce.label": "Use Okta Verify on this device",
      "oie.okta_verify.enroll.force.upgrade.title": "Update Okta Verify",
      "oie.authenticator.app.non_fips_compliant_enrollment_device_incompatible": "The device used to set up Okta Verify does not meet your organization’s security requirements because it is not FIPS compliant. Contact your administrator for help.",
      "oie.authenticator.app.non_fips_compliant_enrollment_app_update_required": "The Okta Verify version on the device used does not meet your organization’s security requirements. To add your account, update Okta Verify to the latest version, then try again.",
      "oie.authenticator.app.method.push.verify.enable.biometrics": "Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.",
      "oie.authenticator.app.method.push.verify.enable.biometrics.title": "Enable biometrics in Okta Verify",
      "oie.authenticator.app.method.push.verify.enable.biometrics.description": "Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:",
      "oie.authenticator.app.method.push.verify.enable.biometrics.point1": "Your device supports biometrics",
      "oie.authenticator.app.method.push.verify.enable.biometrics.point2": "Okta Verify is up-to-date",
      "oie.authenticator.app.method.push.verify.enable.biometrics.point3": "In Okta Verify, biometrics are enabled for your account",
      "oie.authenticator.app.method.push.enroll.enable.biometrics": "Your organization requires biometrics. To proceed, ensure your device supports biometrics, then add your account and enable biometrics when prompted.",
      "oie.authenticator.app.method.push.enroll.enable.biometrics.title": "Enable biometrics to add an account in Okta Verify",
      "oie.google_authenticator.label": "Google Authenticator",
      "oie.google_authenticator.authenticator.description": "Enter a temporary code generated from the Google Authenticator app.",
      "oie.enroll.google_authenticator.setup.title": "Set up Google Authenticator",
      "oie.enroll.google_authenticator.scanBarcode.title": "Scan barcode",
      "oie.enroll.google_authenticator.scanBarcode.description": 'Launch Google Authenticator, tap the "+" icon, then select "Scan barcode".',
      "oie.enroll.google_authenticator.scanBarcode.cannotScan": "Can't scan?",
      "oie.enroll.google_authenticator.cannotScanBarcode.title": "Can't scan barcode?",
      "oie.enroll.google_authenticator.manualSetupInstructions": "To set up manually enter your Okta Account username and then input the following in the Secret Key Field",
      "oie.enroll.google_authenticator.enterCode.title": "Enter code displayed from application",
      "oie.verify.google_authenticator.otp.title": "Verify with Google Authenticator",
      "oie.verify.google_authenticator.otp.description": "Enter the temporary code generated in your Google Authenticator app",
      "oie.google_authenticator.otp.enterCodeText": "Enter code",
      "oie.verify.custom_otp.title": "Verify with {0}",
      "oie.verify.custom_otp.description": "Enter the code generated on your authenticator and verify.",
      "oie.custom_otp.description": "Enter a temporary code generated from an authenticator device.",
      "oie.custom_otp.authenticator.default.vendorName": "Custom OTP Authenticator",
      "oie.custom_otp.verify.passcode.label": "Enter code",
      "oie.on_prem.authenticator.description": "Verify by entering a code generated by {0}.",
      "oie.on_prem.authenticator.default.vendorName": "Custom On-prem Authenticator",
      "oie.on_prem.enroll.title": "Set up {0}",
      "oie.on_prem.verify.title": "Verify with {0}",
      "oie.numberchallenge.warning": "Haven't received a push notification yet? Try opening the Okta Verify app on your device, or <$1>resend the push notification</$1>.",
      "oie.numberchallenge.instruction": "On your mobile device, open the Okta Verify prompt, then tap <$1>{0}</$1> in Okta Verify to continue.",
      "oie.numberchallenge.force.upgrade.title": "Update Okta Verify",
      "oie.authenticator.app.method.push.force.upgrade.number_challenge": "Your response was received, but your Okta Verify version is no longer supported by your organization. To verify your identity with push notifications, update Okta Verify to the latest version, then try again.",
      "oie.rsa.authenticator.description": "Verify by entering a code generated by RSA SecurID",
      "oie.duo.authenticator.description": "Verify your identity using Duo Security.",
      "oie.duo.enroll.title": "Set up Duo Security",
      "oie.duo.verify.title": "Verify with Duo Security",
      "oie.duo.iFrameError": "Error loading Duo. Try again or contact your admin for assistance.",
      "oie.authenticator.duo.error": "We were unable to verify with Duo. Try again.",
      "oie.idp.authenticator.description": "Redirect to verify with {0}.",
      "oie.idp.enroll.title": "Set up {0}",
      "oie.idp.enroll.description": "Clicking below will redirect to enrollment in {0}",
      "oie.idp.challenge.title": "Verify with {0}",
      "oie.idp.challenge.description": "You will be redirected to verify with {0}",
      "oie.symantecVip.authenticator.description": "Verify by entering a temporary code from the {0} app.",
      "oie.symantecVip.enroll.title": "Set up {0}",
      "oie.symantecVip.enroll.description": "From the {0} app, enter your credential ID and two consecutive generated codes",
      "oie.symantecVip.challenge.title": "Verify with {0}",
      "oie.symantecVip.challenge.description": "Enter the generated security code from the {0} app.",
      "oie.symantecVip.verify.passcode.label": "Enter security code",
      "oie.select.authenticators.enroll.title": "Set up authenticators",
      "oie.select.authenticators.enroll.subtitle": "Authenticators help protect your account by ensuring only you have access.",
      "oie.select.authenticators.enroll.subtitle.custom": "Authenticators help protect your {0} account by ensuring only you have access.",
      "oie.setup.required": "Set up required",
      "oie.setup.optional": "Set up optional",
      "oie.optional.authenticator.button.title": "Finish",
      "oie.verify.authenticator.button.text": "Select",
      "oie.enroll.authenticator.button.text": "Set up",
      "oie.select.authenticators.verify.title": "Verify it's you with an authenticator",
      "oie.select.authenticators.verify.subtitle": "Select from the following options",
      "oie.success.text.signingIn": "Signing in",
      "oie.success.text.signingIn.with.appName": "Signing in to {0}",
      "oie.success.text.signingIn.with.appName.and.identifier": "Signing in to {0} as {1}",
      "oie.go.back": "Go back",
      "oie.enroll.switch.authenticator": "Return to authenticator list",
      "oie.enroll.skip.setup": "Skip set up",
      "oie.verification.switch.authenticator": "Verify with something else",
      "oie.remember": "Keep me signed in",
      "oie.try.again": "Try again",
      "enroll.title.oda": "Download Okta Verify",
      "enroll.title.mdm": "Additional setup required",
      "enroll.explanation.p1": "To sign in using Okta Verify, you will need to set up Okta Verify on this device. Download the Okta Verify app on {0}.",
      "enroll.explanation.p2": 'In the app, follow the instructions to add an organizational account. When prompted, choose <span class="semi-strong">Sign In</span>, then enter the <span class="semi-strong">sign-in URL</span>:',
      "enroll.appleStore": "the App Store",
      "enroll.googleStore": "Google Play",
      "enroll.copy.ios": "Apple®, App Store, and the Apple logo are trademarks of Apple Inc.",
      "enroll.copy.android": "Google Play and the Google Play logo are trademarks of Google LLC.",
      "enroll.explanation.mdm": "To access this app, your device needs to meet your organization's security requirements. Follow the instructions below to continue.",
      "enroll.mdm.copyLink": "Copy link to clipboard",
      "enroll.mdm.copyLink.success": "Link copied.",
      "enroll.mdm.step1": "Tap the Copy Link button below.",
      "enroll.mdm.step2": "On this device, open your browser, then paste the copied link into the address bar.",
      "enroll.mdm.step3": 'Follow the instructions in your browser to set up <span class="semi-strong">{0}</span>, then try accessing this app again.',
      "oie.safe.mode.title": "Authenticator set up unavailable",
      "idx.error.server.safe.mode.enrollment.unavailable": "Set up is temporarily unavailable due to server maintenance. Try again later.",
      "oie.primaryauth.submit": "Sign in",
      "oie.registration.form.title": "Sign up",
      "oie.registration.form.submit": "Sign Up",
      "oie.user.profile.lastname": "Last name",
      "oie.user.profile.firstname": "First name",
      "oie.user.profile.primary.email": "Email",
      "oie.selfservice.unlock_user.success.message": "You can log in using your existing username and password.",
      "oie.selfservice.unlock_user.failed.message": "We are unable to unlock your account at this time, please contact your administrator",
      "oie.selfservice.user.unlock.not.allowed": "Self Service Unlock is not allowed at this time. Please contact support for assistance.",
      "idx.session.expired": "The session has expired.",
      "oie.registration.is.not.enabled": "Sign up is not enabled for this organization.",
      "oie.forgot.password.is.not.enabled": "Forgot password is not enabled for this organization.",
      "idx.return.error": "Could not process this email link. Return to the screen where you requested it.",
      "idx.return.stale": "This email link is out of date. Return to the screen where you requested it.",
      "idx.invalid.forgot.password.token": "Your reset password token is no longer valid.",
      "idx.invalid.reset.password.token": "Your reset password token is no longer valid. Contact your administrator to obtain a new token.",
      "idx.reset.password.activating.user": "Reset password cannot be performed while the user is activating. Contact your administrator to obtain a new token.",
      tagsNotAllowed: "The field must not contain HTML tags",
      "api.authn.error.PASSCODE_INVALID": "Invalid code. Try again.",
      "oie.feature.disabled": "The requested feature is not enabled in this environment.",
      "authfactor.challenge.suspended_factor": "This factor is suspended for your account due to too many failed attempts",
      "oie.post.password.update.auth.failure.error": "Your password has been updated but there was a problem signing you in. Please try again or contact your administrator.",
      "oie.assurance.unsatisfiable": 'Unable to login to "{0}" at this time. For assistance, please contact your administrator.',
      "errors.E0000150": "You have reached the limit of sms requests, please try again later.",
      "errors.E0000151": "You have reached the limit of call requests, please try again later.",
      "oie.consent.admin.title": "would like to access:",
      "oie.consent.enduser.title": "Did you just try to sign in?",
      "oie.consent.enduser.accept.label": "Yes, it's me",
      "oie.consent.enduser.deny.label": "No, it's not me",
      "oie.consent.enduser.email.allow.description": "To continue, return to the device or window where you requested the email link. You may close this window at any time.",
      "oie.consent.enduser.deny.description": "You may close this window at any time.",
      "oie.return.to.original.tab": "Please return to the original tab.",
      "idx.operation.cancelled.by.user": "Operation cancelled by user.",
      "idx.transferred.to.new.tab": "Flow continued in a new tab.",
      "idx.return.link.expired": "This email link has expired. To resend it, return to the screen where you requested it.",
      "consent.scopes.email.label": "View your email address.",
      "consent.scopes.profile.label": "View your profile information.",
      "consent.scopes.phone.label": "View your phone number.",
      "consent.scopes.address.label": "View your address.",
      "consent.scopes.offlineAccess.label": "Keep you signed in to the app.",
      "consent.scopes.onlineAccess.label": "Keep you signed in to the app.",
      "consent.scopes.deviceSSO.label": "Request device secret.",
      "consent.scopes.openid.desc": "Signals that a request is an OpenID request.",
      "consent.scopes.profile.desc": "The exact data varies based on what profile information you have provided, such as: name, time zone, picture, or birthday.",
      "consent.scopes.email.desc": "This allows the app to view your email address.",
      "consent.scopes.address.desc": "This allows the app to view your address, such as: street address, city, state, and zip code.",
      "consent.scopes.phone.desc": "This allows the app to view your phone number.",
      "consent.scopes.offlineAccess.desc": "This keeps you signed in to the app, even when you are not using it.",
      "consent.scopes.onlineAccess.desc": "This allows the app to access your data only when you are logged in to the application.",
      "consent.scopes.deviceSSO.desc": "This allows you to single sign on between native client applications on your device.",
      "consent.scopes.okta.users.manage.desc": "Allows the app to create new users and to manage all users'' profile and credentials information.",
      "consent.scopes.okta.users.manage.self.desc": "Allows the app to manage the signed-in user''s profile and credentials.",
      "consent.scopes.okta.users.read.desc": "Allows the app to read the existing users'' profiles and credentials.",
      "consent.scopes.okta.users.read.self.desc": "Allows the app to read the signed-in user''s profile and credentials.",
      "consent.scopes.okta.linkedObjects.manage.desc": "Allows the app to manage linked object definitions in your Okta organization.",
      "consent.scopes.okta.linkedObjects.read.desc": "Allows the app to read linked object definitions in your Okta organization.",
      "consent.scopes.okta.myAccount.manage.desc": "Allows the end-user to manage their account profile.",
      "consent.scopes.okta.myAccount.read.desc": "Allows the end-user to read their account profile.",
      "consent.scopes.okta.riskEvents.manage.desc": "Allows the app to publish risk events to your Okta organization.",
      "consent.scopes.okta.clients.manage.desc": "Allows the app to manage clients in your Okta organization.",
      "consent.scopes.okta.clients.read.desc": "Allows the app to read information about clients in your Okta organization.",
      "consent.scopes.okta.clients.register.desc": "Allows the app to create new clients in your Okta organization.",
      "consent.scopes.okta.authorizationServers.manage.desc": "Allows the app to create and manage Authorization Servers in your Okta organization.",
      "consent.scopes.okta.authorizationServers.read.desc": "Allows the app to read information about Authorization Servers in your Okta organization.",
      "consent.scopes.okta.groups.manage.desc": "Allows the app to manage existing groups in your Okta organization.",
      "consent.scopes.okta.groups.read.desc": "Allows the app to read information about groups and their members in your Okta organization.",
      "consent.scopes.okta.groups.register.desc": "Allows the app to create new groups in your Okta organization.",
      "consent.scopes.okta.events.read.desc": "Allows the app to read information about deprecated Events v1 API entries in your Okta organization.",
      "consent.scopes.okta.logs.read.desc": "Allows the app to read information about System Log entries in your Okta organization.",
      "consent.scopes.okta.inlineHooks.manage.desc": "Allows the app to create and manage Inline Hooks in your Okta organization.",
      "consent.scopes.okta.inlineHooks.read.desc": "Allows the app to read information about Inline Hooks in your Okta organization.",
      "consent.scopes.okta.eventHooks.manage.desc": "Allows the app to create and manage Event Hooks in your Okta organization.",
      "consent.scopes.okta.eventHooks.read.desc": "Allows the app to read information about Event Hooks in your Okta organization.",
      "consent.scopes.okta.apps.manage.desc": "Allows the app to create and manage Apps in your Okta organization.",
      "consent.scopes.okta.apps.read.desc": "Allows the app to read information about Apps in your Okta organization.",
      "consent.scopes.okta.schemas.manage.desc": "Allows the app to create and manage Schemas in your Okta organization.",
      "consent.scopes.okta.schemas.read.desc": "Allows the app to read information about Schemas in your Okta organization.",
      "consent.scopes.okta.idps.manage.desc": "Allows the app to create and manage Identity Providers in your Okta organization.",
      "consent.scopes.okta.idps.read.desc": "Allows the app to read information about Identity Providers in your Okta organization.",
      "consent.scopes.okta.roles.manage.desc": "Allows the app to manage administrative role assignments for users in your Okta organization.",
      "consent.scopes.okta.roles.read.desc": "Allows the app to read administrative role assignments for users in your Okta organization.",
      "consent.scopes.okta.policies.manage.desc": "Allows the app to manage policies in your Okta organization.",
      "consent.scopes.okta.policies.read.desc": "Allows the app to read information about policies in your Okta organization.",
      "consent.scopes.okta.orgs.manage.desc": "Allows the app to manage organization-specific details for your Okta organization.",
      "consent.scopes.okta.orgs.read.desc": "Allows the app to read organization-specific details about your Okta organization.",
      "consent.scopes.okta.captchas.manage.desc": "Allows the app to create and manage CAPTCHAs in your Okta organization.",
      "consent.scopes.okta.captchas.read.desc": "Allows the app to read information about CAPTCHAs in your Okta organization.",
      "consent.scopes.okta.sessions.manage.desc": "Allows the app to manage all sessions in your Okta organization.",
      "consent.scopes.okta.sessions.read.desc": "Allows the app to read all sessions in your Okta organization.",
      "consent.scopes.okta.trustedOrigins.manage.desc": "Allows the app to manage all Trusted Origins in your Okta organization.",
      "consent.scopes.okta.trustedOrigins.read.desc": "Allows the app to read all Trusted Origins in your Okta organization.",
      "consent.scopes.okta.templates.manage.desc": "Allows the app to manage all custom templates in your Okta organization.",
      "consent.scopes.okta.templates.read.desc": "Allows the app to read all custom templates in your Okta organization.",
      "consent.scopes.okta.factors.manage.desc": "Allows the app to manage all admin operations for org factors (e.g. activate, deactivate, read).",
      "consent.scopes.okta.factors.read.desc": "Allows the app to read org factors information.",
      "consent.scopes.okta.authenticators.manage.desc": "Allows the app to manage all authenticators (e.g. enrollments, reset).",
      "consent.scopes.okta.authenticators.read.desc": "Allows the app to read org authenticators information.",
      "consent.scopes.okta.authenticators.manage.self.desc": "Allows the app to manage users own authenticators (e.g. enrollments, reset).",
      "consent.scopes.idSnapshot.read.desc": "Allows the app to read your identity snapshot attestation.",
      "consent.scopes.idSnapshot.manage.desc": "Allows the app to create and manage your identity snapshot attestation.",
      "logo.for.the.app.alt.text": "Logo for the app",
      "device.code.activate.title": "Activate your device",
      "device.code.activate.subtitle": "Follow the instructions on your device to get an activation code",
      "device.code.activate.label": "Activation Code",
      "device.code.activated.success.title": "Device activated",
      "device.code.activated.error.title": "Device not activated",
      "idx.device.activated": "Follow the instructions on your device for next steps",
      "idx.device.not.activated.consent.denied": "Your device cannot be activated because you did not allow access",
      "idx.device.not.activated.internal.error": "Your device cannot be activated because of an internal error",
      "idx.invalid.device.code": "Invalid code. Try again.",
      "idx.operation.cancelled.on.other.device": "Access denied on other device.",
      "oie.browser.error.NotAllowedError": "The operation either timed out or was not allowed.",
      "authfactor.challenge.soft_token.invalid_passcode": "Your code doesn't match our records. Please try again.",
      "authfactor.challenge.soft_token.used_passcode": "Each code can only be used once. Please wait for a new code and try again.",
      "oie.tooManyRequests": "Too many attempts. Try again later.",
      E0000010: "Server is unable to respond at the moment.",
      "idx.error.registration.unavailable": "Registration is currently unavailable.",
      "idx.error.user.not.assigned.to.app": "User is not assigned to this application.",
      "idx.error.code.user_not_assigned": "You are not allowed to access this app. To request access, contact an admin."
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = l.default.extend({
        transformErrorXHR: a.default.transformErrorXHR,
        headers: {
          "X-Okta-User-Agent-Extended": "okta-signin-widget-" + s.default.version
        }
      }, e);
      return t.tokenManager = l.default.extend({}, t.tokenManager, {
        autoRenew: !1
      }), t.headers = a.default.removeNils(t.headers), new i.OktaAuth(t);
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var i = n(250),
        a = o(n(12)),
        s = o(n(155)),
        l = o(n(110));
  }, function (e, t, n) {
    "use strict";

    function r() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = i.$.extend(!0, {}, e.authParams, i._.pick(t, s.default.AUTH_PARAMS)),
          r = Object.assign({}, e, t),
          o = r.el,
          l = r.clientId,
          u = r.redirectUri,
          c = Object.assign({}, {
        el: o,
        clientId: l,
        redirectUri: u,
        authParams: n
      });
      if (!c.el) throw new a.default.ConfigError('"el" is required');
      if (!c.clientId) throw new a.default.ConfigError('"clientId" is required');
      if (!c.redirectUri) throw new a.default.ConfigError('"redirectUri" is required');
      return c;
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var i = n(1),
        a = o(n(24)),
        s = o(n(156));
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n, r, o, s) {
      var l,
          u,
          c = new Promise(function (c, d) {
        u = i.$.extend(!0, {}, t, n, {
          authClient: r,
          globalSuccessFn: function globalSuccessFn(e) {
            o && o(e), e && e.status === a.default.SUCCESS && c(e);
          },
          globalErrorFn: function globalErrorFn(e) {
            s && s(e), d(e);
          }
        }), l = new e(u), l.start();
      });
      return {
        router: l,
        routerOptions: u,
        promise: c
      };
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var i = n(1),
        a = o(n(5));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = r(n(478)),
        i = r(n(479)),
        a = r(n(486)),
        s = r(n(488)),
        l = r(n(490)),
        u = r(n(491)),
        c = r(n(494)),
        d = r(n(495)),
        f = r(n(496)),
        p = r(n(497)),
        h = r(n(498)),
        m = r(n(499)),
        g = r(n(501)),
        v = r(n(260)),
        y = r(n(504)),
        b = r(n(505)),
        _ = r(n(506)),
        w = r(n(507)),
        E = r(n(508)),
        O = r(n(509)),
        S = r(n(510)),
        x = r(n(511)),
        T = r(n(513)),
        k = r(n(514)),
        C = r(n(518)),
        A = r(n(519)),
        N = r(n(520)),
        P = r(n(521)),
        R = r(n(522)),
        I = r(n(523)),
        M = r(n(524)),
        j = r(n(531)),
        L = r(n(533)),
        D = r(n(535)),
        F = r(n(546)),
        U = r(n(547)),
        B = r(n(548)),
        V = r(n(269)),
        H = r(n(549)),
        q = r(n(550)),
        W = r(n(551)),
        z = r(n(552)),
        $ = r(n(553)),
        K = r(n(554)),
        G = r(n(555)),
        Y = r(n(559)),
        J = r(n(560)),
        Q = r(n(561)),
        X = r(n(562)),
        Z = r(n(563)),
        ee = r(n(565)),
        te = r(n(566)),
        ne = r(n(567)),
        re = r(n(568)),
        oe = r(n(569)),
        ie = r(n(572)),
        ae = r(n(575)),
        se = r(n(279)),
        le = r(n(5)),
        ue = oe.default.extend({
      routes: {
        "": "defaultAuth",
        signin: "primaryAuth",
        "signin/verify/duo/web": "verifyDuo",
        "signin/verify/piv": "verifyPIV",
        "signin/poll": "poll",
        "signin/verify/fido/webauthn": "verifyWebauthn",
        "signin/verify/webauthn": "verifyWebauthn",
        "signin/verify/fido/u2f": "verifyU2F",
        "signin/verify/u2f": "verifyU2F",
        "signin/verify/generic_saml/assertion:saml2": "verifySAMLFactor",
        "signin/verify/generic_oidc/assertion:oidc": "verifyOIDCFactor",
        "signin/verify/custom/claims_provider": "verifyClaimsFactor",
        "signin/verify/:factorType": "verifyNoProvider",
        "signin/verify/:provider/:factorType(/:factorIndex)": "verify",
        "signin/enroll": "enrollChoices",
        "signin/enroll/duo/web": "enrollDuo",
        "signin/enroll/okta/question": "enrollQuestion",
        "signin/enroll/okta/password": "enrollPassword",
        "signin/enroll/okta/sms": "enrollSms",
        "signin/enroll/okta/call": "enrollCall",
        "signin/enroll/okta/email": "enrollEmail",
        "signin/enroll-activate/okta/sms": "enrollSms",
        "signin/enroll-activate/okta/call": "enrollCall",
        "signin/enroll/rsa/token": "enrollRsa",
        "signin/enroll/del_oath/token": "enrollOnPrem",
        "signin/enroll/symantec/token": "enrollSymantecVip",
        "signin/enroll/yubico/token:hardware": "enrollYubikey",
        "signin/enroll/fido/webauthn": "enrollWebauthn",
        "signin/enroll/fido/u2f": "enrollU2F",
        "signin/enroll/generic_saml/assertion:saml2": "enrollSAMLFactor",
        "signin/enroll/generic_oidc/assertion:oidc": "enrollOIDCFactor",
        "signin/enroll/custom/claims_provider": "enrollClaimsFactor",
        "signin/enroll/custom/token:hotp": "enrollHotpFactor",
        "signin/enroll/:provider/:factorType": "enrollTotpFactor",
        "signin/enroll-activate/okta/email": "enrollActivateEmail",
        "signin/enroll-activate/okta/push": "scanBarcodePushFactor",
        "signin/enroll-activate/okta/push/manual": "manualSetupPushFactor",
        "signin/enroll-activate/okta/push/sent": "activationLinkSent",
        "signin/enroll-activate/okta/token:software:totp/passcode": "enterPasscodeInPushEnrollmentFlow",
        "signin/enroll-activate/custom/claims_provider": "enrollActivateClaimsFactor",
        "signin/enroll-activate/:provider/:factorType": "scanBarcodeTotpFactor",
        "signin/enroll-activate/:provider/:factorType/activate": "activateTotpFactor",
        "signin/enroll-activate/:provider/:factorType/manual": "manualSetupTotpFactor",
        "signin/password-expired": "passwordExpired",
        "signin/custom-password-expired": "customPasswordExpired",
        "signin/forgot-password": "forgotPassword",
        "signin/recovery-challenge": "recoveryChallenge",
        "signin/recovery-emailed": "recoveryEmailSent",
        "signin/recovery-question": "recoveryQuestion",
        "signin/password-reset": "passwordReset",
        "signin/reset-password/:token": "recoveryLoading",
        "signin/user-unlock/:token": "recoveryLoading",
        "signin/recovery/:token": "recoveryLoading",
        "signin/unlock-emailed": "unlockEmailSent",
        "signin/unlock": "unlockAccount",
        "signin/account-unlocked": "accountUnlocked",
        "signin/refresh-auth-state(/:token)": "refreshAuthState",
        "signin/register": "register",
        "signin/register-complete": "registerComplete",
        "signin/error": "errorState",
        "signin/consent": "consentRequired",
        "signin/admin-consent": "adminConsentRequired",
        "signin/enroll-user": "enrollUser",
        "signin/device-activate-complete": "deviceActivateComplete",
        "signin/device-activate": "deviceActivate",
        "*wildcard": "defaultAuth"
      },
      stateLessRouteHandlers: ["defaultAuth", "idpDiscovery", "primaryAuth", "forgotPassword", "recoveryLoading", "unlockAccount", "refreshAuthState", "register", "registerComplete", "errorState", "verifyPIV"],
      defaultAuth: function defaultAuth() {
        if (location.hash === "#".concat(le.default.WIDGET_CONTAINER_ID)) return void document.getElementById(le.default.WIDGET_CONTAINER_ID).focus();
        this.settings.get("features.idpDiscovery") ? this.idpDiscovery() : this.primaryAuth();
      },
      idpDiscovery: function idpDiscovery() {
        this.render(M.default, {
          Beacon: se.default
        });
      },
      primaryAuth: function primaryAuth() {
        this.render(V.default, {
          Beacon: se.default
        });
      },
      verifyDuo: function verifyDuo() {
        this.render(X.default, {
          provider: "DUO",
          factorType: "web",
          Beacon: ie.default
        });
      },
      verifyPIV: function verifyPIV() {
        this.render(Z.default, {
          Beacon: ae.default
        });
      },
      poll: function poll() {
        this.render(B.default);
      },
      verifyWebauthn: function verifyWebauthn() {
        this.settings.get("features.webauthn") ? this.render(te.default, {
          provider: "FIDO",
          factorType: "webauthn",
          Beacon: ie.default
        }) : this.render(ne.default, {
          provider: "FIDO",
          factorType: "webauthn",
          Beacon: ie.default
        });
      },
      verifyU2F: function verifyU2F() {
        this.render(ee.default, {
          provider: "FIDO",
          factorType: "u2f",
          Beacon: ie.default
        });
      },
      verifySAMLFactor: function verifySAMLFactor() {
        this.render(Q.default, {
          provider: "GENERIC_SAML",
          factorType: "assertion:saml2",
          Beacon: ie.default
        });
      },
      verifyOIDCFactor: function verifyOIDCFactor() {
        this.render(Q.default, {
          provider: "GENERIC_OIDC",
          factorType: "assertion:oidc",
          Beacon: ie.default
        });
      },
      verifyClaimsFactor: function verifyClaimsFactor() {
        this.render(Q.default, {
          provider: "CUSTOM",
          factorType: "claims_provider",
          Beacon: ie.default
        });
      },
      verify: function verify(e, t, n) {
        this.render(D.default, {
          provider: e.toUpperCase(),
          factorType: t,
          factorIndex: n,
          Beacon: ie.default
        });
      },
      verifyNoProvider: function verifyNoProvider(e) {
        this.render(D.default, {
          factorType: e,
          Beacon: ie.default
        });
      },
      enrollChoices: function enrollChoices() {
        this.render(g.default, {
          Beacon: se.default
        });
      },
      enrollDuo: function enrollDuo() {
        this.render(y.default, {
          provider: "DUO",
          factorType: "web",
          Beacon: ie.default
        });
      },
      enrollQuestion: function enrollQuestion() {
        this.render(O.default, {
          provider: "OKTA",
          factorType: "question",
          Beacon: ie.default
        });
      },
      enrollPassword: function enrollPassword() {
        this.render(E.default, {
          provider: "OKTA",
          factorType: "password",
          Beacon: ie.default
        });
      },
      enrollSms: function enrollSms() {
        this.render(m.default, {
          provider: "OKTA",
          factorType: "sms",
          Beacon: ie.default
        });
      },
      enrollCall: function enrollCall() {
        this.render(m.default, {
          provider: "OKTA",
          factorType: "call",
          Beacon: ie.default
        });
      },
      enrollEmail: function enrollEmail() {
        this.render(b.default, {
          provider: "OKTA",
          factorType: "email",
          Beacon: ie.default
        });
      },
      enrollActivateEmail: function enrollActivateEmail() {
        this.render(h.default, {
          provider: "OKTA",
          factorType: "email",
          Beacon: ie.default
        });
      },
      enrollRsa: function enrollRsa() {
        this.render(w.default, {
          provider: "RSA",
          factorType: "token",
          Beacon: ie.default
        });
      },
      enrollOnPrem: function enrollOnPrem() {
        this.render(w.default, {
          provider: "DEL_OATH",
          factorType: "token",
          Beacon: ie.default
        });
      },
      enrollSymantecVip: function enrollSymantecVip() {
        this.render(S.default, {
          provider: "SYMANTEC",
          factorType: "token",
          Beacon: ie.default
        });
      },
      enrollYubikey: function enrollYubikey() {
        this.render(N.default, {
          provider: "YUBICO",
          factorType: "token:hardware",
          Beacon: ie.default
        });
      },
      enrollSAMLFactor: function enrollSAMLFactor() {
        this.render(v.default, {
          provider: "GENERIC_SAML",
          factorType: "assertion:saml2",
          Beacon: ie.default
        });
      },
      enrollOIDCFactor: function enrollOIDCFactor() {
        this.render(v.default, {
          provider: "GENERIC_OIDC",
          factorType: "assertion:oidc",
          Beacon: ie.default
        });
      },
      enrollClaimsFactor: function enrollClaimsFactor() {
        this.render(v.default, {
          provider: "CUSTOM",
          factorType: "claims_provider",
          Beacon: ie.default
        });
      },
      enrollActivateClaimsFactor: function enrollActivateClaimsFactor() {
        this.render(p.default, {
          provider: "CUSTOM",
          factorType: "claims_provider",
          Beacon: ie.default
        });
      },
      enrollTotpFactor: function enrollTotpFactor(e, t) {
        this.render(x.default, {
          provider: e.toUpperCase(),
          factorType: t,
          Beacon: ie.default
        });
      },
      enrollHotpFactor: function enrollHotpFactor() {
        this.render(_.default, {
          provider: "CUSTOM",
          factorType: "token:hotp",
          Beacon: ie.default
        });
      },
      enrollWebauthn: function enrollWebauthn() {
        this.settings.get("features.webauthn") ? this.render(C.default, {
          provider: "FIDO",
          factorType: "webauthn",
          Beacon: ie.default
        }) : this.render(A.default, {
          provider: "FIDO",
          factorType: "webauthn",
          Beacon: ie.default
        });
      },
      enrollU2F: function enrollU2F() {
        this.render(T.default, {
          provider: "FIDO",
          factorType: "u2f",
          Beacon: ie.default
        });
      },
      scanBarcodeTotpFactor: function scanBarcodeTotpFactor(e, t) {
        this.render(l.default, {
          provider: e.toUpperCase(),
          factorType: t,
          Beacon: ie.default
        });
      },
      scanBarcodePushFactor: function scanBarcodePushFactor() {
        this.render(s.default, {
          provider: "OKTA",
          factorType: "push",
          Beacon: ie.default
        });
      },
      activateTotpFactor: function activateTotpFactor(e, t) {
        this.render(i.default, {
          provider: e.toUpperCase(),
          factorType: t,
          Beacon: ie.default
        });
      },
      manualSetupTotpFactor: function manualSetupTotpFactor(e, t) {
        this.render(L.default, {
          provider: e.toUpperCase(),
          factorType: t,
          Beacon: ie.default
        });
      },
      manualSetupPushFactor: function manualSetupPushFactor() {
        this.render(j.default, {
          provider: "OKTA",
          factorType: "push",
          Beacon: ie.default
        });
      },
      activationLinkSent: function activationLinkSent() {
        this.render(P.default, {
          provider: "OKTA",
          factorType: "push",
          Beacon: ie.default
        });
      },
      enterPasscodeInPushEnrollmentFlow: function enterPasscodeInPushEnrollmentFlow() {
        this.render(R.default, {
          provider: "OKTA",
          factorType: "token:software:totp",
          Beacon: ie.default
        });
      },
      passwordExpired: function passwordExpired() {
        this.render(F.default, {
          Beacon: se.default
        });
      },
      customPasswordExpired: function customPasswordExpired() {
        this.render(c.default, {
          Beacon: se.default
        });
      },
      forgotPassword: function forgotPassword() {
        this.render(I.default);
      },
      recoveryChallenge: function recoveryChallenge() {
        this.render(q.default, {
          Beacon: se.default
        });
      },
      recoveryEmailSent: function recoveryEmailSent() {
        this.render(H.default, {
          Beacon: se.default
        });
      },
      unlockEmailSent: function unlockEmailSent() {
        this.render(J.default, {
          Beacon: se.default
        });
      },
      recoveryQuestion: function recoveryQuestion() {
        this.render(z.default, {
          Beacon: se.default
        });
      },
      passwordReset: function passwordReset() {
        this.render(U.default, {
          Beacon: se.default
        });
      },
      recoveryLoading: function recoveryLoading(e) {
        this.render(W.default, {
          token: e,
          Beacon: se.default
        });
      },
      unlockAccount: function unlockAccount() {
        this.render(Y.default);
      },
      accountUnlocked: function accountUnlocked() {
        this.render(o.default, {
          Beacon: se.default
        });
      },
      refreshAuthState: function refreshAuthState(e) {
        this.render($.default, {
          token: e,
          Beacon: se.default
        });
      },
      register: function register() {
        this.render(G.default);
      },
      registerComplete: function registerComplete() {
        this.render(K.default);
      },
      errorState: function errorState() {
        this.render(re.default, {
          Beacon: se.default
        });
      },
      consentRequired: function consentRequired() {
        this.render(u.default);
      },
      adminConsentRequired: function adminConsentRequired() {
        this.render(a.default);
      },
      enrollUser: function enrollUser() {
        this.render(k.default);
      },
      deviceActivate: function deviceActivate() {
        this.render(d.default);
      },
      deviceActivateComplete: function deviceActivateComplete() {
        this.render(f.default);
      }
    });

    t.default = ue;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(5)),
        a = r(n(4)),
        s = r(n(6)),
        l = a.default.extend({
      className: "account-unlocked",
      Model: function Model() {
        return {
          local: {
            userFullName: ["string", !1, this.options.appState.get("userFullName")]
          }
        };
      },
      Form: {
        title: o._.partial(o.loc, "account.unlock.unlocked.title", "login"),
        subtitle: o._.partial(o.loc, "account.unlock.unlocked.desc", "login"),
        noButtonBar: !0,
        attributes: {
          "data-se": "account-unlocked"
        },
        formChildren: function formChildren() {
          return [s.default.Button({
            title: (0, o.loc)("goback", "login"),
            className: "button button-primary button-wide",
            attributes: {
              "data-se": "back-button"
            },
            click: function click() {
              this.state.set("navigateDir", i.default.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
            }
          })];
        }
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(4)),
        i = r(n(251)),
        a = r(n(18)),
        s = o.default.extend({
      className: "activate-totp",
      Model: function Model() {
        return {
          props: {
            factorId: ["string", !0, this.options.appState.get("activatedFactorId")],
            passCode: ["string", !0]
          },
          local: {
            __factorType__: ["string", !1, this.options.factorType],
            __provider__: ["string", !1, this.options.provider]
          },
          save: function save() {
            return this.doTransaction(function (e) {
              return e.activate({
                passCode: this.get("passCode")
              });
            });
          }
        };
      },
      Form: i.default,
      Footer: a.default
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = r(n(42)),
        i = r(n(481)),
        a = r(n(485)),
        s = {
      MILLISECOND: "milliseconds",
      SECOND: "seconds",
      MINUTE: "minutes",
      HOUR: "hours",
      DAY: "days"
    },
        l = Object.keys(s),
        u = function u(e) {
      var t = l.filter(function (t) {
        return s[t] === e;
      });
      return 1 === t.length ? t[0] : e;
    },
        c = {
      getTimeInHighestRelevantUnit: function getTimeInHighestRelevantUnit(e, t) {
        var n,
            r = {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        },
            l = s[t] || t;

        try {
          var c = (0, i.default)(Object.assign(r, (0, o.default)({}, l, e)));
          n = (0, a.default)(c);
        } catch (e) {
          n = {};
        }

        var d,
            f,
            p = Object.keys(n).reduce(function (e, t) {
          return 0 !== n[t] && (e[t] = n[t]), e;
        }, {});
        return 1 === Object.keys(p).length ? Object.keys(p).forEach(function (e) {
          f = p[e], d = e;
        }) : (f = e, d = l), {
          time: f,
          unit: u(d)
        };
      }
    };

    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        o = r(n(10)),
        i = r(n(252)),
        a = {
      days: function days(e) {
        return 864e5 * e;
      },
      hours: function hours(e) {
        return 36e5 * e;
      },
      minutes: function minutes(e) {
        return 6e4 * e;
      },
      seconds: function seconds(e) {
        return 1e3 * e;
      },
      milliseconds: function milliseconds(e) {
        return e;
      },
      microseconds: function microseconds(e) {
        return e / 1e3;
      },
      nanoseconds: function nanoseconds(e) {
        return e / 1e6;
      }
    },
        s = function s(e) {
      return Object.entries(e).reduce(function (e, t) {
        var n = (0, i.default)(t, 2),
            r = n[0],
            s = n[1];
        if ("number" != typeof s) throw new TypeError("Expected a `number` for key `".concat(r, "`, got `").concat(s, "` (").concat((0, o.default)(s), ")"));
        if (!a[r]) throw new Error("Unsupported time key");
        return e + a[r](s);
      }, 0);
    };

    e.exports = s, e.exports.default = s;
  }, function (e, t) {
    function n(e) {
      if (Array.isArray(e)) return e;
    }

    e.exports = n;
  }, function (e, t) {
    function n(e, t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            r || null == s.return || s.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }
    }

    e.exports = n;
  }, function (e, t) {
    function n() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      if ("number" != typeof e) throw new TypeError("Expected a number");
      var t = e > 0 ? Math.floor : Math.ceil;
      return {
        days: t(e / 864e5),
        hours: t(e / 36e5) % 24,
        minutes: t(e / 6e4) % 60,
        seconds: t(e / 1e3) % 60,
        milliseconds: t(e) % 1e3,
        microseconds: t(1e3 * e) % 1e3,
        nanoseconds: t(1e6 * e) % 1e3
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        o = n(1),
        i = r(n(4)),
        a = r(n(6)),
        s = r(n(255)),
        l = r(n(256)),
        u = {
      props: {
        scopes: ["array", !0]
      },
      save: function save() {
        return this.doTransaction(function (e) {
          return e.consent({
            consent: {
              scopes: o._.pluck(this.get("scopes"), "name")
            }
          });
        });
      },
      cancel: function cancel() {
        var e = this;
        return this.doTransaction(function (e) {
          return e.cancel();
        }).then(function () {
          var t = e.settings.get("consent.cancel");
          o._.isFunction(t) && t();
        });
      }
    },
        c = o.View.extend({
      className: "consent-title detail-row",
      template: l.default,
      getTemplateData: function getTemplateData() {
        var e = this.options.appState;
        return {
          appName: e.escape("targetLabel"),
          customLogo: e.get("targetLogo") && e.get("targetLogo").href,
          defaultLogo: e.get("defaultAppLogo"),
          clientURI: e.get("targetClientURI") && e.get("targetClientURI").href,
          issuer: e.get("issuer")
        };
      }
    }),
        d = {
      noCancelButton: !1,
      buttonOrder: ["cancel", "save"],
      autoSave: !0,
      save: o._.partial(o.loc, "consent.required.consentButton", "login"),
      cancel: o._.partial(o.loc, "consent.required.cancelButton", "login"),
      formChildren: [a.default.View({
        View: c
      }), a.default.View({
        View: s.default
      })]
    },
        f = i.default.extend({
      Model: u,
      Form: d,
      className: "admin-consent-required",
      initialize: function initialize() {
        var e = this;
        this.model.set("scopes", this.options.appState.get("scopes")), this.listenTo(this.form, "cancel", function () {
          e.model.cancel();
        });
      }
    });
    e.exports = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1);
    n(114);
    var a = i.View.extend({
      className: "scope-item",
      template: o.default.template({
        1: function _(e, t, n, r, o) {
          return '<span class="scope-item-tooltip icon form-help-16" />';
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a,
              s = null != t ? t : e.nullContext || {},
              l = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<p class="scope-item-text no-translate">' + e.escapeExpression((a = null != (a = l(n, "name") || (null != t ? l(t, "name") : t)) ? a : e.hooks.helperMissing, "function" == typeof a ? a.call(s, {
            name: "name",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 40
              },
              end: {
                line: 1,
                column: 48
              }
            }
          }) : a)) + "</p>" + (null != (i = l(n, "if").call(s, null != t ? l(t, "description") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 52
              },
              end: {
                line: 1,
                column: 131
              }
            }
          })) ? i : "");
        },
        useData: !0
      }),
      postRender: function postRender() {
        this.$(".scope-item-tooltip").qtip({
          content: {
            text: i._.escape(this.options.description)
          },
          style: {
            classes: "okta-tooltip qtip-custom qtip-shadow"
          },
          position: {
            my: "bottom left",
            target: "mouse"
          }
        });
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(15)),
        a = r(n(4)),
        s = r(n(6)),
        l = r(n(257)),
        u = r(n(18)),
        c = a.default.extend({
      className: "barcode-push",
      Model: function Model() {
        return {
          local: {
            __factorType__: ["string", !1, this.options.factorType],
            __provider__: ["string", !1, this.options.provider]
          }
        };
      },
      Form: {
        title: function title() {
          var e = i.default.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
          return (0, o.loc)("enroll.totp.title", "login", [e]);
        },
        noButtonBar: !0,
        attributes: {
          "data-se": "step-scan"
        },
        className: "barcode-scan",
        initialize: function initialize() {
          this.listenTo(this.model, "error errors:clear", function () {
            this.clearErrors();
          });
        },
        formChildren: [s.default.View({
          View: l.default
        })]
      },
      Footer: u.default,
      initialize: function initialize() {
        this.pollForEnrollment();
      },
      pollForEnrollment: function pollForEnrollment() {
        return this.model.doTransaction(function (e) {
          return e.poll(6e3);
        });
      },
      trapAuthResponse: function trapAuthResponse() {
        if (this.options.appState.get("isMfaEnrollActivate")) return !0;
      }
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = {
      INVALID_TOKEN_EXCEPTION: "E0000011"
    };
    t.default = r;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(15)),
        a = r(n(4)),
        s = r(n(6)),
        l = r(n(39)),
        u = r(n(257)),
        c = r(n(18)),
        d = a.default.extend({
      className: "barcode-totp",
      Model: function Model() {
        return {
          local: {
            __factorType__: ["string", !1, this.options.factorType],
            __provider__: ["string", !1, this.options.provider]
          }
        };
      },
      Form: {
        title: function title() {
          var e = i.default.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
          return (0, o.loc)("enroll.totp.title", "login", [e]);
        },
        save: o._.partial(o.loc, "oform.next", "login"),
        noCancelButton: !0,
        attributes: {
          "data-se": "step-scan"
        },
        className: "barcode-scan",
        formChildren: [s.default.View({
          View: u.default
        })]
      },
      Footer: c.default,
      initialize: function initialize() {
        this.listenTo(this.form, "save", function () {
          var e = l.default.createActivateFactorUrl(this.model.get("__provider__"), this.model.get("__factorType__"), "activate");
          this.options.appState.trigger("navigate", e);
        });
      }
    });
    t.default = d;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(5)),
        s = r(n(4)),
        l = r(n(6)),
        u = r(n(258)),
        c = r(n(493)),
        d = r(n(256)),
        f = s.default.extend({
      className: "consent-required",
      initialize: function initialize() {
        this.model.set("expiresAt", this.options.appState.get("expiresAt")), this.model.set("scopes", this.options.appState.get("scopes")), this.listenTo(this.form, "cancel", i._.bind(this.model.cancel, this.model));
        var e = new c.default();
        (0, i.$)("#".concat(a.default.WIDGET_LOGIN_CONTAINER_ID)).prepend(e.render().$el);
      },
      postRender: function postRender() {
        s.default.prototype.postRender.apply(this, arguments), this.$(".o-form-button-bar .button-primary").removeClass("button-primary");
      },
      Model: {
        props: {
          expiresAt: ["string", !0],
          scopes: ["array", !0]
        },
        save: function save() {
          return this.doTransaction(function (e) {
            return e.consent({
              consent: {
                expiresAt: this.get("expiresAt"),
                scopes: i._.pluck(this.get("scopes"), "name")
              }
            });
          });
        },
        cancel: function cancel() {
          var e = this;
          return this.doTransaction(function (e) {
            return e.cancel();
          }).then(function () {
            var t = e.settings.get("consent.cancel");
            i._.isFunction(t) && t();
          });
        }
      },
      Form: {
        noCancelButton: !1,
        buttonOrder: ["cancel", "save"],
        autoSave: !0,
        save: i._.partial(i.loc, "consent.required.consentButton", "login"),
        cancel: i._.partial(i.loc, "consent.required.cancelButton", "login"),
        formChildren: function formChildren() {
          return [l.default.View({
            View: i.View.extend({
              className: "consent-title detail-row",
              template: d.default,
              getTemplateData: function getTemplateData() {
                var e = this.options.appState;
                return {
                  appName: e.escape("targetLabel"),
                  customLogo: e.get("targetLogo") && e.get("targetLogo").href,
                  defaultLogo: e.get("defaultAppLogo"),
                  clientURI: e.get("targetClientURI") && e.get("targetClientURI").href
                };
              }
            })
          }), l.default.View({
            View: new u.default({
              model: this.model
            })
          }), l.default.View({
            View: i.View.extend({
              className: "consent-description detail-row",
              template: o.default.template({
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, o) {
                  var i = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return "<p>" + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                    name: "i18n",
                    hash: {
                      bundle: "login",
                      code: "consent.required.description"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 3
                      },
                      end: {
                        line: 1,
                        column: 62
                      }
                    }
                  })) + "</p>";
                },
                useData: !0
              })
            })
          })];
        }
      },
      Footer: i.View.extend({
        className: "consent-footer",
        template: o.default.template({
          1: function _(e, t, n, r, o) {
            var i,
                a,
                s = null != t ? t : e.nullContext || {},
                l = e.hooks.helperMissing,
                u = e.escapeExpression,
                c = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<a class="terms-of-service" href="' + u((a = null != (a = c(n, "termsOfService") || (null != t ? c(t, "termsOfService") : t)) ? a : l, "function" == typeof a ? a.call(s, {
              name: "termsOfService",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 56
                },
                end: {
                  line: 1,
                  column: 74
                }
              }
            }) : a)) + '" target="_blank">' + u((c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
              name: "i18n",
              hash: {
                bundle: "login",
                code: "consent.required.termsOfService"
              },
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 92
                },
                end: {
                  line: 1,
                  column: 154
                }
              }
            })) + "</a>" + (null != (i = c(n, "if").call(s, null != t ? c(t, "privacyPolicy") : t, {
              name: "if",
              hash: {},
              fn: e.program(2, o, 0),
              inverse: e.noop,
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 158
                },
                end: {
                  line: 1,
                  column: 194
                }
              }
            })) ? i : "");
          },
          2: function _(e, t, n, r, o) {
            return " &#8226 ";
          },
          4: function _(e, t, n, r, o) {
            var i,
                a = null != t ? t : e.nullContext || {},
                s = e.hooks.helperMissing,
                l = e.escapeExpression,
                u = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<a class="privacy-policy" href="' + l((i = null != (i = u(n, "privacyPolicy") || (null != t ? u(t, "privacyPolicy") : t)) ? i : s, "function" == typeof i ? i.call(a, {
              name: "privacyPolicy",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 254
                },
                end: {
                  line: 1,
                  column: 271
                }
              }
            }) : i)) + '" target="_blank">' + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
              name: "i18n",
              hash: {
                bundle: "login",
                code: "consent.required.privacyPolicy"
              },
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 289
                },
                end: {
                  line: 1,
                  column: 350
                }
              }
            })) + "</a>";
          },
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, o) {
            var i,
                a = null != t ? t : e.nullContext || {},
                s = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return (null != (i = s(n, "if").call(a, null != t ? s(t, "termsOfService") : t, {
              name: "if",
              hash: {},
              fn: e.program(1, o, 0),
              inverse: e.noop,
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 0
                },
                end: {
                  line: 1,
                  column: 201
                }
              }
            })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "privacyPolicy") : t, {
              name: "if",
              hash: {},
              fn: e.program(4, o, 0),
              inverse: e.noop,
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 201
                },
                end: {
                  line: 1,
                  column: 361
                }
              }
            })) ? i : "");
          },
          useData: !0
        }),
        getTemplateData: function getTemplateData() {
          var e = this.options.appState;
          return {
            termsOfService: e.get("targetTermsOfService") && e.get("targetTermsOfService").href,
            privacyPolicy: e.get("targetPrivacyPolicy") && e.get("targetPrivacyPolicy").href
          };
        }
      })
    });
    t.default = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1);
    n(114);
    var s = a.View.extend({
      className: "scope-item",
      template: i.default.template({
        1: function _(e, t, n, r, o) {
          return '<span class="scope-item-tooltip icon form-help-16"></span>';
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s,
              l = null != t ? t : e.nullContext || {},
              u = e.hooks.helperMissing,
              c = e.escapeExpression,
              d = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="' + c((s = null != (s = d(n, "classNames") || (null != t ? d(t, "classNames") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "classNames",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 12
              },
              end: {
                line: 1,
                column: 26
              }
            }
          }) : s)) + '"><p>' + c((s = null != (s = d(n, "name") || (null != t ? d(t, "name") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "name",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 31
              },
              end: {
                line: 1,
                column: 39
              }
            }
          }) : s)) + "</p></div>" + (null != (a = d(n, "if").call(l, null != t ? d(t, "description") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 49
              },
              end: {
                line: 1,
                column: 133
              }
            }
          })) ? a : "");
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        var e = this.options,
            t = e.name,
            n = e.description,
            r = e.isCustomized;
        return {
          classNames: "openid" === t || r ? "".concat("scope-item-text", " no-translate") : "scope-item-text",
          name: t,
          description: n
        };
      },
      postRender: function postRender() {
        this.$(".scope-item-tooltip").qtip({
          content: {
            text: a._.escape(this.options.description)
          },
          style: {
            classes: "okta-tooltip qtip-custom qtip-shadow"
          },
          position: {
            my: "bottom right",
            target: "mouse"
          }
        });
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(5)),
        a = o.View.extend({
      tagName: "a",
      className: "skip-to-content-link",
      attributes: {
        href: "#".concat(i.default.WIDGET_CONTAINER_ID)
      },
      initialize: function initialize() {
        this.$el.append((0, o.loc)("skip.to.main.content", "login"));
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(4)),
        a = r(n(6)),
        s = r(n(259)),
        l = o.internal.util.Util,
        u = i.default.extend({
      className: "custom-password-expired",
      Model: {},
      Form: {
        noButtonBar: !0,
        title: function title() {
          var e = this.options.appState.get("isPwdExpiringSoon"),
              t = this.options.appState.get("passwordExpireDays");
          return e && t > 0 ? (0, o.loc)("password.expiring.title", "login", [t]) : e && 0 === t ? (0, o.loc)("password.expiring.today", "login") : e ? (0, o.loc)("password.expiring.soon", "login") : this.settings.get("brandName") ? (0, o.loc)("password.expired.title.specific", "login", [this.settings.get("brandName")]) : (0, o.loc)("password.expired.title.generic", "login");
        },
        subtitle: function subtitle() {
          if (this.options.appState.get("isPwdExpiringSoon")) {
            return (this.settings.get("brandName") ? (0, o.loc)("password.expiring.subtitle.specific", "login", [this.settings.get("brandName")]) : (0, o.loc)("password.expiring.subtitle.generic", "login")) + " " + (0, o.loc)("password.expired.custom.subtitle", "login");
          }

          return (0, o.loc)("password.expired.custom.subtitle", "login");
        },
        formChildren: function formChildren() {
          return [a.default.Button({
            title: o._.partial(o.loc, "password.expired.custom.submit", "login", [this.options.appState.get("passwordExpiredWebsiteName")]),
            className: "button button-primary button-wide",
            attributes: {
              "data-se": "custom-button"
            },
            click: function click() {
              l.redirect(this.options.appState.get("passwordExpiredLinkUrl"));
            }
          })];
        }
      },
      Footer: s.default
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(4)),
        a = r(n(6)),
        s = r(n(13)),
        l = i.default.extend({
      className: "device-code-activate",
      Model: {
        props: {
          userCode: ["string", !0],
          stateToken: "string"
        },
        save: function save() {
          var e = this;
          return this.doTransaction(function (t) {
            return t.deviceActivate({
              userCode: e.get("userCode")
            });
          });
        }
      },
      Form: {
        noCancelButton: !0,
        autoSave: !0,
        save: function save() {
          return (0, o.loc)("oform.next", "login");
        },
        title: function title() {
          return (0, o.loc)("device.code.activate.title", "login");
        },
        subtitle: function subtitle() {
          return (0, o.loc)("device.code.activate.subtitle", "login");
        },
        formChildren: function formChildren() {
          return [a.default.Input({
            label: (0, o.loc)("device.code.activate.label", "login"),
            "label-top": !0,
            name: "userCode",
            input: s.default,
            inputId: "user-code",
            type: "text",
            inlineValidation: !1
          })];
        },
        events: {
          'keyup input[name="userCode"]': function keyupInputNameUserCode(e) {
            e.preventDefault(), this.addHyphen(e);
          }
        },
        addHyphen: function addHyphen(e) {
          var t = e.target.value;
          t && 4 === t.length && !["Backspace", "Delete", "-"].includes(e.key) && (e.target.value = t.concat("-"));
        }
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(4)),
        s = r(n(6)),
        l = ["DEVICE_NOT_ACTIVATED_CONSENT_DENIED", "DEVICE_NOT_ACTIVATED"],
        u = a.default.extend({
      className: "device-code-terminal",
      postRender: function postRender() {
        a.default.prototype.postRender.apply(this, arguments);
        var e = "DEVICE_ACTIVATED" === this.options.appState.get("deviceActivationStatus") ? "success-24-green" : "error-24-red";
        this.$(".o-form-head").before('<div class="device-code-terminal--icon-container"><span class="device-code-terminal--icon ' + e + '"></span></div>');
      },
      Model: {},
      Form: {
        noCancelButton: !0,
        noButtonBar: !0,
        title: function title() {
          var e = this.options.appState.get("deviceActivationStatus");
          return "DEVICE_ACTIVATED" === e ? (0, i.loc)("device.code.activated.success.title", "login") : i._.contains(l, e) ? (0, i.loc)("device.code.activated.error.title", "login") : void 0;
        },
        subtitle: function subtitle() {
          var e = this.options.appState.get("deviceActivationStatus");
          return "DEVICE_ACTIVATED" === e ? (0, i.loc)("idx.device.activated", "login") : "DEVICE_NOT_ACTIVATED_CONSENT_DENIED" === e ? (0, i.loc)("idx.device.not.activated.consent.denied", "login") : "DEVICE_NOT_ACTIVATED" === e ? (0, i.loc)("idx.device.not.activated.internal.error", "login") : void 0;
        },
        formChildren: function formChildren() {
          return [s.default.View({
            View: i.View.extend({
              template: o.default.template({
                1: function _(e, t, n, r, o) {
                  var i = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<a href="/activate" class="button button-primary text-align-c retry-button" data-se="try-again">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                    name: "i18n",
                    hash: {
                      bundle: "login",
                      code: "oie.try.again"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 121
                      },
                      end: {
                        line: 1,
                        column: 165
                      }
                    }
                  })) + "</a>";
                },
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, o) {
                  var i,
                      a = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return null != (i = a(n, "if").call(null != t ? t : e.nullContext || {}, null != t ? a(t, "isDeviceCodeError") : t, {
                    name: "if",
                    hash: {},
                    fn: e.program(1, o, 0),
                    inverse: e.noop,
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 0
                      },
                      end: {
                        line: 1,
                        column: 176
                      }
                    }
                  })) ? i : "";
                },
                useData: !0
              }),
              getTemplateData: function getTemplateData() {
                return {
                  isDeviceCodeError: i._.contains(l, this.options.appState.get("deviceActivationStatus"))
                };
              }
            })
          })];
        }
      }
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(260)),
        a = r(n(115)),
        s = r(n(6)),
        l = r(n(47)),
        u = o.internal.util.Util,
        c = i.default.extend({
      Model: {
        local: {
          provider: "string",
          factorType: "string"
        },
        save: function save() {
          var e = this;
          return this.manageTransaction(function () {
            var t = e.appState.get("enrollCustomFactorRedirectUrl");
            null !== t && u.redirect(t);
          });
        }
      },
      Form: function Form() {
        var e = new a.default.Model(this.options.appState.get("factor"), this.toJSON()),
            t = e.get("vendorName");
        return {
          autoSave: !0,
          title: t,
          subtitle: (0, o.loc)("enroll.customFactor.subtitle", "login", [t]),
          save: (0, o.loc)("enroll.customFactor.save", "login"),
          formChildren: function formChildren() {
            var e = [];
            return this.options.appState.get("isFactorResultFailed") && e.push(s.default.View({
              View: new l.default({
                message: this.options.appState.get("factorResultErrorMessage")
              })
            }, {
              selector: ".o-form-error-container"
            })), e;
          }
        };
      }
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = r(n(2)),
        i = n(1),
        a = r(n(4)),
        s = r(n(6)),
        l = r(n(261)),
        u = r(n(18)),
        c = {
      props: {
        passCode: "string"
      },
      resend: function resend() {
        return this.trigger("form:clear-errors"), this.doTransaction(function (e) {
          return e.resend("email");
        });
      },
      save: function save() {
        this.trigger("save");
        var e = this.toJSON();
        return this.doTransaction(function (t) {
          return t.activate(e);
        });
      }
    },
        d = function d() {
      return {
        title: i._.partial(i.loc, "email.enroll.title", "login"),
        noButtonBar: !1,
        autoSave: !0,
        save: i._.partial(i.loc, "oform.verify", "login"),
        formChildren: [s.default.View({
          View: i.View.extend({
            className: "enroll-activate-email-content",
            attributes: {
              "data-se": "enroll-activate-email-content"
            },
            template: o.default.template({
              compiler: [8, ">= 4.3.0"],
              main: function main(e, t, n, r, o) {
                var i,
                    a = e.lookupProperty || function (e, t) {
                  if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                };

                return null != (i = (a(n, "i18n") || t && a(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                  name: "i18n",
                  hash: {
                    arguments: "factorEmail",
                    bundle: "login",
                    code: "email.mfa.email.sent.description"
                  },
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 0
                    },
                    end: {
                      line: 1,
                      column: 89
                    }
                  }
                })) ? i : "";
              },
              useData: !0
            }),
            getTemplateData: function getTemplateData() {
              var e = this.options.appState.get("factor"),
                  t = e && e.profile ? e.profile.email : "";
              return {
                factorEmail: o.default.template({
                  compiler: [8, ">= 4.3.0"],
                  main: function main(e, t, n, r, o) {
                    var i,
                        a = e.lookupProperty || function (e, t) {
                      if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                    };

                    return '<span class="mask-email">' + e.escapeExpression((i = null != (i = a(n, "email") || (null != t ? a(t, "email") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
                      name: "email",
                      hash: {},
                      data: o,
                      loc: {
                        start: {
                          line: 1,
                          column: 25
                        },
                        end: {
                          line: 1,
                          column: 34
                        }
                      }
                    }) : i)) + "</span>";
                  },
                  useData: !0
                })({
                  email: t
                })
              };
            }
          })
        }), s.default.View({
          View: l.default
        }), s.default.Input({
          label: (0, i.loc)("email.code.label", "login"),
          "label-top": !0,
          name: "passCode",
          type: "text",
          wide: !0
        })]
      };
    },
        f = a.default.extend({
      className: "enroll-activate-email",
      Model: c,
      Form: d,
      Footer: u.default
    });

    t.default = f;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return "call" === e;
    }

    function o(e) {
      return r(e) ? "enroll-call" : "enroll-sms";
    }

    function i(e) {
      v.isEnter(e) && (e.stopPropagation(), e.preventDefault(), "keyup" === e.type && e.data && e.data.model && e.data.model.sendCode());
    }

    var a = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var s = a(n(2)),
        l = n(1),
        u = a(n(74)),
        c = a(n(5)),
        d = a(n(4)),
        f = a(n(6)),
        p = a(n(12)),
        h = a(n(18)),
        m = a(n(262)),
        g = a(n(13)),
        v = l.internal.util.Keys,
        y = l.View.extend({
      className: "okta-form-infobox-warning infobox infobox-warning login-timeout-warning",
      attributes: {
        "aria-live": "polite"
      },
      template: s.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a,
              s = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<span class="icon warning-16"></span><p>' + (null != (a = null != (a = s(n, "warning") || (null != t ? s(t, "warning") : t)) ? a : e.hooks.helperMissing, i = "function" == typeof a ? a.call(null != t ? t : e.nullContext || {}, {
            name: "warning",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 40
              },
              end: {
                line: 1,
                column: 53
              }
            }
          }) : a) ? i : "") + "</p>";
        },
        useData: !0
      })
    }),
        b = {
      factorId: function factorId(e) {
        return !l._.isUndefined(e);
      }
    },
        _ = d.default.extend({
      className: function className() {
        return o(this.options.factorType);
      },
      Model: function Model() {
        return {
          props: {
            phoneNumber: ["string", !0],
            phoneExtension: ["string", !1],
            lastEnrolledPhoneNumber: "string",
            passCode: ["string", !0],
            factorId: "string"
          },
          local: {
            countryCode: ["string", !1, this.options.appState.get("userCountryCode")],
            hasExistingPhones: "boolean",
            trapEnrollment: "boolean",
            ableToResend: "boolean",
            factorType: "string",
            skipPhoneValidation: "boolean"
          },
          derived: {
            countryCallingCode: {
              deps: ["countryCode"],
              fn: function fn(e) {
                return "+" + u.default.getCallingCodeForCountry(e);
              }
            },
            fullPhoneNumber: {
              deps: ["countryCallingCode", "phoneNumber"],
              fn: function fn(e, t) {
                return t ? e + t : "";
              }
            },
            enrolled: {
              deps: ["lastEnrolledPhoneNumber", "fullPhoneNumber"],
              fn: function fn(e, t) {
                return e === t;
              }
            }
          },
          limitResending: function limitResending() {
            this.set({
              ableToResend: !1
            }), l._.delay(l._.bind(this.set, this), c.default.API_RATE_LIMIT, {
              ableToResend: !0
            });
          },
          sendCode: function sendCode() {
            var e = this,
                t = this.get("fullPhoneNumber"),
                n = this.get("phoneExtension");
            return e.trigger("errors:clear"), t.length ? this.doTransaction(function (o) {
              var i = "MFA_ENROLL" === o.status || "FACTOR_ENROLL" === o.status,
                  a = {
                phoneNumber: t,
                updatePhone: !i || e.get("hasExistingPhones")
              };
              r(e.get("factorType")) && (a.phoneExtension = n), e.get("skipPhoneValidation") && (a.validatePhone = !1);

              var s = function s(t) {
                return l._.findWhere(t.factors, {
                  factorType: e.get("factorType"),
                  provider: "OKTA"
                }).enroll({
                  profile: a
                }).catch(function (t) {
                  throw "E0000098" === t.errorCode && (e.set("skipPhoneValidation", !0), t.xhr.responseJSON.errorSummary = (0, l.loc)("enroll.sms.try_again", "login")), t;
                });
              };

              return i ? s(o) : (e.set("trapEnrollment", !0), o.prev().then(s).then(function (t) {
                return e.set("trapEnrollment", !1), t;
              }));
            }, !0).then(function () {
              e.set("lastEnrolledPhoneNumber", t), e.limitResending();
            }).catch(function () {
              e.set("ableToResend", !0), e.set("trapEnrollment", !1);
            }) : void e.trigger("invalid", e, {
              phoneNumber: "model.validation.field.blank"
            });
          },
          resendCode: function resendCode() {
            return this.trigger("errors:clear"), this.limitResending(), this.doTransaction(function (e) {
              return e.resend(this.get("factorType"));
            });
          },
          save: function save() {
            return this.doTransaction(function (e) {
              return e.activate({
                passCode: this.get("passCode")
              });
            });
          }
        };
      },
      Form: function Form() {
        var e = this.options.factorType,
            t = r(e),
            n = (0, l.loc)(t ? "enroll.call.setup" : "enroll.sms.setup", "login"),
            a = (0, l.loc)(t ? "mfa.call" : "mfa.sendCode", "login"),
            s = (0, l.loc)(t ? "mfa.redial" : "mfa.resendCode", "login"),
            c = (0, l.loc)(t ? "mfa.calling" : "mfa.sent", "login"),
            d = t ? "enroll-call-phone" : "enroll-sms-phone",
            h = t ? "call-request-button" : "sms-request-button",
            v = [f.default.Input({
          name: "countryCode",
          type: "select",
          wide: !0,
          options: u.default.getCountries()
        }), f.default.Input({
          label: (0, l.loc)("mfa.phoneNumber.placeholder", "login"),
          "label-top": !0,
          className: d,
          name: "phoneNumber",
          input: m.default,
          type: "text",
          render: function render() {
            this.$('input[name="phoneNumber"]').off("keydown keyup", i).keydown(i).keyup({
              model: this.model
            }, i);
          }
        })];
        return t && v.push(f.default.Input({
          label: (0, l.loc)("mfa.phoneNumber.ext.placeholder", "login"),
          "label-top": !0,
          className: "enroll-call-extension",
          name: "phoneExtension",
          input: g.default,
          type: "text"
        })), v.push(f.default.Button({
          title: a,
          attributes: {
            "data-se": h
          },
          className: "button button-primary js-enroll-phone margin-top-30 " + h,
          click: function click() {
            this.model.sendCode();
          }
        }), f.default.Button({
          title: s,
          attributes: {
            "data-se": h
          },
          className: "button js-enroll-phone margin-top-30 " + h,
          click: function click() {
            this.model.resendCode();
          },
          initialize: function initialize() {
            this.$el.css({
              display: "none"
            }), this.listenTo(this.model, "change:ableToResend", function (e, t) {
              t ? (this.options.title = s, this.enable()) : (this.options.title = c, this.disable()), this.render();
            });
          }
        }), f.default.Divider({
          showWhen: b
        }), f.default.Input({
          label: (0, l.loc)("mfa.challenge.enterCode.placeholder", "login"),
          "label-top": !0,
          explain: p.default.createInputExplain("mfa.challenge.enterCode.tooltip", "mfa.challenge.enterCode.placeholder", "login"),
          "explain-top": !0,
          name: "passCode",
          input: g.default,
          type: "tel",
          showWhen: b
        }), f.default.Toolbar({
          noCancelButton: !0,
          save: (0, l.loc)("mfa.challenge.verify", "login"),
          showWhen: b
        })), {
          title: n,
          noButtonBar: !0,
          autoSave: !0,
          className: o(e),
          showWarning: function showWarning(e) {
            this.clearWarnings(), this.add(y, ".o-form-error-container", {
              options: {
                warning: e
              }
            });
          },
          clearWarnings: function clearWarnings() {
            this.$(".okta-form-infobox-warning").remove();
          },
          initialize: function initialize() {
            this.listenTo(this.model, "change:ableToResend", function (e, n) {
              n ? this.showWarning((0, l.loc)(t ? "factor.call.time.warning" : "factor.sms.time.warning", "login")) : this.clearWarnings();
            }), this.listenTo(this.model, "error errors:clear", function () {
              this.clearWarnings(), this.clearErrors();
            }), this.listenTo(this.model, "change:enrolled", function () {
              this.$(".js-enroll-phone").toggle();
            });
          },
          formChildren: v
        };
      },
      Footer: h.default,
      trapAuthResponse: function trapAuthResponse() {
        return this.options.appState.get("isMfaEnrollActivate") ? (this.model.set("factorId", this.options.appState.get("activatedFactorId")), !0) : !(!this.options.appState.get("isMfaEnroll") || !this.model.get("trapEnrollment")) || void 0;
      },
      initialize: function initialize() {
        r(this.options.factorType) ? this.model.set("hasExistingPhones", this.options.appState.get("hasExistingPhonesForCall")) : this.model.set("hasExistingPhones", this.options.appState.get("hasExistingPhones")), this.model.set("factorType", this.options.factorType);
      }
    });

    t.default = _;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = {
      US: "1",
      AG: "1",
      AI: "1",
      AS: "1",
      BB: "1",
      BM: "1",
      BS: "1",
      CA: "1",
      DM: "1",
      DO: "1",
      GD: "1",
      GU: "1",
      JM: "1",
      KN: "1",
      KY: "1",
      LC: "1",
      MP: "1",
      MS: "1",
      PR: "1",
      SX: "1",
      TC: "1",
      TT: "1",
      VC: "1",
      VG: "1",
      VI: "1",
      RU: "7",
      KZ: "7",
      EG: "20",
      ZA: "27",
      GR: "30",
      NL: "31",
      BE: "32",
      FR: "33",
      ES: "34",
      HU: "36",
      IT: "39",
      VA: "39",
      RO: "40",
      CH: "41",
      AT: "43",
      GB: "44",
      GG: "44",
      IM: "44",
      JE: "44",
      DK: "45",
      SE: "46",
      NO: "47",
      SJ: "47",
      PL: "48",
      DE: "49",
      PE: "51",
      MX: "52",
      CU: "53",
      AR: "54",
      BR: "55",
      CL: "56",
      CO: "57",
      VE: "58",
      MY: "60",
      AU: "61",
      CC: "61",
      CX: "61",
      ID: "62",
      PH: "63",
      NZ: "64",
      SG: "65",
      TH: "66",
      JP: "81",
      KR: "82",
      VN: "84",
      CN: "86",
      TR: "90",
      IN: "91",
      PK: "92",
      AF: "93",
      LK: "94",
      MM: "95",
      IR: "98",
      SS: "211",
      MA: "212",
      EH: "212",
      DZ: "213",
      TN: "216",
      LY: "218",
      GM: "220",
      SN: "221",
      MR: "222",
      ML: "223",
      GN: "224",
      CI: "225",
      BF: "226",
      NE: "227",
      TG: "228",
      BJ: "229",
      MU: "230",
      LR: "231",
      SL: "232",
      GH: "233",
      NG: "234",
      TD: "235",
      CF: "236",
      CM: "237",
      CV: "238",
      ST: "239",
      GQ: "240",
      GA: "241",
      CG: "242",
      CD: "243",
      AO: "244",
      GW: "245",
      IO: "246",
      AC: "247",
      SC: "248",
      SD: "249",
      RW: "250",
      ET: "251",
      SO: "252",
      DJ: "253",
      KE: "254",
      TZ: "255",
      UG: "256",
      BI: "257",
      MZ: "258",
      ZM: "260",
      MG: "261",
      RE: "262",
      YT: "262",
      ZW: "263",
      NA: "264",
      MW: "265",
      LS: "266",
      BW: "267",
      SZ: "268",
      KM: "269",
      SH: "290",
      TA: "290",
      ER: "291",
      AW: "297",
      FO: "298",
      GL: "299",
      GI: "350",
      PT: "351",
      LU: "352",
      IE: "353",
      IS: "354",
      AL: "355",
      MT: "356",
      CY: "357",
      FI: "358",
      AX: "358",
      BG: "359",
      LT: "370",
      LV: "371",
      EE: "372",
      MD: "373",
      AM: "374",
      BY: "375",
      AD: "376",
      MC: "377",
      SM: "378",
      UA: "380",
      RS: "381",
      ME: "382",
      XK: "383",
      HR: "385",
      SI: "386",
      BA: "387",
      MK: "389",
      CZ: "420",
      SK: "421",
      LI: "423",
      FK: "500",
      BZ: "501",
      GT: "502",
      SV: "503",
      HN: "504",
      NI: "505",
      CR: "506",
      PA: "507",
      PM: "508",
      HT: "509",
      GP: "590",
      BL: "590",
      MF: "590",
      BO: "591",
      GY: "592",
      EC: "593",
      GF: "594",
      PY: "595",
      MQ: "596",
      SR: "597",
      UY: "598",
      CW: "599",
      BQ: "599",
      TL: "670",
      NF: "672",
      BN: "673",
      NR: "674",
      PG: "675",
      TO: "676",
      SB: "677",
      VU: "678",
      FJ: "679",
      PW: "680",
      WF: "681",
      CK: "682",
      NU: "683",
      WS: "685",
      KI: "686",
      NC: "687",
      TV: "688",
      PF: "689",
      TK: "690",
      FM: "691",
      MH: "692",
      "001": "979",
      KP: "850",
      HK: "852",
      MO: "853",
      KH: "855",
      LA: "856",
      BD: "880",
      TW: "886",
      MV: "960",
      LB: "961",
      JO: "962",
      SY: "963",
      IQ: "964",
      KW: "965",
      SA: "966",
      YE: "967",
      OM: "968",
      PS: "970",
      AE: "971",
      IL: "972",
      BH: "973",
      QA: "974",
      BT: "975",
      MN: "976",
      NP: "977",
      TJ: "992",
      TM: "993",
      AZ: "994",
      GE: "995",
      KG: "996",
      UZ: "998",
      GS: "500",
      PN: "64",
      AQ: "672",
      UM: "1",
      AN: "599"
    };
    t.default = r;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(263)),
        s = r(n(502)),
        l = r(n(503)),
        u = r(n(5)),
        c = r(n(4)),
        d = r(n(39)),
        f = o.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, o) {
        var i,
            a,
            s = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return "<span>" + (null != (a = null != (a = s(n, "subtitle") || (null != t ? s(t, "subtitle") : t)) ? a : e.hooks.helperMissing, i = "function" == typeof a ? a.call(null != t ? t : e.nullContext || {}, {
          name: "subtitle",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 6
            },
            end: {
              line: 1,
              column: 20
            }
          }
        }) : a) ? i : "") + "</span>";
      },
      useData: !0
    }),
        p = c.default.extend({
      className: "enroll-choices",
      state: {
        pageType: null
      },
      Model: {},
      Form: {
        noCancelButton: !0,
        title: i._.partial(i.loc, "enroll.choices.title", "login"),
        noButtonBar: function noButtonBar() {
          return this.state.get("pageType") === u.default.ALL_OPTIONAL_NONE_ENROLLED;
        },
        subtitle: " ",
        getSubtitle: function getSubtitle() {
          switch (this.state.get("pageType")) {
            case u.default.ALL_OPTIONAL_SOME_ENROLLED:
            case u.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
              return (0, i.loc)("enroll.choices.optional", "login");

            case u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
              var e = this.options.appState.get("gracePeriodRemainingDays");
              return Number.isInteger(e) && e >= 0 ? this.getGracePeriodSubtitle(e) : this.getDefaultSubtitle();

            default:
              return this.getDefaultSubtitle();
          }
        },
        getDefaultSubtitle: function getDefaultSubtitle() {
          return this.settings.get("brandName") ? (0, i.loc)("enroll.choices.description.specific", "login", [this.settings.get("brandName")]) : (0, i.loc)("enroll.choices.description.generic", "login");
        },
        getGracePeriodSubtitle: function getGracePeriodSubtitle(e) {
          return e >= 1 ? (0, i.loc)("enroll.choices.description.gracePeriod.bold", "login", [e]) : (0, i.loc)("enroll.choices.description.gracePeriod.oneDay.bold", "login");
        },
        save: function save() {
          switch (this.state.get("pageType")) {
            case u.default.ALL_OPTIONAL_SOME_ENROLLED:
            case u.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
              return (0, i.loc)("enroll.choices.submit.finish", "login");

            case u.default.HAS_REQUIRED_NONE_ENROLLED:
              return (0, i.loc)("enroll.choices.submit.configure", "login");

            case u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
              return (0, i.loc)("enroll.choices.submit.next", "login");

            default:
              return "";
          }
        },
        initialize: function initialize(e) {
          this.listenTo(this, "save", function () {
            var t;

            switch (this.state.get("pageType")) {
              case u.default.HAS_REQUIRED_NONE_ENROLLED:
              case u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
                t = e.appState.get("factors").getFirstUnenrolledRequiredFactor(), e.appState.trigger("navigate", d.default.createEnrollFactorUrl(t.get("provider"), t.get("factorType")));
                break;

              default:
                return this.model.doTransaction(function (e) {
                  return e.skip();
                });
            }
          });
        },
        preRender: function preRender() {
          this.add(f({
            subtitle: this.getSubtitle()
          }), (0, i.$)("p.okta-form-subtitle"));
          var e = this.options.appState.get("factors");

          switch (this.state.get("pageType")) {
            case u.default.HAS_REQUIRED_NONE_ENROLLED:
            case u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
              this.add(new l.default({
                minimize: !0,
                collection: new i.Collection(e.where({
                  required: !0
                })),
                appState: this.options.appState
              }));
              break;

            case u.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
            case u.default.ALL_OPTIONAL_SOME_ENROLLED:
            case u.default.ALL_OPTIONAL_NONE_ENROLLED:
              var t,
                  n = e.where({
                enrolled: !0
              }),
                  r = e.filter(function (e) {
                return !e.get("enrolled") || e.get("additionalEnrollment");
              });
              n.length > 0 && (t = (0, i.loc)("enroll.choices.list.optional", "login"), this.add(new a.default({
                listTitle: (0, i.loc)("enroll.choices.list.enrolled", "login"),
                minimize: !0,
                collection: new i.Collection(n),
                appState: this.options.appState
              }))), this.add(new a.default({
                listTitle: t,
                collection: new i.Collection(r),
                appState: this.options.appState,
                showInlineSetupButton: !0
              }));
          }
        }
      },
      initialize: function initialize(e) {
        var t,
            n,
            r = 0,
            o = 0,
            i = 0,
            a = 0;
        e.appState.get("factors").each(function (e) {
          var t = e.get("required"),
              n = e.get("enrolled"),
              s = e.get("additionalEnrollment");
          t && n ? r++ : t && !n ? o++ : !t && n ? i++ : t || n || a++, n && s && a++;
        }), t = r > 0 || o > 0, t && 0 === r ? n = u.default.HAS_REQUIRED_NONE_ENROLLED : t && o > 0 ? n = u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED : t && a > 0 ? n = u.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED : 0 === i && a > 0 ? n = u.default.ALL_OPTIONAL_NONE_ENROLLED : a > 0 ? n = u.default.ALL_OPTIONAL_SOME_ENROLLED : this.model.doTransaction(function (e) {
          return e.skip();
        }), this.state.set("pageType", n), this.options.appState.get("skipLink") && n === u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED && this.add(new s.default(this.toJSON()));
      }
    });
    t.default = p;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link goto js-skip" data-se="skip-link">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "enroll.choices.setup.skip"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 58
              },
              end: {
                line: 1,
                column: 114
              }
            }
          })) + "</a>";
        },
        useData: !0
      }),
      className: "auth-footer clearfix",
      events: {
        "click .js-skip": function clickJsSkip(e) {
          e.preventDefault(), this.model.doTransaction(function (e) {
            return e.skip();
          });
        }
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(263)),
        a = i.default.extend({
      listTitle: o._.partial(o.loc, "enroll.choices.list.setup", "login"),
      className: function className() {
        return i.default.prototype.className + " enroll-required-factor-list";
      },
      postRender: function postRender() {
        var e, t;
        i.default.prototype.postRender.apply(this, arguments), e = this.options.appState.get("factors").getFirstUnenrolledRequiredFactor(), t = this.find(function (t) {
          return t.model === e;
        }), t.maximize();
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(157)),
        a = r(n(16)),
        s = r(n(4)),
        l = r(n(18)),
        u = s.default.extend({
      className: "enroll-duo duo-form",
      Model: {
        props: {
          host: "string",
          signature: "string",
          postAction: "string",
          factorId: "string",
          stateToken: "string"
        },
        getInitOptions: function getInitOptions() {
          return this.doTransaction(function (e) {
            return o._.findWhere(e.factors, {
              factorType: "web",
              provider: "DUO"
            }).enroll();
          });
        },
        activate: function activate(e) {
          var t = this.get("postAction"),
              n = this.get("factorId"),
              r = this,
              i = {
            id: n,
            stateToken: this.get("stateToken"),
            sig_response: e
          };
          return (0, a.default)(o.$.post(t, i)).then(function () {
            return r.doTransaction(function (e) {
              return e.poll();
            });
          }).catch(function (e) {
            r.trigger("error", r, e.xhr);
          });
        }
      },
      Form: {
        autoSave: !0,
        noButtonBar: !0,
        title: o._.partial(o.loc, "enroll.duo.title", "login"),
        postRender: function postRender() {
          this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>'), i.default.init({
            host: this.model.get("host"),
            sig_request: this.model.get("signature"),
            iframe: this.$("iframe").get(0),
            post_action: o._.bind(this.model.activate, this.model)
          });
        }
      },
      Footer: l.default,
      fetchInitialData: function fetchInitialData() {
        var e = this;
        return this.model.getInitOptions(this.options.appState).then(function (t) {
          var n = t.data;
          if (!(n && n._embedded && n._embedded.factor && n._embedded.factor._embedded && n._embedded.factor._embedded.activation)) throw new Error("Response does not have duo activation options");
          var r = n._embedded.factor,
              o = r._embedded.activation;
          e.model.set({
            host: o.host,
            signature: o.signature,
            postAction: o._links.complete.href,
            factorId: r.id,
            stateToken: n.stateToken
          });
        });
      },
      trapAuthResponse: function trapAuthResponse() {
        if (this.options.appState.get("isMfaEnrollActivate")) return !0;
      }
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = r(n(2)),
        i = n(1),
        a = r(n(4)),
        s = r(n(6)),
        l = r(n(18)),
        u = {
      local: {
        factorType: "string",
        provider: "string"
      },
      save: function save() {
        this.trigger("save");
        var e = this.pick("factorType", "provider");
        return this.doTransaction(function (t) {
          return i._.findWhere(t.factors, e).enroll();
        });
      }
    },
        c = function c() {
      return {
        title: i._.partial(i.loc, "email.enroll.title", "login"),
        noButtonBar: !1,
        autoSave: !0,
        save: i._.partial(i.loc, "email.button.send", "login"),
        formChildren: [s.default.View({
          View: i.View.extend({
            attributes: {
              "data-se": "enroll-email-content"
            },
            template: o.default.template({
              compiler: [8, ">= 4.3.0"],
              main: function main(e, t, n, r, o) {
                var i = e.lookupProperty || function (e, t) {
                  if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                };

                return e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                  name: "i18n",
                  hash: {
                    bundle: "login",
                    code: "email.enroll.description"
                  },
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 0
                    },
                    end: {
                      line: 1,
                      column: 55
                    }
                  }
                }));
              },
              useData: !0
            })
          })
        })]
      };
    },
        d = a.default.extend({
      className: "enroll-email",
      Model: u,
      Form: c,
      Footer: l.default,
      initialize: function initialize() {
        this.model.set(i._.pick(this.options, "factorType", "provider"));
      }
    });

    t.default = d;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(4)),
        a = r(n(6)),
        s = r(n(18)),
        l = r(n(47)),
        u = i.default.extend({
      className: "enroll-hotp",
      Model: function Model() {
        return {
          local: {
            __factorType__: ["string", !1, this.options.factorType],
            __provider__: ["string", !1, this.options.provider]
          }
        };
      },
      Form: {
        title: function title() {
          var e = this.options.appState.get("factors"),
              t = e.findWhere({
            provider: this.model.get("__provider__"),
            factorType: this.model.get("__factorType__")
          });
          return (0, o.loc)("enroll.totp.title", "login", [t.get("factorLabel")]);
        },
        noButtonBar: !0,
        attributes: {
          "data-se": "restrict-enroll"
        },
        formChildren: function formChildren() {
          return [a.default.View({
            View: new l.default({
              message: (0, o.loc)("enroll.hotp.restricted", "login")
            })
          })];
        }
      },
      Footer: s.default
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return "RSA" === e;
    }

    function o(e) {
      return r(e) ? "enroll-rsa" : "enroll-onprem";
    }

    var i = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(1),
        s = i(n(4)),
        l = i(n(6)),
        u = i(n(12)),
        c = i(n(18)),
        d = i(n(13)),
        f = s.default.extend({
      className: function className() {
        return o(this.options.provider);
      },
      Model: function Model() {
        var e = this.options.provider,
            t = this.options.appState.get("factors"),
            n = t.findWhere(a._.pick(this.options, "provider", "factorType")),
            r = n.get("profile");
        return {
          props: {
            credentialId: ["string", !0, r && r.credentialId ? r.credentialId : ""],
            passCode: ["string", !0],
            factorId: "string"
          },
          save: function save() {
            return this.doTransaction(function (t) {
              return a._.findWhere(t.factors, {
                factorType: "token",
                provider: e
              }).enroll({
                passCode: this.get("passCode"),
                profile: {
                  credentialId: this.get("credentialId")
                }
              });
            });
          }
        };
      },
      Form: function Form() {
        var e = this.options.provider,
            t = this.options.appState.get("factors"),
            n = t.findWhere(a._.pick(this.options, "provider", "factorType")),
            i = n.get("vendorName");
        return {
          title: r(e) ? (0, a.loc)("factor.totpHard.rsaSecurId", "login") : i,
          noButtonBar: !0,
          autoSave: !0,
          className: o(e),
          initialize: function initialize() {
            var e = this;
            this.listenTo(this.model, "error", function (t, n) {
              n && 409 === n.status && (e.$(".o-form-input-name-passCode input").val(""), e.$(".o-form-input-name-passCode input").trigger("change"), e.$(".o-form-input-name-passCode input").focus());
            });
          },
          formChildren: [l.default.Input({
            label: (0, a.loc)("enroll.onprem.username.placeholder", "login", [i]),
            "label-top": !0,
            explain: u.default.createInputExplain("enroll.onprem.username.tooltip", "enroll.onprem.username.placeholder", "login", [i], [i]),
            "explain-top": !0,
            name: "credentialId",
            input: d.default,
            type: "text"
          }), l.default.Input({
            label: (0, a.loc)("enroll.onprem.passcode.placeholder", "login", [i]),
            "label-top": !0,
            explain: u.default.createInputExplain("enroll.onprem.passcode.tooltip", "enroll.onprem.passcode.placeholder", "login", [i], [i]),
            "explain-top": !0,
            name: "passCode",
            input: d.default,
            type: "password"
          }), l.default.Toolbar({
            noCancelButton: !0,
            save: (0, a.loc)("mfa.challenge.verify", "login")
          })]
        };
      },
      Footer: c.default
    });
    t.default = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(4)),
        a = r(n(94)),
        s = r(n(18)),
        l = r(n(13)),
        u = i.default.extend({
      className: "enroll-password",
      Model: {
        props: {
          password: ["string", !0],
          confirmPassword: ["string", !0]
        },
        validate: function validate() {
          return a.default.validateFieldsMatch(this, "password", "confirmPassword", (0, o.loc)("password.enroll.error.match", "login"));
        },
        save: function save() {
          return this.doTransaction(function (e) {
            return o._.findWhere(e.factors, {
              factorType: "password",
              provider: "OKTA"
            }).enroll({
              profile: {
                password: this.get("password")
              }
            });
          });
        }
      },
      Form: {
        autoSave: !0,
        title: o._.partial(o.loc, "enroll.password.setup", "login"),
        inputs: function inputs() {
          return [{
            label: (0, o.loc)("mfa.challenge.password.placeholder", "login"),
            "label-top": !0,
            className: "o-form-fieldset o-form-label-top auth-passcode",
            name: "password",
            input: l.default,
            type: "password"
          }, {
            label: (0, o.loc)("password.confirmPassword.placeholder", "login"),
            "label-top": !0,
            className: "o-form-fieldset o-form-label-top auth-passcode",
            name: "confirmPassword",
            input: l.default,
            type: "password"
          }];
        }
      },
      Footer: s.default
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(15)),
        a = r(n(4)),
        s = r(n(12)),
        l = r(n(18)),
        u = r(n(13)),
        c = a.default.extend({
      className: "enroll-question",
      Model: {
        props: {
          question: "string",
          answer: ["string", !0]
        },
        local: {
          securityQuestions: "object"
        },
        save: function save() {
          return this.doTransaction(function (e) {
            return o._.findWhere(e.factors, {
              factorType: "question",
              provider: "OKTA"
            }).enroll({
              profile: {
                question: this.get("question"),
                answer: this.get("answer")
              }
            });
          });
        }
      },
      Form: {
        autoSave: !0,
        title: o._.partial(o.loc, "enroll.securityQuestion.setup", "login"),
        inputs: function inputs() {
          return [{
            label: !1,
            "label-top": !0,
            name: "question",
            type: "select",
            wide: !0,
            options: function options() {
              return this.model.get("securityQuestions");
            },
            params: {
              searchThreshold: 25
            }
          }, {
            label: (0, o.loc)("mfa.challenge.answer.placeholder", "login"),
            "label-top": !0,
            explain: s.default.createInputExplain("mfa.challenge.answer.tooltip", "mfa.challenge.answer.placeholder", "login"),
            "explain-top": !0,
            className: "o-form-fieldset o-form-label-top auth-passcode",
            name: "answer",
            input: u.default,
            type: "text"
          }];
        }
      },
      Footer: l.default,
      fetchInitialData: function fetchInitialData() {
        var e = this;
        return this.model.manageTransaction(function (e) {
          return o._.findWhere(e.factors, {
            factorType: "question",
            provider: "OKTA"
          }).questions();
        }).then(function (t) {
          var n = {};
          o._.each(t, function (e) {
            n[e.question] = i.default.getSecurityQuestionLabel(e);
          }), e.model.set("securityQuestions", n);
        });
      }
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(4)),
        a = r(n(6)),
        s = r(n(12)),
        l = r(n(18)),
        u = r(n(13)),
        c = i.default.extend({
      className: "enroll-symantec",
      Model: {
        props: {
          credentialId: ["string", !0],
          passCode: ["string", !0],
          nextPassCode: ["string", !0],
          factorId: "string"
        },
        save: function save() {
          return this.doTransaction(function (e) {
            return o._.findWhere(e.factors, {
              factorType: "token",
              provider: "SYMANTEC"
            }).enroll({
              passCode: this.get("passCode"),
              nextPassCode: this.get("nextPassCode"),
              profile: {
                credentialId: this.get("credentialId")
              }
            });
          });
        }
      },
      Form: {
        title: o._.partial(o.loc, "factor.totpHard.symantecVip", "login"),
        subtitle: o._.partial(o.loc, "enroll.symantecVip.subtitle", "login"),
        noButtonBar: !0,
        autoSave: !0,
        className: "enroll-symantec",
        formChildren: function formChildren() {
          return [a.default.Input({
            label: (0, o.loc)("enroll.symantecVip.credentialId.placeholder", "login"),
            "label-top": !0,
            explain: s.default.createInputExplain("enroll.symantecVip.credentialId.tooltip", "enroll.symantecVip.credentialId.placeholder", "login"),
            "explain-top": !0,
            name: "credentialId",
            input: u.default,
            type: "text"
          }), a.default.Input({
            label: (0, o.loc)("enroll.symantecVip.passcode1.placeholder", "login"),
            "label-top": !0,
            explain: s.default.createInputExplain("enroll.symantecVip.passcode1.tooltip", "enroll.symantecVip.passcode1.placeholder", "login"),
            "explain-top": !0,
            name: "passCode",
            input: u.default,
            type: "text"
          }), a.default.Input({
            label: (0, o.loc)("enroll.symantecVip.passcode2.placeholder", "login"),
            "label-top": !0,
            explain: s.default.createInputExplain("enroll.symantecVip.passcode2.tooltip", "enroll.symantecVip.passcode2.placeholder", "login"),
            "explain-top": !0,
            name: "nextPassCode",
            input: u.default,
            type: "text"
          }), a.default.Toolbar({
            noCancelButton: !0,
            save: (0, o.loc)("mfa.challenge.verify", "login")
          })];
        }
      },
      Footer: l.default
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = r(n(15)),
        l = r(n(4)),
        u = r(n(6)),
        c = r(n(512)),
        d = r(n(18)),
        f = {
      __deviceType__: function __deviceType__(e) {
        return void 0 !== e;
      }
    },
        p = a.View.extend({
      attributes: {
        "data-se": "app-download-instructions"
      },
      className: "app-download-instructions",
      template: i.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s,
              l = null != t ? t : e.nullContext || {},
              u = e.hooks.helperMissing,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<span class="app-logo ' + e.escapeExpression((s = null != (s = c(n, "appIcon") || (null != t ? c(t, "appIcon") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "appIcon",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 22
              },
              end: {
                line: 1,
                column: 33
              }
            }
          }) : s)) + '"></span><p class="instructions">' + (null != (s = null != (s = c(n, "appStoreLinkText") || (null != t ? c(t, "appStoreLinkText") : t)) ? s : u, a = "function" === (0, o.default)(s) ? s.call(l, {
            name: "appStoreLinkText",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 66
              },
              end: {
                line: 1,
                column: 88
              }
            }
          }) : s) ? a : "") + "</p>";
        },
        useData: !0
      }),
      initialize: function initialize() {
        this.listenTo(this.model, "change:__deviceType__", this.render);
      },
      getTemplateData: function getTemplateData() {
        var e,
            t,
            n,
            r = s.default.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
        return n = c.default.STORE[this.model.get("__deviceType__")], "GOOGLE" === this.model.get("__provider__") ? (e = c.default.GOOGLE[this.model.get("__deviceType__")], t = "google-auth-38") : (e = c.default.OKTA[this.model.get("__deviceType__")], t = "okta-verify-download-icon"), {
          appStoreLinkText: (0, a.loc)("enroll.totp.downloadApp", "login", [e, r, n]),
          appIcon: t
        };
      }
    }),
        h = l.default.extend({
      className: "enroll-totp",
      Model: function Model() {
        return {
          local: {
            __deviceType__: "string",
            __factorType__: ["string", !1, this.options.factorType],
            __provider__: ["string", !1, this.options.provider]
          },
          save: function save() {
            return this.doTransaction(function (e) {
              return a._.findWhere(e.factors, {
                factorType: this.get("__factorType__"),
                provider: this.get("__provider__")
              }).enroll();
            });
          }
        };
      },
      Form: {
        title: function title() {
          var e = s.default.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
          return (0, a.loc)("enroll.totp.title", "login", [e]);
        },
        subtitle: a._.partial(a.loc, "enroll.totp.selectDevice", "login"),
        autoSave: !0,
        noButtonBar: !0,
        attributes: {
          "data-se": "step-device-type"
        },
        formChildren: function formChildren() {
          var e = {
            APPLE: (0, a.loc)("iphone", "login"),
            ANDROID: (0, a.loc)("android", "login")
          };
          return [u.default.Input({
            name: "__deviceType__",
            type: "radio",
            options: e
          }), u.default.Divider({
            showWhen: f
          }), u.default.View({
            View: p,
            showWhen: f
          }), u.default.Toolbar({
            noCancelButton: !0,
            save: (0, a.loc)("oform.next", "login"),
            showWhen: f
          })];
        }
      },
      Footer: d.default
    }),
        m = h;
    t.default = m;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = {
      OKTA: {
        APPLE: "https://itunes.apple.com/us/app/okta-verify/id490179405",
        ANDROID: "https://play.google.com/store/apps/details?id=com.okta.android.auth"
      },
      GOOGLE: {
        APPLE: "https://itunes.apple.com/us/app/google-authenticator/id388497605",
        ANDROID: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
      },
      STORE: {
        APPLE: "App Store",
        ANDROID: "Google Play Store"
      }
    };
    t.default = r;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(16));
    n(264);
    var s = r(n(24)),
        l = r(n(158)),
        u = r(n(4)),
        c = r(n(6)),
        d = r(n(18)),
        f = r(n(47)),
        p = u.default.extend({
      className: "enroll-u2f",
      Model: {
        local: {
          __enrolled__: "boolean"
        },
        save: function save() {
          return this.trigger("request"), this.get("__enrolled__") ? this.activate() : this.doTransaction(function (e) {
            return i._.findWhere(e.factors, {
              factorType: "u2f",
              provider: "FIDO"
            }).enroll();
          });
        },
        activate: function activate() {
          return this.set("__enrolled__", !0), this.trigger("errors:clear"), this.doTransaction(function (e) {
            var t = e.factor.activation,
                n = t.appId,
                r = [{
              version: l.default.getU2fVersion(),
              challenge: t.nonce
            }],
                o = this,
                i = a.default.defer();
            return u2f.register(n, r, [], function (t) {
              o.trigger("errors:clear"), t.errorCode && 0 !== t.errorCode ? i.reject(new s.default.U2FError({
                xhr: {
                  responseJSON: {
                    errorSummary: l.default.getU2fEnrollErrorMessageByCode(t.errorCode)
                  }
                }
              })) : i.resolve(e.activate({
                registrationData: t.registrationData,
                version: t.version,
                challenge: t.challenge,
                clientData: t.clientData
              }));
            }), i.promise;
          });
        }
      },
      Form: {
        title: i._.partial(i.loc, "enroll.u2f.title", "login"),
        save: i._.partial(i.loc, "enroll.u2f.save", "login"),
        noCancelButton: !0,
        hasSavingState: !1,
        autoSave: !0,
        className: "enroll-u2f-form",
        noButtonBar: function noButtonBar() {
          return !l.default.isU2fAvailable();
        },
        modelEvents: {
          request: "_startEnrollment",
          error: "_stopEnrollment"
        },
        formChildren: function formChildren() {
          var e = [];
          if (l.default.isU2fAvailable()) e.push(c.default.View({
            View: i.View.extend({
              template: o.default.template({
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, o) {
                  var i,
                      a = null != t ? t : e.nullContext || {},
                      s = e.hooks.helperMissing,
                      l = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<div class="u2f-instructions"><ol><li>' + (null != (i = (l(n, "i18n") || t && l(t, "i18n") || s).call(a, {
                    name: "i18n",
                    hash: {
                      bundle: "login",
                      code: "enroll.u2f.general2"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 38
                      },
                      end: {
                        line: 1,
                        column: 90
                      }
                    }
                  })) ? i : "") + "</li><li>" + e.escapeExpression((l(n, "i18n") || t && l(t, "i18n") || s).call(a, {
                    name: "i18n",
                    hash: {
                      bundle: "login",
                      code: "enroll.u2f.general3"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 99
                      },
                      end: {
                        line: 1,
                        column: 149
                      }
                    }
                  })) + "</li></ol></div>";
                },
                useData: !0
              })
            })
          })), e.push(c.default.View({
            View: i.View.extend({
              template: o.default.template({
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, o) {
                  var i = null != t ? t : e.nullContext || {},
                      a = e.hooks.helperMissing,
                      s = e.escapeExpression,
                      l = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<div class="u2f-enroll-text hide"><p>' + s((l(n, "i18n") || t && l(t, "i18n") || a).call(i, {
                    name: "i18n",
                    hash: {
                      bundle: "login",
                      code: "enroll.u2f.instructions"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 37
                      },
                      end: {
                        line: 1,
                        column: 91
                      }
                    }
                  })) + "</p><p>" + s((l(n, "i18n") || t && l(t, "i18n") || a).call(i, {
                    name: "i18n",
                    hash: {
                      bundle: "login",
                      code: "enroll.u2f.instructionsBluetooth"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 98
                      },
                      end: {
                        line: 1,
                        column: 161
                      }
                    }
                  })) + '</p><div data-se="u2f-devices" class="u2f-devices-images"><div class="u2f-usb"></div><div class="u2f-bluetooth"></div></div><div data-se="u2f-waiting" class="okta-waiting-spinner"></div></div>';
                },
                useData: !0
              })
            })
          }));else {
            var t = "u2f.error.factorNotSupported";
            1 === this.options.appState.get("factors").length && (t = "u2f.error.factorNotSupported.oneFactor"), e.push(c.default.View({
              View: new f.default({
                message: (0, i.loc)(t, "login")
              })
            }, {
              selector: ".o-form-error-container"
            }));
          }
          return e;
        },
        _startEnrollment: function _startEnrollment() {
          this.$(".u2f-instructions").addClass("hide"), this.$(".u2f-enroll-text").removeClass("hide"), this.$(".o-form-button-bar").hide();
        },
        _stopEnrollment: function _stopEnrollment() {
          this.$(".u2f-instructions").removeClass("hide"), this.$(".u2f-enroll-text").addClass("hide"), this.$(".o-form-button-bar").show();
        }
      },
      Footer: d.default,
      trapAuthResponse: function trapAuthResponse() {
        if (this.options.appState.get("isMfaEnrollActivate")) return this.model.activate(), !0;
      }
    });
    t.default = p;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(515)),
        i = r(n(73)),
        a = r(n(516)),
        s = r(n(266)),
        l = i.default.extend({
      className: "enroll-user",
      initialize: function initialize(e) {
        this.options = e || {}, this.model = new o.default(this.options);
      },
      fetchInitialData: function fetchInitialData() {
        return this.options.appState.get("isUnauthenticated") ? this.model.getEnrollFormData() : i.default.prototype.fetchInitialData.call();
      },
      trapAuthResponse: function trapAuthResponse() {
        if (this.options.appState.get("isProfileRequired")) return !0;
      },
      postRender: function postRender() {
        var e = new a.default(this.toJSON());
        this.add(e), this.add(new s.default(this.toJSON())), this.addListeners();
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(93)),
        a = i.default.extend({
      initialize: function initialize(e) {
        this.options = e || {}, this.appState = this.options.appState;
      },
      constructPostData: function constructPostData(e) {
        var t = {
          registration: {
            profile: e
          }
        };
        return this.appState.get("policy").registration.createNewAccount && (t.registration.createNewAccount = !0), t;
      },
      getEnrollFormData: function getEnrollFormData() {
        return this.manageTransaction(function (e, t) {
          return e.enroll().then(function (e) {
            t(e);
          });
        });
      },
      save: function save() {
        var e = i.default.prototype.toJSON.apply(this, arguments);
        if (e = o._.omit(e, ["appState", "settings", "createNewAccount"]), !o._.isEmpty(e)) return this.manageTransaction(function (t, n) {
          t.enroll(this.constructPostData(e)).then(function (e) {
            n(e);
          });
        });
        var t = {
          errorSummary: (0, o.loc)("oform.errorbanner.title", "login")
        };
        this.trigger("error", this, {
          responseJSON: t
        });
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(517)),
        s = r(n(265)),
        l = i.Form.extend({
      layout: "o-form-theme",
      autoSave: !0,
      noCancelButton: !0,
      title: function title() {
        return (0, i.loc)("registration.form.title", "login");
      },
      save: function save() {
        return (0, i.loc)("registration.form.submit", "login");
      },
      initialize: function initialize(e) {
        var t = this;
        this.options = e || {}, this.schema = new a.default({
          profileSchemaAttributes: this.options.appState.get("policy").registration.profile
        }), this.schema.properties.each(function (e) {
          var n = s.default.createInputOptions(e);
          t.addInput(n);
        });
        var n = o.default.template({
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<span class="required-fields-label">' + e.escapeExpression((i = null != (i = a(n, "label") || (null != t ? a(t, "label") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
              name: "label",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 36
                },
                end: {
                  line: 1,
                  column: 45
                }
              }
            }) : i)) + "</span>";
          },
          useData: !0
        })({
          label: (0, i.loc)("registration.required.fields.label", "login")
        });
        this.add(n);
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = r.internal.models.BaseSchema,
        i = o.Model.extend({
      expand: ["schema"],
      setFieldPlaceholder: function setFieldPlaceholder(e) {
        return r._.each(e, function (e) {
          e.title = e.label;
        }), e;
      },
      initialize: function initialize(e) {
        var t = e.profileSchemaAttributes;

        if (t = this.setFieldPlaceholder(t)) {
          for (var n = {
            properties: {}
          }, r = 0; r < t.length; r++) {
            var o = t[r];
            n.properties[o.name] = o;
          }

          this.parse.apply(this, [{
            schema: n
          }]);
        }
      }
    });
    t.default = i;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = [];
      return a._.each(e, function (e) {
        t.push({
          type: "public-key",
          id: u.default.strToBin(e.id)
        });
      }), t;
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = o(n(2)),
        a = n(1),
        s = o(n(16)),
        l = o(n(25)),
        u = o(n(116)),
        c = o(n(24)),
        d = o(n(4)),
        f = o(n(6)),
        p = o(n(75)),
        h = o(n(18)),
        m = o(n(47)),
        g = d.default.extend({
      className: "enroll-webauthn",
      Model: {
        local: {
          __enrolled__: "boolean"
        },
        save: function save() {
          return this.trigger("request"), this.get("__enrolled__") ? this.activate() : this.doTransaction(function (e) {
            return a._.findWhere(e.factors, {
              factorType: "webauthn",
              provider: "FIDO"
            }).enroll();
          });
        },
        activate: function activate() {
          var e = this;
          return this.set("__enrolled__", !0), this.trigger("errors:clear"), this.appState.on("backToFactors", function () {
            e.webauthnAbortController && (e.webauthnAbortController.abort(), e.webauthnAbortController = null);
          }), this.doTransaction(function (e) {
            var t = e.factor.activation,
                n = this;

            if (p.default.isNewApiAvailable()) {
              var o = a._.extend({}, t, {
                challenge: u.default.strToBin(t.challenge),
                user: {
                  id: u.default.strToBin(t.user.id),
                  name: t.user.name,
                  displayName: t.user.displayName
                },
                excludeCredentials: r(t.excludeCredentials)
              });

              return n.webauthnAbortController = new AbortController(), new s.default(navigator.credentials.create({
                publicKey: o,
                signal: n.webauthnAbortController.signal
              })).then(function (t) {
                return e.activate({
                  attestation: u.default.binToStr(t.response.attestationObject),
                  clientData: u.default.binToStr(t.response.clientDataJSON)
                });
              }).catch(function (e) {
                throw n.trigger("errors:clear"), n.webauthnAbortController ? new c.default.WebAuthnError({
                  xhr: {
                    responseJSON: {
                      errorSummary: e.message
                    }
                  }
                }) : new c.default.WebauthnAbortError();
              }).finally(function () {
                n.webauthnAbortController = null;
              });
            }
          });
        }
      },
      Form: {
        title: a._.partial(a.loc, "enroll.webauthn.biometric.title", "login"),
        save: a._.partial(a.loc, "enroll.webauthn.save", "login"),
        noCancelButton: !0,
        hasSavingState: !1,
        autoSave: !0,
        className: "enroll-webauthn-form",
        noButtonBar: function noButtonBar() {
          return !p.default.isNewApiAvailable();
        },
        modelEvents: {
          request: "_startEnrollment",
          error: "_stopEnrollment"
        },
        formChildren: function formChildren() {
          var e = [];
          if (p.default.isNewApiAvailable()) e.push(f.default.View({
            View: a.View.extend({
              className: "webauthn-enroll-text",
              template: i.default.template({
                1: function _(e, t, n, r, o) {
                  var i,
                      a = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<div class="webauthn-edge-text"><p>' + (null != (i = (a(n, "i18n") || t && a(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                    name: "i18n",
                    hash: {
                      bundle: "login",
                      code: "enroll.webauthn.biometric.instructions.edge"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 173
                      },
                      end: {
                        line: 1,
                        column: 249
                      }
                    }
                  })) ? i : "") + "</p></div>";
                },
                3: function _(e, t, n, r, o) {
                  var i,
                      a = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<div class="webauthn-restrictions-text"><p>' + (null != (i = (a(n, "i18n") || t && a(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                    name: "i18n",
                    hash: {
                      bundle: "login",
                      code: "enroll.webauthn.instructions.noSupportForBiometric"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 340
                      },
                      end: {
                        line: 1,
                        column: 423
                      }
                    }
                  })) ? i : "") + "</p></div>";
                },
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, o) {
                  var i,
                      a = null != t ? t : e.nullContext || {},
                      s = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<div class="webauthn-enroll-instructions"><p>' + e.escapeExpression((s(n, "i18n") || t && s(t, "i18n") || e.hooks.helperMissing).call(a, {
                    name: "i18n",
                    hash: {
                      bundle: "login",
                      code: "enroll.webauthn.biometric.instructions"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 45
                      },
                      end: {
                        line: 1,
                        column: 114
                      }
                    }
                  })) + "</p></div>" + (null != (i = s(n, "if").call(a, null != t ? s(t, "isEdge") : t, {
                    name: "if",
                    hash: {},
                    fn: e.program(1, o, 0),
                    inverse: e.noop,
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 124
                      },
                      end: {
                        line: 1,
                        column: 266
                      }
                    }
                  })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "onlySupportsSecurityKey") : t, {
                    name: "if",
                    hash: {},
                    fn: e.program(3, o, 0),
                    inverse: e.noop,
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 266
                      },
                      end: {
                        line: 1,
                        column: 440
                      }
                    }
                  })) ? i : "") + '<div data-se="webauthn-waiting" class="okta-waiting-spinner hide"></div>';
                },
                useData: !0
              }),
              getTemplateData: function getTemplateData() {
                return {
                  isEdge: l.default.isEdge(),
                  onlySupportsSecurityKey: (l.default.isFirefox() || l.default.isSafari()) && l.default.isMac()
                };
              }
            })
          }));else {
            var t = "webauthn.biometric.error.factorNotSupported";
            1 === this.options.appState.get("factors").length && (t = "webauthn.biometric.error.factorNotSupported.oneFactor"), e.push(f.default.View({
              View: new m.default({
                message: (0, a.loc)(t, "login")
              })
            }, {
              selector: ".o-form-error-container"
            }));
          }
          return e;
        },
        _startEnrollment: function _startEnrollment() {
          this.$(".okta-waiting-spinner").show(), this.$(".o-form-button-bar").hide();
        },
        _stopEnrollment: function _stopEnrollment() {
          this.$(".okta-waiting-spinner").hide(), this.$(".o-form-button-bar").show();
        }
      },
      Footer: h.default,
      trapAuthResponse: function trapAuthResponse() {
        if (this.options.appState.get("isMfaEnrollActivate")) return this.model.activate(), !0;
      }
    });
    t.default = g;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(4)),
        a = r(n(6)),
        s = r(n(75)),
        l = r(n(18)),
        u = r(n(47)),
        c = r(n(267)),
        d = i.default.extend({
      className: "enroll-windows-hello",
      Model: {
        local: {
          __isEnrolled__: "boolean"
        },
        save: function save() {
          if (s.default.isAvailable()) return this.trigger("request"), this.get("__isEnrolled__") ? this.activate() : this.doTransaction(function (e) {
            return this._enroll(e);
          });
        },
        _enroll: function _enroll(e) {
          return o._.findWhere(e.factors, {
            factorType: "webauthn",
            provider: "FIDO"
          }).enroll();
        },
        activate: function activate() {
          return this.set("__isEnrolled__", !0), this.doTransaction(function (e) {
            var t = e.factor.activation,
                n = e.user,
                r = this,
                o = {
              rpDisplayName: t.rpDisplayName,
              userDisplayName: n.profile.displayName,
              accountName: n.profile.login,
              userId: n.id
            },
                i = [{
              algorithm: t.algorithm
            }],
                a = t.nonce;
            return s.default.makeCredential(o, i, a).then(function (t) {
              return e.activate({
                credentialId: t.credential.id,
                publicKey: t.publicKey,
                attestation: null
              });
            }).catch(function (t) {
              switch (t.message) {
                case "AbortError":
                case "NotFoundError":
                case "NotSupportedError":
                  return r.trigger("abort", t.message), e;
              }

              throw t;
            });
          });
        }
      },
      Form: {
        autoSave: !0,
        hasSavingState: !1,
        title: o._.partial(o.loc, "enroll.windowsHello.title", "login"),
        subtitle: function subtitle() {
          return s.default.isAvailable() ? (0, o.loc)("enroll.windowsHello.subtitle", "login") : "";
        },
        save: o._.partial(o.loc, "enroll.windowsHello.save", "login"),
        customSavingState: {
          stop: "abort"
        },
        modelEvents: function modelEvents() {
          return s.default.isAvailable() ? {
            request: "_startEnrollment",
            error: "_stopEnrollment",
            abort: "_stopEnrollment"
          } : {};
        },
        noButtonBar: function noButtonBar() {
          return !s.default.isAvailable();
        },
        formChildren: function formChildren() {
          var e = [];
          return s.default.isAvailable() || e.push(a.default.View({
            View: new u.default({
              message: (0, o.loc)("enroll.windowsHello.error.notWindows", "login")
            })
          }, {
            selector: ".o-form-error-container"
          })), e.push(a.default.View({
            View: new c.default({
              model: this.model,
              visible: !1
            })
          })), e;
        },
        _startEnrollment: function _startEnrollment() {
          this.subtitle = (0, o.loc)("enroll.windowsHello.subtitle.loading", "login"), this.model.trigger("spinner:show"), this._resetErrorMessage(), this.render(), this.$(".o-form-button-bar").addClass("hide");
        },
        _stopEnrollment: function _stopEnrollment(e) {
          this.subtitle = (0, o.loc)("enroll.windowsHello.subtitle", "login"), this.model.trigger("spinner:hide");
          var t;

          switch (e) {
            case "NotSupportedError":
              t = (0, o.loc)("enroll.windowsHello.error.notConfiguredHtml", "login");
          }

          if (this._resetErrorMessage(), t) {
            var n = new u.default({
              message: t
            });
            this.$(".o-form-error-container").addClass("o-form-has-errors"), this.add(n, {
              selector: ".o-form-error-container"
            }), this._errorMessageView = this.last();
          }

          this.render(), this.$(".o-form-button-bar").removeClass("hide");
        },
        _resetErrorMessage: function _resetErrorMessage() {
          this._errorMessageView && this._errorMessageView.remove(), this._errorMessageView = void 0, this.clearErrors();
        }
      },
      Footer: l.default,
      trapAuthResponse: function trapAuthResponse() {
        if (this.options.appState.get("isMfaEnrollActivate")) return this.model.activate(), !0;
      }
    });
    t.default = d;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(4)),
        a = r(n(6)),
        s = r(n(18)),
        l = r(n(13)),
        u = i.default.extend({
      className: "enroll-yubikey",
      Model: {
        props: {
          passCode: ["string", !0],
          factorId: "string"
        },
        save: function save() {
          return this.doTransaction(function (e) {
            return o._.findWhere(e.factors, {
              factorType: "token:hardware",
              provider: "YUBICO"
            }).enroll({
              passCode: this.get("passCode")
            });
          });
        }
      },
      Form: {
        title: o._.partial(o.loc, "enroll.yubikey.title", "login"),
        subtitle: o._.partial(o.loc, "enroll.yubikey.subtitle", "login"),
        noCancelButton: !0,
        save: o._.partial(o.loc, "mfa.challenge.verify", "login"),
        autoSave: !0,
        className: "enroll-yubikey",
        formChildren: [a.default.View({
          View: '<div class="yubikey-demo" data-type="yubikey-example"></div>'
        }), a.default.Input({
          name: "passCode",
          input: l.default,
          type: "password"
        })]
      },
      Footer: s.default
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(74)),
        s = r(n(4)),
        l = r(n(6)),
        u = r(n(39)),
        c = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link help js-back" data-se="back-link">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oform.back"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 58
              },
              end: {
                line: 1,
                column: 99
              }
            }
          })) + "</a>";
        },
        useData: !0
      }),
      className: "auth-footer",
      events: {
        "click .js-back": function clickJsBack(e) {
          e.preventDefault(), this.back();
        }
      },
      back: function back() {
        var e = u.default.createActivateFactorUrl(this.options.appState.get("activatedFactorProvider"), this.options.appState.get("activatedFactorType"), "manual");
        this.options.appState.trigger("navigate", e);
      }
    }),
        d = {
      title: i._.partial(i.loc, "enroll.totp.enrollViaEmail.title", "login"),
      noButtonBar: !0,
      attributes: {
        "data-se": "sent-email-activation-link"
      },
      formChildren: [l.default.View({
        View: i.View.extend({
          template: o.default.template({
            compiler: [8, ">= 4.3.0"],
            main: function main(e, t, n, r, o) {
              var i,
                  a = null != t ? t : e.nullContext || {},
                  s = e.hooks.helperMissing,
                  l = e.escapeExpression,
                  u = e.lookupProperty || function (e, t) {
                if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
              };

              return "<p>" + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
                name: "i18n",
                hash: {
                  bundle: "login",
                  code: "enroll.totp.enrollViaEmail.msg"
                },
                data: o,
                loc: {
                  start: {
                    line: 1,
                    column: 3
                  },
                  end: {
                    line: 1,
                    column: 64
                  }
                }
              })) + '</p><p class="email-address">' + l((i = null != (i = u(n, "email") || (null != t ? u(t, "email") : t)) ? i : s, "function" == typeof i ? i.call(a, {
                name: "email",
                hash: {},
                data: o,
                loc: {
                  start: {
                    line: 1,
                    column: 93
                  },
                  end: {
                    line: 1,
                    column: 102
                  }
                }
              }) : i)) + "</p>";
            },
            useData: !0
          }),
          getTemplateData: function getTemplateData() {
            return {
              email: this.options.appState.get("userEmail")
            };
          }
        })
      })]
    },
        f = {
      title: i._.partial(i.loc, "enroll.totp.enrollViaSms.title", "login"),
      noButtonBar: !0,
      attributes: {
        "data-se": "sent-sms-activation-link"
      },
      formChildren: [l.default.View({
        View: i.View.extend({
          template: o.default.template({
            compiler: [8, ">= 4.3.0"],
            main: function main(e, t, n, r, o) {
              var i,
                  a = null != t ? t : e.nullContext || {},
                  s = e.hooks.helperMissing,
                  l = e.escapeExpression,
                  u = e.lookupProperty || function (e, t) {
                if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
              };

              return "<p>" + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
                name: "i18n",
                hash: {
                  bundle: "login",
                  code: "enroll.totp.enrollViaSms.msg"
                },
                data: o,
                loc: {
                  start: {
                    line: 1,
                    column: 3
                  },
                  end: {
                    line: 1,
                    column: 62
                  }
                }
              })) + '</p><p class="phone-number">' + l((i = null != (i = u(n, "phoneNumber") || (null != t ? u(t, "phoneNumber") : t)) ? i : s, "function" == typeof i ? i.call(a, {
                name: "phoneNumber",
                hash: {},
                data: o,
                loc: {
                  start: {
                    line: 1,
                    column: 90
                  },
                  end: {
                    line: 1,
                    column: 105
                  }
                }
              }) : i)) + "</p>";
            },
            useData: !0
          }),
          getTemplateData: function getTemplateData() {
            return {
              phoneNumber: this.model.get("fullPhoneNumber")
            };
          }
        })
      })]
    },
        p = s.default.extend({
      className: "enroll-activation-link-sent",
      Model: function Model() {
        return {
          local: {
            countryCode: ["string", !1, this.options.appState.get("userCountryCode")],
            phoneNumber: ["string", !1, this.options.appState.get("userPhoneNumber")],
            __factorType__: ["string", !1, this.options.factorType],
            __provider__: ["string", !1, this.options.provider]
          },
          derived: {
            countryCallingCode: {
              deps: ["countryCode"],
              fn: function fn(e) {
                return "+" + a.default.getCallingCodeForCountry(e);
              }
            },
            fullPhoneNumber: {
              deps: ["countryCallingCode", "phoneNumber"],
              fn: function fn(e, t) {
                return e + t;
              }
            }
          }
        };
      },
      Form: function Form() {
        var e = this.options.appState.get("factorActivationType");

        switch (e) {
          case "SMS":
            return f;

          case "EMAIL":
            return d;

          default:
            throw new Error("Unknown activation option: " + e);
        }
      },
      Footer: c,
      initialize: function initialize() {
        this.pollForEnrollment();
      },
      remove: function remove() {
        return s.default.prototype.remove.apply(this, arguments);
      },
      pollForEnrollment: function pollForEnrollment() {
        return this.model.doTransaction(function (e) {
          return e.poll(6e3);
        });
      },
      trapAuthResponse: function trapAuthResponse() {
        if (this.options.appState.get("isWaitingForActivation")) return this.pollForEnrollment(), !0;
      }
    });
    t.default = p;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(4)),
        s = r(n(39)),
        l = r(n(251)),
        u = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link help js-back" data-se="back-link">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oform.back"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 58
              },
              end: {
                line: 1,
                column: 99
              }
            }
          })) + "</a>";
        },
        useData: !0
      }),
      className: "auth-footer",
      events: {
        "click .js-back": function clickJsBack(e) {
          e.preventDefault(), this.back();
        }
      },
      back: function back() {
        var e = s.default.createActivateFactorUrl(this.options.appState.get("activatedFactorProvider"), "push", "manual");
        this.options.appState.trigger("navigate", e);
      }
    }),
        c = a.default.extend({
      className: "activate-push",
      Model: function Model() {
        return {
          props: {
            factorId: ["string", !0, this.options.appState.get("activatedFactorId")],
            passCode: ["string", !0]
          },
          local: {
            __factorType__: ["string", !1, this.options.factorType],
            __provider__: ["string", !1, this.options.provider]
          },
          save: function save() {
            return this.doTransaction(function (e) {
              return e.activate({
                passCode: this.get("passCode")
              });
            });
          }
        };
      },
      Form: l.default,
      Footer: u
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(5)),
        s = r(n(4)),
        l = r(n(6)),
        u = r(n(12)),
        c = r(n(94)),
        d = r(n(268)),
        f = r(n(13)),
        p = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="okta-form-infobox-error infobox infobox-error" role="alert"><span class="icon error-16"></span><p>' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "password.forgot.noFactorsEnabled"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 110
              },
              end: {
                line: 1,
                column: 173
              }
            }
          })) + "</p></div>";
        },
        useData: !0
      })
    }),
        h = i.View.extend({
      template: o.default.template({
        1: function _(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link help js-back" data-se="back-link">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "goback"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 94
              },
              end: {
                line: 1,
                column: 131
              }
            }
          })) + "</a>";
        },
        3: function _(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link goto js-contact-support">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "mfa.noAccessToEmail"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 220
              },
              end: {
                line: 1,
                column: 270
              }
            }
          })) + "</a>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return (null != (i = s(n, "unless").call(a, null != t ? s(t, "hideBackToSignInForReset") : t, {
            name: "unless",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 146
              }
            }
          })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "helpSupportNumber") : t, {
            name: "if",
            hash: {},
            fn: e.program(3, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 146
              },
              end: {
                line: 1,
                column: 281
              }
            }
          })) ? i : "");
        },
        useData: !0
      }),
      className: "auth-footer",
      events: {
        "click .js-back": function clickJsBack(e) {
          e.preventDefault(), this.back();
        },
        "click .js-contact-support": function clickJsContactSupport(e) {
          e.preventDefault(), this.state.trigger("contactSupport"), this.$(".js-contact-support").hide();
        }
      },
      getTemplateData: function getTemplateData() {
        return {
          hideBackToSignInForReset: this.settings.get("features.hideBackToSignInForReset"),
          helpSupportNumber: this.settings.get("helpSupportNumber")
        };
      },
      back: function back() {
        this.state.set("navigateDir", a.default.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
      }
    }),
        m = s.default.extend({
      className: "forgot-password",
      Model: {
        props: {
          username: ["string", !0],
          factorType: ["string", !0]
        },
        validate: function validate() {
          return c.default.validateUsername(this);
        },
        save: function save() {
          var e = this,
              t = this.settings.get("relayState");
          this.startTransaction(function (n) {
            return n.forgotPassword({
              username: e.settings.transformUsername(e.get("username"), a.default.FORGOT_PASSWORD),
              factorType: e.get("factorType"),
              relayState: t
            });
          }).catch(function () {});
        }
      },
      Form: {
        noButtonBar: !0,
        title: i._.partial(i.loc, "password.reset", "login"),
        formChildren: function formChildren() {
          var e = this.settings.get("features.smsRecovery"),
              t = this.settings.get("features.callRecovery"),
              n = this.settings.get("features.emailRecovery"),
              r = !(e || t || n),
              s = [];
          return r ? this.add(p, ".o-form-error-container") : (s.push(l.default.Input({
            label: (0, i.loc)("password.forgot.email.or.username.placeholder", "login"),
            "label-top": !0,
            explain: u.default.createInputExplain("password.forgot.email.or.username.tooltip", "password.forgot.email.or.username.placeholder", "login"),
            "explain-top": !0,
            name: "username",
            input: f.default,
            inputId: "account-recovery-username",
            autoComplete: "username",
            type: "text",
            inlineValidation: !1
          })), (e || t) && s.push(l.default.View({
            View: i.View.extend({
              template: o.default.template({
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, o) {
                  var i = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<p class="mobile-recovery-hint">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                    name: "i18n",
                    hash: {
                      arguments: "mobileFactors",
                      bundle: "login",
                      code: "recovery.mobile.hint"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 32
                      },
                      end: {
                        line: 1,
                        column: 109
                      }
                    }
                  })) + "</p>";
                },
                useData: !0
              }),
              getTemplateData: function getTemplateData() {
                var n;
                return n = e && t ? (0, i.loc)("recovery.smsOrCall") : t ? (0, i.loc)("recovery.call") : (0, i.loc)("recovery.sms"), {
                  mobileFactors: n
                };
              }
            })
          })), e && (this.$el.addClass("forgot-password-sms-enabled"), s.push(this.createRecoveryFactorButton("sms-button", "password.forgot.sendText", a.default.RECOVERY_FACTOR_TYPE_SMS, this)), this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_SMS)), t && (this.$el.addClass("forgot-password-call-enabled"), s.push(this.createRecoveryFactorButton("call-button", "password.forgot.call", a.default.RECOVERY_FACTOR_TYPE_CALL, this)), this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_CALL)), n && (this.$el.addClass("forgot-password-email-enabled"), s.push(this.createRecoveryFactorButton("email-button", "password.forgot.sendEmail", a.default.RECOVERY_FACTOR_TYPE_EMAIL, this)), this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_EMAIL))), s;
        },
        initialize: function initialize() {
          this.listenTo(this.state, "contactSupport", function () {
            this.add(d.default, ".o-form-error-container");
          }), this.listenTo(this, "save", function () {
            this.options.appState.set("username", this.model.get("username")), this.model.save();
          });
        },
        setDefaultFactorType: function setDefaultFactorType(e) {
          i._.isEmpty(this.model.get("factorType")) && this.model.set("factorType", e);
        },
        createRecoveryFactorButton: function createRecoveryFactorButton(e, t, n, r) {
          return l.default.Button({
            attributes: {
              "data-se": e
            },
            className: "button button-primary button-wide " + e,
            title: (0, i.loc)(t, "login"),
            click: function click() {
              r.clearErrors(), this.model.isValid() && (this.model.set("factorType", n), r.trigger("save", this.model));
            }
          });
        }
      },
      Footer: h,
      initialize: function initialize() {
        this.options.appState.unset("username");
      }
    });
    t.default = m;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(269)),
        i = r(n(529)),
        a = r(n(159)),
        s = r(n(73)),
        l = r(n(530)),
        u = r(n(272)),
        c = o.default.extend({
      className: "idp-discovery",
      View: l.default,
      constructor: function constructor(e) {
        e.appState.unset("username"), this.model = new i.default({
          requestContext: e.settings.get("idpDiscovery.requestContext"),
          settings: e.settings,
          appState: e.appState
        }, {
          parse: !0
        }), s.default.apply(this, arguments), this.addListeners(), e.settings.get("hasConfiguredButtons") && this.add(u.default, {
          prepend: e.settings.get("socialAuthPositionTop"),
          options: {
            currentController: this
          }
        }), this.addFooter(e), this.setUsername();
      },
      initialize: function initialize() {
        o.default.prototype.initialize.apply(this), this.listenTo(this.model, "goToPrimaryAuth", function () {
          if (this.settings.set("username", this.model.get("username")), this.settings.get("features.passwordlessAuth")) {
            var e = new a.default({
              username: this.model.get("username"),
              multiOptionalFactorEnroll: this.options.settings.get("features.multiOptionalFactorEnroll"),
              settings: this.options.settings,
              appState: this.options.appState
            }, {
              parse: !0
            });
            this.addModelListeners(e), e.save();
          } else this.options.appState.set("disableUsername", !0), this.options.appState.trigger("navigate", "signin");
        });
      }
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o,
        i = r(n(526)),
        a = {
      track: function track(e) {
        try {
          o = new i.default(), o.addTarget(e), o.start();
        } catch (e) {}
      },
      getTypingPattern: function getTypingPattern() {
        try {
          return o.getTypingPattern({
            type: 1
          });
        } catch (e) {
          return null;
        }
      }
    };
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        o = r(n(252)),
        i = r(n(10));
    /**
    * TypingDNA - Typing Biometrics JavaScript API
    * https://api.typingdna.com/scripts/typingdna.js
    * https://typingdna.com/scripts/typingdna.js (alternative)
    *
    * @version 2.15
    * @author Raul Popa
    * @copyright SC TypingDNA SRL, http://typingdna.com
    * @license http://www.apache.org/licenses/LICENSE-2.0
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    * http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    *
    * Typical usage:
    * var tdna = new TypingDNA(); // creates a new TypingDNA object and starts recording
    * var typingPattern = tdna.getTypingPattern({type=1, text="Hello5g21?*"});
    * returns a type 1 typing pattern (and continues recording afterwards)
    *
    * Optional:
    * tdna.stop(); // ends recording and clears history stack (returns recording flag: false)
    * tdna.start(); // restarts the recording after a stop (returns recording flag: true)
    * tdna.reset(); // restarts the recording anytime, clears history stack and starts from scratch (returns nothing)
    * var typingPatternQuality = TypingDNA.getQuality(typingPattern); //returns the quality/strength of any typing pattern
    * (there is no need to initialize the class to do pattern quality checking)
    */

    e.exports = function e() {
      if (1 == e.initialized) return e.instance;
      e.prototype.start = function () {
        return e.start.apply(this, arguments);
      }, e.prototype.stop = function () {
        return e.stop.apply(this, arguments);
      }, e.prototype.reset = function () {
        return e.reset.apply(this, arguments);
      }, e.prototype.addTarget = function () {
        return e.addTarget.apply(this, arguments);
      }, e.prototype.removeTarget = function () {
        return e.removeTarget.apply(this, arguments);
      }, e.prototype.getTypingPattern = function () {
        return e.getTypingPattern.apply(this, arguments);
      }, e.prototype.get = function () {
        return e.get.apply(this, arguments);
      }, e.prototype.startDiagram = function () {}, e.prototype.stopDiagram = function () {}, e.prototype.getDiagram = function () {
        return e.getDiagram.apply(this, arguments);
      }, e.prototype.getExtendedDiagram = function () {
        return e.getExtendedDiagram.apply(this, arguments);
      }, e.prototype.getMouseDiagram = function () {
        return e.getMouseDiagram.apply(this, arguments);
      }, e.prototype.startMouse = function () {
        return e.startMouse.apply(this, arguments);
      }, e.prototype.stopMouse = function () {
        return e.stopMouse.apply(this, arguments);
      }, e.prototype.getQuality = function () {
        return e.getQuality.apply(this, arguments);
      }, e.prototype.getLength = function () {
        return e.getLength.apply(this, arguments);
      }, e.prototype.isMobile = function () {
        return e.isMobile.apply(this, arguments);
      }, e.prototype.getTextId = function () {
        return e.getTextId.apply(this, arguments);
      }, e.initialized = !0, e.prototype.maxHistoryLength = e.maxHistoryLength, e.prototype.defaultHistoryLength = e.defaultHistoryLength, e.prototype.maxSeekTime = e.maxSeekTime, e.prototype.maxPressTime = e.maxPressTime, e.version = 2.15, e.flags = 0, e.instance = this, e.document = document, e.maxHistoryLength = 2e3, e.maxSeekTime = 1500, e.maxPressTime = 300, e.defaultHistoryLength = 160, e.spKeyCodes = [8, 13, 32], e.spKeyCodesObj = {
        8: 1,
        13: 1,
        32: 1
      }, e.keyCodes = [65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 32, 222, 188, 190, 186, 187, 189, 191, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57], e.keyCodesObj = {};

      for (var t in e.keyCodes) {
        e.keyCodesObj[e.keyCodes[t]] = 1;
      }

      e.pt1 = e.ut1 = new Date().getTime(), e.wfk = [], e.sti = [], e.skt = [], e.recording = !0, e.mouseRecording = !0, e.mouseMoveRecording = !1, e.spKeyRecording = !0, e.diagramRecording = !0, e.dwfk = [], e.dsti = [], e.dskt = [], e.drkc = [], e.dlastDownKey, e.prevKeyCode = 0, e.maxMoveDeltaTime = 600, e.maxScrollDeltaTime = 800, e.maxStopTime = 1500, e.maxClickTime = 600, e.maxMouseHistoryLength = 500, e.lastMouseMoveTime = e.lastMouseDownTime = new Date().getTime(), e.stopTimes = [], e.clickTimes = [], e.lastMouseStop = !0, e.zl = 1e-7, e.isAndroidChrome = !1, e.ACLastTime = new Date().getTime(), e.ACSeekTime = 0, e.ACPressTime = 0, e.ACLastCharCode = 0, e.ACLastKeyCode = 0, e.ACInputLengths = {
        inputs: [],
        lastLength: []
      }, e.ACPreviousKeyCode = 0, e.targetIds = [], e.lastTarget = "", e.lastTargetFound = !1, e.replaceMissingKeys = !0, e.replaceMissingKeysPerc = 7, e.keyDown = function (t) {
        if ((e.recording || e.diagramRecording) && e.isTarget(t.target.id)) {
          var n = t.keyCode;
          if (1 == e.wfk[n] || e.dwfk[n], 229 == n && e.isMobile() && !e.isAndroidChrome) e.isAndroidChrome = !0, e.ACSeekTime = new Date().getTime() - e.ACLastTime, e.ACLastTime = new Date().getTime(), e.document.removeEventListener("keydown", e.keyDown), e.document.removeEventListener("keyup", e.keyUp), e.document.removeEventListener("keypress", e.keyPress), e.document.addEventListener("keydown", e.ACKeyDown), e.document.addEventListener("keyup", e.ACKeyUp);else {
            var r = e.pt1;
            e.pt1 = new Date().getTime();
            var o = e.pt1 - r,
                i = e.pt1;
            (1 == e.recording || e.spKeyCodesObj[n] && 1 == e.spKeyRecording) && (t.shiftKey && !e.isMobile() || (e.wfk[n] = 1, e.skt[n] = o, e.sti[n] = i)), 1 == e.diagramRecording && (e.dwfk[n] = 1, e.dskt[n] = o, e.dsti[n] = i, e.dlastDownKey = n);
          }
        }
      }, e.keyPress = function (t) {
        if ((e.recording || e.diagramRecording) && e.isTarget(t.target.id) && 1 == e.diagramRecording) {
          var n = e.dlastDownKey;
          e.drkc[n] = t.charCode;
        }
      }, e.keyUp = function (t) {
        if ((e.recording || e.diagramRecording) && e.isTarget(t.target.id)) {
          var n = new Date().getTime(),
              r = t.keyCode;

          if (1 == e.recording || e.spKeyCodesObj[r] && 1 == e.spKeyRecording) {
            if ((!t.shiftKey || e.isMobile()) && 1 == e.wfk[r]) {
              var o = n - e.sti[r],
                  i = e.skt[r],
                  a = [r, i, o, e.prevKeyCode, n, t.target.id];
              e.history.add(a), e.prevKeyCode = r;
            }

            e.wfk[r] = 0;
          }

          if (1 == e.diagramRecording) {
            if (void 0 != e.drkc[r] && 0 != e.drkc[r] && 1 == e.dwfk[r]) {
              var o = n - e.dsti[r],
                  i = e.dskt[r],
                  s = e.drkc[r],
                  l = [r, i, o, s, n, t.target.id];
              e.history.addDiagram(l);
            }

            e.dwfk[r] = 0;
          }
        }
      }, e.mouseScroll = function (t) {
        if (1 == e.mouseRecording && 1 == e.mouseMoveRecording) if (1 == e.mouse.scrollStarted) {
          var n = new Date().getTime();
          e.mouse.scrollTimes.push(n), e.mouse.scrollTopArr.push(e.document.body.scrollTop), clearInterval(e.scrollInterval), e.scrollInterval = setInterval(e.mouse.checkScroll, e.maxScrollDeltaTime);
        } else e.mouse.scrollStarted = !0;
      }, e.mouseMove = function (t) {
        if (1 == e.mouseRecording) {
          var n = new Date().getTime();
          1 == e.mouseMoveRecording && (1 == e.mouse.started ? (e.mouse.times.push(n), e.mouse.xPositions.push(t.screenX), e.mouse.yPositions.push(t.screenY), clearInterval(e.moveInterval), e.moveInterval = setInterval(e.mouse.checkMove, e.maxMoveDeltaTime)) : e.mouse.started = !0), e.lastMouseMoveTime = n;
        }
      }, e.mouseDown = function (t) {
        if (1 == e.mouseRecording && (e.mouse.checkMove(), e.mouse.checkScroll(), 1 == t.which)) {
          e.lastMouseDownTime = new Date().getTime();
          var n = e.lastMouseDownTime - e.lastMouseMoveTime;

          if (n < e.maxStopTime && 0 == e.lastMouseStop && (e.stopTimes.push(n), 1 == e.mouseMoveRecording)) {
            var r = [3, n];
            e.mouse.history.add(r), e.lastMouseStop = !0;
          }
        }
      }, e.mouseUp = function (t) {
        if (1 == e.mouseRecording && 1 == t.which) {
          var n = new Date().getTime() - e.lastMouseDownTime;

          if (n < e.maxClickTime && e.lastMouseDownTime > e.lastMouseMoveTime && (e.clickTimes.push(n), 1 == e.mouseMoveRecording)) {
            var r = [4, n];
            e.mouse.history.add(r);
          }
        }
      }, e.ACKeyDown = function (t) {
        (e.recording || e.diagramRecording) && (e.ACSeekTime = new Date().getTime() - e.ACLastTime, e.ACLastTime = new Date().getTime(), e.isTarget(t.target.id) && -1 === e.ACInputLengths.inputs.indexOf(t.target) && (e.ACInputLengths.inputs.push(t.target), e.ACInputLengths.lastLength.push(0)));
      }, e.ACKeyUp = function (t) {
        if ((e.recording || e.diagramRecording) && (e.ACPressTime = new Date().getTime() - e.ACLastTime, e.ACLastTime = new Date().getTime(), e.isTarget(t.target.id))) {
          var n = t.keyCode,
              r = e.ACInputLengths.inputs.indexOf(t.target);

          if (-1 === r && (e.ACInputLengths.inputs.push(t.target), e.ACInputLengths.lastLength.push(0), r = e.ACInputLengths.inputs.indexOf(t.target)), 229 == n && t.target.value.length >= e.ACInputLengths.lastLength[r]) {
            var o = t.target.value.substr(t.target.selectionStart - 1 || 0, 1);
            n = o.toUpperCase().charCodeAt(0), e.ACLastCharCode = o.charCodeAt(0), e.ACLastKeyCode = o.toUpperCase().charCodeAt(0);
          }

          e.ACInputLengths.lastLength[r] = t.target.value.length;
          var i = [n, e.ACSeekTime, e.ACPressTime, e.ACPreviousKeyCode, e.ACLastTime];

          if (e.history.add(i), e.ACPreviousKeyCode = n, 1 == e.diagramRecording) {
            var a = [n, e.ACSeekTime, e.ACPressTime, e.ACLastCharCode];
            e.history.addDiagram(a);
          }
        }
      }, e.isTarget = function (t) {
        if (e.lastTarget == t && e.lastTargetFound) return !0;
        var n = e.targetIds.length,
            r = !1;

        if (n > 0) {
          for (var o = 0; o < n; o++) {
            if (e.targetIds[o] == t) {
              r = !0;
              break;
            }
          }

          return e.lastTarget = t, e.lastTargetFound = r, r;
        }

        return e.lastTarget = t, e.lastTargetFound = !0, !0;
      }, e.document.addEventListener ? (e.document.addEventListener("keydown", e.keyDown), e.document.addEventListener("keyup", e.keyUp), e.document.addEventListener("keypress", e.keyPress), e.document.addEventListener("mousemove", e.mouseMove), e.document.addEventListener("mousedown", e.mouseDown), e.document.addEventListener("mouseup", e.mouseUp), e.document.addEventListener("scroll", e.mouseScroll)) : e.document.attachEvent && (e.document.attachEvent("onkeydown", e.keyDown), e.document.attachEvent("onkeyup", e.keyUp), e.document.attachEvent("onkeypress", e.keyPress), e.document.attachEvent("onmousemove", e.mouseMove), e.document.attachEvent("onmousedown", e.mouseDown), e.document.attachEvent("onmouseup", e.mouseUp), e.document.attachEvent("onscroll", e.mouseScroll)), e.mouse = {}, e.mouse.times = [], e.mouse.xPositions = [], e.mouse.yPositions = [], e.mouse.scrollTimes = [], e.mouse.scrollTopArr = [], e.mouse.history = {}, e.mouse.history.stack = [], e.mouse.getDistance = function (e, t) {
        return Math.sqrt(e * e + t * t);
      }, e.mouse.getTotalDistance = function (n, r) {
        var o = 0,
            i = n.length;

        for (t = 1; t < i - 1; t++) {
          var a = n[t] - n[t - 1],
              s = r[t] - r[t - 1];
          o += e.mouse.getDistance(a, s);
        }

        return o;
      }, e.mouse.getAngle = function (e, t) {
        var n = e >= 0,
            r = t < 0;
        return n ? r ? 180 + Math.round(Math.atan(Math.abs(e) / (Math.abs(t) + 1e-7)) / .01745329251) : 90 - Math.round(Math.atan(Math.abs(e) / (Math.abs(t) + 1e-7)) / .01745329251) + 270 : r ? 90 - Math.round(Math.atan(Math.abs(e) / (Math.abs(t) + 1e-7)) / .01745329251) + 90 : Math.round(Math.atan(Math.abs(e) / (Math.abs(t) + 1e-7)) / .01745329251);
      }, e.mouse.recordMoveAction = function () {
        var n = e.mouse.times.length;

        if (!(n < 3)) {
          var r = e.mouse.times[n - 1] - e.mouse.times[0],
              o = e.mouse.xPositions[n - 1] - e.mouse.xPositions[0],
              i = e.mouse.yPositions[n - 1] - e.mouse.yPositions[0],
              a = Math.round(e.mouse.getDistance(o, i)),
              s = Math.round(e.mouse.getTotalDistance(e.mouse.xPositions, e.mouse.yPositions)),
              l = Math.round(100 * s / a),
              u = Math.round(100 * a / r),
              c = e.mouse.getAngle(o, i),
              d = [1, r, a, u, c, l];

          for (t in d) {
            if (isNaN(d[t])) return;
          }

          e.mouse.history.add(d), e.lastMouseStop = !1;
        }
      }, e.mouse.recordScrollAction = function () {
        var n = e.mouse.scrollTimes.length;

        if (!(n < 2)) {
          var r = e.mouse.scrollTimes[n - 1] - e.mouse.scrollTimes[0],
              o = e.mouse.scrollTopArr[n - 1] - e.mouse.scrollTopArr[0],
              i = Math.round(100 * o / r),
              a = [2, r, o, i];

          for (t in a) {
            if (isNaN(a[t]) && !isFinite(a[t])) return;
          }

          e.mouse.history.add(a);
        }
      }, e.mouse.history.add = function (t) {
        this.stack.push(t), this.stack.length > e.maxMouseHistoryLength && this.stack.shift();
      }, e.mouse.history.getDiagram = function () {
        var t = this.stack.join("|");
        return [String(e.isMobile()) + "," + String(e.version), t].join("|");
      }, e.mouse.clearLastMove = function () {
        e.mouse.times = [], e.mouse.xPositions = [], e.mouse.yPositions = [];
      }, e.mouse.checkMove = function () {
        clearInterval(e.moveInterval), 1 == e.mouse.started && (e.mouse.started = !1, e.mouse.recordMoveAction(), e.mouse.clearLastMove());
      }, e.mouse.clearLastScroll = function () {
        e.mouse.scrollTimes = [], e.mouse.scrollTopArr = [];
      }, e.mouse.checkScroll = function () {
        clearInterval(e.scrollInterval), 1 == e.mouse.scrollStarted && (e.mouse.scrollStarted = !1, e.mouse.recordScrollAction(), e.mouse.clearLastScroll());
      }, e.addTarget = function (t) {
        var n = e.targetIds.length,
            r = !1;

        if (n > 0) {
          for (var o = 0; o < n; o++) {
            if (e.targetIds[o] == t) {
              r = !0;
              break;
            }
          }

          r || e.targetIds.push(t);
        } else e.targetIds.push(t);
      }, e.removeTarget = function (t) {
        var n = e.targetIds.length;
        if (n > 0) for (var r = 0; r < n; r++) {
          if (e.targetIds[r] == t) {
            e.targetIds.splice(r, 1);
            break;
          }
        }
      }, e.reset = function (t) {
        e.history.stack = [], e.history.stackDiagram = [], e.clickTimes = [], e.stopTimes = [], e.ACInputLengths = {
          inputs: [],
          lastLength: []
        }, 1 == t && (e.mouse.history.stack = []);
      }, e.start = function () {
        return e.diagramRecording = !0, e.recording = !0;
      }, e.stop = function () {
        return e.diagramRecording = !1, e.recording = !1;
      }, e.startMouse = function () {
        return e.mouseRecording = e.mouseMoveRecording = !0;
      }, e.stopMouse = function () {
        return e.mouseRecording = e.mouseMoveRecording = !1;
      }, e.getTypingPattern = function (t) {
        if ("object" !== (0, i.default)(t)) return e.get();

        switch (t.type) {
          case 0:
            return e.get(t.length, t.targetId);

          case 1:
            var n = void 0 != t.text ? t.text : t.length;
            return e.history.getDiagram(t.extended, n, t.textId, t.targetId, t.caseSensitive);

          case 2:
            var n = void 0 != t.text ? t.text : t.length;
            return e.history.getDiagram(!0, n, t.textId, t.targetId, t.caseSensitive);

          default:
            return e.get(t.length);
        }
      }, e.getDiagram = function (t, n) {
        return e.history.getDiagram(!1, t, n, void 0, !1);
      }, e.getExtendedDiagram = function (t, n) {
        return e.history.getDiagram(!0, t, n, void 0, !1);
      }, e.getMouseDiagram = function () {
        return e.mouse.history.getDiagram();
      }, e.get = function (t, n) {
        var r = e.history.stack.length;
        void 0 != t && 0 != t || (t = e.defaultHistoryLength), t > r && (t = r);
        var i = {},
            a = e.history.get(t, "", n),
            s = (0, o.default)(a, 2);
        i.arr = s[0], targetLength = s[1], void 0 != n && "" != n && (t = targetLength);

        var l = e.zl,
            u = t,
            c = e.math.fo(e.history.get(t, "seek", n)),
            d = e.math.fo(e.history.get(t, "press", n)),
            f = Math.round(e.math.avg(d)),
            p = Math.round(e.math.avg(c)),
            h = Math.round(e.math.sd(d)),
            m = Math.round(e.math.sd(c)),
            g = p + f,
            v = e.math.rd((f + l) / (g + l), 4),
            y = e.math.rd((1 - v) / v, 4),
            b = e.math.rd((h + l) / (f + l), 4),
            _ = e.math.rd((m + l) / (f + l), 4),
            w = Math.round(6e4 / (g + l));

        0 == u && (w = 0);

        for (var E in i.arr) {
          var O = i.arr[E][1].length,
              S = 0,
              x = 0,
              T = 0,
              k = 0,
              C = 0,
              A = 0;

          switch (i.arr[E][0].length) {
            case 0:
              break;

            case 1:
              var S = e.math.rd((i.arr[E][0][0] + l) / (p + l), 4);
              break;

            default:
              var N = e.math.fo(i.arr[E][0]);
              S = e.math.rd((e.math.avg(N) + l) / (p + l), 4), k = e.math.rd((e.math.sd(N) + l) / (m + l), 4);
          }

          switch (i.arr[E][1].length) {
            case 0:
              break;

            case 1:
              var x = e.math.rd((i.arr[E][1][0] + l) / (f + l), 4);
              break;

            default:
              var N = e.math.fo(i.arr[E][1]);
              x = e.math.rd((e.math.avg(N) + l) / (f + l), 4), C = e.math.rd((e.math.sd(N) + l) / (h + l), 4);
          }

          switch (i.arr[E][2].length) {
            case 0:
              break;

            case 1:
              var T = e.math.rd((i.arr[E][2][0] + l) / (p + l), 4);
              break;

            default:
              var N = e.math.fo(i.arr[E][2]);
              T = e.math.rd((e.math.avg(N) + l) / (p + l), 4), A = e.math.rd((e.math.sd(N) + l) / (m + l), 4);
          }

          delete i.arr[E][2], delete i.arr[E][1], delete i.arr[E][0], i.arr[E][0] = O, i.arr[E][1] = S, i.arr[E][2] = x, i.arr[E][3] = T, i.arr[E][4] = k, i.arr[E][5] = C, i.arr[E][6] = A;
        }

        var N = [];
        e.apu(N, u), e.apu(N, w), e.apu(N, g), e.apu(N, v), e.apu(N, y), e.apu(N, b), e.apu(N, _), e.apu(N, f), e.apu(N, p), e.apu(N, h), e.apu(N, m);

        for (var P = 0; P <= 6; P++) {
          for (var E = 0; E < 44; E++) {
            var R = e.keyCodes[E],
                I = i.arr[R][P];
            0 == I && P > 0 && (I = 1), e.apu(N, I);
          }
        }

        return e.apu(N, e.isMobile()), e.apu(N, e.version), e.apu(N, e.flags), N.push(e.history.getSpecialKeys()), N.join(",");
      }, e.apu = function (e, t) {
        "NaN" == String(t) && (t = 0), e.push(t);
      }, e.math = {}, e.math.rd = function (e, t) {
        return Number(e.toFixed(t));
      }, e.math.avg = function (e) {
        var t = e.length;

        if (t > 0) {
          for (var n = 0, r = 0; r < t; r++) {
            n += e[r];
          }

          return this.rd(n / t, 4);
        }

        return 0;
      }, e.math.sd = function (e) {
        var t = e.length;
        if (t < 2) return 0;

        for (var n = 0, r = this.avg(e), o = 0; o < t; o++) {
          n += (e[o] - r) * (e[o] - r);
        }

        return Math.sqrt(n / t);
      }, e.math.fo = function (e) {
        if (e.length > 1) {
          var t = e.concat(),
              n = e.length;
          t.sort(function (e, t) {
            return e - t;
          });
          var r = this.sd(t),
              o = t[Math.ceil(e.length / 2)],
              i = o + 2 * r,
              a = o - 2 * r;
          n < 20 && (a = 0);

          for (var s = [], l = 0; l < n; l++) {
            var u = t[l];
            u < i && u > a && s.push(u);
          }

          return s;
        }

        return e;
      }, e.math.fnv1aHash = function (e) {
        if (void 0 == e && "string" != typeof e) return 0;
        e = e.toLowerCase();
        var t,
            n,
            r = 1914395348;

        for (t = 0, n = e.length; t < n; t++) {
          r ^= e.charCodeAt(t), r += (r << 1) + (r << 4) + (r << 7) + (r << 8) + (r << 24);
        }

        return r >>> 0;
      }, e.history = {}, e.history.stack = [], e.history.stackDiagram = [], e.history.add = function (t) {
        this.stack.push(t), this.stack.length > e.maxHistoryLength && this.stack.shift();
      }, e.history.addDiagram = function (e) {
        this.stackDiagram.push(e);
      }, e.history.getDiagram = function (t, n, r, o, a) {
        var a = void 0 != a ? a : void 0 == n || "" == n,
            s = [],
            l = 1 == t ? 1 : 0,
            u = this.stackDiagram;

        if (void 0 != o && "" != o && u.length > 0) {
          if (u = e.sliceStackByTargetId(u, o), void 0 == n || "" == n) {
            var c = e.document.getElementById(o);
            null != c && (n = c.value);
          }
        } else {
          var d = e.targetIds.length;

          if ((void 0 == n || "" == n) && d > 0) {
            n = "";

            for (var f = 0; f < d; f++) {
              var c = e.document.getElementById(e.targetIds[f]);
              null != c && (n += c.value);
            }
          }
        }

        var p = 0,
            h = u.length,
            m = h;
        "string" == typeof n ? m = n.length : "number" == typeof n && n < h && (m = n);
        var g = 0;
        if (void 0 != r ? g = isNaN(parseInt(r)) ? e.math.fnv1aHash(r) : parseInt(r) : "string" == typeof n && (g = e.math.fnv1aHash(n)), s.push([e.isMobile(), e.version, e.flags, l, m, g, e.history.getSpecialKeys()]), void 0 != n && n.length > 0 && "string" == typeof n) for (var v, y, b = n.toLowerCase(), _ = n.toUpperCase(), w = [], E = 0, f = 0; f < n.length; f++) {
          var O = n.charCodeAt(f);
          a || (v = _.charCodeAt(f), y = v != O ? v : b.charCodeAt(f));

          for (var S = E, x = h, T = !1; 0 == T;) {
            for (var k = S; k < x; k++) {
              var C = u[k],
                  A = C[3];

              if (A == O || !a && A == y) {
                if (T = !0, k == E) E++, w = [];else {
                  w.push(k);
                  var N = w.length;
                  N > 1 && w[N - 1] == w[N - 2] + 1 && (E = k + 1, w = []);
                }
                var P = C[0],
                    R = C[1],
                    I = C[2];
                t ? s.push([A, R, I, P]) : s.push([R, I]);
                break;
              }
            }

            if (0 == T) if (0 != S) S = 0, x = E;else if (T = !0, e.replaceMissingKeys) {
              if (p++, "object" !== (0, i.default)(e.savedMissingAvgValues) || e.savedMissingAvgValues.historyLength != h) {
                var M = e.math.fo(e.history.get(0, "seek")),
                    j = e.math.fo(e.history.get(0, "press")),
                    R = Math.round(e.math.avg(M)),
                    I = Math.round(e.math.avg(j));
                e.savedMissingAvgValues = {
                  seekTime: R,
                  pressTime: I,
                  historyLength: h
                };
              } else var R = e.savedMissingAvgValues.seekTime,
                  I = e.savedMissingAvgValues.pressTime;

              t ? s.push([O, R, I, O, 1]) : s.push([R, I, 1]);
              break;
            }
          }

          if (e.replaceMissingKeysPerc < 100 * p / m) return null;
        } else {
          var L = 0;
          "number" == typeof n && (L = h - n), L < 0 && (L = 0);

          for (var f = L; f < h; f++) {
            var C = u[f],
                P = C[0],
                R = C[1],
                I = C[2];

            if (t) {
              var A = C[3];
              s.push([A, R, I, P]);
            } else s.push([R, I]);
          }
        }
        return s.join("|");
      }, e.sliceStackByTargetId = function (e, n) {
        var r = e.length,
            o = [];

        for (t = 0; t < r; t++) {
          var i = e[t];
          i[5] == n && o.push(i);
        }

        return o;
      }, e.history.get = function (t, n, r) {
        var o = this.stack;
        void 0 != r && "" != r && o.length > 0 && (o = e.sliceStackByTargetId(o, r));
        var i = o.length;

        switch (0 != t && void 0 != t || (t = e.defaultHistoryLength), t > i && (t = i), n) {
          case "seek":
            var a = [];

            for (d = 1; d <= t; d++) {
              var s = o[i - d][1];
              s <= e.maxSeekTime && a.push(s);
            }

            return a;

          case "press":
            var l = [];

            for (d = 1; d <= t; d++) {
              var u = o[i - d][2];
              u <= e.maxPressTime && l.push(u);
            }

            return l;

          default:
            var c = {};

            for (var d in e.keyCodes) {
              c[e.keyCodes[d]] = [[], [], []];
            }

            for (d = 1; d <= t; d++) {
              var f = o[i - d],
                  p = f[0],
                  s = f[1],
                  u = f[2],
                  h = f[3];
              e.keyCodesObj[p] && (s <= e.maxSeekTime && (c[p][0].push(s), 0 != h && e.keyCodesObj[h] && c[h][2].push(s)), u <= e.maxPressTime && c[p][1].push(u));
            }

            return [c, t];
        }
      }, e.history.getSpecialKeys = function () {
        var t = [],
            n = this.stack.length,
            r = {};

        for (var o in e.spKeyCodes) {
          r[e.spKeyCodes[o]] = [[]];
        }

        for (o = 1; o <= n; o++) {
          var i = this.stack[n - o];

          if (e.spKeyCodesObj[i[0]]) {
            var a = i[0],
                s = i[2];
            s <= e.maxPressTime && r[a][0].push(s);
          }
        }

        for (var o in e.spKeyCodes) {
          var i = e.math.fo(r[e.spKeyCodes[o]][0]),
              l = i.length;
          t.push(l), l > 1 ? (t.push(Math.round(e.math.avg(i))), t.push(Math.round(e.math.sd(i)))) : 1 == l ? t.push([i[0], -1]) : t.push([-1, -1]);
        }

        var u = e.clickTimes.length;
        t.push(u), u > 1 ? (t.push(Math.round(e.math.avg(e.clickTimes))), t.push(Math.round(e.math.sd(e.clickTimes)))) : 1 == u ? t.push(e.clickTimes[0], -1) : t.push([-1, -1]);
        var c = e.stopTimes.length;
        return t.push(c), c > 1 ? (t.push(Math.round(e.math.avg(e.stopTimes))), t.push(Math.round(e.math.sd(e.stopTimes)))) : 1 == c ? t.push(e.stopTimes[0], -1) : t.push([-1, -1]), t;
      }, e.getQuality = function (t) {
        var n = t.split(",");

        for (a = 0; a < n.length; a++) {
          n[a] = Number(n[a]);
        }

        var r = (n[0], rec = avgAcc = 0),
            o = e.math.avg(n),
            i = n.slice(11, 55);

        for (var a in i) {
          rec += Number(i[a] > 0), r += Number(i[a] > 4), avgAcc += Number(i[a] > o);
        }

        var s = Math.sqrt(rec * r * avgAcc) / 80;
        return s > 1 ? 1 : s;
      }, e.checkMobileValidity = function (e) {
        var t = e.split(","),
            n = t[0];
        if (0 == n) return 0;
        var r = 0,
            o = t.slice(11, 55);

        for (var i in o) {
          r += Number(o[i]);
        }

        return r / n;
      }, e.getLength = function (e) {
        return Number(e.split(",")[1]);
      }, e.isMobile = function () {
        if (void 0 != e.mobile) return e.mobile;
        var t = 0;
        return function (e) {
          (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4))) && (t = 1);
        }(navigator.userAgent || navigator.vendor || window.opera), e.mobile = t, t;
      }, e.getTextId = function (t) {
        return e.math.fnv1aHash(t);
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = a.internal.util.Util,
        l = a.View.extend({
      template: i.default.template({
        1: function _(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<li><a href="#" data-se="unlock" class="link js-unlock">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "unlockaccount"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 440
              },
              end: {
                line: 1,
                column: 484
              }
            }
          })) + "</a></li>";
        },
        3: function _(e, t, n, r, i) {
          var a,
              s,
              l = null != t ? t : e.nullContext || {},
              u = e.hooks.helperMissing,
              c = e.escapeExpression,
              d = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<li><a href="' + c((s = null != (s = d(n, "href") || (null != t ? d(t, "href") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "href",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 539
              },
              end: {
                line: 1,
                column: 547
              }
            }
          }) : s)) + '" class="link js-custom" rel="noopener noreferrer" ' + (null != (a = d(n, "if").call(l, null != t ? d(t, "target") : t, {
            name: "if",
            hash: {},
            fn: e.program(4, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 598
              },
              end: {
                line: 1,
                column: 638
              }
            }
          })) ? a : "") + ">" + c((s = null != (s = d(n, "text") || (null != t ? d(t, "text") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "text",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 639
              },
              end: {
                line: 1,
                column: 647
              }
            }
          }) : s)) + "</a></li>";
        },
        4: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return 'target="' + e.escapeExpression((i = null != (i = a(n, "target") || (null != t ? a(t, "target") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "target",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 620
              },
              end: {
                line: 1,
                column: 630
              }
            }
          }) : i)) + '"';
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" data-se="needhelp" aria-expanded="false" aria-controls="help-links-container" class="link help js-help">' + u((c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "needhelp"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 116
              },
              end: {
                line: 1,
                column: 155
              }
            }
          })) + '</a><ul class="help-links js-help-links" id="help-links-container"><li><a href="#" data-se="forgot-password" class="link js-forgot-password">' + u((c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "forgotpassword"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 296
              },
              end: {
                line: 1,
                column: 341
              }
            }
          })) + "</a></li>" + (null != (i = c(n, "if").call(s, null != (i = null != t ? c(t, "features") : t) ? c(i, "selfServiceUnlock") : i, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 350
              },
              end: {
                line: 1,
                column: 500
              }
            }
          })) ? i : "") + (null != (i = c(n, "each").call(s, null != (i = null != t ? c(t, "helpLinks") : t) ? c(i, "custom") : i, {
            name: "each",
            hash: {},
            fn: e.program(3, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 500
              },
              end: {
                line: 1,
                column: 665
              }
            }
          })) ? i : "") + '<li><a href="' + u((a = null != (a = c(n, "helpLinkUrl") || (null != t ? c(t, "helpLinkUrl") : t)) ? a : l, "function" == typeof a ? a.call(s, {
            name: "helpLinkUrl",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 678
              },
              end: {
                line: 1,
                column: 693
              }
            }
          }) : a)) + '" data-se="help-link" class="link js-help-link" rel="noopener noreferrer" target="_blank">' + u((c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "help"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 783
              },
              end: {
                line: 1,
                column: 818
              }
            }
          })) + "</a></li></ul>";
        },
        useData: !0
      }),
      className: "auth-footer",
      initialize: function initialize() {
        this.listenTo(this.state, "change:enabled", function (e, t) {
          this.$(".link").toggleClass("o-form-disabled", !t);
        });
      },
      getTemplateData: function getTemplateData() {
        var e,
            t = this.settings.get("helpLinks.help");
        return e = t || i.default.template({
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return e.escapeExpression((i = null != (i = a(n, "baseUrl") || (null != t ? a(t, "baseUrl") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
              name: "baseUrl",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 0
                },
                end: {
                  line: 1,
                  column: 11
                }
              }
            }) : i)) + "/help/login";
          },
          useData: !0
        })({
          baseUrl: this.settings.get("baseUrl")
        }), a._.extend(this.settings.toJSON({
          verbose: !0
        }), {
          helpLinkUrl: e
        });
      },
      postRender: function postRender() {
        this.$(".js-help-links").hide();
      },
      toggleLinks: function toggleLinks(e) {
        var t = this;
        e.preventDefault(), this.$(".js-help-links").slideToggle(200, function () {
          t.$(".js-help").attr("aria-expanded", t.$(".js-help-links").is(":visible"));
        });
      },
      events: {
        "click .js-help": function clickJsHelp(e) {
          e.preventDefault(), this.state.get("enabled") && this.toggleLinks(e);
        },
        "click .js-forgot-password": function clickJsForgotPassword(e) {
          if (e.preventDefault(), this.state.get("enabled")) {
            var t = this.settings.get("helpLinks.forgotPassword");
            t ? s.redirect(t) : this.options.appState.trigger("navigate", "signin/forgot-password");
          }
        },
        "click .js-unlock": function clickJsUnlock(e) {
          if (e.preventDefault(), this.state.get("enabled")) {
            var t = this.settings.get("helpLinks.unlock");
            t ? s.redirect(t) : this.options.appState.trigger("navigate", "signin/unlock");
          }
        }
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = a.View.extend({
      template: i.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="content-container"><span class="registration-label">' + u((a = null != (a = c(n, "label") || (null != t ? c(t, "label") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "label",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 64
              },
              end: {
                line: 1,
                column: 73
              }
            }
          }) : a)) + '</span><a title="' + u((a = null != (a = c(n, "text") || (null != t ? c(t, "text") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "text",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 90
              },
              end: {
                line: 1,
                column: 98
              }
            }
          }) : a)) + '" aria-label="' + u((a = null != (a = c(n, "text") || (null != t ? c(t, "text") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "text",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 112
              },
              end: {
                line: 1,
                column: 120
              }
            }
          }) : a)) + '" class="registration-link" href="#">' + u((a = null != (a = c(n, "text") || (null != t ? c(t, "text") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "text",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 157
              },
              end: {
                line: 1,
                column: 165
              }
            }
          }) : a)) + "</a></div>";
        },
        useData: !0
      }),
      className: "registration-container",
      events: {
        "click a.registration-link": "handleClickEvent"
      },
      handleClickEvent: function handleClickEvent(e) {
        e.preventDefault();
        var t = this.settings.get("registration.click");
        t ? t() : this.options.appState.get("isIdxStateToken") ? this.options.appState.trigger("navigate", "signin/enroll-user") : this.options.appState.trigger("navigate", "signin/register");
      },
      getTemplateData: function getTemplateData() {
        return {
          label: (0, a.loc)("registration.signup.label", "login"),
          text: (0, a.loc)("registration.signup.text", "login")
        };
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(159)),
        i = r(n(270)),
        a = r(n(5)),
        s = r(n(12)),
        l = o.default.extend({
      props: function props() {
        var e = i.default.getCookieUsername(),
            t = this.getUsernameAndRemember(e);
        return {
          username: ["string", !0, t.username],
          lastUsername: ["string", !1, e],
          context: ["object", !1],
          remember: ["boolean", !0, t.remember]
        };
      },
      local: {},
      save: function save() {
        var e = this,
            t = this.settings.transformUsername(this.get("username"), a.default.IDP_DISCOVERY),
            n = this.get("remember"),
            r = this.get("lastUsername"),
            o = "okta:acct:" + t,
            l = this.get("requestContext");
        this.setUsernameCookie(t, n, r), this.trigger("save"), this.appState.trigger("loading", !0);
        var u = {
          resource: o,
          requestContext: l
        };
        this.appState.settings.authClient.webfinger(u).then(function (t) {
          if (t && t.links && t.links[0]) if ("OKTA" === t.links[0].properties["okta:idp:type"]) e.trigger("goToPrimaryAuth");else if (t.links[0].href) {
            var n = t.links[0].href.includes("OKTA_INVALID_SESSION_REPOST%3Dtrue") ? s.default.redirectWithFormGet.bind(s.default) : e.settings.get("redirectUtilFn");
            n(t.links[0].href);
          }
        }).catch(function () {
          e.trigger("error"), e.appState.trigger("removeLoading"), i.default.removeUsernameCookie();
        }).finally(function () {
          e.appState.trigger("loading", !1);
        });
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(273)),
        a = i.default.extend({
      className: "idp-discovery-form",
      save: function save() {
        return (0, o.loc)("oform.next", "login");
      },
      saveId: "idp-discovery-submit",
      initialize: function initialize() {
        this.listenTo(this, "save", o._.bind(this.model.save, this.model)), this.stateEnableChange();
      },
      inputs: function inputs() {
        var e = [],
            t = {
          className: "margin-btm-30",
          label: (0, o.loc)("primaryauth.username.placeholder", "login"),
          inputId: "idp-discovery-username",
          disabled: !1
        };
        return e.push(o._.extend(this.getUsernameField(), t)), this.settings.get("features.rememberMe") && e.push(this.getRemeberMeCheckbox()), e;
      },
      focus: function focus() {
        this.model.get("username") ? this.getInputs().toArray()[1] && this.getInputs().toArray()[1].focus() : this.getInputs().first().focus();
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = p.default.createActivateFactorUrl(e.options.appState.get("activatedFactorProvider"), e.options.appState.get("activatedFactorType"), t);
      e.options.appState.trigger("navigate", n);
    }

    function o(e) {
      var t, n;
      "SMS" === e.model.get("activationType") && (n = e.model.get("countryCode"), t = e.model.get("phoneNumber")), e.options.appState.set({
        factorActivationType: e.model.get("activationType"),
        userCountryCode: n,
        userPhoneNumber: t
      });
    }

    function i(e, t) {
      return e.model.doTransaction(function (n) {
        return n.prev().then(function (e) {
          return l._.findWhere(e.factors, {
            factorType: t,
            provider: "OKTA"
          }).enroll();
        }).then(function (t) {
          var n,
              r,
              o,
              i = t.data;

          if (i && i._embedded && i._embedded.factor && i._embedded.factor._embedded && i._embedded.factor._embedded.activation) {
            var a = i._embedded.factor;

            if (o = a._embedded.activation.sharedSecret, a._embedded.activation._links && a._embedded.activation._links.send) {
              var s = a._embedded.activation._links.send,
                  u = l._.findWhere(s, {
                name: "sms"
              });

              n = u ? u.href : null;

              var c = l._.findWhere(s, {
                name: "email"
              });

              r = c ? c.href : null;
            }
          }

          return e.model.set({
            SMS: n,
            EMAIL: r,
            sharedSecret: o
          }), t;
        });
      });
    }

    var a = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var s = a(n(2)),
        l = n(1),
        u = a(n(74)),
        c = a(n(15)),
        d = a(n(4)),
        f = a(n(6)),
        p = a(n(39)),
        h = a(n(532)),
        m = a(n(262)),
        g = a(n(13)),
        v = d.default.extend({
      className: "enroll-manual-push",
      Model: function Model() {
        return {
          local: {
            activationType: ["string", !0, this.options.appState.get("factorActivationType") || "SMS"],
            countryCode: ["string", !1, this.options.appState.get("userCountryCode")],
            phoneNumber: "string",
            SMS: ["string", !1, this.options.appState.get("textActivationLinkUrl")],
            EMAIL: ["string", !1, this.options.appState.get("emailActivationLinkUrl")],
            sharedSecret: ["string", !1, this.options.appState.get("sharedSecret")],
            __factorType__: ["string", !1, this.options.factorType],
            __provider__: ["string", !1, this.options.provider]
          },
          derived: {
            countryCallingCode: {
              deps: ["countryCode"],
              fn: function fn(e) {
                return "+" + u.default.getCallingCodeForCountry(e);
              }
            },
            fullPhoneNumber: {
              deps: ["countryCallingCode", "phoneNumber"],
              fn: function fn(e, t) {
                return e + t;
              }
            }
          }
        };
      },
      Form: {
        title: function title() {
          var e = c.default.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
          return (0, l.loc)("enroll.totp.title", "login", [e]);
        },
        subtitle: l._.partial(l.loc, "enroll.totp.cannotScanBarcode", "login"),
        noButtonBar: !0,
        attributes: {
          "data-se": "step-manual-setup"
        },
        formChildren: function formChildren() {
          var e = this,
              t = this.settings.get("brandName") ? (0, l.loc)("enroll.totp.sharedSecretInstructions.specific", "login", [this.settings.get("brandName")]) : (0, l.loc)("enroll.totp.sharedSecretInstructions.generic", "login");
          return [f.default.Input({
            name: "activationType",
            type: "select",
            wide: !0,
            options: {
              SMS: (0, l.loc)("enroll.totp.sendSms", "login"),
              EMAIL: (0, l.loc)("enroll.totp.sendEmail", "login"),
              MANUAL: (0, l.loc)("enroll.totp.setupManually", "login")
            }
          }), f.default.Input({
            name: "countryCode",
            type: "select",
            wide: !0,
            options: u.default.getCountries(),
            showWhen: {
              activationType: "SMS"
            }
          }), f.default.Input({
            label: (0, l.loc)("mfa.phoneNumber.placeholder", "login"),
            "label-top": !0,
            className: "enroll-sms-phone",
            name: "phoneNumber",
            input: m.default,
            type: "text",
            showWhen: {
              activationType: "SMS"
            }
          }), f.default.View({
            View: l.View.extend({
              template: s.default.template({
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, o) {
                  var i,
                      a = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<p class="okta-form-subtitle o-form-explain text-align-c">' + e.escapeExpression((i = null != (i = a(n, "instructions") || (null != t ? a(t, "instructions") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
                    name: "instructions",
                    hash: {},
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 58
                      },
                      end: {
                        line: 1,
                        column: 74
                      }
                    }
                  }) : i)) + "</p>";
                },
                useData: !0
              }),
              getTemplateData: function getTemplateData() {
                return {
                  instructions: t
                };
              }
            }),
            showWhen: {
              activationType: "MANUAL"
            }
          }), f.default.Input({
            name: "sharedSecret",
            input: g.default,
            type: "text",
            disabled: !0,
            showWhen: {
              activationType: "MANUAL"
            },
            initialize: function initialize() {
              this.listenTo(this.model, "change:sharedSecret", this.render);
            }
          }), f.default.View({
            View: l.View.extend({
              template: s.default.template({
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, o) {
                  return '<div data-type="next-button-wrap"></div>';
                },
                useData: !0
              })
            }),
            showWhen: {
              activationType: "MANUAL"
            }
          }), f.default.Button({
            title: (0, l.loc)("oform.next", "login"),
            className: "button button-primary button-wide button-next",
            attributes: {
              "data-se": "next-button"
            },
            click: function click() {
              o(e), r(e, "passcode");
            }
          }, '[data-type="next-button-wrap"]'), f.default.Toolbar({
            noCancelButton: !0,
            save: (0, l.loc)("oform.send", "login"),
            showWhen: {
              activationType: function activationType(e) {
                return "SMS" === e || "EMAIL" === e;
              }
            }
          })];
        }
      },
      Footer: h.default,
      initialize: function initialize() {
        this.setInitialModel(), this.listenTo(this.form, "save", function () {
          var e = this;
          this.model.doTransaction(function (t) {
            var n = this.get("activationType").toLowerCase(),
                i = {};
            return "sms" === n && (i.profile = {
              phoneNumber: this.get("fullPhoneNumber")
            }), t.factor.activation.send(n, i).then(function (t) {
              return o(e), l._.defer(function () {
                r(e, "sent");
              }), t;
            });
          });
        }), this.listenTo(this.model, "change:activationType", function (e, t) {
          this.form.clearErrors(), "MANUAL" === t && "token:software:totp" !== this.options.appState.get("activatedFactorType") ? i(this, "token:software:totp") : "push" !== this.options.appState.get("activatedFactorType") && i(this, "push");
        });
      },
      setInitialModel: function setInitialModel() {
        "SMS" === this.options.appState.get("factorActivationType") && this.model.set({
          countryCode: this.options.appState.get("userCountryCode") || "US",
          phoneNumber: this.options.appState.get("userPhoneNumber")
        });
      },
      trapAuthResponse: function trapAuthResponse() {
        if (this.options.appState.get("isMfaEnrollActivate") || this.options.appState.get("isMfaEnroll")) return !0;
      }
    });
    t.default = v;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = s.default.createActivateFactorUrl(e.get("activatedFactorProvider"), e.get("activatedFactorType"));
      e.trigger("navigate", t);
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = o(n(2)),
        a = n(1),
        s = o(n(39)),
        l = a.View.extend({
      template: i.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = null != t ? t : e.nullContext || {},
              a = e.hooks.helperMissing,
              s = e.escapeExpression,
              l = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link help js-back" data-se="back-link">' + s((l(n, "i18n") || t && l(t, "i18n") || a).call(i, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "mfa.backToFactors"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 58
              },
              end: {
                line: 1,
                column: 106
              }
            }
          })) + '</a><a href="#" class="link help goto js-goto" data-se="goto-link">' + s((l(n, "i18n") || t && l(t, "i18n") || a).call(i, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "mfa.scanBarcode"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 173
              },
              end: {
                line: 1,
                column: 219
              }
            }
          })) + "</a>";
        },
        useData: !0
      }),
      className: "auth-footer",
      events: {
        "click .js-back": function clickJsBack(e) {
          e.preventDefault(), this.back();
        },
        "click .js-goto": function clickJsGoto(e) {
          e.preventDefault();

          var t = a._.partial(r, this.options.appState);

          this.options.appState.unset("factorActivationType"), this.model.doTransaction(function (e) {
            return e.prev().then(function (e) {
              return a._.findWhere(e.factors, {
                factorType: "push",
                provider: "OKTA"
              }).enroll();
            });
          }).then(t);
        }
      },
      back: function back() {
        var e = this;
        e.options.appState.unset("factorActivationType"), e.options.appState.get("prevLink") ? this.model.doTransaction(function (e) {
          return e.prev();
        }).then(function () {
          e.options.appState.trigger("navigate", "signin/enroll");
        }) : e.options.appState.trigger("navigate", "signin/enroll");
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(15)),
        s = r(n(4)),
        l = r(n(6)),
        u = r(n(39)),
        c = r(n(534)),
        d = r(n(13)),
        f = s.default.extend({
      className: "enroll-manual-totp",
      Model: function Model() {
        return {
          local: {
            sharedSecret: ["string", !1, this.options.appState.get("sharedSecret")],
            __factorType__: ["string", !1, this.options.factorType],
            __provider__: ["string", !1, this.options.provider]
          }
        };
      },
      Form: {
        title: function title() {
          var e = a.default.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
          return (0, i.loc)("enroll.totp.title", "login", [e]);
        },
        subtitle: i._.partial(i.loc, "enroll.totp.cannotScanBarcode", "login"),
        noButtonBar: !0,
        attributes: {
          "data-se": "step-manual-setup"
        },
        formChildren: function formChildren() {
          var e = this.settings.get("brandName") ? (0, i.loc)("enroll.totp.manualSetupInstructions.specific", "login", [this.settings.get("brandName")]) : (0, i.loc)("enroll.totp.manualSetupInstructions.generic", "login");
          return [l.default.View({
            View: i.View.extend({
              template: o.default.template({
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, o) {
                  var i,
                      a = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<p class="okta-form-subtitle o-form-explain text-align-c">' + e.escapeExpression((i = null != (i = a(n, "instructions") || (null != t ? a(t, "instructions") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
                    name: "instructions",
                    hash: {},
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 58
                      },
                      end: {
                        line: 1,
                        column: 74
                      }
                    }
                  }) : i)) + "</p>";
                },
                useData: !0
              }),
              getTemplateData: function getTemplateData() {
                return {
                  instructions: e
                };
              }
            })
          }), l.default.Input({
            name: "sharedSecret",
            input: d.default,
            type: "text",
            disabled: !0
          }), l.default.Toolbar({
            noCancelButton: !0,
            save: (0, i.loc)("oform.next", "login")
          })];
        }
      },
      Footer: c.default,
      initialize: function initialize() {
        this.listenTo(this.form, "save", function () {
          var e = u.default.createActivateFactorUrl(this.model.get("__provider__"), this.model.get("__factorType__"), "activate");
          this.options.appState.trigger("navigate", e);
        });
      }
    });
    t.default = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(5)),
        s = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = null != t ? t : e.nullContext || {},
              a = e.hooks.helperMissing,
              s = e.escapeExpression,
              l = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link help js-back" data-se="back-link">' + s((l(n, "i18n") || t && l(t, "i18n") || a).call(i, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "mfa.backToFactors"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 58
              },
              end: {
                line: 1,
                column: 106
              }
            }
          })) + '</a><a href="#" class="link help goto js-goto" data-se="goto-link">' + s((l(n, "i18n") || t && l(t, "i18n") || a).call(i, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "mfa.scanBarcode"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 173
              },
              end: {
                line: 1,
                column: 219
              }
            }
          })) + "</a>";
        },
        useData: !0
      }),
      className: "auth-footer",
      events: {
        "click .js-back": function clickJsBack(e) {
          e.preventDefault(), this.back();
        },
        "click .js-goto": function clickJsGoto(e) {
          e.preventDefault(), this.model.startTransaction(function (e) {
            return e.tx.resume();
          });
        }
      },
      back: function back() {
        this.state.set("navigateDir", a.default.DIRECTION_BACK), this.options.appState.get("prevLink") ? this.model.doTransaction(function (e) {
          return e.prev();
        }) : this.options.appState.trigger("navigate", "signin/enroll");
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(73)),
        a = r(n(536)),
        s = r(n(537)),
        l = r(n(538)),
        u = r(n(539)),
        c = r(n(540)),
        d = r(n(542)),
        f = r(n(543)),
        p = r(n(544)),
        h = r(n(545)),
        m = r(n(76)),
        g = o.internal.views.forms.inputs.CheckBox,
        v = i.default.extend({
      className: "mfa-verify",
      initialize: function initialize(e) {
        var t,
            n = e.factorType;

        switch (n) {
          case "question":
            t = d.default;
            break;

          case "email":
            t = this.options.appState.get("isIdxStateToken") ? a.default : f.default;
            break;

          case "sms":
          case "call":
            t = l.default;
            break;

          case "token":
          case "token:software:totp":
          case "token:hotp":
            t = p.default;
            break;

          case "token:hardware":
            t = h.default;
            break;

          case "push":
            t = c.default;
            break;

          case "password":
            t = u.default;
            break;

          default:
            throw new Error("Unrecognized factor type");
        }

        if (this.model = this.findModel(n, e), !this.model) throw new Error("Unrecognized factor/provider");
        this.addListeners(), this.add(new t(this.toJSON())), "push" === n && this.model.get("isOktaFactor") && (this.model.get("backupFactor") && (this.inlineTotpForm = this.add(s.default, {
          options: {
            model: this.model.get("backupFactor")
          }
        }).last()), this.settings.get("features.autoPush") && (this.autoPushCheckBox = this.add(g, {
          options: {
            model: this.model,
            name: "autoPush",
            placeholder: (0, o.loc)("autoPush", "login"),
            label: !1,
            "label-top": !1,
            className: "margin-btm-0"
          }
        }).last()), this.options.appState.get("allowRememberDevice") && (this.rememberDeviceCheckbox = this.add(g, {
          options: {
            model: this.model,
            name: "rememberDevice",
            placeholder: this.options.appState.get("rememberDeviceLabel"),
            label: !1,
            "label-top": !0,
            className: "margin-btm-0"
          }
        }).last()), this.model.get("backupFactor") && this.listenTo(this.model, "change:rememberDevice", function (e, t) {
          e.get("backupFactor").set("rememberDevice", t);
        })), this.listenTo(this.options.appState, "change:isWaitingForNumberChallenge", function (e, t) {
          t || "SUCCESS" === this.options.appState.get("lastAuthResponse").status ? (this.autoPushCheckBox && this.autoPushCheckBox.$el.hide(), this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.hide(), this.inlineTotpForm && this.inlineTotpForm.$el.hide()) : (this.autoPushCheckBox && this.autoPushCheckBox.$el.show(), this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.show(), this.inlineTotpForm && this.inlineTotpForm.$el.show());
        }), this.add(new m.default(this.toJSON()));
      },
      findModel: function findModel(e, t) {
        var n = t.appState.get("factors"),
            r = t.provider,
            o = t.factorIndex;
        return r ? n.hasMultipleFactorsOfSameType(e) && o ? n.getFactorByTypeAndIndex(e, o) : n.findWhere({
          provider: r,
          factorType: e
        }) : n.findWhere({
          factorType: e,
          isFactorTypeVerification: !0
        });
      },
      trapAuthResponse: function trapAuthResponse() {
        return !!(this.options.appState.get("isMfaRequired") && this.options.appState.get("trapMfaRequiredResponse") || this.options.appState.get("isMfaChallenge")) && (this.options.appState.set("trapMfaRequiredResponse", !1), !0);
      },
      back: function back() {}
    });
    t.default = v;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(16)),
        a = r(n(5)),
        s = o.Form.extend({
      layout: "o-form-theme",
      className: "factor-verify-magiclink",
      autoSave: !0,
      noCancelButton: !0,
      initialize: function initialize() {
        var e = this;
        this.title = this.model.get("factorLabel");

        var t = this.model.get("email") || this.options.appState.get("lastAuthResponse")._embedded.user.profile.login;

        this.subtitle = "(" + t + ")", this.add((0, o.createButton)({
          attributes: {
            "data-se": "email-send-code"
          },
          className: "button email-request-button",
          title: (0, o.loc)("mfa.sendEmail", "login"),
          click: function click() {
            var t = this;
            e.clearErrors(), this.disable(), this.options.title = (0, o.loc)("mfa.sent", "login"), this.render(), this.model.save().then(function () {
              return i.default.delay(a.default.API_RATE_LIMIT);
            }).then(function () {
              t.options.title = (0, o.loc)("mfa.resendEmail", "login"), t.enable(), t.render();
            });
          }
        }));
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      e.addDivider(), e.addInput({
        label: (0, i.loc)("mfa.challenge.enterCode.placeholder", "login"),
        "label-top": !0,
        className: "o-form-fieldset o-form-label-top inline-input auth-passcode",
        name: "answer",
        input: a.default,
        type: "tel"
      }), e.add((0, i.createButton)({
        attributes: {
          "data-se": "inline-totp-verify"
        },
        className: "button inline-totp-verify margin-top-30",
        title: (0, i.loc)("mfa.challenge.verify", "login"),
        click: function click() {
          e.clearErrors(), e.isValid() && e.model.manageTransaction(function (t, n) {
            if ("MFA_CHALLENGE" === t.status && t.prev) return e.options.appState.set("trapMfaRequiredResponse", !0), t.prev().then(function (t) {
              n(t), e.model.save();
            });
            e.model.save();
          });
        }
      })), e.at(1).focus();
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = n(1),
        a = o(n(13)),
        s = i.Form.extend({
      autoSave: !0,
      noButtonBar: !0,
      scrollOnError: !1,
      layout: "o-form-theme",
      className: "mfa-verify-totp-inline",
      attributes: {
        "data-se": "factor-inline-totp"
      },
      initialize: function initialize() {
        var e = this;
        this.listenTo(this.model, "error", function () {
          this.clearErrors();
        }), this.add((0, i.createButton)({
          className: "link",
          attributes: {
            "data-se": "inline-totp-add"
          },
          title: (0, i.loc)("mfa.challenge.orEnterCode", "login"),
          click: function click() {
            this.remove(), r(e);
          }
        }));
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      switch (e) {
        case "sms":
          return {
            buttonDataSe: "sms-send-code",
            buttonClassName: "sms-request-button",
            formSubmit: (0, a.loc)("mfa.sendCode", "login"),
            formRetry: (0, a.loc)("mfa.resendCode", "login"),
            formSubmitted: (0, a.loc)("mfa.sent", "login"),
            subtitle: c({
              subtitle: this.model.get("phoneNumber")
            }),
            warning: (0, a.loc)("factor.sms.time.warning", "login")
          };

        case "call":
          return {
            buttonDataSe: "make-call",
            buttonClassName: "call-request-button",
            formSubmit: (0, a.loc)("mfa.call", "login"),
            formRetry: (0, a.loc)("mfa.redial", "login"),
            formSubmitted: (0, a.loc)("mfa.calling", "login"),
            subtitle: c({
              subtitle: this.model.get("phoneNumber")
            }),
            warning: (0, a.loc)("factor.call.time.warning", "login")
          };

        case "email":
          return {
            buttonDataSe: "email-send-code",
            buttonClassName: "email-request-button",
            formSubmit: (0, a.loc)("mfa.sendEmail", "login"),
            formRetry: (0, a.loc)("mfa.resendEmail", "login"),
            formSubmitted: (0, a.loc)("mfa.sent", "login"),
            subtitle: c({
              subtitle: this.model.get("email")
            })
          };

        default:
          return {
            buttonDataSe: "",
            buttonClassName: "",
            formSubmit: "",
            formRetry: "",
            formSubmitted: ""
          };
      }
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = o(n(2)),
        a = n(1),
        s = o(n(16)),
        l = o(n(5)),
        u = o(n(13)),
        c = i.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return "(" + e.escapeExpression((i = null != (i = a(n, "subtitle") || (null != t ? a(t, "subtitle") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
          name: "subtitle",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 1
            },
            end: {
              line: 1,
              column: 13
            }
          }
        }) : i)) + ")";
      },
      useData: !0
    }),
        d = a.View.extend({
      className: "okta-form-infobox-warning infobox infobox-warning login-timeout-warning",
      attributes: {
        "aria-live": "polite"
      },
      template: i.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a,
              s = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<span class="icon warning-16"></span><p>' + (null != (a = null != (a = s(n, "warning") || (null != t ? s(t, "warning") : t)) ? a : e.hooks.helperMissing, i = "function" == typeof a ? a.call(null != t ? t : e.nullContext || {}, {
            name: "warning",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 40
              },
              end: {
                line: 1,
                column: 53
              }
            }
          }) : a) ? i : "") + "</p>";
        },
        useData: !0
      })
    }),
        f = a.Form.extend({
      className: "mfa-verify-passcode",
      autoSave: !0,
      noCancelButton: !0,
      save: a._.partial(a.loc, "mfa.challenge.verify", "login"),
      scrollOnError: !1,
      layout: "o-form-theme",
      disableSubmitButton: function disableSubmitButton() {
        return this.model.appState.get("isMfaChallenge") && this.model.get("answer");
      },
      showWarning: function showWarning(e) {
        this.clearWarnings(), this.add(d, ".o-form-error-container", {
          options: {
            warning: e
          }
        });
      },
      clearWarnings: function clearWarnings() {
        this.$(".okta-form-infobox-warning").remove();
      },
      initialize: function initialize() {
        var e = this;
        this.title = this.model.get("factorLabel");
        var t = this.model.get("factorType"),
            n = r.call(this, t),
            o = n.warning;
        this.$el.attr("data-se", "factor-" + t), this.subtitle = n.subtitle, this.listenTo(this.model, "error", function () {
          this.clearErrors();
        }), this.addInput({
          label: (0, a.loc)("mfa.challenge.enterCode.placeholder", "login"),
          "label-top": !0,
          className: "o-form-fieldset o-form-label-top auth-passcode",
          name: "answer",
          input: u.default,
          type: "tel"
        }), this.add((0, a.createButton)({
          attributes: {
            "data-se": n.buttonDataSe
          },
          className: "button " + n.buttonClassName,
          title: n.formSubmit,
          click: function click() {
            var r = this;
            e.clearErrors(), this.disable(), e.clearWarnings(), this.options.title = n.formSubmitted, this.render(), this.model.set("answer", ""), this.model.save().then(function () {
              return e.getInputs().first().render().focus(), s.default.delay(l.default.API_RATE_LIMIT);
            }).then(function () {
              r.options.title = n.formRetry, r.enable(), "call" !== t && "sms" !== t || e.showWarning(o), r.render();
            });
          }
        })), this.options.appState.get("allowRememberDevice") && this.addInput({
          label: !1,
          "label-top": !0,
          placeholder: this.options.appState.get("rememberDeviceLabel"),
          className: "margin-btm-0",
          name: "rememberDevice",
          type: "checkbox"
        });
      }
    });
    t.default = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = r.Form.extend({
      className: "mfa-verify-password",
      autoSave: !0,
      noCancelButton: !0,
      save: r._.partial(r.loc, "mfa.challenge.verify", "login"),
      scrollOnError: !1,
      layout: "o-form-theme",
      attributes: {
        "data-se": "factor-password"
      },
      initialize: function initialize() {
        this.title = this.model.get("factorLabel"), this.addInput({
          label: (0, r.loc)("mfa.challenge.password.placeholder", "login"),
          "label-top": !0,
          className: "auth-passcode",
          name: "password",
          type: "password",
          params: {
            showPasswordToggle: !0
          }
        }), this.options.appState.get("allowRememberDevice") && this.addInput({
          label: !1,
          "label-top": !0,
          placeholder: this.options.appState.get("rememberDeviceLabel"),
          className: "margin-btm-0",
          name: "rememberDevice",
          type: "checkbox"
        });
      }
    });
    t.default = o;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = r(n(12)),
        l = r(n(541)),
        u = i.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, i) {
        var a,
            s,
            l = null != t ? t : e.nullContext || {},
            u = e.hooks.helperMissing,
            c = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return e.escapeExpression((s = null != (s = c(n, "factorName") || (null != t ? c(t, "factorName") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
          name: "factorName",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 0
            },
            end: {
              line: 1,
              column: 14
            }
          }
        }) : s)) + " (" + (null != (s = null != (s = c(n, "deviceName") || (null != t ? c(t, "deviceName") : t)) ? s : u, a = "function" === (0, o.default)(s) ? s.call(l, {
          name: "deviceName",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 16
            },
            end: {
              line: 1,
              column: 32
            }
          }
        }) : s) ? a : "") + ")";
      },
      useData: !0
    }),
        c = a.View.extend({
      className: "okta-form-infobox-warning infobox infobox-warning",
      attributes: {
        "aria-live": "polite"
      },
      template: i.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<span class="icon warning-16"></span><p>' + e.escapeExpression((i = null != (i = a(n, "warning") || (null != t ? a(t, "warning") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "warning",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 40
              },
              end: {
                line: 1,
                column: 51
              }
            }
          }) : i)) + "</p>";
        },
        useData: !0
      })
    }),
        d = a.Form.extend({
      className: "mfa-verify-push",
      autoSave: !0,
      noCancelButton: !0,
      save: a._.partial(a.loc, "oktaverify.send", "login"),
      scrollOnError: !1,
      layout: "o-form-theme",
      attributes: {
        "data-se": "factor-push"
      },
      events: {
        submit: "submit"
      },
      initialize: function initialize() {
        this.enabled = !0, this.listenTo(this.options.appState, "change:isMfaRejected", this.handleRejectStateChange), this.numberChallengeView = this.add(l.default).last(), this.listenTo(this.options.appState, "change:isWaitingForNumberChallenge", function (e, t) {
          t || "SUCCESS" === this.options.appState.get("lastAuthResponse").status ? (this.clearWarnings(), this.$el.find(".button").hide(), this.numberChallengeView.$el.show()) : (this.numberChallengeView.$el.hide(), this.$el.find(".button").show());
        }), this.listenTo(this.options.appState, "change:isMfaTimeout", function (e, t) {
          this.setSubmitState(t), t && this.showError((0, a.loc)("oktaverify.timeout", "login"));
        }), this.listenTo(this.options.appState, "change:isMfaRequired", function (e, t) {
          t && (this.clearErrors(), this.clearWarnings());
        }), this.title = u({
          factorName: this.model.get("factorLabel"),
          deviceName: this.model.get("deviceName")
        });
      },
      setSubmitState: function setSubmitState(e) {
        var t = this.$el.find(".button"),
            n = this.$el.find(".accessibility-text");
        this.enabled = e, e ? (t.removeClass("link-button-disabled"), t.prop("value", (0, a.loc)("oktaverify.send", "login")), t.prop("disabled", !1), n && n.remove()) : (t.addClass("link-button-disabled"), t.prop("value", (0, a.loc)("oktaverify.sent", "login")), t.prop("disabled", !0), this.add("<span class='accessibility-text' role='alert'>".concat((0, a.loc)("oktaverify.sent", "login"), "</span>")));
      },
      submit: function submit(e) {
        void 0 !== e && e.preventDefault(), this.enabled && (this.setSubmitState(!1), this.doSave());
      },
      postRender: function postRender() {
        var e = this.options.appState.get("factorsPolicyInfo"),
            t = this.model.get("id");
        !!(this.settings.get("features.autoPush") && e && e[t]) && e[t].autoPushEnabled && (this.model.set("autoPush", !0), a._.defer(a._.bind(this.submit, this)));
      },
      doSave: function doSave() {
        var e,
            t = this;
        this.clearErrors(), this.clearWarnings(), this.model.isValid() && (this.listenToOnce(this.model, "error", function () {
          this.setSubmitState(!0), this.clearWarnings(), clearTimeout(e);
        }), this.trigger("save", this.model), e = s.default.callAfterTimeout(function () {
          t.options.appState.get("isWaitingForNumberChallenge") || t.showWarning((0, a.loc)("oktaverify.warning", "login"));
        }, 3e4));
      },
      showError: function showError(e) {
        this.clearWarnings(), this.model.trigger("error", this.model, {
          responseJSON: {
            errorSummary: e
          }
        });
      },
      showWarning: function showWarning(e) {
        this.clearWarnings(), this.add(c, ".o-form-error-container", {
          options: {
            warning: e
          }
        });
      },
      clearWarnings: function clearWarnings() {
        this.$(".okta-form-infobox-warning").remove();
      },
      handleRejectStateChange: function handleRejectStateChange(e, t) {
        t && (this.setSubmitState(t), this.setRejectedErrorMessage());
      },
      setRejectedErrorMessage: function setRejectedErrorMessage() {
        "OKTA_VERIFY_UPGRADE_REQUIRED" === this.options.appState.get("lastAuthResponse").factorResultMessage ? "IOS" === this.options.appState.get("factor").profile.platform ? this.showError((0, a.loc)("oktaverify.rejected.upgradeRequired.ios", "login")) : this.showError((0, a.loc)("oktaverify.rejected.upgradeRequired.android", "login")) : this.showError((0, a.loc)("oktaverify.rejected", "login"));
      }
    });
    t.default = d;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      className: "number-challenge-view",
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<p data-se="number-challenge-instruction">' + (null != (i = (c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
            name: "i18n",
            hash: {
              arguments: "number",
              bundle: "login",
              code: "oktaverify.numberchallenge.instruction"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 42
              },
              end: {
                line: 1,
                column: 132
              }
            }
          })) ? i : "") + '</p><div class="phone"><div class="phone--body"><div class="phone--screen"><span class="phone--number" data-se="challenge-number">' + u((a = null != (a = c(n, "number") || (null != t ? c(t, "number") : t)) ? a : l, "function" == typeof a ? a.call(s, {
            name: "number",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 262
              },
              end: {
                line: 1,
                column: 272
              }
            }
          }) : a)) + '</span></div><div class="phone--home-button"></div></div></div><p>' + u((c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oktaverify.numberchallenge.explain"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 338
              },
              end: {
                line: 1,
                column: 403
              }
            }
          })) + "</p>";
        },
        useData: !0
      }),
      initialize: function initialize() {
        var e = this;
        this.listenTo(this.options.appState, "change:isWaitingForNumberChallenge", function () {
          "SUCCESS" !== e.options.appState.get("lastAuthResponse").status && e.render();
        });
      },
      getTemplateData: function getTemplateData() {
        var e = this.options.appState.get("lastAuthResponse");
        return this.options.appState.get("isWaitingForNumberChallenge") ? {
          number: e._embedded.factor._embedded.challenge.correctAnswer
        } : {
          number: null
        };
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = r.Form.extend({
      className: "mfa-verify-question",
      autoSave: !0,
      noCancelButton: !0,
      save: r._.partial(r.loc, "mfa.challenge.verify", "login"),
      scrollOnError: !1,
      layout: "o-form-theme",
      attributes: {
        "data-se": "factor-question"
      },
      initialize: function initialize() {
        this.title = this.model.get("factorLabel"), this.addInput({
          label: this.model.get("securityQuestion"),
          "label-top": !0,
          placeholder: (0, r.loc)("mfa.challenge.answer.placeholder", "login"),
          className: "auth-passcode",
          name: "answer",
          type: "password",
          params: {
            showPasswordToggle: !0
          }
        }), this.options.appState.get("allowRememberDevice") && this.addInput({
          label: !1,
          "label-top": !0,
          placeholder: this.options.appState.get("rememberDeviceLabel"),
          className: "margin-btm-0",
          name: "rememberDevice",
          type: "checkbox"
        });
      }
    });
    t.default = o;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = r(n(2)),
        i = n(1),
        a = r(n(261)),
        s = r(n(13)),
        l = function l() {
      var e = this.model.get("email");
      return {
        factorEmail: o.default.template({
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, o) {
            var i,
                a = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<span class="mask-email">' + e.escapeExpression((i = null != (i = a(n, "email") || (null != t ? a(t, "email") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
              name: "email",
              hash: {},
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 25
                },
                end: {
                  line: 1,
                  column: 34
                }
              }
            }) : i)) + "</span>";
          },
          useData: !0
        })({
          email: e
        })
      };
    },
        u = i.Form.extend({
      layout: "o-form-theme",
      className: "mfa-verify-email",
      title: i._.partial(i.loc, "email.mfa.title", "login"),
      noButtonBar: !1,
      autoSave: !0,
      noCancelButton: !0,
      attributes: {
        "data-se": "factor-email"
      },
      save: function save() {
        return this.options.appState.get("isMfaChallenge") ? (0, i.loc)("mfa.challenge.verify", "login") : (0, i.loc)("email.button.send", "login");
      },
      events: Object.assign({}, i.Form.prototype.events, {
        submit: function submit(e) {
          e.preventDefault(), this.handleSubmit();
        }
      }),
      handleSubmit: function handleSubmit() {
        this.clearErrors(), this.options.appState.get("isMfaChallenge") ? this.isValid() && this.model.save() : (this.model.set("answer", ""), this.model.save().then(this.renderChallengView.bind(this)));
      },
      initialize: function initialize() {
        i.Form.prototype.initialize.apply(this, arguments), this.add(i.View.extend({
          attributes: {
            "data-se": "mfa-send-email-content"
          },
          className: "mfa-send-email-content",
          template: o.default.template({
            compiler: [8, ">= 4.3.0"],
            main: function main(e, t, n, r, o) {
              var i,
                  a = e.lookupProperty || function (e, t) {
                if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
              };

              return null != (i = (a(n, "i18n") || t && a(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                name: "i18n",
                hash: {
                  arguments: "factorEmail",
                  bundle: "login",
                  code: "email.mfa.description"
                },
                data: o,
                loc: {
                  start: {
                    line: 1,
                    column: 0
                  },
                  end: {
                    line: 1,
                    column: 78
                  }
                }
              })) ? i : "";
            },
            useData: !0
          }),
          getTemplateData: l
        }));
      },
      renderChallengView: function renderChallengView() {
        this.removeChildren(), this.add(i.View.extend({
          className: "mfa-email-sent-content",
          attributes: {
            "data-se": "mfa-email-sent-content"
          },
          template: o.default.template({
            compiler: [8, ">= 4.3.0"],
            main: function main(e, t, n, r, o) {
              var i,
                  a = e.lookupProperty || function (e, t) {
                if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
              };

              return null != (i = (a(n, "i18n") || t && a(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                name: "i18n",
                hash: {
                  arguments: "factorEmail",
                  bundle: "login",
                  code: "email.mfa.email.sent.description"
                },
                data: o,
                loc: {
                  start: {
                    line: 1,
                    column: 0
                  },
                  end: {
                    line: 1,
                    column: 89
                  }
                }
              })) ? i : "";
            },
            useData: !0
          }),
          getTemplateData: l
        })), this.add(a.default), this.addInput({
          label: (0, i.loc)("email.code.label", "login"),
          "label-top": !0,
          name: "answer",
          input: s.default,
          wide: !0,
          type: "tel"
        }), this.options.appState.get("allowRememberDevice") && this.addInput({
          label: !1,
          "label-top": !0,
          placeholder: this.options.appState.get("rememberDeviceLabel"),
          className: "margin-btm-0",
          name: "rememberDevice",
          type: "checkbox"
        }), this.render();
      }
    }),
        c = u;

    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(13)),
        a = o.Form.extend({
      className: "mfa-verify-totp",
      autoSave: !0,
      noCancelButton: !0,
      save: o._.partial(o.loc, "mfa.challenge.verify", "login"),
      scrollOnError: !1,
      layout: "o-form-theme",
      attributes: {
        "data-se": "factor-totp"
      },
      initialize: function initialize() {
        var e = this,
            t = this.model.get("factorLabel"),
            n = "RSA" === this.model.get("provider") || "DEL_OATH" === this.model.get("provider");
        this.title = t, this.model.get("isFactorTypeVerification") ? this.subtitle = (0, o.loc)("mfa.challenge.totp.subtitle.multiple", "login", [t]) : this.subtitle = (0, o.loc)("mfa.challenge.title", "login", [t]), this.addInput({
          label: (0, o.loc)("mfa.challenge.enterCode.placeholder", "login"),
          "label-top": !0,
          className: "o-form-fieldset o-form-label-top auth-passcode",
          name: "answer",
          input: i.default,
          type: n ? "password" : "tel"
        }), this.options.appState.get("allowRememberDevice") && this.addInput({
          label: !1,
          "label-top": !0,
          placeholder: this.options.appState.get("rememberDeviceLabel"),
          className: "margin-btm-0",
          name: "rememberDevice",
          type: "checkbox"
        }), "RSA" !== this.model.get("provider") && "DEL_OATH" !== this.model.get("provider") || this.listenTo(this.model, "error", function (t, n) {
          n && 409 === n.status && (e.$(".auth-passcode input").val(""), e.$(".auth-passcode input").trigger("change"), e.$(".auth-passcode input").focus());
        });
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(13)),
        a = o.Form.extend({
      className: "mfa-verify-yubikey",
      autoSave: !0,
      noCancelButton: !0,
      save: o._.partial(o.loc, "mfa.challenge.verify", "login"),
      scrollOnError: !1,
      layout: "o-form-theme",
      attributes: {
        "data-se": "factor-yubikey"
      },
      initialize: function initialize() {
        var e = this.model.get("factorLabel");
        this.title = e, this.subtitle = (0, o.loc)("factor.totpHard.yubikey.description", "login"), this.addInput({
          label: (0, o.loc)("factor.totpHard.yubikey.placeholder", "login"),
          "label-top": !0,
          className: "o-form-fieldset o-form-label-top auth-passcode",
          name: "answer",
          input: i.default,
          inputId: "mfa-answer",
          type: "password"
        }), this.options.appState.get("allowRememberDevice") && this.addInput({
          label: !1,
          "label-top": !0,
          className: "margin-btm-0",
          placeholder: this.options.appState.get("rememberDeviceLabel"),
          name: "rememberDevice",
          type: "checkbox"
        });
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(15)),
        a = r(n(4)),
        s = r(n(6)),
        l = r(n(12)),
        u = r(n(94)),
        c = r(n(259)),
        d = r(n(274)),
        f = r(n(13)),
        p = a.default.extend({
      className: "password-expired",
      Model: {
        props: {
          oldPassword: ["string", !0],
          newPassword: ["string", !0],
          confirmPassword: ["string", !0]
        },
        validate: function validate() {
          return u.default.validatePasswordMatch(this);
        },
        save: function save() {
          return this.trigger("save"), this.doTransaction(function (e) {
            return e.changePassword({
              oldPassword: this.get("oldPassword"),
              newPassword: this.get("newPassword")
            });
          });
        }
      },
      Form: {
        save: o._.partial(o.loc, "password.expired.submit", "login"),
        title: function title() {
          var e = this.options.appState.get("isPwdExpiringSoon"),
              t = this.options.appState.get("passwordExpireDays");
          return e && t > 0 ? (0, o.loc)("password.expiring.title", "login", [t]) : e && 0 === t ? (0, o.loc)("password.expiring.today", "login") : e ? (0, o.loc)("password.expiring.soon", "login") : this.settings.get("brandName") ? (0, o.loc)("password.expired.title.specific", "login", [this.settings.get("brandName")]) : (0, o.loc)("password.expired.title.generic", "login");
        },
        subtitle: function subtitle() {
          if (this.options.appState.get("isPwdExpiringSoon")) return this.settings.get("brandName") ? (0, o.loc)("password.expiring.subtitle.specific", "login", [this.settings.get("brandName")]) : (0, o.loc)("password.expiring.subtitle.generic", "login");
          var e = this.options.appState.get("policy");
          if (e && !this.settings.get("features.showPasswordRequirementsAsHtmlList")) return i.default.getPasswordComplexityDescription(e);
        },
        parseErrorMessage: function parseErrorMessage(e) {
          var t = this.options.appState.get("policy");
          return t && this.settings.get("features.showPasswordRequirementsAsHtmlList") && (e = i.default.removeRequirementsFromError(e, t)), e;
        },
        formChildren: function formChildren() {
          var e = [];
          return this.settings.get("features.showPasswordRequirementsAsHtmlList") && e.push(s.default.View({
            View: new d.default({
              policy: this.options.appState.get("policy")
            })
          })), e = e.concat([s.default.Input({
            "label-top": !0,
            label: (0, o.loc)("password.oldPassword.placeholder", "login"),
            explain: l.default.createInputExplain("password.oldPassword.tooltip", "password.oldPassword.placeholder", "login"),
            "explain-top": !0,
            name: "oldPassword",
            input: f.default,
            type: "password"
          }), s.default.Divider(), s.default.Input({
            className: "margin-btm-5",
            "label-top": !0,
            label: (0, o.loc)("password.newPassword.placeholder", "login"),
            explain: l.default.createInputExplain("password.newPassword.tooltip", "password.newPassword.placeholder", "login"),
            "explain-top": !0,
            name: "newPassword",
            input: f.default,
            type: "password"
          }), s.default.Input({
            "label-top": !0,
            label: (0, o.loc)("password.confirmPassword.placeholder", "login"),
            explain: l.default.createInputExplain("password.confirmPassword.tooltip", "password.confirmPassword.placeholder", "login"),
            "explain-top": !0,
            name: "confirmPassword",
            input: f.default,
            type: "password"
          })]);
        }
      },
      Footer: c.default,
      initialize: function initialize() {
        this.listenTo(this.form, "save", function () {
          var e = {
            username: this.options.appState.get("userEmail"),
            password: this.model.get("newPassword")
          };
          this.settings.processCreds(e).then(o._.bind(this.model.save, this.model));
        });
      }
    });
    t.default = p;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(15)),
        a = r(n(4)),
        s = r(n(6)),
        l = r(n(12)),
        u = r(n(94)),
        c = r(n(117)),
        d = r(n(274)),
        f = r(n(13)),
        p = a.default.extend({
      className: "password-reset",
      Model: {
        props: {
          newPassword: ["string", !0],
          confirmPassword: ["string", !0]
        },
        validate: function validate() {
          return u.default.validatePasswordMatch(this);
        },
        save: function save() {
          this.trigger("save");
          var e = this;
          return this.doTransaction(function (t) {
            return t.resetPassword({
              newPassword: e.get("newPassword")
            });
          });
        }
      },
      Form: {
        save: o._.partial(o.loc, "password.reset", "login"),
        title: function title() {
          return this.settings.get("brandName") ? (0, o.loc)("password.reset.title.specific", "login", [this.settings.get("brandName")]) : (0, o.loc)("password.reset.title.generic", "login");
        },
        subtitle: function subtitle() {
          var e = this.options.appState.get("policy");
          if (e && !this.settings.get("features.showPasswordRequirementsAsHtmlList")) return i.default.getPasswordComplexityDescription(e);
        },
        parseErrorMessage: function parseErrorMessage(e) {
          var t = this.options.appState.get("policy");
          return t && this.settings.get("features.showPasswordRequirementsAsHtmlList") && (e = i.default.removeRequirementsFromError(e, t)), e;
        },
        formChildren: function formChildren() {
          var e = [];
          return this.settings.get("features.showPasswordRequirementsAsHtmlList") && e.push(s.default.View({
            View: new d.default({
              policy: this.options.appState.get("policy")
            })
          })), e = e.concat([s.default.Input({
            className: "margin-btm-5",
            label: (0, o.loc)("password.newPassword.placeholder", "login"),
            "label-top": !0,
            explain: l.default.createInputExplain("password.newPassword.tooltip", "password.newPassword.placeholder", "login"),
            "explain-top": !0,
            name: "newPassword",
            input: f.default,
            type: "password",
            autoComplete: "new-password"
          }), s.default.Input({
            label: (0, o.loc)("password.confirmPassword.placeholder", "login"),
            "label-top": !0,
            explain: l.default.createInputExplain("password.confirmPassword.tooltip", "password.confirmPassword.placeholder", "login"),
            "explain-top": !0,
            name: "confirmPassword",
            input: f.default,
            type: "password",
            autoComplete: "new-password"
          })]);
        }
      },
      initialize: function initialize() {
        this.listenTo(this.form, "save", function () {
          var e = {
            username: this.options.appState.get("userEmail"),
            password: this.model.get("newPassword")
          };
          this.settings.processCreds(e).then(o._.bind(this.model.save, this.model));
        }), this.settings.get("features.hideBackToSignInForReset") || this.addFooter(c.default);
      }
    });
    t.default = p;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(4)),
        a = r(n(6)),
        s = i.default.extend({
      className: "poll",
      Model: {
        save: function save() {
          var e = this;
          return this.trigger("cancelRequest"), this.appState.get("transaction").cancel().then(function () {
            e.options.appState.trigger("navigate", "");
          }).catch(function () {
            e._stopCountDown();
          });
        }
      },
      Form: {
        autoSave: !0,
        hasSavingState: !1,
        title: function title() {
          return this.title;
        },
        className: "poll-controller",
        noCancelButton: !0,
        save: (0, o.loc)("oform.cancel", "login"),
        modelEvents: {
          cancelRequest: "_stopCountDown"
        },
        formChildren: [a.default.View({
          View: '<div >               <div data-se="poll-waiting" class="hide okta-waiting-spinner"></div>             </div>'
        })],
        _checkStatus: function _checkStatus() {
          var e = this;
          this.transactionObject.poll().then(function (t) {
            if (t.data && "POLL" !== t.status) return void e.options.appState.set("transaction", t);
            e.$(".okta-waiting-spinner").hide();
            var n = Math.ceil(t.transaction.profile.refresh / 1e3);

            e._startCountDown(n);
          }).catch(function () {
            e._stopCountDown();
          });
        },
        _startCountDown: function _startCountDown(e) {
          var t = this;
          this.countDown = setInterval(function () {
            t._updateTitle(e), 0 === e ? (t._stopCountDown(), t.$(".okta-waiting-spinner").show(), t.checkStatusTimeout = setTimeout(function () {
              t._checkStatus();
            }, 200)) : e -= 1;
          }, 1e3);
        },
        _updateTitle: function _updateTitle(e) {
          this.title = (0, o.loc)("polling.title", "login", [e]), this.$el.find(".okta-form-title").text(this.title);
        },
        _stopCountDown: function _stopCountDown() {
          this.countDown && clearInterval(this.countDown), this.checkStatusTimeout && clearInterval(this.checkStatusTimeout);
        },
        initialize: function initialize(e) {
          this.transactionObject = e.appState.get("transaction"), this.factorPollingIntervalSeconds = Math.ceil(this.transactionObject.transaction.profile.refresh / 1e3), this._updateTitle(this.factorPollingIntervalSeconds), this._startCountDown(this.factorPollingIntervalSeconds);
        }
      },
      back: function back() {},
      remove: function remove() {
        this.form._stopCountDown();
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(5)),
        s = r(n(4)),
        l = r(n(6)),
        u = s.default.extend({
      className: "password-reset-email-sent",
      Model: function Model() {
        return {
          local: {
            userFullName: ["string", !1, this.options.appState.get("userFullName")]
          }
        };
      },
      Form: {
        title: i._.partial(i.loc, "password.forgot.emailSent.title", "login"),
        subtitle: function subtitle() {
          var e = this.options.appState.get("username");
          return (0, i.loc)("password.forgot.emailSent.desc", "login", [e]);
        },
        noButtonBar: !0,
        attributes: {
          "data-se": "pwd-reset-email-sent"
        },
        formChildren: function formChildren() {
          var e = [l.default.View({
            View: i.View.extend({
              template: o.default.template({
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, o) {
                  var i,
                      a = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<span class="accessibility-text" role="status">' + e.escapeExpression((i = null != (i = a(n, "alert") || (null != t ? a(t, "alert") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
                    name: "alert",
                    hash: {},
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 47
                      },
                      end: {
                        line: 1,
                        column: 56
                      }
                    }
                  }) : i)) + "</span>";
                },
                useData: !0
              }),
              getTemplateData: function getTemplateData() {
                return {
                  alert: (0, i.loc)("password.forgot.emailSent.title", "login")
                };
              }
            })
          })];
          return this.settings.get("features.hideBackToSignInForReset") || e.push(l.default.Button({
            title: (0, i.loc)("goback", "login"),
            className: "button button-primary button-wide",
            attributes: {
              "data-se": "back-button"
            },
            click: function click() {
              var e = this;
              return this.model.doTransaction(function (e) {
                return e.cancel();
              }).then(function () {
                e.state.set("navigateDir", a.default.DIRECTION_BACK), e.options.appState.trigger("navigate", "");
              });
            }
          })), e;
        }
      },
      initialize: function initialize(e) {
        this.settings.callGlobalSuccess(a.default.FORGOT_PASSWORD_EMAIL_SENT, {
          username: e.appState.get("username")
        });
      }
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(5)),
        s = r(n(4)),
        l = r(n(6)),
        u = r(n(117)),
        c = r(n(13)),
        d = s.default.extend({
      className: "recovery-challenge",
      Model: {
        props: {
          passCode: ["string", !0]
        },
        local: {
          ableToResend: "boolean"
        },
        resendCode: function resendCode() {
          return this.limitResending(), this.doTransaction(function (e) {
            return e.resend();
          });
        },
        limitResending: function limitResending() {
          this.set({
            ableToResend: !1
          }), i._.delay(i._.bind(this.set, this), a.default.API_RATE_LIMIT, {
            ableToResend: !0
          });
        },
        save: function save() {
          return this.doTransaction(function (e) {
            return e.verify({
              passCode: this.get("passCode")
            });
          });
        }
      },
      Form: {
        autoSave: !0,
        save: i._.partial(i.loc, "mfa.challenge.verify", "login"),
        title: function title() {
          return this.options.appState.get("factorType") === a.default.RECOVERY_FACTOR_TYPE_CALL ? (0, i.loc)("recoveryChallenge.call.title", "login") : (0, i.loc)("recoveryChallenge.sms.title", "login");
        },
        className: "recovery-challenge",
        initialize: function initialize() {
          this.listenTo(this.model, "error", function () {
            this.clearErrors();
          });
        },
        formChildren: function formChildren() {
          return [l.default.Button({
            title: (0, i.loc)("mfa.resendCode", "login"),
            attributes: {
              "data-se": "resend-button"
            },
            className: "button sms-request-button margin-top-30",
            click: function click() {
              this.model.resendCode();
            },
            initialize: function initialize() {
              this.listenTo(this.model, "change:ableToResend", function (e, t) {
                t ? (this.options.title = (0, i.loc)("mfa.resendCode", "login"), this.enable(), this.render()) : (this.options.title = (0, i.loc)("mfa.sent", "login"), this.disable(), this.render());
              });
            }
          }), l.default.Input({
            label: (0, i.loc)("mfa.challenge.enterCode.placeholder", "login"),
            "label-top": !0,
            className: "enroll-sms-phone",
            name: "passCode",
            input: c.default,
            type: "text"
          })];
        }
      },
      events: {
        "click .send-email-link": function clickSendEmailLink(e) {
          e.preventDefault();
          var t = this.model.settings,
              n = this.options.appState.get("username"),
              r = this.options.appState.get("recoveryType");
          this.model.startTransaction(function (e) {
            switch (r) {
              case a.default.RECOVERY_TYPE_PASSWORD:
                return e.forgotPassword({
                  username: t.transformUsername(n, a.default.FORGOT_PASSWORD),
                  factorType: a.default.RECOVERY_FACTOR_TYPE_EMAIL
                });

              case a.default.RECOVERY_TYPE_UNLOCK:
                return e.unlockAccount({
                  username: t.transformUsername(n, a.default.UNLOCK_ACCOUNT),
                  factorType: a.default.RECOVERY_FACTOR_TYPE_EMAIL
                });

              default:
                return;
            }
          });
        }
      },
      initialize: function initialize() {
        var e,
            t = this.options.appState.get("recoveryType");

        switch (t) {
          case a.default.RECOVERY_TYPE_PASSWORD:
            e = o.default.template({
              compiler: [8, ">= 4.3.0"],
              main: function main(e, t, n, r, o) {
                var i = e.lookupProperty || function (e, t) {
                  if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                };

                return e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                  name: "i18n",
                  hash: {
                    bundle: "login",
                    code: "password.forgot.code.notReceived"
                  },
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 0
                    },
                    end: {
                      line: 1,
                      column: 63
                    }
                  }
                }));
              },
              useData: !0
            });
            break;

          case a.default.RECOVERY_TYPE_UNLOCK:
            e = o.default.template({
              compiler: [8, ">= 4.3.0"],
              main: function main(e, t, n, r, o) {
                var i = e.lookupProperty || function (e, t) {
                  if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                };

                return e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                  name: "i18n",
                  hash: {
                    bundle: "login",
                    code: "account.unlock.code.notReceived"
                  },
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 0
                    },
                    end: {
                      line: 1,
                      column: 62
                    }
                  }
                }));
              },
              useData: !0
            });
        }

        e && this.settings.get("features.emailRecovery") && this.add(i.View.extend({
          className: "link send-email-link",
          tagName: "a",
          attributes: {
            href: "#",
            "data-se": "send-email-link"
          },
          template: e
        })), this.settings.get("features.hideBackToSignInForReset") || this.add(new u.default(i._.extend(this.toJSON(), {
          linkText: (0, i.loc)("goback", "login"),
          linkClassName: ""
        })));
      },
      postRender: function postRender() {
        this.model.limitResending();
      }
    });
    t.default = d;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(4)),
        i = o.default.extend({
      className: "recovery-loading",
      Model: {},
      Form: {
        noButtonBar: !0
      },
      initialize: function initialize(e) {
        var t = this;
        return this.model.startTransaction(function (t) {
          return t.verifyRecoveryToken({
            recoveryToken: e.token
          });
        }).catch(function () {
          t.options.appState.trigger("loading", !1), t.options.appState.trigger("removeLoading");
        });
      },
      preRender: function preRender() {
        this.options.appState.trigger("loading", !0);
      },
      trapAuthResponse: function trapAuthResponse() {
        return this.options.appState.trigger("loading", !1), !1;
      }
    });
    t.default = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(4)),
        a = r(n(6)),
        s = r(n(117)),
        l = r(n(13)),
        u = i.default.extend({
      className: "recovery-question",
      Model: {
        props: {
          answer: ["string", !0],
          showAnswer: "boolean"
        },
        save: function save() {
          return this.doTransaction(function (e) {
            return e.answer({
              answer: this.get("answer")
            });
          });
        }
      },
      Form: {
        autoSave: !0,
        save: function save() {
          switch (this.options.appState.get("recoveryType")) {
            case "PASSWORD":
              return (0, o.loc)("password.forgot.question.submit", "login");

            case "UNLOCK":
              return (0, o.loc)("account.unlock.question.submit", "login");

            default:
              return (0, o.loc)("mfa.challenge.verify", "login");
          }
        },
        title: function title() {
          switch (this.options.appState.get("recoveryType")) {
            case "PASSWORD":
              return (0, o.loc)("password.forgot.question.title", "login");

            case "UNLOCK":
              return (0, o.loc)("account.unlock.question.title", "login");

            default:
              return "";
          }
        },
        formChildren: function formChildren() {
          return [a.default.Input({
            label: this.options.appState.get("recoveryQuestion"),
            placeholder: (0, o.loc)("mfa.challenge.answer.placeholder", "login"),
            name: "answer",
            input: l.default,
            type: "password",
            initialize: function initialize() {
              this.listenTo(this.model, "change:showAnswer", function () {
                var e = this.model.get("showAnswer") ? "text" : "password";
                this.getInputs()[0].changeType(e);
              });
            }
          }), a.default.Input({
            label: !1,
            "label-top": !0,
            placeholder: (0, o.loc)("mfa.challenge.answer.showAnswer", "login"),
            className: "recovery-question-show margin-btm-0",
            name: "showAnswer",
            type: "checkbox"
          })];
        }
      },
      initialize: function initialize() {
        this.settings.get("features.hideBackToSignInForReset") || this.addFooter(s.default, {
          linkText: (0, o.loc)("goback", "login"),
          linkClassName: ""
        });
      }
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(4)),
        i = o.default.extend({
      className: "refresh-auth-state",
      Model: {},
      Form: {
        noButtonBar: !0
      },
      preRender: function preRender() {
        var e = this.options.appState,
            t = this.options.token;
        this.model.startTransaction(function (n) {
          return e.trigger("loading", !0), t ? n.tx.introspect({
            stateToken: t
          }) : n.tx.exists() ? n.tx.resume() : void e.trigger("navigate", "");
        });
      },
      remove: function remove() {
        return this.options.appState.trigger("loading", !1), o.default.prototype.remove.apply(this, arguments);
      }
    });
    t.default = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = r(n(5)),
        l = r(n(4)),
        u = r(n(6)),
        c = l.default.extend({
      events: {
        "click .back-btn": function clickBackBtn(e) {
          e.preventDefault(), this.back();
        }
      },
      back: function back() {
        this.state.set("navigateDir", s.default.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
      },
      className: "registration-complete",
      Model: function Model() {},
      initialize: function initialize() {
        this.settings.callGlobalSuccess(s.default.ACTIVATION_EMAIL_SENT, {
          username: this.options.appState.get("username")
        });
      },
      Form: {
        noButtonBar: !0,
        formChildren: function formChildren() {
          return [u.default.View({
            View: a.View.extend({
              template: i.default.template({
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, i) {
                  var a,
                      s = null != t ? t : e.nullContext || {},
                      l = e.hooks.helperMissing,
                      u = e.escapeExpression,
                      c = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<div class="container"><span class="title-icon icon icon-16 confirm-16-green"></span><h2 class="title">' + u((a = null != (a = c(n, "title") || (null != t ? c(t, "title") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
                    name: "title",
                    hash: {},
                    data: i,
                    loc: {
                      start: {
                        line: 1,
                        column: 103
                      },
                      end: {
                        line: 1,
                        column: 112
                      }
                    }
                  }) : a)) + '</h2><div class="desc">' + u((a = null != (a = c(n, "desc") || (null != t ? c(t, "desc") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
                    name: "desc",
                    hash: {},
                    data: i,
                    loc: {
                      start: {
                        line: 1,
                        column: 135
                      },
                      end: {
                        line: 1,
                        column: 143
                      }
                    }
                  }) : a)) + '</div></div><a href="#" class="back-btn" data-se="back-link">' + u((c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
                    name: "i18n",
                    hash: {
                      bundle: "login",
                      code: "goback"
                    },
                    data: i,
                    loc: {
                      start: {
                        line: 1,
                        column: 204
                      },
                      end: {
                        line: 1,
                        column: 241
                      }
                    }
                  })) + "</a>";
                },
                useData: !0
              }),
              getTemplateData: function getTemplateData() {
                return {
                  desc: (0, a.loc)("registration.complete.confirm.text", "login"),
                  title: (0, a.loc)("registration.complete.title", "login")
                };
              }
            })
          })];
        }
      }
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(556)),
        s = r(n(557)),
        l = r(n(16)),
        u = r(n(73)),
        c = r(n(5)),
        d = r(n(24)),
        f = r(n(265)),
        p = r(n(12)),
        h = r(n(558)),
        m = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link help" data-se="back-link">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "goback"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 50
              },
              end: {
                line: 1,
                column: 87
              }
            }
          })) + "</a>";
        },
        useData: !0
      }),
      className: "auth-footer",
      events: {
        "click .help": function clickHelp(e) {
          e.preventDefault(), this.back();
        }
      },
      back: function back() {
        this.state.set("navigateDir", c.default.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
      }
    }),
        g = u.default.extend({
      className: "registration",
      initialize: function initialize() {
        var e = s.default.extend({
          settings: this.options.settings,
          url: this.options.settings.get("baseUrl") + "/api/v1/registration/form"
        }),
            t = new e();
        this.state.set("schema", t);
      },
      getRegistrationApiUrl: function getRegistrationApiUrl() {
        var e = this.settings.get("defaultPolicyId"),
            t = this.options.settings.get("policyId");
        return e ? this.getRegistrationPolicyApi(e) : this.getRegistrationPolicyApi(t);
      },
      getRegistrationPolicyApi: function getRegistrationPolicyApi(e) {
        return this.options.settings.get("baseUrl") + "/api/v1/registration/" + e;
      },
      doPostSubmit: function doPostSubmit() {
        if (this.model.get("activationToken")) {
          var e = this;
          e.settings.callGlobalSuccess(c.default.REGISTRATION_COMPLETE, {
            activationToken: this.model.get("activationToken")
          });
          new a.default({
            settings: e.model.appState.settings
          }).loginWithActivationToken(this.model.get("activationToken")).then(function (t) {
            e.model.trigger("setTransaction", t);
          });
        } else this.model.appState.set("username", this.model.get("email")), this.model.appState.trigger("navigate", "signin/register-complete");
      },
      registerUser: function registerUser(e) {
        var t = this;
        this.model.attributes = e, i.Backbone.Model.prototype.save.call(this.model).then(function () {
          var e = t.model.get("activationToken"),
              n = e || t.model.get("email");
          t.settings.postRegistrationSubmit(n, function () {
            t.doPostSubmit();
          }, function (e) {
            t.showErrors(e);
          });
        }).fail(function (e) {
          var n = e.responseJSON;

          if (n && n.errorCauses.length) {
            var r = n.errorCauses[0].errorSummary;
            p.default.triggerAfterError(t, new d.default.RegistrationError(r));
          }
        });
      },
      createRegistrationModel: function createRegistrationModel(e) {
        var t = this;
        return new (i.Model.extend({
          url: t.getRegistrationApiUrl() + "/register",
          settings: this.settings,
          appState: this.options.appState,
          props: e,
          local: {
            activationToken: "string"
          },
          toJSON: function toJSON() {
            return {
              userProfile: i.Model.prototype.toJSON.apply(this, arguments),
              relayState: this.settings.get("relayState")
            };
          },
          parse: function parse(e) {
            return this.set("activationToken", e.activationToken), delete e.activationToken, e;
          },
          save: function save() {
            this.settings.preRegistrationSubmit(this.attributes, function (e) {
              t.registerUser(e);
            }, function (e) {
              t.showErrors(e);
            });
          }
        }))();
      },
      showErrors: function showErrors(e, t) {
        "parseRegistrationSchema" === e.callback && e.errorCauses && (e.errorSummary = i._.clone(e.errorCauses[0].errorSummary), delete e.errorCauses), this.model.trigger("error", this.model, {
          responseJSON: e
        });
        var n = e.callback ? e.callback + ":" + e.errorSummary : e.errorSummary;
        p.default.triggerAfterError(this, new d.default.RegistrationError(n)), t && this.$el.find(".button-primary").hide();
      },
      fetchInitialData: function fetchInitialData() {
        var e = this;
        return e.state.get("schema").on("parseComplete", function (t) {
          var n = t.properties.createModelProperties();
          e.settings.set("defaultPolicyId", t.properties.defaultPolicyId), e.model = e.createRegistrationModel(n);
          var r = i.Form.extend({
            layout: "o-form-theme",
            autoSave: !0,
            noCancelButton: !0,
            title: (0, i.loc)("registration.form.title", "login"),
            save: (0, i.loc)("registration.form.submit", "login"),
            modelEvents: {
              invalid: "modifyErrors"
            },
            modifyErrors: function modifyErrors(e, t) {
              for (var n in t) {
                "model.validation.field.string.minLength" === t[n] ? t[n] = (0, i.loc)("registration.model.validation.field.string.too.short", "login", [e.props[n].minLength]) : "model.validation.field.string.maxLength" === t[n] && (t[n] = (0, i.loc)("registration.model.validation.field.string.too.long", "login", [e.props[n].maxLength + 1]));
              }
            },
            parseErrorMessage: function parseErrorMessage(e) {
              e.errorCauses && e.errorCauses.length && "E0000001" === e.errorCode && "UNIQUE_CONSTRAINT" === e.errorCauses[0].reason && (e.errorCauses[0].errorSummary = (0, i.loc)("registration.error.userName.notUniqueWithinOrg", "login"));
              return e;
            }
          }),
              a = new r(e.toJSON());
          if (e.add(a), e.footer = new e.Footer(e.toJSON()), e.add(e.footer), e.addListeners(), t.error) e.showErrors(t.error, !0);else {
            t.properties.each(function (e) {
              var t = f.default.createInputOptions(e),
                  n = e.get("subSchemas"),
                  r = e.get("name");
              a.addInput(t), "password" === r && n && a.add(h.default.extend({
                id: "subschemas-" + r,
                subSchemas: n
              }));
            });
            var s = o.default.template({
              compiler: [8, ">= 4.3.0"],
              main: function main(e, t, n, r, o) {
                var i,
                    a = e.lookupProperty || function (e, t) {
                  if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                };

                return '<span class="required-fields-label">' + e.escapeExpression((i = null != (i = a(n, "label") || (null != t ? a(t, "label") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
                  name: "label",
                  hash: {},
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 36
                    },
                    end: {
                      line: 1,
                      column: 45
                    }
                  }
                }) : i)) + "</span>";
              },
              useData: !0
            })({
              label: (0, i.loc)("registration.required.fields.label", "login")
            });
            a.add(s);
          }
        }), (0, l.default)(this.state.get("schema").fetch());
      },
      Footer: m
    });
    t.default = g;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(93)),
        a = i.default.extend({
      constructor: function constructor(e) {
        this.settings = e && e.settings, o.Model.apply(this, arguments);
      },
      loginWithActivationToken: function loginWithActivationToken(e) {
        return this.startTransaction(function (t) {
          return t.signInWithCredentials({
            token: e
          });
        });
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = r.internal.models,
        i = o.BaseSchema,
        a = o.SchemaProperty,
        s = a.Collection.extend({
      createModelProperties: function createModelProperties() {
        var e = a.Collection.prototype.createModelProperties.apply(this);
        return r._.each(e, function (e, t) {
          e.required = !!this.get(t).get("required");
        }, this), e;
      }
    }),
        l = i.Model.extend({
      expand: ["schema"],
      constructor: function constructor() {
        this.properties = new s(), r.BaseModel.apply(this, arguments);
      },
      parse: function parse(e) {
        var t = this,
            n = function n(e) {
          var n = e.schema.required;
          r._.isArray(n) && r._.each(n, function (e) {
            var t = this.properties.get(e);
            t && t.set("required", !0);
          }, t);
          var o = e.schema.fieldOrder;
          return r._.isArray(o) && (r._.each(o, function (e, t) {
            var n = this.properties.get(e);
            n && n.set("sortOrder", t);
          }, t), t.properties.comparator = "sortOrder", t.properties.sort()), t.properties.defaultPolicyId = e.policyId, e;
        },
            o = this;

        this.settings.parseRegistrationSchema(e, function (e) {
          e.profileSchema && (e.schema = e.profileSchema, i.Model.prototype.parse.apply(o, [e]), e = n(e)), o.trigger("parseComplete", {
            properties: o.properties
          });
        }, function (e) {
          o.trigger("parseComplete", {
            properties: o.properties,
            error: e
          });
        });
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      index: "",
      message: "",
      class: function _class() {},
      className: function className() {
        return "subschema-unsatisfied subschema-" + this.index;
      },
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<p class="default-schema"><span class="icon icon-16"></span>' + e.escapeExpression((i = null != (i = a(n, "message") || (null != t ? a(t, "message") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "message",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 60
              },
              end: {
                line: 1,
                column: 71
              }
            }
          }) : i)) + "</p>";
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        return {
          message: this.message
        };
      }
    }),
        s = i.View.extend({
      className: "subschema",
      children: function children() {
        return this.subSchemas.map(function (e, t) {
          var n = e.get("description"),
              r = n;
          return a.extend({
            index: t,
            message: r
          });
        });
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(5)),
        s = r(n(4)),
        l = r(n(6)),
        u = r(n(12)),
        c = r(n(94)),
        d = r(n(268)),
        f = r(n(13)),
        p = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="okta-form-infobox-error infobox infobox-error" role="alert"><span class="icon error-16"></span><p>' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "account.unlock.noFactorsEnabled"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 110
              },
              end: {
                line: 1,
                column: 172
              }
            }
          })) + "</p></div>";
        },
        useData: !0
      })
    }),
        h = i.View.extend({
      template: o.default.template({
        1: function _(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link goto js-contact-support">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "mfa.noAccessToEmail"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 173
              },
              end: {
                line: 1,
                column: 223
              }
            }
          })) + "</a>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a href="#" class="link help js-back" data-se="back-link">' + e.escapeExpression((s(n, "i18n") || t && s(t, "i18n") || e.hooks.helperMissing).call(a, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "goback"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 58
              },
              end: {
                line: 1,
                column: 95
              }
            }
          })) + "</a>" + (null != (i = s(n, "if").call(a, null != t ? s(t, "helpSupportNumber") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 99
              },
              end: {
                line: 1,
                column: 234
              }
            }
          })) ? i : "");
        },
        useData: !0
      }),
      className: "auth-footer",
      events: {
        "click .js-back": function clickJsBack(e) {
          e.preventDefault(), this.back();
        },
        "click .js-contact-support": function clickJsContactSupport(e) {
          e.preventDefault(), this.state.trigger("contactSupport"), this.$(".js-contact-support").hide();
        }
      },
      getTemplateData: function getTemplateData() {
        return this.settings.pick("helpSupportNumber");
      },
      back: function back() {
        this.state.set("navigateDir", a.default.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
      }
    }),
        m = s.default.extend({
      className: "account-unlock",
      Model: {
        props: {
          username: ["string", !0],
          factorType: ["string", !0]
        },
        validate: function validate() {
          return c.default.validateUsername(this);
        },
        save: function save() {
          var e = this;
          return this.startTransaction(function (t) {
            return t.unlockAccount({
              username: e.settings.transformUsername(e.get("username"), a.default.UNLOCK_ACCOUNT),
              factorType: e.get("factorType")
            });
          }).catch(function () {});
        }
      },
      Form: {
        noButtonBar: !0,
        title: i._.partial(i.loc, "account.unlock.title", "login"),
        formChildren: function formChildren() {
          var e = this.settings.get("features.smsRecovery"),
              t = this.settings.get("features.callRecovery"),
              n = this.settings.get("features.emailRecovery"),
              r = !(e || t || n),
              s = [],
              c = this;
          return r ? this.add(p, ".o-form-error-container") : (s.push(l.default.Input({
            label: (0, i.loc)("account.unlock.email.or.username.placeholder", "login"),
            "label-top": !0,
            explain: u.default.createInputExplain("account.unlock.email.or.username.tooltip", "account.unlock.email.or.username.placeholder", "login"),
            "explain-top": !0,
            name: "username",
            input: f.default,
            inputId: "account-recovery-username",
            type: "text",
            inlineValidation: !1
          })), (e || t) && s.push(l.default.View({
            View: i.View.extend({
              template: o.default.template({
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, o) {
                  var i = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<p class="mobile-recovery-hint">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                    name: "i18n",
                    hash: {
                      arguments: "mobileFactors",
                      bundle: "login",
                      code: "recovery.mobile.hint"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 32
                      },
                      end: {
                        line: 1,
                        column: 109
                      }
                    }
                  })) + "</p>";
                },
                useData: !0
              }),
              getTemplateData: function getTemplateData() {
                var n;
                return n = e && t ? (0, i.loc)("recovery.smsOrCall") : t ? (0, i.loc)("recovery.call") : (0, i.loc)("recovery.sms"), {
                  mobileFactors: n
                };
              }
            })
          })), e && (this.$el.addClass("forgot-password-sms-enabled"), s.push(this.createRecoveryFactorButton("sms-button", "account.unlock.sendText", a.default.RECOVERY_FACTOR_TYPE_SMS, c)), this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_SMS)), t && (this.$el.addClass("forgot-password-call-enabled"), s.push(this.createRecoveryFactorButton("call-button", "account.unlock.voiceCall", a.default.RECOVERY_FACTOR_TYPE_CALL, c)), this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_CALL)), n && (this.$el.addClass("forgot-password-email-enabled"), s.push(this.createRecoveryFactorButton("email-button", "account.unlock.sendEmail", a.default.RECOVERY_FACTOR_TYPE_EMAIL, c)), this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_EMAIL))), s;
        },
        initialize: function initialize() {
          this.listenTo(this, "save", function () {
            this.options.appState.set("username", this.model.get("username")), this.model.save();
          }), this.listenTo(this.state, "contactSupport", function () {
            this.add(d.default, ".o-form-error-container");
          });
        },
        setDefaultFactorType: function setDefaultFactorType(e) {
          i._.isEmpty(this.model.get("factorType")) && this.model.set("factorType", e);
        },
        createRecoveryFactorButton: function createRecoveryFactorButton(e, t, n, r) {
          return l.default.Button({
            attributes: {
              "data-se": e
            },
            className: "button button-primary button-wide " + e,
            title: (0, i.loc)(t, "login"),
            click: function click() {
              r.clearErrors(), this.model.isValid() && (this.model.set("factorType", n), r.trigger("save", this.model));
            }
          });
        }
      },
      Footer: h
    });
    t.default = m;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(5)),
        a = r(n(4)),
        s = r(n(6)),
        l = a.default.extend({
      className: "account-unlock-email-sent",
      Model: function Model() {
        return {
          local: {
            userFullName: ["string", !1, this.options.appState.get("userFullName")]
          }
        };
      },
      Form: {
        title: o._.partial(o.loc, "account.unlock.emailSent.title", "login"),
        subtitle: function subtitle() {
          var e = this.options.appState.get("username");
          return (0, o.loc)("account.unlock.emailSent.desc", "login", [e]);
        },
        noButtonBar: !0,
        attributes: {
          "data-se": "unlock-email-sent"
        },
        formChildren: function formChildren() {
          return [s.default.Button({
            title: (0, o.loc)("goback", "login"),
            className: "button button-primary button-wide",
            attributes: {
              "data-se": "back-button"
            },
            click: function click() {
              this.state.set("navigateDir", i.default.DIRECTION_BACK), this.options.appState.trigger("navigate", "");
            }
          })];
        }
      },
      initialize: function initialize(e) {
        this.settings.callGlobalSuccess(i.default.UNLOCK_ACCOUNT_EMAIL_SENT, {
          username: e.appState.get("username")
        });
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(15)),
        a = r(n(4)),
        s = r(n(6)),
        l = r(n(47)),
        u = r(n(76)),
        c = o.internal.util.Util,
        d = a.default.extend({
      className: "verify-custom-factor custom-factor-form",
      Model: {
        props: {
          rememberDevice: "boolean"
        },
        initialize: function initialize() {
          var e = i.default.getRememberDeviceValue(this.appState);
          this.set("rememberDevice", e);
        },
        save: function save() {
          var e = this,
              t = !!this.get("rememberDevice");
          return this.manageTransaction(function (n, r) {
            var i = {
              rememberDevice: t
            };
            return o._.findWhere(n.factors, {
              provider: e.get("provider"),
              factorType: e.get("factorType")
            }).verify(i).then(function (t) {
              r(t);
              var n = e.appState.get("verifyCustomFactorRedirectUrl");
              null !== n && c.redirect(n);
            }).catch(function (e) {
              throw e;
            });
          });
        }
      },
      Form: function Form() {
        var e = this.options.appState.get("factors"),
            t = e.findWhere({
          provider: this.options.provider,
          factorType: this.options.factorType
        }),
            n = t.get("vendorName");
        return {
          autoSave: !0,
          title: n,
          save: (0, o.loc)("mfa.challenge.verify", "login"),
          subtitle: (0, o.loc)("verify.customFactor.subtitle", "login", [n]),
          attributes: {
            "data-se": "factor-custom"
          },
          initialize: function initialize() {
            this.options.appState.get("allowRememberDevice") && this.addInput({
              label: !1,
              "label-top": !0,
              placeholder: this.options.appState.get("rememberDeviceLabel"),
              className: "margin-btm-0",
              name: "rememberDevice",
              type: "checkbox"
            });
          },
          formChildren: function formChildren() {
            var e = [],
                t = this.options.appState.get("lastFailedChallengeFactorData");
            return t && e.push(s.default.View({
              View: new l.default({
                message: t.errorMessage
              })
            }, {
              selector: ".o-form-error-container"
            })), e;
          }
        };
      },
      trapAuthResponse: function trapAuthResponse() {
        if (this.options.appState.get("isMfaChallenge")) return !0;
      },
      back: function back() {},
      initialize: function initialize() {
        this.model.set("provider", this.options.provider), this.model.set("factorType", this.options.factorType), this.addFooter(u.default);
      }
    });
    t.default = d;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(157)),
        a = r(n(16)),
        s = r(n(15)),
        l = r(n(4)),
        u = r(n(76)),
        c = l.default.extend({
      className: "mfa-verify-duo duo-form",
      Model: {
        props: {
          host: "string",
          signature: "string",
          postAction: "string",
          factorId: "string",
          stateToken: "string",
          rememberDevice: "boolean"
        },
        initialize: function initialize() {
          var e = s.default.getRememberDeviceValue(this.appState);
          this.set("rememberDevice", e);
        },
        getInitOptions: function getInitOptions() {
          var e = !!this.get("rememberDevice");
          return this.doTransaction(function (t) {
            var n = {
              rememberDevice: e
            };
            return o._.findWhere(t.factors, {
              provider: "DUO",
              factorType: "web"
            }).verify(n).catch(function (e) {
              throw e;
            });
          }, !0);
        },
        verify: function verify(e) {
          var t = this.get("postAction"),
              n = this.get("factorId"),
              r = this,
              i = {
            id: n,
            stateToken: this.get("stateToken"),
            sig_response: e
          },
              s = this.get("rememberDevice");
          return (0, a.default)(o.$.post(t, i)).then(function () {
            return r.doTransaction(function (e) {
              var t;
              return s && (t = {
                rememberDevice: s
              }), e.poll(t);
            });
          }).catch(function (e) {
            r.trigger("error", r, e.xhr);
          });
        }
      },
      Form: {
        autoSave: !0,
        noButtonBar: !0,
        title: o._.partial(o.loc, "factor.duo"),
        attributes: {
          "data-se": "factor-duo"
        },
        postRender: function postRender() {
          this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>'), this.options.appState.get("allowRememberDevice") && this.addInput({
            label: !1,
            "label-top": !0,
            placeholder: this.options.appState.get("rememberDeviceLabel"),
            className: "margin-btm-0",
            name: "rememberDevice",
            type: "checkbox"
          }), i.default.init({
            host: this.model.get("host"),
            sig_request: this.model.get("signature"),
            iframe: this.$("iframe").get(0),
            post_action: o._.bind(this.model.verify, this.model)
          });
        }
      },
      fetchInitialData: function fetchInitialData() {
        var e = this;
        return this.model.getInitOptions().then(function (t) {
          var n = t.data;
          if (!(n._embedded && n._embedded.factor && n._embedded.factor._embedded && n._embedded.factor._embedded.verification)) throw new Error("Response does not have duo verification options");
          var r = n._embedded.factor._embedded.verification;
          e.model.set({
            host: r.host,
            signature: r.signature,
            postAction: r._links.complete.href,
            factorId: n._embedded.factor.id,
            stateToken: n.stateToken
          });
        });
      },
      trapAuthResponse: function trapAuthResponse() {
        if (this.options.appState.get("isMfaChallenge")) return !0;
      },
      back: function back() {},
      Footer: u.default
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(57)),
        i = r(n(58)),
        a = r(n(2)),
        s = n(1),
        l = r(n(4)),
        u = r(n(6)),
        c = r(n(266)),
        d = s.internal.util.Util,
        f = l.default.extend({
      className: "piv-cac-card",
      Model: {
        save: function () {
          function e() {
            return t.apply(this, arguments);
          }

          var t = (0, i.default)(o.default.mark(function e() {
            var t, n, r, i;
            return o.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return this.trigger("request"), t = this, n = this.settings.get("piv"), r = {
                      fromURI: this.settings.get("relayState"),
                      isCustomDomain: n.isCustomDomain
                    }, e.prev = 4, e.next = 7, this.getCert(n.certAuthUrl);

                  case 7:
                    return e.next = 9, this.postCert(n.certAuthUrl, r);

                  case 9:
                    i = e.sent, d.redirect(i.redirectUrl), e.next = 17;
                    break;

                  case 13:
                    e.prev = 13, e.t0 = e.catch(4), s._.isEmpty(e.t0.responseJSON) && !e.t0.responseText && (e.t0.responseJSON = {
                      errorSummary: (0, s.loc)("piv.cac.error", "login")
                    }), t.trigger("error", t, e.t0);

                  case 17:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[4, 13]]);
          }));
          return e;
        }(),
        getCert: function getCert(e) {
          return s.$.get({
            url: e,
            xhrFields: {
              withCredentials: !0
            },
            beforeSend: function beforeSend() {}
          });
        },
        postCert: function postCert(e, t) {
          return s.$.post({
            url: e,
            xhrFields: {
              withCredentials: !0
            },
            data: JSON.stringify(t),
            contentType: "text/plain",
            beforeSend: function beforeSend() {}
          });
        }
      },
      Form: {
        autoSave: !0,
        hasSavingState: !1,
        title: s._.partial(s.loc, "piv.cac.title", "login"),
        className: "piv-cac-card",
        noCancelButton: !0,
        save: s._.partial(s.loc, "retry", "login"),
        modelEvents: {
          request: "_startEnrollment",
          error: "_stopEnrollment"
        },
        formChildren: [u.default.View({
          View: s.View.extend({
            template: a.default.template({
              compiler: [8, ">= 4.3.0"],
              main: function main(e, t, n, r, o) {
                var i = e.lookupProperty || function (e, t) {
                  if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                };

                return '<div class="piv-verify-text"><p>' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                  name: "i18n",
                  hash: {
                    bundle: "login",
                    code: "piv.cac.card.insert"
                  },
                  data: o,
                  loc: {
                    start: {
                      line: 1,
                      column: 32
                    },
                    end: {
                      line: 1,
                      column: 82
                    }
                  }
                })) + '</p><div data-se="piv-waiting" class="okta-waiting-spinner"></div></div>';
              },
              useData: !0
            })
          })
        })],
        _startEnrollment: function _startEnrollment() {
          this.$(".okta-waiting-spinner").show(), this.$(".o-form-button-bar").hide();
        },
        _stopEnrollment: function _stopEnrollment() {
          this.$(".okta-waiting-spinner").hide(), this.$(".o-form-button-bar").show();
        },
        postRender: function postRender() {
          var e = this;

          s._.defer(function () {
            e.model.save();
          });
        }
      },
      back: function back() {},
      Footer: c.default
    });
    t.default = f;
  }, function (e, t, n) {
    /**
    * Copyright (c) 2014-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    var r = function (e) {
      "use strict";

      function t(e, t, n, o) {
        var i = t && t.prototype instanceof r ? t : r,
            a = Object.create(i.prototype),
            s = new f(o || []);
        return a._invoke = l(e, n, s), a;
      }

      function n(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      function r() {}

      function o() {}

      function i() {}

      function a(e) {
        ["next", "throw", "return"].forEach(function (t) {
          e[t] = function (e) {
            return this._invoke(t, e);
          };
        });
      }

      function s(e, t) {
        function r(o, i, a, s) {
          var l = n(e[o], e, i);

          if ("throw" !== l.type) {
            var u = l.arg,
                c = u.value;
            return c && "object" == typeof c && v.call(c, "__await") ? t.resolve(c.__await).then(function (e) {
              r("next", e, a, s);
            }, function (e) {
              r("throw", e, a, s);
            }) : t.resolve(c).then(function (e) {
              u.value = e, a(u);
            }, function (e) {
              return r("throw", e, a, s);
            });
          }

          s(l.arg);
        }

        function o(e, n) {
          function o() {
            return new t(function (t, o) {
              r(e, n, t, o);
            });
          }

          return i = i ? i.then(o, o) : o();
        }

        var i;
        this._invoke = o;
      }

      function l(e, t, r) {
        var o = E;
        return function (i, a) {
          if (o === S) throw new Error("Generator is already running");

          if (o === x) {
            if ("throw" === i) throw a;
            return h();
          }

          for (r.method = i, r.arg = a;;) {
            var s = r.delegate;

            if (s) {
              var l = u(s, r);

              if (l) {
                if (l === T) continue;
                return l;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (o === E) throw o = x, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            o = S;
            var c = n(e, t, r);

            if ("normal" === c.type) {
              if (o = r.done ? x : O, c.arg === T) continue;
              return {
                value: c.arg,
                done: r.done
              };
            }

            "throw" === c.type && (o = x, r.method = "throw", r.arg = c.arg);
          }
        };
      }

      function u(e, t) {
        var r = e.iterator[t.method];

        if (r === m) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = m, u(e, t), "throw" === t.method)) return T;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return T;
        }

        var o = n(r, e.iterator, t.arg);
        if ("throw" === o.type) return t.method = "throw", t.arg = o.arg, t.delegate = null, T;
        var i = o.arg;
        return i ? i.done ? (t[e.resultName] = i.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = m), t.delegate = null, T) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, T);
      }

      function c(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function d(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function f(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(c, this), this.reset(!0);
      }

      function p(e) {
        if (e) {
          var t = e[b];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;

          if (!isNaN(e.length)) {
            var n = -1,
                r = function t() {
              for (; ++n < e.length;) {
                if (v.call(e, n)) return t.value = e[n], t.done = !1, t;
              }

              return t.value = m, t.done = !0, t;
            };

            return r.next = r;
          }
        }

        return {
          next: h
        };
      }

      function h() {
        return {
          value: m,
          done: !0
        };
      }

      var m,
          g = Object.prototype,
          v = g.hasOwnProperty,
          y = "function" == typeof Symbol ? Symbol : {},
          b = y.iterator || "@@iterator",
          _ = y.asyncIterator || "@@asyncIterator",
          w = y.toStringTag || "@@toStringTag";

      e.wrap = t;
      var E = "suspendedStart",
          O = "suspendedYield",
          S = "executing",
          x = "completed",
          T = {},
          k = {};

      k[b] = function () {
        return this;
      };

      var C = Object.getPrototypeOf,
          A = C && C(C(p([])));
      A && A !== g && v.call(A, b) && (k = A);
      var N = i.prototype = r.prototype = Object.create(k);
      return o.prototype = N.constructor = i, i.constructor = o, i[w] = o.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === o || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, i) : (e.__proto__ = i, w in e || (e[w] = "GeneratorFunction")), e.prototype = Object.create(N), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, a(s.prototype), s.prototype[_] = function () {
        return this;
      }, e.AsyncIterator = s, e.async = function (n, r, o, i, a) {
        void 0 === a && (a = Promise);
        var l = new s(t(n, r, o, i), a);
        return e.isGeneratorFunction(r) ? l : l.next().then(function (e) {
          return e.done ? e.value : l.next();
        });
      }, a(N), N[w] = "Generator", N[b] = function () {
        return this;
      }, N.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];

        for (var n in e) {
          t.push(n);
        }

        return t.reverse(), function n() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return n.value = r, n.done = !1, n;
          }

          return n.done = !0, n;
        };
      }, e.values = p, f.prototype = {
        constructor: f,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = m, this.done = !1, this.delegate = null, this.method = "next", this.arg = m, this.tryEntries.forEach(d), !e) for (var t in this) {
            "t" === t.charAt(0) && v.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = m);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0],
              t = e.completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          function t(t, r) {
            return i.type = "throw", i.arg = e, n.next = t, r && (n.method = "next", n.arg = m), !!r;
          }

          if (this.done) throw e;

          for (var n = this, r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r],
                i = o.completion;
            if ("root" === o.tryLoc) return t("end");

            if (o.tryLoc <= this.prev) {
              var a = v.call(o, "catchLoc"),
                  s = v.call(o, "finallyLoc");

              if (a && s) {
                if (this.prev < o.catchLoc) return t(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return t(o.finallyLoc);
              } else if (a) {
                if (this.prev < o.catchLoc) return t(o.catchLoc, !0);
              } else {
                if (!s) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return t(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var r = this.tryEntries[n];

            if (r.tryLoc <= this.prev && v.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
              var o = r;
              break;
            }
          }

          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var i = o ? o.completion : {};
          return i.type = e, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, T) : this.complete(i);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), T;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), d(n), T;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];

            if (n.tryLoc === e) {
              var r = n.completion;

              if ("throw" === r.type) {
                var o = r.arg;
                d(n);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, n) {
          return this.delegate = {
            iterator: p(e),
            resultName: t,
            nextLoc: n
          }, "next" === this.method && (this.arg = m), T;
        }
      }, e;
    }(e.exports);

    try {
      regeneratorRuntime = r;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(r);
    }
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = [];
      return a._.each(e, function (e) {
        t.push({
          version: e.profile.version,
          keyHandle: e.profile.credentialId
        });
      }), t;
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = o(n(2)),
        a = n(1),
        s = o(n(16));
    n(264);
    var l = o(n(24)),
        u = o(n(15)),
        c = o(n(158)),
        d = o(n(4)),
        f = o(n(6)),
        p = o(n(47)),
        h = o(n(76)),
        m = d.default.extend({
      className: "mfa-verify verify-u2f",
      Model: {
        props: {
          rememberDevice: "boolean"
        },
        initialize: function initialize() {
          var e = u.default.getRememberDeviceValue(this.appState);
          this.set("rememberDevice", e);
        },
        save: function save() {
          return this.trigger("request"), this.doTransaction(function (e) {
            var t;
            t = e.factorTypes ? a._.findWhere(e.factorTypes, {
              factorType: "u2f"
            }) : a._.findWhere(e.factors, {
              factorType: "u2f",
              provider: "FIDO"
            });
            var n = this;
            return t.verify().then(function (e) {
              var o, i, a;

              if (e.factors) {
                var u = e.factors;
                i = u[0].profile.appId, a = e.challenge.nonce, o = r(u);
              } else {
                var d = e.factor;
                i = d.profile.appId, a = d.challenge.nonce, o = [{
                  version: c.default.getU2fVersion(),
                  keyHandle: d.profile.credentialId
                }];
              }

              n.trigger("request");
              var f = s.default.defer();
              return u2f.sign(i, a, o, function (e) {
                if (n.trigger("errors:clear"), !e.errorCode || 0 === e.errorCode) {
                  var r = !!n.get("rememberDevice");
                  return t.verify({
                    clientData: e.clientData,
                    signatureData: e.signatureData,
                    rememberDevice: r
                  }).then(f.resolve);
                }

                var o = 1 === n.options.appState.get("factors").length;
                f.reject(new l.default.U2FError({
                  xhr: {
                    responseJSON: {
                      errorSummary: c.default.getU2fVerifyErrorMessageByCode(e.errorCode, o)
                    }
                  }
                }));
              }), f.promise;
            });
          });
        }
      },
      Form: {
        autoSave: !0,
        hasSavingState: !1,
        title: a._.partial(a.loc, "factor.u2f", "login"),
        className: "verify-u2f-form",
        noCancelButton: !0,
        save: a._.partial(a.loc, "verify.u2f.retry", "login"),
        noButtonBar: function noButtonBar() {
          return !c.default.isU2fAvailable();
        },
        modelEvents: {
          request: "_startEnrollment",
          error: "_stopEnrollment"
        },
        formChildren: function formChildren() {
          var e = [];
          if (c.default.isU2fAvailable()) e.push(f.default.View({
            View: a.View.extend({
              template: i.default.template({
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, o) {
                  var i = null != t ? t : e.nullContext || {},
                      a = e.hooks.helperMissing,
                      s = e.escapeExpression,
                      l = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<div class="u2f-verify-text"><p>' + s((l(n, "i18n") || t && l(t, "i18n") || a).call(i, {
                    name: "i18n",
                    hash: {
                      bundle: "login",
                      code: "verify.u2f.instructions"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 32
                      },
                      end: {
                        line: 1,
                        column: 86
                      }
                    }
                  })) + "</p><p>" + s((l(n, "i18n") || t && l(t, "i18n") || a).call(i, {
                    name: "i18n",
                    hash: {
                      bundle: "login",
                      code: "verify.u2f.instructionsBluetooth"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 93
                      },
                      end: {
                        line: 1,
                        column: 156
                      }
                    }
                  })) + '</p><div data-se="u2f-waiting" class="okta-waiting-spinner"></div></div>';
                },
                useData: !0
              })
            })
          }));else {
            var t = "u2f.error.factorNotSupported";
            1 === this.options.appState.get("factors").length && (t = "u2f.error.factorNotSupported.oneFactor"), e.push(f.default.View({
              View: new p.default({
                message: (0, a.loc)(t, "login")
              })
            }, {
              selector: ".o-form-error-container"
            }));
          }
          return this.options.appState.get("allowRememberDevice") && e.push(f.default.Input({
            label: !1,
            "label-top": !0,
            placeholder: this.options.appState.get("rememberDeviceLabel"),
            className: "margin-btm-0",
            name: "rememberDevice",
            type: "checkbox"
          })), e;
        },
        postRender: function postRender() {
          var e = this;

          a._.defer(function () {
            c.default.isU2fAvailable() ? e.model.save() : e.$('[data-se="u2f-waiting"]').addClass("hide");
          });
        },
        _startEnrollment: function _startEnrollment() {
          this.$(".okta-waiting-spinner").removeClass("hide"), this.$(".o-form-button-bar").hide();
        },
        _stopEnrollment: function _stopEnrollment() {
          this.$(".okta-waiting-spinner").addClass("hide"), this.$(".o-form-button-bar").show();
        }
      },
      back: function back() {},
      Footer: h.default
    });
    t.default = m;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = [];
      return a._.each(e, function (e) {
        t.push({
          type: "public-key",
          id: l.default.strToBin(e.profile.credentialId)
        });
      }), t;
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = o(n(2)),
        a = n(1),
        s = o(n(16)),
        l = o(n(116)),
        u = o(n(24)),
        c = o(n(15)),
        d = o(n(4)),
        f = o(n(6)),
        p = o(n(75)),
        h = o(n(25)),
        m = o(n(47)),
        g = o(n(76)),
        v = d.default.extend({
      className: "mfa-verify verify-webauthn",
      Model: {
        props: {
          rememberDevice: "boolean"
        },
        initialize: function initialize() {
          var e = this,
              t = c.default.getRememberDeviceValue(this.appState);
          this.set("rememberDevice", t), this.appState.on("factorSwitched signOut", function () {
            e.webauthnAbortController && (e.webauthnAbortController.abort(), e.webauthnAbortController = null);
          });
        },
        save: function save() {
          return this.trigger("request"), this.doTransaction(function (e) {
            var t;
            t = e.factorTypes ? a._.findWhere(e.factorTypes, {
              factorType: "webauthn"
            }) : a._.findWhere(e.factors, {
              factorType: "webauthn",
              provider: "FIDO"
            });
            var n = this;
            return t.verify().then(function (e) {
              var o, i;

              if (e.factors) {
                var c = e.factors;
                i = e.challenge, o = r(c);
              } else {
                var d = e.factor;
                i = d.challenge, o = r([d]);
              }

              n.trigger("request");

              var f = a._.extend({}, i, {
                allowCredentials: o,
                challenge: l.default.strToBin(i.challenge)
              });

              return n.webauthnAbortController = new AbortController(), new s.default(navigator.credentials.get({
                publicKey: f,
                signal: n.webauthnAbortController.signal
              })).then(function (e) {
                var r = !!n.get("rememberDevice");
                return t.verify({
                  clientData: l.default.binToStr(e.response.clientDataJSON),
                  authenticatorData: l.default.binToStr(e.response.authenticatorData),
                  signatureData: l.default.binToStr(e.response.signature),
                  rememberDevice: r
                });
              }).catch(function (e) {
                throw n.trigger("errors:clear"), n.webauthnAbortController ? new u.default.WebAuthnError({
                  xhr: {
                    responseJSON: {
                      errorSummary: e.message
                    }
                  }
                }) : new u.default.WebauthnAbortError();
              }).finally(function () {
                n.webauthnAbortController = null;
              });
            });
          });
        }
      },
      Form: {
        autoSave: !0,
        hasSavingState: !1,
        title: a._.partial(a.loc, "factor.webauthn.biometric", "login"),
        className: "verify-webauthn-form",
        noCancelButton: !0,
        save: a._.partial(a.loc, "mfa.challenge.verify", "login"),
        noButtonBar: function noButtonBar() {
          return !p.default.isNewApiAvailable();
        },
        modelEvents: {
          request: "_startEnrollment",
          error: "_stopEnrollment"
        },
        formChildren: function formChildren() {
          var e = [];
          if (p.default.isNewApiAvailable()) e.push(f.default.View({
            View: a.View.extend({
              template: i.default.template({
                compiler: [8, ">= 4.3.0"],
                main: function main(e, t, n, r, o) {
                  var i = e.lookupProperty || function (e, t) {
                    if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
                  };

                  return '<div class="webauthn-verify-text"><p>' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                    name: "i18n",
                    hash: {
                      bundle: "login",
                      code: "verify.webauthn.biometric.instructions"
                    },
                    data: o,
                    loc: {
                      start: {
                        line: 1,
                        column: 37
                      },
                      end: {
                        line: 1,
                        column: 106
                      }
                    }
                  })) + '</p><div data-se="webauthn-waiting" class="okta-waiting-spinner"></div></div>';
                },
                useData: !0
              })
            })
          }));else {
            var t = "webauthn.biometric.error.factorNotSupported";
            1 === this.options.appState.get("factors").length && (t = "webauthn.biometric.error.factorNotSupported.oneFactor"), e.push(f.default.View({
              View: new m.default({
                message: (0, a.loc)(t, "login")
              })
            }, {
              selector: ".o-form-error-container"
            }));
          }
          return this.options.appState.get("allowRememberDevice") && e.push(f.default.Input({
            label: !1,
            "label-top": !0,
            placeholder: this.options.appState.get("rememberDeviceLabel"),
            className: "margin-btm-0",
            name: "rememberDevice",
            type: "checkbox"
          })), e;
        },
        _startEnrollment: function _startEnrollment() {
          this.$(".okta-waiting-spinner").show(), this.$(".o-form-button-bar").hide();
        },
        _stopEnrollment: function _stopEnrollment() {
          this.$(".okta-waiting-spinner").hide(), this.$('.o-form-button-bar [type="submit"]')[0].value = (0, a.loc)("verify.u2f.retry", "login"), this.$(".o-form-button-bar").show();
        }
      },
      postRender: function postRender() {
        var e = this;

        a._.defer(function () {
          p.default.isNewApiAvailable() && !h.default.isSafari() && e.model.save();
        });
      },
      back: function back() {},
      Footer: g.default
    });
    t.default = v;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(4)),
        a = r(n(6)),
        s = r(n(75)),
        l = r(n(47)),
        u = r(n(76)),
        c = r(n(267)),
        d = i.default.extend({
      className: "mfa-verify verify-windows-hello",
      Model: {
        local: {
          __autoTriggered__: "boolean"
        },
        save: function save() {
          if (s.default.isAvailable()) {
            this.trigger("request");
            var e = this;
            return this.doTransaction(function (t) {
              var n = o._.findWhere(t.factors, {
                factorType: "webauthn",
                provider: "FIDO"
              });

              return n.verify().then(function (r) {
                var o = r.factor;
                return s.default.getAssertion(o.challenge.nonce, [{
                  id: o.profile.credentialId
                }]).then(function (e) {
                  return n.verify({
                    authenticatorData: e.authenticatorData,
                    clientData: e.clientData,
                    signatureData: e.signature
                  });
                }).then(function (t) {
                  return e.trigger("sync"), e.trigger("signIn"), t;
                }).catch(function (n) {
                  switch (n.message) {
                    case "AbortError":
                    case "NotFoundError":
                    case "NotSupportedError":
                      return e.trigger("abort", n.message), t;
                  }

                  throw n;
                });
              });
            });
          }
        }
      },
      Form: {
        autoSave: !0,
        hasSavingState: !1,
        title: o._.partial(o.loc, "factor.windowsHello", "login"),
        subtitle: function subtitle() {
          return s.default.isAvailable() ? (0, o.loc)("verify.windowsHello.subtitle", "login") : "";
        },
        save: o._.partial(o.loc, "verify.windowsHello.save", "login"),
        customSavingState: {
          stop: "abort"
        },
        modelEvents: function modelEvents() {
          return s.default.isAvailable() ? {
            request: "_startEnrollment",
            error: "_stopEnrollment",
            abort: "_stopEnrollment",
            signIn: "_successEnrollment"
          } : {};
        },
        noButtonBar: function noButtonBar() {
          return !s.default.isAvailable();
        },
        formChildren: function formChildren() {
          var e = [];
          return s.default.isAvailable() || e.push(a.default.View({
            View: new l.default({
              message: (0, o.loc)("enroll.windowsHello.error.notWindows", "login")
            })
          }, {
            selector: ".o-form-error-container"
          })), e.push(a.default.View({
            View: new c.default({
              model: this.model,
              visible: !1
            })
          })), e;
        },
        postRender: function postRender() {
          1 !== this.options.appState.get("factors").length || this.model.get("__autoTriggered__") || (this.model.set("__autoTriggered__", !0), this.model.save());
        },
        _startEnrollment: function _startEnrollment() {
          this.subtitle = (0, o.loc)("verify.windowsHello.subtitle.loading", "login"), this.model.trigger("spinner:show"), this._resetErrorMessage(), this.render(), this.$(".o-form-button-bar").addClass("hide");
        },
        _stopEnrollment: function _stopEnrollment(e) {
          this.subtitle = (0, o.loc)("verify.windowsHello.subtitle", "login"), this.model.trigger("spinner:hide"), this.$(".o-form-button-bar").removeClass("hide");
          var t;

          switch (e) {
            case "NotFoundError":
              t = this.options.appState.get("factors").length > 1 ? (0, o.loc)("verify.windowsHello.error.notFound.selectAnother", "login") : (0, o.loc)("verify.windowsHello.error.notFound", "login");
              break;

            case "NotSupportedError":
              t = (0, o.loc)("enroll.windowsHello.error.notConfiguredHtml", "login");
          }

          if (this._resetErrorMessage(), t) {
            var n = new l.default({
              message: t
            });
            this.$(".o-form-error-container").addClass("o-form-has-errors"), this.add(n, {
              selector: ".o-form-error-container"
            }), this._errorMessageView = this.last();
          }

          this.render();
        },
        _successEnrollment: function _successEnrollment() {
          this.subtitle = this.settings.get("brandName") ? (0, o.loc)("verify.windowsHello.subtitle.signingIn.specific", "login", [this.settings.get("brandName")]) : (0, o.loc)("verify.windowsHello.subtitle.signingIn.generic", "login"), this.render(), this.$(".o-form-button-bar").addClass("hide");
        },
        _resetErrorMessage: function _resetErrorMessage() {
          this._errorMessageView && this._errorMessageView.remove(), this._errorMessageView = void 0, this.clearErrors();
        }
      },
      back: function back() {},
      Footer: u.default
    });
    t.default = d;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(4)),
        i = o.default.extend({
      className: "error-state",
      Model: {},
      Form: {
        noButtonBar: !0
      }
    });
    t.default = i;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return s._.find(e.stateLessRouteHandlers, function (n) {
        return t === e[n];
      });
    }

    function o(e, t) {
      return !!e && (e !== h.default || t.get("features.securityImage"));
    }

    function i(e, t, n, r) {
      var o = setTimeout(function () {
        e.trigger("loading", !0);
      }, 200);
      return c.default.loadLanguage(e.get("languageCode"), t, {
        baseUrl: n,
        rewrite: r
      }).then(function () {
        clearTimeout(o), e.trigger("loading", !1);
      });
    }

    var a = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var s = n(1),
        l = a(n(570)),
        u = a(n(275)),
        c = a(n(72)),
        d = a(n(38)),
        f = a(n(277)),
        p = a(n(278)),
        h = a(n(279)),
        m = a(n(118)),
        g = a(n(25)),
        v = a(n(280)),
        y = a(n(5)),
        b = a(n(24)),
        _ = a(n(39)),
        w = a(n(12)),
        E = s.Router.extend({
      Events: s.Backbone.Events,
      initialize: function initialize(e) {
        e.globalSuccessFn || (e.globalSuccessFn = function () {}), e.globalErrorFn || (e.globalErrorFn = function (e) {
          d.default.error(e);
        }), this.settings = new u.default(s._.omit(e, "el", "authClient"), {
          parse: !0
        }), this.settings.setAuthClient(e.authClient), e.el || this.settings.callGlobalError(new b.default.ConfigError((0, s.loc)("error.required.el"))), (0, s.$)("body > div").on("click", function () {}), this.appState = new l.default({
          baseUrl: this.settings.get("baseUrl"),
          settings: this.settings
        }, {
          parse: !0
        });
        var t = new f.default({
          appState: this.appState
        });
        (0, s.$)(e.el).append(t.render().$el), this.el = "#".concat(y.default.WIDGET_CONTAINER_ID), this.header = new p.default({
          el: this.el,
          appState: this.appState,
          settings: this.settings
        }), this.listenTo(this.appState, "change:transactionError", function (e, t) {
          _.default.routeAfterAuthStatusChangeError(this, t);
        }), this.listenTo(this.appState, "change:transaction", function (e, t) {
          _.default.routeAfterAuthStatusChange(this, t.data);
        }), this.listenTo(this.appState, "navigate", function (e) {
          this.navigate(e, {
            trigger: !0
          });
        });
      },
      execute: function execute(e, t) {
        var n = this.settings.get("recoveryToken");
        if (n) return this.settings.unset("recoveryToken"), void this.navigate(_.default.createRecoveryUrl(n), {
          trigger: !0
        });
        var o = this.settings.get("stateToken");
        if (o) return this.settings.unset("stateToken"), void this.navigate(_.default.createRefreshUrl(o), {
          trigger: !0
        });
        var i = this.appState.get("transaction");
        return i && i.data || r(this, e) ? void e.apply(this, t) : this.settings.getAuthClient().tx.exists() ? void this.navigate(_.default.createRefreshUrl(), {
          trigger: !0
        }) : void this.navigate("", {
          trigger: !0
        });
      },
      navigate: function navigate(e, t) {
        return this.settings.get("features.router") ? s.Router.prototype.navigate.apply(this, arguments) : t && t.trigger ? s.Backbone.history.loadUrl(e) : void 0;
      },
      render: function render(e, t) {
        var n = this;
        t || (t = {});

        var r = t.Beacon,
            a = s._.extend({
          settings: this.settings,
          appState: this.appState
        }, s._.omit(t, "Beacon"));

        if (this.header.rendered() || (this.el = this.header.render().getContentEl()), !c.default.isLoaded(this.appState.get("languageCode"))) return i(this.appState, this.settings.get("i18n"), this.settings.get("assets.baseUrl"), this.settings.get("assets.rewrite")).then(s._.bind(this.render, this, e, t));

        if (this.settings.get("colors.brand") && !v.default.isLoaded()) {
          var l = {
            brand: this.settings.get("colors.brand")
          };
          v.default.addStyle(l);
        }

        var u = this.controller;
        return this.controller = new e(a), this.listenTo(this.controller, "all", this.trigger), this.controller.fetchInitialData().then(function () {
          return o(r, n.settings) || (r = null), n.header.setBeacon(r, a), n.controller.render(), u ? m.default.swapPages({
            $parent: n.el,
            $oldRoot: u.$el,
            $newRoot: n.controller.$el,
            dir: u.state.get("navigateDir"),
            ctx: n,
            success: function success() {
              var e = this.appState.get("flashError"),
                  t = this.controller.model;

              if (u.remove(), u.$el.remove(), this.controller.postRenderAnimation(), e) {
                var n = this.settings.get("features.mfaOnlyFlow") ? "error.mfa.only.expired.session" : "error.expired.session";
                t.trigger("error", t, {
                  responseJSON: {
                    errorSummary: (0, s.loc)(n)
                  }
                }), this.appState.unset("flashError"), w.default.triggerAfterError(this.controller, e);
              }
            }
          }) : (n.el.append(n.controller.el), void n.controller.postRenderAnimation());
        }).catch(function () {
          u && (u.remove(), u.$el.remove());
        });
      },
      start: function start() {
        var e = this,
            t = !1;
        window.addEventListener && this.settings.get("features.router") && (window.addEventListener("popstate", function (t) {
          e.controller.back && (t.preventDefault(), t.stopImmediatePropagation(), e.controller.back());
        }), t = g.default.supportsPushState()), s.Router.prototype.start.call(this, {
          pushState: t
        });
      },
      hide: function hide() {
        this.header.$el.hide();
      },
      show: function show() {
        this.header.$el.show();
      },
      remove: function remove() {
        this.controller && this.controller.remove(), this.header.$el.remove(), c.default.remove(), s.Backbone.history.stop();
      }
    });

    t.default = E;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      if (c._.isEmpty(t) || c._.isUndefined(t)) return (0, f.default)({
        securityImage: g,
        securityImageDescription: b
      });
      t = encodeURIComponent(t);
      var r = w({
        baseUrl: e,
        username: t
      }),
          o = {
        url: r,
        dataType: "json"
      };
      return n && (o.headers = {
        "X-Device-Fingerprint": n
      }), (0, f.default)(c.$.ajax(o)).then(function (e) {
        return e.pwdImg === m ? {
          securityImage: v,
          securityImageDescription: y
        } : {
          securityImage: e.pwdImg,
          securityImageDescription: e.imageDescription || _
        };
      });
    }

    function o(e) {
      if (e > 60 && e <= 1440) {
        var t = e / 60;
        return (0, c.loc)("hours", "login", [t]);
      }

      if (e > 1440) {
        var n = e / 1440;
        return (0, c.loc)("days", "login", [n]);
      }

      return 1 === e ? (0, c.loc)("minutes.oneMinute", "login") : (0, c.loc)("minutes", "login", [e]);
    }

    function i(e) {
      var t = new Date(e).getTime();
      return Math.floor((t - new Date().getTime()) / 864e5);
    }

    function a(e, t) {
      var n = [],
          r = [];
      return c._.each(t, function (t) {
        var o = t.factorType;

        if (!c._.contains(n, o)) {
          var i = c._.findWhere(e, {
            factorType: o
          });

          i ? (n.push(o), r.push(i)) : r.push(t);
        }
      }), r;
    }

    var s = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var l = s(n(10)),
        u = s(n(2)),
        c = n(1),
        d = s(n(115)),
        f = s(n(16)),
        p = s(n(25)),
        h = s(n(24)),
        m = "/img/security/unknown.png",
        g = "/img/security/default.png",
        v = "/img/security/unknown-device.png",
        y = "",
        b = "",
        _ = "",
        w = u.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, o) {
        var i,
            a = null != t ? t : e.nullContext || {},
            s = e.hooks.helperMissing,
            u = e.escapeExpression,
            c = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return u((i = null != (i = c(n, "baseUrl") || (null != t ? c(t, "baseUrl") : t)) ? i : s, "function" === (0, l.default)(i) ? i.call(a, {
          name: "baseUrl",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 0
            },
            end: {
              line: 1,
              column: 11
            }
          }
        }) : i)) + "/login/getimage?username=" + u((i = null != (i = c(n, "username") || (null != t ? c(t, "username") : t)) ? i : s, "function" === (0, l.default)(i) ? i.call(a, {
          name: "username",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 36
            },
            end: {
              line: 1,
              column: 48
            }
          }
        }) : i));
      },
      useData: !0
    }),
        E = c.Model.extend({
      initialize: function initialize() {
        if (this.settings.get("features.securityImage")) {
          var e = this;
          this.listenTo(this, "change:username", function (t, n) {
            r(this.get("baseUrl"), n, this.get("deviceFingerprint")).then(function (e) {
              t.set("securityImage", e.securityImage), t.set("securityImageDescription", e.securityImageDescription), t.unset("deviceFingerprint");
            }).fail(function (t) {
              if (!p.default.corsIsNotEnabled(t)) throw t;
              e.settings.callGlobalError(new h.default.UnsupportedBrowserError((0, c.loc)("error.enabled.cors")));
            }).done();
          });
        }
      },
      local: {
        baseUrl: "string",
        lastAuthResponse: ["object", !0, {}],
        transaction: "object",
        transactionError: "object",
        introspectSuccess: "object",
        introspectError: "object",
        username: "string",
        factors: "object",
        policy: "object",
        securityImage: ["string", !0, g],
        securityImageDescription: ["string", !0, b],
        userCountryCode: "string",
        userPhoneNumber: "string",
        factorActivationType: "string",
        flashError: "object",
        beaconType: "string",
        deviceFingerprint: "string",
        typingPattern: "string",
        languageCode: ["string", !0],
        disableUsername: ["boolean", !1, !1],
        trapMfaRequiredResponse: ["boolean", !1, !1],
        lastFailedChallengeFactorData: ["object", !1]
      },
      setAuthResponse: function setAuthResponse(e) {
        var t = this;

        if (e._embedded && e._embedded.policy && this.set("policy", e._embedded.policy), e._embedded && e._embedded.factors) {
          var n = e._embedded.factors;
          e._embedded.factorTypes && (n = a(e._embedded.factorTypes, n));

          var r = c._.map(n, function (e) {
            return e.settings = t.settings, e.appState = t, e;
          });

          this.set("factors", new d.default.Collection(r, {
            parse: !0
          }));
        }

        this.set("lastAuthResponse", e);
      },
      clearLastAuthResponse: function clearLastAuthResponse() {
        this.set("lastAuthResponse", {});
      },
      setLastFailedChallengeFactorData: function setLastFailedChallengeFactorData() {
        this.set("lastFailedChallengeFactorData", {
          factor: this.get("factor"),
          errorMessage: this.get("factorResultErrorMessage")
        });
      },
      clearLastFailedChallengeFactorData: function clearLastFailedChallengeFactorData() {
        this.unset("lastFailedChallengeFactorData");
      },
      derived: {
        isSuccessResponse: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return "SUCCESS" === e.status;
          }
        },
        isMfaRequired: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return "MFA_REQUIRED" === e.status || "FACTOR_REQUIRED" === e.status;
          }
        },
        isProfileRequired: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return "PROFILE_REQUIRED" === e.status;
          }
        },
        isMfaEnroll: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return "MFA_ENROLL" === e.status || "FACTOR_ENROLL" === e.status;
          }
        },
        isMfaChallenge: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return "MFA_CHALLENGE" === e.status || "FACTOR_CHALLENGE" === e.status;
          }
        },
        isSMSPasswordRecovery: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            var t = e.status,
                n = e.factorType,
                r = e.recoveryType;
            return "RECOVERY_CHALLENGE" === t && "sms" === (null === n || void 0 === n ? void 0 : n.toLowerCase()) && "password" === (null === r || void 0 === r ? void 0 : r.toLowerCase());
          }
        },
        isUnauthenticated: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return "UNAUTHENTICATED" === e.status;
          }
        },
        isMfaRejected: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return "REJECTED" === e.factorResult;
          }
        },
        isMfaTimeout: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return "TIMEOUT" === e.factorResult;
          }
        },
        isMfaEnrollActivate: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return "MFA_ENROLL_ACTIVATE" === e.status || "FACTOR_ENROLL_ACTIVATE" === e.status;
          }
        },
        isWaitingForActivation: {
          deps: ["isMfaEnrollActivate", "lastAuthResponse"],
          fn: function fn(e, t) {
            return e && "WAITING" === t.factorResult;
          }
        },
        isWaitingForNumberChallenge: {
          deps: ["lastAuthResponse", "isMfaChallenge"],
          fn: function fn(e, t) {
            return !!(t && e && "WAITING" === e.factorResult && e._embedded && e._embedded.factor && e._embedded.factor._embedded && e._embedded.factor._embedded.challenge);
          }
        },
        hasMultipleFactorsAvailable: {
          deps: ["factors", "isMfaRequired", "isMfaChallenge", "isUnauthenticated"],
          fn: function fn(e, t, n, r) {
            return !!(t || n || r) && e && e.length > 1;
          }
        },
        promptForFactorInUnauthenticated: {
          deps: ["lastAuthResponse", "factors"],
          fn: function fn(e, t) {
            return "UNAUTHENTICATED" === e.status && t && t.length > 0;
          }
        },
        userId: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e._embedded && e._embedded.user ? e._embedded.user.id : null;
          }
        },
        isIdxStateToken: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e && c._.isString(e.stateToken) && e.stateToken.startsWith("01");
          }
        },
        isPwdExpiringSoon: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return "PASSWORD_WARN" === e.status;
          }
        },
        passwordExpireDays: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e._embedded && e._embedded.policy && e._embedded.policy.expiration ? e._embedded.policy.expiration.passwordExpireDays : null;
          }
        },
        isPwdManagedByOkta: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return !(e._links && e._links.next && e._links.next.title);
          }
        },
        passwordExpiredWebsiteName: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e._links && e._links.next && e._links.next.title ? e._links.next.title : null;
          }
        },
        passwordExpiredLinkUrl: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e._links && e._links.next && e._links.next.title && e._links.next.href ? e._links.next.href : null;
          }
        },
        recoveryType: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e.recoveryType;
          }
        },
        factorType: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e.factorType;
          }
        },
        factor: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e._embedded && e._embedded.factor ? e._embedded.factor : null;
          }
        },
        activatedFactorId: {
          deps: ["factor"],
          fn: function fn(e) {
            return e ? e.id : null;
          }
        },
        activatedFactorType: {
          deps: ["factor"],
          fn: function fn(e) {
            return e ? e.factorType : null;
          }
        },
        activatedFactorProvider: {
          deps: ["factor"],
          fn: function fn(e) {
            return e ? e.provider : null;
          }
        },
        qrcode: {
          deps: ["factor"],
          fn: function fn(e) {
            try {
              return e._embedded.activation._links.qrcode.href;
            } catch (e) {
              return null;
            }
          }
        },
        activationSendLinks: {
          deps: ["factor"],
          fn: function fn(e) {
            var t;

            try {
              t = e._embedded.activation._links.send;
            } catch (e) {
              t = [];
            }

            return t;
          }
        },
        textActivationLinkUrl: {
          deps: ["activationSendLinks"],
          fn: function fn(e) {
            var t = c._.findWhere(e, {
              name: "sms"
            });

            return t ? t.href : null;
          }
        },
        emailActivationLinkUrl: {
          deps: ["activationSendLinks"],
          fn: function fn(e) {
            var t = c._.findWhere(e, {
              name: "email"
            });

            return t ? t.href : null;
          }
        },
        sharedSecret: {
          deps: ["factor"],
          fn: function fn(e) {
            try {
              return e._embedded.activation.sharedSecret;
            } catch (e) {
              return null;
            }
          }
        },
        duoEnrollActivation: {
          deps: ["factor"],
          fn: function fn(e) {
            return e && e._embedded && e._embedded.activation ? e._embedded.activation : null;
          }
        },
        prevLink: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e._links && e._links.prev ? e._links.prev.href : null;
          }
        },
        skipLink: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e._links && e._links.skip ? e._links.skip.href : null;
          }
        },
        gracePeriodRemainingDays: {
          deps: ["policy"],
          fn: function fn(e) {
            return e && e.gracePeriod && e.gracePeriod.endDate ? i(e.gracePeriod.endDate) : null;
          }
        },
        user: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e._embedded && e._embedded.user ? e._embedded.user : null;
          }
        },
        recoveryQuestion: {
          deps: ["user"],
          fn: function fn(e) {
            return e && e.recovery_question ? e.recovery_question.question : null;
          }
        },
        userProfile: {
          deps: ["user"],
          fn: function fn(e) {
            return e && e.profile ? e.profile : null;
          }
        },
        userConsentName: {
          deps: ["userProfile", "username"],
          fn: function fn(e, t) {
            return !e || c._.isEmpty(e.firstName) ? t : c._.isEmpty(e.lastName) ? e.firstName : e.firstName + " " + e.lastName.charAt(0) + ".";
          }
        },
        userEmail: {
          deps: ["userProfile"],
          fn: function fn(e) {
            return e && e.login ? e.login : null;
          }
        },
        userFullName: {
          deps: ["userProfile"],
          fn: function fn(e) {
            return e && (e.firstName || e.lastName) ? e.firstName + " " + e.lastName : "";
          }
        },
        defaultAppLogo: {
          deps: ["baseUrl"],
          fn: function fn(e) {
            return e + "/img/logos/default.png";
          }
        },
        expiresAt: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e.expiresAt;
          }
        },
        target: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e._embedded ? e._embedded.target : null;
          }
        },
        targetLabel: {
          deps: ["target"],
          fn: function fn(e) {
            return e ? e.label : null;
          }
        },
        targetLogo: {
          deps: ["target"],
          fn: function fn(e) {
            return e && e._links ? e._links.logo : null;
          }
        },
        targetTermsOfService: {
          deps: ["target"],
          fn: function fn(e) {
            return e && e._links ? e._links["terms-of-service"] : null;
          }
        },
        targetPrivacyPolicy: {
          deps: ["target"],
          fn: function fn(e) {
            return e && e._links ? e._links["privacy-policy"] : null;
          }
        },
        targetClientURI: {
          deps: ["target"],
          fn: function fn(e) {
            return e && e._links ? e._links["client-uri"] : null;
          }
        },
        scopes: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e._embedded ? e._embedded.scopes : null;
          }
        },
        issuer: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            var t, n, r;
            return null === e || void 0 === e ? void 0 : null === (t = e._embedded) || void 0 === t ? void 0 : null === (n = t.authentication) || void 0 === n ? void 0 : null === (r = n.issuer) || void 0 === r ? void 0 : r.uri;
          }
        },
        hasExistingPhones: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            if (!e._embedded || !e._embedded.factors) return !1;

            var t = e._embedded.factors,
                n = c._.findWhere(t, {
              factorType: "sms",
              provider: "OKTA"
            });

            return !(!n || !n._embedded) && !!n._embedded.phones.length;
          }
        },
        hasExistingPhonesForCall: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            if (!e._embedded || !e._embedded.factors) return !1;

            var t = e._embedded.factors,
                n = c._.findWhere(t, {
              factorType: "call",
              provider: "OKTA"
            });

            return !(!n || !n._embedded) && !!n._embedded.phones.length;
          }
        },
        isUndefinedUser: {
          deps: ["securityImage"],
          fn: function fn(e) {
            return e === g;
          }
        },
        isNewUser: {
          deps: ["securityImage"],
          fn: function fn(e) {
            return e === v;
          }
        },
        allowRememberDevice: {
          deps: ["policy"],
          fn: function fn(e) {
            return e && e.allowRememberDevice;
          }
        },
        rememberDeviceLabel: {
          deps: ["policy"],
          fn: function fn(e) {
            if (e && e.rememberDeviceLifetimeInMinutes > 0) {
              var t = o(e.rememberDeviceLifetimeInMinutes);
              return (0, c.loc)("rememberDevice.timebased", "login", [t]);
            }

            return e && 0 === e.rememberDeviceLifetimeInMinutes ? (0, c.loc)("rememberDevice.devicebased", "login") : (0, c.loc)("rememberDevice", "login");
          }
        },
        rememberDeviceByDefault: {
          deps: ["policy"],
          fn: function fn(e) {
            return e && e.rememberDeviceByDefault;
          }
        },
        factorsPolicyInfo: {
          deps: ["policy"],
          fn: function fn(e) {
            return e && e.factorsPolicyInfo ? e.factorsPolicyInfo : null;
          }
        },
        verifyCustomFactorRedirectUrl: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e._links && e._links.next && "redirect" === e._links.next.name && e._links.next.href ? e._links.next.href : null;
          }
        },
        enrollCustomFactorRedirectUrl: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e._links && e._links.next && "activate" === e._links.next.name && e._links.next.href ? e._links.next.href : null;
          }
        },
        isFactorResultFailed: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return "FAILED" === e.factorResult;
          }
        },
        factorResultErrorMessage: {
          deps: ["lastAuthResponse", "isFactorResultFailed"],
          fn: function fn(e, t) {
            return t ? e.factorResultMessage || (0, c.loc)("oform.error.unexpected", "login") : null;
          }
        },
        deviceActivationStatus: {
          deps: ["lastAuthResponse"],
          fn: function fn(e) {
            return e._embedded ? e._embedded.deviceActivationStatus : null;
          }
        }
      },
      parse: function parse(e) {
        return this.settings = e.settings, c._.extend(c._.omit(e, "settings"), {
          languageCode: this.settings.get("languageCode"),
          userCountryCode: this.settings.get("countryCode")
        });
      }
    });
    t.default = E;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          return '<div class="beacon-blank"></div><div class="bg-helper auth-beacon auth-beacon-security" data-se="loading-beacon"><div class="okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border"></div></div>';
        },
        useData: !0
      }),
      equals: function equals(e) {
        return e && this instanceof e;
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(115)),
        s = r(n(16)),
        l = r(n(15)),
        u = r(n(573)),
        c = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="beacon-blank auth-beacon"><div class="beacon-blank js-blank-beacon-border auth-beacon-border"></div></div><div class="bg-helper auth-beacon auth-beacon-factor ' + e.escapeExpression((i = null != (i = a(n, "className") || (null != t ? a(t, "className") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "className",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 171
              },
              end: {
                line: 1,
                column: 184
              }
            }
          }) : i)) + '" data-se="factor-beacon"><div class="okta-sign-in-beacon-border auth-beacon-border"></div></div><div data-type="factor-types-dropdown" class="factors-dropdown-wrap"></div>';
        },
        useData: !0
      }),
      events: {
        "click .auth-beacon-factor": function clickAuthBeaconFactor(e) {
          e.preventDefault(), e.stopPropagation();
          var t = this.$(".dropdown .options").toggle().is(":visible");
          this.$("a.option-selected").attr("aria-expanded", t), t && this.$("#okta-dropdown-options").find("li.factor-option:first a").focus();
        }
      },
      initialize: function initialize() {
        this.options.appState.set("beaconType", "factor");
      },
      getTemplateData: function getTemplateData() {
        var e,
            t,
            n = this.options.appState.get("factors");
        return e = n ? l.default.findFactorInFactorsArray(n, this.options.provider, this.options.factorType) : new a.default.Model(this.options.appState.get("factor")), t = e.get("iconClassName"), {
          className: t || ""
        };
      },
      postRender: function postRender() {
        this.options.animate && this.$(".auth-beacon-factor").fadeIn(200), this.options.appState.get("hasMultipleFactorsAvailable") && this.add(u.default, '[data-type="factor-types-dropdown"]');
      },
      fadeOut: function fadeOut() {
        var e = s.default.defer();
        return this.$(".auth-beacon-factor").fadeOut(200, function () {
          e.resolve();
        }), e.promise;
      },
      equals: function equals(e, t) {
        return e && this instanceof e && t.provider === this.options.provider && (t.factorType === this.options.factorType || l.default.isOktaVerify(t.provider, t.factorType) && l.default.isOktaVerify(this.options.provider, this.options.factorType));
      }
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(15)),
        a = r(n(115)),
        s = r(n(574)),
        l = o.internal.views.components.BaseDropDown;
    (0, o.$)(document).click(function (e) {
      var t = (0, o.$)(e.target);
      t.closest(".option-selected").length > 0 && t.closest(".dropdown").length > 0 || ((0, o.$)(".dropdown .options").hide(), (0, o.$)(".dropdown a.option-selected").attr("aria-expanded", !1));
    });
    var u = l.extend({
      className: "bg-helper icon-button",
      screenReaderText: function screenReaderText() {
        var e,
            t,
            n = this.options.appState.get("factors");
        return e = n ? i.default.findFactorInFactorsArray(n, this.options.provider, this.options.factorType) : new a.default.Model(this.options.appState.get("factor"), this.toJSON()), t = e.get("factorLabel"), (0, o.loc)("mfa.factors.dropdown.sr.text", "login", [t]);
      },
      events: {
        "click a.option-selected": function clickAOptionSelected(e) {
          if (e.preventDefault(), o._.result(this, "disabled")) e.stopPropagation();else {
            var t = this.$(".options").toggle().is(":visible");
            this.$("a.option-selected").attr("aria-expanded", t), t && this.$("#okta-dropdown-options").find("li.factor-option:first a").focus();
          }
        },
        "click .dropdown-disabled": function clickDropdownDisabled(e) {
          e.preventDefault(), e.stopPropagation();
        }
      },
      initialize: function initialize() {
        this.addOption(s.default.getDropdownOption("TITLE"));
        var e = this.options.appState.get("factors"),
            t = e.hasMultipleFactorsOfSameType("push");
        e.each(function (e) {
          "token:software:totp" === e.get("factorType") && t || (this.addOption(s.default.getDropdownOption(e.get("factorName")), {
            model: e
          }), this.listenTo(this.last(), "options:toggle", function () {
            this.$(".options").hide(), this.$("a.option-selected").attr("aria-expanded", !1);
          }));
        }, this);
      }
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = r(n(39)),
        l = i.default.template({
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, i) {
        var a,
            s,
            l = null != t ? t : e.nullContext || {},
            u = e.hooks.helperMissing,
            c = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return e.escapeExpression((s = null != (s = c(n, "factorName") || (null != t ? c(t, "factorName") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
          name: "factorName",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 0
            },
            end: {
              line: 1,
              column: 14
            }
          }
        }) : s)) + " (" + (null != (s = null != (s = c(n, "deviceName") || (null != t ? c(t, "deviceName") : t)) ? s : u, a = "function" === (0, o.default)(s) ? s.call(l, {
          name: "deviceName",
          hash: {},
          data: i,
          loc: {
            start: {
              line: 1,
              column: 16
            },
            end: {
              line: 1,
              column: 32
            }
          }
        }) : s) ? a : "") + ")";
      },
      useData: !0
    }),
        u = function u(e) {
      var t,
          n = e.get("factorType"),
          r = this.options.appState.get("factors");
      r.hasMultipleFactorsOfSameType(n) && (t = r.getFactorIndex(n, e.get("id")));
      var o = s.default.createVerifyUrl(e.get("provider"), n, t),
          i = this;
      this.options.appState.trigger("factorSwitched"), this.model.manageTransaction(function (e, t) {
        if ("FACTOR_CHALLENGE" === e.status && this.options.appState.set("trapMfaRequiredResponse", !0), "MFA_CHALLENGE" === e.status && e.prev) return this.options.appState.set("trapMfaRequiredResponse", !0), e.prev().then(function (e) {
          i.trigger("options:toggle"), t(e), i.options.appState.trigger("navigate", o);
        });
        i.trigger("options:toggle"), i.options.appState.trigger("navigate", o);
      });
    },
        c = {
      TITLE: {
        title: a._.partial(a.loc, "mfa.factors.dropdown.title", "login"),
        className: "dropdown-list-title",
        disabled: !0
      },
      OKTA_VERIFY: {
        icon: "factor-icon mfa-okta-verify-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      OKTA_VERIFY_PUSH: {
        icon: "factor-icon mfa-okta-verify-30",
        className: "factor-option",
        title: function title() {
          return l({
            factorName: this.model.get("factorLabel"),
            deviceName: this.model.get("deviceName")
          });
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      GOOGLE_AUTH: {
        icon: "factor-icon mfa-google-auth-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      CUSTOM_HOTP: {
        icon: "factor-icon mfa-hotp-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      SYMANTEC_VIP: {
        icon: "factor-icon mfa-symantec-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      RSA_SECURID: {
        icon: "factor-icon mfa-rsa-30",
        className: "factor-option",
        title: a._.partial(a.loc, "factor.totpHard.rsaSecurId", "login"),
        action: function action() {
          u.call(this, this.model);
        }
      },
      ON_PREM: {
        icon: "factor-icon mfa-onprem-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      DUO: {
        icon: "factor-icon mfa-duo-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      DUO_PUSH: {
        icon: "duo-push-16",
        className: "suboption factor-option",
        title: a._.partial(a.loc, "mfa.duoSecurity.push", "login", ["XXX-XXX-7890"])
      },
      DUO_SMS: {
        icon: "duo-sms-16",
        className: "suboption factor-option",
        title: a._.partial(a.loc, "mfa.duoSecurity.sms", "login", ["XXX-XXX-7890"])
      },
      DUO_CALL: {
        icon: "duo-call-16",
        className: "suboption factor-option",
        title: a._.partial(a.loc, "mfa.duoSecurity.call", "login", ["XXX-XXX-7890"])
      },
      YUBIKEY: {
        icon: "factor-icon mfa-yubikey-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      SMS: {
        icon: "factor-icon mfa-sms-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      CALL: {
        icon: "factor-icon mfa-call-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      QUESTION: {
        icon: "factor-icon mfa-question-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      PASSWORD: {
        icon: "factor-icon mfa-password-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      WINDOWS_HELLO: {
        icon: "factor-icon mfa-windows-hello-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      U2F: {
        icon: "factor-icon mfa-u2f-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      WEBAUTHN: {
        icon: "factor-icon mfa-webauthn-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      EMAIL: {
        icon: "factor-icon mfa-email-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      GENERIC_SAML: {
        icon: "factor-icon mfa-custom-factor-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      GENERIC_OIDC: {
        icon: "factor-icon mfa-custom-factor-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      },
      CUSTOM_CLAIMS: {
        icon: "factor-icon mfa-custom-factor-30",
        className: "factor-option",
        title: function title() {
          return this.model.get("factorLabel");
        },
        action: function action() {
          u.call(this, this.model);
        }
      }
    },
        d = {
      getDropdownOption: function getDropdownOption(e) {
        return c[e];
      }
    };

    t.default = d;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      className: "piv-beacon",
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          return '<div class="beacon-blank auth-beacon"><div class="beacon-blank js-blank-beacon-border auth-beacon-border"></div></div><div class="bg-helper auth-beacon smartcard" data-se="piv-beacon"><div class="okta-sign-in-beacon-border auth-beacon-border"></div></div>';
        },
        useData: !0
      }),
      equals: function equals(e) {
        return e && this instanceof e;
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        o = r(n(577)),
        i = r(n(195)),
        a = r(n(846)),
        s = r(n(847));
    e.exports = o.default.extend({
      routes: {
        "": "defaultAuth",
        "signin/register": "renderRegister",
        "signin/forgot-password": "renderForgotPassword",
        "*wildcard": "defaultAuth"
      },
      defaultAuth: function defaultAuth() {
        this.render(i.default);
      },
      renderRegister: function renderRegister() {
        this.render(a.default);
      },
      renderForgotPassword: function renderForgotPassword() {
        this.render(s.default);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = n(1),
        i = r(n(275)),
        a = r(n(72)),
        s = r(n(25)),
        l = r(n(280)),
        u = r(n(5)),
        c = r(n(24)),
        d = r(n(38)),
        f = r(n(578)),
        p = r(n(277)),
        h = r(n(278)),
        m = r(n(579)),
        g = r(n(160)),
        v = n(282),
        y = r(n(768)),
        b = n(8),
        _ = o.Router.extend({
      Events: o.Backbone.Events,
      initialize: function initialize(e) {
        e.globalSuccessFn || (e.globalSuccessFn = function () {}), e.globalErrorFn || (e.globalErrorFn = function (e) {
          d.default.error(e);
        }), this.settings = new i.default(o._.omit(e, "el", "authClient"), {
          parse: !0
        }), this.settings.setAuthClient(e.authClient), e.el || this.settings.callGlobalError(new c.default.ConfigError((0, o.loc)("error.required.el"))), (0, o.$)("body > div").on("click", function () {}), this.appState = new m.default();
        var t = new p.default({
          appState: this.appState
        });
        (0, o.$)(e.el).append(t.render().$el), this.el = "#".concat(u.default.WIDGET_CONTAINER_ID), this.header = new h.default({
          el: this.el,
          appState: this.appState,
          settings: this.settings
        }), (0, v.configIdxJsClient)(this.appState), this.listenTo(this.appState, "remediationSuccess", this.handleIdxResponseSuccess), this.listenTo(this.appState, "remediationError", this.handleIdxResponseFailure);
      },
      handleIdxResponseSuccess: function handleIdxResponseSuccess(e) {
        if (e.interactionCode) return g.default.removeStateHandle(), (0, v.interactionCodeFlow)(this.settings, e);
        var t = this.appState.get("idx");

        if (t) {
          var n;
          g.default.setStateHandle(null === e || void 0 === e ? void 0 : null === (n = e.context) || void 0 === n ? void 0 : n.stateHandle);
        }

        this.appState.get("currentFormName") === b.FORMS.CANCEL_TRANSACTION && g.default.removeStateHandle();
        var r = (0, y.default)(this.settings, e, t);
        this.appState.setIonResponse(r);
      },
      handleIdxResponseFailure: function handleIdxResponseFailure() {
        var e,
            t,
            n,
            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};

        if ("access_denied" === (null === (e = r) || void 0 === e ? void 0 : e.error) && r.error_description) {
          var i = {
            messages: {
              type: "array",
              value: [{
                message: r.error_description,
                i18n: {
                  key: "oie.feature.disabled"
                },
                class: "ERROR"
              }]
            }
          };
          r = Object.assign({
            details: {
              rawIdxState: i,
              context: i,
              neededToProceed: []
            }
          }, r);
        }

        if (null === (t = r) || void 0 === t ? void 0 : null === (n = t.details) || void 0 === n ? void 0 : n.rawIdxState) {
          if (!r.details.rawIdxState.messages) {
            var a = {
              type: "array",
              value: [{
                message: (0, o.loc)("oform.error.unexpected", "login"),
                class: "ERROR"
              }]
            };
            r.details.rawIdxState.messages = a, r.details.context = {
              messages: a
            };
          }

          return this.handleIdxResponseSuccess(r.details);
        }

        this.settings.callGlobalError(new c.default.ConfigError(r));
      },
      render: function render(e) {
        var t = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (g.default.getLastInitiatedLoginUrl() !== window.location.href && g.default.removeStateHandle(), this.header.rendered() || (this.el = this.header.render().getContentEl()), !a.default.isLoaded(this.settings.get("languageCode"))) return f.default.loadLanguage(this.appState, this.settings).done(function () {
          t.render(e, n);
        });
        if (this.settings.get("oieEnabled")) return (0, v.startLoginFlow)(this.settings).then(function (r) {
          t.settings.unset("stateToken"), t.settings.unset("proxyIdxResponse"), t.settings.unset("useInteractionCodeFlow"), t.appState.trigger("remediationSuccess", r), t.render(e, n);
        }).catch(function (r) {
          t.settings.unset("stateToken"), t.settings.unset("proxyIdxResponse"), t.settings.unset("useInteractionCodeFlow"), t.appState.trigger("remediationError", r.error || r), t.render(e, n);
        });

        if (this.settings.get("colors.brand") && !l.default.isLoaded()) {
          var r = {
            brand: this.settings.get("colors.brand")
          };
          l.default.addStyle(r);
        }

        this.unload();

        var i = o._.extend({
          el: this.el,
          settings: this.settings,
          appState: this.appState
        }, n);

        this.controller = new e(i), this.listenTo(this.controller, "all", this.trigger), this.controller.render();
      },
      start: function start() {
        var e = s.default.supportsPushState();
        o.Router.prototype.start.call(this, {
          pushState: e
        });
      },
      hide: function hide() {
        this.header.$el.hide();
      },
      show: function show() {
        this.header.$el.show();
      },
      remove: function remove() {
        this.unload(), this.header.$el.remove(), this.stopListening(this.appState), this.stopListening(this.settings), a.default.remove(), o.Backbone.history.stop();
      }
    });

    t.default = _;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = t.get("languageCode"),
          r = t.get("i18n"),
          o = t.get("assets.baseUrl"),
          a = t.get("assets.rewrite"),
          s = setTimeout(function () {
        e.trigger("loading", !0);
      }, 200);
      return i.default.loadLanguage(n, r, {
        baseUrl: o,
        rewrite: a
      }).then(function () {
        clearTimeout(s), e.trigger("loading", !1);
      });
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = o(n(72)),
        a = {
      loadLanguage: r
    };
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(119)),
        i = n(1),
        a = r(n(38)),
        s = n(8),
        l = n(281),
        u = n(583),
        c = i.Model.extend({
      local: {
        introspectSuccess: "object",
        introspectError: "object",
        user: "object",
        currentFormName: "string",
        idx: "object",
        remediations: "array",
        dynamicRefreshInterval: "number",
        deviceFingerprint: "string"
      },
      derived: {
        authenticatorProfile: {
          deps: ["currentAuthenticator", "currentAuthenticatorEnrollment"],
          fn: function fn() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return e.profile || t.profile || {};
          }
        },
        authenticatorKey: {
          deps: ["currentAuthenticator", "currentAuthenticatorEnrollment"],
          fn: function fn() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return e.key || t.key || "";
          }
        },
        authenticatorMethodType: {
          deps: ["currentAuthenticator", "currentAuthenticatorEnrollment"],
          fn: function fn() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return e.methods && e.methods[0].type || t.methods && t.methods[0].type || "";
          }
        },
        isPasswordRecovery: {
          deps: ["recoveryAuthenticator"],
          fn: function fn() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return "password" === (null === e || void 0 === e ? void 0 : e.type);
          }
        }
      },
      isIdentifierOnlyView: function isIdentifierOnlyView() {
        var e, t, n;
        return !(null === (e = this.get("remediations")) || void 0 === e ? void 0 : null === (t = e.find(function (e) {
          return "identify" === e.name;
        })) || void 0 === t ? void 0 : null === (n = t.uiSchema) || void 0 === n ? void 0 : n.find(function (e) {
          return "credentials.passcode" === e.name;
        }));
      },
      hasRemediationObject: function hasRemediationObject(e) {
        return this.get("idx").neededToProceed.find(function (t) {
          return t.name === e;
        });
      },
      getRemediationAuthenticationOptions: function getRemediationAuthenticationOptions(e) {
        var t = this.hasRemediationObject(e);
        if (!t) return [];
        var n = t.value.find(function (e) {
          return "authenticator" === e.name;
        }),
            r = (null === n || void 0 === n ? void 0 : n.options) || [];
        return r = (0, o.default)(r), (0, l.createOVOptions)(r), r;
      },
      getActionByPath: function getActionByPath(e) {
        var t,
            n = e.split(".");
        t = 1 === n.length ? this.get("idx").actions : this.get(n.shift());
        var r = n.shift();
        return t && u._.isFunction(t[r]) ? t[r] : null;
      },
      getCurrentViewState: function getCurrentViewState() {
        var e = this.get("currentFormName");

        if (e) {
          var t = this.get("remediations").filter(function (t) {
            return t.name === e;
          })[0];

          if (!t) {
            a.default.error("Panic!!"), a.default.error("\tCannot find view state for form ".concat(e, "."));
            var n = this.get("remediations").map(function (e) {
              return e.name;
            });
            a.default.error("\tAll available form names: ".concat(n));
          }

          return t;
        }
      },
      getAuthenticatorDisplayName: function getAuthenticatorDisplayName() {
        var e = this.get("currentAuthenticator") || {},
            t = this.get("currentAuthenticatorEnrollment") || {};
        return e.displayName || t.displayName;
      },
      isAuthenticatorChallenge: function isAuthenticatorChallenge() {
        var e = this.get("currentFormName");
        return s.FORMS_FOR_VERIFICATION.includes(e);
      },
      shouldReRenderView: function shouldReRenderView(e) {
        var t = this.has("idx") ? this.get("idx").rawIdxState : null,
            n = u._.isEqual(u._.nestedOmit(e.idx.rawIdxState, ["expiresAt", "refresh", "stateHandle"]), u._.nestedOmit(t, ["expiresAt", "refresh", "stateHandle"])),
            r = u._.isEqual(u._.nestedOmit(e.idx.rawIdxState, ["expiresAt", "stateHandle"]), u._.nestedOmit(t, ["expiresAt", "stateHandle"]));

        n && !r && this.set("dynamicRefreshInterval", this.getRefreshInterval(e));
        var o = !0;
        return n && (o = !1), n && "poll" === this.get("currentFormName") && (o = !0), n && s.FORMS_WITH_STATIC_BACK_LINK.includes(this.get("currentFormName")) && (o = !0), o;
      },
      getRefreshInterval: function getRefreshInterval(e) {
        var t,
            n,
            r,
            o,
            i = this.get("currentFormName");
        return e.remediations.filter(function (e) {
          return e.name === i;
        })[0].refresh || (null === (t = e.currentAuthenticatorEnrollment) || void 0 === t ? void 0 : null === (n = t.poll) || void 0 === n ? void 0 : n.refresh) || (null === (r = e.currentAuthenticator) || void 0 === r ? void 0 : null === (o = r.poll) || void 0 === o ? void 0 : o.refresh);
      },
      shouldShowSignOutLinkInCurrentForm: function shouldShowSignOutLinkInCurrentForm(e) {
        var t = this.get("idx") && this.get("idx").actions,
            n = this.get("currentFormName");
        return !e && u._.isFunction(null === t || void 0 === t ? void 0 : t.cancel) && !s.FORMS_WITHOUT_SIGNOUT.includes(n);
      },
      containsMessageWithI18nKey: function containsMessageWithI18nKey(e) {
        Array.isArray(e) || (e = [e]);
        var t = this.get("messages");
        return t && Array.isArray(t.value) && t.value.some(function (t) {
          var n;
          return u._.contains(e, null === (n = t.i18n) || void 0 === n ? void 0 : n.key);
        });
      },
      containsMessageStartingWithI18nKey: function containsMessageStartingWithI18nKey(e) {
        var t = this.get("messages");
        return t && Array.isArray(t.value) && t.value.some(function (t) {
          var n;
          return null === (n = t.i18n) || void 0 === n ? void 0 : n.key.startsWith(e);
        });
      },
      clearAppStateCache: function clearAppStateCache() {
        this.clear({
          silent: !0
        }), this.trigger("cache:clear");
      },
      setIonResponse: function setIonResponse(e) {
        if (this.shouldReRenderView(e)) {
          var t = null;
          u._.isEmpty(e.remediations) ? (a.default.error("Panic!!"), a.default.error("\tNo remediation found."), a.default.error("\tHere is the entire response"), a.default.error(JSON.stringify(e, null, 2))) : t = e.remediations[0].name, this.clearAppStateCache(), this.set(e), this.set({
            currentFormName: t
          });
        }
      }
    });
    t.default = c;
  }, function (e, t, n) {
    function r(e) {
      if (Array.isArray(e)) return o(e);
    }

    var o = n(254);
    e.exports = r;
  }, function (e, t) {
    function n(e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }

    e.exports = n;
  }, function (e, t) {
    function n() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "_", {
      enumerable: !0,
      get: function get() {
        return i._;
      }
    });
    var o = r(n(10)),
        i = n(1);

    i._.mixin({
      nestedOmit: function nestedOmit(e, t) {
        var n = i._.omit(e, t);

        return t.includes(n.name) && (n = i._.omit(n, "value")), i._.each(n, function (e, r) {
          Array.isArray(e) ? n[r] = e.map(function (e) {
            return i._.nestedOmit(e, t);
          }) : "object" === (0, o.default)(e) && (n[r] = i._.nestedOmit(e, t));
        }), n;
      }
    });
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return o.apply(this, arguments);
    }

    function o() {
      return o = (0, s.default)(a.default.mark(function e(t, n) {
        var r, o, i, s, f, p, h, m, g;
        return a.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (r = n.interactionCode, o = t.getAuthClient(), i = o.transactionManager.load(), s = o.options.state || i.state, f = "remediation" === t.get("mode"), f && (0, d.clearTransactionMeta)(t), !(p = "always" === t.get("redirect"))) {
                  e.next = 14;
                  break;
                }

                if (h = t.get("redirectUri")) {
                  e.next = 11;
                  break;
                }

                throw new u.default.ConfigError('"redirectUri" is required');

              case 11:
                return m = (0, c.toQueryString)({
                  interaction_code: r,
                  state: s
                }), window.location.assign(h + m), e.abrupt("return");

              case 14:
                if (!f) {
                  e.next = 17;
                  break;
                }

                return t.callGlobalSuccess(l.default.SUCCESS, {
                  interaction_code: r,
                  state: s
                }), e.abrupt("return");

              case 17:
                return g = i.codeVerifier, e.abrupt("return", o.token.exchangeCodeForTokens({
                  codeVerifier: g,
                  interactionCode: r
                }).then(function (e) {
                  var n = e.tokens;
                  t.callGlobalSuccess(l.default.SUCCESS, {
                    tokens: n
                  });
                }).catch(function (e) {
                  t.callGlobalError(e);
                }).finally(function () {
                  (0, d.clearTransactionMeta)(t);
                }));

              case 19:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), o.apply(this, arguments);
    }

    var i = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.interactionCodeFlow = r;
    var a = i(n(57)),
        s = i(n(58)),
        l = i(n(5)),
        u = i(n(24)),
        c = n(250),
        d = n(161);
  }, function (e, t, n) {
    var r = n(284);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(9),
        o = n(26);
    r({
      target: "Object",
      stat: !0,
      forced: !o,
      sham: !o
    }, {
      defineProperty: n(48).f
    });
  }, function (e, t, n) {
    /**
    * Copyright (c) 2014-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    var r = function (e) {
      "use strict";

      function t(e, t, n, o) {
        var i = t && t.prototype instanceof r ? t : r,
            a = Object.create(i.prototype),
            s = new f(o || []);
        return a._invoke = l(e, n, s), a;
      }

      function n(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      function r() {}

      function o() {}

      function i() {}

      function a(e) {
        ["next", "throw", "return"].forEach(function (t) {
          e[t] = function (e) {
            return this._invoke(t, e);
          };
        });
      }

      function s(e, t) {
        function r(o, i, a, s) {
          var l = n(e[o], e, i);

          if ("throw" !== l.type) {
            var u = l.arg,
                c = u.value;
            return c && "object" == typeof c && v.call(c, "__await") ? t.resolve(c.__await).then(function (e) {
              r("next", e, a, s);
            }, function (e) {
              r("throw", e, a, s);
            }) : t.resolve(c).then(function (e) {
              u.value = e, a(u);
            }, function (e) {
              return r("throw", e, a, s);
            });
          }

          s(l.arg);
        }

        function o(e, n) {
          function o() {
            return new t(function (t, o) {
              r(e, n, t, o);
            });
          }

          return i = i ? i.then(o, o) : o();
        }

        var i;
        this._invoke = o;
      }

      function l(e, t, r) {
        var o = E;
        return function (i, a) {
          if (o === S) throw new Error("Generator is already running");

          if (o === x) {
            if ("throw" === i) throw a;
            return h();
          }

          for (r.method = i, r.arg = a;;) {
            var s = r.delegate;

            if (s) {
              var l = u(s, r);

              if (l) {
                if (l === T) continue;
                return l;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (o === E) throw o = x, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            o = S;
            var c = n(e, t, r);

            if ("normal" === c.type) {
              if (o = r.done ? x : O, c.arg === T) continue;
              return {
                value: c.arg,
                done: r.done
              };
            }

            "throw" === c.type && (o = x, r.method = "throw", r.arg = c.arg);
          }
        };
      }

      function u(e, t) {
        var r = e.iterator[t.method];

        if (r === m) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = m, u(e, t), "throw" === t.method)) return T;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return T;
        }

        var o = n(r, e.iterator, t.arg);
        if ("throw" === o.type) return t.method = "throw", t.arg = o.arg, t.delegate = null, T;
        var i = o.arg;
        return i ? i.done ? (t[e.resultName] = i.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = m), t.delegate = null, T) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, T);
      }

      function c(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function d(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function f(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(c, this), this.reset(!0);
      }

      function p(e) {
        if (e) {
          var t = e[b];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;

          if (!isNaN(e.length)) {
            var n = -1,
                r = function t() {
              for (; ++n < e.length;) {
                if (v.call(e, n)) return t.value = e[n], t.done = !1, t;
              }

              return t.value = m, t.done = !0, t;
            };

            return r.next = r;
          }
        }

        return {
          next: h
        };
      }

      function h() {
        return {
          value: m,
          done: !0
        };
      }

      var m,
          g = Object.prototype,
          v = g.hasOwnProperty,
          y = "function" == typeof Symbol ? Symbol : {},
          b = y.iterator || "@@iterator",
          _ = y.asyncIterator || "@@asyncIterator",
          w = y.toStringTag || "@@toStringTag";

      e.wrap = t;
      var E = "suspendedStart",
          O = "suspendedYield",
          S = "executing",
          x = "completed",
          T = {},
          k = {};

      k[b] = function () {
        return this;
      };

      var C = Object.getPrototypeOf,
          A = C && C(C(p([])));
      A && A !== g && v.call(A, b) && (k = A);
      var N = i.prototype = r.prototype = Object.create(k);
      return o.prototype = N.constructor = i, i.constructor = o, i[w] = o.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === o || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, i) : (e.__proto__ = i, w in e || (e[w] = "GeneratorFunction")), e.prototype = Object.create(N), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, a(s.prototype), s.prototype[_] = function () {
        return this;
      }, e.AsyncIterator = s, e.async = function (n, r, o, i, a) {
        void 0 === a && (a = Promise);
        var l = new s(t(n, r, o, i), a);
        return e.isGeneratorFunction(r) ? l : l.next().then(function (e) {
          return e.done ? e.value : l.next();
        });
      }, a(N), N[w] = "Generator", N[b] = function () {
        return this;
      }, N.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];

        for (var n in e) {
          t.push(n);
        }

        return t.reverse(), function n() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return n.value = r, n.done = !1, n;
          }

          return n.done = !0, n;
        };
      }, e.values = p, f.prototype = {
        constructor: f,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = m, this.done = !1, this.delegate = null, this.method = "next", this.arg = m, this.tryEntries.forEach(d), !e) for (var t in this) {
            "t" === t.charAt(0) && v.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = m);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0],
              t = e.completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          function t(t, r) {
            return i.type = "throw", i.arg = e, n.next = t, r && (n.method = "next", n.arg = m), !!r;
          }

          if (this.done) throw e;

          for (var n = this, r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r],
                i = o.completion;
            if ("root" === o.tryLoc) return t("end");

            if (o.tryLoc <= this.prev) {
              var a = v.call(o, "catchLoc"),
                  s = v.call(o, "finallyLoc");

              if (a && s) {
                if (this.prev < o.catchLoc) return t(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return t(o.finallyLoc);
              } else if (a) {
                if (this.prev < o.catchLoc) return t(o.catchLoc, !0);
              } else {
                if (!s) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return t(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var r = this.tryEntries[n];

            if (r.tryLoc <= this.prev && v.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
              var o = r;
              break;
            }
          }

          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var i = o ? o.completion : {};
          return i.type = e, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, T) : this.complete(i);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), T;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), d(n), T;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];

            if (n.tryLoc === e) {
              var r = n.completion;

              if ("throw" === r.type) {
                var o = r.arg;
                d(n);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, n) {
          return this.delegate = {
            iterator: p(e),
            resultName: t,
            nextLoc: n
          }, "next" === this.method && (this.arg = m), T;
        }
      }, e;
    }(e.exports);

    try {
      regeneratorRuntime = r;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(r);
    }
  }, function (e, t, n) {
    e.exports = n(589);
  }, function (e, t, n) {
    var r = n(287);
    e.exports = r;
  }, function (e, t, n) {
    n(591);
    var r = n(60);
    e.exports = r("Array").indexOf;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(288).indexOf,
        i = n(290),
        a = n(82),
        s = [].indexOf,
        l = !!s && 1 / [1].indexOf(1, -0) < 0,
        u = i("indexOf"),
        c = a("indexOf", {
      ACCESSORS: !0,
      1: 0
    });
    r({
      target: "Array",
      proto: !0,
      forced: l || !u || !c
    }, {
      indexOf: function indexOf(e) {
        return l ? s.apply(this, arguments) || 0 : o(this, e, arguments.length > 1 ? arguments[1] : void 0);
      }
    });
  }, function (e, t, n) {
    var r = n(291);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(19),
        o = n(294),
        i = r.WeakMap;
    e.exports = "function" == typeof i && /native code/.test(o(i));
  }, function (e, t, n) {
    var r = n(19),
        o = n(44);

    e.exports = function (e, t) {
      try {
        o(r, e, t);
      } catch (n) {
        r[e] = t;
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(20);
    e.exports = !r(function () {
      function e() {}

      return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(173),
        o = n(83);
    e.exports = r ? {}.toString : function () {
      return "[object " + o(this) + "]";
    };
  }, function (e, t, n) {
    var r = n(35);

    e.exports = function (e) {
      if (!r(e) && null !== e) throw TypeError("Can't set " + String(e) + " as a prototype");
      return e;
    };
  }, function (e, t) {
    e.exports = {
      CSSRuleList: 0,
      CSSStyleDeclaration: 0,
      CSSValueList: 0,
      ClientRectList: 0,
      DOMRectList: 0,
      DOMStringList: 0,
      DOMTokenList: 1,
      DataTransferItemList: 0,
      FileList: 0,
      HTMLAllCollection: 0,
      HTMLCollection: 0,
      HTMLFormElement: 0,
      HTMLSelectElement: 0,
      MediaList: 0,
      MimeTypeArray: 0,
      NamedNodeMap: 0,
      NodeList: 1,
      PaintRequestList: 0,
      Plugin: 0,
      PluginArray: 0,
      SVGLengthList: 0,
      SVGNumberList: 0,
      SVGPathSegList: 0,
      SVGPointList: 0,
      SVGStringList: 0,
      SVGTransformList: 0,
      SourceBufferList: 0,
      StyleSheetList: 0,
      TextTrackCueList: 0,
      TextTrackList: 0,
      TouchList: 0
    };
  }, function (e, t, n) {
    "use strict";

    var r,
        o,
        i,
        a,
        s = n(9),
        l = n(63),
        u = n(19),
        c = n(45),
        d = n(304),
        f = n(66),
        p = n(305),
        h = n(51),
        m = n(600),
        g = n(35),
        v = n(79),
        y = n(175),
        b = n(77),
        _ = n(294),
        w = n(98),
        E = n(308),
        O = n(309),
        S = n(310).set,
        x = n(601),
        T = n(313),
        k = n(602),
        C = n(100),
        A = n(125),
        N = n(62),
        P = n(286),
        R = n(14),
        I = n(176),
        M = R("species"),
        j = "Promise",
        L = N.get,
        D = N.set,
        F = N.getterFor(j),
        _U = d,
        B = u.TypeError,
        V = u.document,
        H = u.process,
        q = c("fetch"),
        W = C.f,
        z = W,
        $ = "process" == b(H),
        K = !!(V && V.createEvent && u.dispatchEvent),
        G = P(j, function () {
      if (_(_U) === String(_U)) {
        if (66 === I) return !0;
        if (!$ && "function" != typeof PromiseRejectionEvent) return !0;
      }

      if (l && !_U.prototype.finally) return !0;
      if (I >= 51 && /native code/.test(_U)) return !1;

      var e = _U.resolve(1),
          t = function t(e) {
        e(function () {}, function () {});
      },
          n = e.constructor = {};

      return n[M] = t, !(e.then(function () {}) instanceof t);
    }),
        Y = G || !E(function (e) {
      _U.all(e).catch(function () {});
    }),
        J = function J(e) {
      var t;
      return !(!g(e) || "function" != typeof (t = e.then)) && t;
    },
        Q = function Q(e, t, n) {
      if (!t.notified) {
        t.notified = !0;
        var r = t.reactions;
        x(function () {
          for (var o = t.value, i = 1 == t.state, a = 0; r.length > a;) {
            var s,
                l,
                u,
                c = r[a++],
                d = i ? c.ok : c.fail,
                f = c.resolve,
                p = c.reject,
                h = c.domain;

            try {
              d ? (i || (2 === t.rejection && te(e, t), t.rejection = 1), !0 === d ? s = o : (h && h.enter(), s = d(o), h && (h.exit(), u = !0)), s === c.promise ? p(B("Promise-chain cycle")) : (l = J(s)) ? l.call(s, f, p) : f(s)) : p(o);
            } catch (e) {
              h && !u && h.exit(), p(e);
            }
          }

          t.reactions = [], t.notified = !1, n && !t.rejection && Z(e, t);
        });
      }
    },
        X = function X(e, t, n) {
      var r, o;
      K ? (r = V.createEvent("Event"), r.promise = t, r.reason = n, r.initEvent(e, !1, !0), u.dispatchEvent(r)) : r = {
        promise: t,
        reason: n
      }, (o = u["on" + e]) ? o(r) : "unhandledrejection" === e && k("Unhandled promise rejection", n);
    },
        Z = function Z(e, t) {
      S.call(u, function () {
        var n,
            r = t.value,
            o = ee(t);
        if (o && (n = A(function () {
          $ ? H.emit("unhandledRejection", r, e) : X("unhandledrejection", e, r);
        }), t.rejection = $ || ee(t) ? 2 : 1, n.error)) throw n.value;
      });
    },
        ee = function ee(e) {
      return 1 !== e.rejection && !e.parent;
    },
        te = function te(e, t) {
      S.call(u, function () {
        $ ? H.emit("rejectionHandled", e) : X("rejectionhandled", e, t.value);
      });
    },
        ne = function ne(e, t, n, r) {
      return function (o) {
        e(t, n, o, r);
      };
    },
        re = function re(e, t, n, r) {
      t.done || (t.done = !0, r && (t = r), t.value = n, t.state = 2, Q(e, t, !0));
    },
        oe = function oe(e, t, n, r) {
      if (!t.done) {
        t.done = !0, r && (t = r);

        try {
          if (e === n) throw B("Promise can't be resolved itself");
          var o = J(n);
          o ? x(function () {
            var r = {
              done: !1
            };

            try {
              o.call(n, ne(oe, e, r, t), ne(re, e, r, t));
            } catch (n) {
              re(e, r, n, t);
            }
          }) : (t.value = n, t.state = 1, Q(e, t, !1));
        } catch (n) {
          re(e, {
            done: !1
          }, n, t);
        }
      }
    };

    G && (_U = function U(e) {
      y(this, _U, j), v(e), r.call(this);
      var t = L(this);

      try {
        e(ne(oe, this, t), ne(re, this, t));
      } catch (e) {
        re(this, t, e);
      }
    }, r = function r(e) {
      D(this, {
        type: j,
        done: !1,
        notified: !1,
        parent: !1,
        reactions: [],
        rejection: !1,
        state: 0,
        value: void 0
      });
    }, r.prototype = p(_U.prototype, {
      then: function then(e, t) {
        var n = F(this),
            r = W(O(this, _U));
        return r.ok = "function" != typeof e || e, r.fail = "function" == typeof t && t, r.domain = $ ? H.domain : void 0, n.parent = !0, n.reactions.push(r), 0 != n.state && Q(this, n, !1), r.promise;
      },
      catch: function _catch(e) {
        return this.then(void 0, e);
      }
    }), o = function o() {
      var e = new r(),
          t = L(e);
      this.promise = e, this.resolve = ne(oe, e, t), this.reject = ne(re, e, t);
    }, C.f = W = function W(e) {
      return e === _U || e === i ? new o(e) : z(e);
    }, l || "function" != typeof d || (a = d.prototype.then, f(d.prototype, "then", function (e, t) {
      var n = this;
      return new _U(function (e, t) {
        a.call(n, e, t);
      }).then(e, t);
    }, {
      unsafe: !0
    }), "function" == typeof q && s({
      global: !0,
      enumerable: !0,
      forced: !0
    }, {
      fetch: function fetch(e) {
        return T(_U, q.apply(u, arguments));
      }
    }))), s({
      global: !0,
      wrap: !0,
      forced: G
    }, {
      Promise: _U
    }), h(_U, j, !1, !0), m(j), i = c(j), s({
      target: j,
      stat: !0,
      forced: G
    }, {
      reject: function reject(e) {
        var t = W(this);
        return t.reject.call(void 0, e), t.promise;
      }
    }), s({
      target: j,
      stat: !0,
      forced: l || G
    }, {
      resolve: function resolve(e) {
        return T(l && this === i ? _U : this, e);
      }
    }), s({
      target: j,
      stat: !0,
      forced: Y
    }, {
      all: function all(e) {
        var t = this,
            n = W(t),
            r = n.resolve,
            o = n.reject,
            i = A(function () {
          var n = v(t.resolve),
              i = [],
              a = 0,
              s = 1;
          w(e, function (e) {
            var l = a++,
                u = !1;
            i.push(void 0), s++, n.call(t, e).then(function (e) {
              u || (u = !0, i[l] = e, --s || r(i));
            }, o);
          }), --s || r(i);
        });
        return i.error && o(i.value), n.promise;
      },
      race: function race(e) {
        var t = this,
            n = W(t),
            r = n.reject,
            o = A(function () {
          var o = v(t.resolve);
          w(e, function (e) {
            o.call(t, e).then(n.resolve, r);
          });
        });
        return o.error && r(o.value), n.promise;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(45),
        o = n(48),
        i = n(14),
        a = n(26),
        s = i("species");

    e.exports = function (e) {
      var t = r(e),
          n = o.f;
      a && t && !t[s] && n(t, s, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    };
  }, function (e, t, n) {
    var r,
        o,
        i,
        a,
        s,
        l,
        u,
        c,
        d = n(19),
        f = n(95).f,
        p = n(77),
        h = n(310).set,
        m = n(311),
        g = d.MutationObserver || d.WebKitMutationObserver,
        v = d.process,
        y = d.Promise,
        b = "process" == p(v),
        _ = f(d, "queueMicrotask"),
        w = _ && _.value;

    w || (r = function r() {
      var e, t;

      for (b && (e = v.domain) && e.exit(); o;) {
        t = o.fn, o = o.next;

        try {
          t();
        } catch (e) {
          throw o ? a() : i = void 0, e;
        }
      }

      i = void 0, e && e.enter();
    }, b ? a = function a() {
      v.nextTick(r);
    } : g && !m ? (s = !0, l = document.createTextNode(""), new g(r).observe(l, {
      characterData: !0
    }), a = function a() {
      l.data = s = !s;
    }) : y && y.resolve ? (u = y.resolve(void 0), c = u.then, a = function a() {
      c.call(u, r);
    }) : a = function a() {
      h.call(d, r);
    }), e.exports = w || function (e) {
      var t = {
        fn: e,
        next: void 0
      };
      i && (i.next = t), o || (o = t, a()), i = t;
    };
  }, function (e, t, n) {
    var r = n(19);

    e.exports = function (e, t) {
      var n = r.console;
      n && n.error && (1 === arguments.length ? n.error(e) : n.error(e, t));
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(63),
        i = n(304),
        a = n(20),
        s = n(45),
        l = n(309),
        u = n(313),
        c = n(66);
    r({
      target: "Promise",
      proto: !0,
      real: !0,
      forced: !!i && a(function () {
        i.prototype.finally.call({
          then: function then() {}
        }, function () {});
      })
    }, {
      finally: function _finally(e) {
        var t = l(this, s("Promise")),
            n = "function" == typeof e;
        return this.then(n ? function (n) {
          return u(t, e()).then(function () {
            return n;
          });
        } : e, n ? function (n) {
          return u(t, e()).then(function () {
            throw n;
          });
        } : e);
      }
    }), o || "function" != typeof i || i.prototype.finally || c(i.prototype, "finally", s("Promise").prototype.finally);
  }, function (e, t, n) {
    e.exports = n(605);
  }, function (e, t, n) {
    var r = n(606);
    e.exports = r;
  }, function (e, t, n) {
    n(607), n(610), n(317);
    var r = n(21);
    e.exports = r.URL;
  }, function (e, t, n) {
    "use strict";

    n(61);

    var r,
        o = n(9),
        i = n(26),
        a = n(315),
        s = n(19),
        l = n(171),
        u = n(66),
        c = n(175),
        d = n(31),
        f = n(608),
        p = n(316),
        h = n(293).codeAt,
        m = n(609),
        g = n(51),
        v = n(317),
        y = n(62),
        b = s.URL,
        _ = v.URLSearchParams,
        w = v.getState,
        E = y.set,
        O = y.getterFor("URL"),
        S = Math.floor,
        x = Math.pow,
        T = /[A-Za-z]/,
        k = /[\d+-.A-Za-z]/,
        C = /\d/,
        A = /^(0x|0X)/,
        N = /^[0-7]+$/,
        P = /^\d+$/,
        R = /^[\dA-Fa-f]+$/,
        I = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/,
        M = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/,
        j = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g,
        L = /[\u0009\u000A\u000D]/g,
        D = function D(e, t) {
      var n, r, o;

      if ("[" == t.charAt(0)) {
        if ("]" != t.charAt(t.length - 1)) return "Invalid host";
        if (!(n = U(t.slice(1, -1)))) return "Invalid host";
        e.host = n;
      } else if (G(e)) {
        if (t = m(t), I.test(t)) return "Invalid host";
        if (null === (n = F(t))) return "Invalid host";
        e.host = n;
      } else {
        if (M.test(t)) return "Invalid host";

        for (n = "", r = p(t), o = 0; o < r.length; o++) {
          n += $(r[o], H);
        }

        e.host = n;
      }
    },
        F = function F(e) {
      var t,
          n,
          r,
          o,
          i,
          a,
          s,
          l = e.split(".");
      if (l.length && "" == l[l.length - 1] && l.pop(), (t = l.length) > 4) return e;

      for (n = [], r = 0; r < t; r++) {
        if ("" == (o = l[r])) return e;
        if (i = 10, o.length > 1 && "0" == o.charAt(0) && (i = A.test(o) ? 16 : 8, o = o.slice(8 == i ? 1 : 2)), "" === o) a = 0;else {
          if (!(10 == i ? P : 8 == i ? N : R).test(o)) return e;
          a = parseInt(o, i);
        }
        n.push(a);
      }

      for (r = 0; r < t; r++) {
        if (a = n[r], r == t - 1) {
          if (a >= x(256, 5 - t)) return null;
        } else if (a > 255) return null;
      }

      for (s = n.pop(), r = 0; r < n.length; r++) {
        s += n[r] * x(256, 3 - r);
      }

      return s;
    },
        U = function U(e) {
      var t,
          n,
          r,
          o,
          i,
          a,
          s,
          l = [0, 0, 0, 0, 0, 0, 0, 0],
          u = 0,
          c = null,
          d = 0,
          f = function f() {
        return e.charAt(d);
      };

      if (":" == f()) {
        if (":" != e.charAt(1)) return;
        d += 2, u++, c = u;
      }

      for (; f();) {
        if (8 == u) return;

        if (":" != f()) {
          for (t = n = 0; n < 4 && R.test(f());) {
            t = 16 * t + parseInt(f(), 16), d++, n++;
          }

          if ("." == f()) {
            if (0 == n) return;
            if (d -= n, u > 6) return;

            for (r = 0; f();) {
              if (o = null, r > 0) {
                if (!("." == f() && r < 4)) return;
                d++;
              }

              if (!C.test(f())) return;

              for (; C.test(f());) {
                if (i = parseInt(f(), 10), null === o) o = i;else {
                  if (0 == o) return;
                  o = 10 * o + i;
                }
                if (o > 255) return;
                d++;
              }

              l[u] = 256 * l[u] + o, r++, 2 != r && 4 != r || u++;
            }

            if (4 != r) return;
            break;
          }

          if (":" == f()) {
            if (d++, !f()) return;
          } else if (f()) return;

          l[u++] = t;
        } else {
          if (null !== c) return;
          d++, u++, c = u;
        }
      }

      if (null !== c) for (a = u - c, u = 7; 0 != u && a > 0;) {
        s = l[u], l[u--] = l[c + a - 1], l[c + --a] = s;
      } else if (8 != u) return;
      return l;
    },
        B = function B(e) {
      for (var t = null, n = 1, r = null, o = 0, i = 0; i < 8; i++) {
        0 !== e[i] ? (o > n && (t = r, n = o), r = null, o = 0) : (null === r && (r = i), ++o);
      }

      return o > n && (t = r, n = o), t;
    },
        V = function V(e) {
      var t, n, r, o;

      if ("number" == typeof e) {
        for (t = [], n = 0; n < 4; n++) {
          t.unshift(e % 256), e = S(e / 256);
        }

        return t.join(".");
      }

      if ("object" == typeof e) {
        for (t = "", r = B(e), n = 0; n < 8; n++) {
          o && 0 === e[n] || (o && (o = !1), r === n ? (t += n ? ":" : "::", o = !0) : (t += e[n].toString(16), n < 7 && (t += ":")));
        }

        return "[" + t + "]";
      }

      return e;
    },
        H = {},
        q = f({}, H, {
      " ": 1,
      '"': 1,
      "<": 1,
      ">": 1,
      "`": 1
    }),
        W = f({}, q, {
      "#": 1,
      "?": 1,
      "{": 1,
      "}": 1
    }),
        z = f({}, W, {
      "/": 1,
      ":": 1,
      ";": 1,
      "=": 1,
      "@": 1,
      "[": 1,
      "\\": 1,
      "]": 1,
      "^": 1,
      "|": 1
    }),
        $ = function $(e, t) {
      var n = h(e, 0);
      return n > 32 && n < 127 && !d(t, e) ? e : encodeURIComponent(e);
    },
        K = {
      ftp: 21,
      file: null,
      http: 80,
      https: 443,
      ws: 80,
      wss: 443
    },
        G = function G(e) {
      return d(K, e.scheme);
    },
        Y = function Y(e) {
      return "" != e.username || "" != e.password;
    },
        J = function J(e) {
      return !e.host || e.cannotBeABaseURL || "file" == e.scheme;
    },
        Q = function Q(e, t) {
      var n;
      return 2 == e.length && T.test(e.charAt(0)) && (":" == (n = e.charAt(1)) || !t && "|" == n);
    },
        X = function X(e) {
      var t;
      return e.length > 1 && Q(e.slice(0, 2)) && (2 == e.length || "/" === (t = e.charAt(2)) || "\\" === t || "?" === t || "#" === t);
    },
        Z = function Z(e) {
      var t = e.path,
          n = t.length;
      !n || "file" == e.scheme && 1 == n && Q(t[0], !0) || t.pop();
    },
        ee = function ee(e) {
      return "." === e || "%2e" === e.toLowerCase();
    },
        te = function te(e) {
      return ".." === (e = e.toLowerCase()) || "%2e." === e || ".%2e" === e || "%2e%2e" === e;
    },
        ne = {},
        re = {},
        oe = {},
        ie = {},
        ae = {},
        se = {},
        le = {},
        ue = {},
        ce = {},
        de = {},
        fe = {},
        pe = {},
        he = {},
        me = {},
        ge = {},
        ve = {},
        ye = {},
        be = {},
        _e = {},
        we = {},
        Ee = {},
        Oe = function Oe(e, t, n, o) {
      var i,
          a,
          s,
          l,
          u = n || ne,
          c = 0,
          f = "",
          h = !1,
          m = !1,
          g = !1;

      for (n || (e.scheme = "", e.username = "", e.password = "", e.host = null, e.port = null, e.path = [], e.query = null, e.fragment = null, e.cannotBeABaseURL = !1, t = t.replace(j, "")), t = t.replace(L, ""), i = p(t); c <= i.length;) {
        switch (a = i[c], u) {
          case ne:
            if (!a || !T.test(a)) {
              if (n) return "Invalid scheme";
              u = oe;
              continue;
            }

            f += a.toLowerCase(), u = re;
            break;

          case re:
            if (a && (k.test(a) || "+" == a || "-" == a || "." == a)) f += a.toLowerCase();else {
              if (":" != a) {
                if (n) return "Invalid scheme";
                f = "", u = oe, c = 0;
                continue;
              }

              if (n && (G(e) != d(K, f) || "file" == f && (Y(e) || null !== e.port) || "file" == e.scheme && !e.host)) return;
              if (e.scheme = f, n) return void (G(e) && K[e.scheme] == e.port && (e.port = null));
              f = "", "file" == e.scheme ? u = me : G(e) && o && o.scheme == e.scheme ? u = ie : G(e) ? u = ue : "/" == i[c + 1] ? (u = ae, c++) : (e.cannotBeABaseURL = !0, e.path.push(""), u = _e);
            }
            break;

          case oe:
            if (!o || o.cannotBeABaseURL && "#" != a) return "Invalid scheme";

            if (o.cannotBeABaseURL && "#" == a) {
              e.scheme = o.scheme, e.path = o.path.slice(), e.query = o.query, e.fragment = "", e.cannotBeABaseURL = !0, u = Ee;
              break;
            }

            u = "file" == o.scheme ? me : se;
            continue;

          case ie:
            if ("/" != a || "/" != i[c + 1]) {
              u = se;
              continue;
            }

            u = ce, c++;
            break;

          case ae:
            if ("/" == a) {
              u = de;
              break;
            }

            u = be;
            continue;

          case se:
            if (e.scheme = o.scheme, a == r) e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.query = o.query;else if ("/" == a || "\\" == a && G(e)) u = le;else if ("?" == a) e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.query = "", u = we;else {
              if ("#" != a) {
                e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.path.pop(), u = be;
                continue;
              }

              e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.query = o.query, e.fragment = "", u = Ee;
            }
            break;

          case le:
            if (!G(e) || "/" != a && "\\" != a) {
              if ("/" != a) {
                e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, u = be;
                continue;
              }

              u = de;
            } else u = ce;

            break;

          case ue:
            if (u = ce, "/" != a || "/" != f.charAt(c + 1)) continue;
            c++;
            break;

          case ce:
            if ("/" != a && "\\" != a) {
              u = de;
              continue;
            }

            break;

          case de:
            if ("@" == a) {
              h && (f = "%40" + f), h = !0, s = p(f);

              for (var v = 0; v < s.length; v++) {
                var y = s[v];

                if (":" != y || g) {
                  var b = $(y, z);
                  g ? e.password += b : e.username += b;
                } else g = !0;
              }

              f = "";
            } else if (a == r || "/" == a || "?" == a || "#" == a || "\\" == a && G(e)) {
              if (h && "" == f) return "Invalid authority";
              c -= p(f).length + 1, f = "", u = fe;
            } else f += a;

            break;

          case fe:
          case pe:
            if (n && "file" == e.scheme) {
              u = ve;
              continue;
            }

            if (":" != a || m) {
              if (a == r || "/" == a || "?" == a || "#" == a || "\\" == a && G(e)) {
                if (G(e) && "" == f) return "Invalid host";
                if (n && "" == f && (Y(e) || null !== e.port)) return;
                if (l = D(e, f)) return l;
                if (f = "", u = ye, n) return;
                continue;
              }

              "[" == a ? m = !0 : "]" == a && (m = !1), f += a;
            } else {
              if ("" == f) return "Invalid host";
              if (l = D(e, f)) return l;
              if (f = "", u = he, n == pe) return;
            }

            break;

          case he:
            if (!C.test(a)) {
              if (a == r || "/" == a || "?" == a || "#" == a || "\\" == a && G(e) || n) {
                if ("" != f) {
                  var _ = parseInt(f, 10);

                  if (_ > 65535) return "Invalid port";
                  e.port = G(e) && _ === K[e.scheme] ? null : _, f = "";
                }

                if (n) return;
                u = ye;
                continue;
              }

              return "Invalid port";
            }

            f += a;
            break;

          case me:
            if (e.scheme = "file", "/" == a || "\\" == a) u = ge;else {
              if (!o || "file" != o.scheme) {
                u = be;
                continue;
              }

              if (a == r) e.host = o.host, e.path = o.path.slice(), e.query = o.query;else if ("?" == a) e.host = o.host, e.path = o.path.slice(), e.query = "", u = we;else {
                if ("#" != a) {
                  X(i.slice(c).join("")) || (e.host = o.host, e.path = o.path.slice(), Z(e)), u = be;
                  continue;
                }

                e.host = o.host, e.path = o.path.slice(), e.query = o.query, e.fragment = "", u = Ee;
              }
            }
            break;

          case ge:
            if ("/" == a || "\\" == a) {
              u = ve;
              break;
            }

            o && "file" == o.scheme && !X(i.slice(c).join("")) && (Q(o.path[0], !0) ? e.path.push(o.path[0]) : e.host = o.host), u = be;
            continue;

          case ve:
            if (a == r || "/" == a || "\\" == a || "?" == a || "#" == a) {
              if (!n && Q(f)) u = be;else if ("" == f) {
                if (e.host = "", n) return;
                u = ye;
              } else {
                if (l = D(e, f)) return l;
                if ("localhost" == e.host && (e.host = ""), n) return;
                f = "", u = ye;
              }
              continue;
            }

            f += a;
            break;

          case ye:
            if (G(e)) {
              if (u = be, "/" != a && "\\" != a) continue;
            } else if (n || "?" != a) {
              if (n || "#" != a) {
                if (a != r && (u = be, "/" != a)) continue;
              } else e.fragment = "", u = Ee;
            } else e.query = "", u = we;

            break;

          case be:
            if (a == r || "/" == a || "\\" == a && G(e) || !n && ("?" == a || "#" == a)) {
              if (te(f) ? (Z(e), "/" == a || "\\" == a && G(e) || e.path.push("")) : ee(f) ? "/" == a || "\\" == a && G(e) || e.path.push("") : ("file" == e.scheme && !e.path.length && Q(f) && (e.host && (e.host = ""), f = f.charAt(0) + ":"), e.path.push(f)), f = "", "file" == e.scheme && (a == r || "?" == a || "#" == a)) for (; e.path.length > 1 && "" === e.path[0];) {
                e.path.shift();
              }
              "?" == a ? (e.query = "", u = we) : "#" == a && (e.fragment = "", u = Ee);
            } else f += $(a, W);

            break;

          case _e:
            "?" == a ? (e.query = "", u = we) : "#" == a ? (e.fragment = "", u = Ee) : a != r && (e.path[0] += $(a, H));
            break;

          case we:
            n || "#" != a ? a != r && ("'" == a && G(e) ? e.query += "%27" : e.query += "#" == a ? "%23" : $(a, H)) : (e.fragment = "", u = Ee);
            break;

          case Ee:
            a != r && (e.fragment += $(a, q));
        }

        c++;
      }
    },
        Se = function Se(e) {
      var t,
          n,
          r = c(this, Se, "URL"),
          o = arguments.length > 1 ? arguments[1] : void 0,
          a = String(e),
          s = E(r, {
        type: "URL"
      });
      if (void 0 !== o) if (o instanceof Se) t = O(o);else if (n = Oe(t = {}, String(o))) throw TypeError(n);
      if (n = Oe(s, a, null, t)) throw TypeError(n);
      var l = s.searchParams = new _(),
          u = w(l);
      u.updateSearchParams(s.query), u.updateURL = function () {
        s.query = String(l) || null;
      }, i || (r.href = Te.call(r), r.origin = ke.call(r), r.protocol = Ce.call(r), r.username = Ae.call(r), r.password = Ne.call(r), r.host = Pe.call(r), r.hostname = Re.call(r), r.port = Ie.call(r), r.pathname = Me.call(r), r.search = je.call(r), r.searchParams = Le.call(r), r.hash = De.call(r));
    },
        xe = Se.prototype,
        Te = function Te() {
      var e = O(this),
          t = e.scheme,
          n = e.username,
          r = e.password,
          o = e.host,
          i = e.port,
          a = e.path,
          s = e.query,
          l = e.fragment,
          u = t + ":";
      return null !== o ? (u += "//", Y(e) && (u += n + (r ? ":" + r : "") + "@"), u += V(o), null !== i && (u += ":" + i)) : "file" == t && (u += "//"), u += e.cannotBeABaseURL ? a[0] : a.length ? "/" + a.join("/") : "", null !== s && (u += "?" + s), null !== l && (u += "#" + l), u;
    },
        ke = function ke() {
      var e = O(this),
          t = e.scheme,
          n = e.port;
      if ("blob" == t) try {
        return new URL(t.path[0]).origin;
      } catch (e) {
        return "null";
      }
      return "file" != t && G(e) ? t + "://" + V(e.host) + (null !== n ? ":" + n : "") : "null";
    },
        Ce = function Ce() {
      return O(this).scheme + ":";
    },
        Ae = function Ae() {
      return O(this).username;
    },
        Ne = function Ne() {
      return O(this).password;
    },
        Pe = function Pe() {
      var e = O(this),
          t = e.host,
          n = e.port;
      return null === t ? "" : null === n ? V(t) : V(t) + ":" + n;
    },
        Re = function Re() {
      var e = O(this).host;
      return null === e ? "" : V(e);
    },
        Ie = function Ie() {
      var e = O(this).port;
      return null === e ? "" : String(e);
    },
        Me = function Me() {
      var e = O(this),
          t = e.path;
      return e.cannotBeABaseURL ? t[0] : t.length ? "/" + t.join("/") : "";
    },
        je = function je() {
      var e = O(this).query;
      return e ? "?" + e : "";
    },
        Le = function Le() {
      return O(this).searchParams;
    },
        De = function De() {
      var e = O(this).fragment;
      return e ? "#" + e : "";
    },
        Fe = function Fe(e, t) {
      return {
        get: e,
        set: t,
        configurable: !0,
        enumerable: !0
      };
    };

    if (i && l(xe, {
      href: Fe(Te, function (e) {
        var t = O(this),
            n = String(e),
            r = Oe(t, n);
        if (r) throw TypeError(r);
        w(t.searchParams).updateSearchParams(t.query);
      }),
      origin: Fe(ke),
      protocol: Fe(Ce, function (e) {
        var t = O(this);
        Oe(t, String(e) + ":", ne);
      }),
      username: Fe(Ae, function (e) {
        var t = O(this),
            n = p(String(e));

        if (!J(t)) {
          t.username = "";

          for (var r = 0; r < n.length; r++) {
            t.username += $(n[r], z);
          }
        }
      }),
      password: Fe(Ne, function (e) {
        var t = O(this),
            n = p(String(e));

        if (!J(t)) {
          t.password = "";

          for (var r = 0; r < n.length; r++) {
            t.password += $(n[r], z);
          }
        }
      }),
      host: Fe(Pe, function (e) {
        var t = O(this);
        t.cannotBeABaseURL || Oe(t, String(e), fe);
      }),
      hostname: Fe(Re, function (e) {
        var t = O(this);
        t.cannotBeABaseURL || Oe(t, String(e), pe);
      }),
      port: Fe(Ie, function (e) {
        var t = O(this);
        J(t) || (e = String(e), "" == e ? t.port = null : Oe(t, e, he));
      }),
      pathname: Fe(Me, function (e) {
        var t = O(this);
        t.cannotBeABaseURL || (t.path = [], Oe(t, e + "", ye));
      }),
      search: Fe(je, function (e) {
        var t = O(this);
        e = String(e), "" == e ? t.query = null : ("?" == e.charAt(0) && (e = e.slice(1)), t.query = "", Oe(t, e, we)), w(t.searchParams).updateSearchParams(t.query);
      }),
      searchParams: Fe(Le),
      hash: Fe(De, function (e) {
        var t = O(this);
        if ("" == (e = String(e))) return void (t.fragment = null);
        "#" == e.charAt(0) && (e = e.slice(1)), t.fragment = "", Oe(t, e, Ee);
      })
    }), u(xe, "toJSON", function () {
      return Te.call(this);
    }, {
      enumerable: !0
    }), u(xe, "toString", function () {
      return Te.call(this);
    }, {
      enumerable: !0
    }), b) {
      var Ue = b.createObjectURL,
          Be = b.revokeObjectURL;
      Ue && u(Se, "createObjectURL", function (e) {
        return Ue.apply(b, arguments);
      }), Be && u(Se, "revokeObjectURL", function (e) {
        return Be.apply(b, arguments);
      });
    }

    g(Se, "URL"), o({
      global: !0,
      forced: !a,
      sham: !i
    }, {
      URL: Se
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(26),
        o = n(20),
        i = n(97),
        a = n(177),
        s = n(120),
        l = n(64),
        u = n(163),
        c = Object.assign,
        d = Object.defineProperty;
    e.exports = !c || o(function () {
      if (r && 1 !== c({
        b: 1
      }, c(d({}, "a", {
        enumerable: !0,
        get: function get() {
          d(this, "b", {
            value: 3,
            enumerable: !1
          });
        }
      }), {
        b: 2
      })).b) return !0;
      var e = {},
          t = {},
          n = Symbol(),
          o = "abcdefghijklmnopqrst";
      return e[n] = 7, o.split("").forEach(function (e) {
        t[e] = e;
      }), 7 != c({}, e)[n] || i(c({}, t)).join("") != o;
    }) ? function (e, t) {
      for (var n = l(e), o = arguments.length, c = 1, d = a.f, f = s.f; o > c;) {
        for (var p, h = u(arguments[c++]), m = d ? i(h).concat(d(h)) : i(h), g = m.length, v = 0; g > v;) {
          p = m[v++], r && !f.call(h, p) || (n[p] = h[p]);
        }
      }

      return n;
    } : c;
  }, function (e, t, n) {
    "use strict";

    var r = /[^\0-\u007E]/,
        o = /[.\u3002\uFF0E\uFF61]/g,
        i = "Overflow: input needs wider integers to process",
        a = Math.floor,
        s = String.fromCharCode,
        l = function l(e) {
      for (var t = [], n = 0, r = e.length; n < r;) {
        var o = e.charCodeAt(n++);

        if (o >= 55296 && o <= 56319 && n < r) {
          var i = e.charCodeAt(n++);
          56320 == (64512 & i) ? t.push(((1023 & o) << 10) + (1023 & i) + 65536) : (t.push(o), n--);
        } else t.push(o);
      }

      return t;
    },
        u = function u(e) {
      return e + 22 + 75 * (e < 26);
    },
        c = function c(e, t, n) {
      var r = 0;

      for (e = n ? a(e / 700) : e >> 1, e += a(e / t); e > 455; r += 36) {
        e = a(e / 35);
      }

      return a(r + 36 * e / (e + 38));
    },
        d = function d(e) {
      var t = [];
      e = l(e);
      var n,
          r,
          o = e.length,
          d = 128,
          f = 0,
          p = 72;

      for (n = 0; n < e.length; n++) {
        (r = e[n]) < 128 && t.push(s(r));
      }

      var h = t.length,
          m = h;

      for (h && t.push("-"); m < o;) {
        var g = 2147483647;

        for (n = 0; n < e.length; n++) {
          (r = e[n]) >= d && r < g && (g = r);
        }

        var v = m + 1;
        if (g - d > a((2147483647 - f) / v)) throw RangeError(i);

        for (f += (g - d) * v, d = g, n = 0; n < e.length; n++) {
          if ((r = e[n]) < d && ++f > 2147483647) throw RangeError(i);

          if (r == d) {
            for (var y = f, b = 36;; b += 36) {
              var _ = b <= p ? 1 : b >= p + 26 ? 26 : b - p;

              if (y < _) break;
              var w = y - _,
                  E = 36 - _;
              t.push(s(u(_ + w % E))), y = a(w / E);
            }

            t.push(s(u(y))), p = c(f, v, m == h), f = 0, ++m;
          }
        }

        ++f, ++d;
      }

      return t.join("");
    };

    e.exports = function (e) {
      var t,
          n,
          i = [],
          a = e.toLowerCase().replace(o, ".").split(".");

      for (t = 0; t < a.length; t++) {
        n = a[t], i.push(r.test(n) ? "xn--" + d(n) : n);
      }

      return i.join(".");
    };
  }, function (e, t) {}, function (e, t, n) {
    "use strict";

    var r = n(612),
        o = n(130),
        i = n(331),
        a = n(131),
        s = n(128),
        l = n(635),
        u = n(637),
        c = n(639),
        d = Math.max,
        f = Math.min,
        p = function p(e) {
      return void 0 === e ? e : String(e);
    };

    r("replace", 2, function (e, t, n, r) {
      var h = r.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE,
          m = r.REPLACE_KEEPS_$0,
          g = h ? "$" : "$0";
      return [function (n, r) {
        var o = s(this),
            i = void 0 == n ? void 0 : n[e];
        return void 0 !== i ? i.call(n, o, r) : t.call(String(o), n, r);
      }, function (e, r) {
        if (!h && m || "string" == typeof r && -1 === r.indexOf(g)) {
          var s = n(t, e, this, r);
          if (s.done) return s.value;
        }

        var v = o(e),
            y = String(this),
            b = "function" == typeof r;
        b || (r = String(r));
        var _ = v.global;

        if (_) {
          var w = v.unicode;
          v.lastIndex = 0;
        }

        for (var E = [];;) {
          var O = c(v, y);
          if (null === O) break;
          if (E.push(O), !_) break;
          "" === String(O[0]) && (v.lastIndex = l(y, i(v.lastIndex), w));
        }

        for (var S = "", x = 0, T = 0; T < E.length; T++) {
          O = E[T];

          for (var k = String(O[0]), C = d(f(a(O.index), y.length), 0), A = [], N = 1; N < O.length; N++) {
            A.push(p(O[N]));
          }

          var P = O.groups;

          if (b) {
            var R = [k].concat(A, C, y);
            void 0 !== P && R.push(P);
            var I = String(r.apply(void 0, R));
          } else I = u(k, y, C, A, P, r);

          C >= x && (S += y.slice(x, C) + I, x = C + k.length);
        }

        return S + y.slice(x);
      }];
    });
  }, function (e, t, n) {
    "use strict";

    n(319);

    var r = n(179),
        o = n(52),
        i = n(183),
        a = n(182),
        s = n(103),
        l = i("species"),
        u = !o(function () {
      var e = /./;
      return e.exec = function () {
        var e = [];
        return e.groups = {
          a: "7"
        }, e;
      }, "7" !== "".replace(e, "$<a>");
    }),
        c = function () {
      return "$0" === "a".replace(/./, "$0");
    }(),
        d = i("replace"),
        f = function () {
      return !!/./[d] && "" === /./[d]("a", "$0");
    }(),
        p = !o(function () {
      var e = /(?:)/,
          t = e.exec;

      e.exec = function () {
        return t.apply(this, arguments);
      };

      var n = "ab".split(e);
      return 2 !== n.length || "a" !== n[0] || "b" !== n[1];
    });

    e.exports = function (e, t, n, d) {
      var h = i(e),
          m = !o(function () {
        var t = {};
        return t[h] = function () {
          return 7;
        }, 7 != ""[e](t);
      }),
          g = m && !o(function () {
        var t = !1,
            n = /a/;
        return "split" === e && (n = {}, n.constructor = {}, n.constructor[l] = function () {
          return n;
        }, n.flags = "", n[h] = /./[h]), n.exec = function () {
          return t = !0, null;
        }, n[h](""), !t;
      });

      if (!m || !g || "replace" === e && (!u || !c || f) || "split" === e && !p) {
        var v = /./[h],
            y = n(h, ""[e], function (e, t, n, r, o) {
          return t.exec === a ? m && !o ? {
            done: !0,
            value: v.call(t, n, r)
          } : {
            done: !0,
            value: e.call(n, t, r)
          } : {
            done: !1
          };
        }, {
          REPLACE_KEEPS_$0: c,
          REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: f
        }),
            b = y[0],
            _ = y[1];
        r(String.prototype, e, b), r(RegExp.prototype, h, 2 == t ? function (e, t) {
          return _.call(e, this, t);
        } : function (e) {
          return _.call(e, this);
        });
      }

      d && s(RegExp.prototype[h], "sham", !0);
    };
  }, function (e, t, n) {
    "use strict";

    var r = {}.propertyIsEnumerable,
        o = Object.getOwnPropertyDescriptor,
        i = o && !r.call({
      1: 2
    }, 1);
    t.f = i ? function (e) {
      var t = o(this, e);
      return !!t && t.enumerable;
    } : r;
  }, function (e, t, n) {
    var r = n(37),
        o = n(129),
        i = r.document,
        a = o(i) && o(i.createElement);

    e.exports = function (e) {
      return a ? i.createElement(e) : {};
    };
  }, function (e, t, n) {
    var r,
        o,
        i,
        a = n(616),
        s = n(37),
        l = n(129),
        u = n(103),
        c = n(85),
        d = n(181),
        f = n(617),
        p = n(329),
        h = s.WeakMap,
        m = function m(e) {
      return i(e) ? o(e) : r(e, {});
    },
        g = function g(e) {
      return function (t) {
        var n;
        if (!l(t) || (n = o(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
        return n;
      };
    };

    if (a) {
      var v = d.state || (d.state = new h()),
          y = v.get,
          b = v.has,
          _ = v.set;
      r = function r(e, t) {
        return t.facade = e, _.call(v, e, t), t;
      }, o = function o(e) {
        return y.call(v, e) || {};
      }, i = function i(e) {
        return b.call(v, e);
      };
    } else {
      var w = f("state");
      p[w] = !0, r = function r(e, t) {
        return t.facade = e, u(e, w, t), t;
      }, o = function o(e) {
        return c(e, w) ? e[w] : {};
      }, i = function i(e) {
        return c(e, w);
      };
    }

    e.exports = {
      set: r,
      get: o,
      has: i,
      enforce: m,
      getterFor: g
    };
  }, function (e, t, n) {
    var r = n(37),
        o = n(326),
        i = r.WeakMap;
    e.exports = "function" == typeof i && /native code/.test(o(i));
  }, function (e, t, n) {
    var r = n(327),
        o = n(328),
        i = r("keys");

    e.exports = function (e) {
      return i[e] || (i[e] = o(e));
    };
  }, function (e, t) {
    e.exports = !1;
  }, function (e, t, n) {
    var r = n(85),
        o = n(620),
        i = n(321),
        a = n(178);

    e.exports = function (e, t) {
      for (var n = o(t), s = a.f, l = i.f, u = 0; u < n.length; u++) {
        var c = n[u];
        r(e, c) || s(e, c, l(t, c));
      }
    };
  }, function (e, t, n) {
    var r = n(330),
        o = n(622),
        i = n(627),
        a = n(130);

    e.exports = r("Reflect", "ownKeys") || function (e) {
      var t = o.f(a(e)),
          n = i.f;
      return n ? t.concat(n(e)) : t;
    };
  }, function (e, t, n) {
    var r = n(37);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(623),
        o = n(626),
        i = o.concat("length", "prototype");

    t.f = Object.getOwnPropertyNames || function (e) {
      return r(e, i);
    };
  }, function (e, t, n) {
    var r = n(85),
        o = n(126),
        i = n(624).indexOf,
        a = n(329);

    e.exports = function (e, t) {
      var n,
          s = o(e),
          l = 0,
          u = [];

      for (n in s) {
        !r(a, n) && r(s, n) && u.push(n);
      }

      for (; t.length > l;) {
        r(s, n = t[l++]) && (~i(u, n) || u.push(n));
      }

      return u;
    };
  }, function (e, t, n) {
    var r = n(126),
        o = n(331),
        i = n(625),
        a = function a(e) {
      return function (t, n, a) {
        var s,
            l = r(t),
            u = o(l.length),
            c = i(a, u);

        if (e && n != n) {
          for (; u > c;) {
            if ((s = l[c++]) != s) return !0;
          }
        } else for (; u > c; c++) {
          if ((e || c in l) && l[c] === n) return e || c || 0;
        }

        return !e && -1;
      };
    };

    e.exports = {
      includes: a(!0),
      indexOf: a(!1)
    };
  }, function (e, t, n) {
    var r = n(131),
        o = Math.max,
        i = Math.min;

    e.exports = function (e, t) {
      var n = r(e);
      return n < 0 ? o(n + t, 0) : i(n, t);
    };
  }, function (e, t) {
    e.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
  }, function (e, t) {
    t.f = Object.getOwnPropertySymbols;
  }, function (e, t, n) {
    var r = n(52),
        o = /#|\.prototype\./,
        i = function i(e, t) {
      var n = s[a(e)];
      return n == u || n != l && ("function" == typeof t ? r(t) : !!t);
    },
        a = i.normalize = function (e) {
      return String(e).replace(o, ".").toLowerCase();
    },
        s = i.data = {},
        l = i.NATIVE = "N",
        u = i.POLYFILL = "P";

    e.exports = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(130);

    e.exports = function () {
      var e = r(this),
          t = "";
      return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return RegExp(e, t);
    }

    var o = n(52);
    t.UNSUPPORTED_Y = o(function () {
      var e = r("a", "y");
      return e.lastIndex = 2, null != e.exec("abcd");
    }), t.BROKEN_CARET = o(function () {
      var e = r("^r", "gy");
      return e.lastIndex = 2, null != e.exec("str");
    });
  }, function (e, t, n) {
    var r = n(127),
        o = n(37);
    e.exports = "process" == r(o.process);
  }, function (e, t, n) {
    var r,
        o,
        i = n(37),
        a = n(633),
        s = i.process,
        l = s && s.versions,
        u = l && l.v8;
    u ? (r = u.split("."), o = r[0] + r[1]) : a && (!(r = a.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = a.match(/Chrome\/(\d+)/)) && (o = r[1]), e.exports = o && +o;
  }, function (e, t, n) {
    var r = n(330);
    e.exports = r("navigator", "userAgent") || "";
  }, function (e, t, n) {
    var r = n(332);
    e.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator;
  }, function (e, t, n) {
    "use strict";

    var r = n(636).charAt;

    e.exports = function (e, t, n) {
      return t + (n ? r(e, t).length : 1);
    };
  }, function (e, t, n) {
    var r = n(131),
        o = n(128),
        i = function i(e) {
      return function (t, n) {
        var i,
            a,
            s = String(o(t)),
            l = r(n),
            u = s.length;
        return l < 0 || l >= u ? e ? "" : void 0 : (i = s.charCodeAt(l), i < 55296 || i > 56319 || l + 1 === u || (a = s.charCodeAt(l + 1)) < 56320 || a > 57343 ? e ? s.charAt(l) : i : e ? s.slice(l, l + 2) : a - 56320 + (i - 55296 << 10) + 65536);
      };
    };

    e.exports = {
      codeAt: i(!1),
      charAt: i(!0)
    };
  }, function (e, t, n) {
    var r = n(638),
        o = Math.floor,
        i = "".replace,
        a = /\$([$&'`]|\d{1,2}|<[^>]*>)/g,
        s = /\$([$&'`]|\d{1,2})/g;

    e.exports = function (e, t, n, l, u, c) {
      var d = n + e.length,
          f = l.length,
          p = s;
      return void 0 !== u && (u = r(u), p = a), i.call(c, p, function (r, i) {
        var a;

        switch (i.charAt(0)) {
          case "$":
            return "$";

          case "&":
            return e;

          case "`":
            return t.slice(0, n);

          case "'":
            return t.slice(d);

          case "<":
            a = u[i.slice(1, -1)];
            break;

          default:
            var s = +i;
            if (0 === s) return r;

            if (s > f) {
              var c = o(s / 10);
              return 0 === c ? r : c <= f ? void 0 === l[c - 1] ? i.charAt(1) : l[c - 1] + i.charAt(1) : r;
            }

            a = l[s - 1];
        }

        return void 0 === a ? "" : a;
      });
    };
  }, function (e, t, n) {
    var r = n(128);

    e.exports = function (e) {
      return Object(r(e));
    };
  }, function (e, t, n) {
    var r = n(127),
        o = n(182);

    e.exports = function (e, t) {
      var n = e.exec;

      if ("function" == typeof n) {
        var i = n.call(e, t);
        if ("object" != typeof i) throw TypeError("RegExp exec method returned something other than an Object or null");
        return i;
      }

      if ("RegExp" !== r(e)) throw TypeError("RegExp#exec called on incompatible receiver");
      return o.call(e, t);
    };
  }, function (e, t, n) {
    e.exports = n(641);
  }, function (e, t, n) {
    var r = n(291);
    n(642), n(643), n(644), n(645), e.exports = r;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(26),
        i = n(169),
        a = n(302),
        s = n(124),
        l = n(48),
        u = n(59),
        c = n(98),
        d = n(44),
        f = n(62),
        p = f.set,
        h = f.getterFor("AggregateError"),
        m = function m(e, t) {
      var n = this;
      if (!(n instanceof m)) return new m(e, t);
      a && (n = a(new Error(t), i(n)));
      var r = [];
      return c(e, r.push, r), o ? p(n, {
        errors: r,
        type: "AggregateError"
      }) : n.errors = r, void 0 !== t && d(n, "message", String(t)), n;
    };

    m.prototype = s(Error.prototype, {
      constructor: u(5, m),
      message: u(5, ""),
      name: u(5, "AggregateError")
    }), o && l.f(m.prototype, "errors", {
      get: function get() {
        return h(this).errors;
      },
      configurable: !0
    }), r({
      global: !0
    }, {
      AggregateError: m
    });
  }, function (e, t, n) {
    n(314);
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(100),
        i = n(125);
    r({
      target: "Promise",
      stat: !0
    }, {
      try: function _try(e) {
        var t = o.f(this),
            n = i(e);
        return (n.error ? t.reject : t.resolve)(n.value), t.promise;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(79),
        i = n(45),
        a = n(100),
        s = n(125),
        l = n(98);
    r({
      target: "Promise",
      stat: !0
    }, {
      any: function any(e) {
        var t = this,
            n = a.f(t),
            r = n.resolve,
            u = n.reject,
            c = s(function () {
          var n = o(t.resolve),
              a = [],
              s = 0,
              c = 1,
              d = !1;
          l(e, function (e) {
            var o = s++,
                l = !1;
            a.push(void 0), c++, n.call(t, e).then(function (e) {
              l || d || (d = !0, r(e));
            }, function (e) {
              l || d || (l = !0, a[o] = e, --c || u(new (i("AggregateError"))(a, "No one promise resolved")));
            });
          }), --c || u(new (i("AggregateError"))(a, "No one promise resolved"));
        });
        return c.error && u(c.value), n.promise;
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(34),
        o = n(40);
    r(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var i = o(n(80)),
        a = o(n(86)),
        s = o(n(96)),
        l = o(n(333)),
        u = n(132),
        c = function c(e) {
      return e.json().then(function (e) {
        return s.default.reject(e);
      });
    },
        d = function () {
      function e(e) {
        return t.apply(this, arguments);
      }

      var t = (0, a.default)(i.default.mark(function e(t) {
        var n, r, o, a, s, d, f;
        return i.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = t.domain, r = t.interactionHandle, o = t.stateHandle, a = t.version, s = "".concat(n, "/idp/idx/introspect"), d = o ? {
                  stateToken: o
                } : {
                  interactionHandle: r
                }, f = {
                  "content-type": "application/ion+json; okta-version=".concat(a),
                  accept: "application/ion+json; okta-version=".concat(a)
                }, e.abrupt("return", (0, u.request)(s, {
                  headers: f,
                  body: (0, l.default)(d)
                }).then(function (e) {
                  return e.ok ? e.json() : c(e);
                }));

              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return e;
    }(),
        f = d;

    t.default = f;
  }, function (e, t, n) {
    var r = n(648);
    e.exports = r;
  }, function (e, t, n) {
    n(649);
    var r = n(21);
    r.JSON || (r.JSON = {
      stringify: JSON.stringify
    }), e.exports = function (e, t, n) {
      return r.JSON.stringify.apply(null, arguments);
    };
  }, function (e, t, n) {
    var r = n(9),
        o = n(45),
        i = n(20),
        a = o("JSON", "stringify"),
        s = /[\uD800-\uDFFF]/g,
        l = /^[\uD800-\uDBFF]$/,
        u = /^[\uDC00-\uDFFF]$/,
        c = function c(e, t, n) {
      var r = n.charAt(t - 1),
          o = n.charAt(t + 1);
      return l.test(e) && !u.test(o) || u.test(e) && !l.test(r) ? "\\u" + e.charCodeAt(0).toString(16) : e;
    },
        d = i(function () {
      return "\"\\udf06\\ud834\"" !== a("��") || "\"\\udead\"" !== a("�");
    });

    a && r({
      target: "JSON",
      stat: !0,
      forced: d
    }, {
      stringify: function stringify(e, t, n) {
        var r = a.apply(null, arguments);
        return "string" == typeof r ? r.replace(s, c) : r;
      }
    });
  }, function (e, t, n) {
    var r = n(334);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(9),
        o = n(64),
        i = n(97);
    r({
      target: "Object",
      stat: !0,
      forced: n(20)(function () {
        i(1);
      })
    }, {
      keys: function keys(e) {
        return i(o(e));
      }
    });
  }, function (e, t, n) {
    var r = n(335);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(43),
        o = n(185).f,
        i = {}.toString,
        a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
        s = function s(e) {
      try {
        return o(e);
      } catch (e) {
        return a.slice();
      }
    };

    e.exports.f = function (e) {
      return a && "[object Window]" == i.call(e) ? s(e) : o(r(e));
    };
  }, function (e, t, n) {
    var r = n(655);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(656),
        o = Array.prototype;

    e.exports = function (e) {
      var t = e.filter;
      return e === o || e instanceof Array && t === o.filter ? r : t;
    };
  }, function (e, t, n) {
    n(657);
    var r = n(60);
    e.exports = r("Array").filter;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(105).filter,
        i = n(135),
        a = n(82),
        s = i("filter"),
        l = a("filter");
    r({
      target: "Array",
      proto: !0,
      forced: !s || !l
    }, {
      filter: function filter(e) {
        return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
      }
    });
  }, function (e, t, n) {
    var r = n(659);
    e.exports = r;
  }, function (e, t, n) {
    n(660);

    var r = n(21),
        o = r.Object,
        i = e.exports = function (e, t) {
      return o.getOwnPropertyDescriptor(e, t);
    };

    o.getOwnPropertyDescriptor.sham && (i.sham = !0);
  }, function (e, t, n) {
    var r = n(9),
        o = n(20),
        i = n(43),
        a = n(95).f,
        s = n(26),
        l = o(function () {
      a(1);
    });
    r({
      target: "Object",
      stat: !0,
      forced: !s || l,
      sham: !s
    }, {
      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(e, t) {
        return a(i(e), t);
      }
    });
  }, function (e, t, n) {
    n(84);
    var r = n(662),
        o = n(83),
        i = Array.prototype,
        a = {
      DOMTokenList: !0,
      NodeList: !0
    };

    e.exports = function (e) {
      var t = e.forEach;
      return e === i || e instanceof Array && t === i.forEach || a.hasOwnProperty(o(e)) ? r : t;
    };
  }, function (e, t, n) {
    var r = n(663);
    e.exports = r;
  }, function (e, t, n) {
    n(664);
    var r = n(60);
    e.exports = r("Array").forEach;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(665);
    r({
      target: "Array",
      proto: !0,
      forced: [].forEach != o
    }, {
      forEach: o
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(105).forEach,
        o = n(290),
        i = n(82),
        a = o("forEach"),
        s = i("forEach");
    e.exports = a && s ? [].forEach : function (e) {
      return r(this, e, arguments.length > 1 ? arguments[1] : void 0);
    };
  }, function (e, t, n) {
    var r = n(667);
    e.exports = r;
  }, function (e, t, n) {
    n(668);
    var r = n(21);
    e.exports = r.Object.getOwnPropertyDescriptors;
  }, function (e, t, n) {
    var r = n(9),
        o = n(26),
        i = n(669),
        a = n(43),
        s = n(95),
        l = n(101);
    r({
      target: "Object",
      stat: !0,
      sham: !o
    }, {
      getOwnPropertyDescriptors: function getOwnPropertyDescriptors(e) {
        for (var t, n, r = a(e), o = s.f, u = i(r), c = {}, d = 0; u.length > d;) {
          void 0 !== (n = o(r, t = u[d++])) && l(c, t, n);
        }

        return c;
      }
    });
  }, function (e, t, n) {
    var r = n(45),
        o = n(185),
        i = n(177),
        a = n(36);

    e.exports = r("Reflect", "ownKeys") || function (e) {
      var t = o.f(a(e)),
          n = i.f;
      return n ? t.concat(n(e)) : t;
    };
  }, function (e, t, n) {
    var r = n(671);
    e.exports = r;
  }, function (e, t, n) {
    n(672);

    var r = n(21),
        o = r.Object,
        i = e.exports = function (e, t) {
      return o.defineProperties(e, t);
    };

    o.defineProperties.sham && (i.sham = !0);
  }, function (e, t, n) {
    var r = n(9),
        o = n(26);
    r({
      target: "Object",
      stat: !0,
      forced: !o,
      sham: !o
    }, {
      defineProperties: n(171)
    });
  }, function (e, t, n) {
    e.exports = n(674);
  }, function (e, t, n) {
    var r = n(284);
    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    n(34)(t, "__esModule", {
      value: !0
    }), t.userAgentHeaders = t.getUserAgent = void 0;

    var r = function r() {
      return "okta-idx-js/".concat("0.14.0");
    };

    t.getUserAgent = r;

    var o = function o() {
      return {
        "X-Okta-User-Agent-Extended": r()
      };
    };

    t.userAgentHeaders = o;
  }, function (e, t, n) {
    "use strict";

    var r = n(34),
        o = n(40);
    r(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = o(n(80));
    n(677);

    var a = o(n(338)),
        s = o(n(86)),
        l = o(n(96)),
        u = o(n(192)),
        c = o(n(351)),
        d = o(n(352)),
        f = n(132),
        p = function p(e) {
      return e.json().then(function (e) {
        return l.default.reject(e);
      });
    },
        h = function () {
      function e(e) {
        return t.apply(this, arguments);
      }

      var t = (0, s.default)(i.default.mark(function e(t) {
        var n, r, o, s, l, h, m, g, v, y, b, _;

        return i.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = t.clientId, o = t.baseUrl, s = t.scopes, l = void 0 === s ? ["openid", "email"] : s, h = t.redirectUri, m = t.codeChallenge, g = t.codeChallengeMethod, v = t.state, y = "".concat(o, "/v1/interact"), b = (0, u.default)(n = (0, c.default)({
                  client_id: r,
                  scope: l.join(" "),
                  redirect_uri: h,
                  code_challenge: m,
                  code_challenge_method: g,
                  state: v
                })).call(n, function (e) {
                  var t,
                      n = (0, a.default)(e, 2),
                      r = n[0],
                      o = n[1];
                  return (0, d.default)(t = "".concat(r, "=")).call(t, encodeURIComponent(o));
                }).join("&"), _ = {
                  "content-type": "application/x-www-form-urlencoded"
                }, e.abrupt("return", (0, f.request)(y, {
                  headers: _,
                  body: b
                }).then(function (e) {
                  return e.ok ? e.json() : p(e);
                }).then(function (e) {
                  return e.interaction_handle;
                }));

              case 5:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return e;
    }(),
        m = h;

    t.default = m;
  }, function (e, t, n) {
    "use strict";

    var r = n(320),
        o = n(323),
        i = n(126),
        a = n(678),
        s = [].join,
        l = o != Object,
        u = a("join", ",");
    r({
      target: "Array",
      proto: !0,
      forced: l || !u
    }, {
      join: function join(e) {
        return s.call(i(this), void 0 === e ? "," : e);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(52);

    e.exports = function (e, t) {
      var n = [][e];
      return !!n && r(function () {
        n.call(null, t || function () {
          throw 1;
        }, 1);
      });
    };
  }, function (e, t, n) {
    function r(e) {
      if (o(e)) return e;
    }

    var o = n(339);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(340);
    e.exports = r;
  }, function (e, t, n) {
    n(9)({
      target: "Array",
      stat: !0
    }, {
      isArray: n(104)
    });
  }, function (e, t, n) {
    function r(e, t) {
      if (void 0 !== a && i(Object(e))) {
        var n = [],
            r = !0,
            s = !1,
            l = void 0;

        try {
          for (var u, c = o(e); !(r = (u = c.next()).done) && (n.push(u.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          s = !0, l = e;
        } finally {
          try {
            r || null == c.return || c.return();
          } finally {
            if (s) throw l;
          }
        }

        return n;
      }
    }

    var o = n(341),
        i = n(342),
        a = n(191);
    e.exports = r;
  }, function (e, t, n) {
    n(84), n(61);
    var r = n(318);
    e.exports = r;
  }, function (e, t, n) {
    n(84), n(61);
    var r = n(685);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(83),
        o = n(14),
        i = n(65),
        a = o("iterator");

    e.exports = function (e) {
      var t = Object(e);
      return void 0 !== t[a] || "@@iterator" in t || i.hasOwnProperty(r(t));
    };
  }, function (e, t, n) {
    var r = n(343);
    n(702), n(703), n(704), n(705), n(706), e.exports = r;
  }, function (e, t, n) {
    n(17)("asyncIterator");
  }, function (e, t) {}, function (e, t, n) {
    n(17)("hasInstance");
  }, function (e, t, n) {
    n(17)("isConcatSpreadable");
  }, function (e, t, n) {
    n(17)("match");
  }, function (e, t, n) {
    n(17)("matchAll");
  }, function (e, t, n) {
    n(17)("replace");
  }, function (e, t, n) {
    n(17)("search");
  }, function (e, t, n) {
    n(17)("species");
  }, function (e, t, n) {
    n(17)("split");
  }, function (e, t, n) {
    n(17)("toPrimitive");
  }, function (e, t, n) {
    n(17)("toStringTag");
  }, function (e, t, n) {
    n(17)("unscopables");
  }, function (e, t, n) {
    n(51)(Math, "Math", !0);
  }, function (e, t, n) {
    var r = n(19);
    n(51)(r.JSON, "JSON", !0);
  }, function (e, t, n) {
    n(17)("asyncDispose");
  }, function (e, t, n) {
    n(17)("dispose");
  }, function (e, t, n) {
    n(17)("observable");
  }, function (e, t, n) {
    n(17)("patternMatch");
  }, function (e, t, n) {
    n(17)("replaceAll");
  }, function (e, t, n) {
    var r = n(348);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(9),
        o = n(316);
    r({
      target: "Array",
      stat: !0,
      forced: !n(308)(function (e) {
        Array.from(e);
      })
    }, {
      from: o
    });
  }, function (e, t, n) {
    e.exports = n(710);
  }, function (e, t, n) {
    var r = n(349);
    e.exports = r;
  }, function (e, t, n) {
    n(712);
    var r = n(60);
    e.exports = r("Array").slice;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(35),
        i = n(104),
        a = n(289),
        s = n(81),
        l = n(43),
        u = n(101),
        c = n(14),
        d = n(135),
        f = n(82),
        p = d("slice"),
        h = f("slice", {
      ACCESSORS: !0,
      0: 0,
      1: 2
    }),
        m = c("species"),
        g = [].slice,
        v = Math.max;
    r({
      target: "Array",
      proto: !0,
      forced: !p || !h
    }, {
      slice: function slice(e, t) {
        var n,
            r,
            c,
            d = l(this),
            f = s(d.length),
            p = a(e, f),
            h = a(void 0 === t ? f : t, f);
        if (i(d) && (n = d.constructor, "function" != typeof n || n !== Array && !i(n.prototype) ? o(n) && null === (n = n[m]) && (n = void 0) : n = void 0, n === Array || void 0 === n)) return g.call(d, p, h);

        for (r = new (void 0 === n ? Array : n)(v(h - p, 0)), c = 0; p < h; p++, c++) {
          p in d && u(r, c, d[p]);
        }

        return r.length = c, r;
      }
    });
  }, function (e, t) {
    function n() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    e.exports = n;
  }, function (e, t, n) {
    var r = n(715);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(716),
        o = Array.prototype;

    e.exports = function (e) {
      var t = e.map;
      return e === o || e instanceof Array && t === o.map ? r : t;
    };
  }, function (e, t, n) {
    n(717);
    var r = n(60);
    e.exports = r("Array").map;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(105).map,
        i = n(135),
        a = n(82),
        s = i("map"),
        l = a("map");
    r({
      target: "Array",
      proto: !0,
      forced: !s || !l
    }, {
      map: function map(e) {
        return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
      }
    });
  }, function (e, t, n) {
    var r = n(719);
    e.exports = r;
  }, function (e, t, n) {
    n(720);
    var r = n(21);
    e.exports = r.Object.entries;
  }, function (e, t, n) {
    var r = n(9),
        o = n(721).entries;
    r({
      target: "Object",
      stat: !0
    }, {
      entries: function entries(e) {
        return o(e);
      }
    });
  }, function (e, t, n) {
    var r = n(26),
        o = n(97),
        i = n(43),
        a = n(120).f,
        s = function s(e) {
      return function (t) {
        for (var n, s = i(t), l = o(s), u = l.length, c = 0, d = []; u > c;) {
          n = l[c++], r && !a.call(s, n) || d.push(e ? [n, s[n]] : s[n]);
        }

        return d;
      };
    };

    e.exports = {
      entries: s(!0),
      values: s(!1)
    };
  }, function (e, t, n) {
    var r = n(723);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(724),
        o = Array.prototype;

    e.exports = function (e) {
      var t = e.concat;
      return e === o || e instanceof Array && t === o.concat ? r : t;
    };
  }, function (e, t, n) {
    n(344);
    var r = n(60);
    e.exports = r("Array").concat;
  }, function (e, t, n) {
    "use strict";

    var r = n(34),
        o = n(40);
    r(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var i = o(n(726)),
        a = function a(e) {
      switch (e) {
        case "1.0.0":
          return i.default;

        case void 0:
        case null:
          throw new Error("Api version is required");

        default:
          throw new Error("Unknown api version: ".concat(e, ".  Use an exact semver version."));
      }
    },
        s = a;

    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(34),
        o = n(40);
    r(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = o(n(353)),
        a = {
      makeIdxState: i.default
    };
    t.default = a;
  }, function (e, t, n) {
    e.exports = n(728);
  }, function (e, t, n) {
    var r = n(729);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(730),
        o = Array.prototype;

    e.exports = function (e) {
      var t = e.find;
      return e === o || e instanceof Array && t === o.find ? r : t;
    };
  }, function (e, t, n) {
    n(731);
    var r = n(60);
    e.exports = r("Array").find;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(105).find,
        i = n(303),
        a = n(82),
        s = !0,
        l = a("find");
    "find" in [] && Array(1).find(function () {
      s = !1;
    }), r({
      target: "Array",
      proto: !0,
      forced: s || !l
    }, {
      find: function find(e) {
        return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), i("find");
  }, function (e, t, n) {
    function r(e) {
      return o(e) || i(e) || a(e) || s();
    }

    var o = n(733),
        i = n(734),
        a = n(346),
        s = n(735);
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      if (o(e)) return i(e);
    }

    var o = n(339),
        i = n(350);
    e.exports = r;
  }, function (e, t, n) {
    function r(e) {
      if (void 0 !== a && i(Object(e))) return o(e);
    }

    var o = n(347),
        i = n(342),
        a = n(191);
    e.exports = r;
  }, function (e, t) {
    function n() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = i(e);

      if (a) {
        var r = a(e);
        t && (r = s(r).call(r, function (t) {
          return l(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};

        if (t % 2) {
          var o;
          u(o = r(Object(n), !0)).call(o, function (t) {
            (0, g.default)(e, t, n[t]);
          });
        } else if (c) d(e, c(n));else {
          var i;
          u(i = r(Object(n))).call(i, function (t) {
            f(e, t, l(n, t));
          });
        }
      }

      return e;
    }

    var i = n(133),
        a = n(184),
        s = n(134),
        l = n(187),
        u = n(106),
        c = n(188),
        d = n(189),
        f = n(34),
        p = n(40);
    f(t, "__esModule", {
      value: !0
    }), t.parseIdxResponse = t.parseNonRemediations = void 0, n(107);

    var h,
        m = p(n(338)),
        g = p(n(190)),
        v = p(n(737)),
        y = p(n(744)),
        b = p(n(355)),
        _ = p(n(192)),
        w = p(n(106)),
        E = p(n(134)),
        O = p(n(133)),
        S = p(n(351)),
        x = p(n(352)),
        T = p(n(193)),
        k = n(752),
        C = p(n(356)),
        A = p(n(765)),
        N = (0, b.default)((0, _.default)(h = ["remediation", "context"]).call(h, function (e) {
      return [e, !0];
    })),
        P = function P(e) {
      var t,
          n,
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          i = {},
          a = {};
      return (0, w.default)(t = (0, E.default)(n = (0, O.default)(e)).call(n, function (e) {
        return !N[e];
      })).call(t, function (t) {
        var n;
        if ("object" !== (0, y.default)(e[t]) || !e[t]) return void (a[t] = e[t]);
        if (e[t].rel) return void (i[e[t].name] = (0, C.default)(e[t], r));
        var s = e[t],
            l = s.value,
            u = s.type,
            c = (0, v.default)(s, ["value", "type"]);
        if (a[t] = o({
          type: u
        }, c), "object" !== u) return void (a[t].value = l);
        a[t].value = {}, (0, w.default)(n = (0, S.default)(l)).call(n, function (e) {
          var n = (0, m.default)(e, 2),
              o = n[0],
              s = n[1];

          if (s.rel) {
            var l;
            i[(0, x.default)(l = "".concat(t, "-")).call(l, o.name || o)] = (0, C.default)(s, r);
          } else a[t].value[o] = s;
        });
      }), {
        context: a,
        actions: i
      };
    };

    t.parseNonRemediations = P;

    var R = function e(t, n) {
      var r;
      (0, w.default)(r = (0, O.default)(n)).call(r, function (r) {
        if ("relatesTo" === r) {
          var o = (0, T.default)(n[r]) ? n[r][0] : n[r];

          if ("string" == typeof o) {
            var i = A.default.query(t, o)[0];
            if (i) return void (n[r] = i);
          }
        }

        if ((0, T.default)(n[r])) {
          var a;
          (0, w.default)(a = n[r]).call(a, function (n) {
            return e(t, n);
          });
        }
      });
    },
        I = function I(e, t) {
      var n = (0, k.generateRemediationFunctions)([e], t),
          r = n[e.name];
      return o(o({}, e), {}, {
        action: r
      });
    },
        M = function M(e) {
      var t,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = (null === (t = e.remediation) || void 0 === t ? void 0 : t.value) || [];
      (0, w.default)(r).call(r, function (t) {
        return R(e, t);
      });
      var o = (0, _.default)(r).call(r, function (e) {
        return I(e, n);
      }),
          i = P(e, n);
      return {
        remediations: o,
        context: i.context,
        actions: i.actions
      };
    };

    t.parseIdxResponse = M;
  }, function (e, t, n) {
    function r(e, t) {
      if (null == e) return {};
      var n,
          r,
          s = a(e, t);

      if (i) {
        var l = i(e);

        for (r = 0; r < l.length; r++) {
          n = l[r], o(t).call(t, n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (s[n] = e[n]);
        }
      }

      return s;
    }

    var o = n(354),
        i = n(739),
        a = n(741);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(287);
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(740);
  }, function (e, t, n) {
    var r = n(335);
    e.exports = r;
  }, function (e, t, n) {
    function r(e, t) {
      if (null == e) return {};
      var n,
          r,
          a = {},
          s = i(e);

      for (r = 0; r < s.length; r++) {
        n = s[r], o(t).call(t, n) >= 0 || (a[n] = e[n]);
      }

      return a;
    }

    var o = n(354),
        i = n(742);
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(743);
  }, function (e, t, n) {
    var r = n(334);
    e.exports = r;
  }, function (e, t, n) {
    function r(t) {
      "@babel/helpers - typeof";

      return e.exports = r = "function" == typeof i && "symbol" == typeof o ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof i && e.constructor === i && e !== i.prototype ? "symbol" : typeof e;
      }, r(t);
    }

    var o = n(745),
        i = n(191);
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(746);
  }, function (e, t, n) {
    var r = n(747);
    e.exports = r;
  }, function (e, t, n) {
    n(345), n(61), n(84);
    var r = n(186);
    e.exports = r.f("iterator");
  }, function (e, t, n) {
    var r = n(749);
    e.exports = r;
  }, function (e, t, n) {
    n(174), n(750);
    var r = n(21);
    e.exports = r.Object.fromEntries;
  }, function (e, t, n) {
    var r = n(9),
        o = n(98),
        i = n(101);
    r({
      target: "Object",
      stat: !0
    }, {
      fromEntries: function fromEntries(e) {
        var t = {};
        return o(e, function (e, n) {
          i(t, e, n);
        }, void 0, !0), t;
      }
    });
  }, function (e, t, n) {
    var r = n(340);
    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    var r = n(34),
        o = n(40);
    r(t, "__esModule", {
      value: !0
    }), t.generateRemediationFunctions = void 0, n(107);

    var i = o(n(355)),
        a = o(n(192)),
        s = o(n(356)),
        l = function l(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return (0, i.default)((0, a.default)(e).call(e, function (e) {
        return [e.name, (0, s.default)(e, t)];
      }));
    };

    t.generateRemediationFunctions = l;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var _n3;

      if (void 0 === l || null == u(e)) {
        if (c(e) || (_n3 = o(e)) || t && e && "number" == typeof e.length) {
          _n3 && (e = _n3);

          var r = 0,
              i = function i() {};

          return {
            s: i,
            n: function n() {
              return r >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[r++]
              };
            },
            e: function e(_e4) {
              throw _e4;
            },
            f: i
          };
        }

        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var a,
          s = !0,
          _f = !1;

      return {
        s: function s() {
          _n3 = d(e);
        },
        n: function n() {
          var e = _n3.next();

          return s = e.done, e;
        },
        e: function e(_e5) {
          _f = !0, a = _e5;
        },
        f: function f() {
          try {
            s || null == _n3.return || _n3.return();
          } finally {
            if (_f) throw a;
          }
        }
      };
    }

    function o(e, t) {
      var n;

      if (e) {
        if ("string" == typeof e) return i(e, t);
        var r = a(n = Object.prototype.toString.call(e)).call(n, 8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? s(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? i(e, t) : void 0;
      }
    }

    function i(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    n(754);
    var a = n(757),
        s = n(759),
        l = n(761),
        u = n(763),
        c = n(193),
        d = n(341),
        f = n(34),
        p = n(40);
    f(t, "__esModule", {
      value: !0
    }), t.divideActionParamsByMutability = void 0;
    var h = p(n(193));
    n(107);

    var m = function m(e) {
      return !1 !== e.mutable;
    },
        g = function g(e) {
      var t = {},
          n = [],
          o = {};
      if (!e.value) return n.push(e), {
        defaultParamsForAction: t,
        neededParamsForAction: n,
        immutableParamsForAction: o
      };
      var i,
          a = r(e.value);

      try {
        for (a.s(); !(i = a.n()).done;) {
          var s = i.value;

          if (m(s)) {
            var l;
            n.push(s), null !== (l = s.value) && void 0 !== l && l && (t[s.name] = s.value);
          } else {
            var u;
            o[s.name] = null !== (u = s.value) && void 0 !== u ? u : "";
          }
        }
      } catch (e) {
        a.e(e);
      } finally {
        a.f();
      }

      return {
        defaultParamsForAction: t,
        neededParamsForAction: n,
        immutableParamsForAction: o
      };
    },
        v = function v(e) {
      e = (0, h.default)(e) ? e : [e];
      var t,
          n = [],
          o = {},
          i = {},
          a = r(e);

      try {
        for (a.s(); !(t = a.n()).done;) {
          var s = t.value,
              l = g(s),
              u = l.defaultParamsForAction,
              c = l.neededParamsForAction,
              d = l.immutableParamsForAction;
          n.push(c), o[s.name] = u, i[s.name] = d;
        }
      } catch (e) {
        a.e(e);
      } finally {
        a.f();
      }

      return {
        defaultParams: o,
        neededParams: n,
        immutableParams: i
      };
    };

    t.divideActionParamsByMutability = v;
  }, function (e, t, n) {
    var r = n(194),
        o = n(179),
        i = n(755);
    r || o(Object.prototype, "toString", i, {
      unsafe: !0
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(194),
        o = n(756);
    e.exports = r ? {}.toString : function () {
      return "[object " + o(this) + "]";
    };
  }, function (e, t, n) {
    var r = n(194),
        o = n(127),
        i = n(183),
        a = i("toStringTag"),
        s = "Arguments" == o(function () {
      return arguments;
    }()),
        l = function l(e, t) {
      try {
        return e[t];
      } catch (e) {}
    };

    e.exports = r ? o : function (e) {
      var t, n, r;
      return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = l(t = Object(e), a)) ? n : s ? o(t) : "Object" == (r = o(t)) && "function" == typeof t.callee ? "Arguments" : r;
    };
  }, function (e, t, n) {
    e.exports = n(758);
  }, function (e, t, n) {
    var r = n(349);
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(760);
  }, function (e, t, n) {
    var r = n(348);
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(762);
  }, function (e, t, n) {
    var r = n(343);
    e.exports = r;
  }, function (e, t, n) {
    e.exports = n(764);
  }, function (e, t, n) {
    n(84), n(61);
    var r = n(99);
    e.exports = r;
  }, function (e, t, n) {
    (function (t) {
      var n, n;
      /*! jsonpath 1.0.2 */

      !function (t) {
        e.exports = t();
      }(function () {
        var e;
        return function e(t, r, o) {
          function i(s, l) {
            if (!r[s]) {
              if (!t[s]) {
                var u = "function" == typeof n && n;
                if (!l && u) return n(s, !0);
                if (a) return a(s, !0);
                var c = new Error("Cannot find module '" + s + "'");
                throw c.code = "MODULE_NOT_FOUND", c;
              }

              var d = r[s] = {
                exports: {}
              };
              t[s][0].call(d.exports, function (e) {
                var n = t[s][1][e];
                return i(n || e);
              }, d, d.exports, e, t, r, o);
            }

            return r[s].exports;
          }

          for (var a = "function" == typeof n && n, s = 0; s < o.length; s++) {
            i(o[s]);
          }

          return i;
        }({
          "./aesprim": [function (t, n, r) {
            /*
            Copyright (C) 2013 Ariya Hidayat <ariya.hidayat@gmail.com>
            Copyright (C) 2013 Thaddee Tyl <thaddee.tyl@gmail.com>
            Copyright (C) 2013 Mathias Bynens <mathias@qiwi.be>
            Copyright (C) 2012 Ariya Hidayat <ariya.hidayat@gmail.com>
            Copyright (C) 2012 Mathias Bynens <mathias@qiwi.be>
            Copyright (C) 2012 Joost-Wim Boekesteijn <joost-wim@boekesteijn.nl>
            Copyright (C) 2012 Kris Kowal <kris.kowal@cixar.com>
            Copyright (C) 2012 Yusuke Suzuki <utatane.tea@gmail.com>
            Copyright (C) 2012 Arpad Borsos <arpad.borsos@googlemail.com>
            Copyright (C) 2011 Ariya Hidayat <ariya.hidayat@gmail.com>
            Redistribution and use in source and binary forms, with or without
            modification, are permitted provided that the following conditions are met:
            * Redistributions of source code must retain the above copyright
            notice, this list of conditions and the following disclaimer.
            * Redistributions in binary form must reproduce the above copyright
            notice, this list of conditions and the following disclaimer in the
            documentation and/or other materials provided with the distribution.
            THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
            AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
            IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
            ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
            DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
            (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
            LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
            ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
            (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
            THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            */
            !function (t, n) {
              "use strict";

              "function" == typeof e && e.amd ? e(["exports"], n) : n(void 0 !== r ? r : t.esprima = {});
            }(this, function (e) {
              "use strict";

              function t(e, t) {
                if (!e) throw new Error("ASSERT: " + t);
              }

              function n(e) {
                return e >= 48 && e <= 57;
              }

              function r(e) {
                return "0123456789abcdefABCDEF".indexOf(e) >= 0;
              }

              function o(e) {
                return "01234567".indexOf(e) >= 0;
              }

              function i(e) {
                return 32 === e || 9 === e || 11 === e || 12 === e || 160 === e || e >= 5760 && [5760, 6158, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279].indexOf(e) >= 0;
              }

              function a(e) {
                return 10 === e || 13 === e || 8232 === e || 8233 === e;
              }

              function s(e) {
                return 64 == e || 36 === e || 95 === e || e >= 65 && e <= 90 || e >= 97 && e <= 122 || 92 === e || e >= 128 && ot.NonAsciiIdentifierStart.test(String.fromCharCode(e));
              }

              function l(e) {
                return 36 === e || 95 === e || e >= 65 && e <= 90 || e >= 97 && e <= 122 || e >= 48 && e <= 57 || 92 === e || e >= 128 && ot.NonAsciiIdentifierPart.test(String.fromCharCode(e));
              }

              function u(e) {
                switch (e) {
                  case "class":
                  case "enum":
                  case "export":
                  case "extends":
                  case "import":
                  case "super":
                    return !0;

                  default:
                    return !1;
                }
              }

              function c(e) {
                switch (e) {
                  case "implements":
                  case "interface":
                  case "package":
                  case "private":
                  case "protected":
                  case "public":
                  case "static":
                  case "yield":
                  case "let":
                    return !0;

                  default:
                    return !1;
                }
              }

              function d(e) {
                return "eval" === e || "arguments" === e;
              }

              function f(e) {
                if (st && c(e)) return !0;

                switch (e.length) {
                  case 2:
                    return "if" === e || "in" === e || "do" === e;

                  case 3:
                    return "var" === e || "for" === e || "new" === e || "try" === e || "let" === e;

                  case 4:
                    return "this" === e || "else" === e || "case" === e || "void" === e || "with" === e || "enum" === e;

                  case 5:
                    return "while" === e || "break" === e || "catch" === e || "throw" === e || "const" === e || "yield" === e || "class" === e || "super" === e;

                  case 6:
                    return "return" === e || "typeof" === e || "delete" === e || "switch" === e || "export" === e || "import" === e;

                  case 7:
                    return "default" === e || "finally" === e || "extends" === e;

                  case 8:
                    return "function" === e || "continue" === e || "debugger" === e;

                  case 10:
                    return "instanceof" === e;

                  default:
                    return !1;
                }
              }

              function p(e, n, r, o, i) {
                var a;
                t("number" == typeof r, "Comment must have valid position"), ht.lastCommentStart >= r || (ht.lastCommentStart = r, a = {
                  type: e,
                  value: n
                }, mt.range && (a.range = [r, o]), mt.loc && (a.loc = i), mt.comments.push(a), mt.attachComment && (mt.leadingComments.push(a), mt.trailingComments.push(a)));
              }

              function h(e) {
                var t, n, r, o;

                for (t = lt - e, n = {
                  start: {
                    line: ut,
                    column: lt - ct - e
                  }
                }; lt < dt;) {
                  if (r = at.charCodeAt(lt), ++lt, a(r)) return mt.comments && (o = at.slice(t + e, lt - 1), n.end = {
                    line: ut,
                    column: lt - ct - 1
                  }, p("Line", o, t, lt - 1, n)), 13 === r && 10 === at.charCodeAt(lt) && ++lt, ++ut, void (ct = lt);
                }

                mt.comments && (o = at.slice(t + e, lt), n.end = {
                  line: ut,
                  column: lt - ct
                }, p("Line", o, t, lt, n));
              }

              function m() {
                var e, t, n, r;

                for (mt.comments && (e = lt - 2, t = {
                  start: {
                    line: ut,
                    column: lt - ct - 2
                  }
                }); lt < dt;) {
                  if (n = at.charCodeAt(lt), a(n)) 13 === n && 10 === at.charCodeAt(lt + 1) && ++lt, ++ut, ++lt, ct = lt, lt >= dt && B({}, rt.UnexpectedToken, "ILLEGAL");else if (42 === n) {
                    if (47 === at.charCodeAt(lt + 1)) return ++lt, ++lt, void (mt.comments && (r = at.slice(e + 2, lt - 2), t.end = {
                      line: ut,
                      column: lt - ct
                    }, p("Block", r, e, lt, t)));
                    ++lt;
                  } else ++lt;
                }

                B({}, rt.UnexpectedToken, "ILLEGAL");
              }

              function g() {
                var e, t;

                for (t = 0 === lt; lt < dt;) {
                  if (e = at.charCodeAt(lt), i(e)) ++lt;else if (a(e)) ++lt, 13 === e && 10 === at.charCodeAt(lt) && ++lt, ++ut, ct = lt, t = !0;else if (47 === e) {
                    if (47 === (e = at.charCodeAt(lt + 1))) ++lt, ++lt, h(2), t = !0;else {
                      if (42 !== e) break;
                      ++lt, ++lt, m();
                    }
                  } else if (t && 45 === e) {
                    if (45 !== at.charCodeAt(lt + 1) || 62 !== at.charCodeAt(lt + 2)) break;
                    lt += 3, h(3);
                  } else {
                    if (60 !== e) break;
                    if ("!--" !== at.slice(lt + 1, lt + 4)) break;
                    ++lt, ++lt, ++lt, ++lt, h(4);
                  }
                }
              }

              function v(e) {
                var t,
                    n,
                    o,
                    i = 0;

                for (n = "u" === e ? 4 : 2, t = 0; t < n; ++t) {
                  if (!(lt < dt && r(at[lt]))) return "";
                  o = at[lt++], i = 16 * i + "0123456789abcdef".indexOf(o.toLowerCase());
                }

                return String.fromCharCode(i);
              }

              function y() {
                var e, t;

                for (e = at.charCodeAt(lt++), t = String.fromCharCode(e), 92 === e && (117 !== at.charCodeAt(lt) && B({}, rt.UnexpectedToken, "ILLEGAL"), ++lt, e = v("u"), e && "\\" !== e && s(e.charCodeAt(0)) || B({}, rt.UnexpectedToken, "ILLEGAL"), t = e); lt < dt && (e = at.charCodeAt(lt), l(e));) {
                  ++lt, t += String.fromCharCode(e), 92 === e && (t = t.substr(0, t.length - 1), 117 !== at.charCodeAt(lt) && B({}, rt.UnexpectedToken, "ILLEGAL"), ++lt, e = v("u"), e && "\\" !== e && l(e.charCodeAt(0)) || B({}, rt.UnexpectedToken, "ILLEGAL"), t += e);
                }

                return t;
              }

              function b() {
                var e, t;

                for (e = lt++; lt < dt;) {
                  if (92 === (t = at.charCodeAt(lt))) return lt = e, y();
                  if (!l(t)) break;
                  ++lt;
                }

                return at.slice(e, lt);
              }

              function _() {
                var e, t, n;
                return e = lt, t = 92 === at.charCodeAt(lt) ? y() : b(), n = 1 === t.length ? Xe.Identifier : f(t) ? Xe.Keyword : "null" === t ? Xe.NullLiteral : "true" === t || "false" === t ? Xe.BooleanLiteral : Xe.Identifier, {
                  type: n,
                  value: t,
                  lineNumber: ut,
                  lineStart: ct,
                  start: e,
                  end: lt
                };
              }

              function w() {
                var e,
                    t,
                    n,
                    r,
                    o = lt,
                    i = at.charCodeAt(lt),
                    a = at[lt];

                switch (i) {
                  case 46:
                  case 40:
                  case 41:
                  case 59:
                  case 44:
                  case 123:
                  case 125:
                  case 91:
                  case 93:
                  case 58:
                  case 63:
                  case 126:
                    return ++lt, mt.tokenize && (40 === i ? mt.openParenToken = mt.tokens.length : 123 === i && (mt.openCurlyToken = mt.tokens.length)), {
                      type: Xe.Punctuator,
                      value: String.fromCharCode(i),
                      lineNumber: ut,
                      lineStart: ct,
                      start: o,
                      end: lt
                    };

                  default:
                    if (61 === (e = at.charCodeAt(lt + 1))) switch (i) {
                      case 43:
                      case 45:
                      case 47:
                      case 60:
                      case 62:
                      case 94:
                      case 124:
                      case 37:
                      case 38:
                      case 42:
                        return lt += 2, {
                          type: Xe.Punctuator,
                          value: String.fromCharCode(i) + String.fromCharCode(e),
                          lineNumber: ut,
                          lineStart: ct,
                          start: o,
                          end: lt
                        };

                      case 33:
                      case 61:
                        return lt += 2, 61 === at.charCodeAt(lt) && ++lt, {
                          type: Xe.Punctuator,
                          value: at.slice(o, lt),
                          lineNumber: ut,
                          lineStart: ct,
                          start: o,
                          end: lt
                        };
                    }
                }

                return ">>>=" === (r = at.substr(lt, 4)) ? (lt += 4, {
                  type: Xe.Punctuator,
                  value: r,
                  lineNumber: ut,
                  lineStart: ct,
                  start: o,
                  end: lt
                }) : ">>>" === (n = r.substr(0, 3)) || "<<=" === n || ">>=" === n ? (lt += 3, {
                  type: Xe.Punctuator,
                  value: n,
                  lineNumber: ut,
                  lineStart: ct,
                  start: o,
                  end: lt
                }) : (t = n.substr(0, 2), a === t[1] && "+-<>&|".indexOf(a) >= 0 || "=>" === t ? (lt += 2, {
                  type: Xe.Punctuator,
                  value: t,
                  lineNumber: ut,
                  lineStart: ct,
                  start: o,
                  end: lt
                }) : "<>=!+-*%&|^/".indexOf(a) >= 0 ? (++lt, {
                  type: Xe.Punctuator,
                  value: a,
                  lineNumber: ut,
                  lineStart: ct,
                  start: o,
                  end: lt
                }) : void B({}, rt.UnexpectedToken, "ILLEGAL"));
              }

              function E(e) {
                for (var t = ""; lt < dt && r(at[lt]);) {
                  t += at[lt++];
                }

                return 0 === t.length && B({}, rt.UnexpectedToken, "ILLEGAL"), s(at.charCodeAt(lt)) && B({}, rt.UnexpectedToken, "ILLEGAL"), {
                  type: Xe.NumericLiteral,
                  value: parseInt("0x" + t, 16),
                  lineNumber: ut,
                  lineStart: ct,
                  start: e,
                  end: lt
                };
              }

              function O(e) {
                for (var t = "0" + at[lt++]; lt < dt && o(at[lt]);) {
                  t += at[lt++];
                }

                return (s(at.charCodeAt(lt)) || n(at.charCodeAt(lt))) && B({}, rt.UnexpectedToken, "ILLEGAL"), {
                  type: Xe.NumericLiteral,
                  value: parseInt(t, 8),
                  octal: !0,
                  lineNumber: ut,
                  lineStart: ct,
                  start: e,
                  end: lt
                };
              }

              function S() {
                var e, r, i;

                if (i = at[lt], t(n(i.charCodeAt(0)) || "." === i, "Numeric literal must start with a decimal digit or a decimal point"), r = lt, e = "", "." !== i) {
                  if (e = at[lt++], i = at[lt], "0" === e) {
                    if ("x" === i || "X" === i) return ++lt, E(r);
                    if (o(i)) return O(r);
                    i && n(i.charCodeAt(0)) && B({}, rt.UnexpectedToken, "ILLEGAL");
                  }

                  for (; n(at.charCodeAt(lt));) {
                    e += at[lt++];
                  }

                  i = at[lt];
                }

                if ("." === i) {
                  for (e += at[lt++]; n(at.charCodeAt(lt));) {
                    e += at[lt++];
                  }

                  i = at[lt];
                }

                if ("e" === i || "E" === i) if (e += at[lt++], i = at[lt], "+" !== i && "-" !== i || (e += at[lt++]), n(at.charCodeAt(lt))) for (; n(at.charCodeAt(lt));) {
                  e += at[lt++];
                } else B({}, rt.UnexpectedToken, "ILLEGAL");
                return s(at.charCodeAt(lt)) && B({}, rt.UnexpectedToken, "ILLEGAL"), {
                  type: Xe.NumericLiteral,
                  value: parseFloat(e),
                  lineNumber: ut,
                  lineStart: ct,
                  start: r,
                  end: lt
                };
              }

              function x() {
                var e,
                    n,
                    r,
                    i,
                    s,
                    l,
                    u,
                    c,
                    d = "",
                    f = !1;

                for (u = ut, c = ct, e = at[lt], t("'" === e || '"' === e, "String literal must starts with a quote"), n = lt, ++lt; lt < dt;) {
                  if ((r = at[lt++]) === e) {
                    e = "";
                    break;
                  }

                  if ("\\" === r) {
                    if ((r = at[lt++]) && a(r.charCodeAt(0))) ++ut, "\r" === r && "\n" === at[lt] && ++lt, ct = lt;else switch (r) {
                      case "u":
                      case "x":
                        l = lt, s = v(r), s ? d += s : (lt = l, d += r);
                        break;

                      case "n":
                        d += "\n";
                        break;

                      case "r":
                        d += "\r";
                        break;

                      case "t":
                        d += "\t";
                        break;

                      case "b":
                        d += "\b";
                        break;

                      case "f":
                        d += "\f";
                        break;

                      case "v":
                        d += "\v";
                        break;

                      default:
                        o(r) ? (i = "01234567".indexOf(r), 0 !== i && (f = !0), lt < dt && o(at[lt]) && (f = !0, i = 8 * i + "01234567".indexOf(at[lt++]), "0123".indexOf(r) >= 0 && lt < dt && o(at[lt]) && (i = 8 * i + "01234567".indexOf(at[lt++]))), d += String.fromCharCode(i)) : d += r;
                    }
                  } else {
                    if (a(r.charCodeAt(0))) break;
                    d += r;
                  }
                }

                return "" !== e && B({}, rt.UnexpectedToken, "ILLEGAL"), {
                  type: Xe.StringLiteral,
                  value: d,
                  octal: f,
                  startLineNumber: u,
                  startLineStart: c,
                  lineNumber: ut,
                  lineStart: ct,
                  start: n,
                  end: lt
                };
              }

              function T(e, t) {
                var n;

                try {
                  n = new RegExp(e, t);
                } catch (e) {
                  B({}, rt.InvalidRegExp);
                }

                return n;
              }

              function k() {
                var e, n, r, o, i;

                for (e = at[lt], t("/" === e, "Regular expression literal must start with a slash"), n = at[lt++], r = !1, o = !1; lt < dt;) {
                  if (e = at[lt++], n += e, "\\" === e) e = at[lt++], a(e.charCodeAt(0)) && B({}, rt.UnterminatedRegExp), n += e;else if (a(e.charCodeAt(0))) B({}, rt.UnterminatedRegExp);else if (r) "]" === e && (r = !1);else {
                    if ("/" === e) {
                      o = !0;
                      break;
                    }

                    "[" === e && (r = !0);
                  }
                }

                return o || B({}, rt.UnterminatedRegExp), i = n.substr(1, n.length - 2), {
                  value: i,
                  literal: n
                };
              }

              function C() {
                var e, t, n, r;

                for (t = "", n = ""; lt < dt && (e = at[lt], l(e.charCodeAt(0)));) {
                  if (++lt, "\\" === e && lt < dt) {
                    if ("u" === (e = at[lt])) {
                      if (++lt, r = lt, e = v("u")) for (n += e, t += "\\u"; r < lt; ++r) {
                        t += at[r];
                      } else lt = r, n += "u", t += "\\u";
                      V({}, rt.UnexpectedToken, "ILLEGAL");
                    } else t += "\\", V({}, rt.UnexpectedToken, "ILLEGAL");
                  } else n += e, t += e;
                }

                return {
                  value: n,
                  literal: t
                };
              }

              function A() {
                var e, t, n, r;
                return pt = null, g(), e = lt, t = k(), n = C(), r = T(t.value, n.value), mt.tokenize ? {
                  type: Xe.RegularExpression,
                  value: r,
                  lineNumber: ut,
                  lineStart: ct,
                  start: e,
                  end: lt
                } : {
                  literal: t.literal + n.literal,
                  value: r,
                  start: e,
                  end: lt
                };
              }

              function N() {
                var e, t, n, r;
                return g(), e = lt, t = {
                  start: {
                    line: ut,
                    column: lt - ct
                  }
                }, n = A(), t.end = {
                  line: ut,
                  column: lt - ct
                }, mt.tokenize || (mt.tokens.length > 0 && (r = mt.tokens[mt.tokens.length - 1], r.range[0] === e && "Punctuator" === r.type && ("/" !== r.value && "/=" !== r.value || mt.tokens.pop())), mt.tokens.push({
                  type: "RegularExpression",
                  value: n.literal,
                  range: [e, lt],
                  loc: t
                })), n;
              }

              function P(e) {
                return e.type === Xe.Identifier || e.type === Xe.Keyword || e.type === Xe.BooleanLiteral || e.type === Xe.NullLiteral;
              }

              function R() {
                var e, t;
                if (!(e = mt.tokens[mt.tokens.length - 1])) return N();

                if ("Punctuator" === e.type) {
                  if ("]" === e.value) return w();
                  if (")" === e.value) return t = mt.tokens[mt.openParenToken - 1], !t || "Keyword" !== t.type || "if" !== t.value && "while" !== t.value && "for" !== t.value && "with" !== t.value ? w() : N();

                  if ("}" === e.value) {
                    if (mt.tokens[mt.openCurlyToken - 3] && "Keyword" === mt.tokens[mt.openCurlyToken - 3].type) {
                      if (!(t = mt.tokens[mt.openCurlyToken - 4])) return w();
                    } else {
                      if (!mt.tokens[mt.openCurlyToken - 4] || "Keyword" !== mt.tokens[mt.openCurlyToken - 4].type) return w();
                      if (!(t = mt.tokens[mt.openCurlyToken - 5])) return N();
                    }

                    return et.indexOf(t.value) >= 0 ? w() : N();
                  }

                  return N();
                }

                return "Keyword" === e.type ? N() : w();
              }

              function I() {
                var e;
                return g(), lt >= dt ? {
                  type: Xe.EOF,
                  lineNumber: ut,
                  lineStart: ct,
                  start: lt,
                  end: lt
                } : (e = at.charCodeAt(lt), s(e) ? _() : 40 === e || 41 === e || 59 === e ? w() : 39 === e || 34 === e ? x() : 46 === e ? n(at.charCodeAt(lt + 1)) ? S() : w() : n(e) ? S() : mt.tokenize && 47 === e ? R() : w());
              }

              function M() {
                var e, t, n;
                return g(), e = {
                  start: {
                    line: ut,
                    column: lt - ct
                  }
                }, t = I(), e.end = {
                  line: ut,
                  column: lt - ct
                }, t.type !== Xe.EOF && (n = at.slice(t.start, t.end), mt.tokens.push({
                  type: Ze[t.type],
                  value: n,
                  range: [t.start, t.end],
                  loc: e
                })), t;
              }

              function j() {
                var e;
                return e = pt, lt = e.end, ut = e.lineNumber, ct = e.lineStart, pt = void 0 !== mt.tokens ? M() : I(), lt = e.end, ut = e.lineNumber, ct = e.lineStart, e;
              }

              function L() {
                var e, t, n;
                e = lt, t = ut, n = ct, pt = void 0 !== mt.tokens ? M() : I(), lt = e, ut = t, ct = n;
              }

              function D(e, t) {
                this.line = e, this.column = t;
              }

              function F(e, t, n, r) {
                this.start = new D(e, t), this.end = new D(n, r);
              }

              function U() {
                var e, t, n, r;
                return e = lt, t = ut, n = ct, g(), r = ut !== t, lt = e, ut = t, ct = n, r;
              }

              function B(e, n) {
                var r,
                    o = Array.prototype.slice.call(arguments, 2),
                    i = n.replace(/%(\d)/g, function (e, n) {
                  return t(n < o.length, "Message reference must be in range"), o[n];
                });
                throw "number" == typeof e.lineNumber ? (r = new Error("Line " + e.lineNumber + ": " + i), r.index = e.start, r.lineNumber = e.lineNumber, r.column = e.start - ct + 1) : (r = new Error("Line " + ut + ": " + i), r.index = lt, r.lineNumber = ut, r.column = lt - ct + 1), r.description = i, r;
              }

              function V() {
                try {
                  B.apply(null, arguments);
                } catch (e) {
                  if (!mt.errors) throw e;
                  mt.errors.push(e);
                }
              }

              function H(e) {
                if (e.type === Xe.EOF && B(e, rt.UnexpectedEOS), e.type === Xe.NumericLiteral && B(e, rt.UnexpectedNumber), e.type === Xe.StringLiteral && B(e, rt.UnexpectedString), e.type === Xe.Identifier && B(e, rt.UnexpectedIdentifier), e.type === Xe.Keyword) {
                  if (u(e.value)) B(e, rt.UnexpectedReserved);else if (st && c(e.value)) return void V(e, rt.StrictReservedWord);
                  B(e, rt.UnexpectedToken, e.value);
                }

                B(e, rt.UnexpectedToken, e.value);
              }

              function q(e) {
                var t = j();
                t.type === Xe.Punctuator && t.value === e || H(t);
              }

              function W(e) {
                var t = j();
                t.type === Xe.Keyword && t.value === e || H(t);
              }

              function z(e) {
                return pt.type === Xe.Punctuator && pt.value === e;
              }

              function $(e) {
                return pt.type === Xe.Keyword && pt.value === e;
              }

              function K() {
                var e;
                return pt.type === Xe.Punctuator && ("=" === (e = pt.value) || "*=" === e || "/=" === e || "%=" === e || "+=" === e || "-=" === e || "<<=" === e || ">>=" === e || ">>>=" === e || "&=" === e || "^=" === e || "|=" === e);
              }

              function G() {
                var e;
                if (59 === at.charCodeAt(lt) || z(";")) return void j();
                e = ut, g(), ut === e && (pt.type === Xe.EOF || z("}") || H(pt));
              }

              function Y(e) {
                return e.type === tt.Identifier || e.type === tt.MemberExpression;
              }

              function J() {
                var e,
                    t = [];

                for (e = pt, q("["); !z("]");) {
                  z(",") ? (j(), t.push(null)) : (t.push(me()), z("]") || q(","));
                }

                return j(), ft.markEnd(ft.createArrayExpression(t), e);
              }

              function Q(e, t) {
                var n, r, o;
                return n = st, o = pt, r = He(), t && st && d(e[0].name) && V(t, rt.StrictParamName), st = n, ft.markEnd(ft.createFunctionExpression(null, e, [], r), o);
              }

              function X() {
                var e, t;
                return t = pt, e = j(), e.type === Xe.StringLiteral || e.type === Xe.NumericLiteral ? (st && e.octal && V(e, rt.StrictOctalLiteral), ft.markEnd(ft.createLiteral(e), t)) : ft.markEnd(ft.createIdentifier(e.value), t);
              }

              function Z() {
                var e, t, n, r, o, i;
                return e = pt, i = pt, e.type === Xe.Identifier ? (n = X(), "get" !== e.value || z(":") ? "set" !== e.value || z(":") ? (q(":"), r = me(), ft.markEnd(ft.createProperty("init", n, r), i)) : (t = X(), q("("), e = pt, e.type !== Xe.Identifier ? (q(")"), V(e, rt.UnexpectedToken, e.value), r = Q([])) : (o = [be()], q(")"), r = Q(o, e)), ft.markEnd(ft.createProperty("set", t, r), i)) : (t = X(), q("("), q(")"), r = Q([]), ft.markEnd(ft.createProperty("get", t, r), i))) : e.type !== Xe.EOF && e.type !== Xe.Punctuator ? (t = X(), q(":"), r = me(), ft.markEnd(ft.createProperty("init", t, r), i)) : void H(e);
              }

              function ee() {
                var e,
                    t,
                    n,
                    r,
                    o,
                    i = [],
                    a = {},
                    s = String;

                for (o = pt, q("{"); !z("}");) {
                  e = Z(), t = e.key.type === tt.Identifier ? e.key.name : s(e.key.value), r = "init" === e.kind ? nt.Data : "get" === e.kind ? nt.Get : nt.Set, n = "$" + t, Object.prototype.hasOwnProperty.call(a, n) ? (a[n] === nt.Data ? st && r === nt.Data ? V({}, rt.StrictDuplicateProperty) : r !== nt.Data && V({}, rt.AccessorDataProperty) : r === nt.Data ? V({}, rt.AccessorDataProperty) : a[n] & r && V({}, rt.AccessorGetSet), a[n] |= r) : a[n] = r, i.push(e), z("}") || q(",");
                }

                return q("}"), ft.markEnd(ft.createObjectExpression(i), o);
              }

              function te() {
                var e;
                return q("("), e = ge(), q(")"), e;
              }

              function ne() {
                var e, t, n, r;
                if (z("(")) return te();
                if (z("[")) return J();
                if (z("{")) return ee();
                if (e = pt.type, r = pt, e === Xe.Identifier) n = ft.createIdentifier(j().value);else if (e === Xe.StringLiteral || e === Xe.NumericLiteral) st && pt.octal && V(pt, rt.StrictOctalLiteral), n = ft.createLiteral(j());else if (e === Xe.Keyword) {
                  if ($("function")) return ze();
                  $("this") ? (j(), n = ft.createThisExpression()) : H(j());
                } else e === Xe.BooleanLiteral ? (t = j(), t.value = "true" === t.value, n = ft.createLiteral(t)) : e === Xe.NullLiteral ? (t = j(), t.value = null, n = ft.createLiteral(t)) : z("/") || z("/=") ? (n = void 0 !== mt.tokens ? ft.createLiteral(N()) : ft.createLiteral(A()), L()) : H(j());
                return ft.markEnd(n, r);
              }

              function re() {
                var e = [];
                if (q("("), !z(")")) for (; lt < dt && (e.push(me()), !z(")"));) {
                  q(",");
                }
                return q(")"), e;
              }

              function oe() {
                var e, t;
                return t = pt, e = j(), P(e) || H(e), ft.markEnd(ft.createIdentifier(e.value), t);
              }

              function ie() {
                return q("."), oe();
              }

              function ae() {
                var e;
                return q("["), e = ge(), q("]"), e;
              }

              function se() {
                var e, t, n;
                return n = pt, W("new"), e = ue(), t = z("(") ? re() : [], ft.markEnd(ft.createNewExpression(e, t), n);
              }

              function le() {
                var e, t, n, r, o;

                for (o = pt, e = ht.allowIn, ht.allowIn = !0, t = $("new") ? se() : ne(), ht.allowIn = e;;) {
                  if (z(".")) r = ie(), t = ft.createMemberExpression(".", t, r);else if (z("(")) n = re(), t = ft.createCallExpression(t, n);else {
                    if (!z("[")) break;
                    r = ae(), t = ft.createMemberExpression("[", t, r);
                  }
                  ft.markEnd(t, o);
                }

                return t;
              }

              function ue() {
                var e, t, n, r;

                for (r = pt, e = ht.allowIn, t = $("new") ? se() : ne(), ht.allowIn = e; z(".") || z("[");) {
                  z("[") ? (n = ae(), t = ft.createMemberExpression("[", t, n)) : (n = ie(), t = ft.createMemberExpression(".", t, n)), ft.markEnd(t, r);
                }

                return t;
              }

              function ce() {
                var e,
                    t,
                    n = pt;
                return e = le(), pt.type === Xe.Punctuator && (!z("++") && !z("--") || U() || (st && e.type === tt.Identifier && d(e.name) && V({}, rt.StrictLHSPostfix), Y(e) || V({}, rt.InvalidLHSInAssignment), t = j(), e = ft.markEnd(ft.createPostfixExpression(t.value, e), n))), e;
              }

              function de() {
                var e, t, n;
                return pt.type !== Xe.Punctuator && pt.type !== Xe.Keyword ? t = ce() : z("++") || z("--") ? (n = pt, e = j(), t = de(), st && t.type === tt.Identifier && d(t.name) && V({}, rt.StrictLHSPrefix), Y(t) || V({}, rt.InvalidLHSInAssignment), t = ft.createUnaryExpression(e.value, t), t = ft.markEnd(t, n)) : z("+") || z("-") || z("~") || z("!") ? (n = pt, e = j(), t = de(), t = ft.createUnaryExpression(e.value, t), t = ft.markEnd(t, n)) : $("delete") || $("void") || $("typeof") ? (n = pt, e = j(), t = de(), t = ft.createUnaryExpression(e.value, t), t = ft.markEnd(t, n), st && "delete" === t.operator && t.argument.type === tt.Identifier && V({}, rt.StrictDelete)) : t = ce(), t;
              }

              function fe(e, t) {
                var n = 0;
                if (e.type !== Xe.Punctuator && e.type !== Xe.Keyword) return 0;

                switch (e.value) {
                  case "||":
                    n = 1;
                    break;

                  case "&&":
                    n = 2;
                    break;

                  case "|":
                    n = 3;
                    break;

                  case "^":
                    n = 4;
                    break;

                  case "&":
                    n = 5;
                    break;

                  case "==":
                  case "!=":
                  case "===":
                  case "!==":
                    n = 6;
                    break;

                  case "<":
                  case ">":
                  case "<=":
                  case ">=":
                  case "instanceof":
                    n = 7;
                    break;

                  case "in":
                    n = t ? 7 : 0;
                    break;

                  case "<<":
                  case ">>":
                  case ">>>":
                    n = 8;
                    break;

                  case "+":
                  case "-":
                    n = 9;
                    break;

                  case "*":
                  case "/":
                  case "%":
                    n = 11;
                }

                return n;
              }

              function pe() {
                var e, t, n, r, o, i, a, s, l, u;
                if (e = pt, l = de(), r = pt, 0 === (o = fe(r, ht.allowIn))) return l;

                for (r.prec = o, j(), t = [e, pt], a = de(), i = [l, r, a]; (o = fe(pt, ht.allowIn)) > 0;) {
                  for (; i.length > 2 && o <= i[i.length - 2].prec;) {
                    a = i.pop(), s = i.pop().value, l = i.pop(), n = ft.createBinaryExpression(s, l, a), t.pop(), e = t[t.length - 1], ft.markEnd(n, e), i.push(n);
                  }

                  r = j(), r.prec = o, i.push(r), t.push(pt), n = de(), i.push(n);
                }

                for (u = i.length - 1, n = i[u], t.pop(); u > 1;) {
                  n = ft.createBinaryExpression(i[u - 1].value, i[u - 2], n), u -= 2, e = t.pop(), ft.markEnd(n, e);
                }

                return n;
              }

              function he() {
                var e, t, n, r, o;
                return o = pt, e = pe(), z("?") && (j(), t = ht.allowIn, ht.allowIn = !0, n = me(), ht.allowIn = t, q(":"), r = me(), e = ft.createConditionalExpression(e, n, r), ft.markEnd(e, o)), e;
              }

              function me() {
                var e, t, n, r, o;
                return e = pt, o = pt, r = t = he(), K() && (Y(t) || V({}, rt.InvalidLHSInAssignment), st && t.type === tt.Identifier && d(t.name) && V(e, rt.StrictLHSAssignment), e = j(), n = me(), r = ft.markEnd(ft.createAssignmentExpression(e.value, t, n), o)), r;
              }

              function ge() {
                var e,
                    t = pt;

                if (e = me(), z(",")) {
                  for (e = ft.createSequenceExpression([e]); lt < dt && z(",");) {
                    j(), e.expressions.push(me());
                  }

                  ft.markEnd(e, t);
                }

                return e;
              }

              function ve() {
                for (var e, t = []; lt < dt && !z("}") && void 0 !== (e = $e());) {
                  t.push(e);
                }

                return t;
              }

              function ye() {
                var e, t;
                return t = pt, q("{"), e = ve(), q("}"), ft.markEnd(ft.createBlockStatement(e), t);
              }

              function be() {
                var e, t;
                return t = pt, e = j(), e.type !== Xe.Identifier && H(e), ft.markEnd(ft.createIdentifier(e.value), t);
              }

              function _e(e) {
                var t,
                    n,
                    r = null;
                return n = pt, t = be(), st && d(t.name) && V({}, rt.StrictVarName), "const" === e ? (q("="), r = me()) : z("=") && (j(), r = me()), ft.markEnd(ft.createVariableDeclarator(t, r), n);
              }

              function we(e) {
                var t = [];

                do {
                  if (t.push(_e(e)), !z(",")) break;
                  j();
                } while (lt < dt);

                return t;
              }

              function Ee() {
                var e;
                return W("var"), e = we(), G(), ft.createVariableDeclaration(e, "var");
              }

              function Oe(e) {
                var t, n;
                return n = pt, W(e), t = we(e), G(), ft.markEnd(ft.createVariableDeclaration(t, e), n);
              }

              function Se() {
                return q(";"), ft.createEmptyStatement();
              }

              function xe() {
                var e = ge();
                return G(), ft.createExpressionStatement(e);
              }

              function Te() {
                var e, t, n;
                return W("if"), q("("), e = ge(), q(")"), t = Ve(), $("else") ? (j(), n = Ve()) : n = null, ft.createIfStatement(e, t, n);
              }

              function ke() {
                var e, t, n;
                return W("do"), n = ht.inIteration, ht.inIteration = !0, e = Ve(), ht.inIteration = n, W("while"), q("("), t = ge(), q(")"), z(";") && j(), ft.createDoWhileStatement(e, t);
              }

              function Ce() {
                var e, t, n;
                return W("while"), q("("), e = ge(), q(")"), n = ht.inIteration, ht.inIteration = !0, t = Ve(), ht.inIteration = n, ft.createWhileStatement(e, t);
              }

              function Ae() {
                var e, t, n;
                return n = pt, e = j(), t = we(), ft.markEnd(ft.createVariableDeclaration(t, e.value), n);
              }

              function Ne() {
                var e, t, n, r, o, i, a;
                return e = t = n = null, W("for"), q("("), z(";") ? j() : ($("var") || $("let") ? (ht.allowIn = !1, e = Ae(), ht.allowIn = !0, 1 === e.declarations.length && $("in") && (j(), r = e, o = ge(), e = null)) : (ht.allowIn = !1, e = ge(), ht.allowIn = !0, $("in") && (Y(e) || V({}, rt.InvalidLHSInForIn), j(), r = e, o = ge(), e = null)), void 0 === r && q(";")), void 0 === r && (z(";") || (t = ge()), q(";"), z(")") || (n = ge())), q(")"), a = ht.inIteration, ht.inIteration = !0, i = Ve(), ht.inIteration = a, void 0 === r ? ft.createForStatement(e, t, n, i) : ft.createForInStatement(r, o, i);
              }

              function Pe() {
                var e,
                    t = null;
                return W("continue"), 59 === at.charCodeAt(lt) ? (j(), ht.inIteration || B({}, rt.IllegalContinue), ft.createContinueStatement(null)) : U() ? (ht.inIteration || B({}, rt.IllegalContinue), ft.createContinueStatement(null)) : (pt.type === Xe.Identifier && (t = be(), e = "$" + t.name, Object.prototype.hasOwnProperty.call(ht.labelSet, e) || B({}, rt.UnknownLabel, t.name)), G(), null !== t || ht.inIteration || B({}, rt.IllegalContinue), ft.createContinueStatement(t));
              }

              function Re() {
                var e,
                    t = null;
                return W("break"), 59 === at.charCodeAt(lt) ? (j(), ht.inIteration || ht.inSwitch || B({}, rt.IllegalBreak), ft.createBreakStatement(null)) : U() ? (ht.inIteration || ht.inSwitch || B({}, rt.IllegalBreak), ft.createBreakStatement(null)) : (pt.type === Xe.Identifier && (t = be(), e = "$" + t.name, Object.prototype.hasOwnProperty.call(ht.labelSet, e) || B({}, rt.UnknownLabel, t.name)), G(), null !== t || ht.inIteration || ht.inSwitch || B({}, rt.IllegalBreak), ft.createBreakStatement(t));
              }

              function Ie() {
                var e = null;
                return W("return"), ht.inFunctionBody || V({}, rt.IllegalReturn), 32 === at.charCodeAt(lt) && s(at.charCodeAt(lt + 1)) ? (e = ge(), G(), ft.createReturnStatement(e)) : U() ? ft.createReturnStatement(null) : (z(";") || z("}") || pt.type === Xe.EOF || (e = ge()), G(), ft.createReturnStatement(e));
              }

              function Me() {
                var e, t;
                return st && (g(), V({}, rt.StrictModeWith)), W("with"), q("("), e = ge(), q(")"), t = Ve(), ft.createWithStatement(e, t);
              }

              function je() {
                var e,
                    t,
                    n,
                    r = [];

                for (n = pt, $("default") ? (j(), e = null) : (W("case"), e = ge()), q(":"); lt < dt && !(z("}") || $("default") || $("case"));) {
                  t = Ve(), r.push(t);
                }

                return ft.markEnd(ft.createSwitchCase(e, r), n);
              }

              function Le() {
                var e, t, n, r, o;
                if (W("switch"), q("("), e = ge(), q(")"), q("{"), t = [], z("}")) return j(), ft.createSwitchStatement(e, t);

                for (r = ht.inSwitch, ht.inSwitch = !0, o = !1; lt < dt && !z("}");) {
                  n = je(), null === n.test && (o && B({}, rt.MultipleDefaultsInSwitch), o = !0), t.push(n);
                }

                return ht.inSwitch = r, q("}"), ft.createSwitchStatement(e, t);
              }

              function De() {
                var e;
                return W("throw"), U() && B({}, rt.NewlineAfterThrow), e = ge(), G(), ft.createThrowStatement(e);
              }

              function Fe() {
                var e, t, n;
                return n = pt, W("catch"), q("("), z(")") && H(pt), e = be(), st && d(e.name) && V({}, rt.StrictCatchVariable), q(")"), t = ye(), ft.markEnd(ft.createCatchClause(e, t), n);
              }

              function Ue() {
                var e,
                    t = [],
                    n = null;
                return W("try"), e = ye(), $("catch") && t.push(Fe()), $("finally") && (j(), n = ye()), 0 !== t.length || n || B({}, rt.NoCatchOrFinally), ft.createTryStatement(e, [], t, n);
              }

              function Be() {
                return W("debugger"), G(), ft.createDebuggerStatement();
              }

              function Ve() {
                var e,
                    t,
                    n,
                    r,
                    o = pt.type;
                if (o === Xe.EOF && H(pt), o === Xe.Punctuator && "{" === pt.value) return ye();
                if (r = pt, o === Xe.Punctuator) switch (pt.value) {
                  case ";":
                    return ft.markEnd(Se(), r);

                  case "(":
                    return ft.markEnd(xe(), r);
                }
                if (o === Xe.Keyword) switch (pt.value) {
                  case "break":
                    return ft.markEnd(Re(), r);

                  case "continue":
                    return ft.markEnd(Pe(), r);

                  case "debugger":
                    return ft.markEnd(Be(), r);

                  case "do":
                    return ft.markEnd(ke(), r);

                  case "for":
                    return ft.markEnd(Ne(), r);

                  case "function":
                    return ft.markEnd(We(), r);

                  case "if":
                    return ft.markEnd(Te(), r);

                  case "return":
                    return ft.markEnd(Ie(), r);

                  case "switch":
                    return ft.markEnd(Le(), r);

                  case "throw":
                    return ft.markEnd(De(), r);

                  case "try":
                    return ft.markEnd(Ue(), r);

                  case "var":
                    return ft.markEnd(Ee(), r);

                  case "while":
                    return ft.markEnd(Ce(), r);

                  case "with":
                    return ft.markEnd(Me(), r);
                }
                return e = ge(), e.type === tt.Identifier && z(":") ? (j(), n = "$" + e.name, Object.prototype.hasOwnProperty.call(ht.labelSet, n) && B({}, rt.Redeclaration, "Label", e.name), ht.labelSet[n] = !0, t = Ve(), delete ht.labelSet[n], ft.markEnd(ft.createLabeledStatement(e, t), r)) : (G(), ft.markEnd(ft.createExpressionStatement(e), r));
              }

              function He() {
                var e,
                    t,
                    n,
                    r,
                    o,
                    i,
                    a,
                    s,
                    l,
                    u = [];

                for (l = pt, q("{"); lt < dt && pt.type === Xe.StringLiteral && (t = pt, e = $e(), u.push(e), e.expression.type === tt.Literal);) {
                  n = at.slice(t.start + 1, t.end - 1), "use strict" === n ? (st = !0, r && V(r, rt.StrictOctalLiteral)) : !r && t.octal && (r = t);
                }

                for (o = ht.labelSet, i = ht.inIteration, a = ht.inSwitch, s = ht.inFunctionBody, ht.labelSet = {}, ht.inIteration = !1, ht.inSwitch = !1, ht.inFunctionBody = !0; lt < dt && !z("}") && void 0 !== (e = $e());) {
                  u.push(e);
                }

                return q("}"), ht.labelSet = o, ht.inIteration = i, ht.inSwitch = a, ht.inFunctionBody = s, ft.markEnd(ft.createBlockStatement(u), l);
              }

              function qe(e) {
                var t,
                    n,
                    r,
                    o,
                    i,
                    a,
                    s = [];
                if (q("("), !z(")")) for (o = {}; lt < dt && (n = pt, t = be(), i = "$" + n.value, st ? (d(n.value) && (r = n, a = rt.StrictParamName), Object.prototype.hasOwnProperty.call(o, i) && (r = n, a = rt.StrictParamDupe)) : e || (d(n.value) ? (e = n, a = rt.StrictParamName) : c(n.value) ? (e = n, a = rt.StrictReservedWord) : Object.prototype.hasOwnProperty.call(o, i) && (e = n, a = rt.StrictParamDupe)), s.push(t), o[i] = !0, !z(")"));) {
                  q(",");
                }
                return q(")"), {
                  params: s,
                  stricted: r,
                  firstRestricted: e,
                  message: a
                };
              }

              function We() {
                var e,
                    t,
                    n,
                    r,
                    o,
                    i,
                    a,
                    s,
                    l,
                    u = [];
                return l = pt, W("function"), n = pt, e = be(), st ? d(n.value) && V(n, rt.StrictFunctionName) : d(n.value) ? (i = n, a = rt.StrictFunctionName) : c(n.value) && (i = n, a = rt.StrictReservedWord), o = qe(i), u = o.params, r = o.stricted, i = o.firstRestricted, o.message && (a = o.message), s = st, t = He(), st && i && B(i, a), st && r && V(r, a), st = s, ft.markEnd(ft.createFunctionDeclaration(e, u, [], t), l);
              }

              function ze() {
                var e,
                    t,
                    n,
                    r,
                    o,
                    i,
                    a,
                    s,
                    l = null,
                    u = [];
                return s = pt, W("function"), z("(") || (e = pt, l = be(), st ? d(e.value) && V(e, rt.StrictFunctionName) : d(e.value) ? (n = e, r = rt.StrictFunctionName) : c(e.value) && (n = e, r = rt.StrictReservedWord)), o = qe(n), u = o.params, t = o.stricted, n = o.firstRestricted, o.message && (r = o.message), a = st, i = He(), st && n && B(n, r), st && t && V(t, r), st = a, ft.markEnd(ft.createFunctionExpression(l, u, [], i), s);
              }

              function $e() {
                if (pt.type === Xe.Keyword) switch (pt.value) {
                  case "const":
                  case "let":
                    return Oe(pt.value);

                  case "function":
                    return We();

                  default:
                    return Ve();
                }
                if (pt.type !== Xe.EOF) return Ve();
              }

              function Ke() {
                for (var e, t, n, r, o = []; lt < dt && (t = pt, t.type === Xe.StringLiteral) && (e = $e(), o.push(e), e.expression.type === tt.Literal);) {
                  n = at.slice(t.start + 1, t.end - 1), "use strict" === n ? (st = !0, r && V(r, rt.StrictOctalLiteral)) : !r && t.octal && (r = t);
                }

                for (; lt < dt && void 0 !== (e = $e());) {
                  o.push(e);
                }

                return o;
              }

              function Ge() {
                var e, t;
                return g(), L(), t = pt, st = !1, e = Ke(), ft.markEnd(ft.createProgram(e), t);
              }

              function Ye() {
                var e,
                    t,
                    n,
                    r = [];

                for (e = 0; e < mt.tokens.length; ++e) {
                  t = mt.tokens[e], n = {
                    type: t.type,
                    value: t.value
                  }, mt.range && (n.range = t.range), mt.loc && (n.loc = t.loc), r.push(n);
                }

                mt.tokens = r;
              }

              function Je(e, t) {
                var n, r;
                n = String, "string" == typeof e || e instanceof String || (e = n(e)), ft = it, at = e, lt = 0, ut = at.length > 0 ? 1 : 0, ct = 0, dt = at.length, pt = null, ht = {
                  allowIn: !0,
                  labelSet: {},
                  inFunctionBody: !1,
                  inIteration: !1,
                  inSwitch: !1,
                  lastCommentStart: -1
                }, mt = {}, t = t || {}, t.tokens = !0, mt.tokens = [], mt.tokenize = !0, mt.openParenToken = -1, mt.openCurlyToken = -1, mt.range = "boolean" == typeof t.range && t.range, mt.loc = "boolean" == typeof t.loc && t.loc, "boolean" == typeof t.comment && t.comment && (mt.comments = []), "boolean" == typeof t.tolerant && t.tolerant && (mt.errors = []);

                try {
                  if (L(), pt.type === Xe.EOF) return mt.tokens;

                  for (j(); pt.type !== Xe.EOF;) {
                    try {
                      j();
                    } catch (e) {
                      if (pt, mt.errors) {
                        mt.errors.push(e);
                        break;
                      }

                      throw e;
                    }
                  }

                  Ye(), r = mt.tokens, void 0 !== mt.comments && (r.comments = mt.comments), void 0 !== mt.errors && (r.errors = mt.errors);
                } catch (e) {
                  throw e;
                } finally {
                  mt = {};
                }

                return r;
              }

              function Qe(e, t) {
                var n, r;
                r = String, "string" == typeof e || e instanceof String || (e = r(e)), ft = it, at = e, lt = 0, ut = at.length > 0 ? 1 : 0, ct = 0, dt = at.length, pt = null, ht = {
                  allowIn: !0,
                  labelSet: {},
                  inFunctionBody: !1,
                  inIteration: !1,
                  inSwitch: !1,
                  lastCommentStart: -1
                }, mt = {}, void 0 !== t && (mt.range = "boolean" == typeof t.range && t.range, mt.loc = "boolean" == typeof t.loc && t.loc, mt.attachComment = "boolean" == typeof t.attachComment && t.attachComment, mt.loc && null !== t.source && void 0 !== t.source && (mt.source = r(t.source)), "boolean" == typeof t.tokens && t.tokens && (mt.tokens = []), "boolean" == typeof t.comment && t.comment && (mt.comments = []), "boolean" == typeof t.tolerant && t.tolerant && (mt.errors = []), mt.attachComment && (mt.range = !0, mt.comments = [], mt.bottomRightStack = [], mt.trailingComments = [], mt.leadingComments = []));

                try {
                  n = Ge(), void 0 !== mt.comments && (n.comments = mt.comments), void 0 !== mt.tokens && (Ye(), n.tokens = mt.tokens), void 0 !== mt.errors && (n.errors = mt.errors);
                } catch (e) {
                  throw e;
                } finally {
                  mt = {};
                }

                return n;
              }

              var Xe, Ze, et, tt, nt, rt, ot, it, at, st, lt, ut, ct, dt, ft, pt, ht, mt;
              Xe = {
                BooleanLiteral: 1,
                EOF: 2,
                Identifier: 3,
                Keyword: 4,
                NullLiteral: 5,
                NumericLiteral: 6,
                Punctuator: 7,
                StringLiteral: 8,
                RegularExpression: 9
              }, Ze = {}, Ze[Xe.BooleanLiteral] = "Boolean", Ze[Xe.EOF] = "<end>", Ze[Xe.Identifier] = "Identifier", Ze[Xe.Keyword] = "Keyword", Ze[Xe.NullLiteral] = "Null", Ze[Xe.NumericLiteral] = "Numeric", Ze[Xe.Punctuator] = "Punctuator", Ze[Xe.StringLiteral] = "String", Ze[Xe.RegularExpression] = "RegularExpression", et = ["(", "{", "[", "in", "typeof", "instanceof", "new", "return", "case", "delete", "throw", "void", "=", "+=", "-=", "*=", "/=", "%=", "<<=", ">>=", ">>>=", "&=", "|=", "^=", ",", "+", "-", "*", "/", "%", "++", "--", "<<", ">>", ">>>", "&", "|", "^", "!", "~", "&&", "||", "?", ":", "===", "==", ">=", "<=", "<", ">", "!=", "!=="], tt = {
                AssignmentExpression: "AssignmentExpression",
                ArrayExpression: "ArrayExpression",
                BlockStatement: "BlockStatement",
                BinaryExpression: "BinaryExpression",
                BreakStatement: "BreakStatement",
                CallExpression: "CallExpression",
                CatchClause: "CatchClause",
                ConditionalExpression: "ConditionalExpression",
                ContinueStatement: "ContinueStatement",
                DoWhileStatement: "DoWhileStatement",
                DebuggerStatement: "DebuggerStatement",
                EmptyStatement: "EmptyStatement",
                ExpressionStatement: "ExpressionStatement",
                ForStatement: "ForStatement",
                ForInStatement: "ForInStatement",
                FunctionDeclaration: "FunctionDeclaration",
                FunctionExpression: "FunctionExpression",
                Identifier: "Identifier",
                IfStatement: "IfStatement",
                Literal: "Literal",
                LabeledStatement: "LabeledStatement",
                LogicalExpression: "LogicalExpression",
                MemberExpression: "MemberExpression",
                NewExpression: "NewExpression",
                ObjectExpression: "ObjectExpression",
                Program: "Program",
                Property: "Property",
                ReturnStatement: "ReturnStatement",
                SequenceExpression: "SequenceExpression",
                SwitchStatement: "SwitchStatement",
                SwitchCase: "SwitchCase",
                ThisExpression: "ThisExpression",
                ThrowStatement: "ThrowStatement",
                TryStatement: "TryStatement",
                UnaryExpression: "UnaryExpression",
                UpdateExpression: "UpdateExpression",
                VariableDeclaration: "VariableDeclaration",
                VariableDeclarator: "VariableDeclarator",
                WhileStatement: "WhileStatement",
                WithStatement: "WithStatement"
              }, nt = {
                Data: 1,
                Get: 2,
                Set: 4
              }, rt = {
                UnexpectedToken: "Unexpected token %0",
                UnexpectedNumber: "Unexpected number",
                UnexpectedString: "Unexpected string",
                UnexpectedIdentifier: "Unexpected identifier",
                UnexpectedReserved: "Unexpected reserved word",
                UnexpectedEOS: "Unexpected end of input",
                NewlineAfterThrow: "Illegal newline after throw",
                InvalidRegExp: "Invalid regular expression",
                UnterminatedRegExp: "Invalid regular expression: missing /",
                InvalidLHSInAssignment: "Invalid left-hand side in assignment",
                InvalidLHSInForIn: "Invalid left-hand side in for-in",
                MultipleDefaultsInSwitch: "More than one default clause in switch statement",
                NoCatchOrFinally: "Missing catch or finally after try",
                UnknownLabel: "Undefined label '%0'",
                Redeclaration: "%0 '%1' has already been declared",
                IllegalContinue: "Illegal continue statement",
                IllegalBreak: "Illegal break statement",
                IllegalReturn: "Illegal return statement",
                StrictModeWith: "Strict mode code may not include a with statement",
                StrictCatchVariable: "Catch variable may not be eval or arguments in strict mode",
                StrictVarName: "Variable name may not be eval or arguments in strict mode",
                StrictParamName: "Parameter name eval or arguments is not allowed in strict mode",
                StrictParamDupe: "Strict mode function may not have duplicate parameter names",
                StrictFunctionName: "Function name may not be eval or arguments in strict mode",
                StrictOctalLiteral: "Octal literals are not allowed in strict mode.",
                StrictDelete: "Delete of an unqualified identifier in strict mode.",
                StrictDuplicateProperty: "Duplicate data property in object literal not allowed in strict mode",
                AccessorDataProperty: "Object literal may not have data and accessor property with the same name",
                AccessorGetSet: "Object literal may not have multiple get/set accessors with the same name",
                StrictLHSAssignment: "Assignment to eval or arguments is not allowed in strict mode",
                StrictLHSPostfix: "Postfix increment/decrement may not have eval or arguments operand in strict mode",
                StrictLHSPrefix: "Prefix increment/decrement may not have eval or arguments operand in strict mode",
                StrictReservedWord: "Use of future reserved word in strict mode"
              }, ot = {
                NonAsciiIdentifierStart: new RegExp("[ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ]"),
                NonAsciiIdentifierPart: new RegExp("[ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮ̀-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁ҃-҇Ҋ-ԧԱ-Ֆՙա-և֑-ׇֽֿׁׂׅׄא-תװ-ײؐ-ؚؠ-٩ٮ-ۓە-ۜ۟-۪ۨ-ۼۿܐ-݊ݍ-ޱ߀-ߵߺࠀ-࠭ࡀ-࡛ࢠࢢ-ࢬࣤ-ࣾऀ-ॣ०-९ॱ-ॷॹ-ॿঁ-ঃঅ-ঌএঐও-নপ-রলশ-হ়-ৄেৈো-ৎৗড়ঢ়য়-ৣ০-ৱਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹ਼ਾ-ੂੇੈੋ-੍ੑਖ਼-ੜਫ਼੦-ੵઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હ઼-ૅે-ૉો-્ૐૠ-ૣ૦-૯ଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହ଼-ୄେୈୋ-୍ୖୗଡ଼ଢ଼ୟ-ୣ୦-୯ୱஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-்ௐௗ௦-௯ఁ-ఃఅ-ఌఎ-ఐఒ-నప-ళవ-హఽ-ౄె-ైొ-్ౕౖౘౙౠ-ౣ౦-౯ಂಃಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹ಼-ೄೆ-ೈೊ-್ೕೖೞೠ-ೣ೦-೯ೱೲംഃഅ-ഌഎ-ഐഒ-ഺഽ-ൄെ-ൈൊ-ൎൗൠ-ൣ൦-൯ൺ-ൿංඃඅ-ඖක-නඳ-රලව-ෆ්ා-ුූෘ-ෟෲෳก-ฺเ-๎๐-๙ກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ູົ-ຽເ-ໄໆ່-ໍ໐-໙ໜ-ໟༀ༘༙༠-༩༹༵༷༾-ཇཉ-ཬཱ-྄྆-ྗྙ-ྼ࿆က-၉ၐ-ႝႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚ፝-፟ᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-᜔ᜠ-᜴ᝀ-ᝓᝠ-ᝬᝮ-ᝰᝲᝳក-៓ៗៜ៝០-៩᠋-᠍᠐-᠙ᠠ-ᡷᢀ-ᢪᢰ-ᣵᤀ-ᤜᤠ-ᤫᤰ-᤻᥆-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉ᧐-᧙ᨀ-ᨛᨠ-ᩞ᩠-᩿᩼-᪉᪐-᪙ᪧᬀ-ᭋ᭐-᭙᭫-᭳ᮀ-᯳ᰀ-᰷᱀-᱉ᱍ-ᱽ᳐-᳔᳒-ᳶᴀ-ᷦ᷼-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼ‌‍‿⁀⁔ⁱⁿₐ-ₜ⃐-⃥⃜⃡-⃰ℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯ⵿-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⷠ-ⷿⸯ々-〇〡-〯〱-〵〸-〼ぁ-ゖ゙゚ゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘫꙀ-꙯ꙴ-꙽ꙿ-ꚗꚟ-꛱ꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠧꡀ-ꡳꢀ-꣄꣐-꣙꣠-ꣷꣻ꤀-꤭ꤰ-꥓ꥠ-ꥼꦀ-꧀ꧏ-꧙ꨀ-ꨶꩀ-ꩍ꩐-꩙ꩠ-ꩶꩺꩻꪀ-ꫂꫛ-ꫝꫠ-ꫯꫲ-꫶ꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯪ꯬꯭꯰-꯹가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻ︀-️︠-︦︳︴﹍-﹏ﹰ-ﹴﹶ-ﻼ０-９Ａ-Ｚ＿ａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ]")
              }, it = {
                name: "SyntaxTree",
                processComment: function processComment(e) {
                  var t, n;

                  if (!(e.type === tt.Program && e.body.length > 0)) {
                    for (mt.trailingComments.length > 0 ? mt.trailingComments[0].range[0] >= e.range[1] ? (n = mt.trailingComments, mt.trailingComments = []) : mt.trailingComments.length = 0 : mt.bottomRightStack.length > 0 && mt.bottomRightStack[mt.bottomRightStack.length - 1].trailingComments && mt.bottomRightStack[mt.bottomRightStack.length - 1].trailingComments[0].range[0] >= e.range[1] && (n = mt.bottomRightStack[mt.bottomRightStack.length - 1].trailingComments, delete mt.bottomRightStack[mt.bottomRightStack.length - 1].trailingComments); mt.bottomRightStack.length > 0 && mt.bottomRightStack[mt.bottomRightStack.length - 1].range[0] >= e.range[0];) {
                      t = mt.bottomRightStack.pop();
                    }

                    t ? t.leadingComments && t.leadingComments[t.leadingComments.length - 1].range[1] <= e.range[0] && (e.leadingComments = t.leadingComments, delete t.leadingComments) : mt.leadingComments.length > 0 && mt.leadingComments[mt.leadingComments.length - 1].range[1] <= e.range[0] && (e.leadingComments = mt.leadingComments, mt.leadingComments = []), n && (e.trailingComments = n), mt.bottomRightStack.push(e);
                  }
                },
                markEnd: function markEnd(e, t) {
                  return mt.range && (e.range = [t.start, lt]), mt.loc && (e.loc = new F(void 0 === t.startLineNumber ? t.lineNumber : t.startLineNumber, t.start - (void 0 === t.startLineStart ? t.lineStart : t.startLineStart), ut, lt - ct), this.postProcess(e)), mt.attachComment && this.processComment(e), e;
                },
                postProcess: function postProcess(e) {
                  return mt.source && (e.loc.source = mt.source), e;
                },
                createArrayExpression: function createArrayExpression(e) {
                  return {
                    type: tt.ArrayExpression,
                    elements: e
                  };
                },
                createAssignmentExpression: function createAssignmentExpression(e, t, n) {
                  return {
                    type: tt.AssignmentExpression,
                    operator: e,
                    left: t,
                    right: n
                  };
                },
                createBinaryExpression: function createBinaryExpression(e, t, n) {
                  return {
                    type: "||" === e || "&&" === e ? tt.LogicalExpression : tt.BinaryExpression,
                    operator: e,
                    left: t,
                    right: n
                  };
                },
                createBlockStatement: function createBlockStatement(e) {
                  return {
                    type: tt.BlockStatement,
                    body: e
                  };
                },
                createBreakStatement: function createBreakStatement(e) {
                  return {
                    type: tt.BreakStatement,
                    label: e
                  };
                },
                createCallExpression: function createCallExpression(e, t) {
                  return {
                    type: tt.CallExpression,
                    callee: e,
                    arguments: t
                  };
                },
                createCatchClause: function createCatchClause(e, t) {
                  return {
                    type: tt.CatchClause,
                    param: e,
                    body: t
                  };
                },
                createConditionalExpression: function createConditionalExpression(e, t, n) {
                  return {
                    type: tt.ConditionalExpression,
                    test: e,
                    consequent: t,
                    alternate: n
                  };
                },
                createContinueStatement: function createContinueStatement(e) {
                  return {
                    type: tt.ContinueStatement,
                    label: e
                  };
                },
                createDebuggerStatement: function createDebuggerStatement() {
                  return {
                    type: tt.DebuggerStatement
                  };
                },
                createDoWhileStatement: function createDoWhileStatement(e, t) {
                  return {
                    type: tt.DoWhileStatement,
                    body: e,
                    test: t
                  };
                },
                createEmptyStatement: function createEmptyStatement() {
                  return {
                    type: tt.EmptyStatement
                  };
                },
                createExpressionStatement: function createExpressionStatement(e) {
                  return {
                    type: tt.ExpressionStatement,
                    expression: e
                  };
                },
                createForStatement: function createForStatement(e, t, n, r) {
                  return {
                    type: tt.ForStatement,
                    init: e,
                    test: t,
                    update: n,
                    body: r
                  };
                },
                createForInStatement: function createForInStatement(e, t, n) {
                  return {
                    type: tt.ForInStatement,
                    left: e,
                    right: t,
                    body: n,
                    each: !1
                  };
                },
                createFunctionDeclaration: function createFunctionDeclaration(e, t, n, r) {
                  return {
                    type: tt.FunctionDeclaration,
                    id: e,
                    params: t,
                    defaults: n,
                    body: r,
                    rest: null,
                    generator: !1,
                    expression: !1
                  };
                },
                createFunctionExpression: function createFunctionExpression(e, t, n, r) {
                  return {
                    type: tt.FunctionExpression,
                    id: e,
                    params: t,
                    defaults: n,
                    body: r,
                    rest: null,
                    generator: !1,
                    expression: !1
                  };
                },
                createIdentifier: function createIdentifier(e) {
                  return {
                    type: tt.Identifier,
                    name: e
                  };
                },
                createIfStatement: function createIfStatement(e, t, n) {
                  return {
                    type: tt.IfStatement,
                    test: e,
                    consequent: t,
                    alternate: n
                  };
                },
                createLabeledStatement: function createLabeledStatement(e, t) {
                  return {
                    type: tt.LabeledStatement,
                    label: e,
                    body: t
                  };
                },
                createLiteral: function createLiteral(e) {
                  return {
                    type: tt.Literal,
                    value: e.value,
                    raw: at.slice(e.start, e.end)
                  };
                },
                createMemberExpression: function createMemberExpression(e, t, n) {
                  return {
                    type: tt.MemberExpression,
                    computed: "[" === e,
                    object: t,
                    property: n
                  };
                },
                createNewExpression: function createNewExpression(e, t) {
                  return {
                    type: tt.NewExpression,
                    callee: e,
                    arguments: t
                  };
                },
                createObjectExpression: function createObjectExpression(e) {
                  return {
                    type: tt.ObjectExpression,
                    properties: e
                  };
                },
                createPostfixExpression: function createPostfixExpression(e, t) {
                  return {
                    type: tt.UpdateExpression,
                    operator: e,
                    argument: t,
                    prefix: !1
                  };
                },
                createProgram: function createProgram(e) {
                  return {
                    type: tt.Program,
                    body: e
                  };
                },
                createProperty: function createProperty(e, t, n) {
                  return {
                    type: tt.Property,
                    key: t,
                    value: n,
                    kind: e
                  };
                },
                createReturnStatement: function createReturnStatement(e) {
                  return {
                    type: tt.ReturnStatement,
                    argument: e
                  };
                },
                createSequenceExpression: function createSequenceExpression(e) {
                  return {
                    type: tt.SequenceExpression,
                    expressions: e
                  };
                },
                createSwitchCase: function createSwitchCase(e, t) {
                  return {
                    type: tt.SwitchCase,
                    test: e,
                    consequent: t
                  };
                },
                createSwitchStatement: function createSwitchStatement(e, t) {
                  return {
                    type: tt.SwitchStatement,
                    discriminant: e,
                    cases: t
                  };
                },
                createThisExpression: function createThisExpression() {
                  return {
                    type: tt.ThisExpression
                  };
                },
                createThrowStatement: function createThrowStatement(e) {
                  return {
                    type: tt.ThrowStatement,
                    argument: e
                  };
                },
                createTryStatement: function createTryStatement(e, t, n, r) {
                  return {
                    type: tt.TryStatement,
                    block: e,
                    guardedHandlers: t,
                    handlers: n,
                    finalizer: r
                  };
                },
                createUnaryExpression: function createUnaryExpression(e, t) {
                  return "++" === e || "--" === e ? {
                    type: tt.UpdateExpression,
                    operator: e,
                    argument: t,
                    prefix: !0
                  } : {
                    type: tt.UnaryExpression,
                    operator: e,
                    argument: t,
                    prefix: !0
                  };
                },
                createVariableDeclaration: function createVariableDeclaration(e, t) {
                  return {
                    type: tt.VariableDeclaration,
                    declarations: e,
                    kind: t
                  };
                },
                createVariableDeclarator: function createVariableDeclarator(e, t) {
                  return {
                    type: tt.VariableDeclarator,
                    id: e,
                    init: t
                  };
                },
                createWhileStatement: function createWhileStatement(e, t) {
                  return {
                    type: tt.WhileStatement,
                    test: e,
                    body: t
                  };
                },
                createWithStatement: function createWithStatement(e, t) {
                  return {
                    type: tt.WithStatement,
                    object: e,
                    body: t
                  };
                }
              }, e.version = "1.2.2", e.tokenize = Je, e.parse = Qe, e.Syntax = function () {
                var e,
                    t = {};
                "function" == typeof Object.create && (t = Object.create(null));

                for (e in tt) {
                  tt.hasOwnProperty(e) && (t[e] = tt[e]);
                }

                return "function" == typeof Object.freeze && Object.freeze(t), t;
              }();
            });
          }, {}],
          1: [function (e, t, n) {
            (function (r) {
              var o = function () {
                function e() {
                  this.yy = {};
                }

                var t = {
                  trace: function trace() {},
                  yy: {},
                  symbols_: {
                    error: 2,
                    JSON_PATH: 3,
                    DOLLAR: 4,
                    PATH_COMPONENTS: 5,
                    LEADING_CHILD_MEMBER_EXPRESSION: 6,
                    PATH_COMPONENT: 7,
                    MEMBER_COMPONENT: 8,
                    SUBSCRIPT_COMPONENT: 9,
                    CHILD_MEMBER_COMPONENT: 10,
                    DESCENDANT_MEMBER_COMPONENT: 11,
                    DOT: 12,
                    MEMBER_EXPRESSION: 13,
                    DOT_DOT: 14,
                    STAR: 15,
                    IDENTIFIER: 16,
                    SCRIPT_EXPRESSION: 17,
                    INTEGER: 18,
                    END: 19,
                    CHILD_SUBSCRIPT_COMPONENT: 20,
                    DESCENDANT_SUBSCRIPT_COMPONENT: 21,
                    "[": 22,
                    SUBSCRIPT: 23,
                    "]": 24,
                    SUBSCRIPT_EXPRESSION: 25,
                    SUBSCRIPT_EXPRESSION_LIST: 26,
                    SUBSCRIPT_EXPRESSION_LISTABLE: 27,
                    ",": 28,
                    STRING_LITERAL: 29,
                    ARRAY_SLICE: 30,
                    FILTER_EXPRESSION: 31,
                    QQ_STRING: 32,
                    Q_STRING: 33,
                    $accept: 0,
                    $end: 1
                  },
                  terminals_: {
                    2: "error",
                    4: "DOLLAR",
                    12: "DOT",
                    14: "DOT_DOT",
                    15: "STAR",
                    16: "IDENTIFIER",
                    17: "SCRIPT_EXPRESSION",
                    18: "INTEGER",
                    19: "END",
                    22: "[",
                    24: "]",
                    28: ",",
                    30: "ARRAY_SLICE",
                    31: "FILTER_EXPRESSION",
                    32: "QQ_STRING",
                    33: "Q_STRING"
                  },
                  productions_: [0, [3, 1], [3, 2], [3, 1], [3, 2], [5, 1], [5, 2], [7, 1], [7, 1], [8, 1], [8, 1], [10, 2], [6, 1], [11, 2], [13, 1], [13, 1], [13, 1], [13, 1], [13, 1], [9, 1], [9, 1], [20, 3], [21, 4], [23, 1], [23, 1], [26, 1], [26, 3], [27, 1], [27, 1], [27, 1], [25, 1], [25, 1], [25, 1], [29, 1], [29, 1]],
                  performAction: function performAction(e, t, r, o, i, a, s) {
                    o.ast || (o.ast = n, n.initialize());
                    var l = a.length - 1;

                    switch (i) {
                      case 1:
                        return o.ast.set({
                          expression: {
                            type: "root",
                            value: a[l]
                          }
                        }), o.ast.unshift(), o.ast.yield();

                      case 2:
                        return o.ast.set({
                          expression: {
                            type: "root",
                            value: a[l - 1]
                          }
                        }), o.ast.unshift(), o.ast.yield();

                      case 3:
                        return o.ast.unshift(), o.ast.yield();

                      case 4:
                        return o.ast.set({
                          operation: "member",
                          scope: "child",
                          expression: {
                            type: "identifier",
                            value: a[l - 1]
                          }
                        }), o.ast.unshift(), o.ast.yield();

                      case 5:
                      case 6:
                        break;

                      case 7:
                        o.ast.set({
                          operation: "member"
                        }), o.ast.push();
                        break;

                      case 8:
                        o.ast.set({
                          operation: "subscript"
                        }), o.ast.push();
                        break;

                      case 9:
                        o.ast.set({
                          scope: "child"
                        });
                        break;

                      case 10:
                        o.ast.set({
                          scope: "descendant"
                        });
                        break;

                      case 11:
                        break;

                      case 12:
                        o.ast.set({
                          scope: "child",
                          operation: "member"
                        });
                        break;

                      case 13:
                        break;

                      case 14:
                        o.ast.set({
                          expression: {
                            type: "wildcard",
                            value: a[l]
                          }
                        });
                        break;

                      case 15:
                        o.ast.set({
                          expression: {
                            type: "identifier",
                            value: a[l]
                          }
                        });
                        break;

                      case 16:
                        o.ast.set({
                          expression: {
                            type: "script_expression",
                            value: a[l]
                          }
                        });
                        break;

                      case 17:
                        o.ast.set({
                          expression: {
                            type: "numeric_literal",
                            value: parseInt(a[l])
                          }
                        });
                        break;

                      case 18:
                        break;

                      case 19:
                        o.ast.set({
                          scope: "child"
                        });
                        break;

                      case 20:
                        o.ast.set({
                          scope: "descendant"
                        });
                        break;

                      case 21:
                      case 22:
                      case 23:
                        break;

                      case 24:
                        a[l].length > 1 ? o.ast.set({
                          expression: {
                            type: "union",
                            value: a[l]
                          }
                        }) : this.$ = a[l];
                        break;

                      case 25:
                        this.$ = [a[l]];
                        break;

                      case 26:
                        this.$ = a[l - 2].concat(a[l]);
                        break;

                      case 27:
                        this.$ = {
                          expression: {
                            type: "numeric_literal",
                            value: parseInt(a[l])
                          }
                        }, o.ast.set(this.$);
                        break;

                      case 28:
                        this.$ = {
                          expression: {
                            type: "string_literal",
                            value: a[l]
                          }
                        }, o.ast.set(this.$);
                        break;

                      case 29:
                        this.$ = {
                          expression: {
                            type: "slice",
                            value: a[l]
                          }
                        }, o.ast.set(this.$);
                        break;

                      case 30:
                        this.$ = {
                          expression: {
                            type: "wildcard",
                            value: a[l]
                          }
                        }, o.ast.set(this.$);
                        break;

                      case 31:
                        this.$ = {
                          expression: {
                            type: "script_expression",
                            value: a[l]
                          }
                        }, o.ast.set(this.$);
                        break;

                      case 32:
                        this.$ = {
                          expression: {
                            type: "filter_expression",
                            value: a[l]
                          }
                        }, o.ast.set(this.$);
                        break;

                      case 33:
                      case 34:
                        this.$ = a[l];
                    }
                  },
                  table: [{
                    3: 1,
                    4: [1, 2],
                    6: 3,
                    13: 4,
                    15: [1, 5],
                    16: [1, 6],
                    17: [1, 7],
                    18: [1, 8],
                    19: [1, 9]
                  }, {
                    1: [3]
                  }, {
                    1: [2, 1],
                    5: 10,
                    7: 11,
                    8: 12,
                    9: 13,
                    10: 14,
                    11: 15,
                    12: [1, 18],
                    14: [1, 19],
                    20: 16,
                    21: 17,
                    22: [1, 20]
                  }, {
                    1: [2, 3],
                    5: 21,
                    7: 11,
                    8: 12,
                    9: 13,
                    10: 14,
                    11: 15,
                    12: [1, 18],
                    14: [1, 19],
                    20: 16,
                    21: 17,
                    22: [1, 20]
                  }, {
                    1: [2, 12],
                    12: [2, 12],
                    14: [2, 12],
                    22: [2, 12]
                  }, {
                    1: [2, 14],
                    12: [2, 14],
                    14: [2, 14],
                    22: [2, 14]
                  }, {
                    1: [2, 15],
                    12: [2, 15],
                    14: [2, 15],
                    22: [2, 15]
                  }, {
                    1: [2, 16],
                    12: [2, 16],
                    14: [2, 16],
                    22: [2, 16]
                  }, {
                    1: [2, 17],
                    12: [2, 17],
                    14: [2, 17],
                    22: [2, 17]
                  }, {
                    1: [2, 18],
                    12: [2, 18],
                    14: [2, 18],
                    22: [2, 18]
                  }, {
                    1: [2, 2],
                    7: 22,
                    8: 12,
                    9: 13,
                    10: 14,
                    11: 15,
                    12: [1, 18],
                    14: [1, 19],
                    20: 16,
                    21: 17,
                    22: [1, 20]
                  }, {
                    1: [2, 5],
                    12: [2, 5],
                    14: [2, 5],
                    22: [2, 5]
                  }, {
                    1: [2, 7],
                    12: [2, 7],
                    14: [2, 7],
                    22: [2, 7]
                  }, {
                    1: [2, 8],
                    12: [2, 8],
                    14: [2, 8],
                    22: [2, 8]
                  }, {
                    1: [2, 9],
                    12: [2, 9],
                    14: [2, 9],
                    22: [2, 9]
                  }, {
                    1: [2, 10],
                    12: [2, 10],
                    14: [2, 10],
                    22: [2, 10]
                  }, {
                    1: [2, 19],
                    12: [2, 19],
                    14: [2, 19],
                    22: [2, 19]
                  }, {
                    1: [2, 20],
                    12: [2, 20],
                    14: [2, 20],
                    22: [2, 20]
                  }, {
                    13: 23,
                    15: [1, 5],
                    16: [1, 6],
                    17: [1, 7],
                    18: [1, 8],
                    19: [1, 9]
                  }, {
                    13: 24,
                    15: [1, 5],
                    16: [1, 6],
                    17: [1, 7],
                    18: [1, 8],
                    19: [1, 9],
                    22: [1, 25]
                  }, {
                    15: [1, 29],
                    17: [1, 30],
                    18: [1, 33],
                    23: 26,
                    25: 27,
                    26: 28,
                    27: 32,
                    29: 34,
                    30: [1, 35],
                    31: [1, 31],
                    32: [1, 36],
                    33: [1, 37]
                  }, {
                    1: [2, 4],
                    7: 22,
                    8: 12,
                    9: 13,
                    10: 14,
                    11: 15,
                    12: [1, 18],
                    14: [1, 19],
                    20: 16,
                    21: 17,
                    22: [1, 20]
                  }, {
                    1: [2, 6],
                    12: [2, 6],
                    14: [2, 6],
                    22: [2, 6]
                  }, {
                    1: [2, 11],
                    12: [2, 11],
                    14: [2, 11],
                    22: [2, 11]
                  }, {
                    1: [2, 13],
                    12: [2, 13],
                    14: [2, 13],
                    22: [2, 13]
                  }, {
                    15: [1, 29],
                    17: [1, 30],
                    18: [1, 33],
                    23: 38,
                    25: 27,
                    26: 28,
                    27: 32,
                    29: 34,
                    30: [1, 35],
                    31: [1, 31],
                    32: [1, 36],
                    33: [1, 37]
                  }, {
                    24: [1, 39]
                  }, {
                    24: [2, 23]
                  }, {
                    24: [2, 24],
                    28: [1, 40]
                  }, {
                    24: [2, 30]
                  }, {
                    24: [2, 31]
                  }, {
                    24: [2, 32]
                  }, {
                    24: [2, 25],
                    28: [2, 25]
                  }, {
                    24: [2, 27],
                    28: [2, 27]
                  }, {
                    24: [2, 28],
                    28: [2, 28]
                  }, {
                    24: [2, 29],
                    28: [2, 29]
                  }, {
                    24: [2, 33],
                    28: [2, 33]
                  }, {
                    24: [2, 34],
                    28: [2, 34]
                  }, {
                    24: [1, 41]
                  }, {
                    1: [2, 21],
                    12: [2, 21],
                    14: [2, 21],
                    22: [2, 21]
                  }, {
                    18: [1, 33],
                    27: 42,
                    29: 34,
                    30: [1, 35],
                    32: [1, 36],
                    33: [1, 37]
                  }, {
                    1: [2, 22],
                    12: [2, 22],
                    14: [2, 22],
                    22: [2, 22]
                  }, {
                    24: [2, 26],
                    28: [2, 26]
                  }],
                  defaultActions: {
                    27: [2, 23],
                    29: [2, 30],
                    30: [2, 31],
                    31: [2, 32]
                  },
                  parseError: function parseError(e, t) {
                    if (!t.recoverable) throw new Error(e);
                    this.trace(e);
                  },
                  parse: function parse(e) {
                    var t = this,
                        n = [0],
                        r = [null],
                        o = [],
                        i = this.table,
                        a = "",
                        s = 0,
                        l = 0,
                        u = 0,
                        c = 1,
                        d = o.slice.call(arguments, 1);
                    this.lexer.setInput(e), this.lexer.yy = this.yy, this.yy.lexer = this.lexer, this.yy.parser = this, void 0 === this.lexer.yylloc && (this.lexer.yylloc = {});
                    var f = this.lexer.yylloc;
                    o.push(f);
                    var p = this.lexer.options && this.lexer.options.ranges;
                    "function" == typeof this.yy.parseError ? this.parseError = this.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

                    for (var h, m, g, v, y, b, _, w, E, O = {};;) {
                      if (g = n[n.length - 1], this.defaultActions[g] ? v = this.defaultActions[g] : (null !== h && void 0 !== h || (h = function () {
                        var e;
                        return e = t.lexer.lex() || c, "number" != typeof e && (e = t.symbols_[e] || e), e;
                      }()), v = i[g] && i[g][h]), void 0 === v || !v.length || !v[0]) {
                        var S = "";
                        E = [];

                        for (b in i[g]) {
                          this.terminals_[b] && b > 2 && E.push("'" + this.terminals_[b] + "'");
                        }

                        S = this.lexer.showPosition ? "Parse error on line " + (s + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + E.join(", ") + ", got '" + (this.terminals_[h] || h) + "'" : "Parse error on line " + (s + 1) + ": Unexpected " + (h == c ? "end of input" : "'" + (this.terminals_[h] || h) + "'"), this.parseError(S, {
                          text: this.lexer.match,
                          token: this.terminals_[h] || h,
                          line: this.lexer.yylineno,
                          loc: f,
                          expected: E
                        });
                      }

                      if (v[0] instanceof Array && v.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + g + ", token: " + h);

                      switch (v[0]) {
                        case 1:
                          n.push(h), r.push(this.lexer.yytext), o.push(this.lexer.yylloc), n.push(v[1]), h = null, m ? (h = m, m = null) : (l = this.lexer.yyleng, a = this.lexer.yytext, s = this.lexer.yylineno, f = this.lexer.yylloc, u > 0 && u--);
                          break;

                        case 2:
                          if (_ = this.productions_[v[1]][1], O.$ = r[r.length - _], O._$ = {
                            first_line: o[o.length - (_ || 1)].first_line,
                            last_line: o[o.length - 1].last_line,
                            first_column: o[o.length - (_ || 1)].first_column,
                            last_column: o[o.length - 1].last_column
                          }, p && (O._$.range = [o[o.length - (_ || 1)].range[0], o[o.length - 1].range[1]]), void 0 !== (y = this.performAction.apply(O, [a, l, s, this.yy, v[1], r, o].concat(d)))) return y;
                          _ && (n = n.slice(0, -1 * _ * 2), r = r.slice(0, -1 * _), o = o.slice(0, -1 * _)), n.push(this.productions_[v[1]][0]), r.push(O.$), o.push(O._$), w = i[n[n.length - 2]][n[n.length - 1]], n.push(w);
                          break;

                        case 3:
                          return !0;
                      }
                    }

                    return !0;
                  }
                },
                    n = {
                  initialize: function initialize() {
                    this._nodes = [], this._node = {}, this._stash = [];
                  },
                  set: function set(e) {
                    for (var t in e) {
                      this._node[t] = e[t];
                    }

                    return this._node;
                  },
                  node: function node(e) {
                    return arguments.length && (this._node = e), this._node;
                  },
                  push: function push() {
                    this._nodes.push(this._node), this._node = {};
                  },
                  unshift: function unshift() {
                    this._nodes.unshift(this._node), this._node = {};
                  },
                  yield: function _yield() {
                    var e = this._nodes;
                    return this.initialize(), e;
                  }
                },
                    r = function () {
                  return {
                    EOF: 1,
                    parseError: function parseError(e, t) {
                      if (!this.yy.parser) throw new Error(e);
                      this.yy.parser.parseError(e, t);
                    },
                    setInput: function setInput(e) {
                      return this._input = e, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                        first_line: 1,
                        first_column: 0,
                        last_line: 1,
                        last_column: 0
                      }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
                    },
                    input: function input() {
                      var e = this._input[0];
                      return this.yytext += e, this.yyleng++, this.offset++, this.match += e, this.matched += e, e.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), e;
                    },
                    unput: function unput(e) {
                      var t = e.length,
                          n = e.split(/(?:\r\n?|\n)/g);
                      this._input = e + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - t - 1), this.offset -= t;
                      var r = this.match.split(/(?:\r\n?|\n)/g);
                      this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
                      var o = this.yylloc.range;
                      return this.yylloc = {
                        first_line: this.yylloc.first_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.first_column,
                        last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - t
                      }, this.options.ranges && (this.yylloc.range = [o[0], o[0] + this.yyleng - t]), this.yyleng = this.yytext.length, this;
                    },
                    more: function more() {
                      return this._more = !0, this;
                    },
                    reject: function reject() {
                      return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                        text: "",
                        token: null,
                        line: this.yylineno
                      });
                    },
                    less: function less(e) {
                      this.unput(this.match.slice(e));
                    },
                    pastInput: function pastInput() {
                      var e = this.matched.substr(0, this.matched.length - this.match.length);
                      return (e.length > 20 ? "..." : "") + e.substr(-20).replace(/\n/g, "");
                    },
                    upcomingInput: function upcomingInput() {
                      var e = this.match;
                      return e.length < 20 && (e += this._input.substr(0, 20 - e.length)), (e.substr(0, 20) + (e.length > 20 ? "..." : "")).replace(/\n/g, "");
                    },
                    showPosition: function showPosition() {
                      var e = this.pastInput(),
                          t = new Array(e.length + 1).join("-");
                      return e + this.upcomingInput() + "\n" + t + "^";
                    },
                    test_match: function test_match(e, t) {
                      var n, r, o;
                      if (this.options.backtrack_lexer && (o = {
                        yylineno: this.yylineno,
                        yylloc: {
                          first_line: this.yylloc.first_line,
                          last_line: this.last_line,
                          first_column: this.yylloc.first_column,
                          last_column: this.yylloc.last_column
                        },
                        yytext: this.yytext,
                        match: this.match,
                        matches: this.matches,
                        matched: this.matched,
                        yyleng: this.yyleng,
                        offset: this.offset,
                        _more: this._more,
                        _input: this._input,
                        yy: this.yy,
                        conditionStack: this.conditionStack.slice(0),
                        done: this.done
                      }, this.options.ranges && (o.yylloc.range = this.yylloc.range.slice(0))), r = e[0].match(/(?:\r\n?|\n).*/g), r && (this.yylineno += r.length), this.yylloc = {
                        first_line: this.yylloc.last_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.last_column,
                        last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + e[0].length
                      }, this.yytext += e[0], this.match += e[0], this.matches = e, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(e[0].length), this.matched += e[0], n = this.performAction.call(this, this.yy, this, t, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

                      if (this._backtrack) {
                        for (var i in o) {
                          this[i] = o[i];
                        }

                        return !1;
                      }

                      return !1;
                    },
                    next: function next() {
                      if (this.done) return this.EOF;
                      this._input || (this.done = !0);
                      var e, t, n, r;
                      this._more || (this.yytext = "", this.match = "");

                      for (var o = this._currentRules(), i = 0; i < o.length; i++) {
                        if ((n = this._input.match(this.rules[o[i]])) && (!t || n[0].length > t[0].length)) {
                          if (t = n, r = i, this.options.backtrack_lexer) {
                            if (!1 !== (e = this.test_match(n, o[i]))) return e;

                            if (this._backtrack) {
                              t = !1;
                              continue;
                            }

                            return !1;
                          }

                          if (!this.options.flex) break;
                        }
                      }

                      return t ? !1 !== (e = this.test_match(t, o[r])) && e : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                        text: "",
                        token: null,
                        line: this.yylineno
                      });
                    },
                    lex: function lex() {
                      var e = this.next();
                      return e || this.lex();
                    },
                    begin: function begin(e) {
                      this.conditionStack.push(e);
                    },
                    popState: function popState() {
                      return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
                    },
                    _currentRules: function _currentRules() {
                      return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
                    },
                    topState: function topState(e) {
                      return e = this.conditionStack.length - 1 - Math.abs(e || 0), e >= 0 ? this.conditionStack[e] : "INITIAL";
                    },
                    pushState: function pushState(e) {
                      this.begin(e);
                    },
                    stateStackSize: function stateStackSize() {
                      return this.conditionStack.length;
                    },
                    options: {},
                    performAction: function performAction(e, t, n, r) {
                      switch (n) {
                        case 0:
                          return 4;

                        case 1:
                          return 14;

                        case 2:
                          return 12;

                        case 3:
                          return 15;

                        case 4:
                          return 16;

                        case 5:
                          return 22;

                        case 6:
                          return 24;

                        case 7:
                          return 28;

                        case 8:
                          return 30;

                        case 9:
                          return 18;

                        case 10:
                          return t.yytext = t.yytext.substr(1, t.yyleng - 2), 32;

                        case 11:
                          return t.yytext = t.yytext.substr(1, t.yyleng - 2), 33;

                        case 12:
                          return 17;

                        case 13:
                          return 31;
                      }
                    },
                    rules: [/^(?:\$)/, /^(?:\.\.)/, /^(?:\.)/, /^(?:\*)/, /^(?:[a-zA-Z_]+[a-zA-Z0-9_]*)/, /^(?:\[)/, /^(?:\])/, /^(?:,)/, /^(?:((-?(?:0|[1-9][0-9]*)))?\:((-?(?:0|[1-9][0-9]*)))?(\:((-?(?:0|[1-9][0-9]*)))?)?)/, /^(?:(-?(?:0|[1-9][0-9]*)))/, /^(?:"(?:\\["bfnrt/\\]|\\u[a-fA-F0-9]{4}|[^"\\])*")/, /^(?:'(?:\\['bfnrt/\\]|\\u[a-fA-F0-9]{4}|[^'\\])*')/, /^(?:\(.+?\)(?=\]))/, /^(?:\?\(.+?\)(?=\]))/],
                    conditions: {
                      INITIAL: {
                        rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
                        inclusive: !0
                      }
                    }
                  };
                }();

                return t.lexer = r, e.prototype = t, t.Parser = e, new e();
              }();

              void 0 !== e && void 0 !== n && (n.parser = o, n.Parser = o.Parser, n.parse = function () {
                return o.parse.apply(o, arguments);
              }, n.main = function (t) {
                t[1] || r.exit(1);
                var o = e("fs").readFileSync(e("path").normalize(t[1]), "utf8");
                return n.parser.parse(o);
              }, void 0 !== t && e.main === t && n.main(r.argv.slice(1)));
            }).call(this, e("_process"));
          }, {
            _process: 14,
            fs: 12,
            path: 13
          }],
          2: [function (e, t, n) {
            t.exports = {
              identifier: "[a-zA-Z_]+[a-zA-Z0-9_]*",
              integer: "-?(?:0|[1-9][0-9]*)",
              qq_string: "\"(?:\\\\[\"bfnrt/\\\\]|\\\\u[a-fA-F0-9]{4}|[^\"\\\\])*\"",
              q_string: "'(?:\\\\['bfnrt/\\\\]|\\\\u[a-fA-F0-9]{4}|[^'\\\\])*'"
            };
          }, {}],
          3: [function (e, t, n) {
            var r = e("./dict"),
                o = e("fs"),
                i = {
              lex: {
                macros: {
                  esc: "\\\\",
                  int: r.integer
                },
                rules: [["\\$", "return 'DOLLAR'"], ["\\.\\.", "return 'DOT_DOT'"], ["\\.", "return 'DOT'"], ["\\*", "return 'STAR'"], [r.identifier, "return 'IDENTIFIER'"], ["\\[", "return '['"], ["\\]", "return ']'"], [",", "return ','"], ["({int})?\\:({int})?(\\:({int})?)?", "return 'ARRAY_SLICE'"], ["{int}", "return 'INTEGER'"], [r.qq_string, "yytext = yytext.substr(1,yyleng-2); return 'QQ_STRING';"], [r.q_string, "yytext = yytext.substr(1,yyleng-2); return 'Q_STRING';"], ["\\(.+?\\)(?=\\])", "return 'SCRIPT_EXPRESSION'"], ["\\?\\(.+?\\)(?=\\])", "return 'FILTER_EXPRESSION'"]]
              },
              start: "JSON_PATH",
              bnf: {
                JSON_PATH: [["DOLLAR", 'yy.ast.set({ expression: { type: "root", value: $1 } }); yy.ast.unshift(); return yy.ast.yield()'], ["DOLLAR PATH_COMPONENTS", 'yy.ast.set({ expression: { type: "root", value: $1 } }); yy.ast.unshift(); return yy.ast.yield()'], ["LEADING_CHILD_MEMBER_EXPRESSION", "yy.ast.unshift(); return yy.ast.yield()"], ["LEADING_CHILD_MEMBER_EXPRESSION PATH_COMPONENTS", 'yy.ast.set({ operation: "member", scope: "child", expression: { type: "identifier", value: $1 }}); yy.ast.unshift(); return yy.ast.yield()']],
                PATH_COMPONENTS: [["PATH_COMPONENT", ""], ["PATH_COMPONENTS PATH_COMPONENT", ""]],
                PATH_COMPONENT: [["MEMBER_COMPONENT", 'yy.ast.set({ operation: "member" }); yy.ast.push()'], ["SUBSCRIPT_COMPONENT", 'yy.ast.set({ operation: "subscript" }); yy.ast.push() ']],
                MEMBER_COMPONENT: [["CHILD_MEMBER_COMPONENT", 'yy.ast.set({ scope: "child" })'], ["DESCENDANT_MEMBER_COMPONENT", 'yy.ast.set({ scope: "descendant" })']],
                CHILD_MEMBER_COMPONENT: [["DOT MEMBER_EXPRESSION", ""]],
                LEADING_CHILD_MEMBER_EXPRESSION: [["MEMBER_EXPRESSION", 'yy.ast.set({ scope: "child", operation: "member" })']],
                DESCENDANT_MEMBER_COMPONENT: [["DOT_DOT MEMBER_EXPRESSION", ""]],
                MEMBER_EXPRESSION: [["STAR", 'yy.ast.set({ expression: { type: "wildcard", value: $1 } })'], ["IDENTIFIER", 'yy.ast.set({ expression: { type: "identifier", value: $1 } })'], ["SCRIPT_EXPRESSION", 'yy.ast.set({ expression: { type: "script_expression", value: $1 } })'], ["INTEGER", 'yy.ast.set({ expression: { type: "numeric_literal", value: parseInt($1) } })'], ["END", ""]],
                SUBSCRIPT_COMPONENT: [["CHILD_SUBSCRIPT_COMPONENT", 'yy.ast.set({ scope: "child" })'], ["DESCENDANT_SUBSCRIPT_COMPONENT", 'yy.ast.set({ scope: "descendant" })']],
                CHILD_SUBSCRIPT_COMPONENT: [["[ SUBSCRIPT ]", ""]],
                DESCENDANT_SUBSCRIPT_COMPONENT: [["DOT_DOT [ SUBSCRIPT ]", ""]],
                SUBSCRIPT: [["SUBSCRIPT_EXPRESSION", ""], ["SUBSCRIPT_EXPRESSION_LIST", '$1.length > 1? yy.ast.set({ expression: { type: "union", value: $1 } }) : $$ = $1']],
                SUBSCRIPT_EXPRESSION_LIST: [["SUBSCRIPT_EXPRESSION_LISTABLE", "$$ = [$1]"], ["SUBSCRIPT_EXPRESSION_LIST , SUBSCRIPT_EXPRESSION_LISTABLE", "$$ = $1.concat($3)"]],
                SUBSCRIPT_EXPRESSION_LISTABLE: [["INTEGER", '$$ = { expression: { type: "numeric_literal", value: parseInt($1) } }; yy.ast.set($$)'], ["STRING_LITERAL", '$$ = { expression: { type: "string_literal", value: $1 } }; yy.ast.set($$)'], ["ARRAY_SLICE", '$$ = { expression: { type: "slice", value: $1 } }; yy.ast.set($$)']],
                SUBSCRIPT_EXPRESSION: [["STAR", '$$ = { expression: { type: "wildcard", value: $1 } }; yy.ast.set($$)'], ["SCRIPT_EXPRESSION", '$$ = { expression: { type: "script_expression", value: $1 } }; yy.ast.set($$)'], ["FILTER_EXPRESSION", '$$ = { expression: { type: "filter_expression", value: $1 } }; yy.ast.set($$)']],
                STRING_LITERAL: [["QQ_STRING", "$$ = $1"], ["Q_STRING", "$$ = $1"]]
              }
            };
            o.readFileSync && (i.moduleInclude = o.readFileSync(e.resolve("../include/module.js")), i.actionInclude = o.readFileSync(e.resolve("../include/action.js"))), t.exports = i;
          }, {
            "./dict": 2,
            fs: 12
          }],
          4: [function (e, t, n) {
            function r(t, n, r) {
              var o = e("./index"),
                  i = f.parse(n).body[0].expression,
                  a = u(i, {
                "@": t.value
              }),
                  s = r.replace(/\{\{\s*value\s*\}\}/g, a),
                  l = o.nodes(t.value, s);
              return l.forEach(function (e) {
                e.path = t.path.concat(e.path.slice(1));
              }), l;
            }

            function o(e) {
              return Array.isArray(e);
            }

            function i(e) {
              return e && !(e instanceof Array) && e instanceof Object;
            }

            function a(e) {
              return function (t, n, r, a) {
                var s = t.value,
                    l = t.path,
                    u = [],
                    c = function (t, s) {
                  o(t) ? (t.forEach(function (e, t) {
                    u.length >= a || r(t, e, n) && u.push({
                      path: s.concat(t),
                      value: e
                    });
                  }), t.forEach(function (t, n) {
                    u.length >= a || e && c(t, s.concat(n));
                  })) : i(t) && (this.keys(t).forEach(function (e) {
                    u.length >= a || r(e, t[e], n) && u.push({
                      path: s.concat(e),
                      value: t[e]
                    });
                  }), this.keys(t).forEach(function (n) {
                    u.length >= a || e && c(t[n], s.concat(n));
                  }));
                }.bind(this);

                return c(s, l), u;
              };
            }

            function s(e) {
              return function (t, n, r) {
                return this.descend(n, t.expression.value, e, r);
              };
            }

            function l(e) {
              return function (t, n, r) {
                return this.traverse(n, t.expression.value, e, r);
              };
            }

            function u() {
              try {
                return h.apply(this, arguments);
              } catch (e) {}
            }

            function c(e) {
              return e = e.filter(function (e) {
                return e;
              }), m(e, function (e) {
                return e.path.map(function (e) {
                  return String(e).replace("-", "--");
                }).join("-");
              });
            }

            function d(e) {
              var t = String(e);
              return t.match(/^-?[0-9]+$/) ? parseInt(t) : null;
            }

            var f = e("./aesprim"),
                p = e("./slice"),
                h = e("static-eval"),
                m = e("underscore").uniq,
                g = function g() {
              return this.initialize.apply(this, arguments);
            };

            g.prototype.initialize = function () {
              this.traverse = a(!0), this.descend = a();
            }, g.prototype.keys = Object.keys, g.prototype.resolve = function (e) {
              var t = [e.operation, e.scope, e.expression.type].join("-"),
                  n = this._fns[t];
              if (!n) throw new Error("couldn't resolve key: " + t);
              return n.bind(this);
            }, g.prototype.register = function (e, t) {
              if (!t instanceof Function) throw new Error("handler must be a function");
              this._fns[e] = t;
            }, g.prototype._fns = {
              "member-child-identifier": function memberChildIdentifier(e, t) {
                var n = e.expression.value,
                    r = t.value;
                if (r instanceof Object && n in r) return [{
                  value: r[n],
                  path: t.path.concat(n)
                }];
              },
              "member-descendant-identifier": l(function (e, t, n) {
                return e == n;
              }),
              "subscript-child-numeric_literal": s(function (e, t, n) {
                return e === n;
              }),
              "member-child-numeric_literal": s(function (e, t, n) {
                return String(e) === String(n);
              }),
              "subscript-descendant-numeric_literal": l(function (e, t, n) {
                return e === n;
              }),
              "member-child-wildcard": s(function () {
                return !0;
              }),
              "member-descendant-wildcard": l(function () {
                return !0;
              }),
              "subscript-descendant-wildcard": l(function () {
                return !0;
              }),
              "subscript-child-wildcard": s(function () {
                return !0;
              }),
              "subscript-child-slice": function subscriptChildSlice(e, t) {
                if (o(t.value)) {
                  var n = e.expression.value.split(":").map(d),
                      r = t.value.map(function (e, n) {
                    return {
                      value: e,
                      path: t.path.concat(n)
                    };
                  });
                  return p.apply(null, [r].concat(n));
                }
              },
              "subscript-child-union": function subscriptChildUnion(e, t) {
                var n = [];
                return e.expression.value.forEach(function (e) {
                  var r = {
                    operation: "subscript",
                    scope: "child",
                    expression: e.expression
                  },
                      o = this.resolve(r),
                      i = o(r, t);
                  i && (n = n.concat(i));
                }, this), c(n);
              },
              "subscript-descendant-union": function subscriptDescendantUnion(t, n, r) {
                var o = e(".."),
                    i = this,
                    a = [];
                return o.nodes(n, "$..*").slice(1).forEach(function (e) {
                  a.length >= r || t.expression.value.forEach(function (t) {
                    var n = {
                      operation: "subscript",
                      scope: "child",
                      expression: t.expression
                    },
                        r = i.resolve(n),
                        o = r(n, e);
                    a = a.concat(o);
                  });
                }), c(a);
              },
              "subscript-child-filter_expression": function subscriptChildFilter_expression(e, t, n) {
                var r = e.expression.value.slice(2, -1),
                    o = f.parse(r).body[0].expression,
                    i = function i(e, t) {
                  return u(o, {
                    "@": t
                  });
                };

                return this.descend(t, null, i, n);
              },
              "subscript-descendant-filter_expression": function subscriptDescendantFilter_expression(e, t, n) {
                var r = e.expression.value.slice(2, -1),
                    o = f.parse(r).body[0].expression,
                    i = function i(e, t) {
                  return u(o, {
                    "@": t
                  });
                };

                return this.traverse(t, null, i, n);
              },
              "subscript-child-script_expression": function subscriptChildScript_expression(e, t) {
                return r(t, e.expression.value.slice(1, -1), "$[{{value}}]");
              },
              "member-child-script_expression": function memberChildScript_expression(e, t) {
                return r(t, e.expression.value.slice(1, -1), "$.{{value}}");
              },
              "member-descendant-script_expression": function memberDescendantScript_expression(e, t) {
                return r(t, e.expression.value.slice(1, -1), "$..value");
              }
            }, g.prototype._fns["subscript-child-string_literal"] = g.prototype._fns["member-child-identifier"], g.prototype._fns["member-descendant-numeric_literal"] = g.prototype._fns["subscript-descendant-string_literal"] = g.prototype._fns["member-descendant-identifier"], t.exports = g;
          }, {
            "..": "jsonpath",
            "./aesprim": "./aesprim",
            "./index": 5,
            "./slice": 7,
            "static-eval": 15,
            underscore: 12
          }],
          5: [function (e, t, n) {
            function r(e) {
              return "[object String]" == Object.prototype.toString.call(e);
            }

            var o = e("assert"),
                i = e("./dict"),
                a = e("./parser"),
                s = e("./handlers"),
                l = function l() {
              this.initialize.apply(this, arguments);
            };

            l.prototype.initialize = function () {
              this.parser = new a(), this.handlers = new s();
            }, l.prototype.parse = function (e) {
              return o.ok(r(e), "we need a path"), this.parser.parse(e);
            }, l.prototype.parent = function (e, t) {
              o.ok(e instanceof Object, "obj needs to be an object"), o.ok(t, "we need a path");
              var n = this.nodes(e, t)[0];
              n.path.pop();
              return this.value(e, n.path);
            }, l.prototype.apply = function (e, t, n) {
              o.ok(e instanceof Object, "obj needs to be an object"), o.ok(t, "we need a path"), o.equal(typeof n, "function", "fn needs to be function");
              var r = this.nodes(e, t).sort(function (e, t) {
                return t.path.length - e.path.length;
              });
              return r.forEach(function (t) {
                var r = t.path.pop(),
                    o = this.value(e, this.stringify(t.path)),
                    i = t.value = n.call(e, o[r]);
                o[r] = i;
              }, this), r;
            }, l.prototype.value = function (e, t, n) {
              if (o.ok(e instanceof Object, "obj needs to be an object"), o.ok(t, "we need a path"), arguments.length >= 3) {
                var r = this.nodes(e, t).shift();
                if (!r) return this._vivify(e, t, n);
                var i = r.path.slice(-1).shift();
                this.parent(e, this.stringify(r.path))[i] = n;
              }

              return this.query(e, this.stringify(t), 1).shift();
            }, l.prototype._vivify = function (e, t, n) {
              var r = this;
              o.ok(e instanceof Object, "obj needs to be an object"), o.ok(t, "we need a path");

              var i = this.parser.parse(t).map(function (e) {
                return e.expression.value;
              }),
                  a = function a(t, n) {
                var o = t.pop(),
                    i = r.value(e, t);
                i || (a(t.concat(), "string" == typeof o ? {} : []), i = r.value(e, t)), i[o] = n;
              };

              return a(i, n), this.query(e, t)[0];
            }, l.prototype.query = function (e, t, n) {
              return o.ok(e instanceof Object, "obj needs to be an object"), o.ok(r(t), "we need a path"), this.nodes(e, t, n).map(function (e) {
                return e.value;
              });
            }, l.prototype.paths = function (e, t, n) {
              return o.ok(e instanceof Object, "obj needs to be an object"), o.ok(t, "we need a path"), this.nodes(e, t, n).map(function (e) {
                return e.path;
              });
            }, l.prototype.nodes = function (e, t, n) {
              if (o.ok(e instanceof Object, "obj needs to be an object"), o.ok(t, "we need a path"), 0 === n) return [];
              var r = this.parser.parse(t),
                  i = this.handlers,
                  a = [{
                path: ["$"],
                value: e
              }],
                  s = [];
              return r.length && "root" == r[0].expression.type && r.shift(), r.length ? (r.forEach(function (e, t) {
                if (!(s.length >= n)) {
                  var o = i.resolve(e),
                      l = [];
                  a.forEach(function (i) {
                    if (!(s.length >= n)) {
                      var a = o(e, i, n);
                      t == r.length - 1 ? s = s.concat(a || []) : l = l.concat(a || []);
                    }
                  }), a = l;
                }
              }), n ? s.slice(0, n) : s) : a;
            }, l.prototype.stringify = function (e) {
              o.ok(e, "we need a path");
              var t = "$",
                  n = {
                "descendant-member": "..{{value}}",
                "child-member": ".{{value}}",
                "descendant-subscript": "..[{{value}}]",
                "child-subscript": "[{{value}}]"
              };
              return e = this._normalize(e), e.forEach(function (e) {
                if ("root" != e.expression.type) {
                  var r,
                      o = [e.scope, e.operation].join("-"),
                      i = n[o];
                  if (r = "string_literal" == e.expression.type ? JSON.stringify(e.expression.value) : e.expression.value, !i) throw new Error("couldn't find template " + o);
                  t += i.replace(/{{value}}/, r);
                }
              }), t;
            }, l.prototype._normalize = function (e) {
              if (o.ok(e, "we need a path"), "string" == typeof e) return this.parser.parse(e);

              if (Array.isArray(e) && "string" == typeof e[0]) {
                var t = [{
                  expression: {
                    type: "root",
                    value: "$"
                  }
                }];
                return e.forEach(function (e, n) {
                  if ("$" != e || 0 !== n) if ("string" == typeof e && e.match("^" + i.identifier + "$")) t.push({
                    operation: "member",
                    scope: "child",
                    expression: {
                      value: e,
                      type: "identifier"
                    }
                  });else {
                    var r = "number" == typeof e ? "numeric_literal" : "string_literal";
                    t.push({
                      operation: "subscript",
                      scope: "child",
                      expression: {
                        value: e,
                        type: r
                      }
                    });
                  }
                }), t;
              }

              if (Array.isArray(e) && "object" == typeof e[0]) return e;
              throw new Error("couldn't understand path " + e);
            }, l.Handlers = s, l.Parser = a;
            var u = new l();
            u.JSONPath = l, t.exports = u;
          }, {
            "./dict": 2,
            "./handlers": 4,
            "./parser": 6,
            assert: 8
          }],
          6: [function (e, t, n) {
            var r = e("./grammar"),
                o = e("../generated/parser"),
                i = function i() {
              var e = new o.Parser(),
                  t = e.parseError;
              return e.yy.parseError = function () {
                e.yy.ast && e.yy.ast.initialize(), t.apply(e, arguments);
              }, e;
            };

            i.grammar = r, t.exports = i;
          }, {
            "../generated/parser": 1,
            "./grammar": 3
          }],
          7: [function (e, t, n) {
            function r(e) {
              return String(e).match(/^[0-9]+$/) ? parseInt(e) : Number.isFinite(e) ? parseInt(e, 10) : 0;
            }

            t.exports = function (e, t, n, o) {
              if ("string" == typeof t) throw new Error("start cannot be a string");
              if ("string" == typeof n) throw new Error("end cannot be a string");
              if ("string" == typeof o) throw new Error("step cannot be a string");
              var i = e.length;
              if (0 === o) throw new Error("step cannot be zero");
              if (o = o ? r(o) : 1, t = t < 0 ? i + t : t, n = n < 0 ? i + n : n, t = r(0 === t ? 0 : t || (o > 0 ? 0 : i - 1)), n = r(0 === n ? 0 : n || (o > 0 ? i : -1)), t = o > 0 ? Math.max(0, t) : Math.min(i, t), n = o > 0 ? Math.min(n, i) : Math.max(-1, n), o > 0 && n <= t) return [];
              if (o < 0 && t <= n) return [];

              for (var a = [], s = t; s != n && !(o < 0 && s <= n || o > 0 && s >= n); s += o) {
                a.push(e[s]);
              }

              return a;
            };
          }, {}],
          8: [function (e, t, n) {
            function r(e, t) {
              return p.isUndefined(t) ? "" + t : p.isNumber(t) && !isFinite(t) ? t.toString() : p.isFunction(t) || p.isRegExp(t) ? t.toString() : t;
            }

            function o(e, t) {
              return p.isString(e) ? e.length < t ? e : e.slice(0, t) : e;
            }

            function i(e) {
              return o(JSON.stringify(e.actual, r), 128) + " " + e.operator + " " + o(JSON.stringify(e.expected, r), 128);
            }

            function a(e, t, n, r, o) {
              throw new g.AssertionError({
                message: n,
                actual: e,
                expected: t,
                operator: r,
                stackStartFunction: o
              });
            }

            function s(e, t) {
              e || a(e, !0, t, "==", g.ok);
            }

            function l(e, t) {
              if (e === t) return !0;

              if (p.isBuffer(e) && p.isBuffer(t)) {
                if (e.length != t.length) return !1;

                for (var n = 0; n < e.length; n++) {
                  if (e[n] !== t[n]) return !1;
                }

                return !0;
              }

              return p.isDate(e) && p.isDate(t) ? e.getTime() === t.getTime() : p.isRegExp(e) && p.isRegExp(t) ? e.source === t.source && e.global === t.global && e.multiline === t.multiline && e.lastIndex === t.lastIndex && e.ignoreCase === t.ignoreCase : p.isObject(e) || p.isObject(t) ? c(e, t) : e == t;
            }

            function u(e) {
              return "[object Arguments]" == Object.prototype.toString.call(e);
            }

            function c(e, t) {
              if (p.isNullOrUndefined(e) || p.isNullOrUndefined(t)) return !1;
              if (e.prototype !== t.prototype) return !1;
              if (p.isPrimitive(e) || p.isPrimitive(t)) return e === t;
              var n = u(e),
                  r = u(t);
              if (n && !r || !n && r) return !1;
              if (n) return e = h.call(e), t = h.call(t), l(e, t);
              var o,
                  i,
                  a = v(e),
                  s = v(t);
              if (a.length != s.length) return !1;

              for (a.sort(), s.sort(), i = a.length - 1; i >= 0; i--) {
                if (a[i] != s[i]) return !1;
              }

              for (i = a.length - 1; i >= 0; i--) {
                if (o = a[i], !l(e[o], t[o])) return !1;
              }

              return !0;
            }

            function d(e, t) {
              return !(!e || !t) && ("[object RegExp]" == Object.prototype.toString.call(t) ? t.test(e) : e instanceof t || !0 === t.call({}, e));
            }

            function f(e, t, n, r) {
              var o;
              p.isString(n) && (r = n, n = null);

              try {
                t();
              } catch (e) {
                o = e;
              }

              if (r = (n && n.name ? " (" + n.name + ")." : ".") + (r ? " " + r : "."), e && !o && a(o, n, "Missing expected exception" + r), !e && d(o, n) && a(o, n, "Got unwanted exception" + r), e && o && n && !d(o, n) || !e && o) throw o;
            } // Copyright (c) 2009 Thomas Robinson <280north.com>
            // rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
            // The above copyright notice and this permission notice shall be included in


            var p = e("util/"),
                h = Array.prototype.slice,
                m = Object.prototype.hasOwnProperty,
                g = t.exports = s;
            g.AssertionError = function (e) {
              this.name = "AssertionError", this.actual = e.actual, this.expected = e.expected, this.operator = e.operator, e.message ? (this.message = e.message, this.generatedMessage = !1) : (this.message = i(this), this.generatedMessage = !0);
              var t = e.stackStartFunction || a;
              if (Error.captureStackTrace) Error.captureStackTrace(this, t);else {
                var n = new Error();

                if (n.stack) {
                  var r = n.stack,
                      o = t.name,
                      s = r.indexOf("\n" + o);

                  if (s >= 0) {
                    var l = r.indexOf("\n", s + 1);
                    r = r.substring(l + 1);
                  }

                  this.stack = r;
                }
              }
            }, p.inherits(g.AssertionError, Error), g.fail = a, g.ok = s, g.equal = function (e, t, n) {
              e != t && a(e, t, n, "==", g.equal);
            }, g.notEqual = function (e, t, n) {
              e == t && a(e, t, n, "!=", g.notEqual);
            }, g.deepEqual = function (e, t, n) {
              l(e, t) || a(e, t, n, "deepEqual", g.deepEqual);
            }, g.notDeepEqual = function (e, t, n) {
              l(e, t) && a(e, t, n, "notDeepEqual", g.notDeepEqual);
            }, g.strictEqual = function (e, t, n) {
              e !== t && a(e, t, n, "===", g.strictEqual);
            }, g.notStrictEqual = function (e, t, n) {
              e === t && a(e, t, n, "!==", g.notStrictEqual);
            }, g.throws = function (e, t, n) {
              f.apply(this, [!0].concat(h.call(arguments)));
            }, g.doesNotThrow = function (e, t) {
              f.apply(this, [!1].concat(h.call(arguments)));
            }, g.ifError = function (e) {
              if (e) throw e;
            };

            var v = Object.keys || function (e) {
              var t = [];

              for (var n in e) {
                m.call(e, n) && t.push(n);
              }

              return t;
            };
          }, {
            "util/": 11
          }],
          9: [function (e, t, n) {
            "function" == typeof Object.create ? t.exports = function (e, t) {
              e.super_ = t, e.prototype = Object.create(t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              });
            } : t.exports = function (e, t) {
              e.super_ = t;

              var n = function n() {};

              n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
            };
          }, {}],
          10: [function (e, t, n) {
            t.exports = function (e) {
              return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
            };
          }, {}],
          11: [function (e, n, r) {
            (function (t, n) {
              function o(e, t) {
                var n = {
                  seen: [],
                  stylize: a
                };
                return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), m(t) ? n.showHidden = t : t && r._extend(n, t), w(n.showHidden) && (n.showHidden = !1), w(n.depth) && (n.depth = 2), w(n.colors) && (n.colors = !1), w(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = i), l(n, e, n.depth);
              }

              function i(e, t) {
                var n = o.styles[t];
                return n ? "[" + o.colors[n][0] + "m" + e + "[" + o.colors[n][1] + "m" : e;
              }

              function a(e, t) {
                return e;
              }

              function s(e) {
                var t = {};
                return e.forEach(function (e, n) {
                  t[e] = !0;
                }), t;
              }

              function l(e, t, n) {
                if (e.customInspect && t && T(t.inspect) && t.inspect !== r.inspect && (!t.constructor || t.constructor.prototype !== t)) {
                  var o = t.inspect(n, e);
                  return b(o) || (o = l(e, o, n)), o;
                }

                var i = u(e, t);
                if (i) return i;
                var a = Object.keys(t),
                    m = s(a);
                if (e.showHidden && (a = Object.getOwnPropertyNames(t)), x(t) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return c(t);

                if (0 === a.length) {
                  if (T(t)) {
                    var g = t.name ? ": " + t.name : "";
                    return e.stylize("[Function" + g + "]", "special");
                  }

                  if (E(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
                  if (S(t)) return e.stylize(Date.prototype.toString.call(t), "date");
                  if (x(t)) return c(t);
                }

                var v = "",
                    y = !1,
                    _ = ["{", "}"];

                if (h(t) && (y = !0, _ = ["[", "]"]), T(t)) {
                  v = " [Function" + (t.name ? ": " + t.name : "") + "]";
                }

                if (E(t) && (v = " " + RegExp.prototype.toString.call(t)), S(t) && (v = " " + Date.prototype.toUTCString.call(t)), x(t) && (v = " " + c(t)), 0 === a.length && (!y || 0 == t.length)) return _[0] + v + _[1];
                if (n < 0) return E(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special");
                e.seen.push(t);
                var w;
                return w = y ? d(e, t, n, m, a) : a.map(function (r) {
                  return f(e, t, n, m, r, y);
                }), e.seen.pop(), p(w, v, _);
              }

              function u(e, t) {
                if (w(t)) return e.stylize("undefined", "undefined");

                if (b(t)) {
                  var n = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                  return e.stylize(n, "string");
                }

                return y(t) ? e.stylize("" + t, "number") : m(t) ? e.stylize("" + t, "boolean") : g(t) ? e.stylize("null", "null") : void 0;
              }

              function c(e) {
                return "[" + Error.prototype.toString.call(e) + "]";
              }

              function d(e, t, n, r, o) {
                for (var i = [], a = 0, s = t.length; a < s; ++a) {
                  A(t, String(a)) ? i.push(f(e, t, n, r, String(a), !0)) : i.push("");
                }

                return o.forEach(function (o) {
                  o.match(/^\d+$/) || i.push(f(e, t, n, r, o, !0));
                }), i;
              }

              function f(e, t, n, r, o, i) {
                var a, s, u;

                if (u = Object.getOwnPropertyDescriptor(t, o) || {
                  value: t[o]
                }, u.get ? s = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (s = e.stylize("[Setter]", "special")), A(r, o) || (a = "[" + o + "]"), s || (e.seen.indexOf(u.value) < 0 ? (s = g(n) ? l(e, u.value, null) : l(e, u.value, n - 1), s.indexOf("\n") > -1 && (s = i ? s.split("\n").map(function (e) {
                  return "  " + e;
                }).join("\n").substr(2) : "\n" + s.split("\n").map(function (e) {
                  return "   " + e;
                }).join("\n"))) : s = e.stylize("[Circular]", "special")), w(a)) {
                  if (i && o.match(/^\d+$/)) return s;
                  a = JSON.stringify("" + o), a.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
                }

                return a + ": " + s;
              }

              function p(e, t, n) {
                var r = 0;
                return e.reduce(function (e, t) {
                  return r++, t.indexOf("\n") >= 0 && r++, e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                }, 0) > 60 ? n[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + n[1] : n[0] + t + " " + e.join(", ") + " " + n[1];
              }

              function h(e) {
                return Array.isArray(e);
              }

              function m(e) {
                return "boolean" == typeof e;
              }

              function g(e) {
                return null === e;
              }

              function v(e) {
                return null == e;
              }

              function y(e) {
                return "number" == typeof e;
              }

              function b(e) {
                return "string" == typeof e;
              }

              function _(e) {
                return "symbol" == typeof e;
              }

              function w(e) {
                return void 0 === e;
              }

              function E(e) {
                return O(e) && "[object RegExp]" === C(e);
              }

              function O(e) {
                return "object" == typeof e && null !== e;
              }

              function S(e) {
                return O(e) && "[object Date]" === C(e);
              }

              function x(e) {
                return O(e) && ("[object Error]" === C(e) || e instanceof Error);
              }

              function T(e) {
                return "function" == typeof e;
              }

              function k(e) {
                return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
              }

              function C(e) {
                return Object.prototype.toString.call(e);
              }

              function A(e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
              } // Copyright Joyent, Inc. and other Node contributors.
              // distribute, sublicense, and/or sell copies of the Software, and to permit
              // The above copyright notice and this permission notice shall be included


              var N = /%[sdj%]/g;
              r.format = function (e) {
                if (!b(e)) {
                  for (var t = [], n = 0; n < arguments.length; n++) {
                    t.push(o(arguments[n]));
                  }

                  return t.join(" ");
                }

                for (var n = 1, r = arguments, i = r.length, a = String(e).replace(N, function (e) {
                  if ("%%" === e) return "%";
                  if (n >= i) return e;

                  switch (e) {
                    case "%s":
                      return String(r[n++]);

                    case "%d":
                      return Number(r[n++]);

                    case "%j":
                      try {
                        return JSON.stringify(r[n++]);
                      } catch (e) {
                        return "[Circular]";
                      }

                    default:
                      return e;
                  }
                }), s = r[n]; n < i; s = r[++n]) {
                  g(s) || !O(s) ? a += " " + s : a += " " + o(s);
                }

                return a;
              }, r.deprecate = function (e, o) {
                function i() {
                  if (!a) {
                    if (t.throwDeprecation) throw new Error(o);
                    t.traceDeprecation, a = !0;
                  }

                  return e.apply(this, arguments);
                }

                if (w(n.process)) return function () {
                  return r.deprecate(e, o).apply(this, arguments);
                };
                if (!0 === t.noDeprecation) return e;
                var a = !1;
                return i;
              };
              var P,
                  R = {};
              r.debuglog = function (e) {
                if (w(P) && (P = t.env.NODE_DEBUG || ""), e = e.toUpperCase(), !R[e]) if (new RegExp("\\b" + e + "\\b", "i").test(P)) {
                  t.pid;

                  R[e] = function () {
                    r.format.apply(r, arguments);
                  };
                } else R[e] = function () {};
                return R[e];
              }, r.inspect = o, o.colors = {
                bold: [1, 22],
                italic: [3, 23],
                underline: [4, 24],
                inverse: [7, 27],
                white: [37, 39],
                grey: [90, 39],
                black: [30, 39],
                blue: [34, 39],
                cyan: [36, 39],
                green: [32, 39],
                magenta: [35, 39],
                red: [31, 39],
                yellow: [33, 39]
              }, o.styles = {
                special: "cyan",
                number: "yellow",
                boolean: "yellow",
                undefined: "grey",
                null: "bold",
                string: "green",
                date: "magenta",
                regexp: "red"
              }, r.isArray = h, r.isBoolean = m, r.isNull = g, r.isNullOrUndefined = v, r.isNumber = y, r.isString = b, r.isSymbol = _, r.isUndefined = w, r.isRegExp = E, r.isObject = O, r.isDate = S, r.isError = x, r.isFunction = T, r.isPrimitive = k, r.isBuffer = e("./support/isBuffer");
              r.log = function () {}, r.inherits = e("inherits"), r._extend = function (e, t) {
                if (!t || !O(t)) return e;

                for (var n = Object.keys(t), r = n.length; r--;) {
                  e[n[r]] = t[n[r]];
                }

                return e;
              };
            }).call(this, e("_process"), void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
          }, {
            "./support/isBuffer": 10,
            _process: 14,
            inherits: 9
          }],
          12: [function (e, t, n) {}, {}],
          13: [function (e, t, n) {
            (function (e) {
              // Copyright Joyent, Inc. and other Node contributors.
              // distribute, sublicense, and/or sell copies of the Software, and to permit
              // The above copyright notice and this permission notice shall be included
              function t(e, t) {
                for (var n = 0, r = e.length - 1; r >= 0; r--) {
                  var o = e[r];
                  "." === o ? e.splice(r, 1) : ".." === o ? (e.splice(r, 1), n++) : n && (e.splice(r, 1), n--);
                }

                if (t) for (; n--; n) {
                  e.unshift("..");
                }
                return e;
              }

              function r(e) {
                "string" != typeof e && (e += "");
                var t,
                    n = 0,
                    r = -1,
                    o = !0;

                for (t = e.length - 1; t >= 0; --t) {
                  if (47 === e.charCodeAt(t)) {
                    if (!o) {
                      n = t + 1;
                      break;
                    }
                  } else -1 === r && (o = !1, r = t + 1);
                }

                return -1 === r ? "" : e.slice(n, r);
              }

              function o(e, t) {
                if (e.filter) return e.filter(t);

                for (var n = [], r = 0; r < e.length; r++) {
                  t(e[r], r, e) && n.push(e[r]);
                }

                return n;
              }

              n.resolve = function () {
                for (var n = "", r = !1, i = arguments.length - 1; i >= -1 && !r; i--) {
                  var a = i >= 0 ? arguments[i] : e.cwd();
                  if ("string" != typeof a) throw new TypeError("Arguments to path.resolve must be strings");
                  a && (n = a + "/" + n, r = "/" === a.charAt(0));
                }

                return n = t(o(n.split("/"), function (e) {
                  return !!e;
                }), !r).join("/"), (r ? "/" : "") + n || ".";
              }, n.normalize = function (e) {
                var r = n.isAbsolute(e),
                    a = "/" === i(e, -1);
                return e = t(o(e.split("/"), function (e) {
                  return !!e;
                }), !r).join("/"), e || r || (e = "."), e && a && (e += "/"), (r ? "/" : "") + e;
              }, n.isAbsolute = function (e) {
                return "/" === e.charAt(0);
              }, n.join = function () {
                var e = Array.prototype.slice.call(arguments, 0);
                return n.normalize(o(e, function (e, t) {
                  if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
                  return e;
                }).join("/"));
              }, n.relative = function (e, t) {
                function r(e) {
                  for (var t = 0; t < e.length && "" === e[t]; t++) {
                    ;
                  }

                  for (var n = e.length - 1; n >= 0 && "" === e[n]; n--) {
                    ;
                  }

                  return t > n ? [] : e.slice(t, n - t + 1);
                }

                e = n.resolve(e).substr(1), t = n.resolve(t).substr(1);

                for (var o = r(e.split("/")), i = r(t.split("/")), a = Math.min(o.length, i.length), s = a, l = 0; l < a; l++) {
                  if (o[l] !== i[l]) {
                    s = l;
                    break;
                  }
                }

                for (var u = [], l = s; l < o.length; l++) {
                  u.push("..");
                }

                return u = u.concat(i.slice(s)), u.join("/");
              }, n.sep = "/", n.delimiter = ":", n.dirname = function (e) {
                if ("string" != typeof e && (e += ""), 0 === e.length) return ".";

                for (var t = e.charCodeAt(0), n = 47 === t, r = -1, o = !0, i = e.length - 1; i >= 1; --i) {
                  if (47 === (t = e.charCodeAt(i))) {
                    if (!o) {
                      r = i;
                      break;
                    }
                  } else o = !1;
                }

                return -1 === r ? n ? "/" : "." : n && 1 === r ? "/" : e.slice(0, r);
              }, n.basename = function (e, t) {
                var n = r(e);
                return t && n.substr(-1 * t.length) === t && (n = n.substr(0, n.length - t.length)), n;
              }, n.extname = function (e) {
                "string" != typeof e && (e += "");

                for (var t = -1, n = 0, r = -1, o = !0, i = 0, a = e.length - 1; a >= 0; --a) {
                  var s = e.charCodeAt(a);
                  if (47 !== s) -1 === r && (o = !1, r = a + 1), 46 === s ? -1 === t ? t = a : 1 !== i && (i = 1) : -1 !== t && (i = -1);else if (!o) {
                    n = a + 1;
                    break;
                  }
                }

                return -1 === t || -1 === r || 0 === i || 1 === i && t === r - 1 && t === n + 1 ? "" : e.slice(t, r);
              };
              var i = "b" === "ab".substr(-1) ? function (e, t, n) {
                return e.substr(t, n);
              } : function (e, t, n) {
                return t < 0 && (t = e.length + t), e.substr(t, n);
              };
            }).call(this, e("_process"));
          }, {
            _process: 14
          }],
          14: [function (e, t, n) {
            function r() {
              throw new Error("setTimeout has not been defined");
            }

            function o() {
              throw new Error("clearTimeout has not been defined");
            }

            function i(e) {
              if (d === setTimeout) return setTimeout(e, 0);
              if ((d === r || !d) && setTimeout) return d = setTimeout, setTimeout(e, 0);

              try {
                return d(e, 0);
              } catch (t) {
                try {
                  return d.call(null, e, 0);
                } catch (t) {
                  return d.call(this, e, 0);
                }
              }
            }

            function a(e) {
              if (f === clearTimeout) return clearTimeout(e);
              if ((f === o || !f) && clearTimeout) return f = clearTimeout, clearTimeout(e);

              try {
                return f(e);
              } catch (t) {
                try {
                  return f.call(null, e);
                } catch (t) {
                  return f.call(this, e);
                }
              }
            }

            function s() {
              g && h && (g = !1, h.length ? m = h.concat(m) : v = -1, m.length && l());
            }

            function l() {
              if (!g) {
                var e = i(s);
                g = !0;

                for (var t = m.length; t;) {
                  for (h = m, m = []; ++v < t;) {
                    h && h[v].run();
                  }

                  v = -1, t = m.length;
                }

                h = null, g = !1, a(e);
              }
            }

            function u(e, t) {
              this.fun = e, this.array = t;
            }

            function c() {}

            var d,
                f,
                p = t.exports = {};
            !function () {
              try {
                d = "function" == typeof setTimeout ? setTimeout : r;
              } catch (e) {
                d = r;
              }

              try {
                f = "function" == typeof clearTimeout ? clearTimeout : o;
              } catch (e) {
                f = o;
              }
            }();
            var h,
                m = [],
                g = !1,
                v = -1;
            p.nextTick = function (e) {
              var t = new Array(arguments.length - 1);
              if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
                t[n - 1] = arguments[n];
              }
              m.push(new u(e, t)), 1 !== m.length || g || i(l);
            }, u.prototype.run = function () {
              this.fun.apply(null, this.array);
            }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = c, p.addListener = c, p.once = c, p.off = c, p.removeListener = c, p.removeAllListeners = c, p.emit = c, p.prependListener = c, p.prependOnceListener = c, p.listeners = function (e) {
              return [];
            }, p.binding = function (e) {
              throw new Error("process.binding is not supported");
            }, p.cwd = function () {
              return "/";
            }, p.chdir = function (e) {
              throw new Error("process.chdir is not supported");
            }, p.umask = function () {
              return 0;
            };
          }, {}],
          15: [function (e, t, n) {
            var r = e("escodegen").generate;

            t.exports = function (e, t) {
              t || (t = {});

              var n = {},
                  o = function e(o, i) {
                if ("Literal" === o.type) return o.value;

                if ("UnaryExpression" === o.type) {
                  var a = e(o.argument);
                  return "+" === o.operator ? +a : "-" === o.operator ? -a : "~" === o.operator ? ~a : "!" === o.operator ? !a : n;
                }

                if ("ArrayExpression" === o.type) {
                  for (var s = [], l = 0, u = o.elements.length; l < u; l++) {
                    var c = e(o.elements[l]);
                    if (c === n) return n;
                    s.push(c);
                  }

                  return s;
                }

                if ("ObjectExpression" === o.type) {
                  for (var d = {}, l = 0; l < o.properties.length; l++) {
                    var f = o.properties[l],
                        p = null === f.value ? f.value : e(f.value);
                    if (p === n) return n;
                    d[f.key.value || f.key.name] = p;
                  }

                  return d;
                }

                if ("BinaryExpression" === o.type || "LogicalExpression" === o.type) {
                  var u = e(o.left);
                  if (u === n) return n;
                  var h = e(o.right);
                  if (h === n) return n;
                  var m = o.operator;
                  return "==" === m ? u == h : "===" === m ? u === h : "!=" === m ? u != h : "!==" === m ? u !== h : "+" === m ? u + h : "-" === m ? u - h : "*" === m ? u * h : "/" === m ? u / h : "%" === m ? u % h : "<" === m ? u < h : "<=" === m ? u <= h : ">" === m ? u > h : ">=" === m ? u >= h : "|" === m ? u | h : "&" === m ? u & h : "^" === m ? u ^ h : "&&" === m ? u && h : "||" === m ? u || h : n;
                }

                if ("Identifier" === o.type) return {}.hasOwnProperty.call(t, o.name) ? t[o.name] : n;
                if ("ThisExpression" === o.type) return {}.hasOwnProperty.call(t, "this") ? t.this : n;

                if ("CallExpression" === o.type) {
                  var g = e(o.callee);
                  if (g === n) return n;
                  if ("function" != typeof g) return n;
                  var v = o.callee.object ? e(o.callee.object) : n;
                  v === n && (v = null);

                  for (var y = [], l = 0, u = o.arguments.length; l < u; l++) {
                    var c = e(o.arguments[l]);
                    if (c === n) return n;
                    y.push(c);
                  }

                  return g.apply(v, y);
                }

                if ("MemberExpression" === o.type) {
                  var d = e(o.object);
                  if (d === n || "function" == typeof d) return n;
                  if ("Identifier" === o.property.type) return d[o.property.name];
                  var f = e(o.property);
                  return f === n ? n : d[f];
                }

                if ("ConditionalExpression" === o.type) {
                  var a = e(o.test);
                  return a === n ? n : e(a ? o.consequent : o.alternate);
                }

                if ("ExpressionStatement" === o.type) {
                  var a = e(o.expression);
                  return a === n ? n : a;
                }

                if ("ReturnStatement" === o.type) return e(o.argument);

                if ("FunctionExpression" === o.type) {
                  var b = o.body.body,
                      _ = {};
                  Object.keys(t).forEach(function (e) {
                    _[e] = t[e];
                  });

                  for (var l = 0; l < o.params.length; l++) {
                    var w = o.params[l];
                    if ("Identifier" != w.type) return n;
                    t[w.name] = null;
                  }

                  for (var l in b) {
                    if (e(b[l]) === n) return n;
                  }

                  t = _;
                  var E = Object.keys(t),
                      O = E.map(function (e) {
                    return t[e];
                  });
                  return Function(E.join(", "), "return " + r(o)).apply(null, O);
                }

                if ("TemplateLiteral" === o.type) {
                  for (var S = "", l = 0; l < o.expressions.length; l++) {
                    S += e(o.quasis[l]), S += e(o.expressions[l]);
                  }

                  return S += e(o.quasis[l]);
                }

                if ("TaggedTemplateExpression" === o.type) {
                  var x = e(o.tag),
                      T = o.quasi,
                      k = T.quasis.map(e),
                      C = T.expressions.map(e);
                  return x.apply(null, [k].concat(C));
                }

                return "TemplateElement" === o.type ? o.value.cooked : n;
              }(e);

              return o === n ? void 0 : o;
            };
          }, {
            escodegen: 12
          }],
          jsonpath: [function (e, t, n) {
            t.exports = e("./lib/index");
          }, {
            "./lib/index": 5
          }]
        }, {}, ["jsonpath"])("jsonpath");
      });
    }).call(t, n(49));
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return o.apply(this, arguments);
    }

    function o() {
      return o = (0, s.default)(a.default.mark(function e(t) {
        var n, o, i;
        return a.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (!t.get("proxyIdxResponse")) {
                  e.next = 2;
                  break;
                }

                return e.abrupt("return", f(t));

              case 2:
                if (t.get("overrideExistingStateToken") && d.default.removeStateHandle(), !(n = t.get("useInteractionCodeFlow") || t.get("interactionHandle"))) {
                  e.next = 6;
                  break;
                }

                return e.abrupt("return", (0, u.interact)(t));

              case 6:
                if (!(o = d.default.getStateHandle())) {
                  e.next = 9;
                  break;
                }

                return e.abrupt("return", (0, c.introspect)(t, o).then(function (e) {
                  return t.set("stateToken", o), e;
                }).catch(function () {
                  return d.default.removeStateHandle(), r(t);
                }));

              case 9:
                if (!(i = t.get("stateToken"))) {
                  e.next = 12;
                  break;
                }

                return e.abrupt("return", (0, c.introspect)(t, i));

              case 12:
                throw new l.default.ConfigError('Set "useInteractionCodeFlow" to true in configuration to enable the interaction_code" flow for self-hosted widget.');

              case 13:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), o.apply(this, arguments);
    }

    var i = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.startLoginFlow = r;

    var a = i(n(57)),
        s = i(n(58)),
        l = i(n(24)),
        u = n(283),
        c = n(357),
        d = i(n(160)),
        f = function () {
      var e = (0, s.default)(a.default.mark(function e(t) {
        return a.default.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", Promise.resolve({
                  rawIdxState: t.get("proxyIdxResponse"),
                  context: t.get("proxyIdxResponse"),
                  neededToProceed: []
                }));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }();
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      i.default.client.interceptors.request.use(function (t) {
        var n = e.get("deviceFingerprint");
        n && (t.headers["X-Device-Fingerprint"] = n);
      });
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.configIdxJsClient = r;
    var i = o(n(162));
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      return i._.compose(l.default, s.default.bind({}, e), a.default.bind({}, e))(t, n);
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var i = n(1),
        a = o(n(769)),
        s = o(n(770)),
        l = o(n(67));
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = r(n(119)),
        i = n(1),
        a = n(8),
        s = function s(e) {
      return i._.isObject(e);
    },
        l = function l(e) {
      return !!e.messages;
    },
        u = function u(e) {
      var t = {};
      return i._.each(e, function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = arguments.length > 1 ? arguments[1] : void 0;
        "remediation" !== n && ("array" === e.type && (t[n] = {
          value: e.value
        }), "object" === e.type && (t[n] = e.value));
      }), t;
    },
        c = function c(e) {
      var t = [],
          n = 1 === e.neededToProceed.length && "skip" === e.neededToProceed[0].name;
      return (i._.isEmpty(e.neededToProceed) || n) && (e.context.success ? t.push({
        name: e.context.success.name,
        href: e.context.success.href,
        value: []
      }) : e.context.messages ? t.push({
        name: a.FORMS.TERMINAL,
        value: []
      }) : e.context.deviceEnrollment && t.push({
        name: a.FORMS.DEVICE_ENROLLMENT_TERMINAL,
        value: []
      })), {
        remediations: [].concat(t, (0, o.default)(e.neededToProceed))
      };
    },
        d = function d(e, t) {
      var n = t.remediations;
      if (0 === n.filter(function (e) {
        return "identify" === e.name;
      }).length) return t;
      var r = e.get("idps");

      if (Array.isArray(r)) {
        var o = {};
        n.forEach(function (e) {
          e.name === a.FORMS.REDIRECT_IDP && e.idp && (o[e.idp.id] = !0);
        });
        var i = e.get("baseUrl"),
            s = t.idx.context.stateHandle,
            l = r.filter(function (e) {
          return !o[e.id];
        }).map(function (e) {
          var t = {
            id: e.id,
            name: e.text
          },
              n = "".concat(i, "/sso/idps/").concat(e.id, "?stateToken=").concat(s);
          return e.className && (t.className = e.className), {
            name: a.FORMS.REDIRECT_IDP,
            type: e.type,
            idp: t,
            href: n
          };
        });
        t.remediations = n.concat(l);
      }

      return t;
    },
        f = function f(e, t, n) {
      if (Array.isArray(t.remediations)) {
        var r = t.remediations.filter(function (e) {
          return e.name === a.FORMS.REDIRECT_IDP;
        });
        if (1 !== r.length || 1 !== t.remediations.length) return;
        if (e.get("oauth2Enabled") && !n) return;
        var o = {
          name: a.FORMS.SUCCESS_REDIRECT,
          href: r[0].href,
          value: []
        };
        t.remediations = [o];
      }
    },
        p = function p(e) {
      if (Array.isArray(e.remediations)) {
        var t = e.remediations.filter(function (e) {
          var t, n;
          return e.name === a.FORMS.REDIRECT_IDP && "external_idp" === (null === e || void 0 === e ? void 0 : null === (t = e.relatesTo) || void 0 === t ? void 0 : null === (n = t.value) || void 0 === n ? void 0 : n.key);
        });

        if (1 === t.length) {
          var n = Object.prototype.hasOwnProperty.call(e, "currentAuthenticatorEnrollment");
          t[0].name = n ? "challenge-authenticator" : "enroll-authenticator";
        }
      }
    },
        h = function h(e) {
      var t = e.idx.context;
      return t.failure && "failure-redirect" === t.failure.name;
    },
        m = function m(e, t) {
      var n = t.idx.context,
          r = e.get("oauth2Enabled"),
          o = "always" === e.get("redirect");

      if (!r || o) {
        var i = {
          name: a.FORMS.FAILURE_REDIRECT,
          href: n.failure.href,
          value: []
        };
        t.remediations = [i];
      }
    },
        g = function g(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
      if (!s(t.rawIdxState)) return null;
      var r = u(t.rawIdxState),
          o = c(t),
          i = Object.assign({}, r, o, {
        idx: t
      });
      return l(i) && h(i) && m(e, i), d(e, i), p(i), l(i) || f(e, i, n), i;
    },
        v = g;

    t.default = v;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = n(1),
        i = r(n(771)),
        a = r(n(281)),
        s = r(n(772)),
        l = {
      string: s.default,
      boolean: i.default,
      object: a.default
    },
        u = function e(t, n, r) {
      return o._.chain(n.value || []).filter(function (e) {
        return !1 !== e.visible;
      }).map(function (e) {
        var t, n;

        if (e.form ? n = e.form : (null === (t = e.value) || void 0 === t ? void 0 : t.form) && (n = e.value.form), n) {
          var r = e.name;
          return n.value.map(function (e) {
            return Object.assign({}, e, {
              name: r + "." + e.name
            });
          });
        }

        return e;
      }).flatten().value().map(function (o) {
        var i = {
          "label-top": !0,
          "data-se": "o-form-fieldset-".concat(o.name)
        },
            a = o.type || "string",
            s = l[a],
            u = s(o, n, t, e, r);
        return Object.assign({}, o, i, u);
      });
    },
        c = function c(e, t) {
      return t && (t.remediations = t.remediations.map(function (n) {
        return n.uiSchema = u(t, n, e), n;
      })), t;
    },
        d = c;

    t.default = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var r = n(8),
        o = function o(e) {
      return {
        placeholder: e.label,
        label: !1,
        modelType: e.type,
        type: "checkbox",
        required: e.required || !1
      };
    },
        i = function i(e, t) {
      if ([r.FORMS.CONSENT_ENDUSER, r.FORMS.CONSENT_ADMIN].includes(t.name)) {
        var n = t.scopes.map(function (e) {
          return {
            name: e.name,
            displayName: e.label,
            description: e.desc
          };
        });
        return {
          type: t.name,
          scopes: n,
          options: e.options
        };
      }

      return o(e);
    },
        a = i;

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var r = n(8),
        o = function o(e) {
      var t = {};
      return e.forEach(function (e) {
        var n = e.value,
            r = e.label;
        t[n] = r;
      }), t;
    },
        i = function i(e) {
      return {
        type: "password",
        params: {
          showPasswordToggle: e.get("showPasswordToggle")
        }
      };
    },
        a = function a() {
      return {
        type: "captcha"
      };
    },
        s = function s(e) {
      return e.indexOf("methodType") >= 0 || e.indexOf("channel") >= 0;
    },
        l = function l(e, t, n, _l, u) {
      var c = {
        type: "text"
      };
      return !0 === e.secret && Object.assign(c, i(u)), e.hint === r.HINTS.CAPTCHA && Object.assign(c, a()), Array.isArray(e.options) && (s(e.name) ? (c.type = "radio", e.options[0] && e.options[0].value && (e.value = e.options[0].value)) : (c.type = "select", c.wide = !0, c.options = o(e.options))), c;
    },
        u = l;

    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r,
        o,
        i,
        a,
        s,
        l = n(0),
        u = l(n(42)),
        c = l(n(38)),
        d = n(8),
        f = n(3),
        p = l(n(365)),
        h = l(n(781)),
        m = l(n(782)),
        g = l(n(196)),
        v = l(n(784)),
        y = l(n(785)),
        b = l(n(370)),
        _ = l(n(786)),
        w = l(n(790)),
        E = l(n(791)),
        O = l(n(792)),
        S = l(n(793)),
        x = l(n(794)),
        T = l(n(797)),
        k = l(n(798)),
        C = l(n(375)),
        A = l(n(799)),
        N = l(n(138)),
        P = l(n(800)),
        R = l(n(801)),
        I = l(n(802)),
        M = l(n(803)),
        j = l(n(804)),
        L = l(n(806)),
        D = l(n(376)),
        F = l(n(807)),
        U = l(n(808)),
        B = l(n(809)),
        V = l(n(810)),
        H = l(n(812)),
        q = l(n(814)),
        W = l(n(816)),
        z = l(n(817)),
        $ = l(n(820)),
        K = l(n(821)),
        G = l(n(822)),
        Y = l(n(828)),
        J = l(n(829)),
        Q = l(n(830)),
        X = l(n(831)),
        Z = l(n(832)),
        ee = l(n(835)),
        te = l(n(836)),
        ne = l(n(837)),
        re = l(n(838)),
        oe = l(n(839)),
        ie = l(n(840)),
        ae = l(n(841)),
        se = l(n(842)),
        le = l(n(843)),
        ue = l(n(844)),
        ce = (s = {}, (0, u.default)(s, d.FORMS.IDENTIFY, (0, u.default)({}, "_", p.default)), (0, u.default)(s, d.FORMS.IDENTIFY_RECOVERY, (0, u.default)({}, "_", m.default)), (0, u.default)(s, d.FORMS.DEVICE_CHALLENGE_POLL, (0, u.default)({}, "_", E.default)), (0, u.default)(s, d.FORMS.LAUNCH_AUTHENTICATOR, (0, u.default)({}, "_", S.default)), (0, u.default)(s, d.FORMS.DEVICE_APPLE_SSO_EXTENSION, (r = {}, (0, u.default)(r, "_", O.default), (0, u.default)(r, d.AUTHENTICATOR_KEY.OV, X.default), r)), (0, u.default)(s, d.FORMS.CANCEL_TRANSACTION, (0, u.default)({}, "_", O.default)), (0, u.default)(s, d.FORMS.ENROLL_PROFILE, (0, u.default)({}, "_", T.default)), (0, u.default)(s, d.FORMS.POLL, (0, u.default)({}, "_", y.default)), (0, u.default)(s, d.FORMS.SELECT_AUTHENTICATOR_ENROLL, (0, u.default)({}, "_", k.default)), (0, u.default)(s, d.FORMS.AUTHENTICATOR_ENROLLMENT_DATA, (0, u.default)({}, d.AUTHENTICATOR_KEY.PHONE, L.default)), (0, u.default)(s, d.FORMS.CONSENT_ADMIN, (0, u.default)({}, "_", b.default)), (0, u.default)(s, d.FORMS.CONSENT_ENDUSER, (0, u.default)({}, "_", _.default)), (0, u.default)(s, d.FORMS.CONSENT_EMAIL_CHALLENGE, (0, u.default)({}, "_", w.default)), (0, u.default)(s, d.FORMS.ENROLL_AUTHENTICATOR, (o = {}, (0, u.default)(o, d.AUTHENTICATOR_KEY.DUO, re.default), (0, u.default)(o, d.AUTHENTICATOR_KEY.EMAIL, q.default), (0, u.default)(o, d.AUTHENTICATOR_KEY.GOOGLE_OTP, Z.default), (0, u.default)(o, d.AUTHENTICATOR_KEY.IDP, ae.default), (0, u.default)(o, d.AUTHENTICATOR_KEY.ON_PREM, te.default), (0, u.default)(o, d.AUTHENTICATOR_KEY.PASSWORD, N.default), (0, u.default)(o, d.AUTHENTICATOR_KEY.PHONE, j.default), (0, u.default)(o, d.AUTHENTICATOR_KEY.RSA, te.default), (0, u.default)(o, d.AUTHENTICATOR_KEY.SECURITY_QUESTION, U.default), (0, u.default)(o, d.AUTHENTICATOR_KEY.SYMANTEC_VIP, le.default), (0, u.default)(o, d.AUTHENTICATOR_KEY.WEBAUTHN, V.default), o)), (0, u.default)(s, d.FORMS.CHALLENGE_AUTHENTICATOR, (i = {}, (0, u.default)(i, d.AUTHENTICATOR_KEY.CUSTOM_OTP, se.default), (0, u.default)(i, d.AUTHENTICATOR_KEY.DUO, oe.default), (0, u.default)(i, d.AUTHENTICATOR_KEY.EMAIL, W.default), (0, u.default)(i, d.AUTHENTICATOR_KEY.GOOGLE_OTP, ee.default), (0, u.default)(i, d.AUTHENTICATOR_KEY.IDP, ie.default), (0, u.default)(i, d.AUTHENTICATOR_KEY.ON_PREM, ne.default), (0, u.default)(i, d.AUTHENTICATOR_KEY.OV, Y.default), (0, u.default)(i, d.AUTHENTICATOR_KEY.PASSWORD, P.default), (0, u.default)(i, d.AUTHENTICATOR_KEY.PHONE, D.default), (0, u.default)(i, d.AUTHENTICATOR_KEY.RSA, ne.default), (0, u.default)(i, d.AUTHENTICATOR_KEY.SECURITY_QUESTION, B.default), (0, u.default)(i, d.AUTHENTICATOR_KEY.SYMANTEC_VIP, le.default), (0, u.default)(i, d.AUTHENTICATOR_KEY.WEBAUTHN, H.default), i)), (0, u.default)(s, d.FORMS.ENROLL_POLL, (0, u.default)({}, d.AUTHENTICATOR_KEY.OV, z.default)), (0, u.default)(s, d.FORMS.SELECT_ENROLLMENT_CHANNEL, (0, u.default)({}, d.AUTHENTICATOR_KEY.OV, $.default)), (0, u.default)(s, d.FORMS.ENROLLMENT_CHANNEL_DATA, (0, u.default)({}, d.AUTHENTICATOR_KEY.OV, K.default)), (0, u.default)(s, d.FORMS.REENROLL_AUTHENTICATOR, (0, u.default)({}, d.AUTHENTICATOR_KEY.PASSWORD, R.default)), (0, u.default)(s, d.FORMS.REENROLL_AUTHENTICATOR_WARNING, (0, u.default)({}, d.AUTHENTICATOR_KEY.PASSWORD, I.default)), (0, u.default)(s, d.FORMS.RESET_AUTHENTICATOR, (0, u.default)({}, d.AUTHENTICATOR_KEY.PASSWORD, M.default)), (0, u.default)(s, d.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE, (0, u.default)({}, "_", C.default)), (0, u.default)(s, d.FORMS.SELECT_AUTHENTICATOR_UNLOCK, (0, u.default)({}, "_", A.default)), (0, u.default)(s, d.FORMS.CHALLENGE_POLL, (0, u.default)({}, d.AUTHENTICATOR_KEY.OV, G.default)), (0, u.default)(s, d.FORMS.RESEND, (0, u.default)({}, d.AUTHENTICATOR_KEY.OV, J.default)), (0, u.default)(s, d.FORMS.AUTHENTICATOR_VERIFICATION_DATA, (a = {}, (0, u.default)(a, d.AUTHENTICATOR_KEY.PHONE, F.default), (0, u.default)(a, d.AUTHENTICATOR_KEY.OV, Q.default), a)), (0, u.default)(s, d.FORMS.FAILURE_REDIRECT, (0, u.default)({}, "_", v.default)), (0, u.default)(s, d.FORMS.SUCCESS_REDIRECT, (0, u.default)({}, "_", v.default)), (0, u.default)(s, d.FORMS.REDIRECT_IDP, (0, u.default)({}, "_", h.default)), (0, u.default)(s, d.FORMS.DEVICE_ENROLLMENT_TERMINAL, (0, u.default)({}, "_", x.default)), (0, u.default)(s, d.FORMS.USER_CODE, (0, u.default)({}, "_", ue.default)), (0, u.default)(s, d.FORMS.TERMINAL, (0, u.default)({}, "_", g.default)), s);

    e.exports = {
      create: function create(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "_",
            n = ce[e];
        if (!n) return c.default.warn("Cannot find customized View for ".concat(e, ".")), f.BaseView;
        var r = n[t] || n._;
        return r || (c.default.warn("Cannot find customized View for ".concat(e, " + ").concat(t, ".")), f.BaseView);
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = n(8),
        l = r(n(775)),
        u = a.View.extend({
      className: "authenticator-row clearfix",
      template: i.default.template({
        1: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<p class="authenticator-description--text">' + e.escapeExpression((i = null != (i = a(n, "description") || (null != t ? a(t, "description") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "description",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 276
              },
              end: {
                line: 1,
                column: 291
              }
            }
          }) : i)) + "</p>";
        },
        3: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return 'data-se="' + e.escapeExpression((i = null != (i = a(n, "buttonDataSeAttr") || (null != t ? a(t, "buttonDataSeAttr") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "buttonDataSeAttr",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 369
              },
              end: {
                line: 1,
                column: 389
              }
            }
          }) : i)) + '"';
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s,
              l = null != t ? t : e.nullContext || {},
              u = e.hooks.helperMissing,
              c = e.escapeExpression,
              d = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="authenticator-icon-container"><div class="factor-icon authenticator-icon ' + c((s = null != (s = d(n, "iconClassName") || (null != t ? d(t, "iconClassName") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "iconClassName",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 85
              },
              end: {
                line: 1,
                column: 102
              }
            }
          }) : s)) + '"></div></div><div class="authenticator-description"><h3 class="authenticator-label no-translate">' + c((s = null != (s = d(n, "label") || (null != t ? d(t, "label") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "label",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 200
              },
              end: {
                line: 1,
                column: 209
              }
            }
          }) : s)) + "</h3>" + (null != (a = d(n, "if").call(l, null != t ? d(t, "description") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 214
              },
              end: {
                line: 1,
                column: 302
              }
            }
          })) ? a : "") + '<div class="authenticator-button" ' + (null != (a = d(n, "if").call(l, null != t ? d(t, "buttonDataSeAttr") : t, {
            name: "if",
            hash: {},
            fn: e.program(3, i, 0),
            inverse: e.noop,
            data: i,
            loc: {
              start: {
                line: 1,
                column: 336
              },
              end: {
                line: 1,
                column: 397
              }
            }
          })) ? a : "") + "></div></div>";
        },
        useData: !0
      }),
      children: function children() {
        return [[(0, a.createButton)({
          className: "button select-factor",
          title: function title() {
            return (0, a.loc)("oie.enroll.authenticator.button.text", "login");
          },
          click: function click() {
            this.model.trigger("selectAutheticator", this.model.get("value"));
          }
        }), ".authenticator-button"]];
      },
      minimize: function minimize() {
        this.$el.addClass("authenticator-row-min");
      }
    }),
        c = a.ListView.extend({
      className: "authenticator-enroll-list authenticator-list",
      item: u,
      itemSelector: ".list-content",
      initialize: function initialize() {
        this.listenTo(this.collection, "selectAutheticator", function (e) {
          this.model.set(this.options.name, e), this.options.appState.trigger("saveForm", this.model);
        }), this.hasOptionalFactors = this.options.appState.hasRemediationObject(s.FORMS.SKIP), this.hasOptionalFactors && this.add(l.default);
      },
      template: i.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="list-content"><div class="authenticator-list-title">' + e.escapeExpression((i = null != (i = a(n, "title") || (null != t ? a(t, "title") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "title",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 64
              },
              end: {
                line: 1,
                column: 73
              }
            }
          }) : i)) + "</div></div>";
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        return {
          title: this.hasOptionalFactors ? (0, a.loc)("oie.setup.optional", "login") : (0, a.loc)("oie.setup.required", "login")
        };
      }
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = n(8),
        i = (0, r.createButton)({
      className: "button-primary button skip-all",
      title: function title() {
        return (0, r.loc)("oie.optional.authenticator.button.title", "login");
      },
      click: function click() {
        this.options.appState.trigger("invokeAction", o.FORMS.SKIP);
      }
    }),
        a = i;
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = r(n(5)),
        l = n(46),
        u = "https://hcaptcha.com/1/api.js?onload=".concat("OktaSignInWidgetOnCaptchaLoaded", "&render=explicit"),
        c = "https://www.google.com/recaptcha/api.js?onload=".concat("OktaSignInWidgetOnCaptchaLoaded", "&render=explicit"),
        d = a.View.extend({
      className: "captcha-view",
      template: i.default.template({
        1: function _(e, t, n, r, i) {
          var a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div id ="captcha-container" class="' + u((a = null != (a = c(n, "className") || (null != t ? c(t, "className") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "className",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 63
              },
              end: {
                line: 1,
                column: 76
              }
            }
          }) : a)) + '" data-sitekey="' + u((a = null != (a = c(n, "siteKey") || (null != t ? c(t, "siteKey") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "siteKey",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 92
              },
              end: {
                line: 1,
                column: 103
              }
            }
          }) : a)) + '" data-callback="' + u((a = null != (a = c(n, "onCaptchaSolvedCallback") || (null != t ? c(t, "onCaptchaSolvedCallback") : t)) ? a : l, "function" === (0, o.default)(a) ? a.call(s, {
            name: "onCaptchaSolvedCallback",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 120
              },
              end: {
                line: 1,
                column: 147
              }
            }
          }) : a)) + '" data-size="invisible"></div>';
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return null != (i = a(n, "if").call(null != t ? t : e.nullContext || {}, null != t ? a(t, "isCaptchaConfigured") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 184
              }
            }
          })) ? i : "";
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        if (this.captchaConfig) {
          var e = "HCAPTCHA" === this.captchaConfig.type ? "h-captcha" : "g-recaptcha";
          return {
            siteKey: this.captchaConfig.siteKey,
            isCaptchaConfigured: !0,
            onCaptchaSolvedCallback: "OktaSignInWidgetOnCaptchaSolved",
            className: e
          };
        }

        return {};
      },
      initialize: function initialize() {
        this.options.appState.get("captcha") && (this.captchaConfig = this.options.appState.get("captcha"), this._addCaptcha());
      },
      remove: function remove() {
        a.View.prototype.remove.apply(this, arguments), "HCAPTCHA" === this.captchaConfig.type ? window.hcaptcha = void 0 : "RECAPTCHA_V2" === this.captchaConfig.type && (window.grecaptcha = void 0);
      },
      _addCaptcha: function _addCaptcha() {
        var e = this,
            t = function t(_t10) {
          var n = e._getCaptchaOject(),
              r = e.$el.find("#captcha-container").attr("data-captcha-id");

          n.reset(r);
          var o = e.options.name;
          e.model.set(o, _t10), e.options.appState.trigger("saveForm", e.model);
        },
            n = function n() {
          if (!e.$el.find("#captcha-container").attr("data-captcha-id")) {
            var n = e._getCaptchaOject();

            e.model.set(e.options.name, "tempToken");
            var r = n.render("captcha-container", {
              sitekey: e.captchaConfig.siteKey,
              callback: t
            });
            e.$el.find("#captcha-container").attr("data-captcha-id", r), e.options.appState.trigger("onCaptchaLoaded", n), "HCAPTCHA" === e.captchaConfig.type && e._addHCaptchaFooter();
          }
        };

        window.OktaSignInWidgetOnCaptchaLoaded = n, window.OktaSignInWidgetOnCaptchaSolved = t, "HCAPTCHA" === this.captchaConfig.type ? this._loadCaptchaLib(u) : "RECAPTCHA_V2" === this.captchaConfig.type && this._loadCaptchaLib(c);
      },
      _loadCaptchaLib: function _loadCaptchaLib(e) {
        var t = document.createElement("script");
        t.src = e, t.async = !0, t.defer = !0, document.getElementById(s.default.WIDGET_CONTAINER_ID).appendChild(t);
      },
      _addHCaptchaFooter: function _addHCaptchaFooter() {
        var e = document.getElementsByClassName(l.WIDGET_FOOTER_CLASS);

        if (e.length) {
          var t = i.default.template({
            compiler: [8, ">= 4.3.0"],
            main: function main(e, t, n, r, o) {
              var i = e.lookupProperty || function (e, t) {
                if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
              };

              return '<div class="captcha-footer"><span class="footer-text">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                name: "i18n",
                hash: {
                  $2: "<a href='https://hcaptcha.com/terms' target='_blank'>$2</a>",
                  $1: "<a href='https://hcaptcha.com/privacy' target='_blank'>$1</a>",
                  bundle: "login",
                  code: "hcaptcha.footer.label"
                },
                data: o,
                loc: {
                  start: {
                    line: 1,
                    column: 54
                  },
                  end: {
                    line: 1,
                    column: 238
                  }
                }
              })) + "</span></div>";
            },
            useData: !0
          });
          e[0].insertAdjacentHTML("beforeend", t());
        }
      },
      _getCaptchaOject: function _getCaptchaOject() {
        return "HCAPTCHA" === this.captchaConfig.type ? window.hcaptcha : window.grecaptcha;
      }
    });
    t.default = d;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(358)),
        s = r(n(137)),
        l = r(n(363)),
        u = r(n(359)),
        c = n(364),
        d = i.View.extend({
      Header: a.default,
      Body: s.default,
      Footer: u.default,
      className: function className() {
        var e = this.options.appState,
            t = e.get("currentFormName"),
            n = e.get("authenticatorKey"),
            r = e.get("authenticatorMethodType"),
            o = e.get("isPasswordRecoveryFlow");
        return ["siw-main-view"].concat((0, c.getClassNameMapping)(t, n, r, o)).join(" ");
      },
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          return '<div class="siw-main-header"></div><div class="siw-main-body"></div><div class="siw-main-footer"></div>';
        },
        useData: !0
      }),
      preRender: function preRender() {
        i.View.prototype.preRender.apply(this, arguments), null !== this.Header && this.add(this.Header, {
          selector: ".siw-main-header",
          options: this.options
        }), this.renderForm(), this.add(this.Footer, {
          selector: ".siw-main-footer",
          options: this.options
        });
      },
      renderForm: function renderForm() {
        var e,
            t = this;
        this.form && (this.form.remove(), e = this.form.model.toJSON({
          verbose: !0
        }));
        var n = this.createModelClass(this.options.currentViewState, e, this.settings),
            r = new n({
          formName: this.options.currentViewState.name
        });
        e || (e = r.toJSON({
          verbose: !0
        })), this.model = r, this.form = this.add(this.Body, {
          selector: ".siw-main-body",
          options: Object.assign({}, this.options, {
            model: r,
            optionUiSchemaConfig: e
          })
        }).last(), i._.each(r.attributes, function (e, n) {
          n.match(/sub_schema_local_[^ ]+/) && t.listenTo(r, "change:".concat(n), function () {
            t.renderForm();
          });
        });
      },
      createModelClass: function createModelClass(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return l.default.create(e, t);
      }
    });
    t.default = d;
  }, function (e, t, n) {
    "use strict";

    function r() {
      return navigator.userAgent;
    }

    function o(e) {
      return e.match(/windows phone|iemobile|wpdesktop/i);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = n(1),
        a = {
      isMessageFromCorrectSource: function isMessageFromCorrectSource(e, t) {
        return t.source === e[0].contentWindow;
      },
      generateDeviceFingerprint: function generateDeviceFingerprint(e) {
        var t = this;
        return new Promise(function (n, a) {
          function s() {
            f.off(), f.remove(), window.removeEventListener("message", u, !1);
          }

          function l(e) {
            s(), a(e);
          }

          function u(t) {
            if (h.isMessageFromCorrectSource(f, t)) {
              if (clearTimeout(p), !t || !t.data || t.origin !== e.oktaDomainUrl) return void l("no data");

              try {
                var r = JSON.parse(t.data);
                r && "FingerprintServiceReady" === r.type ? c({
                  type: "GetFingerprint"
                }) : r && "FingerprintAvailable" === r.type ? (s(), n(r.fingerprint)) : l("no data");
              } catch (e) {}
            }
          }

          function c(t) {
            var n = f[0].contentWindow;
            n && n.postMessage(JSON.stringify(t), e.oktaDomainUrl);
          }

          var d = r();
          if (!d) return a("user agent is not defined");
          if (o(d)) return a("device fingerprint is not supported on Windows phones");
          var f,
              p,
              h = t;
          window.addEventListener("message", u, !1), f = (0, i.$)("<iframe>", {
            style: "display: none;",
            src: e.oktaDomainUrl + "/auth/services/devicefingerprint"
          }), e.element.append(f), p = setTimeout(function () {
            l("service not available");
          }, 2e3);
        });
      }
    };
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      className: "sign-in-with-idp",
      template: o.default.template({
        1: function _(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="separation-line"><span>' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "socialauth.divider.text"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 64
              },
              end: {
                line: 1,
                column: 118
              }
            }
          })) + "</span></div>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return (null != (i = s(n, "if").call(a, null != t ? s(t, "isSecondaryIdpDisplay") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 138
              }
            }
          })) ? i : "") + '<div class="okta-idps-container"></div>' + (null != (i = s(n, "if").call(a, null != t ? s(t, "isPrimaryIdpDisplay") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 177
              },
              end: {
                line: 1,
                column: 313
              }
            }
          })) ? i : "");
        },
        useData: !0
      }),
      initialize: function initialize() {
        var e = this;
        this.options.idpButtons.forEach(function (t) {
          e.add((0, i.createButton)(t), ".okta-idps-container");
        });
      },
      getTemplateData: function getTemplateData() {
        var e = i.View.prototype.getTemplateData.apply(this, arguments),
            t = this.options.idpButtons.length > 0;
        return Object.assign(e, {
          isPrimaryIdpDisplay: t && this.options.isPrimaryIdpDisplay,
          isSecondaryIdpDisplay: t && !this.options.isPrimaryIdpDisplay
        });
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      className: "custom-buttons",
      template: o.default.template({
        1: function _(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="separation-line"><span>' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "socialauth.divider.text"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 58
              },
              end: {
                line: 1,
                column: 112
              }
            }
          })) + "</span></div>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return (null != (i = a(n, "if").call(null != t ? t : e.nullContext || {}, null != t ? a(t, "addSeparateLine") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 132
              }
            }
          })) ? i : "") + '<div class="okta-custom-buttons-container primary-auth-container"></div>';
        },
        useData: !0
      }),
      initialize: function initialize(e) {
        var t = this;
        e.customButtons.forEach(function (e) {
          t.add((0, i.createButton)(e), ".okta-custom-buttons-container");
        });
      },
      getTemplateData: function getTemplateData() {
        var e = i.View.prototype.getTemplateData.apply(this, arguments);
        return Object.assign(e, {
          addSeparateLine: this.options.addSeparateLine
        });
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(365)),
        i = o.default.extend({
      render: function render() {
        o.default.prototype.render.apply(this, arguments), this.$el.find(".sign-in-with-idp .separation-line").hide(), this.$el.find(".button-primary").hide();
      }
    });
    t.default = i;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = n(3),
        i = o.BaseForm.extend({
      title: function title() {
        return (0, r.loc)("password.reset.title.generic", "login");
      },
      save: function save() {
        return (0, r.loc)("oform.next", "login");
      }
    }),
        a = o.BaseView.extend({
      Body: i,
      Footer: o.BaseFooter
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0),
        o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div data-type="beacon-container" class="beacon-container"><div class="beacon-blank auth-beacon"><div class="beacon-blank js-blank-beacon-border auth-beacon-border"></div></div><div class="bg-helper auth-beacon auth-beacon-factor ' + e.escapeExpression((i = null != (i = a(n, "className") || (null != t ? a(t, "className") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "className",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 230
              },
              end: {
                line: 1,
                column: 243
              }
            }
          }) : i)) + '" data-se="factor-beacon"><div class="okta-sign-in-beacon-border auth-beacon-border"></div></div></div >';
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        return {
          className: this.getBeaconClassName() || ""
        };
      },
      getBeaconClassName: function getBeaconClassName() {
        return "undefined-user";
      }
    });
    e.exports = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = n(3),
        i = o.BaseForm.extend({
      title: function title() {
        var e = (0, r.loc)("oie.success.text.signingIn", "login"),
            t = this.options.appState.get("app"),
            n = this.options.appState.get("user");
        if (r._.isEmpty(t)) return e;
        var o = t.label,
            i = t.name,
            a = n || {},
            s = a.identifier,
            l = o || i;
        return l && s ? e = (0, r.loc)("oie.success.text.signingIn.with.appName.and.identifier", "login", [l, s]) : l && (e = (0, r.loc)("oie.success.text.signingIn.with.appName", "login", [l])), e;
      },
      noButtonBar: !0,
      initialize: function initialize() {
        o.BaseForm.prototype.initialize.apply(this, arguments), this.model.set("useRedirect", !0), this.trigger("save", this.model);
      },
      render: function render() {
        o.BaseForm.prototype.render.apply(this, arguments), this.add('<div class="okta-waiting-spinner"></div>');
      }
    }),
        a = o.BaseView.extend({
      Body: i
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = n(3),
        s = n(46),
        l = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="ion-messages-container"><p>' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              $1: "<span class='strong'>$1</span>",
              arguments: "countDownCounterValue",
              bundle: "login",
              code: "poll.form.message"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 39
              },
              end: {
                line: 1,
                column: 157
              }
            }
          })) + '</p></div><div class="hide okta-waiting-spinner"></div>';
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        return {
          countDownCounterValue: this.options
        };
      }
    }),
        u = a.BaseForm.extend(Object.assign({
      title: function title() {
        return (0, i.loc)("poll.form.title", "login");
      },
      noButtonBar: !0,
      initialize: function initialize() {
        var e = this;
        a.BaseForm.prototype.initialize.apply(this, arguments);
        var t = this.options.appState.getCurrentViewState().refresh;
        this.refreshTimeout = setTimeout(function () {
          e.$el.find(".okta-waiting-spinner").show(), setTimeout(function () {
            return e.saveForm(e.model);
          }, 200);
        }, t);
      },
      render: function render() {
        a.BaseForm.prototype.render.apply(this, arguments), this.countDownCounterValue = Math.ceil(this.options.appState.getCurrentViewState().refresh / s.MS_PER_SEC), this.add(new l(this.countDownCounterValue)), this.startCountDown(".ion-messages-container span", s.MS_PER_SEC);
      },
      remove: function remove() {
        a.BaseForm.prototype.remove.apply(this, arguments), clearTimeout(this.refreshTimeout);
      },
      triggerAfterError: function triggerAfterError() {
        a.BaseForm.prototype.triggerAfterError.apply(this, arguments), clearTimeout(this.refreshTimeout), this.stopCountDown(), this.$el.find(".o-form-fieldset-container").empty();
      },
      startCountDown: function startCountDown(e, t) {
        var n = this;
        this.countDown && clearInterval(this.countDown), this.counterEl = this.$el.find(e), this.countDown = setInterval(function () {
          "0" !== n.counterEl.text() && n.counterEl.text(n.counterEl.text() - 1);
        }, t, this);
      },
      stopCountDown: function stopCountDown() {
        this.countDown && clearInterval(this.countDown);
      }
    })),
        c = a.BaseView.extend({
      Body: u
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(370)),
        i = r(n(787)),
        a = r(n(788)),
        s = r(n(789)),
        l = o.default.extend({
      Header: a.default,
      Footer: i.default,
      postRender: function postRender() {
        var e = this.$el.find(".scope-list"),
            t = new s.default().render().el;
        e.after(t);
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      className: "consent-footer",
      template: o.default.template({
        1: function _(e, t, n, r, o) {
          var i,
              a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a class="terms-of-service" href="' + u((a = null != (a = c(n, "termsOfService") || (null != t ? c(t, "termsOfService") : t)) ? a : l, "function" == typeof a ? a.call(s, {
            name: "termsOfService",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 56
              },
              end: {
                line: 1,
                column: 74
              }
            }
          }) : a)) + '" target="_blank">' + u((c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "consent.required.termsOfService"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 92
              },
              end: {
                line: 1,
                column: 154
              }
            }
          })) + "</a>" + (null != (i = c(n, "if").call(s, null != t ? c(t, "privacyPolicy") : t, {
            name: "if",
            hash: {},
            fn: e.program(2, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 158
              },
              end: {
                line: 1,
                column: 226
              }
            }
          })) ? i : "");
        },
        2: function _(e, t, n, r, o) {
          return '<span class="no-translate">&#8226</span>';
        },
        4: function _(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.hooks.helperMissing,
              l = e.escapeExpression,
              u = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<a class="privacy-policy" href="' + l((i = null != (i = u(n, "privacyPolicy") || (null != t ? u(t, "privacyPolicy") : t)) ? i : s, "function" == typeof i ? i.call(a, {
            name: "privacyPolicy",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 286
              },
              end: {
                line: 1,
                column: 303
              }
            }
          }) : i)) + '" target="_blank">' + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "consent.required.privacyPolicy"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 321
              },
              end: {
                line: 1,
                column: 382
              }
            }
          })) + "</a>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return (null != (i = s(n, "if").call(a, null != t ? s(t, "termsOfService") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 233
              }
            }
          })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "privacyPolicy") : t, {
            name: "if",
            hash: {},
            fn: e.program(4, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 233
              },
              end: {
                line: 1,
                column: 393
              }
            }
          })) ? i : "");
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        var e = this.options.appState,
            t = e.get("app");
        return {
          termsOfService: t.termsOfService && t.termsOfService.href,
          privacyPolicy: t.privacyPolicy && t.privacyPolicy.href
        };
      }
    }),
        s = a;
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(371)),
        a = i.default.extend({
      titleText: function titleText() {
        return (0, o.loc)("oie.consent.enduser.title", "login");
      },
      hasIssuer: !1
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      className: "consent-description detail-row",
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return "<p>" + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "consent.required.description"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 3
              },
              end: {
                line: 1,
                column: 62
              }
            }
          })) + "</p>";
        },
        useData: !0
      })
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = n(3),
        s = r(n(372)),
        l = r(n(7)),
        u = r(n(368)),
        c = o.default.template({
      1: function _(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return '<div class="enduser-email-consent--info no-translate"><i class="enduser-email-consent--icon icon--desktop"></i><div>' + e.escapeExpression((i = null != (i = a(n, "browser") || (null != t ? a(t, "browser") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
          name: "browser",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 131
            },
            end: {
              line: 1,
              column: 142
            }
          }
        }) : i)) + "</div></div>";
      },
      3: function _(e, t, n, r, o) {
        var i,
            a = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return '<div class="enduser-email-consent--info no-translate"><i class="enduser-email-consent--icon icon--app"></i><div>' + e.escapeExpression((i = null != (i = a(n, "app") || (null != t ? a(t, "app") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
          name: "app",
          hash: {},
          data: o,
          loc: {
            start: {
              line: 1,
              column: 284
            },
            end: {
              line: 1,
              column: 291
            }
          }
        }) : i)) + "</div></div>";
      },
      compiler: [8, ">= 4.3.0"],
      main: function main(e, t, n, r, o) {
        var i,
            a = null != t ? t : e.nullContext || {},
            s = e.lookupProperty || function (e, t) {
          if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        };

        return (null != (i = s(n, "if").call(a, null != t ? s(t, "browser") : t, {
          name: "if",
          hash: {},
          fn: e.program(1, o, 0),
          inverse: e.noop,
          data: o,
          loc: {
            start: {
              line: 1,
              column: 0
            },
            end: {
              line: 1,
              column: 161
            }
          }
        })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "app") : t, {
          name: "if",
          hash: {},
          fn: e.program(3, o, 0),
          inverse: e.noop,
          data: o,
          loc: {
            start: {
              line: 1,
              column: 161
            },
            end: {
              line: 1,
              column: 310
            }
          }
        })) ? i : "");
      },
      useData: !0
    }),
        d = s.default.extend({
      title: function title() {
        return (0, i.loc)("oie.consent.enduser.title", "login");
      },
      save: function save() {
        return (0, i.loc)("oie.consent.enduser.accept.label", "login");
      },
      cancel: function cancel() {
        return (0, i.loc)("oie.consent.enduser.deny.label", "login");
      },
      initialize: function initialize() {
        a.BaseForm.prototype.initialize.apply(this, arguments);
        var e = c(this.model.pick("browser", "app"));
        this.add(e);
      },
      getUISchema: function getUISchema() {
        return a.BaseForm.prototype.getUISchema.apply(this, arguments).filter(function (e) {
          return "consent" !== e.name;
        });
      }
    }),
        f = l.default.extend({
      className: "enduser-email-consent",
      Header: u.default,
      buttonOrder: ["cancel", "save"],
      postRender: function postRender() {
        this.$el.find(".o-form-button-bar").find(".button-primary").removeClass("button-primary");
      },
      Body: d,
      createModelClass: function createModelClass(e) {
        var t = e.requestInfo,
            n = l.default.prototype.createModelClass.apply(this, arguments),
            r = t.find(function (e) {
          return "browser" === e.name;
        }),
            o = t.find(function (e) {
          return "appName" === e.name;
        }),
            i = Object.assign({
          browser: {
            type: "string",
            value: null === r || void 0 === r ? void 0 : r.value
          },
          app: {
            type: "string",
            value: null === o || void 0 === o ? void 0 : o.value
          }
        }, n.prototype.local);
        return n.extend({
          local: i,
          toJSON: function toJSON() {
            return {
              consent: this.get("consent")
            };
          }
        });
      }
    });
    t.default = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = n(1),
        i = n(3),
        a = r(n(38)),
        s = r(n(25)),
        l = r(n(5)),
        u = n(46),
        c = r(n(136)),
        d = n(373),
        f = r(n(374)),
        p = n(68),
        h = function h(e) {
      var t = Object.assign({
        method: "GET",
        contentType: "application/json"
      }, e);
      return o.$.ajax(t);
    },
        m = i.BaseFormWithPolling.extend({
      noButtonBar: !0,
      className: "ion-form device-challenge-poll",
      events: {
        "click #launch-ov": function clickLaunchOv(e) {
          e.preventDefault(), this.doCustomURI();
        }
      },
      initialize: function initialize() {
        i.BaseFormWithPolling.prototype.initialize.apply(this, arguments), this.listenTo(this.model, "error", this.onPollingFail), (0, d.doChallenge)(this), this.startPolling();
      },
      onPollingFail: function onPollingFail() {
        this.$(".spinner").hide(), this.stopPolling();
        var e = {
          label: (0, o.loc)("loopback.polling.cancel.link.with.form.error", "login")
        };
        this.options.appState.trigger("updateFooterLink", e);
      },
      remove: function remove() {
        i.BaseForm.prototype.remove.apply(this, arguments), this.stopProbing(), this.stopPolling();
      },
      getDeviceChallengePayload: function getDeviceChallengePayload() {
        return this.options.currentViewState.relatesTo.value;
      },
      doLoopback: function doLoopback(e) {
        var t,
            n = this,
            r = void 0 !== e.domain ? e.domain : "",
            o = void 0 !== e.ports ? e.ports : [],
            i = void 0 !== e.challengeRequest ? e.challengeRequest : "",
            l = void 0 !== e.probeTimeoutMillis ? e.probeTimeoutMillis : 100,
            c = !1,
            d = 0,
            f = function f(e) {
          return "".concat(r, ":").concat(t, "/").concat(e);
        },
            p = function p() {
          return h({
            url: f("probe"),
            timeout: s.default.isAndroid() ? 3e3 : l
          });
        },
            m = function m() {
          return h({
            url: f("challenge"),
            method: "POST",
            data: JSON.stringify({
              challengeRequest: i
            }),
            timeout: 3e3
          });
        },
            g = function g() {
          a.default.error("Something unexpected happened while we were checking port ".concat(t, "."));
        },
            v = function v() {
          ++d === o.length && (a.default.error("No available ports. Loopback server failed and polling is cancelled."), n.options.appState.trigger("invokeAction", u.CANCEL_POLLING_ACTION));
        },
            y = function y() {
          return n.checkPortXhr = p(), n.checkPortXhr.done(function () {
            return n.probingXhr = m(), n.probingXhr.done(function () {
              return c = !0, n.trigger("save", n.model);
            }).fail(function (e) {
              if (a.default.error("OV challenge response with HTTP code ".concat(e.status, " ").concat(e.responseText)), "timeout" === e.statusText) return c = !0, n.trigger("save", n.model);
              v();
            });
          }).fail(g);
        },
            b = Promise.resolve();

        o.forEach(function (e) {
          b = b.then(function () {
            if (!c) return t = e, y();
          }).catch(function () {
            a.default.error("Authenticator is not listening on port ".concat(t, ".")), v();
          });
        });
      },
      doCustomURI: function doCustomURI() {
        this.ulDom && this.ulDom.remove(), this.ulDom = this.add('\n        <iframe src="'.concat(this.customURI, '" id="custom-uri-container" style="display:none;"></iframe>\n      ')).last();
      },
      stopProbing: function stopProbing() {
        this.checkPortXhr && this.checkPortXhr.abort(), this.probingXhr && this.probingXhr.abort();
      }
    }),
        g = i.BaseFooter.extend({
      initialize: function initialize() {
        this.listenTo(this.options.appState, "updateFooterLink", this.handleUpdateFooterLink), this.isFallbackApproach() ? i.BaseFooter.prototype.initialize.apply(this, arguments) : this.add(c.default, {
          options: {
            name: "cancel-authenticator-challenge",
            label: (0, o.loc)("loopback.polling.cancel.link", "login"),
            actionPath: u.CANCEL_POLLING_ACTION
          }
        });
      },
      handleUpdateFooterLink: function handleUpdateFooterLink(e) {
        this.isFallbackApproach() || (this.$el.find(".js-cancel-authenticator-challenge").remove(), this.add(c.default, {
          options: (0, p.getSignOutLink)(this.options.settings, e)[0]
        }));
      },
      isFallbackApproach: function isFallbackApproach() {
        return [l.default.CUSTOM_URI_CHALLENGE, l.default.UNIVERSAL_LINK_CHALLENGE].includes(this.options.currentViewState.relatesTo.value.challengeMethod);
      }
    }),
        v = i.BaseView.extend({
      Header: f.default,
      Body: m,
      Footer: g
    });

    t.default = v;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(3),
        o = n(1),
        i = r.BaseForm.extend({
      noButtonBar: !0,
      className: "ion-form device-challenge-poll",
      title: function title() {
        return (0, o.loc)("deviceTrust.sso.redirectText", "login");
      },
      initialize: function initialize() {
        var e,
            t,
            n = this;
        r.BaseForm.prototype.initialize.apply(this, arguments), this.listenTo(this.model, "error", function () {
          n.$(".spinner").hide();
        }), this.add('<div class="spinner"></div>');
        var o = "get" === (null === (e = this.options.currentViewState) || void 0 === e ? void 0 : null === (t = e.method) || void 0 === t ? void 0 : t.toLowerCase());
        this.model.set("useRedirect", o), this.trigger("save", this.model);
      }
    }),
        a = r.BaseView.extend({
      Body: i
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(366)),
        s = r(n(367)),
        l = i.BaseForm.extend({
      title: function title() {
        return (0, o.loc)("primaryauth.title", "login");
      },
      noButtonBar: !0,
      initialize: function initialize() {
        i.BaseForm.prototype.initialize.apply(this, arguments), this.add(s.default, {
          selector: ".o-form-fieldset-container",
          bubble: !1,
          prepend: !0,
          options: {
            isRequired: !0
          }
        });
      }
    }),
        u = a.default.extend({
      hasBackToSignInLink: !1
    }),
        c = i.BaseView.extend({
      Body: l,
      Footer: u
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(795)),
        s = r(n(796)),
        l = r(n(5)),
        u = r(n(374)),
        c = i.BaseForm.extend({
      noButtonBar: !0,
      className: "device-enrollment-terminal"
    }),
        d = c.extend({
      title: function title() {
        return (0, o.loc)("enroll.title.oda", "login");
      },
      initialize: function initialize() {
        i.BaseForm.prototype.initialize.apply(this, arguments), this.add(a.default);
      }
    }),
        f = c.extend({
      title: function title() {
        return (0, o.loc)("enroll.title.mdm", "login");
      },
      initialize: function initialize() {
        i.BaseForm.prototype.initialize.apply(this, arguments), this.add(s.default);
      }
    }),
        p = i.BaseView.extend({
      initialize: function initialize() {
        i.BaseView.prototype.initialize.apply(this, arguments);
        var e = this.options.appState.get("deviceEnrollment");

        switch (this.enrollmentType = (e.name || "").toLowerCase(), this.enrollmentType) {
          case l.default.ODA:
            this.Header = u.default, this.Body = d;
            break;

          case l.default.MDM:
            this.Body = f;
        }
      }
    });
    t.default = p;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(10)),
        i = r(n(2)),
        a = n(1),
        s = r(n(5)),
        l = a.View.extend({
      template: i.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, i) {
          var a,
              s,
              l = null != t ? t : e.nullContext || {},
              u = e.hooks.helperMissing,
              c = e.escapeExpression,
              d = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<p class="explanation">' + c((d(n, "i18n") || t && d(t, "i18n") || u).call(l, {
            name: "i18n",
            hash: {
              arguments: "appStoreName",
              bundle: "login",
              code: "enroll.explanation.p1"
            },
            data: i,
            loc: {
              start: {
                line: 1,
                column: 23
              },
              end: {
                line: 1,
                column: 100
              }
            }
          })) + '</p><p class="explanation">' + (null != (a = (d(n, "i18n") || t && d(t, "i18n") || u).call(l, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "enroll.explanation.p2"
            },
            data: i,
            loc: {
              start: {
                line: 1,
                column: 127
              },
              end: {
                line: 1,
                column: 181
              }
            }
          })) ? a : "") + '<br><span class="no-translate">' + c((s = null != (s = d(n, "signInUrl") || (null != t ? d(t, "signInUrl") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "signInUrl",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 212
              },
              end: {
                line: 1,
                column: 225
              }
            }
          }) : s)) + '</span></p><div data-se="app-store"><a href="' + c((s = null != (s = d(n, "appStoreLink") || (null != t ? d(t, "appStoreLink") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "appStoreLink",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 270
              },
              end: {
                line: 1,
                column: 286
              }
            }
          }) : s)) + '" target="_blank"><div class="app-store-logo ' + c((s = null != (s = d(n, "appStoreLogoClass") || (null != t ? d(t, "appStoreLogoClass") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "appStoreLogoClass",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 331
              },
              end: {
                line: 1,
                column: 352
              }
            }
          }) : s)) + '"></div></a></div><div class="copy">' + c((s = null != (s = d(n, "copy") || (null != t ? d(t, "copy") : t)) ? s : u, "function" === (0, o.default)(s) ? s.call(l, {
            name: "copy",
            hash: {},
            data: i,
            loc: {
              start: {
                line: 1,
                column: 388
              },
              end: {
                line: 1,
                column: 396
              }
            }
          }) : s)) + "</div>";
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        var e = this.options.appState.get("deviceEnrollment"),
            t = (e.platform || "").toLowerCase(),
            n = {
          signInUrl: e.signInUrl,
          appStoreLogoClass: "".concat(t, "-app-store-logo"),
          copy: (0, a.loc)("enroll.copy.".concat(t), "login")
        };
        return t === s.default.IOS && (n.appStoreName = (0, a.loc)("enroll.appleStore", "login"), n.appStoreLink = s.default.OKTA_VERIFY_APPLE_APP_STORE_URL), t === s.default.ANDROID && (n.appStoreName = (0, a.loc)("enroll.googleStore", "login"), n.appStoreLink = s.default.OKTA_VERIFY_GOOGLE_PLAY_STORE_URL), n;
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.internal.views.components.Notification,
        s = i.internal.util.Clipboard,
        l = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a,
              s = null != t ? t : e.nullContext || {},
              l = e.hooks.helperMissing,
              u = e.escapeExpression,
              c = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return "<div>" + u((c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "enroll.explanation.mdm"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 5
              },
              end: {
                line: 1,
                column: 58
              }
            }
          })) + "</div><ol><li>" + u((c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "enroll.mdm.step1"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 72
              },
              end: {
                line: 1,
                column: 119
              }
            }
          })) + '<a data-clipboard-text="' + u((a = null != (a = c(n, "enrollmentLink") || (null != t ? c(t, "enrollmentLink") : t)) ? a : l, "function" == typeof a ? a.call(s, {
            name: "enrollmentLink",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 143
              },
              end: {
                line: 1,
                column: 161
              }
            }
          }) : a)) + '" class="button link-button copy-clipboard-button">' + u((c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "enroll.mdm.copyLink"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 212
              },
              end: {
                line: 1,
                column: 262
              }
            }
          })) + "</a></li><li>" + u((c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "enroll.mdm.step2"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 275
              },
              end: {
                line: 1,
                column: 322
              }
            }
          })) + "</li><li>" + (null != (i = (c(n, "i18n") || t && c(t, "i18n") || l).call(s, {
            name: "i18n",
            hash: {
              arguments: "vendor",
              bundle: "login",
              code: "enroll.mdm.step3"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 331
              },
              end: {
                line: 1,
                column: 399
              }
            }
          })) ? i : "") + "</li></ol>";
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        return this.options.appState.get("deviceEnrollment");
      },
      postRender: function postRender() {
        var e = this;
        s.attach(".copy-clipboard-button").done(function () {
          var t = new a({
            message: (0, i.loc)("enroll.mdm.copyLink.success", "login"),
            level: "success"
          });
          return e.el.prepend(t.render().el), !1;
        });
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? r(Object(n), !0).forEach(function (t) {
          (0, a.default)(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var i = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = i(n(42)),
        s = n(1),
        l = n(3),
        u = n(8),
        c = l.BaseForm.extend({
      title: function title() {
        return (0, s.loc)("oie.registration.form.title", "login");
      },
      save: function save() {
        return (0, s.loc)("oie.registration.form.submit", "login");
      },
      saveForm: function saveForm() {
        var e = this;
        this.settings.preRegistrationSubmit(this.model.toJSON(), function (t) {
          e.model.attributes = o(o({}, e.model.attributes), e.model.parse(t)), l.BaseForm.prototype.saveForm.call(e, e.model);
        }, function (t) {
          return e.model.trigger("error", e.model, {
            responseJSON: t
          });
        });
      }
    }),
        d = l.BaseFooter.extend({
      links: function links() {
        var e = [];
        return this.options.appState.hasRemediationObject(u.FORMS.SELECT_IDENTIFY) && e.push({
          type: "link",
          label: (0, s.loc)("haveaccount", "login"),
          name: "back",
          actionPath: u.FORMS.SELECT_IDENTIFY
        }), e;
      }
    }),
        f = l.BaseView.extend({
      Body: c,
      Footer: d,
      createModelClass: function createModelClass(e, t, n) {
        var r = this,
            i = l.BaseView.prototype.createModelClass.apply(this, arguments),
            a = JSON.parse(JSON.stringify(e.uiSchema));
        return n.parseRegistrationSchema(a, function (n) {
          s._.isEqual(n, e.uiSchema) || (e.uiSchema = n, i = l.BaseView.prototype.createModelClass.call(r, e, t));
        }, function (e) {
          i = i.extend({
            local: o({
              parseSchemaError: {
                value: e,
                type: "object"
              }
            }, i.prototype.local)
          });
        }), i;
      },
      postRender: function postRender() {
        l.BaseView.prototype.postRender.apply(this, arguments);
        var e = this.model.get("parseSchemaError");
        e && this.model.trigger("error", this.model, {
          responseJSON: e
        });
      }
    });
    t.default = f;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(3),
        o = n(1),
        i = r.BaseForm.extend({
      title: function title() {
        return (0, o.loc)("oie.select.authenticators.enroll.title", "login");
      },
      subtitle: function subtitle() {
        return this.options.settings.get("brandName") ? (0, o.loc)("oie.select.authenticators.enroll.subtitle.custom", "login", [this.options.settings.get("brandName")]) : (0, o.loc)("oie.select.authenticators.enroll.subtitle", "login");
      },
      noButtonBar: !0
    }),
        a = r.BaseView.extend({
      Body: i
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(3),
        o = n(1),
        i = r.BaseForm.extend({
      noButtonBar: !0,
      title: function title() {
        return (0, o.loc)("unlockaccount", "login");
      }
    }),
        a = r.BaseView.extend({
      initialize: function initialize() {
        r.BaseView.prototype.initialize.apply(this, arguments), this.Body = i;
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(369)),
        s = r(n(7)),
        l = n(68),
        u = n(67),
        c = i.BaseForm.extend({
      title: function title() {
        return (0, o.loc)("oie.password.challenge.title", "login");
      },
      save: function save() {
        return (0, o.loc)("mfa.challenge.verify", "login");
      },
      getUISchema: function getUISchema() {
        var e = i.BaseForm.prototype.getUISchema.apply(this, arguments),
            t = this.options.settings,
            n = e.find(function (e) {
          return "credentials.passcode" === e.name;
        });
        return n && (0, u.isCustomizedI18nKey)("primaryauth.password.tooltip", t) && (n.explain = (0, o.loc)("primaryauth.password.tooltip", "login"), n["explain-top"] = !0), e;
      }
    }),
        d = a.default.extend({
      links: function links() {
        var e = a.default.prototype.links.apply(this, arguments);
        return e = (0, l.getForgotPasswordLink)(this.options.appState, this.options.settings).concat(e), e;
      }
    }),
        f = s.default.extend({
      Body: c,
      Footer: d
    });
    t.default = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(138)),
        a = i.default.prototype.Body.extend({
      className: "password-authenticator",
      title: function title() {
        return this.options.settings.get("brandName") ? (0, o.loc)("password.expired.title.specific", "login", [this.options.settings.get("brandName")]) : (0, o.loc)("password.expired.title.generic", "login");
      },
      save: function save() {
        return (0, o.loc)("password.expired.submit", "login");
      },
      getPasswordPolicySettings: function getPasswordPolicySettings() {
        var e, t;
        return (null === (e = this.options.appState.get("recoveryAuthenticator")) || void 0 === e ? void 0 : e.settings) || (null === (t = this.options.appState.get("enrollmentAuthenticator")) || void 0 === t ? void 0 : t.settings);
      }
    }),
        s = i.default.extend({
      Body: a
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(138)),
        s = a.default.prototype.Body.extend({
      className: "password-authenticator",
      subtitle: function subtitle() {
        if (this.options.settings.get("brandName")) return (0, o.loc)("password.expiring.subtitle.specific", "login", [this.options.settings.get("brandName")]);
      },
      title: function title() {
        var e = this.getPasswordPolicySettings() || {},
            t = e.daysToExpiry;
        return t > 0 ? (0, o.loc)("password.expiring.title", "login", [t]) : 0 === t ? (0, o.loc)("password.expiring.today", "login") : (0, o.loc)("password.expiring.soon", "login");
      },
      save: function save() {
        return (0, o.loc)("password.expired.submit", "login");
      },
      showMessages: function showMessages() {
        if (this.options.settings.get("brandName")) return null;
        a.default.prototype.Body.prototype.showMessages.apply(this, arguments);
      }
    }),
        l = i.BaseFooter.extend({
      links: function links() {
        var e = [];
        return this.options.appState.hasRemediationObject("skip") && e.push({
          type: "link",
          label: (0, o.loc)("password.expiring.later", "login"),
          name: "skip",
          actionPath: "skip"
        }), e;
      }
    }),
        u = a.default.extend({
      Body: s,
      Footer: l
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(138)),
        a = i.default.prototype.Body.extend({
      className: "password-authenticator",
      title: function title() {
        return this.options.settings.get("brandName") ? (0, o.loc)("password.reset.title.specific", "login", [this.options.settings.get("brandName")]) : (0, o.loc)("password.reset.title.generic", "login");
      },
      save: function save() {
        return (0, o.loc)("password.reset", "login");
      }
    }),
        s = i.default.extend({
      Body: a
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(805);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(376)),
        a = n(3),
        s = i.ResendView.extend({
      className: "phone-authenticator-enroll--warning hide",
      resendActionKey: "currentAuthenticator-resend"
    }),
        l = i.default.prototype.Body.extend({
      className: "phone-authenticator-enroll",
      title: function title() {
        return (0, o.loc)("oie.phone.enroll.title", "login");
      },
      postRender: function postRender() {
        a.BaseForm.prototype.postRender.apply(this, arguments), this.add(s, {
          selector: ".o-form-error-container",
          prepend: !0
        });
      }
    }),
        u = i.default.extend({
      Body: l
    });
    t.default = u;
  }, function (e, t, n) {
    function r() {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap();
      return r = function r() {
        return e;
      }, e;
    }

    function o(e) {
      if (e && e.__esModule) return e;
      if (null === e || "object" !== i(e) && "function" != typeof e) return {
        default: e
      };
      var t = r();
      if (t && t.has(e)) return t.get(e);
      var n = {},
          o = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var a in e) {
        if (Object.prototype.hasOwnProperty.call(e, a)) {
          var s = o ? Object.getOwnPropertyDescriptor(e, a) : null;
          s && (s.get || s.set) ? Object.defineProperty(n, a, s) : n[a] = e[a];
        }
      }

      return n.default = e, t && t.set(e, n), n;
    }

    var i = n(10);
    e.exports = o;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = r(n(74)),
        l = i.BaseForm.extend({
      className: "phone-authenticator-enroll",
      title: function title() {
        return (0, o.loc)("oie.phone.enroll.title", "login");
      },
      subtitle: function subtitle() {
        return "voice" === this.model.get("authenticator.methodType") ? (0, o.loc)("oie.phone.enroll.call.subtitle", "login") : (0, o.loc)("oie.phone.enroll.sms.subtitle", "login");
      },
      render: function render() {
        i.BaseForm.prototype.render.apply(this, arguments);
        var e = this.model.get("authenticator.methodType"),
            t = this.el.querySelector(".phone-authenticator-enroll__phone"),
            n = this.el.querySelector(".phone-authenticator-enroll__phone-ext");
        "voice" === e && (t.classList.contains("phone-authenticator-enroll__phone--small") || t.classList.add("phone-authenticator-enroll__phone--small"), n.classList.remove("hide")), "sms" === e && (t.classList.remove("phone-authenticator-enroll__phone--small"), n.classList.contains("hide") || n.classList.add("hide")), this.el.querySelector(".phone-authenticator-enroll__phone-code").innerText = "+".concat(this.model.get("phoneCode"));
      },
      handlePhoneCodeChange: function handlePhoneCodeChange() {
        this.el.querySelector(".phone-authenticator-enroll__phone-code").innerText = "+".concat(this.model.get("phoneCode"));
      },
      save: function save() {
        return "voice" === this.model.get("authenticator.methodType") ? (0, o.loc)("oie.phone.call.primaryButton", "login") : (0, o.loc)("oie.phone.sms.primaryButton", "login");
      },
      getUISchema: function getUISchema() {
        var e = i.BaseForm.prototype.getUISchema.apply(this, arguments),
            t = o._.findIndex(e, function (e) {
          return "authenticator.phoneNumber" === e.name;
        }),
            n = {
          "label-top": !0,
          label: (0, o.loc)("country.label", "login"),
          type: "select",
          options: s.default.getCountries(),
          name: "country",
          wide: !0
        },
            r = {
          label: (0, o.loc)("mfa.phoneNumber.placeholder", "login"),
          type: "group",
          modelType: "string",
          "label-top": !0,
          name: "phoneCode",
          className: "phone-authenticator-enroll__phone",
          input: [{
            type: "label",
            label: "+".concat(this.model.get("phoneCode")),
            className: "phone-authenticator-enroll__phone-code no-translate"
          }, Object.assign({}, e[t])]
        },
            a = {
          label: (0, o.loc)("phone.extention.label", "login"),
          type: "text",
          className: "phone-authenticator-enroll__phone-ext hide",
          "label-top": !0,
          name: "extension"
        };

        -1 !== t && (e.splice(t, 1, r), e.splice(t, 0, n), e.splice(t + 2, 0, a));

        var l = o._.find(e, function (e) {
          return "authenticator.methodType" === e.name;
        });

        return l && 1 === l.options.length && (l.className = "hide"), e;
      },
      initialize: function initialize() {
        i.BaseForm.prototype.initialize.apply(this, arguments), this.listenTo(this.model, "change:authenticator.methodType", this.render.bind(this)), this.listenTo(this.model, "change:phoneCode", this.handlePhoneCodeChange.bind(this));
      }
    }),
        u = a.default.extend({
      Body: l,
      createModelClass: function createModelClass() {
        var e = i.BaseView.prototype.createModelClass.apply(this, arguments),
            t = Object.assign({
          country: {
            value: "US",
            type: "string"
          },
          extension: {
            type: "string"
          }
        }, e.prototype.local),
            n = Object.assign({
          phoneCode: {
            deps: ["country"],
            fn: function fn(e) {
              return s.default.getCallingCodeForCountry(e);
            }
          }
        }, e.prototype.derived);
        return e.extend({
          local: t,
          derived: n,
          toJSON: function toJSON() {
            var e = o.Model.prototype.toJSON.call(this, arguments),
                t = this.get("extension"),
                n = this.get("phoneCode"),
                r = "+".concat(n).concat(e.authenticator.phoneNumber);
            return "voice" === e.authenticator.methodType && (null === t || void 0 === t ? void 0 : t.trim().length) && (r = "".concat(r, "x").concat(t)), e.authenticator.phoneNumber = r, e;
          }
        });
      }
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = i.BaseForm.extend({
      className: "phone-authenticator-challenge",
      events: {
        "click a.phone-authenticator-challenge__link": "handleSecondaryLinkClick"
      },
      title: function title() {
        return (0, o.loc)("oie.phone.verify.title", "login");
      },
      save: function save() {
        return "sms" === this.model.get("primaryMode") ? (0, o.loc)("oie.phone.sms.primaryButton", "login") : (0, o.loc)("oie.phone.call.primaryButton", "login");
      },
      handleSecondaryLinkClick: function handleSecondaryLinkClick() {
        var e = this.model.get("secondaryMode");
        this.model.set("authenticator.methodType", e), this.saveForm(this.model);
      },
      initialize: function initialize() {
        var e = this;
        this.model.on("error", function () {
          return e.model.set("authenticator.methodType", e.model.get("primaryMode"));
        }), i.BaseForm.prototype.initialize.apply(this, arguments);
        var t = "sms" === this.model.get("primaryMode") ? (0, o.loc)("oie.phone.verify.sms.sendText", "login") : (0, o.loc)("oie.phone.verify.call.sendText", "login"),
            n = (0, o.loc)("oie.phone.carrier.charges", "login"),
            r = this.model.get("phoneNumber") !== (0, o.loc)("oie.phone.alternate.title", "login") ? "strong no-translate" : "";
        this.add('<div class="okta-form-subtitle" data-se="o-form-explain">'.concat(t, "\n        <span ").concat(r ? 'class="' + r + '"' : "", ">").concat(this.model.escape("phoneNumber"), "</span>\n        <p>").concat(n, "</p>\n      </div>"));
      },
      getUISchema: function getUISchema() {
        return i.BaseForm.prototype.getUISchema.apply(this, arguments).filter(function (e) {
          return "authenticator.methodType" !== e.name;
        });
      },
      render: function render() {
        i.BaseForm.prototype.render.apply(this, arguments);
        var e = this.model.get("secondaryMode");

        if (e) {
          var t = "sms" === e ? (0, o.loc)("oie.phone.sms.secondaryButton", "login") : (0, o.loc)("oie.phone.call.secondaryButton", "login");
          this.add('<a href="#"\n            class="link phone-authenticator-challenge__link"\n            data-se="phone-authenticator-challenge__link">'.concat(t, "</a>"), ".o-form-button-bar");
        }
      }
    }),
        l = a.default.extend({
      Body: s,
      createModelClass: function createModelClass(e) {
        var t = e.uiSchema,
            n = o._.find(t, function (e) {
          return "authenticator.methodType" === e.name;
        }),
            r = n.options,
            a = this.options.currentViewState.relatesTo,
            s = (null === a || void 0 === a ? void 0 : a.value) || {},
            l = s.profile,
            u = i.BaseView.prototype.createModelClass.apply(this, arguments),
            c = Object.assign({
          primaryMode: {
            value: r[0].value,
            type: "string"
          },
          secondaryMode: {
            value: r[1] && r[1].value,
            type: "string"
          },
          phoneNumber: {
            value: (null === l || void 0 === l ? void 0 : l.phoneNumber) ? l.phoneNumber : (0, o.loc)("oie.phone.alternate.title", "login"),
            type: "string"
          }
        }, u.prototype.local);

        return u.extend({
          local: c
        });
      }
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = i.BaseForm.extend({
      title: function title() {
        return (0, o.loc)("oie.security.question.enroll.title", "login");
      },
      save: function save() {
        return (0, o.loc)("mfa.challenge.verify", "login");
      }
    }),
        l = a.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = i.BaseForm.extend({
      title: function title() {
        return (0, o.loc)("oie.security.question.challenge.title", "login");
      },
      save: function save() {
        return (0, o.loc)("mfa.challenge.verify", "login");
      },
      getUISchema: function getUISchema() {
        var e = i.BaseForm.prototype.getUISchema.apply(this, arguments),
            t = e.filter(function (e) {
          return e.name.indexOf("questionKey") >= 0;
        }),
            n = e.filter(function (e) {
          return e.name.indexOf("answer") >= 0;
        });
        return 1 === t.length && 1 === n.length && (n[0].label = t[0].label), e;
      }
    }),
        l = a.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    function r() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = [];
      return e.forEach(function (e) {
        "webauthn" === e.key && t.push({
          type: "public-key",
          id: u.default.strToBin(e.credentialId)
        });
      }), t;
    }

    var o = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var i = n(1),
        a = n(3),
        s = o(n(7)),
        l = o(n(75)),
        u = o(n(116)),
        c = o(n(811)),
        d = n(67),
        f = a.BaseForm.extend({
      title: function title() {
        return (0, i.loc)("oie.enroll.webauthn.title", "login");
      },
      className: "oie-enroll-webauthn",
      modelEvents: {
        error: "_stopEnrollment"
      },
      getUISchema: function getUISchema() {
        var e = this,
            t = [];
        return l.default.isNewApiAvailable() ? (t.push({
          View: c.default
        }), t.push({
          View: (0, i.createButton)({
            className: "webauthn-setup button button-primary button-wide",
            title: (0, i.loc)("oie.enroll.webauthn.save", "login"),
            click: function click() {
              e.triggerWebauthnPrompt();
            }
          })
        })) : t.push({
          View: (0, i.createCallout)({
            className: "webauthn-not-supported",
            type: "error",
            subtitle: (0, i.loc)("oie.webauthn.error.not.supported", "login")
          })
        }), t;
      },
      triggerWebauthnPrompt: function triggerWebauthnPrompt() {
        var e = this;
        this.$el.find(".o-form-error-container").empty(), this._startEnrollment();
        var t = this.options.currentViewState.relatesTo,
            n = null === t || void 0 === t ? void 0 : t.value.contextualData.activationData;

        if (l.default.isNewApiAvailable()) {
          var o = i._.extend({}, n, {
            challenge: u.default.strToBin(n.challenge),
            user: {
              id: u.default.strToBin(n.user.id),
              name: n.user.name,
              displayName: n.user.displayName
            },
            excludeCredentials: r(this.options.appState.get("authenticatorEnrollments").value)
          });

          this.webauthnAbortController = new AbortController(), navigator.credentials.create({
            publicKey: o,
            signal: this.webauthnAbortController.signal
          }).then(function (t) {
            e.model.set({
              credentials: {
                clientData: u.default.binToStr(t.response.clientDataJSON),
                attestation: u.default.binToStr(t.response.attestationObject)
              }
            }), e.saveForm(e.model);
          }).catch(function (t) {
            e.model.trigger("error", e.model, {
              responseJSON: {
                errorSummary: (0, d.getMessageFromBrowserError)(t)
              }
            });
          }).finally(function () {
            e.webauthnAbortController = null;
          });
        }
      },
      _startEnrollment: function _startEnrollment() {
        this.$(".okta-waiting-spinner").show(), this.$(".webauthn-setup").hide();
      },
      _stopEnrollment: function _stopEnrollment() {
        this.$(".okta-waiting-spinner").hide(), this.$(".webauthn-setup").show();
      }
    }),
        p = s.default.extend({
      Body: f,
      postRender: function postRender() {
        s.default.prototype.postRender.apply(this, arguments), this.$el.find('.o-form-button-bar [type="submit"]').remove();
      }
    });
    t.default = p;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(25)),
        s = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<p class="idx-webauthn-enroll-text">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oie.enroll.webauthn.instructions"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 36
              },
              end: {
                line: 1,
                column: 99
              }
            }
          })) + "</p>";
        },
        useData: !0
      }),
      initialize: function initialize() {
        var e = this.options.currentViewState.relatesTo,
            t = null === e || void 0 === e ? void 0 : e.value.contextualData.activationData;
        a.default.isEdge() && this.add(i.View.extend({
          tagName: "p",
          className: "idx-webauthn-enroll-text-edge",
          template: o.default.template({
            compiler: [8, ">= 4.3.0"],
            main: function main(e, t, n, r, o) {
              var i = e.lookupProperty || function (e, t) {
                if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
              };

              return e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                name: "i18n",
                hash: {
                  bundle: "login",
                  code: "oie.enroll.webauthn.instructions.edge"
                },
                data: o,
                loc: {
                  start: {
                    line: 1,
                    column: 0
                  },
                  end: {
                    line: 1,
                    column: 68
                  }
                }
              }));
            },
            useData: !0
          })
        })), "required" === t.authenticatorSelection.userVerification && this.add((0, i.createCallout)({
          className: "uv-required-callout",
          size: "slim",
          type: "warning",
          subtitle: (0, i.loc)("oie.enroll.webauthn.uv.required.instructions", "login")
        })), this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>');
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = r(n(116)),
        l = r(n(75)),
        u = r(n(25)),
        c = r(n(813)),
        d = n(67),
        f = i.BaseForm.extend({
      title: function title() {
        return (0, o.loc)("oie.verify.webauth.title", "login");
      },
      className: "oie-verify-webauthn",
      getUISchema: function getUISchema() {
        var e = this,
            t = [];

        if (l.default.isNewApiAvailable()) {
          var n = (0, o.createButton)({
            className: "retry-webauthn button-primary default-custom-button",
            title: (0, o.loc)("mfa.challenge.verify", "login"),
            click: function click() {
              e.getCredentialsAndSave();
            }
          });
          t.push({
            View: c.default
          }, {
            View: n
          });
        } else t.push({
          View: (0, o.createCallout)({
            className: "webauthn-not-supported",
            type: "error",
            subtitle: (0, o.loc)("oie.webauthn.error.not.supported", "login")
          })
        });

        return t;
      },
      remove: function remove() {
        i.BaseForm.prototype.remove.apply(this, arguments), this.webauthnAbortController && (this.webauthnAbortController.abort(), this.webauthnAbortController = null);
      },
      noButtonBar: !0,
      modelEvents: {
        error: "_stopVerification"
      },
      getCredentialsAndSave: function getCredentialsAndSave() {
        var e = this;
        this.clearErrors(), this._startVerification(), this.webauthnAbortController = new AbortController();
        var t = this.options.currentViewState.relatesTo,
            n = (null === t || void 0 === t ? void 0 : t.value) || {},
            r = [];
        (this.options.appState.get("authenticatorEnrollments").value || []).forEach(function (e) {
          "webauthn" === e.key && r.push({
            type: "public-key",
            id: s.default.strToBin(e.credentialId)
          });
        });
        var o = {
          allowCredentials: r,
          userVerification: n.contextualData.challengeData.userVerification,
          challenge: s.default.strToBin(n.contextualData.challengeData.challenge)
        };
        navigator.credentials.get({
          publicKey: o,
          signal: this.webauthnAbortController.signal
        }).then(function (t) {
          e.model.set({
            credentials: {
              clientData: s.default.binToStr(t.response.clientDataJSON),
              authenticatorData: s.default.binToStr(t.response.authenticatorData),
              signatureData: s.default.binToStr(t.response.signature)
            }
          }), e.saveForm(e.model);
        }, function (t) {
          e.webauthnAbortController && e.model.trigger("error", e.model, {
            responseJSON: {
              errorSummary: (0, d.getMessageFromBrowserError)(t)
            }
          });
        }).finally(function () {
          e.webauthnAbortController = null;
        });
      },
      _startVerification: function _startVerification() {
        this.$(".okta-waiting-spinner").show(), this.$(".retry-webauthn").hide(), this.$(".retry-webauthn")[0].textContent = (0, o.loc)("retry", "login");
      },
      _stopVerification: function _stopVerification() {
        this.$(".okta-waiting-spinner").hide(), this.$(".retry-webauthn").show();
      }
    }),
        p = a.default.extend({
      Body: f,
      postRender: function postRender() {
        a.default.prototype.postRender.apply(this, arguments), l.default.isNewApiAvailable() && !u.default.isSafari() && this.form.getCredentialsAndSave();
      }
    });
    t.default = p;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<p class="idx-webauthn-verify-text">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oie.verify.webauthn.instructions"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 36
              },
              end: {
                line: 1,
                column: 99
              }
            }
          })) + "</p>";
        },
        useData: !0
      }),
      initialize: function initialize() {
        var e = this.options.currentViewState.relatesTo;
        "required" === (null === e || void 0 === e ? void 0 : e.value.contextualData.challengeData).userVerification && this.add((0, i.createCallout)({
          className: "uv-required-callout",
          size: "slim",
          type: "warning",
          subtitle: (0, i.loc)("oie.verify.webauthn.uv.required.instructions", "login")
        })), this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>');
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(377)),
        a = i.default.prototype.Body,
        s = a.extend(Object.assign({
      resendEmailAction: "currentAuthenticator-resend",
      subtitle: function subtitle() {
        return (0, o.loc)("oie.email.enroll.subtitle", "login");
      }
    })),
        l = i.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = {
      title: function title() {
        return (0, r.loc)("oie.email.mfa.title", "login");
      }
    };
    t.default = o;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = r(n(377)),
        s = a.default.prototype.Body,
        l = i.View.extend({
      className: "okta-form-subtitle",
      attributes: {
        "data-se": "o-form-explain"
      },
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oie.email.verify.alternate.sentText"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 66
              }
            }
          }));
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        return {
          email: this.options.email
        };
      }
    }),
        u = s.extend(Object.assign({
      resendEmailAction: "currentAuthenticatorEnrollment-resend",
      initialize: function initialize() {
        var e, t;
        s.prototype.initialize.apply(this, arguments);
        var n = (null === (e = this.options.currentViewState.relatesTo) || void 0 === e ? void 0 : null === (t = e.value) || void 0 === t ? void 0 : t.profile) || {},
            r = n.email;
        this.add(l, {
          prepend: !0,
          selector: ".o-form-error-container",
          options: {
            email: r
          }
        });
      }
    })),
        c = a.default.extend({
      Body: u
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(25)),
        s = r(n(7)),
        l = r(n(109)),
        u = n(8),
        c = r(n(818)),
        d = r(n(378)),
        f = r(n(819)),
        p = i.BaseForm.extend(Object.assign({
      title: function title() {
        var e,
            t = this.options.appState.get("currentAuthenticator").contextualData.selectedChannel;

        switch (t) {
          case "email":
            e = (0, o.loc)("oie.enroll.okta_verify.setup.email.title", "login");
            break;

          case "sms":
            e = (0, o.loc)("oie.enroll.okta_verify.setup.sms.title", "login");
            break;

          default:
            e = (0, o.loc)("oie.enroll.okta_verify.setup.title", "login");
        }

        return e;
      },
      className: "oie-enroll-ov-poll",
      noButtonBar: !0,
      initialize: function initialize() {
        i.BaseForm.prototype.initialize.apply(this, arguments), (a.default.isAndroid() || a.default.isIOS()) & "qrcode" === this.options.appState.get("currentAuthenticator").contextualData.selectedChannel && this.options.appState.trigger("switchForm", u.FORMS.SELECT_ENROLLMENT_CHANNEL), this.listenTo(this.model, "error", this.stopPolling), this.startPolling();
      },
      showMessages: function showMessages() {
        var e = this,
            t = this.options.appState.get("messages");
        t && Array.isArray(t.value) && (this.add('<div class="ion-messages-container"></div>', ".o-form-error-container"), t.value.forEach(function (t) {
          var n = t.message;

          if ("ERROR" === (null === t || void 0 === t ? void 0 : t.class)) {
            var r = {
              content: n,
              type: "error"
            };
            e.options.appState.containsMessageWithI18nKey("oie.authenticator.app.non_fips_compliant_enrollment_device_incompatible") || e.options.appState.containsMessageWithI18nKey("oie.authenticator.app.non_fips_compliant_enrollment_app_update_required") ? r.title = (0, o.loc)("oie.okta_verify.enroll.force.upgrade.title", "login") : e.options.appState.containsMessageWithI18nKey("oie.authenticator.app.method.push.enroll.enable.biometrics") && (r.title = (0, o.loc)("oie.authenticator.app.method.push.enroll.enable.biometrics.title", "login")), e.add((0, o.createCallout)(r), ".o-form-error-container");
          } else e.add("<p>".concat(n, "</p>"), ".ion-messages-container");
        }));
      },
      getUISchema: function getUISchema() {
        var e = [],
            t = this.options.appState.get("currentAuthenticator").contextualData,
            n = t.selectedChannel;
        return e.push({
          View: f.default
        }), e.push({
          View: d.default,
          options: {
            selectedChannel: n
          },
          selector: "qrcode" === n ? ".qrcode-container" : ".switch-channel-content"
        }), ["email", "sms"].includes(n) && e.push({
          View: c.default,
          selector: ".o-form-error-container"
        }), e;
      },
      remove: function remove() {
        i.BaseForm.prototype.remove.apply(this, arguments), this.stopPolling();
      }
    }, l.default)),
        h = s.default.extend({
      Body: p
    });
    t.default = h;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = n(46),
        s = i.View.extend({
      className: "hide resend-ov-link-view",
      events: {
        "click a.resend-link": "handelResendLink"
      },
      initialize: function initialize() {
        var e = this.options.appState.get("currentAuthenticator").contextualData.selectedChannel;
        this.add((0, i.createCallout)({
          content: "email" === e ? o.default.template({
            compiler: [8, ">= 4.3.0"],
            main: function main(e, t, n, r, o) {
              var i,
                  a = e.lookupProperty || function (e, t) {
                if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
              };

              return null != (i = (a(n, "i18n") || t && a(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                name: "i18n",
                hash: {
                  bundle: "login",
                  code: "oie.enroll.okta_verify.email.notReceived"
                },
                data: o,
                loc: {
                  start: {
                    line: 1,
                    column: 0
                  },
                  end: {
                    line: 1,
                    column: 73
                  }
                }
              })) ? i : "";
            },
            useData: !0
          }) : o.default.template({
            compiler: [8, ">= 4.3.0"],
            main: function main(e, t, n, r, o) {
              var i,
                  a = e.lookupProperty || function (e, t) {
                if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
              };

              return null != (i = (a(n, "i18n") || t && a(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
                name: "i18n",
                hash: {
                  bundle: "login",
                  code: "oie.enroll.okta_verify.sms.notReceived"
                },
                data: o,
                loc: {
                  start: {
                    line: 1,
                    column: 0
                  },
                  end: {
                    line: 1,
                    column: 71
                  }
                }
              })) ? i : "";
            },
            useData: !0
          }),
          type: "warning"
        }));
      },
      handelResendLink: function handelResendLink() {
        this.options.appState.trigger("invokeAction", "currentAuthenticator-resend"), this.$el.addClass("hide"), this.showCalloutWithDelay();
      },
      postRender: function postRender() {
        this.showCalloutWithDelay();
      },
      showCalloutWithDelay: function showCalloutWithDelay() {
        var e = this;
        this.showMeTimeout = i._.delay(function () {
          e.$el.removeClass("hide");
        }, a.SHOW_RESEND_TIMEOUT);
      },
      remove: function remove() {
        i.View.prototype.remove.apply(this, arguments), clearTimeout(this.showMeTimeout);
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      template: o.default.template({
        1: function _(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.hooks.helperMissing,
              l = e.escapeExpression,
              u = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<ol class="qrcode-info ov-info"><li>' + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oie.enroll.okta_verify.qrcode.step1"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 48
              },
              end: {
                line: 1,
                column: 114
              }
            }
          })) + "</li><li>" + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oie.enroll.okta_verify.qrcode.step2"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 123
              },
              end: {
                line: 1,
                column: 189
              }
            }
          })) + "</li><li>" + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oie.enroll.okta_verify.qrcode.step3"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 198
              },
              end: {
                line: 1,
                column: 264
              }
            }
          })) + '</li></ol><div class="qrcode-container"><img class="qrcode" src=' + l((i = null != (i = u(n, "href") || (null != t ? u(t, "href") : t)) ? i : s, "function" == typeof i ? i.call(a, {
            name: "href",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 328
              },
              end: {
                line: 1,
                column: 336
              }
            }
          }) : i)) + ' alt="qr code"></img></div>';
        },
        3: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<ul class="email-info ov-info"><li>' + (null != (i = (a(n, "i18n") || t && a(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              arguments: "email",
              bundle: "login",
              code: "oie.enroll.okta_verify.email.info"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 418
              },
              end: {
                line: 1,
                column: 502
              }
            }
          })) ? i : "") + '</li><li class="switch-channel-content"></li></ul>';
        },
        5: function _(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<ul class="sms-info ov-info"><li>' + (null != (i = (a(n, "i18n") || t && a(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              arguments: "phoneNumber",
              bundle: "login",
              code: "oie.enroll.okta_verify.sms.info"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 611
              },
              end: {
                line: 1,
                column: 699
              }
            }
          })) ? i : "") + '</li><li class="switch-channel-content"></li></ul>';
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return (null != (i = s(n, "if").call(a, null != t ? s(t, "href") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 370
              }
            }
          })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "email") : t, {
            name: "if",
            hash: {},
            fn: e.program(3, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 370
              },
              end: {
                line: 1,
                column: 559
              }
            }
          })) ? i : "") + (null != (i = s(n, "if").call(a, null != t ? s(t, "phoneNumber") : t, {
            name: "if",
            hash: {},
            fn: e.program(5, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 559
              },
              end: {
                line: 1,
                column: 756
              }
            }
          })) ? i : "");
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        var e,
            t = this.options.appState.get("currentAuthenticator").contextualData;
        return {
          href: null === (e = t.qrcode) || void 0 === e ? void 0 : e.href,
          email: i._.escape(null === t || void 0 === t ? void 0 : t.email),
          phoneNumber: i._.escape(null === t || void 0 === t ? void 0 : t.phoneNumber)
        };
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(119)),
        i = n(1),
        a = n(3),
        s = r(n(7)),
        l = r(n(25)),
        u = a.BaseForm.extend({
      title: function title() {
        return l.default.isAndroid() || l.default.isIOS() ? (0, i.loc)("oie.enroll.okta_verify.setup.title", "login") : (0, i.loc)("oie.enroll.okta_verify.select.channel.title", "login");
      },
      getUISchema: function getUISchema() {
        var e,
            t = this,
            n = a.BaseForm.prototype.getUISchema.apply(this, arguments),
            r = i._.find(n, function (e) {
          return "authenticator.channel" === e.name;
        });

        return r.options = i._.filter(null === r || void 0 === r ? void 0 : r.options, function (e) {
          var n, r;
          return e.value !== (null === (n = t.options.appState.get("currentAuthenticator")) || void 0 === n ? void 0 : null === (r = n.contextualData) || void 0 === r ? void 0 : r.selectedChannel);
        }), r.value = null === (e = r.options[0]) || void 0 === e ? void 0 : e.value, [{
          View: (0, i.loc)("oie.enroll.okta_verify.select.channel.description", "login"),
          selector: ".o-form-fieldset-container"
        }].concat((0, o.default)(n));
      }
    }),
        c = s.default.extend({
      Body: u
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = r(n(74)),
        l = r(n(378)),
        u = i.BaseForm.extend({
      className: "oie-enroll-ov-data",
      title: function title() {
        return "email" === this.options.appState.get("currentAuthenticator").contextualData.selectedChannel ? (0, o.loc)("oie.enroll.okta_verify.enroll.channel.email.title", "login") : (0, o.loc)("oie.enroll.okta_verify.enroll.channel.sms.title", "login");
      },
      save: function save() {
        return (0, o.loc)("oie.enroll.okta_verify.setupLink", "login");
      },
      getUISchema: function getUISchema() {
        var e = i.BaseForm.prototype.getUISchema.apply(this, arguments),
            t = o._.find(e, function (e) {
          return "phoneNumber" === e.name;
        }),
            n = o._.findIndex(e, function (e) {
          return "phoneNumber" === e.name;
        }),
            r = {
          "label-top": !0,
          label: (0, o.loc)("country.label", "login"),
          type: "select",
          options: s.default.getCountries(),
          name: "country",
          wide: !0
        },
            a = {
          label: (0, o.loc)("mfa.phoneNumber.placeholder", "login"),
          type: "group",
          modelType: "string",
          "label-top": !0,
          name: "phoneCode",
          input: [{
            type: "label",
            label: "+".concat(this.model.get("phoneCode")),
            className: "country-code-label no-translate"
          }, Object.assign({}, t)]
        };

        -1 !== n && e.splice(n, 1, r, a);
        var l = {
          View: "email" === this.options.appState.get("currentAuthenticator").contextualData.selectedChannel ? (0, o.loc)("oie.enroll.okta_verify.channel.email.description", "login") : (0, o.loc)("oie.enroll.okta_verify.channel.sms.description", "login"),
          selector: ".o-form-fieldset-container"
        };
        return e.push(l), e;
      },
      handlePhoneCodeChange: function handlePhoneCodeChange() {
        this.el.querySelector(".country-code-label").innerText = "+".concat(this.model.get("phoneCode"));
      },
      initialize: function initialize() {
        i.BaseForm.prototype.initialize.apply(this, arguments), "sms" === this.options.appState.get("currentAuthenticator").contextualData.selectedChannel && this.listenTo(this.model, "change:phoneCode", this.handlePhoneCodeChange.bind(this));
      }
    }),
        c = a.default.extend({
      Body: u,
      createModelClass: function createModelClass() {
        var e = i.BaseView.prototype.createModelClass.apply(this, arguments);
        if ("sms" !== this.options.appState.get("currentAuthenticator").contextualData.selectedChannel) return e;
        var t = Object.assign({
          country: {
            value: "US",
            type: "string"
          }
        }, e.prototype.local),
            n = Object.assign({
          phoneCode: {
            deps: ["country"],
            fn: function fn(e) {
              return s.default.getCallingCodeForCountry(e);
            }
          }
        }, e.prototype.derived);
        return e.extend({
          local: t,
          derived: n,
          toJSON: function toJSON() {
            var e = o.Model.prototype.toJSON.call(this, arguments),
                t = this.get("phoneCode"),
                n = "+".concat(t).concat(e.phoneNumber);
            return e.phoneNumber = n, e;
          }
        });
      },
      postRender: function postRender() {
        this.add(l.default, "form");
      }
    });
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(7)),
        i = r(n(823)),
        a = r(n(824)),
        s = r(n(825)),
        l = n(8),
        u = o.default.extend({
      initialize: function initialize() {
        var e, t, n;
        o.default.prototype.initialize.apply(this, arguments);
        var r = null === (e = this.options) || void 0 === e ? void 0 : null === (t = e.appState) || void 0 === t ? void 0 : t.get("currentAuthenticator"),
            u = null === r || void 0 === r ? void 0 : r.methods[0];
        (null === u || void 0 === u ? void 0 : u.type) === l.AUTHENTICATOR_METHODS.PUSH && (null === r || void 0 === r ? void 0 : null === (n = r.contextualData) || void 0 === n ? void 0 : n.correctAnswer) ? this.Body = s.default : (null === u || void 0 === u ? void 0 : u.type) === l.AUTHENTICATOR_METHODS.PUSH ? this.Body = i.default : this.Body = a.default;
      }
    });
    t.default = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = n(3),
        s = r(n(109)),
        l = n(46),
        u = i.View.extend({
      className: "okta-form-infobox-warning infobox infobox-warning",
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<span class="icon warning-16"></span><p>' + e.escapeExpression((i = null != (i = a(n, "warning") || (null != t ? a(t, "warning") : t)) ? i : e.hooks.helperMissing, "function" == typeof i ? i.call(null != t ? t : e.nullContext || {}, {
            name: "warning",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 40
              },
              end: {
                line: 1,
                column: 51
              }
            }
          }) : i)) + "</p>";
        },
        useData: !0
      })
    }),
        c = a.BaseForm.extend(Object.assign({
      noButtonBar: !0,
      className: "okta-verify-push-challenge",
      title: function title() {
        return (0, i.loc)("oie.okta_verify.push.title", "login");
      },
      initialize: function initialize() {
        a.BaseForm.prototype.initialize.apply(this, arguments), this.listenTo(this.model, "error", this.stopPoll), this.addView();
      },
      addView: function addView() {
        this.add((0, i.createButton)({
          className: "button button-wide button-primary send-push link-button-disabled",
          title: (0, i.loc)("oie.okta_verify.push.sent", "login"),
          click: function click(e) {
            e.preventDefault();
          }
        })), this.add("<span class='accessibility-text' role='alert'>".concat((0, i.loc)("oie.okta_verify.push.sent", "login"), "</span>"));
      },
      postRender: function postRender() {
        this.startPoll();
      },
      startPoll: function startPoll() {
        this.startPolling(), this.warningTimeout = setTimeout(i._.bind(function () {
          this.showWarning((0, i.loc)("oktaverify.warning", "login"));
        }, this), l.WARNING_TIMEOUT);
      },
      stopPoll: function stopPoll() {
        this.stopPolling(), this.clearWarning();
      },
      showWarning: function showWarning(e) {
        this.clearWarning(), this.add(u, ".o-form-error-container", {
          options: {
            warning: e
          }
        });
      },
      clearWarning: function clearWarning() {
        this.$(".o-form-error-container div").hasClass("okta-form-infobox-warning") && this.$(".okta-form-infobox-warning").remove(), clearTimeout(this.warningTimeout);
      },
      remove: function remove() {
        a.BaseForm.prototype.remove.apply(this, arguments), this.stopPolling();
      }
    }, s.default)),
        d = c;
    t.default = d;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = n(1),
        i = n(3),
        a = r(n(38)),
        s = r(n(25)),
        l = r(n(109)),
        u = n(373),
        c = function c(e) {
      var t = Object.assign({
        method: "GET",
        contentType: "application/json"
      }, e);
      return o.$.ajax(t);
    },
        d = i.BaseForm.extend(Object.assign({
      noButtonBar: !0,
      className: "ion-form device-challenge-poll",
      events: {
        "click #launch-ov": function clickLaunchOv(e) {
          e.preventDefault(), this.doCustomURI();
        }
      },
      initialize: function initialize() {
        i.BaseForm.prototype.initialize.apply(this, arguments), this.listenTo(this.model, "error", this.onPollingFail), (0, u.doChallenge)(this), this.startPolling();
      },
      onPollingFail: function onPollingFail() {
        this.$(".spinner").hide(), this.stopPolling();
      },
      remove: function remove() {
        i.BaseForm.prototype.remove.apply(this, arguments), this.stopPolling();
      },
      getDeviceChallengePayload: function getDeviceChallengePayload() {
        return this.options.currentViewState.relatesTo.value.contextualData.challenge.value;
      },
      doLoopback: function doLoopback(e) {
        var t,
            n = this,
            r = void 0 !== e.domain ? e.domain : "",
            o = void 0 !== e.ports ? e.ports : [],
            i = void 0 !== e.challengeRequest ? e.challengeRequest : "",
            l = void 0 !== e.probeTimeoutMillis ? e.probeTimeoutMillis : 100,
            u = !1,
            d = 0,
            f = function f(e) {
          return "".concat(r, ":").concat(t, "/").concat(e);
        },
            p = function p() {
          return c({
            url: f("probe"),
            timeout: s.default.isAndroid() ? 3e3 : l
          });
        },
            h = function h() {
          return u = !0, c({
            url: f("challenge"),
            method: "POST",
            data: JSON.stringify({
              challengeRequest: i
            }),
            timeout: 3e3
          });
        },
            m = function m() {
          a.default.error("Something unexpected happened while we were checking port ".concat(t, "."));
        },
            g = function g() {
          return p().done(h).fail(m);
        },
            v = Promise.resolve();

        o.forEach(function (e) {
          v = v.then(function () {
            if (!u) return t = e, g();
          }).catch(function () {
            d++, a.default.error("Authenticator is not listening on port ".concat(t, ".")), d === o.length && (a.default.error("No available ports. Loopback server failed and polling is cancelled."), n.options.appState.trigger("invokeAction", "currentAuthenticator-cancel"));
          });
        });
      },
      doCustomURI: function doCustomURI() {
        this.ulDom && this.ulDom.remove(), this.ulDom = this.add('\n        <iframe src="'.concat(this.customURI, '" id="custom-uri-container" style="display:none;"></iframe>\n      ')).last();
      }
    }, l.default)),
        f = d;

    t.default = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(109)),
        s = r(n(826)),
        l = r(n(827)),
        u = i.BaseForm.extend(Object.assign({
      noButtonBar: !0,
      className: "okta-verify-number-challenge",
      events: {
        "click a.resend-number-challenge": "handleResendNumberChallenge"
      },
      handleResendNumberChallenge: function handleResendNumberChallenge() {
        this.options.appState.trigger("invokeAction", "currentAuthenticator-resend"), this.options.appState.trigger("hideNumberChallengeWarning");
      },
      title: function title() {
        return (0, o.loc)("oie.okta_verify.push.sent", "login");
      },
      initialize: function initialize() {
        i.BaseForm.prototype.initialize.apply(this, arguments), this.add(l.default);
      },
      triggerAfterError: function triggerAfterError() {
        i.BaseForm.prototype.triggerAfterError.apply(this, arguments), this.stopPolling(), this.$el.find(".o-form-fieldset-container").empty();
      },
      postRender: function postRender() {
        this.startPoll();
      },
      startPoll: function startPoll() {
        this.startPolling(), this.addWarning();
      },
      stopPoll: function stopPoll() {
        this.stopPolling();
      },
      addWarning: function addWarning() {
        this.add(s.default, ".o-form-error-container"), this.options.appState.trigger("showNumberChallengeWarning");
      },
      remove: function remove() {
        i.BaseForm.prototype.remove.apply(this, arguments), this.stopPolling();
      }
    }, a.default)),
        c = u;
    t.default = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = n(46),
        s = i.View.extend({
      initialize: function initialize() {
        var e = this;
        this.listenTo(this.options.appState, "showNumberChallengeWarning", function () {
          e.startWarningTimeout();
        }), this.listenTo(this.options.appState, "hideNumberChallengeWarning", function () {
          e.clearWarning();
        });
      },
      className: "resend-number-challenge-warning hide",
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="okta-form-infobox-warning infobox infobox-warning"><span class="icon warning-16"></span><p>' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
            name: "i18n",
            hash: {
              $1: "<a href='#' class='resend-number-challenge'>$1</a>",
              bundle: "login",
              code: "oie.numberchallenge.warning"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 103
              },
              end: {
                line: 1,
                column: 217
              }
            }
          })) + "</p></div>";
        },
        useData: !0
      }),
      showWarning: function showWarning() {
        this.$el.removeClass("hide");
      },
      clearWarning: function clearWarning() {
        this.$el.addClass("hide"), clearTimeout(this.warningTimeout), this.startWarningTimeout();
      },
      startWarningTimeout: function startWarningTimeout() {
        this.warningTimeout = setTimeout(i._.bind(function () {
          this.showWarning();
        }, this), a.WARNING_TIMEOUT);
      }
    }),
        l = s;
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      className: "number-challenge-section",
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.hooks.helperMissing,
              l = e.escapeExpression,
              u = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return "<p>" + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
            name: "i18n",
            hash: {
              $1: "<span class='strong'>$1</span>",
              arguments: "correctAnswer",
              bundle: "login",
              code: "oie.numberchallenge.instruction"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 3
              },
              end: {
                line: 1,
                column: 127
              }
            }
          })) + '</p><div class="phone no-translate"><div class="phone--body"><div class="phone--screen"><span class="phone--number" data-se="challenge-number">' + l((i = null != (i = u(n, "correctAnswer") || (null != t ? u(t, "correctAnswer") : t)) ? i : s, "function" == typeof i ? i.call(a, {
            name: "correctAnswer",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 270
              },
              end: {
                line: 1,
                column: 287
              }
            }
          }) : i)) + '</span></div><div class="phone--home-button"></div></div></div>';
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        var e, t;
        return {
          correctAnswer: null === (e = this.options.appState.get("currentAuthenticator")) || void 0 === e ? void 0 : null === (t = e.contextualData) || void 0 === t ? void 0 : t.correctAnswer
        };
      }
    }),
        s = a;
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = i.BaseForm.extend(Object.assign({
      className: "okta-verify-totp-challenge",
      title: function title() {
        return (0, o.loc)("oie.okta_verify.totp.title", "login");
      },
      save: function save() {
        return (0, o.loc)("mfa.challenge.verify", "login");
      }
    })),
        l = a.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = i.BaseForm.extend(Object.assign({
      className: "okta-verify-resend-push",
      title: function title() {
        return (0, o.loc)("oie.okta_verify.push.title", "login");
      },
      save: function save() {
        return (0, o.loc)("oie.okta_verify.push.resend", "login");
      },
      showMessages: function showMessages() {
        var e = this,
            t = this.options.appState.get("messages");
        t && Array.isArray(t.value) && (this.add('<div class="ion-messages-container"></div>', ".o-form-error-container"), t.value.forEach(function (t) {
          var n = t.message;

          if ("ERROR" === (null === t || void 0 === t ? void 0 : t.class)) {
            var r = {
              content: n,
              type: "error"
            };
            e.options.appState.containsMessageWithI18nKey("oie.authenticator.app.method.push.force.upgrade.number_challenge") ? r.title = (0, o.loc)("oie.numberchallenge.force.upgrade.title", "login") : e.options.appState.containsMessageWithI18nKey("oie.authenticator.app.method.push.verify.enable.biometrics") && (r.content = null, r.className = "okta-verify-uv-callout-content", r.title = (0, o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.title", "login"), r.subtitle = (0, o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.description", "login"), r.bullets = [(0, o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.point1", "login"), (0, o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.point2", "login"), (0, o.loc)("oie.authenticator.app.method.push.verify.enable.biometrics.point3", "login")]), e.add((0, o.createCallout)(r), ".o-form-error-container");
          } else e.add("<p>".concat(n, "</p>"), ".ion-messages-container");
        }));
      }
    })),
        l = a.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = r(n(361)),
        l = n(108),
        u = n(375),
        c = n(8),
        d = u.Body.extend({
      getUISchema: function getUISchema() {
        var e = i.BaseForm.prototype.getUISchema.apply(this, arguments),
            t = e.find(function (e) {
          return "authenticator.methodType" === e.name;
        });

        this._sortMethodOptionsIfDeviceKnown(t.options);

        var n = t.options.map(function (e) {
          return Object.assign({}, e, (0, l.getAuthenticatorDataForVerification)({
            authenticatorKey: c.AUTHENTICATOR_KEY.OV
          }));
        });
        return [{
          View: s.default,
          options: {
            name: t.name,
            collection: new o.Collection(n)
          }
        }];
      },
      _sortMethodOptionsIfDeviceKnown: function _sortMethodOptionsIfDeviceKnown(e) {
        var t, n, r, o;

        if (null === (t = this.options) || void 0 === t ? void 0 : null === (n = t.currentViewState) || void 0 === n ? void 0 : null === (r = n.relatesTo) || void 0 === r ? void 0 : null === (o = r.value) || void 0 === o ? void 0 : o.deviceKnown) {
          var i = e.findIndex(function (e) {
            return "signed_nonce" === e.value;
          });

          if (i > 0) {
            var a = e[i];
            e.splice(i, 1), e.unshift(a);
          }
        }
      }
    }),
        f = a.default.extend({
      Body: d,
      Footer: i.BaseFooter
    });
    t.default = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(7)),
        i = n(3),
        a = n(1),
        s = i.BaseForm.extend({
      noButtonBar: !0,
      className: "ion-form device-challenge-poll",
      title: function title() {
        return (0, a.loc)("deviceTrust.sso.redirectText", "login");
      },
      initialize: function initialize() {
        var e,
            t,
            n = this;
        i.BaseForm.prototype.initialize.apply(this, arguments), this.listenTo(this.model, "error", function () {
          n.$(".spinner").hide();
        }), this.add('<div class="credential-sso-extension"><div class="spinner"></div></div>');
        var r = "get" === (null === (e = this.options.currentViewState) || void 0 === e ? void 0 : null === (t = e.method) || void 0 === t ? void 0 : t.toLowerCase());
        this.model.set("useRedirect", r), this.trigger("save", this.model);
      }
    }),
        l = o.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = n(3),
        s = r(n(7)),
        l = r(n(833)),
        u = r(n(834)),
        c = {
      BARCODE: "barcode",
      MANUAL: "manual",
      ENTER_CODE: "enterCode"
    },
        d = a.BaseForm.extend({
      title: function title() {
        return (0, i.loc)("oie.enroll.google_authenticator.setup.title", "login");
      },
      noButtonBar: !0,
      className: "oie-enroll-google-authenticator",
      enterCodeSubtitle: i.View.extend({
        template: o.default.template({
          compiler: [8, ">= 4.3.0"],
          main: function main(e, t, n, r, o) {
            var i = e.lookupProperty || function (e, t) {
              if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
            };

            return '<div class="google-authenticator-setup-info-title enter-code-title">' + e.escapeExpression((i(n, "i18n") || t && i(t, "i18n") || e.hooks.helperMissing).call(null != t ? t : e.nullContext || {}, {
              name: "i18n",
              hash: {
                bundle: "login",
                code: "oie.enroll.google_authenticator.enterCode.title"
              },
              data: o,
              loc: {
                start: {
                  line: 1,
                  column: 68
                },
                end: {
                  line: 1,
                  column: 146
                }
              }
            })) + "</div>";
          },
          useData: !0
        })
      }),
      getUISchema: function getUISchema() {
        var e = this,
            t = a.BaseForm.prototype.getUISchema.apply(this, arguments),
            n = (0, a.addCustomButton)({
          className: "google-authenticator-next",
          title: (0, i.loc)("oform.next", "login"),
          attributes: {
            style: "display: block"
          },
          click: function click() {
            e.model.set("viewToDisplay", c.ENTER_CODE);
          }
        }),
            r = (0, a.addCustomButton)({
          className: "google-authenticator-verify",
          title: (0, i.loc)("oform.verify", "login"),
          click: function click() {
            e.$el.submit();
          }
        });
        return t[0].showWhen = {
          viewToDisplay: c.ENTER_CODE
        }, t.unshift({
          View: this.enterCodeSubtitle,
          selector: ".o-form-fieldset-container",
          showWhen: {
            viewToDisplay: c.ENTER_CODE
          }
        }), t.push({
          View: l.default,
          selector: ".o-form-fieldset-container",
          showWhen: {
            viewToDisplay: c.BARCODE
          }
        }, {
          View: u.default,
          selector: ".o-form-fieldset-container",
          showWhen: {
            viewToDisplay: c.MANUAL
          }
        }, {
          label: !1,
          className: "shared-secret",
          type: "text",
          placeholder: this.options.appState.get("currentAuthenticator").contextualData.sharedSecret,
          disabled: !0,
          showWhen: {
            viewToDisplay: c.MANUAL
          }
        }, {
          View: n,
          showWhen: {
            viewToDisplay: function viewToDisplay(e) {
              return e === c.BARCODE || e === c.MANUAL;
            }
          }
        }, {
          View: r,
          showWhen: {
            viewToDisplay: function viewToDisplay(e) {
              return e === c.ENTER_CODE;
            }
          }
        }), t;
      }
    }),
        f = s.default.extend({
      Body: d,
      createModelClass: function createModelClass() {
        var e = a.BaseView.prototype.createModelClass.apply(this, arguments),
            t = Object.assign({
          viewToDisplay: {
            value: "barcode",
            type: "string",
            required: !0,
            values: [c.BARCODE, c.MANUAL, c.ENTER_CODE]
          }
        }, e.prototype.local);
        return e.extend({
          local: t
        });
      }
    });
    t.default = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      className: "oie-enroll-google-authenticator-barcode",
      template: o.default.template({
        1: function _(e, t, n, r, o) {
          var i,
              a = null != t ? t : e.nullContext || {},
              s = e.hooks.helperMissing,
              l = e.escapeExpression,
              u = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="google-authenticator-setup-info-title barcode-setup-title">' + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oie.enroll.google_authenticator.scanBarcode.title"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 83
              },
              end: {
                line: 1,
                column: 163
              }
            }
          })) + '</div><div class="qrcode-info-container"><p class="google-authenticator-setup-info">' + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oie.enroll.google_authenticator.scanBarcode.description"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 247
              },
              end: {
                line: 1,
                column: 333
              }
            }
          })) + '</p><div class="qrcode-container"><img class="qrcode" src=' + l((i = null != (i = u(n, "href") || (null != t ? u(t, "href") : t)) ? i : s, "function" == typeof i ? i.call(a, {
            name: "href",
            hash: {},
            data: o,
            loc: {
              start: {
                line: 1,
                column: 391
              },
              end: {
                line: 1,
                column: 399
              }
            }
          }) : i)) + ' alt="qr code"></img><a href="#" class="cannot-scan-link">' + l((u(n, "i18n") || t && u(t, "i18n") || s).call(a, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oie.enroll.google_authenticator.scanBarcode.cannotScan"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 457
              },
              end: {
                line: 1,
                column: 542
              }
            }
          })) + "</a></div></div>";
        },
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i,
              a = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return null != (i = a(n, "if").call(null != t ? t : e.nullContext || {}, null != t ? a(t, "href") : t, {
            name: "if",
            hash: {},
            fn: e.program(1, o, 0),
            inverse: e.noop,
            data: o,
            loc: {
              start: {
                line: 1,
                column: 0
              },
              end: {
                line: 1,
                column: 565
              }
            }
          })) ? i : "";
        },
        useData: !0
      }),
      getTemplateData: function getTemplateData() {
        var e;
        return {
          href: null === (e = this.options.appState.get("currentAuthenticator").contextualData.qrcode) || void 0 === e ? void 0 : e.href
        };
      },
      events: {
        "click .cannot-scan-link": function clickCannotScanLink(e) {
          e.preventDefault(), this.options.model.set("viewToDisplay", "manual");
        }
      }
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(2)),
        i = n(1),
        a = i.View.extend({
      className: "oie-enroll-google-authenticator-manual-setup",
      template: o.default.template({
        compiler: [8, ">= 4.3.0"],
        main: function main(e, t, n, r, o) {
          var i = null != t ? t : e.nullContext || {},
              a = e.hooks.helperMissing,
              s = e.escapeExpression,
              l = e.lookupProperty || function (e, t) {
            if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
          };

          return '<div class="google-authenticator-setup-info-title manual-setup-title">' + s((l(n, "i18n") || t && l(t, "i18n") || a).call(i, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oie.enroll.google_authenticator.cannotScanBarcode.title"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 70
              },
              end: {
                line: 1,
                column: 156
              }
            }
          })) + '</div><p class="google-authenticator-setup-info">' + s((l(n, "i18n") || t && l(t, "i18n") || a).call(i, {
            name: "i18n",
            hash: {
              bundle: "login",
              code: "oie.enroll.google_authenticator.manualSetupInstructions"
            },
            data: o,
            loc: {
              start: {
                line: 1,
                column: 205
              },
              end: {
                line: 1,
                column: 291
              }
            }
          })) + "</p>";
        },
        useData: !0
      })
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = i.BaseForm.extend(Object.assign({
      className: "google-authenticator-challenge",
      title: function title() {
        return (0, o.loc)("oie.verify.google_authenticator.otp.title", "login");
      },
      subtitle: function subtitle() {
        return (0, o.loc)("oie.verify.google_authenticator.otp.description", "login");
      },
      save: function save() {
        return (0, o.loc)("mfa.challenge.verify", "login");
      }
    })),
        l = a.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = i.BaseForm.extend({
      className: "on-prem-authenticator-enroll",
      modelEvents: {
        error: "_checkTokenChange"
      },
      title: function title() {
        var e = this.options.appState.getAuthenticatorDisplayName() || (0, o.loc)("oie.on_prem.authenticator.default.vendorName", "login");
        return (0, o.loc)("oie.on_prem.enroll.title", "login", [e]);
      },
      _checkTokenChange: function _checkTokenChange(e, t) {
        var n,
            r = null === t || void 0 === t ? void 0 : null === (n = t.responseJSON) || void 0 === n ? void 0 : n.errorSummaryKeys;
        r && r.includes("errors.E0000113") && (this.model.set("credentials.passcode", ""), this.render());
      },
      save: function save() {
        return (0, o.loc)("mfa.challenge.verify", "login");
      }
    }),
        l = a.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = i.BaseForm.extend({
      className: "on-prem-authenticator-verify",
      modelEvents: {
        error: "_checkTokenChange"
      },
      title: function title() {
        var e = this.options.appState.getAuthenticatorDisplayName() || (0, o.loc)("oie.on_prem.authenticator.default.vendorName", "login");
        return (0, o.loc)("oie.on_prem.verify.title", "login", [e]);
      },
      _checkTokenChange: function _checkTokenChange(e, t) {
        var n,
            r = null === t || void 0 === t ? void 0 : null === (n = t.responseJSON) || void 0 === n ? void 0 : n.errorSummaryKeys;
        r && r.includes("errors.E0000113") && (this.model.set("credentials.passcode", ""), this.render());
      },
      save: function save() {
        return (0, o.loc)("mfa.challenge.verify", "login");
      }
    }),
        l = a.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(379)),
        a = r(n(7)),
        s = i.default.extend({
      title: function title() {
        return (0, o.loc)("oie.duo.enroll.title", "login");
      },
      getContextualData: function getContextualData() {
        return this.options.appState.get("currentAuthenticator").contextualData;
      }
    }),
        l = a.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(379)),
        a = r(n(7)),
        s = i.default.extend({
      title: function title() {
        return (0, o.loc)("oie.duo.verify.title", "login");
      },
      getContextualData: function getContextualData() {
        return this.options.appState.get("currentAuthenticatorEnrollment").contextualData;
      }
    }),
        l = a.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(380)),
        a = r(n(7)),
        s = i.default.extend({
      title: function title() {
        var e = this.options.appState.getAuthenticatorDisplayName();
        return (0, o.loc)("oie.idp.challenge.title", "login", [e]);
      },
      subtitle: function subtitle() {
        var e = this.options.appState.getAuthenticatorDisplayName();
        return (0, o.loc)("oie.idp.challenge.description", "login", [e]);
      },
      save: function save() {
        return (0, o.loc)("mfa.challenge.verify", "login");
      }
    }),
        l = a.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(380)),
        a = r(n(7)),
        s = i.default.extend({
      title: function title() {
        var e = this.options.appState.getAuthenticatorDisplayName();
        return (0, o.loc)("oie.idp.enroll.title", "login", [e]);
      },
      subtitle: function subtitle() {
        var e = this.options.appState.getAuthenticatorDisplayName();
        return (0, o.loc)("oie.idp.enroll.description", "login", [e]);
      },
      save: function save() {
        return (0, o.loc)("mfa.enroll", "login");
      }
    }),
        l = a.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = n(3),
        a = r(n(7)),
        s = i.BaseForm.extend(Object.assign({
      className: "mfa-verify-custom-otp",
      title: function title() {
        var e = this.options.appState.getAuthenticatorDisplayName() || (0, o.loc)("oie.custom_otp.authenticator.default.vendorName", "login");
        return (0, o.loc)("oie.verify.custom_otp.title", "login", [e]);
      },
      subtitle: function subtitle() {
        return (0, o.loc)("oie.verify.custom_otp.description", "login");
      },
      save: function save() {
        return (0, o.loc)("mfa.challenge.verify", "login");
      }
    })),
        l = a.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = n(1),
        i = r(n(137)),
        a = r(n(7)),
        s = i.default.extend({
      title: function title() {
        var e = this.options.appState.getAuthenticatorDisplayName();
        return this.options.appState.isAuthenticatorChallenge() ? (0, o.loc)("oie.symantecVip.challenge.title", "login", [e]) : (0, o.loc)("oie.symantecVip.enroll.title", "login", [e]);
      },
      subtitle: function subtitle() {
        var e = this.options.appState.getAuthenticatorDisplayName();
        return this.options.appState.isAuthenticatorChallenge() ? (0, o.loc)("oie.symantecVip.challenge.description", "login", [e]) : (0, o.loc)("oie.symantecVip.enroll.description", "login", [e]);
      },
      save: function save() {
        return this.options.appState.isAuthenticatorChallenge() ? (0, o.loc)("mfa.challenge.verify", "login") : (0, o.loc)("mfa.enroll", "login");
      }
    }),
        l = a.default.extend({
      Body: s
    });
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(1),
        o = n(3),
        i = o.BaseForm.extend({
      title: function title() {
        return (0, r.loc)("device.code.activate.title", "login");
      },
      subtitle: function subtitle() {
        return (0, r.loc)("device.code.activate.subtitle", "login");
      },
      events: {
        'keyup input[name="userCode"]': function keyupInputNameUserCode(e) {
          e.preventDefault(), this.addHyphen(e);
        }
      },
      addHyphen: function addHyphen(e) {
        var t = e.target.value;
        t && 4 === t.length && !["Backspace", "Delete", "-"].includes(e.key) && (e.target.value = t.concat("-"));
      }
    }),
        a = o.BaseView.extend({
      Body: i
    });
    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var r = n(1),
        o = n(67),
        i = function i(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
      return r._.chain(t).filter(function (e) {
        var t;
        return Array.isArray(null === (t = e.messages) || void 0 === t ? void 0 : t.value) && e.messages.value.length;
      }).map(function (t) {
        return {
          property: e ? "".concat(e, ".").concat(t.name) : t.name,
          errorSummary: t.messages.value.map(o.getMessage),
          errorKey: t.messages.value.map(o.getMessageKey)
        };
      }).value();
    },
        a = function a(e, t) {
      if (!Array.isArray(e)) return [];
      if (!r._.isFunction(t) || 1 === e.length) return e;

      for (var n = [], o = 0; o < e.length; o++) {
        for (var i = !1, a = o + 1; a < e.length; a++) {
          if (t(e[o], e[a])) {
            i = !0;
            break;
          }
        }

        i || n.push(e[o]);
      }

      return n;
    },
        s = function s(e) {
      var t = [];
      if (!e.remediation || !Array.isArray(e.remediation.value) || 0 === e.remediation.value.length) return t;
      var n = e.remediation.value[0].value;
      return Array.isArray(n) ? (t.push(i(null, n)), r._.each(n, function (e) {
        var n,
            o = e.name;
        Array.isArray(null === (n = e.form) || void 0 === n ? void 0 : n.value) && t.push(i(o, e.form.value)), Array.isArray(e.options) && r._.each(e.options, function (e) {
          var n, r;
          Array.isArray(null === (n = e.value) || void 0 === n ? void 0 : null === (r = n.form) || void 0 === r ? void 0 : r.value) && t.push(i(o, e.value.form.value));
        });
      }), a(r._.flatten(t), r._.isEqual)) : t;
    },
        l = function l(e) {
      var t,
          n = [];
      return Array.isArray(null === (t = e.messages) || void 0 === t ? void 0 : t.value) && (n = e.messages.value.map(o.getMessage)), n.join(". ");
    },
        u = function u(e) {
      var t,
          n = [];
      return Array.isArray(null === (t = e.messages) || void 0 === t ? void 0 : t.value) && (n = e.messages.value.map(o.getMessageKey)), n;
    },
        c = function c(e) {
      return {
        responseJSON: {
          errorCauses: s(e),
          errorSummary: l(e),
          errorSummaryKeys: u(e),
          errorIntent: e.intent
        }
      };
    },
        d = function d() {
      return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).version;
    },
        f = {
      convertFormErrors: c,
      isIonErrorResponse: d
    };

    t.default = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(195)),
        i = n(8),
        a = n(196),
        s = o.default.extend({
      postRender: function postRender() {
        if (this.options.appState.get("currentFormName") === i.FORMS.IDENTIFY) {
          if (this.options.appState.hasRemediationObject(i.FORMS.SELECT_ENROLL_PROFILE)) this.handleInvokeAction(i.FORMS.SELECT_ENROLL_PROFILE);else {
            var e = {
              type: "array",
              value: [{
                message: "Sign up is not enabled for this organization.",
                i18n: {
                  key: a.REGISTRATION_NOT_ENABLED
                },
                class: "ERROR"
              }]
            },
                t = {
              neededToProceed: [],
              rawIdxState: {
                messages: e
              },
              context: {
                messages: e
              }
            };
            this.options.appState.trigger("remediationSuccess", t);
          }
        } else o.default.prototype.postRender.apply(this, arguments);
      }
    });
    t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = r(n(195)),
        i = n(8),
        a = n(196),
        s = o.default.extend({
      postRender: function postRender() {
        if (this.options.appState.get("currentFormName") === i.FORMS.IDENTIFY) {
          if (this.options.appState.getActionByPath(i.ACTIONS.ORG_PASSWORD_RECOVERY_LINK)) this.handleInvokeAction(i.ACTIONS.ORG_PASSWORD_RECOVERY_LINK);else {
            var e = {
              type: "array",
              value: [{
                message: "Forgot password is not enabled for this organization.",
                i18n: {
                  key: a.FORGOT_PASSWORD_NOT_ENABLED
                },
                class: "ERROR"
              }]
            },
                t = {
              neededToProceed: [],
              rawIdxState: {
                messages: e
              },
              context: {
                messages: e
              }
            };
            this.options.appState.trigger("remediationSuccess", t);
          }
        } else o.default.prototype.postRender.apply(this, arguments);
      }
    });
    t.default = s;
  }]);
});